/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(227);


/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(416);


/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule invariant
	 */
	
	"use strict";
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var invariant = function(condition, format, a, b, c, d, e, f) {
	  if (false) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  }
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error(
	        'Minified exception occurred; use the non-minified dev environment ' +
	        'for the full error message and additional helpful warnings.'
	      );
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(
	        'Invariant Violation: ' +
	        format.replace(/%s/g, function() { return args[argIndex++]; })
	      );
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	};
	
	module.exports = invariant;


/***/ },
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequire(obj) { return obj && obj.__esModule ? obj['default'] : obj; }
	
	var _DragDropContext = __webpack_require__(234);
	
	exports.DragDropContext = _interopRequire(_DragDropContext);
	
	var _DragLayer = __webpack_require__(235);
	
	exports.DragLayer = _interopRequire(_DragLayer);
	
	var _DragSource = __webpack_require__(236);
	
	exports.DragSource = _interopRequire(_DragSource);
	
	var _DropTarget = __webpack_require__(237);
	
	exports.DropTarget = _interopRequire(_DropTarget);
	
	if (false) {
	  Object.defineProperty(exports, 'default', {
	    get: function get() {
	      console.error('React DnD does not provide a default export. ' + 'You are probably missing the curly braces in the import statement. ' + 'Read more: http://pljenkins.github.io/react-dnd/docs-troubleshooting.html#react-dnd-does-not-provide-a-default-export');
	    }
	  });
	}

/***/ },
/* 4 */
/***/ function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ },
/* 5 */
/***/ function(module, exports) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule Object.assign
	 */
	
	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-object.assign
	
	'use strict';
	
	function assign(target, sources) {
	  if (target == null) {
	    throw new TypeError('Object.assign target cannot be null or undefined');
	  }
	
	  var to = Object(target);
	  var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	  for (var nextIndex = 1; nextIndex < arguments.length; nextIndex++) {
	    var nextSource = arguments[nextIndex];
	    if (nextSource == null) {
	      continue;
	    }
	
	    var from = Object(nextSource);
	
	    // We don't currently support accessors nor proxies. Therefore this
	    // copy cannot throw. If we ever supported this then we must handle
	    // exceptions and side-effects. We don't support symbols so they won't
	    // be transferred.
	
	    for (var key in from) {
	      if (hasOwnProperty.call(from, key)) {
	        to[key] = from[key];
	      }
	    }
	  }
	
	  return to;
	}
	
	module.exports = assign;


/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule warning
	 */
	
	"use strict";
	
	var emptyFunction = __webpack_require__(24);
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = emptyFunction;
	
	if (false) {
	  warning = function(condition, format ) {for (var args=[],$__0=2,$__1=arguments.length;$__0<$__1;$__0++) args.push(arguments[$__0]);
	    if (format === undefined) {
	      throw new Error(
	        '`warning(condition, format, ...args)` requires a warning ' +
	        'message argument'
	      );
	    }
	
	    if (format.length < 10 || /^[s\W]*$/.test(format)) {
	      throw new Error(
	        'The warning format should be able to uniquely identify this ' +
	        'warning. Please, use a more descriptive format than: ' + format
	      );
	    }
	
	    if (format.indexOf('Failed Composite propType: ') === 0) {
	      return; // Ignore CompositeComponent proptype check.
	    }
	
	    if (!condition) {
	      var argIndex = 0;
	      var message = 'Warning: ' + format.replace(/%s/g, function()  {return args[argIndex++];});
	      console.warn(message);
	      try {
	        // --- Welcome to debugging React ---
	        // This error was thrown as a convenience so that you can use this stack
	        // to find the callsite that caused this warning to fire.
	        throw new Error(message);
	      } catch(x) {}
	    }
	  };
	}
	
	module.exports = warning;


/***/ },
/* 7 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactElement
	 */
	
	'use strict';
	
	var ReactContext = __webpack_require__(88);
	var ReactCurrentOwner = __webpack_require__(19);
	
	var assign = __webpack_require__(5);
	var warning = __webpack_require__(6);
	
	var RESERVED_PROPS = {
	  key: true,
	  ref: true
	};
	
	/**
	 * Warn for mutations.
	 *
	 * @internal
	 * @param {object} object
	 * @param {string} key
	 */
	function defineWarningProperty(object, key) {
	  Object.defineProperty(object, key, {
	
	    configurable: false,
	    enumerable: true,
	
	    get: function() {
	      if (!this._store) {
	        return null;
	      }
	      return this._store[key];
	    },
	
	    set: function(value) {
	      ( false ? warning(
	        false,
	        'Don\'t set the %s property of the React element. Instead, ' +
	        'specify the correct value when initially creating the element.',
	        key
	      ) : null);
	      this._store[key] = value;
	    }
	
	  });
	}
	
	/**
	 * This is updated to true if the membrane is successfully created.
	 */
	var useMutationMembrane = false;
	
	/**
	 * Warn for mutations.
	 *
	 * @internal
	 * @param {object} element
	 */
	function defineMutationMembrane(prototype) {
	  try {
	    var pseudoFrozenProperties = {
	      props: true
	    };
	    for (var key in pseudoFrozenProperties) {
	      defineWarningProperty(prototype, key);
	    }
	    useMutationMembrane = true;
	  } catch (x) {
	    // IE will fail on defineProperty
	  }
	}
	
	/**
	 * Base constructor for all React elements. This is only used to make this
	 * work with a dynamic instanceof check. Nothing should live on this prototype.
	 *
	 * @param {*} type
	 * @param {string|object} ref
	 * @param {*} key
	 * @param {*} props
	 * @internal
	 */
	var ReactElement = function(type, key, ref, owner, context, props) {
	  // Built-in properties that belong on the element
	  this.type = type;
	  this.key = key;
	  this.ref = ref;
	
	  // Record the component responsible for creating this element.
	  this._owner = owner;
	
	  // TODO: Deprecate withContext, and then the context becomes accessible
	  // through the owner.
	  this._context = context;
	
	  if (false) {
	    // The validation flag and props are currently mutative. We put them on
	    // an external backing store so that we can freeze the whole object.
	    // This can be replaced with a WeakMap once they are implemented in
	    // commonly used development environments.
	    this._store = {props: props, originalProps: assign({}, props)};
	
	    // To make comparing ReactElements easier for testing purposes, we make
	    // the validation flag non-enumerable (where possible, which should
	    // include every environment we run tests in), so the test framework
	    // ignores it.
	    try {
	      Object.defineProperty(this._store, 'validated', {
	        configurable: false,
	        enumerable: false,
	        writable: true
	      });
	    } catch (x) {
	    }
	    this._store.validated = false;
	
	    // We're not allowed to set props directly on the object so we early
	    // return and rely on the prototype membrane to forward to the backing
	    // store.
	    if (useMutationMembrane) {
	      Object.freeze(this);
	      return;
	    }
	  }
	
	  this.props = props;
	};
	
	// We intentionally don't expose the function on the constructor property.
	// ReactElement should be indistinguishable from a plain object.
	ReactElement.prototype = {
	  _isReactElement: true
	};
	
	if (false) {
	  defineMutationMembrane(ReactElement.prototype);
	}
	
	ReactElement.createElement = function(type, config, children) {
	  var propName;
	
	  // Reserved names are extracted
	  var props = {};
	
	  var key = null;
	  var ref = null;
	
	  if (config != null) {
	    ref = config.ref === undefined ? null : config.ref;
	    key = config.key === undefined ? null : '' + config.key;
	    // Remaining properties are added to a new props object
	    for (propName in config) {
	      if (config.hasOwnProperty(propName) &&
	          !RESERVED_PROPS.hasOwnProperty(propName)) {
	        props[propName] = config[propName];
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    props.children = childArray;
	  }
	
	  // Resolve default props
	  if (type && type.defaultProps) {
	    var defaultProps = type.defaultProps;
	    for (propName in defaultProps) {
	      if (typeof props[propName] === 'undefined') {
	        props[propName] = defaultProps[propName];
	      }
	    }
	  }
	
	  return new ReactElement(
	    type,
	    key,
	    ref,
	    ReactCurrentOwner.current,
	    ReactContext.current,
	    props
	  );
	};
	
	ReactElement.createFactory = function(type) {
	  var factory = ReactElement.createElement.bind(null, type);
	  // Expose the type on the factory and the prototype so that it can be
	  // easily accessed on elements. E.g. <Foo />.type === Foo.type.
	  // This should not be named `constructor` since this may not be the function
	  // that created the element, and it may not even be a constructor.
	  // Legacy hook TODO: Warn if this is accessed
	  factory.type = type;
	  return factory;
	};
	
	ReactElement.cloneAndReplaceProps = function(oldElement, newProps) {
	  var newElement = new ReactElement(
	    oldElement.type,
	    oldElement.key,
	    oldElement.ref,
	    oldElement._owner,
	    oldElement._context,
	    newProps
	  );
	
	  if (false) {
	    // If the key on the original is valid, then the clone is valid
	    newElement._store.validated = oldElement._store.validated;
	  }
	  return newElement;
	};
	
	ReactElement.cloneElement = function(element, config, children) {
	  var propName;
	
	  // Original props are copied
	  var props = assign({}, element.props);
	
	  // Reserved names are extracted
	  var key = element.key;
	  var ref = element.ref;
	
	  // Owner will be preserved, unless ref is overridden
	  var owner = element._owner;
	
	  if (config != null) {
	    if (config.ref !== undefined) {
	      // Silently steal the ref from the parent.
	      ref = config.ref;
	      owner = ReactCurrentOwner.current;
	    }
	    if (config.key !== undefined) {
	      key = '' + config.key;
	    }
	    // Remaining properties override existing props
	    for (propName in config) {
	      if (config.hasOwnProperty(propName) &&
	          !RESERVED_PROPS.hasOwnProperty(propName)) {
	        props[propName] = config[propName];
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    props.children = childArray;
	  }
	
	  return new ReactElement(
	    element.type,
	    key,
	    ref,
	    owner,
	    element._context,
	    props
	  );
	};
	
	/**
	 * @param {?object} object
	 * @return {boolean} True if `object` is a valid component.
	 * @final
	 */
	ReactElement.isValidElement = function(object) {
	  // ReactTestUtils is often used outside of beforeEach where as React is
	  // within it. This leads to two different instances of React on the same
	  // page. To identify a element from a different React instance we use
	  // a flag instead of an instanceof check.
	  var isElement = !!(object && object._isReactElement);
	  // if (isElement && !(object instanceof ReactElement)) {
	  // This is an indicator that you're using multiple versions of React at the
	  // same time. This will screw with ownership and stuff. Fix it, please.
	  // TODO: We could possibly warn here.
	  // }
	  return isElement;
	};
	
	module.exports = ReactElement;


/***/ },
/* 8 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ExecutionEnvironment
	 */
	
	/*jslint evil: true */
	
	"use strict";
	
	var canUseDOM = !!(
	  (typeof window !== 'undefined' &&
	  window.document && window.document.createElement)
	);
	
	/**
	 * Simple, lightweight module assisting with the detection and context of
	 * Worker. Helps avoid circular dependencies and allows code to reason about
	 * whether or not they are in a Worker, even if they never include the main
	 * `ReactWorker` dependency.
	 */
	var ExecutionEnvironment = {
	
	  canUseDOM: canUseDOM,
	
	  canUseWorkers: typeof Worker !== 'undefined',
	
	  canUseEventListeners:
	    canUseDOM && !!(window.addEventListener || window.attachEvent),
	
	  canUseViewport: canUseDOM && !!window.screen,
	
	  isInWorker: !canUseDOM // For now, this is true - might change in the future.
	
	};
	
	module.exports = ExecutionEnvironment;


/***/ },
/* 9 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule invariant
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var invariant = function(condition, format, a, b, c, d, e, f) {
	  if (false) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  }
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error(
	        'Minified exception occurred; use the non-minified dev environment ' +
	        'for the full error message and additional helpful warnings.'
	      );
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(
	        'Invariant Violation: ' +
	        format.replace(/%s/g, function() { return args[argIndex++]; })
	      );
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	};
	
	module.exports = invariant;


/***/ },
/* 10 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _nativeTypesConfig;
	
	exports.getEmptyImage = getEmptyImage;
	exports['default'] = createHTML5Backend;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var _dndCore = __webpack_require__(53);
	
	var _utilsEnterLeaveCounter = __webpack_require__(249);
	
	var _utilsEnterLeaveCounter2 = _interopRequireDefault(_utilsEnterLeaveCounter);
	
	var _utilsBrowserDetector = __webpack_require__(117);
	
	var _utilsOffsetHelpers = __webpack_require__(118);
	
	var _utilsShallowEqual = __webpack_require__(29);
	
	var _utilsShallowEqual2 = _interopRequireDefault(_utilsShallowEqual);
	
	var _lodashObjectDefaults = __webpack_require__(383);
	
	var _lodashObjectDefaults2 = _interopRequireDefault(_lodashObjectDefaults);
	
	var _invariant = __webpack_require__(9);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var emptyImage = undefined;
	
	function getEmptyImage() {
	  if (!emptyImage) {
	    emptyImage = new Image();
	    emptyImage.src = 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==';
	  }
	
	  return emptyImage;
	}
	
	var NativeTypes = {
	  FILE: '__NATIVE_FILE__',
	  URL: '__NATIVE_URL__',
	  TEXT: '__NATIVE_TEXT__'
	};
	
	exports.NativeTypes = NativeTypes;
	function getDataFromDataTransfer(dataTransfer, typesToTry, defaultValue) {
	  var result = typesToTry.reduce(function (resultSoFar, typeToTry) {
	    return resultSoFar || dataTransfer.getData(typeToTry);
	  }, null);
	
	  return result != null ? result : defaultValue;
	}
	
	var nativeTypesConfig = (_nativeTypesConfig = {}, _defineProperty(_nativeTypesConfig, NativeTypes.FILE, {
	  exposeProperty: 'files',
	  matchesTypes: ['Files'],
	  getData: function getData(dataTransfer) {
	    return Array.prototype.slice.call(dataTransfer.files);
	  }
	}), _defineProperty(_nativeTypesConfig, NativeTypes.URL, {
	  exposeProperty: 'urls',
	  matchesTypes: ['Url', 'text/uri-list'],
	  getData: function getData(dataTransfer, matchesTypes) {
	    return getDataFromDataTransfer(dataTransfer, matchesTypes, '').split('\n');
	  }
	}), _defineProperty(_nativeTypesConfig, NativeTypes.TEXT, {
	  exposeProperty: 'text',
	  matchesTypes: ['Text', 'text/plain'],
	  getData: function getData(dataTransfer, matchesTypes) {
	    return getDataFromDataTransfer(dataTransfer, matchesTypes, '');
	  }
	}), _nativeTypesConfig);
	
	function createNativeDragSource(type) {
	  var _nativeTypesConfig$type = nativeTypesConfig[type];
	  var exposeProperty = _nativeTypesConfig$type.exposeProperty;
	  var matchesTypes = _nativeTypesConfig$type.matchesTypes;
	  var getData = _nativeTypesConfig$type.getData;
	
	  return (function (_DragSource) {
	    _inherits(NativeDragSource, _DragSource);
	
	    function NativeDragSource() {
	      _classCallCheck(this, NativeDragSource);
	
	      _DragSource.call(this);
	      this.item = Object.defineProperties({}, _defineProperty({}, exposeProperty, {
	        get: function get() {
	          console.warn('Browser doesn\'t allow reading "' + exposeProperty + '" until the drop event.');
	          return null;
	        },
	        configurable: true,
	        enumerable: true
	      }));
	    }
	
	    NativeDragSource.prototype.mutateItemByReadingDataTransfer = function mutateItemByReadingDataTransfer(dataTransfer) {
	      delete this.item[exposeProperty];
	      this.item[exposeProperty] = getData(dataTransfer, matchesTypes);
	    };
	
	    NativeDragSource.prototype.beginDrag = function beginDrag() {
	      return this.item;
	    };
	
	    return NativeDragSource;
	  })(_dndCore.DragSource);
	}
	
	function matchNativeItemType(dataTransfer) {
	  var dataTransferTypes = Array.prototype.slice.call(dataTransfer.types || []);
	
	  return Object.keys(nativeTypesConfig).filter(function (nativeItemType) {
	    var matchesTypes = nativeTypesConfig[nativeItemType].matchesTypes;
	
	    return matchesTypes.some(function (t) {
	      return dataTransferTypes.indexOf(t) > -1;
	    });
	  })[0] || null;
	}
	
	var HTML5Backend = (function () {
	  function HTML5Backend(manager) {
	    _classCallCheck(this, HTML5Backend);
	
	    this.actions = manager.getActions();
	    this.monitor = manager.getMonitor();
	    this.registry = manager.getRegistry();
	
	    this.sourcePreviewNodes = {};
	    this.sourcePreviewNodeOptions = {};
	    this.sourceNodes = {};
	    this.sourceNodeOptions = {};
	    this.enterLeaveCounter = new _utilsEnterLeaveCounter2['default']();
	
	    this.getSourceClientOffset = this.getSourceClientOffset.bind(this);
	    this.handleTopDragStart = this.handleTopDragStart.bind(this);
	    this.handleTopDragStartCapture = this.handleTopDragStartCapture.bind(this);
	    this.handleTopDragEndCapture = this.handleTopDragEndCapture.bind(this);
	    this.handleTopDragEnter = this.handleTopDragEnter.bind(this);
	    this.handleTopDragEnterCapture = this.handleTopDragEnterCapture.bind(this);
	    this.handleTopDragLeaveCapture = this.handleTopDragLeaveCapture.bind(this);
	    this.handleTopDragOver = this.handleTopDragOver.bind(this);
	    this.handleTopDragOverCapture = this.handleTopDragOverCapture.bind(this);
	    this.handleTopDrop = this.handleTopDrop.bind(this);
	    this.handleTopDropCapture = this.handleTopDropCapture.bind(this);
	    this.handleSelectStart = this.handleSelectStart.bind(this);
	    this.endDragIfSourceWasRemovedFromDOM = this.endDragIfSourceWasRemovedFromDOM.bind(this);
	  }
	
	  HTML5Backend.prototype.setup = function setup() {
	    if (typeof window === 'undefined') {
	      return;
	    }
	
	    _invariant2['default'](!this.constructor.isSetUp, 'Cannot have two HTML5 backends at the same time.');
	    this.constructor.isSetUp = true;
	
	    window.addEventListener('dragstart', this.handleTopDragStart);
	    window.addEventListener('dragstart', this.handleTopDragStartCapture, true);
	    window.addEventListener('dragend', this.handleTopDragEndCapture, true);
	    window.addEventListener('dragenter', this.handleTopDragEnter);
	    window.addEventListener('dragenter', this.handleTopDragEnterCapture, true);
	    window.addEventListener('dragleave', this.handleTopDragLeaveCapture, true);
	    window.addEventListener('dragover', this.handleTopDragOver);
	    window.addEventListener('dragover', this.handleTopDragOverCapture, true);
	    window.addEventListener('drop', this.handleTopDrop);
	    window.addEventListener('drop', this.handleTopDropCapture, true);
	  };
	
	  HTML5Backend.prototype.teardown = function teardown() {
	    if (typeof window === 'undefined') {
	      return;
	    }
	
	    this.constructor.isSetUp = false;
	
	    window.removeEventListener('dragstart', this.handleTopDragStart);
	    window.removeEventListener('dragstart', this.handleTopDragStartCapture, true);
	    window.removeEventListener('dragend', this.handleTopDragEndCapture, true);
	    window.removeEventListener('dragenter', this.handleTopDragEnter);
	    window.removeEventListener('dragenter', this.handleTopDragEnterCapture, true);
	    window.removeEventListener('dragleave', this.handleTopDragLeaveCapture, true);
	    window.removeEventListener('dragover', this.handleTopDragOver);
	    window.removeEventListener('dragover', this.handleTopDragOverCapture, true);
	    window.removeEventListener('drop', this.handleTopDrop);
	    window.removeEventListener('drop', this.handleTopDropCapture, true);
	
	    this.clearCurrentDragSourceNode();
	  };
	
	  HTML5Backend.prototype.connectDragPreview = function connectDragPreview(sourceId, node, options) {
	    var _this = this;
	
	    this.sourcePreviewNodeOptions[sourceId] = options;
	    this.sourcePreviewNodes[sourceId] = node;
	
	    return function () {
	      delete _this.sourcePreviewNodes[sourceId];
	      delete _this.sourcePreviewNodeOptions[sourceId];
	    };
	  };
	
	  HTML5Backend.prototype.connectDragSource = function connectDragSource(sourceId, node, options) {
	    var _this2 = this;
	
	    this.sourceNodes[sourceId] = node;
	    this.sourceNodeOptions[sourceId] = options;
	
	    var handleDragStart = function handleDragStart(e) {
	      return _this2.handleDragStart(e, sourceId);
	    };
	    var handleSelectStart = function handleSelectStart(e) {
	      return _this2.handleSelectStart(e, sourceId);
	    };
	
	    node.setAttribute('draggable', true);
	    node.addEventListener('dragstart', handleDragStart);
	    node.addEventListener('selectstart', handleSelectStart);
	
	    return function () {
	      delete _this2.sourceNodes[sourceId];
	      delete _this2.sourceNodeOptions[sourceId];
	
	      node.removeEventListener('dragstart', handleDragStart);
	      node.removeEventListener('selectstart', handleSelectStart);
	      node.setAttribute('draggable', false);
	    };
	  };
	
	  HTML5Backend.prototype.connectDropTarget = function connectDropTarget(targetId, node) {
	    var _this3 = this;
	
	    var handleDragEnter = function handleDragEnter(e) {
	      return _this3.handleDragEnter(e, targetId);
	    };
	    var handleDragOver = function handleDragOver(e) {
	      return _this3.handleDragOver(e, targetId);
	    };
	    var handleDrop = function handleDrop(e) {
	      return _this3.handleDrop(e, targetId);
	    };
	
	    node.addEventListener('dragenter', handleDragEnter);
	    node.addEventListener('dragover', handleDragOver);
	    node.addEventListener('drop', handleDrop);
	
	    return function () {
	      node.removeEventListener('dragenter', handleDragEnter);
	      node.removeEventListener('dragover', handleDragOver);
	      node.removeEventListener('drop', handleDrop);
	    };
	  };
	
	  HTML5Backend.prototype.getCurrentSourceNodeOptions = function getCurrentSourceNodeOptions() {
	    var sourceId = this.monitor.getSourceId();
	    var sourceNodeOptions = this.sourceNodeOptions[sourceId];
	
	    return _lodashObjectDefaults2['default'](sourceNodeOptions || {}, {
	      dropEffect: 'move'
	    });
	  };
	
	  HTML5Backend.prototype.getCurrentDropEffect = function getCurrentDropEffect() {
	    if (this.isDraggingNativeItem()) {
	      // It makes more sense to default to 'copy' for native resources
	      return 'copy';
	    } else {
	      return this.getCurrentSourceNodeOptions().dropEffect;
	    }
	  };
	
	  HTML5Backend.prototype.getCurrentSourcePreviewNodeOptions = function getCurrentSourcePreviewNodeOptions() {
	    var sourceId = this.monitor.getSourceId();
	    var sourcePreviewNodeOptions = this.sourcePreviewNodeOptions[sourceId];
	
	    return _lodashObjectDefaults2['default'](sourcePreviewNodeOptions || {}, {
	      anchorX: 0.5,
	      anchorY: 0.5,
	      captureDraggingState: false
	    });
	  };
	
	  HTML5Backend.prototype.getSourceClientOffset = function getSourceClientOffset(sourceId) {
	    return _utilsOffsetHelpers.getElementClientOffset(this.sourceNodes[sourceId]);
	  };
	
	  HTML5Backend.prototype.isDraggingNativeItem = function isDraggingNativeItem() {
	    var itemType = this.monitor.getItemType();
	    return Object.keys(NativeTypes).some(function (key) {
	      return NativeTypes[key] === itemType;
	    });
	  };
	
	  HTML5Backend.prototype.beginDragNativeItem = function beginDragNativeItem(type) {
	    this.clearCurrentDragSourceNode();
	
	    var SourceType = createNativeDragSource(type);
	    this.currentNativeSource = new SourceType();
	    this.currentNativeHandle = this.registry.addSource(type, this.currentNativeSource);
	    this.actions.beginDrag([this.currentNativeHandle]);
	  };
	
	  HTML5Backend.prototype.endDragNativeItem = function endDragNativeItem() {
	    this.actions.endDrag();
	    this.registry.removeSource(this.currentNativeHandle);
	    this.currentNativeHandle = null;
	    this.currentNativeSource = null;
	  };
	
	  HTML5Backend.prototype.endDragIfSourceWasRemovedFromDOM = function endDragIfSourceWasRemovedFromDOM() {
	    var node = this.currentDragSourceNode;
	    if (document.body.contains(node)) {
	      return;
	    }
	
	    this.actions.endDrag();
	    this.clearCurrentDragSourceNode();
	  };
	
	  HTML5Backend.prototype.setCurrentDragSourceNode = function setCurrentDragSourceNode(node) {
	    this.clearCurrentDragSourceNode();
	    this.currentDragSourceNode = node;
	    this.currentDragSourceNodeOffset = _utilsOffsetHelpers.getElementClientOffset(node);
	    this.currentDragSourceNodeOffsetChanged = false;
	
	    // Receiving a mouse event in the middle of a dragging operation
	    // means it has ended and the drag source node disappeared from DOM,
	    // so the browser didn't dispatch the dragend event.
	    window.addEventListener('mousemove', this.endDragIfSourceWasRemovedFromDOM, true);
	  };
	
	  HTML5Backend.prototype.clearCurrentDragSourceNode = function clearCurrentDragSourceNode() {
	    if (this.currentDragSourceNode) {
	      this.currentDragSourceNode = null;
	      this.currentDragSourceNodeOffset = null;
	      this.currentDragSourceNodeOffsetChanged = false;
	      window.removeEventListener('mousemove', this.endDragIfSourceWasRemovedFromDOM, true);
	      return true;
	    } else {
	      return false;
	    }
	  };
	
	  HTML5Backend.prototype.checkIfCurrentDragSourceRectChanged = function checkIfCurrentDragSourceRectChanged() {
	    var node = this.currentDragSourceNode;
	    if (!node) {
	      return false;
	    }
	
	    if (this.currentDragSourceNodeOffsetChanged) {
	      return true;
	    }
	
	    this.currentDragSourceNodeOffsetChanged = !_utilsShallowEqual2['default'](_utilsOffsetHelpers.getElementClientOffset(node), this.currentDragSourceNodeOffset);
	
	    return this.currentDragSourceNodeOffsetChanged;
	  };
	
	  HTML5Backend.prototype.handleTopDragStartCapture = function handleTopDragStartCapture() {
	    this.clearCurrentDragSourceNode();
	    this.dragStartSourceIds = [];
	  };
	
	  HTML5Backend.prototype.handleDragStart = function handleDragStart(e, sourceId) {
	    this.dragStartSourceIds.unshift(sourceId);
	  };
	
	  HTML5Backend.prototype.handleTopDragStart = function handleTopDragStart(e) {
	    var _this4 = this;
	
	    var dragStartSourceIds = this.dragStartSourceIds;
	
	    this.dragStartSourceIds = null;
	
	    var clientOffset = _utilsOffsetHelpers.getEventClientOffset(e);
	
	    // Don't publish the source just yet (see why below)
	    this.actions.beginDrag(dragStartSourceIds, {
	      publishSource: false,
	      getSourceClientOffset: this.getSourceClientOffset,
	      clientOffset: clientOffset
	    });
	
	    var dataTransfer = e.dataTransfer;
	
	    var nativeType = matchNativeItemType(dataTransfer);
	
	    if (this.monitor.isDragging()) {
	      if (typeof dataTransfer.setDragImage === 'function') {
	        // Use custom drag image if user specifies it.
	        // If child drag source refuses drag but parent agrees,
	        // use parent's node as drag image. Neither works in IE though.
	        var sourceId = this.monitor.getSourceId();
	        var sourceNode = this.sourceNodes[sourceId];
	        var dragPreview = this.sourcePreviewNodes[sourceId] || sourceNode;
	
	        var _getCurrentSourcePreviewNodeOptions = this.getCurrentSourcePreviewNodeOptions();
	
	        var anchorX = _getCurrentSourcePreviewNodeOptions.anchorX;
	        var anchorY = _getCurrentSourcePreviewNodeOptions.anchorY;
	
	        var anchorPoint = { anchorX: anchorX, anchorY: anchorY };
	        var dragPreviewOffset = _utilsOffsetHelpers.getDragPreviewOffset(sourceNode, dragPreview, clientOffset, anchorPoint);
	        dataTransfer.setDragImage(dragPreview, dragPreviewOffset.x, dragPreviewOffset.y);
	      }
	
	      try {
	        // Firefox won't drag without setting data
	        dataTransfer.setData('application/json', {});
	      } catch (err) {}
	      // IE doesn't support MIME types in setData
	
	      // Store drag source node so we can check whether
	      // it is removed from DOM and trigger endDrag manually.
	      this.setCurrentDragSourceNode(e.target);
	
	      // Now we are ready to publish the drag source.. or are we not?
	
	      var _getCurrentSourcePreviewNodeOptions2 = this.getCurrentSourcePreviewNodeOptions();
	
	      var captureDraggingState = _getCurrentSourcePreviewNodeOptions2.captureDraggingState;
	
	      if (!captureDraggingState) {
	        // Usually we want to publish it in the next tick so that browser
	        // is able to screenshot the current (not yet dragging) state.
	        //
	        // It also neatly avoids a situation where render() returns null
	        // in the same tick for the source element, and browser freaks out.
	        setTimeout(function () {
	          return _this4.actions.publishDragSource();
	        });
	      } else {
	        // In some cases the user may want to override this behavior, e.g.
	        // to work around IE not supporting custom drag previews.
	        //
	        // When using a custom drag layer, the only way to prevent
	        // the default drag preview from drawing in IE is to screenshot
	        // the dragging state in which the node itself has zero opacity
	        // and height. In this case, though, returning null from render()
	        // will abruptly end the dragging, which is not obvious.
	        //
	        // This is the reason such behavior is strictly opt-in.
	        this.actions.publishDragSource();
	      }
	    } else if (nativeType) {
	      // A native item (such as URL) dragged from inside the document
	      this.beginDragNativeItem(nativeType);
	    } else if (!dataTransfer.types && (!e.target.hasAttribute || !e.target.hasAttribute('draggable'))) {
	      // Looks like a Safari bug: dataTransfer.types is null, but there was no draggable.
	      // Just let it drag. It's a native type (URL or text) and will be picked up in dragenter handler.
	      return;
	    } else {
	      // If by this time no drag source reacted, tell browser not to drag.
	      e.preventDefault();
	    }
	  };
	
	  HTML5Backend.prototype.handleTopDragEndCapture = function handleTopDragEndCapture() {
	    if (this.clearCurrentDragSourceNode()) {
	      // Firefox can dispatch this event in an infinite loop
	      // if dragend handler does something like showing an alert.
	      // Only proceed if we have not handled it already.
	      this.actions.endDrag();
	    }
	  };
	
	  HTML5Backend.prototype.handleTopDragEnterCapture = function handleTopDragEnterCapture(e) {
	    this.dragEnterTargetIds = [];
	
	    var isFirstEnter = this.enterLeaveCounter.enter(e.target);
	    if (!isFirstEnter || this.monitor.isDragging()) {
	      return;
	    }
	
	    var dataTransfer = e.dataTransfer;
	
	    var nativeType = matchNativeItemType(dataTransfer);
	
	    if (nativeType) {
	      // A native item (such as file or URL) dragged from outside the document
	      this.beginDragNativeItem(nativeType);
	    }
	  };
	
	  HTML5Backend.prototype.handleDragEnter = function handleDragEnter(e, targetId) {
	    this.dragEnterTargetIds.unshift(targetId);
	  };
	
	  HTML5Backend.prototype.handleTopDragEnter = function handleTopDragEnter(e) {
	    var _this5 = this;
	
	    var dragEnterTargetIds = this.dragEnterTargetIds;
	
	    this.dragEnterTargetIds = [];
	
	    if (!this.monitor.isDragging()) {
	      // This is probably a native item type we don't understand.
	      return;
	    }
	
	    if (!_utilsBrowserDetector.isFirefox()) {
	      // Don't emit hover in `dragenter` on Firefox due to an edge case.
	      // If the target changes position as the result of `dragenter`, Firefox
	      // will still happily dispatch `dragover` despite target being no longer
	      // there. The easy solution is to only fire `hover` in `dragover` on FF.
	      this.actions.hover(dragEnterTargetIds, {
	        clientOffset: _utilsOffsetHelpers.getEventClientOffset(e)
	      });
	    }
	
	    var canDrop = dragEnterTargetIds.some(function (targetId) {
	      return _this5.monitor.canDropOnTarget(targetId);
	    });
	
	    if (canDrop) {
	      // IE requires this to fire dragover events
	      e.preventDefault();
	      e.dataTransfer.dropEffect = this.getCurrentDropEffect();
	    }
	  };
	
	  HTML5Backend.prototype.handleTopDragOverCapture = function handleTopDragOverCapture() {
	    this.dragOverTargetIds = [];
	  };
	
	  HTML5Backend.prototype.handleDragOver = function handleDragOver(e, targetId) {
	    this.dragOverTargetIds.unshift(targetId);
	  };
	
	  HTML5Backend.prototype.handleTopDragOver = function handleTopDragOver(e) {
	    var _this6 = this;
	
	    var dragOverTargetIds = this.dragOverTargetIds;
	
	    this.dragOverTargetIds = [];
	
	    if (!this.monitor.isDragging()) {
	      // This is probably a native item type we don't understand.
	      // Prevent default "drop and blow away the whole document" action.
	      e.preventDefault();
	      e.dataTransfer.dropEffect = 'none';
	      return;
	    }
	
	    this.actions.hover(dragOverTargetIds, {
	      clientOffset: _utilsOffsetHelpers.getEventClientOffset(e)
	    });
	
	    var canDrop = dragOverTargetIds.some(function (targetId) {
	      return _this6.monitor.canDropOnTarget(targetId);
	    });
	
	    if (canDrop) {
	      // Show user-specified drop effect.
	      e.preventDefault();
	      e.dataTransfer.dropEffect = this.getCurrentDropEffect();
	    } else if (this.isDraggingNativeItem()) {
	      // Don't show a nice cursor but still prevent default
	      // "drop and blow away the whole document" action.
	      e.preventDefault();
	      e.dataTransfer.dropEffect = 'none';
	    } else if (this.checkIfCurrentDragSourceRectChanged()) {
	      // Prevent animating to incorrect position.
	      // Drop effect must be other than 'none' to prevent animation.
	      e.preventDefault();
	      e.dataTransfer.dropEffect = 'move';
	    }
	  };
	
	  HTML5Backend.prototype.handleTopDragLeaveCapture = function handleTopDragLeaveCapture(e) {
	    if (this.isDraggingNativeItem()) {
	      e.preventDefault();
	    }
	
	    var isLastLeave = this.enterLeaveCounter.leave(e.target);
	    if (!isLastLeave) {
	      return;
	    }
	
	    if (this.isDraggingNativeItem()) {
	      this.endDragNativeItem();
	    }
	  };
	
	  HTML5Backend.prototype.handleTopDropCapture = function handleTopDropCapture(e) {
	    this.dropTargetIds = [];
	
	    if (this.isDraggingNativeItem()) {
	      e.preventDefault();
	      this.currentNativeSource.mutateItemByReadingDataTransfer(e.dataTransfer);
	    }
	
	    this.enterLeaveCounter.reset();
	  };
	
	  HTML5Backend.prototype.handleDrop = function handleDrop(e, targetId) {
	    this.dropTargetIds.unshift(targetId);
	  };
	
	  HTML5Backend.prototype.handleTopDrop = function handleTopDrop(e) {
	    var dropTargetIds = this.dropTargetIds;
	
	    this.dropTargetIds = [];
	
	    this.actions.hover(dropTargetIds, {
	      clientOffset: _utilsOffsetHelpers.getEventClientOffset(e)
	    });
	    this.actions.drop();
	
	    if (this.isDraggingNativeItem()) {
	      this.endDragNativeItem();
	    } else {
	      this.endDragIfSourceWasRemovedFromDOM();
	    }
	  };
	
	  HTML5Backend.prototype.handleSelectStart = function handleSelectStart(e) {
	    // Prevent selection on IE
	    // and instead ask it to consider dragging.
	    e.preventDefault();
	    if (typeof e.target.dragDrop === 'function') {
	      e.target.dragDrop();
	    }
	  };
	
	  return HTML5Backend;
	})();
	
	function createHTML5Backend(manager) {
	  return new HTML5Backend(manager);
	}

/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	/*
	
	   this index.js file is used for including the faker library as a CommonJS module, instead of a bundle
	
	   you can include the faker library into your existing node.js application by requiring the entire /faker directory
	
	    var faker = require(./faker);
	    var randomName = faker.name.findName();
	
	   you can also simply include the "faker.js" file which is the auto-generated bundled version of the faker library
	
	    var faker = require(./customAppPath/faker);
	    var randomName = faker.name.findName();
	
	
	  if you plan on modifying the faker library you should be performing your changes in the /lib/ directory
	
	*/
	
	exports.name = __webpack_require__(323);
	exports.address = __webpack_require__(284);
	exports.phone = __webpack_require__(324);
	exports.internet = __webpack_require__(290);
	exports.company = __webpack_require__(285);
	exports.image = __webpack_require__(289);
	exports.lorem = __webpack_require__(322);
	exports.helpers =  __webpack_require__(54);
	exports.date = __webpack_require__(286);
	exports.random = __webpack_require__(325);
	exports.finance = __webpack_require__(287);
	exports.hacker = __webpack_require__(288);
	
	var locales = exports.locales = __webpack_require__(291);
	
	// default locale
	exports.locale = "en";
	
	// in case a locale is missing a definition, fallback to this locale
	exports.localeFallback = "en";
	
	exports.definitions = {};
	
	var _definitions = {
	  "name": ["first_name", "last_name", "prefix", "suffix", "title"],
	  "address": ["city_prefix", "city_suffix", "street_suffix", "county", "country", "state", "state_abbr"],
	  "company": ["adjective", "noun", "descriptor", "bs_adjective", "bs_noun", "bs_verb"],
	  "lorem": ["words"],
	  "hacker": ["abbreviation", "adjective", "noun", "verb", "ingverb"],
	  "phone_number": ["formats"],
	  "finance": ["account_type", "transaction_type", "currency"],
	  "internet": ["avatar_uri", "domain_suffix", "free_email", "password"]
	};
	
	// Create a Getter for all definitions.foo.bar propetries
	Object.keys(_definitions).forEach(function(d){
	  if (typeof exports.definitions[d] === "undefined") {
	    exports.definitions[d] = {};
	  }
	  _definitions[d].forEach(function(p){
	    Object.defineProperty(exports.definitions[d], p, {
	      get: function () {
	        if (typeof locales[exports.locale][d] === "undefined" || typeof locales[exports.locale][d][p] === "undefined") {
	          // certain localization sets contain less data then others.
	          // in the case of a missing defintion, use the default localeFallback to substitute the missing set data
	          return locales[exports.localeFallback][d][p];
	        } else {
	          // return localized data
	          return locales[exports.locale][d][p];
	        }
	      }
	    });
	  });
	});


/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EventConstants
	 */
	
	'use strict';
	
	var keyMirror = __webpack_require__(48);
	
	var PropagationPhases = keyMirror({bubbled: null, captured: null});
	
	/**
	 * Types of raw signals from the browser caught at the top level.
	 */
	var topLevelTypes = keyMirror({
	  topBlur: null,
	  topChange: null,
	  topClick: null,
	  topCompositionEnd: null,
	  topCompositionStart: null,
	  topCompositionUpdate: null,
	  topContextMenu: null,
	  topCopy: null,
	  topCut: null,
	  topDoubleClick: null,
	  topDrag: null,
	  topDragEnd: null,
	  topDragEnter: null,
	  topDragExit: null,
	  topDragLeave: null,
	  topDragOver: null,
	  topDragStart: null,
	  topDrop: null,
	  topError: null,
	  topFocus: null,
	  topInput: null,
	  topKeyDown: null,
	  topKeyPress: null,
	  topKeyUp: null,
	  topLoad: null,
	  topMouseDown: null,
	  topMouseMove: null,
	  topMouseOut: null,
	  topMouseOver: null,
	  topMouseUp: null,
	  topPaste: null,
	  topReset: null,
	  topScroll: null,
	  topSelectionChange: null,
	  topSubmit: null,
	  topTextInput: null,
	  topTouchCancel: null,
	  topTouchEnd: null,
	  topTouchMove: null,
	  topTouchStart: null,
	  topWheel: null
	});
	
	var EventConstants = {
	  topLevelTypes: topLevelTypes,
	  PropagationPhases: PropagationPhases
	};
	
	module.exports = EventConstants;


/***/ },
/* 13 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactClass
	 */
	
	'use strict';
	
	var ReactComponent = __webpack_require__(145);
	var ReactCurrentOwner = __webpack_require__(19);
	var ReactElement = __webpack_require__(7);
	var ReactErrorUtils = __webpack_require__(432);
	var ReactInstanceMap = __webpack_require__(36);
	var ReactLifeCycle = __webpack_require__(91);
	var ReactPropTypeLocations = __webpack_require__(92);
	var ReactPropTypeLocationNames = __webpack_require__(62);
	var ReactUpdateQueue = __webpack_require__(93);
	
	var assign = __webpack_require__(5);
	var invariant = __webpack_require__(2);
	var keyMirror = __webpack_require__(48);
	var keyOf = __webpack_require__(21);
	var warning = __webpack_require__(6);
	
	var MIXINS_KEY = keyOf({mixins: null});
	
	/**
	 * Policies that describe methods in `ReactClassInterface`.
	 */
	var SpecPolicy = keyMirror({
	  /**
	   * These methods may be defined only once by the class specification or mixin.
	   */
	  DEFINE_ONCE: null,
	  /**
	   * These methods may be defined by both the class specification and mixins.
	   * Subsequent definitions will be chained. These methods must return void.
	   */
	  DEFINE_MANY: null,
	  /**
	   * These methods are overriding the base class.
	   */
	  OVERRIDE_BASE: null,
	  /**
	   * These methods are similar to DEFINE_MANY, except we assume they return
	   * objects. We try to merge the keys of the return values of all the mixed in
	   * functions. If there is a key conflict we throw.
	   */
	  DEFINE_MANY_MERGED: null
	});
	
	
	var injectedMixins = [];
	
	/**
	 * Composite components are higher-level components that compose other composite
	 * or native components.
	 *
	 * To create a new type of `ReactClass`, pass a specification of
	 * your new class to `React.createClass`. The only requirement of your class
	 * specification is that you implement a `render` method.
	 *
	 *   var MyComponent = React.createClass({
	 *     render: function() {
	 *       return <div>Hello World</div>;
	 *     }
	 *   });
	 *
	 * The class specification supports a specific protocol of methods that have
	 * special meaning (e.g. `render`). See `ReactClassInterface` for
	 * more the comprehensive protocol. Any other properties and methods in the
	 * class specification will available on the prototype.
	 *
	 * @interface ReactClassInterface
	 * @internal
	 */
	var ReactClassInterface = {
	
	  /**
	   * An array of Mixin objects to include when defining your component.
	   *
	   * @type {array}
	   * @optional
	   */
	  mixins: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * An object containing properties and methods that should be defined on
	   * the component's constructor instead of its prototype (static methods).
	   *
	   * @type {object}
	   * @optional
	   */
	  statics: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Definition of prop types for this component.
	   *
	   * @type {object}
	   * @optional
	   */
	  propTypes: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Definition of context types for this component.
	   *
	   * @type {object}
	   * @optional
	   */
	  contextTypes: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Definition of context types this component sets for its children.
	   *
	   * @type {object}
	   * @optional
	   */
	  childContextTypes: SpecPolicy.DEFINE_MANY,
	
	  // ==== Definition methods ====
	
	  /**
	   * Invoked when the component is mounted. Values in the mapping will be set on
	   * `this.props` if that prop is not specified (i.e. using an `in` check).
	   *
	   * This method is invoked before `getInitialState` and therefore cannot rely
	   * on `this.state` or use `this.setState`.
	   *
	   * @return {object}
	   * @optional
	   */
	  getDefaultProps: SpecPolicy.DEFINE_MANY_MERGED,
	
	  /**
	   * Invoked once before the component is mounted. The return value will be used
	   * as the initial value of `this.state`.
	   *
	   *   getInitialState: function() {
	   *     return {
	   *       isOn: false,
	   *       fooBaz: new BazFoo()
	   *     }
	   *   }
	   *
	   * @return {object}
	   * @optional
	   */
	  getInitialState: SpecPolicy.DEFINE_MANY_MERGED,
	
	  /**
	   * @return {object}
	   * @optional
	   */
	  getChildContext: SpecPolicy.DEFINE_MANY_MERGED,
	
	  /**
	   * Uses props from `this.props` and state from `this.state` to render the
	   * structure of the component.
	   *
	   * No guarantees are made about when or how often this method is invoked, so
	   * it must not have side effects.
	   *
	   *   render: function() {
	   *     var name = this.props.name;
	   *     return <div>Hello, {name}!</div>;
	   *   }
	   *
	   * @return {ReactComponent}
	   * @nosideeffects
	   * @required
	   */
	  render: SpecPolicy.DEFINE_ONCE,
	
	
	
	  // ==== Delegate methods ====
	
	  /**
	   * Invoked when the component is initially created and about to be mounted.
	   * This may have side effects, but any external subscriptions or data created
	   * by this method must be cleaned up in `componentWillUnmount`.
	   *
	   * @optional
	   */
	  componentWillMount: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Invoked when the component has been mounted and has a DOM representation.
	   * However, there is no guarantee that the DOM node is in the document.
	   *
	   * Use this as an opportunity to operate on the DOM when the component has
	   * been mounted (initialized and rendered) for the first time.
	   *
	   * @param {DOMElement} rootNode DOM element representing the component.
	   * @optional
	   */
	  componentDidMount: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Invoked before the component receives new props.
	   *
	   * Use this as an opportunity to react to a prop transition by updating the
	   * state using `this.setState`. Current props are accessed via `this.props`.
	   *
	   *   componentWillReceiveProps: function(nextProps, nextContext) {
	   *     this.setState({
	   *       likesIncreasing: nextProps.likeCount > this.props.likeCount
	   *     });
	   *   }
	   *
	   * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
	   * transition may cause a state change, but the opposite is not true. If you
	   * need it, you are probably looking for `componentWillUpdate`.
	   *
	   * @param {object} nextProps
	   * @optional
	   */
	  componentWillReceiveProps: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Invoked while deciding if the component should be updated as a result of
	   * receiving new props, state and/or context.
	   *
	   * Use this as an opportunity to `return false` when you're certain that the
	   * transition to the new props/state/context will not require a component
	   * update.
	   *
	   *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
	   *     return !equal(nextProps, this.props) ||
	   *       !equal(nextState, this.state) ||
	   *       !equal(nextContext, this.context);
	   *   }
	   *
	   * @param {object} nextProps
	   * @param {?object} nextState
	   * @param {?object} nextContext
	   * @return {boolean} True if the component should update.
	   * @optional
	   */
	  shouldComponentUpdate: SpecPolicy.DEFINE_ONCE,
	
	  /**
	   * Invoked when the component is about to update due to a transition from
	   * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
	   * and `nextContext`.
	   *
	   * Use this as an opportunity to perform preparation before an update occurs.
	   *
	   * NOTE: You **cannot** use `this.setState()` in this method.
	   *
	   * @param {object} nextProps
	   * @param {?object} nextState
	   * @param {?object} nextContext
	   * @param {ReactReconcileTransaction} transaction
	   * @optional
	   */
	  componentWillUpdate: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Invoked when the component's DOM representation has been updated.
	   *
	   * Use this as an opportunity to operate on the DOM when the component has
	   * been updated.
	   *
	   * @param {object} prevProps
	   * @param {?object} prevState
	   * @param {?object} prevContext
	   * @param {DOMElement} rootNode DOM element representing the component.
	   * @optional
	   */
	  componentDidUpdate: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Invoked when the component is about to be removed from its parent and have
	   * its DOM representation destroyed.
	   *
	   * Use this as an opportunity to deallocate any external resources.
	   *
	   * NOTE: There is no `componentDidUnmount` since your component will have been
	   * destroyed by that point.
	   *
	   * @optional
	   */
	  componentWillUnmount: SpecPolicy.DEFINE_MANY,
	
	
	
	  // ==== Advanced methods ====
	
	  /**
	   * Updates the component's currently mounted DOM representation.
	   *
	   * By default, this implements React's rendering and reconciliation algorithm.
	   * Sophisticated clients may wish to override this.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   * @overridable
	   */
	  updateComponent: SpecPolicy.OVERRIDE_BASE
	
	};
	
	/**
	 * Mapping from class specification keys to special processing functions.
	 *
	 * Although these are declared like instance properties in the specification
	 * when defining classes using `React.createClass`, they are actually static
	 * and are accessible on the constructor instead of the prototype. Despite
	 * being static, they must be defined outside of the "statics" key under
	 * which all other static methods are defined.
	 */
	var RESERVED_SPEC_KEYS = {
	  displayName: function(Constructor, displayName) {
	    Constructor.displayName = displayName;
	  },
	  mixins: function(Constructor, mixins) {
	    if (mixins) {
	      for (var i = 0; i < mixins.length; i++) {
	        mixSpecIntoComponent(Constructor, mixins[i]);
	      }
	    }
	  },
	  childContextTypes: function(Constructor, childContextTypes) {
	    if (false) {
	      validateTypeDef(
	        Constructor,
	        childContextTypes,
	        ReactPropTypeLocations.childContext
	      );
	    }
	    Constructor.childContextTypes = assign(
	      {},
	      Constructor.childContextTypes,
	      childContextTypes
	    );
	  },
	  contextTypes: function(Constructor, contextTypes) {
	    if (false) {
	      validateTypeDef(
	        Constructor,
	        contextTypes,
	        ReactPropTypeLocations.context
	      );
	    }
	    Constructor.contextTypes = assign(
	      {},
	      Constructor.contextTypes,
	      contextTypes
	    );
	  },
	  /**
	   * Special case getDefaultProps which should move into statics but requires
	   * automatic merging.
	   */
	  getDefaultProps: function(Constructor, getDefaultProps) {
	    if (Constructor.getDefaultProps) {
	      Constructor.getDefaultProps = createMergedResultFunction(
	        Constructor.getDefaultProps,
	        getDefaultProps
	      );
	    } else {
	      Constructor.getDefaultProps = getDefaultProps;
	    }
	  },
	  propTypes: function(Constructor, propTypes) {
	    if (false) {
	      validateTypeDef(
	        Constructor,
	        propTypes,
	        ReactPropTypeLocations.prop
	      );
	    }
	    Constructor.propTypes = assign(
	      {},
	      Constructor.propTypes,
	      propTypes
	    );
	  },
	  statics: function(Constructor, statics) {
	    mixStaticSpecIntoComponent(Constructor, statics);
	  }
	};
	
	function validateTypeDef(Constructor, typeDef, location) {
	  for (var propName in typeDef) {
	    if (typeDef.hasOwnProperty(propName)) {
	      // use a warning instead of an invariant so components
	      // don't show up in prod but not in __DEV__
	      ( false ? warning(
	        typeof typeDef[propName] === 'function',
	        '%s: %s type `%s` is invalid; it must be a function, usually from ' +
	        'React.PropTypes.',
	        Constructor.displayName || 'ReactClass',
	        ReactPropTypeLocationNames[location],
	        propName
	      ) : null);
	    }
	  }
	}
	
	function validateMethodOverride(proto, name) {
	  var specPolicy = ReactClassInterface.hasOwnProperty(name) ?
	    ReactClassInterface[name] :
	    null;
	
	  // Disallow overriding of base class methods unless explicitly allowed.
	  if (ReactClassMixin.hasOwnProperty(name)) {
	    ( false ? invariant(
	      specPolicy === SpecPolicy.OVERRIDE_BASE,
	      'ReactClassInterface: You are attempting to override ' +
	      '`%s` from your class specification. Ensure that your method names ' +
	      'do not overlap with React methods.',
	      name
	    ) : invariant(specPolicy === SpecPolicy.OVERRIDE_BASE));
	  }
	
	  // Disallow defining methods more than once unless explicitly allowed.
	  if (proto.hasOwnProperty(name)) {
	    ( false ? invariant(
	      specPolicy === SpecPolicy.DEFINE_MANY ||
	      specPolicy === SpecPolicy.DEFINE_MANY_MERGED,
	      'ReactClassInterface: You are attempting to define ' +
	      '`%s` on your component more than once. This conflict may be due ' +
	      'to a mixin.',
	      name
	    ) : invariant(specPolicy === SpecPolicy.DEFINE_MANY ||
	    specPolicy === SpecPolicy.DEFINE_MANY_MERGED));
	  }
	}
	
	/**
	 * Mixin helper which handles policy validation and reserved
	 * specification keys when building React classses.
	 */
	function mixSpecIntoComponent(Constructor, spec) {
	  if (!spec) {
	    return;
	  }
	
	  ( false ? invariant(
	    typeof spec !== 'function',
	    'ReactClass: You\'re attempting to ' +
	    'use a component class as a mixin. Instead, just use a regular object.'
	  ) : invariant(typeof spec !== 'function'));
	  ( false ? invariant(
	    !ReactElement.isValidElement(spec),
	    'ReactClass: You\'re attempting to ' +
	    'use a component as a mixin. Instead, just use a regular object.'
	  ) : invariant(!ReactElement.isValidElement(spec)));
	
	  var proto = Constructor.prototype;
	
	  // By handling mixins before any other properties, we ensure the same
	  // chaining order is applied to methods with DEFINE_MANY policy, whether
	  // mixins are listed before or after these methods in the spec.
	  if (spec.hasOwnProperty(MIXINS_KEY)) {
	    RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
	  }
	
	  for (var name in spec) {
	    if (!spec.hasOwnProperty(name)) {
	      continue;
	    }
	
	    if (name === MIXINS_KEY) {
	      // We have already handled mixins in a special case above
	      continue;
	    }
	
	    var property = spec[name];
	    validateMethodOverride(proto, name);
	
	    if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
	      RESERVED_SPEC_KEYS[name](Constructor, property);
	    } else {
	      // Setup methods on prototype:
	      // The following member methods should not be automatically bound:
	      // 1. Expected ReactClass methods (in the "interface").
	      // 2. Overridden methods (that were mixed in).
	      var isReactClassMethod =
	        ReactClassInterface.hasOwnProperty(name);
	      var isAlreadyDefined = proto.hasOwnProperty(name);
	      var markedDontBind = property && property.__reactDontBind;
	      var isFunction = typeof property === 'function';
	      var shouldAutoBind =
	        isFunction &&
	        !isReactClassMethod &&
	        !isAlreadyDefined &&
	        !markedDontBind;
	
	      if (shouldAutoBind) {
	        if (!proto.__reactAutoBindMap) {
	          proto.__reactAutoBindMap = {};
	        }
	        proto.__reactAutoBindMap[name] = property;
	        proto[name] = property;
	      } else {
	        if (isAlreadyDefined) {
	          var specPolicy = ReactClassInterface[name];
	
	          // These cases should already be caught by validateMethodOverride
	          ( false ? invariant(
	            isReactClassMethod && (
	              (specPolicy === SpecPolicy.DEFINE_MANY_MERGED || specPolicy === SpecPolicy.DEFINE_MANY)
	            ),
	            'ReactClass: Unexpected spec policy %s for key %s ' +
	            'when mixing in component specs.',
	            specPolicy,
	            name
	          ) : invariant(isReactClassMethod && (
	            (specPolicy === SpecPolicy.DEFINE_MANY_MERGED || specPolicy === SpecPolicy.DEFINE_MANY)
	          )));
	
	          // For methods which are defined more than once, call the existing
	          // methods before calling the new property, merging if appropriate.
	          if (specPolicy === SpecPolicy.DEFINE_MANY_MERGED) {
	            proto[name] = createMergedResultFunction(proto[name], property);
	          } else if (specPolicy === SpecPolicy.DEFINE_MANY) {
	            proto[name] = createChainedFunction(proto[name], property);
	          }
	        } else {
	          proto[name] = property;
	          if (false) {
	            // Add verbose displayName to the function, which helps when looking
	            // at profiling tools.
	            if (typeof property === 'function' && spec.displayName) {
	              proto[name].displayName = spec.displayName + '_' + name;
	            }
	          }
	        }
	      }
	    }
	  }
	}
	
	function mixStaticSpecIntoComponent(Constructor, statics) {
	  if (!statics) {
	    return;
	  }
	  for (var name in statics) {
	    var property = statics[name];
	    if (!statics.hasOwnProperty(name)) {
	      continue;
	    }
	
	    var isReserved = name in RESERVED_SPEC_KEYS;
	    ( false ? invariant(
	      !isReserved,
	      'ReactClass: You are attempting to define a reserved ' +
	      'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
	      'as an instance property instead; it will still be accessible on the ' +
	      'constructor.',
	      name
	    ) : invariant(!isReserved));
	
	    var isInherited = name in Constructor;
	    ( false ? invariant(
	      !isInherited,
	      'ReactClass: You are attempting to define ' +
	      '`%s` on your component more than once. This conflict may be ' +
	      'due to a mixin.',
	      name
	    ) : invariant(!isInherited));
	    Constructor[name] = property;
	  }
	}
	
	/**
	 * Merge two objects, but throw if both contain the same key.
	 *
	 * @param {object} one The first object, which is mutated.
	 * @param {object} two The second object
	 * @return {object} one after it has been mutated to contain everything in two.
	 */
	function mergeIntoWithNoDuplicateKeys(one, two) {
	  ( false ? invariant(
	    one && two && typeof one === 'object' && typeof two === 'object',
	    'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
	  ) : invariant(one && two && typeof one === 'object' && typeof two === 'object'));
	
	  for (var key in two) {
	    if (two.hasOwnProperty(key)) {
	      ( false ? invariant(
	        one[key] === undefined,
	        'mergeIntoWithNoDuplicateKeys(): ' +
	        'Tried to merge two objects with the same key: `%s`. This conflict ' +
	        'may be due to a mixin; in particular, this may be caused by two ' +
	        'getInitialState() or getDefaultProps() methods returning objects ' +
	        'with clashing keys.',
	        key
	      ) : invariant(one[key] === undefined));
	      one[key] = two[key];
	    }
	  }
	  return one;
	}
	
	/**
	 * Creates a function that invokes two functions and merges their return values.
	 *
	 * @param {function} one Function to invoke first.
	 * @param {function} two Function to invoke second.
	 * @return {function} Function that invokes the two argument functions.
	 * @private
	 */
	function createMergedResultFunction(one, two) {
	  return function mergedResult() {
	    var a = one.apply(this, arguments);
	    var b = two.apply(this, arguments);
	    if (a == null) {
	      return b;
	    } else if (b == null) {
	      return a;
	    }
	    var c = {};
	    mergeIntoWithNoDuplicateKeys(c, a);
	    mergeIntoWithNoDuplicateKeys(c, b);
	    return c;
	  };
	}
	
	/**
	 * Creates a function that invokes two functions and ignores their return vales.
	 *
	 * @param {function} one Function to invoke first.
	 * @param {function} two Function to invoke second.
	 * @return {function} Function that invokes the two argument functions.
	 * @private
	 */
	function createChainedFunction(one, two) {
	  return function chainedFunction() {
	    one.apply(this, arguments);
	    two.apply(this, arguments);
	  };
	}
	
	/**
	 * Binds a method to the component.
	 *
	 * @param {object} component Component whose method is going to be bound.
	 * @param {function} method Method to be bound.
	 * @return {function} The bound method.
	 */
	function bindAutoBindMethod(component, method) {
	  var boundMethod = method.bind(component);
	  if (false) {
	    boundMethod.__reactBoundContext = component;
	    boundMethod.__reactBoundMethod = method;
	    boundMethod.__reactBoundArguments = null;
	    var componentName = component.constructor.displayName;
	    var _bind = boundMethod.bind;
	    /* eslint-disable block-scoped-var, no-undef */
	    boundMethod.bind = function(newThis ) {for (var args=[],$__0=1,$__1=arguments.length;$__0<$__1;$__0++) args.push(arguments[$__0]);
	      // User is trying to bind() an autobound method; we effectively will
	      // ignore the value of "this" that the user is trying to use, so
	      // let's warn.
	      if (newThis !== component && newThis !== null) {
	        ("production" !== process.env.NODE_ENV ? warning(
	          false,
	          'bind(): React component methods may only be bound to the ' +
	          'component instance. See %s',
	          componentName
	        ) : null);
	      } else if (!args.length) {
	        ("production" !== process.env.NODE_ENV ? warning(
	          false,
	          'bind(): You are binding a component method to the component. ' +
	          'React does this for you automatically in a high-performance ' +
	          'way, so you can safely remove this call. See %s',
	          componentName
	        ) : null);
	        return boundMethod;
	      }
	      var reboundMethod = _bind.apply(boundMethod, arguments);
	      reboundMethod.__reactBoundContext = component;
	      reboundMethod.__reactBoundMethod = method;
	      reboundMethod.__reactBoundArguments = args;
	      return reboundMethod;
	      /* eslint-enable */
	    };
	  }
	  return boundMethod;
	}
	
	/**
	 * Binds all auto-bound methods in a component.
	 *
	 * @param {object} component Component whose method is going to be bound.
	 */
	function bindAutoBindMethods(component) {
	  for (var autoBindKey in component.__reactAutoBindMap) {
	    if (component.__reactAutoBindMap.hasOwnProperty(autoBindKey)) {
	      var method = component.__reactAutoBindMap[autoBindKey];
	      component[autoBindKey] = bindAutoBindMethod(
	        component,
	        ReactErrorUtils.guard(
	          method,
	          component.constructor.displayName + '.' + autoBindKey
	        )
	      );
	    }
	  }
	}
	
	var typeDeprecationDescriptor = {
	  enumerable: false,
	  get: function() {
	    var displayName = this.displayName || this.name || 'Component';
	    ( false ? warning(
	      false,
	      '%s.type is deprecated. Use %s directly to access the class.',
	      displayName,
	      displayName
	    ) : null);
	    Object.defineProperty(this, 'type', {
	      value: this
	    });
	    return this;
	  }
	};
	
	/**
	 * Add more to the ReactClass base class. These are all legacy features and
	 * therefore not already part of the modern ReactComponent.
	 */
	var ReactClassMixin = {
	
	  /**
	   * TODO: This will be deprecated because state should always keep a consistent
	   * type signature and the only use case for this, is to avoid that.
	   */
	  replaceState: function(newState, callback) {
	    ReactUpdateQueue.enqueueReplaceState(this, newState);
	    if (callback) {
	      ReactUpdateQueue.enqueueCallback(this, callback);
	    }
	  },
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function() {
	    if (false) {
	      var owner = ReactCurrentOwner.current;
	      if (owner !== null) {
	        ("production" !== process.env.NODE_ENV ? warning(
	          owner._warnedAboutRefsInRender,
	          '%s is accessing isMounted inside its render() function. ' +
	          'render() should be a pure function of props and state. It should ' +
	          'never access something that requires stale data from the previous ' +
	          'render, such as refs. Move this logic to componentDidMount and ' +
	          'componentDidUpdate instead.',
	          owner.getName() || 'A component'
	        ) : null);
	        owner._warnedAboutRefsInRender = true;
	      }
	    }
	    var internalInstance = ReactInstanceMap.get(this);
	    return (
	      internalInstance &&
	      internalInstance !== ReactLifeCycle.currentlyMountingInstance
	    );
	  },
	
	  /**
	   * Sets a subset of the props.
	   *
	   * @param {object} partialProps Subset of the next props.
	   * @param {?function} callback Called after props are updated.
	   * @final
	   * @public
	   * @deprecated
	   */
	  setProps: function(partialProps, callback) {
	    ReactUpdateQueue.enqueueSetProps(this, partialProps);
	    if (callback) {
	      ReactUpdateQueue.enqueueCallback(this, callback);
	    }
	  },
	
	  /**
	   * Replace all the props.
	   *
	   * @param {object} newProps Subset of the next props.
	   * @param {?function} callback Called after props are updated.
	   * @final
	   * @public
	   * @deprecated
	   */
	  replaceProps: function(newProps, callback) {
	    ReactUpdateQueue.enqueueReplaceProps(this, newProps);
	    if (callback) {
	      ReactUpdateQueue.enqueueCallback(this, callback);
	    }
	  }
	};
	
	var ReactClassComponent = function() {};
	assign(
	  ReactClassComponent.prototype,
	  ReactComponent.prototype,
	  ReactClassMixin
	);
	
	/**
	 * Module for creating composite components.
	 *
	 * @class ReactClass
	 */
	var ReactClass = {
	
	  /**
	   * Creates a composite component class given a class specification.
	   *
	   * @param {object} spec Class specification (which must define `render`).
	   * @return {function} Component constructor function.
	   * @public
	   */
	  createClass: function(spec) {
	    var Constructor = function(props, context) {
	      // This constructor is overridden by mocks. The argument is used
	      // by mocks to assert on what gets mounted.
	
	      if (false) {
	        ("production" !== process.env.NODE_ENV ? warning(
	          this instanceof Constructor,
	          'Something is calling a React component directly. Use a factory or ' +
	          'JSX instead. See: https://fb.me/react-legacyfactory'
	        ) : null);
	      }
	
	      // Wire up auto-binding
	      if (this.__reactAutoBindMap) {
	        bindAutoBindMethods(this);
	      }
	
	      this.props = props;
	      this.context = context;
	      this.state = null;
	
	      // ReactClasses doesn't have constructors. Instead, they use the
	      // getInitialState and componentWillMount methods for initialization.
	
	      var initialState = this.getInitialState ? this.getInitialState() : null;
	      if (false) {
	        // We allow auto-mocks to proceed as if they're returning null.
	        if (typeof initialState === 'undefined' &&
	            this.getInitialState._isMockFunction) {
	          // This is probably bad practice. Consider warning here and
	          // deprecating this convenience.
	          initialState = null;
	        }
	      }
	      ( false ? invariant(
	        typeof initialState === 'object' && !Array.isArray(initialState),
	        '%s.getInitialState(): must return an object or null',
	        Constructor.displayName || 'ReactCompositeComponent'
	      ) : invariant(typeof initialState === 'object' && !Array.isArray(initialState)));
	
	      this.state = initialState;
	    };
	    Constructor.prototype = new ReactClassComponent();
	    Constructor.prototype.constructor = Constructor;
	
	    injectedMixins.forEach(
	      mixSpecIntoComponent.bind(null, Constructor)
	    );
	
	    mixSpecIntoComponent(Constructor, spec);
	
	    // Initialize the defaultProps property after all mixins have been merged
	    if (Constructor.getDefaultProps) {
	      Constructor.defaultProps = Constructor.getDefaultProps();
	    }
	
	    if (false) {
	      // This is a tag to indicate that the use of these method names is ok,
	      // since it's used with createClass. If it's not, then it's likely a
	      // mistake so we'll warn you to use the static property, property
	      // initializer or constructor respectively.
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps.isReactClassApproved = {};
	      }
	      if (Constructor.prototype.getInitialState) {
	        Constructor.prototype.getInitialState.isReactClassApproved = {};
	      }
	    }
	
	    ( false ? invariant(
	      Constructor.prototype.render,
	      'createClass(...): Class specification must implement a `render` method.'
	    ) : invariant(Constructor.prototype.render));
	
	    if (false) {
	      ("production" !== process.env.NODE_ENV ? warning(
	        !Constructor.prototype.componentShouldUpdate,
	        '%s has a method called ' +
	        'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
	        'The name is phrased as a question because the function is ' +
	        'expected to return a value.',
	        spec.displayName || 'A component'
	      ) : null);
	    }
	
	    // Reduce time spent doing lookups by setting these on the prototype.
	    for (var methodName in ReactClassInterface) {
	      if (!Constructor.prototype[methodName]) {
	        Constructor.prototype[methodName] = null;
	      }
	    }
	
	    // Legacy hook
	    Constructor.type = Constructor;
	    if (false) {
	      try {
	        Object.defineProperty(Constructor, 'type', typeDeprecationDescriptor);
	      } catch (x) {
	        // IE will fail on defineProperty (es5-shim/sham too)
	      }
	    }
	
	    return Constructor;
	  },
	
	  injection: {
	    injectMixin: function(mixin) {
	      injectedMixins.push(mixin);
	    }
	  }
	
	};
	
	module.exports = ReactClass;


/***/ },
/* 14 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactUpdates
	 */
	
	'use strict';
	
	var CallbackQueue = __webpack_require__(82);
	var PooledClass = __webpack_require__(17);
	var ReactCurrentOwner = __webpack_require__(19);
	var ReactPerf = __webpack_require__(27);
	var ReactReconciler = __webpack_require__(37);
	var Transaction = __webpack_require__(64);
	
	var assign = __webpack_require__(5);
	var invariant = __webpack_require__(2);
	var warning = __webpack_require__(6);
	
	var dirtyComponents = [];
	var asapCallbackQueue = CallbackQueue.getPooled();
	var asapEnqueued = false;
	
	var batchingStrategy = null;
	
	function ensureInjected() {
	  ( false ? invariant(
	    ReactUpdates.ReactReconcileTransaction && batchingStrategy,
	    'ReactUpdates: must inject a reconcile transaction class and batching ' +
	    'strategy'
	  ) : invariant(ReactUpdates.ReactReconcileTransaction && batchingStrategy));
	}
	
	var NESTED_UPDATES = {
	  initialize: function() {
	    this.dirtyComponentsLength = dirtyComponents.length;
	  },
	  close: function() {
	    if (this.dirtyComponentsLength !== dirtyComponents.length) {
	      // Additional updates were enqueued by componentDidUpdate handlers or
	      // similar; before our own UPDATE_QUEUEING wrapper closes, we want to run
	      // these new updates so that if A's componentDidUpdate calls setState on
	      // B, B will update before the callback A's updater provided when calling
	      // setState.
	      dirtyComponents.splice(0, this.dirtyComponentsLength);
	      flushBatchedUpdates();
	    } else {
	      dirtyComponents.length = 0;
	    }
	  }
	};
	
	var UPDATE_QUEUEING = {
	  initialize: function() {
	    this.callbackQueue.reset();
	  },
	  close: function() {
	    this.callbackQueue.notifyAll();
	  }
	};
	
	var TRANSACTION_WRAPPERS = [NESTED_UPDATES, UPDATE_QUEUEING];
	
	function ReactUpdatesFlushTransaction() {
	  this.reinitializeTransaction();
	  this.dirtyComponentsLength = null;
	  this.callbackQueue = CallbackQueue.getPooled();
	  this.reconcileTransaction =
	    ReactUpdates.ReactReconcileTransaction.getPooled();
	}
	
	assign(
	  ReactUpdatesFlushTransaction.prototype,
	  Transaction.Mixin, {
	  getTransactionWrappers: function() {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  destructor: function() {
	    this.dirtyComponentsLength = null;
	    CallbackQueue.release(this.callbackQueue);
	    this.callbackQueue = null;
	    ReactUpdates.ReactReconcileTransaction.release(this.reconcileTransaction);
	    this.reconcileTransaction = null;
	  },
	
	  perform: function(method, scope, a) {
	    // Essentially calls `this.reconcileTransaction.perform(method, scope, a)`
	    // with this transaction's wrappers around it.
	    return Transaction.Mixin.perform.call(
	      this,
	      this.reconcileTransaction.perform,
	      this.reconcileTransaction,
	      method,
	      scope,
	      a
	    );
	  }
	});
	
	PooledClass.addPoolingTo(ReactUpdatesFlushTransaction);
	
	function batchedUpdates(callback, a, b, c, d) {
	  ensureInjected();
	  batchingStrategy.batchedUpdates(callback, a, b, c, d);
	}
	
	/**
	 * Array comparator for ReactComponents by mount ordering.
	 *
	 * @param {ReactComponent} c1 first component you're comparing
	 * @param {ReactComponent} c2 second component you're comparing
	 * @return {number} Return value usable by Array.prototype.sort().
	 */
	function mountOrderComparator(c1, c2) {
	  return c1._mountOrder - c2._mountOrder;
	}
	
	function runBatchedUpdates(transaction) {
	  var len = transaction.dirtyComponentsLength;
	  ( false ? invariant(
	    len === dirtyComponents.length,
	    'Expected flush transaction\'s stored dirty-components length (%s) to ' +
	    'match dirty-components array length (%s).',
	    len,
	    dirtyComponents.length
	  ) : invariant(len === dirtyComponents.length));
	
	  // Since reconciling a component higher in the owner hierarchy usually (not
	  // always -- see shouldComponentUpdate()) will reconcile children, reconcile
	  // them before their children by sorting the array.
	  dirtyComponents.sort(mountOrderComparator);
	
	  for (var i = 0; i < len; i++) {
	    // If a component is unmounted before pending changes apply, it will still
	    // be here, but we assume that it has cleared its _pendingCallbacks and
	    // that performUpdateIfNecessary is a noop.
	    var component = dirtyComponents[i];
	
	    // If performUpdateIfNecessary happens to enqueue any new updates, we
	    // shouldn't execute the callbacks until the next render happens, so
	    // stash the callbacks first
	    var callbacks = component._pendingCallbacks;
	    component._pendingCallbacks = null;
	
	    ReactReconciler.performUpdateIfNecessary(
	      component,
	      transaction.reconcileTransaction
	    );
	
	    if (callbacks) {
	      for (var j = 0; j < callbacks.length; j++) {
	        transaction.callbackQueue.enqueue(
	          callbacks[j],
	          component.getPublicInstance()
	        );
	      }
	    }
	  }
	}
	
	var flushBatchedUpdates = function() {
	  // ReactUpdatesFlushTransaction's wrappers will clear the dirtyComponents
	  // array and perform any updates enqueued by mount-ready handlers (i.e.,
	  // componentDidUpdate) but we need to check here too in order to catch
	  // updates enqueued by setState callbacks and asap calls.
	  while (dirtyComponents.length || asapEnqueued) {
	    if (dirtyComponents.length) {
	      var transaction = ReactUpdatesFlushTransaction.getPooled();
	      transaction.perform(runBatchedUpdates, null, transaction);
	      ReactUpdatesFlushTransaction.release(transaction);
	    }
	
	    if (asapEnqueued) {
	      asapEnqueued = false;
	      var queue = asapCallbackQueue;
	      asapCallbackQueue = CallbackQueue.getPooled();
	      queue.notifyAll();
	      CallbackQueue.release(queue);
	    }
	  }
	};
	flushBatchedUpdates = ReactPerf.measure(
	  'ReactUpdates',
	  'flushBatchedUpdates',
	  flushBatchedUpdates
	);
	
	/**
	 * Mark a component as needing a rerender, adding an optional callback to a
	 * list of functions which will be executed once the rerender occurs.
	 */
	function enqueueUpdate(component) {
	  ensureInjected();
	
	  // Various parts of our code (such as ReactCompositeComponent's
	  // _renderValidatedComponent) assume that calls to render aren't nested;
	  // verify that that's the case. (This is called by each top-level update
	  // function, like setProps, setState, forceUpdate, etc.; creation and
	  // destruction of top-level components is guarded in ReactMount.)
	  ( false ? warning(
	    ReactCurrentOwner.current == null,
	    'enqueueUpdate(): Render methods should be a pure function of props ' +
	    'and state; triggering nested component updates from render is not ' +
	    'allowed. If necessary, trigger nested updates in ' +
	    'componentDidUpdate.'
	  ) : null);
	
	  if (!batchingStrategy.isBatchingUpdates) {
	    batchingStrategy.batchedUpdates(enqueueUpdate, component);
	    return;
	  }
	
	  dirtyComponents.push(component);
	}
	
	/**
	 * Enqueue a callback to be run at the end of the current batching cycle. Throws
	 * if no updates are currently being performed.
	 */
	function asap(callback, context) {
	  ( false ? invariant(
	    batchingStrategy.isBatchingUpdates,
	    'ReactUpdates.asap: Can\'t enqueue an asap callback in a context where' +
	    'updates are not being batched.'
	  ) : invariant(batchingStrategy.isBatchingUpdates));
	  asapCallbackQueue.enqueue(callback, context);
	  asapEnqueued = true;
	}
	
	var ReactUpdatesInjection = {
	  injectReconcileTransaction: function(ReconcileTransaction) {
	    ( false ? invariant(
	      ReconcileTransaction,
	      'ReactUpdates: must provide a reconcile transaction class'
	    ) : invariant(ReconcileTransaction));
	    ReactUpdates.ReactReconcileTransaction = ReconcileTransaction;
	  },
	
	  injectBatchingStrategy: function(_batchingStrategy) {
	    ( false ? invariant(
	      _batchingStrategy,
	      'ReactUpdates: must provide a batching strategy'
	    ) : invariant(_batchingStrategy));
	    ( false ? invariant(
	      typeof _batchingStrategy.batchedUpdates === 'function',
	      'ReactUpdates: must provide a batchedUpdates() function'
	    ) : invariant(typeof _batchingStrategy.batchedUpdates === 'function'));
	    ( false ? invariant(
	      typeof _batchingStrategy.isBatchingUpdates === 'boolean',
	      'ReactUpdates: must provide an isBatchingUpdates boolean attribute'
	    ) : invariant(typeof _batchingStrategy.isBatchingUpdates === 'boolean'));
	    batchingStrategy = _batchingStrategy;
	  }
	};
	
	var ReactUpdates = {
	  /**
	   * React references `ReactReconcileTransaction` using this property in order
	   * to allow dependency injection.
	   *
	   * @internal
	   */
	  ReactReconcileTransaction: null,
	
	  batchedUpdates: batchedUpdates,
	  enqueueUpdate: enqueueUpdate,
	  flushBatchedUpdates: flushBatchedUpdates,
	  injection: ReactUpdatesInjection,
	  asap: asap
	};
	
	module.exports = ReactUpdates;


/***/ },
/* 15 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
	 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(1);
	 * // => false
	 */
	function isObject(value) {
	  // Avoid a V8 JIT bug in Chrome 19-20.
	  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	module.exports = isObject;


/***/ },
/* 16 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var assign = __webpack_require__(5);
	var ReactPropTypes = __webpack_require__(1).PropTypes;
	var Route = __webpack_require__(26);
	
	var PropTypes = assign({}, ReactPropTypes, {
	
	  /**
	   * Indicates that a prop should be falsy.
	   */
	  falsy: function falsy(props, propName, componentName) {
	    if (props[propName]) {
	      return new Error('<' + componentName + '> should not have a "' + propName + '" prop');
	    }
	  },
	
	  /**
	   * Indicates that a prop should be a Route object.
	   */
	  route: ReactPropTypes.instanceOf(Route),
	
	  /**
	   * Indicates that a prop should be a Router object.
	   */
	  //router: ReactPropTypes.instanceOf(Router) // TODO
	  router: ReactPropTypes.func
	
	});
	
	module.exports = PropTypes;

/***/ },
/* 17 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule PooledClass
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(2);
	
	/**
	 * Static poolers. Several custom versions for each potential number of
	 * arguments. A completely generic pooler is easy to implement, but would
	 * require accessing the `arguments` object. In each of these, `this` refers to
	 * the Class itself, not an instance. If any others are needed, simply add them
	 * here, or in their own files.
	 */
	var oneArgumentPooler = function(copyFieldsFrom) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, copyFieldsFrom);
	    return instance;
	  } else {
	    return new Klass(copyFieldsFrom);
	  }
	};
	
	var twoArgumentPooler = function(a1, a2) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2);
	    return instance;
	  } else {
	    return new Klass(a1, a2);
	  }
	};
	
	var threeArgumentPooler = function(a1, a2, a3) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3);
	  }
	};
	
	var fiveArgumentPooler = function(a1, a2, a3, a4, a5) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3, a4, a5);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3, a4, a5);
	  }
	};
	
	var standardReleaser = function(instance) {
	  var Klass = this;
	  ( false ? invariant(
	    instance instanceof Klass,
	    'Trying to release an instance into a pool of a different type.'
	  ) : invariant(instance instanceof Klass));
	  if (instance.destructor) {
	    instance.destructor();
	  }
	  if (Klass.instancePool.length < Klass.poolSize) {
	    Klass.instancePool.push(instance);
	  }
	};
	
	var DEFAULT_POOL_SIZE = 10;
	var DEFAULT_POOLER = oneArgumentPooler;
	
	/**
	 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
	 * itself (statically) not adding any prototypical fields. Any CopyConstructor
	 * you give this may have a `poolSize` property, and will look for a
	 * prototypical `destructor` on instances (optional).
	 *
	 * @param {Function} CopyConstructor Constructor that can be used to reset.
	 * @param {Function} pooler Customizable pooler.
	 */
	var addPoolingTo = function(CopyConstructor, pooler) {
	  var NewKlass = CopyConstructor;
	  NewKlass.instancePool = [];
	  NewKlass.getPooled = pooler || DEFAULT_POOLER;
	  if (!NewKlass.poolSize) {
	    NewKlass.poolSize = DEFAULT_POOL_SIZE;
	  }
	  NewKlass.release = standardReleaser;
	  return NewKlass;
	};
	
	var PooledClass = {
	  addPoolingTo: addPoolingTo,
	  oneArgumentPooler: oneArgumentPooler,
	  twoArgumentPooler: twoArgumentPooler,
	  threeArgumentPooler: threeArgumentPooler,
	  fiveArgumentPooler: fiveArgumentPooler
	};
	
	module.exports = PooledClass;


/***/ },
/* 18 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactBrowserComponentMixin
	 */
	
	'use strict';
	
	var findDOMNode = __webpack_require__(156);
	
	var ReactBrowserComponentMixin = {
	  /**
	   * Returns the DOM node rendered by this component.
	   *
	   * @return {DOMElement} The root node of this component.
	   * @final
	   * @protected
	   */
	  getDOMNode: function() {
	    return findDOMNode(this);
	  }
	};
	
	module.exports = ReactBrowserComponentMixin;


/***/ },
/* 19 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactCurrentOwner
	 */
	
	'use strict';
	
	/**
	 * Keeps track of the current owner.
	 *
	 * The current owner is the component who should own any components that are
	 * currently being constructed.
	 *
	 * The depth indicate how many composite components are above this render level.
	 */
	var ReactCurrentOwner = {
	
	  /**
	   * @internal
	   * @type {ReactComponent}
	   */
	  current: null
	
	};
	
	module.exports = ReactCurrentOwner;


/***/ },
/* 20 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactMount
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(33);
	var ReactBrowserEventEmitter = __webpack_require__(34);
	var ReactCurrentOwner = __webpack_require__(19);
	var ReactElement = __webpack_require__(7);
	var ReactElementValidator = __webpack_require__(46);
	var ReactEmptyComponent = __webpack_require__(90);
	var ReactInstanceHandles = __webpack_require__(35);
	var ReactInstanceMap = __webpack_require__(36);
	var ReactMarkupChecksum = __webpack_require__(149);
	var ReactPerf = __webpack_require__(27);
	var ReactReconciler = __webpack_require__(37);
	var ReactUpdateQueue = __webpack_require__(93);
	var ReactUpdates = __webpack_require__(14);
	
	var emptyObject = __webpack_require__(65);
	var containsNode = __webpack_require__(155);
	var getReactRootElementInContainer = __webpack_require__(464);
	var instantiateReactComponent = __webpack_require__(99);
	var invariant = __webpack_require__(2);
	var setInnerHTML = __webpack_require__(101);
	var shouldUpdateReactComponent = __webpack_require__(102);
	var warning = __webpack_require__(6);
	
	var SEPARATOR = ReactInstanceHandles.SEPARATOR;
	
	var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
	var nodeCache = {};
	
	var ELEMENT_NODE_TYPE = 1;
	var DOC_NODE_TYPE = 9;
	
	/** Mapping from reactRootID to React component instance. */
	var instancesByReactRootID = {};
	
	/** Mapping from reactRootID to `container` nodes. */
	var containersByReactRootID = {};
	
	if (false) {
	  /** __DEV__-only mapping from reactRootID to root elements. */
	  var rootElementsByReactRootID = {};
	}
	
	// Used to store breadth-first search state in findComponentRoot.
	var findComponentRootReusableArray = [];
	
	/**
	 * Finds the index of the first character
	 * that's not common between the two given strings.
	 *
	 * @return {number} the index of the character where the strings diverge
	 */
	function firstDifferenceIndex(string1, string2) {
	  var minLen = Math.min(string1.length, string2.length);
	  for (var i = 0; i < minLen; i++) {
	    if (string1.charAt(i) !== string2.charAt(i)) {
	      return i;
	    }
	  }
	  return string1.length === string2.length ? -1 : minLen;
	}
	
	/**
	 * @param {DOMElement} container DOM element that may contain a React component.
	 * @return {?string} A "reactRoot" ID, if a React component is rendered.
	 */
	function getReactRootID(container) {
	  var rootElement = getReactRootElementInContainer(container);
	  return rootElement && ReactMount.getID(rootElement);
	}
	
	/**
	 * Accessing node[ATTR_NAME] or calling getAttribute(ATTR_NAME) on a form
	 * element can return its control whose name or ID equals ATTR_NAME. All
	 * DOM nodes support `getAttributeNode` but this can also get called on
	 * other objects so just return '' if we're given something other than a
	 * DOM node (such as window).
	 *
	 * @param {?DOMElement|DOMWindow|DOMDocument|DOMTextNode} node DOM node.
	 * @return {string} ID of the supplied `domNode`.
	 */
	function getID(node) {
	  var id = internalGetID(node);
	  if (id) {
	    if (nodeCache.hasOwnProperty(id)) {
	      var cached = nodeCache[id];
	      if (cached !== node) {
	        ( false ? invariant(
	          !isValid(cached, id),
	          'ReactMount: Two valid but unequal nodes with the same `%s`: %s',
	          ATTR_NAME, id
	        ) : invariant(!isValid(cached, id)));
	
	        nodeCache[id] = node;
	      }
	    } else {
	      nodeCache[id] = node;
	    }
	  }
	
	  return id;
	}
	
	function internalGetID(node) {
	  // If node is something like a window, document, or text node, none of
	  // which support attributes or a .getAttribute method, gracefully return
	  // the empty string, as if the attribute were missing.
	  return node && node.getAttribute && node.getAttribute(ATTR_NAME) || '';
	}
	
	/**
	 * Sets the React-specific ID of the given node.
	 *
	 * @param {DOMElement} node The DOM node whose ID will be set.
	 * @param {string} id The value of the ID attribute.
	 */
	function setID(node, id) {
	  var oldID = internalGetID(node);
	  if (oldID !== id) {
	    delete nodeCache[oldID];
	  }
	  node.setAttribute(ATTR_NAME, id);
	  nodeCache[id] = node;
	}
	
	/**
	 * Finds the node with the supplied React-generated DOM ID.
	 *
	 * @param {string} id A React-generated DOM ID.
	 * @return {DOMElement} DOM node with the suppled `id`.
	 * @internal
	 */
	function getNode(id) {
	  if (!nodeCache.hasOwnProperty(id) || !isValid(nodeCache[id], id)) {
	    nodeCache[id] = ReactMount.findReactNodeByID(id);
	  }
	  return nodeCache[id];
	}
	
	/**
	 * Finds the node with the supplied public React instance.
	 *
	 * @param {*} instance A public React instance.
	 * @return {?DOMElement} DOM node with the suppled `id`.
	 * @internal
	 */
	function getNodeFromInstance(instance) {
	  var id = ReactInstanceMap.get(instance)._rootNodeID;
	  if (ReactEmptyComponent.isNullComponentID(id)) {
	    return null;
	  }
	  if (!nodeCache.hasOwnProperty(id) || !isValid(nodeCache[id], id)) {
	    nodeCache[id] = ReactMount.findReactNodeByID(id);
	  }
	  return nodeCache[id];
	}
	
	/**
	 * A node is "valid" if it is contained by a currently mounted container.
	 *
	 * This means that the node does not have to be contained by a document in
	 * order to be considered valid.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @param {string} id The expected ID of the node.
	 * @return {boolean} Whether the node is contained by a mounted container.
	 */
	function isValid(node, id) {
	  if (node) {
	    ( false ? invariant(
	      internalGetID(node) === id,
	      'ReactMount: Unexpected modification of `%s`',
	      ATTR_NAME
	    ) : invariant(internalGetID(node) === id));
	
	    var container = ReactMount.findReactContainerForID(id);
	    if (container && containsNode(container, node)) {
	      return true;
	    }
	  }
	
	  return false;
	}
	
	/**
	 * Causes the cache to forget about one React-specific ID.
	 *
	 * @param {string} id The ID to forget.
	 */
	function purgeID(id) {
	  delete nodeCache[id];
	}
	
	var deepestNodeSoFar = null;
	function findDeepestCachedAncestorImpl(ancestorID) {
	  var ancestor = nodeCache[ancestorID];
	  if (ancestor && isValid(ancestor, ancestorID)) {
	    deepestNodeSoFar = ancestor;
	  } else {
	    // This node isn't populated in the cache, so presumably none of its
	    // descendants are. Break out of the loop.
	    return false;
	  }
	}
	
	/**
	 * Return the deepest cached node whose ID is a prefix of `targetID`.
	 */
	function findDeepestCachedAncestor(targetID) {
	  deepestNodeSoFar = null;
	  ReactInstanceHandles.traverseAncestors(
	    targetID,
	    findDeepestCachedAncestorImpl
	  );
	
	  var foundNode = deepestNodeSoFar;
	  deepestNodeSoFar = null;
	  return foundNode;
	}
	
	/**
	 * Mounts this component and inserts it into the DOM.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {string} rootID DOM ID of the root node.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {ReactReconcileTransaction} transaction
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function mountComponentIntoNode(
	    componentInstance,
	    rootID,
	    container,
	    transaction,
	    shouldReuseMarkup) {
	  var markup = ReactReconciler.mountComponent(
	    componentInstance, rootID, transaction, emptyObject
	  );
	  componentInstance._isTopLevel = true;
	  ReactMount._mountImageIntoNode(markup, container, shouldReuseMarkup);
	}
	
	/**
	 * Batched mount.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {string} rootID DOM ID of the root node.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function batchedMountComponentIntoNode(
	    componentInstance,
	    rootID,
	    container,
	    shouldReuseMarkup) {
	  var transaction = ReactUpdates.ReactReconcileTransaction.getPooled();
	  transaction.perform(
	    mountComponentIntoNode,
	    null,
	    componentInstance,
	    rootID,
	    container,
	    transaction,
	    shouldReuseMarkup
	  );
	  ReactUpdates.ReactReconcileTransaction.release(transaction);
	}
	
	/**
	 * Mounting is the process of initializing a React component by creating its
	 * representative DOM elements and inserting them into a supplied `container`.
	 * Any prior content inside `container` is destroyed in the process.
	 *
	 *   ReactMount.render(
	 *     component,
	 *     document.getElementById('container')
	 *   );
	 *
	 *   <div id="container">                   <-- Supplied `container`.
	 *     <div data-reactid=".3">              <-- Rendered reactRoot of React
	 *       // ...                                 component.
	 *     </div>
	 *   </div>
	 *
	 * Inside of `container`, the first element rendered is the "reactRoot".
	 */
	var ReactMount = {
	  /** Exposed for debugging purposes **/
	  _instancesByReactRootID: instancesByReactRootID,
	
	  /**
	   * This is a hook provided to support rendering React components while
	   * ensuring that the apparent scroll position of its `container` does not
	   * change.
	   *
	   * @param {DOMElement} container The `container` being rendered into.
	   * @param {function} renderCallback This must be called once to do the render.
	   */
	  scrollMonitor: function(container, renderCallback) {
	    renderCallback();
	  },
	
	  /**
	   * Take a component that's already mounted into the DOM and replace its props
	   * @param {ReactComponent} prevComponent component instance already in the DOM
	   * @param {ReactElement} nextElement component instance to render
	   * @param {DOMElement} container container to render into
	   * @param {?function} callback function triggered on completion
	   */
	  _updateRootComponent: function(
	      prevComponent,
	      nextElement,
	      container,
	      callback) {
	    if (false) {
	      ReactElementValidator.checkAndWarnForMutatedProps(nextElement);
	    }
	
	    ReactMount.scrollMonitor(container, function() {
	      ReactUpdateQueue.enqueueElementInternal(prevComponent, nextElement);
	      if (callback) {
	        ReactUpdateQueue.enqueueCallbackInternal(prevComponent, callback);
	      }
	    });
	
	    if (false) {
	      // Record the root element in case it later gets transplanted.
	      rootElementsByReactRootID[getReactRootID(container)] =
	        getReactRootElementInContainer(container);
	    }
	
	    return prevComponent;
	  },
	
	  /**
	   * Register a component into the instance map and starts scroll value
	   * monitoring
	   * @param {ReactComponent} nextComponent component instance to render
	   * @param {DOMElement} container container to render into
	   * @return {string} reactRoot ID prefix
	   */
	  _registerComponent: function(nextComponent, container) {
	    ( false ? invariant(
	      container && (
	        (container.nodeType === ELEMENT_NODE_TYPE || container.nodeType === DOC_NODE_TYPE)
	      ),
	      '_registerComponent(...): Target container is not a DOM element.'
	    ) : invariant(container && (
	      (container.nodeType === ELEMENT_NODE_TYPE || container.nodeType === DOC_NODE_TYPE)
	    )));
	
	    ReactBrowserEventEmitter.ensureScrollValueMonitoring();
	
	    var reactRootID = ReactMount.registerContainer(container);
	    instancesByReactRootID[reactRootID] = nextComponent;
	    return reactRootID;
	  },
	
	  /**
	   * Render a new component into the DOM.
	   * @param {ReactElement} nextElement element to render
	   * @param {DOMElement} container container to render into
	   * @param {boolean} shouldReuseMarkup if we should skip the markup insertion
	   * @return {ReactComponent} nextComponent
	   */
	  _renderNewRootComponent: function(
	    nextElement,
	    container,
	    shouldReuseMarkup
	  ) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case.
	    ( false ? warning(
	      ReactCurrentOwner.current == null,
	      '_renderNewRootComponent(): Render methods should be a pure function ' +
	      'of props and state; triggering nested component updates from ' +
	      'render is not allowed. If necessary, trigger nested updates in ' +
	      'componentDidUpdate.'
	    ) : null);
	
	    var componentInstance = instantiateReactComponent(nextElement, null);
	    var reactRootID = ReactMount._registerComponent(
	      componentInstance,
	      container
	    );
	
	    // The initial render is synchronous but any updates that happen during
	    // rendering, in componentWillMount or componentDidMount, will be batched
	    // according to the current batching strategy.
	
	    ReactUpdates.batchedUpdates(
	      batchedMountComponentIntoNode,
	      componentInstance,
	      reactRootID,
	      container,
	      shouldReuseMarkup
	    );
	
	    if (false) {
	      // Record the root element in case it later gets transplanted.
	      rootElementsByReactRootID[reactRootID] =
	        getReactRootElementInContainer(container);
	    }
	
	    return componentInstance;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  render: function(nextElement, container, callback) {
	    ( false ? invariant(
	      ReactElement.isValidElement(nextElement),
	      'React.render(): Invalid component element.%s',
	      (
	        typeof nextElement === 'string' ?
	          ' Instead of passing an element string, make sure to instantiate ' +
	          'it by passing it to React.createElement.' :
	        typeof nextElement === 'function' ?
	          ' Instead of passing a component class, make sure to instantiate ' +
	          'it by passing it to React.createElement.' :
	        // Check if it quacks like an element
	        nextElement != null && nextElement.props !== undefined ?
	          ' This may be caused by unintentionally loading two independent ' +
	          'copies of React.' :
	          ''
	      )
	    ) : invariant(ReactElement.isValidElement(nextElement)));
	
	    var prevComponent = instancesByReactRootID[getReactRootID(container)];
	
	    if (prevComponent) {
	      var prevElement = prevComponent._currentElement;
	      if (shouldUpdateReactComponent(prevElement, nextElement)) {
	        return ReactMount._updateRootComponent(
	          prevComponent,
	          nextElement,
	          container,
	          callback
	        ).getPublicInstance();
	      } else {
	        ReactMount.unmountComponentAtNode(container);
	      }
	    }
	
	    var reactRootElement = getReactRootElementInContainer(container);
	    var containerHasReactMarkup =
	      reactRootElement && ReactMount.isRenderedByReact(reactRootElement);
	
	    if (false) {
	      if (!containerHasReactMarkup || reactRootElement.nextSibling) {
	        var rootElementSibling = reactRootElement;
	        while (rootElementSibling) {
	          if (ReactMount.isRenderedByReact(rootElementSibling)) {
	            ("production" !== process.env.NODE_ENV ? warning(
	              false,
	              'render(): Target node has markup rendered by React, but there ' +
	              'are unrelated nodes as well. This is most commonly caused by ' +
	              'white-space inserted around server-rendered markup.'
	            ) : null);
	            break;
	          }
	
	          rootElementSibling = rootElementSibling.nextSibling;
	        }
	      }
	    }
	
	    var shouldReuseMarkup = containerHasReactMarkup && !prevComponent;
	
	    var component = ReactMount._renderNewRootComponent(
	      nextElement,
	      container,
	      shouldReuseMarkup
	    ).getPublicInstance();
	    if (callback) {
	      callback.call(component);
	    }
	    return component;
	  },
	
	  /**
	   * Constructs a component instance of `constructor` with `initialProps` and
	   * renders it into the supplied `container`.
	   *
	   * @param {function} constructor React component constructor.
	   * @param {?object} props Initial props of the component instance.
	   * @param {DOMElement} container DOM element to render into.
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  constructAndRenderComponent: function(constructor, props, container) {
	    var element = ReactElement.createElement(constructor, props);
	    return ReactMount.render(element, container);
	  },
	
	  /**
	   * Constructs a component instance of `constructor` with `initialProps` and
	   * renders it into a container node identified by supplied `id`.
	   *
	   * @param {function} componentConstructor React component constructor
	   * @param {?object} props Initial props of the component instance.
	   * @param {string} id ID of the DOM element to render into.
	   * @return {ReactComponent} Component instance rendered in the container node.
	   */
	  constructAndRenderComponentByID: function(constructor, props, id) {
	    var domNode = document.getElementById(id);
	    ( false ? invariant(
	      domNode,
	      'Tried to get element with id of "%s" but it is not present on the page.',
	      id
	    ) : invariant(domNode));
	    return ReactMount.constructAndRenderComponent(constructor, props, domNode);
	  },
	
	  /**
	   * Registers a container node into which React components will be rendered.
	   * This also creates the "reactRoot" ID that will be assigned to the element
	   * rendered within.
	   *
	   * @param {DOMElement} container DOM element to register as a container.
	   * @return {string} The "reactRoot" ID of elements rendered within.
	   */
	  registerContainer: function(container) {
	    var reactRootID = getReactRootID(container);
	    if (reactRootID) {
	      // If one exists, make sure it is a valid "reactRoot" ID.
	      reactRootID = ReactInstanceHandles.getReactRootIDFromNodeID(reactRootID);
	    }
	    if (!reactRootID) {
	      // No valid "reactRoot" ID found, create one.
	      reactRootID = ReactInstanceHandles.createReactRootID();
	    }
	    containersByReactRootID[reactRootID] = container;
	    return reactRootID;
	  },
	
	  /**
	   * Unmounts and destroys the React component rendered in the `container`.
	   *
	   * @param {DOMElement} container DOM element containing a React component.
	   * @return {boolean} True if a component was found in and unmounted from
	   *                   `container`
	   */
	  unmountComponentAtNode: function(container) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case. (Strictly speaking, unmounting won't cause a
	    // render but we still don't expect to be in a render call here.)
	    ( false ? warning(
	      ReactCurrentOwner.current == null,
	      'unmountComponentAtNode(): Render methods should be a pure function of ' +
	      'props and state; triggering nested component updates from render is ' +
	      'not allowed. If necessary, trigger nested updates in ' +
	      'componentDidUpdate.'
	    ) : null);
	
	    ( false ? invariant(
	      container && (
	        (container.nodeType === ELEMENT_NODE_TYPE || container.nodeType === DOC_NODE_TYPE)
	      ),
	      'unmountComponentAtNode(...): Target container is not a DOM element.'
	    ) : invariant(container && (
	      (container.nodeType === ELEMENT_NODE_TYPE || container.nodeType === DOC_NODE_TYPE)
	    )));
	
	    var reactRootID = getReactRootID(container);
	    var component = instancesByReactRootID[reactRootID];
	    if (!component) {
	      return false;
	    }
	    ReactMount.unmountComponentFromNode(component, container);
	    delete instancesByReactRootID[reactRootID];
	    delete containersByReactRootID[reactRootID];
	    if (false) {
	      delete rootElementsByReactRootID[reactRootID];
	    }
	    return true;
	  },
	
	  /**
	   * Unmounts a component and removes it from the DOM.
	   *
	   * @param {ReactComponent} instance React component instance.
	   * @param {DOMElement} container DOM element to unmount from.
	   * @final
	   * @internal
	   * @see {ReactMount.unmountComponentAtNode}
	   */
	  unmountComponentFromNode: function(instance, container) {
	    ReactReconciler.unmountComponent(instance);
	
	    if (container.nodeType === DOC_NODE_TYPE) {
	      container = container.documentElement;
	    }
	
	    // http://jsperf.com/emptying-a-node
	    while (container.lastChild) {
	      container.removeChild(container.lastChild);
	    }
	  },
	
	  /**
	   * Finds the container DOM element that contains React component to which the
	   * supplied DOM `id` belongs.
	   *
	   * @param {string} id The ID of an element rendered by a React component.
	   * @return {?DOMElement} DOM element that contains the `id`.
	   */
	  findReactContainerForID: function(id) {
	    var reactRootID = ReactInstanceHandles.getReactRootIDFromNodeID(id);
	    var container = containersByReactRootID[reactRootID];
	
	    if (false) {
	      var rootElement = rootElementsByReactRootID[reactRootID];
	      if (rootElement && rootElement.parentNode !== container) {
	        ("production" !== process.env.NODE_ENV ? invariant(
	          // Call internalGetID here because getID calls isValid which calls
	          // findReactContainerForID (this function).
	          internalGetID(rootElement) === reactRootID,
	          'ReactMount: Root element ID differed from reactRootID.'
	        ) : invariant(// Call internalGetID here because getID calls isValid which calls
	        // findReactContainerForID (this function).
	        internalGetID(rootElement) === reactRootID));
	
	        var containerChild = container.firstChild;
	        if (containerChild &&
	            reactRootID === internalGetID(containerChild)) {
	          // If the container has a new child with the same ID as the old
	          // root element, then rootElementsByReactRootID[reactRootID] is
	          // just stale and needs to be updated. The case that deserves a
	          // warning is when the container is empty.
	          rootElementsByReactRootID[reactRootID] = containerChild;
	        } else {
	          ("production" !== process.env.NODE_ENV ? warning(
	            false,
	            'ReactMount: Root element has been removed from its original ' +
	            'container. New container:', rootElement.parentNode
	          ) : null);
	        }
	      }
	    }
	
	    return container;
	  },
	
	  /**
	   * Finds an element rendered by React with the supplied ID.
	   *
	   * @param {string} id ID of a DOM node in the React component.
	   * @return {DOMElement} Root DOM node of the React component.
	   */
	  findReactNodeByID: function(id) {
	    var reactRoot = ReactMount.findReactContainerForID(id);
	    return ReactMount.findComponentRoot(reactRoot, id);
	  },
	
	  /**
	   * True if the supplied `node` is rendered by React.
	   *
	   * @param {*} node DOM Element to check.
	   * @return {boolean} True if the DOM Element appears to be rendered by React.
	   * @internal
	   */
	  isRenderedByReact: function(node) {
	    if (node.nodeType !== 1) {
	      // Not a DOMElement, therefore not a React component
	      return false;
	    }
	    var id = ReactMount.getID(node);
	    return id ? id.charAt(0) === SEPARATOR : false;
	  },
	
	  /**
	   * Traverses up the ancestors of the supplied node to find a node that is a
	   * DOM representation of a React component.
	   *
	   * @param {*} node
	   * @return {?DOMEventTarget}
	   * @internal
	   */
	  getFirstReactDOM: function(node) {
	    var current = node;
	    while (current && current.parentNode !== current) {
	      if (ReactMount.isRenderedByReact(current)) {
	        return current;
	      }
	      current = current.parentNode;
	    }
	    return null;
	  },
	
	  /**
	   * Finds a node with the supplied `targetID` inside of the supplied
	   * `ancestorNode`.  Exploits the ID naming scheme to perform the search
	   * quickly.
	   *
	   * @param {DOMEventTarget} ancestorNode Search from this root.
	   * @pararm {string} targetID ID of the DOM representation of the component.
	   * @return {DOMEventTarget} DOM node with the supplied `targetID`.
	   * @internal
	   */
	  findComponentRoot: function(ancestorNode, targetID) {
	    var firstChildren = findComponentRootReusableArray;
	    var childIndex = 0;
	
	    var deepestAncestor = findDeepestCachedAncestor(targetID) || ancestorNode;
	
	    firstChildren[0] = deepestAncestor.firstChild;
	    firstChildren.length = 1;
	
	    while (childIndex < firstChildren.length) {
	      var child = firstChildren[childIndex++];
	      var targetChild;
	
	      while (child) {
	        var childID = ReactMount.getID(child);
	        if (childID) {
	          // Even if we find the node we're looking for, we finish looping
	          // through its siblings to ensure they're cached so that we don't have
	          // to revisit this node again. Otherwise, we make n^2 calls to getID
	          // when visiting the many children of a single node in order.
	
	          if (targetID === childID) {
	            targetChild = child;
	          } else if (ReactInstanceHandles.isAncestorIDOf(childID, targetID)) {
	            // If we find a child whose ID is an ancestor of the given ID,
	            // then we can be sure that we only want to search the subtree
	            // rooted at this child, so we can throw out the rest of the
	            // search state.
	            firstChildren.length = childIndex = 0;
	            firstChildren.push(child.firstChild);
	          }
	
	        } else {
	          // If this child had no ID, then there's a chance that it was
	          // injected automatically by the browser, as when a `<table>`
	          // element sprouts an extra `<tbody>` child as a side effect of
	          // `.innerHTML` parsing. Optimistically continue down this
	          // branch, but not before examining the other siblings.
	          firstChildren.push(child.firstChild);
	        }
	
	        child = child.nextSibling;
	      }
	
	      if (targetChild) {
	        // Emptying firstChildren/findComponentRootReusableArray is
	        // not necessary for correctness, but it helps the GC reclaim
	        // any nodes that were left at the end of the search.
	        firstChildren.length = 0;
	
	        return targetChild;
	      }
	    }
	
	    firstChildren.length = 0;
	
	    ( false ? invariant(
	      false,
	      'findComponentRoot(..., %s): Unable to find element. This probably ' +
	      'means the DOM was unexpectedly mutated (e.g., by the browser), ' +
	      'usually due to forgetting a <tbody> when using tables, nesting tags ' +
	      'like <form>, <p>, or <a>, or using non-SVG elements in an <svg> ' +
	      'parent. ' +
	      'Try inspecting the child nodes of the element with React ID `%s`.',
	      targetID,
	      ReactMount.getID(ancestorNode)
	    ) : invariant(false));
	  },
	
	  _mountImageIntoNode: function(markup, container, shouldReuseMarkup) {
	    ( false ? invariant(
	      container && (
	        (container.nodeType === ELEMENT_NODE_TYPE || container.nodeType === DOC_NODE_TYPE)
	      ),
	      'mountComponentIntoNode(...): Target container is not valid.'
	    ) : invariant(container && (
	      (container.nodeType === ELEMENT_NODE_TYPE || container.nodeType === DOC_NODE_TYPE)
	    )));
	
	    if (shouldReuseMarkup) {
	      var rootElement = getReactRootElementInContainer(container);
	      if (ReactMarkupChecksum.canReuseMarkup(markup, rootElement)) {
	        return;
	      } else {
	        var checksum = rootElement.getAttribute(
	          ReactMarkupChecksum.CHECKSUM_ATTR_NAME
	        );
	        rootElement.removeAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	
	        var rootMarkup = rootElement.outerHTML;
	        rootElement.setAttribute(
	          ReactMarkupChecksum.CHECKSUM_ATTR_NAME,
	          checksum
	        );
	
	        var diffIndex = firstDifferenceIndex(markup, rootMarkup);
	        var difference = ' (client) ' +
	          markup.substring(diffIndex - 20, diffIndex + 20) +
	          '\n (server) ' + rootMarkup.substring(diffIndex - 20, diffIndex + 20);
	
	        ( false ? invariant(
	          container.nodeType !== DOC_NODE_TYPE,
	          'You\'re trying to render a component to the document using ' +
	          'server rendering but the checksum was invalid. This usually ' +
	          'means you rendered a different component type or props on ' +
	          'the client from the one on the server, or your render() ' +
	          'methods are impure. React cannot handle this case due to ' +
	          'cross-browser quirks by rendering at the document root. You ' +
	          'should look for environment dependent code in your components ' +
	          'and ensure the props are the same client and server side:\n%s',
	          difference
	        ) : invariant(container.nodeType !== DOC_NODE_TYPE));
	
	        if (false) {
	          ("production" !== process.env.NODE_ENV ? warning(
	            false,
	            'React attempted to reuse markup in a container but the ' +
	            'checksum was invalid. This generally means that you are ' +
	            'using server rendering and the markup generated on the ' +
	            'server was not what the client was expecting. React injected ' +
	            'new markup to compensate which works but you have lost many ' +
	            'of the benefits of server rendering. Instead, figure out ' +
	            'why the markup being generated is different on the client ' +
	            'or server:\n%s',
	            difference
	          ) : null);
	        }
	      }
	    }
	
	    ( false ? invariant(
	      container.nodeType !== DOC_NODE_TYPE,
	      'You\'re trying to render a component to the document but ' +
	        'you didn\'t use server rendering. We can\'t do this ' +
	        'without using server rendering due to cross-browser quirks. ' +
	        'See React.renderToString() for server rendering.'
	    ) : invariant(container.nodeType !== DOC_NODE_TYPE));
	
	    setInnerHTML(container, markup);
	  },
	
	  /**
	   * React ID utilities.
	   */
	
	  getReactRootID: getReactRootID,
	
	  getID: getID,
	
	  setID: setID,
	
	  getNode: getNode,
	
	  getNodeFromInstance: getNodeFromInstance,
	
	  purgeID: purgeID
	};
	
	ReactPerf.measureMethods(ReactMount, 'ReactMount', {
	  _renderNewRootComponent: '_renderNewRootComponent',
	  _mountImageIntoNode: '_mountImageIntoNode'
	});
	
	module.exports = ReactMount;


/***/ },
/* 21 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule keyOf
	 */
	
	/**
	 * Allows extraction of a minified key. Let's the build system minify keys
	 * without loosing the ability to dynamically use key strings as values
	 * themselves. Pass in an object with a single key/val pair and it will return
	 * you the string key of that single record. Suppose you want to grab the
	 * value for a key 'className' inside of an object. Key/val minification may
	 * have aliased that key to be 'xa12'. keyOf({className: null}) will return
	 * 'xa12' in that case. Resolve keys you want to use once at startup time, then
	 * reuse those resolutions.
	 */
	var keyOf = function(oneKeyObj) {
	  var key;
	  for (key in oneKeyObj) {
	    if (!oneKeyObj.hasOwnProperty(key)) {
	      continue;
	    }
	    return key;
	  }
	  return null;
	};
	
	
	module.exports = keyOf;


/***/ },
/* 22 */
/***/ function(module, exports, __webpack_require__) {

	var getLength = __webpack_require__(126),
	    isLength = __webpack_require__(40);
	
	/**
	 * Checks if `value` is array-like.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 */
	function isArrayLike(value) {
	  return value != null && isLength(getLength(value));
	}
	
	module.exports = isArrayLike;


/***/ },
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(55),
	    isLength = __webpack_require__(40),
	    isObjectLike = __webpack_require__(41);
	
	/** `Object#toString` result references. */
	var arrayTag = '[object Array]';
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objToString = objectProto.toString;
	
	/* Native method references for those with the same name as other `lodash` methods. */
	var nativeIsArray = getNative(Array, 'isArray');
	
	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(function() { return arguments; }());
	 * // => false
	 */
	var isArray = nativeIsArray || function(value) {
	  return isObjectLike(value) && isLength(value.length) && objToString.call(value) == arrayTag;
	};
	
	module.exports = isArray;


/***/ },
/* 24 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule emptyFunction
	 */
	
	function makeEmptyFunction(arg) {
	  return function() {
	    return arg;
	  };
	}
	
	/**
	 * This function accepts and discards inputs; it has no side effects. This is
	 * primarily useful idiomatically for overridable function endpoints which
	 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
	 */
	function emptyFunction() {}
	
	emptyFunction.thatReturns = makeEmptyFunction;
	emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
	emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
	emptyFunction.thatReturnsNull = makeEmptyFunction(null);
	emptyFunction.thatReturnsThis = function() { return this; };
	emptyFunction.thatReturnsArgument = function(arg) { return arg; };
	
	module.exports = emptyFunction;


/***/ },
/* 25 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule update
	 */
	
	 /* global hasOwnProperty:true */
	
	'use strict';
	
	var assign = __webpack_require__(5);
	var keyOf = __webpack_require__(21);
	var invariant = __webpack_require__(2);
	var hasOwnProperty = {}.hasOwnProperty;
	
	function shallowCopy(x) {
	  if (Array.isArray(x)) {
	    return x.concat();
	  } else if (x && typeof x === 'object') {
	    return assign(new x.constructor(), x);
	  } else {
	    return x;
	  }
	}
	
	var COMMAND_PUSH = keyOf({$push: null});
	var COMMAND_UNSHIFT = keyOf({$unshift: null});
	var COMMAND_SPLICE = keyOf({$splice: null});
	var COMMAND_SET = keyOf({$set: null});
	var COMMAND_MERGE = keyOf({$merge: null});
	var COMMAND_APPLY = keyOf({$apply: null});
	
	var ALL_COMMANDS_LIST = [
	  COMMAND_PUSH,
	  COMMAND_UNSHIFT,
	  COMMAND_SPLICE,
	  COMMAND_SET,
	  COMMAND_MERGE,
	  COMMAND_APPLY
	];
	
	var ALL_COMMANDS_SET = {};
	
	ALL_COMMANDS_LIST.forEach(function(command) {
	  ALL_COMMANDS_SET[command] = true;
	});
	
	function invariantArrayCase(value, spec, command) {
	  ( false ? invariant(
	    Array.isArray(value),
	    'update(): expected target of %s to be an array; got %s.',
	    command,
	    value
	  ) : invariant(Array.isArray(value)));
	  var specValue = spec[command];
	  ( false ? invariant(
	    Array.isArray(specValue),
	    'update(): expected spec of %s to be an array; got %s. ' +
	    'Did you forget to wrap your parameter in an array?',
	    command,
	    specValue
	  ) : invariant(Array.isArray(specValue)));
	}
	
	function update(value, spec) {
	  ( false ? invariant(
	    typeof spec === 'object',
	    'update(): You provided a key path to update() that did not contain one ' +
	    'of %s. Did you forget to include {%s: ...}?',
	    ALL_COMMANDS_LIST.join(', '),
	    COMMAND_SET
	  ) : invariant(typeof spec === 'object'));
	
	  if (hasOwnProperty.call(spec, COMMAND_SET)) {
	    ( false ? invariant(
	      Object.keys(spec).length === 1,
	      'Cannot have more than one key in an object with %s',
	      COMMAND_SET
	    ) : invariant(Object.keys(spec).length === 1));
	
	    return spec[COMMAND_SET];
	  }
	
	  var nextValue = shallowCopy(value);
	
	  if (hasOwnProperty.call(spec, COMMAND_MERGE)) {
	    var mergeObj = spec[COMMAND_MERGE];
	    ( false ? invariant(
	      mergeObj && typeof mergeObj === 'object',
	      'update(): %s expects a spec of type \'object\'; got %s',
	      COMMAND_MERGE,
	      mergeObj
	    ) : invariant(mergeObj && typeof mergeObj === 'object'));
	    ( false ? invariant(
	      nextValue && typeof nextValue === 'object',
	      'update(): %s expects a target of type \'object\'; got %s',
	      COMMAND_MERGE,
	      nextValue
	    ) : invariant(nextValue && typeof nextValue === 'object'));
	    assign(nextValue, spec[COMMAND_MERGE]);
	  }
	
	  if (hasOwnProperty.call(spec, COMMAND_PUSH)) {
	    invariantArrayCase(value, spec, COMMAND_PUSH);
	    spec[COMMAND_PUSH].forEach(function(item) {
	      nextValue.push(item);
	    });
	  }
	
	  if (hasOwnProperty.call(spec, COMMAND_UNSHIFT)) {
	    invariantArrayCase(value, spec, COMMAND_UNSHIFT);
	    spec[COMMAND_UNSHIFT].forEach(function(item) {
	      nextValue.unshift(item);
	    });
	  }
	
	  if (hasOwnProperty.call(spec, COMMAND_SPLICE)) {
	    ( false ? invariant(
	      Array.isArray(value),
	      'Expected %s target to be an array; got %s',
	      COMMAND_SPLICE,
	      value
	    ) : invariant(Array.isArray(value)));
	    ( false ? invariant(
	      Array.isArray(spec[COMMAND_SPLICE]),
	      'update(): expected spec of %s to be an array of arrays; got %s. ' +
	      'Did you forget to wrap your parameters in an array?',
	      COMMAND_SPLICE,
	      spec[COMMAND_SPLICE]
	    ) : invariant(Array.isArray(spec[COMMAND_SPLICE])));
	    spec[COMMAND_SPLICE].forEach(function(args) {
	      ( false ? invariant(
	        Array.isArray(args),
	        'update(): expected spec of %s to be an array of arrays; got %s. ' +
	        'Did you forget to wrap your parameters in an array?',
	        COMMAND_SPLICE,
	        spec[COMMAND_SPLICE]
	      ) : invariant(Array.isArray(args)));
	      nextValue.splice.apply(nextValue, args);
	    });
	  }
	
	  if (hasOwnProperty.call(spec, COMMAND_APPLY)) {
	    ( false ? invariant(
	      typeof spec[COMMAND_APPLY] === 'function',
	      'update(): expected spec of %s to be a function; got %s.',
	      COMMAND_APPLY,
	      spec[COMMAND_APPLY]
	    ) : invariant(typeof spec[COMMAND_APPLY] === 'function'));
	    nextValue = spec[COMMAND_APPLY](nextValue);
	  }
	
	  for (var k in spec) {
	    if (!(ALL_COMMANDS_SET.hasOwnProperty(k) && ALL_COMMANDS_SET[k])) {
	      nextValue[k] = update(value[k], spec[k]);
	    }
	  }
	
	  return nextValue;
	}
	
	module.exports = update;


/***/ },
/* 26 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _classCallCheck = function (instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var assign = __webpack_require__(5);
	var invariant = __webpack_require__(2);
	var warning = __webpack_require__(6);
	var PathUtils = __webpack_require__(80);
	
	var _currentRoute;
	
	var Route = (function () {
	  function Route(name, path, ignoreScrollBehavior, isDefault, isNotFound, onEnter, onLeave, handler) {
	    _classCallCheck(this, Route);
	
	    this.name = name;
	    this.path = path;
	    this.paramNames = PathUtils.extractParamNames(this.path);
	    this.ignoreScrollBehavior = !!ignoreScrollBehavior;
	    this.isDefault = !!isDefault;
	    this.isNotFound = !!isNotFound;
	    this.onEnter = onEnter;
	    this.onLeave = onLeave;
	    this.handler = handler;
	  }
	
	  _createClass(Route, [{
	    key: 'appendChild',
	
	    /**
	     * Appends the given route to this route's child routes.
	     */
	    value: function appendChild(route) {
	      invariant(route instanceof Route, 'route.appendChild must use a valid Route');
	
	      if (!this.childRoutes) this.childRoutes = [];
	
	      this.childRoutes.push(route);
	    }
	  }, {
	    key: 'toString',
	    value: function toString() {
	      var string = '<Route';
	
	      if (this.name) string += ' name="' + this.name + '"';
	
	      string += ' path="' + this.path + '">';
	
	      return string;
	    }
	  }], [{
	    key: 'createRoute',
	
	    /**
	     * Creates and returns a new route. Options may be a URL pathname string
	     * with placeholders for named params or an object with any of the following
	     * properties:
	     *
	     * - name                     The name of the route. This is used to lookup a
	     *                            route relative to its parent route and should be
	     *                            unique among all child routes of the same parent
	     * - path                     A URL pathname string with optional placeholders
	     *                            that specify the names of params to extract from
	     *                            the URL when the path matches. Defaults to `/${name}`
	     *                            when there is a name given, or the path of the parent
	     *                            route, or /
	     * - ignoreScrollBehavior     True to make this route (and all descendants) ignore
	     *                            the scroll behavior of the router
	     * - isDefault                True to make this route the default route among all
	     *                            its siblings
	     * - isNotFound               True to make this route the "not found" route among
	     *                            all its siblings
	     * - onEnter                  A transition hook that will be called when the
	     *                            router is going to enter this route
	     * - onLeave                  A transition hook that will be called when the
	     *                            router is going to leave this route
	     * - handler                  A React component that will be rendered when
	     *                            this route is active
	     * - parentRoute              The parent route to use for this route. This option
	     *                            is automatically supplied when creating routes inside
	     *                            the callback to another invocation of createRoute. You
	     *                            only ever need to use this when declaring routes
	     *                            independently of one another to manually piece together
	     *                            the route hierarchy
	     *
	     * The callback may be used to structure your route hierarchy. Any call to
	     * createRoute, createDefaultRoute, createNotFoundRoute, or createRedirect
	     * inside the callback automatically uses this route as its parent.
	     */
	    value: function createRoute(options, callback) {
	      options = options || {};
	
	      if (typeof options === 'string') options = { path: options };
	
	      var parentRoute = _currentRoute;
	
	      if (parentRoute) {
	        warning(options.parentRoute == null || options.parentRoute === parentRoute, 'You should not use parentRoute with createRoute inside another route\'s child callback; it is ignored');
	      } else {
	        parentRoute = options.parentRoute;
	      }
	
	      var name = options.name;
	      var path = options.path || name;
	
	      if (path && !(options.isDefault || options.isNotFound)) {
	        if (PathUtils.isAbsolute(path)) {
	          if (parentRoute) {
	            invariant(path === parentRoute.path || parentRoute.paramNames.length === 0, 'You cannot nest path "%s" inside "%s"; the parent requires URL parameters', path, parentRoute.path);
	          }
	        } else if (parentRoute) {
	          // Relative paths extend their parent.
	          path = PathUtils.join(parentRoute.path, path);
	        } else {
	          path = '/' + path;
	        }
	      } else {
	        path = parentRoute ? parentRoute.path : '/';
	      }
	
	      if (options.isNotFound && !/\*$/.test(path)) path += '*'; // Auto-append * to the path of not found routes.
	
	      var route = new Route(name, path, options.ignoreScrollBehavior, options.isDefault, options.isNotFound, options.onEnter, options.onLeave, options.handler);
	
	      if (parentRoute) {
	        if (route.isDefault) {
	          invariant(parentRoute.defaultRoute == null, '%s may not have more than one default route', parentRoute);
	
	          parentRoute.defaultRoute = route;
	        } else if (route.isNotFound) {
	          invariant(parentRoute.notFoundRoute == null, '%s may not have more than one not found route', parentRoute);
	
	          parentRoute.notFoundRoute = route;
	        }
	
	        parentRoute.appendChild(route);
	      }
	
	      // Any routes created in the callback
	      // use this route as their parent.
	      if (typeof callback === 'function') {
	        var currentRoute = _currentRoute;
	        _currentRoute = route;
	        callback.call(route, route);
	        _currentRoute = currentRoute;
	      }
	
	      return route;
	    }
	  }, {
	    key: 'createDefaultRoute',
	
	    /**
	     * Creates and returns a route that is rendered when its parent matches
	     * the current URL.
	     */
	    value: function createDefaultRoute(options) {
	      return Route.createRoute(assign({}, options, { isDefault: true }));
	    }
	  }, {
	    key: 'createNotFoundRoute',
	
	    /**
	     * Creates and returns a route that is rendered when its parent matches
	     * the current URL but none of its siblings do.
	     */
	    value: function createNotFoundRoute(options) {
	      return Route.createRoute(assign({}, options, { isNotFound: true }));
	    }
	  }, {
	    key: 'createRedirect',
	
	    /**
	     * Creates and returns a route that automatically redirects the transition
	     * to another route. In addition to the normal options to createRoute, this
	     * function accepts the following options:
	     *
	     * - from         An alias for the `path` option. Defaults to *
	     * - to           The path/route/route name to redirect to
	     * - params       The params to use in the redirect URL. Defaults
	     *                to using the current params
	     * - query        The query to use in the redirect URL. Defaults
	     *                to using the current query
	     */
	    value: function createRedirect(options) {
	      return Route.createRoute(assign({}, options, {
	        path: options.path || options.from || '*',
	        onEnter: function onEnter(transition, params, query) {
	          transition.redirect(options.to, options.params || params, options.query || query);
	        }
	      }));
	    }
	  }]);
	
	  return Route;
	})();
	
	module.exports = Route;

/***/ },
/* 27 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactPerf
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/**
	 * ReactPerf is a general AOP system designed to measure performance. This
	 * module only has the hooks: see ReactDefaultPerf for the analysis tool.
	 */
	var ReactPerf = {
	  /**
	   * Boolean to enable/disable measurement. Set to false by default to prevent
	   * accidental logging and perf loss.
	   */
	  enableMeasure: false,
	
	  /**
	   * Holds onto the measure function in use. By default, don't measure
	   * anything, but we'll override this if we inject a measure function.
	   */
	  storedMeasure: _noMeasure,
	
	  /**
	   * @param {object} object
	   * @param {string} objectName
	   * @param {object<string>} methodNames
	   */
	  measureMethods: function(object, objectName, methodNames) {
	    if (false) {
	      for (var key in methodNames) {
	        if (!methodNames.hasOwnProperty(key)) {
	          continue;
	        }
	        object[key] = ReactPerf.measure(
	          objectName,
	          methodNames[key],
	          object[key]
	        );
	      }
	    }
	  },
	
	  /**
	   * Use this to wrap methods you want to measure. Zero overhead in production.
	   *
	   * @param {string} objName
	   * @param {string} fnName
	   * @param {function} func
	   * @return {function}
	   */
	  measure: function(objName, fnName, func) {
	    if (false) {
	      var measuredFunc = null;
	      var wrapper = function() {
	        if (ReactPerf.enableMeasure) {
	          if (!measuredFunc) {
	            measuredFunc = ReactPerf.storedMeasure(objName, fnName, func);
	          }
	          return measuredFunc.apply(this, arguments);
	        }
	        return func.apply(this, arguments);
	      };
	      wrapper.displayName = objName + '_' + fnName;
	      return wrapper;
	    }
	    return func;
	  },
	
	  injection: {
	    /**
	     * @param {function} measure
	     */
	    injectMeasure: function(measure) {
	      ReactPerf.storedMeasure = measure;
	    }
	  }
	};
	
	/**
	 * Simply passes through the measured function, without measuring it.
	 *
	 * @param {string} objName
	 * @param {string} fnName
	 * @param {function} func
	 * @return {function}
	 */
	function _noMeasure(objName, fnName, func) {
	  return func;
	}
	
	module.exports = ReactPerf;


/***/ },
/* 28 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticEvent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var PooledClass = __webpack_require__(17);
	
	var assign = __webpack_require__(5);
	var emptyFunction = __webpack_require__(24);
	var getEventTarget = __webpack_require__(98);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var EventInterface = {
	  type: null,
	  target: getEventTarget,
	  // currentTarget is set when dispatching; no use in copying it here
	  currentTarget: emptyFunction.thatReturnsNull,
	  eventPhase: null,
	  bubbles: null,
	  cancelable: null,
	  timeStamp: function(event) {
	    return event.timeStamp || Date.now();
	  },
	  defaultPrevented: null,
	  isTrusted: null
	};
	
	/**
	 * Synthetic events are dispatched by event plugins, typically in response to a
	 * top-level event delegation handler.
	 *
	 * These systems should generally use pooling to reduce the frequency of garbage
	 * collection. The system should check `isPersistent` to determine whether the
	 * event should be released into the pool after being dispatched. Users that
	 * need a persisted event should invoke `persist`.
	 *
	 * Synthetic events (and subclasses) implement the DOM Level 3 Events API by
	 * normalizing browser quirks. Subclasses do not necessarily have to implement a
	 * DOM interface; custom application-specific events can also subclass this.
	 *
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 */
	function SyntheticEvent(dispatchConfig, dispatchMarker, nativeEvent) {
	  this.dispatchConfig = dispatchConfig;
	  this.dispatchMarker = dispatchMarker;
	  this.nativeEvent = nativeEvent;
	
	  var Interface = this.constructor.Interface;
	  for (var propName in Interface) {
	    if (!Interface.hasOwnProperty(propName)) {
	      continue;
	    }
	    var normalize = Interface[propName];
	    if (normalize) {
	      this[propName] = normalize(nativeEvent);
	    } else {
	      this[propName] = nativeEvent[propName];
	    }
	  }
	
	  var defaultPrevented = nativeEvent.defaultPrevented != null ?
	    nativeEvent.defaultPrevented :
	    nativeEvent.returnValue === false;
	  if (defaultPrevented) {
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  } else {
	    this.isDefaultPrevented = emptyFunction.thatReturnsFalse;
	  }
	  this.isPropagationStopped = emptyFunction.thatReturnsFalse;
	}
	
	assign(SyntheticEvent.prototype, {
	
	  preventDefault: function() {
	    this.defaultPrevented = true;
	    var event = this.nativeEvent;
	    if (event.preventDefault) {
	      event.preventDefault();
	    } else {
	      event.returnValue = false;
	    }
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  },
	
	  stopPropagation: function() {
	    var event = this.nativeEvent;
	    if (event.stopPropagation) {
	      event.stopPropagation();
	    } else {
	      event.cancelBubble = true;
	    }
	    this.isPropagationStopped = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * We release all dispatched `SyntheticEvent`s after each event loop, adding
	   * them back into the pool. This allows a way to hold onto a reference that
	   * won't be added back into the pool.
	   */
	  persist: function() {
	    this.isPersistent = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * Checks if this event should be released back into the pool.
	   *
	   * @return {boolean} True if this should not be released, false otherwise.
	   */
	  isPersistent: emptyFunction.thatReturnsFalse,
	
	  /**
	   * `PooledClass` looks for `destructor` on each instance it releases.
	   */
	  destructor: function() {
	    var Interface = this.constructor.Interface;
	    for (var propName in Interface) {
	      this[propName] = null;
	    }
	    this.dispatchConfig = null;
	    this.dispatchMarker = null;
	    this.nativeEvent = null;
	  }
	
	});
	
	SyntheticEvent.Interface = EventInterface;
	
	/**
	 * Helper to reduce boilerplate when creating subclasses.
	 *
	 * @param {function} Class
	 * @param {?object} Interface
	 */
	SyntheticEvent.augmentClass = function(Class, Interface) {
	  var Super = this;
	
	  var prototype = Object.create(Super.prototype);
	  assign(prototype, Class.prototype);
	  Class.prototype = prototype;
	  Class.prototype.constructor = Class;
	
	  Class.Interface = assign({}, Super.Interface, Interface);
	  Class.augmentClass = Super.augmentClass;
	
	  PooledClass.addPoolingTo(Class, PooledClass.threeArgumentPooler);
	};
	
	PooledClass.addPoolingTo(SyntheticEvent, PooledClass.threeArgumentPooler);
	
	module.exports = SyntheticEvent;


/***/ },
/* 29 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = shallowEqual;
	
	function shallowEqual(objA, objB) {
	  if (objA === objB) {
	    return true;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  var hasOwn = Object.prototype.hasOwnProperty;
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwn.call(objB, keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) {
	
	      return false;
	    }
	
	    var valA = objA[keysA[i]];
	    var valB = objB[keysA[i]];
	
	    if (valA !== valB) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	module.exports = exports["default"];

/***/ },
/* 30 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequire = function (obj) { return obj && obj.__esModule ? obj["default"] : obj; };
	
	var _applyConstructor = function (Constructor, args) { var instance = Object.create(Constructor.prototype); var result = Constructor.apply(instance, args); return result != null && (typeof result == "object" || typeof result == "function") ? result : instance; };
	
	var _prototypeProperties = function (child, staticProps, instanceProps) { if (staticProps) Object.defineProperties(child, staticProps); if (instanceProps) Object.defineProperties(child.prototype, instanceProps); };
	
	var _inherits = function (subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) subClass.__proto__ = superClass; };
	
	var _classCallCheck = function (instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } };
	
	/**
	 * Flux
	 *
	 * The main Flux class.
	 */
	
	var Store = _interopRequire(__webpack_require__(269));
	
	var Actions = _interopRequire(__webpack_require__(268));
	
	var Dispatcher = __webpack_require__(270).Dispatcher;
	var EventEmitter = _interopRequire(__webpack_require__(121));
	
	var Flux = (function (EventEmitter) {
	  function Flux() {
	    _classCallCheck(this, Flux);
	
	    this.dispatcher = new Dispatcher();
	
	    this._stores = {};
	    this._actions = {};
	  }
	
	  _inherits(Flux, EventEmitter);
	
	  _prototypeProperties(Flux, null, {
	    createStore: {
	      value: function createStore(key, _Store) {
	        for (var _len = arguments.length, constructorArgs = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	          constructorArgs[_key - 2] = arguments[_key];
	        }
	
	        if (!(_Store.prototype instanceof Store)) {
	          var className = getClassName(_Store);
	
	          throw new Error("You've attempted to create a store from the class " + className + ", which " + "does not have the base Store class in its prototype chain. Make sure " + ("you're using the `extends` keyword: `class " + className + " extends ") + "Store { ... }`");
	        }
	
	        if (this._stores.hasOwnProperty(key) && this._stores[key]) {
	          throw new Error("You've attempted to create multiple stores with key " + key + ". Keys must " + "be unique.");
	        }
	
	        var store = _applyConstructor(_Store, constructorArgs);
	        var token = this.dispatcher.register(store.handler.bind(store));
	
	        store._waitFor = this.waitFor.bind(this);
	        store._token = token;
	
	        this._stores[key] = store;
	
	        return store;
	      },
	      writable: true,
	      configurable: true
	    },
	    getStore: {
	      value: function getStore(key) {
	        return this._stores.hasOwnProperty(key) ? this._stores[key] : undefined;
	      },
	      writable: true,
	      configurable: true
	    },
	    createActions: {
	      value: function createActions(key, _Actions) {
	        for (var _len = arguments.length, constructorArgs = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	          constructorArgs[_key - 2] = arguments[_key];
	        }
	
	        if (!(_Actions.prototype instanceof Actions) && _Actions !== Actions) {
	          var className = getClassName(_Actions);
	
	          throw new Error("You've attempted to create actions from the class " + className + ", which " + "does not have the base Actions class in its prototype chain. Make " + ("sure you're using the `extends` keyword: `class " + className + " ") + "extends Actions { ... }`");
	        }
	
	        if (this._actions.hasOwnProperty(key) && this._actions[key]) {
	          throw new Error("You've attempted to create multiple actions with key " + key + ". Keys " + "must be unique.");
	        }
	
	        var actions = _applyConstructor(_Actions, constructorArgs);
	        actions.dispatch = this.dispatch.bind(this);
	        actions.dispatchAsync = this.dispatchAsync.bind(this);
	
	        this._actions[key] = actions;
	
	        return actions;
	      },
	      writable: true,
	      configurable: true
	    },
	    getActions: {
	      value: function getActions(key) {
	        return this._actions.hasOwnProperty(key) ? this._actions[key] : undefined;
	      },
	      writable: true,
	      configurable: true
	    },
	    getActionIds: {
	      value: function getActionIds(key) {
	        var actions = this.getActions(key);
	
	        if (!actions) {
	          return;
	        }return actions.getConstants();
	      },
	      writable: true,
	      configurable: true
	    },
	    dispatch: {
	      value: function dispatch(actionId, body) {
	        this._dispatch({ actionId: actionId, body: body });
	      },
	      writable: true,
	      configurable: true
	    },
	    dispatchAsync: {
	      value: function dispatchAsync(actionId, promise, actionArgs) {
	        var _this = this;
	        var payload = {
	          actionId: actionId,
	          async: "begin" };
	
	        if (actionArgs) payload.actionArgs = actionArgs;
	
	        this._dispatch(payload);
	
	        return promise.then(function (body) {
	          _this._dispatch({
	            actionId: actionId,
	            body: body,
	            async: "success"
	          });
	
	          return body;
	        }, function (error) {
	          _this._dispatch({
	            actionId: actionId,
	            error: error,
	            async: "failure" });
	
	          return Promise.reject(error);
	        })["catch"](function (error) {
	          _this.emit("error", error);
	
	          return Promise.reject(error);
	        });
	      },
	      writable: true,
	      configurable: true
	    },
	    _dispatch: {
	      value: function _dispatch(payload) {
	        this.dispatcher.dispatch(payload);
	        this.emit("dispatch", payload);
	      },
	      writable: true,
	      configurable: true
	    },
	    waitFor: {
	      value: function waitFor(tokensOrStores) {
	        if (!Array.isArray(tokensOrStores)) tokensOrStores = [tokensOrStores];
	
	        var ensureIsToken = function (tokenOrStore) {
	          return tokenOrStore instanceof Store ? tokenOrStore._token : tokenOrStore;
	        };
	
	        var tokens = tokensOrStores.map(ensureIsToken);
	
	        this.dispatcher.waitFor(tokens);
	      },
	      writable: true,
	      configurable: true
	    },
	    removeAllStoreListeners: {
	      value: function removeAllStoreListeners(event) {
	        for (var key in this._stores) {
	          if (!this._stores.hasOwnProperty(key)) continue;
	
	          var store = this._stores[key];
	
	          store.removeAllListeners(event);
	        }
	      },
	      writable: true,
	      configurable: true
	    },
	    serialize: {
	      value: function serialize() {
	        var stateTree = {};
	
	        for (var key in this._stores) {
	          if (!this._stores.hasOwnProperty(key)) continue;
	
	          var store = this._stores[key];
	
	          var serialize = store.constructor.serialize;
	
	          if (typeof serialize !== "function") continue;
	
	          var serializedStoreState = serialize(store.state);
	
	          if (typeof serializedStoreState !== "string") {
	            var className = store.constructor.name;
	
	            if (false) {
	              console.warn("The store with key '" + key + "' was not serialized because the static " + ("method `" + className + ".serialize()` returned a non-string with type ") + ("'" + typeof serializedStoreState + "'."));
	            }
	          }
	
	          stateTree[key] = serializedStoreState;
	
	          if (typeof store.constructor.deserialize !== "function") {
	            var className = store.constructor.name;
	
	            if (false) {
	              console.warn("The class `" + className + "` has a `serialize()` method, but no " + "corresponding `deserialize()` method.");
	            }
	          }
	        }
	
	        return JSON.stringify(stateTree);
	      },
	      writable: true,
	      configurable: true
	    },
	    deserialize: {
	      value: function deserialize(serializedState) {
	        var stateMap = undefined;
	
	        try {
	          stateMap = JSON.parse(serializedState);
	        } catch (error) {
	          var className = this.constructor.name;
	
	          if (false) {
	            throw new Error("Invalid value passed to `" + className + "#deserialize()`: " + ("" + serializedState));
	          }
	        }
	
	        for (var key in this._stores) {
	          if (!this._stores.hasOwnProperty(key)) continue;
	
	          var store = this._stores[key];
	
	          var deserialize = store.constructor.deserialize;
	
	          if (typeof deserialize !== "function") continue;
	
	          var storeStateString = stateMap[key];
	          var storeState = deserialize(storeStateString);
	
	          store.replaceState(storeState);
	
	          if (typeof store.constructor.serialize !== "function") {
	            var className = store.constructor.name;
	
	            if (false) {
	              console.warn("The class `" + className + "` has a `deserialize()` method, but no " + "corresponding `serialize()` method.");
	            }
	          }
	        }
	      },
	      writable: true,
	      configurable: true
	    }
	  });
	
	  return Flux;
	})(EventEmitter);
	
	exports["default"] = Flux;
	
	
	// Aliases
	Flux.prototype.getConstants = Flux.prototype.getActionIds;
	Flux.prototype.dehydrate = Flux.prototype.serialize;
	Flux.prototype.hydrate = Flux.prototype.deserialize;
	
	function getClassName(Class) {
	  return Class.prototype.constructor.name;
	}
	
	var Flummox = Flux;
	
	exports.Flux = Flux;
	exports.Flummox = Flummox;
	exports.Store = Store;
	exports.Actions = Actions;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	//# sourceMappingURL=data:application/json;base64,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

/***/ },
/* 31 */
/***/ function(module, exports, __webpack_require__) {

	var baseForIn = __webpack_require__(362),
	    isArguments = __webpack_require__(56),
	    isObjectLike = __webpack_require__(41);
	
	/** `Object#toString` result references. */
	var objectTag = '[object Object]';
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objToString = objectProto.toString;
	
	/**
	 * Checks if `value` is a plain object, that is, an object created by the
	 * `Object` constructor or one with a `[[Prototype]]` of `null`.
	 *
	 * **Note:** This method assumes objects created by the `Object` constructor
	 * have no inherited enumerable properties.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * _.isPlainObject(new Foo);
	 * // => false
	 *
	 * _.isPlainObject([1, 2, 3]);
	 * // => false
	 *
	 * _.isPlainObject({ 'x': 0, 'y': 0 });
	 * // => true
	 *
	 * _.isPlainObject(Object.create(null));
	 * // => true
	 */
	function isPlainObject(value) {
	  var Ctor;
	
	  // Exit early for non `Object` objects.
	  if (!(isObjectLike(value) && objToString.call(value) == objectTag && !isArguments(value)) ||
	      (!hasOwnProperty.call(value, 'constructor') && (Ctor = value.constructor, typeof Ctor == 'function' && !(Ctor instanceof Ctor)))) {
	    return false;
	  }
	  // IE < 9 iterates inherited properties before own properties. If the first
	  // iterated property is an object's own property then there are no inherited
	  // enumerable properties.
	  var result;
	  // In most environments an object's own properties are iterated before
	  // its inherited properties. If the last iterated property is an object's
	  // own property then there are no inherited enumerable properties.
	  baseForIn(value, function(subValue, key) {
	    result = key;
	  });
	  return result === undefined || hasOwnProperty.call(value, result);
	}
	
	module.exports = isPlainObject;


/***/ },
/* 32 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var invariant = __webpack_require__(2);
	var canUseDOM = __webpack_require__(8).canUseDOM;
	
	var History = {
	
	  /**
	   * The current number of entries in the history.
	   *
	   * Note: This property is read-only.
	   */
	  length: 1,
	
	  /**
	   * Sends the browser back one entry in the history.
	   */
	  back: function back() {
	    invariant(canUseDOM, 'Cannot use History.back without a DOM');
	
	    // Do this first so that History.length will
	    // be accurate in location change listeners.
	    History.length -= 1;
	
	    window.history.back();
	  }
	
	};
	
	module.exports = History;

/***/ },
/* 33 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DOMProperty
	 * @typechecks static-only
	 */
	
	/*jslint bitwise: true */
	
	'use strict';
	
	var invariant = __webpack_require__(2);
	
	function checkMask(value, bitmask) {
	  return (value & bitmask) === bitmask;
	}
	
	var DOMPropertyInjection = {
	  /**
	   * Mapping from normalized, camelcased property names to a configuration that
	   * specifies how the associated DOM property should be accessed or rendered.
	   */
	  MUST_USE_ATTRIBUTE: 0x1,
	  MUST_USE_PROPERTY: 0x2,
	  HAS_SIDE_EFFECTS: 0x4,
	  HAS_BOOLEAN_VALUE: 0x8,
	  HAS_NUMERIC_VALUE: 0x10,
	  HAS_POSITIVE_NUMERIC_VALUE: 0x20 | 0x10,
	  HAS_OVERLOADED_BOOLEAN_VALUE: 0x40,
	
	  /**
	   * Inject some specialized knowledge about the DOM. This takes a config object
	   * with the following properties:
	   *
	   * isCustomAttribute: function that given an attribute name will return true
	   * if it can be inserted into the DOM verbatim. Useful for data-* or aria-*
	   * attributes where it's impossible to enumerate all of the possible
	   * attribute names,
	   *
	   * Properties: object mapping DOM property name to one of the
	   * DOMPropertyInjection constants or null. If your attribute isn't in here,
	   * it won't get written to the DOM.
	   *
	   * DOMAttributeNames: object mapping React attribute name to the DOM
	   * attribute name. Attribute names not specified use the **lowercase**
	   * normalized name.
	   *
	   * DOMPropertyNames: similar to DOMAttributeNames but for DOM properties.
	   * Property names not specified use the normalized name.
	   *
	   * DOMMutationMethods: Properties that require special mutation methods. If
	   * `value` is undefined, the mutation method should unset the property.
	   *
	   * @param {object} domPropertyConfig the config as described above.
	   */
	  injectDOMPropertyConfig: function(domPropertyConfig) {
	    var Properties = domPropertyConfig.Properties || {};
	    var DOMAttributeNames = domPropertyConfig.DOMAttributeNames || {};
	    var DOMPropertyNames = domPropertyConfig.DOMPropertyNames || {};
	    var DOMMutationMethods = domPropertyConfig.DOMMutationMethods || {};
	
	    if (domPropertyConfig.isCustomAttribute) {
	      DOMProperty._isCustomAttributeFunctions.push(
	        domPropertyConfig.isCustomAttribute
	      );
	    }
	
	    for (var propName in Properties) {
	      ( false ? invariant(
	        !DOMProperty.isStandardName.hasOwnProperty(propName),
	        'injectDOMPropertyConfig(...): You\'re trying to inject DOM property ' +
	        '\'%s\' which has already been injected. You may be accidentally ' +
	        'injecting the same DOM property config twice, or you may be ' +
	        'injecting two configs that have conflicting property names.',
	        propName
	      ) : invariant(!DOMProperty.isStandardName.hasOwnProperty(propName)));
	
	      DOMProperty.isStandardName[propName] = true;
	
	      var lowerCased = propName.toLowerCase();
	      DOMProperty.getPossibleStandardName[lowerCased] = propName;
	
	      if (DOMAttributeNames.hasOwnProperty(propName)) {
	        var attributeName = DOMAttributeNames[propName];
	        DOMProperty.getPossibleStandardName[attributeName] = propName;
	        DOMProperty.getAttributeName[propName] = attributeName;
	      } else {
	        DOMProperty.getAttributeName[propName] = lowerCased;
	      }
	
	      DOMProperty.getPropertyName[propName] =
	        DOMPropertyNames.hasOwnProperty(propName) ?
	          DOMPropertyNames[propName] :
	          propName;
	
	      if (DOMMutationMethods.hasOwnProperty(propName)) {
	        DOMProperty.getMutationMethod[propName] = DOMMutationMethods[propName];
	      } else {
	        DOMProperty.getMutationMethod[propName] = null;
	      }
	
	      var propConfig = Properties[propName];
	      DOMProperty.mustUseAttribute[propName] =
	        checkMask(propConfig, DOMPropertyInjection.MUST_USE_ATTRIBUTE);
	      DOMProperty.mustUseProperty[propName] =
	        checkMask(propConfig, DOMPropertyInjection.MUST_USE_PROPERTY);
	      DOMProperty.hasSideEffects[propName] =
	        checkMask(propConfig, DOMPropertyInjection.HAS_SIDE_EFFECTS);
	      DOMProperty.hasBooleanValue[propName] =
	        checkMask(propConfig, DOMPropertyInjection.HAS_BOOLEAN_VALUE);
	      DOMProperty.hasNumericValue[propName] =
	        checkMask(propConfig, DOMPropertyInjection.HAS_NUMERIC_VALUE);
	      DOMProperty.hasPositiveNumericValue[propName] =
	        checkMask(propConfig, DOMPropertyInjection.HAS_POSITIVE_NUMERIC_VALUE);
	      DOMProperty.hasOverloadedBooleanValue[propName] =
	        checkMask(propConfig, DOMPropertyInjection.HAS_OVERLOADED_BOOLEAN_VALUE);
	
	      ( false ? invariant(
	        !DOMProperty.mustUseAttribute[propName] ||
	          !DOMProperty.mustUseProperty[propName],
	        'DOMProperty: Cannot require using both attribute and property: %s',
	        propName
	      ) : invariant(!DOMProperty.mustUseAttribute[propName] ||
	        !DOMProperty.mustUseProperty[propName]));
	      ( false ? invariant(
	        DOMProperty.mustUseProperty[propName] ||
	          !DOMProperty.hasSideEffects[propName],
	        'DOMProperty: Properties that have side effects must use property: %s',
	        propName
	      ) : invariant(DOMProperty.mustUseProperty[propName] ||
	        !DOMProperty.hasSideEffects[propName]));
	      ( false ? invariant(
	        !!DOMProperty.hasBooleanValue[propName] +
	          !!DOMProperty.hasNumericValue[propName] +
	          !!DOMProperty.hasOverloadedBooleanValue[propName] <= 1,
	        'DOMProperty: Value can be one of boolean, overloaded boolean, or ' +
	        'numeric value, but not a combination: %s',
	        propName
	      ) : invariant(!!DOMProperty.hasBooleanValue[propName] +
	        !!DOMProperty.hasNumericValue[propName] +
	        !!DOMProperty.hasOverloadedBooleanValue[propName] <= 1));
	    }
	  }
	};
	var defaultValueCache = {};
	
	/**
	 * DOMProperty exports lookup objects that can be used like functions:
	 *
	 *   > DOMProperty.isValid['id']
	 *   true
	 *   > DOMProperty.isValid['foobar']
	 *   undefined
	 *
	 * Although this may be confusing, it performs better in general.
	 *
	 * @see http://jsperf.com/key-exists
	 * @see http://jsperf.com/key-missing
	 */
	var DOMProperty = {
	
	  ID_ATTRIBUTE_NAME: 'data-reactid',
	
	  /**
	   * Checks whether a property name is a standard property.
	   * @type {Object}
	   */
	  isStandardName: {},
	
	  /**
	   * Mapping from lowercase property names to the properly cased version, used
	   * to warn in the case of missing properties.
	   * @type {Object}
	   */
	  getPossibleStandardName: {},
	
	  /**
	   * Mapping from normalized names to attribute names that differ. Attribute
	   * names are used when rendering markup or with `*Attribute()`.
	   * @type {Object}
	   */
	  getAttributeName: {},
	
	  /**
	   * Mapping from normalized names to properties on DOM node instances.
	   * (This includes properties that mutate due to external factors.)
	   * @type {Object}
	   */
	  getPropertyName: {},
	
	  /**
	   * Mapping from normalized names to mutation methods. This will only exist if
	   * mutation cannot be set simply by the property or `setAttribute()`.
	   * @type {Object}
	   */
	  getMutationMethod: {},
	
	  /**
	   * Whether the property must be accessed and mutated as an object property.
	   * @type {Object}
	   */
	  mustUseAttribute: {},
	
	  /**
	   * Whether the property must be accessed and mutated using `*Attribute()`.
	   * (This includes anything that fails `<propName> in <element>`.)
	   * @type {Object}
	   */
	  mustUseProperty: {},
	
	  /**
	   * Whether or not setting a value causes side effects such as triggering
	   * resources to be loaded or text selection changes. We must ensure that
	   * the value is only set if it has changed.
	   * @type {Object}
	   */
	  hasSideEffects: {},
	
	  /**
	   * Whether the property should be removed when set to a falsey value.
	   * @type {Object}
	   */
	  hasBooleanValue: {},
	
	  /**
	   * Whether the property must be numeric or parse as a
	   * numeric and should be removed when set to a falsey value.
	   * @type {Object}
	   */
	  hasNumericValue: {},
	
	  /**
	   * Whether the property must be positive numeric or parse as a positive
	   * numeric and should be removed when set to a falsey value.
	   * @type {Object}
	   */
	  hasPositiveNumericValue: {},
	
	  /**
	   * Whether the property can be used as a flag as well as with a value. Removed
	   * when strictly equal to false; present without a value when strictly equal
	   * to true; present with a value otherwise.
	   * @type {Object}
	   */
	  hasOverloadedBooleanValue: {},
	
	  /**
	   * All of the isCustomAttribute() functions that have been injected.
	   */
	  _isCustomAttributeFunctions: [],
	
	  /**
	   * Checks whether a property name is a custom attribute.
	   * @method
	   */
	  isCustomAttribute: function(attributeName) {
	    for (var i = 0; i < DOMProperty._isCustomAttributeFunctions.length; i++) {
	      var isCustomAttributeFn = DOMProperty._isCustomAttributeFunctions[i];
	      if (isCustomAttributeFn(attributeName)) {
	        return true;
	      }
	    }
	    return false;
	  },
	
	  /**
	   * Returns the default property value for a DOM property (i.e., not an
	   * attribute). Most default values are '' or false, but not all. Worse yet,
	   * some (in particular, `type`) vary depending on the type of element.
	   *
	   * TODO: Is it better to grab all the possible properties when creating an
	   * element to avoid having to create the same element twice?
	   */
	  getDefaultValueForProperty: function(nodeName, prop) {
	    var nodeDefaults = defaultValueCache[nodeName];
	    var testElement;
	    if (!nodeDefaults) {
	      defaultValueCache[nodeName] = nodeDefaults = {};
	    }
	    if (!(prop in nodeDefaults)) {
	      testElement = document.createElement(nodeName);
	      nodeDefaults[prop] = testElement[prop];
	    }
	    return nodeDefaults[prop];
	  },
	
	  injection: DOMPropertyInjection
	};
	
	module.exports = DOMProperty;


/***/ },
/* 34 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactBrowserEventEmitter
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(12);
	var EventPluginHub = __webpack_require__(44);
	var EventPluginRegistry = __webpack_require__(144);
	var ReactEventEmitterMixin = __webpack_require__(433);
	var ViewportMetrics = __webpack_require__(154);
	
	var assign = __webpack_require__(5);
	var isEventSupported = __webpack_require__(100);
	
	/**
	 * Summary of `ReactBrowserEventEmitter` event handling:
	 *
	 *  - Top-level delegation is used to trap most native browser events. This
	 *    may only occur in the main thread and is the responsibility of
	 *    ReactEventListener, which is injected and can therefore support pluggable
	 *    event sources. This is the only work that occurs in the main thread.
	 *
	 *  - We normalize and de-duplicate events to account for browser quirks. This
	 *    may be done in the worker thread.
	 *
	 *  - Forward these native events (with the associated top-level type used to
	 *    trap it) to `EventPluginHub`, which in turn will ask plugins if they want
	 *    to extract any synthetic events.
	 *
	 *  - The `EventPluginHub` will then process each event by annotating them with
	 *    "dispatches", a sequence of listeners and IDs that care about that event.
	 *
	 *  - The `EventPluginHub` then dispatches the events.
	 *
	 * Overview of React and the event system:
	 *
	 * +------------+    .
	 * |    DOM     |    .
	 * +------------+    .
	 *       |           .
	 *       v           .
	 * +------------+    .
	 * | ReactEvent |    .
	 * |  Listener  |    .
	 * +------------+    .                         +-----------+
	 *       |           .               +--------+|SimpleEvent|
	 *       |           .               |         |Plugin     |
	 * +-----|------+    .               v         +-----------+
	 * |     |      |    .    +--------------+                    +------------+
	 * |     +-----------.--->|EventPluginHub|                    |    Event   |
	 * |            |    .    |              |     +-----------+  | Propagators|
	 * | ReactEvent |    .    |              |     |TapEvent   |  |------------|
	 * |  Emitter   |    .    |              |<---+|Plugin     |  |other plugin|
	 * |            |    .    |              |     +-----------+  |  utilities |
	 * |     +-----------.--->|              |                    +------------+
	 * |     |      |    .    +--------------+
	 * +-----|------+    .                ^        +-----------+
	 *       |           .                |        |Enter/Leave|
	 *       +           .                +-------+|Plugin     |
	 * +-------------+   .                         +-----------+
	 * | application |   .
	 * |-------------|   .
	 * |             |   .
	 * |             |   .
	 * +-------------+   .
	 *                   .
	 *    React Core     .  General Purpose Event Plugin System
	 */
	
	var alreadyListeningTo = {};
	var isMonitoringScrollValue = false;
	var reactTopListenersCounter = 0;
	
	// For events like 'submit' which don't consistently bubble (which we trap at a
	// lower node than `document`), binding at `document` would cause duplicate
	// events so we don't include them here
	var topEventMapping = {
	  topBlur: 'blur',
	  topChange: 'change',
	  topClick: 'click',
	  topCompositionEnd: 'compositionend',
	  topCompositionStart: 'compositionstart',
	  topCompositionUpdate: 'compositionupdate',
	  topContextMenu: 'contextmenu',
	  topCopy: 'copy',
	  topCut: 'cut',
	  topDoubleClick: 'dblclick',
	  topDrag: 'drag',
	  topDragEnd: 'dragend',
	  topDragEnter: 'dragenter',
	  topDragExit: 'dragexit',
	  topDragLeave: 'dragleave',
	  topDragOver: 'dragover',
	  topDragStart: 'dragstart',
	  topDrop: 'drop',
	  topFocus: 'focus',
	  topInput: 'input',
	  topKeyDown: 'keydown',
	  topKeyPress: 'keypress',
	  topKeyUp: 'keyup',
	  topMouseDown: 'mousedown',
	  topMouseMove: 'mousemove',
	  topMouseOut: 'mouseout',
	  topMouseOver: 'mouseover',
	  topMouseUp: 'mouseup',
	  topPaste: 'paste',
	  topScroll: 'scroll',
	  topSelectionChange: 'selectionchange',
	  topTextInput: 'textInput',
	  topTouchCancel: 'touchcancel',
	  topTouchEnd: 'touchend',
	  topTouchMove: 'touchmove',
	  topTouchStart: 'touchstart',
	  topWheel: 'wheel'
	};
	
	/**
	 * To ensure no conflicts with other potential React instances on the page
	 */
	var topListenersIDKey = '_reactListenersID' + String(Math.random()).slice(2);
	
	function getListeningForDocument(mountAt) {
	  // In IE8, `mountAt` is a host object and doesn't have `hasOwnProperty`
	  // directly.
	  if (!Object.prototype.hasOwnProperty.call(mountAt, topListenersIDKey)) {
	    mountAt[topListenersIDKey] = reactTopListenersCounter++;
	    alreadyListeningTo[mountAt[topListenersIDKey]] = {};
	  }
	  return alreadyListeningTo[mountAt[topListenersIDKey]];
	}
	
	/**
	 * `ReactBrowserEventEmitter` is used to attach top-level event listeners. For
	 * example:
	 *
	 *   ReactBrowserEventEmitter.putListener('myID', 'onClick', myFunction);
	 *
	 * This would allocate a "registration" of `('onClick', myFunction)` on 'myID'.
	 *
	 * @internal
	 */
	var ReactBrowserEventEmitter = assign({}, ReactEventEmitterMixin, {
	
	  /**
	   * Injectable event backend
	   */
	  ReactEventListener: null,
	
	  injection: {
	    /**
	     * @param {object} ReactEventListener
	     */
	    injectReactEventListener: function(ReactEventListener) {
	      ReactEventListener.setHandleTopLevel(
	        ReactBrowserEventEmitter.handleTopLevel
	      );
	      ReactBrowserEventEmitter.ReactEventListener = ReactEventListener;
	    }
	  },
	
	  /**
	   * Sets whether or not any created callbacks should be enabled.
	   *
	   * @param {boolean} enabled True if callbacks should be enabled.
	   */
	  setEnabled: function(enabled) {
	    if (ReactBrowserEventEmitter.ReactEventListener) {
	      ReactBrowserEventEmitter.ReactEventListener.setEnabled(enabled);
	    }
	  },
	
	  /**
	   * @return {boolean} True if callbacks are enabled.
	   */
	  isEnabled: function() {
	    return !!(
	      (ReactBrowserEventEmitter.ReactEventListener && ReactBrowserEventEmitter.ReactEventListener.isEnabled())
	    );
	  },
	
	  /**
	   * We listen for bubbled touch events on the document object.
	   *
	   * Firefox v8.01 (and possibly others) exhibited strange behavior when
	   * mounting `onmousemove` events at some node that was not the document
	   * element. The symptoms were that if your mouse is not moving over something
	   * contained within that mount point (for example on the background) the
	   * top-level listeners for `onmousemove` won't be called. However, if you
	   * register the `mousemove` on the document object, then it will of course
	   * catch all `mousemove`s. This along with iOS quirks, justifies restricting
	   * top-level listeners to the document object only, at least for these
	   * movement types of events and possibly all events.
	   *
	   * @see http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
	   *
	   * Also, `keyup`/`keypress`/`keydown` do not bubble to the window on IE, but
	   * they bubble to document.
	   *
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {object} contentDocumentHandle Document which owns the container
	   */
	  listenTo: function(registrationName, contentDocumentHandle) {
	    var mountAt = contentDocumentHandle;
	    var isListening = getListeningForDocument(mountAt);
	    var dependencies = EventPluginRegistry.
	      registrationNameDependencies[registrationName];
	
	    var topLevelTypes = EventConstants.topLevelTypes;
	    for (var i = 0, l = dependencies.length; i < l; i++) {
	      var dependency = dependencies[i];
	      if (!(
	            (isListening.hasOwnProperty(dependency) && isListening[dependency])
	          )) {
	        if (dependency === topLevelTypes.topWheel) {
	          if (isEventSupported('wheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(
	              topLevelTypes.topWheel,
	              'wheel',
	              mountAt
	            );
	          } else if (isEventSupported('mousewheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(
	              topLevelTypes.topWheel,
	              'mousewheel',
	              mountAt
	            );
	          } else {
	            // Firefox needs to capture a different mouse scroll event.
	            // @see http://www.quirksmode.org/dom/events/tests/scroll.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(
	              topLevelTypes.topWheel,
	              'DOMMouseScroll',
	              mountAt
	            );
	          }
	        } else if (dependency === topLevelTypes.topScroll) {
	
	          if (isEventSupported('scroll', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(
	              topLevelTypes.topScroll,
	              'scroll',
	              mountAt
	            );
	          } else {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(
	              topLevelTypes.topScroll,
	              'scroll',
	              ReactBrowserEventEmitter.ReactEventListener.WINDOW_HANDLE
	            );
	          }
	        } else if (dependency === topLevelTypes.topFocus ||
	            dependency === topLevelTypes.topBlur) {
	
	          if (isEventSupported('focus', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(
	              topLevelTypes.topFocus,
	              'focus',
	              mountAt
	            );
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(
	              topLevelTypes.topBlur,
	              'blur',
	              mountAt
	            );
	          } else if (isEventSupported('focusin')) {
	            // IE has `focusin` and `focusout` events which bubble.
	            // @see http://www.quirksmode.org/blog/archives/2008/04/delegating_the.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(
	              topLevelTypes.topFocus,
	              'focusin',
	              mountAt
	            );
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(
	              topLevelTypes.topBlur,
	              'focusout',
	              mountAt
	            );
	          }
	
	          // to make sure blur and focus event listeners are only attached once
	          isListening[topLevelTypes.topBlur] = true;
	          isListening[topLevelTypes.topFocus] = true;
	        } else if (topEventMapping.hasOwnProperty(dependency)) {
	          ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(
	            dependency,
	            topEventMapping[dependency],
	            mountAt
	          );
	        }
	
	        isListening[dependency] = true;
	      }
	    }
	  },
	
	  trapBubbledEvent: function(topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(
	      topLevelType,
	      handlerBaseName,
	      handle
	    );
	  },
	
	  trapCapturedEvent: function(topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(
	      topLevelType,
	      handlerBaseName,
	      handle
	    );
	  },
	
	  /**
	   * Listens to window scroll and resize events. We cache scroll values so that
	   * application code can access them without triggering reflows.
	   *
	   * NOTE: Scroll events do not bubble.
	   *
	   * @see http://www.quirksmode.org/dom/events/scroll.html
	   */
	  ensureScrollValueMonitoring: function() {
	    if (!isMonitoringScrollValue) {
	      var refresh = ViewportMetrics.refreshScrollValues;
	      ReactBrowserEventEmitter.ReactEventListener.monitorScrollValue(refresh);
	      isMonitoringScrollValue = true;
	    }
	  },
	
	  eventNameDispatchConfigs: EventPluginHub.eventNameDispatchConfigs,
	
	  registrationNameModules: EventPluginHub.registrationNameModules,
	
	  putListener: EventPluginHub.putListener,
	
	  getListener: EventPluginHub.getListener,
	
	  deleteListener: EventPluginHub.deleteListener,
	
	  deleteAllListeners: EventPluginHub.deleteAllListeners
	
	});
	
	module.exports = ReactBrowserEventEmitter;


/***/ },
/* 35 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactInstanceHandles
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var ReactRootIndex = __webpack_require__(153);
	
	var invariant = __webpack_require__(2);
	
	var SEPARATOR = '.';
	var SEPARATOR_LENGTH = SEPARATOR.length;
	
	/**
	 * Maximum depth of traversals before we consider the possibility of a bad ID.
	 */
	var MAX_TREE_DEPTH = 100;
	
	/**
	 * Creates a DOM ID prefix to use when mounting React components.
	 *
	 * @param {number} index A unique integer
	 * @return {string} React root ID.
	 * @internal
	 */
	function getReactRootIDString(index) {
	  return SEPARATOR + index.toString(36);
	}
	
	/**
	 * Checks if a character in the supplied ID is a separator or the end.
	 *
	 * @param {string} id A React DOM ID.
	 * @param {number} index Index of the character to check.
	 * @return {boolean} True if the character is a separator or end of the ID.
	 * @private
	 */
	function isBoundary(id, index) {
	  return id.charAt(index) === SEPARATOR || index === id.length;
	}
	
	/**
	 * Checks if the supplied string is a valid React DOM ID.
	 *
	 * @param {string} id A React DOM ID, maybe.
	 * @return {boolean} True if the string is a valid React DOM ID.
	 * @private
	 */
	function isValidID(id) {
	  return id === '' || (
	    id.charAt(0) === SEPARATOR && id.charAt(id.length - 1) !== SEPARATOR
	  );
	}
	
	/**
	 * Checks if the first ID is an ancestor of or equal to the second ID.
	 *
	 * @param {string} ancestorID
	 * @param {string} descendantID
	 * @return {boolean} True if `ancestorID` is an ancestor of `descendantID`.
	 * @internal
	 */
	function isAncestorIDOf(ancestorID, descendantID) {
	  return (
	    descendantID.indexOf(ancestorID) === 0 &&
	    isBoundary(descendantID, ancestorID.length)
	  );
	}
	
	/**
	 * Gets the parent ID of the supplied React DOM ID, `id`.
	 *
	 * @param {string} id ID of a component.
	 * @return {string} ID of the parent, or an empty string.
	 * @private
	 */
	function getParentID(id) {
	  return id ? id.substr(0, id.lastIndexOf(SEPARATOR)) : '';
	}
	
	/**
	 * Gets the next DOM ID on the tree path from the supplied `ancestorID` to the
	 * supplied `destinationID`. If they are equal, the ID is returned.
	 *
	 * @param {string} ancestorID ID of an ancestor node of `destinationID`.
	 * @param {string} destinationID ID of the destination node.
	 * @return {string} Next ID on the path from `ancestorID` to `destinationID`.
	 * @private
	 */
	function getNextDescendantID(ancestorID, destinationID) {
	  ( false ? invariant(
	    isValidID(ancestorID) && isValidID(destinationID),
	    'getNextDescendantID(%s, %s): Received an invalid React DOM ID.',
	    ancestorID,
	    destinationID
	  ) : invariant(isValidID(ancestorID) && isValidID(destinationID)));
	  ( false ? invariant(
	    isAncestorIDOf(ancestorID, destinationID),
	    'getNextDescendantID(...): React has made an invalid assumption about ' +
	    'the DOM hierarchy. Expected `%s` to be an ancestor of `%s`.',
	    ancestorID,
	    destinationID
	  ) : invariant(isAncestorIDOf(ancestorID, destinationID)));
	  if (ancestorID === destinationID) {
	    return ancestorID;
	  }
	  // Skip over the ancestor and the immediate separator. Traverse until we hit
	  // another separator or we reach the end of `destinationID`.
	  var start = ancestorID.length + SEPARATOR_LENGTH;
	  var i;
	  for (i = start; i < destinationID.length; i++) {
	    if (isBoundary(destinationID, i)) {
	      break;
	    }
	  }
	  return destinationID.substr(0, i);
	}
	
	/**
	 * Gets the nearest common ancestor ID of two IDs.
	 *
	 * Using this ID scheme, the nearest common ancestor ID is the longest common
	 * prefix of the two IDs that immediately preceded a "marker" in both strings.
	 *
	 * @param {string} oneID
	 * @param {string} twoID
	 * @return {string} Nearest common ancestor ID, or the empty string if none.
	 * @private
	 */
	function getFirstCommonAncestorID(oneID, twoID) {
	  var minLength = Math.min(oneID.length, twoID.length);
	  if (minLength === 0) {
	    return '';
	  }
	  var lastCommonMarkerIndex = 0;
	  // Use `<=` to traverse until the "EOL" of the shorter string.
	  for (var i = 0; i <= minLength; i++) {
	    if (isBoundary(oneID, i) && isBoundary(twoID, i)) {
	      lastCommonMarkerIndex = i;
	    } else if (oneID.charAt(i) !== twoID.charAt(i)) {
	      break;
	    }
	  }
	  var longestCommonID = oneID.substr(0, lastCommonMarkerIndex);
	  ( false ? invariant(
	    isValidID(longestCommonID),
	    'getFirstCommonAncestorID(%s, %s): Expected a valid React DOM ID: %s',
	    oneID,
	    twoID,
	    longestCommonID
	  ) : invariant(isValidID(longestCommonID)));
	  return longestCommonID;
	}
	
	/**
	 * Traverses the parent path between two IDs (either up or down). The IDs must
	 * not be the same, and there must exist a parent path between them. If the
	 * callback returns `false`, traversal is stopped.
	 *
	 * @param {?string} start ID at which to start traversal.
	 * @param {?string} stop ID at which to end traversal.
	 * @param {function} cb Callback to invoke each ID with.
	 * @param {?boolean} skipFirst Whether or not to skip the first node.
	 * @param {?boolean} skipLast Whether or not to skip the last node.
	 * @private
	 */
	function traverseParentPath(start, stop, cb, arg, skipFirst, skipLast) {
	  start = start || '';
	  stop = stop || '';
	  ( false ? invariant(
	    start !== stop,
	    'traverseParentPath(...): Cannot traverse from and to the same ID, `%s`.',
	    start
	  ) : invariant(start !== stop));
	  var traverseUp = isAncestorIDOf(stop, start);
	  ( false ? invariant(
	    traverseUp || isAncestorIDOf(start, stop),
	    'traverseParentPath(%s, %s, ...): Cannot traverse from two IDs that do ' +
	    'not have a parent path.',
	    start,
	    stop
	  ) : invariant(traverseUp || isAncestorIDOf(start, stop)));
	  // Traverse from `start` to `stop` one depth at a time.
	  var depth = 0;
	  var traverse = traverseUp ? getParentID : getNextDescendantID;
	  for (var id = start; /* until break */; id = traverse(id, stop)) {
	    var ret;
	    if ((!skipFirst || id !== start) && (!skipLast || id !== stop)) {
	      ret = cb(id, traverseUp, arg);
	    }
	    if (ret === false || id === stop) {
	      // Only break //after// visiting `stop`.
	      break;
	    }
	    ( false ? invariant(
	      depth++ < MAX_TREE_DEPTH,
	      'traverseParentPath(%s, %s, ...): Detected an infinite loop while ' +
	      'traversing the React DOM ID tree. This may be due to malformed IDs: %s',
	      start, stop
	    ) : invariant(depth++ < MAX_TREE_DEPTH));
	  }
	}
	
	/**
	 * Manages the IDs assigned to DOM representations of React components. This
	 * uses a specific scheme in order to traverse the DOM efficiently (e.g. in
	 * order to simulate events).
	 *
	 * @internal
	 */
	var ReactInstanceHandles = {
	
	  /**
	   * Constructs a React root ID
	   * @return {string} A React root ID.
	   */
	  createReactRootID: function() {
	    return getReactRootIDString(ReactRootIndex.createReactRootIndex());
	  },
	
	  /**
	   * Constructs a React ID by joining a root ID with a name.
	   *
	   * @param {string} rootID Root ID of a parent component.
	   * @param {string} name A component's name (as flattened children).
	   * @return {string} A React ID.
	   * @internal
	   */
	  createReactID: function(rootID, name) {
	    return rootID + name;
	  },
	
	  /**
	   * Gets the DOM ID of the React component that is the root of the tree that
	   * contains the React component with the supplied DOM ID.
	   *
	   * @param {string} id DOM ID of a React component.
	   * @return {?string} DOM ID of the React component that is the root.
	   * @internal
	   */
	  getReactRootIDFromNodeID: function(id) {
	    if (id && id.charAt(0) === SEPARATOR && id.length > 1) {
	      var index = id.indexOf(SEPARATOR, 1);
	      return index > -1 ? id.substr(0, index) : id;
	    }
	    return null;
	  },
	
	  /**
	   * Traverses the ID hierarchy and invokes the supplied `cb` on any IDs that
	   * should would receive a `mouseEnter` or `mouseLeave` event.
	   *
	   * NOTE: Does not invoke the callback on the nearest common ancestor because
	   * nothing "entered" or "left" that element.
	   *
	   * @param {string} leaveID ID being left.
	   * @param {string} enterID ID being entered.
	   * @param {function} cb Callback to invoke on each entered/left ID.
	   * @param {*} upArg Argument to invoke the callback with on left IDs.
	   * @param {*} downArg Argument to invoke the callback with on entered IDs.
	   * @internal
	   */
	  traverseEnterLeave: function(leaveID, enterID, cb, upArg, downArg) {
	    var ancestorID = getFirstCommonAncestorID(leaveID, enterID);
	    if (ancestorID !== leaveID) {
	      traverseParentPath(leaveID, ancestorID, cb, upArg, false, true);
	    }
	    if (ancestorID !== enterID) {
	      traverseParentPath(ancestorID, enterID, cb, downArg, true, false);
	    }
	  },
	
	  /**
	   * Simulates the traversal of a two-phase, capture/bubble event dispatch.
	   *
	   * NOTE: This traversal happens on IDs without touching the DOM.
	   *
	   * @param {string} targetID ID of the target node.
	   * @param {function} cb Callback to invoke.
	   * @param {*} arg Argument to invoke the callback with.
	   * @internal
	   */
	  traverseTwoPhase: function(targetID, cb, arg) {
	    if (targetID) {
	      traverseParentPath('', targetID, cb, arg, true, false);
	      traverseParentPath(targetID, '', cb, arg, false, true);
	    }
	  },
	
	  /**
	   * Traverse a node ID, calling the supplied `cb` for each ancestor ID. For
	   * example, passing `.0.$row-0.1` would result in `cb` getting called
	   * with `.0`, `.0.$row-0`, and `.0.$row-0.1`.
	   *
	   * NOTE: This traversal happens on IDs without touching the DOM.
	   *
	   * @param {string} targetID ID of the target node.
	   * @param {function} cb Callback to invoke.
	   * @param {*} arg Argument to invoke the callback with.
	   * @internal
	   */
	  traverseAncestors: function(targetID, cb, arg) {
	    traverseParentPath('', targetID, cb, arg, true, false);
	  },
	
	  /**
	   * Exposed for unit testing.
	   * @private
	   */
	  _getFirstCommonAncestorID: getFirstCommonAncestorID,
	
	  /**
	   * Exposed for unit testing.
	   * @private
	   */
	  _getNextDescendantID: getNextDescendantID,
	
	  isAncestorIDOf: isAncestorIDOf,
	
	  SEPARATOR: SEPARATOR
	
	};
	
	module.exports = ReactInstanceHandles;


/***/ },
/* 36 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactInstanceMap
	 */
	
	'use strict';
	
	/**
	 * `ReactInstanceMap` maintains a mapping from a public facing stateful
	 * instance (key) and the internal representation (value). This allows public
	 * methods to accept the user facing instance as an argument and map them back
	 * to internal methods.
	 */
	
	// TODO: Replace this with ES6: var ReactInstanceMap = new Map();
	var ReactInstanceMap = {
	
	  /**
	   * This API should be called `delete` but we'd have to make sure to always
	   * transform these to strings for IE support. When this transform is fully
	   * supported we can rename it.
	   */
	  remove: function(key) {
	    key._reactInternalInstance = undefined;
	  },
	
	  get: function(key) {
	    return key._reactInternalInstance;
	  },
	
	  has: function(key) {
	    return key._reactInternalInstance !== undefined;
	  },
	
	  set: function(key, value) {
	    key._reactInternalInstance = value;
	  }
	
	};
	
	module.exports = ReactInstanceMap;


/***/ },
/* 37 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactReconciler
	 */
	
	'use strict';
	
	var ReactRef = __webpack_require__(439);
	var ReactElementValidator = __webpack_require__(46);
	
	/**
	 * Helper to call ReactRef.attachRefs with this composite component, split out
	 * to avoid allocations in the transaction mount-ready queue.
	 */
	function attachRefs() {
	  ReactRef.attachRefs(this, this._currentElement);
	}
	
	var ReactReconciler = {
	
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {string} rootID DOM ID of the root node.
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function(internalInstance, rootID, transaction, context) {
	    var markup = internalInstance.mountComponent(rootID, transaction, context);
	    if (false) {
	      ReactElementValidator.checkAndWarnForMutatedProps(
	        internalInstance._currentElement
	      );
	    }
	    transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    return markup;
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function(internalInstance) {
	    ReactRef.detachRefs(internalInstance, internalInstance._currentElement);
	    internalInstance.unmountComponent();
	  },
	
	  /**
	   * Update a component using a new element.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @internal
	   */
	  receiveComponent: function(
	    internalInstance, nextElement, transaction, context
	  ) {
	    var prevElement = internalInstance._currentElement;
	
	    if (nextElement === prevElement && nextElement._owner != null) {
	      // Since elements are immutable after the owner is rendered,
	      // we can do a cheap identity compare here to determine if this is a
	      // superfluous reconcile. It's possible for state to be mutable but such
	      // change should trigger an update of the owner which would recreate
	      // the element. We explicitly check for the existence of an owner since
	      // it's possible for an element created outside a composite to be
	      // deeply mutated and reused.
	      return;
	    }
	
	    if (false) {
	      ReactElementValidator.checkAndWarnForMutatedProps(nextElement);
	    }
	
	    var refsChanged = ReactRef.shouldUpdateRefs(
	      prevElement,
	      nextElement
	    );
	
	    if (refsChanged) {
	      ReactRef.detachRefs(internalInstance, prevElement);
	    }
	
	    internalInstance.receiveComponent(nextElement, transaction, context);
	
	    if (refsChanged) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	  },
	
	  /**
	   * Flush any dirty changes in a component.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function(
	    internalInstance,
	    transaction
	  ) {
	    internalInstance.performUpdateIfNecessary(transaction);
	  }
	
	};
	
	module.exports = ReactReconciler;


/***/ },
/* 38 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = shouldPureComponentUpdate;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _shallowEqual = __webpack_require__(189);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	function shouldPureComponentUpdate(nextProps, nextState) {
	  return !_shallowEqual2['default'](this.props, nextProps) || !_shallowEqual2['default'](this.state, nextState);
	}
	
	module.exports = exports['default'];

/***/ },
/* 39 */
/***/ function(module, exports) {

	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/* Native method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * Creates a function that invokes `func` with the `this` binding of the
	 * created function and arguments from `start` and beyond provided as an array.
	 *
	 * **Note:** This method is based on the [rest parameter](https://developer.mozilla.org/Web/JavaScript/Reference/Functions/rest_parameters).
	 *
	 * @static
	 * @memberOf _
	 * @category Function
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @returns {Function} Returns the new function.
	 * @example
	 *
	 * var say = _.restParam(function(what, names) {
	 *   return what + ' ' + _.initial(names).join(', ') +
	 *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
	 * });
	 *
	 * say('hello', 'fred', 'barney', 'pebbles');
	 * // => 'hello fred, barney, & pebbles'
	 */
	function restParam(func, start) {
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  start = nativeMax(start === undefined ? (func.length - 1) : (+start || 0), 0);
	  return function() {
	    var args = arguments,
	        index = -1,
	        length = nativeMax(args.length - start, 0),
	        rest = Array(length);
	
	    while (++index < length) {
	      rest[index] = args[start + index];
	    }
	    switch (start) {
	      case 0: return func.call(this, rest);
	      case 1: return func.call(this, args[0], rest);
	      case 2: return func.call(this, args[0], args[1], rest);
	    }
	    var otherArgs = Array(start + 1);
	    index = -1;
	    while (++index < start) {
	      otherArgs[index] = args[index];
	    }
	    otherArgs[start] = rest;
	    return func.apply(this, otherArgs);
	  };
	}
	
	module.exports = restParam;


/***/ },
/* 40 */
/***/ function(module, exports) {

	/**
	 * Used as the [maximum length](http://ecma-international.org/ecma-262/6.0/#sec-number.max_safe_integer)
	 * of an array-like value.
	 */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This function is based on [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 */
	function isLength(value) {
	  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	module.exports = isLength;


/***/ },
/* 41 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is object-like.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	module.exports = isObjectLike;


/***/ },
/* 42 */
/***/ function(module, exports) {

	/**
	 * Actions that modify the URL.
	 */
	'use strict';
	
	var LocationActions = {
	
	  /**
	   * Indicates a new location is being pushed to the history stack.
	   */
	  PUSH: 'push',
	
	  /**
	   * Indicates the current location should be replaced.
	   */
	  REPLACE: 'replace',
	
	  /**
	   * Indicates the most recent entry should be removed from the history stack.
	   */
	  POP: 'pop'
	
	};
	
	module.exports = LocationActions;

/***/ },
/* 43 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DOMPropertyOperations
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(33);
	
	var quoteAttributeValueForBrowser = __webpack_require__(472);
	var warning = __webpack_require__(6);
	
	function shouldIgnoreValue(name, value) {
	  return value == null ||
	    (DOMProperty.hasBooleanValue[name] && !value) ||
	    (DOMProperty.hasNumericValue[name] && isNaN(value)) ||
	    (DOMProperty.hasPositiveNumericValue[name] && (value < 1)) ||
	    (DOMProperty.hasOverloadedBooleanValue[name] && value === false);
	}
	
	if (false) {
	  var reactProps = {
	    children: true,
	    dangerouslySetInnerHTML: true,
	    key: true,
	    ref: true
	  };
	  var warnedProperties = {};
	
	  var warnUnknownProperty = function(name) {
	    if (reactProps.hasOwnProperty(name) && reactProps[name] ||
	        warnedProperties.hasOwnProperty(name) && warnedProperties[name]) {
	      return;
	    }
	
	    warnedProperties[name] = true;
	    var lowerCasedName = name.toLowerCase();
	
	    // data-* attributes should be lowercase; suggest the lowercase version
	    var standardName = (
	      DOMProperty.isCustomAttribute(lowerCasedName) ?
	        lowerCasedName :
	      DOMProperty.getPossibleStandardName.hasOwnProperty(lowerCasedName) ?
	        DOMProperty.getPossibleStandardName[lowerCasedName] :
	        null
	    );
	
	    // For now, only warn when we have a suggested correction. This prevents
	    // logging too much when using transferPropsTo.
	    ("production" !== process.env.NODE_ENV ? warning(
	      standardName == null,
	      'Unknown DOM property %s. Did you mean %s?',
	      name,
	      standardName
	    ) : null);
	
	  };
	}
	
	/**
	 * Operations for dealing with DOM properties.
	 */
	var DOMPropertyOperations = {
	
	  /**
	   * Creates markup for the ID property.
	   *
	   * @param {string} id Unescaped ID.
	   * @return {string} Markup string.
	   */
	  createMarkupForID: function(id) {
	    return DOMProperty.ID_ATTRIBUTE_NAME + '=' +
	      quoteAttributeValueForBrowser(id);
	  },
	
	  /**
	   * Creates markup for a property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {?string} Markup string, or null if the property was invalid.
	   */
	  createMarkupForProperty: function(name, value) {
	    if (DOMProperty.isStandardName.hasOwnProperty(name) &&
	        DOMProperty.isStandardName[name]) {
	      if (shouldIgnoreValue(name, value)) {
	        return '';
	      }
	      var attributeName = DOMProperty.getAttributeName[name];
	      if (DOMProperty.hasBooleanValue[name] ||
	          (DOMProperty.hasOverloadedBooleanValue[name] && value === true)) {
	        return attributeName;
	      }
	      return attributeName + '=' + quoteAttributeValueForBrowser(value);
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      if (value == null) {
	        return '';
	      }
	      return name + '=' + quoteAttributeValueForBrowser(value);
	    } else if (false) {
	      warnUnknownProperty(name);
	    }
	    return null;
	  },
	
	  /**
	   * Sets the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   * @param {*} value
	   */
	  setValueForProperty: function(node, name, value) {
	    if (DOMProperty.isStandardName.hasOwnProperty(name) &&
	        DOMProperty.isStandardName[name]) {
	      var mutationMethod = DOMProperty.getMutationMethod[name];
	      if (mutationMethod) {
	        mutationMethod(node, value);
	      } else if (shouldIgnoreValue(name, value)) {
	        this.deleteValueForProperty(node, name);
	      } else if (DOMProperty.mustUseAttribute[name]) {
	        // `setAttribute` with objects becomes only `[object]` in IE8/9,
	        // ('' + value) makes it output the correct toString()-value.
	        node.setAttribute(DOMProperty.getAttributeName[name], '' + value);
	      } else {
	        var propName = DOMProperty.getPropertyName[name];
	        // Must explicitly cast values for HAS_SIDE_EFFECTS-properties to the
	        // property type before comparing; only `value` does and is string.
	        if (!DOMProperty.hasSideEffects[name] ||
	            ('' + node[propName]) !== ('' + value)) {
	          // Contrary to `setAttribute`, object properties are properly
	          // `toString`ed by IE8/9.
	          node[propName] = value;
	        }
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      if (value == null) {
	        node.removeAttribute(name);
	      } else {
	        node.setAttribute(name, '' + value);
	      }
	    } else if (false) {
	      warnUnknownProperty(name);
	    }
	  },
	
	  /**
	   * Deletes the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   */
	  deleteValueForProperty: function(node, name) {
	    if (DOMProperty.isStandardName.hasOwnProperty(name) &&
	        DOMProperty.isStandardName[name]) {
	      var mutationMethod = DOMProperty.getMutationMethod[name];
	      if (mutationMethod) {
	        mutationMethod(node, undefined);
	      } else if (DOMProperty.mustUseAttribute[name]) {
	        node.removeAttribute(DOMProperty.getAttributeName[name]);
	      } else {
	        var propName = DOMProperty.getPropertyName[name];
	        var defaultValue = DOMProperty.getDefaultValueForProperty(
	          node.nodeName,
	          propName
	        );
	        if (!DOMProperty.hasSideEffects[name] ||
	            ('' + node[propName]) !== defaultValue) {
	          node[propName] = defaultValue;
	        }
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      node.removeAttribute(name);
	    } else if (false) {
	      warnUnknownProperty(name);
	    }
	  }
	
	};
	
	module.exports = DOMPropertyOperations;


/***/ },
/* 44 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EventPluginHub
	 */
	
	'use strict';
	
	var EventPluginRegistry = __webpack_require__(144);
	var EventPluginUtils = __webpack_require__(83);
	
	var accumulateInto = __webpack_require__(94);
	var forEachAccumulated = __webpack_require__(95);
	var invariant = __webpack_require__(2);
	
	/**
	 * Internal store for event listeners
	 */
	var listenerBank = {};
	
	/**
	 * Internal queue of events that have accumulated their dispatches and are
	 * waiting to have their dispatches executed.
	 */
	var eventQueue = null;
	
	/**
	 * Dispatches an event and releases it back into the pool, unless persistent.
	 *
	 * @param {?object} event Synthetic event to be dispatched.
	 * @private
	 */
	var executeDispatchesAndRelease = function(event) {
	  if (event) {
	    var executeDispatch = EventPluginUtils.executeDispatch;
	    // Plugins can provide custom behavior when dispatching events.
	    var PluginModule = EventPluginRegistry.getPluginModuleForEvent(event);
	    if (PluginModule && PluginModule.executeDispatch) {
	      executeDispatch = PluginModule.executeDispatch;
	    }
	    EventPluginUtils.executeDispatchesInOrder(event, executeDispatch);
	
	    if (!event.isPersistent()) {
	      event.constructor.release(event);
	    }
	  }
	};
	
	/**
	 * - `InstanceHandle`: [required] Module that performs logical traversals of DOM
	 *   hierarchy given ids of the logical DOM elements involved.
	 */
	var InstanceHandle = null;
	
	function validateInstanceHandle() {
	  var valid =
	    InstanceHandle &&
	    InstanceHandle.traverseTwoPhase &&
	    InstanceHandle.traverseEnterLeave;
	  ( false ? invariant(
	    valid,
	    'InstanceHandle not injected before use!'
	  ) : invariant(valid));
	}
	
	/**
	 * This is a unified interface for event plugins to be installed and configured.
	 *
	 * Event plugins can implement the following properties:
	 *
	 *   `extractEvents` {function(string, DOMEventTarget, string, object): *}
	 *     Required. When a top-level event is fired, this method is expected to
	 *     extract synthetic events that will in turn be queued and dispatched.
	 *
	 *   `eventTypes` {object}
	 *     Optional, plugins that fire events must publish a mapping of registration
	 *     names that are used to register listeners. Values of this mapping must
	 *     be objects that contain `registrationName` or `phasedRegistrationNames`.
	 *
	 *   `executeDispatch` {function(object, function, string)}
	 *     Optional, allows plugins to override how an event gets dispatched. By
	 *     default, the listener is simply invoked.
	 *
	 * Each plugin that is injected into `EventsPluginHub` is immediately operable.
	 *
	 * @public
	 */
	var EventPluginHub = {
	
	  /**
	   * Methods for injecting dependencies.
	   */
	  injection: {
	
	    /**
	     * @param {object} InjectedMount
	     * @public
	     */
	    injectMount: EventPluginUtils.injection.injectMount,
	
	    /**
	     * @param {object} InjectedInstanceHandle
	     * @public
	     */
	    injectInstanceHandle: function(InjectedInstanceHandle) {
	      InstanceHandle = InjectedInstanceHandle;
	      if (false) {
	        validateInstanceHandle();
	      }
	    },
	
	    getInstanceHandle: function() {
	      if (false) {
	        validateInstanceHandle();
	      }
	      return InstanceHandle;
	    },
	
	    /**
	     * @param {array} InjectedEventPluginOrder
	     * @public
	     */
	    injectEventPluginOrder: EventPluginRegistry.injectEventPluginOrder,
	
	    /**
	     * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	     */
	    injectEventPluginsByName: EventPluginRegistry.injectEventPluginsByName
	
	  },
	
	  eventNameDispatchConfigs: EventPluginRegistry.eventNameDispatchConfigs,
	
	  registrationNameModules: EventPluginRegistry.registrationNameModules,
	
	  /**
	   * Stores `listener` at `listenerBank[registrationName][id]`. Is idempotent.
	   *
	   * @param {string} id ID of the DOM element.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {?function} listener The callback to store.
	   */
	  putListener: function(id, registrationName, listener) {
	    ( false ? invariant(
	      !listener || typeof listener === 'function',
	      'Expected %s listener to be a function, instead got type %s',
	      registrationName, typeof listener
	    ) : invariant(!listener || typeof listener === 'function'));
	
	    var bankForRegistrationName =
	      listenerBank[registrationName] || (listenerBank[registrationName] = {});
	    bankForRegistrationName[id] = listener;
	  },
	
	  /**
	   * @param {string} id ID of the DOM element.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @return {?function} The stored callback.
	   */
	  getListener: function(id, registrationName) {
	    var bankForRegistrationName = listenerBank[registrationName];
	    return bankForRegistrationName && bankForRegistrationName[id];
	  },
	
	  /**
	   * Deletes a listener from the registration bank.
	   *
	   * @param {string} id ID of the DOM element.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   */
	  deleteListener: function(id, registrationName) {
	    var bankForRegistrationName = listenerBank[registrationName];
	    if (bankForRegistrationName) {
	      delete bankForRegistrationName[id];
	    }
	  },
	
	  /**
	   * Deletes all listeners for the DOM element with the supplied ID.
	   *
	   * @param {string} id ID of the DOM element.
	   */
	  deleteAllListeners: function(id) {
	    for (var registrationName in listenerBank) {
	      delete listenerBank[registrationName][id];
	    }
	  },
	
	  /**
	   * Allows registered plugins an opportunity to extract events from top-level
	   * native browser events.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {DOMEventTarget} topLevelTarget The listening component root node.
	   * @param {string} topLevelTargetID ID of `topLevelTarget`.
	   * @param {object} nativeEvent Native browser event.
	   * @return {*} An accumulation of synthetic events.
	   * @internal
	   */
	  extractEvents: function(
	      topLevelType,
	      topLevelTarget,
	      topLevelTargetID,
	      nativeEvent) {
	    var events;
	    var plugins = EventPluginRegistry.plugins;
	    for (var i = 0, l = plugins.length; i < l; i++) {
	      // Not every plugin in the ordering may be loaded at runtime.
	      var possiblePlugin = plugins[i];
	      if (possiblePlugin) {
	        var extractedEvents = possiblePlugin.extractEvents(
	          topLevelType,
	          topLevelTarget,
	          topLevelTargetID,
	          nativeEvent
	        );
	        if (extractedEvents) {
	          events = accumulateInto(events, extractedEvents);
	        }
	      }
	    }
	    return events;
	  },
	
	  /**
	   * Enqueues a synthetic event that should be dispatched when
	   * `processEventQueue` is invoked.
	   *
	   * @param {*} events An accumulation of synthetic events.
	   * @internal
	   */
	  enqueueEvents: function(events) {
	    if (events) {
	      eventQueue = accumulateInto(eventQueue, events);
	    }
	  },
	
	  /**
	   * Dispatches all synthetic events on the event queue.
	   *
	   * @internal
	   */
	  processEventQueue: function() {
	    // Set `eventQueue` to null before processing it so that we can tell if more
	    // events get enqueued while processing.
	    var processingEventQueue = eventQueue;
	    eventQueue = null;
	    forEachAccumulated(processingEventQueue, executeDispatchesAndRelease);
	    ( false ? invariant(
	      !eventQueue,
	      'processEventQueue(): Additional events were enqueued while processing ' +
	      'an event queue. Support for this has not yet been implemented.'
	    ) : invariant(!eventQueue));
	  },
	
	  /**
	   * These are needed for tests only. Do not use!
	   */
	  __purge: function() {
	    listenerBank = {};
	  },
	
	  __getListenerBank: function() {
	    return listenerBank;
	  }
	
	};
	
	module.exports = EventPluginHub;


/***/ },
/* 45 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EventPropagators
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(12);
	var EventPluginHub = __webpack_require__(44);
	
	var accumulateInto = __webpack_require__(94);
	var forEachAccumulated = __webpack_require__(95);
	
	var PropagationPhases = EventConstants.PropagationPhases;
	var getListener = EventPluginHub.getListener;
	
	/**
	 * Some event types have a notion of different registration names for different
	 * "phases" of propagation. This finds listeners by a given phase.
	 */
	function listenerAtPhase(id, event, propagationPhase) {
	  var registrationName =
	    event.dispatchConfig.phasedRegistrationNames[propagationPhase];
	  return getListener(id, registrationName);
	}
	
	/**
	 * Tags a `SyntheticEvent` with dispatched listeners. Creating this function
	 * here, allows us to not have to bind or create functions for each event.
	 * Mutating the event's members allows us to not have to create a wrapping
	 * "dispatch" object that pairs the event with the listener.
	 */
	function accumulateDirectionalDispatches(domID, upwards, event) {
	  if (false) {
	    if (!domID) {
	      throw new Error('Dispatching id must not be null');
	    }
	  }
	  var phase = upwards ? PropagationPhases.bubbled : PropagationPhases.captured;
	  var listener = listenerAtPhase(domID, event, phase);
	  if (listener) {
	    event._dispatchListeners =
	      accumulateInto(event._dispatchListeners, listener);
	    event._dispatchIDs = accumulateInto(event._dispatchIDs, domID);
	  }
	}
	
	/**
	 * Collect dispatches (must be entirely collected before dispatching - see unit
	 * tests). Lazily allocate the array to conserve memory.  We must loop through
	 * each event and perform the traversal for each one. We can not perform a
	 * single traversal for the entire collection of events because each event may
	 * have a different target.
	 */
	function accumulateTwoPhaseDispatchesSingle(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    EventPluginHub.injection.getInstanceHandle().traverseTwoPhase(
	      event.dispatchMarker,
	      accumulateDirectionalDispatches,
	      event
	    );
	  }
	}
	
	
	/**
	 * Accumulates without regard to direction, does not look for phased
	 * registration names. Same as `accumulateDirectDispatchesSingle` but without
	 * requiring that the `dispatchMarker` be the same as the dispatched ID.
	 */
	function accumulateDispatches(id, ignoredDirection, event) {
	  if (event && event.dispatchConfig.registrationName) {
	    var registrationName = event.dispatchConfig.registrationName;
	    var listener = getListener(id, registrationName);
	    if (listener) {
	      event._dispatchListeners =
	        accumulateInto(event._dispatchListeners, listener);
	      event._dispatchIDs = accumulateInto(event._dispatchIDs, id);
	    }
	  }
	}
	
	/**
	 * Accumulates dispatches on an `SyntheticEvent`, but only for the
	 * `dispatchMarker`.
	 * @param {SyntheticEvent} event
	 */
	function accumulateDirectDispatchesSingle(event) {
	  if (event && event.dispatchConfig.registrationName) {
	    accumulateDispatches(event.dispatchMarker, null, event);
	  }
	}
	
	function accumulateTwoPhaseDispatches(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingle);
	}
	
	function accumulateEnterLeaveDispatches(leave, enter, fromID, toID) {
	  EventPluginHub.injection.getInstanceHandle().traverseEnterLeave(
	    fromID,
	    toID,
	    accumulateDispatches,
	    leave,
	    enter
	  );
	}
	
	
	function accumulateDirectDispatches(events) {
	  forEachAccumulated(events, accumulateDirectDispatchesSingle);
	}
	
	
	
	/**
	 * A small set of propagation patterns, each of which will accept a small amount
	 * of information, and generate a set of "dispatch ready event objects" - which
	 * are sets of events that have already been annotated with a set of dispatched
	 * listener functions/ids. The API is designed this way to discourage these
	 * propagation strategies from actually executing the dispatches, since we
	 * always want to collect the entire set of dispatches before executing event a
	 * single one.
	 *
	 * @constructor EventPropagators
	 */
	var EventPropagators = {
	  accumulateTwoPhaseDispatches: accumulateTwoPhaseDispatches,
	  accumulateDirectDispatches: accumulateDirectDispatches,
	  accumulateEnterLeaveDispatches: accumulateEnterLeaveDispatches
	};
	
	module.exports = EventPropagators;


/***/ },
/* 46 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactElementValidator
	 */
	
	/**
	 * ReactElementValidator provides a wrapper around a element factory
	 * which validates the props passed to the element. This is intended to be
	 * used only in DEV and could be replaced by a static type checker for languages
	 * that support it.
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(7);
	var ReactFragment = __webpack_require__(60);
	var ReactPropTypeLocations = __webpack_require__(92);
	var ReactPropTypeLocationNames = __webpack_require__(62);
	var ReactCurrentOwner = __webpack_require__(19);
	var ReactNativeComponent = __webpack_require__(61);
	
	var getIteratorFn = __webpack_require__(159);
	var invariant = __webpack_require__(2);
	var warning = __webpack_require__(6);
	
	function getDeclarationErrorAddendum() {
	  if (ReactCurrentOwner.current) {
	    var name = ReactCurrentOwner.current.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Warn if there's no key explicitly set on dynamic arrays of children or
	 * object keys are not valid. This allows us to keep track of children between
	 * updates.
	 */
	var ownerHasKeyUseWarning = {};
	
	var loggedTypeFailures = {};
	
	var NUMERIC_PROPERTY_REGEX = /^\d+$/;
	
	/**
	 * Gets the instance's name for use in warnings.
	 *
	 * @internal
	 * @return {?string} Display name or undefined
	 */
	function getName(instance) {
	  var publicInstance = instance && instance.getPublicInstance();
	  if (!publicInstance) {
	    return undefined;
	  }
	  var constructor = publicInstance.constructor;
	  if (!constructor) {
	    return undefined;
	  }
	  return constructor.displayName || constructor.name || undefined;
	}
	
	/**
	 * Gets the current owner's displayName for use in warnings.
	 *
	 * @internal
	 * @return {?string} Display name or undefined
	 */
	function getCurrentOwnerDisplayName() {
	  var current = ReactCurrentOwner.current;
	  return (
	    current && getName(current) || undefined
	  );
	}
	
	/**
	 * Warn if the element doesn't have an explicit key assigned to it.
	 * This element is in an array. The array could grow and shrink or be
	 * reordered. All children that haven't already been validated are required to
	 * have a "key" property assigned to it.
	 *
	 * @internal
	 * @param {ReactElement} element Element that requires a key.
	 * @param {*} parentType element's parent's type.
	 */
	function validateExplicitKey(element, parentType) {
	  if (element._store.validated || element.key != null) {
	    return;
	  }
	  element._store.validated = true;
	
	  warnAndMonitorForKeyUse(
	    'Each child in an array or iterator should have a unique "key" prop.',
	    element,
	    parentType
	  );
	}
	
	/**
	 * Warn if the key is being defined as an object property but has an incorrect
	 * value.
	 *
	 * @internal
	 * @param {string} name Property name of the key.
	 * @param {ReactElement} element Component that requires a key.
	 * @param {*} parentType element's parent's type.
	 */
	function validatePropertyKey(name, element, parentType) {
	  if (!NUMERIC_PROPERTY_REGEX.test(name)) {
	    return;
	  }
	  warnAndMonitorForKeyUse(
	    'Child objects should have non-numeric keys so ordering is preserved.',
	    element,
	    parentType
	  );
	}
	
	/**
	 * Shared warning and monitoring code for the key warnings.
	 *
	 * @internal
	 * @param {string} message The base warning that gets output.
	 * @param {ReactElement} element Component that requires a key.
	 * @param {*} parentType element's parent's type.
	 */
	function warnAndMonitorForKeyUse(message, element, parentType) {
	  var ownerName = getCurrentOwnerDisplayName();
	  var parentName = typeof parentType === 'string' ?
	    parentType : parentType.displayName || parentType.name;
	
	  var useName = ownerName || parentName;
	  var memoizer = ownerHasKeyUseWarning[message] || (
	    (ownerHasKeyUseWarning[message] = {})
	  );
	  if (memoizer.hasOwnProperty(useName)) {
	    return;
	  }
	  memoizer[useName] = true;
	
	  var parentOrOwnerAddendum =
	    ownerName ? (" Check the render method of " + ownerName + ".") :
	    parentName ? (" Check the React.render call using <" + parentName + ">.") :
	    '';
	
	  // Usually the current owner is the offender, but if it accepts children as a
	  // property, it may be the creator of the child that's responsible for
	  // assigning it a key.
	  var childOwnerAddendum = '';
	  if (element &&
	      element._owner &&
	      element._owner !== ReactCurrentOwner.current) {
	    // Name of the component that originally created this child.
	    var childOwnerName = getName(element._owner);
	
	    childOwnerAddendum = (" It was passed a child from " + childOwnerName + ".");
	  }
	
	  ( false ? warning(
	    false,
	    message + '%s%s See https://fb.me/react-warning-keys for more information.',
	    parentOrOwnerAddendum,
	    childOwnerAddendum
	  ) : null);
	}
	
	/**
	 * Ensure that every element either is passed in a static location, in an
	 * array with an explicit keys property defined, or in an object literal
	 * with valid key property.
	 *
	 * @internal
	 * @param {ReactNode} node Statically passed child of any type.
	 * @param {*} parentType node's parent's type.
	 */
	function validateChildKeys(node, parentType) {
	  if (Array.isArray(node)) {
	    for (var i = 0; i < node.length; i++) {
	      var child = node[i];
	      if (ReactElement.isValidElement(child)) {
	        validateExplicitKey(child, parentType);
	      }
	    }
	  } else if (ReactElement.isValidElement(node)) {
	    // This element was passed in a valid location.
	    node._store.validated = true;
	  } else if (node) {
	    var iteratorFn = getIteratorFn(node);
	    // Entry iterators provide implicit keys.
	    if (iteratorFn) {
	      if (iteratorFn !== node.entries) {
	        var iterator = iteratorFn.call(node);
	        var step;
	        while (!(step = iterator.next()).done) {
	          if (ReactElement.isValidElement(step.value)) {
	            validateExplicitKey(step.value, parentType);
	          }
	        }
	      }
	    } else if (typeof node === 'object') {
	      var fragment = ReactFragment.extractIfFragment(node);
	      for (var key in fragment) {
	        if (fragment.hasOwnProperty(key)) {
	          validatePropertyKey(key, fragment[key], parentType);
	        }
	      }
	    }
	  }
	}
	
	/**
	 * Assert that the props are valid
	 *
	 * @param {string} componentName Name of the component for error messages.
	 * @param {object} propTypes Map of prop name to a ReactPropType
	 * @param {object} props
	 * @param {string} location e.g. "prop", "context", "child context"
	 * @private
	 */
	function checkPropTypes(componentName, propTypes, props, location) {
	  for (var propName in propTypes) {
	    if (propTypes.hasOwnProperty(propName)) {
	      var error;
	      // Prop type validation may throw. In case they do, we don't want to
	      // fail the render phase where it didn't fail before. So we log it.
	      // After these have been cleaned up, we'll let them throw.
	      try {
	        // This is intentionally an invariant that gets caught. It's the same
	        // behavior as without this statement except with a better message.
	        ( false ? invariant(
	          typeof propTypes[propName] === 'function',
	          '%s: %s type `%s` is invalid; it must be a function, usually from ' +
	          'React.PropTypes.',
	          componentName || 'React class',
	          ReactPropTypeLocationNames[location],
	          propName
	        ) : invariant(typeof propTypes[propName] === 'function'));
	        error = propTypes[propName](props, propName, componentName, location);
	      } catch (ex) {
	        error = ex;
	      }
	      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	        // Only monitor this failure once because there tends to be a lot of the
	        // same error.
	        loggedTypeFailures[error.message] = true;
	
	        var addendum = getDeclarationErrorAddendum(this);
	        ( false ? warning(false, 'Failed propType: %s%s', error.message, addendum) : null);
	      }
	    }
	  }
	}
	
	var warnedPropsMutations = {};
	
	/**
	 * Warn about mutating props when setting `propName` on `element`.
	 *
	 * @param {string} propName The string key within props that was set
	 * @param {ReactElement} element
	 */
	function warnForPropsMutation(propName, element) {
	  var type = element.type;
	  var elementName = typeof type === 'string' ? type : type.displayName;
	  var ownerName = element._owner ?
	    element._owner.getPublicInstance().constructor.displayName : null;
	
	  var warningKey = propName + '|' + elementName + '|' + ownerName;
	  if (warnedPropsMutations.hasOwnProperty(warningKey)) {
	    return;
	  }
	  warnedPropsMutations[warningKey] = true;
	
	  var elementInfo = '';
	  if (elementName) {
	    elementInfo = ' <' + elementName + ' />';
	  }
	  var ownerInfo = '';
	  if (ownerName) {
	    ownerInfo = ' The element was created by ' + ownerName + '.';
	  }
	
	  ( false ? warning(
	    false,
	    'Don\'t set .props.%s of the React component%s. Instead, specify the ' +
	    'correct value when initially creating the element or use ' +
	    'React.cloneElement to make a new element with updated props.%s',
	    propName,
	    elementInfo,
	    ownerInfo
	  ) : null);
	}
	
	// Inline Object.is polyfill
	function is(a, b) {
	  if (a !== a) {
	    // NaN
	    return b !== b;
	  }
	  if (a === 0 && b === 0) {
	    // +-0
	    return 1 / a === 1 / b;
	  }
	  return a === b;
	}
	
	/**
	 * Given an element, check if its props have been mutated since element
	 * creation (or the last call to this function). In particular, check if any
	 * new props have been added, which we can't directly catch by defining warning
	 * properties on the props object.
	 *
	 * @param {ReactElement} element
	 */
	function checkAndWarnForMutatedProps(element) {
	  if (!element._store) {
	    // Element was created using `new ReactElement` directly or with
	    // `ReactElement.createElement`; skip mutation checking
	    return;
	  }
	
	  var originalProps = element._store.originalProps;
	  var props = element.props;
	
	  for (var propName in props) {
	    if (props.hasOwnProperty(propName)) {
	      if (!originalProps.hasOwnProperty(propName) ||
	          !is(originalProps[propName], props[propName])) {
	        warnForPropsMutation(propName, element);
	
	        // Copy over the new value so that the two props objects match again
	        originalProps[propName] = props[propName];
	      }
	    }
	  }
	}
	
	/**
	 * Given an element, validate that its props follow the propTypes definition,
	 * provided by the type.
	 *
	 * @param {ReactElement} element
	 */
	function validatePropTypes(element) {
	  if (element.type == null) {
	    // This has already warned. Don't throw.
	    return;
	  }
	  // Extract the component class from the element. Converts string types
	  // to a composite class which may have propTypes.
	  // TODO: Validating a string's propTypes is not decoupled from the
	  // rendering target which is problematic.
	  var componentClass = ReactNativeComponent.getComponentClassForElement(
	    element
	  );
	  var name = componentClass.displayName || componentClass.name;
	  if (componentClass.propTypes) {
	    checkPropTypes(
	      name,
	      componentClass.propTypes,
	      element.props,
	      ReactPropTypeLocations.prop
	    );
	  }
	  if (typeof componentClass.getDefaultProps === 'function') {
	    ( false ? warning(
	      componentClass.getDefaultProps.isReactClassApproved,
	      'getDefaultProps is only used on classic React.createClass ' +
	      'definitions. Use a static property named `defaultProps` instead.'
	    ) : null);
	  }
	}
	
	var ReactElementValidator = {
	
	  checkAndWarnForMutatedProps: checkAndWarnForMutatedProps,
	
	  createElement: function(type, props, children) {
	    // We warn in this case but don't throw. We expect the element creation to
	    // succeed and there will likely be errors in render.
	    ( false ? warning(
	      type != null,
	      'React.createElement: type should not be null or undefined. It should ' +
	        'be a string (for DOM elements) or a ReactClass (for composite ' +
	        'components).'
	    ) : null);
	
	    var element = ReactElement.createElement.apply(this, arguments);
	
	    // The result can be nullish if a mock or a custom function is used.
	    // TODO: Drop this when these are no longer allowed as the type argument.
	    if (element == null) {
	      return element;
	    }
	
	    for (var i = 2; i < arguments.length; i++) {
	      validateChildKeys(arguments[i], type);
	    }
	
	    validatePropTypes(element);
	
	    return element;
	  },
	
	  createFactory: function(type) {
	    var validatedFactory = ReactElementValidator.createElement.bind(
	      null,
	      type
	    );
	    // Legacy hook TODO: Warn if this is accessed
	    validatedFactory.type = type;
	
	    if (false) {
	      try {
	        Object.defineProperty(
	          validatedFactory,
	          'type',
	          {
	            enumerable: false,
	            get: function() {
	              ("production" !== process.env.NODE_ENV ? warning(
	                false,
	                'Factory.type is deprecated. Access the class directly ' +
	                'before passing it to createFactory.'
	              ) : null);
	              Object.defineProperty(this, 'type', {
	                value: type
	              });
	              return type;
	            }
	          }
	        );
	      } catch (x) {
	        // IE will fail on defineProperty (es5-shim/sham too)
	      }
	    }
	
	
	    return validatedFactory;
	  },
	
	  cloneElement: function(element, props, children) {
	    var newElement = ReactElement.cloneElement.apply(this, arguments);
	    for (var i = 2; i < arguments.length; i++) {
	      validateChildKeys(arguments[i], newElement.type);
	    }
	    validatePropTypes(newElement);
	    return newElement;
	  }
	
	};
	
	module.exports = ReactElementValidator;


/***/ },
/* 47 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticUIEvent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(28);
	
	var getEventTarget = __webpack_require__(98);
	
	/**
	 * @interface UIEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var UIEventInterface = {
	  view: function(event) {
	    if (event.view) {
	      return event.view;
	    }
	
	    var target = getEventTarget(event);
	    if (target != null && target.window === target) {
	      // target is a window object
	      return target;
	    }
	
	    var doc = target.ownerDocument;
	    // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	    if (doc) {
	      return doc.defaultView || doc.parentWindow;
	    } else {
	      return window;
	    }
	  },
	  detail: function(event) {
	    return event.detail || 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticUIEvent(dispatchConfig, dispatchMarker, nativeEvent) {
	  SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent);
	}
	
	SyntheticEvent.augmentClass(SyntheticUIEvent, UIEventInterface);
	
	module.exports = SyntheticUIEvent;


/***/ },
/* 48 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule keyMirror
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(2);
	
	/**
	 * Constructs an enumeration with keys equal to their value.
	 *
	 * For example:
	 *
	 *   var COLORS = keyMirror({blue: null, red: null});
	 *   var myColor = COLORS.blue;
	 *   var isColorValid = !!COLORS[myColor];
	 *
	 * The last line could not be performed if the values of the generated enum were
	 * not equal to their keys.
	 *
	 *   Input:  {key1: val1, key2: val2}
	 *   Output: {key1: key1, key2: key2}
	 *
	 * @param {object} obj
	 * @return {object}
	 */
	var keyMirror = function(obj) {
	  var ret = {};
	  var key;
	  ( false ? invariant(
	    obj instanceof Object && !Array.isArray(obj),
	    'keyMirror(...): Argument must be an object.'
	  ) : invariant(obj instanceof Object && !Array.isArray(obj)));
	  for (key in obj) {
	    if (!obj.hasOwnProperty(key)) {
	      continue;
	    }
	    ret[key] = key;
	  }
	  return ret;
	};
	
	module.exports = keyMirror;


/***/ },
/* 49 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = shouldPureComponentUpdate;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _shallowEqual = __webpack_require__(209);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	function shouldPureComponentUpdate(nextProps, nextState) {
	  return !_shallowEqual2['default'](this.props, nextProps) || !_shallowEqual2['default'](this.state, nextState);
	}
	
	module.exports = exports['default'];

/***/ },
/* 50 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var Pages = {
	  HOME: {
	    location: 'index.html',
	    title: 'Home'
	  }
	};
	
	exports.Pages = Pages;
	var APIPages = [{
	  title: 'Quick Start',
	  pages: {
	    OVERVIEW: {
	      location: 'docs-overview.html',
	      title: 'Overview'
	    },
	    TUTORIAL: {
	      location: 'docs-tutorial.html',
	      title: 'Tutorial'
	    },
	    TESTING: {
	      location: 'docs-testing.html',
	      title: 'Testing'
	    },
	    FAQ: {
	      location: 'docs-faq.html',
	      title: 'FAQ'
	    },
	    TROUBLESHOOTING: {
	      location: 'docs-troubleshooting.html',
	      title: 'Troubleshooting'
	    }
	  }
	}, {
	  title: 'Top-Level API',
	  pages: {
	    DRAG_SOURCE: {
	      location: 'docs-drag-source.html',
	      title: 'DragSource'
	    },
	    DROP_TARGET: {
	      location: 'docs-drop-target.html',
	      title: 'DropTarget'
	    },
	    DRAG_LAYER: {
	      location: 'docs-drag-layer.html',
	      title: 'DragLayer'
	    },
	    DRAG_DROP_CONTEXT: {
	      location: 'docs-drag-drop-context.html',
	      title: 'DragDropContext'
	    }
	  }
	}, {
	  title: 'Connecting to DOM',
	  pages: {
	    DRAG_SOURCE_CONNECTOR: {
	      location: 'docs-drag-source-connector.html',
	      title: 'DragSourceConnector'
	    },
	    DROP_TARGET_CONNECTOR: {
	      location: 'docs-drop-target-connector.html',
	      title: 'DropTargetConnector'
	    }
	  }
	}, {
	  title: 'Monitoring State',
	  pages: {
	    DRAG_SOURCE_MONITOR: {
	      location: 'docs-drag-source-monitor.html',
	      title: 'DragSourceMonitor'
	    },
	    DROP_TARGET_MONITOR: {
	      location: 'docs-drop-target-monitor.html',
	      title: 'DropTargetMonitor'
	    },
	    DRAG_LAYER_MONITOR: {
	      location: 'docs-drag-layer-monitor.html',
	      title: 'DragLayerMonitor'
	    }
	  }
	}, {
	  title: 'Backends',
	  pages: {
	    HTML5_BACKEND: {
	      location: 'docs-html5-backend.html',
	      title: 'HTML5'
	    },
	    TEST_BACKEND: {
	      location: 'docs-test-backend.html',
	      title: 'Test'
	    }
	  }
	}];
	
	exports.APIPages = APIPages;
	var ExamplePages = [{
	  title: 'Chessboard',
	  pages: {
	    CHESSBOARD_TUTORIAL_APP: {
	      location: 'examples-chessboard-tutorial-app.html',
	      title: 'Tutorial App'
	    }
	  }
	}, {
	  title: 'Dustbin',
	  pages: {
	    DUSTBIN_SINGLE_TARGET: {
	      location: 'examples-dustbin-single-target.html',
	      title: 'Single Target'
	    },
	    DUSTBIN_MULTIPLE_TARGETS: {
	      location: 'examples-dustbin-multiple-targets.html',
	      title: 'Multiple Targets'
	    },
	    DUSTBIN_STRESS_TEST: {
	      location: 'examples-dustbin-stress-test.html',
	      title: 'Stress Test'
	    }
	  }
	}, {
	  title: 'Drag Around',
	  pages: {
	    DRAG_AROUND_NAIVE: {
	      location: 'examples-drag-around-naive.html',
	      title: 'Naive'
	    },
	    DRAG_AROUND_CUSTOM_DRAG_LAYER: {
	      location: 'examples-drag-around-custom-drag-layer.html',
	      title: 'Custom Drag Layer'
	    }
	  }
	}, {
	  title: 'Nesting',
	  pages: {
	    NESTING_DRAG_SOURCES: {
	      location: 'examples-nesting-drag-sources.html',
	      title: 'Drag Sources'
	    },
	    NESTING_DROP_TARGETS: {
	      location: 'examples-nesting-drop-targets.html',
	      title: 'Drop Targets'
	    }
	  }
	}, {
	  title: 'Sortable',
	  pages: {
	    SORTABLE_SIMPLE: {
	      location: 'examples-sortable-simple.html',
	      title: 'Simple'
	    },
	    LIST_SELECTION: {
	      location: 'examples-list-selection.html',
	      title: 'List Selection'
	    },
	    SORTABLE_CANCEL_ON_DROP_OUTSIDE: {
	      location: 'examples-sortable-cancel-on-drop-outside.html',
	      title: 'Cancel on Drop Outside'
	    },
	    SORTABLE_STRESS_TEST: {
	      location: 'examples-sortable-stress.html',
	      title: 'Stress Test'
	    }
	  }
	}, {
	  title: 'Customize',
	  pages: {
	    CUSTOMIZE_HANDLES_AND_PREVIEWS: {
	      location: 'examples-customize-handles-and-previews.html',
	      title: 'Handles and Previews'
	    },
	    CUSTOMIZE_DROP_EFFECTS: {
	      location: 'examples-customize-drop-effects.html',
	      title: 'Drop Effects'
	    }
	  }
	}];
	
	exports.ExamplePages = ExamplePages;
	var DOCS_DEFAULT = APIPages[0].pages.OVERVIEW;
	exports.DOCS_DEFAULT = DOCS_DEFAULT;
	var EXAMPLES_DEFAULT = ExamplePages[0].pages.CHESSBOARD_TUTORIAL_APP;
	exports.EXAMPLES_DEFAULT = EXAMPLES_DEFAULT;

/***/ },
/* 51 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = checkDecoratorArguments;
	
	function checkDecoratorArguments(functionName, signature) {
	  if (false) {
	    for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	      args[_key - 2] = arguments[_key];
	    }
	
	    for (var i = 0; i < args.length; i++) {
	      var arg = args[i];
	      if (arg && arg.prototype && arg.prototype.render) {
	        console.error('You seem to be applying the arguments in the wrong order. ' + ('It should be ' + functionName + '(' + signature + ')(Component), not the other way around. ') + 'Read more: http://pljenkins.github.io/react-dnd/docs-troubleshooting.html#you-seem-to-be-applying-the-arguments-in-the-wrong-order');
	        return;
	      }
	    }
	  }
	}
	
	module.exports = exports['default'];

/***/ },
/* 52 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = shallowEqualScalar;
	
	function shallowEqualScalar(objA, objB) {
	  if (objA === objB) {
	    return true;
	  }
	
	  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  var hasOwn = Object.prototype.hasOwnProperty;
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwn.call(objB, keysA[i])) {
	      return false;
	    }
	
	    var valA = objA[keysA[i]];
	    var valB = objB[keysA[i]];
	
	    if (valA !== valB || typeof valA === 'object' || typeof valB === 'object') {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	module.exports = exports['default'];

/***/ },
/* 53 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequire = function (obj) { return obj && obj.__esModule ? obj['default'] : obj; };
	
	exports.__esModule = true;
	
	var _default = __webpack_require__(255);
	
	exports.DragDropManager = _interopRequire(_default);
	
	var _default2 = __webpack_require__(257);
	
	exports.DragSource = _interopRequire(_default2);
	
	var _default3 = __webpack_require__(258);
	
	exports.DropTarget = _interopRequire(_default3);
	
	var _default4 = __webpack_require__(262);
	
	exports.createTestBackend = _interopRequire(_default4);

/***/ },
/* 54 */
/***/ function(module, exports, __webpack_require__) {

	var faker = __webpack_require__(11);
	
	// backword-compatibility
	exports.randomNumber = function (range) {
	    return faker.random.number(range);
	};
	
	// backword-compatibility
	exports.randomize = function (array) {
	    array = array || ["a", "b", "c"];
	    return faker.random.array_element(array);
	};
	
	// slugifies string
	exports.slugify = function (string) {
	    string = string || "";
	    return string.replace(/ /g, '-').replace(/[^\w\.\-]+/g, '');
	};
	
	// parses string for a symbol and replace it with a random number from 1-10
	exports.replaceSymbolWithNumber = function (string, symbol) {
	    string = string || "";
	    // default symbol is '#'
	    if (symbol === undefined) {
	        symbol = '#';
	    }
	
	    var str = '';
	    for (var i = 0; i < string.length; i++) {
	        if (string.charAt(i) == symbol) {
	            str += faker.random.number(9);
	        } else {
	            str += string.charAt(i);
	        }
	    }
	    return str;
	};
	
	// takes an array and returns it randomized
	exports.shuffle = function (o) {
	    o = o || ["a", "b", "c"];
	    for (var j, x, i = o.length-1; i; j = faker.random.number(i), x = o[--i], o[i] = o[j], o[j] = x);
	    return o;
	};
	
	exports.mustache = function (str, data) {
	  for(var p in data) {
	    var re = new RegExp('{{' + p + '}}', 'g')
	    str = str.replace(re, data[p]);
	  }
	  return str;
	};
	
	exports.createCard = function () {
	    return {
	        "name": faker.name.findName(),
	        "username": faker.internet.userName(),
	        "email": faker.internet.email(),
	        "address": {
	            "streetA": faker.address.streetName(),
	            "streetB": faker.address.streetAddress(),
	            "streetC": faker.address.streetAddress(true),
	            "streetD": faker.address.secondaryAddress(),
	            "city": faker.address.city(),
	            "state": faker.address.state(),
	            "country": faker.address.country(),
	            "zipcode": faker.address.zipCode(),
	            "geo": {
	                "lat": faker.address.latitude(),
	                "lng": faker.address.longitude()
	            }
	        },
	        "phone": faker.phone.phoneNumber(),
	        "website": faker.internet.domainName(),
	        "company": {
	            "name": faker.company.companyName(),
	            "catchPhrase": faker.company.catchPhrase(),
	            "bs": faker.company.bs()
	        },
	        "posts": [
	            {
	                "words": faker.lorem.words(),
	                "sentence": faker.lorem.sentence(),
	                "sentences": faker.lorem.sentences(),
	                "paragraph": faker.lorem.paragraph()
	            },
	            {
	                "words": faker.lorem.words(),
	                "sentence": faker.lorem.sentence(),
	                "sentences": faker.lorem.sentences(),
	                "paragraph": faker.lorem.paragraph()
	            },
	            {
	                "words": faker.lorem.words(),
	                "sentence": faker.lorem.sentence(),
	                "sentences": faker.lorem.sentences(),
	                "paragraph": faker.lorem.paragraph()
	            }
	        ],
	        "accountHistory": [faker.helpers.createTransaction(), faker.helpers.createTransaction(), faker.helpers.createTransaction()]
	    };
	};
	
	exports.contextualCard = function () {
	  var name = faker.name.firstName(),
	      userName = faker.internet.userName(name);
	  return {
	      "name": name,
	      "username": userName,
	      "avatar": faker.internet.avatar(),
	      "email": faker.internet.email(userName),
	      "dob": faker.date.past(50, new Date("Sat Sep 20 1992 21:35:02 GMT+0200 (CEST)")),
	      "phone": faker.phone.phoneNumber(),
	      "address": {
	          "street": faker.address.streetName(true),
	          "suite": faker.address.secondaryAddress(),
	          "city": faker.address.city(),
	          "zipcode": faker.address.zipCode(),
	          "geo": {
	              "lat": faker.address.latitude(),
	              "lng": faker.address.longitude()
	          }
	      },
	      "website": faker.internet.domainName(),
	      "company": {
	          "name": faker.company.companyName(),
	          "catchPhrase": faker.company.catchPhrase(),
	          "bs": faker.company.bs()
	      }
	  };
	};
	
	
	exports.userCard = function () {
	    return {
	        "name": faker.name.findName(),
	        "username": faker.internet.userName(),
	        "email": faker.internet.email(),
	        "address": {
	            "street": faker.address.streetName(true),
	            "suite": faker.address.secondaryAddress(),
	            "city": faker.address.city(),
	            "zipcode": faker.address.zipCode(),
	            "geo": {
	                "lat": faker.address.latitude(),
	                "lng": faker.address.longitude()
	            }
	        },
	        "phone": faker.phone.phoneNumber(),
	        "website": faker.internet.domainName(),
	        "company": {
	            "name": faker.company.companyName(),
	            "catchPhrase": faker.company.catchPhrase(),
	            "bs": faker.company.bs()
	        }
	    };
	};
	
	exports.createTransaction = function(){
	  return {
	    "amount" : faker.finance.amount(),
	    "date" : new Date(2012, 1, 2),  //TODO: add a ranged date method
	    "business": faker.company.companyName(),
	    "name": [faker.finance.accountName(), faker.finance.mask()].join(' '),
	    "type" : exports.randomize(faker.definitions.finance.transaction_type),
	    "account" : faker.finance.account()
	  };
	};
	
	/*
	String.prototype.capitalize = function () { //v1.0
	    return this.replace(/\w+/g, function (a) {
	        return a.charAt(0).toUpperCase() + a.substr(1).toLowerCase();
	    });
	};
	*/
	


/***/ },
/* 55 */
/***/ function(module, exports, __webpack_require__) {

	var isNative = __webpack_require__(380);
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = object == null ? undefined : object[key];
	  return isNative(value) ? value : undefined;
	}
	
	module.exports = getNative;


/***/ },
/* 56 */
/***/ function(module, exports, __webpack_require__) {

	var isArrayLike = __webpack_require__(22),
	    isObjectLike = __webpack_require__(41);
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Native method references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/**
	 * Checks if `value` is classified as an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	function isArguments(value) {
	  return isObjectLike(value) && isArrayLike(value) &&
	    hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
	}
	
	module.exports = isArguments;


/***/ },
/* 57 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _classCallCheck = function (instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _inherits = function (subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) subClass.__proto__ = superClass; };
	
	var React = __webpack_require__(1);
	var invariant = __webpack_require__(2);
	var PropTypes = __webpack_require__(16);
	var RouteHandler = __webpack_require__(58);
	
	/**
	 * <Route> components specify components that are rendered to the page when the
	 * URL matches a given pattern.
	 *
	 * Routes are arranged in a nested tree structure. When a new URL is requested,
	 * the tree is searched depth-first to find a route whose path matches the URL.
	 * When one is found, all routes in the tree that lead to it are considered
	 * "active" and their components are rendered into the DOM, nested in the same
	 * order as they are in the tree.
	 *
	 * The preferred way to configure a router is using JSX. The XML-like syntax is
	 * a great way to visualize how routes are laid out in an application.
	 *
	 *   var routes = [
	 *     <Route handler={App}>
	 *       <Route name="login" handler={Login}/>
	 *       <Route name="logout" handler={Logout}/>
	 *       <Route name="about" handler={About}/>
	 *     </Route>
	 *   ];
	 *   
	 *   Router.run(routes, function (Handler) {
	 *     React.render(<Handler/>, document.body);
	 *   });
	 *
	 * Handlers for Route components that contain children can render their active
	 * child route using a <RouteHandler> element.
	 *
	 *   var App = React.createClass({
	 *     render: function () {
	 *       return (
	 *         <div class="application">
	 *           <RouteHandler/>
	 *         </div>
	 *       );
	 *     }
	 *   });
	 *
	 * If no handler is provided for the route, it will render a matched child route.
	 */
	
	var Route = (function (_React$Component) {
	  function Route() {
	    _classCallCheck(this, Route);
	
	    if (_React$Component != null) {
	      _React$Component.apply(this, arguments);
	    }
	  }
	
	  _inherits(Route, _React$Component);
	
	  _createClass(Route, [{
	    key: 'render',
	    value: function render() {
	      invariant(false, '%s elements are for router configuration only and should not be rendered', this.constructor.name);
	    }
	  }]);
	
	  return Route;
	})(React.Component);
	
	// TODO: Include these in the above class definition
	// once we can use ES7 property initializers.
	// https://github.com/babel/babel/issues/619
	
	Route.propTypes = {
	  name: PropTypes.string,
	  path: PropTypes.string,
	  handler: PropTypes.func,
	  ignoreScrollBehavior: PropTypes.bool
	};
	
	Route.defaultProps = {
	  handler: RouteHandler
	};
	
	module.exports = Route;

/***/ },
/* 58 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _classCallCheck = function (instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _inherits = function (subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) subClass.__proto__ = superClass; };
	
	var React = __webpack_require__(1);
	var ContextWrapper = __webpack_require__(392);
	var assign = __webpack_require__(5);
	var PropTypes = __webpack_require__(16);
	
	var REF_NAME = '__routeHandler__';
	
	/**
	 * A <RouteHandler> component renders the active child route handler
	 * when routes are nested.
	 */
	
	var RouteHandler = (function (_React$Component) {
	  function RouteHandler() {
	    _classCallCheck(this, RouteHandler);
	
	    if (_React$Component != null) {
	      _React$Component.apply(this, arguments);
	    }
	  }
	
	  _inherits(RouteHandler, _React$Component);
	
	  _createClass(RouteHandler, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      return {
	        routeDepth: this.context.routeDepth + 1
	      };
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this._updateRouteComponent(this.refs[REF_NAME]);
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this._updateRouteComponent(this.refs[REF_NAME]);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this._updateRouteComponent(null);
	    }
	  }, {
	    key: '_updateRouteComponent',
	    value: function _updateRouteComponent(component) {
	      this.context.router.setRouteComponentAtDepth(this.getRouteDepth(), component);
	    }
	  }, {
	    key: 'getRouteDepth',
	    value: function getRouteDepth() {
	      return this.context.routeDepth;
	    }
	  }, {
	    key: 'createChildRouteHandler',
	    value: function createChildRouteHandler(props) {
	      var route = this.context.router.getRouteAtDepth(this.getRouteDepth());
	
	      if (route == null) {
	        return null;
	      }var childProps = assign({}, props || this.props, {
	        ref: REF_NAME,
	        params: this.context.router.getCurrentParams(),
	        query: this.context.router.getCurrentQuery()
	      });
	
	      return React.createElement(route.handler, childProps);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var handler = this.createChildRouteHandler();
	      // <script/> for things like <CSSTransitionGroup/> that don't like null
	      return handler ? React.createElement(
	        ContextWrapper,
	        null,
	        handler
	      ) : React.createElement('script', null);
	    }
	  }]);
	
	  return RouteHandler;
	})(React.Component);
	
	// TODO: Include these in the above class definition
	// once we can use ES7 property initializers.
	// https://github.com/babel/babel/issues/619
	
	RouteHandler.contextTypes = {
	  routeDepth: PropTypes.number.isRequired,
	  router: PropTypes.router.isRequired
	};
	
	RouteHandler.childContextTypes = {
	  routeDepth: PropTypes.number.isRequired
	};
	
	module.exports = RouteHandler;

/***/ },
/* 59 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule AutoFocusMixin
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var focusNode = __webpack_require__(157);
	
	var AutoFocusMixin = {
	  componentDidMount: function() {
	    if (this.props.autoFocus) {
	      focusNode(this.getDOMNode());
	    }
	  }
	};
	
	module.exports = AutoFocusMixin;


/***/ },
/* 60 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	* @providesModule ReactFragment
	*/
	
	'use strict';
	
	var ReactElement = __webpack_require__(7);
	
	var warning = __webpack_require__(6);
	
	/**
	 * We used to allow keyed objects to serve as a collection of ReactElements,
	 * or nested sets. This allowed us a way to explicitly key a set a fragment of
	 * components. This is now being replaced with an opaque data structure.
	 * The upgrade path is to call React.addons.createFragment({ key: value }) to
	 * create a keyed fragment. The resulting data structure is opaque, for now.
	 */
	
	if (false) {
	  var fragmentKey = '_reactFragment';
	  var didWarnKey = '_reactDidWarn';
	  var canWarnForReactFragment = false;
	
	  try {
	    // Feature test. Don't even try to issue this warning if we can't use
	    // enumerable: false.
	
	    var dummy = function() {
	      return 1;
	    };
	
	    Object.defineProperty(
	      {},
	      fragmentKey,
	      {enumerable: false, value: true}
	    );
	
	    Object.defineProperty(
	      {},
	      'key',
	      {enumerable: true, get: dummy}
	    );
	
	    canWarnForReactFragment = true;
	  } catch (x) { }
	
	  var proxyPropertyAccessWithWarning = function(obj, key) {
	    Object.defineProperty(obj, key, {
	      enumerable: true,
	      get: function() {
	        ("production" !== process.env.NODE_ENV ? warning(
	          this[didWarnKey],
	          'A ReactFragment is an opaque type. Accessing any of its ' +
	          'properties is deprecated. Pass it to one of the React.Children ' +
	          'helpers.'
	        ) : null);
	        this[didWarnKey] = true;
	        return this[fragmentKey][key];
	      },
	      set: function(value) {
	        ("production" !== process.env.NODE_ENV ? warning(
	          this[didWarnKey],
	          'A ReactFragment is an immutable opaque type. Mutating its ' +
	          'properties is deprecated.'
	        ) : null);
	        this[didWarnKey] = true;
	        this[fragmentKey][key] = value;
	      }
	    });
	  };
	
	  var issuedWarnings = {};
	
	  var didWarnForFragment = function(fragment) {
	    // We use the keys and the type of the value as a heuristic to dedupe the
	    // warning to avoid spamming too much.
	    var fragmentCacheKey = '';
	    for (var key in fragment) {
	      fragmentCacheKey += key + ':' + (typeof fragment[key]) + ',';
	    }
	    var alreadyWarnedOnce = !!issuedWarnings[fragmentCacheKey];
	    issuedWarnings[fragmentCacheKey] = true;
	    return alreadyWarnedOnce;
	  };
	}
	
	var ReactFragment = {
	  // Wrap a keyed object in an opaque proxy that warns you if you access any
	  // of its properties.
	  create: function(object) {
	    if (false) {
	      if (typeof object !== 'object' || !object || Array.isArray(object)) {
	        ("production" !== process.env.NODE_ENV ? warning(
	          false,
	          'React.addons.createFragment only accepts a single object.',
	          object
	        ) : null);
	        return object;
	      }
	      if (ReactElement.isValidElement(object)) {
	        ("production" !== process.env.NODE_ENV ? warning(
	          false,
	          'React.addons.createFragment does not accept a ReactElement ' +
	          'without a wrapper object.'
	        ) : null);
	        return object;
	      }
	      if (canWarnForReactFragment) {
	        var proxy = {};
	        Object.defineProperty(proxy, fragmentKey, {
	          enumerable: false,
	          value: object
	        });
	        Object.defineProperty(proxy, didWarnKey, {
	          writable: true,
	          enumerable: false,
	          value: false
	        });
	        for (var key in object) {
	          proxyPropertyAccessWithWarning(proxy, key);
	        }
	        Object.preventExtensions(proxy);
	        return proxy;
	      }
	    }
	    return object;
	  },
	  // Extract the original keyed object from the fragment opaque type. Warn if
	  // a plain object is passed here.
	  extract: function(fragment) {
	    if (false) {
	      if (canWarnForReactFragment) {
	        if (!fragment[fragmentKey]) {
	          ("production" !== process.env.NODE_ENV ? warning(
	            didWarnForFragment(fragment),
	            'Any use of a keyed object should be wrapped in ' +
	            'React.addons.createFragment(object) before being passed as a ' +
	            'child.'
	          ) : null);
	          return fragment;
	        }
	        return fragment[fragmentKey];
	      }
	    }
	    return fragment;
	  },
	  // Check if this is a fragment and if so, extract the keyed object. If it
	  // is a fragment-like object, warn that it should be wrapped. Ignore if we
	  // can't determine what kind of object this is.
	  extractIfFragment: function(fragment) {
	    if (false) {
	      if (canWarnForReactFragment) {
	        // If it is the opaque type, return the keyed object.
	        if (fragment[fragmentKey]) {
	          return fragment[fragmentKey];
	        }
	        // Otherwise, check each property if it has an element, if it does
	        // it is probably meant as a fragment, so we can warn early. Defer,
	        // the warning to extract.
	        for (var key in fragment) {
	          if (fragment.hasOwnProperty(key) &&
	              ReactElement.isValidElement(fragment[key])) {
	            // This looks like a fragment object, we should provide an
	            // early warning.
	            return ReactFragment.extract(fragment);
	          }
	        }
	      }
	    }
	    return fragment;
	  }
	};
	
	module.exports = ReactFragment;


/***/ },
/* 61 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactNativeComponent
	 */
	
	'use strict';
	
	var assign = __webpack_require__(5);
	var invariant = __webpack_require__(2);
	
	var autoGenerateWrapperClass = null;
	var genericComponentClass = null;
	// This registry keeps track of wrapper classes around native tags
	var tagToComponentClass = {};
	var textComponentClass = null;
	
	var ReactNativeComponentInjection = {
	  // This accepts a class that receives the tag string. This is a catch all
	  // that can render any kind of tag.
	  injectGenericComponentClass: function(componentClass) {
	    genericComponentClass = componentClass;
	  },
	  // This accepts a text component class that takes the text string to be
	  // rendered as props.
	  injectTextComponentClass: function(componentClass) {
	    textComponentClass = componentClass;
	  },
	  // This accepts a keyed object with classes as values. Each key represents a
	  // tag. That particular tag will use this class instead of the generic one.
	  injectComponentClasses: function(componentClasses) {
	    assign(tagToComponentClass, componentClasses);
	  },
	  // Temporary hack since we expect DOM refs to behave like composites,
	  // for this release.
	  injectAutoWrapper: function(wrapperFactory) {
	    autoGenerateWrapperClass = wrapperFactory;
	  }
	};
	
	/**
	 * Get a composite component wrapper class for a specific tag.
	 *
	 * @param {ReactElement} element The tag for which to get the class.
	 * @return {function} The React class constructor function.
	 */
	function getComponentClassForElement(element) {
	  if (typeof element.type === 'function') {
	    return element.type;
	  }
	  var tag = element.type;
	  var componentClass = tagToComponentClass[tag];
	  if (componentClass == null) {
	    tagToComponentClass[tag] = componentClass = autoGenerateWrapperClass(tag);
	  }
	  return componentClass;
	}
	
	/**
	 * Get a native internal component class for a specific tag.
	 *
	 * @param {ReactElement} element The element to create.
	 * @return {function} The internal class constructor function.
	 */
	function createInternalComponent(element) {
	  ( false ? invariant(
	    genericComponentClass,
	    'There is no registered component for the tag %s',
	    element.type
	  ) : invariant(genericComponentClass));
	  return new genericComponentClass(element.type, element.props);
	}
	
	/**
	 * @param {ReactText} text
	 * @return {ReactComponent}
	 */
	function createInstanceForText(text) {
	  return new textComponentClass(text);
	}
	
	/**
	 * @param {ReactComponent} component
	 * @return {boolean}
	 */
	function isTextComponent(component) {
	  return component instanceof textComponentClass;
	}
	
	var ReactNativeComponent = {
	  getComponentClassForElement: getComponentClassForElement,
	  createInternalComponent: createInternalComponent,
	  createInstanceForText: createInstanceForText,
	  isTextComponent: isTextComponent,
	  injection: ReactNativeComponentInjection
	};
	
	module.exports = ReactNativeComponent;


/***/ },
/* 62 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactPropTypeLocationNames
	 */
	
	'use strict';
	
	var ReactPropTypeLocationNames = {};
	
	if (false) {
	  ReactPropTypeLocationNames = {
	    prop: 'prop',
	    context: 'context',
	    childContext: 'child context'
	  };
	}
	
	module.exports = ReactPropTypeLocationNames;


/***/ },
/* 63 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticMouseEvent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(47);
	var ViewportMetrics = __webpack_require__(154);
	
	var getEventModifierState = __webpack_require__(97);
	
	/**
	 * @interface MouseEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var MouseEventInterface = {
	  screenX: null,
	  screenY: null,
	  clientX: null,
	  clientY: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  getModifierState: getEventModifierState,
	  button: function(event) {
	    // Webkit, Firefox, IE9+
	    // which:  1 2 3
	    // button: 0 1 2 (standard)
	    var button = event.button;
	    if ('which' in event) {
	      return button;
	    }
	    // IE<9
	    // which:  undefined
	    // button: 0 0 0
	    // button: 1 4 2 (onmouseup)
	    return button === 2 ? 2 : button === 4 ? 1 : 0;
	  },
	  buttons: null,
	  relatedTarget: function(event) {
	    return event.relatedTarget || (
	      ((event.fromElement === event.srcElement ? event.toElement : event.fromElement))
	    );
	  },
	  // "Proprietary" Interface.
	  pageX: function(event) {
	    return 'pageX' in event ?
	      event.pageX :
	      event.clientX + ViewportMetrics.currentScrollLeft;
	  },
	  pageY: function(event) {
	    return 'pageY' in event ?
	      event.pageY :
	      event.clientY + ViewportMetrics.currentScrollTop;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticMouseEvent(dispatchConfig, dispatchMarker, nativeEvent) {
	  SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticMouseEvent, MouseEventInterface);
	
	module.exports = SyntheticMouseEvent;


/***/ },
/* 64 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule Transaction
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(2);
	
	/**
	 * `Transaction` creates a black box that is able to wrap any method such that
	 * certain invariants are maintained before and after the method is invoked
	 * (Even if an exception is thrown while invoking the wrapped method). Whoever
	 * instantiates a transaction can provide enforcers of the invariants at
	 * creation time. The `Transaction` class itself will supply one additional
	 * automatic invariant for you - the invariant that any transaction instance
	 * should not be run while it is already being run. You would typically create a
	 * single instance of a `Transaction` for reuse multiple times, that potentially
	 * is used to wrap several different methods. Wrappers are extremely simple -
	 * they only require implementing two methods.
	 *
	 * <pre>
	 *                       wrappers (injected at creation time)
	 *                                      +        +
	 *                                      |        |
	 *                    +-----------------|--------|--------------+
	 *                    |                 v        |              |
	 *                    |      +---------------+   |              |
	 *                    |   +--|    wrapper1   |---|----+         |
	 *                    |   |  +---------------+   v    |         |
	 *                    |   |          +-------------+  |         |
	 *                    |   |     +----|   wrapper2  |--------+   |
	 *                    |   |     |    +-------------+  |     |   |
	 *                    |   |     |                     |     |   |
	 *                    |   v     v                     v     v   | wrapper
	 *                    | +---+ +---+   +---------+   +---+ +---+ | invariants
	 * perform(anyMethod) | |   | |   |   |         |   |   | |   | | maintained
	 * +----------------->|-|---|-|---|-->|anyMethod|---|---|-|---|-|-------->
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | +---+ +---+   +---------+   +---+ +---+ |
	 *                    |  initialize                    close    |
	 *                    +-----------------------------------------+
	 * </pre>
	 *
	 * Use cases:
	 * - Preserving the input selection ranges before/after reconciliation.
	 *   Restoring selection even in the event of an unexpected error.
	 * - Deactivating events while rearranging the DOM, preventing blurs/focuses,
	 *   while guaranteeing that afterwards, the event system is reactivated.
	 * - Flushing a queue of collected DOM mutations to the main UI thread after a
	 *   reconciliation takes place in a worker thread.
	 * - Invoking any collected `componentDidUpdate` callbacks after rendering new
	 *   content.
	 * - (Future use case): Wrapping particular flushes of the `ReactWorker` queue
	 *   to preserve the `scrollTop` (an automatic scroll aware DOM).
	 * - (Future use case): Layout calculations before and after DOM updates.
	 *
	 * Transactional plugin API:
	 * - A module that has an `initialize` method that returns any precomputation.
	 * - and a `close` method that accepts the precomputation. `close` is invoked
	 *   when the wrapped process is completed, or has failed.
	 *
	 * @param {Array<TransactionalWrapper>} transactionWrapper Wrapper modules
	 * that implement `initialize` and `close`.
	 * @return {Transaction} Single transaction for reuse in thread.
	 *
	 * @class Transaction
	 */
	var Mixin = {
	  /**
	   * Sets up this instance so that it is prepared for collecting metrics. Does
	   * so such that this setup method may be used on an instance that is already
	   * initialized, in a way that does not consume additional memory upon reuse.
	   * That can be useful if you decide to make your subclass of this mixin a
	   * "PooledClass".
	   */
	  reinitializeTransaction: function() {
	    this.transactionWrappers = this.getTransactionWrappers();
	    if (!this.wrapperInitData) {
	      this.wrapperInitData = [];
	    } else {
	      this.wrapperInitData.length = 0;
	    }
	    this._isInTransaction = false;
	  },
	
	  _isInTransaction: false,
	
	  /**
	   * @abstract
	   * @return {Array<TransactionWrapper>} Array of transaction wrappers.
	   */
	  getTransactionWrappers: null,
	
	  isInTransaction: function() {
	    return !!this._isInTransaction;
	  },
	
	  /**
	   * Executes the function within a safety window. Use this for the top level
	   * methods that result in large amounts of computation/mutations that would
	   * need to be safety checked.
	   *
	   * @param {function} method Member of scope to call.
	   * @param {Object} scope Scope to invoke from.
	   * @param {Object?=} args... Arguments to pass to the method (optional).
	   *                           Helps prevent need to bind in many cases.
	   * @return Return value from `method`.
	   */
	  perform: function(method, scope, a, b, c, d, e, f) {
	    ( false ? invariant(
	      !this.isInTransaction(),
	      'Transaction.perform(...): Cannot initialize a transaction when there ' +
	      'is already an outstanding transaction.'
	    ) : invariant(!this.isInTransaction()));
	    var errorThrown;
	    var ret;
	    try {
	      this._isInTransaction = true;
	      // Catching errors makes debugging more difficult, so we start with
	      // errorThrown set to true before setting it to false after calling
	      // close -- if it's still set to true in the finally block, it means
	      // one of these calls threw.
	      errorThrown = true;
	      this.initializeAll(0);
	      ret = method.call(scope, a, b, c, d, e, f);
	      errorThrown = false;
	    } finally {
	      try {
	        if (errorThrown) {
	          // If `method` throws, prefer to show that stack trace over any thrown
	          // by invoking `closeAll`.
	          try {
	            this.closeAll(0);
	          } catch (err) {
	          }
	        } else {
	          // Since `method` didn't throw, we don't want to silence the exception
	          // here.
	          this.closeAll(0);
	        }
	      } finally {
	        this._isInTransaction = false;
	      }
	    }
	    return ret;
	  },
	
	  initializeAll: function(startIndex) {
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      try {
	        // Catching errors makes debugging more difficult, so we start with the
	        // OBSERVED_ERROR state before overwriting it with the real return value
	        // of initialize -- if it's still set to OBSERVED_ERROR in the finally
	        // block, it means wrapper.initialize threw.
	        this.wrapperInitData[i] = Transaction.OBSERVED_ERROR;
	        this.wrapperInitData[i] = wrapper.initialize ?
	          wrapper.initialize.call(this) :
	          null;
	      } finally {
	        if (this.wrapperInitData[i] === Transaction.OBSERVED_ERROR) {
	          // The initializer for wrapper i threw an error; initialize the
	          // remaining wrappers but silence any exceptions from them to ensure
	          // that the first error is the one to bubble up.
	          try {
	            this.initializeAll(i + 1);
	          } catch (err) {
	          }
	        }
	      }
	    }
	  },
	
	  /**
	   * Invokes each of `this.transactionWrappers.close[i]` functions, passing into
	   * them the respective return values of `this.transactionWrappers.init[i]`
	   * (`close`rs that correspond to initializers that failed will not be
	   * invoked).
	   */
	  closeAll: function(startIndex) {
	    ( false ? invariant(
	      this.isInTransaction(),
	      'Transaction.closeAll(): Cannot close transaction when none are open.'
	    ) : invariant(this.isInTransaction()));
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      var initData = this.wrapperInitData[i];
	      var errorThrown;
	      try {
	        // Catching errors makes debugging more difficult, so we start with
	        // errorThrown set to true before setting it to false after calling
	        // close -- if it's still set to true in the finally block, it means
	        // wrapper.close threw.
	        errorThrown = true;
	        if (initData !== Transaction.OBSERVED_ERROR && wrapper.close) {
	          wrapper.close.call(this, initData);
	        }
	        errorThrown = false;
	      } finally {
	        if (errorThrown) {
	          // The closer for wrapper i threw an error; close the remaining
	          // wrappers but silence any exceptions from them to ensure that the
	          // first error is the one to bubble up.
	          try {
	            this.closeAll(i + 1);
	          } catch (e) {
	          }
	        }
	      }
	    }
	    this.wrapperInitData.length = 0;
	  }
	};
	
	var Transaction = {
	
	  Mixin: Mixin,
	
	  /**
	   * Token to look for to determine if an error occured.
	   */
	  OBSERVED_ERROR: {}
	
	};
	
	module.exports = Transaction;


/***/ },
/* 65 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule emptyObject
	 */
	
	"use strict";
	
	var emptyObject = {};
	
	if (false) {
	  Object.freeze(emptyObject);
	}
	
	module.exports = emptyObject;


/***/ },
/* 66 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule escapeTextContentForBrowser
	 */
	
	'use strict';
	
	var ESCAPE_LOOKUP = {
	  '&': '&amp;',
	  '>': '&gt;',
	  '<': '&lt;',
	  '"': '&quot;',
	  '\'': '&#x27;'
	};
	
	var ESCAPE_REGEX = /[&><"']/g;
	
	function escaper(match) {
	  return ESCAPE_LOOKUP[match];
	}
	
	/**
	 * Escapes text to prevent scripting attacks.
	 *
	 * @param {*} text Text value to escape.
	 * @return {string} An escaped string.
	 */
	function escapeTextContentForBrowser(text) {
	  return ('' + text).replace(ESCAPE_REGEX, escaper);
	}
	
	module.exports = escapeTextContentForBrowser;


/***/ },
/* 67 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = {
	  BOX: 'box'
	};
	module.exports = exports['default'];

/***/ },
/* 68 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = {
	  YELLOW: 'yellow',
	  BLUE: 'blue'
	};
	module.exports = exports['default'];

/***/ },
/* 69 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = {
	  CARD: 'card'
	};
	module.exports = exports['default'];

/***/ },
/* 70 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _NavBar = __webpack_require__(230);
	
	var _NavBar2 = _interopRequireDefault(_NavBar);
	
	var _Cover = __webpack_require__(229);
	
	var _Cover2 = _interopRequireDefault(_Cover);
	
	__webpack_require__(280);
	
	var Header = (function () {
	  function Header() {
	    _classCallCheck(this, Header);
	  }
	
	  Header.prototype.render = function render() {
	    return _react2['default'].createElement(
	      'header',
	      { className: 'Header' },
	      _react2['default'].createElement(_NavBar2['default'], null)
	    );
	  };
	
	  return Header;
	})();
	
	exports['default'] = Header;
	module.exports = exports['default'];

/***/ },
/* 71 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(282);
	
	var PageBody = (function () {
	  function PageBody() {
	    _classCallCheck(this, PageBody);
	  }
	
	  PageBody.prototype.render = function render() {
	    var _props = this.props;
	    var hasSidebar = _props.hasSidebar;
	    var html = _props.html;
	
	    var props = _objectWithoutProperties(_props, ['hasSidebar', 'html']);
	
	    return _react2['default'].createElement(
	      'div',
	      { className: 'PageBody ' + (hasSidebar ? 'PageBody--hasSidebar' : '') },
	      _react2['default'].createElement(
	        'div',
	        { className: 'PageBody-container' },
	        this.props.children
	      )
	    );
	  };
	
	  _createClass(PageBody, null, [{
	    key: 'propTypes',
	    value: {
	      hasSidebar: _react2['default'].PropTypes.bool
	    },
	    enumerable: true
	  }]);
	
	  return PageBody;
	})();
	
	exports['default'] = PageBody;
	module.exports = exports['default'];

/***/ },
/* 72 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _CodeBlock = __webpack_require__(228);
	
	var _CodeBlock2 = _interopRequireDefault(_CodeBlock);
	
	var StaticHTMLBlock = (function () {
	  function StaticHTMLBlock() {
	    _classCallCheck(this, StaticHTMLBlock);
	  }
	
	  StaticHTMLBlock.prototype.render = function render() {
	    var html = this.props.html;
	
	    // Here goes a really hack-ish way to convert
	    // areas separated by Markdown <hr>s into code tabs.
	
	    var blocks = html.split('<hr/>');
	    var elements = [];
	
	    var es5Content = null;
	    var es6Content = null;
	    var es7Content = null;
	
	    for (var i = 0; i < blocks.length; i++) {
	      var content = blocks[i];
	
	      switch (i % 4) {
	        case 0:
	          elements.push(_react2['default'].createElement('div', { key: i,
	            style: { width: '100%' },
	            dangerouslySetInnerHTML: { __html: content } }));
	          break;
	        case 1:
	          es5Content = content;
	          break;
	        case 2:
	          es6Content = content;
	          break;
	        case 3:
	          es7Content = content;
	          elements.push(_react2['default'].createElement(_CodeBlock2['default'], { key: i,
	            es5: es5Content,
	            es6: es6Content,
	            es7: es7Content }));
	          break;
	      }
	    }
	
	    return _react2['default'].createElement(
	      'div',
	      { style: { width: '100%' } },
	      elements
	    );
	  };
	
	  _createClass(StaticHTMLBlock, null, [{
	    key: 'propTypes',
	    value: {
	      html: _react2['default'].PropTypes.string.isRequired
	    },
	    enumerable: true
	  }]);
	
	  return StaticHTMLBlock;
	})();
	
	exports['default'] = StaticHTMLBlock;
	module.exports = exports['default'];

/***/ },
/* 73 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireWildcard = function (obj) { return obj && obj.__esModule ? obj : { 'default': obj }; };
	
	exports.__esModule = true;
	
	var _isDisposable2 = __webpack_require__(74);
	
	var _isDisposable3 = _interopRequireWildcard(_isDisposable2);
	
	exports.isDisposable = _isDisposable3['default'];
	
	var _Disposable2 = __webpack_require__(253);
	
	var _Disposable3 = _interopRequireWildcard(_Disposable2);
	
	exports.Disposable = _Disposable3['default'];
	
	var _CompositeDisposable2 = __webpack_require__(252);
	
	var _CompositeDisposable3 = _interopRequireWildcard(_CompositeDisposable2);
	
	exports.CompositeDisposable = _CompositeDisposable3['default'];
	
	var _SerialDisposable2 = __webpack_require__(254);
	
	var _SerialDisposable3 = _interopRequireWildcard(_SerialDisposable2);
	
	exports.SerialDisposable = _SerialDisposable3['default'];

/***/ },
/* 74 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = isDisposable;
	
	function isDisposable(obj) {
	  return Boolean(obj && typeof obj.dispose === 'function');
	}
	
	module.exports = exports['default'];

/***/ },
/* 75 */
/***/ function(module, exports, __webpack_require__) {

	var indexOfNaN = __webpack_require__(371);
	
	/**
	 * The base implementation of `_.indexOf` without support for binary searches.
	 *
	 * @private
	 * @param {Array} array The array to search.
	 * @param {*} value The value to search for.
	 * @param {number} fromIndex The index to search from.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseIndexOf(array, value, fromIndex) {
	  if (value !== value) {
	    return indexOfNaN(array, fromIndex);
	  }
	  var index = fromIndex - 1,
	      length = array.length;
	
	  while (++index < length) {
	    if (array[index] === value) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	module.exports = baseIndexOf;


/***/ },
/* 76 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(15);
	
	/**
	 * Checks if `value` is in `cache` mimicking the return signature of
	 * `_.indexOf` by returning `0` if the value is found, else `-1`.
	 *
	 * @private
	 * @param {Object} cache The cache to search.
	 * @param {*} value The value to search for.
	 * @returns {number} Returns `0` if `value` is found, else `-1`.
	 */
	function cacheIndexOf(cache, value) {
	  var data = cache.data,
	      result = (typeof value == 'string' || isObject(value)) ? data.set.has(value) : data.hash[value];
	
	  return result ? 0 : -1;
	}
	
	module.exports = cacheIndexOf;


/***/ },
/* 77 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var SetCache = __webpack_require__(354),
	    getNative = __webpack_require__(55);
	
	/** Native method references. */
	var Set = getNative(global, 'Set');
	
	/* Native method references for those with the same name as other `lodash` methods. */
	var nativeCreate = getNative(Object, 'create');
	
	/**
	 * Creates a `Set` cache object to optimize linear searches of large arrays.
	 *
	 * @private
	 * @param {Array} [values] The values to cache.
	 * @returns {null|Object} Returns the new cache object if `Set` is supported, else `null`.
	 */
	function createCache(values) {
	  return (nativeCreate && Set) ? new SetCache(values) : null;
	}
	
	module.exports = createCache;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 78 */
/***/ function(module, exports) {

	/** Used to detect unsigned integer values. */
	var reIsUint = /^\d+$/;
	
	/**
	 * Used as the [maximum length](http://ecma-international.org/ecma-262/6.0/#sec-number.max_safe_integer)
	 * of an array-like value.
	 */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  value = (typeof value == 'number' || reIsUint.test(value)) ? +value : -1;
	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return value > -1 && value % 1 == 0 && value < length;
	}
	
	module.exports = isIndex;


/***/ },
/* 79 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(55),
	    isArrayLike = __webpack_require__(22),
	    isObject = __webpack_require__(15),
	    shimKeys = __webpack_require__(376);
	
	/* Native method references for those with the same name as other `lodash` methods. */
	var nativeKeys = getNative(Object, 'keys');
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/6.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	var keys = !nativeKeys ? shimKeys : function(object) {
	  var Ctor = object == null ? undefined : object.constructor;
	  if ((typeof Ctor == 'function' && Ctor.prototype === object) ||
	      (typeof object != 'function' && isArrayLike(object))) {
	    return shimKeys(object);
	  }
	  return isObject(object) ? nativeKeys(object) : [];
	};
	
	module.exports = keys;


/***/ },
/* 80 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var invariant = __webpack_require__(2);
	var assign = __webpack_require__(400);
	var qs = __webpack_require__(401);
	
	var paramCompileMatcher = /:([a-zA-Z_$][a-zA-Z0-9_$]*)|[*.()\[\]\\+|{}^$]/g;
	var paramInjectMatcher = /:([a-zA-Z_$][a-zA-Z0-9_$?]*[?]?)|[*]/g;
	var paramInjectTrailingSlashMatcher = /\/\/\?|\/\?\/|\/\?/g;
	var queryMatcher = /\?(.*)$/;
	
	var _compiledPatterns = {};
	
	function compilePattern(pattern) {
	  if (!(pattern in _compiledPatterns)) {
	    var paramNames = [];
	    var source = pattern.replace(paramCompileMatcher, function (match, paramName) {
	      if (paramName) {
	        paramNames.push(paramName);
	        return '([^/?#]+)';
	      } else if (match === '*') {
	        paramNames.push('splat');
	        return '(.*?)';
	      } else {
	        return '\\' + match;
	      }
	    });
	
	    _compiledPatterns[pattern] = {
	      matcher: new RegExp('^' + source + '$', 'i'),
	      paramNames: paramNames
	    };
	  }
	
	  return _compiledPatterns[pattern];
	}
	
	var PathUtils = {
	
	  /**
	   * Returns true if the given path is absolute.
	   */
	  isAbsolute: function isAbsolute(path) {
	    return path.charAt(0) === '/';
	  },
	
	  /**
	   * Joins two URL paths together.
	   */
	  join: function join(a, b) {
	    return a.replace(/\/*$/, '/') + b;
	  },
	
	  /**
	   * Returns an array of the names of all parameters in the given pattern.
	   */
	  extractParamNames: function extractParamNames(pattern) {
	    return compilePattern(pattern).paramNames;
	  },
	
	  /**
	   * Extracts the portions of the given URL path that match the given pattern
	   * and returns an object of param name => value pairs. Returns null if the
	   * pattern does not match the given path.
	   */
	  extractParams: function extractParams(pattern, path) {
	    var _compilePattern = compilePattern(pattern);
	
	    var matcher = _compilePattern.matcher;
	    var paramNames = _compilePattern.paramNames;
	
	    var match = path.match(matcher);
	
	    if (!match) {
	      return null;
	    }var params = {};
	
	    paramNames.forEach(function (paramName, index) {
	      params[paramName] = match[index + 1];
	    });
	
	    return params;
	  },
	
	  /**
	   * Returns a version of the given route path with params interpolated. Throws
	   * if there is a dynamic segment of the route path for which there is no param.
	   */
	  injectParams: function injectParams(pattern, params) {
	    params = params || {};
	
	    var splatIndex = 0;
	
	    return pattern.replace(paramInjectMatcher, function (match, paramName) {
	      paramName = paramName || 'splat';
	
	      // If param is optional don't check for existence
	      if (paramName.slice(-1) === '?') {
	        paramName = paramName.slice(0, -1);
	
	        if (params[paramName] == null) return '';
	      } else {
	        invariant(params[paramName] != null, 'Missing "%s" parameter for path "%s"', paramName, pattern);
	      }
	
	      var segment;
	      if (paramName === 'splat' && Array.isArray(params[paramName])) {
	        segment = params[paramName][splatIndex++];
	
	        invariant(segment != null, 'Missing splat # %s for path "%s"', splatIndex, pattern);
	      } else {
	        segment = params[paramName];
	      }
	
	      return segment;
	    }).replace(paramInjectTrailingSlashMatcher, '/');
	  },
	
	  /**
	   * Returns an object that is the result of parsing any query string contained
	   * in the given path, null if the path contains no query string.
	   */
	  extractQuery: function extractQuery(path) {
	    var match = path.match(queryMatcher);
	    return match && qs.parse(match[1]);
	  },
	
	  /**
	   * Returns a version of the given path without the query string.
	   */
	  withoutQuery: function withoutQuery(path) {
	    return path.replace(queryMatcher, '');
	  },
	
	  /**
	   * Returns a version of the given path with the parameters in the given
	   * query merged into the query string.
	   */
	  withQuery: function withQuery(path, query) {
	    var existingQuery = PathUtils.extractQuery(path);
	
	    if (existingQuery) query = query ? assign(existingQuery, query) : existingQuery;
	
	    var queryString = qs.stringify(query, { arrayFormat: 'brackets' });
	
	    if (queryString) {
	      return PathUtils.withoutQuery(path) + '?' + queryString;
	    }return PathUtils.withoutQuery(path);
	  }
	
	};
	
	module.exports = PathUtils;

/***/ },
/* 81 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var LocationActions = __webpack_require__(42);
	var History = __webpack_require__(32);
	
	var _listeners = [];
	var _isListening = false;
	
	function notifyChange(type) {
	  var change = {
	    path: HistoryLocation.getCurrentPath(),
	    type: type
	  };
	
	  _listeners.forEach(function (listener) {
	    listener.call(HistoryLocation, change);
	  });
	}
	
	function onPopState(event) {
	  if (event.state === undefined) {
	    return;
	  } // Ignore extraneous popstate events in WebKit.
	
	  notifyChange(LocationActions.POP);
	}
	
	/**
	 * A Location that uses HTML5 history.
	 */
	var HistoryLocation = {
	
	  addChangeListener: function addChangeListener(listener) {
	    _listeners.push(listener);
	
	    if (!_isListening) {
	      if (window.addEventListener) {
	        window.addEventListener('popstate', onPopState, false);
	      } else {
	        window.attachEvent('onpopstate', onPopState);
	      }
	
	      _isListening = true;
	    }
	  },
	
	  removeChangeListener: function removeChangeListener(listener) {
	    _listeners = _listeners.filter(function (l) {
	      return l !== listener;
	    });
	
	    if (_listeners.length === 0) {
	      if (window.addEventListener) {
	        window.removeEventListener('popstate', onPopState, false);
	      } else {
	        window.removeEvent('onpopstate', onPopState);
	      }
	
	      _isListening = false;
	    }
	  },
	
	  push: function push(path) {
	    window.history.pushState({ path: path }, '', path);
	    History.length += 1;
	    notifyChange(LocationActions.PUSH);
	  },
	
	  replace: function replace(path) {
	    window.history.replaceState({ path: path }, '', path);
	    notifyChange(LocationActions.REPLACE);
	  },
	
	  pop: History.back,
	
	  getCurrentPath: function getCurrentPath() {
	    return decodeURI(window.location.pathname + window.location.search);
	  },
	
	  toString: function toString() {
	    return '<HistoryLocation>';
	  }
	
	};
	
	module.exports = HistoryLocation;

/***/ },
/* 82 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule CallbackQueue
	 */
	
	'use strict';
	
	var PooledClass = __webpack_require__(17);
	
	var assign = __webpack_require__(5);
	var invariant = __webpack_require__(2);
	
	/**
	 * A specialized pseudo-event module to help keep track of components waiting to
	 * be notified when their DOM representations are available for use.
	 *
	 * This implements `PooledClass`, so you should never need to instantiate this.
	 * Instead, use `CallbackQueue.getPooled()`.
	 *
	 * @class ReactMountReady
	 * @implements PooledClass
	 * @internal
	 */
	function CallbackQueue() {
	  this._callbacks = null;
	  this._contexts = null;
	}
	
	assign(CallbackQueue.prototype, {
	
	  /**
	   * Enqueues a callback to be invoked when `notifyAll` is invoked.
	   *
	   * @param {function} callback Invoked when `notifyAll` is invoked.
	   * @param {?object} context Context to call `callback` with.
	   * @internal
	   */
	  enqueue: function(callback, context) {
	    this._callbacks = this._callbacks || [];
	    this._contexts = this._contexts || [];
	    this._callbacks.push(callback);
	    this._contexts.push(context);
	  },
	
	  /**
	   * Invokes all enqueued callbacks and clears the queue. This is invoked after
	   * the DOM representation of a component has been created or updated.
	   *
	   * @internal
	   */
	  notifyAll: function() {
	    var callbacks = this._callbacks;
	    var contexts = this._contexts;
	    if (callbacks) {
	      ( false ? invariant(
	        callbacks.length === contexts.length,
	        'Mismatched list of contexts in callback queue'
	      ) : invariant(callbacks.length === contexts.length));
	      this._callbacks = null;
	      this._contexts = null;
	      for (var i = 0, l = callbacks.length; i < l; i++) {
	        callbacks[i].call(contexts[i]);
	      }
	      callbacks.length = 0;
	      contexts.length = 0;
	    }
	  },
	
	  /**
	   * Resets the internal queue.
	   *
	   * @internal
	   */
	  reset: function() {
	    this._callbacks = null;
	    this._contexts = null;
	  },
	
	  /**
	   * `PooledClass` looks for this.
	   */
	  destructor: function() {
	    this.reset();
	  }
	
	});
	
	PooledClass.addPoolingTo(CallbackQueue);
	
	module.exports = CallbackQueue;


/***/ },
/* 83 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EventPluginUtils
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(12);
	
	var invariant = __webpack_require__(2);
	
	/**
	 * Injected dependencies:
	 */
	
	/**
	 * - `Mount`: [required] Module that can convert between React dom IDs and
	 *   actual node references.
	 */
	var injection = {
	  Mount: null,
	  injectMount: function(InjectedMount) {
	    injection.Mount = InjectedMount;
	    if (false) {
	      ("production" !== process.env.NODE_ENV ? invariant(
	        InjectedMount && InjectedMount.getNode,
	        'EventPluginUtils.injection.injectMount(...): Injected Mount module ' +
	        'is missing getNode.'
	      ) : invariant(InjectedMount && InjectedMount.getNode));
	    }
	  }
	};
	
	var topLevelTypes = EventConstants.topLevelTypes;
	
	function isEndish(topLevelType) {
	  return topLevelType === topLevelTypes.topMouseUp ||
	         topLevelType === topLevelTypes.topTouchEnd ||
	         topLevelType === topLevelTypes.topTouchCancel;
	}
	
	function isMoveish(topLevelType) {
	  return topLevelType === topLevelTypes.topMouseMove ||
	         topLevelType === topLevelTypes.topTouchMove;
	}
	function isStartish(topLevelType) {
	  return topLevelType === topLevelTypes.topMouseDown ||
	         topLevelType === topLevelTypes.topTouchStart;
	}
	
	
	var validateEventDispatches;
	if (false) {
	  validateEventDispatches = function(event) {
	    var dispatchListeners = event._dispatchListeners;
	    var dispatchIDs = event._dispatchIDs;
	
	    var listenersIsArr = Array.isArray(dispatchListeners);
	    var idsIsArr = Array.isArray(dispatchIDs);
	    var IDsLen = idsIsArr ? dispatchIDs.length : dispatchIDs ? 1 : 0;
	    var listenersLen = listenersIsArr ?
	      dispatchListeners.length :
	      dispatchListeners ? 1 : 0;
	
	    ("production" !== process.env.NODE_ENV ? invariant(
	      idsIsArr === listenersIsArr && IDsLen === listenersLen,
	      'EventPluginUtils: Invalid `event`.'
	    ) : invariant(idsIsArr === listenersIsArr && IDsLen === listenersLen));
	  };
	}
	
	/**
	 * Invokes `cb(event, listener, id)`. Avoids using call if no scope is
	 * provided. The `(listener,id)` pair effectively forms the "dispatch" but are
	 * kept separate to conserve memory.
	 */
	function forEachEventDispatch(event, cb) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchIDs = event._dispatchIDs;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and IDs are two parallel arrays that are always in sync.
	      cb(event, dispatchListeners[i], dispatchIDs[i]);
	    }
	  } else if (dispatchListeners) {
	    cb(event, dispatchListeners, dispatchIDs);
	  }
	}
	
	/**
	 * Default implementation of PluginModule.executeDispatch().
	 * @param {SyntheticEvent} SyntheticEvent to handle
	 * @param {function} Application-level callback
	 * @param {string} domID DOM id to pass to the callback.
	 */
	function executeDispatch(event, listener, domID) {
	  event.currentTarget = injection.Mount.getNode(domID);
	  var returnValue = listener(event, domID);
	  event.currentTarget = null;
	  return returnValue;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches.
	 */
	function executeDispatchesInOrder(event, cb) {
	  forEachEventDispatch(event, cb);
	  event._dispatchListeners = null;
	  event._dispatchIDs = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches, but stops
	 * at the first dispatch execution returning true, and returns that id.
	 *
	 * @return id of the first dispatch execution who's listener returns true, or
	 * null if no listener returned true.
	 */
	function executeDispatchesInOrderStopAtTrueImpl(event) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchIDs = event._dispatchIDs;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and IDs are two parallel arrays that are always in sync.
	      if (dispatchListeners[i](event, dispatchIDs[i])) {
	        return dispatchIDs[i];
	      }
	    }
	  } else if (dispatchListeners) {
	    if (dispatchListeners(event, dispatchIDs)) {
	      return dispatchIDs;
	    }
	  }
	  return null;
	}
	
	/**
	 * @see executeDispatchesInOrderStopAtTrueImpl
	 */
	function executeDispatchesInOrderStopAtTrue(event) {
	  var ret = executeDispatchesInOrderStopAtTrueImpl(event);
	  event._dispatchIDs = null;
	  event._dispatchListeners = null;
	  return ret;
	}
	
	/**
	 * Execution of a "direct" dispatch - there must be at most one dispatch
	 * accumulated on the event or it is considered an error. It doesn't really make
	 * sense for an event with multiple dispatches (bubbled) to keep track of the
	 * return values at each dispatch execution, but it does tend to make sense when
	 * dealing with "direct" dispatches.
	 *
	 * @return The return value of executing the single dispatch.
	 */
	function executeDirectDispatch(event) {
	  if (false) {
	    validateEventDispatches(event);
	  }
	  var dispatchListener = event._dispatchListeners;
	  var dispatchID = event._dispatchIDs;
	  ( false ? invariant(
	    !Array.isArray(dispatchListener),
	    'executeDirectDispatch(...): Invalid `event`.'
	  ) : invariant(!Array.isArray(dispatchListener)));
	  var res = dispatchListener ?
	    dispatchListener(event, dispatchID) :
	    null;
	  event._dispatchListeners = null;
	  event._dispatchIDs = null;
	  return res;
	}
	
	/**
	 * @param {SyntheticEvent} event
	 * @return {bool} True iff number of dispatches accumulated is greater than 0.
	 */
	function hasDispatches(event) {
	  return !!event._dispatchListeners;
	}
	
	/**
	 * General utilities that are useful in creating custom Event Plugins.
	 */
	var EventPluginUtils = {
	  isEndish: isEndish,
	  isMoveish: isMoveish,
	  isStartish: isStartish,
	
	  executeDirectDispatch: executeDirectDispatch,
	  executeDispatch: executeDispatch,
	  executeDispatchesInOrder: executeDispatchesInOrder,
	  executeDispatchesInOrderStopAtTrue: executeDispatchesInOrderStopAtTrue,
	  hasDispatches: hasDispatches,
	  injection: injection,
	  useTouchEvents: false
	};
	
	module.exports = EventPluginUtils;


/***/ },
/* 84 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule LinkedValueUtils
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var ReactPropTypes = __webpack_require__(151);
	
	var invariant = __webpack_require__(2);
	
	var hasReadOnlyValue = {
	  'button': true,
	  'checkbox': true,
	  'image': true,
	  'hidden': true,
	  'radio': true,
	  'reset': true,
	  'submit': true
	};
	
	function _assertSingleLink(input) {
	  ( false ? invariant(
	    input.props.checkedLink == null || input.props.valueLink == null,
	    'Cannot provide a checkedLink and a valueLink. If you want to use ' +
	    'checkedLink, you probably don\'t want to use valueLink and vice versa.'
	  ) : invariant(input.props.checkedLink == null || input.props.valueLink == null));
	}
	function _assertValueLink(input) {
	  _assertSingleLink(input);
	  ( false ? invariant(
	    input.props.value == null && input.props.onChange == null,
	    'Cannot provide a valueLink and a value or onChange event. If you want ' +
	    'to use value or onChange, you probably don\'t want to use valueLink.'
	  ) : invariant(input.props.value == null && input.props.onChange == null));
	}
	
	function _assertCheckedLink(input) {
	  _assertSingleLink(input);
	  ( false ? invariant(
	    input.props.checked == null && input.props.onChange == null,
	    'Cannot provide a checkedLink and a checked property or onChange event. ' +
	    'If you want to use checked or onChange, you probably don\'t want to ' +
	    'use checkedLink'
	  ) : invariant(input.props.checked == null && input.props.onChange == null));
	}
	
	/**
	 * @param {SyntheticEvent} e change event to handle
	 */
	function _handleLinkedValueChange(e) {
	  /*jshint validthis:true */
	  this.props.valueLink.requestChange(e.target.value);
	}
	
	/**
	  * @param {SyntheticEvent} e change event to handle
	  */
	function _handleLinkedCheckChange(e) {
	  /*jshint validthis:true */
	  this.props.checkedLink.requestChange(e.target.checked);
	}
	
	/**
	 * Provide a linked `value` attribute for controlled forms. You should not use
	 * this outside of the ReactDOM controlled form components.
	 */
	var LinkedValueUtils = {
	  Mixin: {
	    propTypes: {
	      value: function(props, propName, componentName) {
	        if (!props[propName] ||
	            hasReadOnlyValue[props.type] ||
	            props.onChange ||
	            props.readOnly ||
	            props.disabled) {
	          return null;
	        }
	        return new Error(
	          'You provided a `value` prop to a form field without an ' +
	          '`onChange` handler. This will render a read-only field. If ' +
	          'the field should be mutable use `defaultValue`. Otherwise, ' +
	          'set either `onChange` or `readOnly`.'
	        );
	      },
	      checked: function(props, propName, componentName) {
	        if (!props[propName] ||
	            props.onChange ||
	            props.readOnly ||
	            props.disabled) {
	          return null;
	        }
	        return new Error(
	          'You provided a `checked` prop to a form field without an ' +
	          '`onChange` handler. This will render a read-only field. If ' +
	          'the field should be mutable use `defaultChecked`. Otherwise, ' +
	          'set either `onChange` or `readOnly`.'
	        );
	      },
	      onChange: ReactPropTypes.func
	    }
	  },
	
	  /**
	   * @param {ReactComponent} input Form component
	   * @return {*} current value of the input either from value prop or link.
	   */
	  getValue: function(input) {
	    if (input.props.valueLink) {
	      _assertValueLink(input);
	      return input.props.valueLink.value;
	    }
	    return input.props.value;
	  },
	
	  /**
	   * @param {ReactComponent} input Form component
	   * @return {*} current checked status of the input either from checked prop
	   *             or link.
	   */
	  getChecked: function(input) {
	    if (input.props.checkedLink) {
	      _assertCheckedLink(input);
	      return input.props.checkedLink.value;
	    }
	    return input.props.checked;
	  },
	
	  /**
	   * @param {ReactComponent} input Form component
	   * @return {function} change callback either from onChange prop or link.
	   */
	  getOnChange: function(input) {
	    if (input.props.valueLink) {
	      _assertValueLink(input);
	      return _handleLinkedValueChange;
	    } else if (input.props.checkedLink) {
	      _assertCheckedLink(input);
	      return _handleLinkedCheckChange;
	    }
	    return input.props.onChange;
	  }
	};
	
	module.exports = LinkedValueUtils;


/***/ },
/* 85 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule LocalEventTrapMixin
	 */
	
	'use strict';
	
	var ReactBrowserEventEmitter = __webpack_require__(34);
	
	var accumulateInto = __webpack_require__(94);
	var forEachAccumulated = __webpack_require__(95);
	var invariant = __webpack_require__(2);
	
	function remove(event) {
	  event.remove();
	}
	
	var LocalEventTrapMixin = {
	  trapBubbledEvent:function(topLevelType, handlerBaseName) {
	    ( false ? invariant(this.isMounted(), 'Must be mounted to trap events') : invariant(this.isMounted()));
	    // If a component renders to null or if another component fatals and causes
	    // the state of the tree to be corrupted, `node` here can be null.
	    var node = this.getDOMNode();
	    ( false ? invariant(
	      node,
	      'LocalEventTrapMixin.trapBubbledEvent(...): Requires node to be rendered.'
	    ) : invariant(node));
	    var listener = ReactBrowserEventEmitter.trapBubbledEvent(
	      topLevelType,
	      handlerBaseName,
	      node
	    );
	    this._localEventListeners =
	      accumulateInto(this._localEventListeners, listener);
	  },
	
	  // trapCapturedEvent would look nearly identical. We don't implement that
	  // method because it isn't currently needed.
	
	  componentWillUnmount:function() {
	    if (this._localEventListeners) {
	      forEachAccumulated(this._localEventListeners, remove);
	    }
	  }
	};
	
	module.exports = LocalEventTrapMixin;


/***/ },
/* 86 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactComponentBrowserEnvironment
	 */
	
	/*jslint evil: true */
	
	'use strict';
	
	var ReactDOMIDOperations = __webpack_require__(146);
	var ReactMount = __webpack_require__(20);
	
	/**
	 * Abstracts away all functionality of the reconciler that requires knowledge of
	 * the browser context. TODO: These callers should be refactored to avoid the
	 * need for this injection.
	 */
	var ReactComponentBrowserEnvironment = {
	
	  processChildrenUpdates:
	    ReactDOMIDOperations.dangerouslyProcessChildrenUpdates,
	
	  replaceNodeWithMarkupByID:
	    ReactDOMIDOperations.dangerouslyReplaceNodeWithMarkupByID,
	
	  /**
	   * If a particular environment requires that some resources be cleaned up,
	   * specify this in the injected Mixin. In the DOM, we would likely want to
	   * purge any cached node ID lookups.
	   *
	   * @private
	   */
	  unmountIDFromEnvironment: function(rootNodeID) {
	    ReactMount.purgeID(rootNodeID);
	  }
	
	};
	
	module.exports = ReactComponentBrowserEnvironment;


/***/ },
/* 87 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactComponentEnvironment
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(2);
	
	var injected = false;
	
	var ReactComponentEnvironment = {
	
	  /**
	   * Optionally injectable environment dependent cleanup hook. (server vs.
	   * browser etc). Example: A browser system caches DOM nodes based on component
	   * ID and must remove that cache entry when this instance is unmounted.
	   */
	  unmountIDFromEnvironment: null,
	
	  /**
	   * Optionally injectable hook for swapping out mount images in the middle of
	   * the tree.
	   */
	  replaceNodeWithMarkupByID: null,
	
	  /**
	   * Optionally injectable hook for processing a queue of child updates. Will
	   * later move into MultiChildComponents.
	   */
	  processChildrenUpdates: null,
	
	  injection: {
	    injectEnvironment: function(environment) {
	      ( false ? invariant(
	        !injected,
	        'ReactCompositeComponent: injectEnvironment() can only be called once.'
	      ) : invariant(!injected));
	      ReactComponentEnvironment.unmountIDFromEnvironment =
	        environment.unmountIDFromEnvironment;
	      ReactComponentEnvironment.replaceNodeWithMarkupByID =
	        environment.replaceNodeWithMarkupByID;
	      ReactComponentEnvironment.processChildrenUpdates =
	        environment.processChildrenUpdates;
	      injected = true;
	    }
	  }
	
	};
	
	module.exports = ReactComponentEnvironment;


/***/ },
/* 88 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactContext
	 */
	
	'use strict';
	
	var assign = __webpack_require__(5);
	var emptyObject = __webpack_require__(65);
	var warning = __webpack_require__(6);
	
	var didWarn = false;
	
	/**
	 * Keeps track of the current context.
	 *
	 * The context is automatically passed down the component ownership hierarchy
	 * and is accessible via `this.context` on ReactCompositeComponents.
	 */
	var ReactContext = {
	
	  /**
	   * @internal
	   * @type {object}
	   */
	  current: emptyObject,
	
	  /**
	   * Temporarily extends the current context while executing scopedCallback.
	   *
	   * A typical use case might look like
	   *
	   *  render: function() {
	   *    var children = ReactContext.withContext({foo: 'foo'}, () => (
	   *
	   *    ));
	   *    return <div>{children}</div>;
	   *  }
	   *
	   * @param {object} newContext New context to merge into the existing context
	   * @param {function} scopedCallback Callback to run with the new context
	   * @return {ReactComponent|array<ReactComponent>}
	   */
	  withContext: function(newContext, scopedCallback) {
	    if (false) {
	      ("production" !== process.env.NODE_ENV ? warning(
	        didWarn,
	        'withContext is deprecated and will be removed in a future version. ' +
	        'Use a wrapper component with getChildContext instead.'
	      ) : null);
	
	      didWarn = true;
	    }
	
	    var result;
	    var previousContext = ReactContext.current;
	    ReactContext.current = assign({}, previousContext, newContext);
	    try {
	      result = scopedCallback();
	    } finally {
	      ReactContext.current = previousContext;
	    }
	    return result;
	  }
	
	};
	
	module.exports = ReactContext;


/***/ },
/* 89 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMComponent
	 * @typechecks static-only
	 */
	
	/* global hasOwnProperty:true */
	
	'use strict';
	
	var CSSPropertyOperations = __webpack_require__(143);
	var DOMProperty = __webpack_require__(33);
	var DOMPropertyOperations = __webpack_require__(43);
	var ReactBrowserEventEmitter = __webpack_require__(34);
	var ReactComponentBrowserEnvironment =
	  __webpack_require__(86);
	var ReactMount = __webpack_require__(20);
	var ReactMultiChild = __webpack_require__(436);
	var ReactPerf = __webpack_require__(27);
	
	var assign = __webpack_require__(5);
	var escapeTextContentForBrowser = __webpack_require__(66);
	var invariant = __webpack_require__(2);
	var isEventSupported = __webpack_require__(100);
	var keyOf = __webpack_require__(21);
	var warning = __webpack_require__(6);
	
	var deleteListener = ReactBrowserEventEmitter.deleteListener;
	var listenTo = ReactBrowserEventEmitter.listenTo;
	var registrationNameModules = ReactBrowserEventEmitter.registrationNameModules;
	
	// For quickly matching children type, to test if can be treated as content.
	var CONTENT_TYPES = {'string': true, 'number': true};
	
	var STYLE = keyOf({style: null});
	
	var ELEMENT_NODE_TYPE = 1;
	
	/**
	 * Optionally injectable operations for mutating the DOM
	 */
	var BackendIDOperations = null;
	
	/**
	 * @param {?object} props
	 */
	function assertValidProps(props) {
	  if (!props) {
	    return;
	  }
	  // Note the use of `==` which checks for null or undefined.
	  if (props.dangerouslySetInnerHTML != null) {
	    ( false ? invariant(
	      props.children == null,
	      'Can only set one of `children` or `props.dangerouslySetInnerHTML`.'
	    ) : invariant(props.children == null));
	    ( false ? invariant(
	      typeof props.dangerouslySetInnerHTML === 'object' &&
	      '__html' in props.dangerouslySetInnerHTML,
	      '`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. ' +
	      'Please visit https://fb.me/react-invariant-dangerously-set-inner-html ' +
	      'for more information.'
	    ) : invariant(typeof props.dangerouslySetInnerHTML === 'object' &&
	    '__html' in props.dangerouslySetInnerHTML));
	  }
	  if (false) {
	    ("production" !== process.env.NODE_ENV ? warning(
	      props.innerHTML == null,
	      'Directly setting property `innerHTML` is not permitted. ' +
	      'For more information, lookup documentation on `dangerouslySetInnerHTML`.'
	    ) : null);
	    ("production" !== process.env.NODE_ENV ? warning(
	      !props.contentEditable || props.children == null,
	      'A component is `contentEditable` and contains `children` managed by ' +
	      'React. It is now your responsibility to guarantee that none of ' +
	      'those nodes are unexpectedly modified or duplicated. This is ' +
	      'probably not intentional.'
	    ) : null);
	  }
	  ( false ? invariant(
	    props.style == null || typeof props.style === 'object',
	    'The `style` prop expects a mapping from style properties to values, ' +
	    'not a string. For example, style={{marginRight: spacing + \'em\'}} when ' +
	    'using JSX.'
	  ) : invariant(props.style == null || typeof props.style === 'object'));
	}
	
	function putListener(id, registrationName, listener, transaction) {
	  if (false) {
	    // IE8 has no API for event capturing and the `onScroll` event doesn't
	    // bubble.
	    ("production" !== process.env.NODE_ENV ? warning(
	      registrationName !== 'onScroll' || isEventSupported('scroll', true),
	      'This browser doesn\'t support the `onScroll` event'
	    ) : null);
	  }
	  var container = ReactMount.findReactContainerForID(id);
	  if (container) {
	    var doc = container.nodeType === ELEMENT_NODE_TYPE ?
	      container.ownerDocument :
	      container;
	    listenTo(registrationName, doc);
	  }
	  transaction.getPutListenerQueue().enqueuePutListener(
	    id,
	    registrationName,
	    listener
	  );
	}
	
	// For HTML, certain tags should omit their close tag. We keep a whitelist for
	// those special cased tags.
	
	var omittedCloseTags = {
	  'area': true,
	  'base': true,
	  'br': true,
	  'col': true,
	  'embed': true,
	  'hr': true,
	  'img': true,
	  'input': true,
	  'keygen': true,
	  'link': true,
	  'meta': true,
	  'param': true,
	  'source': true,
	  'track': true,
	  'wbr': true
	  // NOTE: menuitem's close tag should be omitted, but that causes problems.
	};
	
	// We accept any tag to be rendered but since this gets injected into abitrary
	// HTML, we want to make sure that it's a safe tag.
	// http://www.w3.org/TR/REC-xml/#NT-Name
	
	var VALID_TAG_REGEX = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/; // Simplified subset
	var validatedTagCache = {};
	var hasOwnProperty = {}.hasOwnProperty;
	
	function validateDangerousTag(tag) {
	  if (!hasOwnProperty.call(validatedTagCache, tag)) {
	    ( false ? invariant(VALID_TAG_REGEX.test(tag), 'Invalid tag: %s', tag) : invariant(VALID_TAG_REGEX.test(tag)));
	    validatedTagCache[tag] = true;
	  }
	}
	
	/**
	 * Creates a new React class that is idempotent and capable of containing other
	 * React components. It accepts event listeners and DOM properties that are
	 * valid according to `DOMProperty`.
	 *
	 *  - Event listeners: `onClick`, `onMouseDown`, etc.
	 *  - DOM properties: `className`, `name`, `title`, etc.
	 *
	 * The `style` property functions differently from the DOM API. It accepts an
	 * object mapping of style properties to values.
	 *
	 * @constructor ReactDOMComponent
	 * @extends ReactMultiChild
	 */
	function ReactDOMComponent(tag) {
	  validateDangerousTag(tag);
	  this._tag = tag;
	  this._renderedChildren = null;
	  this._previousStyleCopy = null;
	  this._rootNodeID = null;
	}
	
	ReactDOMComponent.displayName = 'ReactDOMComponent';
	
	ReactDOMComponent.Mixin = {
	
	  construct: function(element) {
	    this._currentElement = element;
	  },
	
	  /**
	   * Generates root tag markup then recurses. This method has side effects and
	   * is not idempotent.
	   *
	   * @internal
	   * @param {string} rootID The root DOM ID for this node.
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @return {string} The computed markup.
	   */
	  mountComponent: function(rootID, transaction, context) {
	    this._rootNodeID = rootID;
	    assertValidProps(this._currentElement.props);
	    var closeTag = omittedCloseTags[this._tag] ? '' : '</' + this._tag + '>';
	    return (
	      this._createOpenTagMarkupAndPutListeners(transaction) +
	      this._createContentMarkup(transaction, context) +
	      closeTag
	    );
	  },
	
	  /**
	   * Creates markup for the open tag and all attributes.
	   *
	   * This method has side effects because events get registered.
	   *
	   * Iterating over object properties is faster than iterating over arrays.
	   * @see http://jsperf.com/obj-vs-arr-iteration
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @return {string} Markup of opening tag.
	   */
	  _createOpenTagMarkupAndPutListeners: function(transaction) {
	    var props = this._currentElement.props;
	    var ret = '<' + this._tag;
	
	    for (var propKey in props) {
	      if (!props.hasOwnProperty(propKey)) {
	        continue;
	      }
	      var propValue = props[propKey];
	      if (propValue == null) {
	        continue;
	      }
	      if (registrationNameModules.hasOwnProperty(propKey)) {
	        putListener(this._rootNodeID, propKey, propValue, transaction);
	      } else {
	        if (propKey === STYLE) {
	          if (propValue) {
	            propValue = this._previousStyleCopy = assign({}, props.style);
	          }
	          propValue = CSSPropertyOperations.createMarkupForStyles(propValue);
	        }
	        var markup =
	          DOMPropertyOperations.createMarkupForProperty(propKey, propValue);
	        if (markup) {
	          ret += ' ' + markup;
	        }
	      }
	    }
	
	    // For static pages, no need to put React ID and checksum. Saves lots of
	    // bytes.
	    if (transaction.renderToStaticMarkup) {
	      return ret + '>';
	    }
	
	    var markupForID = DOMPropertyOperations.createMarkupForID(this._rootNodeID);
	    return ret + ' ' + markupForID + '>';
	  },
	
	  /**
	   * Creates markup for the content between the tags.
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} context
	   * @return {string} Content markup.
	   */
	  _createContentMarkup: function(transaction, context) {
	    var prefix = '';
	    if (this._tag === 'listing' ||
	        this._tag === 'pre' ||
	        this._tag === 'textarea') {
	      // Add an initial newline because browsers ignore the first newline in
	      // a <listing>, <pre>, or <textarea> as an "authoring convenience" -- see
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody.
	      prefix = '\n';
	    }
	
	    var props = this._currentElement.props;
	
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        return prefix + innerHTML.__html;
	      }
	    } else {
	      var contentToUse =
	        CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      if (contentToUse != null) {
	        return prefix + escapeTextContentForBrowser(contentToUse);
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(
	          childrenToUse,
	          transaction,
	          context
	        );
	        return prefix + mountImages.join('');
	      }
	    }
	    return prefix;
	  },
	
	  receiveComponent: function(nextElement, transaction, context) {
	    var prevElement = this._currentElement;
	    this._currentElement = nextElement;
	    this.updateComponent(transaction, prevElement, nextElement, context);
	  },
	
	  /**
	   * Updates a native DOM component after it has already been allocated and
	   * attached to the DOM. Reconciles the root DOM node, then recurses.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevElement
	   * @param {ReactElement} nextElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function(transaction, prevElement, nextElement, context) {
	    assertValidProps(this._currentElement.props);
	    this._updateDOMProperties(prevElement.props, transaction);
	    this._updateDOMChildren(prevElement.props, transaction, context);
	  },
	
	  /**
	   * Reconciles the properties by detecting differences in property values and
	   * updating the DOM as necessary. This function is probably the single most
	   * critical path for performance optimization.
	   *
	   * TODO: Benchmark whether checking for changed values in memory actually
	   *       improves performance (especially statically positioned elements).
	   * TODO: Benchmark the effects of putting this at the top since 99% of props
	   *       do not change for a given reconciliation.
	   * TODO: Benchmark areas that can be improved with caching.
	   *
	   * @private
	   * @param {object} lastProps
	   * @param {ReactReconcileTransaction} transaction
	   */
	  _updateDOMProperties: function(lastProps, transaction) {
	    var nextProps = this._currentElement.props;
	    var propKey;
	    var styleName;
	    var styleUpdates;
	    for (propKey in lastProps) {
	      if (nextProps.hasOwnProperty(propKey) ||
	         !lastProps.hasOwnProperty(propKey)) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        var lastStyle = this._previousStyleCopy;
	        for (styleName in lastStyle) {
	          if (lastStyle.hasOwnProperty(styleName)) {
	            styleUpdates = styleUpdates || {};
	            styleUpdates[styleName] = '';
	          }
	        }
	        this._previousStyleCopy = null;
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        deleteListener(this._rootNodeID, propKey);
	      } else if (
	          DOMProperty.isStandardName[propKey] ||
	          DOMProperty.isCustomAttribute(propKey)) {
	        BackendIDOperations.deletePropertyByID(
	          this._rootNodeID,
	          propKey
	        );
	      }
	    }
	    for (propKey in nextProps) {
	      var nextProp = nextProps[propKey];
	      var lastProp = propKey === STYLE ?
	        this._previousStyleCopy :
	        lastProps[propKey];
	      if (!nextProps.hasOwnProperty(propKey) || nextProp === lastProp) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        if (nextProp) {
	          nextProp = this._previousStyleCopy = assign({}, nextProp);
	        } else {
	          this._previousStyleCopy = null;
	        }
	        if (lastProp) {
	          // Unset styles on `lastProp` but not on `nextProp`.
	          for (styleName in lastProp) {
	            if (lastProp.hasOwnProperty(styleName) &&
	                (!nextProp || !nextProp.hasOwnProperty(styleName))) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = '';
	            }
	          }
	          // Update styles that changed since `lastProp`.
	          for (styleName in nextProp) {
	            if (nextProp.hasOwnProperty(styleName) &&
	                lastProp[styleName] !== nextProp[styleName]) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = nextProp[styleName];
	            }
	          }
	        } else {
	          // Relies on `updateStylesByID` not mutating `styleUpdates`.
	          styleUpdates = nextProp;
	        }
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        putListener(this._rootNodeID, propKey, nextProp, transaction);
	      } else if (
	          DOMProperty.isStandardName[propKey] ||
	          DOMProperty.isCustomAttribute(propKey)) {
	        BackendIDOperations.updatePropertyByID(
	          this._rootNodeID,
	          propKey,
	          nextProp
	        );
	      }
	    }
	    if (styleUpdates) {
	      BackendIDOperations.updateStylesByID(
	        this._rootNodeID,
	        styleUpdates
	      );
	    }
	  },
	
	  /**
	   * Reconciles the children with the various properties that affect the
	   * children content.
	   *
	   * @param {object} lastProps
	   * @param {ReactReconcileTransaction} transaction
	   */
	  _updateDOMChildren: function(lastProps, transaction, context) {
	    var nextProps = this._currentElement.props;
	
	    var lastContent =
	      CONTENT_TYPES[typeof lastProps.children] ? lastProps.children : null;
	    var nextContent =
	      CONTENT_TYPES[typeof nextProps.children] ? nextProps.children : null;
	
	    var lastHtml =
	      lastProps.dangerouslySetInnerHTML &&
	      lastProps.dangerouslySetInnerHTML.__html;
	    var nextHtml =
	      nextProps.dangerouslySetInnerHTML &&
	      nextProps.dangerouslySetInnerHTML.__html;
	
	    // Note the use of `!=` which checks for null or undefined.
	    var lastChildren = lastContent != null ? null : lastProps.children;
	    var nextChildren = nextContent != null ? null : nextProps.children;
	
	    // If we're switching from children to content/html or vice versa, remove
	    // the old content
	    var lastHasContentOrHtml = lastContent != null || lastHtml != null;
	    var nextHasContentOrHtml = nextContent != null || nextHtml != null;
	    if (lastChildren != null && nextChildren == null) {
	      this.updateChildren(null, transaction, context);
	    } else if (lastHasContentOrHtml && !nextHasContentOrHtml) {
	      this.updateTextContent('');
	    }
	
	    if (nextContent != null) {
	      if (lastContent !== nextContent) {
	        this.updateTextContent('' + nextContent);
	      }
	    } else if (nextHtml != null) {
	      if (lastHtml !== nextHtml) {
	        BackendIDOperations.updateInnerHTMLByID(
	          this._rootNodeID,
	          nextHtml
	        );
	      }
	    } else if (nextChildren != null) {
	      this.updateChildren(nextChildren, transaction, context);
	    }
	  },
	
	  /**
	   * Destroys all event registrations for this instance. Does not remove from
	   * the DOM. That must be done by the parent.
	   *
	   * @internal
	   */
	  unmountComponent: function() {
	    this.unmountChildren();
	    ReactBrowserEventEmitter.deleteAllListeners(this._rootNodeID);
	    ReactComponentBrowserEnvironment.unmountIDFromEnvironment(this._rootNodeID);
	    this._rootNodeID = null;
	  }
	
	};
	
	ReactPerf.measureMethods(ReactDOMComponent, 'ReactDOMComponent', {
	  mountComponent: 'mountComponent',
	  updateComponent: 'updateComponent'
	});
	
	assign(
	  ReactDOMComponent.prototype,
	  ReactDOMComponent.Mixin,
	  ReactMultiChild.Mixin
	);
	
	ReactDOMComponent.injection = {
	  injectIDOperations: function(IDOperations) {
	    ReactDOMComponent.BackendIDOperations = BackendIDOperations = IDOperations;
	  }
	};
	
	module.exports = ReactDOMComponent;


/***/ },
/* 90 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactEmptyComponent
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(7);
	var ReactInstanceMap = __webpack_require__(36);
	
	var invariant = __webpack_require__(2);
	
	var component;
	// This registry keeps track of the React IDs of the components that rendered to
	// `null` (in reality a placeholder such as `noscript`)
	var nullComponentIDsRegistry = {};
	
	var ReactEmptyComponentInjection = {
	  injectEmptyComponent: function(emptyComponent) {
	    component = ReactElement.createFactory(emptyComponent);
	  }
	};
	
	var ReactEmptyComponentType = function() {};
	ReactEmptyComponentType.prototype.componentDidMount = function() {
	  var internalInstance = ReactInstanceMap.get(this);
	  // TODO: Make sure we run these methods in the correct order, we shouldn't
	  // need this check. We're going to assume if we're here it means we ran
	  // componentWillUnmount already so there is no internal instance (it gets
	  // removed as part of the unmounting process).
	  if (!internalInstance) {
	    return;
	  }
	  registerNullComponentID(internalInstance._rootNodeID);
	};
	ReactEmptyComponentType.prototype.componentWillUnmount = function() {
	  var internalInstance = ReactInstanceMap.get(this);
	  // TODO: Get rid of this check. See TODO in componentDidMount.
	  if (!internalInstance) {
	    return;
	  }
	  deregisterNullComponentID(internalInstance._rootNodeID);
	};
	ReactEmptyComponentType.prototype.render = function() {
	  ( false ? invariant(
	    component,
	    'Trying to return null from a render, but no null placeholder component ' +
	    'was injected.'
	  ) : invariant(component));
	  return component();
	};
	
	var emptyElement = ReactElement.createElement(ReactEmptyComponentType);
	
	/**
	 * Mark the component as having rendered to null.
	 * @param {string} id Component's `_rootNodeID`.
	 */
	function registerNullComponentID(id) {
	  nullComponentIDsRegistry[id] = true;
	}
	
	/**
	 * Unmark the component as having rendered to null: it renders to something now.
	 * @param {string} id Component's `_rootNodeID`.
	 */
	function deregisterNullComponentID(id) {
	  delete nullComponentIDsRegistry[id];
	}
	
	/**
	 * @param {string} id Component's `_rootNodeID`.
	 * @return {boolean} True if the component is rendered to null.
	 */
	function isNullComponentID(id) {
	  return !!nullComponentIDsRegistry[id];
	}
	
	var ReactEmptyComponent = {
	  emptyElement: emptyElement,
	  injection: ReactEmptyComponentInjection,
	  isNullComponentID: isNullComponentID
	};
	
	module.exports = ReactEmptyComponent;


/***/ },
/* 91 */
/***/ function(module, exports) {

	/**
	 * Copyright 2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactLifeCycle
	 */
	
	'use strict';
	
	/**
	 * This module manages the bookkeeping when a component is in the process
	 * of being mounted or being unmounted. This is used as a way to enforce
	 * invariants (or warnings) when it is not recommended to call
	 * setState/forceUpdate.
	 *
	 * currentlyMountingInstance: During the construction phase, it is not possible
	 * to trigger an update since the instance is not fully mounted yet. However, we
	 * currently allow this as a convenience for mutating the initial state.
	 *
	 * currentlyUnmountingInstance: During the unmounting phase, the instance is
	 * still mounted and can therefore schedule an update. However, this is not
	 * recommended and probably an error since it's about to be unmounted.
	 * Therefore we still want to trigger in an error for that case.
	 */
	
	var ReactLifeCycle = {
	  currentlyMountingInstance: null,
	  currentlyUnmountingInstance: null
	};
	
	module.exports = ReactLifeCycle;


/***/ },
/* 92 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactPropTypeLocations
	 */
	
	'use strict';
	
	var keyMirror = __webpack_require__(48);
	
	var ReactPropTypeLocations = keyMirror({
	  prop: null,
	  context: null,
	  childContext: null
	});
	
	module.exports = ReactPropTypeLocations;


/***/ },
/* 93 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactUpdateQueue
	 */
	
	'use strict';
	
	var ReactLifeCycle = __webpack_require__(91);
	var ReactCurrentOwner = __webpack_require__(19);
	var ReactElement = __webpack_require__(7);
	var ReactInstanceMap = __webpack_require__(36);
	var ReactUpdates = __webpack_require__(14);
	
	var assign = __webpack_require__(5);
	var invariant = __webpack_require__(2);
	var warning = __webpack_require__(6);
	
	function enqueueUpdate(internalInstance) {
	  if (internalInstance !== ReactLifeCycle.currentlyMountingInstance) {
	    // If we're in a componentWillMount handler, don't enqueue a rerender
	    // because ReactUpdates assumes we're in a browser context (which is
	    // wrong for server rendering) and we're about to do a render anyway.
	    // See bug in #1740.
	    ReactUpdates.enqueueUpdate(internalInstance);
	  }
	}
	
	function getInternalInstanceReadyForUpdate(publicInstance, callerName) {
	  ( false ? invariant(
	    ReactCurrentOwner.current == null,
	    '%s(...): Cannot update during an existing state transition ' +
	    '(such as within `render`). Render methods should be a pure function ' +
	    'of props and state.',
	    callerName
	  ) : invariant(ReactCurrentOwner.current == null));
	
	  var internalInstance = ReactInstanceMap.get(publicInstance);
	  if (!internalInstance) {
	    if (false) {
	      // Only warn when we have a callerName. Otherwise we should be silent.
	      // We're probably calling from enqueueCallback. We don't want to warn
	      // there because we already warned for the corresponding lifecycle method.
	      ("production" !== process.env.NODE_ENV ? warning(
	        !callerName,
	        '%s(...): Can only update a mounted or mounting component. ' +
	        'This usually means you called %s() on an unmounted ' +
	        'component. This is a no-op.',
	        callerName,
	        callerName
	      ) : null);
	    }
	    return null;
	  }
	
	  if (internalInstance === ReactLifeCycle.currentlyUnmountingInstance) {
	    return null;
	  }
	
	  return internalInstance;
	}
	
	/**
	 * ReactUpdateQueue allows for state updates to be scheduled into a later
	 * reconciliation step.
	 */
	var ReactUpdateQueue = {
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	  enqueueCallback: function(publicInstance, callback) {
	    ( false ? invariant(
	      typeof callback === 'function',
	      'enqueueCallback(...): You called `setProps`, `replaceProps`, ' +
	      '`setState`, `replaceState`, or `forceUpdate` with a callback that ' +
	      'isn\'t callable.'
	    ) : invariant(typeof callback === 'function'));
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance);
	
	    // Previously we would throw an error if we didn't have an internal
	    // instance. Since we want to make it a no-op instead, we mirror the same
	    // behavior we have in other enqueue* methods.
	    // We also need to ignore callbacks in componentWillMount. See
	    // enqueueUpdates.
	    if (!internalInstance ||
	        internalInstance === ReactLifeCycle.currentlyMountingInstance) {
	      return null;
	    }
	
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    // TODO: The callback here is ignored when setState is called from
	    // componentWillMount. Either fix it or disallow doing so completely in
	    // favor of getInitialState. Alternatively, we can disallow
	    // componentWillMount during server-side rendering.
	    enqueueUpdate(internalInstance);
	  },
	
	  enqueueCallbackInternal: function(internalInstance, callback) {
	    ( false ? invariant(
	      typeof callback === 'function',
	      'enqueueCallback(...): You called `setProps`, `replaceProps`, ' +
	      '`setState`, `replaceState`, or `forceUpdate` with a callback that ' +
	      'isn\'t callable.'
	    ) : invariant(typeof callback === 'function'));
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldUpdateComponent`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function(publicInstance) {
	    var internalInstance = getInternalInstanceReadyForUpdate(
	      publicInstance,
	      'forceUpdate'
	    );
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingForceUpdate = true;
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function(publicInstance, completeState) {
	    var internalInstance = getInternalInstanceReadyForUpdate(
	      publicInstance,
	      'replaceState'
	    );
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingStateQueue = [completeState];
	    internalInstance._pendingReplaceState = true;
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function(publicInstance, partialState) {
	    var internalInstance = getInternalInstanceReadyForUpdate(
	      publicInstance,
	      'setState'
	    );
	
	    if (!internalInstance) {
	      return;
	    }
	
	    var queue =
	      internalInstance._pendingStateQueue ||
	      (internalInstance._pendingStateQueue = []);
	    queue.push(partialState);
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Sets a subset of the props.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialProps Subset of the next props.
	   * @internal
	   */
	  enqueueSetProps: function(publicInstance, partialProps) {
	    var internalInstance = getInternalInstanceReadyForUpdate(
	      publicInstance,
	      'setProps'
	    );
	
	    if (!internalInstance) {
	      return;
	    }
	
	    ( false ? invariant(
	      internalInstance._isTopLevel,
	      'setProps(...): You called `setProps` on a ' +
	      'component with a parent. This is an anti-pattern since props will ' +
	      'get reactively updated when rendered. Instead, change the owner\'s ' +
	      '`render` method to pass the correct value as props to the component ' +
	      'where it is created.'
	    ) : invariant(internalInstance._isTopLevel));
	
	    // Merge with the pending element if it exists, otherwise with existing
	    // element props.
	    var element = internalInstance._pendingElement ||
	                  internalInstance._currentElement;
	    var props = assign({}, element.props, partialProps);
	    internalInstance._pendingElement = ReactElement.cloneAndReplaceProps(
	      element,
	      props
	    );
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Replaces all of the props.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} props New props.
	   * @internal
	   */
	  enqueueReplaceProps: function(publicInstance, props) {
	    var internalInstance = getInternalInstanceReadyForUpdate(
	      publicInstance,
	      'replaceProps'
	    );
	
	    if (!internalInstance) {
	      return;
	    }
	
	    ( false ? invariant(
	      internalInstance._isTopLevel,
	      'replaceProps(...): You called `replaceProps` on a ' +
	      'component with a parent. This is an anti-pattern since props will ' +
	      'get reactively updated when rendered. Instead, change the owner\'s ' +
	      '`render` method to pass the correct value as props to the component ' +
	      'where it is created.'
	    ) : invariant(internalInstance._isTopLevel));
	
	    // Merge with the pending element if it exists, otherwise with existing
	    // element props.
	    var element = internalInstance._pendingElement ||
	                  internalInstance._currentElement;
	    internalInstance._pendingElement = ReactElement.cloneAndReplaceProps(
	      element,
	      props
	    );
	
	    enqueueUpdate(internalInstance);
	  },
	
	  enqueueElementInternal: function(internalInstance, newElement) {
	    internalInstance._pendingElement = newElement;
	    enqueueUpdate(internalInstance);
	  }
	
	};
	
	module.exports = ReactUpdateQueue;


/***/ },
/* 94 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule accumulateInto
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(2);
	
	/**
	 *
	 * Accumulates items that must not be null or undefined into the first one. This
	 * is used to conserve memory by avoiding array allocations, and thus sacrifices
	 * API cleanness. Since `current` can be null before being passed in and not
	 * null after this function, make sure to assign it back to `current`:
	 *
	 * `a = accumulateInto(a, b);`
	 *
	 * This API should be sparingly used. Try `accumulate` for something cleaner.
	 *
	 * @return {*|array<*>} An accumulation of items.
	 */
	
	function accumulateInto(current, next) {
	  ( false ? invariant(
	    next != null,
	    'accumulateInto(...): Accumulated items must not be null or undefined.'
	  ) : invariant(next != null));
	  if (current == null) {
	    return next;
	  }
	
	  // Both are not empty. Warning: Never call x.concat(y) when you are not
	  // certain that x is an Array (x could be a string with concat method).
	  var currentIsArray = Array.isArray(current);
	  var nextIsArray = Array.isArray(next);
	
	  if (currentIsArray && nextIsArray) {
	    current.push.apply(current, next);
	    return current;
	  }
	
	  if (currentIsArray) {
	    current.push(next);
	    return current;
	  }
	
	  if (nextIsArray) {
	    // A bit too dangerous to mutate `next`.
	    return [current].concat(next);
	  }
	
	  return [current, next];
	}
	
	module.exports = accumulateInto;


/***/ },
/* 95 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule forEachAccumulated
	 */
	
	'use strict';
	
	/**
	 * @param {array} an "accumulation" of items which is either an Array or
	 * a single item. Useful when paired with the `accumulate` module. This is a
	 * simple utility that allows us to reason about a collection of items, but
	 * handling the case when there is exactly one item (and we do not need to
	 * allocate an array).
	 */
	var forEachAccumulated = function(arr, cb, scope) {
	  if (Array.isArray(arr)) {
	    arr.forEach(cb, scope);
	  } else if (arr) {
	    cb.call(scope, arr);
	  }
	};
	
	module.exports = forEachAccumulated;


/***/ },
/* 96 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getEventCharCode
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/**
	 * `charCode` represents the actual "character code" and is safe to use with
	 * `String.fromCharCode`. As such, only keys that correspond to printable
	 * characters produce a valid `charCode`, the only exception to this is Enter.
	 * The Tab-key is considered non-printable and does not have a `charCode`,
	 * presumably because it does not produce a tab-character in browsers.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {string} Normalized `charCode` property.
	 */
	function getEventCharCode(nativeEvent) {
	  var charCode;
	  var keyCode = nativeEvent.keyCode;
	
	  if ('charCode' in nativeEvent) {
	    charCode = nativeEvent.charCode;
	
	    // FF does not set `charCode` for the Enter-key, check against `keyCode`.
	    if (charCode === 0 && keyCode === 13) {
	      charCode = 13;
	    }
	  } else {
	    // IE8 does not implement `charCode`, but `keyCode` has the correct value.
	    charCode = keyCode;
	  }
	
	  // Some non-printable keys are reported in `charCode`/`keyCode`, discard them.
	  // Must not discard the (non-)printable Enter-key.
	  if (charCode >= 32 || charCode === 13) {
	    return charCode;
	  }
	
	  return 0;
	}
	
	module.exports = getEventCharCode;


/***/ },
/* 97 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getEventModifierState
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/**
	 * Translation from modifier key to the associated property in the event.
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#keys-Modifiers
	 */
	
	var modifierKeyToProp = {
	  'Alt': 'altKey',
	  'Control': 'ctrlKey',
	  'Meta': 'metaKey',
	  'Shift': 'shiftKey'
	};
	
	// IE8 does not implement getModifierState so we simply map it to the only
	// modifier keys exposed by the event itself, does not support Lock-keys.
	// Currently, all major browsers except Chrome seems to support Lock-keys.
	function modifierStateGetter(keyArg) {
	  /*jshint validthis:true */
	  var syntheticEvent = this;
	  var nativeEvent = syntheticEvent.nativeEvent;
	  if (nativeEvent.getModifierState) {
	    return nativeEvent.getModifierState(keyArg);
	  }
	  var keyProp = modifierKeyToProp[keyArg];
	  return keyProp ? !!nativeEvent[keyProp] : false;
	}
	
	function getEventModifierState(nativeEvent) {
	  return modifierStateGetter;
	}
	
	module.exports = getEventModifierState;


/***/ },
/* 98 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getEventTarget
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/**
	 * Gets the target node from a native browser event by accounting for
	 * inconsistencies in browser DOM APIs.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {DOMEventTarget} Target node.
	 */
	function getEventTarget(nativeEvent) {
	  var target = nativeEvent.target || nativeEvent.srcElement || window;
	  // Safari may fire events on text nodes (Node.TEXT_NODE is 3).
	  // @see http://www.quirksmode.org/js/events_properties.html
	  return target.nodeType === 3 ? target.parentNode : target;
	}
	
	module.exports = getEventTarget;


/***/ },
/* 99 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule instantiateReactComponent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var ReactCompositeComponent = __webpack_require__(419);
	var ReactEmptyComponent = __webpack_require__(90);
	var ReactNativeComponent = __webpack_require__(61);
	
	var assign = __webpack_require__(5);
	var invariant = __webpack_require__(2);
	var warning = __webpack_require__(6);
	
	// To avoid a cyclic dependency, we create the final class in this module
	var ReactCompositeComponentWrapper = function() { };
	assign(
	  ReactCompositeComponentWrapper.prototype,
	  ReactCompositeComponent.Mixin,
	  {
	    _instantiateReactComponent: instantiateReactComponent
	  }
	);
	
	/**
	 * Check if the type reference is a known internal type. I.e. not a user
	 * provided composite type.
	 *
	 * @param {function} type
	 * @return {boolean} Returns true if this is a valid internal type.
	 */
	function isInternalComponentType(type) {
	  return (
	    typeof type === 'function' &&
	    typeof type.prototype !== 'undefined' &&
	    typeof type.prototype.mountComponent === 'function' &&
	    typeof type.prototype.receiveComponent === 'function'
	  );
	}
	
	/**
	 * Given a ReactNode, create an instance that will actually be mounted.
	 *
	 * @param {ReactNode} node
	 * @param {*} parentCompositeType The composite type that resolved this.
	 * @return {object} A new instance of the element's constructor.
	 * @protected
	 */
	function instantiateReactComponent(node, parentCompositeType) {
	  var instance;
	
	  if (node === null || node === false) {
	    node = ReactEmptyComponent.emptyElement;
	  }
	
	  if (typeof node === 'object') {
	    var element = node;
	    if (false) {
	      ("production" !== process.env.NODE_ENV ? warning(
	        element && (typeof element.type === 'function' ||
	                    typeof element.type === 'string'),
	        'Only functions or strings can be mounted as React components.'
	      ) : null);
	    }
	
	    // Special case string values
	    if (parentCompositeType === element.type &&
	        typeof element.type === 'string') {
	      // Avoid recursion if the wrapper renders itself.
	      instance = ReactNativeComponent.createInternalComponent(element);
	      // All native components are currently wrapped in a composite so we're
	      // safe to assume that this is what we should instantiate.
	    } else if (isInternalComponentType(element.type)) {
	      // This is temporarily available for custom components that are not string
	      // represenations. I.e. ART. Once those are updated to use the string
	      // representation, we can drop this code path.
	      instance = new element.type(element);
	    } else {
	      instance = new ReactCompositeComponentWrapper();
	    }
	  } else if (typeof node === 'string' || typeof node === 'number') {
	    instance = ReactNativeComponent.createInstanceForText(node);
	  } else {
	    ( false ? invariant(
	      false,
	      'Encountered invalid React node of type %s',
	      typeof node
	    ) : invariant(false));
	  }
	
	  if (false) {
	    ("production" !== process.env.NODE_ENV ? warning(
	      typeof instance.construct === 'function' &&
	      typeof instance.mountComponent === 'function' &&
	      typeof instance.receiveComponent === 'function' &&
	      typeof instance.unmountComponent === 'function',
	      'Only React Components can be mounted.'
	    ) : null);
	  }
	
	  // Sets up the instance. This can probably just move into the constructor now.
	  instance.construct(node);
	
	  // These two fields are used by the DOM and ART diffing algorithms
	  // respectively. Instead of using expandos on components, we should be
	  // storing the state needed by the diffing algorithms elsewhere.
	  instance._mountIndex = 0;
	  instance._mountImage = null;
	
	  if (false) {
	    instance._isOwnerNecessary = false;
	    instance._warnedAboutRefsInRender = false;
	  }
	
	  // Internal instances should fully constructed at this point, so they should
	  // not get any new fields added to them at this point.
	  if (false) {
	    if (Object.preventExtensions) {
	      Object.preventExtensions(instance);
	    }
	  }
	
	  return instance;
	}
	
	module.exports = instantiateReactComponent;


/***/ },
/* 100 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule isEventSupported
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(8);
	
	var useHasFeature;
	if (ExecutionEnvironment.canUseDOM) {
	  useHasFeature =
	    document.implementation &&
	    document.implementation.hasFeature &&
	    // always returns true in newer browsers as per the standard.
	    // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
	    document.implementation.hasFeature('', '') !== true;
	}
	
	/**
	 * Checks if an event is supported in the current execution environment.
	 *
	 * NOTE: This will not work correctly for non-generic events such as `change`,
	 * `reset`, `load`, `error`, and `select`.
	 *
	 * Borrows from Modernizr.
	 *
	 * @param {string} eventNameSuffix Event name, e.g. "click".
	 * @param {?boolean} capture Check if the capture phase is supported.
	 * @return {boolean} True if the event is supported.
	 * @internal
	 * @license Modernizr 3.0.0pre (Custom Build) | MIT
	 */
	function isEventSupported(eventNameSuffix, capture) {
	  if (!ExecutionEnvironment.canUseDOM ||
	      capture && !('addEventListener' in document)) {
	    return false;
	  }
	
	  var eventName = 'on' + eventNameSuffix;
	  var isSupported = eventName in document;
	
	  if (!isSupported) {
	    var element = document.createElement('div');
	    element.setAttribute(eventName, 'return;');
	    isSupported = typeof element[eventName] === 'function';
	  }
	
	  if (!isSupported && useHasFeature && eventNameSuffix === 'wheel') {
	    // This is the only way to test support for the `wheel` event in IE9+.
	    isSupported = document.implementation.hasFeature('Events.wheel', '3.0');
	  }
	
	  return isSupported;
	}
	
	module.exports = isEventSupported;


/***/ },
/* 101 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule setInnerHTML
	 */
	
	/* globals MSApp */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(8);
	
	var WHITESPACE_TEST = /^[ \r\n\t\f]/;
	var NONVISIBLE_TEST = /<(!--|link|noscript|meta|script|style)[ \r\n\t\f\/>]/;
	
	/**
	 * Set the innerHTML property of a node, ensuring that whitespace is preserved
	 * even in IE8.
	 *
	 * @param {DOMElement} node
	 * @param {string} html
	 * @internal
	 */
	var setInnerHTML = function(node, html) {
	  node.innerHTML = html;
	};
	
	// Win8 apps: Allow all html to be inserted
	if (typeof MSApp !== 'undefined' && MSApp.execUnsafeLocalFunction) {
	  setInnerHTML = function(node, html) {
	    MSApp.execUnsafeLocalFunction(function() {
	      node.innerHTML = html;
	    });
	  };
	}
	
	if (ExecutionEnvironment.canUseDOM) {
	  // IE8: When updating a just created node with innerHTML only leading
	  // whitespace is removed. When updating an existing node with innerHTML
	  // whitespace in root TextNodes is also collapsed.
	  // @see quirksmode.org/bugreports/archives/2004/11/innerhtml_and_t.html
	
	  // Feature detection; only IE8 is known to behave improperly like this.
	  var testElement = document.createElement('div');
	  testElement.innerHTML = ' ';
	  if (testElement.innerHTML === '') {
	    setInnerHTML = function(node, html) {
	      // Magic theory: IE8 supposedly differentiates between added and updated
	      // nodes when processing innerHTML, innerHTML on updated nodes suffers
	      // from worse whitespace behavior. Re-adding a node like this triggers
	      // the initial and more favorable whitespace behavior.
	      // TODO: What to do on a detached node?
	      if (node.parentNode) {
	        node.parentNode.replaceChild(node, node);
	      }
	
	      // We also implement a workaround for non-visible tags disappearing into
	      // thin air on IE8, this only happens if there is no visible text
	      // in-front of the non-visible tags. Piggyback on the whitespace fix
	      // and simply check if any non-visible tags appear in the source.
	      if (WHITESPACE_TEST.test(html) ||
	          html[0] === '<' && NONVISIBLE_TEST.test(html)) {
	        // Recover leading whitespace by temporarily prepending any character.
	        // \uFEFF has the potential advantage of being zero-width/invisible.
	        node.innerHTML = '\uFEFF' + html;
	
	        // deleteData leaves an empty `TextNode` which offsets the index of all
	        // children. Definitely want to avoid this.
	        var textNode = node.firstChild;
	        if (textNode.data.length === 1) {
	          node.removeChild(textNode);
	        } else {
	          textNode.deleteData(0, 1);
	        }
	      } else {
	        node.innerHTML = html;
	      }
	    };
	  }
	}
	
	module.exports = setInnerHTML;


/***/ },
/* 102 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule shouldUpdateReactComponent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var warning = __webpack_require__(6);
	
	/**
	 * Given a `prevElement` and `nextElement`, determines if the existing
	 * instance should be updated as opposed to being destroyed or replaced by a new
	 * instance. Both arguments are elements. This ensures that this logic can
	 * operate on stateless trees without any backing instance.
	 *
	 * @param {?object} prevElement
	 * @param {?object} nextElement
	 * @return {boolean} True if the existing instance should be updated.
	 * @protected
	 */
	function shouldUpdateReactComponent(prevElement, nextElement) {
	  if (prevElement != null && nextElement != null) {
	    var prevType = typeof prevElement;
	    var nextType = typeof nextElement;
	    if (prevType === 'string' || prevType === 'number') {
	      return (nextType === 'string' || nextType === 'number');
	    } else {
	      if (nextType === 'object' &&
	          prevElement.type === nextElement.type &&
	          prevElement.key === nextElement.key) {
	        var ownersMatch = prevElement._owner === nextElement._owner;
	        var prevName = null;
	        var nextName = null;
	        var nextDisplayName = null;
	        if (false) {
	          if (!ownersMatch) {
	            if (prevElement._owner != null &&
	                prevElement._owner.getPublicInstance() != null &&
	                prevElement._owner.getPublicInstance().constructor != null) {
	              prevName =
	                prevElement._owner.getPublicInstance().constructor.displayName;
	            }
	            if (nextElement._owner != null &&
	                nextElement._owner.getPublicInstance() != null &&
	                nextElement._owner.getPublicInstance().constructor != null) {
	              nextName =
	                nextElement._owner.getPublicInstance().constructor.displayName;
	            }
	            if (nextElement.type != null &&
	                nextElement.type.displayName != null) {
	              nextDisplayName = nextElement.type.displayName;
	            }
	            if (nextElement.type != null && typeof nextElement.type === 'string') {
	              nextDisplayName = nextElement.type;
	            }
	            if (typeof nextElement.type !== 'string' ||
	                nextElement.type === 'input' ||
	                nextElement.type === 'textarea') {
	              if ((prevElement._owner != null &&
	                  prevElement._owner._isOwnerNecessary === false) ||
	                  (nextElement._owner != null &&
	                  nextElement._owner._isOwnerNecessary === false)) {
	                if (prevElement._owner != null) {
	                  prevElement._owner._isOwnerNecessary = true;
	                }
	                if (nextElement._owner != null) {
	                  nextElement._owner._isOwnerNecessary = true;
	                }
	                ("production" !== process.env.NODE_ENV ? warning(
	                  false,
	                  '<%s /> is being rendered by both %s and %s using the same ' +
	                  'key (%s) in the same place. Currently, this means that ' +
	                  'they don\'t preserve state. This behavior should be very ' +
	                  'rare so we\'re considering deprecating it. Please contact ' +
	                  'the React team and explain your use case so that we can ' +
	                  'take that into consideration.',
	                  nextDisplayName || 'Unknown Component',
	                  prevName || '[Unknown]',
	                  nextName || '[Unknown]',
	                  prevElement.key
	                ) : null);
	              }
	            }
	          }
	        }
	        return ownersMatch;
	      }
	    }
	  }
	  return false;
	}
	
	module.exports = shouldUpdateReactComponent;


/***/ },
/* 103 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var ItemTypes = {
	  KNIGHT: 'knight'
	};
	exports.ItemTypes = ItemTypes;

/***/ },
/* 104 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	
	var _slicedToArray = (function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i['return']) _i['return'](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError('Invalid attempt to destructure non-iterable instance'); } }; })();
	
	exports.observe = observe;
	exports.canMoveKnight = canMoveKnight;
	exports.moveKnight = moveKnight;
	var knightPosition = [1, 7];
	var observer = null;
	
	function emitChange() {
	  observer(knightPosition);
	}
	
	function observe(o) {
	  if (observer) {
	    throw new Error('Multiple observers not implemented.');
	  }
	
	  observer = o;
	  emitChange();
	
	  return function () {
	    observer = null;
	  };
	}
	
	function canMoveKnight(toX, toY) {
	  var _knightPosition = knightPosition;
	
	  var _knightPosition2 = _slicedToArray(_knightPosition, 2);
	
	  var x = _knightPosition2[0];
	  var y = _knightPosition2[1];
	
	  var dx = toX - x;
	  var dy = toY - y;
	
	  return Math.abs(dx) === 2 && Math.abs(dy) === 1 || Math.abs(dx) === 1 && Math.abs(dy) === 2;
	}
	
	function moveKnight(toX, toY) {
	  knightPosition = [toX, toY];
	  emitChange();
	}

/***/ },
/* 105 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = {
	  BOX: 'box'
	};
	module.exports = exports['default'];

/***/ },
/* 106 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _shouldPureComponentUpdate = __webpack_require__(38);
	
	var _shouldPureComponentUpdate2 = _interopRequireDefault(_shouldPureComponentUpdate);
	
	var styles = {
	  border: '1px dashed gray',
	  padding: '0.5rem 1rem',
	  cursor: 'move'
	};
	
	var Box = (function () {
	  function Box() {
	    _classCallCheck(this, Box);
	
	    this.shouldComponentUpdate = _shouldPureComponentUpdate2['default'];
	  }
	
	  Box.prototype.render = function render() {
	    var _props = this.props;
	    var title = _props.title;
	    var yellow = _props.yellow;
	
	    var backgroundColor = yellow ? 'yellow' : 'white';
	
	    return _react2['default'].createElement(
	      'div',
	      { style: _extends({}, styles, { backgroundColor: backgroundColor }) },
	      title
	    );
	  };
	
	  _createClass(Box, null, [{
	    key: 'propTypes',
	    value: {
	      title: _react.PropTypes.string.isRequired,
	      yellow: _react.PropTypes.bool
	    },
	    enumerable: true
	  }]);
	
	  return Box;
	})();
	
	exports['default'] = Box;
	module.exports = exports['default'];

/***/ },
/* 107 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = snapToGrid;
	
	function snapToGrid(x, y) {
	  x = Math.round(x / 32) * 32;
	  y = Math.round(y / 32) * 32;
	
	  return [x, y];
	}
	
	module.exports = exports["default"];

/***/ },
/* 108 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = {
	  BOX: 'box'
	};
	module.exports = exports['default'];

/***/ },
/* 109 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = {
	  BOX: 'box'
	};
	module.exports = exports['default'];

/***/ },
/* 110 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = {
	  CARD: 'card'
	};
	module.exports = exports['default'];

/***/ },
/* 111 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _shouldPureComponentUpdate = __webpack_require__(49);
	
	var _shouldPureComponentUpdate2 = _interopRequireDefault(_shouldPureComponentUpdate);
	
	var _ItemTypes = __webpack_require__(69);
	
	var _ItemTypes2 = _interopRequireDefault(_ItemTypes);
	
	var _reactDnd = __webpack_require__(3);
	
	var _reactDndModulesBackendsHTML5 = __webpack_require__(10);
	
	var style = {
	  border: '1px dashed gray',
	  padding: '0.5rem 1rem',
	  marginBottom: '.5rem',
	  backgroundColor: 'white',
	  cursor: 'move',
	  minWidth: '200px'
	};
	
	var cardSource = {
	  beginDrag: function beginDrag(props) {
	    props.selectCard({ dragging: true }, props.id);
	    return { id: props.id };
	  },
	  endDrag: function endDrag(props, monitor) {
	    var didDrop = monitor.didDrop();
	
	    if (didDrop) {
	      props.completeBoxMove();
	    } else {
	      props.moveRecentCardsBackFromBox();
	    }
	  }
	};
	
	//const cardSource = {
	//  beginDrag(props) {
	//    const { id, text, left, top } = props;
	//    return { id, text, left, top };  }
	//};
	//
	//function getStyles(props) {
	//  const { left, top, isDragging } = props;
	//  const transform = `translate3d(${left}px, ${top}px, 0)`;
	//
	//  return {
	//    border: '1px dashed gray',
	//    padding: '0.5rem 1rem',
	//    marginBottom: '.5rem',
	//    backgroundColor: 'white',
	//    cursor: 'move',
	//    // position: 'absolute',
	//    // transform: transform,
	//    // WebkitTransform: transform,
	//    // IE fallback: hide the real node using CSS when dragging
	//    // because IE will ignore our custom "empty image" drag preview.
	//    opacity: isDragging ? 0 : 1,
	//    height: isDragging ? 0 : ''
	//  };
	//}
	
	var cardTarget = {
	  canDrop: function canDrop() {
	    return false;
	  },
	  hover: function hover(props, monitor) {
	    props.moveRecentCardsBackFromBox();
	  }
	};
	
	var Card = (function () {
	  function Card() {
	    _classCallCheck(this, _Card);
	  }
	
	  Card.prototype.render = function render() {
	    var _this = this;
	
	    var _props = this.props;
	    var text = _props.text;
	    var isDragging = _props.isDragging;
	    var connectDragSource = _props.connectDragSource;
	    var connectDropTarget = _props.connectDropTarget;
	    var selectCard = _props.selectCard;
	    var debounceTouch = _props.debounceTouch;
	    var selected = _props.selected;
	    var supportsTouch = _props.supportsTouch;
	    var isAnchor = _props.isAnchor;
	
	    var opacity = isDragging ? 0 : 1;
	    var backgroundColor = isAnchor ? 'lightgreen' : selected ? 'lightblue' : style.backgroundColor;
	    //      <div style={ getStyles(this.props) }>
	    var clickTouchEvent = supportsTouch ? { onTouchStart: function onTouchStart(e) {
	        return debounceTouch(e, _this.props.id);
	      } } : { onClick: function onClick(e) {
	        return selectCard(e, _this.props.id);
	      } };
	    var tmp = connectDragSource(connectDropTarget(_react2['default'].createElement(
	      'div',
	      _extends({}, clickTouchEvent, { style: _extends({}, style, { opacity: opacity, backgroundColor: backgroundColor }) }),
	      text
	    )));
	    return tmp;
	  };
	
	  _createClass(Card, null, [{
	    key: 'propTypes',
	    value: {
	      connectDragSource: _react.PropTypes.func.isRequired,
	      connectDropTarget: _react.PropTypes.func.isRequired,
	      isDragging: _react.PropTypes.bool.isRequired,
	      id: _react.PropTypes.any.isRequired,
	      text: _react.PropTypes.string.isRequired,
	      moveRecentCardsBackFromBox: _react.PropTypes.func.isRequired,
	      completeBoxMove: _react.PropTypes.func.isRequired,
	      selectCard: _react.PropTypes.func.isRequired,
	      selected: _react.PropTypes.bool.isRequired,
	      left: _react.PropTypes.number.isRequired,
	      top: _react.PropTypes.number.isRequired,
	      supportsTouch: _react.PropTypes.bool.isRequired,
	      isAnchor: _react.PropTypes.bool.isRequired
	    },
	    enumerable: true
	  }]);
	
	  var _Card = Card;
	  Card = _reactDnd.DragSource(_ItemTypes2['default'].CARD, cardSource, function (connect, monitor) {
	    return {
	      connectDragSource: connect.dragSource(),
	      isDragging: monitor.isDragging()
	    };
	  })(Card) || Card;
	  Card = _reactDnd.DropTarget(_ItemTypes2['default'].CARD, cardTarget, function (connect) {
	    return {
	      connectDropTarget: connect.dropTarget()
	    };
	  })(Card) || Card;
	  return Card;
	})();
	
	exports['default'] = Card;
	module.exports = exports['default'];

/***/ },
/* 112 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = {
	  BOX: 'box'
	};
	module.exports = exports['default'];

/***/ },
/* 113 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = {
	  BOX: 'box'
	};
	module.exports = exports['default'];

/***/ },
/* 114 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = SupportsTouch;
	function testStyles(rule, callback, nodes, testnames) {
	  var mod = 'modernizr';
	  var style;
	  var ret;
	  var node;
	  var docOverflow;
	  var div = document.createElement('div');
	  var body = document.body;
	
	  if (parseInt(nodes, 10)) {
	    // In order not to give false positives we create a node for each test
	    // This also allows the method to scale for unspecified uses
	    while (nodes--) {
	      node = document.createElement('div');
	      node.id = testnames ? testnames[nodes] : mod + (nodes + 1);
	      div.appendChild(node);
	    }
	  }
	
	  // <style> elements in IE6-9 are considered 'NoScope' elements and therefore will be removed
	  // when injected with innerHTML. To get around this you need to prepend the 'NoScope' element
	  // with a 'scoped' element, in our case the soft-hyphen entity as it won't mess with our measurements.
	  // msdn.microsoft.com/en-us/library/ms533897%28VS.85%29.aspx
	  // Documents served as xml will throw if using &shy; so use xml friendly encoded version. See issue #277
	  style = ['&#173;', '<style id="s', mod, '">', rule, '</style>'].join('');
	  div.id = mod;
	  // IE6 will false positive on some tests due to the style element inside the test div somehow interfering offsetHeight, so insert it into body or fakebody.
	  // Opera will act all quirky when injecting elements in documentElement when page is served as xml, needs fakebody too. #270
	  (!body.fake ? div : body).innerHTML += style;
	  body.appendChild(div);
	  if (body.fake) {
	    //avoid crashing IE8, if background image is used
	    body.style.background = '';
	    //Safari 5.13/5.1.4 OSX stops loading if ::-webkit-scrollbar is used and scrollbars are visible
	    body.style.overflow = 'hidden';
	    docOverflow = docElement.style.overflow;
	    docElement.style.overflow = 'hidden';
	    docElement.appendChild(body);
	  }
	
	  ret = callback(div, rule);
	  // If this is done after page load we don't want to remove the body so check if body exists
	  if (body.fake) {
	    body.parentNode.removeChild(body);
	    docElement.style.overflow = docOverflow;
	    // Trigger layout so kinetic scrolling isn't disabled in iOS6+
	    docElement.offsetHeight;
	  } else {
	    div.parentNode.removeChild(div);
	  }
	
	  return !!ret;
	}
	
	function SupportsTouch() {
	  var supports = undefined;
	  if (typeof window !== "undefined") {
	    if ('ontouchstart' in window || window.DocumentTouch && document instanceof DocumentTouch) {
	      supports = true;
	    } else {
	      var prefixes = ' -webkit- -moz- -o- -ms- '.split(' ');
	      var query = ['@media (', prefixes.join('touch-enabled),('), 'heartz', ')', '{#modernizr{top:9px;position:absolute}}'].join('');
	      testStyles(query, function (node) {
	        supports = node.offsetTop === 9;
	      });
	    }
	  } else {
	    supports = false;
	  }
	  return supports;
	}
	
	module.exports = exports['default'];

/***/ },
/* 115 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(283);
	
	var SideBar = (function () {
	  function SideBar() {
	    _classCallCheck(this, SideBar);
	  }
	
	  SideBar.prototype.render = function render() {
	    return _react2['default'].createElement(
	      'div',
	      { className: 'SideBar' },
	      _react2['default'].createElement(
	        'div',
	        { className: 'SideBar-content' },
	        this.props.groups.map(this.renderGroup, this)
	      )
	    );
	  };
	
	  SideBar.prototype.renderGroup = function renderGroup(_ref, index) {
	    var _this = this;
	
	    var title = _ref.title;
	    var pages = _ref.pages;
	
	    return _react2['default'].createElement(
	      'div',
	      { className: 'SideBar-group', key: index },
	      _react2['default'].createElement(
	        'h4',
	        { className: 'SideBar-groupTitle' },
	        title
	      ),
	      Object.keys(pages).map(function (key) {
	        return _this.renderLink(pages[key], key);
	      })
	    );
	  };
	
	  SideBar.prototype.renderLink = function renderLink(_ref2, key) {
	    var title = _ref2.title;
	    var location = _ref2.location;
	
	    var arrow = _react2['default'].createElement('span', { className: 'arrowBullet' });
	
	    var linkClass = 'SideBar-item';
	    if (this.props.example.location === location) {
	      linkClass += ' SideBar-item--selected';
	    }
	
	    return _react2['default'].createElement(
	      'a',
	      { key: key, href: location, target: '_self', className: linkClass },
	      _react2['default'].createElement(
	        'span',
	        { className: 'SideBar-itemText' },
	        title
	      ),
	      arrow
	    );
	  };
	
	  return SideBar;
	})();
	
	exports['default'] = SideBar;
	module.exports = exports['default'];

/***/ },
/* 116 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	exports['default'] = decorateHandler;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _disposables = __webpack_require__(73);
	
	var _utilsShallowEqual = __webpack_require__(29);
	
	var _utilsShallowEqual2 = _interopRequireDefault(_utilsShallowEqual);
	
	var _utilsShallowEqualScalar = __webpack_require__(52);
	
	var _utilsShallowEqualScalar2 = _interopRequireDefault(_utilsShallowEqualScalar);
	
	var _lodashLangIsPlainObject = __webpack_require__(31);
	
	var _lodashLangIsPlainObject2 = _interopRequireDefault(_lodashLangIsPlainObject);
	
	var _invariant = __webpack_require__(9);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _bindConnector2 = __webpack_require__(239);
	
	var _bindConnector3 = _interopRequireDefault(_bindConnector2);
	
	function decorateHandler(_ref) {
	  var DecoratedComponent = _ref.DecoratedComponent;
	  var createHandler = _ref.createHandler;
	  var createMonitor = _ref.createMonitor;
	  var createConnector = _ref.createConnector;
	  var registerHandler = _ref.registerHandler;
	  var containerDisplayName = _ref.containerDisplayName;
	  var getType = _ref.getType;
	  var collect = _ref.collect;
	  var options = _ref.options;
	  var _options$arePropsEqual = options.arePropsEqual;
	  var arePropsEqual = _options$arePropsEqual === undefined ? _utilsShallowEqualScalar2['default'] : _options$arePropsEqual;
	
	  var displayName = DecoratedComponent.displayName || DecoratedComponent.name || 'Component';
	
	  return (function (_Component) {
	    _inherits(DragDropContainer, _Component);
	
	    DragDropContainer.prototype.getHandlerId = function getHandlerId() {
	      return this.handlerId;
	    };
	
	    DragDropContainer.prototype.getDecoratedComponentInstance = function getDecoratedComponentInstance() {
	      return this.decoratedComponentInstance;
	    };
	
	    DragDropContainer.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
	      return !arePropsEqual(nextProps, this.props) || !_utilsShallowEqual2['default'](nextState, this.state);
	    };
	
	    _createClass(DragDropContainer, null, [{
	      key: 'DecoratedComponent',
	      value: DecoratedComponent,
	      enumerable: true
	    }, {
	      key: 'displayName',
	      value: containerDisplayName + '(' + displayName + ')',
	      enumerable: true
	    }, {
	      key: 'contextTypes',
	      value: {
	        dragDropManager: _react.PropTypes.object.isRequired
	      },
	      enumerable: true
	    }]);
	
	    function DragDropContainer(props, context) {
	      _classCallCheck(this, DragDropContainer);
	
	      _Component.call(this, props, context);
	      this.handleChange = this.handleChange.bind(this);
	      this.handleChildRef = this.handleChildRef.bind(this);
	
	      _invariant2['default'](typeof this.context.dragDropManager === 'object', 'Could not find the drag and drop manager in the context of %s. ' + 'Make sure to wrap the top-level component of your app with DragDropContext. ' + 'Read more: http://pljenkins.github.io/react-dnd/docs-troubleshooting.html#could-not-find-the-drag-and-drop-manager-in-the-context', displayName, displayName);
	
	      this.manager = this.context.dragDropManager;
	      this.handlerMonitor = createMonitor(this.manager);
	      this.handler = createHandler(this.handlerMonitor);
	      this.disposable = new _disposables.SerialDisposable();
	
	      this.receiveProps(props);
	      this.state = this.getCurrentState();
	    }
	
	    DragDropContainer.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	      if (!arePropsEqual(nextProps, this.props)) {
	        this.receiveProps(nextProps);
	        this.handleChange();
	      }
	    };
	
	    DragDropContainer.prototype.componentWillUnmount = function componentWillUnmount() {
	      this.disposable.dispose();
	    };
	
	    DragDropContainer.prototype.receiveProps = function receiveProps(props) {
	      this.handler.receiveProps(props);
	      this.receiveType(getType(props));
	    };
	
	    DragDropContainer.prototype.receiveType = function receiveType(type) {
	      if (type === this.currentType) {
	        return;
	      }
	
	      this.currentType = type;
	
	      var _registerHandler = registerHandler(type, this.handler, this.manager);
	
	      var handlerId = _registerHandler.handlerId;
	      var unregister = _registerHandler.unregister;
	
	      var connector = createConnector(this.manager.getBackend());
	
	      var _bindConnector = _bindConnector3['default'](connector, handlerId);
	
	      var handlerConnector = _bindConnector.handlerConnector;
	      var connectorDisposable = _bindConnector.disposable;
	
	      var globalMonitor = this.manager.getMonitor();
	      var unsubscribe = globalMonitor.subscribeToStateChange(this.handleChange, { handlerIds: [handlerId] });
	
	      this.disposable.setDisposable(new _disposables.CompositeDisposable(new _disposables.Disposable(unregister), new _disposables.Disposable(unsubscribe), connectorDisposable));
	
	      this.handlerMonitor.receiveHandlerId(handlerId);
	      this.handlerConnector = handlerConnector;
	      this.handlerId = handlerId;
	    };
	
	    DragDropContainer.prototype.handleChange = function handleChange() {
	      var nextState = this.getCurrentState();
	      if (!_utilsShallowEqual2['default'](nextState, this.state)) {
	        this.setState(nextState);
	      }
	    };
	
	    DragDropContainer.prototype.handleChildRef = function handleChildRef(component) {
	      this.decoratedComponentInstance = component;
	      this.handler.receiveComponent(component);
	    };
	
	    DragDropContainer.prototype.getCurrentState = function getCurrentState() {
	      var nextState = collect(this.handlerConnector, this.handlerMonitor);
	      if (false) {
	        _invariant2['default'](_lodashLangIsPlainObject2['default'](nextState), 'Expected `collect` specified as the second argument to ' + '%s for %s to return a plain object of props to inject. ' + 'Instead, received %s.', containerDisplayName, displayName, nextState);
	      }
	      return nextState;
	    };
	
	    DragDropContainer.prototype.render = function render() {
	      return _react2['default'].createElement(DecoratedComponent, _extends({}, this.props, this.state, {
	        ref: this.handleChildRef }));
	    };
	
	    return DragDropContainer;
	  })(_react.Component);
	}
	
	module.exports = exports['default'];

/***/ },
/* 117 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _lodashFunctionMemoize = __webpack_require__(351);
	
	var _lodashFunctionMemoize2 = _interopRequireDefault(_lodashFunctionMemoize);
	
	var isFirefox = _lodashFunctionMemoize2['default'](function () {
	  return (/firefox/i.test(navigator.userAgent)
	  );
	});
	
	exports.isFirefox = isFirefox;
	var isSafari = _lodashFunctionMemoize2['default'](function () {
	  return Boolean(window.safari);
	});
	exports.isSafari = isSafari;

/***/ },
/* 118 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.getElementClientOffset = getElementClientOffset;
	exports.getEventClientOffset = getEventClientOffset;
	exports.getDragPreviewOffset = getDragPreviewOffset;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _BrowserDetector = __webpack_require__(117);
	
	var _createMonotonicInterpolant = __webpack_require__(251);
	
	var _createMonotonicInterpolant2 = _interopRequireDefault(_createMonotonicInterpolant);
	
	var ELEMENT_NODE = 1;
	
	function getElementClientOffset(el) {
	  if (el.nodeType !== ELEMENT_NODE) {
	    el = el.parentElement;
	  }
	
	  if (!el) {
	    return null;
	  }
	
	  var _el$getBoundingClientRect = el.getBoundingClientRect();
	
	  var top = _el$getBoundingClientRect.top;
	  var left = _el$getBoundingClientRect.left;
	
	  return { x: left, y: top };
	}
	
	function getEventClientOffset(e) {
	  return {
	    x: e.clientX,
	    y: e.clientY
	  };
	}
	
	function getDragPreviewOffset(sourceNode, dragPreview, clientOffset, anchorPoint) {
	  // The browsers will use the image intrinsic size under different conditions.
	  // Firefox only cares if it's an image, but WebKit also wants it to be detached.
	  var isImage = dragPreview.nodeName === 'IMG' && (_BrowserDetector.isFirefox() || !document.documentElement.contains(dragPreview));
	  var dragPreviewNode = isImage ? sourceNode : dragPreview;
	
	  var dragPreviewNodeOffsetFromClient = getElementClientOffset(dragPreviewNode);
	  var offsetFromDragPreview = {
	    x: clientOffset.x - dragPreviewNodeOffsetFromClient.x,
	    y: clientOffset.y - dragPreviewNodeOffsetFromClient.y
	  };
	
	  var sourceWidth = sourceNode.offsetWidth;
	  var sourceHeight = sourceNode.offsetHeight;
	  var anchorX = anchorPoint.anchorX;
	  var anchorY = anchorPoint.anchorY;
	
	  var dragPreviewWidth = isImage ? dragPreview.width : sourceWidth;
	  var dragPreviewHeight = isImage ? dragPreview.height : sourceHeight;
	
	  // Work around @2x coordinate discrepancies in browsers
	  if (_BrowserDetector.isSafari() && isImage) {
	    dragPreviewHeight /= window.devicePixelRatio;
	    dragPreviewWidth /= window.devicePixelRatio;
	  } else if (_BrowserDetector.isFirefox() && !isImage) {
	    dragPreviewHeight *= window.devicePixelRatio;
	    dragPreviewWidth *= window.devicePixelRatio;
	  }
	
	  // Interpolate coordinates depending on anchor point
	  // If you know a simpler way to do this, let me know
	  var interpolateX = _createMonotonicInterpolant2['default']([0, 0.5, 1], [
	  // Dock to the left
	  offsetFromDragPreview.x,
	  // Align at the center
	  offsetFromDragPreview.x / sourceWidth * dragPreviewWidth,
	  // Dock to the right
	  offsetFromDragPreview.x + dragPreviewWidth - sourceWidth]);
	  var interpolateY = _createMonotonicInterpolant2['default']([0, 0.5, 1], [
	  // Dock to the top
	  offsetFromDragPreview.y,
	  // Align at the center
	  offsetFromDragPreview.y / sourceHeight * dragPreviewHeight,
	  // Dock to the bottom
	  offsetFromDragPreview.y + dragPreviewHeight - sourceHeight]);
	  var x = interpolateX(anchorX);
	  var y = interpolateY(anchorY);
	
	  // Work around Safari 8 positioning bug
	  if (_BrowserDetector.isSafari() && isImage) {
	    // We'll have to wait for @3x to see if this is entirely correct
	    y += (window.devicePixelRatio - 1) * dragPreviewHeight;
	  }
	
	  return { x: x, y: y };
	}

/***/ },
/* 119 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = isValidType;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _lodashLangIsArray = __webpack_require__(23);
	
	var _lodashLangIsArray2 = _interopRequireDefault(_lodashLangIsArray);
	
	function isValidType(type, allowArray) {
	       return typeof type === 'string' || typeof type === 'symbol' || allowArray && _lodashLangIsArray2['default'](type) && type.every(function (t) {
	              return isValidType(t, false);
	       });
	}
	
	module.exports = exports['default'];

/***/ },
/* 120 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireWildcard = function (obj) { return obj && obj.__esModule ? obj : { 'default': obj }; };
	
	exports.__esModule = true;
	exports['default'] = matchesType;
	
	var _isArray = __webpack_require__(23);
	
	var _isArray2 = _interopRequireWildcard(_isArray);
	
	function matchesType(targetType, draggedItemType) {
	  if (_isArray2['default'](targetType)) {
	    return targetType.some(function (t) {
	      return t === draggedItemType;
	    });
	  } else {
	    return targetType === draggedItemType;
	  }
	}
	
	module.exports = exports['default'];

/***/ },
/* 121 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Representation of a single EventEmitter function.
	 *
	 * @param {Function} fn Event handler to be called.
	 * @param {Mixed} context Context for function execution.
	 * @param {Boolean} once Only emit once
	 * @api private
	 */
	function EE(fn, context, once) {
	  this.fn = fn;
	  this.context = context;
	  this.once = once || false;
	}
	
	/**
	 * Minimal EventEmitter interface that is molded against the Node.js
	 * EventEmitter interface.
	 *
	 * @constructor
	 * @api public
	 */
	function EventEmitter() { /* Nothing to set */ }
	
	/**
	 * Holds the assigned EventEmitters by name.
	 *
	 * @type {Object}
	 * @private
	 */
	EventEmitter.prototype._events = undefined;
	
	/**
	 * Return a list of assigned event listeners.
	 *
	 * @param {String} event The events that should be listed.
	 * @returns {Array}
	 * @api public
	 */
	EventEmitter.prototype.listeners = function listeners(event) {
	  if (!this._events || !this._events[event]) return [];
	  if (this._events[event].fn) return [this._events[event].fn];
	
	  for (var i = 0, l = this._events[event].length, ee = new Array(l); i < l; i++) {
	    ee[i] = this._events[event][i].fn;
	  }
	
	  return ee;
	};
	
	/**
	 * Emit an event to all registered event listeners.
	 *
	 * @param {String} event The name of the event.
	 * @returns {Boolean} Indication if we've emitted an event.
	 * @api public
	 */
	EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
	  if (!this._events || !this._events[event]) return false;
	
	  var listeners = this._events[event]
	    , len = arguments.length
	    , args
	    , i;
	
	  if ('function' === typeof listeners.fn) {
	    if (listeners.once) this.removeListener(event, listeners.fn, true);
	
	    switch (len) {
	      case 1: return listeners.fn.call(listeners.context), true;
	      case 2: return listeners.fn.call(listeners.context, a1), true;
	      case 3: return listeners.fn.call(listeners.context, a1, a2), true;
	      case 4: return listeners.fn.call(listeners.context, a1, a2, a3), true;
	      case 5: return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
	      case 6: return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
	    }
	
	    for (i = 1, args = new Array(len -1); i < len; i++) {
	      args[i - 1] = arguments[i];
	    }
	
	    listeners.fn.apply(listeners.context, args);
	  } else {
	    var length = listeners.length
	      , j;
	
	    for (i = 0; i < length; i++) {
	      if (listeners[i].once) this.removeListener(event, listeners[i].fn, true);
	
	      switch (len) {
	        case 1: listeners[i].fn.call(listeners[i].context); break;
	        case 2: listeners[i].fn.call(listeners[i].context, a1); break;
	        case 3: listeners[i].fn.call(listeners[i].context, a1, a2); break;
	        default:
	          if (!args) for (j = 1, args = new Array(len -1); j < len; j++) {
	            args[j - 1] = arguments[j];
	          }
	
	          listeners[i].fn.apply(listeners[i].context, args);
	      }
	    }
	  }
	
	  return true;
	};
	
	/**
	 * Register a new EventListener for the given event.
	 *
	 * @param {String} event Name of the event.
	 * @param {Functon} fn Callback function.
	 * @param {Mixed} context The context of the function.
	 * @api public
	 */
	EventEmitter.prototype.on = function on(event, fn, context) {
	  var listener = new EE(fn, context || this);
	
	  if (!this._events) this._events = {};
	  if (!this._events[event]) this._events[event] = listener;
	  else {
	    if (!this._events[event].fn) this._events[event].push(listener);
	    else this._events[event] = [
	      this._events[event], listener
	    ];
	  }
	
	  return this;
	};
	
	/**
	 * Add an EventListener that's only called once.
	 *
	 * @param {String} event Name of the event.
	 * @param {Function} fn Callback function.
	 * @param {Mixed} context The context of the function.
	 * @api public
	 */
	EventEmitter.prototype.once = function once(event, fn, context) {
	  var listener = new EE(fn, context || this, true);
	
	  if (!this._events) this._events = {};
	  if (!this._events[event]) this._events[event] = listener;
	  else {
	    if (!this._events[event].fn) this._events[event].push(listener);
	    else this._events[event] = [
	      this._events[event], listener
	    ];
	  }
	
	  return this;
	};
	
	/**
	 * Remove event listeners.
	 *
	 * @param {String} event The event we want to remove.
	 * @param {Function} fn The listener that we need to find.
	 * @param {Boolean} once Only remove once listeners.
	 * @api public
	 */
	EventEmitter.prototype.removeListener = function removeListener(event, fn, once) {
	  if (!this._events || !this._events[event]) return this;
	
	  var listeners = this._events[event]
	    , events = [];
	
	  if (fn) {
	    if (listeners.fn && (listeners.fn !== fn || (once && !listeners.once))) {
	      events.push(listeners);
	    }
	    if (!listeners.fn) for (var i = 0, length = listeners.length; i < length; i++) {
	      if (listeners[i].fn !== fn || (once && !listeners[i].once)) {
	        events.push(listeners[i]);
	      }
	    }
	  }
	
	  //
	  // Reset the array, or remove it completely if we have no more listeners.
	  //
	  if (events.length) {
	    this._events[event] = events.length === 1 ? events[0] : events;
	  } else {
	    delete this._events[event];
	  }
	
	  return this;
	};
	
	/**
	 * Remove all listeners or only the listeners for the specified event.
	 *
	 * @param {String} event The event want to remove all listeners for.
	 * @api public
	 */
	EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
	  if (!this._events) return this;
	
	  if (event) delete this._events[event];
	  else this._events = {};
	
	  return this;
	};
	
	//
	// Alias methods names because people roll like that.
	//
	EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
	EventEmitter.prototype.addListener = EventEmitter.prototype.on;
	
	//
	// This function doesn't apply anymore.
	//
	EventEmitter.prototype.setMaxListeners = function setMaxListeners() {
	  return this;
	};
	
	//
	// Expose the module.
	//
	EventEmitter.EventEmitter = EventEmitter;
	EventEmitter.EventEmitter2 = EventEmitter;
	EventEmitter.EventEmitter3 = EventEmitter;
	
	//
	// Expose the module.
	//
	module.exports = EventEmitter;


/***/ },
/* 122 */
/***/ function(module, exports, __webpack_require__) {

	var baseDifference = __webpack_require__(124),
	    isArrayLike = __webpack_require__(22),
	    restParam = __webpack_require__(39);
	
	/**
	 * Creates an array excluding all provided values using
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	 * for equality comparisons.
	 *
	 * @static
	 * @memberOf _
	 * @category Array
	 * @param {Array} array The array to filter.
	 * @param {...*} [values] The values to exclude.
	 * @returns {Array} Returns the new array of filtered values.
	 * @example
	 *
	 * _.without([1, 2, 1, 3], 1, 2);
	 * // => [3]
	 */
	var without = restParam(function(array, values) {
	  return isArrayLike(array)
	    ? baseDifference(array, values)
	    : [];
	});
	
	module.exports = without;


/***/ },
/* 123 */
/***/ function(module, exports) {

	/**
	 * Appends the elements of `values` to `array`.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {Array} values The values to append.
	 * @returns {Array} Returns `array`.
	 */
	function arrayPush(array, values) {
	  var index = -1,
	      length = values.length,
	      offset = array.length;
	
	  while (++index < length) {
	    array[offset + index] = values[index];
	  }
	  return array;
	}
	
	module.exports = arrayPush;


/***/ },
/* 124 */
/***/ function(module, exports, __webpack_require__) {

	var baseIndexOf = __webpack_require__(75),
	    cacheIndexOf = __webpack_require__(76),
	    createCache = __webpack_require__(77);
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/**
	 * The base implementation of `_.difference` which accepts a single array
	 * of values to exclude.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Array} values The values to exclude.
	 * @returns {Array} Returns the new array of filtered values.
	 */
	function baseDifference(array, values) {
	  var length = array ? array.length : 0,
	      result = [];
	
	  if (!length) {
	    return result;
	  }
	  var index = -1,
	      indexOf = baseIndexOf,
	      isCommon = true,
	      cache = (isCommon && values.length >= LARGE_ARRAY_SIZE) ? createCache(values) : null,
	      valuesLength = values.length;
	
	  if (cache) {
	    indexOf = cacheIndexOf;
	    isCommon = false;
	    values = cache;
	  }
	  outer:
	  while (++index < length) {
	    var value = array[index];
	
	    if (isCommon && value === value) {
	      var valuesIndex = valuesLength;
	      while (valuesIndex--) {
	        if (values[valuesIndex] === value) {
	          continue outer;
	        }
	      }
	      result.push(value);
	    }
	    else if (indexOf(values, value, 0) < 0) {
	      result.push(value);
	    }
	  }
	  return result;
	}
	
	module.exports = baseDifference;


/***/ },
/* 125 */
/***/ function(module, exports, __webpack_require__) {

	var baseIndexOf = __webpack_require__(75),
	    cacheIndexOf = __webpack_require__(76),
	    createCache = __webpack_require__(77);
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/**
	 * The base implementation of `_.uniq` without support for callback shorthands
	 * and `this` binding.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Function} [iteratee] The function invoked per iteration.
	 * @returns {Array} Returns the new duplicate free array.
	 */
	function baseUniq(array, iteratee) {
	  var index = -1,
	      indexOf = baseIndexOf,
	      length = array.length,
	      isCommon = true,
	      isLarge = isCommon && length >= LARGE_ARRAY_SIZE,
	      seen = isLarge ? createCache() : null,
	      result = [];
	
	  if (seen) {
	    indexOf = cacheIndexOf;
	    isCommon = false;
	  } else {
	    isLarge = false;
	    seen = iteratee ? [] : result;
	  }
	  outer:
	  while (++index < length) {
	    var value = array[index],
	        computed = iteratee ? iteratee(value, index, array) : value;
	
	    if (isCommon && value === value) {
	      var seenIndex = seen.length;
	      while (seenIndex--) {
	        if (seen[seenIndex] === computed) {
	          continue outer;
	        }
	      }
	      if (iteratee) {
	        seen.push(computed);
	      }
	      result.push(value);
	    }
	    else if (indexOf(seen, computed, 0) < 0) {
	      if (iteratee || isLarge) {
	        seen.push(computed);
	      }
	      result.push(value);
	    }
	  }
	  return result;
	}
	
	module.exports = baseUniq;


/***/ },
/* 126 */
/***/ function(module, exports, __webpack_require__) {

	var baseProperty = __webpack_require__(363);
	
	/**
	 * Gets the "length" property value of `object`.
	 *
	 * **Note:** This function is used to avoid a [JIT bug](https://bugs.webkit.org/show_bug.cgi?id=142792)
	 * that affects Safari on at least iOS 8.1-8.3 ARM64.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {*} Returns the "length" value.
	 */
	var getLength = baseProperty('length');
	
	module.exports = getLength;


/***/ },
/* 127 */
/***/ function(module, exports, __webpack_require__) {

	var isArrayLike = __webpack_require__(22),
	    isIndex = __webpack_require__(78),
	    isObject = __webpack_require__(15);
	
	/**
	 * Checks if the provided arguments are from an iteratee call.
	 *
	 * @private
	 * @param {*} value The potential iteratee value argument.
	 * @param {*} index The potential iteratee index or key argument.
	 * @param {*} object The potential iteratee object argument.
	 * @returns {boolean} Returns `true` if the arguments are from an iteratee call, else `false`.
	 */
	function isIterateeCall(value, index, object) {
	  if (!isObject(object)) {
	    return false;
	  }
	  var type = typeof index;
	  if (type == 'number'
	      ? (isArrayLike(object) && isIndex(index, object.length))
	      : (type == 'string' && index in object)) {
	    var other = object[index];
	    return value === value ? (value === other) : (other !== other);
	  }
	  return false;
	}
	
	module.exports = isIterateeCall;


/***/ },
/* 128 */
/***/ function(module, exports, __webpack_require__) {

	var isArguments = __webpack_require__(56),
	    isArray = __webpack_require__(23),
	    isIndex = __webpack_require__(78),
	    isLength = __webpack_require__(40),
	    isObject = __webpack_require__(15);
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Creates an array of the own and inherited enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keysIn(new Foo);
	 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	 */
	function keysIn(object) {
	  if (object == null) {
	    return [];
	  }
	  if (!isObject(object)) {
	    object = Object(object);
	  }
	  var length = object.length;
	  length = (length && isLength(length) &&
	    (isArray(object) || isArguments(object)) && length) || 0;
	
	  var Ctor = object.constructor,
	      index = -1,
	      isProto = typeof Ctor == 'function' && Ctor.prototype === object,
	      result = Array(length),
	      skipIndexes = length > 0;
	
	  while (++index < length) {
	    result[index] = (index + '');
	  }
	  for (var key in object) {
	    if (!(skipIndexes && isIndex(key, length)) &&
	        !(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = keysIn;


/***/ },
/* 129 */
/***/ function(module, exports, __webpack_require__) {

	var baseValues = __webpack_require__(365),
	    keys = __webpack_require__(79);
	
	/**
	 * Creates an array of the own enumerable property values of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property values.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.values(new Foo);
	 * // => [1, 2] (iteration order is not guaranteed)
	 *
	 * _.values('hi');
	 * // => ['h', 'i']
	 */
	function values(object) {
	  return baseValues(object, keys(object));
	}
	
	module.exports = values;


/***/ },
/* 130 */
/***/ function(module, exports) {

	/**
	 * Represents a cancellation caused by navigating away
	 * before the previous transition has fully resolved.
	 */
	"use strict";
	
	function Cancellation() {}
	
	module.exports = Cancellation;

/***/ },
/* 131 */
/***/ function(module, exports) {

	/**
	 * Encapsulates a redirect to the given route.
	 */
	"use strict";
	
	function Redirect(to, params, query) {
	  this.to = to;
	  this.params = params;
	  this.query = query;
	}
	
	module.exports = Redirect;

/***/ },
/* 132 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var LocationActions = __webpack_require__(42);
	
	/**
	 * A scroll behavior that attempts to imitate the default behavior
	 * of modern browsers.
	 */
	var ImitateBrowserBehavior = {
	
	  updateScrollPosition: function updateScrollPosition(position, actionType) {
	    switch (actionType) {
	      case LocationActions.PUSH:
	      case LocationActions.REPLACE:
	        window.scrollTo(0, 0);
	        break;
	      case LocationActions.POP:
	        if (position) {
	          window.scrollTo(position.x, position.y);
	        } else {
	          window.scrollTo(0, 0);
	        }
	        break;
	    }
	  }
	
	};
	
	module.exports = ImitateBrowserBehavior;

/***/ },
/* 133 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _classCallCheck = function (instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } };
	
	var _inherits = function (subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) subClass.__proto__ = superClass; };
	
	var PropTypes = __webpack_require__(16);
	var RouteHandler = __webpack_require__(58);
	var Route = __webpack_require__(57);
	
	/**
	 * A <DefaultRoute> component is a special kind of <Route> that
	 * renders when its parent matches but none of its siblings do.
	 * Only one such route may be used at any given level in the
	 * route hierarchy.
	 */
	
	var DefaultRoute = (function (_Route) {
	  function DefaultRoute() {
	    _classCallCheck(this, DefaultRoute);
	
	    if (_Route != null) {
	      _Route.apply(this, arguments);
	    }
	  }
	
	  _inherits(DefaultRoute, _Route);
	
	  return DefaultRoute;
	})(Route);
	
	// TODO: Include these in the above class definition
	// once we can use ES7 property initializers.
	// https://github.com/babel/babel/issues/619
	
	DefaultRoute.propTypes = {
	  name: PropTypes.string,
	  path: PropTypes.falsy,
	  children: PropTypes.falsy,
	  handler: PropTypes.func.isRequired
	};
	
	DefaultRoute.defaultProps = {
	  handler: RouteHandler
	};
	
	module.exports = DefaultRoute;

/***/ },
/* 134 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _classCallCheck = function (instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } };
	
	var _inherits = function (subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) subClass.__proto__ = superClass; };
	
	var PropTypes = __webpack_require__(16);
	var RouteHandler = __webpack_require__(58);
	var Route = __webpack_require__(57);
	
	/**
	 * A <NotFoundRoute> is a special kind of <Route> that
	 * renders when the beginning of its parent's path matches
	 * but none of its siblings do, including any <DefaultRoute>.
	 * Only one such route may be used at any given level in the
	 * route hierarchy.
	 */
	
	var NotFoundRoute = (function (_Route) {
	  function NotFoundRoute() {
	    _classCallCheck(this, NotFoundRoute);
	
	    if (_Route != null) {
	      _Route.apply(this, arguments);
	    }
	  }
	
	  _inherits(NotFoundRoute, _Route);
	
	  return NotFoundRoute;
	})(Route);
	
	// TODO: Include these in the above class definition
	// once we can use ES7 property initializers.
	// https://github.com/babel/babel/issues/619
	
	NotFoundRoute.propTypes = {
	  name: PropTypes.string,
	  path: PropTypes.falsy,
	  children: PropTypes.falsy,
	  handler: PropTypes.func.isRequired
	};
	
	NotFoundRoute.defaultProps = {
	  handler: RouteHandler
	};
	
	module.exports = NotFoundRoute;

/***/ },
/* 135 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _classCallCheck = function (instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } };
	
	var _inherits = function (subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) subClass.__proto__ = superClass; };
	
	var PropTypes = __webpack_require__(16);
	var Route = __webpack_require__(57);
	
	/**
	 * A <Redirect> component is a special kind of <Route> that always
	 * redirects to another route when it matches.
	 */
	
	var Redirect = (function (_Route) {
	  function Redirect() {
	    _classCallCheck(this, Redirect);
	
	    if (_Route != null) {
	      _Route.apply(this, arguments);
	    }
	  }
	
	  _inherits(Redirect, _Route);
	
	  return Redirect;
	})(Route);
	
	// TODO: Include these in the above class definition
	// once we can use ES7 property initializers.
	// https://github.com/babel/babel/issues/619
	
	Redirect.propTypes = {
	  path: PropTypes.string,
	  from: PropTypes.string, // Alias for path.
	  to: PropTypes.string,
	  handler: PropTypes.falsy
	};
	
	// Redirects should not have a default handler
	Redirect.defaultProps = {};
	
	module.exports = Redirect;

/***/ },
/* 136 */
/***/ function(module, exports, __webpack_require__) {

	/* jshint -W058 */
	'use strict';
	
	var React = __webpack_require__(1);
	var warning = __webpack_require__(6);
	var invariant = __webpack_require__(2);
	var canUseDOM = __webpack_require__(8).canUseDOM;
	var LocationActions = __webpack_require__(42);
	var ImitateBrowserBehavior = __webpack_require__(132);
	var HashLocation = __webpack_require__(138);
	var HistoryLocation = __webpack_require__(81);
	var RefreshLocation = __webpack_require__(139);
	var StaticLocation = __webpack_require__(140);
	var ScrollHistory = __webpack_require__(388);
	var createRoutesFromReactChildren = __webpack_require__(137);
	var isReactChildren = __webpack_require__(396);
	var Transition = __webpack_require__(390);
	var PropTypes = __webpack_require__(16);
	var Redirect = __webpack_require__(131);
	var History = __webpack_require__(32);
	var Cancellation = __webpack_require__(130);
	var Match = __webpack_require__(386);
	var Route = __webpack_require__(26);
	var supportsHistory = __webpack_require__(399);
	var PathUtils = __webpack_require__(80);
	
	/**
	 * The default location for new routers.
	 */
	var DEFAULT_LOCATION = canUseDOM ? HashLocation : '/';
	
	/**
	 * The default scroll behavior for new routers.
	 */
	var DEFAULT_SCROLL_BEHAVIOR = canUseDOM ? ImitateBrowserBehavior : null;
	
	function hasProperties(object, properties) {
	  for (var propertyName in properties) if (properties.hasOwnProperty(propertyName) && object[propertyName] !== properties[propertyName]) {
	    return false;
	  }return true;
	}
	
	function hasMatch(routes, route, prevParams, nextParams, prevQuery, nextQuery) {
	  return routes.some(function (r) {
	    if (r !== route) return false;
	
	    var paramNames = route.paramNames;
	    var paramName;
	
	    // Ensure that all params the route cares about did not change.
	    for (var i = 0, len = paramNames.length; i < len; ++i) {
	      paramName = paramNames[i];
	
	      if (nextParams[paramName] !== prevParams[paramName]) return false;
	    }
	
	    // Ensure the query hasn't changed.
	    return hasProperties(prevQuery, nextQuery) && hasProperties(nextQuery, prevQuery);
	  });
	}
	
	function addRoutesToNamedRoutes(routes, namedRoutes) {
	  var route;
	  for (var i = 0, len = routes.length; i < len; ++i) {
	    route = routes[i];
	
	    if (route.name) {
	      invariant(namedRoutes[route.name] == null, 'You may not have more than one route named "%s"', route.name);
	
	      namedRoutes[route.name] = route;
	    }
	
	    if (route.childRoutes) addRoutesToNamedRoutes(route.childRoutes, namedRoutes);
	  }
	}
	
	function routeIsActive(activeRoutes, routeName) {
	  return activeRoutes.some(function (route) {
	    return route.name === routeName;
	  });
	}
	
	function paramsAreActive(activeParams, params) {
	  for (var property in params) if (String(activeParams[property]) !== String(params[property])) {
	    return false;
	  }return true;
	}
	
	function queryIsActive(activeQuery, query) {
	  for (var property in query) if (String(activeQuery[property]) !== String(query[property])) {
	    return false;
	  }return true;
	}
	
	/**
	 * Creates and returns a new router using the given options. A router
	 * is a ReactComponent class that knows how to react to changes in the
	 * URL and keep the contents of the page in sync.
	 *
	 * Options may be any of the following:
	 *
	 * - routes           (required) The route config
	 * - location         The location to use. Defaults to HashLocation when
	 *                    the DOM is available, "/" otherwise
	 * - scrollBehavior   The scroll behavior to use. Defaults to ImitateBrowserBehavior
	 *                    when the DOM is available, null otherwise
	 * - onError          A function that is used to handle errors
	 * - onAbort          A function that is used to handle aborted transitions
	 *
	 * When rendering in a server-side environment, the location should simply
	 * be the URL path that was used in the request, including the query string.
	 */
	function createRouter(options) {
	  options = options || {};
	
	  if (isReactChildren(options)) options = { routes: options };
	
	  var mountedComponents = [];
	  var location = options.location || DEFAULT_LOCATION;
	  var scrollBehavior = options.scrollBehavior || DEFAULT_SCROLL_BEHAVIOR;
	  var state = {};
	  var nextState = {};
	  var pendingTransition = null;
	  var dispatchHandler = null;
	
	  if (typeof location === 'string') location = new StaticLocation(location);
	
	  if (location instanceof StaticLocation) {
	    warning(!canUseDOM || ("production") === 'test', 'You should not use a static location in a DOM environment because ' + 'the router will not be kept in sync with the current URL');
	  } else {
	    invariant(canUseDOM || location.needsDOM === false, 'You cannot use %s without a DOM', location);
	  }
	
	  // Automatically fall back to full page refreshes in
	  // browsers that don't support the HTML history API.
	  if (location === HistoryLocation && !supportsHistory()) location = RefreshLocation;
	
	  var Router = React.createClass({
	
	    displayName: 'Router',
	
	    statics: {
	
	      isRunning: false,
	
	      cancelPendingTransition: function cancelPendingTransition() {
	        if (pendingTransition) {
	          pendingTransition.cancel();
	          pendingTransition = null;
	        }
	      },
	
	      clearAllRoutes: function clearAllRoutes() {
	        Router.cancelPendingTransition();
	        Router.namedRoutes = {};
	        Router.routes = [];
	      },
	
	      /**
	       * Adds routes to this router from the given children object (see ReactChildren).
	       */
	      addRoutes: function addRoutes(routes) {
	        if (isReactChildren(routes)) routes = createRoutesFromReactChildren(routes);
	
	        addRoutesToNamedRoutes(routes, Router.namedRoutes);
	
	        Router.routes.push.apply(Router.routes, routes);
	      },
	
	      /**
	       * Replaces routes of this router from the given children object (see ReactChildren).
	       */
	      replaceRoutes: function replaceRoutes(routes) {
	        Router.clearAllRoutes();
	        Router.addRoutes(routes);
	        Router.refresh();
	      },
	
	      /**
	       * Performs a match of the given path against this router and returns an object
	       * with the { routes, params, pathname, query } that match. Returns null if no
	       * match can be made.
	       */
	      match: function match(path) {
	        return Match.findMatch(Router.routes, path);
	      },
	
	      /**
	       * Returns an absolute URL path created from the given route
	       * name, URL parameters, and query.
	       */
	      makePath: function makePath(to, params, query) {
	        var path;
	        if (PathUtils.isAbsolute(to)) {
	          path = to;
	        } else {
	          var route = to instanceof Route ? to : Router.namedRoutes[to];
	
	          invariant(route instanceof Route, 'Cannot find a route named "%s"', to);
	
	          path = route.path;
	        }
	
	        return PathUtils.withQuery(PathUtils.injectParams(path, params), query);
	      },
	
	      /**
	       * Returns a string that may safely be used as the href of a link
	       * to the route with the given name, URL parameters, and query.
	       */
	      makeHref: function makeHref(to, params, query) {
	        var path = Router.makePath(to, params, query);
	        return location === HashLocation ? '#' + path : path;
	      },
	
	      /**
	       * Transitions to the URL specified in the arguments by pushing
	       * a new URL onto the history stack.
	       */
	      transitionTo: function transitionTo(to, params, query) {
	        var path = Router.makePath(to, params, query);
	
	        if (pendingTransition) {
	          // Replace so pending location does not stay in history.
	          location.replace(path);
	        } else {
	          location.push(path);
	        }
	      },
	
	      /**
	       * Transitions to the URL specified in the arguments by replacing
	       * the current URL in the history stack.
	       */
	      replaceWith: function replaceWith(to, params, query) {
	        location.replace(Router.makePath(to, params, query));
	      },
	
	      /**
	       * Transitions to the previous URL if one is available. Returns true if the
	       * router was able to go back, false otherwise.
	       *
	       * Note: The router only tracks history entries in your application, not the
	       * current browser session, so you can safely call this function without guarding
	       * against sending the user back to some other site. However, when using
	       * RefreshLocation (which is the fallback for HistoryLocation in browsers that
	       * don't support HTML5 history) this method will *always* send the client back
	       * because we cannot reliably track history length.
	       */
	      goBack: function goBack() {
	        if (History.length > 1 || location === RefreshLocation) {
	          location.pop();
	          return true;
	        }
	
	        warning(false, 'goBack() was ignored because there is no router history');
	
	        return false;
	      },
	
	      handleAbort: options.onAbort || function (abortReason) {
	        if (location instanceof StaticLocation) throw new Error('Unhandled aborted transition! Reason: ' + abortReason);
	
	        if (abortReason instanceof Cancellation) {
	          return;
	        } else if (abortReason instanceof Redirect) {
	          location.replace(Router.makePath(abortReason.to, abortReason.params, abortReason.query));
	        } else {
	          location.pop();
	        }
	      },
	
	      handleError: options.onError || function (error) {
	        // Throw so we don't silently swallow async errors.
	        throw error; // This error probably originated in a transition hook.
	      },
	
	      handleLocationChange: function handleLocationChange(change) {
	        Router.dispatch(change.path, change.type);
	      },
	
	      /**
	       * Performs a transition to the given path and calls callback(error, abortReason)
	       * when the transition is finished. If both arguments are null the router's state
	       * was updated. Otherwise the transition did not complete.
	       *
	       * In a transition, a router first determines which routes are involved by beginning
	       * with the current route, up the route tree to the first parent route that is shared
	       * with the destination route, and back down the tree to the destination route. The
	       * willTransitionFrom hook is invoked on all route handlers we're transitioning away
	       * from, in reverse nesting order. Likewise, the willTransitionTo hook is invoked on
	       * all route handlers we're transitioning to.
	       *
	       * Both willTransitionFrom and willTransitionTo hooks may either abort or redirect the
	       * transition. To resolve asynchronously, they may use the callback argument. If no
	       * hooks wait, the transition is fully synchronous.
	       */
	      dispatch: function dispatch(path, action) {
	        Router.cancelPendingTransition();
	
	        var prevPath = state.path;
	        var isRefreshing = action == null;
	
	        if (prevPath === path && !isRefreshing) {
	          return;
	        } // Nothing to do!
	
	        // Record the scroll position as early as possible to
	        // get it before browsers try update it automatically.
	        if (prevPath && action === LocationActions.PUSH) Router.recordScrollPosition(prevPath);
	
	        var match = Router.match(path);
	
	        warning(match != null, 'No route matches path "%s". Make sure you have <Route path="%s"> somewhere in your routes', path, path);
	
	        if (match == null) match = {};
	
	        var prevRoutes = state.routes || [];
	        var prevParams = state.params || {};
	        var prevQuery = state.query || {};
	
	        var nextRoutes = match.routes || [];
	        var nextParams = match.params || {};
	        var nextQuery = match.query || {};
	
	        var fromRoutes, toRoutes;
	        if (prevRoutes.length) {
	          fromRoutes = prevRoutes.filter(function (route) {
	            return !hasMatch(nextRoutes, route, prevParams, nextParams, prevQuery, nextQuery);
	          });
	
	          toRoutes = nextRoutes.filter(function (route) {
	            return !hasMatch(prevRoutes, route, prevParams, nextParams, prevQuery, nextQuery);
	          });
	        } else {
	          fromRoutes = [];
	          toRoutes = nextRoutes;
	        }
	
	        var transition = new Transition(path, Router.replaceWith.bind(Router, path));
	        pendingTransition = transition;
	
	        var fromComponents = mountedComponents.slice(prevRoutes.length - fromRoutes.length);
	
	        Transition.from(transition, fromRoutes, fromComponents, function (error) {
	          if (error || transition.abortReason) return dispatchHandler.call(Router, error, transition); // No need to continue.
	
	          Transition.to(transition, toRoutes, nextParams, nextQuery, function (error) {
	            dispatchHandler.call(Router, error, transition, {
	              path: path,
	              action: action,
	              pathname: match.pathname,
	              routes: nextRoutes,
	              params: nextParams,
	              query: nextQuery
	            });
	          });
	        });
	      },
	
	      /**
	       * Starts this router and calls callback(router, state) when the route changes.
	       *
	       * If the router's location is static (i.e. a URL path in a server environment)
	       * the callback is called only once. Otherwise, the location should be one of the
	       * Router.*Location objects (e.g. Router.HashLocation or Router.HistoryLocation).
	       */
	      run: function run(callback) {
	        invariant(!Router.isRunning, 'Router is already running');
	
	        dispatchHandler = function (error, transition, newState) {
	          if (error) Router.handleError(error);
	
	          if (pendingTransition !== transition) return;
	
	          pendingTransition = null;
	
	          if (transition.abortReason) {
	            Router.handleAbort(transition.abortReason);
	          } else {
	            callback.call(Router, Router, nextState = newState);
	          }
	        };
	
	        if (!(location instanceof StaticLocation)) {
	          if (location.addChangeListener) location.addChangeListener(Router.handleLocationChange);
	
	          Router.isRunning = true;
	        }
	
	        // Bootstrap using the current path.
	        Router.refresh();
	      },
	
	      refresh: function refresh() {
	        Router.dispatch(location.getCurrentPath(), null);
	      },
	
	      stop: function stop() {
	        Router.cancelPendingTransition();
	
	        if (location.removeChangeListener) location.removeChangeListener(Router.handleLocationChange);
	
	        Router.isRunning = false;
	      },
	
	      getLocation: function getLocation() {
	        return location;
	      },
	
	      getScrollBehavior: function getScrollBehavior() {
	        return scrollBehavior;
	      },
	
	      getRouteAtDepth: function getRouteAtDepth(routeDepth) {
	        var routes = state.routes;
	        return routes && routes[routeDepth];
	      },
	
	      setRouteComponentAtDepth: function setRouteComponentAtDepth(routeDepth, component) {
	        mountedComponents[routeDepth] = component;
	      },
	
	      /**
	       * Returns the current URL path + query string.
	       */
	      getCurrentPath: function getCurrentPath() {
	        return state.path;
	      },
	
	      /**
	       * Returns the current URL path without the query string.
	       */
	      getCurrentPathname: function getCurrentPathname() {
	        return state.pathname;
	      },
	
	      /**
	       * Returns an object of the currently active URL parameters.
	       */
	      getCurrentParams: function getCurrentParams() {
	        return state.params;
	      },
	
	      /**
	       * Returns an object of the currently active query parameters.
	       */
	      getCurrentQuery: function getCurrentQuery() {
	        return state.query;
	      },
	
	      /**
	       * Returns an array of the currently active routes.
	       */
	      getCurrentRoutes: function getCurrentRoutes() {
	        return state.routes;
	      },
	
	      /**
	       * Returns true if the given route, params, and query are active.
	       */
	      isActive: function isActive(to, params, query) {
	        if (PathUtils.isAbsolute(to)) {
	          return to === state.path;
	        }return routeIsActive(state.routes, to) && paramsAreActive(state.params, params) && (query == null || queryIsActive(state.query, query));
	      }
	
	    },
	
	    mixins: [ScrollHistory],
	
	    propTypes: {
	      children: PropTypes.falsy
	    },
	
	    childContextTypes: {
	      routeDepth: PropTypes.number.isRequired,
	      router: PropTypes.router.isRequired
	    },
	
	    getChildContext: function getChildContext() {
	      return {
	        routeDepth: 1,
	        router: Router
	      };
	    },
	
	    getInitialState: function getInitialState() {
	      return state = nextState;
	    },
	
	    componentWillReceiveProps: function componentWillReceiveProps() {
	      this.setState(state = nextState);
	    },
	
	    componentWillUnmount: function componentWillUnmount() {
	      Router.stop();
	    },
	
	    render: function render() {
	      var route = Router.getRouteAtDepth(0);
	      return route ? React.createElement(route.handler, this.props) : null;
	    }
	
	  });
	
	  Router.clearAllRoutes();
	
	  if (options.routes) Router.addRoutes(options.routes);
	
	  return Router;
	}
	
	module.exports = createRouter;

/***/ },
/* 137 */
/***/ function(module, exports, __webpack_require__) {

	/* jshint -W084 */
	'use strict';
	
	var React = __webpack_require__(1);
	var assign = __webpack_require__(5);
	var warning = __webpack_require__(6);
	var DefaultRoute = __webpack_require__(133);
	var NotFoundRoute = __webpack_require__(134);
	var Redirect = __webpack_require__(135);
	var Route = __webpack_require__(26);
	
	function checkPropTypes(componentName, propTypes, props) {
	  componentName = componentName || 'UnknownComponent';
	
	  for (var propName in propTypes) {
	    if (propTypes.hasOwnProperty(propName)) {
	      var error = propTypes[propName](props, propName, componentName);
	
	      if (error instanceof Error) warning(false, error.message);
	    }
	  }
	}
	
	function createRouteOptions(props) {
	  var options = assign({}, props);
	  var handler = options.handler;
	
	  if (handler) {
	    options.onEnter = handler.willTransitionTo;
	    options.onLeave = handler.willTransitionFrom;
	  }
	
	  return options;
	}
	
	function createRouteFromReactElement(element) {
	  if (!React.isValidElement(element)) {
	    return;
	  }var type = element.type;
	  var props = assign({}, type.defaultProps, element.props);
	
	  if (type.propTypes) checkPropTypes(type.displayName, type.propTypes, props);
	
	  if (type === DefaultRoute) {
	    return Route.createDefaultRoute(createRouteOptions(props));
	  }if (type === NotFoundRoute) {
	    return Route.createNotFoundRoute(createRouteOptions(props));
	  }if (type === Redirect) {
	    return Route.createRedirect(createRouteOptions(props));
	  }return Route.createRoute(createRouteOptions(props), function () {
	    if (props.children) createRoutesFromReactChildren(props.children);
	  });
	}
	
	/**
	 * Creates and returns an array of routes created from the given
	 * ReactChildren, all of which should be one of <Route>, <DefaultRoute>,
	 * <NotFoundRoute>, or <Redirect>, e.g.:
	 *
	 *   var { createRoutesFromReactChildren, Route, Redirect } = require('react-router');
	 *
	 *   var routes = createRoutesFromReactChildren(
	 *     <Route path="/" handler={App}>
	 *       <Route name="user" path="/user/:userId" handler={User}>
	 *         <Route name="task" path="tasks/:taskId" handler={Task}/>
	 *         <Redirect from="todos/:taskId" to="task"/>
	 *       </Route>
	 *     </Route>
	 *   );
	 */
	function createRoutesFromReactChildren(children) {
	  var routes = [];
	
	  React.Children.forEach(children, function (child) {
	    if (child = createRouteFromReactElement(child)) routes.push(child);
	  });
	
	  return routes;
	}
	
	module.exports = createRoutesFromReactChildren;

/***/ },
/* 138 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var LocationActions = __webpack_require__(42);
	var History = __webpack_require__(32);
	
	var _listeners = [];
	var _isListening = false;
	var _actionType;
	
	function notifyChange(type) {
	  if (type === LocationActions.PUSH) History.length += 1;
	
	  var change = {
	    path: HashLocation.getCurrentPath(),
	    type: type
	  };
	
	  _listeners.forEach(function (listener) {
	    listener.call(HashLocation, change);
	  });
	}
	
	function ensureSlash() {
	  var path = HashLocation.getCurrentPath();
	
	  if (path.charAt(0) === '/') {
	    return true;
	  }HashLocation.replace('/' + path);
	
	  return false;
	}
	
	function onHashChange() {
	  if (ensureSlash()) {
	    // If we don't have an _actionType then all we know is the hash
	    // changed. It was probably caused by the user clicking the Back
	    // button, but may have also been the Forward button or manual
	    // manipulation. So just guess 'pop'.
	    var curActionType = _actionType;
	    _actionType = null;
	    notifyChange(curActionType || LocationActions.POP);
	  }
	}
	
	/**
	 * A Location that uses `window.location.hash`.
	 */
	var HashLocation = {
	
	  addChangeListener: function addChangeListener(listener) {
	    _listeners.push(listener);
	
	    // Do this BEFORE listening for hashchange.
	    ensureSlash();
	
	    if (!_isListening) {
	      if (window.addEventListener) {
	        window.addEventListener('hashchange', onHashChange, false);
	      } else {
	        window.attachEvent('onhashchange', onHashChange);
	      }
	
	      _isListening = true;
	    }
	  },
	
	  removeChangeListener: function removeChangeListener(listener) {
	    _listeners = _listeners.filter(function (l) {
	      return l !== listener;
	    });
	
	    if (_listeners.length === 0) {
	      if (window.removeEventListener) {
	        window.removeEventListener('hashchange', onHashChange, false);
	      } else {
	        window.removeEvent('onhashchange', onHashChange);
	      }
	
	      _isListening = false;
	    }
	  },
	
	  push: function push(path) {
	    _actionType = LocationActions.PUSH;
	    window.location.hash = path;
	  },
	
	  replace: function replace(path) {
	    _actionType = LocationActions.REPLACE;
	    window.location.replace(window.location.pathname + window.location.search + '#' + path);
	  },
	
	  pop: function pop() {
	    _actionType = LocationActions.POP;
	    History.back();
	  },
	
	  getCurrentPath: function getCurrentPath() {
	    return decodeURI(
	    // We can't use window.location.hash here because it's not
	    // consistent across browsers - Firefox will pre-decode it!
	    window.location.href.split('#')[1] || '');
	  },
	
	  toString: function toString() {
	    return '<HashLocation>';
	  }
	
	};
	
	module.exports = HashLocation;

/***/ },
/* 139 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var HistoryLocation = __webpack_require__(81);
	var History = __webpack_require__(32);
	
	/**
	 * A Location that uses full page refreshes. This is used as
	 * the fallback for HistoryLocation in browsers that do not
	 * support the HTML5 history API.
	 */
	var RefreshLocation = {
	
	  push: function push(path) {
	    window.location = path;
	  },
	
	  replace: function replace(path) {
	    window.location.replace(path);
	  },
	
	  pop: History.back,
	
	  getCurrentPath: HistoryLocation.getCurrentPath,
	
	  toString: function toString() {
	    return '<RefreshLocation>';
	  }
	
	};
	
	module.exports = RefreshLocation;

/***/ },
/* 140 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _classCallCheck = function (instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var invariant = __webpack_require__(2);
	
	function throwCannotModify() {
	  invariant(false, 'You cannot modify a static location');
	}
	
	/**
	 * A location that only ever contains a single path. Useful in
	 * stateless environments like servers where there is no path history,
	 * only the path that was used in the request.
	 */
	
	var StaticLocation = (function () {
	  function StaticLocation(path) {
	    _classCallCheck(this, StaticLocation);
	
	    this.path = path;
	  }
	
	  _createClass(StaticLocation, [{
	    key: 'getCurrentPath',
	    value: function getCurrentPath() {
	      return this.path;
	    }
	  }, {
	    key: 'toString',
	    value: function toString() {
	      return '<StaticLocation path="' + this.path + '">';
	    }
	  }]);
	
	  return StaticLocation;
	})();
	
	// TODO: Include these in the above class definition
	// once we can use ES7 property initializers.
	// https://github.com/babel/babel/issues/619
	
	StaticLocation.prototype.push = throwCannotModify;
	StaticLocation.prototype.replace = throwCannotModify;
	StaticLocation.prototype.pop = throwCannotModify;
	
	module.exports = StaticLocation;

/***/ },
/* 141 */
/***/ function(module, exports) {

	// Load modules
	
	
	// Declare internals
	
	var internals = {};
	
	
	exports.arrayToObject = function (source) {
	
	    var obj = {};
	    for (var i = 0, il = source.length; i < il; ++i) {
	        if (typeof source[i] !== 'undefined') {
	
	            obj[i] = source[i];
	        }
	    }
	
	    return obj;
	};
	
	
	exports.merge = function (target, source) {
	
	    if (!source) {
	        return target;
	    }
	
	    if (typeof source !== 'object') {
	        if (Array.isArray(target)) {
	            target.push(source);
	        }
	        else {
	            target[source] = true;
	        }
	
	        return target;
	    }
	
	    if (typeof target !== 'object') {
	        target = [target].concat(source);
	        return target;
	    }
	
	    if (Array.isArray(target) &&
	        !Array.isArray(source)) {
	
	        target = exports.arrayToObject(target);
	    }
	
	    var keys = Object.keys(source);
	    for (var k = 0, kl = keys.length; k < kl; ++k) {
	        var key = keys[k];
	        var value = source[key];
	
	        if (!target[key]) {
	            target[key] = value;
	        }
	        else {
	            target[key] = exports.merge(target[key], value);
	        }
	    }
	
	    return target;
	};
	
	
	exports.decode = function (str) {
	
	    try {
	        return decodeURIComponent(str.replace(/\+/g, ' '));
	    } catch (e) {
	        return str;
	    }
	};
	
	
	exports.compact = function (obj, refs) {
	
	    if (typeof obj !== 'object' ||
	        obj === null) {
	
	        return obj;
	    }
	
	    refs = refs || [];
	    var lookup = refs.indexOf(obj);
	    if (lookup !== -1) {
	        return refs[lookup];
	    }
	
	    refs.push(obj);
	
	    if (Array.isArray(obj)) {
	        var compacted = [];
	
	        for (var i = 0, il = obj.length; i < il; ++i) {
	            if (typeof obj[i] !== 'undefined') {
	                compacted.push(obj[i]);
	            }
	        }
	
	        return compacted;
	    }
	
	    var keys = Object.keys(obj);
	    for (i = 0, il = keys.length; i < il; ++i) {
	        var key = keys[i];
	        obj[key] = exports.compact(obj[key], refs);
	    }
	
	    return obj;
	};
	
	
	exports.isRegExp = function (obj) {
	    return Object.prototype.toString.call(obj) === '[object RegExp]';
	};
	
	
	exports.isBuffer = function (obj) {
	
	    if (obj === null ||
	        typeof obj === 'undefined') {
	
	        return false;
	    }
	
	    return !!(obj.constructor &&
	        obj.constructor.isBuffer &&
	        obj.constructor.isBuffer(obj));
	};


/***/ },
/* 142 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule CSSProperty
	 */
	
	'use strict';
	
	/**
	 * CSS properties which accept numbers but are not in units of "px".
	 */
	var isUnitlessNumber = {
	  boxFlex: true,
	  boxFlexGroup: true,
	  columnCount: true,
	  flex: true,
	  flexGrow: true,
	  flexPositive: true,
	  flexShrink: true,
	  flexNegative: true,
	  fontWeight: true,
	  lineClamp: true,
	  lineHeight: true,
	  opacity: true,
	  order: true,
	  orphans: true,
	  widows: true,
	  zIndex: true,
	  zoom: true,
	
	  // SVG-related properties
	  fillOpacity: true,
	  strokeDashoffset: true,
	  strokeOpacity: true,
	  strokeWidth: true
	};
	
	/**
	 * @param {string} prefix vendor-specific prefix, eg: Webkit
	 * @param {string} key style name, eg: transitionDuration
	 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
	 * WebkitTransitionDuration
	 */
	function prefixKey(prefix, key) {
	  return prefix + key.charAt(0).toUpperCase() + key.substring(1);
	}
	
	/**
	 * Support style names that may come passed in prefixed by adding permutations
	 * of vendor prefixes.
	 */
	var prefixes = ['Webkit', 'ms', 'Moz', 'O'];
	
	// Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
	// infinite loop, because it iterates over the newly added props too.
	Object.keys(isUnitlessNumber).forEach(function(prop) {
	  prefixes.forEach(function(prefix) {
	    isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
	  });
	});
	
	/**
	 * Most style properties can be unset by doing .style[prop] = '' but IE8
	 * doesn't like doing that with shorthand properties so for the properties that
	 * IE8 breaks on, which are listed here, we instead unset each of the
	 * individual properties. See http://bugs.jquery.com/ticket/12385.
	 * The 4-value 'clock' properties like margin, padding, border-width seem to
	 * behave without any problems. Curiously, list-style works too without any
	 * special prodding.
	 */
	var shorthandPropertyExpansions = {
	  background: {
	    backgroundImage: true,
	    backgroundPosition: true,
	    backgroundRepeat: true,
	    backgroundColor: true
	  },
	  border: {
	    borderWidth: true,
	    borderStyle: true,
	    borderColor: true
	  },
	  borderBottom: {
	    borderBottomWidth: true,
	    borderBottomStyle: true,
	    borderBottomColor: true
	  },
	  borderLeft: {
	    borderLeftWidth: true,
	    borderLeftStyle: true,
	    borderLeftColor: true
	  },
	  borderRight: {
	    borderRightWidth: true,
	    borderRightStyle: true,
	    borderRightColor: true
	  },
	  borderTop: {
	    borderTopWidth: true,
	    borderTopStyle: true,
	    borderTopColor: true
	  },
	  font: {
	    fontStyle: true,
	    fontVariant: true,
	    fontWeight: true,
	    fontSize: true,
	    lineHeight: true,
	    fontFamily: true
	  }
	};
	
	var CSSProperty = {
	  isUnitlessNumber: isUnitlessNumber,
	  shorthandPropertyExpansions: shorthandPropertyExpansions
	};
	
	module.exports = CSSProperty;


/***/ },
/* 143 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule CSSPropertyOperations
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(142);
	var ExecutionEnvironment = __webpack_require__(8);
	
	var camelizeStyleName = __webpack_require__(456);
	var dangerousStyleValue = __webpack_require__(460);
	var hyphenateStyleName = __webpack_require__(467);
	var memoizeStringOnly = __webpack_require__(470);
	var warning = __webpack_require__(6);
	
	var processStyleName = memoizeStringOnly(function(styleName) {
	  return hyphenateStyleName(styleName);
	});
	
	var styleFloatAccessor = 'cssFloat';
	if (ExecutionEnvironment.canUseDOM) {
	  // IE8 only supports accessing cssFloat (standard) as styleFloat
	  if (document.documentElement.style.cssFloat === undefined) {
	    styleFloatAccessor = 'styleFloat';
	  }
	}
	
	if (false) {
	  // 'msTransform' is correct, but the other prefixes should be capitalized
	  var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;
	
	  // style values shouldn't contain a semicolon
	  var badStyleValueWithSemicolonPattern = /;\s*$/;
	
	  var warnedStyleNames = {};
	  var warnedStyleValues = {};
	
	  var warnHyphenatedStyleName = function(name) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    ("production" !== process.env.NODE_ENV ? warning(
	      false,
	      'Unsupported style property %s. Did you mean %s?',
	      name,
	      camelizeStyleName(name)
	    ) : null);
	  };
	
	  var warnBadVendoredStyleName = function(name) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    ("production" !== process.env.NODE_ENV ? warning(
	      false,
	      'Unsupported vendor-prefixed style property %s. Did you mean %s?',
	      name,
	      name.charAt(0).toUpperCase() + name.slice(1)
	    ) : null);
	  };
	
	  var warnStyleValueWithSemicolon = function(name, value) {
	    if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) {
	      return;
	    }
	
	    warnedStyleValues[value] = true;
	    ("production" !== process.env.NODE_ENV ? warning(
	      false,
	      'Style property values shouldn\'t contain a semicolon. ' +
	      'Try "%s: %s" instead.',
	      name,
	      value.replace(badStyleValueWithSemicolonPattern, '')
	    ) : null);
	  };
	
	  /**
	   * @param {string} name
	   * @param {*} value
	   */
	  var warnValidStyle = function(name, value) {
	    if (name.indexOf('-') > -1) {
	      warnHyphenatedStyleName(name);
	    } else if (badVendoredStyleNamePattern.test(name)) {
	      warnBadVendoredStyleName(name);
	    } else if (badStyleValueWithSemicolonPattern.test(value)) {
	      warnStyleValueWithSemicolon(name, value);
	    }
	  };
	}
	
	/**
	 * Operations for dealing with CSS properties.
	 */
	var CSSPropertyOperations = {
	
	  /**
	   * Serializes a mapping of style properties for use as inline styles:
	   *
	   *   > createMarkupForStyles({width: '200px', height: 0})
	   *   "width:200px;height:0;"
	   *
	   * Undefined values are ignored so that declarative programming is easier.
	   * The result should be HTML-escaped before insertion into the DOM.
	   *
	   * @param {object} styles
	   * @return {?string}
	   */
	  createMarkupForStyles: function(styles) {
	    var serialized = '';
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      var styleValue = styles[styleName];
	      if (false) {
	        warnValidStyle(styleName, styleValue);
	      }
	      if (styleValue != null) {
	        serialized += processStyleName(styleName) + ':';
	        serialized += dangerousStyleValue(styleName, styleValue) + ';';
	      }
	    }
	    return serialized || null;
	  },
	
	  /**
	   * Sets the value for multiple styles on a node.  If a value is specified as
	   * '' (empty string), the corresponding style property will be unset.
	   *
	   * @param {DOMElement} node
	   * @param {object} styles
	   */
	  setValueForStyles: function(node, styles) {
	    var style = node.style;
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      if (false) {
	        warnValidStyle(styleName, styles[styleName]);
	      }
	      var styleValue = dangerousStyleValue(styleName, styles[styleName]);
	      if (styleName === 'float') {
	        styleName = styleFloatAccessor;
	      }
	      if (styleValue) {
	        style[styleName] = styleValue;
	      } else {
	        var expansion = CSSProperty.shorthandPropertyExpansions[styleName];
	        if (expansion) {
	          // Shorthand property that IE8 won't like unsetting, so unset each
	          // component to placate it
	          for (var individualStyleName in expansion) {
	            style[individualStyleName] = '';
	          }
	        } else {
	          style[styleName] = '';
	        }
	      }
	    }
	  }
	
	};
	
	module.exports = CSSPropertyOperations;


/***/ },
/* 144 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EventPluginRegistry
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(2);
	
	/**
	 * Injectable ordering of event plugins.
	 */
	var EventPluginOrder = null;
	
	/**
	 * Injectable mapping from names to event plugin modules.
	 */
	var namesToPlugins = {};
	
	/**
	 * Recomputes the plugin list using the injected plugins and plugin ordering.
	 *
	 * @private
	 */
	function recomputePluginOrdering() {
	  if (!EventPluginOrder) {
	    // Wait until an `EventPluginOrder` is injected.
	    return;
	  }
	  for (var pluginName in namesToPlugins) {
	    var PluginModule = namesToPlugins[pluginName];
	    var pluginIndex = EventPluginOrder.indexOf(pluginName);
	    ( false ? invariant(
	      pluginIndex > -1,
	      'EventPluginRegistry: Cannot inject event plugins that do not exist in ' +
	      'the plugin ordering, `%s`.',
	      pluginName
	    ) : invariant(pluginIndex > -1));
	    if (EventPluginRegistry.plugins[pluginIndex]) {
	      continue;
	    }
	    ( false ? invariant(
	      PluginModule.extractEvents,
	      'EventPluginRegistry: Event plugins must implement an `extractEvents` ' +
	      'method, but `%s` does not.',
	      pluginName
	    ) : invariant(PluginModule.extractEvents));
	    EventPluginRegistry.plugins[pluginIndex] = PluginModule;
	    var publishedEvents = PluginModule.eventTypes;
	    for (var eventName in publishedEvents) {
	      ( false ? invariant(
	        publishEventForPlugin(
	          publishedEvents[eventName],
	          PluginModule,
	          eventName
	        ),
	        'EventPluginRegistry: Failed to publish event `%s` for plugin `%s`.',
	        eventName,
	        pluginName
	      ) : invariant(publishEventForPlugin(
	        publishedEvents[eventName],
	        PluginModule,
	        eventName
	      )));
	    }
	  }
	}
	
	/**
	 * Publishes an event so that it can be dispatched by the supplied plugin.
	 *
	 * @param {object} dispatchConfig Dispatch configuration for the event.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @return {boolean} True if the event was successfully published.
	 * @private
	 */
	function publishEventForPlugin(dispatchConfig, PluginModule, eventName) {
	  ( false ? invariant(
	    !EventPluginRegistry.eventNameDispatchConfigs.hasOwnProperty(eventName),
	    'EventPluginHub: More than one plugin attempted to publish the same ' +
	    'event name, `%s`.',
	    eventName
	  ) : invariant(!EventPluginRegistry.eventNameDispatchConfigs.hasOwnProperty(eventName)));
	  EventPluginRegistry.eventNameDispatchConfigs[eventName] = dispatchConfig;
	
	  var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
	  if (phasedRegistrationNames) {
	    for (var phaseName in phasedRegistrationNames) {
	      if (phasedRegistrationNames.hasOwnProperty(phaseName)) {
	        var phasedRegistrationName = phasedRegistrationNames[phaseName];
	        publishRegistrationName(
	          phasedRegistrationName,
	          PluginModule,
	          eventName
	        );
	      }
	    }
	    return true;
	  } else if (dispatchConfig.registrationName) {
	    publishRegistrationName(
	      dispatchConfig.registrationName,
	      PluginModule,
	      eventName
	    );
	    return true;
	  }
	  return false;
	}
	
	/**
	 * Publishes a registration name that is used to identify dispatched events and
	 * can be used with `EventPluginHub.putListener` to register listeners.
	 *
	 * @param {string} registrationName Registration name to add.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @private
	 */
	function publishRegistrationName(registrationName, PluginModule, eventName) {
	  ( false ? invariant(
	    !EventPluginRegistry.registrationNameModules[registrationName],
	    'EventPluginHub: More than one plugin attempted to publish the same ' +
	    'registration name, `%s`.',
	    registrationName
	  ) : invariant(!EventPluginRegistry.registrationNameModules[registrationName]));
	  EventPluginRegistry.registrationNameModules[registrationName] = PluginModule;
	  EventPluginRegistry.registrationNameDependencies[registrationName] =
	    PluginModule.eventTypes[eventName].dependencies;
	}
	
	/**
	 * Registers plugins so that they can extract and dispatch events.
	 *
	 * @see {EventPluginHub}
	 */
	var EventPluginRegistry = {
	
	  /**
	   * Ordered list of injected plugins.
	   */
	  plugins: [],
	
	  /**
	   * Mapping from event name to dispatch config
	   */
	  eventNameDispatchConfigs: {},
	
	  /**
	   * Mapping from registration name to plugin module
	   */
	  registrationNameModules: {},
	
	  /**
	   * Mapping from registration name to event name
	   */
	  registrationNameDependencies: {},
	
	  /**
	   * Injects an ordering of plugins (by plugin name). This allows the ordering
	   * to be decoupled from injection of the actual plugins so that ordering is
	   * always deterministic regardless of packaging, on-the-fly injection, etc.
	   *
	   * @param {array} InjectedEventPluginOrder
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginOrder}
	   */
	  injectEventPluginOrder: function(InjectedEventPluginOrder) {
	    ( false ? invariant(
	      !EventPluginOrder,
	      'EventPluginRegistry: Cannot inject event plugin ordering more than ' +
	      'once. You are likely trying to load more than one copy of React.'
	    ) : invariant(!EventPluginOrder));
	    // Clone the ordering so it cannot be dynamically mutated.
	    EventPluginOrder = Array.prototype.slice.call(InjectedEventPluginOrder);
	    recomputePluginOrdering();
	  },
	
	  /**
	   * Injects plugins to be used by `EventPluginHub`. The plugin names must be
	   * in the ordering injected by `injectEventPluginOrder`.
	   *
	   * Plugins can be injected as part of page initialization or on-the-fly.
	   *
	   * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginsByName}
	   */
	  injectEventPluginsByName: function(injectedNamesToPlugins) {
	    var isOrderingDirty = false;
	    for (var pluginName in injectedNamesToPlugins) {
	      if (!injectedNamesToPlugins.hasOwnProperty(pluginName)) {
	        continue;
	      }
	      var PluginModule = injectedNamesToPlugins[pluginName];
	      if (!namesToPlugins.hasOwnProperty(pluginName) ||
	          namesToPlugins[pluginName] !== PluginModule) {
	        ( false ? invariant(
	          !namesToPlugins[pluginName],
	          'EventPluginRegistry: Cannot inject two different event plugins ' +
	          'using the same name, `%s`.',
	          pluginName
	        ) : invariant(!namesToPlugins[pluginName]));
	        namesToPlugins[pluginName] = PluginModule;
	        isOrderingDirty = true;
	      }
	    }
	    if (isOrderingDirty) {
	      recomputePluginOrdering();
	    }
	  },
	
	  /**
	   * Looks up the plugin for the supplied event.
	   *
	   * @param {object} event A synthetic event.
	   * @return {?object} The plugin that created the supplied event.
	   * @internal
	   */
	  getPluginModuleForEvent: function(event) {
	    var dispatchConfig = event.dispatchConfig;
	    if (dispatchConfig.registrationName) {
	      return EventPluginRegistry.registrationNameModules[
	        dispatchConfig.registrationName
	      ] || null;
	    }
	    for (var phase in dispatchConfig.phasedRegistrationNames) {
	      if (!dispatchConfig.phasedRegistrationNames.hasOwnProperty(phase)) {
	        continue;
	      }
	      var PluginModule = EventPluginRegistry.registrationNameModules[
	        dispatchConfig.phasedRegistrationNames[phase]
	      ];
	      if (PluginModule) {
	        return PluginModule;
	      }
	    }
	    return null;
	  },
	
	  /**
	   * Exposed for unit testing.
	   * @private
	   */
	  _resetEventPlugins: function() {
	    EventPluginOrder = null;
	    for (var pluginName in namesToPlugins) {
	      if (namesToPlugins.hasOwnProperty(pluginName)) {
	        delete namesToPlugins[pluginName];
	      }
	    }
	    EventPluginRegistry.plugins.length = 0;
	
	    var eventNameDispatchConfigs = EventPluginRegistry.eventNameDispatchConfigs;
	    for (var eventName in eventNameDispatchConfigs) {
	      if (eventNameDispatchConfigs.hasOwnProperty(eventName)) {
	        delete eventNameDispatchConfigs[eventName];
	      }
	    }
	
	    var registrationNameModules = EventPluginRegistry.registrationNameModules;
	    for (var registrationName in registrationNameModules) {
	      if (registrationNameModules.hasOwnProperty(registrationName)) {
	        delete registrationNameModules[registrationName];
	      }
	    }
	  }
	
	};
	
	module.exports = EventPluginRegistry;


/***/ },
/* 145 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactComponent
	 */
	
	'use strict';
	
	var ReactUpdateQueue = __webpack_require__(93);
	
	var invariant = __webpack_require__(2);
	var warning = __webpack_require__(6);
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactComponent(props, context) {
	  this.props = props;
	  this.context = context;
	}
	
	/**
	 * Sets a subset of the state. Always use this to mutate
	 * state. You should treat `this.state` as immutable.
	 *
	 * There is no guarantee that `this.state` will be immediately updated, so
	 * accessing `this.state` after calling this method may return the old value.
	 *
	 * There is no guarantee that calls to `setState` will run synchronously,
	 * as they may eventually be batched together.  You can provide an optional
	 * callback that will be executed when the call to setState is actually
	 * completed.
	 *
	 * When a function is provided to setState, it will be called at some point in
	 * the future (not synchronously). It will be called with the up to date
	 * component arguments (state, props, context). These values can be different
	 * from this.* because your function may be called after receiveProps but before
	 * shouldComponentUpdate, and this new state, props, and context will not yet be
	 * assigned to this.
	 *
	 * @param {object|function} partialState Next partial state or function to
	 *        produce next partial state to be merged with current state.
	 * @param {?function} callback Called after state is updated.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.setState = function(partialState, callback) {
	  ( false ? invariant(
	    typeof partialState === 'object' ||
	    typeof partialState === 'function' ||
	    partialState == null,
	    'setState(...): takes an object of state variables to update or a ' +
	    'function which returns an object of state variables.'
	  ) : invariant(typeof partialState === 'object' ||
	  typeof partialState === 'function' ||
	  partialState == null));
	  if (false) {
	    ("production" !== process.env.NODE_ENV ? warning(
	      partialState != null,
	      'setState(...): You passed an undefined or null state object; ' +
	      'instead, use forceUpdate().'
	    ) : null);
	  }
	  ReactUpdateQueue.enqueueSetState(this, partialState);
	  if (callback) {
	    ReactUpdateQueue.enqueueCallback(this, callback);
	  }
	};
	
	/**
	 * Forces an update. This should only be invoked when it is known with
	 * certainty that we are **not** in a DOM transaction.
	 *
	 * You may want to call this when you know that some deeper aspect of the
	 * component's state has changed but `setState` was not called.
	 *
	 * This will not invoke `shouldComponentUpdate`, but it will invoke
	 * `componentWillUpdate` and `componentDidUpdate`.
	 *
	 * @param {?function} callback Called after update is complete.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.forceUpdate = function(callback) {
	  ReactUpdateQueue.enqueueForceUpdate(this);
	  if (callback) {
	    ReactUpdateQueue.enqueueCallback(this, callback);
	  }
	};
	
	/**
	 * Deprecated APIs. These APIs used to exist on classic React classes but since
	 * we would like to deprecate them, we're not going to move them over to this
	 * modern base class. Instead, we define a getter that warns if it's accessed.
	 */
	if (false) {
	  var deprecatedAPIs = {
	    getDOMNode: [
	      'getDOMNode',
	      'Use React.findDOMNode(component) instead.'
	    ],
	    isMounted: [
	      'isMounted',
	      'Instead, make sure to clean up subscriptions and pending requests in ' +
	      'componentWillUnmount to prevent memory leaks.'
	    ],
	    replaceProps: [
	      'replaceProps',
	      'Instead, call React.render again at the top level.'
	    ],
	    replaceState: [
	      'replaceState',
	      'Refactor your code to use setState instead (see ' +
	      'https://github.com/facebook/react/issues/3236).'
	    ],
	    setProps: [
	      'setProps',
	      'Instead, call React.render again at the top level.'
	    ]
	  };
	  var defineDeprecationWarning = function(methodName, info) {
	    try {
	      Object.defineProperty(ReactComponent.prototype, methodName, {
	        get: function() {
	          ("production" !== process.env.NODE_ENV ? warning(
	            false,
	            '%s(...) is deprecated in plain JavaScript React classes. %s',
	            info[0],
	            info[1]
	          ) : null);
	          return undefined;
	        }
	      });
	    } catch (x) {
	      // IE will fail on defineProperty (es5-shim/sham too)
	    }
	  };
	  for (var fnName in deprecatedAPIs) {
	    if (deprecatedAPIs.hasOwnProperty(fnName)) {
	      defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
	    }
	  }
	}
	
	module.exports = ReactComponent;


/***/ },
/* 146 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMIDOperations
	 * @typechecks static-only
	 */
	
	/*jslint evil: true */
	
	'use strict';
	
	var CSSPropertyOperations = __webpack_require__(143);
	var DOMChildrenOperations = __webpack_require__(408);
	var DOMPropertyOperations = __webpack_require__(43);
	var ReactMount = __webpack_require__(20);
	var ReactPerf = __webpack_require__(27);
	
	var invariant = __webpack_require__(2);
	var setInnerHTML = __webpack_require__(101);
	
	/**
	 * Errors for properties that should not be updated with `updatePropertyById()`.
	 *
	 * @type {object}
	 * @private
	 */
	var INVALID_PROPERTY_ERRORS = {
	  dangerouslySetInnerHTML:
	    '`dangerouslySetInnerHTML` must be set using `updateInnerHTMLByID()`.',
	  style: '`style` must be set using `updateStylesByID()`.'
	};
	
	/**
	 * Operations used to process updates to DOM nodes. This is made injectable via
	 * `ReactDOMComponent.BackendIDOperations`.
	 */
	var ReactDOMIDOperations = {
	
	  /**
	   * Updates a DOM node with new property values. This should only be used to
	   * update DOM properties in `DOMProperty`.
	   *
	   * @param {string} id ID of the node to update.
	   * @param {string} name A valid property name, see `DOMProperty`.
	   * @param {*} value New value of the property.
	   * @internal
	   */
	  updatePropertyByID: function(id, name, value) {
	    var node = ReactMount.getNode(id);
	    ( false ? invariant(
	      !INVALID_PROPERTY_ERRORS.hasOwnProperty(name),
	      'updatePropertyByID(...): %s',
	      INVALID_PROPERTY_ERRORS[name]
	    ) : invariant(!INVALID_PROPERTY_ERRORS.hasOwnProperty(name)));
	
	    // If we're updating to null or undefined, we should remove the property
	    // from the DOM node instead of inadvertantly setting to a string. This
	    // brings us in line with the same behavior we have on initial render.
	    if (value != null) {
	      DOMPropertyOperations.setValueForProperty(node, name, value);
	    } else {
	      DOMPropertyOperations.deleteValueForProperty(node, name);
	    }
	  },
	
	  /**
	   * Updates a DOM node to remove a property. This should only be used to remove
	   * DOM properties in `DOMProperty`.
	   *
	   * @param {string} id ID of the node to update.
	   * @param {string} name A property name to remove, see `DOMProperty`.
	   * @internal
	   */
	  deletePropertyByID: function(id, name, value) {
	    var node = ReactMount.getNode(id);
	    ( false ? invariant(
	      !INVALID_PROPERTY_ERRORS.hasOwnProperty(name),
	      'updatePropertyByID(...): %s',
	      INVALID_PROPERTY_ERRORS[name]
	    ) : invariant(!INVALID_PROPERTY_ERRORS.hasOwnProperty(name)));
	    DOMPropertyOperations.deleteValueForProperty(node, name, value);
	  },
	
	  /**
	   * Updates a DOM node with new style values. If a value is specified as '',
	   * the corresponding style property will be unset.
	   *
	   * @param {string} id ID of the node to update.
	   * @param {object} styles Mapping from styles to values.
	   * @internal
	   */
	  updateStylesByID: function(id, styles) {
	    var node = ReactMount.getNode(id);
	    CSSPropertyOperations.setValueForStyles(node, styles);
	  },
	
	  /**
	   * Updates a DOM node's innerHTML.
	   *
	   * @param {string} id ID of the node to update.
	   * @param {string} html An HTML string.
	   * @internal
	   */
	  updateInnerHTMLByID: function(id, html) {
	    var node = ReactMount.getNode(id);
	    setInnerHTML(node, html);
	  },
	
	  /**
	   * Updates a DOM node's text content set by `props.content`.
	   *
	   * @param {string} id ID of the node to update.
	   * @param {string} content Text content.
	   * @internal
	   */
	  updateTextContentByID: function(id, content) {
	    var node = ReactMount.getNode(id);
	    DOMChildrenOperations.updateTextContent(node, content);
	  },
	
	  /**
	   * Replaces a DOM node that exists in the document with markup.
	   *
	   * @param {string} id ID of child to be replaced.
	   * @param {string} markup Dangerous markup to inject in place of child.
	   * @internal
	   * @see {Danger.dangerouslyReplaceNodeWithMarkup}
	   */
	  dangerouslyReplaceNodeWithMarkupByID: function(id, markup) {
	    var node = ReactMount.getNode(id);
	    DOMChildrenOperations.dangerouslyReplaceNodeWithMarkup(node, markup);
	  },
	
	  /**
	   * Updates a component's children by processing a series of updates.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @param {array<string>} markup List of markup strings.
	   * @internal
	   */
	  dangerouslyProcessChildrenUpdates: function(updates, markup) {
	    for (var i = 0; i < updates.length; i++) {
	      updates[i].parentNode = ReactMount.getNode(updates[i].parentID);
	    }
	    DOMChildrenOperations.processUpdates(updates, markup);
	  }
	};
	
	ReactPerf.measureMethods(ReactDOMIDOperations, 'ReactDOMIDOperations', {
	  updatePropertyByID: 'updatePropertyByID',
	  deletePropertyByID: 'deletePropertyByID',
	  updateStylesByID: 'updateStylesByID',
	  updateInnerHTMLByID: 'updateInnerHTMLByID',
	  updateTextContentByID: 'updateTextContentByID',
	  dangerouslyReplaceNodeWithMarkupByID: 'dangerouslyReplaceNodeWithMarkupByID',
	  dangerouslyProcessChildrenUpdates: 'dangerouslyProcessChildrenUpdates'
	});
	
	module.exports = ReactDOMIDOperations;


/***/ },
/* 147 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMTextComponent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var DOMPropertyOperations = __webpack_require__(43);
	var ReactComponentBrowserEnvironment =
	  __webpack_require__(86);
	var ReactDOMComponent = __webpack_require__(89);
	
	var assign = __webpack_require__(5);
	var escapeTextContentForBrowser = __webpack_require__(66);
	
	/**
	 * Text nodes violate a couple assumptions that React makes about components:
	 *
	 *  - When mounting text into the DOM, adjacent text nodes are merged.
	 *  - Text nodes cannot be assigned a React root ID.
	 *
	 * This component is used to wrap strings in elements so that they can undergo
	 * the same reconciliation that is applied to elements.
	 *
	 * TODO: Investigate representing React components in the DOM with text nodes.
	 *
	 * @class ReactDOMTextComponent
	 * @extends ReactComponent
	 * @internal
	 */
	var ReactDOMTextComponent = function(props) {
	  // This constructor and its argument is currently used by mocks.
	};
	
	assign(ReactDOMTextComponent.prototype, {
	
	  /**
	   * @param {ReactText} text
	   * @internal
	   */
	  construct: function(text) {
	    // TODO: This is really a ReactText (ReactNode), not a ReactElement
	    this._currentElement = text;
	    this._stringText = '' + text;
	
	    // Properties
	    this._rootNodeID = null;
	    this._mountIndex = 0;
	  },
	
	  /**
	   * Creates the markup for this text node. This node is not intended to have
	   * any features besides containing text content.
	   *
	   * @param {string} rootID DOM ID of the root node.
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @return {string} Markup for this text node.
	   * @internal
	   */
	  mountComponent: function(rootID, transaction, context) {
	    this._rootNodeID = rootID;
	    var escapedText = escapeTextContentForBrowser(this._stringText);
	
	    if (transaction.renderToStaticMarkup) {
	      // Normally we'd wrap this in a `span` for the reasons stated above, but
	      // since this is a situation where React won't take over (static pages),
	      // we can simply return the text as it is.
	      return escapedText;
	    }
	
	    return (
	      '<span ' + DOMPropertyOperations.createMarkupForID(rootID) + '>' +
	        escapedText +
	      '</span>'
	    );
	  },
	
	  /**
	   * Updates this component by updating the text content.
	   *
	   * @param {ReactText} nextText The next text content
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  receiveComponent: function(nextText, transaction) {
	    if (nextText !== this._currentElement) {
	      this._currentElement = nextText;
	      var nextStringText = '' + nextText;
	      if (nextStringText !== this._stringText) {
	        // TODO: Save this as pending props and use performUpdateIfNecessary
	        // and/or updateComponent to do the actual update for consistency with
	        // other component types?
	        this._stringText = nextStringText;
	        ReactDOMComponent.BackendIDOperations.updateTextContentByID(
	          this._rootNodeID,
	          nextStringText
	        );
	      }
	    }
	  },
	
	  unmountComponent: function() {
	    ReactComponentBrowserEnvironment.unmountIDFromEnvironment(this._rootNodeID);
	  }
	
	});
	
	module.exports = ReactDOMTextComponent;


/***/ },
/* 148 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactInputSelection
	 */
	
	'use strict';
	
	var ReactDOMSelection = __webpack_require__(428);
	
	var containsNode = __webpack_require__(155);
	var focusNode = __webpack_require__(157);
	var getActiveElement = __webpack_require__(158);
	
	function isInDocument(node) {
	  return containsNode(document.documentElement, node);
	}
	
	/**
	 * @ReactInputSelection: React input selection module. Based on Selection.js,
	 * but modified to be suitable for react and has a couple of bug fixes (doesn't
	 * assume buttons have range selections allowed).
	 * Input selection module for React.
	 */
	var ReactInputSelection = {
	
	  hasSelectionCapabilities: function(elem) {
	    return elem && (
	      ((elem.nodeName === 'INPUT' && elem.type === 'text') ||
	      elem.nodeName === 'TEXTAREA' || elem.contentEditable === 'true')
	    );
	  },
	
	  getSelectionInformation: function() {
	    var focusedElem = getActiveElement();
	    return {
	      focusedElem: focusedElem,
	      selectionRange:
	          ReactInputSelection.hasSelectionCapabilities(focusedElem) ?
	          ReactInputSelection.getSelection(focusedElem) :
	          null
	    };
	  },
	
	  /**
	   * @restoreSelection: If any selection information was potentially lost,
	   * restore it. This is useful when performing operations that could remove dom
	   * nodes and place them back in, resulting in focus being lost.
	   */
	  restoreSelection: function(priorSelectionInformation) {
	    var curFocusedElem = getActiveElement();
	    var priorFocusedElem = priorSelectionInformation.focusedElem;
	    var priorSelectionRange = priorSelectionInformation.selectionRange;
	    if (curFocusedElem !== priorFocusedElem &&
	        isInDocument(priorFocusedElem)) {
	      if (ReactInputSelection.hasSelectionCapabilities(priorFocusedElem)) {
	        ReactInputSelection.setSelection(
	          priorFocusedElem,
	          priorSelectionRange
	        );
	      }
	      focusNode(priorFocusedElem);
	    }
	  },
	
	  /**
	   * @getSelection: Gets the selection bounds of a focused textarea, input or
	   * contentEditable node.
	   * -@input: Look up selection bounds of this input
	   * -@return {start: selectionStart, end: selectionEnd}
	   */
	  getSelection: function(input) {
	    var selection;
	
	    if ('selectionStart' in input) {
	      // Modern browser with input or textarea.
	      selection = {
	        start: input.selectionStart,
	        end: input.selectionEnd
	      };
	    } else if (document.selection && input.nodeName === 'INPUT') {
	      // IE8 input.
	      var range = document.selection.createRange();
	      // There can only be one selection per document in IE, so it must
	      // be in our element.
	      if (range.parentElement() === input) {
	        selection = {
	          start: -range.moveStart('character', -input.value.length),
	          end: -range.moveEnd('character', -input.value.length)
	        };
	      }
	    } else {
	      // Content editable or old IE textarea.
	      selection = ReactDOMSelection.getOffsets(input);
	    }
	
	    return selection || {start: 0, end: 0};
	  },
	
	  /**
	   * @setSelection: Sets the selection bounds of a textarea or input and focuses
	   * the input.
	   * -@input     Set selection bounds of this input or textarea
	   * -@offsets   Object of same form that is returned from get*
	   */
	  setSelection: function(input, offsets) {
	    var start = offsets.start;
	    var end = offsets.end;
	    if (typeof end === 'undefined') {
	      end = start;
	    }
	
	    if ('selectionStart' in input) {
	      input.selectionStart = start;
	      input.selectionEnd = Math.min(end, input.value.length);
	    } else if (document.selection && input.nodeName === 'INPUT') {
	      var range = input.createTextRange();
	      range.collapse(true);
	      range.moveStart('character', start);
	      range.moveEnd('character', end - start);
	      range.select();
	    } else {
	      ReactDOMSelection.setOffsets(input, offsets);
	    }
	  }
	};
	
	module.exports = ReactInputSelection;


/***/ },
/* 149 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactMarkupChecksum
	 */
	
	'use strict';
	
	var adler32 = __webpack_require__(454);
	
	var ReactMarkupChecksum = {
	  CHECKSUM_ATTR_NAME: 'data-react-checksum',
	
	  /**
	   * @param {string} markup Markup string
	   * @return {string} Markup string with checksum attribute attached
	   */
	  addChecksumToMarkup: function(markup) {
	    var checksum = adler32(markup);
	    return markup.replace(
	      '>',
	      ' ' + ReactMarkupChecksum.CHECKSUM_ATTR_NAME + '="' + checksum + '">'
	    );
	  },
	
	  /**
	   * @param {string} markup to use
	   * @param {DOMElement} element root React element
	   * @returns {boolean} whether or not the markup is the same
	   */
	  canReuseMarkup: function(markup, element) {
	    var existingChecksum = element.getAttribute(
	      ReactMarkupChecksum.CHECKSUM_ATTR_NAME
	    );
	    existingChecksum = existingChecksum && parseInt(existingChecksum, 10);
	    var markupChecksum = adler32(markup);
	    return markupChecksum === existingChecksum;
	  }
	};
	
	module.exports = ReactMarkupChecksum;


/***/ },
/* 150 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactMultiChildUpdateTypes
	 */
	
	'use strict';
	
	var keyMirror = __webpack_require__(48);
	
	/**
	 * When a component's children are updated, a series of update configuration
	 * objects are created in order to batch and serialize the required changes.
	 *
	 * Enumerates all the possible types of update configurations.
	 *
	 * @internal
	 */
	var ReactMultiChildUpdateTypes = keyMirror({
	  INSERT_MARKUP: null,
	  MOVE_EXISTING: null,
	  REMOVE_NODE: null,
	  TEXT_CONTENT: null
	});
	
	module.exports = ReactMultiChildUpdateTypes;


/***/ },
/* 151 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactPropTypes
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(7);
	var ReactFragment = __webpack_require__(60);
	var ReactPropTypeLocationNames = __webpack_require__(62);
	
	var emptyFunction = __webpack_require__(24);
	
	/**
	 * Collection of methods that allow declaration and validation of props that are
	 * supplied to React components. Example usage:
	 *
	 *   var Props = require('ReactPropTypes');
	 *   var MyArticle = React.createClass({
	 *     propTypes: {
	 *       // An optional string prop named "description".
	 *       description: Props.string,
	 *
	 *       // A required enum prop named "category".
	 *       category: Props.oneOf(['News','Photos']).isRequired,
	 *
	 *       // A prop named "dialog" that requires an instance of Dialog.
	 *       dialog: Props.instanceOf(Dialog).isRequired
	 *     },
	 *     render: function() { ... }
	 *   });
	 *
	 * A more formal specification of how these methods are used:
	 *
	 *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
	 *   decl := ReactPropTypes.{type}(.isRequired)?
	 *
	 * Each and every declaration produces a function with the same signature. This
	 * allows the creation of custom validation functions. For example:
	 *
	 *  var MyLink = React.createClass({
	 *    propTypes: {
	 *      // An optional string or URI prop named "href".
	 *      href: function(props, propName, componentName) {
	 *        var propValue = props[propName];
	 *        if (propValue != null && typeof propValue !== 'string' &&
	 *            !(propValue instanceof URI)) {
	 *          return new Error(
	 *            'Expected a string or an URI for ' + propName + ' in ' +
	 *            componentName
	 *          );
	 *        }
	 *      }
	 *    },
	 *    render: function() {...}
	 *  });
	 *
	 * @internal
	 */
	
	var ANONYMOUS = '<<anonymous>>';
	
	var elementTypeChecker = createElementTypeChecker();
	var nodeTypeChecker = createNodeChecker();
	
	var ReactPropTypes = {
	  array: createPrimitiveTypeChecker('array'),
	  bool: createPrimitiveTypeChecker('boolean'),
	  func: createPrimitiveTypeChecker('function'),
	  number: createPrimitiveTypeChecker('number'),
	  object: createPrimitiveTypeChecker('object'),
	  string: createPrimitiveTypeChecker('string'),
	
	  any: createAnyTypeChecker(),
	  arrayOf: createArrayOfTypeChecker,
	  element: elementTypeChecker,
	  instanceOf: createInstanceTypeChecker,
	  node: nodeTypeChecker,
	  objectOf: createObjectOfTypeChecker,
	  oneOf: createEnumTypeChecker,
	  oneOfType: createUnionTypeChecker,
	  shape: createShapeTypeChecker
	};
	
	function createChainableTypeChecker(validate) {
	  function checkType(isRequired, props, propName, componentName, location) {
	    componentName = componentName || ANONYMOUS;
	    if (props[propName] == null) {
	      var locationName = ReactPropTypeLocationNames[location];
	      if (isRequired) {
	        return new Error(
	          ("Required " + locationName + " `" + propName + "` was not specified in ") +
	          ("`" + componentName + "`.")
	        );
	      }
	      return null;
	    } else {
	      return validate(props, propName, componentName, location);
	    }
	  }
	
	  var chainedCheckType = checkType.bind(null, false);
	  chainedCheckType.isRequired = checkType.bind(null, true);
	
	  return chainedCheckType;
	}
	
	function createPrimitiveTypeChecker(expectedType) {
	  function validate(props, propName, componentName, location) {
	    var propValue = props[propName];
	    var propType = getPropType(propValue);
	    if (propType !== expectedType) {
	      var locationName = ReactPropTypeLocationNames[location];
	      // `propValue` being instance of, say, date/regexp, pass the 'object'
	      // check, but we can offer a more precise error message here rather than
	      // 'of type `object`'.
	      var preciseType = getPreciseType(propValue);
	
	      return new Error(
	        ("Invalid " + locationName + " `" + propName + "` of type `" + preciseType + "` ") +
	        ("supplied to `" + componentName + "`, expected `" + expectedType + "`.")
	      );
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createAnyTypeChecker() {
	  return createChainableTypeChecker(emptyFunction.thatReturns(null));
	}
	
	function createArrayOfTypeChecker(typeChecker) {
	  function validate(props, propName, componentName, location) {
	    var propValue = props[propName];
	    if (!Array.isArray(propValue)) {
	      var locationName = ReactPropTypeLocationNames[location];
	      var propType = getPropType(propValue);
	      return new Error(
	        ("Invalid " + locationName + " `" + propName + "` of type ") +
	        ("`" + propType + "` supplied to `" + componentName + "`, expected an array.")
	      );
	    }
	    for (var i = 0; i < propValue.length; i++) {
	      var error = typeChecker(propValue, i, componentName, location);
	      if (error instanceof Error) {
	        return error;
	      }
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createElementTypeChecker() {
	  function validate(props, propName, componentName, location) {
	    if (!ReactElement.isValidElement(props[propName])) {
	      var locationName = ReactPropTypeLocationNames[location];
	      return new Error(
	        ("Invalid " + locationName + " `" + propName + "` supplied to ") +
	        ("`" + componentName + "`, expected a ReactElement.")
	      );
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createInstanceTypeChecker(expectedClass) {
	  function validate(props, propName, componentName, location) {
	    if (!(props[propName] instanceof expectedClass)) {
	      var locationName = ReactPropTypeLocationNames[location];
	      var expectedClassName = expectedClass.name || ANONYMOUS;
	      return new Error(
	        ("Invalid " + locationName + " `" + propName + "` supplied to ") +
	        ("`" + componentName + "`, expected instance of `" + expectedClassName + "`.")
	      );
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createEnumTypeChecker(expectedValues) {
	  function validate(props, propName, componentName, location) {
	    var propValue = props[propName];
	    for (var i = 0; i < expectedValues.length; i++) {
	      if (propValue === expectedValues[i]) {
	        return null;
	      }
	    }
	
	    var locationName = ReactPropTypeLocationNames[location];
	    var valuesString = JSON.stringify(expectedValues);
	    return new Error(
	      ("Invalid " + locationName + " `" + propName + "` of value `" + propValue + "` ") +
	      ("supplied to `" + componentName + "`, expected one of " + valuesString + ".")
	    );
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createObjectOfTypeChecker(typeChecker) {
	  function validate(props, propName, componentName, location) {
	    var propValue = props[propName];
	    var propType = getPropType(propValue);
	    if (propType !== 'object') {
	      var locationName = ReactPropTypeLocationNames[location];
	      return new Error(
	        ("Invalid " + locationName + " `" + propName + "` of type ") +
	        ("`" + propType + "` supplied to `" + componentName + "`, expected an object.")
	      );
	    }
	    for (var key in propValue) {
	      if (propValue.hasOwnProperty(key)) {
	        var error = typeChecker(propValue, key, componentName, location);
	        if (error instanceof Error) {
	          return error;
	        }
	      }
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createUnionTypeChecker(arrayOfTypeCheckers) {
	  function validate(props, propName, componentName, location) {
	    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	      var checker = arrayOfTypeCheckers[i];
	      if (checker(props, propName, componentName, location) == null) {
	        return null;
	      }
	    }
	
	    var locationName = ReactPropTypeLocationNames[location];
	    return new Error(
	      ("Invalid " + locationName + " `" + propName + "` supplied to ") +
	      ("`" + componentName + "`.")
	    );
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createNodeChecker() {
	  function validate(props, propName, componentName, location) {
	    if (!isNode(props[propName])) {
	      var locationName = ReactPropTypeLocationNames[location];
	      return new Error(
	        ("Invalid " + locationName + " `" + propName + "` supplied to ") +
	        ("`" + componentName + "`, expected a ReactNode.")
	      );
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createShapeTypeChecker(shapeTypes) {
	  function validate(props, propName, componentName, location) {
	    var propValue = props[propName];
	    var propType = getPropType(propValue);
	    if (propType !== 'object') {
	      var locationName = ReactPropTypeLocationNames[location];
	      return new Error(
	        ("Invalid " + locationName + " `" + propName + "` of type `" + propType + "` ") +
	        ("supplied to `" + componentName + "`, expected `object`.")
	      );
	    }
	    for (var key in shapeTypes) {
	      var checker = shapeTypes[key];
	      if (!checker) {
	        continue;
	      }
	      var error = checker(propValue, key, componentName, location);
	      if (error) {
	        return error;
	      }
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function isNode(propValue) {
	  switch (typeof propValue) {
	    case 'number':
	    case 'string':
	    case 'undefined':
	      return true;
	    case 'boolean':
	      return !propValue;
	    case 'object':
	      if (Array.isArray(propValue)) {
	        return propValue.every(isNode);
	      }
	      if (propValue === null || ReactElement.isValidElement(propValue)) {
	        return true;
	      }
	      propValue = ReactFragment.extractIfFragment(propValue);
	      for (var k in propValue) {
	        if (!isNode(propValue[k])) {
	          return false;
	        }
	      }
	      return true;
	    default:
	      return false;
	  }
	}
	
	// Equivalent of `typeof` but with special handling for array and regexp.
	function getPropType(propValue) {
	  var propType = typeof propValue;
	  if (Array.isArray(propValue)) {
	    return 'array';
	  }
	  if (propValue instanceof RegExp) {
	    // Old webkits (at least until Android 4.0) return 'function' rather than
	    // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
	    // passes PropTypes.object.
	    return 'object';
	  }
	  return propType;
	}
	
	// This handles more types than `getPropType`. Only used for error messages.
	// See `createPrimitiveTypeChecker`.
	function getPreciseType(propValue) {
	  var propType = getPropType(propValue);
	  if (propType === 'object') {
	    if (propValue instanceof Date) {
	      return 'date';
	    } else if (propValue instanceof RegExp) {
	      return 'regexp';
	    }
	  }
	  return propType;
	}
	
	module.exports = ReactPropTypes;


/***/ },
/* 152 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactPutListenerQueue
	 */
	
	'use strict';
	
	var PooledClass = __webpack_require__(17);
	var ReactBrowserEventEmitter = __webpack_require__(34);
	
	var assign = __webpack_require__(5);
	
	function ReactPutListenerQueue() {
	  this.listenersToPut = [];
	}
	
	assign(ReactPutListenerQueue.prototype, {
	  enqueuePutListener: function(rootNodeID, propKey, propValue) {
	    this.listenersToPut.push({
	      rootNodeID: rootNodeID,
	      propKey: propKey,
	      propValue: propValue
	    });
	  },
	
	  putListeners: function() {
	    for (var i = 0; i < this.listenersToPut.length; i++) {
	      var listenerToPut = this.listenersToPut[i];
	      ReactBrowserEventEmitter.putListener(
	        listenerToPut.rootNodeID,
	        listenerToPut.propKey,
	        listenerToPut.propValue
	      );
	    }
	  },
	
	  reset: function() {
	    this.listenersToPut.length = 0;
	  },
	
	  destructor: function() {
	    this.reset();
	  }
	});
	
	PooledClass.addPoolingTo(ReactPutListenerQueue);
	
	module.exports = ReactPutListenerQueue;


/***/ },
/* 153 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactRootIndex
	 * @typechecks
	 */
	
	'use strict';
	
	var ReactRootIndexInjection = {
	  /**
	   * @param {function} _createReactRootIndex
	   */
	  injectCreateReactRootIndex: function(_createReactRootIndex) {
	    ReactRootIndex.createReactRootIndex = _createReactRootIndex;
	  }
	};
	
	var ReactRootIndex = {
	  createReactRootIndex: null,
	  injection: ReactRootIndexInjection
	};
	
	module.exports = ReactRootIndex;


/***/ },
/* 154 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ViewportMetrics
	 */
	
	'use strict';
	
	var ViewportMetrics = {
	
	  currentScrollLeft: 0,
	
	  currentScrollTop: 0,
	
	  refreshScrollValues: function(scrollPosition) {
	    ViewportMetrics.currentScrollLeft = scrollPosition.x;
	    ViewportMetrics.currentScrollTop = scrollPosition.y;
	  }
	
	};
	
	module.exports = ViewportMetrics;


/***/ },
/* 155 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule containsNode
	 * @typechecks
	 */
	
	var isTextNode = __webpack_require__(468);
	
	/*jslint bitwise:true */
	
	/**
	 * Checks if a given DOM node contains or is another DOM node.
	 *
	 * @param {?DOMNode} outerNode Outer DOM node.
	 * @param {?DOMNode} innerNode Inner DOM node.
	 * @return {boolean} True if `outerNode` contains or is `innerNode`.
	 */
	function containsNode(outerNode, innerNode) {
	  if (!outerNode || !innerNode) {
	    return false;
	  } else if (outerNode === innerNode) {
	    return true;
	  } else if (isTextNode(outerNode)) {
	    return false;
	  } else if (isTextNode(innerNode)) {
	    return containsNode(outerNode, innerNode.parentNode);
	  } else if (outerNode.contains) {
	    return outerNode.contains(innerNode);
	  } else if (outerNode.compareDocumentPosition) {
	    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
	  } else {
	    return false;
	  }
	}
	
	module.exports = containsNode;


/***/ },
/* 156 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule findDOMNode
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var ReactCurrentOwner = __webpack_require__(19);
	var ReactInstanceMap = __webpack_require__(36);
	var ReactMount = __webpack_require__(20);
	
	var invariant = __webpack_require__(2);
	var isNode = __webpack_require__(162);
	var warning = __webpack_require__(6);
	
	/**
	 * Returns the DOM node rendered by this element.
	 *
	 * @param {ReactComponent|DOMElement} componentOrElement
	 * @return {DOMElement} The root node of this element.
	 */
	function findDOMNode(componentOrElement) {
	  if (false) {
	    var owner = ReactCurrentOwner.current;
	    if (owner !== null) {
	      ("production" !== process.env.NODE_ENV ? warning(
	        owner._warnedAboutRefsInRender,
	        '%s is accessing getDOMNode or findDOMNode inside its render(). ' +
	        'render() should be a pure function of props and state. It should ' +
	        'never access something that requires stale data from the previous ' +
	        'render, such as refs. Move this logic to componentDidMount and ' +
	        'componentDidUpdate instead.',
	        owner.getName() || 'A component'
	      ) : null);
	      owner._warnedAboutRefsInRender = true;
	    }
	  }
	  if (componentOrElement == null) {
	    return null;
	  }
	  if (isNode(componentOrElement)) {
	    return componentOrElement;
	  }
	  if (ReactInstanceMap.has(componentOrElement)) {
	    return ReactMount.getNodeFromInstance(componentOrElement);
	  }
	  ( false ? invariant(
	    componentOrElement.render == null ||
	    typeof componentOrElement.render !== 'function',
	    'Component (with keys: %s) contains `render` method ' +
	    'but is not mounted in the DOM',
	    Object.keys(componentOrElement)
	  ) : invariant(componentOrElement.render == null ||
	  typeof componentOrElement.render !== 'function'));
	  ( false ? invariant(
	    false,
	    'Element appears to be neither ReactComponent nor DOMNode (keys: %s)',
	    Object.keys(componentOrElement)
	  ) : invariant(false));
	}
	
	module.exports = findDOMNode;


/***/ },
/* 157 */
/***/ function(module, exports) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule focusNode
	 */
	
	"use strict";
	
	/**
	 * @param {DOMElement} node input/textarea to focus
	 */
	function focusNode(node) {
	  // IE8 can throw "Can't move focus to the control because it is invisible,
	  // not enabled, or of a type that does not accept the focus." for all kinds of
	  // reasons that are too expensive and fragile to test.
	  try {
	    node.focus();
	  } catch(e) {
	  }
	}
	
	module.exports = focusNode;


/***/ },
/* 158 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getActiveElement
	 * @typechecks
	 */
	
	/**
	 * Same as document.activeElement but wraps in a try-catch block. In IE it is
	 * not safe to call document.activeElement if there is nothing focused.
	 *
	 * The activeElement will be null only if the document body is not yet defined.
	 */
	function getActiveElement() /*?DOMElement*/ {
	  try {
	    return document.activeElement || document.body;
	  } catch (e) {
	    return document.body;
	  }
	}
	
	module.exports = getActiveElement;


/***/ },
/* 159 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getIteratorFn
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/* global Symbol */
	var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	/**
	 * Returns the iterator method function contained on the iterable object.
	 *
	 * Be sure to invoke the function with the iterable as context:
	 *
	 *     var iteratorFn = getIteratorFn(myIterable);
	 *     if (iteratorFn) {
	 *       var iterator = iteratorFn.call(myIterable);
	 *       ...
	 *     }
	 *
	 * @param {?object} maybeIterable
	 * @return {?function}
	 */
	function getIteratorFn(maybeIterable) {
	  var iteratorFn = maybeIterable && (
	    (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL])
	  );
	  if (typeof iteratorFn === 'function') {
	    return iteratorFn;
	  }
	}
	
	module.exports = getIteratorFn;


/***/ },
/* 160 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getMarkupWrap
	 */
	
	var ExecutionEnvironment = __webpack_require__(8);
	
	var invariant = __webpack_require__(2);
	
	/**
	 * Dummy container used to detect which wraps are necessary.
	 */
	var dummyNode =
	  ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Some browsers cannot use `innerHTML` to render certain elements standalone,
	 * so we wrap them, render the wrapped nodes, then extract the desired node.
	 *
	 * In IE8, certain elements cannot render alone, so wrap all elements ('*').
	 */
	var shouldWrap = {
	  // Force wrapping for SVG elements because if they get created inside a <div>,
	  // they will be initialized in the wrong namespace (and will not display).
	  'circle': true,
	  'clipPath': true,
	  'defs': true,
	  'ellipse': true,
	  'g': true,
	  'line': true,
	  'linearGradient': true,
	  'path': true,
	  'polygon': true,
	  'polyline': true,
	  'radialGradient': true,
	  'rect': true,
	  'stop': true,
	  'text': true
	};
	
	var selectWrap = [1, '<select multiple="true">', '</select>'];
	var tableWrap = [1, '<table>', '</table>'];
	var trWrap = [3, '<table><tbody><tr>', '</tr></tbody></table>'];
	
	var svgWrap = [1, '<svg>', '</svg>'];
	
	var markupWrap = {
	  '*': [1, '?<div>', '</div>'],
	
	  'area': [1, '<map>', '</map>'],
	  'col': [2, '<table><tbody></tbody><colgroup>', '</colgroup></table>'],
	  'legend': [1, '<fieldset>', '</fieldset>'],
	  'param': [1, '<object>', '</object>'],
	  'tr': [2, '<table><tbody>', '</tbody></table>'],
	
	  'optgroup': selectWrap,
	  'option': selectWrap,
	
	  'caption': tableWrap,
	  'colgroup': tableWrap,
	  'tbody': tableWrap,
	  'tfoot': tableWrap,
	  'thead': tableWrap,
	
	  'td': trWrap,
	  'th': trWrap,
	
	  'circle': svgWrap,
	  'clipPath': svgWrap,
	  'defs': svgWrap,
	  'ellipse': svgWrap,
	  'g': svgWrap,
	  'line': svgWrap,
	  'linearGradient': svgWrap,
	  'path': svgWrap,
	  'polygon': svgWrap,
	  'polyline': svgWrap,
	  'radialGradient': svgWrap,
	  'rect': svgWrap,
	  'stop': svgWrap,
	  'text': svgWrap
	};
	
	/**
	 * Gets the markup wrap configuration for the supplied `nodeName`.
	 *
	 * NOTE: This lazily detects which wraps are necessary for the current browser.
	 *
	 * @param {string} nodeName Lowercase `nodeName`.
	 * @return {?array} Markup wrap configuration, if applicable.
	 */
	function getMarkupWrap(nodeName) {
	  ( false ? invariant(!!dummyNode, 'Markup wrapping node not initialized') : invariant(!!dummyNode));
	  if (!markupWrap.hasOwnProperty(nodeName)) {
	    nodeName = '*';
	  }
	  if (!shouldWrap.hasOwnProperty(nodeName)) {
	    if (nodeName === '*') {
	      dummyNode.innerHTML = '<link />';
	    } else {
	      dummyNode.innerHTML = '<' + nodeName + '></' + nodeName + '>';
	    }
	    shouldWrap[nodeName] = !dummyNode.firstChild;
	  }
	  return shouldWrap[nodeName] ? markupWrap[nodeName] : null;
	}
	
	
	module.exports = getMarkupWrap;


/***/ },
/* 161 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getTextContentAccessor
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(8);
	
	var contentKey = null;
	
	/**
	 * Gets the key used to access text content on a DOM node.
	 *
	 * @return {?string} Key used to access text content.
	 * @internal
	 */
	function getTextContentAccessor() {
	  if (!contentKey && ExecutionEnvironment.canUseDOM) {
	    // Prefer textContent to innerText because many browsers support both but
	    // SVG <text> elements don't support innerText even when <div> does.
	    contentKey = 'textContent' in document.documentElement ?
	      'textContent' :
	      'innerText';
	  }
	  return contentKey;
	}
	
	module.exports = getTextContentAccessor;


/***/ },
/* 162 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule isNode
	 * @typechecks
	 */
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM node.
	 */
	function isNode(object) {
	  return !!(object && (
	    ((typeof Node === 'function' ? object instanceof Node : typeof object === 'object' &&
	    typeof object.nodeType === 'number' &&
	    typeof object.nodeName === 'string'))
	  ));
	}
	
	module.exports = isNode;


/***/ },
/* 163 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule isTextInputElement
	 */
	
	'use strict';
	
	/**
	 * @see http://www.whatwg.org/specs/web-apps/current-work/multipage/the-input-element.html#input-type-attr-summary
	 */
	var supportedInputTypes = {
	  'color': true,
	  'date': true,
	  'datetime': true,
	  'datetime-local': true,
	  'email': true,
	  'month': true,
	  'number': true,
	  'password': true,
	  'range': true,
	  'search': true,
	  'tel': true,
	  'text': true,
	  'time': true,
	  'url': true,
	  'week': true
	};
	
	function isTextInputElement(elem) {
	  return elem && (
	    (elem.nodeName === 'INPUT' && supportedInputTypes[elem.type] || elem.nodeName === 'TEXTAREA')
	  );
	}
	
	module.exports = isTextInputElement;


/***/ },
/* 164 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule traverseAllChildren
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(7);
	var ReactFragment = __webpack_require__(60);
	var ReactInstanceHandles = __webpack_require__(35);
	
	var getIteratorFn = __webpack_require__(159);
	var invariant = __webpack_require__(2);
	var warning = __webpack_require__(6);
	
	var SEPARATOR = ReactInstanceHandles.SEPARATOR;
	var SUBSEPARATOR = ':';
	
	/**
	 * TODO: Test that a single child and an array with one item have the same key
	 * pattern.
	 */
	
	var userProvidedKeyEscaperLookup = {
	  '=': '=0',
	  '.': '=1',
	  ':': '=2'
	};
	
	var userProvidedKeyEscapeRegex = /[=.:]/g;
	
	var didWarnAboutMaps = false;
	
	function userProvidedKeyEscaper(match) {
	  return userProvidedKeyEscaperLookup[match];
	}
	
	/**
	 * Generate a key string that identifies a component within a set.
	 *
	 * @param {*} component A component that could contain a manual key.
	 * @param {number} index Index that is used if a manual key is not provided.
	 * @return {string}
	 */
	function getComponentKey(component, index) {
	  if (component && component.key != null) {
	    // Explicit key
	    return wrapUserProvidedKey(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	/**
	 * Escape a component key so that it is safe to use in a reactid.
	 *
	 * @param {*} key Component key to be escaped.
	 * @return {string} An escaped string.
	 */
	function escapeUserProvidedKey(text) {
	  return ('' + text).replace(
	    userProvidedKeyEscapeRegex,
	    userProvidedKeyEscaper
	  );
	}
	
	/**
	 * Wrap a `key` value explicitly provided by the user to distinguish it from
	 * implicitly-generated keys generated by a component's index in its parent.
	 *
	 * @param {string} key Value of a user-provided `key` attribute
	 * @return {string}
	 */
	function wrapUserProvidedKey(key) {
	  return '$' + escapeUserProvidedKey(key);
	}
	
	/**
	 * @param {?*} children Children tree container.
	 * @param {!string} nameSoFar Name of the key path so far.
	 * @param {!number} indexSoFar Number of children encountered until this point.
	 * @param {!function} callback Callback to invoke with each child found.
	 * @param {?*} traverseContext Used to pass information throughout the traversal
	 * process.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildrenImpl(
	  children,
	  nameSoFar,
	  indexSoFar,
	  callback,
	  traverseContext
	) {
	  var type = typeof children;
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (children === null ||
	      type === 'string' ||
	      type === 'number' ||
	      ReactElement.isValidElement(children)) {
	    callback(
	      traverseContext,
	      children,
	      // If it's the only child, treat the name as if it was wrapped in an array
	      // so that it's consistent if the number of children grows.
	      nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar,
	      indexSoFar
	    );
	    return 1;
	  }
	
	  var child, nextName, nextIndex;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = (
	        (nameSoFar !== '' ? nameSoFar + SUBSEPARATOR : SEPARATOR) +
	        getComponentKey(child, i)
	      );
	      nextIndex = indexSoFar + subtreeCount;
	      subtreeCount += traverseAllChildrenImpl(
	        child,
	        nextName,
	        nextIndex,
	        callback,
	        traverseContext
	      );
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      var iterator = iteratorFn.call(children);
	      var step;
	      if (iteratorFn !== children.entries) {
	        var ii = 0;
	        while (!(step = iterator.next()).done) {
	          child = step.value;
	          nextName = (
	            (nameSoFar !== '' ? nameSoFar + SUBSEPARATOR : SEPARATOR) +
	            getComponentKey(child, ii++)
	          );
	          nextIndex = indexSoFar + subtreeCount;
	          subtreeCount += traverseAllChildrenImpl(
	            child,
	            nextName,
	            nextIndex,
	            callback,
	            traverseContext
	          );
	        }
	      } else {
	        if (false) {
	          ("production" !== process.env.NODE_ENV ? warning(
	            didWarnAboutMaps,
	            'Using Maps as children is not yet fully supported. It is an ' +
	            'experimental feature that might be removed. Convert it to a ' +
	            'sequence / iterable of keyed ReactElements instead.'
	          ) : null);
	          didWarnAboutMaps = true;
	        }
	        // Iterator will provide entry [k,v] tuples rather than values.
	        while (!(step = iterator.next()).done) {
	          var entry = step.value;
	          if (entry) {
	            child = entry[1];
	            nextName = (
	              (nameSoFar !== '' ? nameSoFar + SUBSEPARATOR : SEPARATOR) +
	              wrapUserProvidedKey(entry[0]) + SUBSEPARATOR +
	              getComponentKey(child, 0)
	            );
	            nextIndex = indexSoFar + subtreeCount;
	            subtreeCount += traverseAllChildrenImpl(
	              child,
	              nextName,
	              nextIndex,
	              callback,
	              traverseContext
	            );
	          }
	        }
	      }
	    } else if (type === 'object') {
	      ( false ? invariant(
	        children.nodeType !== 1,
	        'traverseAllChildren(...): Encountered an invalid child; DOM ' +
	        'elements are not valid children of React components.'
	      ) : invariant(children.nodeType !== 1));
	      var fragment = ReactFragment.extract(children);
	      for (var key in fragment) {
	        if (fragment.hasOwnProperty(key)) {
	          child = fragment[key];
	          nextName = (
	            (nameSoFar !== '' ? nameSoFar + SUBSEPARATOR : SEPARATOR) +
	            wrapUserProvidedKey(key) + SUBSEPARATOR +
	            getComponentKey(child, 0)
	          );
	          nextIndex = indexSoFar + subtreeCount;
	          subtreeCount += traverseAllChildrenImpl(
	            child,
	            nextName,
	            nextIndex,
	            callback,
	            traverseContext
	          );
	        }
	      }
	    }
	  }
	
	  return subtreeCount;
	}
	
	/**
	 * Traverses children that are typically specified as `props.children`, but
	 * might also be specified through attributes:
	 *
	 * - `traverseAllChildren(this.props.children, ...)`
	 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
	 *
	 * The `traverseContext` is an optional argument that is passed through the
	 * entire traversal. It can be used to store accumulations or anything else that
	 * the callback might find relevant.
	 *
	 * @param {?*} children Children tree object.
	 * @param {!function} callback To invoke upon traversing each child.
	 * @param {?*} traverseContext Context for traversal.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', 0, callback, traverseContext);
	}
	
	module.exports = traverseAllChildren;


/***/ },
/* 165 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _slicedToArray = (function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i['return']) _i['return'](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError('Invalid attempt to destructure non-iterable instance'); } }; })();
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _BoardSquare = __webpack_require__(166);
	
	var _BoardSquare2 = _interopRequireDefault(_BoardSquare);
	
	var _Knight = __webpack_require__(167);
	
	var _Knight2 = _interopRequireDefault(_Knight);
	
	var _reactDnd = __webpack_require__(3);
	
	var _reactDndModulesBackendsHTML5 = __webpack_require__(10);
	
	var _reactDndModulesBackendsHTML52 = _interopRequireDefault(_reactDndModulesBackendsHTML5);
	
	__webpack_require__(276);
	
	var Board = (function () {
	  function Board() {
	    _classCallCheck(this, _Board);
	  }
	
	  Board.prototype.renderSquare = function renderSquare(i) {
	    var x = i % 8;
	    var y = Math.floor(i / 8);
	
	    return _react2['default'].createElement(
	      'div',
	      { key: i,
	        style: { width: '12.5%', height: '12.5%' } },
	      _react2['default'].createElement(
	        _BoardSquare2['default'],
	        { x: x,
	          y: y },
	        this.renderPiece(x, y)
	      )
	    );
	  };
	
	  Board.prototype.renderPiece = function renderPiece(x, y) {
	    var _props$knightPosition = _slicedToArray(this.props.knightPosition, 2);
	
	    var knightX = _props$knightPosition[0];
	    var knightY = _props$knightPosition[1];
	
	    if (x === knightX && y === knightY) {
	      return _react2['default'].createElement(_Knight2['default'], null);
	    }
	  };
	
	  Board.prototype.render = function render() {
	    var squares = [];
	    for (var i = 0; i < 64; i++) {
	      squares.push(this.renderSquare(i));
	    }
	
	    return _react2['default'].createElement(
	      'div',
	      { className: 'Board' },
	      squares
	    );
	  };
	
	  _createClass(Board, null, [{
	    key: 'propTypes',
	    value: {
	      knightPosition: _react.PropTypes.arrayOf(_react.PropTypes.number.isRequired).isRequired
	    },
	    enumerable: true
	  }]);
	
	  var _Board = Board;
	  Board = _reactDnd.DragDropContext(_reactDndModulesBackendsHTML52['default'])(Board) || Board;
	  return Board;
	})();
	
	exports['default'] = Board;
	module.exports = exports['default'];

/***/ },
/* 166 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Square = __webpack_require__(168);
	
	var _Square2 = _interopRequireDefault(_Square);
	
	var _Game = __webpack_require__(104);
	
	var _Constants = __webpack_require__(103);
	
	var _reactDnd = __webpack_require__(3);
	
	var squareTarget = {
	  canDrop: function canDrop(props) {
	    return _Game.canMoveKnight(props.x, props.y);
	  },
	
	  drop: function drop(props) {
	    _Game.moveKnight(props.x, props.y);
	  }
	};
	
	function collect(connect, monitor) {
	  return {
	    connectDropTarget: connect.dropTarget(),
	    isOver: monitor.isOver(),
	    canDrop: monitor.canDrop()
	  };
	}
	
	var BoardSquare = (function () {
	  function BoardSquare() {
	    _classCallCheck(this, _BoardSquare);
	  }
	
	  BoardSquare.prototype.renderOverlay = function renderOverlay(color) {
	    return _react2['default'].createElement('div', { style: {
	        position: 'absolute',
	        top: 0,
	        left: 0,
	        height: '100%',
	        width: '100%',
	        zIndex: 1,
	        opacity: 0.5,
	        backgroundColor: color
	      } });
	  };
	
	  BoardSquare.prototype.render = function render() {
	    var _props = this.props;
	    var x = _props.x;
	    var y = _props.y;
	    var connectDropTarget = _props.connectDropTarget;
	    var isOver = _props.isOver;
	    var canDrop = _props.canDrop;
	
	    var black = (x + y) % 2 === 1;
	
	    return connectDropTarget(_react2['default'].createElement(
	      'div',
	      { style: {
	          position: 'relative',
	          width: '100%',
	          height: '100%'
	        } },
	      _react2['default'].createElement(
	        _Square2['default'],
	        { black: black },
	        this.props.children
	      ),
	      isOver && !canDrop && this.renderOverlay('red'),
	      !isOver && canDrop && this.renderOverlay('yellow'),
	      isOver && canDrop && this.renderOverlay('green')
	    ));
	  };
	
	  _createClass(BoardSquare, null, [{
	    key: 'propTypes',
	    value: {
	      x: _react.PropTypes.number.isRequired,
	      y: _react.PropTypes.number.isRequired,
	      isOver: _react.PropTypes.bool.isRequired,
	      canDrop: _react.PropTypes.bool.isRequired
	    },
	    enumerable: true
	  }]);
	
	  var _BoardSquare = BoardSquare;
	  BoardSquare = _reactDnd.DropTarget(_Constants.ItemTypes.KNIGHT, squareTarget, collect)(BoardSquare) || BoardSquare;
	  return BoardSquare;
	})();
	
	exports['default'] = BoardSquare;
	module.exports = exports['default'];

/***/ },
/* 167 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Constants = __webpack_require__(103);
	
	var _reactDnd = __webpack_require__(3);
	
	var knightSource = {
	  beginDrag: function beginDrag() {
	    return {};
	  }
	};
	
	function collect(connect, monitor) {
	  return {
	    connectDragSource: connect.dragSource(),
	    connectDragPreview: connect.dragPreview(),
	    isDragging: monitor.isDragging()
	  };
	}
	
	var Knight = (function () {
	  function Knight() {
	    _classCallCheck(this, _Knight);
	  }
	
	  Knight.prototype.componentDidMount = function componentDidMount() {
	    var _this = this;
	
	    var img = new Image();
	    img.src = 'data:image/png;base64,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';
	    img.onload = function () {
	      return _this.props.connectDragPreview(img);
	    };
	  };
	
	  Knight.prototype.render = function render() {
	    var _props = this.props;
	    var connectDragSource = _props.connectDragSource;
	    var isDragging = _props.isDragging;
	
	    return connectDragSource(_react2['default'].createElement(
	      'div',
	      { style: {
	          fontSize: 40,
	          fontWeight: 'bold',
	          cursor: 'move',
	          opacity: isDragging ? 0.5 : 1
	        } },
	      '♘'
	    ));
	  };
	
	  _createClass(Knight, null, [{
	    key: 'propTypes',
	    value: {
	      connectDragSource: _react.PropTypes.func.isRequired,
	      isDragging: _react.PropTypes.bool.isRequired
	    },
	    enumerable: true
	  }]);
	
	  var _Knight = Knight;
	  Knight = _reactDnd.DragSource(_Constants.ItemTypes.KNIGHT, knightSource, collect)(Knight) || Knight;
	  return Knight;
	})();
	
	exports['default'] = Knight;
	module.exports = exports['default'];

/***/ },
/* 168 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var Square = (function () {
	  function Square() {
	    _classCallCheck(this, Square);
	  }
	
	  Square.prototype.render = function render() {
	    var black = this.props.black;
	
	    var backgroundColor = black ? 'black' : 'white';
	    var color = black ? 'white' : 'black';
	
	    return _react2['default'].createElement(
	      'div',
	      { style: {
	          color: color,
	          backgroundColor: backgroundColor,
	          width: '100%',
	          height: '100%'
	        } },
	      this.props.children
	    );
	  };
	
	  _createClass(Square, null, [{
	    key: 'propTypes',
	    value: {
	      black: _react.PropTypes.bool
	    },
	    enumerable: true
	  }]);
	
	  return Square;
	})();
	
	exports['default'] = Square;
	module.exports = exports['default'];

/***/ },
/* 169 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Board = __webpack_require__(165);
	
	var _Board2 = _interopRequireDefault(_Board);
	
	var _Game = __webpack_require__(104);
	
	/**
	 * Unlike the tutorial, export a component so it can be used on the website.
	 */
	
	var ChessboardTutorialApp = (function (_Component) {
	  _inherits(ChessboardTutorialApp, _Component);
	
	  function ChessboardTutorialApp(props) {
	    _classCallCheck(this, ChessboardTutorialApp);
	
	    _Component.call(this, props);
	    this.unobserve = _Game.observe(this.handleChange.bind(this));
	  }
	
	  ChessboardTutorialApp.prototype.handleChange = function handleChange(knightPosition) {
	    var nextState = { knightPosition: knightPosition };
	    if (this.state) {
	      this.setState(nextState);
	    } else {
	      this.state = nextState;
	    }
	  };
	
	  ChessboardTutorialApp.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.unobserve();
	  };
	
	  ChessboardTutorialApp.prototype.render = function render() {
	    var knightPosition = this.state.knightPosition;
	
	    return _react2['default'].createElement(
	      'div',
	      null,
	      _react2['default'].createElement(
	        'p',
	        null,
	        _react2['default'].createElement(
	          'b',
	          null,
	          _react2['default'].createElement(
	            'a',
	            { href: 'https://github.com/pljenkins/react-dnd/tree/master/examples/00%20Chessboard/Tutorial%20App' },
	            'Browse the Source'
	          )
	        )
	      ),
	      _react2['default'].createElement(
	        'p',
	        null,
	        'This is a sample app you\'ll build as you work through the ',
	        _react2['default'].createElement(
	          'a',
	          { href: 'docs-tutorial.html' },
	          'tutorial'
	        ),
	        '.'
	      ),
	      _react2['default'].createElement(
	        'p',
	        null,
	        'It illustrates creating the drag sources and the drop targets, using the monitors to query the current drag state, and customizing the drag previews.'
	      ),
	      _react2['default'].createElement(
	        'div',
	        { style: {
	            width: 500,
	            height: 500,
	            border: '1px solid gray'
	          } },
	        _react2['default'].createElement(_Board2['default'], { knightPosition: knightPosition })
	      ),
	      _react2['default'].createElement(
	        'p',
	        null,
	        'Make sure to check out the ',
	        _react2['default'].createElement(
	          'a',
	          { href: 'docs-tutorial.html' },
	          'tutorial'
	        ),
	        ' for step-by-step instructions on building it!'
	      )
	    );
	  };
	
	  return ChessboardTutorialApp;
	})(_react.Component);
	
	exports['default'] = ChessboardTutorialApp;
	module.exports = exports['default'];

/***/ },
/* 170 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDnd = __webpack_require__(3);
	
	var style = {
	  border: '1px dashed gray',
	  backgroundColor: 'white',
	  padding: '0.5rem 1rem',
	  marginRight: '1.5rem',
	  marginBottom: '1.5rem',
	  cursor: 'move',
	  float: 'left'
	};
	
	var boxSource = {
	  beginDrag: function beginDrag(props) {
	    return {
	      name: props.name
	    };
	  }
	};
	
	var Box = (function (_Component) {
	  _inherits(Box, _Component);
	
	  function Box() {
	    _classCallCheck(this, _Box);
	
	    _Component.apply(this, arguments);
	  }
	
	  Box.prototype.render = function render() {
	    var _props = this.props;
	    var name = _props.name;
	    var isDropped = _props.isDropped;
	    var isDragging = _props.isDragging;
	    var connectDragSource = _props.connectDragSource;
	
	    var opacity = isDragging ? 0.4 : 1;
	
	    return connectDragSource(_react2['default'].createElement(
	      'div',
	      { style: _extends({}, style, { opacity: opacity }) },
	      isDropped ? _react2['default'].createElement(
	        's',
	        null,
	        name
	      ) : name
	    ));
	  };
	
	  _createClass(Box, null, [{
	    key: 'propTypes',
	    value: {
	      connectDragSource: _react.PropTypes.func.isRequired,
	      isDragging: _react.PropTypes.bool.isRequired,
	      name: _react.PropTypes.string.isRequired,
	      type: _react.PropTypes.string.isRequired,
	      isDropped: _react.PropTypes.bool.isRequired
	    },
	    enumerable: true
	  }]);
	
	  var _Box = Box;
	  Box = _reactDnd.DragSource(function (props) {
	    return props.type;
	  }, boxSource, function (connect, monitor) {
	    return {
	      connectDragSource: connect.dragSource(),
	      isDragging: monitor.isDragging()
	    };
	  })(Box) || Box;
	  return Box;
	})(_react.Component);
	
	exports['default'] = Box;
	module.exports = exports['default'];

/***/ },
/* 171 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDnd = __webpack_require__(3);
	
	var _reactDndModulesBackendsHTML5 = __webpack_require__(10);
	
	var _reactDndModulesBackendsHTML52 = _interopRequireDefault(_reactDndModulesBackendsHTML5);
	
	var _Dustbin = __webpack_require__(172);
	
	var _Dustbin2 = _interopRequireDefault(_Dustbin);
	
	var _Box = __webpack_require__(170);
	
	var _Box2 = _interopRequireDefault(_Box);
	
	var _ItemTypes = __webpack_require__(173);
	
	var _ItemTypes2 = _interopRequireDefault(_ItemTypes);
	
	var _reactLibUpdate = __webpack_require__(25);
	
	var _reactLibUpdate2 = _interopRequireDefault(_reactLibUpdate);
	
	var Container = (function (_Component) {
	  _inherits(Container, _Component);
	
	  function Container(props) {
	    _classCallCheck(this, _Container);
	
	    _Component.call(this, props);
	    this.state = {
	      dustbins: [{ accepts: [_ItemTypes2['default'].GLASS], lastDroppedItem: null }, { accepts: [_ItemTypes2['default'].FOOD], lastDroppedItem: null }, { accepts: [_ItemTypes2['default'].PAPER, _ItemTypes2['default'].GLASS, _reactDndModulesBackendsHTML5.NativeTypes.URL], lastDroppedItem: null }, { accepts: [_ItemTypes2['default'].PAPER, _reactDndModulesBackendsHTML5.NativeTypes.FILE], lastDroppedItem: null }],
	      boxes: [{ name: 'Bottle', type: _ItemTypes2['default'].GLASS }, { name: 'Banana', type: _ItemTypes2['default'].FOOD }, { name: 'Magazine', type: _ItemTypes2['default'].PAPER }],
	      droppedBoxNames: []
	    };
	  }
	
	  Container.prototype.isDropped = function isDropped(boxName) {
	    return this.state.droppedBoxNames.indexOf(boxName) > -1;
	  };
	
	  Container.prototype.render = function render() {
	    var _this = this;
	
	    var _state = this.state;
	    var boxes = _state.boxes;
	    var dustbins = _state.dustbins;
	
	    return _react2['default'].createElement(
	      'div',
	      null,
	      _react2['default'].createElement(
	        'div',
	        { style: { overflow: 'hidden', clear: 'both' } },
	        dustbins.map(function (_ref, index) {
	          var accepts = _ref.accepts;
	          var lastDroppedItem = _ref.lastDroppedItem;
	          return _react2['default'].createElement(_Dustbin2['default'], { accepts: accepts,
	            lastDroppedItem: lastDroppedItem,
	            onDrop: function (item) {
	              return _this.handleDrop(index, item);
	            },
	            key: index });
	        })
	      ),
	      _react2['default'].createElement(
	        'div',
	        { style: { overflow: 'hidden', clear: 'both' } },
	        boxes.map(function (_ref2, index) {
	          var name = _ref2.name;
	          var type = _ref2.type;
	          return _react2['default'].createElement(_Box2['default'], { name: name,
	            type: type,
	            isDropped: _this.isDropped(name),
	            key: index });
	        })
	      )
	    );
	  };
	
	  Container.prototype.handleDrop = function handleDrop(index, item) {
	    var name = item.name;
	
	    this.setState(_reactLibUpdate2['default'](this.state, {
	      dustbins: _defineProperty({}, index, {
	        lastDroppedItem: {
	          $set: item
	        }
	      }),
	      droppedBoxNames: name ? {
	        $push: [name]
	      } : {}
	    }));
	  };
	
	  var _Container = Container;
	  Container = _reactDnd.DragDropContext(_reactDndModulesBackendsHTML52['default'])(Container) || Container;
	  return Container;
	})(_react.Component);
	
	exports['default'] = Container;
	module.exports = exports['default'];

/***/ },
/* 172 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDnd = __webpack_require__(3);
	
	var style = {
	  height: '12rem',
	  width: '12rem',
	  marginRight: '1.5rem',
	  marginBottom: '1.5rem',
	  color: 'white',
	  padding: '1rem',
	  textAlign: 'center',
	  fontSize: '1rem',
	  lineHeight: 'normal',
	  float: 'left'
	};
	
	var dustbinTarget = {
	  drop: function drop(props, monitor) {
	    props.onDrop(monitor.getItem());
	  }
	};
	
	var Dustbin = (function (_Component) {
	  _inherits(Dustbin, _Component);
	
	  function Dustbin() {
	    _classCallCheck(this, _Dustbin);
	
	    _Component.apply(this, arguments);
	  }
	
	  Dustbin.prototype.render = function render() {
	    var _props = this.props;
	    var accepts = _props.accepts;
	    var isOver = _props.isOver;
	    var canDrop = _props.canDrop;
	    var connectDropTarget = _props.connectDropTarget;
	    var lastDroppedItem = _props.lastDroppedItem;
	
	    var isActive = isOver && canDrop;
	
	    var backgroundColor = '#222';
	    if (isActive) {
	      backgroundColor = 'darkgreen';
	    } else if (canDrop) {
	      backgroundColor = 'darkkhaki';
	    }
	
	    return connectDropTarget(_react2['default'].createElement(
	      'div',
	      { style: _extends({}, style, { backgroundColor: backgroundColor }) },
	      isActive ? 'Release to drop' : 'This dustbin accepts: ' + accepts.join(', '),
	      lastDroppedItem && _react2['default'].createElement(
	        'p',
	        null,
	        'Last dropped: ',
	        JSON.stringify(lastDroppedItem)
	      )
	    ));
	  };
	
	  _createClass(Dustbin, null, [{
	    key: 'propTypes',
	    value: {
	      connectDropTarget: _react.PropTypes.func.isRequired,
	      isOver: _react.PropTypes.bool.isRequired,
	      canDrop: _react.PropTypes.bool.isRequired,
	      accepts: _react.PropTypes.arrayOf(_react.PropTypes.string).isRequired,
	      lastDroppedItem: _react.PropTypes.object,
	      onDrop: _react.PropTypes.func.isRequired
	    },
	    enumerable: true
	  }]);
	
	  var _Dustbin = Dustbin;
	  Dustbin = _reactDnd.DropTarget(function (props) {
	    return props.accepts;
	  }, dustbinTarget, function (connect, monitor) {
	    return {
	      connectDropTarget: connect.dropTarget(),
	      isOver: monitor.isOver(),
	      canDrop: monitor.canDrop()
	    };
	  })(Dustbin) || Dustbin;
	  return Dustbin;
	})(_react.Component);
	
	exports['default'] = Dustbin;
	module.exports = exports['default'];

/***/ },
/* 173 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = {
	  FOOD: 'food',
	  GLASS: 'glass',
	  PAPER: 'paper'
	};
	module.exports = exports['default'];

/***/ },
/* 174 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Container = __webpack_require__(171);
	
	var _Container2 = _interopRequireDefault(_Container);
	
	var DustbinMultipleTargets = (function () {
	  function DustbinMultipleTargets() {
	    _classCallCheck(this, DustbinMultipleTargets);
	  }
	
	  DustbinMultipleTargets.prototype.render = function render() {
	    return _react2['default'].createElement(
	      'div',
	      null,
	      _react2['default'].createElement(
	        'p',
	        null,
	        _react2['default'].createElement(
	          'b',
	          null,
	          _react2['default'].createElement(
	            'a',
	            { href: 'https://github.com/pljenkins/react-dnd/tree/master/examples/01%20Dustbin/Multiple%20Targets' },
	            'Browse the Source'
	          )
	        )
	      ),
	      _react2['default'].createElement(
	        'p',
	        null,
	        'This is a slightly more interesting example.'
	      ),
	      _react2['default'].createElement(
	        'p',
	        null,
	        'It demonstrates how a single drop target may accept multiple types, and how those types may be derived from props. It also demonstrates the handling of native files and URLs (try dropping them onto the last two dustbins).'
	      ),
	      _react2['default'].createElement(_Container2['default'], null)
	    );
	  };
	
	  return DustbinMultipleTargets;
	})();
	
	exports['default'] = DustbinMultipleTargets;
	module.exports = exports['default'];

/***/ },
/* 175 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ItemTypes = __webpack_require__(105);
	
	var _ItemTypes2 = _interopRequireDefault(_ItemTypes);
	
	var _reactDnd = __webpack_require__(3);
	
	var style = {
	  border: '1px dashed gray',
	  backgroundColor: 'white',
	  padding: '0.5rem 1rem',
	  marginRight: '1.5rem',
	  marginBottom: '1.5rem',
	  cursor: 'move',
	  float: 'left'
	};
	
	var boxSource = {
	  beginDrag: function beginDrag(props) {
	    return {
	      name: props.name
	    };
	  },
	
	  endDrag: function endDrag(props, monitor) {
	    var item = monitor.getItem();
	    var dropResult = monitor.getDropResult();
	
	    if (dropResult) {
	      window.alert('You dropped ' + item.name + ' into ' + dropResult.name + '!');
	    }
	  }
	};
	
	var Box = (function (_Component) {
	  _inherits(Box, _Component);
	
	  function Box() {
	    _classCallCheck(this, _Box);
	
	    _Component.apply(this, arguments);
	  }
	
	  Box.prototype.render = function render() {
	    var _props = this.props;
	    var isDragging = _props.isDragging;
	    var connectDragSource = _props.connectDragSource;
	    var name = this.props.name;
	
	    var opacity = isDragging ? 0.4 : 1;
	
	    return connectDragSource(_react2['default'].createElement(
	      'div',
	      { style: _extends({}, style, { opacity: opacity }) },
	      name
	    ));
	  };
	
	  _createClass(Box, null, [{
	    key: 'propTypes',
	    value: {
	      connectDragSource: _react.PropTypes.func.isRequired,
	      isDragging: _react.PropTypes.bool.isRequired,
	      name: _react.PropTypes.string.isRequired
	    },
	    enumerable: true
	  }]);
	
	  var _Box = Box;
	  Box = _reactDnd.DragSource(_ItemTypes2['default'].BOX, boxSource, function (connect, monitor) {
	    return {
	      connectDragSource: connect.dragSource(),
	      isDragging: monitor.isDragging()
	    };
	  })(Box) || Box;
	  return Box;
	})(_react.Component);
	
	exports['default'] = Box;
	module.exports = exports['default'];

/***/ },
/* 176 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDnd = __webpack_require__(3);
	
	var _reactDndModulesBackendsHTML5 = __webpack_require__(10);
	
	var _reactDndModulesBackendsHTML52 = _interopRequireDefault(_reactDndModulesBackendsHTML5);
	
	var _Dustbin = __webpack_require__(177);
	
	var _Dustbin2 = _interopRequireDefault(_Dustbin);
	
	var _Box = __webpack_require__(175);
	
	var _Box2 = _interopRequireDefault(_Box);
	
	var Container = (function (_Component) {
	  _inherits(Container, _Component);
	
	  function Container() {
	    _classCallCheck(this, _Container);
	
	    _Component.apply(this, arguments);
	  }
	
	  Container.prototype.render = function render() {
	    return _react2['default'].createElement(
	      'div',
	      null,
	      _react2['default'].createElement(
	        'div',
	        { style: { overflow: 'hidden', clear: 'both' } },
	        _react2['default'].createElement(_Dustbin2['default'], null)
	      ),
	      _react2['default'].createElement(
	        'div',
	        { style: { overflow: 'hidden', clear: 'both' } },
	        _react2['default'].createElement(_Box2['default'], { name: 'Glass' }),
	        _react2['default'].createElement(_Box2['default'], { name: 'Banana' }),
	        _react2['default'].createElement(_Box2['default'], { name: 'Paper' })
	      )
	    );
	  };
	
	  var _Container = Container;
	  Container = _reactDnd.DragDropContext(_reactDndModulesBackendsHTML52['default'])(Container) || Container;
	  return Container;
	})(_react.Component);
	
	exports['default'] = Container;
	module.exports = exports['default'];

/***/ },
/* 177 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ItemTypes = __webpack_require__(105);
	
	var _ItemTypes2 = _interopRequireDefault(_ItemTypes);
	
	var _reactDnd = __webpack_require__(3);
	
	var style = {
	  height: '12rem',
	  width: '12rem',
	  marginRight: '1.5rem',
	  marginBottom: '1.5rem',
	  color: 'white',
	  padding: '1rem',
	  textAlign: 'center',
	  fontSize: '1rem',
	  lineHeight: 'normal',
	  float: 'left'
	};
	
	var boxTarget = {
	  drop: function drop() {
	    return { name: 'Dustbin' };
	  }
	};
	
	var Dustbin = (function (_Component) {
	  _inherits(Dustbin, _Component);
	
	  function Dustbin() {
	    _classCallCheck(this, _Dustbin);
	
	    _Component.apply(this, arguments);
	  }
	
	  Dustbin.prototype.render = function render() {
	    var _props = this.props;
	    var canDrop = _props.canDrop;
	    var isOver = _props.isOver;
	    var connectDropTarget = _props.connectDropTarget;
	
	    var isActive = canDrop && isOver;
	
	    var backgroundColor = '#222';
	    if (isActive) {
	      backgroundColor = 'darkgreen';
	    } else if (canDrop) {
	      backgroundColor = 'darkkhaki';
	    }
	
	    return connectDropTarget(_react2['default'].createElement(
	      'div',
	      { style: _extends({}, style, { backgroundColor: backgroundColor }) },
	      isActive ? 'Release to drop' : 'Drag a box here'
	    ));
	  };
	
	  _createClass(Dustbin, null, [{
	    key: 'propTypes',
	    value: {
	      connectDropTarget: _react.PropTypes.func.isRequired,
	      isOver: _react.PropTypes.bool.isRequired,
	      canDrop: _react.PropTypes.bool.isRequired
	    },
	    enumerable: true
	  }]);
	
	  var _Dustbin = Dustbin;
	  Dustbin = _reactDnd.DropTarget(_ItemTypes2['default'].BOX, boxTarget, function (connect, monitor) {
	    return {
	      connectDropTarget: connect.dropTarget(),
	      isOver: monitor.isOver(),
	      canDrop: monitor.canDrop()
	    };
	  })(Dustbin) || Dustbin;
	  return Dustbin;
	})(_react.Component);
	
	exports['default'] = Dustbin;
	module.exports = exports['default'];

/***/ },
/* 178 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Container = __webpack_require__(176);
	
	var _Container2 = _interopRequireDefault(_Container);
	
	var DustbinSingleTarget = (function () {
	  function DustbinSingleTarget() {
	    _classCallCheck(this, DustbinSingleTarget);
	  }
	
	  DustbinSingleTarget.prototype.render = function render() {
	    return _react2['default'].createElement(
	      'div',
	      null,
	      _react2['default'].createElement(
	        'p',
	        null,
	        _react2['default'].createElement(
	          'b',
	          null,
	          _react2['default'].createElement(
	            'a',
	            { href: 'https://github.com/pljenkins/react-dnd/tree/master/examples/01%20Dustbin/Single%20Target' },
	            'Browse the Source'
	          )
	        )
	      ),
	      _react2['default'].createElement(
	        'p',
	        null,
	        'This is the simplest example there is.'
	      ),
	      _react2['default'].createElement(
	        'p',
	        null,
	        'Drag the boxes below and drop them into the dustbin. Note that it has a neutral, an active and a hovered state. The dragged item itself changes opacity while dragged.'
	      ),
	      _react2['default'].createElement(_Container2['default'], null)
	    );
	  };
	
	  return DustbinSingleTarget;
	})();
	
	exports['default'] = DustbinSingleTarget;
	module.exports = exports['default'];

/***/ },
/* 179 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDnd = __webpack_require__(3);
	
	var style = {
	  border: '1px dashed gray',
	  backgroundColor: 'white',
	  padding: '0.5rem 1rem',
	  marginRight: '1.5rem',
	  marginBottom: '1.5rem',
	  cursor: 'move',
	  float: 'left'
	};
	
	var boxSource = {
	  beginDrag: function beginDrag(props) {
	    return {
	      name: props.name
	    };
	  },
	
	  isDragging: function isDragging(props, monitor) {
	    var item = monitor.getItem();
	    return props.name === item.name;
	  }
	};
	
	var Box = (function (_Component) {
	  _inherits(Box, _Component);
	
	  function Box() {
	    _classCallCheck(this, _Box);
	
	    _Component.apply(this, arguments);
	  }
	
	  Box.prototype.render = function render() {
	    var _props = this.props;
	    var name = _props.name;
	    var isDropped = _props.isDropped;
	    var isDragging = _props.isDragging;
	    var connectDragSource = _props.connectDragSource;
	
	    var opacity = isDragging ? 0.4 : 1;
	
	    return connectDragSource(_react2['default'].createElement(
	      'div',
	      { style: _extends({}, style, { opacity: opacity }) },
	      isDropped ? _react2['default'].createElement(
	        's',
	        null,
	        name
	      ) : name
	    ));
	  };
	
	  _createClass(Box, null, [{
	    key: 'propTypes',
	    value: {
	      connectDragSource: _react.PropTypes.func.isRequired,
	      isDragging: _react.PropTypes.bool.isRequired,
	      name: _react.PropTypes.string.isRequired,
	      type: _react.PropTypes.string.isRequired,
	      isDropped: _react.PropTypes.bool.isRequired
	    },
	    enumerable: true
	  }]);
	
	  var _Box = Box;
	  Box = _reactDnd.DragSource(function (props) {
	    return props.type;
	  }, boxSource, function (connect, monitor) {
	    return {
	      connectDragSource: connect.dragSource(),
	      isDragging: monitor.isDragging()
	    };
	  })(Box) || Box;
	  return Box;
	})(_react.Component);
	
	exports['default'] = Box;
	module.exports = exports['default'];

/***/ },
/* 180 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDnd = __webpack_require__(3);
	
	var _reactDndModulesBackendsHTML5 = __webpack_require__(10);
	
	var _reactDndModulesBackendsHTML52 = _interopRequireDefault(_reactDndModulesBackendsHTML5);
	
	var _Dustbin = __webpack_require__(181);
	
	var _Dustbin2 = _interopRequireDefault(_Dustbin);
	
	var _Box = __webpack_require__(179);
	
	var _Box2 = _interopRequireDefault(_Box);
	
	var _ItemTypes = __webpack_require__(182);
	
	var _ItemTypes2 = _interopRequireDefault(_ItemTypes);
	
	var _lodashCollectionShuffle = __webpack_require__(350);
	
	var _lodashCollectionShuffle2 = _interopRequireDefault(_lodashCollectionShuffle);
	
	var _reactLibUpdate = __webpack_require__(25);
	
	var _reactLibUpdate2 = _interopRequireDefault(_reactLibUpdate);
	
	var Container = (function (_Component) {
	  _inherits(Container, _Component);
	
	  function Container(props) {
	    _classCallCheck(this, _Container);
	
	    _Component.call(this, props);
	    this.state = {
	      dustbins: [{ accepts: [_ItemTypes2['default'].GLASS], lastDroppedItem: null }, { accepts: [_ItemTypes2['default'].FOOD], lastDroppedItem: null }, { accepts: [_ItemTypes2['default'].PAPER, _ItemTypes2['default'].GLASS, _reactDndModulesBackendsHTML5.NativeTypes.URL], lastDroppedItem: null }, { accepts: [_ItemTypes2['default'].PAPER, _reactDndModulesBackendsHTML5.NativeTypes.FILE], lastDroppedItem: null }],
	      boxes: [{ name: 'Bottle', type: _ItemTypes2['default'].GLASS }, { name: 'Banana', type: _ItemTypes2['default'].FOOD }, { name: 'Magazine', type: _ItemTypes2['default'].PAPER }],
	      droppedBoxNames: []
	    };
	  }
	
	  Container.prototype.componentDidMount = function componentDidMount() {
	    var _this = this;
	
	    this.interval = setInterval(function () {
	      return _this.tickTock();
	    }, 1000);
	  };
	
	  Container.prototype.tickTock = function tickTock() {
	    this.setState({
	      boxes: _lodashCollectionShuffle2['default'](this.state.boxes),
	      dustbins: _lodashCollectionShuffle2['default'](this.state.dustbins)
	    });
	  };
	
	  Container.prototype.componentWillUnmount = function componentWillUnmount() {
	    clearInterval(this.interval);
	  };
	
	  Container.prototype.isDropped = function isDropped(boxName) {
	    return this.state.droppedBoxNames.indexOf(boxName) > -1;
	  };
	
	  Container.prototype.render = function render() {
	    var _this2 = this;
	
	    var _state = this.state;
	    var boxes = _state.boxes;
	    var dustbins = _state.dustbins;
	
	    return _react2['default'].createElement(
	      'div',
	      null,
	      _react2['default'].createElement(
	        'div',
	        { style: { overflow: 'hidden', clear: 'both' } },
	        dustbins.map(function (_ref, index) {
	          var accepts = _ref.accepts;
	          var lastDroppedItem = _ref.lastDroppedItem;
	          return _react2['default'].createElement(_Dustbin2['default'], { accepts: accepts,
	            lastDroppedItem: lastDroppedItem,
	            onDrop: function (item) {
	              return _this2.handleDrop(index, item);
	            } });
	        })
	      ),
	      _react2['default'].createElement(
	        'div',
	        { style: { overflow: 'hidden', clear: 'both' } },
	        boxes.map(function (_ref2) {
	          var name = _ref2.name;
	          var type = _ref2.type;
	          return _react2['default'].createElement(_Box2['default'], { name: name,
	            type: type,
	            isDropped: _this2.isDropped(name) });
	        })
	      )
	    );
	  };
	
	  Container.prototype.handleDrop = function handleDrop(index, item) {
	    var name = item.name;
	
	    this.setState(_reactLibUpdate2['default'](this.state, {
	      dustbins: _defineProperty({}, index, {
	        lastDroppedItem: {
	          $set: item
	        }
	      }),
	      droppedBoxNames: name ? {
	        $push: [name]
	      } : {}
	    }));
	  };
	
	  var _Container = Container;
	  Container = _reactDnd.DragDropContext(_reactDndModulesBackendsHTML52['default'])(Container) || Container;
	  return Container;
	})(_react.Component);
	
	exports['default'] = Container;
	module.exports = exports['default'];

/***/ },
/* 181 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDnd = __webpack_require__(3);
	
	var style = {
	  height: '12rem',
	  width: '12rem',
	  marginRight: '1.5rem',
	  marginBottom: '1.5rem',
	  color: 'white',
	  padding: '1rem',
	  textAlign: 'center',
	  fontSize: '1rem',
	  lineHeight: 'normal',
	  float: 'left'
	};
	
	var dustbinTarget = {
	  drop: function drop(props, monitor) {
	    props.onDrop(monitor.getItem());
	  }
	};
	
	var Dustbin = (function (_Component) {
	  _inherits(Dustbin, _Component);
	
	  function Dustbin() {
	    _classCallCheck(this, _Dustbin);
	
	    _Component.apply(this, arguments);
	  }
	
	  Dustbin.prototype.render = function render() {
	    var _props = this.props;
	    var accepts = _props.accepts;
	    var isOver = _props.isOver;
	    var canDrop = _props.canDrop;
	    var connectDropTarget = _props.connectDropTarget;
	    var lastDroppedItem = _props.lastDroppedItem;
	
	    var isActive = isOver && canDrop;
	
	    var backgroundColor = '#222';
	    if (isActive) {
	      backgroundColor = 'darkgreen';
	    } else if (canDrop) {
	      backgroundColor = 'darkkhaki';
	    }
	
	    return connectDropTarget(_react2['default'].createElement(
	      'div',
	      { style: _extends({}, style, { backgroundColor: backgroundColor }) },
	      isActive ? 'Release to drop' : 'This dustbin accepts: ' + accepts.join(', '),
	      lastDroppedItem && _react2['default'].createElement(
	        'p',
	        null,
	        'Last dropped: ',
	        JSON.stringify(lastDroppedItem)
	      )
	    ));
	  };
	
	  _createClass(Dustbin, null, [{
	    key: 'propTypes',
	    value: {
	      connectDropTarget: _react.PropTypes.func.isRequired,
	      isOver: _react.PropTypes.bool.isRequired,
	      canDrop: _react.PropTypes.bool.isRequired,
	      accepts: _react.PropTypes.arrayOf(_react.PropTypes.string).isRequired,
	      lastDroppedItem: _react.PropTypes.object,
	      onDrop: _react.PropTypes.func.isRequired
	    },
	    enumerable: true
	  }]);
	
	  var _Dustbin = Dustbin;
	  Dustbin = _reactDnd.DropTarget(function (props) {
	    return props.accepts;
	  }, dustbinTarget, function (connect, monitor) {
	    return {
	      connectDropTarget: connect.dropTarget(),
	      isOver: monitor.isOver(),
	      canDrop: monitor.canDrop()
	    };
	  })(Dustbin) || Dustbin;
	  return Dustbin;
	})(_react.Component);
	
	exports['default'] = Dustbin;
	module.exports = exports['default'];

/***/ },
/* 182 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = {
	  FOOD: 'food',
	  GLASS: 'glass',
	  PAPER: 'paper'
	};
	module.exports = exports['default'];

/***/ },
/* 183 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Container = __webpack_require__(180);
	
	var _Container2 = _interopRequireDefault(_Container);
	
	var DustbinStressTest = (function () {
	  function DustbinStressTest() {
	    _classCallCheck(this, DustbinStressTest);
	  }
	
	  DustbinStressTest.prototype.render = function render() {
	    return _react2['default'].createElement(
	      'div',
	      null,
	      _react2['default'].createElement(
	        'p',
	        null,
	        _react2['default'].createElement(
	          'b',
	          null,
	          _react2['default'].createElement(
	            'a',
	            { href: 'https://github.com/pljenkins/react-dnd/tree/master/examples/01%20Dustbin/Stress%20Test' },
	            'Browse the Source'
	          )
	        )
	      ),
	      _react2['default'].createElement(
	        'p',
	        null,
	        'This example is similar to the previous one, but props of both the drag sources and the drop targets change every second. It demonstrates that React DnD keeps track of the changing props, and if a component receives the new props, React DnD recalculates the drag and drop state. It also shows how a custom ',
	        _react2['default'].createElement(
	          'code',
	          null,
	          'isDragging'
	        ),
	        ' implementation can make the drag source appear as dragged, even if the component that initiated the drag has received new props.'
	      ),
	      _react2['default'].createElement(_Container2['default'], null)
	    );
	  };
	
	  return DustbinStressTest;
	})();
	
	exports['default'] = DustbinStressTest;
	module.exports = exports['default'];

/***/ },
/* 184 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _shouldPureComponentUpdate = __webpack_require__(38);
	
	var _shouldPureComponentUpdate2 = _interopRequireDefault(_shouldPureComponentUpdate);
	
	var _Box = __webpack_require__(106);
	
	var _Box2 = _interopRequireDefault(_Box);
	
	var styles = {
	  display: 'inline-block',
	  transform: 'rotate(-7deg)',
	  WebkitTransform: 'rotate(-7deg)'
	};
	
	var BoxDragPreview = (function (_Component) {
	  _inherits(BoxDragPreview, _Component);
	
	  _createClass(BoxDragPreview, null, [{
	    key: 'propTypes',
	    value: {
	      title: _react.PropTypes.string.isRequired
	    },
	    enumerable: true
	  }]);
	
	  function BoxDragPreview(props) {
	    _classCallCheck(this, BoxDragPreview);
	
	    _Component.call(this, props);
	    this.shouldComponentUpdate = _shouldPureComponentUpdate2['default'];
	    this.tick = this.tick.bind(this);
	    this.state = {
	      tickTock: false
	    };
	  }
	
	  BoxDragPreview.prototype.componentDidMount = function componentDidMount() {
	    this.interval = setInterval(this.tick, 500);
	  };
	
	  BoxDragPreview.prototype.componentWillUnmount = function componentWillUnmount() {
	    clearInterval(this.interval);
	  };
	
	  BoxDragPreview.prototype.tick = function tick() {
	    this.setState({
	      tickTock: !this.state.tickTock
	    });
	  };
	
	  BoxDragPreview.prototype.render = function render() {
	    var title = this.props.title;
	    var tickTock = this.state.tickTock;
	
	    return _react2['default'].createElement(
	      'div',
	      { style: styles },
	      _react2['default'].createElement(_Box2['default'], { title: title,
	        yellow: tickTock })
	    );
	  };
	
	  return BoxDragPreview;
	})(_react.Component);
	
	exports['default'] = BoxDragPreview;
	module.exports = exports['default'];

/***/ },
/* 185 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _slicedToArray = (function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i['return']) _i['return'](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError('Invalid attempt to destructure non-iterable instance'); } }; })();
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _shouldPureComponentUpdate = __webpack_require__(38);
	
	var _shouldPureComponentUpdate2 = _interopRequireDefault(_shouldPureComponentUpdate);
	
	var _reactLibUpdate = __webpack_require__(25);
	
	var _reactLibUpdate2 = _interopRequireDefault(_reactLibUpdate);
	
	var _ItemTypes = __webpack_require__(67);
	
	var _ItemTypes2 = _interopRequireDefault(_ItemTypes);
	
	var _DraggableBox = __webpack_require__(187);
	
	var _DraggableBox2 = _interopRequireDefault(_DraggableBox);
	
	var _snapToGrid3 = __webpack_require__(107);
	
	var _snapToGrid4 = _interopRequireDefault(_snapToGrid3);
	
	var _reactDnd = __webpack_require__(3);
	
	var styles = {
	  width: 300,
	  height: 300,
	  border: '1px solid black',
	  position: 'relative'
	};
	
	var boxTarget = {
	  drop: function drop(props, monitor, component) {
	    var delta = monitor.getDifferenceFromInitialOffset();
	    var item = monitor.getItem();
	
	    var left = Math.round(item.left + delta.x);
	    var top = Math.round(item.top + delta.y);
	    if (props.snapToGrid) {
	      var _snapToGrid = _snapToGrid4['default'](left, top);
	
	      var _snapToGrid2 = _slicedToArray(_snapToGrid, 2);
	
	      left = _snapToGrid2[0];
	      top = _snapToGrid2[1];
	    }
	
	    component.moveBox(item.id, left, top);
	  }
	};
	
	var Container = (function (_Component) {
	  _inherits(Container, _Component);
	
	  _createClass(Container, null, [{
	    key: 'propTypes',
	    value: {
	      connectDropTarget: _react.PropTypes.func.isRequired,
	      snapToGrid: _react.PropTypes.bool.isRequired
	    },
	    enumerable: true
	  }]);
	
	  function Container(props) {
	    _classCallCheck(this, _Container);
	
	    _Component.call(this, props);
	    this.shouldComponentUpdate = _shouldPureComponentUpdate2['default'];
	    this.state = {
	      boxes: {
	        'a': { top: 20, left: 80, title: 'Drag me around' },
	        'b': { top: 180, left: 20, title: 'Drag me too' }
	      }
	    };
	  }
	
	  Container.prototype.moveBox = function moveBox(id, left, top) {
	    this.setState(_reactLibUpdate2['default'](this.state, {
	      boxes: _defineProperty({}, id, {
	        $merge: {
	          left: left,
	          top: top
	        }
	      })
	    }));
	  };
	
	  Container.prototype.renderBox = function renderBox(item, key) {
	    return _react2['default'].createElement(_DraggableBox2['default'], _extends({ key: key,
	      id: key
	    }, item));
	  };
	
	  Container.prototype.render = function render() {
	    var _this = this;
	
	    var connectDropTarget = this.props.connectDropTarget;
	    var boxes = this.state.boxes;
	
	    return connectDropTarget(_react2['default'].createElement(
	      'div',
	      { style: styles },
	      Object.keys(boxes).map(function (key) {
	        return _this.renderBox(boxes[key], key);
	      })
	    ));
	  };
	
	  var _Container = Container;
	  Container = _reactDnd.DropTarget(_ItemTypes2['default'].BOX, boxTarget, function (connect) {
	    return {
	      connectDropTarget: connect.dropTarget()
	    };
	  })(Container) || Container;
	  return Container;
	})(_react.Component);
	
	exports['default'] = Container;
	module.exports = exports['default'];

/***/ },
/* 186 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _slicedToArray = (function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i['return']) _i['return'](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError('Invalid attempt to destructure non-iterable instance'); } }; })();
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _shouldPureComponentUpdate = __webpack_require__(38);
	
	var _shouldPureComponentUpdate2 = _interopRequireDefault(_shouldPureComponentUpdate);
	
	var _ItemTypes = __webpack_require__(67);
	
	var _ItemTypes2 = _interopRequireDefault(_ItemTypes);
	
	var _BoxDragPreview = __webpack_require__(184);
	
	var _BoxDragPreview2 = _interopRequireDefault(_BoxDragPreview);
	
	var _snapToGrid3 = __webpack_require__(107);
	
	var _snapToGrid4 = _interopRequireDefault(_snapToGrid3);
	
	var _reactDnd = __webpack_require__(3);
	
	var layerStyles = {
	  position: 'fixed',
	  pointerEvents: 'none',
	  zIndex: 100,
	  left: 0,
	  top: 0,
	  width: '100%',
	  height: '100%'
	};
	
	function getItemStyles(props) {
	  var initialOffset = props.initialOffset;
	  var currentOffset = props.currentOffset;
	
	  if (!initialOffset || !currentOffset) {
	    return {
	      display: 'none'
	    };
	  }
	
	  var x = currentOffset.x;
	  var y = currentOffset.y;
	
	  if (props.snapToGrid) {
	    x -= initialOffset.x;
	    y -= initialOffset.y;
	
	    var _snapToGrid = _snapToGrid4['default'](x, y);
	
	    var _snapToGrid2 = _slicedToArray(_snapToGrid, 2);
	
	    x = _snapToGrid2[0];
	    y = _snapToGrid2[1];
	
	    x += initialOffset.x;
	    y += initialOffset.y;
	  }
	
	  var transform = 'translate(' + x + 'px, ' + y + 'px)';
	  return {
	    transform: transform,
	    WebkitTransform: transform
	  };
	}
	
	var CustomDragLayer = (function () {
	  function CustomDragLayer() {
	    _classCallCheck(this, _CustomDragLayer);
	  }
	
	  CustomDragLayer.prototype.renderItem = function renderItem(type, item) {
	    switch (type) {
	      case _ItemTypes2['default'].BOX:
	        return _react2['default'].createElement(_BoxDragPreview2['default'], { title: item.title });
	    }
	  };
	
	  CustomDragLayer.prototype.render = function render() {
	    var _props = this.props;
	    var item = _props.item;
	    var itemType = _props.itemType;
	    var isDragging = _props.isDragging;
	
	    if (!isDragging) {
	      return null;
	    }
	
	    return _react2['default'].createElement(
	      'div',
	      { style: layerStyles },
	      _react2['default'].createElement(
	        'div',
	        { style: getItemStyles(this.props) },
	        this.renderItem(itemType, item)
	      )
	    );
	  };
	
	  _createClass(CustomDragLayer, null, [{
	    key: 'propTypes',
	    value: {
	      item: _react.PropTypes.object,
	      itemType: _react.PropTypes.string,
	      initialOffset: _react.PropTypes.shape({
	        x: _react.PropTypes.number.isRequired,
	        y: _react.PropTypes.number.isRequired
	      }),
	      currentOffset: _react.PropTypes.shape({
	        x: _react.PropTypes.number.isRequired,
	        y: _react.PropTypes.number.isRequired
	      }),
	      isDragging: _react.PropTypes.bool.isRequired,
	      snapToGrid: _react.PropTypes.bool.isRequired
	    },
	    enumerable: true
	  }]);
	
	  var _CustomDragLayer = CustomDragLayer;
	  CustomDragLayer = _reactDnd.DragLayer(function (monitor) {
	    return {
	      item: monitor.getItem(),
	      itemType: monitor.getItemType(),
	      initialOffset: monitor.getInitialSourceClientOffset(),
	      currentOffset: monitor.getSourceClientOffset(),
	      isDragging: monitor.isDragging()
	    };
	  })(CustomDragLayer) || CustomDragLayer;
	  return CustomDragLayer;
	})();
	
	exports['default'] = CustomDragLayer;
	module.exports = exports['default'];

/***/ },
/* 187 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _shouldPureComponentUpdate = __webpack_require__(38);
	
	var _shouldPureComponentUpdate2 = _interopRequireDefault(_shouldPureComponentUpdate);
	
	var _ItemTypes = __webpack_require__(67);
	
	var _ItemTypes2 = _interopRequireDefault(_ItemTypes);
	
	var _Box = __webpack_require__(106);
	
	var _Box2 = _interopRequireDefault(_Box);
	
	var _reactDnd = __webpack_require__(3);
	
	var _reactDndModulesBackendsHTML5 = __webpack_require__(10);
	
	var boxSource = {
	  beginDrag: function beginDrag(props) {
	    var id = props.id;
	    var title = props.title;
	    var left = props.left;
	    var top = props.top;
	
	    return { id: id, title: title, left: left, top: top };
	  }
	};
	
	function getStyles(props) {
	  var left = props.left;
	  var top = props.top;
	  var isDragging = props.isDragging;
	
	  var transform = 'translate3d(' + left + 'px, ' + top + 'px, 0)';
	
	  return {
	    position: 'absolute',
	    transform: transform,
	    WebkitTransform: transform,
	    // IE fallback: hide the real node using CSS when dragging
	    // because IE will ignore our custom "empty image" drag preview.
	    opacity: isDragging ? 0 : 1,
	    height: isDragging ? 0 : ''
	  };
	}
	
	var DraggableBox = (function () {
	  function DraggableBox() {
	    _classCallCheck(this, _DraggableBox);
	
	    this.shouldComponentUpdate = _shouldPureComponentUpdate2['default'];
	  }
	
	  DraggableBox.prototype.componentDidMount = function componentDidMount() {
	    // Use empty image as a drag preview so browsers don't draw it
	    // and we can draw whatever we want on the custom drag layer instead.
	    this.props.connectDragPreview(_reactDndModulesBackendsHTML5.getEmptyImage(), {
	      // IE fallback: specify that we'd rather screenshot the node
	      // when it already knows it's being dragged so we can hide it with CSS.
	      captureDraggingState: true
	    });
	  };
	
	  DraggableBox.prototype.render = function render() {
	    var _props = this.props;
	    var title = _props.title;
	    var connectDragSource = _props.connectDragSource;
	
	    return connectDragSource(_react2['default'].createElement(
	      'div',
	      { style: getStyles(this.props) },
	      _react2['default'].createElement(_Box2['default'], { title: title })
	    ));
	  };
	
	  _createClass(DraggableBox, null, [{
	    key: 'propTypes',
	    value: {
	      connectDragSource: _react.PropTypes.func.isRequired,
	      connectDragPreview: _react.PropTypes.func.isRequired,
	      isDragging: _react.PropTypes.bool.isRequired,
	      id: _react.PropTypes.any.isRequired,
	      title: _react.PropTypes.string.isRequired,
	      left: _react.PropTypes.number.isRequired,
	      top: _react.PropTypes.number.isRequired
	    },
	    enumerable: true
	  }]);
	
	  var _DraggableBox = DraggableBox;
	  DraggableBox = _reactDnd.DragSource(_ItemTypes2['default'].BOX, boxSource, function (connect, monitor) {
	    return {
	      connectDragSource: connect.dragSource(),
	      connectDragPreview: connect.dragPreview(),
	      isDragging: monitor.isDragging()
	    };
	  })(DraggableBox) || DraggableBox;
	  return DraggableBox;
	})();
	
	exports['default'] = DraggableBox;
	module.exports = exports['default'];

/***/ },
/* 188 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Container = __webpack_require__(185);
	
	var _Container2 = _interopRequireDefault(_Container);
	
	var _CustomDragLayer = __webpack_require__(186);
	
	var _CustomDragLayer2 = _interopRequireDefault(_CustomDragLayer);
	
	var _reactDnd = __webpack_require__(3);
	
	var _reactDndModulesBackendsHTML5 = __webpack_require__(10);
	
	var _reactDndModulesBackendsHTML52 = _interopRequireDefault(_reactDndModulesBackendsHTML5);
	
	var DragAroundCustomDragLayer = (function (_Component) {
	  _inherits(DragAroundCustomDragLayer, _Component);
	
	  function DragAroundCustomDragLayer(props) {
	    _classCallCheck(this, _DragAroundCustomDragLayer);
	
	    _Component.call(this, props);
	
	    this.handleSnapToGridAfterDropChange = this.handleSnapToGridAfterDropChange.bind(this);
	    this.handleSnapToGridWhileDraggingChange = this.handleSnapToGridWhileDraggingChange.bind(this);
	
	    this.state = {
	      snapToGridAfterDrop: false,
	      snapToGridWhileDragging: false
	    };
	  }
	
	  DragAroundCustomDragLayer.prototype.render = function render() {
	    var _state = this.state;
	    var snapToGridAfterDrop = _state.snapToGridAfterDrop;
	    var snapToGridWhileDragging = _state.snapToGridWhileDragging;
	
	    return _react2['default'].createElement(
	      'div',
	      null,
	      _react2['default'].createElement(
	        'p',
	        null,
	        _react2['default'].createElement(
	          'b',
	          null,
	          _react2['default'].createElement(
	            'a',
	            { href: 'https://github.com/pljenkins/react-dnd/tree/master/examples/02%20Drag%20Around/Custom%20Drag%20Layer' },
	            'Browse the Source'
	          )
	        )
	      ),
	      _react2['default'].createElement(
	        'p',
	        null,
	        'The browser APIs provide no way to change the drag preview or its behavior once drag has started. Libraries such as jQuery UI implement the drag and drop from scratch to work around this, but react-dnd only supports browser drag and drop “backend” for now, so we have to accept its limitations.'
	      ),
	      _react2['default'].createElement(
	        'p',
	        null,
	        'We can, however, customize behavior a great deal if we feed the browser an empty image as drag preview. This library provides a ',
	        _react2['default'].createElement(
	          'code',
	          null,
	          'DragLayer'
	        ),
	        ' that you can use to implement a fixed layer on top of your app where you\'d draw a custom drag preview component.'
	      ),
	      _react2['default'].createElement(
	        'p',
	        null,
	        'Note that we can draw a completely different component on our drag layer if we wish so. It\'s not just a screenshot.'
	      ),
	      _react2['default'].createElement(
	        'p',
	        null,
	        'With this approach, we miss out on default “return” animation when dropping outside the container. However, we get great flexibility in customizing drag feedback and zero flicker.'
	      ),
	      _react2['default'].createElement(_Container2['default'], { snapToGrid: snapToGridAfterDrop }),
	      _react2['default'].createElement(_CustomDragLayer2['default'], { snapToGrid: snapToGridWhileDragging }),
	      _react2['default'].createElement(
	        'p',
	        null,
	        _react2['default'].createElement(
	          'label',
	          null,
	          _react2['default'].createElement('input', { type: 'checkbox',
	            checked: snapToGridWhileDragging,
	            onChange: this.handleSnapToGridWhileDraggingChange }),
	          _react2['default'].createElement(
	            'small',
	            null,
	            'Snap to grid while dragging'
	          )
	        ),
	        _react2['default'].createElement('br', null),
	        _react2['default'].createElement(
	          'label',
	          null,
	          _react2['default'].createElement('input', { type: 'checkbox',
	            checked: snapToGridAfterDrop,
	            onChange: this.handleSnapToGridAfterDropChange }),
	          _react2['default'].createElement(
	            'small',
	            null,
	            'Snap to grid after drop'
	          )
	        )
	      )
	    );
	  };
	
	  DragAroundCustomDragLayer.prototype.handleSnapToGridAfterDropChange = function handleSnapToGridAfterDropChange() {
	    this.setState({
	      snapToGridAfterDrop: !this.state.snapToGridAfterDrop
	    });
	  };
	
	  DragAroundCustomDragLayer.prototype.handleSnapToGridWhileDraggingChange = function handleSnapToGridWhileDraggingChange() {
	    this.setState({
	      snapToGridWhileDragging: !this.state.snapToGridWhileDragging
	    });
	  };
	
	  var _DragAroundCustomDragLayer = DragAroundCustomDragLayer;
	  DragAroundCustomDragLayer = _reactDnd.DragDropContext(_reactDndModulesBackendsHTML52['default'])(DragAroundCustomDragLayer) || DragAroundCustomDragLayer;
	  return DragAroundCustomDragLayer;
	})(_react.Component);
	
	exports['default'] = DragAroundCustomDragLayer;
	module.exports = exports['default'];

/***/ },
/* 189 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = shallowEqual;
	
	function shallowEqual(objA, objB) {
	  if (objA === objB) {
	    return true;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  var hasOwn = Object.prototype.hasOwnProperty;
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwn.call(objB, keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) {
	
	      return false;
	    }
	
	    var valA = objA[keysA[i]];
	    var valB = objB[keysA[i]];
	
	    if (valA !== valB) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	module.exports = exports["default"];

/***/ },
/* 190 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ItemTypes = __webpack_require__(108);
	
	var _ItemTypes2 = _interopRequireDefault(_ItemTypes);
	
	var _reactDnd = __webpack_require__(3);
	
	var style = {
	  position: 'absolute',
	  border: '1px dashed gray',
	  backgroundColor: 'white',
	  padding: '0.5rem 1rem',
	  cursor: 'move'
	};
	
	var boxSource = {
	  beginDrag: function beginDrag(props) {
	    var id = props.id;
	    var left = props.left;
	    var top = props.top;
	
	    return { id: id, left: left, top: top };
	  }
	};
	
	var Box = (function () {
	  function Box() {
	    _classCallCheck(this, _Box);
	  }
	
	  Box.prototype.render = function render() {
	    var _props = this.props;
	    var hideSourceOnDrag = _props.hideSourceOnDrag;
	    var left = _props.left;
	    var top = _props.top;
	    var connectDragSource = _props.connectDragSource;
	    var isDragging = _props.isDragging;
	    var children = _props.children;
	
	    if (isDragging && hideSourceOnDrag) {
	      return null;
	    }
	
	    return connectDragSource(_react2['default'].createElement(
	      'div',
	      { style: _extends({}, style, { left: left, top: top }) },
	      children
	    ));
	  };
	
	  _createClass(Box, null, [{
	    key: 'propTypes',
	    value: {
	      connectDragSource: _react.PropTypes.func.isRequired,
	      isDragging: _react.PropTypes.bool.isRequired,
	      id: _react.PropTypes.any.isRequired,
	      left: _react.PropTypes.number.isRequired,
	      top: _react.PropTypes.number.isRequired,
	      hideSourceOnDrag: _react.PropTypes.bool.isRequired
	    },
	    enumerable: true
	  }]);
	
	  var _Box = Box;
	  Box = _reactDnd.DragSource(_ItemTypes2['default'].BOX, boxSource, function (connect, monitor) {
	    return {
	      connectDragSource: connect.dragSource(),
	      isDragging: monitor.isDragging()
	    };
	  })(Box) || Box;
	  return Box;
	})();
	
	exports['default'] = Box;
	module.exports = exports['default'];

/***/ },
/* 191 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactLibUpdate = __webpack_require__(25);
	
	var _reactLibUpdate2 = _interopRequireDefault(_reactLibUpdate);
	
	var _ItemTypes = __webpack_require__(108);
	
	var _ItemTypes2 = _interopRequireDefault(_ItemTypes);
	
	var _Box = __webpack_require__(190);
	
	var _Box2 = _interopRequireDefault(_Box);
	
	var _reactDnd = __webpack_require__(3);
	
	var _reactDndModulesBackendsHTML5 = __webpack_require__(10);
	
	var _reactDndModulesBackendsHTML52 = _interopRequireDefault(_reactDndModulesBackendsHTML5);
	
	var styles = {
	  width: 300,
	  height: 300,
	  border: '1px solid black',
	  position: 'relative'
	};
	
	var boxTarget = {
	  drop: function drop(props, monitor, component) {
	    var item = monitor.getItem();
	    var delta = monitor.getDifferenceFromInitialOffset();
	    var left = Math.round(item.left + delta.x);
	    var top = Math.round(item.top + delta.y);
	
	    component.moveBox(item.id, left, top);
	  }
	};
	
	var Container = (function (_Component) {
	  _inherits(Container, _Component);
	
	  _createClass(Container, null, [{
	    key: 'propTypes',
	    value: {
	      hideSourceOnDrag: _react.PropTypes.bool.isRequired,
	      connectDropTarget: _react.PropTypes.func.isRequired
	    },
	    enumerable: true
	  }]);
	
	  function Container(props) {
	    _classCallCheck(this, _Container);
	
	    _Component.call(this, props);
	    this.state = {
	      boxes: {
	        'a': { top: 20, left: 80, title: 'Drag me around' },
	        'b': { top: 180, left: 20, title: 'Drag me too' }
	      }
	    };
	  }
	
	  Container.prototype.moveBox = function moveBox(id, left, top) {
	    this.setState(_reactLibUpdate2['default'](this.state, {
	      boxes: _defineProperty({}, id, {
	        $merge: {
	          left: left,
	          top: top
	        }
	      })
	    }));
	  };
	
	  Container.prototype.render = function render() {
	    var _props = this.props;
	    var hideSourceOnDrag = _props.hideSourceOnDrag;
	    var connectDropTarget = _props.connectDropTarget;
	    var boxes = this.state.boxes;
	
	    return connectDropTarget(_react2['default'].createElement(
	      'div',
	      { style: styles },
	      Object.keys(boxes).map(function (key) {
	        var _boxes$key = boxes[key];
	        var left = _boxes$key.left;
	        var top = _boxes$key.top;
	        var title = _boxes$key.title;
	
	        return _react2['default'].createElement(
	          _Box2['default'],
	          { key: key,
	            id: key,
	            left: left,
	            top: top,
	            hideSourceOnDrag: hideSourceOnDrag },
	          title
	        );
	      })
	    ));
	  };
	
	  var _Container = Container;
	  Container = _reactDnd.DropTarget(_ItemTypes2['default'].BOX, boxTarget, function (connect) {
	    return {
	      connectDropTarget: connect.dropTarget()
	    };
	  })(Container) || Container;
	  Container = _reactDnd.DragDropContext(_reactDndModulesBackendsHTML52['default'])(Container) || Container;
	  return Container;
	})(_react.Component);
	
	exports['default'] = Container;
	module.exports = exports['default'];

/***/ },
/* 192 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Container = __webpack_require__(191);
	
	var _Container2 = _interopRequireDefault(_Container);
	
	var _reactRouter = __webpack_require__(395);
	
	var DragAroundNaive = (function (_Component) {
	  _inherits(DragAroundNaive, _Component);
	
	  function DragAroundNaive(props) {
	    _classCallCheck(this, DragAroundNaive);
	
	    _Component.call(this, props);
	    this.handleHideSourceClick = this.handleHideSourceClick.bind(this);
	    this.state = {
	      hideSourceOnDrag: true
	    };
	  }
	
	  DragAroundNaive.prototype.handleHideSourceClick = function handleHideSourceClick() {
	    this.setState({
	      hideSourceOnDrag: !this.state.hideSourceOnDrag
	    });
	  };
	
	  DragAroundNaive.prototype.render = function render() {
	    var hideSourceOnDrag = this.state.hideSourceOnDrag;
	
	    return _react2['default'].createElement(
	      'div',
	      null,
	      _react2['default'].createElement(
	        'p',
	        null,
	        _react2['default'].createElement(
	          'b',
	          null,
	          _react2['default'].createElement(
	            'a',
	            { href: 'https://github.com/pljenkins/react-dnd/tree/master/examples/02%20Drag%20Around/Naive' },
	            'Browse the Source'
	          )
	        )
	      ),
	      _react2['default'].createElement(
	        'p',
	        null,
	        'This example naively relies on browser drag and drop implementation without much custom logic.'
	      ),
	      _react2['default'].createElement(
	        'p',
	        null,
	        'When the box is dragged, we remove its original DOM node by returning ',
	        _react2['default'].createElement(
	          'code',
	          null,
	          'null'
	        ),
	        ' from ',
	        _react2['default'].createElement(
	          'code',
	          null,
	          'render()'
	        ),
	        ' and let browser draw the drag preview. When the is released, we draw it at the new coordinates. If you try to drag the box outside the container, the browser will animate its return.'
	      ),
	      _react2['default'].createElement(
	        'p',
	        null,
	        'While this approach works for simple cases, it flickers on drop. This happens because the browser removes the drag preview before we have a chance to make the dragged item visible. This might not be a problem if you dim the original item instead of hiding it, but it\'s clearly visible otherwise.'
	      ),
	      _react2['default'].createElement(
	        'p',
	        null,
	        'If we want to add custom logic such as snapping to grid or bounds checking, we can only do this on drop. There is no way for us to control what happens to dragged preview once the browser has drawn it. Check out the ',
	        _react2['default'].createElement(
	          'a',
	          { href: '/examples-drag-around-custom-drag-layer.html' },
	          'custom rendering example'
	        ),
	        ' if you\'d rather trade more control for some more work.'
	      ),
	      _react2['default'].createElement(_Container2['default'], { hideSourceOnDrag: hideSourceOnDrag }),
	      _react2['default'].createElement(
	        'p',
	        null,
	        _react2['default'].createElement(
	          'label',
	          null,
	          _react2['default'].createElement('input', { type: 'checkbox',
	            checked: hideSourceOnDrag,
	            onChange: this.handleHideSourceClick }),
	          _react2['default'].createElement(
	            'small',
	            null,
	            'Hide the source item while dragging'
	          )
	        )
	      )
	    );
	  };
	
	  return DragAroundNaive;
	})(_react.Component);
	
	exports['default'] = DragAroundNaive;
	module.exports = exports['default'];

/***/ },
/* 193 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _SourceBox = __webpack_require__(194);
	
	var _SourceBox2 = _interopRequireDefault(_SourceBox);
	
	var _TargetBox = __webpack_require__(195);
	
	var _TargetBox2 = _interopRequireDefault(_TargetBox);
	
	var _Colors = __webpack_require__(68);
	
	var _Colors2 = _interopRequireDefault(_Colors);
	
	var _reactDnd = __webpack_require__(3);
	
	var _reactDndModulesBackendsHTML5 = __webpack_require__(10);
	
	var _reactDndModulesBackendsHTML52 = _interopRequireDefault(_reactDndModulesBackendsHTML5);
	
	var Container = (function () {
	  function Container() {
	    _classCallCheck(this, _Container);
	  }
	
	  Container.prototype.render = function render() {
	    return _react2['default'].createElement(
	      'div',
	      { style: { overflow: 'hidden', clear: 'both', margin: '-.5rem' } },
	      _react2['default'].createElement(
	        'div',
	        { style: { float: 'left' } },
	        _react2['default'].createElement(
	          _SourceBox2['default'],
	          { color: _Colors2['default'].BLUE },
	          _react2['default'].createElement(
	            _SourceBox2['default'],
	            { color: _Colors2['default'].YELLOW },
	            _react2['default'].createElement(_SourceBox2['default'], { color: _Colors2['default'].YELLOW }),
	            _react2['default'].createElement(_SourceBox2['default'], { color: _Colors2['default'].BLUE })
	          ),
	          _react2['default'].createElement(
	            _SourceBox2['default'],
	            { color: _Colors2['default'].BLUE },
	            _react2['default'].createElement(_SourceBox2['default'], { color: _Colors2['default'].YELLOW })
	          )
	        )
	      ),
	      _react2['default'].createElement(
	        'div',
	        { style: { float: 'left', marginLeft: '5rem', marginTop: '.5rem' } },
	        _react2['default'].createElement(_TargetBox2['default'], null)
	      )
	    );
	  };
	
	  var _Container = Container;
	  Container = _reactDnd.DragDropContext(_reactDndModulesBackendsHTML52['default'])(Container) || Container;
	  return Container;
	})();
	
	exports['default'] = Container;
	module.exports = exports['default'];

/***/ },
/* 194 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Colors = __webpack_require__(68);
	
	var _Colors2 = _interopRequireDefault(_Colors);
	
	var _reactDnd = __webpack_require__(3);
	
	var style = {
	  border: '1px dashed gray',
	  padding: '0.5rem',
	  margin: '0.5rem'
	};
	
	var ColorSource = {
	  canDrag: function canDrag(props) {
	    return !props.forbidDrag;
	  },
	
	  beginDrag: function beginDrag() {
	    return {};
	  }
	};
	
	var SourceBox = (function (_Component) {
	  _inherits(SourceBox, _Component);
	
	  function SourceBox() {
	    _classCallCheck(this, _SourceBox);
	
	    _Component.apply(this, arguments);
	  }
	
	  SourceBox.prototype.render = function render() {
	    var _props = this.props;
	    var color = _props.color;
	    var children = _props.children;
	    var isDragging = _props.isDragging;
	    var connectDragSource = _props.connectDragSource;
	    var forbidDrag = _props.forbidDrag;
	    var onToggleForbidDrag = _props.onToggleForbidDrag;
	
	    var opacity = isDragging ? 0.4 : 1;
	
	    var backgroundColor = undefined;
	    switch (color) {
	      case _Colors2['default'].YELLOW:
	        backgroundColor = 'lightgoldenrodyellow';
	        break;
	      case _Colors2['default'].BLUE:
	        backgroundColor = 'lightblue';
	        break;
	    }
	
	    return connectDragSource(_react2['default'].createElement(
	      'div',
	      { style: _extends({}, style, {
	          backgroundColor: backgroundColor,
	          opacity: opacity,
	          cursor: forbidDrag ? 'default' : 'move'
	        }) },
	      _react2['default'].createElement(
	        'input',
	        { type: 'checkbox',
	          checked: forbidDrag,
	          onChange: onToggleForbidDrag },
	        _react2['default'].createElement(
	          'small',
	          null,
	          'Forbid drag'
	        )
	      ),
	      children
	    ));
	  };
	
	  _createClass(SourceBox, null, [{
	    key: 'propTypes',
	    value: {
	      connectDragSource: _react.PropTypes.func.isRequired,
	      isDragging: _react.PropTypes.bool.isRequired,
	      color: _react.PropTypes.string.isRequired,
	      forbidDrag: _react.PropTypes.bool.isRequired,
	      onToggleForbidDrag: _react.PropTypes.func.isRequired
	    },
	    enumerable: true
	  }]);
	
	  var _SourceBox = SourceBox;
	  SourceBox = _reactDnd.DragSource(function (props) {
	    return props.color;
	  }, ColorSource, function (connect, monitor) {
	    return {
	      connectDragSource: connect.dragSource(),
	      isDragging: monitor.isDragging()
	    };
	  })(SourceBox) || SourceBox;
	  return SourceBox;
	})(_react.Component);
	
	var StatefulSourceBox = (function (_Component2) {
	  _inherits(StatefulSourceBox, _Component2);
	
	  function StatefulSourceBox(props) {
	    _classCallCheck(this, StatefulSourceBox);
	
	    _Component2.call(this, props);
	    this.state = {
	      forbidDrag: false
	    };
	  }
	
	  StatefulSourceBox.prototype.render = function render() {
	    var _this = this;
	
	    return _react2['default'].createElement(SourceBox, _extends({}, this.props, {
	      forbidDrag: this.state.forbidDrag,
	      onToggleForbidDrag: function () {
	        return _this.handleToggleForbidDrag();
	      } }));
	  };
	
	  StatefulSourceBox.prototype.handleToggleForbidDrag = function handleToggleForbidDrag() {
	    this.setState({
	      forbidDrag: !this.state.forbidDrag
	    });
	  };
	
	  return StatefulSourceBox;
	})(_react.Component);
	
	exports['default'] = StatefulSourceBox;
	module.exports = exports['default'];

/***/ },
/* 195 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDnd = __webpack_require__(3);
	
	var _Colors = __webpack_require__(68);
	
	var _Colors2 = _interopRequireDefault(_Colors);
	
	var style = {
	  border: '1px solid gray',
	  height: '15rem',
	  width: '15rem',
	  padding: '2rem',
	  textAlign: 'center'
	};
	
	var ColorTarget = {
	  drop: function drop(props, monitor) {
	    props.onDrop(monitor.getItemType());
	  }
	};
	
	var TargetBox = (function (_Component) {
	  _inherits(TargetBox, _Component);
	
	  function TargetBox() {
	    _classCallCheck(this, _TargetBox);
	
	    _Component.apply(this, arguments);
	  }
	
	  TargetBox.prototype.render = function render() {
	    var _props = this.props;
	    var canDrop = _props.canDrop;
	    var isOver = _props.isOver;
	    var draggingColor = _props.draggingColor;
	    var lastDroppedColor = _props.lastDroppedColor;
	    var connectDropTarget = _props.connectDropTarget;
	
	    var opacity = isOver ? 1 : 0.7;
	
	    var backgroundColor = '#fff';
	    switch (draggingColor) {
	      case _Colors2['default'].BLUE:
	        backgroundColor = 'lightblue';
	        break;
	      case _Colors2['default'].YELLOW:
	        backgroundColor = 'lightgoldenrodyellow';
	        break;
	    }
	
	    return connectDropTarget(_react2['default'].createElement(
	      'div',
	      { style: _extends({}, style, { backgroundColor: backgroundColor, opacity: opacity }) },
	      _react2['default'].createElement(
	        'p',
	        null,
	        'Drop here.'
	      ),
	      !canDrop && lastDroppedColor && _react2['default'].createElement(
	        'p',
	        null,
	        'Last dropped: ',
	        lastDroppedColor
	      )
	    ));
	  };
	
	  _createClass(TargetBox, null, [{
	    key: 'propTypes',
	    value: {
	      isOver: _react.PropTypes.bool.isRequired,
	      canDrop: _react.PropTypes.bool.isRequired,
	      draggingColor: _react.PropTypes.string,
	      lastDroppedColor: _react.PropTypes.string,
	      connectDropTarget: _react.PropTypes.func.isRequired,
	      onDrop: _react.PropTypes.func.isRequired
	    },
	    enumerable: true
	  }]);
	
	  var _TargetBox = TargetBox;
	  TargetBox = _reactDnd.DropTarget([_Colors2['default'].YELLOW, _Colors2['default'].BLUE], ColorTarget, function (connect, monitor) {
	    return {
	      connectDropTarget: connect.dropTarget(),
	      isOver: monitor.isOver(),
	      canDrop: monitor.canDrop(),
	      draggingColor: monitor.getItemType()
	    };
	  })(TargetBox) || TargetBox;
	  return TargetBox;
	})(_react.Component);
	
	var StatefulTargetBox = (function (_Component2) {
	  _inherits(StatefulTargetBox, _Component2);
	
	  function StatefulTargetBox(props) {
	    _classCallCheck(this, StatefulTargetBox);
	
	    _Component2.call(this, props);
	    this.state = { lastDroppedColor: null };
	  }
	
	  StatefulTargetBox.prototype.render = function render() {
	    var _this = this;
	
	    return _react2['default'].createElement(TargetBox, _extends({}, this.props, {
	      lastDroppedColor: this.state.lastDroppedColor,
	      onDrop: function (color) {
	        return _this.handleDrop(color);
	      } }));
	  };
	
	  StatefulTargetBox.prototype.handleDrop = function handleDrop(color) {
	    this.setState({
	      lastDroppedColor: color
	    });
	  };
	
	  return StatefulTargetBox;
	})(_react.Component);
	
	exports['default'] = StatefulTargetBox;
	module.exports = exports['default'];

/***/ },
/* 196 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Container = __webpack_require__(193);
	
	var _Container2 = _interopRequireDefault(_Container);
	
	var NestingDragSources = (function () {
	  function NestingDragSources() {
	    _classCallCheck(this, NestingDragSources);
	  }
	
	  NestingDragSources.prototype.render = function render() {
	    return _react2['default'].createElement(
	      'div',
	      null,
	      _react2['default'].createElement(
	        'p',
	        null,
	        _react2['default'].createElement(
	          'b',
	          null,
	          _react2['default'].createElement(
	            'a',
	            { href: 'https://github.com/pljenkins/react-dnd/tree/master/examples/03%20Nesting/Drag%20Sources' },
	            'Browse the Source'
	          )
	        )
	      ),
	      _react2['default'].createElement(
	        'p',
	        null,
	        'You can nest the drag sources in one another. If a nested drag source returns ',
	        _react2['default'].createElement(
	          'code',
	          null,
	          'false'
	        ),
	        ' from ',
	        _react2['default'].createElement(
	          'code',
	          null,
	          'canDrag'
	        ),
	        ', its parent will be asked, until a draggable source is found and activated. Only the activated drag source will have its ',
	        _react2['default'].createElement(
	          'code',
	          null,
	          'beginDrag()'
	        ),
	        ' and ',
	        _react2['default'].createElement(
	          'code',
	          null,
	          'endDrag()'
	        ),
	        ' called.'
	      ),
	      _react2['default'].createElement(_Container2['default'], null)
	    );
	  };
	
	  return NestingDragSources;
	})();
	
	exports['default'] = NestingDragSources;
	module.exports = exports['default'];

/***/ },
/* 197 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ItemTypes = __webpack_require__(109);
	
	var _ItemTypes2 = _interopRequireDefault(_ItemTypes);
	
	var _reactDnd = __webpack_require__(3);
	
	var style = {
	  display: 'inline-block',
	  border: '1px dashed gray',
	  padding: '0.5rem 1rem',
	  backgroundColor: 'white',
	  cursor: 'move'
	};
	
	var boxSource = {
	  beginDrag: function beginDrag() {
	    return {};
	  }
	};
	
	var Box = (function () {
	  function Box() {
	    _classCallCheck(this, _Box);
	  }
	
	  Box.prototype.render = function render() {
	    var _props = this.props;
	    var isDragging = _props.isDragging;
	    var connectDragSource = _props.connectDragSource;
	
	    return connectDragSource(_react2['default'].createElement(
	      'div',
	      { style: style },
	      'Drag me'
	    ));
	  };
	
	  _createClass(Box, null, [{
	    key: 'propTypes',
	    value: {
	      connectDragSource: _react.PropTypes.func.isRequired,
	      isDragging: _react.PropTypes.bool.isRequired
	    },
	    enumerable: true
	  }]);
	
	  var _Box = Box;
	  Box = _reactDnd.DragSource(_ItemTypes2['default'].BOX, boxSource, function (connect, monitor) {
	    return {
	      connectDragSource: connect.dragSource(),
	      isDragging: monitor.isDragging()
	    };
	  })(Box) || Box;
	  return Box;
	})();
	
	exports['default'] = Box;
	module.exports = exports['default'];

/***/ },
/* 198 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Dustbin = __webpack_require__(199);
	
	var _Dustbin2 = _interopRequireDefault(_Dustbin);
	
	var _Box = __webpack_require__(197);
	
	var _Box2 = _interopRequireDefault(_Box);
	
	var _reactDnd = __webpack_require__(3);
	
	var _reactDndModulesBackendsHTML5 = __webpack_require__(10);
	
	var _reactDndModulesBackendsHTML52 = _interopRequireDefault(_reactDndModulesBackendsHTML5);
	
	var Container = (function () {
	  function Container() {
	    _classCallCheck(this, _Container);
	  }
	
	  Container.prototype.render = function render() {
	    return _react2['default'].createElement(
	      'div',
	      null,
	      _react2['default'].createElement(
	        'div',
	        { style: { overflow: 'hidden', clear: 'both', margin: '-1rem' } },
	        _react2['default'].createElement(
	          _Dustbin2['default'],
	          { greedy: true },
	          _react2['default'].createElement(
	            _Dustbin2['default'],
	            { greedy: true },
	            _react2['default'].createElement(_Dustbin2['default'], { greedy: true })
	          )
	        ),
	        _react2['default'].createElement(
	          _Dustbin2['default'],
	          null,
	          _react2['default'].createElement(
	            _Dustbin2['default'],
	            null,
	            _react2['default'].createElement(_Dustbin2['default'], null)
	          )
	        )
	      ),
	      _react2['default'].createElement(
	        'div',
	        { style: { overflow: 'hidden', clear: 'both', marginTop: '1.5rem' } },
	        _react2['default'].createElement(_Box2['default'], null)
	      )
	    );
	  };
	
	  var _Container = Container;
	  Container = _reactDnd.DragDropContext(_reactDndModulesBackendsHTML52['default'])(Container) || Container;
	  return Container;
	})();
	
	exports['default'] = Container;
	module.exports = exports['default'];

/***/ },
/* 199 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ItemTypes = __webpack_require__(109);
	
	var _ItemTypes2 = _interopRequireDefault(_ItemTypes);
	
	var _reactDnd = __webpack_require__(3);
	
	function getStyle(backgroundColor) {
	  return {
	    border: '1px solid rgba(0,0,0,0.2)',
	    minHeight: '8rem',
	    minWidth: '8rem',
	    color: 'white',
	    backgroundColor: backgroundColor,
	    padding: '2rem',
	    paddingTop: '1rem',
	    margin: '1rem',
	    textAlign: 'center',
	    float: 'left',
	    fontSize: '1rem'
	  };
	}
	
	var boxTarget = {
	  drop: function drop(props, monitor, component) {
	    var hasDroppedOnChild = monitor.didDrop();
	    if (hasDroppedOnChild && !props.greedy) {
	      return;
	    }
	
	    component.setState({
	      hasDropped: true,
	      hasDroppedOnChild: hasDroppedOnChild
	    });
	  }
	};
	
	var Dustbin = (function (_Component) {
	  _inherits(Dustbin, _Component);
	
	  _createClass(Dustbin, null, [{
	    key: 'propTypes',
	    value: {
	      connectDropTarget: _react.PropTypes.func.isRequired,
	      isOver: _react.PropTypes.bool.isRequired,
	      isOverCurrent: _react.PropTypes.bool.isRequired,
	      greedy: _react.PropTypes.bool
	    },
	    enumerable: true
	  }]);
	
	  function Dustbin(props) {
	    _classCallCheck(this, _Dustbin);
	
	    _Component.call(this, props);
	    this.state = {
	      hasDropped: false,
	      hasDroppedOnChild: false
	    };
	  }
	
	  Dustbin.prototype.render = function render() {
	    var _props = this.props;
	    var greedy = _props.greedy;
	    var isOver = _props.isOver;
	    var isOverCurrent = _props.isOverCurrent;
	    var isDragging = _props.isDragging;
	    var connectDropTarget = _props.connectDropTarget;
	    var _state = this.state;
	    var hasDropped = _state.hasDropped;
	    var hasDroppedOnChild = _state.hasDroppedOnChild;
	
	    var text = greedy ? 'greedy' : 'not greedy';
	    var backgroundColor = 'rgba(0, 0, 0, .5)';
	
	    if (isOverCurrent || isOver && greedy) {
	      backgroundColor = 'darkgreen';
	    } else if (isDragging) {
	      backgroundColor = 'darkkhaki';
	    }
	
	    return connectDropTarget(_react2['default'].createElement(
	      'div',
	      { style: getStyle(backgroundColor) },
	      text,
	      _react2['default'].createElement('br', null),
	      hasDropped && _react2['default'].createElement(
	        'span',
	        null,
	        'dropped ',
	        hasDroppedOnChild && ' on child'
	      ),
	      _react2['default'].createElement(
	        'div',
	        null,
	        this.props.children
	      )
	    ));
	  };
	
	  var _Dustbin = Dustbin;
	  Dustbin = _reactDnd.DropTarget(_ItemTypes2['default'].BOX, boxTarget, function (connect, monitor) {
	    return {
	      connectDropTarget: connect.dropTarget(),
	      isOver: monitor.isOver(),
	      isOverCurrent: monitor.isOver({ shallow: true })
	    };
	  })(Dustbin) || Dustbin;
	  return Dustbin;
	})(_react.Component);
	
	exports['default'] = Dustbin;
	module.exports = exports['default'];

/***/ },
/* 200 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Container = __webpack_require__(198);
	
	var _Container2 = _interopRequireDefault(_Container);
	
	var NestingDropTargets = (function () {
	  function NestingDropTargets() {
	    _classCallCheck(this, NestingDropTargets);
	  }
	
	  NestingDropTargets.prototype.render = function render() {
	    return _react2['default'].createElement(
	      'div',
	      null,
	      _react2['default'].createElement(
	        'p',
	        null,
	        _react2['default'].createElement(
	          'b',
	          null,
	          _react2['default'].createElement(
	            'a',
	            { href: 'https://github.com/pljenkins/react-dnd/tree/master/examples/03%20Nesting/Drop%20Targets' },
	            'Browse the Source'
	          )
	        )
	      ),
	      _react2['default'].createElement(
	        'p',
	        null,
	        'Drop targets can, too, be nested in one another. Unlike the drag sources, several drop targets may react to the same item being dragged. React DnD by design offers no means of stopping propagation. Instead, the drop targets may compare ',
	        _react2['default'].createElement(
	          'code',
	          null,
	          'monitor.isOver()'
	        ),
	        ' and ',
	        _react2['default'].createElement(
	          'code',
	          null,
	          'monitor.isOver(',
	          '{',
	          ' shallow: false ',
	          '}',
	          ')'
	        ),
	        ' to learn if just them, or their nested targets, are being hovered. They may also check ',
	        _react2['default'].createElement(
	          'code',
	          null,
	          'monitor.didDrop()'
	        ),
	        ' and ',
	        _react2['default'].createElement(
	          'code',
	          null,
	          'monitor.getDropResult()'
	        ),
	        ' to learn if a nested target has already handled the drop, and even return a different drop result.'
	      ),
	      _react2['default'].createElement(_Container2['default'], null)
	    );
	  };
	
	  return NestingDropTargets;
	})();
	
	exports['default'] = NestingDropTargets;
	module.exports = exports['default'];

/***/ },
/* 201 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ItemTypes = __webpack_require__(110);
	
	var _ItemTypes2 = _interopRequireDefault(_ItemTypes);
	
	var _reactDnd = __webpack_require__(3);
	
	var style = {
	  border: '1px dashed gray',
	  padding: '0.5rem 1rem',
	  marginBottom: '.5rem',
	  backgroundColor: 'white',
	  cursor: 'move'
	};
	
	var cardSource = {
	  beginDrag: function beginDrag(props) {
	    return {
	      id: props.id,
	      originalIndex: props.findCard(props.id).index
	    };
	  },
	
	  endDrag: function endDrag(props, monitor) {
	    var _monitor$getItem = monitor.getItem();
	
	    var droppedId = _monitor$getItem.id;
	    var originalIndex = _monitor$getItem.originalIndex;
	
	    var didDrop = monitor.didDrop();
	
	    if (!didDrop) {
	      props.moveCard(droppedId, originalIndex);
	    }
	  }
	};
	
	var cardTarget = {
	  canDrop: function canDrop() {
	    return false;
	  },
	
	  hover: function hover(props, monitor) {
	    var _monitor$getItem2 = monitor.getItem();
	
	    var draggedId = _monitor$getItem2.id;
	    var overId = props.id;
	
	    if (draggedId !== overId) {
	      var _props$findCard = props.findCard(overId);
	
	      var overIndex = _props$findCard.index;
	
	      props.moveCard(draggedId, overIndex);
	    }
	  }
	};
	
	var Card = (function () {
	  function Card() {
	    _classCallCheck(this, _Card);
	  }
	
	  Card.prototype.render = function render() {
	    var _props = this.props;
	    var text = _props.text;
	    var isDragging = _props.isDragging;
	    var connectDragSource = _props.connectDragSource;
	    var connectDropTarget = _props.connectDropTarget;
	
	    var opacity = isDragging ? 0 : 1;
	
	    return connectDragSource(connectDropTarget(_react2['default'].createElement(
	      'div',
	      { style: _extends({}, style, { opacity: opacity }) },
	      text
	    )));
	  };
	
	  _createClass(Card, null, [{
	    key: 'propTypes',
	    value: {
	      connectDragSource: _react.PropTypes.func.isRequired,
	      connectDropTarget: _react.PropTypes.func.isRequired,
	      isDragging: _react.PropTypes.bool.isRequired,
	      id: _react.PropTypes.any.isRequired,
	      text: _react.PropTypes.string.isRequired,
	      moveCard: _react.PropTypes.func.isRequired,
	      findCard: _react.PropTypes.func.isRequired
	    },
	    enumerable: true
	  }]);
	
	  var _Card = Card;
	  Card = _reactDnd.DragSource(_ItemTypes2['default'].CARD, cardSource, function (connect, monitor) {
	    return {
	      connectDragSource: connect.dragSource(),
	      isDragging: monitor.isDragging()
	    };
	  })(Card) || Card;
	  Card = _reactDnd.DropTarget(_ItemTypes2['default'].CARD, cardTarget, function (connect) {
	    return {
	      connectDropTarget: connect.dropTarget()
	    };
	  })(Card) || Card;
	  return Card;
	})();
	
	exports['default'] = Card;
	module.exports = exports['default'];

/***/ },
/* 202 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactLibUpdate = __webpack_require__(25);
	
	var _reactLibUpdate2 = _interopRequireDefault(_reactLibUpdate);
	
	var _Card = __webpack_require__(201);
	
	var _Card2 = _interopRequireDefault(_Card);
	
	var _reactDnd = __webpack_require__(3);
	
	var _reactDndModulesBackendsHTML5 = __webpack_require__(10);
	
	var _reactDndModulesBackendsHTML52 = _interopRequireDefault(_reactDndModulesBackendsHTML5);
	
	var _ItemTypes = __webpack_require__(110);
	
	var _ItemTypes2 = _interopRequireDefault(_ItemTypes);
	
	var style = {
	  width: 400
	};
	
	var cardTarget = {
	  drop: function drop() {}
	};
	
	var Container = (function (_Component) {
	  _inherits(Container, _Component);
	
	  _createClass(Container, null, [{
	    key: 'propTypes',
	    value: {
	      connectDropTarget: _react.PropTypes.func.isRequired
	    },
	    enumerable: true
	  }]);
	
	  function Container(props) {
	    _classCallCheck(this, _Container);
	
	    _Component.call(this, props);
	    this.moveCard = this.moveCard.bind(this);
	    this.findCard = this.findCard.bind(this);
	    this.state = {
	      cards: [{
	        id: 1,
	        text: 'Write a cool JS library'
	      }, {
	        id: 2,
	        text: 'Make it generic enough'
	      }, {
	        id: 3,
	        text: 'Write README'
	      }, {
	        id: 4,
	        text: 'Create some examples'
	      }, {
	        id: 5,
	        text: 'Spam in Twitter and IRC to promote it'
	      }, {
	        id: 6,
	        text: '???'
	      }, {
	        id: 7,
	        text: 'PROFIT'
	      }]
	    };
	  }
	
	  Container.prototype.moveCard = function moveCard(id, atIndex) {
	    var _findCard = this.findCard(id);
	
	    var card = _findCard.card;
	    var index = _findCard.index;
	
	    this.setState(_reactLibUpdate2['default'](this.state, {
	      cards: {
	        $splice: [[index, 1], [atIndex, 0, card]]
	      }
	    }));
	  };
	
	  Container.prototype.findCard = function findCard(id) {
	    var cards = this.state.cards;
	
	    var card = cards.filter(function (c) {
	      return c.id === id;
	    })[0];
	
	    return {
	      card: card,
	      index: cards.indexOf(card)
	    };
	  };
	
	  Container.prototype.render = function render() {
	    var _this = this;
	
	    var connectDropTarget = this.props.connectDropTarget;
	    var cards = this.state.cards;
	
	    return connectDropTarget(_react2['default'].createElement(
	      'div',
	      { style: style },
	      cards.map(function (card, index) {
	        return _react2['default'].createElement(_Card2['default'], { key: card.id,
	          id: card.id,
	          text: card.text,
	          moveCard: _this.moveCard,
	          findCard: _this.findCard });
	      })
	    ));
	  };
	
	  var _Container = Container;
	  Container = _reactDnd.DropTarget(_ItemTypes2['default'].CARD, cardTarget, function (connect) {
	    return {
	      connectDropTarget: connect.dropTarget()
	    };
	  })(Container) || Container;
	  Container = _reactDnd.DragDropContext(_reactDndModulesBackendsHTML52['default'])(Container) || Container;
	  return Container;
	})(_react.Component);
	
	exports['default'] = Container;
	module.exports = exports['default'];

/***/ },
/* 203 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Container = __webpack_require__(202);
	
	var _Container2 = _interopRequireDefault(_Container);
	
	var SortableCancelOnDropOutside = (function () {
	  function SortableCancelOnDropOutside() {
	    _classCallCheck(this, SortableCancelOnDropOutside);
	  }
	
	  SortableCancelOnDropOutside.prototype.render = function render() {
	    return _react2['default'].createElement(
	      'div',
	      null,
	      _react2['default'].createElement(
	        'p',
	        null,
	        _react2['default'].createElement(
	          'b',
	          null,
	          _react2['default'].createElement(
	            'a',
	            { href: 'https://github.com/pljenkins/react-dnd/tree/master/examples/04%20Sortable/Cancel%20on%20Drop%20Outside' },
	            'Browse the Source'
	          )
	        )
	      ),
	      _react2['default'].createElement(
	        'p',
	        null,
	        'Because you write the logic instead of using the readymade components, you can tweak the behavior to the one your app needs. In this example, instead of moving the card inside the drop target\'s ',
	        _react2['default'].createElement(
	          'code',
	          null,
	          'drop()'
	        ),
	        ' handler, we do it inside the drag source\'s ',
	        _react2['default'].createElement(
	          'code',
	          null,
	          'endDrag()'
	        ),
	        ' handler. This let us check ',
	        _react2['default'].createElement(
	          'code',
	          null,
	          'monitor.didDrop()'
	        ),
	        ' and revert the drag operation if the card was dropped outside its container.'
	      ),
	      _react2['default'].createElement(_Container2['default'], null)
	    );
	  };
	
	  return SortableCancelOnDropOutside;
	})();
	
	exports['default'] = SortableCancelOnDropOutside;
	module.exports = exports['default'];

/***/ },
/* 204 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ItemTypes = __webpack_require__(69);
	
	var _ItemTypes2 = _interopRequireDefault(_ItemTypes);
	
	var _reactDnd = __webpack_require__(3);
	
	var style = {
	  border: '1px dashed black',
	  padding: '0.5rem 1rem',
	  marginBottom: '.5rem',
	  backgroundColor: 'white',
	  cursor: 'move',
	  minWidth: '200px',
	  minHeight: '40px'
	};
	
	var cardTarget = {
	  hover: function hover(props, monitor) {
	    props.moveSelectedCardsToBox();
	  }
	};
	
	var BoxTarget = (function (_Component) {
	  _inherits(BoxTarget, _Component);
	
	  function BoxTarget() {
	    _classCallCheck(this, _BoxTarget);
	
	    _Component.apply(this, arguments);
	  }
	
	  BoxTarget.prototype.render = function render() {
	    var _props = this.props;
	    var items = _props.items;
	    var isDragging = _props.isDragging;
	    var connectDragSource = _props.connectDragSource;
	    var connectDropTarget = _props.connectDropTarget;
	
	    var opacity = isDragging ? 0 : 1;
	
	    return connectDropTarget(_react2['default'].createElement(
	      'div',
	      { style: _extends({}, style, { opacity: opacity }) },
	      items.map(function (item) {
	        return _react2['default'].createElement(
	          'div',
	          { key: item },
	          item
	        );
	      })
	    ));
	  };
	
	  _createClass(BoxTarget, null, [{
	    key: 'propTypes',
	    value: {
	      connectDropTarget: _react.PropTypes.func.isRequired,
	      items: _react.PropTypes.array.isRequired,
	      moveSelectedCardsToBox: _react.PropTypes.func.isRequired
	    },
	    enumerable: true
	  }]);
	
	  var _BoxTarget = BoxTarget;
	  BoxTarget = _reactDnd.DropTarget(_ItemTypes2['default'].CARD, cardTarget, function (connect, monitor) {
	    return {
	      connectDropTarget: connect.dropTarget()
	    };
	  })(BoxTarget) || BoxTarget;
	  return BoxTarget;
	})(_react.Component);
	
	exports['default'] = BoxTarget;
	module.exports = exports['default'];

/***/ },
/* 205 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _shouldPureComponentUpdate = __webpack_require__(49);
	
	var _shouldPureComponentUpdate2 = _interopRequireDefault(_shouldPureComponentUpdate);
	
	var _Card = __webpack_require__(111);
	
	var _Card2 = _interopRequireDefault(_Card);
	
	var styles = {
	  display: 'inline-block'
	};
	
	var CardDragPreview = (function (_Component) {
	  _inherits(CardDragPreview, _Component);
	
	  function CardDragPreview() {
	    _classCallCheck(this, CardDragPreview);
	
	    _Component.apply(this, arguments);
	
	    this.shouldComponentUpdate = _shouldPureComponentUpdate2['default'];
	  }
	
	  CardDragPreview.prototype.render = function render() {
	    console.log('CardDragPreview render');
	    return _react2['default'].createElement(
	      'div',
	      { style: styles },
	      _react2['default'].createElement(_Card2['default'], { text: text })
	    );
	  };
	
	  _createClass(CardDragPreview, null, [{
	    key: 'propTypes',
	    value: {
	      text: _react.PropTypes.string.isRequired
	    },
	    enumerable: true
	  }]);
	
	  return CardDragPreview;
	})(_react.Component);
	
	exports['default'] = CardDragPreview;
	module.exports = exports['default'];

/***/ },
/* 206 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _shouldPureComponentUpdate = __webpack_require__(49);
	
	var _shouldPureComponentUpdate2 = _interopRequireDefault(_shouldPureComponentUpdate);
	
	var _reactLibUpdate = __webpack_require__(25);
	
	var _reactLibUpdate2 = _interopRequireDefault(_reactLibUpdate);
	
	var _Card = __webpack_require__(111);
	
	var _Card2 = _interopRequireDefault(_Card);
	
	var _BoxTarget = __webpack_require__(204);
	
	var _BoxTarget2 = _interopRequireDefault(_BoxTarget);
	
	var _lodash = __webpack_require__(352);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _SupportsTouch = __webpack_require__(114);
	
	var _SupportsTouch2 = _interopRequireDefault(_SupportsTouch);
	
	var style = {
	  width: 450,
	  'margin-left': 50
	},
	    selectionA = 'A',
	    selectionB = 'B';
	
	var singleTouch;
	// TODO-NK: have the option of doing fancy styling somewhere based on whether
	// user is still dragging or not here, but this is good enough for now
	
	var Container = (function (_Component) {
	  _inherits(Container, _Component);
	
	  function Container(props) {
	    _classCallCheck(this, Container);
	
	    _Component.call(this, props);
	    this.supportsTouch = undefined;
	    this.selectionStyle = selectionA;
	    this.moveRecentCardsBackFromBox = this.moveRecentCardsBackFromBox.bind(this);
	    this.moveSelectedCardsToBox = this.moveSelectedCardsToBox.bind(this);
	    this.completeBoxMove = this.completeBoxMove.bind(this);
	    this.debounceTouch = this.debounceTouch.bind(this);
	    this.selectCard = this.selectCard.bind(this);
	    this.selectCardStyleA = this.selectCardStyleA.bind(this);
	    this.selectCardStyleB = this.selectCardStyleB.bind(this);
	    this.setSelectionStyleA = this.setSelectionStyleA.bind(this);
	    this.setSelectionStyleB = this.setSelectionStyleB.bind(this);
	    this.resetSelection = this.resetSelection.bind(this);
	    this.supportsTouch = _SupportsTouch2['default']();
	    console.log('constructor this.supportsTouch', this.supportsTouch);
	    this.state = {
	      cards: [{
	        id: 1,
	        text: 'Frank',
	        selected: false
	      }, {
	        id: 2,
	        text: 'And Drag N Drop',
	        selected: false
	      }, {
	        id: 3,
	        text: 'Unite!',
	        selected: false
	      }, {
	        id: 4,
	        text: 'Fancy DNA Sample',
	        selected: false
	      }, {
	        id: 5,
	        text: 'Tumor Tissue',
	        selected: false
	      }, {
	        id: 6,
	        text: 'Blood Sample',
	        selected: false
	      }, {
	        id: 7,
	        text: 'Feather',
	        selected: false
	      }, {
	        id: 8,
	        text: 'Knight',
	        selected: false
	      }, {
	        id: 9,
	        text: 'Sparkles',
	        selected: false
	      }, {
	        id: 10,
	        text: 'Boots',
	        selected: false
	      }, {
	        id: 11,
	        text: 'Hodor!',
	        selected: false
	      }, {
	        id: 12,
	        text: 'Bone Marrow',
	        selected: false
	      }, {
	        id: 13,
	        text: 'Epithelial Cells',
	        selected: false
	      }, {
	        id: 14,
	        text: 'FFPE',
	        selected: false
	      }, {
	        id: 15,
	        text: 'Frank2',
	        selected: false
	      }, {
	        id: 16,
	        text: 'And Drag N Drop2',
	        selected: false
	      }, {
	        id: 17,
	        text: 'Unite!2',
	        selected: false
	      }, {
	        id: 18,
	        text: 'Fancy DNA Sample2',
	        selected: false
	      }, {
	        id: 19,
	        text: 'Tumor Tissue2',
	        selected: false
	      }, {
	        id: 20,
	        text: 'Blood Sample2',
	        selected: false
	      }, {
	        id: 21,
	        text: 'Feather2',
	        selected: false
	      }, {
	        id: 22,
	        text: 'Knight2',
	        selected: false
	      }, {
	        id: 23,
	        text: 'Sparkles2',
	        selected: false
	      }, {
	        id: 24,
	        text: 'Boots2',
	        selected: false
	      }, {
	        id: 25,
	        text: 'Hodor!2',
	        selected: false
	      }, {
	        id: 26,
	        text: 'Bone Marrow2',
	        selected: false
	      }, {
	        id: 27,
	        text: 'Epithelial Cells2',
	        selected: false
	      }, {
	        id: 28,
	        text: 'FFPE2',
	        selected: false
	      }],
	      cardsInBox: [],
	      selectedCards: [],
	      mostRecentlyMovedCards: []
	    };
	  }
	
	  Container.prototype.moveSelectedCardsToBox = function moveSelectedCardsToBox() {
	    var selectedIds = this.state.cards.filter(function (card) {
	      return card.selected;
	    }).map(function (card) {
	      return card.id;
	    });
	    this.setState(_reactLibUpdate2['default'](this.state, {
	      cardsInBox: { $push: selectedIds },
	      mostRecentlyMovedCards: { $set: selectedIds }
	    }));
	  };
	
	  Container.prototype.completeBoxMove = function completeBoxMove() {
	    var selectedIds = this.state.cards.filter(function (card) {
	      return card.selected;
	    }).map(function (card) {
	      return card.id;
	    }),
	        unselectedCards = this.state.cards.map(function (card) {
	      card.selected = false;
	      return card;
	    });
	
	    this.setState({
	      cards: unselectedCards,
	      mostRecentlyMovedCards: []
	    });
	  };
	
	  Container.prototype.moveRecentCardsBackFromBox = function moveRecentCardsBackFromBox() {
	    var cardsToRemove = this.state.mostRecentlyMovedCards,
	        cardsInBox = this.state.cardsInBox.filter(function (id) {
	      return cardsToRemove.indexOf(id) === -1;
	    });
	
	    this.setState({ cardsInBox: cardsInBox });
	  };
	
	  Container.prototype.debounceTouch = function debounceTouch(e, id) {
	    console.log('debounceTouch', e.targetTouches.length, id, e);
	    if (e.targetTouches.length === 1) {
	      singleTouch = _lodash2['default'].debounce(this.selectCard, 100);
	      singleTouch(e, id);
	    }if (e.targetTouches.length === 2) {
	      if (!_lodash2['default'].isUndefined(singleTouch)) {
	        singleTouch.cancel();
	      }
	      this.selectCard(e, id);
	      e.preventDefault();
	    }
	  };
	
	  Container.prototype.selectCard = function selectCard(e, id) {
	    if (this.selectionStyle === selectionA) {
	      this.selectCardStyleA(e, id);
	    } else if (this.selectionStyle === selectionB) {
	      this.selectCardStyleB(e, id);
	    } else {
	      console.log('Unknown selection style!!');
	    }
	  };
	
	  Container.prototype.selectCardStyleA = function selectCardStyleA(e, id) {
	    e.targetTouches = e.targetTouches || [];
	    console.log('selectCardStyleA arguments', e.targetTouches.length, id, e);
	
	    if (e.targetTouches && e.targetTouches && e.targetTouches.length > 1) {
	      e.shiftKey = true;
	      console.log('selectCardStyleA multitouch');
	    }
	    // indices?
	    var currentlySelectedIndexes = this.state.cards.map(function (card, index) {
	      return card.selected ? index : null;
	    }).filter(function (index) {
	      return index !== null;
	    }),
	        combineSelections = function combineSelections(currentIndex, lastIndex, e) {
	      var indexOfIndex = currentlySelectedIndexes.indexOf(currentIndex); // sorry
	
	      if (indexOfIndex !== -1 && !e.dragging) {
	        currentlySelectedIndexes.splice(indexOfIndex, 1);
	      } else if (indexOfIndex === -1) {
	        currentlySelectedIndexes.push(currentIndex);
	      }
	      if (e.shiftKey) {
	        // bit hacky, doesn't fully account for single click selection
	        var indexesToAdd = lastIndex <= currentIndex ? _lodash2['default'].range(lastIndex, currentIndex + 1) : _lodash2['default'].range(currentIndex, lastIndex + 1);
	        currentlySelectedIndexes = currentlySelectedIndexes.concat(indexesToAdd);
	      }
	      return currentlySelectedIndexes;
	    },
	        indexOfCurrent = _lodash2['default'].findIndex(this.state.cards, function (card) {
	      return card.id === id;
	    }),
	        selectedIndexes = combineSelections(indexOfCurrent, this.state.anchorIndex, e),
	        updateCard = function updateCard(card, index) {
	      if (selectedIndexes.indexOf(index) !== -1) {
	        card.selected = true;
	      } else {
	        card.selected = false;
	      }
	      return card;
	    },
	        updatedCards = this.state.cards.map(updateCard),
	        wasDelecting = !this.state.cards[indexOfCurrent].selected;
	
	    this.setState({
	      cards: updatedCards,
	      anchorIndex: e.shiftKey || wasDelecting ? this.state.anchorIndex : indexOfCurrent
	    });
	  };
	
	  Container.prototype.selectCardStyleB = function selectCardStyleB(e, id) {
	    e.targetTouches = e.targetTouches || [];
	    console.log('selectCardStyleB arguments', e.targetTouches.length, id, e);
	    var indexOfCurrent = _lodash2['default'].findIndex(this.state.cards, function (card) {
	      return card.id === id;
	    });
	    var anchorIndex = undefined;
	
	    if (e.shiftKey || e.targetTouches && e.targetTouches && e.targetTouches.length > 1 && _lodash2['default'].isUndefined(this.state.anchorIndex)) {
	      anchorIndex = indexOfCurrent;
	      console.log('selectCardStyleB multitouch');
	    }
	    // indices?
	    var currentlySelectedIndexes = this.state.cards.map(function (card, index) {
	      return card.selected ? index : null;
	    }).filter(function (index) {
	      return index !== null;
	    }),
	        combineSelections = function combineSelections(currentIndex, currentAnchorIndex, e) {
	      var indexOfIndex = currentlySelectedIndexes.indexOf(currentIndex); // sorry
	
	      if (indexOfIndex !== -1 && !e.dragging) {
	        currentlySelectedIndexes.splice(indexOfIndex, 1);
	      } else if (indexOfIndex === -1) {
	        currentlySelectedIndexes.push(currentIndex);
	      }
	      if (!_lodash2['default'].isUndefined(currentAnchorIndex)) {
	        // bit hacky, doesn't fully account for single click selection
	        var indexesToAdd = currentAnchorIndex <= currentIndex ? _lodash2['default'].range(currentAnchorIndex, currentIndex + 1) : _lodash2['default'].range(currentIndex, currentAnchorIndex + 1);
	        currentlySelectedIndexes = currentlySelectedIndexes.concat(indexesToAdd);
	      }
	      return currentlySelectedIndexes;
	    },
	        selectedIndexes = combineSelections(indexOfCurrent, this.state.anchorIndex, e),
	        updateCard = function updateCard(card, index) {
	      if (selectedIndexes.indexOf(index) !== -1) {
	        card.selected = true;
	      } else {
	        card.selected = false;
	      }
	      return card;
	    },
	        updatedCards = this.state.cards.map(updateCard);
	
	    this.setState({
	      cards: updatedCards,
	      anchorIndex: anchorIndex
	    });
	  };
	
	  Container.prototype.setSelectionStyleA = function setSelectionStyleA() {
	    console.log('setSelectionStyleA');
	    this.setState({
	      cards: this.state.cards.map(function (card) {
	        card.selected = false;return card;
	      }),
	      anchorIndex: undefined
	    });
	    this.selectionStyle = selectionA;
	  };
	
	  Container.prototype.setSelectionStyleB = function setSelectionStyleB() {
	    console.log('setSelectionStyleB');
	    this.setState({
	      cards: this.state.cards.map(function (card) {
	        card.selected = false;return card;
	      }),
	      anchorIndex: undefined
	    });
	    this.selectionStyle = selectionB;
	  };
	
	  Container.prototype.resetSelection = function resetSelection() {
	    console.log('resetSelection');
	    this.setState({
	      cards: this.state.cards.map(function (card) {
	        card.selected = false;return card;
	      }),
	      anchorIndex: undefined
	    });
	  };
	
	  Container.prototype.render = function render() {
	    var _this = this;
	
	    var cards = this.state.cards;
	
	    var boxCards = cards.filter(function (card) {
	      return _this.state.cardsInBox.indexOf(card.id) !== -1;
	    }).map(function (card) {
	      return card.id + ". " + card.text;
	    });
	
	    return _react2['default'].createElement(
	      'div',
	      { style: style },
	      _react2['default'].createElement(
	        'button',
	        { style: { 'margin-bottom': 30, fontSize: 14, width: 70, height: 40 }, onClick: this.resetSelection },
	        'Reset'
	      ),
	      _react2['default'].createElement('br', null),
	      _react2['default'].createElement(
	        'div',
	        { style: { display: 'inline-block', 'margin-bottom': 30 } },
	        _react2['default'].createElement(
	          'label',
	          { 'for': 'selection-style-A' },
	          _react2['default'].createElement('input', { type: 'radio', name: 'selectionStyle', id: 'selection-style-A', defaultChecked: true, onChange: this.setSelectionStyleA }),
	          'Selection style A'
	        ),
	        _react2['default'].createElement(
	          'label',
	          { 'for': 'selection-style-B' },
	          _react2['default'].createElement('input', { style: { 'margin-left': 20 }, type: 'radio', name: 'selectionStyle', id: 'selection-style-B', onChange: this.setSelectionStyleB }),
	          'Selection style B'
	        )
	      ),
	      _react2['default'].createElement(
	        'div',
	        { style: { float: 'left' } },
	        cards.filter(function (card) {
	          return _this.state.cardsInBox.indexOf(card.id) === -1;
	        }).map(function (card, index) {
	          return _react2['default'].createElement(_Card2['default'], { key: card.id,
	            id: card.id,
	            text: card.id + ". " + card.text,
	            completeBoxMove: _this.completeBoxMove,
	            moveRecentCardsBackFromBox: _this.moveRecentCardsBackFromBox,
	            selectCard: _this.selectCard,
	            debounceTouch: _this.debounceTouch,
	            selected: card.selected,
	            supportsTouch: _this.supportsTouch,
	            isAnchor: _this.selectionStyle === selectionB && index === _this.state.anchorIndex });
	        })
	      ),
	      _react2['default'].createElement(
	        'div',
	        { style: { float: 'right' } },
	        _react2['default'].createElement(_BoxTarget2['default'], { items: boxCards,
	          moveSelectedCardsToBox: this.moveSelectedCardsToBox })
	      )
	    );
	  };
	
	  return Container;
	})(_react.Component);
	
	exports['default'] = Container;
	module.exports = exports['default'];

/***/ },
/* 207 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _shouldPureComponentUpdate = __webpack_require__(49);
	
	var _shouldPureComponentUpdate2 = _interopRequireDefault(_shouldPureComponentUpdate);
	
	var _ItemTypes = __webpack_require__(69);
	
	var _ItemTypes2 = _interopRequireDefault(_ItemTypes);
	
	var _CardDragPreview = __webpack_require__(205);
	
	var _CardDragPreview2 = _interopRequireDefault(_CardDragPreview);
	
	var _reactDnd = __webpack_require__(3);
	
	var layerStyles = {
	  position: 'fixed',
	  pointerEvents: 'none',
	  zIndex: 100,
	  left: 0,
	  top: 0,
	  width: '100%',
	  height: '100%'
	};
	
	function getItemStyles(props) {
	  var initialOffset = props.initialOffset;
	  var currentOffset = props.currentOffset;
	
	  if (!initialOffset || !currentOffset) {
	    return {
	      display: 'none'
	    };
	  }
	
	  var x = currentOffset.x;
	  var y = currentOffset.y;
	
	  var transform = 'translate(' + x + 'px, ' + y + 'px)';
	  return {
	    transform: transform,
	    WebkitTransform: transform
	  };
	}
	
	var CustomDragLayer = (function () {
	  function CustomDragLayer() {
	    _classCallCheck(this, _CustomDragLayer);
	  }
	
	  CustomDragLayer.prototype.renderItem = function renderItem(type, item) {
	    switch (type) {
	      case _ItemTypes2['default'].CARD:
	        return _react2['default'].createElement(_CardDragPreview2['default'], { text: item.text });
	    }
	  };
	
	  CustomDragLayer.prototype.render = function render() {
	    console.log('CustomDragLayer.render()');
	    var _props = this.props;
	    var item = _props.item;
	    var itemType = _props.itemType;
	    var isDragging = _props.isDragging;
	
	    if (!isDragging) {
	      return null;
	    }
	
	    return _react2['default'].createElement(
	      'div',
	      { style: layerStyles },
	      _react2['default'].createElement(
	        'div',
	        { style: getItemStyles(this.props) },
	        this.renderItem(itemType, item)
	      )
	    );
	  };
	
	  _createClass(CustomDragLayer, null, [{
	    key: 'propTypes',
	    value: {
	      item: _react.PropTypes.object,
	      itemType: _react.PropTypes.string,
	      initialOffset: _react.PropTypes.shape({
	        x: _react.PropTypes.number.isRequired,
	        y: _react.PropTypes.number.isRequired
	      }),
	      currentOffset: _react.PropTypes.shape({
	        x: _react.PropTypes.number.isRequired,
	        y: _react.PropTypes.number.isRequired
	      }),
	      isDragging: _react.PropTypes.bool.isRequired
	    },
	    enumerable: true
	  }]);
	
	  var _CustomDragLayer = CustomDragLayer;
	  CustomDragLayer = _reactDnd.DragLayer(function (monitor) {
	    return {
	      item: monitor.getItem(),
	      itemType: monitor.getItemType(),
	      initialOffset: monitor.getInitialSourceClientOffset(),
	      currentOffset: monitor.getSourceClientOffset(),
	      isDragging: monitor.isDragging()
	    };
	  })(CustomDragLayer) || CustomDragLayer;
	  return CustomDragLayer;
	})();
	
	exports['default'] = CustomDragLayer;
	module.exports = exports['default'];

/***/ },
/* 208 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Container = __webpack_require__(206);
	
	var _Container2 = _interopRequireDefault(_Container);
	
	var _CustomDragLayer = __webpack_require__(207);
	
	var _CustomDragLayer2 = _interopRequireDefault(_CustomDragLayer);
	
	var _reactDnd = __webpack_require__(3);
	
	var _SupportsTouch = __webpack_require__(114);
	
	var _SupportsTouch2 = _interopRequireDefault(_SupportsTouch);
	
	var _reactDndModulesBackendsHTML5 = __webpack_require__(10);
	
	var _reactDndModulesBackendsHTML52 = _interopRequireDefault(_reactDndModulesBackendsHTML5);
	
	var _reactDndModulesBackendsTouch = __webpack_require__(238);
	
	var _reactDndModulesBackendsTouch2 = _interopRequireDefault(_reactDndModulesBackendsTouch);
	
	var ListSelection = (function (_Component) {
	  _inherits(ListSelection, _Component);
	
	  function ListSelection(props) {
	    _classCallCheck(this, _ListSelection);
	
	    _Component.call(this, props);
	    _react2['default'].initializeTouchEvents(true);
	  }
	
	  ListSelection.prototype.render = function render() {
	    // <CustomDragLayer /> should go after Container if to show the component while it is being dragged in a touch scenario
	    return _react2['default'].createElement(
	      'div',
	      null,
	      _react2['default'].createElement(
	        'p',
	        { style: { 'margin-left': 50 } },
	        'Multi select and drag and drop example'
	      ),
	      _react2['default'].createElement(_Container2['default'], null)
	    );
	  };
	
	  var _ListSelection = ListSelection;
	  ListSelection = _reactDnd.DragDropContext(_SupportsTouch2['default']() ? _reactDndModulesBackendsTouch2['default'] : _reactDndModulesBackendsHTML52['default'])(ListSelection) || ListSelection;
	  return ListSelection;
	})(_react.Component);
	
	exports['default'] = ListSelection;
	module.exports = exports['default'];

/***/ },
/* 209 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = shallowEqual;
	
	function shallowEqual(objA, objB) {
	  if (objA === objB) {
	    return true;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  var hasOwn = Object.prototype.hasOwnProperty;
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwn.call(objB, keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) {
	
	      return false;
	    }
	
	    var valA = objA[keysA[i]];
	    var valB = objB[keysA[i]];
	
	    if (valA !== valB) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	module.exports = exports["default"];

/***/ },
/* 210 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ItemTypes = __webpack_require__(212);
	
	var _ItemTypes2 = _interopRequireDefault(_ItemTypes);
	
	var _reactDnd = __webpack_require__(3);
	
	var style = {
	  border: '1px dashed gray',
	  padding: '0.5rem 1rem',
	  marginBottom: '.5rem',
	  backgroundColor: 'white',
	  cursor: 'move'
	};
	
	var cardSource = {
	  beginDrag: function beginDrag(props) {
	    return { id: props.id };
	  }
	};
	
	var cardTarget = {
	  hover: function hover(props, monitor) {
	    var draggedId = monitor.getItem().id;
	
	    if (draggedId !== props.id) {
	      props.moveCard(draggedId, props.id);
	    }
	  }
	};
	
	var Card = (function () {
	  function Card() {
	    _classCallCheck(this, _Card);
	  }
	
	  Card.prototype.render = function render() {
	    var _props = this.props;
	    var text = _props.text;
	    var isDragging = _props.isDragging;
	    var connectDragSource = _props.connectDragSource;
	    var connectDropTarget = _props.connectDropTarget;
	
	    var opacity = isDragging ? 0 : 1;
	
	    return connectDragSource(connectDropTarget(_react2['default'].createElement(
	      'div',
	      { style: _extends({}, style, { opacity: opacity }) },
	      text
	    )));
	  };
	
	  _createClass(Card, null, [{
	    key: 'propTypes',
	    value: {
	      connectDragSource: _react.PropTypes.func.isRequired,
	      connectDropTarget: _react.PropTypes.func.isRequired,
	      isDragging: _react.PropTypes.bool.isRequired,
	      id: _react.PropTypes.any.isRequired,
	      text: _react.PropTypes.string.isRequired,
	      moveCard: _react.PropTypes.func.isRequired
	    },
	    enumerable: true
	  }]);
	
	  var _Card = Card;
	  Card = _reactDnd.DragSource(_ItemTypes2['default'].CARD, cardSource, function (connect, monitor) {
	    return {
	      connectDragSource: connect.dragSource(),
	      isDragging: monitor.isDragging()
	    };
	  })(Card) || Card;
	  Card = _reactDnd.DropTarget(_ItemTypes2['default'].CARD, cardTarget, function (connect) {
	    return {
	      connectDropTarget: connect.dropTarget()
	    };
	  })(Card) || Card;
	  return Card;
	})();
	
	exports['default'] = Card;
	module.exports = exports['default'];

/***/ },
/* 211 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactLibUpdate = __webpack_require__(25);
	
	var _reactLibUpdate2 = _interopRequireDefault(_reactLibUpdate);
	
	var _Card = __webpack_require__(210);
	
	var _Card2 = _interopRequireDefault(_Card);
	
	var _reactDnd = __webpack_require__(3);
	
	var _reactDndModulesBackendsHTML5 = __webpack_require__(10);
	
	var _reactDndModulesBackendsHTML52 = _interopRequireDefault(_reactDndModulesBackendsHTML5);
	
	var style = {
	  width: 400
	};
	
	var Container = (function (_Component) {
	  _inherits(Container, _Component);
	
	  function Container(props) {
	    _classCallCheck(this, _Container);
	
	    _Component.call(this, props);
	    this.moveCard = this.moveCard.bind(this);
	    this.state = {
	      cards: [{
	        id: 1,
	        text: 'Write a cool JS library'
	      }, {
	        id: 2,
	        text: 'Make it generic enough'
	      }, {
	        id: 3,
	        text: 'Write README'
	      }, {
	        id: 4,
	        text: 'Create some examples'
	      }, {
	        id: 5,
	        text: 'Spam in Twitter and IRC to promote it'
	      }, {
	        id: 6,
	        text: '???'
	      }, {
	        id: 7,
	        text: 'PROFIT'
	      }]
	    };
	  }
	
	  Container.prototype.moveCard = function moveCard(id, afterId) {
	    var cards = this.state.cards;
	
	    var card = cards.filter(function (c) {
	      return c.id === id;
	    })[0];
	    var afterCard = cards.filter(function (c) {
	      return c.id === afterId;
	    })[0];
	    var cardIndex = cards.indexOf(card);
	    var afterIndex = cards.indexOf(afterCard);
	
	    this.setState(_reactLibUpdate2['default'](this.state, {
	      cards: {
	        $splice: [[cardIndex, 1], [afterIndex, 0, card]]
	      }
	    }));
	  };
	
	  Container.prototype.render = function render() {
	    var _this = this;
	
	    var cards = this.state.cards;
	
	    return _react2['default'].createElement(
	      'div',
	      { style: style },
	      cards.map(function (card) {
	        return _react2['default'].createElement(_Card2['default'], { key: card.id,
	          id: card.id,
	          text: card.text,
	          moveCard: _this.moveCard });
	      })
	    );
	  };
	
	  var _Container = Container;
	  Container = _reactDnd.DragDropContext(_reactDndModulesBackendsHTML52['default'])(Container) || Container;
	  return Container;
	})(_react.Component);
	
	exports['default'] = Container;
	module.exports = exports['default'];

/***/ },
/* 212 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = {
	  CARD: 'card'
	};
	module.exports = exports['default'];

/***/ },
/* 213 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Container = __webpack_require__(211);
	
	var _Container2 = _interopRequireDefault(_Container);
	
	var SortableSimple = (function () {
	  function SortableSimple() {
	    _classCallCheck(this, SortableSimple);
	  }
	
	  SortableSimple.prototype.render = function render() {
	    return _react2['default'].createElement(
	      'div',
	      null,
	      _react2['default'].createElement(
	        'p',
	        null,
	        _react2['default'].createElement(
	          'b',
	          null,
	          _react2['default'].createElement(
	            'a',
	            { href: 'https://github.com/pljenkins/react-dnd/tree/master/examples/04%20Sortable/Simple' },
	            'Browse the Source'
	          )
	        )
	      ),
	      _react2['default'].createElement(
	        'p',
	        null,
	        'It is easy to implement a sortable interface with React DnD. Just make the same component both a drag source and a drop target, and reorder the data in the ',
	        _react2['default'].createElement(
	          'code',
	          null,
	          'hover'
	        ),
	        ' handler.'
	      ),
	      _react2['default'].createElement(_Container2['default'], null)
	    );
	  };
	
	  return SortableSimple;
	})();
	
	exports['default'] = SortableSimple;
	module.exports = exports['default'];

/***/ },
/* 214 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ItemTypes = __webpack_require__(216);
	
	var _ItemTypes2 = _interopRequireDefault(_ItemTypes);
	
	var _reactDnd = __webpack_require__(3);
	
	var style = {
	  border: '1px dashed gray',
	  padding: '0.5rem 1rem',
	  marginBottom: '.5rem',
	  backgroundColor: 'white',
	  cursor: 'move'
	};
	
	var cardSource = {
	  beginDrag: function beginDrag(props) {
	    return { id: props.id };
	  }
	};
	
	var cardTarget = {
	  hover: function hover(props, monitor) {
	    var draggedId = monitor.getItem().id;
	
	    if (draggedId !== props.id) {
	      props.moveCard(draggedId, props.id);
	    }
	  }
	};
	
	var Card = (function () {
	  function Card() {
	    _classCallCheck(this, _Card);
	  }
	
	  Card.prototype.render = function render() {
	    var _props = this.props;
	    var text = _props.text;
	    var isDragging = _props.isDragging;
	    var connectDragSource = _props.connectDragSource;
	    var connectDropTarget = _props.connectDropTarget;
	
	    var opacity = isDragging ? 0 : 1;
	
	    return connectDragSource(connectDropTarget(_react2['default'].createElement(
	      'div',
	      { style: _extends({}, style, { opacity: opacity }) },
	      text
	    )));
	  };
	
	  _createClass(Card, null, [{
	    key: 'propTypes',
	    value: {
	      connectDragSource: _react.PropTypes.func.isRequired,
	      connectDropTarget: _react.PropTypes.func.isRequired,
	      isDragging: _react.PropTypes.bool.isRequired,
	      id: _react.PropTypes.any.isRequired,
	      text: _react.PropTypes.string.isRequired,
	      moveCard: _react.PropTypes.func.isRequired
	    },
	    enumerable: true
	  }]);
	
	  var _Card = Card;
	  Card = _reactDnd.DragSource(_ItemTypes2['default'].CARD, cardSource, function (connect, monitor) {
	    return {
	      connectDragSource: connect.dragSource(),
	      isDragging: monitor.isDragging()
	    };
	  })(Card) || Card;
	  Card = _reactDnd.DropTarget(_ItemTypes2['default'].CARD, cardTarget, function (connect) {
	    return {
	      connectDropTarget: connect.dropTarget()
	    };
	  })(Card) || Card;
	  return Card;
	})();
	
	exports['default'] = Card;
	module.exports = exports['default'];

/***/ },
/* 215 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactLibUpdate = __webpack_require__(25);
	
	var _reactLibUpdate2 = _interopRequireDefault(_reactLibUpdate);
	
	var _faker = __webpack_require__(11);
	
	var _Card = __webpack_require__(214);
	
	var _Card2 = _interopRequireDefault(_Card);
	
	var _reactDnd = __webpack_require__(3);
	
	var _reactDndModulesBackendsHTML5 = __webpack_require__(10);
	
	var _reactDndModulesBackendsHTML52 = _interopRequireDefault(_reactDndModulesBackendsHTML5);
	
	var style = {
	  width: 400
	};
	
	var Container = (function (_Component) {
	  _inherits(Container, _Component);
	
	  function Container(props) {
	    _classCallCheck(this, _Container);
	
	    _Component.call(this, props);
	
	    this.moveCard = this.moveCard.bind(this);
	    this.drawFrame = this.drawFrame.bind(this);
	
	    var cardsById = {};
	    var cardsByIndex = [];
	
	    for (var i = 0; i < 1000; i++) {
	      var card = { id: i, text: _faker.name.findName() };
	      cardsById[card.id] = card;
	      cardsByIndex[i] = card;
	    }
	
	    this.state = {
	      cardsById: cardsById,
	      cardsByIndex: cardsByIndex
	    };
	  }
	
	  Container.prototype.moveCard = function moveCard(id, afterId) {
	    var _state = this.state;
	    var cardsById = _state.cardsById;
	    var cardsByIndex = _state.cardsByIndex;
	
	    var card = cardsById[id];
	    var afterCard = cardsById[afterId];
	
	    var cardIndex = cardsByIndex.indexOf(card);
	    var afterIndex = cardsByIndex.indexOf(afterCard);
	
	    this.scheduleUpdate({
	      cardsByIndex: {
	        $splice: [[cardIndex, 1], [afterIndex, 0, card]]
	      }
	    });
	  };
	
	  Container.prototype.componentWillUnmount = function componentWillUnmount() {
	    cancelAnimationFrame(this.requestedFrame);
	  };
	
	  Container.prototype.scheduleUpdate = function scheduleUpdate(update) {
	    this.pendingUpdate = update;
	
	    if (!this.requestedFrame) {
	      this.requestedFrame = requestAnimationFrame(this.drawFrame);
	    }
	  };
	
	  Container.prototype.drawFrame = function drawFrame() {
	    var nextState = _reactLibUpdate2['default'](this.state, this.pendingUpdate);
	    this.setState(nextState);
	
	    this.pendingUpdate = null;
	    this.requestedFrame = null;
	  };
	
	  Container.prototype.render = function render() {
	    var _this = this;
	
	    var cardsByIndex = this.state.cardsByIndex;
	
	    return _react2['default'].createElement(
	      'div',
	      { style: style },
	      cardsByIndex.map(function (card) {
	        return _react2['default'].createElement(_Card2['default'], { key: card.id,
	          id: card.id,
	          text: card.text,
	          moveCard: _this.moveCard });
	      })
	    );
	  };
	
	  var _Container = Container;
	  Container = _reactDnd.DragDropContext(_reactDndModulesBackendsHTML52['default'])(Container) || Container;
	  return Container;
	})(_react.Component);
	
	exports['default'] = Container;
	module.exports = exports['default'];

/***/ },
/* 216 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = {
	  CARD: 'card'
	};
	module.exports = exports['default'];

/***/ },
/* 217 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Container = __webpack_require__(215);
	
	var _Container2 = _interopRequireDefault(_Container);
	
	var SortableStressTest = (function (_Component) {
	  _inherits(SortableStressTest, _Component);
	
	  function SortableStressTest(props) {
	    _classCallCheck(this, SortableStressTest);
	
	    _Component.call(this, props);
	    // Avoid rendering on server because the big data list is generated
	    this.state = { shouldRender: false };
	  }
	
	  SortableStressTest.prototype.componentDidMount = function componentDidMount() {
	    // Won't fire on server.
	    this.setState({ shouldRender: true });
	  };
	
	  SortableStressTest.prototype.render = function render() {
	    var shouldRender = this.state.shouldRender;
	
	    return _react2['default'].createElement(
	      'div',
	      null,
	      _react2['default'].createElement(
	        'p',
	        null,
	        _react2['default'].createElement(
	          'b',
	          null,
	          _react2['default'].createElement(
	            'a',
	            { href: 'https://github.com/pljenkins/react-dnd/tree/master/examples/04%20Sortable/Stress%20Test' },
	            'Browse the Source'
	          )
	        )
	      ),
	      _react2['default'].createElement(
	        'p',
	        null,
	        'How many items can React DnD handle at the same time? There are a thousand items in this list. With some optimizations like updating the state inside a ',
	        _react2['default'].createElement(
	          'code',
	          null,
	          'requestAnimationFrame'
	        ),
	        ' callback, it can handle a few thousand items without lagging. After that, you\'re better off using virtual lists like ',
	        _react2['default'].createElement(
	          'a',
	          { href: 'https://github.com/facebook/fixed-data-table' },
	          'fixed-data-table'
	        ),
	        '. Luckily, React DnD is designed to work great with any virtual React data list components because it doesn\'t keep any state in the DOM.'
	      ),
	      _react2['default'].createElement(
	        'p',
	        null,
	        'This example does not scroll automatically but you can add the scrolling with a parent drop target that compares ',
	        _react2['default'].createElement(
	          'code',
	          null,
	          'component.getBoundingClientRect()'
	        ),
	        ' with ',
	        _react2['default'].createElement(
	          'code',
	          null,
	          'monitor.getClientOffset()'
	        ),
	        ' inside its ',
	        _react2['default'].createElement(
	          'code',
	          null,
	          'hover'
	        ),
	        ' handler. In fact, you are welcome to contribute this functionality to this example!'
	      ),
	      shouldRender && _react2['default'].createElement(_Container2['default'], null)
	    );
	  };
	
	  return SortableStressTest;
	})(_react.Component);
	
	exports['default'] = SortableStressTest;
	module.exports = exports['default'];

/***/ },
/* 218 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDnd = __webpack_require__(3);
	
	var _reactDndModulesBackendsHTML5 = __webpack_require__(10);
	
	var _reactDndModulesBackendsHTML52 = _interopRequireDefault(_reactDndModulesBackendsHTML5);
	
	var _SourceBox = __webpack_require__(219);
	
	var _SourceBox2 = _interopRequireDefault(_SourceBox);
	
	var _TargetBox = __webpack_require__(220);
	
	var _TargetBox2 = _interopRequireDefault(_TargetBox);
	
	var Container = (function (_Component) {
	  _inherits(Container, _Component);
	
	  function Container() {
	    _classCallCheck(this, _Container);
	
	    _Component.apply(this, arguments);
	  }
	
	  Container.prototype.render = function render() {
	    return _react2['default'].createElement(
	      'div',
	      { style: { overflow: 'hidden', clear: 'both', marginTop: '1.5rem' } },
	      _react2['default'].createElement(
	        'div',
	        { style: { float: 'left' } },
	        _react2['default'].createElement(_SourceBox2['default'], { showCopyIcon: true }),
	        _react2['default'].createElement(_SourceBox2['default'], null)
	      ),
	      _react2['default'].createElement(
	        'div',
	        { style: { float: 'left' } },
	        _react2['default'].createElement(_TargetBox2['default'], null)
	      )
	    );
	  };
	
	  var _Container = Container;
	  Container = _reactDnd.DragDropContext(_reactDndModulesBackendsHTML52['default'])(Container) || Container;
	  return Container;
	})(_react.Component);
	
	exports['default'] = Container;
	module.exports = exports['default'];

/***/ },
/* 219 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ItemTypes = __webpack_require__(112);
	
	var _ItemTypes2 = _interopRequireDefault(_ItemTypes);
	
	var _reactDnd = __webpack_require__(3);
	
	var style = {
	  border: '1px dashed gray',
	  backgroundColor: 'white',
	  padding: '0.5rem 1rem',
	  marginRight: '1rem',
	  marginBottom: '1rem',
	  cursor: 'move'
	};
	
	var boxSource = {
	  beginDrag: function beginDrag() {
	    return {};
	  }
	};
	
	var SourceBox = (function (_Component) {
	  _inherits(SourceBox, _Component);
	
	  function SourceBox() {
	    _classCallCheck(this, _SourceBox);
	
	    _Component.apply(this, arguments);
	  }
	
	  SourceBox.prototype.render = function render() {
	    var _props = this.props;
	    var isDragging = _props.isDragging;
	    var connectDragSource = _props.connectDragSource;
	    var showCopyIcon = _props.showCopyIcon;
	
	    var opacity = isDragging ? 0.4 : 1;
	    var dropEffect = showCopyIcon ? 'copy' : 'move';
	
	    return connectDragSource(_react2['default'].createElement(
	      'div',
	      { style: _extends({}, style, { opacity: opacity }) },
	      'When I am over a drop zone, I have ',
	      showCopyIcon ? 'copy' : 'no',
	      ' icon.'
	    ), { dropEffect: dropEffect });
	  };
	
	  _createClass(SourceBox, null, [{
	    key: 'propTypes',
	    value: {
	      isDragging: _react.PropTypes.bool.isRequired,
	      connectDragSource: _react.PropTypes.func.isRequired,
	      showCopyIcon: _react.PropTypes.bool
	    },
	    enumerable: true
	  }]);
	
	  var _SourceBox = SourceBox;
	  SourceBox = _reactDnd.DragSource(_ItemTypes2['default'].BOX, boxSource, function (connect, monitor) {
	    return {
	      connectDragSource: connect.dragSource(),
	      isDragging: monitor.isDragging()
	    };
	  })(SourceBox) || SourceBox;
	  return SourceBox;
	})(_react.Component);
	
	exports['default'] = SourceBox;
	module.exports = exports['default'];

/***/ },
/* 220 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ItemTypes = __webpack_require__(112);
	
	var _ItemTypes2 = _interopRequireDefault(_ItemTypes);
	
	var _reactDnd = __webpack_require__(3);
	
	var style = {
	  border: '1px solid gray',
	  height: '15rem',
	  width: '15rem',
	  padding: '2rem',
	  textAlign: 'center'
	};
	
	var boxTarget = {
	  drop: function drop() {}
	};
	
	var TargetBox = (function (_Component) {
	  _inherits(TargetBox, _Component);
	
	  function TargetBox() {
	    _classCallCheck(this, _TargetBox);
	
	    _Component.apply(this, arguments);
	  }
	
	  TargetBox.prototype.render = function render() {
	    var _props = this.props;
	    var canDrop = _props.canDrop;
	    var isOver = _props.isOver;
	    var connectDropTarget = _props.connectDropTarget;
	
	    var isActive = canDrop && isOver;
	
	    return connectDropTarget(_react2['default'].createElement(
	      'div',
	      { style: style },
	      isActive ? 'Release to drop' : 'Drag item here'
	    ));
	  };
	
	  _createClass(TargetBox, null, [{
	    key: 'propTypes',
	    value: {
	      connectDropTarget: _react.PropTypes.func.isRequired,
	      isOver: _react.PropTypes.bool.isRequired,
	      canDrop: _react.PropTypes.bool.isRequired
	    },
	    enumerable: true
	  }]);
	
	  var _TargetBox = TargetBox;
	  TargetBox = _reactDnd.DropTarget(_ItemTypes2['default'].BOX, boxTarget, function (connect, monitor) {
	    return {
	      connectDropTarget: connect.dropTarget(),
	      isOver: monitor.isOver(),
	      canDrop: monitor.canDrop()
	    };
	  })(TargetBox) || TargetBox;
	  return TargetBox;
	})(_react.Component);
	
	exports['default'] = TargetBox;
	module.exports = exports['default'];

/***/ },
/* 221 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Container = __webpack_require__(218);
	
	var _Container2 = _interopRequireDefault(_Container);
	
	var CustomizeDropEffects = (function () {
	  function CustomizeDropEffects() {
	    _classCallCheck(this, CustomizeDropEffects);
	  }
	
	  CustomizeDropEffects.prototype.render = function render() {
	    return _react2['default'].createElement(
	      'div',
	      null,
	      _react2['default'].createElement(
	        'p',
	        null,
	        _react2['default'].createElement(
	          'b',
	          null,
	          _react2['default'].createElement(
	            'a',
	            { href: 'https://github.com/pljenkins/react-dnd/tree/master/examples/05%20Customize/Drop%20Effects' },
	            'Browse the Source'
	          )
	        )
	      ),
	      _react2['default'].createElement(
	        'p',
	        null,
	        'Some browsers let you specify the “drop effects” for the draggable items. In the compatible browsers, you will see a “copy” icon when you drag the first box over the drop zone.'
	      ),
	      _react2['default'].createElement(_Container2['default'], null)
	    );
	  };
	
	  return CustomizeDropEffects;
	})();
	
	exports['default'] = CustomizeDropEffects;
	module.exports = exports['default'];

/***/ },
/* 222 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ItemTypes = __webpack_require__(113);
	
	var _ItemTypes2 = _interopRequireDefault(_ItemTypes);
	
	var _reactDnd = __webpack_require__(3);
	
	var style = {
	  border: '1px dashed gray',
	  padding: '0.5rem 1rem',
	  marginBottom: '.5rem',
	  backgroundColor: 'white',
	  width: '20rem'
	};
	
	var handleStyle = {
	  backgroundColor: 'green',
	  width: '1rem',
	  height: '1rem',
	  display: 'inline-block',
	  marginRight: '0.75rem',
	  cursor: 'move'
	};
	
	var boxSource = {
	  beginDrag: function beginDrag() {
	    return {};
	  }
	};
	
	var BoxWithHandle = (function (_Component) {
	  _inherits(BoxWithHandle, _Component);
	
	  function BoxWithHandle() {
	    _classCallCheck(this, _BoxWithHandle);
	
	    _Component.apply(this, arguments);
	  }
	
	  BoxWithHandle.prototype.render = function render() {
	    var _props = this.props;
	    var isDragging = _props.isDragging;
	    var connectDragSource = _props.connectDragSource;
	    var connectDragPreview = _props.connectDragPreview;
	
	    var opacity = isDragging ? 0.4 : 1;
	
	    return connectDragPreview(_react2['default'].createElement(
	      'div',
	      { style: _extends({}, style, { opacity: opacity }) },
	      connectDragSource(_react2['default'].createElement('div', { style: handleStyle })),
	      'Drag me by the handle'
	    ));
	  };
	
	  _createClass(BoxWithHandle, null, [{
	    key: 'propTypes',
	    value: {
	      connectDragSource: _react.PropTypes.func.isRequired,
	      connectDragPreview: _react.PropTypes.func.isRequired,
	      isDragging: _react.PropTypes.bool.isRequired
	    },
	    enumerable: true
	  }]);
	
	  var _BoxWithHandle = BoxWithHandle;
	  BoxWithHandle = _reactDnd.DragSource(_ItemTypes2['default'].BOX, boxSource, function (connect, monitor) {
	    return {
	      connectDragSource: connect.dragSource(),
	      connectDragPreview: connect.dragPreview(),
	      isDragging: monitor.isDragging()
	    };
	  })(BoxWithHandle) || BoxWithHandle;
	  return BoxWithHandle;
	})(_react.Component);
	
	exports['default'] = BoxWithHandle;
	module.exports = exports['default'];

/***/ },
/* 223 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ItemTypes = __webpack_require__(113);
	
	var _ItemTypes2 = _interopRequireDefault(_ItemTypes);
	
	var _reactDnd = __webpack_require__(3);
	
	var style = {
	  border: '1px dashed gray',
	  padding: '0.5rem 1rem',
	  marginBottom: '.5rem',
	  backgroundColor: 'white',
	  cursor: 'move',
	  width: '20rem'
	};
	
	var BoxSource = {
	  beginDrag: function beginDrag() {
	    return {};
	  }
	};
	
	var BoxWithImage = (function (_Component) {
	  _inherits(BoxWithImage, _Component);
	
	  function BoxWithImage() {
	    _classCallCheck(this, _BoxWithImage);
	
	    _Component.apply(this, arguments);
	  }
	
	  BoxWithImage.prototype.componentDidMount = function componentDidMount() {
	    var _this = this;
	
	    var img = new Image();
	    img.onload = function () {
	      return _this.props.connectDragPreview(img);
	    };
	    img.src = 'data:image/png;base64,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';
	  };
	
	  BoxWithImage.prototype.render = function render() {
	    var _props = this.props;
	    var isDragging = _props.isDragging;
	    var connectDragSource = _props.connectDragSource;
	
	    var opacity = isDragging ? 0.4 : 1;
	
	    return connectDragSource(_react2['default'].createElement(
	      'div',
	      { style: _extends({}, style, { opacity: opacity }) },
	      'Drag me to see an image'
	    ));
	  };
	
	  _createClass(BoxWithImage, null, [{
	    key: 'propTypes',
	    value: {
	      connectDragSource: _react.PropTypes.func.isRequired,
	      connectDragPreview: _react.PropTypes.func.isRequired,
	      isDragging: _react.PropTypes.bool.isRequired
	    },
	    enumerable: true
	  }]);
	
	  var _BoxWithImage = BoxWithImage;
	  BoxWithImage = _reactDnd.DragSource(_ItemTypes2['default'].BOX, BoxSource, function (connect, monitor) {
	    return {
	      connectDragSource: connect.dragSource(),
	      connectDragPreview: connect.dragPreview(),
	      isDragging: monitor.isDragging()
	    };
	  })(BoxWithImage) || BoxWithImage;
	  return BoxWithImage;
	})(_react.Component);
	
	exports['default'] = BoxWithImage;
	module.exports = exports['default'];

/***/ },
/* 224 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDnd = __webpack_require__(3);
	
	var _reactDndModulesBackendsHTML5 = __webpack_require__(10);
	
	var _reactDndModulesBackendsHTML52 = _interopRequireDefault(_reactDndModulesBackendsHTML5);
	
	var _BoxWithImage = __webpack_require__(223);
	
	var _BoxWithImage2 = _interopRequireDefault(_BoxWithImage);
	
	var _BoxWithHandle = __webpack_require__(222);
	
	var _BoxWithHandle2 = _interopRequireDefault(_BoxWithHandle);
	
	var Container = (function (_Component) {
	  _inherits(Container, _Component);
	
	  function Container() {
	    _classCallCheck(this, _Container);
	
	    _Component.apply(this, arguments);
	  }
	
	  Container.prototype.render = function render() {
	    return _react2['default'].createElement(
	      'div',
	      null,
	      _react2['default'].createElement(
	        'div',
	        { style: { marginTop: '1.5rem' } },
	        _react2['default'].createElement(_BoxWithHandle2['default'], null),
	        _react2['default'].createElement(_BoxWithImage2['default'], null)
	      )
	    );
	  };
	
	  var _Container = Container;
	  Container = _reactDnd.DragDropContext(_reactDndModulesBackendsHTML52['default'])(Container) || Container;
	  return Container;
	})(_react.Component);
	
	exports['default'] = Container;
	module.exports = exports['default'];

/***/ },
/* 225 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Container = __webpack_require__(224);
	
	var _Container2 = _interopRequireDefault(_Container);
	
	var CustomizeHandlesAndPreviews = (function () {
	  function CustomizeHandlesAndPreviews() {
	    _classCallCheck(this, CustomizeHandlesAndPreviews);
	  }
	
	  CustomizeHandlesAndPreviews.prototype.render = function render() {
	    return _react2['default'].createElement(
	      'div',
	      null,
	      _react2['default'].createElement(
	        'p',
	        null,
	        _react2['default'].createElement(
	          'b',
	          null,
	          _react2['default'].createElement(
	            'a',
	            { href: 'https://github.com/pljenkins/react-dnd/tree/master/examples/05%20Customize/Handles%20and%20Previews' },
	            'Browse the Source'
	          )
	        )
	      ),
	      _react2['default'].createElement(
	        'p',
	        null,
	        'React DnD lets you choose the draggable node, as well as the drag preview node in your component\'s ',
	        _react2['default'].createElement(
	          'code',
	          null,
	          'render'
	        ),
	        ' function. You may also use an ',
	        _react2['default'].createElement(
	          'a',
	          { href: 'https://developer.mozilla.org/en-US/docs/Web/API/HTMLImageElement/Image' },
	          _react2['default'].createElement(
	            'code',
	            null,
	            'Image'
	          )
	        ),
	        ' instance that you created programmatically once it has loaded.'
	      ),
	      _react2['default'].createElement(_Container2['default'], null)
	    );
	  };
	
	  return CustomizeHandlesAndPreviews;
	})();
	
	exports['default'] = CustomizeHandlesAndPreviews;
	module.exports = exports['default'];

/***/ },
/* 226 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	__webpack_require__(277);
	
	var _Constants = __webpack_require__(50);
	
	var _Constants2 = _interopRequireDefault(_Constants);
	
	var _pagesHomePage = __webpack_require__(233);
	
	var _pagesHomePage2 = _interopRequireDefault(_pagesHomePage);
	
	var _pagesAPIPage = __webpack_require__(231);
	
	var _pagesAPIPage2 = _interopRequireDefault(_pagesAPIPage);
	
	var _pagesExamplePage = __webpack_require__(232);
	
	var _pagesExamplePage2 = _interopRequireDefault(_pagesExamplePage);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var APIDocs = {
	  OVERVIEW: __webpack_require__(330),
	  TUTORIAL: __webpack_require__(333),
	  TESTING: __webpack_require__(331),
	  FAQ: __webpack_require__(329),
	  TROUBLESHOOTING: __webpack_require__(332),
	  DRAG_SOURCE: __webpack_require__(336),
	  DRAG_SOURCE_MONITOR: __webpack_require__(341),
	  DRAG_SOURCE_CONNECTOR: __webpack_require__(338),
	  DROP_TARGET: __webpack_require__(337),
	  DROP_TARGET_CONNECTOR: __webpack_require__(339),
	  DROP_TARGET_MONITOR: __webpack_require__(342),
	  DRAG_DROP_CONTEXT: __webpack_require__(334),
	  DRAG_LAYER: __webpack_require__(335),
	  DRAG_LAYER_MONITOR: __webpack_require__(340),
	  HTML5_BACKEND: __webpack_require__(343),
	  TEST_BACKEND: __webpack_require__(344)
	};
	
	var Examples = {
	  CHESSBOARD_TUTORIAL_APP: __webpack_require__(169),
	  DUSTBIN_SINGLE_TARGET: __webpack_require__(178),
	  DUSTBIN_MULTIPLE_TARGETS: __webpack_require__(174),
	  DUSTBIN_STRESS_TEST: __webpack_require__(183),
	  DRAG_AROUND_NAIVE: __webpack_require__(192),
	  DRAG_AROUND_CUSTOM_DRAG_LAYER: __webpack_require__(188),
	  NESTING_DRAG_SOURCES: __webpack_require__(196),
	  NESTING_DROP_TARGETS: __webpack_require__(200),
	  SORTABLE_SIMPLE: __webpack_require__(213),
	  LIST_SELECTION: __webpack_require__(208),
	  SORTABLE_CANCEL_ON_DROP_OUTSIDE: __webpack_require__(203),
	  SORTABLE_STRESS_TEST: __webpack_require__(217),
	  CUSTOMIZE_HANDLES_AND_PREVIEWS: __webpack_require__(225),
	  CUSTOMIZE_DROP_EFFECTS: __webpack_require__(221)
	};
	
	var IndexPage = (function (_Component) {
	  _inherits(IndexPage, _Component);
	
	  IndexPage.getDoctype = function getDoctype() {
	    return '<!doctype html>';
	  };
	
	  IndexPage.renderToString = function renderToString(props) {
	    return IndexPage.getDoctype() + _react2['default'].renderToString(_react2['default'].createElement(IndexPage, props));
	  };
	
	  function IndexPage(props) {
	    _classCallCheck(this, IndexPage);
	
	    _Component.call(this, props);
	    this.state = {
	      renderPage: !this.props.devMode
	    };
	  }
	
	  IndexPage.prototype.render = function render() {
	    // Dump out our current props to a global object via a script tag so
	    // when initialising the browser environment we can bootstrap from the
	    // same props as what each page was rendered with.
	    var browserInitScriptObj = {
	      __html: 'window.INITIAL_PROPS = ' + JSON.stringify(this.props) + ';\n'
	    };
	
	    return _react2['default'].createElement(
	      'html',
	      null,
	      _react2['default'].createElement(
	        'head',
	        null,
	        _react2['default'].createElement('meta', { charSet: 'utf-8' }),
	        _react2['default'].createElement(
	          'title',
	          null,
	          'React DnD'
	        ),
	        _react2['default'].createElement('meta', { name: 'viewport', content: 'width=device-width, initial-scale=1.0, maximum-scale=1.0' }),
	        _react2['default'].createElement('link', { rel: 'stylesheet', type: 'text/css', href: this.props.files['main.css'] }),
	        _react2['default'].createElement('base', { target: '_blank' })
	      ),
	      _react2['default'].createElement(
	        'body',
	        null,
	        this.state.renderPage && this.renderPage(),
	        _react2['default'].createElement('script', { dangerouslySetInnerHTML: browserInitScriptObj }),
	        _react2['default'].createElement('script', { src: this.props.files['main.js'] })
	      )
	    );
	  };
	
	  IndexPage.prototype.renderPage = function renderPage() {
	    switch (this.props.location) {
	      case _Constants.Pages.HOME.location:
	        return _react2['default'].createElement(_pagesHomePage2['default'], null);
	    }
	
	    for (var groupIndex in _Constants.APIPages) {
	      var group = _Constants.APIPages[groupIndex];
	      var pageKeys = Object.keys(group.pages);
	
	      for (var i = 0; i < pageKeys.length; i++) {
	        var key = pageKeys[i];
	        var page = group.pages[key];
	
	        if (this.props.location === page.location) {
	          return _react2['default'].createElement(_pagesAPIPage2['default'], { example: page,
	            html: APIDocs[key] });
	        }
	      }
	    }
	
	    for (var groupIndex in _Constants.ExamplePages) {
	      var group = _Constants.ExamplePages[groupIndex];
	      var pageKeys = Object.keys(group.pages);
	
	      for (var i = 0; i < pageKeys.length; i++) {
	        var key = pageKeys[i];
	        var page = group.pages[key];
	        var _Component2 = Examples[key];
	
	        if (this.props.location === page.location) {
	          return _react2['default'].createElement(
	            _pagesExamplePage2['default'],
	            { example: page },
	            _react2['default'].createElement(_Component2, null)
	          );
	        }
	      }
	    }
	
	    throw new Error('Page of location ' + JSON.stringify(this.props.location) + ' not found.');
	  };
	
	  IndexPage.prototype.componentDidMount = function componentDidMount() {
	    if (!this.state.renderPage) {
	      this.setState({
	        renderPage: true
	      });
	    }
	  };
	
	  return IndexPage;
	})(_react.Component);
	
	exports['default'] = IndexPage;
	module.exports = exports['default'];

/***/ },
/* 227 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var React = __webpack_require__(1);
	var IndexPage = __webpack_require__(226);
	
	React.render(React.createElement(IndexPage, window.INITIAL_PROPS), document);

/***/ },
/* 228 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactLibReactUpdates = __webpack_require__(14);
	
	var _reactLibReactUpdates2 = _interopRequireDefault(_reactLibReactUpdates);
	
	var _StaticHTMLBlock = __webpack_require__(72);
	
	var _StaticHTMLBlock2 = _interopRequireDefault(_StaticHTMLBlock);
	
	__webpack_require__(278);
	
	var preferredSyntax = 'es5';
	var observers = [];
	
	function subscribe(observer) {
	  observers.push(observer);
	  return function () {
	    observers.slice(observers.indexOf(observer), 1);
	  };
	}
	
	function setPreferredSyntax(syntax) {
	  preferredSyntax = syntax;
	  observers.forEach(function (o) {
	    return o(preferredSyntax);
	  });
	}
	
	var CodeBlock = (function (_Component) {
	  _inherits(CodeBlock, _Component);
	
	  _createClass(CodeBlock, null, [{
	    key: 'propTypes',
	    value: {
	      es5: _react.PropTypes.string,
	      es6: _react.PropTypes.string,
	      es7: _react.PropTypes.string
	    },
	    enumerable: true
	  }, {
	    key: 'defaultProps',
	    value: {
	      es5: '',
	      es6: '',
	      es7: ''
	    },
	    enumerable: true
	  }]);
	
	  function CodeBlock(props) {
	    _classCallCheck(this, CodeBlock);
	
	    _Component.call(this, props);
	    this.state = {
	      chosen: false,
	      syntax: this.props.es5.trim().length && 'es5' || this.props.es6.trim().length && 'es6' || this.props.es7.trim().length && 'es7'
	    };
	  }
	
	  CodeBlock.prototype.componentDidMount = function componentDidMount() {
	    this.unsubscribe = subscribe(this.handlePreferredSyntaxChange.bind(this));
	  };
	
	  CodeBlock.prototype.handlePreferredSyntaxChange = function handlePreferredSyntaxChange(syntax) {
	    if (this.state.chosen || this.state.syntax === syntax) {
	      return;
	    }
	
	    if (this.props[syntax].trim().length) {
	      this.setState({
	        syntax: syntax
	      });
	    }
	  };
	
	  CodeBlock.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.unsubscribe();
	  };
	
	  CodeBlock.prototype.handleSyntaxClick = function handleSyntaxClick(syntax) {
	    this.setState({
	      syntax: syntax,
	      chosen: true
	    });
	
	    var scrollTopBefore = _react.findDOMNode(this).getBoundingClientRect().top;
	    setPreferredSyntax(syntax);
	    _reactLibReactUpdates2['default'].flushBatchedUpdates();
	    var scrollTopAfter = _react.findDOMNode(this).getBoundingClientRect().top;
	
	    window.scroll(window.pageXOffset || window.scrollX, (window.pageYOffset || window.scrollY) - (scrollTopBefore - scrollTopAfter));
	  };
	
	  CodeBlock.prototype.render = function render() {
	    return _react2['default'].createElement(
	      'div',
	      { className: 'CodeBlock' },
	      _react2['default'].createElement(
	        'ul',
	        { className: 'CodeBlock-tabs' },
	        ['es5', 'es6', 'es7'].map(this.renderSyntaxLink, this)
	      ),
	      _react2['default'].createElement(
	        'div',
	        { className: 'CodeBlock-content' },
	        _react2['default'].createElement(_StaticHTMLBlock2['default'], { html: this.props[this.state.syntax] })
	      )
	    );
	  };
	
	  CodeBlock.prototype.renderSyntaxLink = function renderSyntaxLink(syntax) {
	    if (!this.props[syntax] || !this.props[syntax].trim().length) {
	      return;
	    }
	
	    if (syntax === 'es5' && !this.props.es6.trim().length && !this.props.es7.trim().length) {
	      return;
	    }
	
	    var active = this.state.syntax === syntax;
	    return _react2['default'].createElement(
	      'li',
	      { className: 'CodeBlock-tab ' + (active ? 'CodeBlock-activeTab' : ''),
	        key: syntax },
	      _react2['default'].createElement(
	        'a',
	        { onClick: this.handleSyntaxClick.bind(this, syntax) },
	        syntax.toUpperCase()
	      )
	    );
	  };
	
	  return CodeBlock;
	})(_react.Component);
	
	exports['default'] = CodeBlock;
	module.exports = exports['default'];

/***/ },
/* 229 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(279);
	
	var Cover = (function () {
	  function Cover() {
	    _classCallCheck(this, Cover);
	  }
	
	  Cover.prototype.render = function render() {
	    return _react2['default'].createElement(
	      'div',
	      { className: 'Cover' },
	      _react2['default'].createElement(
	        'div',
	        { className: 'Cover-header' },
	        _react2['default'].createElement(
	          'p',
	          { className: 'Cover-description' },
	          'Drag and Drop for React'
	        )
	      )
	    );
	  };
	
	  return Cover;
	})();
	
	exports['default'] = Cover;
	module.exports = exports['default'];

/***/ },
/* 230 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Constants = __webpack_require__(50);
	
	__webpack_require__(281);
	
	var GITHUB_URL = 'https://github.com/pljenkins/react-dnd';
	var DOCS_LOCATION = _Constants.DOCS_DEFAULT.location;
	var EXAMPLES_LOCATION = _Constants.EXAMPLES_DEFAULT.location;
	
	var NavBar = (function () {
	  function NavBar() {
	    _classCallCheck(this, NavBar);
	  }
	
	  NavBar.prototype.render = function render() {
	    return _react2['default'].createElement(
	      'div',
	      { className: 'NavBar' },
	      _react2['default'].createElement(
	        'div',
	        { className: 'NavBar-container' },
	        _react2['default'].createElement(
	          'div',
	          { className: 'NavBar-logo' },
	          _react2['default'].createElement(
	            'a',
	            { href: './', target: '_self', className: 'NavBar-logoTitle' },
	            'React ',
	            _react2['default'].createElement(
	              'i',
	              null,
	              'DnD'
	            )
	          ),
	          _react2['default'].createElement(
	            'p',
	            { className: 'NavBar-logoDescription' },
	            'Drag and Drop for React'
	          )
	        ),
	        _react2['default'].createElement(
	          'div',
	          { className: 'NavBar-item' },
	          _react2['default'].createElement(
	            'a',
	            { className: 'NavBar-link', href: DOCS_LOCATION, target: '_self' },
	            'Docs'
	          ),
	          _react2['default'].createElement(
	            'a',
	            { className: 'NavBar-link', href: EXAMPLES_LOCATION, target: '_self' },
	            'Examples'
	          ),
	          _react2['default'].createElement(
	            'a',
	            { className: 'NavBar-link', href: GITHUB_URL },
	            'GitHub'
	          )
	        )
	      )
	    );
	  };
	
	  return NavBar;
	})();
	
	exports['default'] = NavBar;
	module.exports = exports['default'];

/***/ },
/* 231 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _componentsHeader = __webpack_require__(70);
	
	var _componentsHeader2 = _interopRequireDefault(_componentsHeader);
	
	var _componentsPageBody = __webpack_require__(71);
	
	var _componentsPageBody2 = _interopRequireDefault(_componentsPageBody);
	
	var _componentsSideBar = __webpack_require__(115);
	
	var _componentsSideBar2 = _interopRequireDefault(_componentsSideBar);
	
	var _componentsStaticHTMLBlock = __webpack_require__(72);
	
	var _componentsStaticHTMLBlock2 = _interopRequireDefault(_componentsStaticHTMLBlock);
	
	var _Constants = __webpack_require__(50);
	
	var APIPage = (function () {
	  function APIPage() {
	    _classCallCheck(this, APIPage);
	  }
	
	  APIPage.prototype.render = function render() {
	    return _react2['default'].createElement(
	      'div',
	      null,
	      _react2['default'].createElement(_componentsHeader2['default'], null),
	      _react2['default'].createElement(
	        _componentsPageBody2['default'],
	        { hasSidebar: true },
	        _react2['default'].createElement(_componentsSideBar2['default'], {
	          groups: _Constants.APIPages,
	          example: this.props.example
	        }),
	        _react2['default'].createElement(_componentsStaticHTMLBlock2['default'], { html: this.props.html })
	      )
	    );
	  };
	
	  return APIPage;
	})();
	
	exports['default'] = APIPage;
	module.exports = exports['default'];

/***/ },
/* 232 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _componentsHeader = __webpack_require__(70);
	
	var _componentsHeader2 = _interopRequireDefault(_componentsHeader);
	
	var _componentsPageBody = __webpack_require__(71);
	
	var _componentsPageBody2 = _interopRequireDefault(_componentsPageBody);
	
	var _componentsSideBar = __webpack_require__(115);
	
	var _componentsSideBar2 = _interopRequireDefault(_componentsSideBar);
	
	var _Constants = __webpack_require__(50);
	
	var ExamplesPage = (function () {
	  function ExamplesPage() {
	    _classCallCheck(this, ExamplesPage);
	  }
	
	  ExamplesPage.prototype.render = function render() {
	    return _react2['default'].createElement(
	      'div',
	      null,
	      this.props.children
	    );
	  };
	
	  return ExamplesPage;
	})();
	
	exports['default'] = ExamplesPage;
	module.exports = exports['default'];

/***/ },
/* 233 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _componentsHeader = __webpack_require__(70);
	
	var _componentsHeader2 = _interopRequireDefault(_componentsHeader);
	
	var _componentsPageBody = __webpack_require__(71);
	
	var _componentsPageBody2 = _interopRequireDefault(_componentsPageBody);
	
	var _componentsStaticHTMLBlock = __webpack_require__(72);
	
	var _componentsStaticHTMLBlock2 = _interopRequireDefault(_componentsStaticHTMLBlock);
	
	var _docsIndexMd = __webpack_require__(345);
	
	var _docsIndexMd2 = _interopRequireDefault(_docsIndexMd);
	
	var HomePage = (function () {
	  function HomePage() {
	    _classCallCheck(this, HomePage);
	  }
	
	  HomePage.prototype.render = function render() {
	    return _react2['default'].createElement(
	      'div',
	      null,
	      _react2['default'].createElement(_componentsHeader2['default'], { showCover: true }),
	      _react2['default'].createElement(
	        _componentsPageBody2['default'],
	        null,
	        _react2['default'].createElement(_componentsStaticHTMLBlock2['default'], { html: _docsIndexMd2['default'] })
	      )
	    );
	  };
	
	  return HomePage;
	})();
	
	exports['default'] = HomePage;
	module.exports = exports['default'];

/***/ },
/* 234 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _slice = Array.prototype.slice;
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	exports['default'] = DragDropContext;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _dndCore = __webpack_require__(53);
	
	var _invariant = __webpack_require__(9);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _utilsCheckDecoratorArguments = __webpack_require__(51);
	
	var _utilsCheckDecoratorArguments2 = _interopRequireDefault(_utilsCheckDecoratorArguments);
	
	function DragDropContext(backend) {
	  _utilsCheckDecoratorArguments2['default'].apply(undefined, ['DragDropContext', 'backend'].concat(_slice.call(arguments)));
	
	  // Auto-detect ES6 default export for people still using ES5
	  if (typeof backend === 'object' && typeof backend['default'] === 'function') {
	    backend = backend['default'];
	  }
	  _invariant2['default'](typeof backend === 'function', 'Expected the backend to be a function or an ES6 module exporting a default function. ' + 'Read more: http://pljenkins.github.io/react-dnd/docs-drag-drop-context.html');
	
	  var childContext = {
	    dragDropManager: new _dndCore.DragDropManager(backend)
	  };
	
	  return function decorateContext(DecoratedComponent) {
	    var displayName = DecoratedComponent.displayName || DecoratedComponent.name || 'Component';
	
	    return (function (_Component) {
	      _inherits(DragDropContextContainer, _Component);
	
	      function DragDropContextContainer() {
	        _classCallCheck(this, DragDropContextContainer);
	
	        _Component.apply(this, arguments);
	      }
	
	      DragDropContextContainer.prototype.getDecoratedComponentInstance = function getDecoratedComponentInstance() {
	        return this.refs.child;
	      };
	
	      DragDropContextContainer.prototype.getManager = function getManager() {
	        return childContext.dragDropManager;
	      };
	
	      DragDropContextContainer.prototype.getChildContext = function getChildContext() {
	        return childContext;
	      };
	
	      DragDropContextContainer.prototype.render = function render() {
	        return _react2['default'].createElement(DecoratedComponent, _extends({}, this.props, {
	          ref: 'child' }));
	      };
	
	      _createClass(DragDropContextContainer, null, [{
	        key: 'DecoratedComponent',
	        value: DecoratedComponent,
	        enumerable: true
	      }, {
	        key: 'displayName',
	        value: 'DragDropContext(' + displayName + ')',
	        enumerable: true
	      }, {
	        key: 'childContextTypes',
	        value: {
	          dragDropManager: _react.PropTypes.object.isRequired
	        },
	        enumerable: true
	      }]);
	
	      return DragDropContextContainer;
	    })(_react.Component);
	  };
	}
	
	module.exports = exports['default'];

/***/ },
/* 235 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _slice = Array.prototype.slice;
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	exports['default'] = DragLayer;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _dndCore = __webpack_require__(53);
	
	var _utilsShallowEqual = __webpack_require__(29);
	
	var _utilsShallowEqual2 = _interopRequireDefault(_utilsShallowEqual);
	
	var _utilsShallowEqualScalar = __webpack_require__(52);
	
	var _utilsShallowEqualScalar2 = _interopRequireDefault(_utilsShallowEqualScalar);
	
	var _lodashLangIsPlainObject = __webpack_require__(31);
	
	var _lodashLangIsPlainObject2 = _interopRequireDefault(_lodashLangIsPlainObject);
	
	var _invariant = __webpack_require__(9);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _utilsCheckDecoratorArguments = __webpack_require__(51);
	
	var _utilsCheckDecoratorArguments2 = _interopRequireDefault(_utilsCheckDecoratorArguments);
	
	function DragLayer(collect) {
	  var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
	  _utilsCheckDecoratorArguments2['default'].apply(undefined, ['DragLayer', 'collect[, options]'].concat(_slice.call(arguments)));
	  _invariant2['default'](typeof collect === 'function', 'Expected "collect" provided as the first argument to DragLayer ' + 'to be a function that collects props to inject into the component. ', 'Instead, received %s. ' + 'Read more: http://pljenkins.github.io/react-dnd/docs-drag-layer.html', collect);
	  _invariant2['default'](_lodashLangIsPlainObject2['default'](options), 'Expected "options" provided as the second argument to DragLayer to be ' + 'a plain object when specified. ' + 'Instead, received %s. ' + 'Read more: http://pljenkins.github.io/react-dnd/docs-drag-layer.html', options);
	
	  return function decorateLayer(DecoratedComponent) {
	    var _options$arePropsEqual = options.arePropsEqual;
	    var arePropsEqual = _options$arePropsEqual === undefined ? _utilsShallowEqualScalar2['default'] : _options$arePropsEqual;
	
	    var displayName = DecoratedComponent.displayName || DecoratedComponent.name || 'Component';
	
	    return (function (_Component) {
	      _inherits(DragLayerContainer, _Component);
	
	      DragLayerContainer.prototype.getDecoratedComponentInstance = function getDecoratedComponentInstance() {
	        return this.refs.child;
	      };
	
	      DragLayerContainer.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
	        return !arePropsEqual(nextProps, this.props) || !_utilsShallowEqual2['default'](nextState, this.state);
	      };
	
	      _createClass(DragLayerContainer, null, [{
	        key: 'DecoratedComponent',
	        value: DecoratedComponent,
	        enumerable: true
	      }, {
	        key: 'displayName',
	        value: 'DragLayer(' + displayName + ')',
	        enumerable: true
	      }, {
	        key: 'contextTypes',
	        value: {
	          dragDropManager: _react.PropTypes.object.isRequired
	        },
	        enumerable: true
	      }]);
	
	      function DragLayerContainer(props, context) {
	        _classCallCheck(this, DragLayerContainer);
	
	        _Component.call(this, props);
	        this.handleChange = this.handleChange.bind(this);
	
	        this.manager = context.dragDropManager;
	        _invariant2['default'](typeof this.manager === 'object', 'Could not find the drag and drop manager in the context of %s. ' + 'Make sure to wrap the top-level component of your app with DragDropContext. ' + 'Read more: http://pljenkins.github.io/react-dnd/docs-troubleshooting.html#could-not-find-the-drag-and-drop-manager-in-the-context', displayName, displayName);
	
	        this.state = this.getCurrentState();
	      }
	
	      DragLayerContainer.prototype.componentDidMount = function componentDidMount() {
	        var monitor = this.manager.getMonitor();
	        this.unsubscribe = monitor.subscribeToOffsetChange(this.handleChange);
	      };
	
	      DragLayerContainer.prototype.componentWillUnmount = function componentWillUnmount() {
	        this.unsubscribe();
	      };
	
	      DragLayerContainer.prototype.handleChange = function handleChange() {
	        var nextState = this.getCurrentState();
	        if (!_utilsShallowEqual2['default'](nextState, this.state)) {
	          this.setState(nextState);
	        }
	      };
	
	      DragLayerContainer.prototype.getCurrentState = function getCurrentState() {
	        var monitor = this.manager.getMonitor();
	        return collect(monitor);
	      };
	
	      DragLayerContainer.prototype.render = function render() {
	        return _react2['default'].createElement(DecoratedComponent, _extends({}, this.props, this.state, {
	          ref: 'child' }));
	      };
	
	      return DragLayerContainer;
	    })(_react.Component);
	  };
	}
	
	module.exports = exports['default'];

/***/ },
/* 236 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	var _slice = Array.prototype.slice;
	exports['default'] = DragSource;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utilsShallowEqual = __webpack_require__(29);
	
	var _utilsShallowEqual2 = _interopRequireDefault(_utilsShallowEqual);
	
	var _utilsShallowEqualScalar = __webpack_require__(52);
	
	var _utilsShallowEqualScalar2 = _interopRequireDefault(_utilsShallowEqualScalar);
	
	var _invariant = __webpack_require__(9);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _lodashLangIsPlainObject = __webpack_require__(31);
	
	var _lodashLangIsPlainObject2 = _interopRequireDefault(_lodashLangIsPlainObject);
	
	var _utilsCheckDecoratorArguments = __webpack_require__(51);
	
	var _utilsCheckDecoratorArguments2 = _interopRequireDefault(_utilsCheckDecoratorArguments);
	
	var _decorateHandler = __webpack_require__(116);
	
	var _decorateHandler2 = _interopRequireDefault(_decorateHandler);
	
	var _registerSource = __webpack_require__(247);
	
	var _registerSource2 = _interopRequireDefault(_registerSource);
	
	var _createSourceFactory = __webpack_require__(242);
	
	var _createSourceFactory2 = _interopRequireDefault(_createSourceFactory);
	
	var _createSourceMonitor = __webpack_require__(243);
	
	var _createSourceMonitor2 = _interopRequireDefault(_createSourceMonitor);
	
	var _createSourceConnector = __webpack_require__(241);
	
	var _createSourceConnector2 = _interopRequireDefault(_createSourceConnector);
	
	var _utilsIsValidType = __webpack_require__(119);
	
	var _utilsIsValidType2 = _interopRequireDefault(_utilsIsValidType);
	
	function DragSource(type, spec, collect) {
	  var options = arguments.length <= 3 || arguments[3] === undefined ? {} : arguments[3];
	
	  _utilsCheckDecoratorArguments2['default'].apply(undefined, ['DragSource', 'type, spec, collect[, options]'].concat(_slice.call(arguments)));
	  var getType = type;
	  if (typeof type !== 'function') {
	    _invariant2['default'](_utilsIsValidType2['default'](type), 'Expected "type" provided as the first argument to DragSource to be ' + 'a string, or a function that returns a string given the current props. ' + 'Instead, received %s. ' + 'Read more: http://pljenkins.github.io/react-dnd/docs-drag-source.html', type);
	    getType = function () {
	      return type;
	    };
	  }
	  _invariant2['default'](_lodashLangIsPlainObject2['default'](spec), 'Expected "spec" provided as the second argument to DragSource to be ' + 'a plain object. Instead, received %s. ' + 'Read more: http://pljenkins.github.io/react-dnd/docs-drag-source.html', spec);
	  var createSource = _createSourceFactory2['default'](spec);
	  _invariant2['default'](typeof collect === 'function', 'Expected "collect" provided as the third argument to DragSource to be ' + 'a function that returns a plain object of props to inject. ' + 'Instead, received %s. ' + 'Read more: http://pljenkins.github.io/react-dnd/docs-drag-source.html', collect);
	  _invariant2['default'](_lodashLangIsPlainObject2['default'](options), 'Expected "options" provided as the fourth argument to DragSource to be ' + 'a plain object when specified. ' + 'Instead, received %s. ' + 'Read more: http://pljenkins.github.io/react-dnd/docs-drag-source.html', collect);
	
	  return function decorateSource(DecoratedComponent) {
	    return _decorateHandler2['default']({
	      connectBackend: function connectBackend(backend, sourceId) {
	        return backend.connectDragSource(sourceId);
	      },
	      containerDisplayName: 'DragSource',
	      createHandler: createSource,
	      registerHandler: _registerSource2['default'],
	      createMonitor: _createSourceMonitor2['default'],
	      createConnector: _createSourceConnector2['default'],
	      DecoratedComponent: DecoratedComponent,
	      getType: getType,
	      collect: collect,
	      options: options
	    });
	  };
	}
	
	module.exports = exports['default'];

/***/ },
/* 237 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	var _slice = Array.prototype.slice;
	exports['default'] = DropTarget;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utilsShallowEqual = __webpack_require__(29);
	
	var _utilsShallowEqual2 = _interopRequireDefault(_utilsShallowEqual);
	
	var _utilsShallowEqualScalar = __webpack_require__(52);
	
	var _utilsShallowEqualScalar2 = _interopRequireDefault(_utilsShallowEqualScalar);
	
	var _invariant = __webpack_require__(9);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _lodashLangIsPlainObject = __webpack_require__(31);
	
	var _lodashLangIsPlainObject2 = _interopRequireDefault(_lodashLangIsPlainObject);
	
	var _utilsCheckDecoratorArguments = __webpack_require__(51);
	
	var _utilsCheckDecoratorArguments2 = _interopRequireDefault(_utilsCheckDecoratorArguments);
	
	var _decorateHandler = __webpack_require__(116);
	
	var _decorateHandler2 = _interopRequireDefault(_decorateHandler);
	
	var _registerTarget = __webpack_require__(248);
	
	var _registerTarget2 = _interopRequireDefault(_registerTarget);
	
	var _createTargetFactory = __webpack_require__(245);
	
	var _createTargetFactory2 = _interopRequireDefault(_createTargetFactory);
	
	var _createTargetMonitor = __webpack_require__(246);
	
	var _createTargetMonitor2 = _interopRequireDefault(_createTargetMonitor);
	
	var _createTargetConnector = __webpack_require__(244);
	
	var _createTargetConnector2 = _interopRequireDefault(_createTargetConnector);
	
	var _utilsIsValidType = __webpack_require__(119);
	
	var _utilsIsValidType2 = _interopRequireDefault(_utilsIsValidType);
	
	function DropTarget(type, spec, collect) {
	  var options = arguments.length <= 3 || arguments[3] === undefined ? {} : arguments[3];
	
	  _utilsCheckDecoratorArguments2['default'].apply(undefined, ['DropTarget', 'type, spec, collect[, options]'].concat(_slice.call(arguments)));
	  var getType = type;
	  if (typeof type !== 'function') {
	    _invariant2['default'](_utilsIsValidType2['default'](type, true), 'Expected "type" provided as the first argument to DropTarget to be ' + 'a string, an array of strings, or a function that returns either given ' + 'the current props. Instead, received %s. ' + 'Read more: http://pljenkins.github.io/react-dnd/docs-drop-target.html', type);
	    getType = function () {
	      return type;
	    };
	  }
	  _invariant2['default'](_lodashLangIsPlainObject2['default'](spec), 'Expected "spec" provided as the second argument to DropTarget to be ' + 'a plain object. Instead, received %s. ' + 'Read more: http://pljenkins.github.io/react-dnd/docs-drop-target.html', spec);
	  var createTarget = _createTargetFactory2['default'](spec);
	  _invariant2['default'](typeof collect === 'function', 'Expected "collect" provided as the third argument to DropTarget to be ' + 'a function that returns a plain object of props to inject. ' + 'Instead, received %s. ' + 'Read more: http://pljenkins.github.io/react-dnd/docs-drop-target.html', collect);
	  _invariant2['default'](_lodashLangIsPlainObject2['default'](options), 'Expected "options" provided as the fourth argument to DropTarget to be ' + 'a plain object when specified. ' + 'Instead, received %s. ' + 'Read more: http://pljenkins.github.io/react-dnd/docs-drop-target.html', collect);
	
	  return function decorateTarget(DecoratedComponent) {
	    return _decorateHandler2['default']({
	      connectBackend: function connectBackend(backend, targetId) {
	        return backend.connectDropTarget(targetId);
	      },
	      containerDisplayName: 'DropTarget',
	      createHandler: createTarget,
	      registerHandler: _registerTarget2['default'],
	      createMonitor: _createTargetMonitor2['default'],
	      createConnector: _createTargetConnector2['default'],
	      DecoratedComponent: DecoratedComponent,
	      getType: getType,
	      collect: collect,
	      options: options
	    });
	  };
	}
	
	module.exports = exports['default'];

/***/ },
/* 238 */
/***/ function(module, exports, __webpack_require__) {

	/* global window, document */
	// This is basically https://github.com/pljenkins/react-dnd/blob/ba8359ab3d7c76592357e078561d0e9d96afbcb0/src/backends/Touch.js
	'use strict';
	exports.__esModule = true;
	exports['default'] = createTouchBackend;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _dndCore = __webpack_require__(53);
	
	var _utilsOffsetHelpers = __webpack_require__(118);
	
	var _invariant = __webpack_require__(9);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var TouchBackend = (function () {
	  function TouchBackend(manager) {
	    _classCallCheck(this, TouchBackend);
	
	    this.actions = manager.getActions();
	    this.monitor = manager.getMonitor();
	    this.registry = manager.getRegistry();
	
	    this.sourceNodes = {};
	    this.sourceNodeOptions = {};
	    this.sourcePreviewNodes = {};
	    this.sourcePreviewNodeOptions = {};
	    this.targetNodes = {};
	    this.targetNodeOptions = {};
	    this._mouseClientOffset = {};
	
	    this.getSourceClientOffset = this.getSourceClientOffset.bind(this);
	    this.handleTopTouchStart = this.handleTopTouchStart.bind(this);
	    this.handleTopTouchStartCapture = this.handleTopTouchStartCapture.bind(this);
	    this.handleTopTouchMoveCapture = this.handleTopTouchMoveCapture.bind(this);
	    this.handleTopTouchEndCapture = this.handleTopTouchEndCapture.bind(this);
	  }
	
	  TouchBackend.prototype.setup = function setup() {
	    if (typeof window === 'undefined') {
	      return;
	    }
	
	    _invariant2['default'](!this.constructor.isSetUp, 'Cannot have two Touch backends at the same time.');
	    this.constructor.isSetUp = true;
	
	    window.addEventListener('touchstart', this.handleTopTouchStartCapture, true);
	    window.addEventListener('touchstart', this.handleTopTouchStart);
	    window.addEventListener('touchmove', this.handleTopTouchMoveCapture, true);
	    window.addEventListener('touchend', this.handleTopTouchEndCapture, true);
	  };
	
	  TouchBackend.prototype.teardown = function teardown() {
	    if (typeof window === 'undefined') {
	      return;
	    }
	
	    this.constructor.isSetUp = false;
	    this._mouseClientOffset = {};
	
	    window.removeEventListener('touchstart', this.handleTopTouchStartCapture, true);
	    window.removeEventListener('touchstart', this.handleTopTouchStart);
	    window.removeEventListener('touchmove', this.handleTopTouchMoveCapture, true);
	    window.removeEventListener('touchend', this.handleTopTouchEndCapture, true);
	
	    this.uninstallSourceNodeRemovalObserver();
	  };
	
	  TouchBackend.prototype.connectDragSource = function connectDragSource(sourceId, node, options) {
	    var _this = this;
	
	    var handleTouchStart = this.handleTouchStart.bind(this, sourceId);
	    this.sourceNodes[sourceId] = node;
	
	    node.addEventListener('touchstart', handleTouchStart);
	
	    return function () {
	      delete _this.sourceNodes[sourceId];
	      node.removeEventListener('touchstart', handleTouchStart);
	    };
	  };
	
	  TouchBackend.prototype.connectDragPreview = function connectDragPreview(sourceId, node, options) {
	    var _this2 = this;
	
	    this.sourcePreviewNodeOptions[sourceId] = options;
	    this.sourcePreviewNodes[sourceId] = node;
	
	    return function () {
	      delete _this2.sourcePreviewNodes[sourceId];
	      delete _this2.sourcePreviewNodeOptions[sourceId];
	    };
	  };
	
	  TouchBackend.prototype.connectDropTarget = function connectDropTarget(targetId, node) {
	    var _this3 = this;
	
	    this.targetNodes[targetId] = node;
	
	    return function () {
	      delete _this3.targetNodes[targetId];
	    };
	  };
	
	  TouchBackend.prototype.getSourceClientOffset = function getSourceClientOffset(sourceId) {
	    return _utilsOffsetHelpers.getElementClientOffset(this.sourceNodes[sourceId]);
	  };
	
	  TouchBackend.prototype.handleTopTouchStartCapture = function handleTopTouchStartCapture(e) {
	    this.touchStartSourceIds = [];
	  };
	
	  TouchBackend.prototype.handleTouchStart = function handleTouchStart(sourceId) {
	    this.touchStartSourceIds.unshift(sourceId);
	  };
	
	  TouchBackend.prototype.handleTopTouchStart = function handleTopTouchStart(e) {
	    if (e.targetTouches.length !== 1) {
	      return;
	    }
	
	    // Don't prematurely preventDefault() here since it might:
	    // 1. Mess up scrolling
	    // 2. Mess up long tap (which brings up context menu)
	    // 3. If there's an anchor link as a child, tap won't be triggered on link
	
	    this._mouseClientOffset = _utilsOffsetHelpers.getEventClientOffset(e.targetTouches[0]);
	  };
	
	  TouchBackend.prototype.handleTopTouchMoveCapture = function handleTopTouchMoveCapture(e) {
	    var _this4 = this;
	
	    var touchStartSourceIds = this.touchStartSourceIds;
	
	    var dragDeadzone = 10;
	
	    if (e.targetTouches.length !== 1) {
	      return;
	    }
	
	    var clientOffset = _utilsOffsetHelpers.getEventClientOffset(e.targetTouches[0]);
	
	    // If we're not dragging and we've moved a little, that counts as a drag start
	    if (!this.monitor.isDragging() && this._mouseClientOffset.hasOwnProperty('x') && touchStartSourceIds && (Math.abs(this._mouseClientOffset.x - clientOffset.x) > dragDeadzone || Math.abs(this._mouseClientOffset.y - clientOffset.y) > dragDeadzone)) {
	      this.touchStartSourceIds = null;
	
	      this.actions.beginDrag(touchStartSourceIds, {
	        clientOffset: this._mouseClientOffset,
	        getSourceClientOffset: this.getSourceClientOffset,
	        publishSource: false
	      });
	    }
	
	    if (!this.monitor.isDragging()) {
	      return;
	    }
	
	    var sourceNode = this.sourceNodes[this.monitor.getSourceId()];
	    this.installSourceNodeRemovalObserver(sourceNode);
	    this.actions.publishDragSource();
	
	    e.preventDefault();
	
	    var matchingTargetIds = Object.keys(this.targetNodes).filter(function (targetId) {
	      var boundingRect = _this4.targetNodes[targetId].getBoundingClientRect();
	      return clientOffset.x >= boundingRect.left && clientOffset.x <= boundingRect.right && clientOffset.y >= boundingRect.top && clientOffset.y <= boundingRect.bottom;
	    });
	
	    this.actions.hover(matchingTargetIds, {
	      clientOffset: clientOffset
	    });
	  };
	
	  TouchBackend.prototype.handleTopTouchEndCapture = function handleTopTouchEndCapture(e) {
	    if (!this.monitor.isDragging() || this.monitor.didDrop()) {
	      return;
	    }
	
	    e.preventDefault();
	
	    this._mouseClientOffset = {};
	
	    this.uninstallSourceNodeRemovalObserver();
	    this.actions.drop();
	    this.actions.endDrag();
	  };
	
	  TouchBackend.prototype.installSourceNodeRemovalObserver = function installSourceNodeRemovalObserver(node) {
	    var _this5 = this;
	
	    this.uninstallSourceNodeRemovalObserver();
	
	    this.draggedSourceNode = node;
	    this.draggedSourceNodeRemovalObserver = new window.MutationObserver(function () {
	      if (!node.parentElement) {
	        _this5.resurrectSourceNode();
	        _this5.uninstallSourceNodeRemovalObserver();
	      }
	    });
	
	    this.draggedSourceNodeRemovalObserver.observe(node.parentElement, { childList: true });
	  };
	
	  TouchBackend.prototype.resurrectSourceNode = function resurrectSourceNode() {
	    this.draggedSourceNode.style.display = 'none';
	    this.draggedSourceNode.removeAttribute('data-reactid');
	    document.body.appendChild(this.draggedSourceNode);
	  };
	
	  TouchBackend.prototype.uninstallSourceNodeRemovalObserver = function uninstallSourceNodeRemovalObserver() {
	    if (this.draggedSourceNodeRemovalObserver) {
	      this.draggedSourceNodeRemovalObserver.disconnect();
	    }
	
	    this.draggedSourceNodeRemovalObserver = null;
	    this.draggedSourceNode = null;
	  };
	
	  return TouchBackend;
	})();
	
	function createTouchBackend(manager) {
	  return new TouchBackend(manager);
	}
	
	module.exports = exports['default'];

/***/ },
/* 239 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = bindConnector;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _bindConnectorMethod2 = __webpack_require__(240);
	
	var _bindConnectorMethod3 = _interopRequireDefault(_bindConnectorMethod2);
	
	var _disposables = __webpack_require__(73);
	
	function bindConnector(connector, handlerId) {
	  var compositeDisposable = new _disposables.CompositeDisposable();
	  var handlerConnector = {};
	
	  Object.keys(connector).forEach(function (key) {
	    var _bindConnectorMethod = _bindConnectorMethod3['default'](handlerId, connector[key]);
	
	    var disposable = _bindConnectorMethod.disposable;
	    var ref = _bindConnectorMethod.ref;
	
	    compositeDisposable.add(disposable);
	    handlerConnector[key] = function () {
	      return ref;
	    };
	  });
	
	  return {
	    disposable: compositeDisposable,
	    handlerConnector: handlerConnector
	  };
	}
	
	module.exports = exports['default'];

/***/ },
/* 240 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = bindConnectorMethod;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _utilsShallowEqual = __webpack_require__(29);
	
	var _utilsShallowEqual2 = _interopRequireDefault(_utilsShallowEqual);
	
	var _utilsCloneWithRef = __webpack_require__(250);
	
	var _utilsCloneWithRef2 = _interopRequireDefault(_utilsCloneWithRef);
	
	var _disposables = __webpack_require__(73);
	
	var _react = __webpack_require__(1);
	
	function bindConnectorMethod(handlerId, connect) {
	  var disposable = new _disposables.SerialDisposable();
	
	  var currentNode = null;
	  var currentOptions = null;
	
	  function ref(nextWhatever, nextOptions) {
	    // If passed a ReactElement, clone it and attach this function as a ref.
	    // This helps us achieve a neat API where user doesn't even know that refs
	    // are being used under the hood.
	    if (_react.isValidElement(nextWhatever)) {
	      var nextElement = nextWhatever;
	      return _utilsCloneWithRef2['default'](nextElement, function (inst) {
	        return ref(inst, nextOptions);
	      });
	    }
	
	    // At this point we can only receive components or DOM nodes.
	    var nextNode = _react.findDOMNode(nextWhatever);
	
	    // If nothing changed, bail out of re-connecting the node to the backend.
	    if (nextNode === currentNode && _utilsShallowEqual2['default'](currentOptions, nextOptions)) {
	      return;
	    }
	
	    currentNode = nextNode;
	    currentOptions = nextOptions;
	
	    if (!nextNode) {
	      disposable.setDisposable(null);
	      return;
	    }
	
	    // Re-connect the node to the backend.
	    var currentDispose = connect(handlerId, nextNode, nextOptions);
	    disposable.setDisposable(new _disposables.Disposable(currentDispose));
	  }
	
	  return {
	    ref: ref,
	    disposable: disposable
	  };
	}
	
	module.exports = exports['default'];

/***/ },
/* 241 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = createSourceConnector;
	
	function createSourceConnector(backend) {
	  return {
	    dragSource: backend.connectDragSource.bind(backend),
	    dragPreview: backend.connectDragPreview.bind(backend)
	  };
	}
	
	module.exports = exports["default"];

/***/ },
/* 242 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = createSourceFactory;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _invariant = __webpack_require__(9);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _lodashLangIsPlainObject = __webpack_require__(31);
	
	var _lodashLangIsPlainObject2 = _interopRequireDefault(_lodashLangIsPlainObject);
	
	var ALLOWED_SPEC_METHODS = ['canDrag', 'beginDrag', 'canDrag', 'isDragging', 'endDrag'];
	var REQUIRED_SPEC_METHODS = ['beginDrag'];
	
	function createSourceFactory(spec) {
	  Object.keys(spec).forEach(function (key) {
	    _invariant2['default'](ALLOWED_SPEC_METHODS.indexOf(key) > -1, 'Expected the drag source specification to only have ' + 'some of the following keys: %s. ' + 'Instead received a specification with an unexpected "%s" key. ' + 'Read more: http://pljenkins.github.io/react-dnd/docs-drag-source.html', ALLOWED_SPEC_METHODS.join(', '), key);
	    _invariant2['default'](typeof spec[key] === 'function', 'Expected %s in the drag source specification to be a function. ' + 'Instead received a specification with %s: %s. ' + 'Read more: http://pljenkins.github.io/react-dnd/docs-drag-source.html', key, key, spec[key]);
	  });
	  REQUIRED_SPEC_METHODS.forEach(function (key) {
	    _invariant2['default'](typeof spec[key] === 'function', 'Expected %s in the drag source specification to be a function. ' + 'Instead received a specification with %s: %s. ' + 'Read more: http://pljenkins.github.io/react-dnd/docs-drag-source.html', key, key, spec[key]);
	  });
	
	  var Source = (function () {
	    function Source(monitor) {
	      _classCallCheck(this, Source);
	
	      this.monitor = monitor;
	      this.props = null;
	      this.component = null;
	    }
	
	    Source.prototype.receiveProps = function receiveProps(props) {
	      this.props = props;
	    };
	
	    Source.prototype.receiveComponent = function receiveComponent(component) {
	      this.component = component;
	    };
	
	    Source.prototype.canDrag = function canDrag() {
	      if (!spec.canDrag) {
	        return true;
	      }
	
	      return spec.canDrag(this.props, this.monitor);
	    };
	
	    Source.prototype.isDragging = function isDragging(globalMonitor, sourceId) {
	      if (!spec.isDragging) {
	        return sourceId === globalMonitor.getSourceId();
	      }
	
	      return spec.isDragging(this.props, this.monitor);
	    };
	
	    Source.prototype.beginDrag = function beginDrag() {
	      var item = spec.beginDrag(this.props, this.monitor, this.component);
	      if (false) {
	        _invariant2['default'](_lodashLangIsPlainObject2['default'](item), 'beginDrag() must return a plain object that represents the dragged item. ' + 'Instead received %s. ' + 'Read more: http://pljenkins.github.io/react-dnd/docs-drag-source.html', item);
	      }
	      return item;
	    };
	
	    Source.prototype.endDrag = function endDrag() {
	      if (!spec.endDrag) {
	        return;
	      }
	
	      spec.endDrag(this.props, this.monitor, this.component);
	    };
	
	    return Source;
	  })();
	
	  return function createSource(monitor) {
	    return new Source(monitor);
	  };
	}
	
	module.exports = exports['default'];

/***/ },
/* 243 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = createSourceMonitor;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _invariant = __webpack_require__(9);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var isCallingCanDrag = false;
	var isCallingIsDragging = false;
	
	var SourceMonitor = (function () {
	  function SourceMonitor(manager) {
	    _classCallCheck(this, SourceMonitor);
	
	    this.internalMonitor = manager.getMonitor();
	  }
	
	  SourceMonitor.prototype.receiveHandlerId = function receiveHandlerId(sourceId) {
	    this.sourceId = sourceId;
	  };
	
	  SourceMonitor.prototype.canDrag = function canDrag() {
	    _invariant2['default'](!isCallingCanDrag, 'You may not call monitor.canDrag() inside your canDrag() implementation. ' + 'Read more: http://pljenkins.github.io/react-dnd/docs-drag-source-monitor.html');
	
	    try {
	      isCallingCanDrag = true;
	      return this.internalMonitor.canDragSource(this.sourceId);
	    } finally {
	      isCallingCanDrag = false;
	    }
	  };
	
	  SourceMonitor.prototype.isDragging = function isDragging() {
	    _invariant2['default'](!isCallingIsDragging, 'You may not call monitor.isDragging() inside your isDragging() implementation. ' + 'Read more: http://pljenkins.github.io/react-dnd/docs-drag-source-monitor.html');
	
	    try {
	      isCallingIsDragging = true;
	      return this.internalMonitor.isDraggingSource(this.sourceId);
	    } finally {
	      isCallingIsDragging = false;
	    }
	  };
	
	  SourceMonitor.prototype.getItemType = function getItemType() {
	    return this.internalMonitor.getItemType();
	  };
	
	  SourceMonitor.prototype.getItem = function getItem() {
	    return this.internalMonitor.getItem();
	  };
	
	  SourceMonitor.prototype.getDropResult = function getDropResult() {
	    return this.internalMonitor.getDropResult();
	  };
	
	  SourceMonitor.prototype.didDrop = function didDrop() {
	    return this.internalMonitor.didDrop();
	  };
	
	  SourceMonitor.prototype.getInitialClientOffset = function getInitialClientOffset() {
	    return this.internalMonitor.getInitialClientOffset();
	  };
	
	  SourceMonitor.prototype.getInitialSourceClientOffset = function getInitialSourceClientOffset() {
	    return this.internalMonitor.getInitialSourceClientOffset();
	  };
	
	  SourceMonitor.prototype.getSourceClientOffset = function getSourceClientOffset() {
	    return this.internalMonitor.getSourceClientOffset();
	  };
	
	  SourceMonitor.prototype.getClientOffset = function getClientOffset() {
	    return this.internalMonitor.getClientOffset();
	  };
	
	  SourceMonitor.prototype.getDifferenceFromInitialOffset = function getDifferenceFromInitialOffset() {
	    return this.internalMonitor.getDifferenceFromInitialOffset();
	  };
	
	  return SourceMonitor;
	})();
	
	function createSourceMonitor(manager) {
	  return new SourceMonitor(manager);
	}
	
	module.exports = exports['default'];

/***/ },
/* 244 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = createTargetConnector;
	
	function createTargetConnector(backend) {
	  return {
	    dropTarget: backend.connectDropTarget.bind(backend)
	  };
	}
	
	module.exports = exports["default"];

/***/ },
/* 245 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = createTargetFactory;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _invariant = __webpack_require__(9);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _lodashLangIsPlainObject = __webpack_require__(31);
	
	var _lodashLangIsPlainObject2 = _interopRequireDefault(_lodashLangIsPlainObject);
	
	var ALLOWED_SPEC_METHODS = ['canDrop', 'hover', 'drop'];
	
	function createTargetFactory(spec) {
	  Object.keys(spec).forEach(function (key) {
	    _invariant2['default'](ALLOWED_SPEC_METHODS.indexOf(key) > -1, 'Expected the drop target specification to only have ' + 'some of the following keys: %s. ' + 'Instead received a specification with an unexpected "%s" key. ' + 'Read more: http://pljenkins.github.io/react-dnd/docs-drop-target.html', ALLOWED_SPEC_METHODS.join(', '), key);
	    _invariant2['default'](typeof spec[key] === 'function', 'Expected %s in the drop target specification to be a function. ' + 'Instead received a specification with %s: %s. ' + 'Read more: http://pljenkins.github.io/react-dnd/docs-drop-target.html', key, key, spec[key]);
	  });
	
	  var Target = (function () {
	    function Target(monitor) {
	      _classCallCheck(this, Target);
	
	      this.monitor = monitor;
	      this.props = null;
	      this.component = null;
	    }
	
	    Target.prototype.receiveProps = function receiveProps(props) {
	      this.props = props;
	    };
	
	    Target.prototype.receiveMonitor = function receiveMonitor(monitor) {
	      this.monitor = monitor;
	    };
	
	    Target.prototype.receiveComponent = function receiveComponent(component) {
	      this.component = component;
	    };
	
	    Target.prototype.canDrop = function canDrop() {
	      if (!spec.canDrop) {
	        return true;
	      }
	
	      return spec.canDrop(this.props, this.monitor);
	    };
	
	    Target.prototype.hover = function hover() {
	      if (!spec.hover) {
	        return;
	      }
	
	      spec.hover(this.props, this.monitor, this.component);
	    };
	
	    Target.prototype.drop = function drop() {
	      if (!spec.drop) {
	        return;
	      }
	
	      var dropResult = spec.drop(this.props, this.monitor, this.component);
	      if (false) {
	        _invariant2['default'](typeof dropResult === 'undefined' || _lodashLangIsPlainObject2['default'](dropResult), 'drop() must either return undefined, or an object that represents the drop result. ' + 'Instead received %s. ' + 'Read more: http://pljenkins.github.io/react-dnd/docs-drop-target.html', dropResult);
	      }
	      return dropResult;
	    };
	
	    return Target;
	  })();
	
	  return function createTarget(monitor) {
	    return new Target(monitor);
	  };
	}
	
	module.exports = exports['default'];

/***/ },
/* 246 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = createTargetMonitor;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _invariant = __webpack_require__(9);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var isCallingCanDrop = false;
	
	var TargetMonitor = (function () {
	  function TargetMonitor(manager) {
	    _classCallCheck(this, TargetMonitor);
	
	    this.internalMonitor = manager.getMonitor();
	  }
	
	  TargetMonitor.prototype.receiveHandlerId = function receiveHandlerId(targetId) {
	    this.targetId = targetId;
	  };
	
	  TargetMonitor.prototype.canDrop = function canDrop() {
	    _invariant2['default'](!isCallingCanDrop, 'You may not call monitor.canDrop() inside your canDrop() implementation. ' + 'Read more: http://pljenkins.github.io/react-dnd/docs-drop-target-monitor.html');
	
	    try {
	      isCallingCanDrop = true;
	      return this.internalMonitor.canDropOnTarget(this.targetId);
	    } finally {
	      isCallingCanDrop = false;
	    }
	  };
	
	  TargetMonitor.prototype.isOver = function isOver(options) {
	    return this.internalMonitor.isOverTarget(this.targetId, options);
	  };
	
	  TargetMonitor.prototype.getItemType = function getItemType() {
	    return this.internalMonitor.getItemType();
	  };
	
	  TargetMonitor.prototype.getItem = function getItem() {
	    return this.internalMonitor.getItem();
	  };
	
	  TargetMonitor.prototype.getDropResult = function getDropResult() {
	    return this.internalMonitor.getDropResult();
	  };
	
	  TargetMonitor.prototype.didDrop = function didDrop() {
	    return this.internalMonitor.didDrop();
	  };
	
	  TargetMonitor.prototype.getInitialClientOffset = function getInitialClientOffset() {
	    return this.internalMonitor.getInitialClientOffset();
	  };
	
	  TargetMonitor.prototype.getInitialSourceClientOffset = function getInitialSourceClientOffset() {
	    return this.internalMonitor.getInitialSourceClientOffset();
	  };
	
	  TargetMonitor.prototype.getSourceClientOffset = function getSourceClientOffset() {
	    return this.internalMonitor.getSourceClientOffset();
	  };
	
	  TargetMonitor.prototype.getClientOffset = function getClientOffset() {
	    return this.internalMonitor.getClientOffset();
	  };
	
	  TargetMonitor.prototype.getDifferenceFromInitialOffset = function getDifferenceFromInitialOffset() {
	    return this.internalMonitor.getDifferenceFromInitialOffset();
	  };
	
	  return TargetMonitor;
	})();
	
	function createTargetMonitor(manager) {
	  return new TargetMonitor(manager);
	}
	
	module.exports = exports['default'];

/***/ },
/* 247 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = registerSource;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _invariant = __webpack_require__(9);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function registerSource(type, source, manager) {
	  var registry = manager.getRegistry();
	  var sourceId = registry.addSource(type, source);
	
	  function unregisterSource() {
	    registry.removeSource(sourceId);
	  };
	
	  return {
	    handlerId: sourceId,
	    unregister: unregisterSource
	  };
	}
	
	module.exports = exports['default'];

/***/ },
/* 248 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = registerTarget;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _invariant = __webpack_require__(9);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function registerTarget(type, target, manager) {
	  var registry = manager.getRegistry();
	  var targetId = registry.addTarget(type, target);
	
	  function unregisterTarget() {
	    registry.removeTarget(targetId);
	  };
	
	  return {
	    handlerId: targetId,
	    unregister: unregisterTarget
	  };
	}
	
	module.exports = exports['default'];

/***/ },
/* 249 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _lodashArrayUnion = __webpack_require__(347);
	
	var _lodashArrayUnion2 = _interopRequireDefault(_lodashArrayUnion);
	
	var _lodashArrayWithout = __webpack_require__(122);
	
	var _lodashArrayWithout2 = _interopRequireDefault(_lodashArrayWithout);
	
	var EnterLeaveCounter = (function () {
	  function EnterLeaveCounter() {
	    _classCallCheck(this, EnterLeaveCounter);
	
	    this.entered = [];
	  }
	
	  EnterLeaveCounter.prototype.enter = function enter(enteringNode) {
	    var previousLength = this.entered.length;
	
	    this.entered = _lodashArrayUnion2['default'](this.entered.filter(function (node) {
	      return document.documentElement.contains(node) && (!node.contains || node.contains(enteringNode));
	    }), [enteringNode]);
	
	    return previousLength === 0 && this.entered.length > 0;
	  };
	
	  EnterLeaveCounter.prototype.leave = function leave(leavingNode) {
	    var previousLength = this.entered.length;
	
	    this.entered = _lodashArrayWithout2['default'](this.entered.filter(function (node) {
	      return document.documentElement.contains(node);
	    }), leavingNode);
	
	    return previousLength > 0 && this.entered.length === 0;
	  };
	
	  EnterLeaveCounter.prototype.reset = function reset() {
	    this.entered = [];
	  };
	
	  return EnterLeaveCounter;
	})();
	
	exports['default'] = EnterLeaveCounter;
	module.exports = exports['default'];

/***/ },
/* 250 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = cloneWithRef;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _invariant = __webpack_require__(9);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	function cloneWithRef(element, newRef) {
	  var previousRef = element.ref;
	  _invariant2['default'](typeof previousRef !== 'string', 'Cannot connect React DnD to an element with an existing string ref. ' + 'Please convert it to use a callback ref instead, or wrap it into a <span> or <div>. ' + 'Read more: https://facebook.github.io/react/docs/more-about-refs.html#the-ref-callback-attribute');
	
	  return _react.cloneElement(element, {
	    ref: function ref(instance) {
	      newRef(instance);
	
	      if (previousRef) {
	        previousRef(instance);
	      }
	    }
	  });
	}
	
	module.exports = exports['default'];

/***/ },
/* 251 */
/***/ function(module, exports) {

	/**
	 * I took this straight from Wikipedia, it must be good!
	 */
	"use strict";
	
	exports.__esModule = true;
	exports["default"] = createMonotonicInterpolant;
	
	function createMonotonicInterpolant(xs, ys) {
	  var length = xs.length;
	
	  // Rearrange xs and ys so that xs is sorted
	  var indexes = [];
	  for (var i = 0; i < length; i++) {
	    indexes.push(i);
	  }
	  indexes.sort(function (a, b) {
	    return xs[a] < xs[b] ? -1 : 1;
	  });
	
	  var oldXs = xs,
	      oldYs = ys;
	  // Impl: Creating new arrays also prevents problems if the input arrays are mutated later
	  xs = [];
	  ys = [];
	  // Impl: Unary plus properly converts values to numbers
	  for (var i = 0; i < length; i++) {
	    xs.push(+oldXs[indexes[i]]);
	    ys.push(+oldYs[indexes[i]]);
	  }
	
	  // Get consecutive differences and slopes
	  var dys = [];
	  var dxs = [];
	  var ms = [];
	  var dx = undefined,
	      dy = undefined;
	  for (var i = 0; i < length - 1; i++) {
	    dx = xs[i + 1] - xs[i];
	    dy = ys[i + 1] - ys[i];
	    dxs.push(dx);
	    dys.push(dy);
	    ms.push(dy / dx);
	  }
	
	  // Get degree-1 coefficients
	  var c1s = [ms[0]];
	  for (var i = 0; i < dxs.length - 1; i++) {
	    var _m = ms[i];
	    var mNext = ms[i + 1];
	    if (_m * mNext <= 0) {
	      c1s.push(0);
	    } else {
	      dx = dxs[i];
	      var dxNext = dxs[i + 1];
	      var common = dx + dxNext;
	      c1s.push(3 * common / ((common + dxNext) / _m + (common + dx) / mNext));
	    }
	  }
	  c1s.push(ms[ms.length - 1]);
	
	  // Get degree-2 and degree-3 coefficients
	  var c2s = [];
	  var c3s = [];
	  var m = undefined;
	  for (var i = 0; i < c1s.length - 1; i++) {
	    m = ms[i];
	    var c1 = c1s[i];
	    var invDx = 1 / dxs[i];
	    var common = c1 + c1s[i + 1] - m - m;
	    c2s.push((m - c1 - common) * invDx);
	    c3s.push(common * invDx * invDx);
	  }
	
	  // Return interpolant function
	  return function (x) {
	    // The rightmost point in the dataset should give an exact result
	    var i = xs.length - 1;
	    if (x === xs[i]) {
	      return ys[i];
	    }
	
	    // Search for the interval x is in, returning the corresponding y if x is one of the original xs
	    var low = 0;
	    var high = c3s.length - 1;
	    var mid = undefined;
	    while (low <= high) {
	      mid = Math.floor(0.5 * (low + high));
	      var xHere = xs[mid];
	      if (xHere < x) {
	        low = mid + 1;
	      } else if (xHere > x) {
	        high = mid - 1;
	      } else {
	        return ys[mid];
	      }
	    }
	    i = Math.max(0, high);
	
	    // Interpolate
	    var diff = x - xs[i],
	        diffSq = diff * diff;
	    return ys[i] + c1s[i] * diff + c2s[i] * diffSq + c3s[i] * diff * diffSq;
	  };
	}
	
	module.exports = exports["default"];

/***/ },
/* 252 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireWildcard = function (obj) { return obj && obj.__esModule ? obj : { 'default': obj }; };
	
	var _classCallCheck = function (instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } };
	
	exports.__esModule = true;
	
	var _isDisposable = __webpack_require__(74);
	
	var _isDisposable2 = _interopRequireWildcard(_isDisposable);
	
	/**
	 * Represents a group of disposable resources that are disposed together.
	 */
	
	var CompositeDisposable = (function () {
	  function CompositeDisposable() {
	    for (var _len = arguments.length, disposables = Array(_len), _key = 0; _key < _len; _key++) {
	      disposables[_key] = arguments[_key];
	    }
	
	    _classCallCheck(this, CompositeDisposable);
	
	    if (Array.isArray(disposables[0]) && disposables.length === 1) {
	      disposables = disposables[0];
	    }
	
	    for (var i = 0; i < disposables.length; i++) {
	      if (!_isDisposable2['default'](disposables[i])) {
	        throw new Error('Expected a disposable');
	      }
	    }
	
	    this.disposables = disposables;
	    this.isDisposed = false;
	  }
	
	  /**
	   * Adds a disposable to the CompositeDisposable or disposes the disposable if the CompositeDisposable is disposed.
	   * @param {Disposable} item Disposable to add.
	   */
	
	  CompositeDisposable.prototype.add = function add(item) {
	    if (this.isDisposed) {
	      item.dispose();
	    } else {
	      this.disposables.push(item);
	    }
	  };
	
	  /**
	   * Removes and disposes the first occurrence of a disposable from the CompositeDisposable.
	   * @param {Disposable} item Disposable to remove.
	   * @returns {Boolean} true if found; false otherwise.
	   */
	
	  CompositeDisposable.prototype.remove = function remove(item) {
	    if (this.isDisposed) {
	      return false;
	    }
	
	    var index = this.disposables.indexOf(item);
	    if (index === -1) {
	      return false;
	    }
	
	    this.disposables.splice(index, 1);
	    item.dispose();
	    return true;
	  };
	
	  /**
	   * Disposes all disposables in the group and removes them from the group.
	   */
	
	  CompositeDisposable.prototype.dispose = function dispose() {
	    if (this.isDisposed) {
	      return;
	    }
	
	    var len = this.disposables.length;
	    var currentDisposables = new Array(len);
	    for (var i = 0; i < len; i++) {
	      currentDisposables[i] = this.disposables[i];
	    }
	
	    this.isDisposed = true;
	    this.disposables = [];
	    this.length = 0;
	
	    for (var i = 0; i < len; i++) {
	      currentDisposables[i].dispose();
	    }
	  };
	
	  return CompositeDisposable;
	})();
	
	exports['default'] = CompositeDisposable;
	module.exports = exports['default'];

/***/ },
/* 253 */
/***/ function(module, exports) {

	"use strict";
	
	var _classCallCheck = function (instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	exports.__esModule = true;
	var noop = function noop() {};
	
	/**
	 * The basic disposable.
	 */
	
	var Disposable = (function () {
	  function Disposable(action) {
	    _classCallCheck(this, Disposable);
	
	    this.isDisposed = false;
	    this.action = action || noop;
	  }
	
	  Disposable.prototype.dispose = function dispose() {
	    if (!this.isDisposed) {
	      this.action.call(null);
	      this.isDisposed = true;
	    }
	  };
	
	  _createClass(Disposable, null, [{
	    key: "empty",
	    enumerable: true,
	    value: { dispose: noop }
	  }]);
	
	  return Disposable;
	})();
	
	exports["default"] = Disposable;
	module.exports = exports["default"];

/***/ },
/* 254 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireWildcard = function (obj) { return obj && obj.__esModule ? obj : { 'default': obj }; };
	
	var _classCallCheck = function (instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } };
	
	exports.__esModule = true;
	
	var _isDisposable = __webpack_require__(74);
	
	var _isDisposable2 = _interopRequireWildcard(_isDisposable);
	
	var SerialDisposable = (function () {
	  function SerialDisposable() {
	    _classCallCheck(this, SerialDisposable);
	
	    this.isDisposed = false;
	    this.current = null;
	  }
	
	  /**
	   * Gets the underlying disposable.
	   * @return The underlying disposable.
	   */
	
	  SerialDisposable.prototype.getDisposable = function getDisposable() {
	    return this.current;
	  };
	
	  /**
	   * Sets the underlying disposable.
	   * @param {Disposable} value The new underlying disposable.
	   */
	
	  SerialDisposable.prototype.setDisposable = function setDisposable() {
	    var value = arguments[0] === undefined ? null : arguments[0];
	
	    if (value != null && !_isDisposable2['default'](value)) {
	      throw new Error('Expected either an empty value or a valid disposable');
	    }
	
	    var isDisposed = this.isDisposed;
	    var previous = undefined;
	
	    if (!isDisposed) {
	      previous = this.current;
	      this.current = value;
	    }
	
	    if (previous) {
	      previous.dispose();
	    }
	
	    if (isDisposed && value) {
	      value.dispose();
	    }
	  };
	
	  /**
	   * Disposes the underlying disposable as well as all future replacements.
	   */
	
	  SerialDisposable.prototype.dispose = function dispose() {
	    if (this.isDisposed) {
	      return;
	    }
	
	    this.isDisposed = true;
	    var previous = this.current;
	    this.current = null;
	
	    if (previous) {
	      previous.dispose();
	    }
	  };
	
	  return SerialDisposable;
	})();
	
	exports['default'] = SerialDisposable;
	module.exports = exports['default'];

/***/ },
/* 255 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireWildcard = function (obj) { return obj && obj.__esModule ? obj : { 'default': obj }; };
	
	var _classCallCheck = function (instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } };
	
	exports.__esModule = true;
	
	var _Flux = __webpack_require__(259);
	
	var _Flux2 = _interopRequireWildcard(_Flux);
	
	var _DragDropMonitor = __webpack_require__(256);
	
	var _DragDropMonitor2 = _interopRequireWildcard(_DragDropMonitor);
	
	var _HandlerRegistry = __webpack_require__(266);
	
	var _HandlerRegistry2 = _interopRequireWildcard(_HandlerRegistry);
	
	var DragDropManager = (function () {
	  function DragDropManager(createBackend) {
	    _classCallCheck(this, DragDropManager);
	
	    var flux = new _Flux2['default'](this);
	
	    this.flux = flux;
	    this.registry = new _HandlerRegistry2['default'](flux.registryActions);
	    this.monitor = new _DragDropMonitor2['default'](flux, this.registry);
	    this.backend = createBackend(this);
	
	    flux.refCountStore.addListener('change', this.handleRefCountChange, this);
	  }
	
	  DragDropManager.prototype.handleRefCountChange = function handleRefCountChange() {
	    var shouldSetUp = this.flux.refCountStore.hasRefs();
	    if (shouldSetUp && !this.isSetUp) {
	      this.backend.setup();
	      this.isSetUp = true;
	    } else if (!shouldSetUp && this.isSetUp) {
	      this.backend.teardown();
	      this.isSetUp = false;
	    }
	  };
	
	  DragDropManager.prototype.getMonitor = function getMonitor() {
	    return this.monitor;
	  };
	
	  DragDropManager.prototype.getBackend = function getBackend() {
	    return this.backend;
	  };
	
	  DragDropManager.prototype.getRegistry = function getRegistry() {
	    return this.registry;
	  };
	
	  DragDropManager.prototype.getActions = function getActions() {
	    return this.flux.dragDropActions;
	  };
	
	  return DragDropManager;
	})();
	
	exports['default'] = DragDropManager;
	module.exports = exports['default'];

/***/ },
/* 256 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireWildcard = function (obj) { return obj && obj.__esModule ? obj : { 'default': obj }; };
	
	var _classCallCheck = function (instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } };
	
	exports.__esModule = true;
	
	var _invariant = __webpack_require__(9);
	
	var _invariant2 = _interopRequireWildcard(_invariant);
	
	var _matchesType = __webpack_require__(120);
	
	var _matchesType2 = _interopRequireWildcard(_matchesType);
	
	var _isArray = __webpack_require__(23);
	
	var _isArray2 = _interopRequireWildcard(_isArray);
	
	var DragDropMonitor = (function () {
	  function DragDropMonitor(flux, registry) {
	    _classCallCheck(this, DragDropMonitor);
	
	    this.dragOperationStore = flux.dragOperationStore;
	    this.dragOffsetStore = flux.dragOffsetStore;
	    this.registry = registry;
	  }
	
	  DragDropMonitor.prototype.subscribeToStateChange = function subscribeToStateChange(listener) {
	    var _ref = arguments[1] === undefined ? {} : arguments[1];
	
	    var _ref$handlerIds = _ref.handlerIds;
	    var handlerIds = _ref$handlerIds === undefined ? null : _ref$handlerIds;
	
	    _invariant2['default'](typeof listener === 'function', 'listener must be a function.');
	
	    var dragOperationStore = this.dragOperationStore;
	
	    var handleChange = listener;
	    if (handlerIds) {
	      _invariant2['default'](_isArray2['default'](handlerIds), 'handlerIds, when specified, must be an array of strings.');
	      handleChange = function () {
	        if (dragOperationStore.areDirty(handlerIds)) {
	          listener();
	        }
	      };
	    }
	
	    dragOperationStore.addListener('change', handleChange);
	
	    return function dispose() {
	      dragOperationStore.removeListener('change', handleChange);
	    };
	  };
	
	  DragDropMonitor.prototype.subscribeToOffsetChange = function subscribeToOffsetChange(listener) {
	    _invariant2['default'](typeof listener === 'function', 'listener must be a function.');
	
	    var dragOffsetStore = this.dragOffsetStore;
	
	    dragOffsetStore.addListener('change', listener);
	
	    return function dispose() {
	      dragOffsetStore.removeListener('change', listener);
	    };
	  };
	
	  DragDropMonitor.prototype.canDragSource = function canDragSource(sourceId) {
	    var source = this.registry.getSource(sourceId);
	    _invariant2['default'](source, 'Expected to find a valid source.');
	
	    if (this.isDragging()) {
	      return false;
	    }
	
	    return source.canDrag(this, sourceId);
	  };
	
	  DragDropMonitor.prototype.canDropOnTarget = function canDropOnTarget(targetId) {
	    var target = this.registry.getTarget(targetId);
	    _invariant2['default'](target, 'Expected to find a valid target.');
	
	    if (!this.isDragging() || this.didDrop()) {
	      return false;
	    }
	
	    var targetType = this.registry.getTargetType(targetId);
	    var draggedItemType = this.getItemType();
	    return _matchesType2['default'](targetType, draggedItemType) && target.canDrop(this, targetId);
	  };
	
	  DragDropMonitor.prototype.isDragging = function isDragging() {
	    return this.dragOperationStore.isDragging();
	  };
	
	  DragDropMonitor.prototype.isDraggingSource = function isDraggingSource(sourceId) {
	    var source = this.registry.getSource(sourceId, true);
	    _invariant2['default'](source, 'Expected to find a valid source.');
	
	    if (!this.isDragging() || !this.isSourcePublic()) {
	      return false;
	    }
	
	    var sourceType = this.registry.getSourceType(sourceId);
	    var draggedItemType = this.getItemType();
	    if (sourceType !== draggedItemType) {
	      return false;
	    }
	
	    return source.isDragging(this, sourceId);
	  };
	
	  DragDropMonitor.prototype.isOverTarget = function isOverTarget(targetId) {
	    var _ref2 = arguments[1] === undefined ? {} : arguments[1];
	
	    var _ref2$shallow = _ref2.shallow;
	    var shallow = _ref2$shallow === undefined ? false : _ref2$shallow;
	
	    if (!this.isDragging()) {
	      return false;
	    }
	
	    var targetType = this.registry.getTargetType(targetId);
	    var draggedItemType = this.getItemType();
	    if (!_matchesType2['default'](targetType, draggedItemType)) {
	      return false;
	    }
	
	    var targetIds = this.getTargetIds();
	    if (!targetIds.length) {
	      return false;
	    }
	
	    var index = targetIds.indexOf(targetId);
	    if (shallow) {
	      return index === targetIds.length - 1;
	    } else {
	      return index > -1;
	    }
	  };
	
	  DragDropMonitor.prototype.getItemType = function getItemType() {
	    return this.dragOperationStore.getItemType();
	  };
	
	  DragDropMonitor.prototype.getItem = function getItem() {
	    return this.dragOperationStore.getItem();
	  };
	
	  DragDropMonitor.prototype.getSourceId = function getSourceId() {
	    return this.dragOperationStore.getSourceId();
	  };
	
	  DragDropMonitor.prototype.getTargetIds = function getTargetIds() {
	    return this.dragOperationStore.getTargetIds();
	  };
	
	  DragDropMonitor.prototype.getDropResult = function getDropResult() {
	    return this.dragOperationStore.getDropResult();
	  };
	
	  DragDropMonitor.prototype.didDrop = function didDrop() {
	    return this.dragOperationStore.didDrop();
	  };
	
	  DragDropMonitor.prototype.isSourcePublic = function isSourcePublic() {
	    return this.dragOperationStore.isSourcePublic();
	  };
	
	  DragDropMonitor.prototype.getInitialClientOffset = function getInitialClientOffset() {
	    return this.dragOffsetStore.getInitialClientOffset();
	  };
	
	  DragDropMonitor.prototype.getInitialSourceClientOffset = function getInitialSourceClientOffset() {
	    return this.dragOffsetStore.getInitialSourceClientOffset();
	  };
	
	  DragDropMonitor.prototype.getSourceClientOffset = function getSourceClientOffset() {
	    return this.dragOffsetStore.getSourceClientOffset();
	  };
	
	  DragDropMonitor.prototype.getClientOffset = function getClientOffset() {
	    return this.dragOffsetStore.getClientOffset();
	  };
	
	  DragDropMonitor.prototype.getDifferenceFromInitialOffset = function getDifferenceFromInitialOffset() {
	    return this.dragOffsetStore.getDifferenceFromInitialOffset();
	  };
	
	  return DragDropMonitor;
	})();
	
	exports['default'] = DragDropMonitor;
	module.exports = exports['default'];

/***/ },
/* 257 */
/***/ function(module, exports) {

	"use strict";
	
	var _classCallCheck = function (instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } };
	
	exports.__esModule = true;
	
	var DragSource = (function () {
	  function DragSource() {
	    _classCallCheck(this, DragSource);
	  }
	
	  DragSource.prototype.canDrag = function canDrag() {
	    return true;
	  };
	
	  DragSource.prototype.isDragging = function isDragging(monitor, handle) {
	    return handle === monitor.getSourceId();
	  };
	
	  DragSource.prototype.endDrag = function endDrag() {};
	
	  return DragSource;
	})();
	
	exports["default"] = DragSource;
	module.exports = exports["default"];

/***/ },
/* 258 */
/***/ function(module, exports) {

	"use strict";
	
	var _classCallCheck = function (instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } };
	
	exports.__esModule = true;
	
	var DropTarget = (function () {
	  function DropTarget() {
	    _classCallCheck(this, DropTarget);
	  }
	
	  DropTarget.prototype.canDrop = function canDrop() {
	    return true;
	  };
	
	  DropTarget.prototype.hover = function hover() {};
	
	  DropTarget.prototype.drop = function drop() {};
	
	  return DropTarget;
	})();
	
	exports["default"] = DropTarget;
	module.exports = exports["default"];

/***/ },
/* 259 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireWildcard = function (obj) { return obj && obj.__esModule ? obj : { 'default': obj }; };
	
	var _classCallCheck = function (instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } };
	
	var _inherits = function (subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) subClass.__proto__ = superClass; };
	
	exports.__esModule = true;
	
	var _Flummox2 = __webpack_require__(30);
	
	var _DragDropActions = __webpack_require__(260);
	
	var _DragDropActions2 = _interopRequireWildcard(_DragDropActions);
	
	var _RegistryActions = __webpack_require__(261);
	
	var _RegistryActions2 = _interopRequireWildcard(_RegistryActions);
	
	var _DragOperationStore = __webpack_require__(264);
	
	var _DragOperationStore2 = _interopRequireWildcard(_DragOperationStore);
	
	var _DragOffsetStore = __webpack_require__(263);
	
	var _DragOffsetStore2 = _interopRequireWildcard(_DragOffsetStore);
	
	var _RefCountStore = __webpack_require__(265);
	
	var _RefCountStore2 = _interopRequireWildcard(_RefCountStore);
	
	var Flux = (function (_Flummox) {
	  function Flux(manager) {
	    _classCallCheck(this, Flux);
	
	    _Flummox.call(this);
	
	    this.dragDropActions = this.createActions('dragDropActions', _DragDropActions2['default'], manager);
	    this.dragDropActionIds = this.getActionIds('dragDropActions');
	
	    this.registryActions = this.createActions('registryActions', _RegistryActions2['default']);
	    this.registryActionIds = this.getActionIds('registryActions');
	
	    this.dragOperationStore = this.createStore('dragOperationStore', _DragOperationStore2['default'], this);
	
	    this.dragOffsetStore = this.createStore('dragOffsetStore', _DragOffsetStore2['default'], this);
	
	    this.refCountStore = this.createStore('refCountStore', _RefCountStore2['default'], this);
	  }
	
	  _inherits(Flux, _Flummox);
	
	  return Flux;
	})(_Flummox2.Flummox);
	
	exports['default'] = Flux;
	module.exports = exports['default'];

/***/ },
/* 260 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireWildcard = function (obj) { return obj && obj.__esModule ? obj : { 'default': obj }; };
	
	var _classCallCheck = function (instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } };
	
	var _inherits = function (subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) subClass.__proto__ = superClass; };
	
	exports.__esModule = true;
	
	var _Actions2 = __webpack_require__(30);
	
	var _matchesType = __webpack_require__(120);
	
	var _matchesType2 = _interopRequireWildcard(_matchesType);
	
	var _invariant = __webpack_require__(9);
	
	var _invariant2 = _interopRequireWildcard(_invariant);
	
	var _isArray = __webpack_require__(23);
	
	var _isArray2 = _interopRequireWildcard(_isArray);
	
	var _isObject = __webpack_require__(15);
	
	var _isObject2 = _interopRequireWildcard(_isObject);
	
	var DragDropActions = (function (_Actions) {
	  function DragDropActions(manager) {
	    _classCallCheck(this, DragDropActions);
	
	    _Actions.call(this);
	    this.manager = manager;
	  }
	
	  _inherits(DragDropActions, _Actions);
	
	  DragDropActions.prototype.beginDrag = function beginDrag(sourceIds) {
	    var _ref = arguments[1] === undefined ? {} : arguments[1];
	
	    var _ref$publishSource = _ref.publishSource;
	    var publishSource = _ref$publishSource === undefined ? true : _ref$publishSource;
	    var _ref$clientOffset = _ref.clientOffset;
	    var clientOffset = _ref$clientOffset === undefined ? null : _ref$clientOffset;
	    var getSourceClientOffset = _ref.getSourceClientOffset;
	
	    _invariant2['default'](_isArray2['default'](sourceIds), 'Expected sourceIds to be an array.');
	
	    var monitor = this.manager.getMonitor();
	    var registry = this.manager.getRegistry();
	    _invariant2['default'](!monitor.isDragging(), 'Cannot call beginDrag while dragging.');
	
	    for (var i = 0; i < sourceIds.length; i++) {
	      _invariant2['default'](registry.getSource(sourceIds[i]), 'Expected sourceIds to be registered.');
	    }
	
	    var sourceId = null;
	    for (var i = sourceIds.length - 1; i >= 0; i--) {
	      if (monitor.canDragSource(sourceIds[i])) {
	        sourceId = sourceIds[i];
	        break;
	      }
	    }
	    if (sourceId === null) {
	      return;
	    }
	
	    var sourceClientOffset = null;
	    if (clientOffset) {
	      _invariant2['default'](typeof getSourceClientOffset === 'function', 'When clientOffset is provided, getSourceClientOffset must be a function.');
	      sourceClientOffset = getSourceClientOffset(sourceId);
	    }
	
	    var source = registry.getSource(sourceId);
	    var item = source.beginDrag(monitor, sourceId);
	    _invariant2['default'](_isObject2['default'](item), 'Item must be an object.');
	
	    registry.pinSource(sourceId);
	
	    var itemType = registry.getSourceType(sourceId);
	    return {
	      itemType: itemType,
	      item: item,
	      sourceId: sourceId,
	      clientOffset: clientOffset,
	      sourceClientOffset: sourceClientOffset,
	      isSourcePublic: publishSource
	    };
	  };
	
	  DragDropActions.prototype.publishDragSource = function publishDragSource() {
	    var monitor = this.manager.getMonitor();
	    if (!monitor.isDragging()) {
	      return;
	    }
	
	    return {};
	  };
	
	  DragDropActions.prototype.hover = function hover(targetIds) {
	    var _ref2 = arguments[1] === undefined ? {} : arguments[1];
	
	    var _ref2$clientOffset = _ref2.clientOffset;
	    var clientOffset = _ref2$clientOffset === undefined ? null : _ref2$clientOffset;
	
	    _invariant2['default'](_isArray2['default'](targetIds), 'Expected targetIds to be an array.');
	    targetIds = targetIds.slice(0);
	
	    var monitor = this.manager.getMonitor();
	    var registry = this.manager.getRegistry();
	    _invariant2['default'](monitor.isDragging(), 'Cannot call hover while not dragging.');
	    _invariant2['default'](!monitor.didDrop(), 'Cannot call hover after drop.');
	
	    var draggedItemType = monitor.getItemType();
	    for (var i = 0; i < targetIds.length; i++) {
	      var targetId = targetIds[i];
	      _invariant2['default'](targetIds.lastIndexOf(targetId) === i, 'Expected targetIds to be unique in the passed array.');
	
	      var target = registry.getTarget(targetId);
	      _invariant2['default'](target, 'Expected targetIds to be registered.');
	
	      var targetType = registry.getTargetType(targetId);
	      if (_matchesType2['default'](targetType, draggedItemType)) {
	        target.hover(monitor, targetId);
	      }
	    }
	
	    return { targetIds: targetIds, clientOffset: clientOffset };
	  };
	
	  DragDropActions.prototype.drop = function drop() {
	    var _this = this;
	
	    var monitor = this.manager.getMonitor();
	    var registry = this.manager.getRegistry();
	    _invariant2['default'](monitor.isDragging(), 'Cannot call drop while not dragging.');
	    _invariant2['default'](!monitor.didDrop(), 'Cannot call drop twice during one drag operation.');
	
	    var _getActionIds = this.getActionIds();
	
	    var dropActionId = _getActionIds.drop;
	
	    var targetIds = monitor.getTargetIds().filter(monitor.canDropOnTarget, monitor);
	
	    targetIds.reverse();
	    targetIds.forEach(function (targetId, index) {
	      var target = registry.getTarget(targetId);
	
	      var dropResult = target.drop(monitor, targetId);
	      _invariant2['default'](typeof dropResult === 'undefined' || _isObject2['default'](dropResult), 'Drop result must either be an object or undefined.');
	      if (typeof dropResult === 'undefined') {
	        dropResult = index === 0 ? {} : monitor.getDropResult();
	      }
	
	      _this.dispatch(dropActionId, { dropResult: dropResult });
	    });
	  };
	
	  DragDropActions.prototype.endDrag = function endDrag() {
	    var monitor = this.manager.getMonitor();
	    var registry = this.manager.getRegistry();
	    _invariant2['default'](monitor.isDragging(), 'Cannot call endDrag while not dragging.');
	
	    var sourceId = monitor.getSourceId();
	    var source = registry.getSource(sourceId, true);
	    source.endDrag(monitor, sourceId);
	
	    registry.unpinSource();
	
	    return {};
	  };
	
	  return DragDropActions;
	})(_Actions2.Actions);
	
	exports['default'] = DragDropActions;
	module.exports = exports['default'];

/***/ },
/* 261 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _classCallCheck = function (instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } };
	
	var _inherits = function (subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) subClass.__proto__ = superClass; };
	
	exports.__esModule = true;
	
	var _Actions2 = __webpack_require__(30);
	
	var RegistryActions = (function (_Actions) {
	  function RegistryActions() {
	    _classCallCheck(this, RegistryActions);
	
	    if (_Actions != null) {
	      _Actions.apply(this, arguments);
	    }
	  }
	
	  _inherits(RegistryActions, _Actions);
	
	  RegistryActions.prototype.addSource = function addSource(sourceId) {
	    return { sourceId: sourceId };
	  };
	
	  RegistryActions.prototype.addTarget = function addTarget(targetId) {
	    return { targetId: targetId };
	  };
	
	  RegistryActions.prototype.removeSource = function removeSource(sourceId) {
	    return { sourceId: sourceId };
	  };
	
	  RegistryActions.prototype.removeTarget = function removeTarget(targetId) {
	    return { targetId: targetId };
	  };
	
	  return RegistryActions;
	})(_Actions2.Actions);
	
	exports['default'] = RegistryActions;
	module.exports = exports['default'];

/***/ },
/* 262 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireWildcard = function (obj) { return obj && obj.__esModule ? obj : { 'default': obj }; };
	
	var _classCallCheck = function (instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } };
	
	exports.__esModule = true;
	exports['default'] = createBackend;
	
	var _noop = __webpack_require__(385);
	
	var _noop2 = _interopRequireWildcard(_noop);
	
	var TestBackend = (function () {
	  function TestBackend(manager) {
	    _classCallCheck(this, TestBackend);
	
	    this.actions = manager.getActions();
	  }
	
	  TestBackend.prototype.setup = function setup() {
	    this.didCallSetup = true;
	  };
	
	  TestBackend.prototype.teardown = function teardown() {
	    this.didCallTeardown = true;
	  };
	
	  TestBackend.prototype.connectDragSource = function connectDragSource() {
	    return _noop2['default'];
	  };
	
	  TestBackend.prototype.connectDragPreview = function connectDragPreview() {
	    return _noop2['default'];
	  };
	
	  TestBackend.prototype.connectDropTarget = function connectDropTarget() {
	    return _noop2['default'];
	  };
	
	  TestBackend.prototype.simulateBeginDrag = function simulateBeginDrag(sourceIds, options) {
	    this.actions.beginDrag(sourceIds, options);
	  };
	
	  TestBackend.prototype.simulatePublishDragSource = function simulatePublishDragSource() {
	    this.actions.publishDragSource();
	  };
	
	  TestBackend.prototype.simulateHover = function simulateHover(targetIds, options) {
	    this.actions.hover(targetIds, options);
	  };
	
	  TestBackend.prototype.simulateDrop = function simulateDrop() {
	    this.actions.drop();
	  };
	
	  TestBackend.prototype.simulateEndDrag = function simulateEndDrag() {
	    this.actions.endDrag();
	  };
	
	  return TestBackend;
	})();
	
	function createBackend(manager) {
	  return new TestBackend(manager);
	}
	
	module.exports = exports['default'];

/***/ },
/* 263 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _classCallCheck = function (instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } };
	
	var _inherits = function (subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) subClass.__proto__ = superClass; };
	
	exports.__esModule = true;
	
	var _Store2 = __webpack_require__(30);
	
	function areOffsetsEqual(offsetA, offsetB) {
	  if (offsetA === offsetB) {
	    return true;
	  }
	
	  return offsetA && offsetB && offsetA.x === offsetB.x && offsetA.y === offsetB.y;
	}
	
	var DragOffsetStore = (function (_Store) {
	  function DragOffsetStore(flux) {
	    _classCallCheck(this, DragOffsetStore);
	
	    _Store.call(this);
	
	    var dragDropActionIds = flux.dragDropActionIds;
	
	    this.register(dragDropActionIds.beginDrag, this.handleBeginDrag);
	    this.register(dragDropActionIds.hover, this.handleHover);
	    this.register(dragDropActionIds.endDrag, this.handleEndDrag);
	    this.register(dragDropActionIds.drop, this.handleDrop);
	
	    this.state = {
	      initialSourceClientOffset: null,
	      initialClientOffset: null,
	      clientOffset: null
	    };
	  }
	
	  _inherits(DragOffsetStore, _Store);
	
	  DragOffsetStore.prototype.handleBeginDrag = function handleBeginDrag(_ref) {
	    var clientOffset = _ref.clientOffset;
	    var sourceClientOffset = _ref.sourceClientOffset;
	
	    this.setState({
	      initialClientOffset: clientOffset,
	      initialSourceClientOffset: sourceClientOffset,
	      clientOffset: clientOffset
	    });
	  };
	
	  DragOffsetStore.prototype.handleHover = function handleHover(_ref2) {
	    var clientOffset = _ref2.clientOffset;
	    var prevClientOffset = this.state.clientOffset;
	
	    if (!areOffsetsEqual(clientOffset, prevClientOffset)) {
	      this.setState({
	        clientOffset: clientOffset
	      });
	    }
	  };
	
	  DragOffsetStore.prototype.handleEndDrag = function handleEndDrag() {
	    this.setState({
	      initialClientOffset: null,
	      initialSourceClientOffset: null,
	      clientOffset: null
	    });
	  };
	
	  DragOffsetStore.prototype.handleDrop = function handleDrop() {
	    this.setState({
	      initialClientOffset: null,
	      initialSourceClientOffset: null,
	      clientOffset: null
	    });
	  };
	
	  DragOffsetStore.prototype.getInitialClientOffset = function getInitialClientOffset() {
	    return this.state.initialClientOffset;
	  };
	
	  DragOffsetStore.prototype.getInitialSourceClientOffset = function getInitialSourceClientOffset() {
	    return this.state.initialSourceClientOffset;
	  };
	
	  DragOffsetStore.prototype.getClientOffset = function getClientOffset() {
	    return this.state.clientOffset;
	  };
	
	  DragOffsetStore.prototype.getSourceClientOffset = function getSourceClientOffset() {
	    var _state = this.state;
	    var clientOffset = _state.clientOffset;
	    var initialClientOffset = _state.initialClientOffset;
	    var initialSourceClientOffset = _state.initialSourceClientOffset;
	
	    if (!clientOffset || !initialClientOffset || !initialSourceClientOffset) {
	      return null;
	    }
	
	    return {
	      x: clientOffset.x + initialSourceClientOffset.x - initialClientOffset.x,
	      y: clientOffset.y + initialSourceClientOffset.y - initialClientOffset.y
	    };
	  };
	
	  DragOffsetStore.prototype.getDifferenceFromInitialOffset = function getDifferenceFromInitialOffset() {
	    var _state2 = this.state;
	    var clientOffset = _state2.clientOffset;
	    var initialClientOffset = _state2.initialClientOffset;
	
	    if (!clientOffset || !initialClientOffset) {
	      return null;
	    }
	
	    return {
	      x: clientOffset.x - initialClientOffset.x,
	      y: clientOffset.y - initialClientOffset.y
	    };
	  };
	
	  return DragOffsetStore;
	})(_Store2.Store);
	
	exports['default'] = DragOffsetStore;
	module.exports = exports['default'];

/***/ },
/* 264 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireWildcard = function (obj) { return obj && obj.__esModule ? obj : { 'default': obj }; };
	
	var _classCallCheck = function (instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } };
	
	var _inherits = function (subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) subClass.__proto__ = superClass; };
	
	exports.__esModule = true;
	
	var _Store2 = __webpack_require__(30);
	
	var _xor = __webpack_require__(348);
	
	var _xor2 = _interopRequireWildcard(_xor);
	
	var _without = __webpack_require__(122);
	
	var _without2 = _interopRequireWildcard(_without);
	
	var _intersection = __webpack_require__(346);
	
	var _intersection2 = _interopRequireWildcard(_intersection);
	
	var ALL_DIRTY_WILDCARD = { __all__: true };
	
	var DragOperationStore = (function (_Store) {
	  function DragOperationStore(flux) {
	    _classCallCheck(this, DragOperationStore);
	
	    _Store.call(this);
	
	    var dragDropActionIds = flux.dragDropActionIds;
	    var registryActionIds = flux.registryActionIds;
	
	    this.register(dragDropActionIds.beginDrag, this.handleBeginDrag);
	    this.register(dragDropActionIds.publishDragSource, this.handlePublishDragSource);
	    this.register(dragDropActionIds.hover, this.handleHover);
	    this.register(dragDropActionIds.endDrag, this.handleEndDrag);
	    this.register(dragDropActionIds.drop, this.handleDrop);
	    this.register(registryActionIds.removeTarget, this.handleRemoveTarget);
	
	    this.dirtyHandlerIds = [];
	    this.state = {
	      itemType: null,
	      item: null,
	      sourceId: null,
	      targetIds: [],
	      dropResult: null,
	      didDrop: false,
	      isSourcePublic: null
	    };
	  }
	
	  _inherits(DragOperationStore, _Store);
	
	  DragOperationStore.prototype.setState = function setState(nextState) {
	    var dirtyHandlerIds = arguments[1] === undefined ? ALL_DIRTY_WILDCARD : arguments[1];
	
	    this.dirtyHandlerIds = dirtyHandlerIds;
	    _Store.prototype.setState.call(this, nextState);
	  };
	
	  DragOperationStore.prototype.handleBeginDrag = function handleBeginDrag(_ref) {
	    var itemType = _ref.itemType;
	    var item = _ref.item;
	    var sourceId = _ref.sourceId;
	    var isSourcePublic = _ref.isSourcePublic;
	
	    this.setState({
	      itemType: itemType,
	      item: item,
	      sourceId: sourceId,
	      isSourcePublic: isSourcePublic,
	      dropResult: null,
	      didDrop: false
	    });
	  };
	
	  DragOperationStore.prototype.handlePublishDragSource = function handlePublishDragSource() {
	    this.setState({
	      isSourcePublic: true
	    });
	  };
	
	  DragOperationStore.prototype.handleHover = function handleHover(_ref2) {
	    var targetIds = _ref2.targetIds;
	    var prevTargetIds = this.state.targetIds;
	
	    var dirtyHandlerIds = _xor2['default'](targetIds, prevTargetIds);
	
	    var didChange = false;
	    if (dirtyHandlerIds.length === 0) {
	      for (var i = 0; i < targetIds.length; i++) {
	        if (targetIds[i] !== prevTargetIds[i]) {
	          didChange = true;
	          break;
	        }
	      }
	    } else {
	      didChange = true;
	    }
	
	    if (!didChange) {
	      return;
	    }
	
	    var prevInnermostTargetId = prevTargetIds[prevTargetIds.length - 1];
	    var innermostTargetId = targetIds[targetIds.length - 1];
	
	    if (prevInnermostTargetId !== innermostTargetId) {
	      if (prevInnermostTargetId) {
	        dirtyHandlerIds.push(prevInnermostTargetId);
	      }
	      if (innermostTargetId) {
	        dirtyHandlerIds.push(innermostTargetId);
	      }
	    }
	
	    this.setState({
	      targetIds: targetIds
	    }, dirtyHandlerIds);
	  };
	
	  DragOperationStore.prototype.handleRemoveTarget = function handleRemoveTarget(_ref3) {
	    var targetId = _ref3.targetId;
	    var targetIds = this.state.targetIds;
	
	    if (targetIds.indexOf(targetId) === -1) {
	      return;
	    }
	
	    this.setState({
	      targetIds: _without2['default'](targetIds, targetId)
	    }, []);
	  };
	
	  DragOperationStore.prototype.handleDrop = function handleDrop(_ref4) {
	    var dropResult = _ref4.dropResult;
	
	    this.setState({
	      dropResult: dropResult,
	      didDrop: true,
	      targetIds: []
	    });
	  };
	
	  DragOperationStore.prototype.handleEndDrag = function handleEndDrag() {
	    this.setState({
	      itemType: null,
	      item: null,
	      sourceId: null,
	      dropResult: null,
	      didDrop: false,
	      isSourcePublic: null,
	      targetIds: []
	    });
	  };
	
	  DragOperationStore.prototype.isDragging = function isDragging() {
	    return Boolean(this.getItemType());
	  };
	
	  DragOperationStore.prototype.getItemType = function getItemType() {
	    return this.state.itemType;
	  };
	
	  DragOperationStore.prototype.getSourceId = function getSourceId() {
	    return this.state.sourceId;
	  };
	
	  DragOperationStore.prototype.getTargetIds = function getTargetIds() {
	    return this.state.targetIds.slice(0);
	  };
	
	  DragOperationStore.prototype.getItem = function getItem() {
	    return this.state.item;
	  };
	
	  DragOperationStore.prototype.getDropResult = function getDropResult() {
	    return this.state.dropResult;
	  };
	
	  DragOperationStore.prototype.didDrop = function didDrop() {
	    return this.state.didDrop;
	  };
	
	  DragOperationStore.prototype.isSourcePublic = function isSourcePublic() {
	    return this.state.isSourcePublic;
	  };
	
	  DragOperationStore.prototype.areDirty = function areDirty(handlerIds) {
	    if (this.dirtyHandlerIds === ALL_DIRTY_WILDCARD) {
	      return true;
	    }
	
	    return _intersection2['default'](handlerIds, this.dirtyHandlerIds).length > 0;
	  };
	
	  return DragOperationStore;
	})(_Store2.Store);
	
	exports['default'] = DragOperationStore;
	module.exports = exports['default'];

/***/ },
/* 265 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _classCallCheck = function (instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } };
	
	var _inherits = function (subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) subClass.__proto__ = superClass; };
	
	exports.__esModule = true;
	
	var _Store2 = __webpack_require__(30);
	
	var RefCountStore = (function (_Store) {
	  function RefCountStore(flux) {
	    _classCallCheck(this, RefCountStore);
	
	    _Store.call(this);
	
	    var registryActionIds = flux.registryActionIds;
	
	    this.register(registryActionIds.addSource, this.addRef);
	    this.register(registryActionIds.addTarget, this.addRef);
	    this.register(registryActionIds.removeSource, this.removeRef);
	    this.register(registryActionIds.removeTarget, this.removeRef);
	
	    this.state = {
	      refCount: 0
	    };
	  }
	
	  _inherits(RefCountStore, _Store);
	
	  RefCountStore.prototype.addRef = function addRef() {
	    this.setState({
	      refCount: this.state.refCount + 1
	    });
	  };
	
	  RefCountStore.prototype.removeRef = function removeRef() {
	    this.setState({
	      refCount: this.state.refCount - 1
	    });
	  };
	
	  RefCountStore.prototype.hasRefs = function hasRefs() {
	    return this.state.refCount > 0;
	  };
	
	  return RefCountStore;
	})(_Store2.Store);
	
	exports['default'] = RefCountStore;
	module.exports = exports['default'];

/***/ },
/* 266 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireWildcard = function (obj) { return obj && obj.__esModule ? obj : { 'default': obj }; };
	
	var _classCallCheck = function (instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } };
	
	exports.__esModule = true;
	
	var _invariant = __webpack_require__(9);
	
	var _invariant2 = _interopRequireWildcard(_invariant);
	
	var _keyMirror = __webpack_require__(275);
	
	var _keyMirror2 = _interopRequireWildcard(_keyMirror);
	
	var _isArray = __webpack_require__(23);
	
	var _isArray2 = _interopRequireWildcard(_isArray);
	
	var _getNextUniqueId = __webpack_require__(267);
	
	var _getNextUniqueId2 = _interopRequireWildcard(_getNextUniqueId);
	
	var HandlerRoles = _keyMirror2['default']({
	  SOURCE: null,
	  TARGET: null
	});
	
	function validateSourceContract(source) {
	  _invariant2['default'](typeof source.canDrag === 'function', 'Expected canDrag to be a function.');
	  _invariant2['default'](typeof source.beginDrag === 'function', 'Expected beginDrag to be a function.');
	  _invariant2['default'](typeof source.endDrag === 'function', 'Expected endDrag to be a function.');
	}
	
	function validateTargetContract(target) {
	  _invariant2['default'](typeof target.canDrop === 'function', 'Expected canDrop to be a function.');
	  _invariant2['default'](typeof target.hover === 'function', 'Expected hover to be a function.');
	  _invariant2['default'](typeof target.drop === 'function', 'Expected beginDrag to be a function.');
	}
	
	function validateType(type, allowArray) {
	  if (allowArray && _isArray2['default'](type)) {
	    type.forEach(function (t) {
	      return validateType(t, false);
	    });
	    return;
	  }
	
	  _invariant2['default'](typeof type === 'string' || typeof type === 'symbol', allowArray ? 'Type can only be a string, a symbol, or an array of either.' : 'Type can only be a string or a symbol.');
	}
	
	function getNextHandlerId(role) {
	  var id = _getNextUniqueId2['default']().toString();
	  switch (role) {
	    case HandlerRoles.SOURCE:
	      return 'S' + id;
	    case HandlerRoles.TARGET:
	      return 'T' + id;
	    default:
	      _invariant2['default'](false, 'Unknown role: ' + role);
	  }
	}
	
	function parseRoleFromHandlerId(handlerId) {
	  switch (handlerId[0]) {
	    case 'S':
	      return HandlerRoles.SOURCE;
	    case 'T':
	      return HandlerRoles.TARGET;
	    default:
	      _invariant2['default'](false, 'Cannot parse handler ID: ' + handlerId);
	  }
	}
	
	var HandlerRegistry = (function () {
	  function HandlerRegistry(actions) {
	    _classCallCheck(this, HandlerRegistry);
	
	    this.actions = actions;
	
	    this.types = {};
	    this.handlers = {};
	
	    this.pinnedSourceId = null;
	    this.pinnedSource = null;
	  }
	
	  HandlerRegistry.prototype.addSource = function addSource(type, source) {
	    validateType(type);
	    validateSourceContract(source);
	
	    var sourceId = this.addHandler(HandlerRoles.SOURCE, type, source);
	    this.actions.addSource(sourceId);
	    return sourceId;
	  };
	
	  HandlerRegistry.prototype.addTarget = function addTarget(type, target) {
	    validateType(type, true);
	    validateTargetContract(target);
	
	    var targetId = this.addHandler(HandlerRoles.TARGET, type, target);
	    this.actions.addTarget(targetId);
	    return targetId;
	  };
	
	  HandlerRegistry.prototype.addHandler = function addHandler(role, type, handler) {
	    var id = getNextHandlerId(role);
	    this.types[id] = type;
	    this.handlers[id] = handler;
	
	    return id;
	  };
	
	  HandlerRegistry.prototype.containsHandler = function containsHandler(handler) {
	    var _this = this;
	
	    return Object.keys(this.handlers).some(function (key) {
	      return _this.handlers[key] === handler;
	    });
	  };
	
	  HandlerRegistry.prototype.getSource = function getSource(sourceId, includePinned) {
	    _invariant2['default'](this.isSourceId(sourceId), 'Expected a valid source ID.');
	
	    var isPinned = includePinned && sourceId === this.pinnedSourceId;
	    var source = isPinned ? this.pinnedSource : this.handlers[sourceId];
	
	    return source;
	  };
	
	  HandlerRegistry.prototype.getTarget = function getTarget(targetId) {
	    _invariant2['default'](this.isTargetId(targetId), 'Expected a valid target ID.');
	    return this.handlers[targetId];
	  };
	
	  HandlerRegistry.prototype.getSourceType = function getSourceType(sourceId) {
	    _invariant2['default'](this.isSourceId(sourceId), 'Expected a valid source ID.');
	    return this.types[sourceId];
	  };
	
	  HandlerRegistry.prototype.getTargetType = function getTargetType(targetId) {
	    _invariant2['default'](this.isTargetId(targetId), 'Expected a valid target ID.');
	    return this.types[targetId];
	  };
	
	  HandlerRegistry.prototype.isSourceId = function isSourceId(handlerId) {
	    var role = parseRoleFromHandlerId(handlerId);
	    return role === HandlerRoles.SOURCE;
	  };
	
	  HandlerRegistry.prototype.isTargetId = function isTargetId(handlerId) {
	    var role = parseRoleFromHandlerId(handlerId);
	    return role === HandlerRoles.TARGET;
	  };
	
	  HandlerRegistry.prototype.removeSource = function removeSource(sourceId) {
	    _invariant2['default'](this.getSource(sourceId), 'Expected an existing source.');
	
	    delete this.handlers[sourceId];
	    delete this.types[sourceId];
	
	    this.actions.removeSource(sourceId);
	  };
	
	  HandlerRegistry.prototype.removeTarget = function removeTarget(targetId) {
	    _invariant2['default'](this.getTarget(targetId), 'Expected an existing target.');
	
	    delete this.handlers[targetId];
	    delete this.types[targetId];
	
	    this.actions.removeTarget(targetId);
	  };
	
	  HandlerRegistry.prototype.pinSource = function pinSource(sourceId) {
	    var source = this.getSource(sourceId);
	    _invariant2['default'](source, 'Expected an existing source.');
	
	    this.pinnedSourceId = sourceId;
	    this.pinnedSource = source;
	  };
	
	  HandlerRegistry.prototype.unpinSource = function unpinSource() {
	    _invariant2['default'](this.pinnedSource, 'No source is pinned at the time.');
	
	    this.pinnedSourceId = null;
	    this.pinnedSource = null;
	  };
	
	  return HandlerRegistry;
	})();
	
	exports['default'] = HandlerRegistry;
	module.exports = exports['default'];

/***/ },
/* 267 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = getNextUniqueId;
	var nextUniqueId = 0;
	
	function getNextUniqueId() {
	  return nextUniqueId++;
	}
	
	module.exports = exports["default"];

/***/ },
/* 268 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequire = function (obj) { return obj && obj.__esModule ? obj["default"] : obj; };
	
	var _prototypeProperties = function (child, staticProps, instanceProps) { if (staticProps) Object.defineProperties(child, staticProps); if (instanceProps) Object.defineProperties(child.prototype, instanceProps); };
	
	var _classCallCheck = function (instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } };
	
	/**
	 * Actions
	 *
	 * Instances of the Actions class represent a set of actions. (In Flux parlance,
	 * these might be more accurately denoted as Action Creators, while Action
	 * refers to the payload sent to the dispatcher, but this is... confusing. We
	 * will use Action to mean the function you call to trigger a dispatch.)
	 *
	 * Create actions by extending from the base Actions class and adding methods.
	 * All methods on the prototype (except the constructor) will be
	 * converted into actions. The return value of an action is used as the body
	 * of the payload sent to the dispatcher.
	 */
	
	var uniqueId = _interopRequire(__webpack_require__(274));
	
	var Actions = (function () {
	  function Actions() {
	    _classCallCheck(this, Actions);
	
	    this._baseId = uniqueId();
	
	    var methodNames = this._getActionMethodNames();
	    for (var i = 0; i < methodNames.length; i++) {
	      var methodName = methodNames[i];
	      this._wrapAction(methodName);
	    }
	
	    this.getConstants = this.getActionIds;
	  }
	
	  _prototypeProperties(Actions, null, {
	    getActionIds: {
	      value: function getActionIds() {
	        var _this = this;
	        return this._getActionMethodNames().reduce(function (result, actionName) {
	          result[actionName] = _this[actionName]._id;
	          return result;
	        }, {});
	      },
	      writable: true,
	      configurable: true
	    },
	    _getActionMethodNames: {
	      value: function _getActionMethodNames(instance) {
	        var _this = this;
	        return Object.getOwnPropertyNames(this.constructor.prototype).filter(function (name) {
	          return name !== "constructor" && typeof _this[name] === "function";
	        });
	      },
	      writable: true,
	      configurable: true
	    },
	    _wrapAction: {
	      value: function _wrapAction(methodName) {
	        var _this = this;
	        var originalMethod = this[methodName];
	        var actionId = this._createActionId(methodName);
	
	        var action = function () {
	          for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	          }
	
	          var body = originalMethod.apply(_this, args);
	
	          if (isPromise(body)) {
	            var promise = body;
	            _this._dispatchAsync(actionId, promise, args, methodName)
	            // Catch errors and do nothing
	            // They can be handled by store or caller
	            ["catch"](function (error) {});
	
	            return promise;
	          } else {
	            return _this._dispatch(actionId, body, args, methodName);
	          }
	        };
	
	        action._id = actionId;
	
	        this[methodName] = action;
	      },
	      writable: true,
	      configurable: true
	    },
	    _createActionId: {
	
	      /**
	       * Create unique string constant for an action method, using
	       * @param {string} methodName - Name of the action method
	       */
	      value: function _createActionId(methodName) {
	        return "" + this._baseId + "-" + methodName;
	      },
	      writable: true,
	      configurable: true
	    },
	    _dispatch: {
	      value: function _dispatch(actionId, body, args, methodName) {
	        if (typeof this.dispatch === "function") {
	          if (typeof body !== "undefined") {
	            this.dispatch(actionId, body, args);
	          }
	        } else {
	          if (false) {
	            console.warn("You've attempted to perform the action " + ("" + this.constructor.name + "#" + methodName + ", but it hasn't been added ") + "to a Flux instance.");
	          }
	        }
	
	        return body;
	      },
	      writable: true,
	      configurable: true
	    },
	    _dispatchAsync: {
	      value: function _dispatchAsync(actionId, promise, args, methodName) {
	        if (typeof this.dispatchAsync === "function") {
	          return this.dispatchAsync(actionId, promise, args);
	        } else {
	          if (false) {
	            console.warn("You've attempted to perform the asynchronous action " + ("" + this.constructor.name + "#" + methodName + ", but it hasn't been added ") + "to a Flux instance.");
	          }
	
	          return promise;
	        }
	      },
	      writable: true,
	      configurable: true
	    }
	  });
	
	  return Actions;
	})();
	
	module.exports = Actions;
	
	
	function isPromise(value) {
	  return value && typeof value.then === "function";
	}
	//# sourceMappingURL=data:application/json;base64,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

/***/ },
/* 269 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequire = function (obj) { return obj && obj.__esModule ? obj["default"] : obj; };
	
	var _prototypeProperties = function (child, staticProps, instanceProps) { if (staticProps) Object.defineProperties(child, staticProps); if (instanceProps) Object.defineProperties(child.prototype, instanceProps); };
	
	var _inherits = function (subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) subClass.__proto__ = superClass; };
	
	var _classCallCheck = function (instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } };
	
	/**
	 * Store
	 *
	 * Stores hold application state. They respond to actions sent by the dispatcher
	 * and broadcast change events to listeners, so they can grab the latest data.
	 * The key thing to remember is that the only way stores receive information
	 * from the outside world is via the dispatcher.
	 */
	
	var EventEmitter = _interopRequire(__webpack_require__(121));
	
	var assign = _interopRequire(__webpack_require__(273));
	
	var Store = (function (EventEmitter) {
	  /**
	   * Stores are initialized with a reference
	   * @type {Object}
	   */
	  function Store() {
	    _classCallCheck(this, Store);
	
	    this.state = undefined;
	
	    this._handlers = {};
	    this._asyncHandlers = {};
	  }
	
	  _inherits(Store, EventEmitter);
	
	  _prototypeProperties(Store, null, {
	    getState: {
	
	      /**
	       * Return a (shallow) copy of the store's internal state, so that it is
	       * protected from mutation by the consumer.
	       * @returns {object}
	       */
	      value: function getState() {
	        return assign({}, this.state);
	      },
	      writable: true,
	      configurable: true
	    },
	    setState: {
	      value: function setState(newState) {
	        if (typeof this.state === "undefined") this.state = {};
	
	        if (this._isHandlingDispatch) {
	          this._pendingState = assign(this._pendingState, newState);
	          this._emitChangeAfterHandlingDispatch = true;
	        } else {
	          if (false) {
	            console.warn("Store#setState() called from outside an action handler. This is likely " + "a mistake. Flux stores should manage their own state.");
	          }
	
	          this.state = assign({}, this.state, newState);
	          this.emit("change");
	        }
	      },
	      writable: true,
	      configurable: true
	    },
	    replaceState: {
	      value: function replaceState(newState) {
	        if (typeof this.state === "undefined") this.state = {};
	
	        if (this._isHandlingDispatch) {
	          this._pendingState = assign({}, newState);
	          this._emitChangeAfterHandlingDispatch = true;
	        } else {
	          this.state = assign({}, newState);
	          this.emit("change");
	        }
	      },
	      writable: true,
	      configurable: true
	    },
	    forceUpdate: {
	      value: function forceUpdate() {
	        if (this._isHandlingDispatch) {
	          this._emitChangeAfterHandlingDispatch = true;
	        } else {
	          this.emit("change");
	        }
	      },
	      writable: true,
	      configurable: true
	    },
	    register: {
	      value: function register(actionId, handler) {
	        actionId = ensureActionId(actionId);
	
	        if (typeof handler !== "function") {
	          return;
	        }this._handlers[actionId] = handler.bind(this);
	      },
	      writable: true,
	      configurable: true
	    },
	    registerAsync: {
	      value: function registerAsync(actionId, beginHandler, successHandler, failureHandler) {
	        actionId = ensureActionId(actionId);
	
	        var asyncHandlers = {
	          begin: beginHandler,
	          success: successHandler,
	          failure: failureHandler };
	
	        for (var key in asyncHandlers) {
	          if (!asyncHandlers.hasOwnProperty(key)) continue;
	
	          var handler = asyncHandlers[key];
	
	          if (typeof handler === "function") {
	            asyncHandlers[key] = handler.bind(this);
	          } else {
	            delete asyncHandlers[key];
	          }
	        }
	
	        this._asyncHandlers[actionId] = asyncHandlers;
	      },
	      writable: true,
	      configurable: true
	    },
	    waitFor: {
	      value: function waitFor(tokensOrStores) {
	        this._waitFor(tokensOrStores);
	      },
	      writable: true,
	      configurable: true
	    },
	    handler: {
	      value: function handler(payload) {
	        var body = payload.body;
	        var actionId = payload.actionId;
	        var _async = payload.async;
	        var actionArgs = payload.actionArgs;
	        var error = payload.error;
	
	
	        var _handler = this._handlers[actionId];
	        var _asyncHandler = this._asyncHandlers[actionId] && this._asyncHandlers[actionId][_async];
	
	        if (_async) {
	          switch (_async) {
	            case "begin":
	              if (typeof _asyncHandler === "function") {
	                this._performHandler.apply(this, [_asyncHandler].concat(actionArgs));
	              }
	              return;
	            case "failure":
	              if (typeof _asyncHandler === "function") {
	                this._performHandler(_asyncHandler, error);
	              }
	              return;
	            case "success":
	              if (typeof _asyncHandler === "function") {
	                _handler = _asyncHandler;
	              }
	              break;
	            default:
	              return;
	          }
	        }
	
	        if (typeof _handler !== "function") {
	          return;
	        }this._performHandler(_handler, body);
	      },
	      writable: true,
	      configurable: true
	    },
	    _performHandler: {
	      value: function _performHandler(_handler) {
	        for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	          args[_key - 1] = arguments[_key];
	        }
	
	        this._isHandlingDispatch = true;
	        this._pendingState = assign({}, this.state);
	        this._emitChangeAfterHandlingDispatch = false;
	
	        try {
	          _handler.apply(this, args);
	        } finally {
	          if (this._emitChangeAfterHandlingDispatch) {
	            this.state = this._pendingState;
	            this.emit("change");
	          }
	
	          this._isHandlingDispatch = false;
	          this._pendingState = {};
	          this._emitChangeAfterHandlingDispatch = false;
	        }
	      },
	      writable: true,
	      configurable: true
	    }
	  });
	
	  return Store;
	})(EventEmitter);
	
	module.exports = Store;
	
	
	function ensureActionId(actionOrActionId) {
	  return typeof actionOrActionId === "function" ? actionOrActionId._id : actionOrActionId;
	}
	//# sourceMappingURL=data:application/json;base64,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

/***/ },
/* 270 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	module.exports.Dispatcher = __webpack_require__(271)


/***/ },
/* 271 */
/***/ function(module, exports, __webpack_require__) {

	/*
	 * Copyright (c) 2014, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule Dispatcher
	 * @typechecks
	 */
	
	"use strict";
	
	var invariant = __webpack_require__(272);
	
	var _lastID = 1;
	var _prefix = 'ID_';
	
	/**
	 * Dispatcher is used to broadcast payloads to registered callbacks. This is
	 * different from generic pub-sub systems in two ways:
	 *
	 *   1) Callbacks are not subscribed to particular events. Every payload is
	 *      dispatched to every registered callback.
	 *   2) Callbacks can be deferred in whole or part until other callbacks have
	 *      been executed.
	 *
	 * For example, consider this hypothetical flight destination form, which
	 * selects a default city when a country is selected:
	 *
	 *   var flightDispatcher = new Dispatcher();
	 *
	 *   // Keeps track of which country is selected
	 *   var CountryStore = {country: null};
	 *
	 *   // Keeps track of which city is selected
	 *   var CityStore = {city: null};
	 *
	 *   // Keeps track of the base flight price of the selected city
	 *   var FlightPriceStore = {price: null}
	 *
	 * When a user changes the selected city, we dispatch the payload:
	 *
	 *   flightDispatcher.dispatch({
	 *     actionType: 'city-update',
	 *     selectedCity: 'paris'
	 *   });
	 *
	 * This payload is digested by `CityStore`:
	 *
	 *   flightDispatcher.register(function(payload) {
	 *     if (payload.actionType === 'city-update') {
	 *       CityStore.city = payload.selectedCity;
	 *     }
	 *   });
	 *
	 * When the user selects a country, we dispatch the payload:
	 *
	 *   flightDispatcher.dispatch({
	 *     actionType: 'country-update',
	 *     selectedCountry: 'australia'
	 *   });
	 *
	 * This payload is digested by both stores:
	 *
	 *    CountryStore.dispatchToken = flightDispatcher.register(function(payload) {
	 *     if (payload.actionType === 'country-update') {
	 *       CountryStore.country = payload.selectedCountry;
	 *     }
	 *   });
	 *
	 * When the callback to update `CountryStore` is registered, we save a reference
	 * to the returned token. Using this token with `waitFor()`, we can guarantee
	 * that `CountryStore` is updated before the callback that updates `CityStore`
	 * needs to query its data.
	 *
	 *   CityStore.dispatchToken = flightDispatcher.register(function(payload) {
	 *     if (payload.actionType === 'country-update') {
	 *       // `CountryStore.country` may not be updated.
	 *       flightDispatcher.waitFor([CountryStore.dispatchToken]);
	 *       // `CountryStore.country` is now guaranteed to be updated.
	 *
	 *       // Select the default city for the new country
	 *       CityStore.city = getDefaultCityForCountry(CountryStore.country);
	 *     }
	 *   });
	 *
	 * The usage of `waitFor()` can be chained, for example:
	 *
	 *   FlightPriceStore.dispatchToken =
	 *     flightDispatcher.register(function(payload) {
	 *       switch (payload.actionType) {
	 *         case 'country-update':
	 *           flightDispatcher.waitFor([CityStore.dispatchToken]);
	 *           FlightPriceStore.price =
	 *             getFlightPriceStore(CountryStore.country, CityStore.city);
	 *           break;
	 *
	 *         case 'city-update':
	 *           FlightPriceStore.price =
	 *             FlightPriceStore(CountryStore.country, CityStore.city);
	 *           break;
	 *     }
	 *   });
	 *
	 * The `country-update` payload will be guaranteed to invoke the stores'
	 * registered callbacks in order: `CountryStore`, `CityStore`, then
	 * `FlightPriceStore`.
	 */
	
	  function Dispatcher() {
	    this.$Dispatcher_callbacks = {};
	    this.$Dispatcher_isPending = {};
	    this.$Dispatcher_isHandled = {};
	    this.$Dispatcher_isDispatching = false;
	    this.$Dispatcher_pendingPayload = null;
	  }
	
	  /**
	   * Registers a callback to be invoked with every dispatched payload. Returns
	   * a token that can be used with `waitFor()`.
	   *
	   * @param {function} callback
	   * @return {string}
	   */
	  Dispatcher.prototype.register=function(callback) {
	    var id = _prefix + _lastID++;
	    this.$Dispatcher_callbacks[id] = callback;
	    return id;
	  };
	
	  /**
	   * Removes a callback based on its token.
	   *
	   * @param {string} id
	   */
	  Dispatcher.prototype.unregister=function(id) {
	    invariant(
	      this.$Dispatcher_callbacks[id],
	      'Dispatcher.unregister(...): `%s` does not map to a registered callback.',
	      id
	    );
	    delete this.$Dispatcher_callbacks[id];
	  };
	
	  /**
	   * Waits for the callbacks specified to be invoked before continuing execution
	   * of the current callback. This method should only be used by a callback in
	   * response to a dispatched payload.
	   *
	   * @param {array<string>} ids
	   */
	  Dispatcher.prototype.waitFor=function(ids) {
	    invariant(
	      this.$Dispatcher_isDispatching,
	      'Dispatcher.waitFor(...): Must be invoked while dispatching.'
	    );
	    for (var ii = 0; ii < ids.length; ii++) {
	      var id = ids[ii];
	      if (this.$Dispatcher_isPending[id]) {
	        invariant(
	          this.$Dispatcher_isHandled[id],
	          'Dispatcher.waitFor(...): Circular dependency detected while ' +
	          'waiting for `%s`.',
	          id
	        );
	        continue;
	      }
	      invariant(
	        this.$Dispatcher_callbacks[id],
	        'Dispatcher.waitFor(...): `%s` does not map to a registered callback.',
	        id
	      );
	      this.$Dispatcher_invokeCallback(id);
	    }
	  };
	
	  /**
	   * Dispatches a payload to all registered callbacks.
	   *
	   * @param {object} payload
	   */
	  Dispatcher.prototype.dispatch=function(payload) {
	    invariant(
	      !this.$Dispatcher_isDispatching,
	      'Dispatch.dispatch(...): Cannot dispatch in the middle of a dispatch.'
	    );
	    this.$Dispatcher_startDispatching(payload);
	    try {
	      for (var id in this.$Dispatcher_callbacks) {
	        if (this.$Dispatcher_isPending[id]) {
	          continue;
	        }
	        this.$Dispatcher_invokeCallback(id);
	      }
	    } finally {
	      this.$Dispatcher_stopDispatching();
	    }
	  };
	
	  /**
	   * Is this Dispatcher currently dispatching.
	   *
	   * @return {boolean}
	   */
	  Dispatcher.prototype.isDispatching=function() {
	    return this.$Dispatcher_isDispatching;
	  };
	
	  /**
	   * Call the callback stored with the given id. Also do some internal
	   * bookkeeping.
	   *
	   * @param {string} id
	   * @internal
	   */
	  Dispatcher.prototype.$Dispatcher_invokeCallback=function(id) {
	    this.$Dispatcher_isPending[id] = true;
	    this.$Dispatcher_callbacks[id](this.$Dispatcher_pendingPayload);
	    this.$Dispatcher_isHandled[id] = true;
	  };
	
	  /**
	   * Set up bookkeeping needed when dispatching.
	   *
	   * @param {object} payload
	   * @internal
	   */
	  Dispatcher.prototype.$Dispatcher_startDispatching=function(payload) {
	    for (var id in this.$Dispatcher_callbacks) {
	      this.$Dispatcher_isPending[id] = false;
	      this.$Dispatcher_isHandled[id] = false;
	    }
	    this.$Dispatcher_pendingPayload = payload;
	    this.$Dispatcher_isDispatching = true;
	  };
	
	  /**
	   * Clear bookkeeping used for dispatching.
	   *
	   * @internal
	   */
	  Dispatcher.prototype.$Dispatcher_stopDispatching=function() {
	    this.$Dispatcher_pendingPayload = null;
	    this.$Dispatcher_isDispatching = false;
	  };
	
	
	module.exports = Dispatcher;


/***/ },
/* 272 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2014, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule invariant
	 */
	
	"use strict";
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var invariant = function(condition, format, a, b, c, d, e, f) {
	  if (false) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  }
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error(
	        'Minified exception occurred; use the non-minified dev environment ' +
	        'for the full error message and additional helpful warnings.'
	      );
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(
	        'Invariant Violation: ' +
	        format.replace(/%s/g, function() { return args[argIndex++]; })
	      );
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	};
	
	module.exports = invariant;


/***/ },
/* 273 */
/***/ function(module, exports) {

	'use strict';
	
	function ToObject(val) {
		if (val == null) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	module.exports = Object.assign || function (target, source) {
		var from;
		var keys;
		var to = ToObject(target);
	
		for (var s = 1; s < arguments.length; s++) {
			from = arguments[s];
			keys = Object.keys(Object(from));
	
			for (var i = 0; i < keys.length; i++) {
				to[keys[i]] = from[keys[i]];
			}
		}
	
		return to;
	};


/***/ },
/* 274 */
/***/ function(module, exports) {

	'use strict';
	
	
	var count = 0;
	
	/**
	 * Generate a unique ID.
	 *
	 * Optionally pass a prefix to prepend, a suffix to append, or a
	 * multiplier to use on the ID.
	 *
	 * ```js
	 * uniqueId(); //=> '25'
	 *
	 * uniqueId({prefix: 'apple_'});
	 * //=> 'apple_10'
	 *
	 * uniqueId({suffix: '_orange'});
	 * //=> '10_orange'
	 *
	 * uniqueId({multiplier: 5});
	 * //=> 5, 10, 15, 20...
	 * ```
	 *
	 * To reset the `id` to zero, do `id.reset()`.
	 *
	 * @param  {Object} `options` Optionally pass a `prefix`, `suffix` and/or `multiplier.
	 * @return {String} The unique id.
	 * @api public
	 */
	
	var id = module.exports = function (options) {
	  options = options || {};
	
	  var prefix = options.prefix;
	  var suffix = options.suffix;
	
	  var id = ++count * (options.multiplier || 1);
	
	  if (prefix == null) {
	    prefix = '';
	  }
	
	  if (suffix == null) {
	    suffix = '';
	  }
	
	  return String(prefix) + id + String(suffix);
	};
	
	
	id.reset = function() {
	  return count = 0;
	};

/***/ },
/* 275 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2014 Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 */
	
	"use strict";
	
	/**
	 * Constructs an enumeration with keys equal to their value.
	 *
	 * For example:
	 *
	 *   var COLORS = keyMirror({blue: null, red: null});
	 *   var myColor = COLORS.blue;
	 *   var isColorValid = !!COLORS[myColor];
	 *
	 * The last line could not be performed if the values of the generated enum were
	 * not equal to their keys.
	 *
	 *   Input:  {key1: val1, key2: val2}
	 *   Output: {key1: key1, key2: key2}
	 *
	 * @param {object} obj
	 * @return {object}
	 */
	var keyMirror = function(obj) {
	  var ret = {};
	  var key;
	  if (!(obj instanceof Object && !Array.isArray(obj))) {
	    throw new Error('keyMirror(...): Argument must be an object.');
	  }
	  for (key in obj) {
	    if (!obj.hasOwnProperty(key)) {
	      continue;
	    }
	    ret[key] = key;
	  }
	  return ret;
	};
	
	module.exports = keyMirror;


/***/ },
/* 276 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 277 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 278 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 279 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 280 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 281 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 282 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 283 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 284 */
/***/ function(module, exports, __webpack_require__) {

	var Helpers = __webpack_require__(54);
	var faker = __webpack_require__(11);
	
	var address = {
	    zipCode: function () {
	        return Helpers.replaceSymbolWithNumber(faker.random.array_element(["#####", '#####-####']));
	    },
	
	    city: function () {
	        var result;
	        switch (faker.random.number(3)) {
	        case 0:
	            result = faker.address.cityPrefix() + " " + faker.name.firstName() + faker.address.citySuffix();
	            break;
	        case 1:
	            result = faker.address.cityPrefix() + " " + faker.name.firstName();
	            break;
	        case 2:
	            result = faker.name.firstName() + faker.address.citySuffix();
	            break;
	        case 3:
	            result = faker.name.lastName() + faker.address.citySuffix();
	            break;
	        }
	        return result;
	    },
	
	    cityPrefix: function () {
	      return faker.random.array_element(faker.definitions.address.city_prefix);
	    },
	
	    citySuffix: function () {
	      return faker.random.array_element(faker.definitions.address.city_suffix);
	    },
	
	    streetName: function () {
	        var result;
	        switch (faker.random.number(1)) {
	        case 0:
	            result = faker.name.lastName() + " " + faker.address.streetSuffix();
	            break;
	        case 1:
	            result = faker.name.firstName() + " " + faker.address.streetSuffix();
	            break;
	        }
	        return result;
	    },
	
	    //
	    // TODO: change all these methods that accept a boolean to instead accept an options hash.
	    //
	    streetAddress: function (useFullAddress) {
	        if (useFullAddress === undefined) { useFullAddress = false; }
	        var address = "";
	        switch (faker.random.number(2)) {
	        case 0:
	            address = Helpers.replaceSymbolWithNumber("#####") + " " + faker.address.streetName();
	            break;
	        case 1:
	            address = Helpers.replaceSymbolWithNumber("####") +  " " + faker.address.streetName();
	            break;
	        case 2:
	            address = Helpers.replaceSymbolWithNumber("###") + " " + faker.address.streetName();
	            break;
	        }
	        return useFullAddress ? (address + " " + faker.address.secondaryAddress()) : address;
	    },
	
	    streetSuffix: function () {
	        return faker.random.array_element(faker.definitions.address.street_suffix);
	    },
	
	    secondaryAddress: function () {
	        return Helpers.replaceSymbolWithNumber(faker.random.array_element(
	            [
	                'Apt. ###',
	                'Suite ###'
	            ]
	        ));
	    },
	
	    county: function () {
	      return faker.random.array_element(faker.definitions.address.county);
	    },
	
	    country: function () {
	      return faker.random.array_element(faker.definitions.address.country);
	    },
	
	    state: function (useAbbr) {
	        return faker.random.array_element(faker.definitions.address.state);
	    },
	
	    stateAbbr: function () {
	        return faker.random.array_element(faker.definitions.address.state_abbr);
	    },
	
	    latitude: function () {
	        return (faker.random.number(180 * 10000) / 10000.0 - 90.0).toFixed(4);
	    },
	
	    longitude: function () {
	        return (faker.random.number(360 * 10000) / 10000.0 - 180.0).toFixed(4);
	    }
	};
	
	module.exports = address;


/***/ },
/* 285 */
/***/ function(module, exports, __webpack_require__) {

	var faker = __webpack_require__(11);
	
	var company = {
	
	    suffixes: function () {
	        return ["Inc", "and Sons", "LLC", "Group", "and Daughters"];
	    },
	
	    companyName: function (format) {
	        switch ((format ? format : faker.random.number(2))) {
	        case 0:
	            return faker.name.lastName() + " " + faker.company.companySuffix();
	        case 1:
	            return faker.name.lastName() + "-" + faker.name.lastName();
	        case 2:
	            return faker.name.lastName() + ", " + faker.name.lastName() + " and " + faker.name.lastName();
	        }
	    },
	
	    companySuffix: function () {
	        return faker.random.array_element(faker.company.suffixes());
	    },
	
	    catchPhrase: function () {
	        return faker.company.catchPhraseAdjective() + " " +
	            faker.company.catchPhraseDescriptor() + " " +
	            faker.company.catchPhraseNoun();
	    },
	
	    bs: function () {
	        return faker.company.bsAdjective() + " " +
	            faker.company.bsBuzz() + " " +
	            faker.company.bsNoun();
	    },
	
	    catchPhraseAdjective: function () {
	        return faker.random.array_element(faker.definitions.company.adjective);
	    },
	
	    catchPhraseDescriptor: function () {
	        return faker.random.array_element(faker.definitions.company.descriptor);
	    },
	
	    catchPhraseNoun: function () {
	        return faker.random.array_element(faker.definitions.company.noun);
	    },
	
	    bsAdjective: function () {
	        return faker.random.array_element(faker.definitions.company.bs_adjective);
	    },
	
	    bsBuzz: function () {
	        return faker.random.array_element(faker.definitions.company.bs_verb);
	    },
	
	    bsNoun: function () {
	        return faker.random.array_element(faker.definitions.company.bs_noun);
	    }
	
	};
	
	module.exports = company;


/***/ },
/* 286 */
/***/ function(module, exports, __webpack_require__) {

	var faker = __webpack_require__(11);
	
	var date = {
	
	    past: function (years, refDate) {
	        var date = (refDate) ? new Date(Date.parse(refDate)) : new Date();
	        var range = {
	          min: 1000,
	          max: (years || 1) * 365 * 24 * 3600 * 1000
	        };
	
	        var past = date.getTime();
	        past -= faker.random.number(range); // some time from now to N years ago, in milliseconds
	        date.setTime(past);
	
	        return date;
	    },
	
	    future: function (years, refDate) {
	        var date = (refDate) ? new Date(Date.parse(refDate)) : new Date();
	        var range = {
	          min: 1000,
	          max: (years || 1) * 365 * 24 * 3600 * 1000
	        };
	
	        var future = date.getTime();
	        future += faker.random.number(range); // some time from now to N years later, in milliseconds
	        date.setTime(future);
	
	        return date;
	    },
	
	    between: function (from, to) {
	        var fromMilli = Date.parse(from);
	        var dateOffset = faker.random.number(Date.parse(to) - fromMilli);
	
	        var newDate = new Date(fromMilli + dateOffset);
	
	        return newDate;
	    },
	
	    recent: function (days) {
	        var date = new Date();
	        var range = {
	          min: 1000,
	          max: (days || 1) * 24 * 3600 * 1000
	        };
	
	        var future = date.getTime();
	        future -= faker.random.number(range); // some time from now to N days ago, in milliseconds
	        date.setTime(future);
	
	        return date;
	    }
	};
	module.exports = date;


/***/ },
/* 287 */
/***/ function(module, exports, __webpack_require__) {

	var Helpers = __webpack_require__(54),
	    faker = __webpack_require__(11);
	
	var finance = {
	
	    account: function (length) {
	
	        length = length || 8;
	
	        var template = '';
	
	        for (var i = 0; i < length; i++) {
	            template = template + '#';
	        }
	        length = null;
	        return Helpers.replaceSymbolWithNumber(template);
	    },
	
	    accountName: function () {
	
	        return [Helpers.randomize(faker.definitions.finance.account_type), 'Account'].join(' ');
	    },
	
	    mask: function (length, parens, elipsis) {
	
	
	        //set defaults
	        length = (length == 0 || !length || typeof length == 'undefined') ? 4 : length;
	        parens = (parens === null) ? true : parens;
	        elipsis = (elipsis === null) ? true : elipsis;
	
	        //create a template for length
	        var template = '';
	
	        for (var i = 0; i < length; i++) {
	            template = template + '#';
	        }
	
	        //prefix with elipsis
	        template = (elipsis) ? ['...', template].join('') : template;
	
	        template = (parens) ? ['(', template, ')'].join('') : template;
	
	        //generate random numbers
	        template = Helpers.replaceSymbolWithNumber(template);
	
	        return template;
	
	    },
	
	    //min and max take in minimum and maximum amounts, dec is the decimal place you want rounded to, symbol is $, €, £, etc
	    //NOTE: this returns a string representation of the value, if you want a number use parseFloat and no symbol
	
	    amount: function (min, max, dec, symbol) {
	
	        min = min || 0;
	        max = max || 1000;
	        dec = dec || 2;
	        symbol = symbol || '';
	
	        return symbol + (Math.round((Math.random() * (max - min) + min) * Math.pow(10, dec)) / Math.pow(10, dec)).toFixed(dec);
	
	    },
	
	    transactionType: function () {
	        return Helpers.randomize(faker.definitions.finance.transaction_type);
	    },
	
	    currencyCode: function () {
	        return faker.random.object_element(faker.definitions.finance.currency)['code'];
	    },
	
	    currencyName: function () {
	        return faker.random.object_element(faker.definitions.finance.currency, 'key');
	    },
	
	    currencySymbol: function () {
	        var symbol;
	
	        while (!symbol) {
	            symbol = faker.random.object_element(faker.definitions.finance.currency)['symbol'];
	        }
	        return symbol;
	    }
	};
	
	module.exports = finance;

/***/ },
/* 288 */
/***/ function(module, exports, __webpack_require__) {

	var faker = __webpack_require__(11);
	
	var hacker = {
	
	  abbreviation : function () {
	    return faker.random.array_element(faker.definitions.hacker.abbreviation);
	  },
	
	  adjective : function () {
	    return faker.random.array_element(faker.definitions.hacker.adjective);
	  },
	
	  noun : function () {
	    return faker.random.array_element(faker.definitions.hacker.noun);
	  },
	
	  verb : function () {
	    return faker.random.array_element(faker.definitions.hacker.verb);
	  },
	
	  ingverb : function () {
	    return faker.random.array_element(faker.definitions.hacker.ingverb);
	  },
	
	  phrase : function () {
	
	    var data = {
	      abbreviation: hacker.abbreviation(),
	      adjective: hacker.adjective(),
	      ingverb: hacker.ingverb(),
	      noun: hacker.noun(),
	      verb: hacker.verb()
	    };
	
	    var phrase = faker.random.array_element([ "If we {{verb}} the {{noun}}, we can get to the {{abbreviation}} {{noun}} through the {{adjective}} {{abbreviation}} {{noun}}!",
	      "We need to {{verb}} the {{adjective}} {{abbreviation}} {{noun}}!",
	      "Try to {{verb}} the {{abbreviation}} {{noun}}, maybe it will {{verb}} the {{adjective}} {{noun}}!",
	      "You can't {{verb}} the {{noun}} without {{ingverb}} the {{adjective}} {{abbreviation}} {{noun}}!",
	      "Use the {{adjective}} {{abbreviation}} {{noun}}, then you can {{verb}} the {{adjective}} {{noun}}!",
	      "The {{abbreviation}} {{noun}} is down, {{verb}} the {{adjective}} {{noun}} so we can {{verb}} the {{abbreviation}} {{noun}}!",
	      "{{ingverb}} the {{noun}} won't do anything, we need to {{verb}} the {{adjective}} {{abbreviation}} {{noun}}!",
	      "I'll {{verb}} the {{adjective}} {{abbreviation}} {{noun}}, that should {{noun}} the {{abbreviation}} {{noun}}!"
	   ]);
	
	   return faker.helpers.mustache(phrase, data);
	
	  },
	
	
	};
	
	module.exports = hacker;


/***/ },
/* 289 */
/***/ function(module, exports, __webpack_require__) {

	var faker = __webpack_require__(11);
	
	var image = {
	  image: function () {
	    var categories = ["abstract", "animals", "business", "cats", "city", "food", "nightlife", "fashion", "people", "nature", "sports", "technics", "transport"];
	    return image[faker.random.array_element(categories)]();
	  },
	  avatar: function () {
	    return faker.internet.avatar();
	  },
	  imageUrl: function (width, height, category) {
	      var width = width || 640;
	      var height = height || 480;
	
	      var url ='http://lorempixel.com/' + width + '/' + height;
	      if (typeof category !== 'undefined') {
	        url += '/' + category;
	      }
	      return url;
	  },
	  abstract: function (width, height) {
	    return faker.image.imageUrl(width, height, 'abstract');
	  },
	  animals: function (width, height) {
	    return faker.image.imageUrl(width, height, 'animals');
	  },
	  business: function (width, height) {
	    return faker.image.imageUrl(width, height, 'business');
	  },
	  cats: function (width, height) {
	    return faker.image.imageUrl(width, height, 'cats');
	  },
	  city: function (width, height) {
	    return faker.image.imageUrl(width, height, 'city');
	  },
	  food: function (width, height) {
	    return faker.image.imageUrl(width, height, 'food');
	  },
	  nightlife: function (width, height) {
	    return faker.image.imageUrl(width, height, 'nightlife');
	  },
	  fashion: function (width, height) {
	    return faker.image.imageUrl(width, height, 'fashion');
	  },
	  people: function (width, height) {
	    return faker.image.imageUrl(width, height, 'people');
	  },
	  nature: function (width, height) {
	    return faker.image.imageUrl(width, height, 'nature');
	  },
	  sports: function (width, height) {
	    return faker.image.imageUrl(width, height, 'sports');
	  },
	  technics: function (width, height) {
	    return faker.image.imageUrl(width, height, 'technics');
	  },
	  transport: function (width, height) {
	    return faker.image.imageUrl(width, height, 'transport');
	  }
	};
	
	module.exports = image;


/***/ },
/* 290 */
/***/ function(module, exports, __webpack_require__) {

	var faker = __webpack_require__(11),
	    password_generator = __webpack_require__(327),
	    random_ua = __webpack_require__(328);
	
	var internet = {
	
	    avatar: function () {
	        return faker.random.array_element(faker.definitions.internet.avatar_uri);
	    },
	
	    email: function (firstName, lastName, provider) {
	        provider = provider || faker.random.array_element(faker.definitions.internet.free_email);
	        return  faker.helpers.slugify(faker.internet.userName(firstName, lastName)) + "@" + provider;
	    },
	
	    userName: function (firstName, lastName) {
	        var result;
	        firstName = firstName || faker.name.firstName();
	        lastName = lastName || faker.name.lastName();
	        switch (faker.random.number(2)) {
	        case 0:
	            result = firstName + faker.random.number(99);
	            break;
	        case 1:
	            result = firstName + faker.random.array_element([".", "_"]) + lastName;
	            break;
	        case 2:
	            result = firstName + faker.random.array_element([".", "_"]) + lastName + faker.random.number(99);
	            break;
	        }
	        result = result.replace(/'/g, "");
	        result = result.replace(/ /g, "");
	        return result;
	    },
	
	    protocol: function () {
	        var protocols = ['http','https'];
	        return faker.random.array_element(protocols);
	    },
	
	    url: function () {
	        return faker.internet.protocol() + '://' + faker.internet.domainName();
	    },
	
	    domainName: function () {
	        return faker.internet.domainWord() + "." + faker.internet.domainSuffix();
	    },
	
	    domainSuffix: function () {
	        return faker.random.array_element(faker.definitions.internet.domain_suffix);
	    },
	
	    domainWord:  function () {
	        return faker.name.firstName().replace(/([^A-Z0-9._%+-])/ig, '').toLowerCase();
	    },
	
	    ip: function () {
	        var randNum = function () {
	            return (faker.random.number(255)).toFixed(0);
	        };
	
	        var result = [];
	        for (var i = 0; i < 4; i++) {
	            result[i] = randNum();
	        }
	
	        return result.join(".");
	    },
	
	    userAgent: function () {
	      return random_ua.generate();
	    },
	
	    color: function (baseRed255, baseGreen255, baseBlue255) {
	        baseRed255 = baseRed255 || 0;
	        baseGreen255 = baseGreen255 || 0;
	        baseBlue255 = baseBlue255 || 0;
	        // based on awesome response : http://stackoverflow.com/questions/43044/algorithm-to-randomly-generate-an-aesthetically-pleasing-color-palette
	        var red = Math.floor((faker.random.number(256) + baseRed255) / 2);
	        var green = Math.floor((faker.random.number(256) + baseGreen255) / 2);
	        var blue = Math.floor((faker.random.number(256) + baseBlue255) / 2);
	        var redStr = red.toString(16);
	        var greenStr = green.toString(16);
	        var blueStr = blue.toString(16);
	        return '#' +
	          (redStr.length === 1 ? '0' : '') + redStr +
	          (greenStr.length === 1 ? '0' : '') + greenStr +
	          (blueStr.length === 1 ? '0': '') + blueStr;
	
	    },
	
	    password: function (len, memorable, pattern, prefix) {
	      len = len || 15;
	      if (typeof memorable === "undefined") {
	        memorable = false;
	      }
	      return password_generator(len, memorable, pattern, prefix);
	    }
	};
	
	module.exports = internet;


/***/ },
/* 291 */
/***/ function(module, exports, __webpack_require__) {

	var faker = __webpack_require__(11);
	exports['de'] = __webpack_require__(292);
	exports['de_AT'] = __webpack_require__(293);
	exports['de_CH'] = __webpack_require__(294);
	exports['en'] = __webpack_require__(295);
	exports['en_AU'] = __webpack_require__(296);
	exports['en_BORK'] = __webpack_require__(297);
	exports['en_CA'] = __webpack_require__(298);
	exports['en_GB'] = __webpack_require__(299);
	exports['en_IND'] = __webpack_require__(300);
	exports['en_US'] = __webpack_require__(301);
	exports['en_au_ocker'] = __webpack_require__(302);
	exports['es'] = __webpack_require__(303);
	exports['fa'] = __webpack_require__(304);
	exports['fr'] = __webpack_require__(305);
	exports['ge'] = __webpack_require__(306);
	exports['it'] = __webpack_require__(307);
	exports['ja'] = __webpack_require__(308);
	exports['ko'] = __webpack_require__(309);
	exports['nb_NO'] = __webpack_require__(310);
	exports['nep'] = __webpack_require__(311);
	exports['nl'] = __webpack_require__(312);
	exports['pl'] = __webpack_require__(313);
	exports['pt_BR'] = __webpack_require__(314);
	exports['ru'] = __webpack_require__(315);
	exports['sk'] = __webpack_require__(316);
	exports['sv'] = __webpack_require__(317);
	exports['tr'] = __webpack_require__(318);
	exports['vi'] = __webpack_require__(319);
	exports['zh_CN'] = __webpack_require__(320);
	exports['zh_TW'] = __webpack_require__(321);

/***/ },
/* 292 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var de = {};
	module["exports"] = de;
	de.title = "German";
	de.address = {
	  "city_prefix": [
	    "Nord",
	    "Ost",
	    "West",
	    "Süd",
	    "Neu",
	    "Alt",
	    "Bad"
	  ],
	  "city_suffix": [
	    "stadt",
	    "dorf",
	    "land",
	    "scheid",
	    "burg"
	  ],
	  "country": [
	    "Ägypten",
	    "Äquatorialguinea",
	    "Äthiopien",
	    "Österreich",
	    "Afghanistan",
	    "Albanien",
	    "Algerien",
	    "Amerikanisch-Samoa",
	    "Amerikanische Jungferninseln",
	    "Andorra",
	    "Angola",
	    "Anguilla",
	    "Antarktis",
	    "Antigua und Barbuda",
	    "Argentinien",
	    "Armenien",
	    "Aruba",
	    "Aserbaidschan",
	    "Australien",
	    "Bahamas",
	    "Bahrain",
	    "Bangladesch",
	    "Barbados",
	    "Belarus",
	    "Belgien",
	    "Belize",
	    "Benin",
	    "die Bermudas",
	    "Bhutan",
	    "Bolivien",
	    "Bosnien und Herzegowina",
	    "Botsuana",
	    "Bouvetinsel",
	    "Brasilien",
	    "Britische Jungferninseln",
	    "Britisches Territorium im Indischen Ozean",
	    "Brunei Darussalam",
	    "Bulgarien",
	    "Burkina Faso",
	    "Burundi",
	    "Chile",
	    "China",
	    "Cookinseln",
	    "Costa Rica",
	    "Dänemark",
	    "Demokratische Republik Kongo",
	    "Demokratische Volksrepublik Korea",
	    "Deutschland",
	    "Dominica",
	    "Dominikanische Republik",
	    "Dschibuti",
	    "Ecuador",
	    "El Salvador",
	    "Eritrea",
	    "Estland",
	    "Färöer",
	    "Falklandinseln",
	    "Fidschi",
	    "Finnland",
	    "Frankreich",
	    "Französisch-Guayana",
	    "Französisch-Polynesien",
	    "Französische Gebiete im südlichen Indischen Ozean",
	    "Gabun",
	    "Gambia",
	    "Georgien",
	    "Ghana",
	    "Gibraltar",
	    "Grönland",
	    "Grenada",
	    "Griechenland",
	    "Guadeloupe",
	    "Guam",
	    "Guatemala",
	    "Guinea",
	    "Guinea-Bissau",
	    "Guyana",
	    "Haiti",
	    "Heard und McDonaldinseln",
	    "Honduras",
	    "Hongkong",
	    "Indien",
	    "Indonesien",
	    "Irak",
	    "Iran",
	    "Irland",
	    "Island",
	    "Israel",
	    "Italien",
	    "Jamaika",
	    "Japan",
	    "Jemen",
	    "Jordanien",
	    "Jugoslawien",
	    "Kaimaninseln",
	    "Kambodscha",
	    "Kamerun",
	    "Kanada",
	    "Kap Verde",
	    "Kasachstan",
	    "Katar",
	    "Kenia",
	    "Kirgisistan",
	    "Kiribati",
	    "Kleinere amerikanische Überseeinseln",
	    "Kokosinseln",
	    "Kolumbien",
	    "Komoren",
	    "Kongo",
	    "Kroatien",
	    "Kuba",
	    "Kuwait",
	    "Laos",
	    "Lesotho",
	    "Lettland",
	    "Libanon",
	    "Liberia",
	    "Libyen",
	    "Liechtenstein",
	    "Litauen",
	    "Luxemburg",
	    "Macau",
	    "Madagaskar",
	    "Malawi",
	    "Malaysia",
	    "Malediven",
	    "Mali",
	    "Malta",
	    "ehemalige jugoslawische Republik Mazedonien",
	    "Marokko",
	    "Marshallinseln",
	    "Martinique",
	    "Mauretanien",
	    "Mauritius",
	    "Mayotte",
	    "Mexiko",
	    "Mikronesien",
	    "Monaco",
	    "Mongolei",
	    "Montserrat",
	    "Mosambik",
	    "Myanmar",
	    "Nördliche Marianen",
	    "Namibia",
	    "Nauru",
	    "Nepal",
	    "Neukaledonien",
	    "Neuseeland",
	    "Nicaragua",
	    "Niederländische Antillen",
	    "Niederlande",
	    "Niger",
	    "Nigeria",
	    "Niue",
	    "Norfolkinsel",
	    "Norwegen",
	    "Oman",
	    "Osttimor",
	    "Pakistan",
	    "Palau",
	    "Panama",
	    "Papua-Neuguinea",
	    "Paraguay",
	    "Peru",
	    "Philippinen",
	    "Pitcairninseln",
	    "Polen",
	    "Portugal",
	    "Puerto Rico",
	    "Réunion",
	    "Republik Korea",
	    "Republik Moldau",
	    "Ruanda",
	    "Rumänien",
	    "Russische Föderation",
	    "São Tomé und Príncipe",
	    "Südafrika",
	    "Südgeorgien und Südliche Sandwichinseln",
	    "Salomonen",
	    "Sambia",
	    "Samoa",
	    "San Marino",
	    "Saudi-Arabien",
	    "Schweden",
	    "Schweiz",
	    "Senegal",
	    "Seychellen",
	    "Sierra Leone",
	    "Simbabwe",
	    "Singapur",
	    "Slowakei",
	    "Slowenien",
	    "Somalien",
	    "Spanien",
	    "Sri Lanka",
	    "St. Helena",
	    "St. Kitts und Nevis",
	    "St. Lucia",
	    "St. Pierre und Miquelon",
	    "St. Vincent und die Grenadinen",
	    "Sudan",
	    "Surinam",
	    "Svalbard und Jan Mayen",
	    "Swasiland",
	    "Syrien",
	    "Türkei",
	    "Tadschikistan",
	    "Taiwan",
	    "Tansania",
	    "Thailand",
	    "Togo",
	    "Tokelau",
	    "Tonga",
	    "Trinidad und Tobago",
	    "Tschad",
	    "Tschechische Republik",
	    "Tunesien",
	    "Turkmenistan",
	    "Turks- und Caicosinseln",
	    "Tuvalu",
	    "Uganda",
	    "Ukraine",
	    "Ungarn",
	    "Uruguay",
	    "Usbekistan",
	    "Vanuatu",
	    "Vatikanstadt",
	    "Venezuela",
	    "Vereinigte Arabische Emirate",
	    "Vereinigte Staaten",
	    "Vereinigtes Königreich",
	    "Vietnam",
	    "Wallis und Futuna",
	    "Weihnachtsinsel",
	    "Westsahara",
	    "Zentralafrikanische Republik",
	    "Zypern"
	  ],
	  "street_root": [
	    "Ackerweg",
	    "Adalbert-Stifter-Str.",
	    "Adalbertstr.",
	    "Adolf-Baeyer-Str.",
	    "Adolf-Kaschny-Str.",
	    "Adolf-Reichwein-Str.",
	    "Adolfsstr.",
	    "Ahornweg",
	    "Ahrstr.",
	    "Akazienweg",
	    "Albert-Einstein-Str.",
	    "Albert-Schweitzer-Str.",
	    "Albertus-Magnus-Str.",
	    "Albert-Zarthe-Weg",
	    "Albin-Edelmann-Str.",
	    "Albrecht-Haushofer-Str.",
	    "Aldegundisstr.",
	    "Alexanderstr.",
	    "Alfred-Delp-Str.",
	    "Alfred-Kubin-Str.",
	    "Alfred-Stock-Str.",
	    "Alkenrather Str.",
	    "Allensteiner Str.",
	    "Alsenstr.",
	    "Alt Steinbücheler Weg",
	    "Alte Garten",
	    "Alte Heide",
	    "Alte Landstr.",
	    "Alte Ziegelei",
	    "Altenberger Str.",
	    "Altenhof",
	    "Alter Grenzweg",
	    "Altstadtstr.",
	    "Am Alten Gaswerk",
	    "Am Alten Schafstall",
	    "Am Arenzberg",
	    "Am Benthal",
	    "Am Birkenberg",
	    "Am Blauen Berg",
	    "Am Borsberg",
	    "Am Brungen",
	    "Am Büchelter Hof",
	    "Am Buttermarkt",
	    "Am Ehrenfriedhof",
	    "Am Eselsdamm",
	    "Am Falkenberg",
	    "Am Frankenberg",
	    "Am Gesundheitspark",
	    "Am Gierlichshof",
	    "Am Graben",
	    "Am Hagelkreuz",
	    "Am Hang",
	    "Am Heidkamp",
	    "Am Hemmelrather Hof",
	    "Am Hofacker",
	    "Am Hohen Ufer",
	    "Am Höllers Eck",
	    "Am Hühnerberg",
	    "Am Jägerhof",
	    "Am Junkernkamp",
	    "Am Kemperstiegel",
	    "Am Kettnersbusch",
	    "Am Kiesberg",
	    "Am Klösterchen",
	    "Am Knechtsgraben",
	    "Am Köllerweg",
	    "Am Köttersbach",
	    "Am Kreispark",
	    "Am Kronefeld",
	    "Am Küchenhof",
	    "Am Kühnsbusch",
	    "Am Lindenfeld",
	    "Am Märchen",
	    "Am Mittelberg",
	    "Am Mönchshof",
	    "Am Mühlenbach",
	    "Am Neuenhof",
	    "Am Nonnenbruch",
	    "Am Plattenbusch",
	    "Am Quettinger Feld",
	    "Am Rosenhügel",
	    "Am Sandberg",
	    "Am Scherfenbrand",
	    "Am Schokker",
	    "Am Silbersee",
	    "Am Sonnenhang",
	    "Am Sportplatz",
	    "Am Stadtpark",
	    "Am Steinberg",
	    "Am Telegraf",
	    "Am Thelenhof",
	    "Am Vogelkreuz",
	    "Am Vogelsang",
	    "Am Vogelsfeldchen",
	    "Am Wambacher Hof",
	    "Am Wasserturm",
	    "Am Weidenbusch",
	    "Am Weiher",
	    "Am Weingarten",
	    "Am Werth",
	    "Amselweg",
	    "An den Irlen",
	    "An den Rheinauen",
	    "An der Bergerweide",
	    "An der Dingbank",
	    "An der Evangelischen Kirche",
	    "An der Evgl. Kirche",
	    "An der Feldgasse",
	    "An der Fettehenne",
	    "An der Kante",
	    "An der Laach",
	    "An der Lehmkuhle",
	    "An der Lichtenburg",
	    "An der Luisenburg",
	    "An der Robertsburg",
	    "An der Schmitten",
	    "An der Schusterinsel",
	    "An der Steinrütsch",
	    "An St. Andreas",
	    "An St. Remigius",
	    "Andreasstr.",
	    "Ankerweg",
	    "Annette-Kolb-Str.",
	    "Apenrader Str.",
	    "Arnold-Ohletz-Str.",
	    "Atzlenbacher Str.",
	    "Auerweg",
	    "Auestr.",
	    "Auf dem Acker",
	    "Auf dem Blahnenhof",
	    "Auf dem Bohnbüchel",
	    "Auf dem Bruch",
	    "Auf dem End",
	    "Auf dem Forst",
	    "Auf dem Herberg",
	    "Auf dem Lehn",
	    "Auf dem Stein",
	    "Auf dem Weierberg",
	    "Auf dem Weiherhahn",
	    "Auf den Reien",
	    "Auf der Donnen",
	    "Auf der Grieße",
	    "Auf der Ohmer",
	    "Auf der Weide",
	    "Auf'm Berg",
	    "Auf'm Kamp",
	    "Augustastr.",
	    "August-Kekulé-Str.",
	    "A.-W.-v.-Hofmann-Str.",
	    "Bahnallee",
	    "Bahnhofstr.",
	    "Baltrumstr.",
	    "Bamberger Str.",
	    "Baumberger Str.",
	    "Bebelstr.",
	    "Beckers Kämpchen",
	    "Beerenstr.",
	    "Beethovenstr.",
	    "Behringstr.",
	    "Bendenweg",
	    "Bensberger Str.",
	    "Benzstr.",
	    "Bergische Landstr.",
	    "Bergstr.",
	    "Berliner Platz",
	    "Berliner Str.",
	    "Bernhard-Letterhaus-Str.",
	    "Bernhard-Lichtenberg-Str.",
	    "Bernhard-Ridder-Str.",
	    "Bernsteinstr.",
	    "Bertha-Middelhauve-Str.",
	    "Bertha-von-Suttner-Str.",
	    "Bertolt-Brecht-Str.",
	    "Berzeliusstr.",
	    "Bielertstr.",
	    "Biesenbach",
	    "Billrothstr.",
	    "Birkenbergstr.",
	    "Birkengartenstr.",
	    "Birkenweg",
	    "Bismarckstr.",
	    "Bitterfelder Str.",
	    "Blankenburg",
	    "Blaukehlchenweg",
	    "Blütenstr.",
	    "Boberstr.",
	    "Böcklerstr.",
	    "Bodelschwinghstr.",
	    "Bodestr.",
	    "Bogenstr.",
	    "Bohnenkampsweg",
	    "Bohofsweg",
	    "Bonifatiusstr.",
	    "Bonner Str.",
	    "Borkumstr.",
	    "Bornheimer Str.",
	    "Borsigstr.",
	    "Borussiastr.",
	    "Bracknellstr.",
	    "Brahmsweg",
	    "Brandenburger Str.",
	    "Breidenbachstr.",
	    "Breslauer Str.",
	    "Bruchhauser Str.",
	    "Brückenstr.",
	    "Brucknerstr.",
	    "Brüder-Bonhoeffer-Str.",
	    "Buchenweg",
	    "Bürgerbuschweg",
	    "Burgloch",
	    "Burgplatz",
	    "Burgstr.",
	    "Burgweg",
	    "Bürriger Weg",
	    "Burscheider Str.",
	    "Buschkämpchen",
	    "Butterheider Str.",
	    "Carl-Duisberg-Platz",
	    "Carl-Duisberg-Str.",
	    "Carl-Leverkus-Str.",
	    "Carl-Maria-von-Weber-Platz",
	    "Carl-Maria-von-Weber-Str.",
	    "Carlo-Mierendorff-Str.",
	    "Carl-Rumpff-Str.",
	    "Carl-von-Ossietzky-Str.",
	    "Charlottenburger Str.",
	    "Christian-Heß-Str.",
	    "Claasbruch",
	    "Clemens-Winkler-Str.",
	    "Concordiastr.",
	    "Cranachstr.",
	    "Dahlemer Str.",
	    "Daimlerstr.",
	    "Damaschkestr.",
	    "Danziger Str.",
	    "Debengasse",
	    "Dechant-Fein-Str.",
	    "Dechant-Krey-Str.",
	    "Deichtorstr.",
	    "Dhünnberg",
	    "Dhünnstr.",
	    "Dianastr.",
	    "Diedenhofener Str.",
	    "Diepental",
	    "Diepenthaler Str.",
	    "Dieselstr.",
	    "Dillinger Str.",
	    "Distelkamp",
	    "Dohrgasse",
	    "Domblick",
	    "Dönhoffstr.",
	    "Dornierstr.",
	    "Drachenfelsstr.",
	    "Dr.-August-Blank-Str.",
	    "Dresdener Str.",
	    "Driescher Hecke",
	    "Drosselweg",
	    "Dudweilerstr.",
	    "Dünenweg",
	    "Dünfelder Str.",
	    "Dünnwalder Grenzweg",
	    "Düppeler Str.",
	    "Dürerstr.",
	    "Dürscheider Weg",
	    "Düsseldorfer Str.",
	    "Edelrather Weg",
	    "Edmund-Husserl-Str.",
	    "Eduard-Spranger-Str.",
	    "Ehrlichstr.",
	    "Eichenkamp",
	    "Eichenweg",
	    "Eidechsenweg",
	    "Eifelstr.",
	    "Eifgenstr.",
	    "Eintrachtstr.",
	    "Elbestr.",
	    "Elisabeth-Langgässer-Str.",
	    "Elisabethstr.",
	    "Elisabeth-von-Thadden-Str.",
	    "Elisenstr.",
	    "Elsa-Brändström-Str.",
	    "Elsbachstr.",
	    "Else-Lasker-Schüler-Str.",
	    "Elsterstr.",
	    "Emil-Fischer-Str.",
	    "Emil-Nolde-Str.",
	    "Engelbertstr.",
	    "Engstenberger Weg",
	    "Entenpfuhl",
	    "Erbelegasse",
	    "Erftstr.",
	    "Erfurter Str.",
	    "Erich-Heckel-Str.",
	    "Erich-Klausener-Str.",
	    "Erich-Ollenhauer-Str.",
	    "Erlenweg",
	    "Ernst-Bloch-Str.",
	    "Ernst-Ludwig-Kirchner-Str.",
	    "Erzbergerstr.",
	    "Eschenallee",
	    "Eschenweg",
	    "Esmarchstr.",
	    "Espenweg",
	    "Euckenstr.",
	    "Eulengasse",
	    "Eulenkamp",
	    "Ewald-Flamme-Str.",
	    "Ewald-Röll-Str.",
	    "Fährstr.",
	    "Farnweg",
	    "Fasanenweg",
	    "Faßbacher Hof",
	    "Felderstr.",
	    "Feldkampstr.",
	    "Feldsiefer Weg",
	    "Feldsiefer Wiesen",
	    "Feldstr.",
	    "Feldtorstr.",
	    "Felix-von-Roll-Str.",
	    "Ferdinand-Lassalle-Str.",
	    "Fester Weg",
	    "Feuerbachstr.",
	    "Feuerdornweg",
	    "Fichtenweg",
	    "Fichtestr.",
	    "Finkelsteinstr.",
	    "Finkenweg",
	    "Fixheider Str.",
	    "Flabbenhäuschen",
	    "Flensburger Str.",
	    "Fliederweg",
	    "Florastr.",
	    "Florianweg",
	    "Flotowstr.",
	    "Flurstr.",
	    "Föhrenweg",
	    "Fontanestr.",
	    "Forellental",
	    "Fortunastr.",
	    "Franz-Esser-Str.",
	    "Franz-Hitze-Str.",
	    "Franz-Kail-Str.",
	    "Franz-Marc-Str.",
	    "Freiburger Str.",
	    "Freiheitstr.",
	    "Freiherr-vom-Stein-Str.",
	    "Freudenthal",
	    "Freudenthaler Weg",
	    "Fridtjof-Nansen-Str.",
	    "Friedenberger Str.",
	    "Friedensstr.",
	    "Friedhofstr.",
	    "Friedlandstr.",
	    "Friedlieb-Ferdinand-Runge-Str.",
	    "Friedrich-Bayer-Str.",
	    "Friedrich-Bergius-Platz",
	    "Friedrich-Ebert-Platz",
	    "Friedrich-Ebert-Str.",
	    "Friedrich-Engels-Str.",
	    "Friedrich-List-Str.",
	    "Friedrich-Naumann-Str.",
	    "Friedrich-Sertürner-Str.",
	    "Friedrichstr.",
	    "Friedrich-Weskott-Str.",
	    "Friesenweg",
	    "Frischenberg",
	    "Fritz-Erler-Str.",
	    "Fritz-Henseler-Str.",
	    "Fröbelstr.",
	    "Fürstenbergplatz",
	    "Fürstenbergstr.",
	    "Gabriele-Münter-Str.",
	    "Gartenstr.",
	    "Gebhardstr.",
	    "Geibelstr.",
	    "Gellertstr.",
	    "Georg-von-Vollmar-Str.",
	    "Gerhard-Domagk-Str.",
	    "Gerhart-Hauptmann-Str.",
	    "Gerichtsstr.",
	    "Geschwister-Scholl-Str.",
	    "Gezelinallee",
	    "Gierener Weg",
	    "Ginsterweg",
	    "Gisbert-Cremer-Str.",
	    "Glücksburger Str.",
	    "Gluckstr.",
	    "Gneisenaustr.",
	    "Goetheplatz",
	    "Goethestr.",
	    "Golo-Mann-Str.",
	    "Görlitzer Str.",
	    "Görresstr.",
	    "Graebestr.",
	    "Graf-Galen-Platz",
	    "Gregor-Mendel-Str.",
	    "Greifswalder Str.",
	    "Grillenweg",
	    "Gronenborner Weg",
	    "Große Kirchstr.",
	    "Grunder Wiesen",
	    "Grundermühle",
	    "Grundermühlenhof",
	    "Grundermühlenweg",
	    "Grüner Weg",
	    "Grunewaldstr.",
	    "Grünstr.",
	    "Günther-Weisenborn-Str.",
	    "Gustav-Freytag-Str.",
	    "Gustav-Heinemann-Str.",
	    "Gustav-Radbruch-Str.",
	    "Gut Reuschenberg",
	    "Gutenbergstr.",
	    "Haberstr.",
	    "Habichtgasse",
	    "Hafenstr.",
	    "Hagenauer Str.",
	    "Hahnenblecher",
	    "Halenseestr.",
	    "Halfenleimbach",
	    "Hallesche Str.",
	    "Halligstr.",
	    "Hamberger Str.",
	    "Hammerweg",
	    "Händelstr.",
	    "Hannah-Höch-Str.",
	    "Hans-Arp-Str.",
	    "Hans-Gerhard-Str.",
	    "Hans-Sachs-Str.",
	    "Hans-Schlehahn-Str.",
	    "Hans-von-Dohnanyi-Str.",
	    "Hardenbergstr.",
	    "Haselweg",
	    "Hauptstr.",
	    "Haus-Vorster-Str.",
	    "Hauweg",
	    "Havelstr.",
	    "Havensteinstr.",
	    "Haydnstr.",
	    "Hebbelstr.",
	    "Heckenweg",
	    "Heerweg",
	    "Hegelstr.",
	    "Heidberg",
	    "Heidehöhe",
	    "Heidestr.",
	    "Heimstättenweg",
	    "Heinrich-Böll-Str.",
	    "Heinrich-Brüning-Str.",
	    "Heinrich-Claes-Str.",
	    "Heinrich-Heine-Str.",
	    "Heinrich-Hörlein-Str.",
	    "Heinrich-Lübke-Str.",
	    "Heinrich-Lützenkirchen-Weg",
	    "Heinrichstr.",
	    "Heinrich-Strerath-Str.",
	    "Heinrich-von-Kleist-Str.",
	    "Heinrich-von-Stephan-Str.",
	    "Heisterbachstr.",
	    "Helenenstr.",
	    "Helmestr.",
	    "Hemmelrather Weg",
	    "Henry-T.-v.-Böttinger-Str.",
	    "Herderstr.",
	    "Heribertstr.",
	    "Hermann-Ehlers-Str.",
	    "Hermann-Hesse-Str.",
	    "Hermann-König-Str.",
	    "Hermann-Löns-Str.",
	    "Hermann-Milde-Str.",
	    "Hermann-Nörrenberg-Str.",
	    "Hermann-von-Helmholtz-Str.",
	    "Hermann-Waibel-Str.",
	    "Herzogstr.",
	    "Heymannstr.",
	    "Hindenburgstr.",
	    "Hirzenberg",
	    "Hitdorfer Kirchweg",
	    "Hitdorfer Str.",
	    "Höfer Mühle",
	    "Höfer Weg",
	    "Hohe Str.",
	    "Höhenstr.",
	    "Höltgestal",
	    "Holunderweg",
	    "Holzer Weg",
	    "Holzer Wiesen",
	    "Hornpottweg",
	    "Hubertusweg",
	    "Hufelandstr.",
	    "Hufer Weg",
	    "Humboldtstr.",
	    "Hummelsheim",
	    "Hummelweg",
	    "Humperdinckstr.",
	    "Hüscheider Gärten",
	    "Hüscheider Str.",
	    "Hütte",
	    "Ilmstr.",
	    "Im Bergischen Heim",
	    "Im Bruch",
	    "Im Buchenhain",
	    "Im Bühl",
	    "Im Burgfeld",
	    "Im Dorf",
	    "Im Eisholz",
	    "Im Friedenstal",
	    "Im Frohental",
	    "Im Grunde",
	    "Im Hederichsfeld",
	    "Im Jücherfeld",
	    "Im Kalkfeld",
	    "Im Kirberg",
	    "Im Kirchfeld",
	    "Im Kreuzbruch",
	    "Im Mühlenfeld",
	    "Im Nesselrader Kamp",
	    "Im Oberdorf",
	    "Im Oberfeld",
	    "Im Rosengarten",
	    "Im Rottland",
	    "Im Scheffengarten",
	    "Im Staderfeld",
	    "Im Steinfeld",
	    "Im Weidenblech",
	    "Im Winkel",
	    "Im Ziegelfeld",
	    "Imbach",
	    "Imbacher Weg",
	    "Immenweg",
	    "In den Blechenhöfen",
	    "In den Dehlen",
	    "In der Birkenau",
	    "In der Dasladen",
	    "In der Felderhütten",
	    "In der Hartmannswiese",
	    "In der Höhle",
	    "In der Schaafsdellen",
	    "In der Wasserkuhl",
	    "In der Wüste",
	    "In Holzhausen",
	    "Insterstr.",
	    "Jacob-Fröhlen-Str.",
	    "Jägerstr.",
	    "Jahnstr.",
	    "Jakob-Eulenberg-Weg",
	    "Jakobistr.",
	    "Jakob-Kaiser-Str.",
	    "Jenaer Str.",
	    "Johannes-Baptist-Str.",
	    "Johannes-Dott-Str.",
	    "Johannes-Popitz-Str.",
	    "Johannes-Wislicenus-Str.",
	    "Johannisburger Str.",
	    "Johann-Janssen-Str.",
	    "Johann-Wirtz-Weg",
	    "Josefstr.",
	    "Jüch",
	    "Julius-Doms-Str.",
	    "Julius-Leber-Str.",
	    "Kaiserplatz",
	    "Kaiserstr.",
	    "Kaiser-Wilhelm-Allee",
	    "Kalkstr.",
	    "Kämpchenstr.",
	    "Kämpenwiese",
	    "Kämper Weg",
	    "Kamptalweg",
	    "Kanalstr.",
	    "Kandinskystr.",
	    "Kantstr.",
	    "Kapellenstr.",
	    "Karl-Arnold-Str.",
	    "Karl-Bosch-Str.",
	    "Karl-Bückart-Str.",
	    "Karl-Carstens-Ring",
	    "Karl-Friedrich-Goerdeler-Str.",
	    "Karl-Jaspers-Str.",
	    "Karl-König-Str.",
	    "Karl-Krekeler-Str.",
	    "Karl-Marx-Str.",
	    "Karlstr.",
	    "Karl-Ulitzka-Str.",
	    "Karl-Wichmann-Str.",
	    "Karl-Wingchen-Str.",
	    "Käsenbrod",
	    "Käthe-Kollwitz-Str.",
	    "Katzbachstr.",
	    "Kerschensteinerstr.",
	    "Kiefernweg",
	    "Kieler Str.",
	    "Kieselstr.",
	    "Kiesweg",
	    "Kinderhausen",
	    "Kleiberweg",
	    "Kleine Kirchstr.",
	    "Kleingansweg",
	    "Kleinheider Weg",
	    "Klief",
	    "Kneippstr.",
	    "Knochenbergsweg",
	    "Kochergarten",
	    "Kocherstr.",
	    "Kockelsberg",
	    "Kolberger Str.",
	    "Kolmarer Str.",
	    "Kölner Gasse",
	    "Kölner Str.",
	    "Kolpingstr.",
	    "Königsberger Platz",
	    "Konrad-Adenauer-Platz",
	    "Köpenicker Str.",
	    "Kopernikusstr.",
	    "Körnerstr.",
	    "Köschenberg",
	    "Köttershof",
	    "Kreuzbroicher Str.",
	    "Kreuzkamp",
	    "Krummer Weg",
	    "Kruppstr.",
	    "Kuhlmannweg",
	    "Kump",
	    "Kumper Weg",
	    "Kunstfeldstr.",
	    "Küppersteger Str.",
	    "Kursiefen",
	    "Kursiefer Weg",
	    "Kurtekottenweg",
	    "Kurt-Schumacher-Ring",
	    "Kyllstr.",
	    "Langenfelder Str.",
	    "Längsleimbach",
	    "Lärchenweg",
	    "Legienstr.",
	    "Lehner Mühle",
	    "Leichlinger Str.",
	    "Leimbacher Hof",
	    "Leinestr.",
	    "Leineweberstr.",
	    "Leipziger Str.",
	    "Lerchengasse",
	    "Lessingstr.",
	    "Libellenweg",
	    "Lichstr.",
	    "Liebigstr.",
	    "Lindenstr.",
	    "Lingenfeld",
	    "Linienstr.",
	    "Lippe",
	    "Löchergraben",
	    "Löfflerstr.",
	    "Loheweg",
	    "Lohrbergstr.",
	    "Lohrstr.",
	    "Löhstr.",
	    "Lortzingstr.",
	    "Lötzener Str.",
	    "Löwenburgstr.",
	    "Lucasstr.",
	    "Ludwig-Erhard-Platz",
	    "Ludwig-Girtler-Str.",
	    "Ludwig-Knorr-Str.",
	    "Luisenstr.",
	    "Lupinenweg",
	    "Lurchenweg",
	    "Lützenkirchener Str.",
	    "Lycker Str.",
	    "Maashofstr.",
	    "Manforter Str.",
	    "Marc-Chagall-Str.",
	    "Maria-Dresen-Str.",
	    "Maria-Terwiel-Str.",
	    "Marie-Curie-Str.",
	    "Marienburger Str.",
	    "Mariendorfer Str.",
	    "Marienwerderstr.",
	    "Marie-Schlei-Str.",
	    "Marktplatz",
	    "Markusweg",
	    "Martin-Buber-Str.",
	    "Martin-Heidegger-Str.",
	    "Martin-Luther-Str.",
	    "Masurenstr.",
	    "Mathildenweg",
	    "Maurinusstr.",
	    "Mauspfad",
	    "Max-Beckmann-Str.",
	    "Max-Delbrück-Str.",
	    "Max-Ernst-Str.",
	    "Max-Holthausen-Platz",
	    "Max-Horkheimer-Str.",
	    "Max-Liebermann-Str.",
	    "Max-Pechstein-Str.",
	    "Max-Planck-Str.",
	    "Max-Scheler-Str.",
	    "Max-Schönenberg-Str.",
	    "Maybachstr.",
	    "Meckhofer Feld",
	    "Meisenweg",
	    "Memelstr.",
	    "Menchendahler Str.",
	    "Mendelssohnstr.",
	    "Merziger Str.",
	    "Mettlacher Str.",
	    "Metzer Str.",
	    "Michaelsweg",
	    "Miselohestr.",
	    "Mittelstr.",
	    "Mohlenstr.",
	    "Moltkestr.",
	    "Monheimer Str.",
	    "Montanusstr.",
	    "Montessoriweg",
	    "Moosweg",
	    "Morsbroicher Str.",
	    "Moselstr.",
	    "Moskauer Str.",
	    "Mozartstr.",
	    "Mühlenweg",
	    "Muhrgasse",
	    "Muldestr.",
	    "Mülhausener Str.",
	    "Mülheimer Str.",
	    "Münsters Gäßchen",
	    "Münzstr.",
	    "Müritzstr.",
	    "Myliusstr.",
	    "Nachtigallenweg",
	    "Nauener Str.",
	    "Neißestr.",
	    "Nelly-Sachs-Str.",
	    "Netzestr.",
	    "Neuendriesch",
	    "Neuenhausgasse",
	    "Neuenkamp",
	    "Neujudenhof",
	    "Neukronenberger Str.",
	    "Neustadtstr.",
	    "Nicolai-Hartmann-Str.",
	    "Niederblecher",
	    "Niederfeldstr.",
	    "Nietzschestr.",
	    "Nikolaus-Groß-Str.",
	    "Nobelstr.",
	    "Norderneystr.",
	    "Nordstr.",
	    "Ober dem Hof",
	    "Obere Lindenstr.",
	    "Obere Str.",
	    "Oberölbach",
	    "Odenthaler Str.",
	    "Oderstr.",
	    "Okerstr.",
	    "Olof-Palme-Str.",
	    "Ophovener Str.",
	    "Opladener Platz",
	    "Opladener Str.",
	    "Ortelsburger Str.",
	    "Oskar-Moll-Str.",
	    "Oskar-Schlemmer-Str.",
	    "Oststr.",
	    "Oswald-Spengler-Str.",
	    "Otto-Dix-Str.",
	    "Otto-Grimm-Str.",
	    "Otto-Hahn-Str.",
	    "Otto-Müller-Str.",
	    "Otto-Stange-Str.",
	    "Ottostr.",
	    "Otto-Varnhagen-Str.",
	    "Otto-Wels-Str.",
	    "Ottweilerstr.",
	    "Oulustr.",
	    "Overfeldweg",
	    "Pappelweg",
	    "Paracelsusstr.",
	    "Parkstr.",
	    "Pastor-Louis-Str.",
	    "Pastor-Scheibler-Str.",
	    "Pastorskamp",
	    "Paul-Klee-Str.",
	    "Paul-Löbe-Str.",
	    "Paulstr.",
	    "Peenestr.",
	    "Pescher Busch",
	    "Peschstr.",
	    "Pestalozzistr.",
	    "Peter-Grieß-Str.",
	    "Peter-Joseph-Lenné-Str.",
	    "Peter-Neuenheuser-Str.",
	    "Petersbergstr.",
	    "Peterstr.",
	    "Pfarrer-Jekel-Str.",
	    "Pfarrer-Klein-Str.",
	    "Pfarrer-Röhr-Str.",
	    "Pfeilshofstr.",
	    "Philipp-Ott-Str.",
	    "Piet-Mondrian-Str.",
	    "Platanenweg",
	    "Pommernstr.",
	    "Porschestr.",
	    "Poststr.",
	    "Potsdamer Str.",
	    "Pregelstr.",
	    "Prießnitzstr.",
	    "Pützdelle",
	    "Quarzstr.",
	    "Quettinger Str.",
	    "Rat-Deycks-Str.",
	    "Rathenaustr.",
	    "Ratherkämp",
	    "Ratiborer Str.",
	    "Raushofstr.",
	    "Regensburger Str.",
	    "Reinickendorfer Str.",
	    "Renkgasse",
	    "Rennbaumplatz",
	    "Rennbaumstr.",
	    "Reuschenberger Str.",
	    "Reusrather Str.",
	    "Reuterstr.",
	    "Rheinallee",
	    "Rheindorfer Str.",
	    "Rheinstr.",
	    "Rhein-Wupper-Platz",
	    "Richard-Wagner-Str.",
	    "Rilkestr.",
	    "Ringstr.",
	    "Robert-Blum-Str.",
	    "Robert-Koch-Str.",
	    "Robert-Medenwald-Str.",
	    "Rolandstr.",
	    "Romberg",
	    "Röntgenstr.",
	    "Roonstr.",
	    "Ropenstall",
	    "Ropenstaller Weg",
	    "Rosenthal",
	    "Rostocker Str.",
	    "Rotdornweg",
	    "Röttgerweg",
	    "Rückertstr.",
	    "Rudolf-Breitscheid-Str.",
	    "Rudolf-Mann-Platz",
	    "Rudolf-Stracke-Str.",
	    "Ruhlachplatz",
	    "Ruhlachstr.",
	    "Rüttersweg",
	    "Saalestr.",
	    "Saarbrücker Str.",
	    "Saarlauterner Str.",
	    "Saarstr.",
	    "Salamanderweg",
	    "Samlandstr.",
	    "Sanddornstr.",
	    "Sandstr.",
	    "Sauerbruchstr.",
	    "Schäfershütte",
	    "Scharnhorststr.",
	    "Scheffershof",
	    "Scheidemannstr.",
	    "Schellingstr.",
	    "Schenkendorfstr.",
	    "Schießbergstr.",
	    "Schillerstr.",
	    "Schlangenhecke",
	    "Schlebuscher Heide",
	    "Schlebuscher Str.",
	    "Schlebuschrath",
	    "Schlehdornstr.",
	    "Schleiermacherstr.",
	    "Schloßstr.",
	    "Schmalenbruch",
	    "Schnepfenflucht",
	    "Schöffenweg",
	    "Schöllerstr.",
	    "Schöne Aussicht",
	    "Schöneberger Str.",
	    "Schopenhauerstr.",
	    "Schubertplatz",
	    "Schubertstr.",
	    "Schulberg",
	    "Schulstr.",
	    "Schumannstr.",
	    "Schwalbenweg",
	    "Schwarzastr.",
	    "Sebastianusweg",
	    "Semmelweisstr.",
	    "Siebelplatz",
	    "Siemensstr.",
	    "Solinger Str.",
	    "Sonderburger Str.",
	    "Spandauer Str.",
	    "Speestr.",
	    "Sperberweg",
	    "Sperlingsweg",
	    "Spitzwegstr.",
	    "Sporrenberger Mühle",
	    "Spreestr.",
	    "St. Ingberter Str.",
	    "Starenweg",
	    "Stauffenbergstr.",
	    "Stefan-Zweig-Str.",
	    "Stegerwaldstr.",
	    "Steglitzer Str.",
	    "Steinbücheler Feld",
	    "Steinbücheler Str.",
	    "Steinstr.",
	    "Steinweg",
	    "Stephan-Lochner-Str.",
	    "Stephanusstr.",
	    "Stettiner Str.",
	    "Stixchesstr.",
	    "Stöckenstr.",
	    "Stralsunder Str.",
	    "Straßburger Str.",
	    "Stresemannplatz",
	    "Strombergstr.",
	    "Stromstr.",
	    "Stüttekofener Str.",
	    "Sudestr.",
	    "Sürderstr.",
	    "Syltstr.",
	    "Talstr.",
	    "Tannenbergstr.",
	    "Tannenweg",
	    "Taubenweg",
	    "Teitscheider Weg",
	    "Telegrafenstr.",
	    "Teltower Str.",
	    "Tempelhofer Str.",
	    "Theodor-Adorno-Str.",
	    "Theodor-Fliedner-Str.",
	    "Theodor-Gierath-Str.",
	    "Theodor-Haubach-Str.",
	    "Theodor-Heuss-Ring",
	    "Theodor-Storm-Str.",
	    "Theodorstr.",
	    "Thomas-Dehler-Str.",
	    "Thomas-Morus-Str.",
	    "Thomas-von-Aquin-Str.",
	    "Tönges Feld",
	    "Torstr.",
	    "Treptower Str.",
	    "Treuburger Str.",
	    "Uhlandstr.",
	    "Ulmenweg",
	    "Ulmer Str.",
	    "Ulrichstr.",
	    "Ulrich-von-Hassell-Str.",
	    "Umlag",
	    "Unstrutstr.",
	    "Unter dem Schildchen",
	    "Unterölbach",
	    "Unterstr.",
	    "Uppersberg",
	    "Van\\'t-Hoff-Str.",
	    "Veit-Stoß-Str.",
	    "Vereinsstr.",
	    "Viktor-Meyer-Str.",
	    "Vincent-van-Gogh-Str.",
	    "Virchowstr.",
	    "Voigtslach",
	    "Volhardstr.",
	    "Völklinger Str.",
	    "Von-Brentano-Str.",
	    "Von-Diergardt-Str.",
	    "Von-Eichendorff-Str.",
	    "Von-Ketteler-Str.",
	    "Von-Knoeringen-Str.",
	    "Von-Pettenkofer-Str.",
	    "Von-Siebold-Str.",
	    "Wacholderweg",
	    "Waldstr.",
	    "Walter-Flex-Str.",
	    "Walter-Hempel-Str.",
	    "Walter-Hochapfel-Str.",
	    "Walter-Nernst-Str.",
	    "Wannseestr.",
	    "Warnowstr.",
	    "Warthestr.",
	    "Weddigenstr.",
	    "Weichselstr.",
	    "Weidenstr.",
	    "Weidfeldstr.",
	    "Weiherfeld",
	    "Weiherstr.",
	    "Weinhäuser Str.",
	    "Weißdornweg",
	    "Weißenseestr.",
	    "Weizkamp",
	    "Werftstr.",
	    "Werkstättenstr.",
	    "Werner-Heisenberg-Str.",
	    "Werrastr.",
	    "Weyerweg",
	    "Widdauener Str.",
	    "Wiebertshof",
	    "Wiehbachtal",
	    "Wiembachallee",
	    "Wiesdorfer Platz",
	    "Wiesenstr.",
	    "Wilhelm-Busch-Str.",
	    "Wilhelm-Hastrich-Str.",
	    "Wilhelm-Leuschner-Str.",
	    "Wilhelm-Liebknecht-Str.",
	    "Wilhelmsgasse",
	    "Wilhelmstr.",
	    "Willi-Baumeister-Str.",
	    "Willy-Brandt-Ring",
	    "Winand-Rossi-Str.",
	    "Windthorststr.",
	    "Winkelweg",
	    "Winterberg",
	    "Wittenbergstr.",
	    "Wolf-Vostell-Str.",
	    "Wolkenburgstr.",
	    "Wupperstr.",
	    "Wuppertalstr.",
	    "Wüstenhof",
	    "Yitzhak-Rabin-Str.",
	    "Zauberkuhle",
	    "Zedernweg",
	    "Zehlendorfer Str.",
	    "Zehntenweg",
	    "Zeisigweg",
	    "Zeppelinstr.",
	    "Zschopaustr.",
	    "Zum Claashäuschen",
	    "Zündhütchenweg",
	    "Zur Alten Brauerei",
	    "Zur alten Fabrik"
	  ],
	  "building_number": [
	    "###",
	    "##",
	    "#",
	    "##a",
	    "##b",
	    "##c"
	  ],
	  "secondary_address": [
	    "Apt. ###",
	    "Zimmer ###",
	    "# OG"
	  ],
	  "postcode": [
	    "#####",
	    "#####"
	  ],
	  "state": [
	    "Baden-Württemberg",
	    "Bayern",
	    "Berlin",
	    "Brandenburg",
	    "Bremen",
	    "Hamburg",
	    "Hessen",
	    "Mecklenburg-Vorpommern",
	    "Niedersachsen",
	    "Nordrhein-Westfalen",
	    "Rheinland-Pfalz",
	    "Saarland",
	    "Sachsen",
	    "Sachsen-Anhalt",
	    "Schleswig-Holstein",
	    "Thüringen"
	  ],
	  "state_abbr": [
	    "BW",
	    "BY",
	    "BE",
	    "BB",
	    "HB",
	    "HH",
	    "HE",
	    "MV",
	    "NI",
	    "NW",
	    "RP",
	    "SL",
	    "SN",
	    "ST",
	    "SH",
	    "TH"
	  ],
	  "city": [
	    "#{city_prefix} #{Name.first_name}#{city_suffix}",
	    "#{city_prefix} #{Name.first_name}",
	    "#{Name.first_name}#{city_suffix}",
	    "#{Name.last_name}#{city_suffix}"
	  ],
	  "street_name": [
	    "#{street_root}"
	  ],
	  "street_address": [
	    "#{street_name} #{building_number}"
	  ],
	  "default_country": [
	    "Deutschland"
	  ]
	};
	de.company = {
	  "suffix": [
	    "GmbH",
	    "AG",
	    "Gruppe",
	    "KG",
	    "GmbH & Co. KG",
	    "UG",
	    "OHG"
	  ],
	  "legal_form": [
	    "GmbH",
	    "AG",
	    "Gruppe",
	    "KG",
	    "GmbH & Co. KG",
	    "UG",
	    "OHG"
	  ],
	  "name": [
	    "#{Name.last_name} #{suffix}",
	    "#{Name.last_name}-#{Name.last_name}",
	    "#{Name.last_name}, #{Name.last_name} und #{Name.last_name}"
	  ]
	};
	de.internet = {
	  "free_email": [
	    "gmail.com",
	    "yahoo.com",
	    "hotmail.com"
	  ],
	  "domain_suffix": [
	    "com",
	    "info",
	    "name",
	    "net",
	    "org",
	    "de",
	    "ch"
	  ]
	};
	de.lorem = {
	  "words": [
	    "alias",
	    "consequatur",
	    "aut",
	    "perferendis",
	    "sit",
	    "voluptatem",
	    "accusantium",
	    "doloremque",
	    "aperiam",
	    "eaque",
	    "ipsa",
	    "quae",
	    "ab",
	    "illo",
	    "inventore",
	    "veritatis",
	    "et",
	    "quasi",
	    "architecto",
	    "beatae",
	    "vitae",
	    "dicta",
	    "sunt",
	    "explicabo",
	    "aspernatur",
	    "aut",
	    "odit",
	    "aut",
	    "fugit",
	    "sed",
	    "quia",
	    "consequuntur",
	    "magni",
	    "dolores",
	    "eos",
	    "qui",
	    "ratione",
	    "voluptatem",
	    "sequi",
	    "nesciunt",
	    "neque",
	    "dolorem",
	    "ipsum",
	    "quia",
	    "dolor",
	    "sit",
	    "amet",
	    "consectetur",
	    "adipisci",
	    "velit",
	    "sed",
	    "quia",
	    "non",
	    "numquam",
	    "eius",
	    "modi",
	    "tempora",
	    "incidunt",
	    "ut",
	    "labore",
	    "et",
	    "dolore",
	    "magnam",
	    "aliquam",
	    "quaerat",
	    "voluptatem",
	    "ut",
	    "enim",
	    "ad",
	    "minima",
	    "veniam",
	    "quis",
	    "nostrum",
	    "exercitationem",
	    "ullam",
	    "corporis",
	    "nemo",
	    "enim",
	    "ipsam",
	    "voluptatem",
	    "quia",
	    "voluptas",
	    "sit",
	    "suscipit",
	    "laboriosam",
	    "nisi",
	    "ut",
	    "aliquid",
	    "ex",
	    "ea",
	    "commodi",
	    "consequatur",
	    "quis",
	    "autem",
	    "vel",
	    "eum",
	    "iure",
	    "reprehenderit",
	    "qui",
	    "in",
	    "ea",
	    "voluptate",
	    "velit",
	    "esse",
	    "quam",
	    "nihil",
	    "molestiae",
	    "et",
	    "iusto",
	    "odio",
	    "dignissimos",
	    "ducimus",
	    "qui",
	    "blanditiis",
	    "praesentium",
	    "laudantium",
	    "totam",
	    "rem",
	    "voluptatum",
	    "deleniti",
	    "atque",
	    "corrupti",
	    "quos",
	    "dolores",
	    "et",
	    "quas",
	    "molestias",
	    "excepturi",
	    "sint",
	    "occaecati",
	    "cupiditate",
	    "non",
	    "provident",
	    "sed",
	    "ut",
	    "perspiciatis",
	    "unde",
	    "omnis",
	    "iste",
	    "natus",
	    "error",
	    "similique",
	    "sunt",
	    "in",
	    "culpa",
	    "qui",
	    "officia",
	    "deserunt",
	    "mollitia",
	    "animi",
	    "id",
	    "est",
	    "laborum",
	    "et",
	    "dolorum",
	    "fuga",
	    "et",
	    "harum",
	    "quidem",
	    "rerum",
	    "facilis",
	    "est",
	    "et",
	    "expedita",
	    "distinctio",
	    "nam",
	    "libero",
	    "tempore",
	    "cum",
	    "soluta",
	    "nobis",
	    "est",
	    "eligendi",
	    "optio",
	    "cumque",
	    "nihil",
	    "impedit",
	    "quo",
	    "porro",
	    "quisquam",
	    "est",
	    "qui",
	    "minus",
	    "id",
	    "quod",
	    "maxime",
	    "placeat",
	    "facere",
	    "possimus",
	    "omnis",
	    "voluptas",
	    "assumenda",
	    "est",
	    "omnis",
	    "dolor",
	    "repellendus",
	    "temporibus",
	    "autem",
	    "quibusdam",
	    "et",
	    "aut",
	    "consequatur",
	    "vel",
	    "illum",
	    "qui",
	    "dolorem",
	    "eum",
	    "fugiat",
	    "quo",
	    "voluptas",
	    "nulla",
	    "pariatur",
	    "at",
	    "vero",
	    "eos",
	    "et",
	    "accusamus",
	    "officiis",
	    "debitis",
	    "aut",
	    "rerum",
	    "necessitatibus",
	    "saepe",
	    "eveniet",
	    "ut",
	    "et",
	    "voluptates",
	    "repudiandae",
	    "sint",
	    "et",
	    "molestiae",
	    "non",
	    "recusandae",
	    "itaque",
	    "earum",
	    "rerum",
	    "hic",
	    "tenetur",
	    "a",
	    "sapiente",
	    "delectus",
	    "ut",
	    "aut",
	    "reiciendis",
	    "voluptatibus",
	    "maiores",
	    "doloribus",
	    "asperiores",
	    "repellat"
	  ]
	};
	de.name = {
	  "first_name": [
	    "Aaron",
	    "Abdul",
	    "Abdullah",
	    "Adam",
	    "Adrian",
	    "Adriano",
	    "Ahmad",
	    "Ahmed",
	    "Ahmet",
	    "Alan",
	    "Albert",
	    "Alessandro",
	    "Alessio",
	    "Alex",
	    "Alexander",
	    "Alfred",
	    "Ali",
	    "Amar",
	    "Amir",
	    "Amon",
	    "Andre",
	    "Andreas",
	    "Andrew",
	    "Angelo",
	    "Ansgar",
	    "Anthony",
	    "Anton",
	    "Antonio",
	    "Arda",
	    "Arian",
	    "Armin",
	    "Arne",
	    "Arno",
	    "Arthur",
	    "Artur",
	    "Arved",
	    "Arvid",
	    "Ayman",
	    "Baran",
	    "Baris",
	    "Bastian",
	    "Batuhan",
	    "Bela",
	    "Ben",
	    "Benedikt",
	    "Benjamin",
	    "Bennet",
	    "Bennett",
	    "Benno",
	    "Bent",
	    "Berat",
	    "Berkay",
	    "Bernd",
	    "Bilal",
	    "Bjarne",
	    "Björn",
	    "Bo",
	    "Boris",
	    "Brandon",
	    "Brian",
	    "Bruno",
	    "Bryan",
	    "Burak",
	    "Calvin",
	    "Can",
	    "Carl",
	    "Carlo",
	    "Carlos",
	    "Caspar",
	    "Cedric",
	    "Cedrik",
	    "Cem",
	    "Charlie",
	    "Chris",
	    "Christian",
	    "Christiano",
	    "Christoph",
	    "Christopher",
	    "Claas",
	    "Clemens",
	    "Colin",
	    "Collin",
	    "Conner",
	    "Connor",
	    "Constantin",
	    "Corvin",
	    "Curt",
	    "Damian",
	    "Damien",
	    "Daniel",
	    "Danilo",
	    "Danny",
	    "Darian",
	    "Dario",
	    "Darius",
	    "Darren",
	    "David",
	    "Davide",
	    "Davin",
	    "Dean",
	    "Deniz",
	    "Dennis",
	    "Denny",
	    "Devin",
	    "Diego",
	    "Dion",
	    "Domenic",
	    "Domenik",
	    "Dominic",
	    "Dominik",
	    "Dorian",
	    "Dustin",
	    "Dylan",
	    "Ecrin",
	    "Eddi",
	    "Eddy",
	    "Edgar",
	    "Edwin",
	    "Efe",
	    "Ege",
	    "Elia",
	    "Eliah",
	    "Elias",
	    "Elijah",
	    "Emanuel",
	    "Emil",
	    "Emilian",
	    "Emilio",
	    "Emir",
	    "Emirhan",
	    "Emre",
	    "Enes",
	    "Enno",
	    "Enrico",
	    "Eren",
	    "Eric",
	    "Erik",
	    "Etienne",
	    "Fabian",
	    "Fabien",
	    "Fabio",
	    "Fabrice",
	    "Falk",
	    "Felix",
	    "Ferdinand",
	    "Fiete",
	    "Filip",
	    "Finlay",
	    "Finley",
	    "Finn",
	    "Finnley",
	    "Florian",
	    "Francesco",
	    "Franz",
	    "Frederic",
	    "Frederick",
	    "Frederik",
	    "Friedrich",
	    "Fritz",
	    "Furkan",
	    "Fynn",
	    "Gabriel",
	    "Georg",
	    "Gerrit",
	    "Gian",
	    "Gianluca",
	    "Gino",
	    "Giuliano",
	    "Giuseppe",
	    "Gregor",
	    "Gustav",
	    "Hagen",
	    "Hamza",
	    "Hannes",
	    "Hanno",
	    "Hans",
	    "Hasan",
	    "Hassan",
	    "Hauke",
	    "Hendrik",
	    "Hennes",
	    "Henning",
	    "Henri",
	    "Henrick",
	    "Henrik",
	    "Henry",
	    "Hugo",
	    "Hussein",
	    "Ian",
	    "Ibrahim",
	    "Ilias",
	    "Ilja",
	    "Ilyas",
	    "Immanuel",
	    "Ismael",
	    "Ismail",
	    "Ivan",
	    "Iven",
	    "Jack",
	    "Jacob",
	    "Jaden",
	    "Jakob",
	    "Jamal",
	    "James",
	    "Jamie",
	    "Jan",
	    "Janek",
	    "Janis",
	    "Janne",
	    "Jannek",
	    "Jannes",
	    "Jannik",
	    "Jannis",
	    "Jano",
	    "Janosch",
	    "Jared",
	    "Jari",
	    "Jarne",
	    "Jarno",
	    "Jaron",
	    "Jason",
	    "Jasper",
	    "Jay",
	    "Jayden",
	    "Jayson",
	    "Jean",
	    "Jens",
	    "Jeremias",
	    "Jeremie",
	    "Jeremy",
	    "Jermaine",
	    "Jerome",
	    "Jesper",
	    "Jesse",
	    "Jim",
	    "Jimmy",
	    "Joe",
	    "Joel",
	    "Joey",
	    "Johann",
	    "Johannes",
	    "John",
	    "Johnny",
	    "Jon",
	    "Jona",
	    "Jonah",
	    "Jonas",
	    "Jonathan",
	    "Jonte",
	    "Joost",
	    "Jordan",
	    "Joris",
	    "Joscha",
	    "Joschua",
	    "Josef",
	    "Joseph",
	    "Josh",
	    "Joshua",
	    "Josua",
	    "Juan",
	    "Julian",
	    "Julien",
	    "Julius",
	    "Juri",
	    "Justin",
	    "Justus",
	    "Kaan",
	    "Kai",
	    "Kalle",
	    "Karim",
	    "Karl",
	    "Karlo",
	    "Kay",
	    "Keanu",
	    "Kenan",
	    "Kenny",
	    "Keno",
	    "Kerem",
	    "Kerim",
	    "Kevin",
	    "Kian",
	    "Kilian",
	    "Kim",
	    "Kimi",
	    "Kjell",
	    "Klaas",
	    "Klemens",
	    "Konrad",
	    "Konstantin",
	    "Koray",
	    "Korbinian",
	    "Kurt",
	    "Lars",
	    "Lasse",
	    "Laurence",
	    "Laurens",
	    "Laurenz",
	    "Laurin",
	    "Lean",
	    "Leander",
	    "Leandro",
	    "Leif",
	    "Len",
	    "Lenn",
	    "Lennard",
	    "Lennart",
	    "Lennert",
	    "Lennie",
	    "Lennox",
	    "Lenny",
	    "Leo",
	    "Leon",
	    "Leonard",
	    "Leonardo",
	    "Leonhard",
	    "Leonidas",
	    "Leopold",
	    "Leroy",
	    "Levent",
	    "Levi",
	    "Levin",
	    "Lewin",
	    "Lewis",
	    "Liam",
	    "Lian",
	    "Lias",
	    "Lino",
	    "Linus",
	    "Lio",
	    "Lion",
	    "Lionel",
	    "Logan",
	    "Lorenz",
	    "Lorenzo",
	    "Loris",
	    "Louis",
	    "Luan",
	    "Luc",
	    "Luca",
	    "Lucas",
	    "Lucian",
	    "Lucien",
	    "Ludwig",
	    "Luis",
	    "Luiz",
	    "Luk",
	    "Luka",
	    "Lukas",
	    "Luke",
	    "Lutz",
	    "Maddox",
	    "Mads",
	    "Magnus",
	    "Maik",
	    "Maksim",
	    "Malik",
	    "Malte",
	    "Manuel",
	    "Marc",
	    "Marcel",
	    "Marco",
	    "Marcus",
	    "Marek",
	    "Marian",
	    "Mario",
	    "Marius",
	    "Mark",
	    "Marko",
	    "Markus",
	    "Marlo",
	    "Marlon",
	    "Marten",
	    "Martin",
	    "Marvin",
	    "Marwin",
	    "Mateo",
	    "Mathis",
	    "Matis",
	    "Mats",
	    "Matteo",
	    "Mattes",
	    "Matthias",
	    "Matthis",
	    "Matti",
	    "Mattis",
	    "Maurice",
	    "Max",
	    "Maxim",
	    "Maximilian",
	    "Mehmet",
	    "Meik",
	    "Melvin",
	    "Merlin",
	    "Mert",
	    "Michael",
	    "Michel",
	    "Mick",
	    "Miguel",
	    "Mika",
	    "Mikail",
	    "Mike",
	    "Milan",
	    "Milo",
	    "Mio",
	    "Mirac",
	    "Mirco",
	    "Mirko",
	    "Mohamed",
	    "Mohammad",
	    "Mohammed",
	    "Moritz",
	    "Morten",
	    "Muhammed",
	    "Murat",
	    "Mustafa",
	    "Nathan",
	    "Nathanael",
	    "Nelson",
	    "Neo",
	    "Nevio",
	    "Nick",
	    "Niclas",
	    "Nico",
	    "Nicolai",
	    "Nicolas",
	    "Niels",
	    "Nikita",
	    "Niklas",
	    "Niko",
	    "Nikolai",
	    "Nikolas",
	    "Nils",
	    "Nino",
	    "Noah",
	    "Noel",
	    "Norman",
	    "Odin",
	    "Oke",
	    "Ole",
	    "Oliver",
	    "Omar",
	    "Onur",
	    "Oscar",
	    "Oskar",
	    "Pascal",
	    "Patrice",
	    "Patrick",
	    "Paul",
	    "Peer",
	    "Pepe",
	    "Peter",
	    "Phil",
	    "Philip",
	    "Philipp",
	    "Pierre",
	    "Piet",
	    "Pit",
	    "Pius",
	    "Quentin",
	    "Quirin",
	    "Rafael",
	    "Raik",
	    "Ramon",
	    "Raphael",
	    "Rasmus",
	    "Raul",
	    "Rayan",
	    "René",
	    "Ricardo",
	    "Riccardo",
	    "Richard",
	    "Rick",
	    "Rico",
	    "Robert",
	    "Robin",
	    "Rocco",
	    "Roman",
	    "Romeo",
	    "Ron",
	    "Ruben",
	    "Ryan",
	    "Said",
	    "Salih",
	    "Sam",
	    "Sami",
	    "Sammy",
	    "Samuel",
	    "Sandro",
	    "Santino",
	    "Sascha",
	    "Sean",
	    "Sebastian",
	    "Selim",
	    "Semih",
	    "Shawn",
	    "Silas",
	    "Simeon",
	    "Simon",
	    "Sinan",
	    "Sky",
	    "Stefan",
	    "Steffen",
	    "Stephan",
	    "Steve",
	    "Steven",
	    "Sven",
	    "Sönke",
	    "Sören",
	    "Taha",
	    "Tamino",
	    "Tammo",
	    "Tarik",
	    "Tayler",
	    "Taylor",
	    "Teo",
	    "Theo",
	    "Theodor",
	    "Thies",
	    "Thilo",
	    "Thomas",
	    "Thorben",
	    "Thore",
	    "Thorge",
	    "Tiago",
	    "Til",
	    "Till",
	    "Tillmann",
	    "Tim",
	    "Timm",
	    "Timo",
	    "Timon",
	    "Timothy",
	    "Tino",
	    "Titus",
	    "Tizian",
	    "Tjark",
	    "Tobias",
	    "Tom",
	    "Tommy",
	    "Toni",
	    "Tony",
	    "Torben",
	    "Tore",
	    "Tristan",
	    "Tyler",
	    "Tyron",
	    "Umut",
	    "Valentin",
	    "Valentino",
	    "Veit",
	    "Victor",
	    "Viktor",
	    "Vin",
	    "Vincent",
	    "Vito",
	    "Vitus",
	    "Wilhelm",
	    "Willi",
	    "William",
	    "Willy",
	    "Xaver",
	    "Yannic",
	    "Yannick",
	    "Yannik",
	    "Yannis",
	    "Yasin",
	    "Youssef",
	    "Yunus",
	    "Yusuf",
	    "Yven",
	    "Yves",
	    "Ömer",
	    "Aaliyah",
	    "Abby",
	    "Abigail",
	    "Ada",
	    "Adelina",
	    "Adriana",
	    "Aileen",
	    "Aimee",
	    "Alana",
	    "Alea",
	    "Alena",
	    "Alessa",
	    "Alessia",
	    "Alexa",
	    "Alexandra",
	    "Alexia",
	    "Alexis",
	    "Aleyna",
	    "Alia",
	    "Alica",
	    "Alice",
	    "Alicia",
	    "Alina",
	    "Alisa",
	    "Alisha",
	    "Alissa",
	    "Aliya",
	    "Aliyah",
	    "Allegra",
	    "Alma",
	    "Alyssa",
	    "Amalia",
	    "Amanda",
	    "Amelia",
	    "Amelie",
	    "Amina",
	    "Amira",
	    "Amy",
	    "Ana",
	    "Anabel",
	    "Anastasia",
	    "Andrea",
	    "Angela",
	    "Angelina",
	    "Angelique",
	    "Anja",
	    "Ann",
	    "Anna",
	    "Annabel",
	    "Annabell",
	    "Annabelle",
	    "Annalena",
	    "Anne",
	    "Anneke",
	    "Annelie",
	    "Annemarie",
	    "Anni",
	    "Annie",
	    "Annika",
	    "Anny",
	    "Anouk",
	    "Antonia",
	    "Arda",
	    "Ariana",
	    "Ariane",
	    "Arwen",
	    "Ashley",
	    "Asya",
	    "Aurelia",
	    "Aurora",
	    "Ava",
	    "Ayleen",
	    "Aylin",
	    "Ayse",
	    "Azra",
	    "Betty",
	    "Bianca",
	    "Bianka",
	    "Caitlin",
	    "Cara",
	    "Carina",
	    "Carla",
	    "Carlotta",
	    "Carmen",
	    "Carolin",
	    "Carolina",
	    "Caroline",
	    "Cassandra",
	    "Catharina",
	    "Catrin",
	    "Cecile",
	    "Cecilia",
	    "Celia",
	    "Celina",
	    "Celine",
	    "Ceyda",
	    "Ceylin",
	    "Chantal",
	    "Charleen",
	    "Charlotta",
	    "Charlotte",
	    "Chayenne",
	    "Cheyenne",
	    "Chiara",
	    "Christin",
	    "Christina",
	    "Cindy",
	    "Claire",
	    "Clara",
	    "Clarissa",
	    "Colleen",
	    "Collien",
	    "Cora",
	    "Corinna",
	    "Cosima",
	    "Dana",
	    "Daniela",
	    "Daria",
	    "Darleen",
	    "Defne",
	    "Delia",
	    "Denise",
	    "Diana",
	    "Dilara",
	    "Dina",
	    "Dorothea",
	    "Ecrin",
	    "Eda",
	    "Eileen",
	    "Ela",
	    "Elaine",
	    "Elanur",
	    "Elea",
	    "Elena",
	    "Eleni",
	    "Eleonora",
	    "Eliana",
	    "Elif",
	    "Elina",
	    "Elisa",
	    "Elisabeth",
	    "Ella",
	    "Ellen",
	    "Elli",
	    "Elly",
	    "Elsa",
	    "Emelie",
	    "Emely",
	    "Emilia",
	    "Emilie",
	    "Emily",
	    "Emma",
	    "Emmely",
	    "Emmi",
	    "Emmy",
	    "Enie",
	    "Enna",
	    "Enya",
	    "Esma",
	    "Estelle",
	    "Esther",
	    "Eva",
	    "Evelin",
	    "Evelina",
	    "Eveline",
	    "Evelyn",
	    "Fabienne",
	    "Fatima",
	    "Fatma",
	    "Felicia",
	    "Felicitas",
	    "Felina",
	    "Femke",
	    "Fenja",
	    "Fine",
	    "Finia",
	    "Finja",
	    "Finnja",
	    "Fiona",
	    "Flora",
	    "Florentine",
	    "Francesca",
	    "Franka",
	    "Franziska",
	    "Frederike",
	    "Freya",
	    "Frida",
	    "Frieda",
	    "Friederike",
	    "Giada",
	    "Gina",
	    "Giulia",
	    "Giuliana",
	    "Greta",
	    "Hailey",
	    "Hana",
	    "Hanna",
	    "Hannah",
	    "Heidi",
	    "Helen",
	    "Helena",
	    "Helene",
	    "Helin",
	    "Henriette",
	    "Henrike",
	    "Hermine",
	    "Ida",
	    "Ilayda",
	    "Imke",
	    "Ina",
	    "Ines",
	    "Inga",
	    "Inka",
	    "Irem",
	    "Isa",
	    "Isabel",
	    "Isabell",
	    "Isabella",
	    "Isabelle",
	    "Ivonne",
	    "Jacqueline",
	    "Jamie",
	    "Jamila",
	    "Jana",
	    "Jane",
	    "Janin",
	    "Janina",
	    "Janine",
	    "Janna",
	    "Janne",
	    "Jara",
	    "Jasmin",
	    "Jasmina",
	    "Jasmine",
	    "Jella",
	    "Jenna",
	    "Jennifer",
	    "Jenny",
	    "Jessica",
	    "Jessy",
	    "Jette",
	    "Jil",
	    "Jill",
	    "Joana",
	    "Joanna",
	    "Joelina",
	    "Joeline",
	    "Joelle",
	    "Johanna",
	    "Joleen",
	    "Jolie",
	    "Jolien",
	    "Jolin",
	    "Jolina",
	    "Joline",
	    "Jona",
	    "Jonah",
	    "Jonna",
	    "Josefin",
	    "Josefine",
	    "Josephin",
	    "Josephine",
	    "Josie",
	    "Josy",
	    "Joy",
	    "Joyce",
	    "Judith",
	    "Judy",
	    "Jule",
	    "Julia",
	    "Juliana",
	    "Juliane",
	    "Julie",
	    "Julienne",
	    "Julika",
	    "Julina",
	    "Juna",
	    "Justine",
	    "Kaja",
	    "Karina",
	    "Karla",
	    "Karlotta",
	    "Karolina",
	    "Karoline",
	    "Kassandra",
	    "Katarina",
	    "Katharina",
	    "Kathrin",
	    "Katja",
	    "Katrin",
	    "Kaya",
	    "Kayra",
	    "Kiana",
	    "Kiara",
	    "Kim",
	    "Kimberley",
	    "Kimberly",
	    "Kira",
	    "Klara",
	    "Korinna",
	    "Kristin",
	    "Kyra",
	    "Laila",
	    "Lana",
	    "Lara",
	    "Larissa",
	    "Laura",
	    "Laureen",
	    "Lavinia",
	    "Lea",
	    "Leah",
	    "Leana",
	    "Leandra",
	    "Leann",
	    "Lee",
	    "Leila",
	    "Lena",
	    "Lene",
	    "Leni",
	    "Lenia",
	    "Lenja",
	    "Lenya",
	    "Leona",
	    "Leoni",
	    "Leonie",
	    "Leonora",
	    "Leticia",
	    "Letizia",
	    "Levke",
	    "Leyla",
	    "Lia",
	    "Liah",
	    "Liana",
	    "Lili",
	    "Lilia",
	    "Lilian",
	    "Liliana",
	    "Lilith",
	    "Lilli",
	    "Lillian",
	    "Lilly",
	    "Lily",
	    "Lina",
	    "Linda",
	    "Lindsay",
	    "Line",
	    "Linn",
	    "Linnea",
	    "Lisa",
	    "Lisann",
	    "Lisanne",
	    "Liv",
	    "Livia",
	    "Liz",
	    "Lola",
	    "Loreen",
	    "Lorena",
	    "Lotta",
	    "Lotte",
	    "Louisa",
	    "Louise",
	    "Luana",
	    "Luca",
	    "Lucia",
	    "Lucie",
	    "Lucienne",
	    "Lucy",
	    "Luisa",
	    "Luise",
	    "Luka",
	    "Luna",
	    "Luzie",
	    "Lya",
	    "Lydia",
	    "Lyn",
	    "Lynn",
	    "Madeleine",
	    "Madita",
	    "Madleen",
	    "Madlen",
	    "Magdalena",
	    "Maike",
	    "Mailin",
	    "Maira",
	    "Maja",
	    "Malena",
	    "Malia",
	    "Malin",
	    "Malina",
	    "Mandy",
	    "Mara",
	    "Marah",
	    "Mareike",
	    "Maren",
	    "Maria",
	    "Mariam",
	    "Marie",
	    "Marieke",
	    "Mariella",
	    "Marika",
	    "Marina",
	    "Marisa",
	    "Marissa",
	    "Marit",
	    "Marla",
	    "Marleen",
	    "Marlen",
	    "Marlena",
	    "Marlene",
	    "Marta",
	    "Martha",
	    "Mary",
	    "Maryam",
	    "Mathilda",
	    "Mathilde",
	    "Matilda",
	    "Maxi",
	    "Maxima",
	    "Maxine",
	    "Maya",
	    "Mayra",
	    "Medina",
	    "Medine",
	    "Meike",
	    "Melanie",
	    "Melek",
	    "Melike",
	    "Melina",
	    "Melinda",
	    "Melis",
	    "Melisa",
	    "Melissa",
	    "Merle",
	    "Merve",
	    "Meryem",
	    "Mette",
	    "Mia",
	    "Michaela",
	    "Michelle",
	    "Mieke",
	    "Mila",
	    "Milana",
	    "Milena",
	    "Milla",
	    "Mina",
	    "Mira",
	    "Miray",
	    "Miriam",
	    "Mirja",
	    "Mona",
	    "Monique",
	    "Nadine",
	    "Nadja",
	    "Naemi",
	    "Nancy",
	    "Naomi",
	    "Natalia",
	    "Natalie",
	    "Nathalie",
	    "Neele",
	    "Nela",
	    "Nele",
	    "Nelli",
	    "Nelly",
	    "Nia",
	    "Nicole",
	    "Nika",
	    "Nike",
	    "Nikita",
	    "Nila",
	    "Nina",
	    "Nisa",
	    "Noemi",
	    "Nora",
	    "Olivia",
	    "Patricia",
	    "Patrizia",
	    "Paula",
	    "Paulina",
	    "Pauline",
	    "Penelope",
	    "Philine",
	    "Phoebe",
	    "Pia",
	    "Rahel",
	    "Rania",
	    "Rebecca",
	    "Rebekka",
	    "Riana",
	    "Rieke",
	    "Rike",
	    "Romina",
	    "Romy",
	    "Ronja",
	    "Rosa",
	    "Rosalie",
	    "Ruby",
	    "Sabrina",
	    "Sahra",
	    "Sally",
	    "Salome",
	    "Samantha",
	    "Samia",
	    "Samira",
	    "Sandra",
	    "Sandy",
	    "Sanja",
	    "Saphira",
	    "Sara",
	    "Sarah",
	    "Saskia",
	    "Selin",
	    "Selina",
	    "Selma",
	    "Sena",
	    "Sidney",
	    "Sienna",
	    "Silja",
	    "Sina",
	    "Sinja",
	    "Smilla",
	    "Sofia",
	    "Sofie",
	    "Sonja",
	    "Sophia",
	    "Sophie",
	    "Soraya",
	    "Stefanie",
	    "Stella",
	    "Stephanie",
	    "Stina",
	    "Sude",
	    "Summer",
	    "Susanne",
	    "Svea",
	    "Svenja",
	    "Sydney",
	    "Tabea",
	    "Talea",
	    "Talia",
	    "Tamara",
	    "Tamia",
	    "Tamina",
	    "Tanja",
	    "Tara",
	    "Tarja",
	    "Teresa",
	    "Tessa",
	    "Thalea",
	    "Thalia",
	    "Thea",
	    "Theresa",
	    "Tia",
	    "Tina",
	    "Tomke",
	    "Tuana",
	    "Valentina",
	    "Valeria",
	    "Valerie",
	    "Vanessa",
	    "Vera",
	    "Veronika",
	    "Victoria",
	    "Viktoria",
	    "Viola",
	    "Vivian",
	    "Vivien",
	    "Vivienne",
	    "Wibke",
	    "Wiebke",
	    "Xenia",
	    "Yara",
	    "Yaren",
	    "Yasmin",
	    "Ylvi",
	    "Ylvie",
	    "Yvonne",
	    "Zara",
	    "Zehra",
	    "Zeynep",
	    "Zoe",
	    "Zoey",
	    "Zoé"
	  ],
	  "last_name": [
	    "Abel",
	    "Abicht",
	    "Abraham",
	    "Abramovic",
	    "Abt",
	    "Achilles",
	    "Achkinadze",
	    "Ackermann",
	    "Adam",
	    "Adams",
	    "Ade",
	    "Agostini",
	    "Ahlke",
	    "Ahrenberg",
	    "Ahrens",
	    "Aigner",
	    "Albert",
	    "Albrecht",
	    "Alexa",
	    "Alexander",
	    "Alizadeh",
	    "Allgeyer",
	    "Amann",
	    "Amberg",
	    "Anding",
	    "Anggreny",
	    "Apitz",
	    "Arendt",
	    "Arens",
	    "Arndt",
	    "Aryee",
	    "Aschenbroich",
	    "Assmus",
	    "Astafei",
	    "Auer",
	    "Axmann",
	    "Baarck",
	    "Bachmann",
	    "Badane",
	    "Bader",
	    "Baganz",
	    "Bahl",
	    "Bak",
	    "Balcer",
	    "Balck",
	    "Balkow",
	    "Balnuweit",
	    "Balzer",
	    "Banse",
	    "Barr",
	    "Bartels",
	    "Barth",
	    "Barylla",
	    "Baseda",
	    "Battke",
	    "Bauer",
	    "Bauermeister",
	    "Baumann",
	    "Baumeister",
	    "Bauschinger",
	    "Bauschke",
	    "Bayer",
	    "Beavogui",
	    "Beck",
	    "Beckel",
	    "Becker",
	    "Beckmann",
	    "Bedewitz",
	    "Beele",
	    "Beer",
	    "Beggerow",
	    "Beh",
	    "Behr",
	    "Behrenbruch",
	    "Belz",
	    "Bender",
	    "Benecke",
	    "Benner",
	    "Benninger",
	    "Benzing",
	    "Berends",
	    "Berger",
	    "Berner",
	    "Berning",
	    "Bertenbreiter",
	    "Best",
	    "Bethke",
	    "Betz",
	    "Beushausen",
	    "Beutelspacher",
	    "Beyer",
	    "Biba",
	    "Bichler",
	    "Bickel",
	    "Biedermann",
	    "Bieler",
	    "Bielert",
	    "Bienasch",
	    "Bienias",
	    "Biesenbach",
	    "Bigdeli",
	    "Birkemeyer",
	    "Bittner",
	    "Blank",
	    "Blaschek",
	    "Blassneck",
	    "Bloch",
	    "Blochwitz",
	    "Blockhaus",
	    "Blum",
	    "Blume",
	    "Bock",
	    "Bode",
	    "Bogdashin",
	    "Bogenrieder",
	    "Bohge",
	    "Bolm",
	    "Borgschulze",
	    "Bork",
	    "Bormann",
	    "Bornscheuer",
	    "Borrmann",
	    "Borsch",
	    "Boruschewski",
	    "Bos",
	    "Bosler",
	    "Bourrouag",
	    "Bouschen",
	    "Boxhammer",
	    "Boyde",
	    "Bozsik",
	    "Brand",
	    "Brandenburg",
	    "Brandis",
	    "Brandt",
	    "Brauer",
	    "Braun",
	    "Brehmer",
	    "Breitenstein",
	    "Bremer",
	    "Bremser",
	    "Brenner",
	    "Brettschneider",
	    "Breu",
	    "Breuer",
	    "Briesenick",
	    "Bringmann",
	    "Brinkmann",
	    "Brix",
	    "Broening",
	    "Brosch",
	    "Bruckmann",
	    "Bruder",
	    "Bruhns",
	    "Brunner",
	    "Bruns",
	    "Bräutigam",
	    "Brömme",
	    "Brüggmann",
	    "Buchholz",
	    "Buchrucker",
	    "Buder",
	    "Bultmann",
	    "Bunjes",
	    "Burger",
	    "Burghagen",
	    "Burkhard",
	    "Burkhardt",
	    "Burmeister",
	    "Busch",
	    "Buschbaum",
	    "Busemann",
	    "Buss",
	    "Busse",
	    "Bussmann",
	    "Byrd",
	    "Bäcker",
	    "Böhm",
	    "Bönisch",
	    "Börgeling",
	    "Börner",
	    "Böttner",
	    "Büchele",
	    "Bühler",
	    "Büker",
	    "Büngener",
	    "Bürger",
	    "Bürklein",
	    "Büscher",
	    "Büttner",
	    "Camara",
	    "Carlowitz",
	    "Carlsohn",
	    "Caspari",
	    "Caspers",
	    "Chapron",
	    "Christ",
	    "Cierpinski",
	    "Clarius",
	    "Cleem",
	    "Cleve",
	    "Co",
	    "Conrad",
	    "Cordes",
	    "Cornelsen",
	    "Cors",
	    "Cotthardt",
	    "Crews",
	    "Cronjäger",
	    "Crosskofp",
	    "Da",
	    "Dahm",
	    "Dahmen",
	    "Daimer",
	    "Damaske",
	    "Danneberg",
	    "Danner",
	    "Daub",
	    "Daubner",
	    "Daudrich",
	    "Dauer",
	    "Daum",
	    "Dauth",
	    "Dautzenberg",
	    "De",
	    "Decker",
	    "Deckert",
	    "Deerberg",
	    "Dehmel",
	    "Deja",
	    "Delonge",
	    "Demut",
	    "Dengler",
	    "Denner",
	    "Denzinger",
	    "Derr",
	    "Dertmann",
	    "Dethloff",
	    "Deuschle",
	    "Dieckmann",
	    "Diedrich",
	    "Diekmann",
	    "Dienel",
	    "Dies",
	    "Dietrich",
	    "Dietz",
	    "Dietzsch",
	    "Diezel",
	    "Dilla",
	    "Dingelstedt",
	    "Dippl",
	    "Dittmann",
	    "Dittmar",
	    "Dittmer",
	    "Dix",
	    "Dobbrunz",
	    "Dobler",
	    "Dohring",
	    "Dolch",
	    "Dold",
	    "Dombrowski",
	    "Donie",
	    "Doskoczynski",
	    "Dragu",
	    "Drechsler",
	    "Drees",
	    "Dreher",
	    "Dreier",
	    "Dreissigacker",
	    "Dressler",
	    "Drews",
	    "Duma",
	    "Dutkiewicz",
	    "Dyett",
	    "Dylus",
	    "Dächert",
	    "Döbel",
	    "Döring",
	    "Dörner",
	    "Dörre",
	    "Dück",
	    "Eberhard",
	    "Eberhardt",
	    "Ecker",
	    "Eckhardt",
	    "Edorh",
	    "Effler",
	    "Eggenmueller",
	    "Ehm",
	    "Ehmann",
	    "Ehrig",
	    "Eich",
	    "Eichmann",
	    "Eifert",
	    "Einert",
	    "Eisenlauer",
	    "Ekpo",
	    "Elbe",
	    "Eleyth",
	    "Elss",
	    "Emert",
	    "Emmelmann",
	    "Ender",
	    "Engel",
	    "Engelen",
	    "Engelmann",
	    "Eplinius",
	    "Erdmann",
	    "Erhardt",
	    "Erlei",
	    "Erm",
	    "Ernst",
	    "Ertl",
	    "Erwes",
	    "Esenwein",
	    "Esser",
	    "Evers",
	    "Everts",
	    "Ewald",
	    "Fahner",
	    "Faller",
	    "Falter",
	    "Farber",
	    "Fassbender",
	    "Faulhaber",
	    "Fehrig",
	    "Feld",
	    "Felke",
	    "Feller",
	    "Fenner",
	    "Fenske",
	    "Feuerbach",
	    "Fietz",
	    "Figl",
	    "Figura",
	    "Filipowski",
	    "Filsinger",
	    "Fincke",
	    "Fink",
	    "Finke",
	    "Fischer",
	    "Fitschen",
	    "Fleischer",
	    "Fleischmann",
	    "Floder",
	    "Florczak",
	    "Flore",
	    "Flottmann",
	    "Forkel",
	    "Forst",
	    "Frahmeke",
	    "Frank",
	    "Franke",
	    "Franta",
	    "Frantz",
	    "Franz",
	    "Franzis",
	    "Franzmann",
	    "Frauen",
	    "Frauendorf",
	    "Freigang",
	    "Freimann",
	    "Freimuth",
	    "Freisen",
	    "Frenzel",
	    "Frey",
	    "Fricke",
	    "Fried",
	    "Friedek",
	    "Friedenberg",
	    "Friedmann",
	    "Friedrich",
	    "Friess",
	    "Frisch",
	    "Frohn",
	    "Frosch",
	    "Fuchs",
	    "Fuhlbrügge",
	    "Fusenig",
	    "Fust",
	    "Förster",
	    "Gaba",
	    "Gabius",
	    "Gabler",
	    "Gadschiew",
	    "Gakstädter",
	    "Galander",
	    "Gamlin",
	    "Gamper",
	    "Gangnus",
	    "Ganzmann",
	    "Garatva",
	    "Gast",
	    "Gastel",
	    "Gatzka",
	    "Gauder",
	    "Gebhardt",
	    "Geese",
	    "Gehre",
	    "Gehrig",
	    "Gehring",
	    "Gehrke",
	    "Geiger",
	    "Geisler",
	    "Geissler",
	    "Gelling",
	    "Gens",
	    "Gerbennow",
	    "Gerdel",
	    "Gerhardt",
	    "Gerschler",
	    "Gerson",
	    "Gesell",
	    "Geyer",
	    "Ghirmai",
	    "Ghosh",
	    "Giehl",
	    "Gierisch",
	    "Giesa",
	    "Giesche",
	    "Gilde",
	    "Glatting",
	    "Goebel",
	    "Goedicke",
	    "Goldbeck",
	    "Goldfuss",
	    "Goldkamp",
	    "Goldkühle",
	    "Goller",
	    "Golling",
	    "Gollnow",
	    "Golomski",
	    "Gombert",
	    "Gotthardt",
	    "Gottschalk",
	    "Gotz",
	    "Goy",
	    "Gradzki",
	    "Graf",
	    "Grams",
	    "Grasse",
	    "Gratzky",
	    "Grau",
	    "Greb",
	    "Green",
	    "Greger",
	    "Greithanner",
	    "Greschner",
	    "Griem",
	    "Griese",
	    "Grimm",
	    "Gromisch",
	    "Gross",
	    "Grosser",
	    "Grossheim",
	    "Grosskopf",
	    "Grothaus",
	    "Grothkopp",
	    "Grotke",
	    "Grube",
	    "Gruber",
	    "Grundmann",
	    "Gruning",
	    "Gruszecki",
	    "Gröss",
	    "Grötzinger",
	    "Grün",
	    "Grüner",
	    "Gummelt",
	    "Gunkel",
	    "Gunther",
	    "Gutjahr",
	    "Gutowicz",
	    "Gutschank",
	    "Göbel",
	    "Göckeritz",
	    "Göhler",
	    "Görlich",
	    "Görmer",
	    "Götz",
	    "Götzelmann",
	    "Güldemeister",
	    "Günther",
	    "Günz",
	    "Gürbig",
	    "Haack",
	    "Haaf",
	    "Habel",
	    "Hache",
	    "Hackbusch",
	    "Hackelbusch",
	    "Hadfield",
	    "Hadwich",
	    "Haferkamp",
	    "Hahn",
	    "Hajek",
	    "Hallmann",
	    "Hamann",
	    "Hanenberger",
	    "Hannecker",
	    "Hanniske",
	    "Hansen",
	    "Hardy",
	    "Hargasser",
	    "Harms",
	    "Harnapp",
	    "Harter",
	    "Harting",
	    "Hartlieb",
	    "Hartmann",
	    "Hartwig",
	    "Hartz",
	    "Haschke",
	    "Hasler",
	    "Hasse",
	    "Hassfeld",
	    "Haug",
	    "Hauke",
	    "Haupt",
	    "Haverney",
	    "Heberstreit",
	    "Hechler",
	    "Hecht",
	    "Heck",
	    "Hedermann",
	    "Hehl",
	    "Heidelmann",
	    "Heidler",
	    "Heinemann",
	    "Heinig",
	    "Heinke",
	    "Heinrich",
	    "Heinze",
	    "Heiser",
	    "Heist",
	    "Hellmann",
	    "Helm",
	    "Helmke",
	    "Helpling",
	    "Hengmith",
	    "Henkel",
	    "Hennes",
	    "Henry",
	    "Hense",
	    "Hensel",
	    "Hentel",
	    "Hentschel",
	    "Hentschke",
	    "Hepperle",
	    "Herberger",
	    "Herbrand",
	    "Hering",
	    "Hermann",
	    "Hermecke",
	    "Herms",
	    "Herold",
	    "Herrmann",
	    "Herschmann",
	    "Hertel",
	    "Herweg",
	    "Herwig",
	    "Herzenberg",
	    "Hess",
	    "Hesse",
	    "Hessek",
	    "Hessler",
	    "Hetzler",
	    "Heuck",
	    "Heydemüller",
	    "Hiebl",
	    "Hildebrand",
	    "Hildenbrand",
	    "Hilgendorf",
	    "Hillard",
	    "Hiller",
	    "Hingsen",
	    "Hingst",
	    "Hinrichs",
	    "Hirsch",
	    "Hirschberg",
	    "Hirt",
	    "Hodea",
	    "Hoffman",
	    "Hoffmann",
	    "Hofmann",
	    "Hohenberger",
	    "Hohl",
	    "Hohn",
	    "Hohnheiser",
	    "Hold",
	    "Holdt",
	    "Holinski",
	    "Holl",
	    "Holtfreter",
	    "Holz",
	    "Holzdeppe",
	    "Holzner",
	    "Hommel",
	    "Honz",
	    "Hooss",
	    "Hoppe",
	    "Horak",
	    "Horn",
	    "Horna",
	    "Hornung",
	    "Hort",
	    "Howard",
	    "Huber",
	    "Huckestein",
	    "Hudak",
	    "Huebel",
	    "Hugo",
	    "Huhn",
	    "Hujo",
	    "Huke",
	    "Huls",
	    "Humbert",
	    "Huneke",
	    "Huth",
	    "Häber",
	    "Häfner",
	    "Höcke",
	    "Höft",
	    "Höhne",
	    "Hönig",
	    "Hördt",
	    "Hübenbecker",
	    "Hübl",
	    "Hübner",
	    "Hügel",
	    "Hüttcher",
	    "Hütter",
	    "Ibe",
	    "Ihly",
	    "Illing",
	    "Isak",
	    "Isekenmeier",
	    "Itt",
	    "Jacob",
	    "Jacobs",
	    "Jagusch",
	    "Jahn",
	    "Jahnke",
	    "Jakobs",
	    "Jakubczyk",
	    "Jambor",
	    "Jamrozy",
	    "Jander",
	    "Janich",
	    "Janke",
	    "Jansen",
	    "Jarets",
	    "Jaros",
	    "Jasinski",
	    "Jasper",
	    "Jegorov",
	    "Jellinghaus",
	    "Jeorga",
	    "Jerschabek",
	    "Jess",
	    "John",
	    "Jonas",
	    "Jossa",
	    "Jucken",
	    "Jung",
	    "Jungbluth",
	    "Jungton",
	    "Just",
	    "Jürgens",
	    "Kaczmarek",
	    "Kaesmacher",
	    "Kahl",
	    "Kahlert",
	    "Kahles",
	    "Kahlmeyer",
	    "Kaiser",
	    "Kalinowski",
	    "Kallabis",
	    "Kallensee",
	    "Kampf",
	    "Kampschulte",
	    "Kappe",
	    "Kappler",
	    "Karhoff",
	    "Karrass",
	    "Karst",
	    "Karsten",
	    "Karus",
	    "Kass",
	    "Kasten",
	    "Kastner",
	    "Katzinski",
	    "Kaufmann",
	    "Kaul",
	    "Kausemann",
	    "Kawohl",
	    "Kazmarek",
	    "Kedzierski",
	    "Keil",
	    "Keiner",
	    "Keller",
	    "Kelm",
	    "Kempe",
	    "Kemper",
	    "Kempter",
	    "Kerl",
	    "Kern",
	    "Kesselring",
	    "Kesselschläger",
	    "Kette",
	    "Kettenis",
	    "Keutel",
	    "Kick",
	    "Kiessling",
	    "Kinadeter",
	    "Kinzel",
	    "Kinzy",
	    "Kirch",
	    "Kirst",
	    "Kisabaka",
	    "Klaas",
	    "Klabuhn",
	    "Klapper",
	    "Klauder",
	    "Klaus",
	    "Kleeberg",
	    "Kleiber",
	    "Klein",
	    "Kleinert",
	    "Kleininger",
	    "Kleinmann",
	    "Kleinsteuber",
	    "Kleiss",
	    "Klemme",
	    "Klimczak",
	    "Klinger",
	    "Klink",
	    "Klopsch",
	    "Klose",
	    "Kloss",
	    "Kluge",
	    "Kluwe",
	    "Knabe",
	    "Kneifel",
	    "Knetsch",
	    "Knies",
	    "Knippel",
	    "Knobel",
	    "Knoblich",
	    "Knoll",
	    "Knorr",
	    "Knorscheidt",
	    "Knut",
	    "Kobs",
	    "Koch",
	    "Kochan",
	    "Kock",
	    "Koczulla",
	    "Koderisch",
	    "Koehl",
	    "Koehler",
	    "Koenig",
	    "Koester",
	    "Kofferschlager",
	    "Koha",
	    "Kohle",
	    "Kohlmann",
	    "Kohnle",
	    "Kohrt",
	    "Koj",
	    "Kolb",
	    "Koleiski",
	    "Kolokas",
	    "Komoll",
	    "Konieczny",
	    "Konig",
	    "Konow",
	    "Konya",
	    "Koob",
	    "Kopf",
	    "Kosenkow",
	    "Koster",
	    "Koszewski",
	    "Koubaa",
	    "Kovacs",
	    "Kowalick",
	    "Kowalinski",
	    "Kozakiewicz",
	    "Krabbe",
	    "Kraft",
	    "Kral",
	    "Kramer",
	    "Krauel",
	    "Kraus",
	    "Krause",
	    "Krauspe",
	    "Kreb",
	    "Krebs",
	    "Kreissig",
	    "Kresse",
	    "Kreutz",
	    "Krieger",
	    "Krippner",
	    "Krodinger",
	    "Krohn",
	    "Krol",
	    "Kron",
	    "Krueger",
	    "Krug",
	    "Kruger",
	    "Krull",
	    "Kruschinski",
	    "Krämer",
	    "Kröckert",
	    "Kröger",
	    "Krüger",
	    "Kubera",
	    "Kufahl",
	    "Kuhlee",
	    "Kuhnen",
	    "Kulimann",
	    "Kulma",
	    "Kumbernuss",
	    "Kummle",
	    "Kunz",
	    "Kupfer",
	    "Kupprion",
	    "Kuprion",
	    "Kurnicki",
	    "Kurrat",
	    "Kurschilgen",
	    "Kuschewitz",
	    "Kuschmann",
	    "Kuske",
	    "Kustermann",
	    "Kutscherauer",
	    "Kutzner",
	    "Kwadwo",
	    "Kähler",
	    "Käther",
	    "Köhler",
	    "Köhrbrück",
	    "Köhre",
	    "Kölotzei",
	    "König",
	    "Köpernick",
	    "Köseoglu",
	    "Kúhn",
	    "Kúhnert",
	    "Kühn",
	    "Kühnel",
	    "Kühnemund",
	    "Kühnert",
	    "Kühnke",
	    "Küsters",
	    "Küter",
	    "Laack",
	    "Lack",
	    "Ladewig",
	    "Lakomy",
	    "Lammert",
	    "Lamos",
	    "Landmann",
	    "Lang",
	    "Lange",
	    "Langfeld",
	    "Langhirt",
	    "Lanig",
	    "Lauckner",
	    "Lauinger",
	    "Laurén",
	    "Lausecker",
	    "Laux",
	    "Laws",
	    "Lax",
	    "Leberer",
	    "Lehmann",
	    "Lehner",
	    "Leibold",
	    "Leide",
	    "Leimbach",
	    "Leipold",
	    "Leist",
	    "Leiter",
	    "Leiteritz",
	    "Leitheim",
	    "Leiwesmeier",
	    "Lenfers",
	    "Lenk",
	    "Lenz",
	    "Lenzen",
	    "Leo",
	    "Lepthin",
	    "Lesch",
	    "Leschnik",
	    "Letzelter",
	    "Lewin",
	    "Lewke",
	    "Leyckes",
	    "Lg",
	    "Lichtenfeld",
	    "Lichtenhagen",
	    "Lichtl",
	    "Liebach",
	    "Liebe",
	    "Liebich",
	    "Liebold",
	    "Lieder",
	    "Lienshöft",
	    "Linden",
	    "Lindenberg",
	    "Lindenmayer",
	    "Lindner",
	    "Linke",
	    "Linnenbaum",
	    "Lippe",
	    "Lipske",
	    "Lipus",
	    "Lischka",
	    "Lobinger",
	    "Logsch",
	    "Lohmann",
	    "Lohre",
	    "Lohse",
	    "Lokar",
	    "Loogen",
	    "Lorenz",
	    "Losch",
	    "Loska",
	    "Lott",
	    "Loy",
	    "Lubina",
	    "Ludolf",
	    "Lufft",
	    "Lukoschek",
	    "Lutje",
	    "Lutz",
	    "Löser",
	    "Löwa",
	    "Lübke",
	    "Maak",
	    "Maczey",
	    "Madetzky",
	    "Madubuko",
	    "Mai",
	    "Maier",
	    "Maisch",
	    "Malek",
	    "Malkus",
	    "Mallmann",
	    "Malucha",
	    "Manns",
	    "Manz",
	    "Marahrens",
	    "Marchewski",
	    "Margis",
	    "Markowski",
	    "Marl",
	    "Marner",
	    "Marquart",
	    "Marschek",
	    "Martel",
	    "Marten",
	    "Martin",
	    "Marx",
	    "Marxen",
	    "Mathes",
	    "Mathies",
	    "Mathiszik",
	    "Matschke",
	    "Mattern",
	    "Matthes",
	    "Matula",
	    "Mau",
	    "Maurer",
	    "Mauroff",
	    "May",
	    "Maybach",
	    "Mayer",
	    "Mebold",
	    "Mehl",
	    "Mehlhorn",
	    "Mehlorn",
	    "Meier",
	    "Meisch",
	    "Meissner",
	    "Meloni",
	    "Melzer",
	    "Menga",
	    "Menne",
	    "Mensah",
	    "Mensing",
	    "Merkel",
	    "Merseburg",
	    "Mertens",
	    "Mesloh",
	    "Metzger",
	    "Metzner",
	    "Mewes",
	    "Meyer",
	    "Michallek",
	    "Michel",
	    "Mielke",
	    "Mikitenko",
	    "Milde",
	    "Minah",
	    "Mintzlaff",
	    "Mockenhaupt",
	    "Moede",
	    "Moedl",
	    "Moeller",
	    "Moguenara",
	    "Mohr",
	    "Mohrhard",
	    "Molitor",
	    "Moll",
	    "Moller",
	    "Molzan",
	    "Montag",
	    "Moormann",
	    "Mordhorst",
	    "Morgenstern",
	    "Morhelfer",
	    "Moritz",
	    "Moser",
	    "Motchebon",
	    "Motzenbbäcker",
	    "Mrugalla",
	    "Muckenthaler",
	    "Mues",
	    "Muller",
	    "Mulrain",
	    "Mächtig",
	    "Mäder",
	    "Möcks",
	    "Mögenburg",
	    "Möhsner",
	    "Möldner",
	    "Möllenbeck",
	    "Möller",
	    "Möllinger",
	    "Mörsch",
	    "Mühleis",
	    "Müller",
	    "Münch",
	    "Nabein",
	    "Nabow",
	    "Nagel",
	    "Nannen",
	    "Nastvogel",
	    "Nau",
	    "Naubert",
	    "Naumann",
	    "Ne",
	    "Neimke",
	    "Nerius",
	    "Neubauer",
	    "Neubert",
	    "Neuendorf",
	    "Neumair",
	    "Neumann",
	    "Neupert",
	    "Neurohr",
	    "Neuschwander",
	    "Newton",
	    "Ney",
	    "Nicolay",
	    "Niedermeier",
	    "Nieklauson",
	    "Niklaus",
	    "Nitzsche",
	    "Noack",
	    "Nodler",
	    "Nolte",
	    "Normann",
	    "Norris",
	    "Northoff",
	    "Nowak",
	    "Nussbeck",
	    "Nwachukwu",
	    "Nytra",
	    "Nöh",
	    "Oberem",
	    "Obergföll",
	    "Obermaier",
	    "Ochs",
	    "Oeser",
	    "Olbrich",
	    "Onnen",
	    "Ophey",
	    "Oppong",
	    "Orth",
	    "Orthmann",
	    "Oschkenat",
	    "Osei",
	    "Osenberg",
	    "Ostendarp",
	    "Ostwald",
	    "Otte",
	    "Otto",
	    "Paesler",
	    "Pajonk",
	    "Pallentin",
	    "Panzig",
	    "Paschke",
	    "Patzwahl",
	    "Paukner",
	    "Peselman",
	    "Peter",
	    "Peters",
	    "Petzold",
	    "Pfeiffer",
	    "Pfennig",
	    "Pfersich",
	    "Pfingsten",
	    "Pflieger",
	    "Pflügner",
	    "Philipp",
	    "Pichlmaier",
	    "Piesker",
	    "Pietsch",
	    "Pingpank",
	    "Pinnock",
	    "Pippig",
	    "Pitschugin",
	    "Plank",
	    "Plass",
	    "Platzer",
	    "Plauk",
	    "Plautz",
	    "Pletsch",
	    "Plotzitzka",
	    "Poehn",
	    "Poeschl",
	    "Pogorzelski",
	    "Pohl",
	    "Pohland",
	    "Pohle",
	    "Polifka",
	    "Polizzi",
	    "Pollmächer",
	    "Pomp",
	    "Ponitzsch",
	    "Porsche",
	    "Porth",
	    "Poschmann",
	    "Poser",
	    "Pottel",
	    "Prah",
	    "Prange",
	    "Prediger",
	    "Pressler",
	    "Preuk",
	    "Preuss",
	    "Prey",
	    "Priemer",
	    "Proske",
	    "Pusch",
	    "Pöche",
	    "Pöge",
	    "Raabe",
	    "Rabenstein",
	    "Rach",
	    "Radtke",
	    "Rahn",
	    "Ranftl",
	    "Rangen",
	    "Ranz",
	    "Rapp",
	    "Rath",
	    "Rau",
	    "Raubuch",
	    "Raukuc",
	    "Rautenkranz",
	    "Rehwagen",
	    "Reiber",
	    "Reichardt",
	    "Reichel",
	    "Reichling",
	    "Reif",
	    "Reifenrath",
	    "Reimann",
	    "Reinberg",
	    "Reinelt",
	    "Reinhardt",
	    "Reinke",
	    "Reitze",
	    "Renk",
	    "Rentz",
	    "Renz",
	    "Reppin",
	    "Restle",
	    "Restorff",
	    "Retzke",
	    "Reuber",
	    "Reumann",
	    "Reus",
	    "Reuss",
	    "Reusse",
	    "Rheder",
	    "Rhoden",
	    "Richards",
	    "Richter",
	    "Riedel",
	    "Riediger",
	    "Rieger",
	    "Riekmann",
	    "Riepl",
	    "Riermeier",
	    "Riester",
	    "Riethmüller",
	    "Rietmüller",
	    "Rietscher",
	    "Ringel",
	    "Ringer",
	    "Rink",
	    "Ripken",
	    "Ritosek",
	    "Ritschel",
	    "Ritter",
	    "Rittweg",
	    "Ritz",
	    "Roba",
	    "Rockmeier",
	    "Rodehau",
	    "Rodowski",
	    "Roecker",
	    "Roggatz",
	    "Rohländer",
	    "Rohrer",
	    "Rokossa",
	    "Roleder",
	    "Roloff",
	    "Roos",
	    "Rosbach",
	    "Roschinsky",
	    "Rose",
	    "Rosenauer",
	    "Rosenbauer",
	    "Rosenthal",
	    "Rosksch",
	    "Rossberg",
	    "Rossler",
	    "Roth",
	    "Rother",
	    "Ruch",
	    "Ruckdeschel",
	    "Rumpf",
	    "Rupprecht",
	    "Ruth",
	    "Ryjikh",
	    "Ryzih",
	    "Rädler",
	    "Räntsch",
	    "Rödiger",
	    "Röse",
	    "Röttger",
	    "Rücker",
	    "Rüdiger",
	    "Rüter",
	    "Sachse",
	    "Sack",
	    "Saflanis",
	    "Sagafe",
	    "Sagonas",
	    "Sahner",
	    "Saile",
	    "Sailer",
	    "Salow",
	    "Salzer",
	    "Salzmann",
	    "Sammert",
	    "Sander",
	    "Sarvari",
	    "Sattelmaier",
	    "Sauer",
	    "Sauerland",
	    "Saumweber",
	    "Savoia",
	    "Scc",
	    "Schacht",
	    "Schaefer",
	    "Schaffarzik",
	    "Schahbasian",
	    "Scharf",
	    "Schedler",
	    "Scheer",
	    "Schelk",
	    "Schellenbeck",
	    "Schembera",
	    "Schenk",
	    "Scherbarth",
	    "Scherer",
	    "Schersing",
	    "Scherz",
	    "Scheurer",
	    "Scheuring",
	    "Scheytt",
	    "Schielke",
	    "Schieskow",
	    "Schildhauer",
	    "Schilling",
	    "Schima",
	    "Schimmer",
	    "Schindzielorz",
	    "Schirmer",
	    "Schirrmeister",
	    "Schlachter",
	    "Schlangen",
	    "Schlawitz",
	    "Schlechtweg",
	    "Schley",
	    "Schlicht",
	    "Schlitzer",
	    "Schmalzle",
	    "Schmid",
	    "Schmidt",
	    "Schmidtchen",
	    "Schmitt",
	    "Schmitz",
	    "Schmuhl",
	    "Schneider",
	    "Schnelting",
	    "Schnieder",
	    "Schniedermeier",
	    "Schnürer",
	    "Schoberg",
	    "Scholz",
	    "Schonberg",
	    "Schondelmaier",
	    "Schorr",
	    "Schott",
	    "Schottmann",
	    "Schouren",
	    "Schrader",
	    "Schramm",
	    "Schreck",
	    "Schreiber",
	    "Schreiner",
	    "Schreiter",
	    "Schroder",
	    "Schröder",
	    "Schuermann",
	    "Schuff",
	    "Schuhaj",
	    "Schuldt",
	    "Schult",
	    "Schulte",
	    "Schultz",
	    "Schultze",
	    "Schulz",
	    "Schulze",
	    "Schumacher",
	    "Schumann",
	    "Schupp",
	    "Schuri",
	    "Schuster",
	    "Schwab",
	    "Schwalm",
	    "Schwanbeck",
	    "Schwandke",
	    "Schwanitz",
	    "Schwarthoff",
	    "Schwartz",
	    "Schwarz",
	    "Schwarzer",
	    "Schwarzkopf",
	    "Schwarzmeier",
	    "Schwatlo",
	    "Schweisfurth",
	    "Schwennen",
	    "Schwerdtner",
	    "Schwidde",
	    "Schwirkschlies",
	    "Schwuchow",
	    "Schäfer",
	    "Schäffel",
	    "Schäffer",
	    "Schäning",
	    "Schöckel",
	    "Schönball",
	    "Schönbeck",
	    "Schönberg",
	    "Schönebeck",
	    "Schönenberger",
	    "Schönfeld",
	    "Schönherr",
	    "Schönlebe",
	    "Schötz",
	    "Schüler",
	    "Schüppel",
	    "Schütz",
	    "Schütze",
	    "Seeger",
	    "Seelig",
	    "Sehls",
	    "Seibold",
	    "Seidel",
	    "Seiders",
	    "Seigel",
	    "Seiler",
	    "Seitz",
	    "Semisch",
	    "Senkel",
	    "Sewald",
	    "Siebel",
	    "Siebert",
	    "Siegling",
	    "Sielemann",
	    "Siemon",
	    "Siener",
	    "Sievers",
	    "Siewert",
	    "Sihler",
	    "Sillah",
	    "Simon",
	    "Sinnhuber",
	    "Sischka",
	    "Skibicki",
	    "Sladek",
	    "Slotta",
	    "Smieja",
	    "Soboll",
	    "Sokolowski",
	    "Soller",
	    "Sollner",
	    "Sommer",
	    "Somssich",
	    "Sonn",
	    "Sonnabend",
	    "Spahn",
	    "Spank",
	    "Spelmeyer",
	    "Spiegelburg",
	    "Spielvogel",
	    "Spinner",
	    "Spitzmüller",
	    "Splinter",
	    "Sporrer",
	    "Sprenger",
	    "Spöttel",
	    "Stahl",
	    "Stang",
	    "Stanger",
	    "Stauss",
	    "Steding",
	    "Steffen",
	    "Steffny",
	    "Steidl",
	    "Steigauf",
	    "Stein",
	    "Steinecke",
	    "Steinert",
	    "Steinkamp",
	    "Steinmetz",
	    "Stelkens",
	    "Stengel",
	    "Stengl",
	    "Stenzel",
	    "Stepanov",
	    "Stephan",
	    "Stern",
	    "Steuk",
	    "Stief",
	    "Stifel",
	    "Stoll",
	    "Stolle",
	    "Stolz",
	    "Storl",
	    "Storp",
	    "Stoutjesdijk",
	    "Stratmann",
	    "Straub",
	    "Strausa",
	    "Streck",
	    "Streese",
	    "Strege",
	    "Streit",
	    "Streller",
	    "Strieder",
	    "Striezel",
	    "Strogies",
	    "Strohschank",
	    "Strunz",
	    "Strutz",
	    "Stube",
	    "Stöckert",
	    "Stöppler",
	    "Stöwer",
	    "Stürmer",
	    "Suffa",
	    "Sujew",
	    "Sussmann",
	    "Suthe",
	    "Sutschet",
	    "Swillims",
	    "Szendrei",
	    "Sören",
	    "Sürth",
	    "Tafelmeier",
	    "Tang",
	    "Tasche",
	    "Taufratshofer",
	    "Tegethof",
	    "Teichmann",
	    "Tepper",
	    "Terheiden",
	    "Terlecki",
	    "Teufel",
	    "Theele",
	    "Thieke",
	    "Thimm",
	    "Thiomas",
	    "Thomas",
	    "Thriene",
	    "Thränhardt",
	    "Thust",
	    "Thyssen",
	    "Thöne",
	    "Tidow",
	    "Tiedtke",
	    "Tietze",
	    "Tilgner",
	    "Tillack",
	    "Timmermann",
	    "Tischler",
	    "Tischmann",
	    "Tittman",
	    "Tivontschik",
	    "Tonat",
	    "Tonn",
	    "Trampeli",
	    "Trauth",
	    "Trautmann",
	    "Travan",
	    "Treff",
	    "Tremmel",
	    "Tress",
	    "Tsamonikian",
	    "Tschiers",
	    "Tschirch",
	    "Tuch",
	    "Tucholke",
	    "Tudow",
	    "Tuschmo",
	    "Tächl",
	    "Többen",
	    "Töpfer",
	    "Uhlemann",
	    "Uhlig",
	    "Uhrig",
	    "Uibel",
	    "Uliczka",
	    "Ullmann",
	    "Ullrich",
	    "Umbach",
	    "Umlauft",
	    "Umminger",
	    "Unger",
	    "Unterpaintner",
	    "Urban",
	    "Urbaniak",
	    "Urbansky",
	    "Urhig",
	    "Vahlensieck",
	    "Van",
	    "Vangermain",
	    "Vater",
	    "Venghaus",
	    "Verniest",
	    "Verzi",
	    "Vey",
	    "Viellehner",
	    "Vieweg",
	    "Voelkel",
	    "Vogel",
	    "Vogelgsang",
	    "Vogt",
	    "Voigt",
	    "Vokuhl",
	    "Volk",
	    "Volker",
	    "Volkmann",
	    "Von",
	    "Vona",
	    "Vontein",
	    "Wachenbrunner",
	    "Wachtel",
	    "Wagner",
	    "Waibel",
	    "Wakan",
	    "Waldmann",
	    "Wallner",
	    "Wallstab",
	    "Walter",
	    "Walther",
	    "Walton",
	    "Walz",
	    "Wanner",
	    "Wartenberg",
	    "Waschbüsch",
	    "Wassilew",
	    "Wassiluk",
	    "Weber",
	    "Wehrsen",
	    "Weidlich",
	    "Weidner",
	    "Weigel",
	    "Weight",
	    "Weiler",
	    "Weimer",
	    "Weis",
	    "Weiss",
	    "Weller",
	    "Welsch",
	    "Welz",
	    "Welzel",
	    "Weniger",
	    "Wenk",
	    "Werle",
	    "Werner",
	    "Werrmann",
	    "Wessel",
	    "Wessinghage",
	    "Weyel",
	    "Wezel",
	    "Wichmann",
	    "Wickert",
	    "Wiebe",
	    "Wiechmann",
	    "Wiegelmann",
	    "Wierig",
	    "Wiese",
	    "Wieser",
	    "Wilhelm",
	    "Wilky",
	    "Will",
	    "Willwacher",
	    "Wilts",
	    "Wimmer",
	    "Winkelmann",
	    "Winkler",
	    "Winter",
	    "Wischek",
	    "Wischer",
	    "Wissing",
	    "Wittich",
	    "Wittl",
	    "Wolf",
	    "Wolfarth",
	    "Wolff",
	    "Wollenberg",
	    "Wollmann",
	    "Woytkowska",
	    "Wujak",
	    "Wurm",
	    "Wyludda",
	    "Wölpert",
	    "Wöschler",
	    "Wühn",
	    "Wünsche",
	    "Zach",
	    "Zaczkiewicz",
	    "Zahn",
	    "Zaituc",
	    "Zandt",
	    "Zanner",
	    "Zapletal",
	    "Zauber",
	    "Zeidler",
	    "Zekl",
	    "Zender",
	    "Zeuch",
	    "Zeyen",
	    "Zeyhle",
	    "Ziegler",
	    "Zimanyi",
	    "Zimmer",
	    "Zimmermann",
	    "Zinser",
	    "Zintl",
	    "Zipp",
	    "Zipse",
	    "Zschunke",
	    "Zuber",
	    "Zwiener",
	    "Zümsande",
	    "Östringer",
	    "Überacker"
	  ],
	  "prefix": [
	    "Hr.",
	    "Fr.",
	    "Dr.",
	    "Prof. Dr."
	  ],
	  "nobility_title_prefix": [
	    "zu",
	    "von",
	    "vom",
	    "von der"
	  ],
	  "name": [
	    "#{prefix} #{first_name} #{last_name}",
	    "#{first_name} #{nobility_title_prefix} #{last_name}",
	    "#{first_name} #{last_name}",
	    "#{first_name} #{last_name}",
	    "#{first_name} #{last_name}",
	    "#{first_name} #{last_name}"
	  ]
	};
	de.phone_number = {
	  "formats": [
	    "(0###) #########",
	    "(0####) #######",
	    "+49-###-#######",
	    "+49-####-########"
	  ]
	};
	de.cell_phone = {
	  "formats": [
	    "+49-1##-#######",
	    "+49-1###-########"
	  ]
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)(module)))

/***/ },
/* 293 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var de_AT = {};
	module["exports"] = de_AT;
	de_AT.title = "German (Austria)";
	de_AT.address = {
	  "country": [
	    "Ägypten",
	    "Äquatorialguinea",
	    "Äthiopien",
	    "Österreich",
	    "Afghanistan",
	    "Albanien",
	    "Algerien",
	    "Amerikanisch-Samoa",
	    "Amerikanische Jungferninseln",
	    "Andorra",
	    "Angola",
	    "Anguilla",
	    "Antarktis",
	    "Antigua und Barbuda",
	    "Argentinien",
	    "Armenien",
	    "Aruba",
	    "Aserbaidschan",
	    "Australien",
	    "Bahamas",
	    "Bahrain",
	    "Bangladesch",
	    "Barbados",
	    "Belarus",
	    "Belgien",
	    "Belize",
	    "Benin",
	    "die Bermudas",
	    "Bhutan",
	    "Bolivien",
	    "Bosnien und Herzegowina",
	    "Botsuana",
	    "Bouvetinsel",
	    "Brasilien",
	    "Britische Jungferninseln",
	    "Britisches Territorium im Indischen Ozean",
	    "Brunei Darussalam",
	    "Bulgarien",
	    "Burkina Faso",
	    "Burundi",
	    "Chile",
	    "China",
	    "Cookinseln",
	    "Costa Rica",
	    "Dänemark",
	    "Demokratische Republik Kongo",
	    "Demokratische Volksrepublik Korea",
	    "Deutschland",
	    "Dominica",
	    "Dominikanische Republik",
	    "Dschibuti",
	    "Ecuador",
	    "El Salvador",
	    "Eritrea",
	    "Estland",
	    "Färöer",
	    "Falklandinseln",
	    "Fidschi",
	    "Finnland",
	    "Frankreich",
	    "Französisch-Guayana",
	    "Französisch-Polynesien",
	    "Französische Gebiete im südlichen Indischen Ozean",
	    "Gabun",
	    "Gambia",
	    "Georgien",
	    "Ghana",
	    "Gibraltar",
	    "Grönland",
	    "Grenada",
	    "Griechenland",
	    "Guadeloupe",
	    "Guam",
	    "Guatemala",
	    "Guinea",
	    "Guinea-Bissau",
	    "Guyana",
	    "Haiti",
	    "Heard und McDonaldinseln",
	    "Honduras",
	    "Hongkong",
	    "Indien",
	    "Indonesien",
	    "Irak",
	    "Iran",
	    "Irland",
	    "Island",
	    "Israel",
	    "Italien",
	    "Jamaika",
	    "Japan",
	    "Jemen",
	    "Jordanien",
	    "Jugoslawien",
	    "Kaimaninseln",
	    "Kambodscha",
	    "Kamerun",
	    "Kanada",
	    "Kap Verde",
	    "Kasachstan",
	    "Katar",
	    "Kenia",
	    "Kirgisistan",
	    "Kiribati",
	    "Kleinere amerikanische Überseeinseln",
	    "Kokosinseln",
	    "Kolumbien",
	    "Komoren",
	    "Kongo",
	    "Kroatien",
	    "Kuba",
	    "Kuwait",
	    "Laos",
	    "Lesotho",
	    "Lettland",
	    "Libanon",
	    "Liberia",
	    "Libyen",
	    "Liechtenstein",
	    "Litauen",
	    "Luxemburg",
	    "Macau",
	    "Madagaskar",
	    "Malawi",
	    "Malaysia",
	    "Malediven",
	    "Mali",
	    "Malta",
	    "ehemalige jugoslawische Republik Mazedonien",
	    "Marokko",
	    "Marshallinseln",
	    "Martinique",
	    "Mauretanien",
	    "Mauritius",
	    "Mayotte",
	    "Mexiko",
	    "Mikronesien",
	    "Monaco",
	    "Mongolei",
	    "Montserrat",
	    "Mosambik",
	    "Myanmar",
	    "Nördliche Marianen",
	    "Namibia",
	    "Nauru",
	    "Nepal",
	    "Neukaledonien",
	    "Neuseeland",
	    "Nicaragua",
	    "Niederländische Antillen",
	    "Niederlande",
	    "Niger",
	    "Nigeria",
	    "Niue",
	    "Norfolkinsel",
	    "Norwegen",
	    "Oman",
	    "Osttimor",
	    "Pakistan",
	    "Palau",
	    "Panama",
	    "Papua-Neuguinea",
	    "Paraguay",
	    "Peru",
	    "Philippinen",
	    "Pitcairninseln",
	    "Polen",
	    "Portugal",
	    "Puerto Rico",
	    "Réunion",
	    "Republik Korea",
	    "Republik Moldau",
	    "Ruanda",
	    "Rumänien",
	    "Russische Föderation",
	    "São Tomé und Príncipe",
	    "Südafrika",
	    "Südgeorgien und Südliche Sandwichinseln",
	    "Salomonen",
	    "Sambia",
	    "Samoa",
	    "San Marino",
	    "Saudi-Arabien",
	    "Schweden",
	    "Schweiz",
	    "Senegal",
	    "Seychellen",
	    "Sierra Leone",
	    "Simbabwe",
	    "Singapur",
	    "Slowakei",
	    "Slowenien",
	    "Somalien",
	    "Spanien",
	    "Sri Lanka",
	    "St. Helena",
	    "St. Kitts und Nevis",
	    "St. Lucia",
	    "St. Pierre und Miquelon",
	    "St. Vincent und die Grenadinen",
	    "Sudan",
	    "Surinam",
	    "Svalbard und Jan Mayen",
	    "Swasiland",
	    "Syrien",
	    "Türkei",
	    "Tadschikistan",
	    "Taiwan",
	    "Tansania",
	    "Thailand",
	    "Togo",
	    "Tokelau",
	    "Tonga",
	    "Trinidad und Tobago",
	    "Tschad",
	    "Tschechische Republik",
	    "Tunesien",
	    "Turkmenistan",
	    "Turks- und Caicosinseln",
	    "Tuvalu",
	    "Uganda",
	    "Ukraine",
	    "Ungarn",
	    "Uruguay",
	    "Usbekistan",
	    "Vanuatu",
	    "Vatikanstadt",
	    "Venezuela",
	    "Vereinigte Arabische Emirate",
	    "Vereinigte Staaten",
	    "Vereinigtes Königreich",
	    "Vietnam",
	    "Wallis und Futuna",
	    "Weihnachtsinsel",
	    "Westsahara",
	    "Zentralafrikanische Republik",
	    "Zypern"
	  ],
	  "street_root": [
	    "Ahorn",
	    "Ahorngasse (St. Andrä)",
	    "Alleestraße (Poysbrunn)",
	    "Alpenlandstraße",
	    "Alte Poststraße",
	    "Alte Ufergasse",
	    "Am Kronawett (Hagenbrunn)",
	    "Am Mühlwasser",
	    "Am Rebenhang",
	    "Am Sternweg",
	    "Anton Wildgans-Straße",
	    "Auer-von-Welsbach-Weg",
	    "Auf der Stift",
	    "Aufeldgasse",
	    "Bahngasse",
	    "Bahnhofstraße",
	    "Bahnstraße (Gerhaus)",
	    "Basteigasse",
	    "Berggasse",
	    "Bergstraße",
	    "Birkenweg",
	    "Blasiussteig",
	    "Blattur",
	    "Bruderhofgasse",
	    "Brunnelligasse",
	    "Bühelweg",
	    "Darnautgasse",
	    "Donaugasse",
	    "Dorfplatz (Haselbach)",
	    "Dr.-Oberreiter-Straße",
	    "Dr.Karl Holoubek-Str.",
	    "Drautal Bundesstraße",
	    "Dürnrohrer Straße",
	    "Ebenthalerstraße",
	    "Eckgrabenweg",
	    "Erlenstraße",
	    "Erlenweg",
	    "Eschenweg",
	    "Etrichgasse",
	    "Fassergasse",
	    "Feichteggerwiese",
	    "Feld-Weg",
	    "Feldgasse",
	    "Feldstapfe",
	    "Fischpointweg",
	    "Flachbergstraße",
	    "Flurweg",
	    "Franz Schubert-Gasse",
	    "Franz-Schneeweiß-Weg",
	    "Franz-von-Assisi-Straße",
	    "Fritz-Pregl-Straße",
	    "Fuchsgrubenweg",
	    "Födlerweg",
	    "Föhrenweg",
	    "Fünfhaus (Paasdorf)",
	    "Gabelsbergerstraße",
	    "Gartenstraße",
	    "Geigen",
	    "Geigergasse",
	    "Gemeindeaugasse",
	    "Gemeindeplatz",
	    "Georg-Aichinger-Straße",
	    "Glanfeldbachweg",
	    "Graben (Burgauberg)",
	    "Grub",
	    "Gröretgasse",
	    "Grünbach",
	    "Gösting",
	    "Hainschwang",
	    "Hans-Mauracher-Straße",
	    "Hart",
	    "Teichstraße",
	    "Hauptplatz",
	    "Hauptstraße",
	    "Heideweg",
	    "Heinrich Landauer Gasse",
	    "Helenengasse",
	    "Hermann von Gilmweg",
	    "Hermann-Löns-Gasse",
	    "Herminengasse",
	    "Hernstorferstraße",
	    "Hirsdorf",
	    "Hochfeistritz",
	    "Hochhaus Neue Donau",
	    "Hof",
	    "Hussovits Gasse",
	    "Höggen",
	    "Hütten",
	    "Janzgasse",
	    "Jochriemgutstraße",
	    "Johann-Strauß-Gasse",
	    "Julius-Raab-Straße",
	    "Kahlenberger Straße",
	    "Karl Kraft-Straße",
	    "Kegelprielstraße",
	    "Keltenberg-Eponaweg",
	    "Kennedybrücke",
	    "Kerpelystraße",
	    "Kindergartenstraße",
	    "Kinderheimgasse",
	    "Kirchenplatz",
	    "Kirchweg",
	    "Klagenfurter Straße",
	    "Klamm",
	    "Kleinbaumgarten",
	    "Klingergasse",
	    "Koloniestraße",
	    "Konrad-Duden-Gasse",
	    "Krankenhausstraße",
	    "Kubinstraße",
	    "Köhldorfergasse",
	    "Lackenweg",
	    "Lange Mekotte",
	    "Leifling",
	    "Leopold Frank-Straße (Pellendorf)",
	    "Lerchengasse (Pirka)",
	    "Lichtensternsiedlung V",
	    "Lindenhofstraße",
	    "Lindenweg",
	    "Luegstraße",
	    "Maierhof",
	    "Malerweg",
	    "Mitterweg",
	    "Mittlere Hauptstraße",
	    "Moosbachgasse",
	    "Morettigasse",
	    "Musikpavillon Riezlern",
	    "Mühlboden",
	    "Mühle",
	    "Mühlenweg",
	    "Neustiftgasse",
	    "Niederegg",
	    "Niedergams",
	    "Nordwestbahnbrücke",
	    "Oberbödenalm",
	    "Obere Berggasse",
	    "Oedt",
	    "Am Färberberg",
	    "Ottogasse",
	    "Paul Peters-Gasse",
	    "Perspektivstraße",
	    "Poppichl",
	    "Privatweg",
	    "Prixgasse",
	    "Pyhra",
	    "Radetzkystraße",
	    "Raiden",
	    "Reichensteinstraße",
	    "Reitbauernstraße",
	    "Reiterweg",
	    "Reitschulgasse",
	    "Ringweg",
	    "Rupertistraße",
	    "Römerstraße",
	    "Römerweg",
	    "Sackgasse",
	    "Schaunbergerstraße",
	    "Schloßweg",
	    "Schulgasse (Langeck)",
	    "Schönholdsiedlung",
	    "Seeblick",
	    "Seestraße",
	    "Semriacherstraße",
	    "Simling",
	    "Sipbachzeller Straße",
	    "Sonnenweg",
	    "Spargelfeldgasse",
	    "Spiesmayrweg",
	    "Sportplatzstraße",
	    "St.Ulrich",
	    "Steilmannstraße",
	    "Steingrüneredt",
	    "Strassfeld",
	    "Straßerau",
	    "Stöpflweg",
	    "Stüra",
	    "Taferngasse",
	    "Tennweg",
	    "Thomas Koschat-Gasse",
	    "Tiroler Straße",
	    "Torrogasse",
	    "Uferstraße (Schwarzau am Steinfeld)",
	    "Unterdörfl",
	    "Unterer Sonnrainweg",
	    "Verwaltersiedlung",
	    "Waldhang",
	    "Wasen",
	    "Weidenstraße",
	    "Weiherweg",
	    "Wettsteingasse",
	    "Wiener Straße",
	    "Windisch",
	    "Zebragasse",
	    "Zellerstraße",
	    "Ziehrerstraße",
	    "Zulechnerweg",
	    "Zwergjoch",
	    "Ötzbruck"
	  ],
	  "building_number": [
	    "###",
	    "##",
	    "#",
	    "##a",
	    "##b",
	    "##c"
	  ],
	  "secondary_address": [
	    "Apt. ###",
	    "Zimmer ###",
	    "# OG"
	  ],
	  "postcode": [
	    "####"
	  ],
	  "state": [
	    "Burgenland",
	    "Kärnten",
	    "Niederösterreich",
	    "Oberösterreich",
	    "Salzburg",
	    "Steiermark",
	    "Tirol",
	    "Vorarlberg",
	    "Wien"
	  ],
	  "state_abbr": [
	    "Bgld.",
	    "Ktn.",
	    "NÖ",
	    "OÖ",
	    "Sbg.",
	    "Stmk.",
	    "T",
	    "Vbg.",
	    "W"
	  ],
	  "city_name": [
	    "Aigen im Mühlkreis",
	    "Allerheiligen bei Wildon",
	    "Altenfelden",
	    "Arriach",
	    "Axams",
	    "Baumgartenberg",
	    "Bergern im Dunkelsteinerwald",
	    "Berndorf bei Salzburg",
	    "Bregenz",
	    "Breitenbach am Inn",
	    "Deutsch-Wagram",
	    "Dienten am Hochkönig",
	    "Dietach",
	    "Dornbirn",
	    "Dürnkrut",
	    "Eben im Pongau",
	    "Ebenthal in Kärnten",
	    "Eichgraben",
	    "Eisenstadt",
	    "Ellmau",
	    "Feistritz am Wechsel",
	    "Finkenberg",
	    "Fiss",
	    "Frantschach-St. Gertraud",
	    "Fritzens",
	    "Gams bei Hieflau",
	    "Geiersberg",
	    "Graz",
	    "Großhöflein",
	    "Gößnitz",
	    "Hartl",
	    "Hausleiten",
	    "Herzogenburg",
	    "Hinterhornbach",
	    "Hochwolkersdorf",
	    "Ilz",
	    "Ilztal",
	    "Innerbraz",
	    "Innsbruck",
	    "Itter",
	    "Jagerberg",
	    "Jeging",
	    "Johnsbach",
	    "Johnsdorf-Brunn",
	    "Jungholz",
	    "Kirchdorf am Inn",
	    "Klagenfurt",
	    "Kottes-Purk",
	    "Krumau am Kamp",
	    "Krumbach",
	    "Lavamünd",
	    "Lech",
	    "Linz",
	    "Ludesch",
	    "Lödersdorf",
	    "Marbach an der Donau",
	    "Mattsee",
	    "Mautern an der Donau",
	    "Mauterndorf",
	    "Mitterbach am Erlaufsee",
	    "Neudorf bei Passail",
	    "Neudorf bei Staatz",
	    "Neukirchen an der Enknach",
	    "Neustift an der Lafnitz",
	    "Niederleis",
	    "Oberndorf in Tirol",
	    "Oberstorcha",
	    "Oberwaltersdorf",
	    "Oed-Oehling",
	    "Ort im Innkreis",
	    "Pilgersdorf",
	    "Pitschgau",
	    "Pollham",
	    "Preitenegg",
	    "Purbach am Neusiedler See",
	    "Rabenwald",
	    "Raiding",
	    "Rastenfeld",
	    "Ratten",
	    "Rettenegg",
	    "Salzburg",
	    "Sankt Johann im Saggautal",
	    "St. Peter am Kammersberg",
	    "St. Pölten",
	    "St. Veit an der Glan",
	    "Taxenbach",
	    "Tragwein",
	    "Trebesing",
	    "Trieben",
	    "Turnau",
	    "Ungerdorf",
	    "Unterauersbach",
	    "Unterstinkenbrunn",
	    "Untertilliach",
	    "Uttendorf",
	    "Vals",
	    "Velden am Wörther See",
	    "Viehhofen",
	    "Villach",
	    "Vitis",
	    "Waidhofen an der Thaya",
	    "Waldkirchen am Wesen",
	    "Weißkirchen an der Traun",
	    "Wien",
	    "Wimpassing im Schwarzatale",
	    "Ybbs an der Donau",
	    "Ybbsitz",
	    "Yspertal",
	    "Zeillern",
	    "Zell am Pettenfirst",
	    "Zell an der Pram",
	    "Zerlach",
	    "Zwölfaxing",
	    "Öblarn",
	    "Übelbach",
	    "Überackern",
	    "Übersaxen",
	    "Übersbach"
	  ],
	  "city": [
	    "#{city_name}"
	  ],
	  "street_name": [
	    "#{street_root}"
	  ],
	  "street_address": [
	    "#{street_name} #{building_number}"
	  ],
	  "default_country": [
	    "Österreich"
	  ]
	};
	de_AT.company = {
	  "suffix": [
	    "GmbH",
	    "AG",
	    "Gruppe",
	    "KG",
	    "GmbH & Co. KG",
	    "UG",
	    "OHG"
	  ],
	  "legal_form": [
	    "GmbH",
	    "AG",
	    "Gruppe",
	    "KG",
	    "GmbH & Co. KG",
	    "UG",
	    "OHG"
	  ],
	  "name": [
	    "#{Name.last_name} #{suffix}",
	    "#{Name.last_name}-#{Name.last_name}",
	    "#{Name.last_name}, #{Name.last_name} und #{Name.last_name}"
	  ]
	};
	de_AT.internet = {
	  "free_email": [
	    "gmail.com",
	    "yahoo.com",
	    "hotmail.com"
	  ],
	  "domain_suffix": [
	    "com",
	    "info",
	    "name",
	    "net",
	    "org",
	    "de",
	    "ch",
	    "at"
	  ]
	};
	de_AT.name = {
	  "first_name": [
	    "Aaron",
	    "Abdul",
	    "Abdullah",
	    "Adam",
	    "Adrian",
	    "Adriano",
	    "Ahmad",
	    "Ahmed",
	    "Ahmet",
	    "Alan",
	    "Albert",
	    "Alessandro",
	    "Alessio",
	    "Alex",
	    "Alexander",
	    "Alfred",
	    "Ali",
	    "Amar",
	    "Amir",
	    "Amon",
	    "Andre",
	    "Andreas",
	    "Andrew",
	    "Angelo",
	    "Ansgar",
	    "Anthony",
	    "Anton",
	    "Antonio",
	    "Arda",
	    "Arian",
	    "Armin",
	    "Arne",
	    "Arno",
	    "Arthur",
	    "Artur",
	    "Arved",
	    "Arvid",
	    "Ayman",
	    "Baran",
	    "Baris",
	    "Bastian",
	    "Batuhan",
	    "Bela",
	    "Ben",
	    "Benedikt",
	    "Benjamin",
	    "Bennet",
	    "Bennett",
	    "Benno",
	    "Bent",
	    "Berat",
	    "Berkay",
	    "Bernd",
	    "Bilal",
	    "Bjarne",
	    "Björn",
	    "Bo",
	    "Boris",
	    "Brandon",
	    "Brian",
	    "Bruno",
	    "Bryan",
	    "Burak",
	    "Calvin",
	    "Can",
	    "Carl",
	    "Carlo",
	    "Carlos",
	    "Caspar",
	    "Cedric",
	    "Cedrik",
	    "Cem",
	    "Charlie",
	    "Chris",
	    "Christian",
	    "Christiano",
	    "Christoph",
	    "Christopher",
	    "Claas",
	    "Clemens",
	    "Colin",
	    "Collin",
	    "Conner",
	    "Connor",
	    "Constantin",
	    "Corvin",
	    "Curt",
	    "Damian",
	    "Damien",
	    "Daniel",
	    "Danilo",
	    "Danny",
	    "Darian",
	    "Dario",
	    "Darius",
	    "Darren",
	    "David",
	    "Davide",
	    "Davin",
	    "Dean",
	    "Deniz",
	    "Dennis",
	    "Denny",
	    "Devin",
	    "Diego",
	    "Dion",
	    "Domenic",
	    "Domenik",
	    "Dominic",
	    "Dominik",
	    "Dorian",
	    "Dustin",
	    "Dylan",
	    "Ecrin",
	    "Eddi",
	    "Eddy",
	    "Edgar",
	    "Edwin",
	    "Efe",
	    "Ege",
	    "Elia",
	    "Eliah",
	    "Elias",
	    "Elijah",
	    "Emanuel",
	    "Emil",
	    "Emilian",
	    "Emilio",
	    "Emir",
	    "Emirhan",
	    "Emre",
	    "Enes",
	    "Enno",
	    "Enrico",
	    "Eren",
	    "Eric",
	    "Erik",
	    "Etienne",
	    "Fabian",
	    "Fabien",
	    "Fabio",
	    "Fabrice",
	    "Falk",
	    "Felix",
	    "Ferdinand",
	    "Fiete",
	    "Filip",
	    "Finlay",
	    "Finley",
	    "Finn",
	    "Finnley",
	    "Florian",
	    "Francesco",
	    "Franz",
	    "Frederic",
	    "Frederick",
	    "Frederik",
	    "Friedrich",
	    "Fritz",
	    "Furkan",
	    "Fynn",
	    "Gabriel",
	    "Georg",
	    "Gerrit",
	    "Gian",
	    "Gianluca",
	    "Gino",
	    "Giuliano",
	    "Giuseppe",
	    "Gregor",
	    "Gustav",
	    "Hagen",
	    "Hamza",
	    "Hannes",
	    "Hanno",
	    "Hans",
	    "Hasan",
	    "Hassan",
	    "Hauke",
	    "Hendrik",
	    "Hennes",
	    "Henning",
	    "Henri",
	    "Henrick",
	    "Henrik",
	    "Henry",
	    "Hugo",
	    "Hussein",
	    "Ian",
	    "Ibrahim",
	    "Ilias",
	    "Ilja",
	    "Ilyas",
	    "Immanuel",
	    "Ismael",
	    "Ismail",
	    "Ivan",
	    "Iven",
	    "Jack",
	    "Jacob",
	    "Jaden",
	    "Jakob",
	    "Jamal",
	    "James",
	    "Jamie",
	    "Jan",
	    "Janek",
	    "Janis",
	    "Janne",
	    "Jannek",
	    "Jannes",
	    "Jannik",
	    "Jannis",
	    "Jano",
	    "Janosch",
	    "Jared",
	    "Jari",
	    "Jarne",
	    "Jarno",
	    "Jaron",
	    "Jason",
	    "Jasper",
	    "Jay",
	    "Jayden",
	    "Jayson",
	    "Jean",
	    "Jens",
	    "Jeremias",
	    "Jeremie",
	    "Jeremy",
	    "Jermaine",
	    "Jerome",
	    "Jesper",
	    "Jesse",
	    "Jim",
	    "Jimmy",
	    "Joe",
	    "Joel",
	    "Joey",
	    "Johann",
	    "Johannes",
	    "John",
	    "Johnny",
	    "Jon",
	    "Jona",
	    "Jonah",
	    "Jonas",
	    "Jonathan",
	    "Jonte",
	    "Joost",
	    "Jordan",
	    "Joris",
	    "Joscha",
	    "Joschua",
	    "Josef",
	    "Joseph",
	    "Josh",
	    "Joshua",
	    "Josua",
	    "Juan",
	    "Julian",
	    "Julien",
	    "Julius",
	    "Juri",
	    "Justin",
	    "Justus",
	    "Kaan",
	    "Kai",
	    "Kalle",
	    "Karim",
	    "Karl",
	    "Karlo",
	    "Kay",
	    "Keanu",
	    "Kenan",
	    "Kenny",
	    "Keno",
	    "Kerem",
	    "Kerim",
	    "Kevin",
	    "Kian",
	    "Kilian",
	    "Kim",
	    "Kimi",
	    "Kjell",
	    "Klaas",
	    "Klemens",
	    "Konrad",
	    "Konstantin",
	    "Koray",
	    "Korbinian",
	    "Kurt",
	    "Lars",
	    "Lasse",
	    "Laurence",
	    "Laurens",
	    "Laurenz",
	    "Laurin",
	    "Lean",
	    "Leander",
	    "Leandro",
	    "Leif",
	    "Len",
	    "Lenn",
	    "Lennard",
	    "Lennart",
	    "Lennert",
	    "Lennie",
	    "Lennox",
	    "Lenny",
	    "Leo",
	    "Leon",
	    "Leonard",
	    "Leonardo",
	    "Leonhard",
	    "Leonidas",
	    "Leopold",
	    "Leroy",
	    "Levent",
	    "Levi",
	    "Levin",
	    "Lewin",
	    "Lewis",
	    "Liam",
	    "Lian",
	    "Lias",
	    "Lino",
	    "Linus",
	    "Lio",
	    "Lion",
	    "Lionel",
	    "Logan",
	    "Lorenz",
	    "Lorenzo",
	    "Loris",
	    "Louis",
	    "Luan",
	    "Luc",
	    "Luca",
	    "Lucas",
	    "Lucian",
	    "Lucien",
	    "Ludwig",
	    "Luis",
	    "Luiz",
	    "Luk",
	    "Luka",
	    "Lukas",
	    "Luke",
	    "Lutz",
	    "Maddox",
	    "Mads",
	    "Magnus",
	    "Maik",
	    "Maksim",
	    "Malik",
	    "Malte",
	    "Manuel",
	    "Marc",
	    "Marcel",
	    "Marco",
	    "Marcus",
	    "Marek",
	    "Marian",
	    "Mario",
	    "Marius",
	    "Mark",
	    "Marko",
	    "Markus",
	    "Marlo",
	    "Marlon",
	    "Marten",
	    "Martin",
	    "Marvin",
	    "Marwin",
	    "Mateo",
	    "Mathis",
	    "Matis",
	    "Mats",
	    "Matteo",
	    "Mattes",
	    "Matthias",
	    "Matthis",
	    "Matti",
	    "Mattis",
	    "Maurice",
	    "Max",
	    "Maxim",
	    "Maximilian",
	    "Mehmet",
	    "Meik",
	    "Melvin",
	    "Merlin",
	    "Mert",
	    "Michael",
	    "Michel",
	    "Mick",
	    "Miguel",
	    "Mika",
	    "Mikail",
	    "Mike",
	    "Milan",
	    "Milo",
	    "Mio",
	    "Mirac",
	    "Mirco",
	    "Mirko",
	    "Mohamed",
	    "Mohammad",
	    "Mohammed",
	    "Moritz",
	    "Morten",
	    "Muhammed",
	    "Murat",
	    "Mustafa",
	    "Nathan",
	    "Nathanael",
	    "Nelson",
	    "Neo",
	    "Nevio",
	    "Nick",
	    "Niclas",
	    "Nico",
	    "Nicolai",
	    "Nicolas",
	    "Niels",
	    "Nikita",
	    "Niklas",
	    "Niko",
	    "Nikolai",
	    "Nikolas",
	    "Nils",
	    "Nino",
	    "Noah",
	    "Noel",
	    "Norman",
	    "Odin",
	    "Oke",
	    "Ole",
	    "Oliver",
	    "Omar",
	    "Onur",
	    "Oscar",
	    "Oskar",
	    "Pascal",
	    "Patrice",
	    "Patrick",
	    "Paul",
	    "Peer",
	    "Pepe",
	    "Peter",
	    "Phil",
	    "Philip",
	    "Philipp",
	    "Pierre",
	    "Piet",
	    "Pit",
	    "Pius",
	    "Quentin",
	    "Quirin",
	    "Rafael",
	    "Raik",
	    "Ramon",
	    "Raphael",
	    "Rasmus",
	    "Raul",
	    "Rayan",
	    "René",
	    "Ricardo",
	    "Riccardo",
	    "Richard",
	    "Rick",
	    "Rico",
	    "Robert",
	    "Robin",
	    "Rocco",
	    "Roman",
	    "Romeo",
	    "Ron",
	    "Ruben",
	    "Ryan",
	    "Said",
	    "Salih",
	    "Sam",
	    "Sami",
	    "Sammy",
	    "Samuel",
	    "Sandro",
	    "Santino",
	    "Sascha",
	    "Sean",
	    "Sebastian",
	    "Selim",
	    "Semih",
	    "Shawn",
	    "Silas",
	    "Simeon",
	    "Simon",
	    "Sinan",
	    "Sky",
	    "Stefan",
	    "Steffen",
	    "Stephan",
	    "Steve",
	    "Steven",
	    "Sven",
	    "Sönke",
	    "Sören",
	    "Taha",
	    "Tamino",
	    "Tammo",
	    "Tarik",
	    "Tayler",
	    "Taylor",
	    "Teo",
	    "Theo",
	    "Theodor",
	    "Thies",
	    "Thilo",
	    "Thomas",
	    "Thorben",
	    "Thore",
	    "Thorge",
	    "Tiago",
	    "Til",
	    "Till",
	    "Tillmann",
	    "Tim",
	    "Timm",
	    "Timo",
	    "Timon",
	    "Timothy",
	    "Tino",
	    "Titus",
	    "Tizian",
	    "Tjark",
	    "Tobias",
	    "Tom",
	    "Tommy",
	    "Toni",
	    "Tony",
	    "Torben",
	    "Tore",
	    "Tristan",
	    "Tyler",
	    "Tyron",
	    "Umut",
	    "Valentin",
	    "Valentino",
	    "Veit",
	    "Victor",
	    "Viktor",
	    "Vin",
	    "Vincent",
	    "Vito",
	    "Vitus",
	    "Wilhelm",
	    "Willi",
	    "William",
	    "Willy",
	    "Xaver",
	    "Yannic",
	    "Yannick",
	    "Yannik",
	    "Yannis",
	    "Yasin",
	    "Youssef",
	    "Yunus",
	    "Yusuf",
	    "Yven",
	    "Yves",
	    "Ömer",
	    "Aaliyah",
	    "Abby",
	    "Abigail",
	    "Ada",
	    "Adelina",
	    "Adriana",
	    "Aileen",
	    "Aimee",
	    "Alana",
	    "Alea",
	    "Alena",
	    "Alessa",
	    "Alessia",
	    "Alexa",
	    "Alexandra",
	    "Alexia",
	    "Alexis",
	    "Aleyna",
	    "Alia",
	    "Alica",
	    "Alice",
	    "Alicia",
	    "Alina",
	    "Alisa",
	    "Alisha",
	    "Alissa",
	    "Aliya",
	    "Aliyah",
	    "Allegra",
	    "Alma",
	    "Alyssa",
	    "Amalia",
	    "Amanda",
	    "Amelia",
	    "Amelie",
	    "Amina",
	    "Amira",
	    "Amy",
	    "Ana",
	    "Anabel",
	    "Anastasia",
	    "Andrea",
	    "Angela",
	    "Angelina",
	    "Angelique",
	    "Anja",
	    "Ann",
	    "Anna",
	    "Annabel",
	    "Annabell",
	    "Annabelle",
	    "Annalena",
	    "Anne",
	    "Anneke",
	    "Annelie",
	    "Annemarie",
	    "Anni",
	    "Annie",
	    "Annika",
	    "Anny",
	    "Anouk",
	    "Antonia",
	    "Arda",
	    "Ariana",
	    "Ariane",
	    "Arwen",
	    "Ashley",
	    "Asya",
	    "Aurelia",
	    "Aurora",
	    "Ava",
	    "Ayleen",
	    "Aylin",
	    "Ayse",
	    "Azra",
	    "Betty",
	    "Bianca",
	    "Bianka",
	    "Caitlin",
	    "Cara",
	    "Carina",
	    "Carla",
	    "Carlotta",
	    "Carmen",
	    "Carolin",
	    "Carolina",
	    "Caroline",
	    "Cassandra",
	    "Catharina",
	    "Catrin",
	    "Cecile",
	    "Cecilia",
	    "Celia",
	    "Celina",
	    "Celine",
	    "Ceyda",
	    "Ceylin",
	    "Chantal",
	    "Charleen",
	    "Charlotta",
	    "Charlotte",
	    "Chayenne",
	    "Cheyenne",
	    "Chiara",
	    "Christin",
	    "Christina",
	    "Cindy",
	    "Claire",
	    "Clara",
	    "Clarissa",
	    "Colleen",
	    "Collien",
	    "Cora",
	    "Corinna",
	    "Cosima",
	    "Dana",
	    "Daniela",
	    "Daria",
	    "Darleen",
	    "Defne",
	    "Delia",
	    "Denise",
	    "Diana",
	    "Dilara",
	    "Dina",
	    "Dorothea",
	    "Ecrin",
	    "Eda",
	    "Eileen",
	    "Ela",
	    "Elaine",
	    "Elanur",
	    "Elea",
	    "Elena",
	    "Eleni",
	    "Eleonora",
	    "Eliana",
	    "Elif",
	    "Elina",
	    "Elisa",
	    "Elisabeth",
	    "Ella",
	    "Ellen",
	    "Elli",
	    "Elly",
	    "Elsa",
	    "Emelie",
	    "Emely",
	    "Emilia",
	    "Emilie",
	    "Emily",
	    "Emma",
	    "Emmely",
	    "Emmi",
	    "Emmy",
	    "Enie",
	    "Enna",
	    "Enya",
	    "Esma",
	    "Estelle",
	    "Esther",
	    "Eva",
	    "Evelin",
	    "Evelina",
	    "Eveline",
	    "Evelyn",
	    "Fabienne",
	    "Fatima",
	    "Fatma",
	    "Felicia",
	    "Felicitas",
	    "Felina",
	    "Femke",
	    "Fenja",
	    "Fine",
	    "Finia",
	    "Finja",
	    "Finnja",
	    "Fiona",
	    "Flora",
	    "Florentine",
	    "Francesca",
	    "Franka",
	    "Franziska",
	    "Frederike",
	    "Freya",
	    "Frida",
	    "Frieda",
	    "Friederike",
	    "Giada",
	    "Gina",
	    "Giulia",
	    "Giuliana",
	    "Greta",
	    "Hailey",
	    "Hana",
	    "Hanna",
	    "Hannah",
	    "Heidi",
	    "Helen",
	    "Helena",
	    "Helene",
	    "Helin",
	    "Henriette",
	    "Henrike",
	    "Hermine",
	    "Ida",
	    "Ilayda",
	    "Imke",
	    "Ina",
	    "Ines",
	    "Inga",
	    "Inka",
	    "Irem",
	    "Isa",
	    "Isabel",
	    "Isabell",
	    "Isabella",
	    "Isabelle",
	    "Ivonne",
	    "Jacqueline",
	    "Jamie",
	    "Jamila",
	    "Jana",
	    "Jane",
	    "Janin",
	    "Janina",
	    "Janine",
	    "Janna",
	    "Janne",
	    "Jara",
	    "Jasmin",
	    "Jasmina",
	    "Jasmine",
	    "Jella",
	    "Jenna",
	    "Jennifer",
	    "Jenny",
	    "Jessica",
	    "Jessy",
	    "Jette",
	    "Jil",
	    "Jill",
	    "Joana",
	    "Joanna",
	    "Joelina",
	    "Joeline",
	    "Joelle",
	    "Johanna",
	    "Joleen",
	    "Jolie",
	    "Jolien",
	    "Jolin",
	    "Jolina",
	    "Joline",
	    "Jona",
	    "Jonah",
	    "Jonna",
	    "Josefin",
	    "Josefine",
	    "Josephin",
	    "Josephine",
	    "Josie",
	    "Josy",
	    "Joy",
	    "Joyce",
	    "Judith",
	    "Judy",
	    "Jule",
	    "Julia",
	    "Juliana",
	    "Juliane",
	    "Julie",
	    "Julienne",
	    "Julika",
	    "Julina",
	    "Juna",
	    "Justine",
	    "Kaja",
	    "Karina",
	    "Karla",
	    "Karlotta",
	    "Karolina",
	    "Karoline",
	    "Kassandra",
	    "Katarina",
	    "Katharina",
	    "Kathrin",
	    "Katja",
	    "Katrin",
	    "Kaya",
	    "Kayra",
	    "Kiana",
	    "Kiara",
	    "Kim",
	    "Kimberley",
	    "Kimberly",
	    "Kira",
	    "Klara",
	    "Korinna",
	    "Kristin",
	    "Kyra",
	    "Laila",
	    "Lana",
	    "Lara",
	    "Larissa",
	    "Laura",
	    "Laureen",
	    "Lavinia",
	    "Lea",
	    "Leah",
	    "Leana",
	    "Leandra",
	    "Leann",
	    "Lee",
	    "Leila",
	    "Lena",
	    "Lene",
	    "Leni",
	    "Lenia",
	    "Lenja",
	    "Lenya",
	    "Leona",
	    "Leoni",
	    "Leonie",
	    "Leonora",
	    "Leticia",
	    "Letizia",
	    "Levke",
	    "Leyla",
	    "Lia",
	    "Liah",
	    "Liana",
	    "Lili",
	    "Lilia",
	    "Lilian",
	    "Liliana",
	    "Lilith",
	    "Lilli",
	    "Lillian",
	    "Lilly",
	    "Lily",
	    "Lina",
	    "Linda",
	    "Lindsay",
	    "Line",
	    "Linn",
	    "Linnea",
	    "Lisa",
	    "Lisann",
	    "Lisanne",
	    "Liv",
	    "Livia",
	    "Liz",
	    "Lola",
	    "Loreen",
	    "Lorena",
	    "Lotta",
	    "Lotte",
	    "Louisa",
	    "Louise",
	    "Luana",
	    "Luca",
	    "Lucia",
	    "Lucie",
	    "Lucienne",
	    "Lucy",
	    "Luisa",
	    "Luise",
	    "Luka",
	    "Luna",
	    "Luzie",
	    "Lya",
	    "Lydia",
	    "Lyn",
	    "Lynn",
	    "Madeleine",
	    "Madita",
	    "Madleen",
	    "Madlen",
	    "Magdalena",
	    "Maike",
	    "Mailin",
	    "Maira",
	    "Maja",
	    "Malena",
	    "Malia",
	    "Malin",
	    "Malina",
	    "Mandy",
	    "Mara",
	    "Marah",
	    "Mareike",
	    "Maren",
	    "Maria",
	    "Mariam",
	    "Marie",
	    "Marieke",
	    "Mariella",
	    "Marika",
	    "Marina",
	    "Marisa",
	    "Marissa",
	    "Marit",
	    "Marla",
	    "Marleen",
	    "Marlen",
	    "Marlena",
	    "Marlene",
	    "Marta",
	    "Martha",
	    "Mary",
	    "Maryam",
	    "Mathilda",
	    "Mathilde",
	    "Matilda",
	    "Maxi",
	    "Maxima",
	    "Maxine",
	    "Maya",
	    "Mayra",
	    "Medina",
	    "Medine",
	    "Meike",
	    "Melanie",
	    "Melek",
	    "Melike",
	    "Melina",
	    "Melinda",
	    "Melis",
	    "Melisa",
	    "Melissa",
	    "Merle",
	    "Merve",
	    "Meryem",
	    "Mette",
	    "Mia",
	    "Michaela",
	    "Michelle",
	    "Mieke",
	    "Mila",
	    "Milana",
	    "Milena",
	    "Milla",
	    "Mina",
	    "Mira",
	    "Miray",
	    "Miriam",
	    "Mirja",
	    "Mona",
	    "Monique",
	    "Nadine",
	    "Nadja",
	    "Naemi",
	    "Nancy",
	    "Naomi",
	    "Natalia",
	    "Natalie",
	    "Nathalie",
	    "Neele",
	    "Nela",
	    "Nele",
	    "Nelli",
	    "Nelly",
	    "Nia",
	    "Nicole",
	    "Nika",
	    "Nike",
	    "Nikita",
	    "Nila",
	    "Nina",
	    "Nisa",
	    "Noemi",
	    "Nora",
	    "Olivia",
	    "Patricia",
	    "Patrizia",
	    "Paula",
	    "Paulina",
	    "Pauline",
	    "Penelope",
	    "Philine",
	    "Phoebe",
	    "Pia",
	    "Rahel",
	    "Rania",
	    "Rebecca",
	    "Rebekka",
	    "Riana",
	    "Rieke",
	    "Rike",
	    "Romina",
	    "Romy",
	    "Ronja",
	    "Rosa",
	    "Rosalie",
	    "Ruby",
	    "Sabrina",
	    "Sahra",
	    "Sally",
	    "Salome",
	    "Samantha",
	    "Samia",
	    "Samira",
	    "Sandra",
	    "Sandy",
	    "Sanja",
	    "Saphira",
	    "Sara",
	    "Sarah",
	    "Saskia",
	    "Selin",
	    "Selina",
	    "Selma",
	    "Sena",
	    "Sidney",
	    "Sienna",
	    "Silja",
	    "Sina",
	    "Sinja",
	    "Smilla",
	    "Sofia",
	    "Sofie",
	    "Sonja",
	    "Sophia",
	    "Sophie",
	    "Soraya",
	    "Stefanie",
	    "Stella",
	    "Stephanie",
	    "Stina",
	    "Sude",
	    "Summer",
	    "Susanne",
	    "Svea",
	    "Svenja",
	    "Sydney",
	    "Tabea",
	    "Talea",
	    "Talia",
	    "Tamara",
	    "Tamia",
	    "Tamina",
	    "Tanja",
	    "Tara",
	    "Tarja",
	    "Teresa",
	    "Tessa",
	    "Thalea",
	    "Thalia",
	    "Thea",
	    "Theresa",
	    "Tia",
	    "Tina",
	    "Tomke",
	    "Tuana",
	    "Valentina",
	    "Valeria",
	    "Valerie",
	    "Vanessa",
	    "Vera",
	    "Veronika",
	    "Victoria",
	    "Viktoria",
	    "Viola",
	    "Vivian",
	    "Vivien",
	    "Vivienne",
	    "Wibke",
	    "Wiebke",
	    "Xenia",
	    "Yara",
	    "Yaren",
	    "Yasmin",
	    "Ylvi",
	    "Ylvie",
	    "Yvonne",
	    "Zara",
	    "Zehra",
	    "Zeynep",
	    "Zoe",
	    "Zoey",
	    "Zoé"
	  ],
	  "last_name": [
	    "Abel",
	    "Abicht",
	    "Abraham",
	    "Abramovic",
	    "Abt",
	    "Achilles",
	    "Achkinadze",
	    "Ackermann",
	    "Adam",
	    "Adams",
	    "Ade",
	    "Agostini",
	    "Ahlke",
	    "Ahrenberg",
	    "Ahrens",
	    "Aigner",
	    "Albert",
	    "Albrecht",
	    "Alexa",
	    "Alexander",
	    "Alizadeh",
	    "Allgeyer",
	    "Amann",
	    "Amberg",
	    "Anding",
	    "Anggreny",
	    "Apitz",
	    "Arendt",
	    "Arens",
	    "Arndt",
	    "Aryee",
	    "Aschenbroich",
	    "Assmus",
	    "Astafei",
	    "Auer",
	    "Axmann",
	    "Baarck",
	    "Bachmann",
	    "Badane",
	    "Bader",
	    "Baganz",
	    "Bahl",
	    "Bak",
	    "Balcer",
	    "Balck",
	    "Balkow",
	    "Balnuweit",
	    "Balzer",
	    "Banse",
	    "Barr",
	    "Bartels",
	    "Barth",
	    "Barylla",
	    "Baseda",
	    "Battke",
	    "Bauer",
	    "Bauermeister",
	    "Baumann",
	    "Baumeister",
	    "Bauschinger",
	    "Bauschke",
	    "Bayer",
	    "Beavogui",
	    "Beck",
	    "Beckel",
	    "Becker",
	    "Beckmann",
	    "Bedewitz",
	    "Beele",
	    "Beer",
	    "Beggerow",
	    "Beh",
	    "Behr",
	    "Behrenbruch",
	    "Belz",
	    "Bender",
	    "Benecke",
	    "Benner",
	    "Benninger",
	    "Benzing",
	    "Berends",
	    "Berger",
	    "Berner",
	    "Berning",
	    "Bertenbreiter",
	    "Best",
	    "Bethke",
	    "Betz",
	    "Beushausen",
	    "Beutelspacher",
	    "Beyer",
	    "Biba",
	    "Bichler",
	    "Bickel",
	    "Biedermann",
	    "Bieler",
	    "Bielert",
	    "Bienasch",
	    "Bienias",
	    "Biesenbach",
	    "Bigdeli",
	    "Birkemeyer",
	    "Bittner",
	    "Blank",
	    "Blaschek",
	    "Blassneck",
	    "Bloch",
	    "Blochwitz",
	    "Blockhaus",
	    "Blum",
	    "Blume",
	    "Bock",
	    "Bode",
	    "Bogdashin",
	    "Bogenrieder",
	    "Bohge",
	    "Bolm",
	    "Borgschulze",
	    "Bork",
	    "Bormann",
	    "Bornscheuer",
	    "Borrmann",
	    "Borsch",
	    "Boruschewski",
	    "Bos",
	    "Bosler",
	    "Bourrouag",
	    "Bouschen",
	    "Boxhammer",
	    "Boyde",
	    "Bozsik",
	    "Brand",
	    "Brandenburg",
	    "Brandis",
	    "Brandt",
	    "Brauer",
	    "Braun",
	    "Brehmer",
	    "Breitenstein",
	    "Bremer",
	    "Bremser",
	    "Brenner",
	    "Brettschneider",
	    "Breu",
	    "Breuer",
	    "Briesenick",
	    "Bringmann",
	    "Brinkmann",
	    "Brix",
	    "Broening",
	    "Brosch",
	    "Bruckmann",
	    "Bruder",
	    "Bruhns",
	    "Brunner",
	    "Bruns",
	    "Bräutigam",
	    "Brömme",
	    "Brüggmann",
	    "Buchholz",
	    "Buchrucker",
	    "Buder",
	    "Bultmann",
	    "Bunjes",
	    "Burger",
	    "Burghagen",
	    "Burkhard",
	    "Burkhardt",
	    "Burmeister",
	    "Busch",
	    "Buschbaum",
	    "Busemann",
	    "Buss",
	    "Busse",
	    "Bussmann",
	    "Byrd",
	    "Bäcker",
	    "Böhm",
	    "Bönisch",
	    "Börgeling",
	    "Börner",
	    "Böttner",
	    "Büchele",
	    "Bühler",
	    "Büker",
	    "Büngener",
	    "Bürger",
	    "Bürklein",
	    "Büscher",
	    "Büttner",
	    "Camara",
	    "Carlowitz",
	    "Carlsohn",
	    "Caspari",
	    "Caspers",
	    "Chapron",
	    "Christ",
	    "Cierpinski",
	    "Clarius",
	    "Cleem",
	    "Cleve",
	    "Co",
	    "Conrad",
	    "Cordes",
	    "Cornelsen",
	    "Cors",
	    "Cotthardt",
	    "Crews",
	    "Cronjäger",
	    "Crosskofp",
	    "Da",
	    "Dahm",
	    "Dahmen",
	    "Daimer",
	    "Damaske",
	    "Danneberg",
	    "Danner",
	    "Daub",
	    "Daubner",
	    "Daudrich",
	    "Dauer",
	    "Daum",
	    "Dauth",
	    "Dautzenberg",
	    "De",
	    "Decker",
	    "Deckert",
	    "Deerberg",
	    "Dehmel",
	    "Deja",
	    "Delonge",
	    "Demut",
	    "Dengler",
	    "Denner",
	    "Denzinger",
	    "Derr",
	    "Dertmann",
	    "Dethloff",
	    "Deuschle",
	    "Dieckmann",
	    "Diedrich",
	    "Diekmann",
	    "Dienel",
	    "Dies",
	    "Dietrich",
	    "Dietz",
	    "Dietzsch",
	    "Diezel",
	    "Dilla",
	    "Dingelstedt",
	    "Dippl",
	    "Dittmann",
	    "Dittmar",
	    "Dittmer",
	    "Dix",
	    "Dobbrunz",
	    "Dobler",
	    "Dohring",
	    "Dolch",
	    "Dold",
	    "Dombrowski",
	    "Donie",
	    "Doskoczynski",
	    "Dragu",
	    "Drechsler",
	    "Drees",
	    "Dreher",
	    "Dreier",
	    "Dreissigacker",
	    "Dressler",
	    "Drews",
	    "Duma",
	    "Dutkiewicz",
	    "Dyett",
	    "Dylus",
	    "Dächert",
	    "Döbel",
	    "Döring",
	    "Dörner",
	    "Dörre",
	    "Dück",
	    "Eberhard",
	    "Eberhardt",
	    "Ecker",
	    "Eckhardt",
	    "Edorh",
	    "Effler",
	    "Eggenmueller",
	    "Ehm",
	    "Ehmann",
	    "Ehrig",
	    "Eich",
	    "Eichmann",
	    "Eifert",
	    "Einert",
	    "Eisenlauer",
	    "Ekpo",
	    "Elbe",
	    "Eleyth",
	    "Elss",
	    "Emert",
	    "Emmelmann",
	    "Ender",
	    "Engel",
	    "Engelen",
	    "Engelmann",
	    "Eplinius",
	    "Erdmann",
	    "Erhardt",
	    "Erlei",
	    "Erm",
	    "Ernst",
	    "Ertl",
	    "Erwes",
	    "Esenwein",
	    "Esser",
	    "Evers",
	    "Everts",
	    "Ewald",
	    "Fahner",
	    "Faller",
	    "Falter",
	    "Farber",
	    "Fassbender",
	    "Faulhaber",
	    "Fehrig",
	    "Feld",
	    "Felke",
	    "Feller",
	    "Fenner",
	    "Fenske",
	    "Feuerbach",
	    "Fietz",
	    "Figl",
	    "Figura",
	    "Filipowski",
	    "Filsinger",
	    "Fincke",
	    "Fink",
	    "Finke",
	    "Fischer",
	    "Fitschen",
	    "Fleischer",
	    "Fleischmann",
	    "Floder",
	    "Florczak",
	    "Flore",
	    "Flottmann",
	    "Forkel",
	    "Forst",
	    "Frahmeke",
	    "Frank",
	    "Franke",
	    "Franta",
	    "Frantz",
	    "Franz",
	    "Franzis",
	    "Franzmann",
	    "Frauen",
	    "Frauendorf",
	    "Freigang",
	    "Freimann",
	    "Freimuth",
	    "Freisen",
	    "Frenzel",
	    "Frey",
	    "Fricke",
	    "Fried",
	    "Friedek",
	    "Friedenberg",
	    "Friedmann",
	    "Friedrich",
	    "Friess",
	    "Frisch",
	    "Frohn",
	    "Frosch",
	    "Fuchs",
	    "Fuhlbrügge",
	    "Fusenig",
	    "Fust",
	    "Förster",
	    "Gaba",
	    "Gabius",
	    "Gabler",
	    "Gadschiew",
	    "Gakstädter",
	    "Galander",
	    "Gamlin",
	    "Gamper",
	    "Gangnus",
	    "Ganzmann",
	    "Garatva",
	    "Gast",
	    "Gastel",
	    "Gatzka",
	    "Gauder",
	    "Gebhardt",
	    "Geese",
	    "Gehre",
	    "Gehrig",
	    "Gehring",
	    "Gehrke",
	    "Geiger",
	    "Geisler",
	    "Geissler",
	    "Gelling",
	    "Gens",
	    "Gerbennow",
	    "Gerdel",
	    "Gerhardt",
	    "Gerschler",
	    "Gerson",
	    "Gesell",
	    "Geyer",
	    "Ghirmai",
	    "Ghosh",
	    "Giehl",
	    "Gierisch",
	    "Giesa",
	    "Giesche",
	    "Gilde",
	    "Glatting",
	    "Goebel",
	    "Goedicke",
	    "Goldbeck",
	    "Goldfuss",
	    "Goldkamp",
	    "Goldkühle",
	    "Goller",
	    "Golling",
	    "Gollnow",
	    "Golomski",
	    "Gombert",
	    "Gotthardt",
	    "Gottschalk",
	    "Gotz",
	    "Goy",
	    "Gradzki",
	    "Graf",
	    "Grams",
	    "Grasse",
	    "Gratzky",
	    "Grau",
	    "Greb",
	    "Green",
	    "Greger",
	    "Greithanner",
	    "Greschner",
	    "Griem",
	    "Griese",
	    "Grimm",
	    "Gromisch",
	    "Gross",
	    "Grosser",
	    "Grossheim",
	    "Grosskopf",
	    "Grothaus",
	    "Grothkopp",
	    "Grotke",
	    "Grube",
	    "Gruber",
	    "Grundmann",
	    "Gruning",
	    "Gruszecki",
	    "Gröss",
	    "Grötzinger",
	    "Grün",
	    "Grüner",
	    "Gummelt",
	    "Gunkel",
	    "Gunther",
	    "Gutjahr",
	    "Gutowicz",
	    "Gutschank",
	    "Göbel",
	    "Göckeritz",
	    "Göhler",
	    "Görlich",
	    "Görmer",
	    "Götz",
	    "Götzelmann",
	    "Güldemeister",
	    "Günther",
	    "Günz",
	    "Gürbig",
	    "Haack",
	    "Haaf",
	    "Habel",
	    "Hache",
	    "Hackbusch",
	    "Hackelbusch",
	    "Hadfield",
	    "Hadwich",
	    "Haferkamp",
	    "Hahn",
	    "Hajek",
	    "Hallmann",
	    "Hamann",
	    "Hanenberger",
	    "Hannecker",
	    "Hanniske",
	    "Hansen",
	    "Hardy",
	    "Hargasser",
	    "Harms",
	    "Harnapp",
	    "Harter",
	    "Harting",
	    "Hartlieb",
	    "Hartmann",
	    "Hartwig",
	    "Hartz",
	    "Haschke",
	    "Hasler",
	    "Hasse",
	    "Hassfeld",
	    "Haug",
	    "Hauke",
	    "Haupt",
	    "Haverney",
	    "Heberstreit",
	    "Hechler",
	    "Hecht",
	    "Heck",
	    "Hedermann",
	    "Hehl",
	    "Heidelmann",
	    "Heidler",
	    "Heinemann",
	    "Heinig",
	    "Heinke",
	    "Heinrich",
	    "Heinze",
	    "Heiser",
	    "Heist",
	    "Hellmann",
	    "Helm",
	    "Helmke",
	    "Helpling",
	    "Hengmith",
	    "Henkel",
	    "Hennes",
	    "Henry",
	    "Hense",
	    "Hensel",
	    "Hentel",
	    "Hentschel",
	    "Hentschke",
	    "Hepperle",
	    "Herberger",
	    "Herbrand",
	    "Hering",
	    "Hermann",
	    "Hermecke",
	    "Herms",
	    "Herold",
	    "Herrmann",
	    "Herschmann",
	    "Hertel",
	    "Herweg",
	    "Herwig",
	    "Herzenberg",
	    "Hess",
	    "Hesse",
	    "Hessek",
	    "Hessler",
	    "Hetzler",
	    "Heuck",
	    "Heydemüller",
	    "Hiebl",
	    "Hildebrand",
	    "Hildenbrand",
	    "Hilgendorf",
	    "Hillard",
	    "Hiller",
	    "Hingsen",
	    "Hingst",
	    "Hinrichs",
	    "Hirsch",
	    "Hirschberg",
	    "Hirt",
	    "Hodea",
	    "Hoffman",
	    "Hoffmann",
	    "Hofmann",
	    "Hohenberger",
	    "Hohl",
	    "Hohn",
	    "Hohnheiser",
	    "Hold",
	    "Holdt",
	    "Holinski",
	    "Holl",
	    "Holtfreter",
	    "Holz",
	    "Holzdeppe",
	    "Holzner",
	    "Hommel",
	    "Honz",
	    "Hooss",
	    "Hoppe",
	    "Horak",
	    "Horn",
	    "Horna",
	    "Hornung",
	    "Hort",
	    "Howard",
	    "Huber",
	    "Huckestein",
	    "Hudak",
	    "Huebel",
	    "Hugo",
	    "Huhn",
	    "Hujo",
	    "Huke",
	    "Huls",
	    "Humbert",
	    "Huneke",
	    "Huth",
	    "Häber",
	    "Häfner",
	    "Höcke",
	    "Höft",
	    "Höhne",
	    "Hönig",
	    "Hördt",
	    "Hübenbecker",
	    "Hübl",
	    "Hübner",
	    "Hügel",
	    "Hüttcher",
	    "Hütter",
	    "Ibe",
	    "Ihly",
	    "Illing",
	    "Isak",
	    "Isekenmeier",
	    "Itt",
	    "Jacob",
	    "Jacobs",
	    "Jagusch",
	    "Jahn",
	    "Jahnke",
	    "Jakobs",
	    "Jakubczyk",
	    "Jambor",
	    "Jamrozy",
	    "Jander",
	    "Janich",
	    "Janke",
	    "Jansen",
	    "Jarets",
	    "Jaros",
	    "Jasinski",
	    "Jasper",
	    "Jegorov",
	    "Jellinghaus",
	    "Jeorga",
	    "Jerschabek",
	    "Jess",
	    "John",
	    "Jonas",
	    "Jossa",
	    "Jucken",
	    "Jung",
	    "Jungbluth",
	    "Jungton",
	    "Just",
	    "Jürgens",
	    "Kaczmarek",
	    "Kaesmacher",
	    "Kahl",
	    "Kahlert",
	    "Kahles",
	    "Kahlmeyer",
	    "Kaiser",
	    "Kalinowski",
	    "Kallabis",
	    "Kallensee",
	    "Kampf",
	    "Kampschulte",
	    "Kappe",
	    "Kappler",
	    "Karhoff",
	    "Karrass",
	    "Karst",
	    "Karsten",
	    "Karus",
	    "Kass",
	    "Kasten",
	    "Kastner",
	    "Katzinski",
	    "Kaufmann",
	    "Kaul",
	    "Kausemann",
	    "Kawohl",
	    "Kazmarek",
	    "Kedzierski",
	    "Keil",
	    "Keiner",
	    "Keller",
	    "Kelm",
	    "Kempe",
	    "Kemper",
	    "Kempter",
	    "Kerl",
	    "Kern",
	    "Kesselring",
	    "Kesselschläger",
	    "Kette",
	    "Kettenis",
	    "Keutel",
	    "Kick",
	    "Kiessling",
	    "Kinadeter",
	    "Kinzel",
	    "Kinzy",
	    "Kirch",
	    "Kirst",
	    "Kisabaka",
	    "Klaas",
	    "Klabuhn",
	    "Klapper",
	    "Klauder",
	    "Klaus",
	    "Kleeberg",
	    "Kleiber",
	    "Klein",
	    "Kleinert",
	    "Kleininger",
	    "Kleinmann",
	    "Kleinsteuber",
	    "Kleiss",
	    "Klemme",
	    "Klimczak",
	    "Klinger",
	    "Klink",
	    "Klopsch",
	    "Klose",
	    "Kloss",
	    "Kluge",
	    "Kluwe",
	    "Knabe",
	    "Kneifel",
	    "Knetsch",
	    "Knies",
	    "Knippel",
	    "Knobel",
	    "Knoblich",
	    "Knoll",
	    "Knorr",
	    "Knorscheidt",
	    "Knut",
	    "Kobs",
	    "Koch",
	    "Kochan",
	    "Kock",
	    "Koczulla",
	    "Koderisch",
	    "Koehl",
	    "Koehler",
	    "Koenig",
	    "Koester",
	    "Kofferschlager",
	    "Koha",
	    "Kohle",
	    "Kohlmann",
	    "Kohnle",
	    "Kohrt",
	    "Koj",
	    "Kolb",
	    "Koleiski",
	    "Kolokas",
	    "Komoll",
	    "Konieczny",
	    "Konig",
	    "Konow",
	    "Konya",
	    "Koob",
	    "Kopf",
	    "Kosenkow",
	    "Koster",
	    "Koszewski",
	    "Koubaa",
	    "Kovacs",
	    "Kowalick",
	    "Kowalinski",
	    "Kozakiewicz",
	    "Krabbe",
	    "Kraft",
	    "Kral",
	    "Kramer",
	    "Krauel",
	    "Kraus",
	    "Krause",
	    "Krauspe",
	    "Kreb",
	    "Krebs",
	    "Kreissig",
	    "Kresse",
	    "Kreutz",
	    "Krieger",
	    "Krippner",
	    "Krodinger",
	    "Krohn",
	    "Krol",
	    "Kron",
	    "Krueger",
	    "Krug",
	    "Kruger",
	    "Krull",
	    "Kruschinski",
	    "Krämer",
	    "Kröckert",
	    "Kröger",
	    "Krüger",
	    "Kubera",
	    "Kufahl",
	    "Kuhlee",
	    "Kuhnen",
	    "Kulimann",
	    "Kulma",
	    "Kumbernuss",
	    "Kummle",
	    "Kunz",
	    "Kupfer",
	    "Kupprion",
	    "Kuprion",
	    "Kurnicki",
	    "Kurrat",
	    "Kurschilgen",
	    "Kuschewitz",
	    "Kuschmann",
	    "Kuske",
	    "Kustermann",
	    "Kutscherauer",
	    "Kutzner",
	    "Kwadwo",
	    "Kähler",
	    "Käther",
	    "Köhler",
	    "Köhrbrück",
	    "Köhre",
	    "Kölotzei",
	    "König",
	    "Köpernick",
	    "Köseoglu",
	    "Kúhn",
	    "Kúhnert",
	    "Kühn",
	    "Kühnel",
	    "Kühnemund",
	    "Kühnert",
	    "Kühnke",
	    "Küsters",
	    "Küter",
	    "Laack",
	    "Lack",
	    "Ladewig",
	    "Lakomy",
	    "Lammert",
	    "Lamos",
	    "Landmann",
	    "Lang",
	    "Lange",
	    "Langfeld",
	    "Langhirt",
	    "Lanig",
	    "Lauckner",
	    "Lauinger",
	    "Laurén",
	    "Lausecker",
	    "Laux",
	    "Laws",
	    "Lax",
	    "Leberer",
	    "Lehmann",
	    "Lehner",
	    "Leibold",
	    "Leide",
	    "Leimbach",
	    "Leipold",
	    "Leist",
	    "Leiter",
	    "Leiteritz",
	    "Leitheim",
	    "Leiwesmeier",
	    "Lenfers",
	    "Lenk",
	    "Lenz",
	    "Lenzen",
	    "Leo",
	    "Lepthin",
	    "Lesch",
	    "Leschnik",
	    "Letzelter",
	    "Lewin",
	    "Lewke",
	    "Leyckes",
	    "Lg",
	    "Lichtenfeld",
	    "Lichtenhagen",
	    "Lichtl",
	    "Liebach",
	    "Liebe",
	    "Liebich",
	    "Liebold",
	    "Lieder",
	    "Lienshöft",
	    "Linden",
	    "Lindenberg",
	    "Lindenmayer",
	    "Lindner",
	    "Linke",
	    "Linnenbaum",
	    "Lippe",
	    "Lipske",
	    "Lipus",
	    "Lischka",
	    "Lobinger",
	    "Logsch",
	    "Lohmann",
	    "Lohre",
	    "Lohse",
	    "Lokar",
	    "Loogen",
	    "Lorenz",
	    "Losch",
	    "Loska",
	    "Lott",
	    "Loy",
	    "Lubina",
	    "Ludolf",
	    "Lufft",
	    "Lukoschek",
	    "Lutje",
	    "Lutz",
	    "Löser",
	    "Löwa",
	    "Lübke",
	    "Maak",
	    "Maczey",
	    "Madetzky",
	    "Madubuko",
	    "Mai",
	    "Maier",
	    "Maisch",
	    "Malek",
	    "Malkus",
	    "Mallmann",
	    "Malucha",
	    "Manns",
	    "Manz",
	    "Marahrens",
	    "Marchewski",
	    "Margis",
	    "Markowski",
	    "Marl",
	    "Marner",
	    "Marquart",
	    "Marschek",
	    "Martel",
	    "Marten",
	    "Martin",
	    "Marx",
	    "Marxen",
	    "Mathes",
	    "Mathies",
	    "Mathiszik",
	    "Matschke",
	    "Mattern",
	    "Matthes",
	    "Matula",
	    "Mau",
	    "Maurer",
	    "Mauroff",
	    "May",
	    "Maybach",
	    "Mayer",
	    "Mebold",
	    "Mehl",
	    "Mehlhorn",
	    "Mehlorn",
	    "Meier",
	    "Meisch",
	    "Meissner",
	    "Meloni",
	    "Melzer",
	    "Menga",
	    "Menne",
	    "Mensah",
	    "Mensing",
	    "Merkel",
	    "Merseburg",
	    "Mertens",
	    "Mesloh",
	    "Metzger",
	    "Metzner",
	    "Mewes",
	    "Meyer",
	    "Michallek",
	    "Michel",
	    "Mielke",
	    "Mikitenko",
	    "Milde",
	    "Minah",
	    "Mintzlaff",
	    "Mockenhaupt",
	    "Moede",
	    "Moedl",
	    "Moeller",
	    "Moguenara",
	    "Mohr",
	    "Mohrhard",
	    "Molitor",
	    "Moll",
	    "Moller",
	    "Molzan",
	    "Montag",
	    "Moormann",
	    "Mordhorst",
	    "Morgenstern",
	    "Morhelfer",
	    "Moritz",
	    "Moser",
	    "Motchebon",
	    "Motzenbbäcker",
	    "Mrugalla",
	    "Muckenthaler",
	    "Mues",
	    "Muller",
	    "Mulrain",
	    "Mächtig",
	    "Mäder",
	    "Möcks",
	    "Mögenburg",
	    "Möhsner",
	    "Möldner",
	    "Möllenbeck",
	    "Möller",
	    "Möllinger",
	    "Mörsch",
	    "Mühleis",
	    "Müller",
	    "Münch",
	    "Nabein",
	    "Nabow",
	    "Nagel",
	    "Nannen",
	    "Nastvogel",
	    "Nau",
	    "Naubert",
	    "Naumann",
	    "Ne",
	    "Neimke",
	    "Nerius",
	    "Neubauer",
	    "Neubert",
	    "Neuendorf",
	    "Neumair",
	    "Neumann",
	    "Neupert",
	    "Neurohr",
	    "Neuschwander",
	    "Newton",
	    "Ney",
	    "Nicolay",
	    "Niedermeier",
	    "Nieklauson",
	    "Niklaus",
	    "Nitzsche",
	    "Noack",
	    "Nodler",
	    "Nolte",
	    "Normann",
	    "Norris",
	    "Northoff",
	    "Nowak",
	    "Nussbeck",
	    "Nwachukwu",
	    "Nytra",
	    "Nöh",
	    "Oberem",
	    "Obergföll",
	    "Obermaier",
	    "Ochs",
	    "Oeser",
	    "Olbrich",
	    "Onnen",
	    "Ophey",
	    "Oppong",
	    "Orth",
	    "Orthmann",
	    "Oschkenat",
	    "Osei",
	    "Osenberg",
	    "Ostendarp",
	    "Ostwald",
	    "Otte",
	    "Otto",
	    "Paesler",
	    "Pajonk",
	    "Pallentin",
	    "Panzig",
	    "Paschke",
	    "Patzwahl",
	    "Paukner",
	    "Peselman",
	    "Peter",
	    "Peters",
	    "Petzold",
	    "Pfeiffer",
	    "Pfennig",
	    "Pfersich",
	    "Pfingsten",
	    "Pflieger",
	    "Pflügner",
	    "Philipp",
	    "Pichlmaier",
	    "Piesker",
	    "Pietsch",
	    "Pingpank",
	    "Pinnock",
	    "Pippig",
	    "Pitschugin",
	    "Plank",
	    "Plass",
	    "Platzer",
	    "Plauk",
	    "Plautz",
	    "Pletsch",
	    "Plotzitzka",
	    "Poehn",
	    "Poeschl",
	    "Pogorzelski",
	    "Pohl",
	    "Pohland",
	    "Pohle",
	    "Polifka",
	    "Polizzi",
	    "Pollmächer",
	    "Pomp",
	    "Ponitzsch",
	    "Porsche",
	    "Porth",
	    "Poschmann",
	    "Poser",
	    "Pottel",
	    "Prah",
	    "Prange",
	    "Prediger",
	    "Pressler",
	    "Preuk",
	    "Preuss",
	    "Prey",
	    "Priemer",
	    "Proske",
	    "Pusch",
	    "Pöche",
	    "Pöge",
	    "Raabe",
	    "Rabenstein",
	    "Rach",
	    "Radtke",
	    "Rahn",
	    "Ranftl",
	    "Rangen",
	    "Ranz",
	    "Rapp",
	    "Rath",
	    "Rau",
	    "Raubuch",
	    "Raukuc",
	    "Rautenkranz",
	    "Rehwagen",
	    "Reiber",
	    "Reichardt",
	    "Reichel",
	    "Reichling",
	    "Reif",
	    "Reifenrath",
	    "Reimann",
	    "Reinberg",
	    "Reinelt",
	    "Reinhardt",
	    "Reinke",
	    "Reitze",
	    "Renk",
	    "Rentz",
	    "Renz",
	    "Reppin",
	    "Restle",
	    "Restorff",
	    "Retzke",
	    "Reuber",
	    "Reumann",
	    "Reus",
	    "Reuss",
	    "Reusse",
	    "Rheder",
	    "Rhoden",
	    "Richards",
	    "Richter",
	    "Riedel",
	    "Riediger",
	    "Rieger",
	    "Riekmann",
	    "Riepl",
	    "Riermeier",
	    "Riester",
	    "Riethmüller",
	    "Rietmüller",
	    "Rietscher",
	    "Ringel",
	    "Ringer",
	    "Rink",
	    "Ripken",
	    "Ritosek",
	    "Ritschel",
	    "Ritter",
	    "Rittweg",
	    "Ritz",
	    "Roba",
	    "Rockmeier",
	    "Rodehau",
	    "Rodowski",
	    "Roecker",
	    "Roggatz",
	    "Rohländer",
	    "Rohrer",
	    "Rokossa",
	    "Roleder",
	    "Roloff",
	    "Roos",
	    "Rosbach",
	    "Roschinsky",
	    "Rose",
	    "Rosenauer",
	    "Rosenbauer",
	    "Rosenthal",
	    "Rosksch",
	    "Rossberg",
	    "Rossler",
	    "Roth",
	    "Rother",
	    "Ruch",
	    "Ruckdeschel",
	    "Rumpf",
	    "Rupprecht",
	    "Ruth",
	    "Ryjikh",
	    "Ryzih",
	    "Rädler",
	    "Räntsch",
	    "Rödiger",
	    "Röse",
	    "Röttger",
	    "Rücker",
	    "Rüdiger",
	    "Rüter",
	    "Sachse",
	    "Sack",
	    "Saflanis",
	    "Sagafe",
	    "Sagonas",
	    "Sahner",
	    "Saile",
	    "Sailer",
	    "Salow",
	    "Salzer",
	    "Salzmann",
	    "Sammert",
	    "Sander",
	    "Sarvari",
	    "Sattelmaier",
	    "Sauer",
	    "Sauerland",
	    "Saumweber",
	    "Savoia",
	    "Scc",
	    "Schacht",
	    "Schaefer",
	    "Schaffarzik",
	    "Schahbasian",
	    "Scharf",
	    "Schedler",
	    "Scheer",
	    "Schelk",
	    "Schellenbeck",
	    "Schembera",
	    "Schenk",
	    "Scherbarth",
	    "Scherer",
	    "Schersing",
	    "Scherz",
	    "Scheurer",
	    "Scheuring",
	    "Scheytt",
	    "Schielke",
	    "Schieskow",
	    "Schildhauer",
	    "Schilling",
	    "Schima",
	    "Schimmer",
	    "Schindzielorz",
	    "Schirmer",
	    "Schirrmeister",
	    "Schlachter",
	    "Schlangen",
	    "Schlawitz",
	    "Schlechtweg",
	    "Schley",
	    "Schlicht",
	    "Schlitzer",
	    "Schmalzle",
	    "Schmid",
	    "Schmidt",
	    "Schmidtchen",
	    "Schmitt",
	    "Schmitz",
	    "Schmuhl",
	    "Schneider",
	    "Schnelting",
	    "Schnieder",
	    "Schniedermeier",
	    "Schnürer",
	    "Schoberg",
	    "Scholz",
	    "Schonberg",
	    "Schondelmaier",
	    "Schorr",
	    "Schott",
	    "Schottmann",
	    "Schouren",
	    "Schrader",
	    "Schramm",
	    "Schreck",
	    "Schreiber",
	    "Schreiner",
	    "Schreiter",
	    "Schroder",
	    "Schröder",
	    "Schuermann",
	    "Schuff",
	    "Schuhaj",
	    "Schuldt",
	    "Schult",
	    "Schulte",
	    "Schultz",
	    "Schultze",
	    "Schulz",
	    "Schulze",
	    "Schumacher",
	    "Schumann",
	    "Schupp",
	    "Schuri",
	    "Schuster",
	    "Schwab",
	    "Schwalm",
	    "Schwanbeck",
	    "Schwandke",
	    "Schwanitz",
	    "Schwarthoff",
	    "Schwartz",
	    "Schwarz",
	    "Schwarzer",
	    "Schwarzkopf",
	    "Schwarzmeier",
	    "Schwatlo",
	    "Schweisfurth",
	    "Schwennen",
	    "Schwerdtner",
	    "Schwidde",
	    "Schwirkschlies",
	    "Schwuchow",
	    "Schäfer",
	    "Schäffel",
	    "Schäffer",
	    "Schäning",
	    "Schöckel",
	    "Schönball",
	    "Schönbeck",
	    "Schönberg",
	    "Schönebeck",
	    "Schönenberger",
	    "Schönfeld",
	    "Schönherr",
	    "Schönlebe",
	    "Schötz",
	    "Schüler",
	    "Schüppel",
	    "Schütz",
	    "Schütze",
	    "Seeger",
	    "Seelig",
	    "Sehls",
	    "Seibold",
	    "Seidel",
	    "Seiders",
	    "Seigel",
	    "Seiler",
	    "Seitz",
	    "Semisch",
	    "Senkel",
	    "Sewald",
	    "Siebel",
	    "Siebert",
	    "Siegling",
	    "Sielemann",
	    "Siemon",
	    "Siener",
	    "Sievers",
	    "Siewert",
	    "Sihler",
	    "Sillah",
	    "Simon",
	    "Sinnhuber",
	    "Sischka",
	    "Skibicki",
	    "Sladek",
	    "Slotta",
	    "Smieja",
	    "Soboll",
	    "Sokolowski",
	    "Soller",
	    "Sollner",
	    "Sommer",
	    "Somssich",
	    "Sonn",
	    "Sonnabend",
	    "Spahn",
	    "Spank",
	    "Spelmeyer",
	    "Spiegelburg",
	    "Spielvogel",
	    "Spinner",
	    "Spitzmüller",
	    "Splinter",
	    "Sporrer",
	    "Sprenger",
	    "Spöttel",
	    "Stahl",
	    "Stang",
	    "Stanger",
	    "Stauss",
	    "Steding",
	    "Steffen",
	    "Steffny",
	    "Steidl",
	    "Steigauf",
	    "Stein",
	    "Steinecke",
	    "Steinert",
	    "Steinkamp",
	    "Steinmetz",
	    "Stelkens",
	    "Stengel",
	    "Stengl",
	    "Stenzel",
	    "Stepanov",
	    "Stephan",
	    "Stern",
	    "Steuk",
	    "Stief",
	    "Stifel",
	    "Stoll",
	    "Stolle",
	    "Stolz",
	    "Storl",
	    "Storp",
	    "Stoutjesdijk",
	    "Stratmann",
	    "Straub",
	    "Strausa",
	    "Streck",
	    "Streese",
	    "Strege",
	    "Streit",
	    "Streller",
	    "Strieder",
	    "Striezel",
	    "Strogies",
	    "Strohschank",
	    "Strunz",
	    "Strutz",
	    "Stube",
	    "Stöckert",
	    "Stöppler",
	    "Stöwer",
	    "Stürmer",
	    "Suffa",
	    "Sujew",
	    "Sussmann",
	    "Suthe",
	    "Sutschet",
	    "Swillims",
	    "Szendrei",
	    "Sören",
	    "Sürth",
	    "Tafelmeier",
	    "Tang",
	    "Tasche",
	    "Taufratshofer",
	    "Tegethof",
	    "Teichmann",
	    "Tepper",
	    "Terheiden",
	    "Terlecki",
	    "Teufel",
	    "Theele",
	    "Thieke",
	    "Thimm",
	    "Thiomas",
	    "Thomas",
	    "Thriene",
	    "Thränhardt",
	    "Thust",
	    "Thyssen",
	    "Thöne",
	    "Tidow",
	    "Tiedtke",
	    "Tietze",
	    "Tilgner",
	    "Tillack",
	    "Timmermann",
	    "Tischler",
	    "Tischmann",
	    "Tittman",
	    "Tivontschik",
	    "Tonat",
	    "Tonn",
	    "Trampeli",
	    "Trauth",
	    "Trautmann",
	    "Travan",
	    "Treff",
	    "Tremmel",
	    "Tress",
	    "Tsamonikian",
	    "Tschiers",
	    "Tschirch",
	    "Tuch",
	    "Tucholke",
	    "Tudow",
	    "Tuschmo",
	    "Tächl",
	    "Többen",
	    "Töpfer",
	    "Uhlemann",
	    "Uhlig",
	    "Uhrig",
	    "Uibel",
	    "Uliczka",
	    "Ullmann",
	    "Ullrich",
	    "Umbach",
	    "Umlauft",
	    "Umminger",
	    "Unger",
	    "Unterpaintner",
	    "Urban",
	    "Urbaniak",
	    "Urbansky",
	    "Urhig",
	    "Vahlensieck",
	    "Van",
	    "Vangermain",
	    "Vater",
	    "Venghaus",
	    "Verniest",
	    "Verzi",
	    "Vey",
	    "Viellehner",
	    "Vieweg",
	    "Voelkel",
	    "Vogel",
	    "Vogelgsang",
	    "Vogt",
	    "Voigt",
	    "Vokuhl",
	    "Volk",
	    "Volker",
	    "Volkmann",
	    "Von",
	    "Vona",
	    "Vontein",
	    "Wachenbrunner",
	    "Wachtel",
	    "Wagner",
	    "Waibel",
	    "Wakan",
	    "Waldmann",
	    "Wallner",
	    "Wallstab",
	    "Walter",
	    "Walther",
	    "Walton",
	    "Walz",
	    "Wanner",
	    "Wartenberg",
	    "Waschbüsch",
	    "Wassilew",
	    "Wassiluk",
	    "Weber",
	    "Wehrsen",
	    "Weidlich",
	    "Weidner",
	    "Weigel",
	    "Weight",
	    "Weiler",
	    "Weimer",
	    "Weis",
	    "Weiss",
	    "Weller",
	    "Welsch",
	    "Welz",
	    "Welzel",
	    "Weniger",
	    "Wenk",
	    "Werle",
	    "Werner",
	    "Werrmann",
	    "Wessel",
	    "Wessinghage",
	    "Weyel",
	    "Wezel",
	    "Wichmann",
	    "Wickert",
	    "Wiebe",
	    "Wiechmann",
	    "Wiegelmann",
	    "Wierig",
	    "Wiese",
	    "Wieser",
	    "Wilhelm",
	    "Wilky",
	    "Will",
	    "Willwacher",
	    "Wilts",
	    "Wimmer",
	    "Winkelmann",
	    "Winkler",
	    "Winter",
	    "Wischek",
	    "Wischer",
	    "Wissing",
	    "Wittich",
	    "Wittl",
	    "Wolf",
	    "Wolfarth",
	    "Wolff",
	    "Wollenberg",
	    "Wollmann",
	    "Woytkowska",
	    "Wujak",
	    "Wurm",
	    "Wyludda",
	    "Wölpert",
	    "Wöschler",
	    "Wühn",
	    "Wünsche",
	    "Zach",
	    "Zaczkiewicz",
	    "Zahn",
	    "Zaituc",
	    "Zandt",
	    "Zanner",
	    "Zapletal",
	    "Zauber",
	    "Zeidler",
	    "Zekl",
	    "Zender",
	    "Zeuch",
	    "Zeyen",
	    "Zeyhle",
	    "Ziegler",
	    "Zimanyi",
	    "Zimmer",
	    "Zimmermann",
	    "Zinser",
	    "Zintl",
	    "Zipp",
	    "Zipse",
	    "Zschunke",
	    "Zuber",
	    "Zwiener",
	    "Zümsande",
	    "Östringer",
	    "Überacker"
	  ],
	  "prefix": [
	    "Dr.",
	    "Prof. Dr."
	  ],
	  "nobility_title_prefix": [
	    "zu",
	    "von",
	    "vom",
	    "von der"
	  ],
	  "name": [
	    "#{prefix} #{first_name} #{last_name}",
	    "#{first_name} #{nobility_title_prefix} #{last_name}",
	    "#{first_name} #{last_name}",
	    "#{first_name} #{last_name}",
	    "#{first_name} #{last_name}",
	    "#{first_name} #{last_name}"
	  ]
	};
	de_AT.phone_number = {
	  "formats": [
	    "01 #######",
	    "01#######",
	    "+43-1-#######",
	    "+431#######",
	    "0#### ####",
	    "0#########",
	    "+43-####-####",
	    "+43 ########"
	  ]
	};
	de_AT.cell_phone = {
	  "formats": [
	    "+43-6##-#######",
	    "06##-########",
	    "+436#########",
	    "06##########"
	  ]
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)(module)))

/***/ },
/* 294 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var de_CH = {};
	module["exports"] = de_CH;
	de_CH.title = "German (Switzerland)";
	de_CH.address = {
	  "country_code": [
	    "CH",
	    "CH",
	    "CH",
	    "DE",
	    "AT",
	    "US",
	    "LI",
	    "US",
	    "HK",
	    "VN"
	  ],
	  "postcode": [
	    "1###",
	    "2###",
	    "3###",
	    "4###",
	    "5###",
	    "6###",
	    "7###",
	    "8###",
	    "9###"
	  ],
	  "default_country": [
	    "Schweiz"
	  ]
	};
	de_CH.company = {
	  "suffix": [
	    "AG",
	    "GmbH",
	    "und Söhne",
	    "und Partner",
	    "& Co.",
	    "Gruppe",
	    "LLC",
	    "Inc."
	  ],
	  "name": [
	    "#{Name.last_name} #{suffix}",
	    "#{Name.last_name}-#{Name.last_name}",
	    "#{Name.last_name}, #{Name.last_name} und #{Name.last_name}"
	  ]
	};
	de_CH.internet = {
	  "domain_suffix": [
	    "com",
	    "net",
	    "biz",
	    "ch",
	    "de",
	    "li",
	    "at",
	    "ch",
	    "ch"
	  ]
	};
	de_CH.phone_number = {
	  "formats": [
	    "0800 ### ###",
	    "0800 ## ## ##",
	    "0## ### ## ##",
	    "0## ### ## ##",
	    "+41 ## ### ## ##",
	    "0900 ### ###",
	    "076 ### ## ##",
	    "+4178 ### ## ##",
	    "0041 79 ### ## ##"
	  ]
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)(module)))

/***/ },
/* 295 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var en = {};
	module["exports"] = en;
	en.title = "English";
	en.separator = " & ";
	en.address = {
	  "city_prefix": [
	    "North",
	    "East",
	    "West",
	    "South",
	    "New",
	    "Lake",
	    "Port"
	  ],
	  "city_suffix": [
	    "town",
	    "ton",
	    "land",
	    "ville",
	    "berg",
	    "burgh",
	    "borough",
	    "bury",
	    "view",
	    "port",
	    "mouth",
	    "stad",
	    "furt",
	    "chester",
	    "mouth",
	    "fort",
	    "haven",
	    "side",
	    "shire"
	  ],
	  // TODO: get common County names in America and populate here
	  "county": [
	    "Avon",
	    "Bedfordshire",
	    "Berkshire",
	    "Borders",
	    "Buckinghamshire",
	    "Cambridgeshire"
	  ],
	  "country": [
	    "Afghanistan",
	    "Albania",
	    "Algeria",
	    "American Samoa",
	    "Andorra",
	    "Angola",
	    "Anguilla",
	    "Antarctica (the territory South of 60 deg S)",
	    "Antigua and Barbuda",
	    "Argentina",
	    "Armenia",
	    "Aruba",
	    "Australia",
	    "Austria",
	    "Azerbaijan",
	    "Bahamas",
	    "Bahrain",
	    "Bangladesh",
	    "Barbados",
	    "Belarus",
	    "Belgium",
	    "Belize",
	    "Benin",
	    "Bermuda",
	    "Bhutan",
	    "Bolivia",
	    "Bosnia and Herzegovina",
	    "Botswana",
	    "Bouvet Island (Bouvetoya)",
	    "Brazil",
	    "British Indian Ocean Territory (Chagos Archipelago)",
	    "Brunei Darussalam",
	    "Bulgaria",
	    "Burkina Faso",
	    "Burundi",
	    "Cambodia",
	    "Cameroon",
	    "Canada",
	    "Cape Verde",
	    "Cayman Islands",
	    "Central African Republic",
	    "Chad",
	    "Chile",
	    "China",
	    "Christmas Island",
	    "Cocos (Keeling) Islands",
	    "Colombia",
	    "Comoros",
	    "Congo",
	    "Congo",
	    "Cook Islands",
	    "Costa Rica",
	    "Cote d'Ivoire",
	    "Croatia",
	    "Cuba",
	    "Cyprus",
	    "Czech Republic",
	    "Denmark",
	    "Djibouti",
	    "Dominica",
	    "Dominican Republic",
	    "Ecuador",
	    "Egypt",
	    "El Salvador",
	    "Equatorial Guinea",
	    "Eritrea",
	    "Estonia",
	    "Ethiopia",
	    "Faroe Islands",
	    "Falkland Islands (Malvinas)",
	    "Fiji",
	    "Finland",
	    "France",
	    "French Guiana",
	    "French Polynesia",
	    "French Southern Territories",
	    "Gabon",
	    "Gambia",
	    "Georgia",
	    "Germany",
	    "Ghana",
	    "Gibraltar",
	    "Greece",
	    "Greenland",
	    "Grenada",
	    "Guadeloupe",
	    "Guam",
	    "Guatemala",
	    "Guernsey",
	    "Guinea",
	    "Guinea-Bissau",
	    "Guyana",
	    "Haiti",
	    "Heard Island and McDonald Islands",
	    "Holy See (Vatican City State)",
	    "Honduras",
	    "Hong Kong",
	    "Hungary",
	    "Iceland",
	    "India",
	    "Indonesia",
	    "Iran",
	    "Iraq",
	    "Ireland",
	    "Isle of Man",
	    "Israel",
	    "Italy",
	    "Jamaica",
	    "Japan",
	    "Jersey",
	    "Jordan",
	    "Kazakhstan",
	    "Kenya",
	    "Kiribati",
	    "Democratic People's Republic of Korea",
	    "Republic of Korea",
	    "Kuwait",
	    "Kyrgyz Republic",
	    "Lao People's Democratic Republic",
	    "Latvia",
	    "Lebanon",
	    "Lesotho",
	    "Liberia",
	    "Libyan Arab Jamahiriya",
	    "Liechtenstein",
	    "Lithuania",
	    "Luxembourg",
	    "Macao",
	    "Macedonia",
	    "Madagascar",
	    "Malawi",
	    "Malaysia",
	    "Maldives",
	    "Mali",
	    "Malta",
	    "Marshall Islands",
	    "Martinique",
	    "Mauritania",
	    "Mauritius",
	    "Mayotte",
	    "Mexico",
	    "Micronesia",
	    "Moldova",
	    "Monaco",
	    "Mongolia",
	    "Montenegro",
	    "Montserrat",
	    "Morocco",
	    "Mozambique",
	    "Myanmar",
	    "Namibia",
	    "Nauru",
	    "Nepal",
	    "Netherlands Antilles",
	    "Netherlands",
	    "New Caledonia",
	    "New Zealand",
	    "Nicaragua",
	    "Niger",
	    "Nigeria",
	    "Niue",
	    "Norfolk Island",
	    "Northern Mariana Islands",
	    "Norway",
	    "Oman",
	    "Pakistan",
	    "Palau",
	    "Palestinian Territory",
	    "Panama",
	    "Papua New Guinea",
	    "Paraguay",
	    "Peru",
	    "Philippines",
	    "Pitcairn Islands",
	    "Poland",
	    "Portugal",
	    "Puerto Rico",
	    "Qatar",
	    "Reunion",
	    "Romania",
	    "Russian Federation",
	    "Rwanda",
	    "Saint Barthelemy",
	    "Saint Helena",
	    "Saint Kitts and Nevis",
	    "Saint Lucia",
	    "Saint Martin",
	    "Saint Pierre and Miquelon",
	    "Saint Vincent and the Grenadines",
	    "Samoa",
	    "San Marino",
	    "Sao Tome and Principe",
	    "Saudi Arabia",
	    "Senegal",
	    "Serbia",
	    "Seychelles",
	    "Sierra Leone",
	    "Singapore",
	    "Slovakia (Slovak Republic)",
	    "Slovenia",
	    "Solomon Islands",
	    "Somalia",
	    "South Africa",
	    "South Georgia and the South Sandwich Islands",
	    "Spain",
	    "Sri Lanka",
	    "Sudan",
	    "Suriname",
	    "Svalbard & Jan Mayen Islands",
	    "Swaziland",
	    "Sweden",
	    "Switzerland",
	    "Syrian Arab Republic",
	    "Taiwan",
	    "Tajikistan",
	    "Tanzania",
	    "Thailand",
	    "Timor-Leste",
	    "Togo",
	    "Tokelau",
	    "Tonga",
	    "Trinidad and Tobago",
	    "Tunisia",
	    "Turkey",
	    "Turkmenistan",
	    "Turks and Caicos Islands",
	    "Tuvalu",
	    "Uganda",
	    "Ukraine",
	    "United Arab Emirates",
	    "United Kingdom",
	    "United States of America",
	    "United States Minor Outlying Islands",
	    "Uruguay",
	    "Uzbekistan",
	    "Vanuatu",
	    "Venezuela",
	    "Vietnam",
	    "Virgin Islands, British",
	    "Virgin Islands, U.S.",
	    "Wallis and Futuna",
	    "Western Sahara",
	    "Yemen",
	    "Zambia",
	    "Zimbabwe"
	  ],
	  "country_code": [
	    "AD",
	    "AE",
	    "AF",
	    "AG",
	    "AI",
	    "AL",
	    "AM",
	    "AO",
	    "AQ",
	    "AR",
	    "AS",
	    "AT",
	    "AU",
	    "AW",
	    "AX",
	    "AZ",
	    "BA",
	    "BB",
	    "BD",
	    "BE",
	    "BF",
	    "BG",
	    "BH",
	    "BI",
	    "BJ",
	    "BL",
	    "BM",
	    "BN",
	    "BO",
	    "BQ",
	    "BQ",
	    "BR",
	    "BS",
	    "BT",
	    "BV",
	    "BW",
	    "BY",
	    "BZ",
	    "CA",
	    "CC",
	    "CD",
	    "CF",
	    "CG",
	    "CH",
	    "CI",
	    "CK",
	    "CL",
	    "CM",
	    "CN",
	    "CO",
	    "CR",
	    "CU",
	    "CV",
	    "CW",
	    "CX",
	    "CY",
	    "CZ",
	    "DE",
	    "DJ",
	    "DK",
	    "DM",
	    "DO",
	    "DZ",
	    "EC",
	    "EE",
	    "EG",
	    "EH",
	    "ER",
	    "ES",
	    "ET",
	    "FI",
	    "FJ",
	    "FK",
	    "FM",
	    "FO",
	    "FR",
	    "GA",
	    "GB",
	    "GD",
	    "GE",
	    "GF",
	    "GG",
	    "GH",
	    "GI",
	    "GL",
	    "GM",
	    "GN",
	    "GP",
	    "GQ",
	    "GR",
	    "GS",
	    "GT",
	    "GU",
	    "GW",
	    "GY",
	    "HK",
	    "HM",
	    "HN",
	    "HR",
	    "HT",
	    "HU",
	    "ID",
	    "IE",
	    "IL",
	    "IM",
	    "IN",
	    "IO",
	    "IQ",
	    "IR",
	    "IS",
	    "IT",
	    "JE",
	    "JM",
	    "JO",
	    "JP",
	    "KE",
	    "KG",
	    "KH",
	    "KI",
	    "KM",
	    "KN",
	    "KP",
	    "KR",
	    "KW",
	    "KY",
	    "KZ",
	    "LA",
	    "LB",
	    "LC",
	    "LI",
	    "LK",
	    "LR",
	    "LS",
	    "LT",
	    "LU",
	    "LV",
	    "LY",
	    "MA",
	    "MC",
	    "MD",
	    "ME",
	    "MF",
	    "MG",
	    "MH",
	    "MK",
	    "ML",
	    "MM",
	    "MN",
	    "MO",
	    "MP",
	    "MQ",
	    "MR",
	    "MS",
	    "MT",
	    "MU",
	    "MV",
	    "MW",
	    "MX",
	    "MY",
	    "MZ",
	    "NA",
	    "NC",
	    "NE",
	    "NF",
	    "NG",
	    "NI",
	    "NL",
	    "NO",
	    "NP",
	    "NR",
	    "NU",
	    "NZ",
	    "OM",
	    "PA",
	    "PE",
	    "PF",
	    "PG",
	    "PH",
	    "PK",
	    "PL",
	    "PM",
	    "PN",
	    "PR",
	    "PS",
	    "PT",
	    "PW",
	    "PY",
	    "QA",
	    "RE",
	    "RO",
	    "RS",
	    "RU",
	    "RW",
	    "SA",
	    "SB",
	    "SC",
	    "SD",
	    "SE",
	    "SG",
	    "SH",
	    "SI",
	    "SJ",
	    "SK",
	    "SL",
	    "SM",
	    "SN",
	    "SO",
	    "SR",
	    "SS",
	    "ST",
	    "SV",
	    "SX",
	    "SY",
	    "SZ",
	    "TC",
	    "TD",
	    "TF",
	    "TG",
	    "TH",
	    "TJ",
	    "TK",
	    "TL",
	    "TM",
	    "TN",
	    "TO",
	    "TR",
	    "TT",
	    "TV",
	    "TW",
	    "TZ",
	    "UA",
	    "UG",
	    "UM",
	    "US",
	    "UY",
	    "UZ",
	    "VA",
	    "VC",
	    "VE",
	    "VG",
	    "VI",
	    "VN",
	    "VU",
	    "WF",
	    "WS",
	    "YE",
	    "YT",
	    "ZA",
	    "ZM",
	    "ZW"
	  ],
	  "building_number": [
	    "#####",
	    "####",
	    "###"
	  ],
	  "street_suffix": [
	    "Alley",
	    "Avenue",
	    "Branch",
	    "Bridge",
	    "Brook",
	    "Brooks",
	    "Burg",
	    "Burgs",
	    "Bypass",
	    "Camp",
	    "Canyon",
	    "Cape",
	    "Causeway",
	    "Center",
	    "Centers",
	    "Circle",
	    "Circles",
	    "Cliff",
	    "Cliffs",
	    "Club",
	    "Common",
	    "Corner",
	    "Corners",
	    "Course",
	    "Court",
	    "Courts",
	    "Cove",
	    "Coves",
	    "Creek",
	    "Crescent",
	    "Crest",
	    "Crossing",
	    "Crossroad",
	    "Curve",
	    "Dale",
	    "Dam",
	    "Divide",
	    "Drive",
	    "Drive",
	    "Drives",
	    "Estate",
	    "Estates",
	    "Expressway",
	    "Extension",
	    "Extensions",
	    "Fall",
	    "Falls",
	    "Ferry",
	    "Field",
	    "Fields",
	    "Flat",
	    "Flats",
	    "Ford",
	    "Fords",
	    "Forest",
	    "Forge",
	    "Forges",
	    "Fork",
	    "Forks",
	    "Fort",
	    "Freeway",
	    "Garden",
	    "Gardens",
	    "Gateway",
	    "Glen",
	    "Glens",
	    "Green",
	    "Greens",
	    "Grove",
	    "Groves",
	    "Harbor",
	    "Harbors",
	    "Haven",
	    "Heights",
	    "Highway",
	    "Hill",
	    "Hills",
	    "Hollow",
	    "Inlet",
	    "Inlet",
	    "Island",
	    "Island",
	    "Islands",
	    "Islands",
	    "Isle",
	    "Isle",
	    "Junction",
	    "Junctions",
	    "Key",
	    "Keys",
	    "Knoll",
	    "Knolls",
	    "Lake",
	    "Lakes",
	    "Land",
	    "Landing",
	    "Lane",
	    "Light",
	    "Lights",
	    "Loaf",
	    "Lock",
	    "Locks",
	    "Locks",
	    "Lodge",
	    "Lodge",
	    "Loop",
	    "Mall",
	    "Manor",
	    "Manors",
	    "Meadow",
	    "Meadows",
	    "Mews",
	    "Mill",
	    "Mills",
	    "Mission",
	    "Mission",
	    "Motorway",
	    "Mount",
	    "Mountain",
	    "Mountain",
	    "Mountains",
	    "Mountains",
	    "Neck",
	    "Orchard",
	    "Oval",
	    "Overpass",
	    "Park",
	    "Parks",
	    "Parkway",
	    "Parkways",
	    "Pass",
	    "Passage",
	    "Path",
	    "Pike",
	    "Pine",
	    "Pines",
	    "Place",
	    "Plain",
	    "Plains",
	    "Plains",
	    "Plaza",
	    "Plaza",
	    "Point",
	    "Points",
	    "Port",
	    "Port",
	    "Ports",
	    "Ports",
	    "Prairie",
	    "Prairie",
	    "Radial",
	    "Ramp",
	    "Ranch",
	    "Rapid",
	    "Rapids",
	    "Rest",
	    "Ridge",
	    "Ridges",
	    "River",
	    "Road",
	    "Road",
	    "Roads",
	    "Roads",
	    "Route",
	    "Row",
	    "Rue",
	    "Run",
	    "Shoal",
	    "Shoals",
	    "Shore",
	    "Shores",
	    "Skyway",
	    "Spring",
	    "Springs",
	    "Springs",
	    "Spur",
	    "Spurs",
	    "Square",
	    "Square",
	    "Squares",
	    "Squares",
	    "Station",
	    "Station",
	    "Stravenue",
	    "Stravenue",
	    "Stream",
	    "Stream",
	    "Street",
	    "Street",
	    "Streets",
	    "Summit",
	    "Summit",
	    "Terrace",
	    "Throughway",
	    "Trace",
	    "Track",
	    "Trafficway",
	    "Trail",
	    "Trail",
	    "Tunnel",
	    "Tunnel",
	    "Turnpike",
	    "Turnpike",
	    "Underpass",
	    "Union",
	    "Unions",
	    "Valley",
	    "Valleys",
	    "Via",
	    "Viaduct",
	    "View",
	    "Views",
	    "Village",
	    "Village",
	    "Villages",
	    "Ville",
	    "Vista",
	    "Vista",
	    "Walk",
	    "Walks",
	    "Wall",
	    "Way",
	    "Ways",
	    "Well",
	    "Wells"
	  ],
	  "secondary_address": [
	    "Apt. ###",
	    "Suite ###"
	  ],
	  "postcode": [
	    "#####",
	    "#####-####"
	  ],
	  "postcode_by_state": [
	    "#####",
	    "#####-####"
	  ],
	  "state": [
	    "Alabama",
	    "Alaska",
	    "Arizona",
	    "Arkansas",
	    "California",
	    "Colorado",
	    "Connecticut",
	    "Delaware",
	    "Florida",
	    "Georgia",
	    "Hawaii",
	    "Idaho",
	    "Illinois",
	    "Indiana",
	    "Iowa",
	    "Kansas",
	    "Kentucky",
	    "Louisiana",
	    "Maine",
	    "Maryland",
	    "Massachusetts",
	    "Michigan",
	    "Minnesota",
	    "Mississippi",
	    "Missouri",
	    "Montana",
	    "Nebraska",
	    "Nevada",
	    "New Hampshire",
	    "New Jersey",
	    "New Mexico",
	    "New York",
	    "North Carolina",
	    "North Dakota",
	    "Ohio",
	    "Oklahoma",
	    "Oregon",
	    "Pennsylvania",
	    "Rhode Island",
	    "South Carolina",
	    "South Dakota",
	    "Tennessee",
	    "Texas",
	    "Utah",
	    "Vermont",
	    "Virginia",
	    "Washington",
	    "West Virginia",
	    "Wisconsin",
	    "Wyoming"
	  ],
	  "state_abbr": [
	    "AL",
	    "AK",
	    "AZ",
	    "AR",
	    "CA",
	    "CO",
	    "CT",
	    "DE",
	    "FL",
	    "GA",
	    "HI",
	    "ID",
	    "IL",
	    "IN",
	    "IA",
	    "KS",
	    "KY",
	    "LA",
	    "ME",
	    "MD",
	    "MA",
	    "MI",
	    "MN",
	    "MS",
	    "MO",
	    "MT",
	    "NE",
	    "NV",
	    "NH",
	    "NJ",
	    "NM",
	    "NY",
	    "NC",
	    "ND",
	    "OH",
	    "OK",
	    "OR",
	    "PA",
	    "RI",
	    "SC",
	    "SD",
	    "TN",
	    "TX",
	    "UT",
	    "VT",
	    "VA",
	    "WA",
	    "WV",
	    "WI",
	    "WY"
	  ],
	  "time_zone": [
	    "Pacific/Midway",
	    "Pacific/Pago_Pago",
	    "Pacific/Honolulu",
	    "America/Juneau",
	    "America/Los_Angeles",
	    "America/Tijuana",
	    "America/Denver",
	    "America/Phoenix",
	    "America/Chihuahua",
	    "America/Mazatlan",
	    "America/Chicago",
	    "America/Regina",
	    "America/Mexico_City",
	    "America/Mexico_City",
	    "America/Monterrey",
	    "America/Guatemala",
	    "America/New_York",
	    "America/Indiana/Indianapolis",
	    "America/Bogota",
	    "America/Lima",
	    "America/Lima",
	    "America/Halifax",
	    "America/Caracas",
	    "America/La_Paz",
	    "America/Santiago",
	    "America/St_Johns",
	    "America/Sao_Paulo",
	    "America/Argentina/Buenos_Aires",
	    "America/Guyana",
	    "America/Godthab",
	    "Atlantic/South_Georgia",
	    "Atlantic/Azores",
	    "Atlantic/Cape_Verde",
	    "Europe/Dublin",
	    "Europe/London",
	    "Europe/Lisbon",
	    "Europe/London",
	    "Africa/Casablanca",
	    "Africa/Monrovia",
	    "Etc/UTC",
	    "Europe/Belgrade",
	    "Europe/Bratislava",
	    "Europe/Budapest",
	    "Europe/Ljubljana",
	    "Europe/Prague",
	    "Europe/Sarajevo",
	    "Europe/Skopje",
	    "Europe/Warsaw",
	    "Europe/Zagreb",
	    "Europe/Brussels",
	    "Europe/Copenhagen",
	    "Europe/Madrid",
	    "Europe/Paris",
	    "Europe/Amsterdam",
	    "Europe/Berlin",
	    "Europe/Berlin",
	    "Europe/Rome",
	    "Europe/Stockholm",
	    "Europe/Vienna",
	    "Africa/Algiers",
	    "Europe/Bucharest",
	    "Africa/Cairo",
	    "Europe/Helsinki",
	    "Europe/Kiev",
	    "Europe/Riga",
	    "Europe/Sofia",
	    "Europe/Tallinn",
	    "Europe/Vilnius",
	    "Europe/Athens",
	    "Europe/Istanbul",
	    "Europe/Minsk",
	    "Asia/Jerusalem",
	    "Africa/Harare",
	    "Africa/Johannesburg",
	    "Europe/Moscow",
	    "Europe/Moscow",
	    "Europe/Moscow",
	    "Asia/Kuwait",
	    "Asia/Riyadh",
	    "Africa/Nairobi",
	    "Asia/Baghdad",
	    "Asia/Tehran",
	    "Asia/Muscat",
	    "Asia/Muscat",
	    "Asia/Baku",
	    "Asia/Tbilisi",
	    "Asia/Yerevan",
	    "Asia/Kabul",
	    "Asia/Yekaterinburg",
	    "Asia/Karachi",
	    "Asia/Karachi",
	    "Asia/Tashkent",
	    "Asia/Kolkata",
	    "Asia/Kolkata",
	    "Asia/Kolkata",
	    "Asia/Kolkata",
	    "Asia/Kathmandu",
	    "Asia/Dhaka",
	    "Asia/Dhaka",
	    "Asia/Colombo",
	    "Asia/Almaty",
	    "Asia/Novosibirsk",
	    "Asia/Rangoon",
	    "Asia/Bangkok",
	    "Asia/Bangkok",
	    "Asia/Jakarta",
	    "Asia/Krasnoyarsk",
	    "Asia/Shanghai",
	    "Asia/Chongqing",
	    "Asia/Hong_Kong",
	    "Asia/Urumqi",
	    "Asia/Kuala_Lumpur",
	    "Asia/Singapore",
	    "Asia/Taipei",
	    "Australia/Perth",
	    "Asia/Irkutsk",
	    "Asia/Ulaanbaatar",
	    "Asia/Seoul",
	    "Asia/Tokyo",
	    "Asia/Tokyo",
	    "Asia/Tokyo",
	    "Asia/Yakutsk",
	    "Australia/Darwin",
	    "Australia/Adelaide",
	    "Australia/Melbourne",
	    "Australia/Melbourne",
	    "Australia/Sydney",
	    "Australia/Brisbane",
	    "Australia/Hobart",
	    "Asia/Vladivostok",
	    "Pacific/Guam",
	    "Pacific/Port_Moresby",
	    "Asia/Magadan",
	    "Asia/Magadan",
	    "Pacific/Noumea",
	    "Pacific/Fiji",
	    "Asia/Kamchatka",
	    "Pacific/Majuro",
	    "Pacific/Auckland",
	    "Pacific/Auckland",
	    "Pacific/Tongatapu",
	    "Pacific/Fakaofo",
	    "Pacific/Apia"
	  ],
	  "city": [
	    "#{city_prefix} #{Name.first_name}#{city_suffix}",
	    "#{city_prefix} #{Name.first_name}",
	    "#{Name.first_name}#{city_suffix}",
	    "#{Name.last_name}#{city_suffix}"
	  ],
	  "street_name": [
	    "#{Name.first_name} #{street_suffix}",
	    "#{Name.last_name} #{street_suffix}"
	  ],
	  "street_address": [
	    "#{building_number} #{street_name}"
	  ],
	  "default_country": [
	    "United States of America"
	  ]
	};
	en.credit_card = {
	  "visa": [
	    "/4###########L/",
	    "/4###-####-####-###L/"
	  ],
	  "mastercard": [
	    "/5[1-5]##-####-####-###L/",
	    "/6771-89##-####-###L/"
	  ],
	  "discover": [
	    "/6011-####-####-###L/",
	    "/65##-####-####-###L/",
	    "/64[4-9]#-####-####-###L/",
	    "/6011-62##-####-####-###L/",
	    "/65##-62##-####-####-###L/",
	    "/64[4-9]#-62##-####-####-###L/"
	  ],
	  "american_express": [
	    "/34##-######-####L/",
	    "/37##-######-####L/"
	  ],
	  "diners_club": [
	    "/30[0-5]#-######-###L/",
	    "/368#-######-###L/"
	  ],
	  "jcb": [
	    "/3528-####-####-###L/",
	    "/3529-####-####-###L/",
	    "/35[3-8]#-####-####-###L/"
	  ],
	  "switch": [
	    "/6759-####-####-###L/",
	    "/6759-####-####-####-#L/",
	    "/6759-####-####-####-##L/"
	  ],
	  "solo": [
	    "/6767-####-####-###L/",
	    "/6767-####-####-####-#L/",
	    "/6767-####-####-####-##L/"
	  ],
	  "dankort": "/5019-####-####-###L/",
	  "maestro": [
	    "/50#{9,16}L/",
	    "/5[6-8]#{9,16}L/",
	    "/56##{9,16}L/"
	  ],
	  "forbrugsforeningen": "/6007-22##-####-###L/",
	  "laser": [
	    "/6304###########L/",
	    "/6706###########L/",
	    "/6771###########L/",
	    "/6709###########L/",
	    "/6304#########{5,6}L/",
	    "/6706#########{5,6}L/",
	    "/6771#########{5,6}L/",
	    "/6709#########{5,6}L/"
	  ]
	};
	en.company = {
	  "suffix": [
	    "Inc",
	    "and Sons",
	    "LLC",
	    "Group"
	  ],
	  "adjective": [
	      "Adaptive",
	      "Advanced",
	      "Ameliorated",
	      "Assimilated",
	      "Automated",
	      "Balanced",
	      "Business-focused",
	      "Centralized",
	      "Cloned",
	      "Compatible",
	      "Configurable",
	      "Cross-group",
	      "Cross-platform",
	      "Customer-focused",
	      "Customizable",
	      "Decentralized",
	      "De-engineered",
	      "Devolved",
	      "Digitized",
	      "Distributed",
	      "Diverse",
	      "Down-sized",
	      "Enhanced",
	      "Enterprise-wide",
	      "Ergonomic",
	      "Exclusive",
	      "Expanded",
	      "Extended",
	      "Face to face",
	      "Focused",
	      "Front-line",
	      "Fully-configurable",
	      "Function-based",
	      "Fundamental",
	      "Future-proofed",
	      "Grass-roots",
	      "Horizontal",
	      "Implemented",
	      "Innovative",
	      "Integrated",
	      "Intuitive",
	      "Inverse",
	      "Managed",
	      "Mandatory",
	      "Monitored",
	      "Multi-channelled",
	      "Multi-lateral",
	      "Multi-layered",
	      "Multi-tiered",
	      "Networked",
	      "Object-based",
	      "Open-architected",
	      "Open-source",
	      "Operative",
	      "Optimized",
	      "Optional",
	      "Organic",
	      "Organized",
	      "Persevering",
	      "Persistent",
	      "Phased",
	      "Polarised",
	      "Pre-emptive",
	      "Proactive",
	      "Profit-focused",
	      "Profound",
	      "Programmable",
	      "Progressive",
	      "Public-key",
	      "Quality-focused",
	      "Reactive",
	      "Realigned",
	      "Re-contextualized",
	      "Re-engineered",
	      "Reduced",
	      "Reverse-engineered",
	      "Right-sized",
	      "Robust",
	      "Seamless",
	      "Secured",
	      "Self-enabling",
	      "Sharable",
	      "Stand-alone",
	      "Streamlined",
	      "Switchable",
	      "Synchronised",
	      "Synergistic",
	      "Synergized",
	      "Team-oriented",
	      "Total",
	      "Triple-buffered",
	      "Universal",
	      "Up-sized",
	      "Upgradable",
	      "User-centric",
	      "User-friendly",
	      "Versatile",
	      "Virtual",
	      "Visionary",
	      "Vision-oriented"
	  ],
	  "descriptor": [
	      "24 hour",
	      "24/7",
	      "3rd generation",
	      "4th generation",
	      "5th generation",
	      "6th generation",
	      "actuating",
	      "analyzing",
	      "asymmetric",
	      "asynchronous",
	      "attitude-oriented",
	      "background",
	      "bandwidth-monitored",
	      "bi-directional",
	      "bifurcated",
	      "bottom-line",
	      "clear-thinking",
	      "client-driven",
	      "client-server",
	      "coherent",
	      "cohesive",
	      "composite",
	      "context-sensitive",
	      "contextually-based",
	      "content-based",
	      "dedicated",
	      "demand-driven",
	      "didactic",
	      "directional",
	      "discrete",
	      "disintermediate",
	      "dynamic",
	      "eco-centric",
	      "empowering",
	      "encompassing",
	      "even-keeled",
	      "executive",
	      "explicit",
	      "exuding",
	      "fault-tolerant",
	      "foreground",
	      "fresh-thinking",
	      "full-range",
	      "global",
	      "grid-enabled",
	      "heuristic",
	      "high-level",
	      "holistic",
	      "homogeneous",
	      "human-resource",
	      "hybrid",
	      "impactful",
	      "incremental",
	      "intangible",
	      "interactive",
	      "intermediate",
	      "leading edge",
	      "local",
	      "logistical",
	      "maximized",
	      "methodical",
	      "mission-critical",
	      "mobile",
	      "modular",
	      "motivating",
	      "multimedia",
	      "multi-state",
	      "multi-tasking",
	      "national",
	      "needs-based",
	      "neutral",
	      "next generation",
	      "non-volatile",
	      "object-oriented",
	      "optimal",
	      "optimizing",
	      "radical",
	      "real-time",
	      "reciprocal",
	      "regional",
	      "responsive",
	      "scalable",
	      "secondary",
	      "solution-oriented",
	      "stable",
	      "static",
	      "systematic",
	      "systemic",
	      "system-worthy",
	      "tangible",
	      "tertiary",
	      "transitional",
	      "uniform",
	      "upward-trending",
	      "user-facing",
	      "value-added",
	      "web-enabled",
	      "well-modulated",
	      "zero administration",
	      "zero defect",
	      "zero tolerance"
	    ],
	    "noun": [
	      "ability",
	      "access",
	      "adapter",
	      "algorithm",
	      "alliance",
	      "analyzer",
	      "application",
	      "approach",
	      "architecture",
	      "archive",
	      "artificial intelligence",
	      "array",
	      "attitude",
	      "benchmark",
	      "budgetary management",
	      "capability",
	      "capacity",
	      "challenge",
	      "circuit",
	      "collaboration",
	      "complexity",
	      "concept",
	      "conglomeration",
	      "contingency",
	      "core",
	      "customer loyalty",
	      "database",
	      "data-warehouse",
	      "definition",
	      "emulation",
	      "encoding",
	      "encryption",
	      "extranet",
	      "firmware",
	      "flexibility",
	      "focus group",
	      "forecast",
	      "frame",
	      "framework",
	      "function",
	      "functionalities",
	      "Graphic Interface",
	      "groupware",
	      "Graphical User Interface",
	      "hardware",
	      "help-desk",
	      "hierarchy",
	      "hub",
	      "implementation",
	      "info-mediaries",
	      "infrastructure",
	      "initiative",
	      "installation",
	      "instruction set",
	      "interface",
	      "internet solution",
	      "intranet",
	      "knowledge user",
	      "knowledge base",
	      "local area network",
	      "leverage",
	      "matrices",
	      "matrix",
	      "methodology",
	      "middleware",
	      "migration",
	      "model",
	      "moderator",
	      "monitoring",
	      "moratorium",
	      "neural-net",
	      "open architecture",
	      "open system",
	      "orchestration",
	      "paradigm",
	      "parallelism",
	      "policy",
	      "portal",
	      "pricing structure",
	      "process improvement",
	      "product",
	      "productivity",
	      "project",
	      "projection",
	      "protocol",
	      "secured line",
	      "service-desk",
	      "software",
	      "solution",
	      "standardization",
	      "strategy",
	      "structure",
	      "success",
	      "superstructure",
	      "support",
	      "synergy",
	      "system engine",
	      "task-force",
	      "throughput",
	      "time-frame",
	      "toolset",
	      "utilisation",
	      "website",
	      "workforce"
	   ],
	  "bs_verb": [
	      "implement",
	      "utilize",
	      "integrate",
	      "streamline",
	      "optimize",
	      "evolve",
	      "transform",
	      "embrace",
	      "enable",
	      "orchestrate",
	      "leverage",
	      "reinvent",
	      "aggregate",
	      "architect",
	      "enhance",
	      "incentivize",
	      "morph",
	      "empower",
	      "envisioneer",
	      "monetize",
	      "harness",
	      "facilitate",
	      "seize",
	      "disintermediate",
	      "synergize",
	      "strategize",
	      "deploy",
	      "brand",
	      "grow",
	      "target",
	      "syndicate",
	      "synthesize",
	      "deliver",
	      "mesh",
	      "incubate",
	      "engage",
	      "maximize",
	      "benchmark",
	      "expedite",
	      "reintermediate",
	      "whiteboard",
	      "visualize",
	      "repurpose",
	      "innovate",
	      "scale",
	      "unleash",
	      "drive",
	      "extend",
	      "engineer",
	      "revolutionize",
	      "generate",
	      "exploit",
	      "transition",
	      "e-enable",
	      "iterate",
	      "cultivate",
	      "matrix",
	      "productize",
	      "redefine",
	      "recontextualize"
	    ],
	    "bs_adjective": [
	      "clicks-and-mortar",
	      "value-added",
	      "vertical",
	      "proactive",
	      "robust",
	      "revolutionary",
	      "scalable",
	      "leading-edge",
	      "innovative",
	      "intuitive",
	      "strategic",
	      "e-business",
	      "mission-critical",
	      "sticky",
	      "one-to-one",
	      "24/7",
	      "end-to-end",
	      "global",
	      "B2B",
	      "B2C",
	      "granular",
	      "frictionless",
	      "virtual",
	      "viral",
	      "dynamic",
	      "24/365",
	      "best-of-breed",
	      "killer",
	      "magnetic",
	      "bleeding-edge",
	      "web-enabled",
	      "interactive",
	      "dot-com",
	      "sexy",
	      "back-end",
	      "real-time",
	      "efficient",
	      "front-end",
	      "distributed",
	      "seamless",
	      "extensible",
	      "turn-key",
	      "world-class",
	      "open-source",
	      "cross-platform",
	      "cross-media",
	      "synergistic",
	      "bricks-and-clicks",
	      "out-of-the-box",
	      "enterprise",
	      "integrated",
	      "impactful",
	      "wireless",
	      "transparent",
	      "next-generation",
	      "cutting-edge",
	      "user-centric",
	      "visionary",
	      "customized",
	      "ubiquitous",
	      "plug-and-play",
	      "collaborative",
	      "compelling",
	      "holistic",
	      "rich"
	    ],
	    "bs_noun": [
	      "synergies",
	      "web-readiness",
	      "paradigms",
	      "markets",
	      "partnerships",
	      "infrastructures",
	      "platforms",
	      "initiatives",
	      "channels",
	      "eyeballs",
	      "communities",
	      "ROI",
	      "solutions",
	      "e-tailers",
	      "e-services",
	      "action-items",
	      "portals",
	      "niches",
	      "technologies",
	      "content",
	      "vortals",
	      "supply-chains",
	      "convergence",
	      "relationships",
	      "architectures",
	      "interfaces",
	      "e-markets",
	      "e-commerce",
	      "systems",
	      "bandwidth",
	      "infomediaries",
	      "models",
	      "mindshare",
	      "deliverables",
	      "users",
	      "schemas",
	      "networks",
	      "applications",
	      "metrics",
	      "e-business",
	      "functionalities",
	      "experiences",
	      "web services",
	      "methodologies"
	  ],
	  "name": [
	    "#{Name.last_name} #{suffix}",
	    "#{Name.last_name}-#{Name.last_name}",
	    "#{Name.last_name}, #{Name.last_name} and #{Name.last_name}"
	  ]
	};
	en.internet = {
	  "free_email": [
	    "gmail.com",
	    "yahoo.com",
	    "hotmail.com"
	  ],
	  "domain_suffix": [
	    "com",
	    "biz",
	    "info",
	    "name",
	    "net",
	    "org"
	  ]
	};
	
	//All this avatar have been authorized by its awesome users to be use on live websites (not just mockups)
	//For more information, please visit: http://uifaces.com/authorized
	var avatarUri = ["jarjan/128.jpg",
	    "mahdif/128.jpg",
	    "sprayaga/128.jpg",
	    "ruzinav/128.jpg",
	    "Skyhartman/128.jpg",
	    "moscoz/128.jpg",
	    "kurafire/128.jpg",
	    "91bilal/128.jpg",
	    "igorgarybaldi/128.jpg",
	    "calebogden/128.jpg",
	    "malykhinv/128.jpg",
	    "joelhelin/128.jpg",
	    "kushsolitary/128.jpg",
	    "coreyweb/128.jpg",
	    "snowshade/128.jpg",
	    "areus/128.jpg",
	    "holdenweb/128.jpg",
	    "heyimjuani/128.jpg",
	    "envex/128.jpg",
	    "unterdreht/128.jpg",
	    "collegeman/128.jpg",
	    "peejfancher/128.jpg",
	    "andyisonline/128.jpg",
	    "ultragex/128.jpg",
	    "fuck_you_two/128.jpg",
	    "adellecharles/128.jpg",
	    "ateneupopular/128.jpg",
	    "ahmetalpbalkan/128.jpg",
	    "Stievius/128.jpg",
	    "kerem/128.jpg",
	    "osvaldas/128.jpg",
	    "angelceballos/128.jpg",
	    "thierrykoblentz/128.jpg",
	    "peterlandt/128.jpg",
	    "catarino/128.jpg",
	    "wr/128.jpg",
	    "weglov/128.jpg",
	    "brandclay/128.jpg",
	    "flame_kaizar/128.jpg",
	    "ahmetsulek/128.jpg",
	    "nicolasfolliot/128.jpg",
	    "jayrobinson/128.jpg",
	    "victorerixon/128.jpg",
	    "kolage/128.jpg",
	    "michzen/128.jpg",
	    "markjenkins/128.jpg",
	    "nicolai_larsen/128.jpg",
	    "gt/128.jpg",
	    "noxdzine/128.jpg",
	    "alagoon/128.jpg",
	    "idiot/128.jpg",
	    "mizko/128.jpg",
	    "chadengle/128.jpg",
	    "mutlu82/128.jpg",
	    "simobenso/128.jpg",
	    "vocino/128.jpg",
	    "guiiipontes/128.jpg",
	    "soyjavi/128.jpg",
	    "joshaustin/128.jpg",
	    "tomaslau/128.jpg",
	    "VinThomas/128.jpg",
	    "ManikRathee/128.jpg",
	    "langate/128.jpg",
	    "cemshid/128.jpg",
	    "leemunroe/128.jpg",
	    "_shahedk/128.jpg",
	    "enda/128.jpg",
	    "BillSKenney/128.jpg",
	    "divya/128.jpg",
	    "joshhemsley/128.jpg",
	    "sindresorhus/128.jpg",
	    "soffes/128.jpg",
	    "9lessons/128.jpg",
	    "linux29/128.jpg",
	    "Chakintosh/128.jpg",
	    "anaami/128.jpg",
	    "joreira/128.jpg",
	    "shadeed9/128.jpg",
	    "scottkclark/128.jpg",
	    "jedbridges/128.jpg",
	    "salleedesign/128.jpg",
	    "marakasina/128.jpg",
	    "ariil/128.jpg",
	    "BrianPurkiss/128.jpg",
	    "michaelmartinho/128.jpg",
	    "bublienko/128.jpg",
	    "devankoshal/128.jpg",
	    "ZacharyZorbas/128.jpg",
	    "timmillwood/128.jpg",
	    "joshuasortino/128.jpg",
	    "damenleeturks/128.jpg",
	    "tomas_janousek/128.jpg",
	    "herrhaase/128.jpg",
	    "RussellBishop/128.jpg",
	    "brajeshwar/128.jpg",
	    "nachtmeister/128.jpg",
	    "cbracco/128.jpg",
	    "bermonpainter/128.jpg",
	    "abdullindenis/128.jpg",
	    "isacosta/128.jpg",
	    "suprb/128.jpg",
	    "yalozhkin/128.jpg",
	    "chandlervdw/128.jpg",
	    "iamgarth/128.jpg",
	    "_victa/128.jpg",
	    "commadelimited/128.jpg",
	    "roybarberuk/128.jpg",
	    "axel/128.jpg",
	    "vladarbatov/128.jpg",
	    "ffbel/128.jpg",
	    "syropian/128.jpg",
	    "ankitind/128.jpg",
	    "traneblow/128.jpg",
	    "flashmurphy/128.jpg",
	    "ChrisFarina78/128.jpg",
	    "baliomega/128.jpg",
	    "saschamt/128.jpg",
	    "jm_denis/128.jpg",
	    "anoff/128.jpg",
	    "kennyadr/128.jpg",
	    "chatyrko/128.jpg",
	    "dingyi/128.jpg",
	    "mds/128.jpg",
	    "terryxlife/128.jpg",
	    "aaroni/128.jpg",
	    "kinday/128.jpg",
	    "prrstn/128.jpg",
	    "eduardostuart/128.jpg",
	    "dhilipsiva/128.jpg",
	    "GavicoInd/128.jpg",
	    "baires/128.jpg",
	    "rohixx/128.jpg",
	    "bigmancho/128.jpg",
	    "blakesimkins/128.jpg",
	    "leeiio/128.jpg",
	    "tjrus/128.jpg",
	    "uberschizo/128.jpg",
	    "kylefoundry/128.jpg",
	    "claudioguglieri/128.jpg",
	    "ripplemdk/128.jpg",
	    "exentrich/128.jpg",
	    "jakemoore/128.jpg",
	    "joaoedumedeiros/128.jpg",
	    "poormini/128.jpg",
	    "tereshenkov/128.jpg",
	    "keryilmaz/128.jpg",
	    "haydn_woods/128.jpg",
	    "rude/128.jpg",
	    "llun/128.jpg",
	    "sgaurav_baghel/128.jpg",
	    "jamiebrittain/128.jpg",
	    "badlittleduck/128.jpg",
	    "pifagor/128.jpg",
	    "agromov/128.jpg",
	    "benefritz/128.jpg",
	    "erwanhesry/128.jpg",
	    "diesellaws/128.jpg",
	    "jeremiaha/128.jpg",
	    "koridhandy/128.jpg",
	    "chaensel/128.jpg",
	    "andrewcohen/128.jpg",
	    "smaczny/128.jpg",
	    "gonzalorobaina/128.jpg",
	    "nandini_m/128.jpg",
	    "sydlawrence/128.jpg",
	    "cdharrison/128.jpg",
	    "tgerken/128.jpg",
	    "lewisainslie/128.jpg",
	    "charliecwaite/128.jpg",
	    "robbschiller/128.jpg",
	    "flexrs/128.jpg",
	    "mattdetails/128.jpg",
	    "raquelwilson/128.jpg",
	    "karsh/128.jpg",
	    "mrmartineau/128.jpg",
	    "opnsrce/128.jpg",
	    "hgharrygo/128.jpg",
	    "maximseshuk/128.jpg",
	    "uxalex/128.jpg",
	    "samihah/128.jpg",
	    "chanpory/128.jpg",
	    "sharvin/128.jpg",
	    "josemarques/128.jpg",
	    "jefffis/128.jpg",
	    "krystalfister/128.jpg",
	    "lokesh_coder/128.jpg",
	    "thedamianhdez/128.jpg",
	    "dpmachado/128.jpg",
	    "funwatercat/128.jpg",
	    "timothycd/128.jpg",
	    "ivanfilipovbg/128.jpg",
	    "picard102/128.jpg",
	    "marcobarbosa/128.jpg",
	    "krasnoukhov/128.jpg",
	    "g3d/128.jpg",
	    "ademilter/128.jpg",
	    "rickdt/128.jpg",
	    "operatino/128.jpg",
	    "bungiwan/128.jpg",
	    "hugomano/128.jpg",
	    "logorado/128.jpg",
	    "dc_user/128.jpg",
	    "horaciobella/128.jpg",
	    "SlaapMe/128.jpg",
	    "teeragit/128.jpg",
	    "iqonicd/128.jpg",
	    "ilya_pestov/128.jpg",
	    "andrewarrow/128.jpg",
	    "ssiskind/128.jpg",
	    "stan/128.jpg",
	    "HenryHoffman/128.jpg",
	    "rdsaunders/128.jpg",
	    "adamsxu/128.jpg",
	    "curiousoffice/128.jpg",
	    "themadray/128.jpg",
	    "michigangraham/128.jpg",
	    "kohette/128.jpg",
	    "nickfratter/128.jpg",
	    "runningskull/128.jpg",
	    "madysondesigns/128.jpg",
	    "brenton_clarke/128.jpg",
	    "jennyshen/128.jpg",
	    "bradenhamm/128.jpg",
	    "kurtinc/128.jpg",
	    "amanruzaini/128.jpg",
	    "coreyhaggard/128.jpg",
	    "Karimmove/128.jpg",
	    "aaronalfred/128.jpg",
	    "wtrsld/128.jpg",
	    "jitachi/128.jpg",
	    "therealmarvin/128.jpg",
	    "pmeissner/128.jpg",
	    "ooomz/128.jpg",
	    "chacky14/128.jpg",
	    "jesseddy/128.jpg",
	    "thinmatt/128.jpg",
	    "shanehudson/128.jpg",
	    "akmur/128.jpg",
	    "IsaryAmairani/128.jpg",
	    "arthurholcombe1/128.jpg",
	    "andychipster/128.jpg",
	    "boxmodel/128.jpg",
	    "ehsandiary/128.jpg",
	    "LucasPerdidao/128.jpg",
	    "shalt0ni/128.jpg",
	    "swaplord/128.jpg",
	    "kaelifa/128.jpg",
	    "plbabin/128.jpg",
	    "guillemboti/128.jpg",
	    "arindam_/128.jpg",
	    "renbyrd/128.jpg",
	    "thiagovernetti/128.jpg",
	    "jmillspaysbills/128.jpg",
	    "mikemai2awesome/128.jpg",
	    "jervo/128.jpg",
	    "mekal/128.jpg",
	    "sta1ex/128.jpg",
	    "robergd/128.jpg",
	    "felipecsl/128.jpg",
	    "andrea211087/128.jpg",
	    "garand/128.jpg",
	    "dhooyenga/128.jpg",
	    "abovefunction/128.jpg",
	    "pcridesagain/128.jpg",
	    "randomlies/128.jpg",
	    "BryanHorsey/128.jpg",
	    "heykenneth/128.jpg",
	    "dahparra/128.jpg",
	    "allthingssmitty/128.jpg",
	    "danvernon/128.jpg",
	    "beweinreich/128.jpg",
	    "increase/128.jpg",
	    "falvarad/128.jpg",
	    "alxndrustinov/128.jpg",
	    "souuf/128.jpg",
	    "orkuncaylar/128.jpg",
	    "AM_Kn2/128.jpg",
	    "gearpixels/128.jpg",
	    "bassamology/128.jpg",
	    "vimarethomas/128.jpg",
	    "kosmar/128.jpg",
	    "SULiik/128.jpg",
	    "mrjamesnoble/128.jpg",
	    "silvanmuhlemann/128.jpg",
	    "shaneIxD/128.jpg",
	    "nacho/128.jpg",
	    "yigitpinarbasi/128.jpg",
	    "buzzusborne/128.jpg",
	    "aaronkwhite/128.jpg",
	    "rmlewisuk/128.jpg",
	    "giancarlon/128.jpg",
	    "nbirckel/128.jpg",
	    "d_nny_m_cher/128.jpg",
	    "sdidonato/128.jpg",
	    "atariboy/128.jpg",
	    "abotap/128.jpg",
	    "karalek/128.jpg",
	    "psdesignuk/128.jpg",
	    "ludwiczakpawel/128.jpg",
	    "nemanjaivanovic/128.jpg",
	    "baluli/128.jpg",
	    "ahmadajmi/128.jpg",
	    "vovkasolovev/128.jpg",
	    "samgrover/128.jpg",
	    "derienzo777/128.jpg",
	    "jonathansimmons/128.jpg",
	    "nelsonjoyce/128.jpg",
	    "S0ufi4n3/128.jpg",
	    "xtopherpaul/128.jpg",
	    "oaktreemedia/128.jpg",
	    "nateschulte/128.jpg",
	    "findingjenny/128.jpg",
	    "namankreative/128.jpg",
	    "antonyzotov/128.jpg",
	    "we_social/128.jpg",
	    "leehambley/128.jpg",
	    "solid_color/128.jpg",
	    "abelcabans/128.jpg",
	    "mbilderbach/128.jpg",
	    "kkusaa/128.jpg",
	    "jordyvdboom/128.jpg",
	    "carlosgavina/128.jpg",
	    "pechkinator/128.jpg",
	    "vc27/128.jpg",
	    "rdbannon/128.jpg",
	    "croakx/128.jpg",
	    "suribbles/128.jpg",
	    "kerihenare/128.jpg",
	    "catadeleon/128.jpg",
	    "gcmorley/128.jpg",
	    "duivvv/128.jpg",
	    "saschadroste/128.jpg",
	    "victorDubugras/128.jpg",
	    "wintopia/128.jpg",
	    "mattbilotti/128.jpg",
	    "taylorling/128.jpg",
	    "megdraws/128.jpg",
	    "meln1ks/128.jpg",
	    "mahmoudmetwally/128.jpg",
	    "Silveredge9/128.jpg",
	    "derekebradley/128.jpg",
	    "happypeter1983/128.jpg",
	    "travis_arnold/128.jpg",
	    "artem_kostenko/128.jpg",
	    "adobi/128.jpg",
	    "daykiine/128.jpg",
	    "alek_djuric/128.jpg",
	    "scips/128.jpg",
	    "miguelmendes/128.jpg",
	    "justinrhee/128.jpg",
	    "alsobrooks/128.jpg",
	    "fronx/128.jpg",
	    "mcflydesign/128.jpg",
	    "santi_urso/128.jpg",
	    "allfordesign/128.jpg",
	    "stayuber/128.jpg",
	    "bertboerland/128.jpg",
	    "marosholly/128.jpg",
	    "adamnac/128.jpg",
	    "cynthiasavard/128.jpg",
	    "muringa/128.jpg",
	    "danro/128.jpg",
	    "hiemil/128.jpg",
	    "jackiesaik/128.jpg",
	    "zacsnider/128.jpg",
	    "iduuck/128.jpg",
	    "antjanus/128.jpg",
	    "aroon_sharma/128.jpg",
	    "dshster/128.jpg",
	    "thehacker/128.jpg",
	    "michaelbrooksjr/128.jpg",
	    "ryanmclaughlin/128.jpg",
	    "clubb3rry/128.jpg",
	    "taybenlor/128.jpg",
	    "xripunov/128.jpg",
	    "myastro/128.jpg",
	    "adityasutomo/128.jpg",
	    "digitalmaverick/128.jpg",
	    "hjartstrorn/128.jpg",
	    "itolmach/128.jpg",
	    "vaughanmoffitt/128.jpg",
	    "abdots/128.jpg",
	    "isnifer/128.jpg",
	    "sergeysafonov/128.jpg",
	    "maz/128.jpg",
	    "scrapdnb/128.jpg",
	    "chrismj83/128.jpg",
	    "vitorleal/128.jpg",
	    "sokaniwaal/128.jpg",
	    "zaki3d/128.jpg",
	    "illyzoren/128.jpg",
	    "mocabyte/128.jpg",
	    "osmanince/128.jpg",
	    "djsherman/128.jpg",
	    "davidhemphill/128.jpg",
	    "waghner/128.jpg",
	    "necodymiconer/128.jpg",
	    "praveen_vijaya/128.jpg",
	    "fabbrucci/128.jpg",
	    "cliffseal/128.jpg",
	    "travishines/128.jpg",
	    "kuldarkalvik/128.jpg",
	    "Elt_n/128.jpg",
	    "phillapier/128.jpg",
	    "okseanjay/128.jpg",
	    "id835559/128.jpg",
	    "kudretkeskin/128.jpg",
	    "anjhero/128.jpg",
	    "duck4fuck/128.jpg",
	    "scott_riley/128.jpg",
	    "noufalibrahim/128.jpg",
	    "h1brd/128.jpg",
	    "borges_marcos/128.jpg",
	    "devinhalladay/128.jpg",
	    "ciaranr/128.jpg",
	    "stefooo/128.jpg",
	    "mikebeecham/128.jpg",
	    "tonymillion/128.jpg",
	    "joshuaraichur/128.jpg",
	    "irae/128.jpg",
	    "petrangr/128.jpg",
	    "dmitriychuta/128.jpg",
	    "charliegann/128.jpg",
	    "arashmanteghi/128.jpg",
	    "adhamdannaway/128.jpg",
	    "ainsleywagon/128.jpg",
	    "svenlen/128.jpg",
	    "faisalabid/128.jpg",
	    "beshur/128.jpg",
	    "carlyson/128.jpg",
	    "dutchnadia/128.jpg",
	    "teddyzetterlund/128.jpg",
	    "samuelkraft/128.jpg",
	    "aoimedia/128.jpg",
	    "toddrew/128.jpg",
	    "codepoet_ru/128.jpg",
	    "artvavs/128.jpg",
	    "benoitboucart/128.jpg",
	    "jomarmen/128.jpg",
	    "kolmarlopez/128.jpg",
	    "creartinc/128.jpg",
	    "homka/128.jpg",
	    "gaborenton/128.jpg",
	    "robinclediere/128.jpg",
	    "maximsorokin/128.jpg",
	    "plasticine/128.jpg",
	    "j2deme/128.jpg",
	    "peachananr/128.jpg",
	    "kapaluccio/128.jpg",
	    "de_ascanio/128.jpg",
	    "rikas/128.jpg",
	    "dawidwu/128.jpg",
	    "marcoramires/128.jpg",
	    "angelcreative/128.jpg",
	    "rpatey/128.jpg",
	    "popey/128.jpg",
	    "rehatkathuria/128.jpg",
	    "the_purplebunny/128.jpg",
	    "1markiz/128.jpg",
	    "ajaxy_ru/128.jpg",
	    "brenmurrell/128.jpg",
	    "dudestein/128.jpg",
	    "oskarlevinson/128.jpg",
	    "victorstuber/128.jpg",
	    "nehfy/128.jpg",
	    "vicivadeline/128.jpg",
	    "leandrovaranda/128.jpg",
	    "scottgallant/128.jpg",
	    "victor_haydin/128.jpg",
	    "sawrb/128.jpg",
	    "ryhanhassan/128.jpg",
	    "amayvs/128.jpg",
	    "a_brixen/128.jpg",
	    "karolkrakowiak_/128.jpg",
	    "herkulano/128.jpg",
	    "geran7/128.jpg",
	    "cggaurav/128.jpg",
	    "chris_witko/128.jpg",
	    "lososina/128.jpg",
	    "polarity/128.jpg",
	    "mattlat/128.jpg",
	    "brandonburke/128.jpg",
	    "constantx/128.jpg",
	    "teylorfeliz/128.jpg",
	    "craigelimeliah/128.jpg",
	    "rachelreveley/128.jpg",
	    "reabo101/128.jpg",
	    "rahmeen/128.jpg",
	    "ky/128.jpg",
	    "rickyyean/128.jpg",
	    "j04ntoh/128.jpg",
	    "spbroma/128.jpg",
	    "sebashton/128.jpg",
	    "jpenico/128.jpg",
	    "francis_vega/128.jpg",
	    "oktayelipek/128.jpg",
	    "kikillo/128.jpg",
	    "fabbianz/128.jpg",
	    "larrygerard/128.jpg",
	    "BroumiYoussef/128.jpg",
	    "0therplanet/128.jpg",
	    "mbilalsiddique1/128.jpg",
	    "ionuss/128.jpg",
	    "grrr_nl/128.jpg",
	    "liminha/128.jpg",
	    "rawdiggie/128.jpg",
	    "ryandownie/128.jpg",
	    "sethlouey/128.jpg",
	    "pixage/128.jpg",
	    "arpitnj/128.jpg",
	    "switmer777/128.jpg",
	    "josevnclch/128.jpg",
	    "kanickairaj/128.jpg",
	    "puzik/128.jpg",
	    "tbakdesigns/128.jpg",
	    "besbujupi/128.jpg",
	    "supjoey/128.jpg",
	    "lowie/128.jpg",
	    "linkibol/128.jpg",
	    "balintorosz/128.jpg",
	    "imcoding/128.jpg",
	    "agustincruiz/128.jpg",
	    "gusoto/128.jpg",
	    "thomasschrijer/128.jpg",
	    "superoutman/128.jpg",
	    "kalmerrautam/128.jpg",
	    "gabrielizalo/128.jpg",
	    "gojeanyn/128.jpg",
	    "davidbaldie/128.jpg",
	    "_vojto/128.jpg",
	    "laurengray/128.jpg",
	    "jydesign/128.jpg",
	    "mymyboy/128.jpg",
	    "nellleo/128.jpg",
	    "marciotoledo/128.jpg",
	    "ninjad3m0/128.jpg",
	    "to_soham/128.jpg",
	    "hasslunsford/128.jpg",
	    "muridrahhal/128.jpg",
	    "levisan/128.jpg",
	    "grahamkennery/128.jpg",
	    "lepetitogre/128.jpg",
	    "antongenkin/128.jpg",
	    "nessoila/128.jpg",
	    "amandabuzard/128.jpg",
	    "safrankov/128.jpg",
	    "cocolero/128.jpg",
	    "dss49/128.jpg",
	    "matt3224/128.jpg",
	    "bluesix/128.jpg",
	    "quailandquasar/128.jpg",
	    "AlbertoCococi/128.jpg",
	    "lepinski/128.jpg",
	    "sementiy/128.jpg",
	    "mhudobivnik/128.jpg",
	    "thibaut_re/128.jpg",
	    "olgary/128.jpg",
	    "shojberg/128.jpg",
	    "mtolokonnikov/128.jpg",
	    "bereto/128.jpg",
	    "naupintos/128.jpg",
	    "wegotvices/128.jpg",
	    "xadhix/128.jpg",
	    "macxim/128.jpg",
	    "rodnylobos/128.jpg",
	    "madcampos/128.jpg",
	    "madebyvadim/128.jpg",
	    "bartoszdawydzik/128.jpg",
	    "supervova/128.jpg",
	    "markretzloff/128.jpg",
	    "vonachoo/128.jpg",
	    "darylws/128.jpg",
	    "stevedesigner/128.jpg",
	    "mylesb/128.jpg",
	    "herbigt/128.jpg",
	    "depaulawagner/128.jpg",
	    "geshan/128.jpg",
	    "gizmeedevil1991/128.jpg",
	    "_scottburgess/128.jpg",
	    "lisovsky/128.jpg",
	    "davidsasda/128.jpg",
	    "artd_sign/128.jpg",
	    "YoungCutlass/128.jpg",
	    "mgonto/128.jpg",
	    "itstotallyamy/128.jpg",
	    "victorquinn/128.jpg",
	    "osmond/128.jpg",
	    "oksanafrewer/128.jpg",
	    "zauerkraut/128.jpg",
	    "iamkeithmason/128.jpg",
	    "nitinhayaran/128.jpg",
	    "lmjabreu/128.jpg",
	    "mandalareopens/128.jpg",
	    "thinkleft/128.jpg",
	    "ponchomendivil/128.jpg",
	    "juamperro/128.jpg",
	    "brunodesign1206/128.jpg",
	    "caseycavanagh/128.jpg",
	    "luxe/128.jpg",
	    "dotgridline/128.jpg",
	    "spedwig/128.jpg",
	    "madewulf/128.jpg",
	    "mattsapii/128.jpg",
	    "helderleal/128.jpg",
	    "chrisstumph/128.jpg",
	    "jayphen/128.jpg",
	    "nsamoylov/128.jpg",
	    "chrisvanderkooi/128.jpg",
	    "justme_timothyg/128.jpg",
	    "otozk/128.jpg",
	    "prinzadi/128.jpg",
	    "gu5taf/128.jpg",
	    "cyril_gaillard/128.jpg",
	    "d_kobelyatsky/128.jpg",
	    "daniloc/128.jpg",
	    "nwdsha/128.jpg",
	    "romanbulah/128.jpg",
	    "skkirilov/128.jpg",
	    "dvdwinden/128.jpg",
	    "dannol/128.jpg",
	    "thekevinjones/128.jpg",
	    "jwalter14/128.jpg",
	    "timgthomas/128.jpg",
	    "buddhasource/128.jpg",
	    "uxpiper/128.jpg",
	    "thatonetommy/128.jpg",
	    "diansigitp/128.jpg",
	    "adrienths/128.jpg",
	    "klimmka/128.jpg",
	    "gkaam/128.jpg",
	    "derekcramer/128.jpg",
	    "jennyyo/128.jpg",
	    "nerrsoft/128.jpg",
	    "xalionmalik/128.jpg",
	    "edhenderson/128.jpg",
	    "keyuri85/128.jpg",
	    "roxanejammet/128.jpg",
	    "kimcool/128.jpg",
	    "edkf/128.jpg",
	    "matkins/128.jpg",
	    "alessandroribe/128.jpg",
	    "jacksonlatka/128.jpg",
	    "lebronjennan/128.jpg",
	    "kostaspt/128.jpg",
	    "karlkanall/128.jpg",
	    "moynihan/128.jpg",
	    "danpliego/128.jpg",
	    "saulihirvi/128.jpg",
	    "wesleytrankin/128.jpg",
	    "fjaguero/128.jpg",
	    "bowbrick/128.jpg",
	    "mashaaaaal/128.jpg",
	    "yassiryahya/128.jpg",
	    "dparrelli/128.jpg",
	    "fotomagin/128.jpg",
	    "aka_james/128.jpg",
	    "denisepires/128.jpg",
	    "iqbalperkasa/128.jpg",
	    "martinansty/128.jpg",
	    "jarsen/128.jpg",
	    "r_oy/128.jpg",
	    "justinrob/128.jpg",
	    "gabrielrosser/128.jpg",
	    "malgordon/128.jpg",
	    "carlfairclough/128.jpg",
	    "michaelabehsera/128.jpg",
	    "pierrestoffe/128.jpg",
	    "enjoythetau/128.jpg",
	    "loganjlambert/128.jpg",
	    "rpeezy/128.jpg",
	    "coreyginnivan/128.jpg",
	    "michalhron/128.jpg",
	    "msveet/128.jpg",
	    "lingeswaran/128.jpg",
	    "kolsvein/128.jpg",
	    "peter576/128.jpg",
	    "reideiredale/128.jpg",
	    "joeymurdah/128.jpg",
	    "raphaelnikson/128.jpg",
	    "mvdheuvel/128.jpg",
	    "maxlinderman/128.jpg",
	    "jimmuirhead/128.jpg",
	    "begreative/128.jpg",
	    "frankiefreesbie/128.jpg",
	    "robturlinckx/128.jpg",
	    "Talbi_ConSept/128.jpg",
	    "longlivemyword/128.jpg",
	    "vanchesz/128.jpg",
	    "maiklam/128.jpg",
	    "hermanobrother/128.jpg",
	    "rez___a/128.jpg",
	    "gregsqueeb/128.jpg",
	    "greenbes/128.jpg",
	    "_ragzor/128.jpg",
	    "anthonysukow/128.jpg",
	    "fluidbrush/128.jpg",
	    "dactrtr/128.jpg",
	    "jehnglynn/128.jpg",
	    "bergmartin/128.jpg",
	    "hugocornejo/128.jpg",
	    "_kkga/128.jpg",
	    "dzantievm/128.jpg",
	    "sawalazar/128.jpg",
	    "sovesove/128.jpg",
	    "jonsgotwood/128.jpg",
	    "byryan/128.jpg",
	    "vytautas_a/128.jpg",
	    "mizhgan/128.jpg",
	    "cicerobr/128.jpg",
	    "nilshelmersson/128.jpg",
	    "d33pthought/128.jpg",
	    "davecraige/128.jpg",
	    "nckjrvs/128.jpg",
	    "alexandermayes/128.jpg",
	    "jcubic/128.jpg",
	    "craigrcoles/128.jpg",
	    "bagawarman/128.jpg",
	    "rob_thomas10/128.jpg",
	    "cofla/128.jpg",
	    "maikelk/128.jpg",
	    "rtgibbons/128.jpg",
	    "russell_baylis/128.jpg",
	    "mhesslow/128.jpg",
	    "codysanfilippo/128.jpg",
	    "webtanya/128.jpg",
	    "madebybrenton/128.jpg",
	    "dcalonaci/128.jpg",
	    "perfectflow/128.jpg",
	    "jjsiii/128.jpg",
	    "saarabpreet/128.jpg",
	    "kumarrajan12123/128.jpg",
	    "iamsteffen/128.jpg",
	    "themikenagle/128.jpg",
	    "ceekaytweet/128.jpg",
	    "larrybolt/128.jpg",
	    "conspirator/128.jpg",
	    "dallasbpeters/128.jpg",
	    "n3dmax/128.jpg",
	    "terpimost/128.jpg",
	    "kirillz/128.jpg",
	    "byrnecore/128.jpg",
	    "j_drake_/128.jpg",
	    "calebjoyce/128.jpg",
	    "russoedu/128.jpg",
	    "hoangloi/128.jpg",
	    "tobysaxon/128.jpg",
	    "gofrasdesign/128.jpg",
	    "dimaposnyy/128.jpg",
	    "tjisousa/128.jpg",
	    "okandungel/128.jpg",
	    "billyroshan/128.jpg",
	    "oskamaya/128.jpg",
	    "motionthinks/128.jpg",
	    "knilob/128.jpg",
	    "ashocka18/128.jpg",
	    "marrimo/128.jpg",
	    "bartjo/128.jpg",
	    "omnizya/128.jpg",
	    "ernestsemerda/128.jpg",
	    "andreas_pr/128.jpg",
	    "edgarchris99/128.jpg",
	    "thomasgeisen/128.jpg",
	    "gseguin/128.jpg",
	    "joannefournier/128.jpg",
	    "demersdesigns/128.jpg",
	    "adammarsbar/128.jpg",
	    "nasirwd/128.jpg",
	    "n_tassone/128.jpg",
	    "javorszky/128.jpg",
	    "themrdave/128.jpg",
	    "yecidsm/128.jpg",
	    "nicollerich/128.jpg",
	    "canapud/128.jpg",
	    "nicoleglynn/128.jpg",
	    "judzhin_miles/128.jpg",
	    "designervzm/128.jpg",
	    "kianoshp/128.jpg",
	    "evandrix/128.jpg",
	    "alterchuca/128.jpg",
	    "dhrubo/128.jpg",
	    "ma_tiax/128.jpg",
	    "ssbb_me/128.jpg",
	    "dorphern/128.jpg",
	    "mauriolg/128.jpg",
	    "bruno_mart/128.jpg",
	    "mactopus/128.jpg",
	    "the_winslet/128.jpg",
	    "joemdesign/128.jpg",
	    "Shriiiiimp/128.jpg",
	    "jacobbennett/128.jpg",
	    "nfedoroff/128.jpg",
	    "iamglimy/128.jpg",
	    "allagringaus/128.jpg",
	    "aiiaiiaii/128.jpg",
	    "olaolusoga/128.jpg",
	    "buryaknick/128.jpg",
	    "wim1k/128.jpg",
	    "nicklacke/128.jpg",
	    "a1chapone/128.jpg",
	    "steynviljoen/128.jpg",
	    "strikewan/128.jpg",
	    "ryankirkman/128.jpg",
	    "andrewabogado/128.jpg",
	    "doooon/128.jpg",
	    "jagan123/128.jpg",
	    "ariffsetiawan/128.jpg",
	    "elenadissi/128.jpg",
	    "mwarkentin/128.jpg",
	    "thierrymeier_/128.jpg",
	    "r_garcia/128.jpg",
	    "dmackerman/128.jpg",
	    "borantula/128.jpg",
	    "konus/128.jpg",
	    "spacewood_/128.jpg",
	    "ryuchi311/128.jpg",
	    "evanshajed/128.jpg",
	    "tristanlegros/128.jpg",
	    "shoaib253/128.jpg",
	    "aislinnkelly/128.jpg",
	    "okcoker/128.jpg",
	    "timpetricola/128.jpg",
	    "sunshinedgirl/128.jpg",
	    "chadami/128.jpg",
	    "aleclarsoniv/128.jpg",
	    "nomidesigns/128.jpg",
	    "petebernardo/128.jpg",
	    "scottiedude/128.jpg",
	    "millinet/128.jpg",
	    "imsoper/128.jpg",
	    "imammuht/128.jpg",
	    "benjamin_knight/128.jpg",
	    "nepdud/128.jpg",
	    "joki4/128.jpg",
	    "lanceguyatt/128.jpg",
	    "bboy1895/128.jpg",
	    "amywebbb/128.jpg",
	    "rweve/128.jpg",
	    "haruintesettden/128.jpg",
	    "ricburton/128.jpg",
	    "nelshd/128.jpg",
	    "batsirai/128.jpg",
	    "primozcigler/128.jpg",
	    "jffgrdnr/128.jpg",
	    "8d3k/128.jpg",
	    "geneseleznev/128.jpg",
	    "al_li/128.jpg",
	    "souperphly/128.jpg",
	    "mslarkina/128.jpg",
	    "2fockus/128.jpg",
	    "cdavis565/128.jpg",
	    "xiel/128.jpg",
	    "turkutuuli/128.jpg",
	    "uxward/128.jpg",
	    "lebinoclard/128.jpg",
	    "gauravjassal/128.jpg",
	    "davidmerrique/128.jpg",
	    "mdsisto/128.jpg",
	    "andrewofficer/128.jpg",
	    "kojourin/128.jpg",
	    "dnirmal/128.jpg",
	    "kevka/128.jpg",
	    "mr_shiznit/128.jpg",
	    "aluisio_azevedo/128.jpg",
	    "cloudstudio/128.jpg",
	    "danvierich/128.jpg",
	    "alexivanichkin/128.jpg",
	    "fran_mchamy/128.jpg",
	    "perretmagali/128.jpg",
	    "betraydan/128.jpg",
	    "cadikkara/128.jpg",
	    "matbeedotcom/128.jpg",
	    "jeremyworboys/128.jpg",
	    "bpartridge/128.jpg",
	    "michaelkoper/128.jpg",
	    "silv3rgvn/128.jpg",
	    "alevizio/128.jpg",
	    "johnsmithagency/128.jpg",
	    "lawlbwoy/128.jpg",
	    "vitor376/128.jpg",
	    "desastrozo/128.jpg",
	    "thimo_cz/128.jpg",
	    "jasonmarkjones/128.jpg",
	    "lhausermann/128.jpg",
	    "xravil/128.jpg",
	    "guischmitt/128.jpg",
	    "vigobronx/128.jpg",
	    "panghal0/128.jpg",
	    "miguelkooreman/128.jpg",
	    "surgeonist/128.jpg",
	    "christianoliff/128.jpg",
	    "caspergrl/128.jpg",
	    "iamkarna/128.jpg",
	    "ipavelek/128.jpg",
	    "pierre_nel/128.jpg",
	    "y2graphic/128.jpg",
	    "sterlingrules/128.jpg",
	    "elbuscainfo/128.jpg",
	    "bennyjien/128.jpg",
	    "stushona/128.jpg",
	    "estebanuribe/128.jpg",
	    "embrcecreations/128.jpg",
	    "danillos/128.jpg",
	    "elliotlewis/128.jpg",
	    "charlesrpratt/128.jpg",
	    "vladyn/128.jpg",
	    "emmeffess/128.jpg",
	    "carlosblanco_eu/128.jpg",
	    "leonfedotov/128.jpg",
	    "rangafangs/128.jpg",
	    "chris_frees/128.jpg",
	    "tgormtx/128.jpg",
	    "bryan_topham/128.jpg",
	    "jpscribbles/128.jpg",
	    "mighty55/128.jpg",
	    "carbontwelve/128.jpg",
	    "isaacfifth/128.jpg",
	    "iamjdeleon/128.jpg",
	    "snowwrite/128.jpg",
	    "barputro/128.jpg",
	    "drewbyreese/128.jpg",
	    "sachacorazzi/128.jpg",
	    "bistrianiosip/128.jpg",
	    "magoo04/128.jpg",
	    "pehamondello/128.jpg",
	    "yayteejay/128.jpg",
	    "a_harris88/128.jpg",
	    "algunsanabria/128.jpg",
	    "zforrester/128.jpg",
	    "ovall/128.jpg",
	    "carlosjgsousa/128.jpg",
	    "geobikas/128.jpg",
	    "ah_lice/128.jpg",
	    "looneydoodle/128.jpg",
	    "nerdgr8/128.jpg",
	    "ddggccaa/128.jpg",
	    "zackeeler/128.jpg",
	    "normanbox/128.jpg",
	    "el_fuertisimo/128.jpg",
	    "ismail_biltagi/128.jpg",
	    "juangomezw/128.jpg",
	    "jnmnrd/128.jpg",
	    "patrickcoombe/128.jpg",
	    "ryanjohnson_me/128.jpg",
	    "markolschesky/128.jpg",
	    "jeffgolenski/128.jpg",
	    "kvasnic/128.jpg",
	    "lindseyzilla/128.jpg",
	    "gauchomatt/128.jpg",
	    "afusinatto/128.jpg",
	    "kevinoh/128.jpg",
	    "okansurreel/128.jpg",
	    "adamawesomeface/128.jpg",
	    "emileboudeling/128.jpg",
	    "arishi_/128.jpg",
	    "juanmamartinez/128.jpg",
	    "wikiziner/128.jpg",
	    "danthms/128.jpg",
	    "mkginfo/128.jpg",
	    "terrorpixel/128.jpg",
	    "curiousonaut/128.jpg",
	    "prheemo/128.jpg",
	    "michaelcolenso/128.jpg",
	    "foczzi/128.jpg",
	    "martip07/128.jpg",
	    "thaodang17/128.jpg",
	    "johncafazza/128.jpg",
	    "robinlayfield/128.jpg",
	    "franciscoamk/128.jpg",
	    "abdulhyeuk/128.jpg",
	    "marklamb/128.jpg",
	    "edobene/128.jpg",
	    "andresenfredrik/128.jpg",
	    "mikaeljorhult/128.jpg",
	    "chrisslowik/128.jpg",
	    "vinciarts/128.jpg",
	    "meelford/128.jpg",
	    "elliotnolten/128.jpg",
	    "yehudab/128.jpg",
	    "vijaykarthik/128.jpg",
	    "bfrohs/128.jpg",
	    "josep_martins/128.jpg",
	    "attacks/128.jpg",
	    "sur4dye/128.jpg",
	    "tumski/128.jpg",
	    "instalox/128.jpg",
	    "mangosango/128.jpg",
	    "paulfarino/128.jpg",
	    "kazaky999/128.jpg",
	    "kiwiupover/128.jpg",
	    "nvkznemo/128.jpg",
	    "tom_even/128.jpg",
	    "ratbus/128.jpg",
	    "woodsman001/128.jpg",
	    "joshmedeski/128.jpg",
	    "thewillbeard/128.jpg",
	    "psaikali/128.jpg",
	    "joe_black/128.jpg",
	    "aleinadsays/128.jpg",
	    "marcusgorillius/128.jpg",
	    "hota_v/128.jpg",
	    "jghyllebert/128.jpg",
	    "shinze/128.jpg",
	    "janpalounek/128.jpg",
	    "jeremiespoken/128.jpg",
	    "her_ruu/128.jpg",
	    "dansowter/128.jpg",
	    "felipeapiress/128.jpg",
	    "magugzbrand2d/128.jpg",
	    "posterjob/128.jpg",
	    "nathalie_fs/128.jpg",
	    "bobbytwoshoes/128.jpg",
	    "dreizle/128.jpg",
	    "jeremymouton/128.jpg",
	    "elisabethkjaer/128.jpg",
	    "notbadart/128.jpg",
	    "mohanrohith/128.jpg",
	    "jlsolerdeltoro/128.jpg",
	    "itskawsar/128.jpg",
	    "slowspock/128.jpg",
	    "zvchkelly/128.jpg",
	    "wiljanslofstra/128.jpg",
	    "craighenneberry/128.jpg",
	    "trubeatto/128.jpg",
	    "juaumlol/128.jpg",
	    "samscouto/128.jpg",
	    "BenouarradeM/128.jpg",
	    "gipsy_raf/128.jpg",
	    "netonet_il/128.jpg",
	    "arkokoley/128.jpg",
	    "itsajimithing/128.jpg",
	    "smalonso/128.jpg",
	    "victordeanda/128.jpg",
	    "_dwite_/128.jpg",
	    "richardgarretts/128.jpg",
	    "gregrwilkinson/128.jpg",
	    "anatolinicolae/128.jpg",
	    "lu4sh1i/128.jpg",
	    "stefanotirloni/128.jpg",
	    "ostirbu/128.jpg",
	    "darcystonge/128.jpg",
	    "naitanamoreno/128.jpg",
	    "michaelcomiskey/128.jpg",
	    "adhiardana/128.jpg",
	    "marcomano_/128.jpg",
	    "davidcazalis/128.jpg",
	    "falconerie/128.jpg",
	    "gregkilian/128.jpg",
	    "bcrad/128.jpg",
	    "bolzanmarco/128.jpg",
	    "low_res/128.jpg",
	    "vlajki/128.jpg",
	    "petar_prog/128.jpg",
	    "jonkspr/128.jpg",
	    "akmalfikri/128.jpg",
	    "mfacchinello/128.jpg",
	    "atanism/128.jpg",
	    "harry_sistalam/128.jpg",
	    "murrayswift/128.jpg",
	    "bobwassermann/128.jpg",
	    "gavr1l0/128.jpg",
	    "madshensel/128.jpg",
	    "mr_subtle/128.jpg",
	    "deviljho_/128.jpg",
	    "salimianoff/128.jpg",
	    "joetruesdell/128.jpg",
	    "twittypork/128.jpg",
	    "airskylar/128.jpg",
	    "dnezkumar/128.jpg",
	    "dgajjar/128.jpg",
	    "cherif_b/128.jpg",
	    "salvafc/128.jpg",
	    "louis_currie/128.jpg",
	    "deeenright/128.jpg",
	    "cybind/128.jpg",
	    "eyronn/128.jpg",
	    "vickyshits/128.jpg",
	    "sweetdelisa/128.jpg",
	    "cboller1/128.jpg",
	    "andresdjasso/128.jpg",
	    "melvindidit/128.jpg",
	    "andysolomon/128.jpg",
	    "thaisselenator_/128.jpg",
	    "lvovenok/128.jpg",
	    "giuliusa/128.jpg",
	    "belyaev_rs/128.jpg",
	    "overcloacked/128.jpg",
	    "kamal_chaneman/128.jpg",
	    "incubo82/128.jpg",
	    "hellofeverrrr/128.jpg",
	    "mhaligowski/128.jpg",
	    "sunlandictwin/128.jpg",
	    "bu7921/128.jpg",
	    "andytlaw/128.jpg",
	    "jeremery/128.jpg",
	    "finchjke/128.jpg",
	    "manigm/128.jpg",
	    "umurgdk/128.jpg",
	    "scottfeltham/128.jpg",
	    "ganserene/128.jpg",
	    "mutu_krish/128.jpg",
	    "jodytaggart/128.jpg",
	    "ntfblog/128.jpg",
	    "tanveerrao/128.jpg",
	    "hfalucas/128.jpg",
	    "alxleroydeval/128.jpg",
	    "kucingbelang4/128.jpg",
	    "bargaorobalo/128.jpg",
	    "colgruv/128.jpg",
	    "stalewine/128.jpg",
	    "kylefrost/128.jpg",
	    "baumannzone/128.jpg",
	    "angelcolberg/128.jpg",
	    "sachingawas/128.jpg",
	    "jjshaw14/128.jpg",
	    "ramanathan_pdy/128.jpg",
	    "johndezember/128.jpg",
	    "nilshoenson/128.jpg",
	    "brandonmorreale/128.jpg",
	    "nutzumi/128.jpg",
	    "brandonflatsoda/128.jpg",
	    "sergeyalmone/128.jpg",
	    "klefue/128.jpg",
	    "kirangopal/128.jpg",
	    "baumann_alex/128.jpg",
	    "matthewkay_/128.jpg",
	    "jay_wilburn/128.jpg",
	    "shesgared/128.jpg",
	    "apriendeau/128.jpg",
	    "johnriordan/128.jpg",
	    "wake_gs/128.jpg",
	    "aleksitappura/128.jpg",
	    "emsgulam/128.jpg",
	    "xilantra/128.jpg",
	    "imomenui/128.jpg",
	    "sircalebgrove/128.jpg",
	    "newbrushes/128.jpg",
	    "hsinyo23/128.jpg",
	    "m4rio/128.jpg",
	    "katiemdaly/128.jpg",
	    "s4f1/128.jpg",
	    "ecommerceil/128.jpg",
	    "marlinjayakody/128.jpg",
	    "swooshycueb/128.jpg",
	    "sangdth/128.jpg",
	    "coderdiaz/128.jpg",
	    "bluefx_/128.jpg",
	    "vivekprvr/128.jpg",
	    "sasha_shestakov/128.jpg",
	    "eugeneeweb/128.jpg",
	    "dgclegg/128.jpg",
	    "n1ght_coder/128.jpg",
	    "dixchen/128.jpg",
	    "blakehawksworth/128.jpg",
	    "trueblood_33/128.jpg",
	    "hai_ninh_nguyen/128.jpg",
	    "marclgonzales/128.jpg",
	    "yesmeck/128.jpg",
	    "stephcoue/128.jpg",
	    "doronmalki/128.jpg",
	    "ruehldesign/128.jpg",
	    "anasnakawa/128.jpg",
	    "kijanmaharjan/128.jpg",
	    "wearesavas/128.jpg",
	    "stefvdham/128.jpg",
	    "tweetubhai/128.jpg",
	    "alecarpentier/128.jpg",
	    "fiterik/128.jpg",
	    "antonyryndya/128.jpg",
	    "d00maz/128.jpg",
	    "theonlyzeke/128.jpg",
	    "missaaamy/128.jpg",
	    "carlosm/128.jpg",
	    "manekenthe/128.jpg",
	    "reetajayendra/128.jpg",
	    "jeremyshimko/128.jpg",
	    "justinrgraham/128.jpg",
	    "stefanozoffoli/128.jpg",
	    "overra/128.jpg",
	    "mrebay007/128.jpg",
	    "shvelo96/128.jpg",
	    "pyronite/128.jpg",
	    "thedjpetersen/128.jpg",
	    "rtyukmaev/128.jpg",
	    "_williamguerra/128.jpg",
	    "albertaugustin/128.jpg",
	    "vikashpathak18/128.jpg",
	    "kevinjohndayy/128.jpg",
	    "vj_demien/128.jpg",
	    "colirpixoil/128.jpg",
	    "goddardlewis/128.jpg",
	    "laasli/128.jpg",
	    "jqiuss/128.jpg",
	    "heycamtaylor/128.jpg",
	    "nastya_mane/128.jpg",
	    "mastermindesign/128.jpg",
	    "ccinojasso1/128.jpg",
	    "nyancecom/128.jpg",
	    "sandywoodruff/128.jpg",
	    "bighanddesign/128.jpg",
	    "sbtransparent/128.jpg",
	    "aviddayentonbay/128.jpg",
	    "richwild/128.jpg",
	    "kaysix_dizzy/128.jpg",
	    "tur8le/128.jpg",
	    "seyedhossein1/128.jpg",
	    "privetwagner/128.jpg",
	    "emmandenn/128.jpg",
	    "dev_essentials/128.jpg",
	    "jmfsocial/128.jpg",
	    "_yardenoon/128.jpg",
	    "mateaodviteza/128.jpg",
	    "weavermedia/128.jpg",
	    "mufaddal_mw/128.jpg",
	    "hafeeskhan/128.jpg",
	    "ashernatali/128.jpg",
	    "sulaqo/128.jpg",
	    "eddiechen/128.jpg",
	    "josecarlospsh/128.jpg",
	    "vm_f/128.jpg",
	    "enricocicconi/128.jpg",
	    "danmartin70/128.jpg",
	    "gmourier/128.jpg",
	    "donjain/128.jpg",
	    "mrxloka/128.jpg",
	    "_pedropinho/128.jpg",
	    "eitarafa/128.jpg",
	    "oscarowusu/128.jpg",
	    "ralph_lam/128.jpg",
	    "panchajanyag/128.jpg",
	    "woodydotmx/128.jpg",
	    "jerrybai1907/128.jpg",
	    "marshallchen_/128.jpg",
	    "xamorep/128.jpg",
	    "aio___/128.jpg",
	    "chaabane_wail/128.jpg",
	    "txcx/128.jpg",
	    "akashsharma39/128.jpg",
	    "falling_soul/128.jpg",
	    "sainraja/128.jpg",
	    "mugukamil/128.jpg",
	    "johannesneu/128.jpg",
	    "markwienands/128.jpg",
	    "karthipanraj/128.jpg",
	    "balakayuriy/128.jpg",
	    "alan_zhang_/128.jpg",
	    "layerssss/128.jpg",
	    "kaspernordkvist/128.jpg",
	    "mirfanqureshi/128.jpg",
	    "hanna_smi/128.jpg",
	    "VMilescu/128.jpg",
	    "aeon56/128.jpg",
	    "m_kalibry/128.jpg",
	    "sreejithexp/128.jpg",
	    "dicesales/128.jpg",
	    "dhoot_amit/128.jpg",
	    "smenov/128.jpg",
	    "lonesomelemon/128.jpg",
	    "vladimirdevic/128.jpg",
	    "joelcipriano/128.jpg",
	    "haligaliharun/128.jpg",
	    "buleswapnil/128.jpg",
	    "serefka/128.jpg",
	    "ifarafonow/128.jpg",
	    "vikasvinfotech/128.jpg",
	    "urrutimeoli/128.jpg",
	    "areandacom/128.jpg"
	];
	
	en.internet.avatar_uri = [];
	
	for (var i = 0; i < avatarUri.length; i++) {
	  en.internet.avatar_uri.push("https://s3.amazonaws.com/uifaces/faces/twitter/" + avatarUri[i]);
	};
	
	en.lorem = {
	  "words": [
	    "alias",
	    "consequatur",
	    "aut",
	    "perferendis",
	    "sit",
	    "voluptatem",
	    "accusantium",
	    "doloremque",
	    "aperiam",
	    "eaque",
	    "ipsa",
	    "quae",
	    "ab",
	    "illo",
	    "inventore",
	    "veritatis",
	    "et",
	    "quasi",
	    "architecto",
	    "beatae",
	    "vitae",
	    "dicta",
	    "sunt",
	    "explicabo",
	    "aspernatur",
	    "aut",
	    "odit",
	    "aut",
	    "fugit",
	    "sed",
	    "quia",
	    "consequuntur",
	    "magni",
	    "dolores",
	    "eos",
	    "qui",
	    "ratione",
	    "voluptatem",
	    "sequi",
	    "nesciunt",
	    "neque",
	    "dolorem",
	    "ipsum",
	    "quia",
	    "dolor",
	    "sit",
	    "amet",
	    "consectetur",
	    "adipisci",
	    "velit",
	    "sed",
	    "quia",
	    "non",
	    "numquam",
	    "eius",
	    "modi",
	    "tempora",
	    "incidunt",
	    "ut",
	    "labore",
	    "et",
	    "dolore",
	    "magnam",
	    "aliquam",
	    "quaerat",
	    "voluptatem",
	    "ut",
	    "enim",
	    "ad",
	    "minima",
	    "veniam",
	    "quis",
	    "nostrum",
	    "exercitationem",
	    "ullam",
	    "corporis",
	    "nemo",
	    "enim",
	    "ipsam",
	    "voluptatem",
	    "quia",
	    "voluptas",
	    "sit",
	    "suscipit",
	    "laboriosam",
	    "nisi",
	    "ut",
	    "aliquid",
	    "ex",
	    "ea",
	    "commodi",
	    "consequatur",
	    "quis",
	    "autem",
	    "vel",
	    "eum",
	    "iure",
	    "reprehenderit",
	    "qui",
	    "in",
	    "ea",
	    "voluptate",
	    "velit",
	    "esse",
	    "quam",
	    "nihil",
	    "molestiae",
	    "et",
	    "iusto",
	    "odio",
	    "dignissimos",
	    "ducimus",
	    "qui",
	    "blanditiis",
	    "praesentium",
	    "laudantium",
	    "totam",
	    "rem",
	    "voluptatum",
	    "deleniti",
	    "atque",
	    "corrupti",
	    "quos",
	    "dolores",
	    "et",
	    "quas",
	    "molestias",
	    "excepturi",
	    "sint",
	    "occaecati",
	    "cupiditate",
	    "non",
	    "provident",
	    "sed",
	    "ut",
	    "perspiciatis",
	    "unde",
	    "omnis",
	    "iste",
	    "natus",
	    "error",
	    "similique",
	    "sunt",
	    "in",
	    "culpa",
	    "qui",
	    "officia",
	    "deserunt",
	    "mollitia",
	    "animi",
	    "id",
	    "est",
	    "laborum",
	    "et",
	    "dolorum",
	    "fuga",
	    "et",
	    "harum",
	    "quidem",
	    "rerum",
	    "facilis",
	    "est",
	    "et",
	    "expedita",
	    "distinctio",
	    "nam",
	    "libero",
	    "tempore",
	    "cum",
	    "soluta",
	    "nobis",
	    "est",
	    "eligendi",
	    "optio",
	    "cumque",
	    "nihil",
	    "impedit",
	    "quo",
	    "porro",
	    "quisquam",
	    "est",
	    "qui",
	    "minus",
	    "id",
	    "quod",
	    "maxime",
	    "placeat",
	    "facere",
	    "possimus",
	    "omnis",
	    "voluptas",
	    "assumenda",
	    "est",
	    "omnis",
	    "dolor",
	    "repellendus",
	    "temporibus",
	    "autem",
	    "quibusdam",
	    "et",
	    "aut",
	    "consequatur",
	    "vel",
	    "illum",
	    "qui",
	    "dolorem",
	    "eum",
	    "fugiat",
	    "quo",
	    "voluptas",
	    "nulla",
	    "pariatur",
	    "at",
	    "vero",
	    "eos",
	    "et",
	    "accusamus",
	    "officiis",
	    "debitis",
	    "aut",
	    "rerum",
	    "necessitatibus",
	    "saepe",
	    "eveniet",
	    "ut",
	    "et",
	    "voluptates",
	    "repudiandae",
	    "sint",
	    "et",
	    "molestiae",
	    "non",
	    "recusandae",
	    "itaque",
	    "earum",
	    "rerum",
	    "hic",
	    "tenetur",
	    "a",
	    "sapiente",
	    "delectus",
	    "ut",
	    "aut",
	    "reiciendis",
	    "voluptatibus",
	    "maiores",
	    "doloribus",
	    "asperiores",
	    "repellat"
	  ],
	  "supplemental": [
	    "abbas",
	    "abduco",
	    "abeo",
	    "abscido",
	    "absconditus",
	    "absens",
	    "absorbeo",
	    "absque",
	    "abstergo",
	    "absum",
	    "abundans",
	    "abutor",
	    "accedo",
	    "accendo",
	    "acceptus",
	    "accipio",
	    "accommodo",
	    "accusator",
	    "acer",
	    "acerbitas",
	    "acervus",
	    "acidus",
	    "acies",
	    "acquiro",
	    "acsi",
	    "adamo",
	    "adaugeo",
	    "addo",
	    "adduco",
	    "ademptio",
	    "adeo",
	    "adeptio",
	    "adfectus",
	    "adfero",
	    "adficio",
	    "adflicto",
	    "adhaero",
	    "adhuc",
	    "adicio",
	    "adimpleo",
	    "adinventitias",
	    "adipiscor",
	    "adiuvo",
	    "administratio",
	    "admiratio",
	    "admitto",
	    "admoneo",
	    "admoveo",
	    "adnuo",
	    "adopto",
	    "adsidue",
	    "adstringo",
	    "adsuesco",
	    "adsum",
	    "adulatio",
	    "adulescens",
	    "adultus",
	    "aduro",
	    "advenio",
	    "adversus",
	    "advoco",
	    "aedificium",
	    "aeger",
	    "aegre",
	    "aegrotatio",
	    "aegrus",
	    "aeneus",
	    "aequitas",
	    "aequus",
	    "aer",
	    "aestas",
	    "aestivus",
	    "aestus",
	    "aetas",
	    "aeternus",
	    "ager",
	    "aggero",
	    "aggredior",
	    "agnitio",
	    "agnosco",
	    "ago",
	    "ait",
	    "aiunt",
	    "alienus",
	    "alii",
	    "alioqui",
	    "aliqua",
	    "alius",
	    "allatus",
	    "alo",
	    "alter",
	    "altus",
	    "alveus",
	    "amaritudo",
	    "ambitus",
	    "ambulo",
	    "amicitia",
	    "amiculum",
	    "amissio",
	    "amita",
	    "amitto",
	    "amo",
	    "amor",
	    "amoveo",
	    "amplexus",
	    "amplitudo",
	    "amplus",
	    "ancilla",
	    "angelus",
	    "angulus",
	    "angustus",
	    "animadverto",
	    "animi",
	    "animus",
	    "annus",
	    "anser",
	    "ante",
	    "antea",
	    "antepono",
	    "antiquus",
	    "aperio",
	    "aperte",
	    "apostolus",
	    "apparatus",
	    "appello",
	    "appono",
	    "appositus",
	    "approbo",
	    "apto",
	    "aptus",
	    "apud",
	    "aqua",
	    "ara",
	    "aranea",
	    "arbitro",
	    "arbor",
	    "arbustum",
	    "arca",
	    "arceo",
	    "arcesso",
	    "arcus",
	    "argentum",
	    "argumentum",
	    "arguo",
	    "arma",
	    "armarium",
	    "armo",
	    "aro",
	    "ars",
	    "articulus",
	    "artificiose",
	    "arto",
	    "arx",
	    "ascisco",
	    "ascit",
	    "asper",
	    "aspicio",
	    "asporto",
	    "assentator",
	    "astrum",
	    "atavus",
	    "ater",
	    "atqui",
	    "atrocitas",
	    "atrox",
	    "attero",
	    "attollo",
	    "attonbitus",
	    "auctor",
	    "auctus",
	    "audacia",
	    "audax",
	    "audentia",
	    "audeo",
	    "audio",
	    "auditor",
	    "aufero",
	    "aureus",
	    "auris",
	    "aurum",
	    "aut",
	    "autem",
	    "autus",
	    "auxilium",
	    "avaritia",
	    "avarus",
	    "aveho",
	    "averto",
	    "avoco",
	    "baiulus",
	    "balbus",
	    "barba",
	    "bardus",
	    "basium",
	    "beatus",
	    "bellicus",
	    "bellum",
	    "bene",
	    "beneficium",
	    "benevolentia",
	    "benigne",
	    "bestia",
	    "bibo",
	    "bis",
	    "blandior",
	    "bonus",
	    "bos",
	    "brevis",
	    "cado",
	    "caecus",
	    "caelestis",
	    "caelum",
	    "calamitas",
	    "calcar",
	    "calco",
	    "calculus",
	    "callide",
	    "campana",
	    "candidus",
	    "canis",
	    "canonicus",
	    "canto",
	    "capillus",
	    "capio",
	    "capitulus",
	    "capto",
	    "caput",
	    "carbo",
	    "carcer",
	    "careo",
	    "caries",
	    "cariosus",
	    "caritas",
	    "carmen",
	    "carpo",
	    "carus",
	    "casso",
	    "caste",
	    "casus",
	    "catena",
	    "caterva",
	    "cattus",
	    "cauda",
	    "causa",
	    "caute",
	    "caveo",
	    "cavus",
	    "cedo",
	    "celebrer",
	    "celer",
	    "celo",
	    "cena",
	    "cenaculum",
	    "ceno",
	    "censura",
	    "centum",
	    "cerno",
	    "cernuus",
	    "certe",
	    "certo",
	    "certus",
	    "cervus",
	    "cetera",
	    "charisma",
	    "chirographum",
	    "cibo",
	    "cibus",
	    "cicuta",
	    "cilicium",
	    "cimentarius",
	    "ciminatio",
	    "cinis",
	    "circumvenio",
	    "cito",
	    "civis",
	    "civitas",
	    "clam",
	    "clamo",
	    "claro",
	    "clarus",
	    "claudeo",
	    "claustrum",
	    "clementia",
	    "clibanus",
	    "coadunatio",
	    "coaegresco",
	    "coepi",
	    "coerceo",
	    "cogito",
	    "cognatus",
	    "cognomen",
	    "cogo",
	    "cohaero",
	    "cohibeo",
	    "cohors",
	    "colligo",
	    "colloco",
	    "collum",
	    "colo",
	    "color",
	    "coma",
	    "combibo",
	    "comburo",
	    "comedo",
	    "comes",
	    "cometes",
	    "comis",
	    "comitatus",
	    "commemoro",
	    "comminor",
	    "commodo",
	    "communis",
	    "comparo",
	    "compello",
	    "complectus",
	    "compono",
	    "comprehendo",
	    "comptus",
	    "conatus",
	    "concedo",
	    "concido",
	    "conculco",
	    "condico",
	    "conduco",
	    "confero",
	    "confido",
	    "conforto",
	    "confugo",
	    "congregatio",
	    "conicio",
	    "coniecto",
	    "conitor",
	    "coniuratio",
	    "conor",
	    "conqueror",
	    "conscendo",
	    "conservo",
	    "considero",
	    "conspergo",
	    "constans",
	    "consuasor",
	    "contabesco",
	    "contego",
	    "contigo",
	    "contra",
	    "conturbo",
	    "conventus",
	    "convoco",
	    "copia",
	    "copiose",
	    "cornu",
	    "corona",
	    "corpus",
	    "correptius",
	    "corrigo",
	    "corroboro",
	    "corrumpo",
	    "coruscus",
	    "cotidie",
	    "crapula",
	    "cras",
	    "crastinus",
	    "creator",
	    "creber",
	    "crebro",
	    "credo",
	    "creo",
	    "creptio",
	    "crepusculum",
	    "cresco",
	    "creta",
	    "cribro",
	    "crinis",
	    "cruciamentum",
	    "crudelis",
	    "cruentus",
	    "crur",
	    "crustulum",
	    "crux",
	    "cubicularis",
	    "cubitum",
	    "cubo",
	    "cui",
	    "cuius",
	    "culpa",
	    "culpo",
	    "cultellus",
	    "cultura",
	    "cum",
	    "cunabula",
	    "cunae",
	    "cunctatio",
	    "cupiditas",
	    "cupio",
	    "cuppedia",
	    "cupressus",
	    "cur",
	    "cura",
	    "curatio",
	    "curia",
	    "curiositas",
	    "curis",
	    "curo",
	    "curriculum",
	    "currus",
	    "cursim",
	    "curso",
	    "cursus",
	    "curto",
	    "curtus",
	    "curvo",
	    "curvus",
	    "custodia",
	    "damnatio",
	    "damno",
	    "dapifer",
	    "debeo",
	    "debilito",
	    "decens",
	    "decerno",
	    "decet",
	    "decimus",
	    "decipio",
	    "decor",
	    "decretum",
	    "decumbo",
	    "dedecor",
	    "dedico",
	    "deduco",
	    "defaeco",
	    "defendo",
	    "defero",
	    "defessus",
	    "defetiscor",
	    "deficio",
	    "defigo",
	    "defleo",
	    "defluo",
	    "defungo",
	    "degenero",
	    "degero",
	    "degusto",
	    "deinde",
	    "delectatio",
	    "delego",
	    "deleo",
	    "delibero",
	    "delicate",
	    "delinquo",
	    "deludo",
	    "demens",
	    "demergo",
	    "demitto",
	    "demo",
	    "demonstro",
	    "demoror",
	    "demulceo",
	    "demum",
	    "denego",
	    "denique",
	    "dens",
	    "denuncio",
	    "denuo",
	    "deorsum",
	    "depereo",
	    "depono",
	    "depopulo",
	    "deporto",
	    "depraedor",
	    "deprecator",
	    "deprimo",
	    "depromo",
	    "depulso",
	    "deputo",
	    "derelinquo",
	    "derideo",
	    "deripio",
	    "desidero",
	    "desino",
	    "desipio",
	    "desolo",
	    "desparatus",
	    "despecto",
	    "despirmatio",
	    "infit",
	    "inflammatio",
	    "paens",
	    "patior",
	    "patria",
	    "patrocinor",
	    "patruus",
	    "pauci",
	    "paulatim",
	    "pauper",
	    "pax",
	    "peccatus",
	    "pecco",
	    "pecto",
	    "pectus",
	    "pecunia",
	    "pecus",
	    "peior",
	    "pel",
	    "ocer",
	    "socius",
	    "sodalitas",
	    "sol",
	    "soleo",
	    "solio",
	    "solitudo",
	    "solium",
	    "sollers",
	    "sollicito",
	    "solum",
	    "solus",
	    "solutio",
	    "solvo",
	    "somniculosus",
	    "somnus",
	    "sonitus",
	    "sono",
	    "sophismata",
	    "sopor",
	    "sordeo",
	    "sortitus",
	    "spargo",
	    "speciosus",
	    "spectaculum",
	    "speculum",
	    "sperno",
	    "spero",
	    "spes",
	    "spiculum",
	    "spiritus",
	    "spoliatio",
	    "sponte",
	    "stabilis",
	    "statim",
	    "statua",
	    "stella",
	    "stillicidium",
	    "stipes",
	    "stips",
	    "sto",
	    "strenuus",
	    "strues",
	    "studio",
	    "stultus",
	    "suadeo",
	    "suasoria",
	    "sub",
	    "subito",
	    "subiungo",
	    "sublime",
	    "subnecto",
	    "subseco",
	    "substantia",
	    "subvenio",
	    "succedo",
	    "succurro",
	    "sufficio",
	    "suffoco",
	    "suffragium",
	    "suggero",
	    "sui",
	    "sulum",
	    "sum",
	    "summa",
	    "summisse",
	    "summopere",
	    "sumo",
	    "sumptus",
	    "supellex",
	    "super",
	    "suppellex",
	    "supplanto",
	    "suppono",
	    "supra",
	    "surculus",
	    "surgo",
	    "sursum",
	    "suscipio",
	    "suspendo",
	    "sustineo",
	    "suus",
	    "synagoga",
	    "tabella",
	    "tabernus",
	    "tabesco",
	    "tabgo",
	    "tabula",
	    "taceo",
	    "tactus",
	    "taedium",
	    "talio",
	    "talis",
	    "talus",
	    "tam",
	    "tamdiu",
	    "tamen",
	    "tametsi",
	    "tamisium",
	    "tamquam",
	    "tandem",
	    "tantillus",
	    "tantum",
	    "tardus",
	    "tego",
	    "temeritas",
	    "temperantia",
	    "templum",
	    "temptatio",
	    "tempus",
	    "tenax",
	    "tendo",
	    "teneo",
	    "tener",
	    "tenuis",
	    "tenus",
	    "tepesco",
	    "tepidus",
	    "ter",
	    "terebro",
	    "teres",
	    "terga",
	    "tergeo",
	    "tergiversatio",
	    "tergo",
	    "tergum",
	    "termes",
	    "terminatio",
	    "tero",
	    "terra",
	    "terreo",
	    "territo",
	    "terror",
	    "tersus",
	    "tertius",
	    "testimonium",
	    "texo",
	    "textilis",
	    "textor",
	    "textus",
	    "thalassinus",
	    "theatrum",
	    "theca",
	    "thema",
	    "theologus",
	    "thermae",
	    "thesaurus",
	    "thesis",
	    "thorax",
	    "thymbra",
	    "thymum",
	    "tibi",
	    "timidus",
	    "timor",
	    "titulus",
	    "tolero",
	    "tollo",
	    "tondeo",
	    "tonsor",
	    "torqueo",
	    "torrens",
	    "tot",
	    "totidem",
	    "toties",
	    "totus",
	    "tracto",
	    "trado",
	    "traho",
	    "trans",
	    "tredecim",
	    "tremo",
	    "trepide",
	    "tres",
	    "tribuo",
	    "tricesimus",
	    "triduana",
	    "triginta",
	    "tripudio",
	    "tristis",
	    "triumphus",
	    "trucido",
	    "truculenter",
	    "tubineus",
	    "tui",
	    "tum",
	    "tumultus",
	    "tunc",
	    "turba",
	    "turbo",
	    "turpe",
	    "turpis",
	    "tutamen",
	    "tutis",
	    "tyrannus",
	    "uberrime",
	    "ubi",
	    "ulciscor",
	    "ullus",
	    "ulterius",
	    "ultio",
	    "ultra",
	    "umbra",
	    "umerus",
	    "umquam",
	    "una",
	    "unde",
	    "undique",
	    "universe",
	    "unus",
	    "urbanus",
	    "urbs",
	    "uredo",
	    "usitas",
	    "usque",
	    "ustilo",
	    "ustulo",
	    "usus",
	    "uter",
	    "uterque",
	    "utilis",
	    "utique",
	    "utor",
	    "utpote",
	    "utrimque",
	    "utroque",
	    "utrum",
	    "uxor",
	    "vaco",
	    "vacuus",
	    "vado",
	    "vae",
	    "valde",
	    "valens",
	    "valeo",
	    "valetudo",
	    "validus",
	    "vallum",
	    "vapulus",
	    "varietas",
	    "varius",
	    "vehemens",
	    "vel",
	    "velociter",
	    "velum",
	    "velut",
	    "venia",
	    "venio",
	    "ventito",
	    "ventosus",
	    "ventus",
	    "venustas",
	    "ver",
	    "verbera",
	    "verbum",
	    "vere",
	    "verecundia",
	    "vereor",
	    "vergo",
	    "veritas",
	    "vero",
	    "versus",
	    "verto",
	    "verumtamen",
	    "verus",
	    "vesco",
	    "vesica",
	    "vesper",
	    "vespillo",
	    "vester",
	    "vestigium",
	    "vestrum",
	    "vetus",
	    "via",
	    "vicinus",
	    "vicissitudo",
	    "victoria",
	    "victus",
	    "videlicet",
	    "video",
	    "viduata",
	    "viduo",
	    "vigilo",
	    "vigor",
	    "vilicus",
	    "vilis",
	    "vilitas",
	    "villa",
	    "vinco",
	    "vinculum",
	    "vindico",
	    "vinitor",
	    "vinum",
	    "vir",
	    "virga",
	    "virgo",
	    "viridis",
	    "viriliter",
	    "virtus",
	    "vis",
	    "viscus",
	    "vita",
	    "vitiosus",
	    "vitium",
	    "vito",
	    "vivo",
	    "vix",
	    "vobis",
	    "vociferor",
	    "voco",
	    "volaticus",
	    "volo",
	    "volubilis",
	    "voluntarius",
	    "volup",
	    "volutabrum",
	    "volva",
	    "vomer",
	    "vomica",
	    "vomito",
	    "vorago",
	    "vorax",
	    "voro",
	    "vos",
	    "votum",
	    "voveo",
	    "vox",
	    "vulariter",
	    "vulgaris",
	    "vulgivagus",
	    "vulgo",
	    "vulgus",
	    "vulnero",
	    "vulnus",
	    "vulpes",
	    "vulticulus",
	    "vultuosus",
	    "xiphias"
	  ]
	};
	en.name = {
	  "first_name": [
	    "Aaliyah",
	    "Aaron",
	    "Abagail",
	    "Abbey",
	    "Abbie",
	    "Abbigail",
	    "Abby",
	    "Abdiel",
	    "Abdul",
	    "Abdullah",
	    "Abe",
	    "Abel",
	    "Abelardo",
	    "Abigail",
	    "Abigale",
	    "Abigayle",
	    "Abner",
	    "Abraham",
	    "Ada",
	    "Adah",
	    "Adalberto",
	    "Adaline",
	    "Adam",
	    "Adan",
	    "Addie",
	    "Addison",
	    "Adela",
	    "Adelbert",
	    "Adele",
	    "Adelia",
	    "Adeline",
	    "Adell",
	    "Adella",
	    "Adelle",
	    "Aditya",
	    "Adolf",
	    "Adolfo",
	    "Adolph",
	    "Adolphus",
	    "Adonis",
	    "Adrain",
	    "Adrian",
	    "Adriana",
	    "Adrianna",
	    "Adriel",
	    "Adrien",
	    "Adrienne",
	    "Afton",
	    "Aglae",
	    "Agnes",
	    "Agustin",
	    "Agustina",
	    "Ahmad",
	    "Ahmed",
	    "Aida",
	    "Aidan",
	    "Aiden",
	    "Aileen",
	    "Aimee",
	    "Aisha",
	    "Aiyana",
	    "Akeem",
	    "Al",
	    "Alaina",
	    "Alan",
	    "Alana",
	    "Alanis",
	    "Alanna",
	    "Alayna",
	    "Alba",
	    "Albert",
	    "Alberta",
	    "Albertha",
	    "Alberto",
	    "Albin",
	    "Albina",
	    "Alda",
	    "Alden",
	    "Alec",
	    "Aleen",
	    "Alejandra",
	    "Alejandrin",
	    "Alek",
	    "Alena",
	    "Alene",
	    "Alessandra",
	    "Alessandro",
	    "Alessia",
	    "Aletha",
	    "Alex",
	    "Alexa",
	    "Alexander",
	    "Alexandra",
	    "Alexandre",
	    "Alexandrea",
	    "Alexandria",
	    "Alexandrine",
	    "Alexandro",
	    "Alexane",
	    "Alexanne",
	    "Alexie",
	    "Alexis",
	    "Alexys",
	    "Alexzander",
	    "Alf",
	    "Alfonso",
	    "Alfonzo",
	    "Alford",
	    "Alfred",
	    "Alfreda",
	    "Alfredo",
	    "Ali",
	    "Alia",
	    "Alice",
	    "Alicia",
	    "Alisa",
	    "Alisha",
	    "Alison",
	    "Alivia",
	    "Aliya",
	    "Aliyah",
	    "Aliza",
	    "Alize",
	    "Allan",
	    "Allen",
	    "Allene",
	    "Allie",
	    "Allison",
	    "Ally",
	    "Alphonso",
	    "Alta",
	    "Althea",
	    "Alva",
	    "Alvah",
	    "Alvena",
	    "Alvera",
	    "Alverta",
	    "Alvina",
	    "Alvis",
	    "Alyce",
	    "Alycia",
	    "Alysa",
	    "Alysha",
	    "Alyson",
	    "Alysson",
	    "Amalia",
	    "Amanda",
	    "Amani",
	    "Amara",
	    "Amari",
	    "Amaya",
	    "Amber",
	    "Ambrose",
	    "Amelia",
	    "Amelie",
	    "Amely",
	    "America",
	    "Americo",
	    "Amie",
	    "Amina",
	    "Amir",
	    "Amira",
	    "Amiya",
	    "Amos",
	    "Amparo",
	    "Amy",
	    "Amya",
	    "Ana",
	    "Anabel",
	    "Anabelle",
	    "Anahi",
	    "Anais",
	    "Anastacio",
	    "Anastasia",
	    "Anderson",
	    "Andre",
	    "Andreane",
	    "Andreanne",
	    "Andres",
	    "Andrew",
	    "Andy",
	    "Angel",
	    "Angela",
	    "Angelica",
	    "Angelina",
	    "Angeline",
	    "Angelita",
	    "Angelo",
	    "Angie",
	    "Angus",
	    "Anibal",
	    "Anika",
	    "Anissa",
	    "Anita",
	    "Aniya",
	    "Aniyah",
	    "Anjali",
	    "Anna",
	    "Annabel",
	    "Annabell",
	    "Annabelle",
	    "Annalise",
	    "Annamae",
	    "Annamarie",
	    "Anne",
	    "Annetta",
	    "Annette",
	    "Annie",
	    "Ansel",
	    "Ansley",
	    "Anthony",
	    "Antoinette",
	    "Antone",
	    "Antonetta",
	    "Antonette",
	    "Antonia",
	    "Antonietta",
	    "Antonina",
	    "Antonio",
	    "Antwan",
	    "Antwon",
	    "Anya",
	    "April",
	    "Ara",
	    "Araceli",
	    "Aracely",
	    "Arch",
	    "Archibald",
	    "Ardella",
	    "Arden",
	    "Ardith",
	    "Arely",
	    "Ari",
	    "Ariane",
	    "Arianna",
	    "Aric",
	    "Ariel",
	    "Arielle",
	    "Arjun",
	    "Arlene",
	    "Arlie",
	    "Arlo",
	    "Armand",
	    "Armando",
	    "Armani",
	    "Arnaldo",
	    "Arne",
	    "Arno",
	    "Arnold",
	    "Arnoldo",
	    "Arnulfo",
	    "Aron",
	    "Art",
	    "Arthur",
	    "Arturo",
	    "Arvel",
	    "Arvid",
	    "Arvilla",
	    "Aryanna",
	    "Asa",
	    "Asha",
	    "Ashlee",
	    "Ashleigh",
	    "Ashley",
	    "Ashly",
	    "Ashlynn",
	    "Ashton",
	    "Ashtyn",
	    "Asia",
	    "Assunta",
	    "Astrid",
	    "Athena",
	    "Aubree",
	    "Aubrey",
	    "Audie",
	    "Audra",
	    "Audreanne",
	    "Audrey",
	    "August",
	    "Augusta",
	    "Augustine",
	    "Augustus",
	    "Aurelia",
	    "Aurelie",
	    "Aurelio",
	    "Aurore",
	    "Austen",
	    "Austin",
	    "Austyn",
	    "Autumn",
	    "Ava",
	    "Avery",
	    "Avis",
	    "Axel",
	    "Ayana",
	    "Ayden",
	    "Ayla",
	    "Aylin",
	    "Baby",
	    "Bailee",
	    "Bailey",
	    "Barbara",
	    "Barney",
	    "Baron",
	    "Barrett",
	    "Barry",
	    "Bart",
	    "Bartholome",
	    "Barton",
	    "Baylee",
	    "Beatrice",
	    "Beau",
	    "Beaulah",
	    "Bell",
	    "Bella",
	    "Belle",
	    "Ben",
	    "Benedict",
	    "Benjamin",
	    "Bennett",
	    "Bennie",
	    "Benny",
	    "Benton",
	    "Berenice",
	    "Bernadette",
	    "Bernadine",
	    "Bernard",
	    "Bernardo",
	    "Berneice",
	    "Bernhard",
	    "Bernice",
	    "Bernie",
	    "Berniece",
	    "Bernita",
	    "Berry",
	    "Bert",
	    "Berta",
	    "Bertha",
	    "Bertram",
	    "Bertrand",
	    "Beryl",
	    "Bessie",
	    "Beth",
	    "Bethany",
	    "Bethel",
	    "Betsy",
	    "Bette",
	    "Bettie",
	    "Betty",
	    "Bettye",
	    "Beulah",
	    "Beverly",
	    "Bianka",
	    "Bill",
	    "Billie",
	    "Billy",
	    "Birdie",
	    "Blair",
	    "Blaise",
	    "Blake",
	    "Blanca",
	    "Blanche",
	    "Blaze",
	    "Bo",
	    "Bobbie",
	    "Bobby",
	    "Bonita",
	    "Bonnie",
	    "Boris",
	    "Boyd",
	    "Brad",
	    "Braden",
	    "Bradford",
	    "Bradley",
	    "Bradly",
	    "Brady",
	    "Braeden",
	    "Brain",
	    "Brandi",
	    "Brando",
	    "Brandon",
	    "Brandt",
	    "Brandy",
	    "Brandyn",
	    "Brannon",
	    "Branson",
	    "Brant",
	    "Braulio",
	    "Braxton",
	    "Brayan",
	    "Breana",
	    "Breanna",
	    "Breanne",
	    "Brenda",
	    "Brendan",
	    "Brenden",
	    "Brendon",
	    "Brenna",
	    "Brennan",
	    "Brennon",
	    "Brent",
	    "Bret",
	    "Brett",
	    "Bria",
	    "Brian",
	    "Briana",
	    "Brianne",
	    "Brice",
	    "Bridget",
	    "Bridgette",
	    "Bridie",
	    "Brielle",
	    "Brigitte",
	    "Brionna",
	    "Brisa",
	    "Britney",
	    "Brittany",
	    "Brock",
	    "Broderick",
	    "Brody",
	    "Brook",
	    "Brooke",
	    "Brooklyn",
	    "Brooks",
	    "Brown",
	    "Bruce",
	    "Bryana",
	    "Bryce",
	    "Brycen",
	    "Bryon",
	    "Buck",
	    "Bud",
	    "Buddy",
	    "Buford",
	    "Bulah",
	    "Burdette",
	    "Burley",
	    "Burnice",
	    "Buster",
	    "Cade",
	    "Caden",
	    "Caesar",
	    "Caitlyn",
	    "Cale",
	    "Caleb",
	    "Caleigh",
	    "Cali",
	    "Calista",
	    "Callie",
	    "Camden",
	    "Cameron",
	    "Camila",
	    "Camilla",
	    "Camille",
	    "Camren",
	    "Camron",
	    "Camryn",
	    "Camylle",
	    "Candace",
	    "Candelario",
	    "Candice",
	    "Candida",
	    "Candido",
	    "Cara",
	    "Carey",
	    "Carissa",
	    "Carlee",
	    "Carleton",
	    "Carley",
	    "Carli",
	    "Carlie",
	    "Carlo",
	    "Carlos",
	    "Carlotta",
	    "Carmel",
	    "Carmela",
	    "Carmella",
	    "Carmelo",
	    "Carmen",
	    "Carmine",
	    "Carol",
	    "Carolanne",
	    "Carole",
	    "Carolina",
	    "Caroline",
	    "Carolyn",
	    "Carolyne",
	    "Carrie",
	    "Carroll",
	    "Carson",
	    "Carter",
	    "Cary",
	    "Casandra",
	    "Casey",
	    "Casimer",
	    "Casimir",
	    "Casper",
	    "Cassandra",
	    "Cassandre",
	    "Cassidy",
	    "Cassie",
	    "Catalina",
	    "Caterina",
	    "Catharine",
	    "Catherine",
	    "Cathrine",
	    "Cathryn",
	    "Cathy",
	    "Cayla",
	    "Ceasar",
	    "Cecelia",
	    "Cecil",
	    "Cecile",
	    "Cecilia",
	    "Cedrick",
	    "Celestine",
	    "Celestino",
	    "Celia",
	    "Celine",
	    "Cesar",
	    "Chad",
	    "Chadd",
	    "Chadrick",
	    "Chaim",
	    "Chance",
	    "Chandler",
	    "Chanel",
	    "Chanelle",
	    "Charity",
	    "Charlene",
	    "Charles",
	    "Charley",
	    "Charlie",
	    "Charlotte",
	    "Chase",
	    "Chasity",
	    "Chauncey",
	    "Chaya",
	    "Chaz",
	    "Chelsea",
	    "Chelsey",
	    "Chelsie",
	    "Chesley",
	    "Chester",
	    "Chet",
	    "Cheyanne",
	    "Cheyenne",
	    "Chloe",
	    "Chris",
	    "Christ",
	    "Christa",
	    "Christelle",
	    "Christian",
	    "Christiana",
	    "Christina",
	    "Christine",
	    "Christop",
	    "Christophe",
	    "Christopher",
	    "Christy",
	    "Chyna",
	    "Ciara",
	    "Cicero",
	    "Cielo",
	    "Cierra",
	    "Cindy",
	    "Citlalli",
	    "Clair",
	    "Claire",
	    "Clara",
	    "Clarabelle",
	    "Clare",
	    "Clarissa",
	    "Clark",
	    "Claud",
	    "Claude",
	    "Claudia",
	    "Claudie",
	    "Claudine",
	    "Clay",
	    "Clemens",
	    "Clement",
	    "Clementina",
	    "Clementine",
	    "Clemmie",
	    "Cleo",
	    "Cleora",
	    "Cleta",
	    "Cletus",
	    "Cleve",
	    "Cleveland",
	    "Clifford",
	    "Clifton",
	    "Clint",
	    "Clinton",
	    "Clotilde",
	    "Clovis",
	    "Cloyd",
	    "Clyde",
	    "Coby",
	    "Cody",
	    "Colby",
	    "Cole",
	    "Coleman",
	    "Colin",
	    "Colleen",
	    "Collin",
	    "Colt",
	    "Colten",
	    "Colton",
	    "Columbus",
	    "Concepcion",
	    "Conner",
	    "Connie",
	    "Connor",
	    "Conor",
	    "Conrad",
	    "Constance",
	    "Constantin",
	    "Consuelo",
	    "Cooper",
	    "Cora",
	    "Coralie",
	    "Corbin",
	    "Cordelia",
	    "Cordell",
	    "Cordia",
	    "Cordie",
	    "Corene",
	    "Corine",
	    "Cornelius",
	    "Cornell",
	    "Corrine",
	    "Cortez",
	    "Cortney",
	    "Cory",
	    "Coty",
	    "Courtney",
	    "Coy",
	    "Craig",
	    "Crawford",
	    "Creola",
	    "Cristal",
	    "Cristian",
	    "Cristina",
	    "Cristobal",
	    "Cristopher",
	    "Cruz",
	    "Crystal",
	    "Crystel",
	    "Cullen",
	    "Curt",
	    "Curtis",
	    "Cydney",
	    "Cynthia",
	    "Cyril",
	    "Cyrus",
	    "Dagmar",
	    "Dahlia",
	    "Daija",
	    "Daisha",
	    "Daisy",
	    "Dakota",
	    "Dale",
	    "Dallas",
	    "Dallin",
	    "Dalton",
	    "Damaris",
	    "Dameon",
	    "Damian",
	    "Damien",
	    "Damion",
	    "Damon",
	    "Dan",
	    "Dana",
	    "Dandre",
	    "Dane",
	    "D'angelo",
	    "Dangelo",
	    "Danial",
	    "Daniela",
	    "Daniella",
	    "Danielle",
	    "Danika",
	    "Dannie",
	    "Danny",
	    "Dante",
	    "Danyka",
	    "Daphne",
	    "Daphnee",
	    "Daphney",
	    "Darby",
	    "Daren",
	    "Darian",
	    "Dariana",
	    "Darien",
	    "Dario",
	    "Darion",
	    "Darius",
	    "Darlene",
	    "Daron",
	    "Darrel",
	    "Darrell",
	    "Darren",
	    "Darrick",
	    "Darrin",
	    "Darrion",
	    "Darron",
	    "Darryl",
	    "Darwin",
	    "Daryl",
	    "Dashawn",
	    "Dasia",
	    "Dave",
	    "David",
	    "Davin",
	    "Davion",
	    "Davon",
	    "Davonte",
	    "Dawn",
	    "Dawson",
	    "Dax",
	    "Dayana",
	    "Dayna",
	    "Dayne",
	    "Dayton",
	    "Dean",
	    "Deangelo",
	    "Deanna",
	    "Deborah",
	    "Declan",
	    "Dedric",
	    "Dedrick",
	    "Dee",
	    "Deion",
	    "Deja",
	    "Dejah",
	    "Dejon",
	    "Dejuan",
	    "Delaney",
	    "Delbert",
	    "Delfina",
	    "Delia",
	    "Delilah",
	    "Dell",
	    "Della",
	    "Delmer",
	    "Delores",
	    "Delpha",
	    "Delphia",
	    "Delphine",
	    "Delta",
	    "Demarco",
	    "Demarcus",
	    "Demario",
	    "Demetris",
	    "Demetrius",
	    "Demond",
	    "Dena",
	    "Denis",
	    "Dennis",
	    "Deon",
	    "Deondre",
	    "Deontae",
	    "Deonte",
	    "Dereck",
	    "Derek",
	    "Derick",
	    "Deron",
	    "Derrick",
	    "Deshaun",
	    "Deshawn",
	    "Desiree",
	    "Desmond",
	    "Dessie",
	    "Destany",
	    "Destin",
	    "Destinee",
	    "Destiney",
	    "Destini",
	    "Destiny",
	    "Devan",
	    "Devante",
	    "Deven",
	    "Devin",
	    "Devon",
	    "Devonte",
	    "Devyn",
	    "Dewayne",
	    "Dewitt",
	    "Dexter",
	    "Diamond",
	    "Diana",
	    "Dianna",
	    "Diego",
	    "Dillan",
	    "Dillon",
	    "Dimitri",
	    "Dina",
	    "Dino",
	    "Dion",
	    "Dixie",
	    "Dock",
	    "Dolly",
	    "Dolores",
	    "Domenic",
	    "Domenica",
	    "Domenick",
	    "Domenico",
	    "Domingo",
	    "Dominic",
	    "Dominique",
	    "Don",
	    "Donald",
	    "Donato",
	    "Donavon",
	    "Donna",
	    "Donnell",
	    "Donnie",
	    "Donny",
	    "Dora",
	    "Dorcas",
	    "Dorian",
	    "Doris",
	    "Dorothea",
	    "Dorothy",
	    "Dorris",
	    "Dortha",
	    "Dorthy",
	    "Doug",
	    "Douglas",
	    "Dovie",
	    "Doyle",
	    "Drake",
	    "Drew",
	    "Duane",
	    "Dudley",
	    "Dulce",
	    "Duncan",
	    "Durward",
	    "Dustin",
	    "Dusty",
	    "Dwight",
	    "Dylan",
	    "Earl",
	    "Earlene",
	    "Earline",
	    "Earnest",
	    "Earnestine",
	    "Easter",
	    "Easton",
	    "Ebba",
	    "Ebony",
	    "Ed",
	    "Eda",
	    "Edd",
	    "Eddie",
	    "Eden",
	    "Edgar",
	    "Edgardo",
	    "Edison",
	    "Edmond",
	    "Edmund",
	    "Edna",
	    "Eduardo",
	    "Edward",
	    "Edwardo",
	    "Edwin",
	    "Edwina",
	    "Edyth",
	    "Edythe",
	    "Effie",
	    "Efrain",
	    "Efren",
	    "Eileen",
	    "Einar",
	    "Eino",
	    "Eladio",
	    "Elaina",
	    "Elbert",
	    "Elda",
	    "Eldon",
	    "Eldora",
	    "Eldred",
	    "Eldridge",
	    "Eleanora",
	    "Eleanore",
	    "Eleazar",
	    "Electa",
	    "Elena",
	    "Elenor",
	    "Elenora",
	    "Eleonore",
	    "Elfrieda",
	    "Eli",
	    "Elian",
	    "Eliane",
	    "Elias",
	    "Eliezer",
	    "Elijah",
	    "Elinor",
	    "Elinore",
	    "Elisa",
	    "Elisabeth",
	    "Elise",
	    "Eliseo",
	    "Elisha",
	    "Elissa",
	    "Eliza",
	    "Elizabeth",
	    "Ella",
	    "Ellen",
	    "Ellie",
	    "Elliot",
	    "Elliott",
	    "Ellis",
	    "Ellsworth",
	    "Elmer",
	    "Elmira",
	    "Elmo",
	    "Elmore",
	    "Elna",
	    "Elnora",
	    "Elody",
	    "Eloisa",
	    "Eloise",
	    "Elouise",
	    "Eloy",
	    "Elroy",
	    "Elsa",
	    "Else",
	    "Elsie",
	    "Elta",
	    "Elton",
	    "Elva",
	    "Elvera",
	    "Elvie",
	    "Elvis",
	    "Elwin",
	    "Elwyn",
	    "Elyse",
	    "Elyssa",
	    "Elza",
	    "Emanuel",
	    "Emelia",
	    "Emelie",
	    "Emely",
	    "Emerald",
	    "Emerson",
	    "Emery",
	    "Emie",
	    "Emil",
	    "Emile",
	    "Emilia",
	    "Emiliano",
	    "Emilie",
	    "Emilio",
	    "Emily",
	    "Emma",
	    "Emmalee",
	    "Emmanuel",
	    "Emmanuelle",
	    "Emmet",
	    "Emmett",
	    "Emmie",
	    "Emmitt",
	    "Emmy",
	    "Emory",
	    "Ena",
	    "Enid",
	    "Enoch",
	    "Enola",
	    "Enos",
	    "Enrico",
	    "Enrique",
	    "Ephraim",
	    "Era",
	    "Eriberto",
	    "Eric",
	    "Erica",
	    "Erich",
	    "Erick",
	    "Ericka",
	    "Erik",
	    "Erika",
	    "Erin",
	    "Erling",
	    "Erna",
	    "Ernest",
	    "Ernestina",
	    "Ernestine",
	    "Ernesto",
	    "Ernie",
	    "Ervin",
	    "Erwin",
	    "Eryn",
	    "Esmeralda",
	    "Esperanza",
	    "Esta",
	    "Esteban",
	    "Estefania",
	    "Estel",
	    "Estell",
	    "Estella",
	    "Estelle",
	    "Estevan",
	    "Esther",
	    "Estrella",
	    "Etha",
	    "Ethan",
	    "Ethel",
	    "Ethelyn",
	    "Ethyl",
	    "Ettie",
	    "Eudora",
	    "Eugene",
	    "Eugenia",
	    "Eula",
	    "Eulah",
	    "Eulalia",
	    "Euna",
	    "Eunice",
	    "Eusebio",
	    "Eva",
	    "Evalyn",
	    "Evan",
	    "Evangeline",
	    "Evans",
	    "Eve",
	    "Eveline",
	    "Evelyn",
	    "Everardo",
	    "Everett",
	    "Everette",
	    "Evert",
	    "Evie",
	    "Ewald",
	    "Ewell",
	    "Ezekiel",
	    "Ezequiel",
	    "Ezra",
	    "Fabian",
	    "Fabiola",
	    "Fae",
	    "Fannie",
	    "Fanny",
	    "Fatima",
	    "Faustino",
	    "Fausto",
	    "Favian",
	    "Fay",
	    "Faye",
	    "Federico",
	    "Felicia",
	    "Felicita",
	    "Felicity",
	    "Felipa",
	    "Felipe",
	    "Felix",
	    "Felton",
	    "Fermin",
	    "Fern",
	    "Fernando",
	    "Ferne",
	    "Fidel",
	    "Filiberto",
	    "Filomena",
	    "Finn",
	    "Fiona",
	    "Flavie",
	    "Flavio",
	    "Fleta",
	    "Fletcher",
	    "Flo",
	    "Florence",
	    "Florencio",
	    "Florian",
	    "Florida",
	    "Florine",
	    "Flossie",
	    "Floy",
	    "Floyd",
	    "Ford",
	    "Forest",
	    "Forrest",
	    "Foster",
	    "Frances",
	    "Francesca",
	    "Francesco",
	    "Francis",
	    "Francisca",
	    "Francisco",
	    "Franco",
	    "Frank",
	    "Frankie",
	    "Franz",
	    "Fred",
	    "Freda",
	    "Freddie",
	    "Freddy",
	    "Frederic",
	    "Frederick",
	    "Frederik",
	    "Frederique",
	    "Fredrick",
	    "Fredy",
	    "Freeda",
	    "Freeman",
	    "Freida",
	    "Frida",
	    "Frieda",
	    "Friedrich",
	    "Fritz",
	    "Furman",
	    "Gabe",
	    "Gabriel",
	    "Gabriella",
	    "Gabrielle",
	    "Gaetano",
	    "Gage",
	    "Gail",
	    "Gardner",
	    "Garett",
	    "Garfield",
	    "Garland",
	    "Garnet",
	    "Garnett",
	    "Garret",
	    "Garrett",
	    "Garrick",
	    "Garrison",
	    "Garry",
	    "Garth",
	    "Gaston",
	    "Gavin",
	    "Gay",
	    "Gayle",
	    "Gaylord",
	    "Gene",
	    "General",
	    "Genesis",
	    "Genevieve",
	    "Gennaro",
	    "Genoveva",
	    "Geo",
	    "Geoffrey",
	    "George",
	    "Georgette",
	    "Georgiana",
	    "Georgianna",
	    "Geovanni",
	    "Geovanny",
	    "Geovany",
	    "Gerald",
	    "Geraldine",
	    "Gerard",
	    "Gerardo",
	    "Gerda",
	    "Gerhard",
	    "Germaine",
	    "German",
	    "Gerry",
	    "Gerson",
	    "Gertrude",
	    "Gia",
	    "Gianni",
	    "Gideon",
	    "Gilbert",
	    "Gilberto",
	    "Gilda",
	    "Giles",
	    "Gillian",
	    "Gina",
	    "Gino",
	    "Giovani",
	    "Giovanna",
	    "Giovanni",
	    "Giovanny",
	    "Gisselle",
	    "Giuseppe",
	    "Gladyce",
	    "Gladys",
	    "Glen",
	    "Glenda",
	    "Glenna",
	    "Glennie",
	    "Gloria",
	    "Godfrey",
	    "Golda",
	    "Golden",
	    "Gonzalo",
	    "Gordon",
	    "Grace",
	    "Gracie",
	    "Graciela",
	    "Grady",
	    "Graham",
	    "Grant",
	    "Granville",
	    "Grayce",
	    "Grayson",
	    "Green",
	    "Greg",
	    "Gregg",
	    "Gregoria",
	    "Gregorio",
	    "Gregory",
	    "Greta",
	    "Gretchen",
	    "Greyson",
	    "Griffin",
	    "Grover",
	    "Guadalupe",
	    "Gudrun",
	    "Guido",
	    "Guillermo",
	    "Guiseppe",
	    "Gunnar",
	    "Gunner",
	    "Gus",
	    "Gussie",
	    "Gust",
	    "Gustave",
	    "Guy",
	    "Gwen",
	    "Gwendolyn",
	    "Hadley",
	    "Hailee",
	    "Hailey",
	    "Hailie",
	    "Hal",
	    "Haleigh",
	    "Haley",
	    "Halie",
	    "Halle",
	    "Hallie",
	    "Hank",
	    "Hanna",
	    "Hannah",
	    "Hans",
	    "Hardy",
	    "Harley",
	    "Harmon",
	    "Harmony",
	    "Harold",
	    "Harrison",
	    "Harry",
	    "Harvey",
	    "Haskell",
	    "Hassan",
	    "Hassie",
	    "Hattie",
	    "Haven",
	    "Hayden",
	    "Haylee",
	    "Hayley",
	    "Haylie",
	    "Hazel",
	    "Hazle",
	    "Heath",
	    "Heather",
	    "Heaven",
	    "Heber",
	    "Hector",
	    "Heidi",
	    "Helen",
	    "Helena",
	    "Helene",
	    "Helga",
	    "Hellen",
	    "Helmer",
	    "Heloise",
	    "Henderson",
	    "Henri",
	    "Henriette",
	    "Henry",
	    "Herbert",
	    "Herman",
	    "Hermann",
	    "Hermina",
	    "Herminia",
	    "Herminio",
	    "Hershel",
	    "Herta",
	    "Hertha",
	    "Hester",
	    "Hettie",
	    "Hilario",
	    "Hilbert",
	    "Hilda",
	    "Hildegard",
	    "Hillard",
	    "Hillary",
	    "Hilma",
	    "Hilton",
	    "Hipolito",
	    "Hiram",
	    "Hobart",
	    "Holden",
	    "Hollie",
	    "Hollis",
	    "Holly",
	    "Hope",
	    "Horace",
	    "Horacio",
	    "Hortense",
	    "Hosea",
	    "Houston",
	    "Howard",
	    "Howell",
	    "Hoyt",
	    "Hubert",
	    "Hudson",
	    "Hugh",
	    "Hulda",
	    "Humberto",
	    "Hunter",
	    "Hyman",
	    "Ian",
	    "Ibrahim",
	    "Icie",
	    "Ida",
	    "Idell",
	    "Idella",
	    "Ignacio",
	    "Ignatius",
	    "Ike",
	    "Ila",
	    "Ilene",
	    "Iliana",
	    "Ima",
	    "Imani",
	    "Imelda",
	    "Immanuel",
	    "Imogene",
	    "Ines",
	    "Irma",
	    "Irving",
	    "Irwin",
	    "Isaac",
	    "Isabel",
	    "Isabell",
	    "Isabella",
	    "Isabelle",
	    "Isac",
	    "Isadore",
	    "Isai",
	    "Isaiah",
	    "Isaias",
	    "Isidro",
	    "Ismael",
	    "Isobel",
	    "Isom",
	    "Israel",
	    "Issac",
	    "Itzel",
	    "Iva",
	    "Ivah",
	    "Ivory",
	    "Ivy",
	    "Izabella",
	    "Izaiah",
	    "Jabari",
	    "Jace",
	    "Jacey",
	    "Jacinthe",
	    "Jacinto",
	    "Jack",
	    "Jackeline",
	    "Jackie",
	    "Jacklyn",
	    "Jackson",
	    "Jacky",
	    "Jaclyn",
	    "Jacquelyn",
	    "Jacques",
	    "Jacynthe",
	    "Jada",
	    "Jade",
	    "Jaden",
	    "Jadon",
	    "Jadyn",
	    "Jaeden",
	    "Jaida",
	    "Jaiden",
	    "Jailyn",
	    "Jaime",
	    "Jairo",
	    "Jakayla",
	    "Jake",
	    "Jakob",
	    "Jaleel",
	    "Jalen",
	    "Jalon",
	    "Jalyn",
	    "Jamaal",
	    "Jamal",
	    "Jamar",
	    "Jamarcus",
	    "Jamel",
	    "Jameson",
	    "Jamey",
	    "Jamie",
	    "Jamil",
	    "Jamir",
	    "Jamison",
	    "Jammie",
	    "Jan",
	    "Jana",
	    "Janae",
	    "Jane",
	    "Janelle",
	    "Janessa",
	    "Janet",
	    "Janice",
	    "Janick",
	    "Janie",
	    "Janis",
	    "Janiya",
	    "Jannie",
	    "Jany",
	    "Jaquan",
	    "Jaquelin",
	    "Jaqueline",
	    "Jared",
	    "Jaren",
	    "Jarod",
	    "Jaron",
	    "Jarred",
	    "Jarrell",
	    "Jarret",
	    "Jarrett",
	    "Jarrod",
	    "Jarvis",
	    "Jasen",
	    "Jasmin",
	    "Jason",
	    "Jasper",
	    "Jaunita",
	    "Javier",
	    "Javon",
	    "Javonte",
	    "Jay",
	    "Jayce",
	    "Jaycee",
	    "Jayda",
	    "Jayde",
	    "Jayden",
	    "Jaydon",
	    "Jaylan",
	    "Jaylen",
	    "Jaylin",
	    "Jaylon",
	    "Jayme",
	    "Jayne",
	    "Jayson",
	    "Jazlyn",
	    "Jazmin",
	    "Jazmyn",
	    "Jazmyne",
	    "Jean",
	    "Jeanette",
	    "Jeanie",
	    "Jeanne",
	    "Jed",
	    "Jedediah",
	    "Jedidiah",
	    "Jeff",
	    "Jefferey",
	    "Jeffery",
	    "Jeffrey",
	    "Jeffry",
	    "Jena",
	    "Jenifer",
	    "Jennie",
	    "Jennifer",
	    "Jennings",
	    "Jennyfer",
	    "Jensen",
	    "Jerad",
	    "Jerald",
	    "Jeramie",
	    "Jeramy",
	    "Jerel",
	    "Jeremie",
	    "Jeremy",
	    "Jermain",
	    "Jermaine",
	    "Jermey",
	    "Jerod",
	    "Jerome",
	    "Jeromy",
	    "Jerrell",
	    "Jerrod",
	    "Jerrold",
	    "Jerry",
	    "Jess",
	    "Jesse",
	    "Jessica",
	    "Jessie",
	    "Jessika",
	    "Jessy",
	    "Jessyca",
	    "Jesus",
	    "Jett",
	    "Jettie",
	    "Jevon",
	    "Jewel",
	    "Jewell",
	    "Jillian",
	    "Jimmie",
	    "Jimmy",
	    "Jo",
	    "Joan",
	    "Joana",
	    "Joanie",
	    "Joanne",
	    "Joannie",
	    "Joanny",
	    "Joany",
	    "Joaquin",
	    "Jocelyn",
	    "Jodie",
	    "Jody",
	    "Joe",
	    "Joel",
	    "Joelle",
	    "Joesph",
	    "Joey",
	    "Johan",
	    "Johann",
	    "Johanna",
	    "Johathan",
	    "John",
	    "Johnathan",
	    "Johnathon",
	    "Johnnie",
	    "Johnny",
	    "Johnpaul",
	    "Johnson",
	    "Jolie",
	    "Jon",
	    "Jonas",
	    "Jonatan",
	    "Jonathan",
	    "Jonathon",
	    "Jordan",
	    "Jordane",
	    "Jordi",
	    "Jordon",
	    "Jordy",
	    "Jordyn",
	    "Jorge",
	    "Jose",
	    "Josefa",
	    "Josefina",
	    "Joseph",
	    "Josephine",
	    "Josh",
	    "Joshua",
	    "Joshuah",
	    "Josiah",
	    "Josiane",
	    "Josianne",
	    "Josie",
	    "Josue",
	    "Jovan",
	    "Jovani",
	    "Jovanny",
	    "Jovany",
	    "Joy",
	    "Joyce",
	    "Juana",
	    "Juanita",
	    "Judah",
	    "Judd",
	    "Jude",
	    "Judge",
	    "Judson",
	    "Judy",
	    "Jules",
	    "Julia",
	    "Julian",
	    "Juliana",
	    "Julianne",
	    "Julie",
	    "Julien",
	    "Juliet",
	    "Julio",
	    "Julius",
	    "June",
	    "Junior",
	    "Junius",
	    "Justen",
	    "Justice",
	    "Justina",
	    "Justine",
	    "Juston",
	    "Justus",
	    "Justyn",
	    "Juvenal",
	    "Juwan",
	    "Kacey",
	    "Kaci",
	    "Kacie",
	    "Kade",
	    "Kaden",
	    "Kadin",
	    "Kaela",
	    "Kaelyn",
	    "Kaia",
	    "Kailee",
	    "Kailey",
	    "Kailyn",
	    "Kaitlin",
	    "Kaitlyn",
	    "Kale",
	    "Kaleb",
	    "Kaleigh",
	    "Kaley",
	    "Kali",
	    "Kallie",
	    "Kameron",
	    "Kamille",
	    "Kamren",
	    "Kamron",
	    "Kamryn",
	    "Kane",
	    "Kara",
	    "Kareem",
	    "Karelle",
	    "Karen",
	    "Kari",
	    "Kariane",
	    "Karianne",
	    "Karina",
	    "Karine",
	    "Karl",
	    "Karlee",
	    "Karley",
	    "Karli",
	    "Karlie",
	    "Karolann",
	    "Karson",
	    "Kasandra",
	    "Kasey",
	    "Kassandra",
	    "Katarina",
	    "Katelin",
	    "Katelyn",
	    "Katelynn",
	    "Katharina",
	    "Katherine",
	    "Katheryn",
	    "Kathleen",
	    "Kathlyn",
	    "Kathryn",
	    "Kathryne",
	    "Katlyn",
	    "Katlynn",
	    "Katrina",
	    "Katrine",
	    "Kattie",
	    "Kavon",
	    "Kay",
	    "Kaya",
	    "Kaycee",
	    "Kayden",
	    "Kayla",
	    "Kaylah",
	    "Kaylee",
	    "Kayleigh",
	    "Kayley",
	    "Kayli",
	    "Kaylie",
	    "Kaylin",
	    "Keagan",
	    "Keanu",
	    "Keara",
	    "Keaton",
	    "Keegan",
	    "Keeley",
	    "Keely",
	    "Keenan",
	    "Keira",
	    "Keith",
	    "Kellen",
	    "Kelley",
	    "Kelli",
	    "Kellie",
	    "Kelly",
	    "Kelsi",
	    "Kelsie",
	    "Kelton",
	    "Kelvin",
	    "Ken",
	    "Kendall",
	    "Kendra",
	    "Kendrick",
	    "Kenna",
	    "Kennedi",
	    "Kennedy",
	    "Kenneth",
	    "Kennith",
	    "Kenny",
	    "Kenton",
	    "Kenya",
	    "Kenyatta",
	    "Kenyon",
	    "Keon",
	    "Keshaun",
	    "Keshawn",
	    "Keven",
	    "Kevin",
	    "Kevon",
	    "Keyon",
	    "Keyshawn",
	    "Khalid",
	    "Khalil",
	    "Kian",
	    "Kiana",
	    "Kianna",
	    "Kiara",
	    "Kiarra",
	    "Kiel",
	    "Kiera",
	    "Kieran",
	    "Kiley",
	    "Kim",
	    "Kimberly",
	    "King",
	    "Kip",
	    "Kira",
	    "Kirk",
	    "Kirsten",
	    "Kirstin",
	    "Kitty",
	    "Kobe",
	    "Koby",
	    "Kody",
	    "Kolby",
	    "Kole",
	    "Korbin",
	    "Korey",
	    "Kory",
	    "Kraig",
	    "Kris",
	    "Krista",
	    "Kristian",
	    "Kristin",
	    "Kristina",
	    "Kristofer",
	    "Kristoffer",
	    "Kristopher",
	    "Kristy",
	    "Krystal",
	    "Krystel",
	    "Krystina",
	    "Kurt",
	    "Kurtis",
	    "Kyla",
	    "Kyle",
	    "Kylee",
	    "Kyleigh",
	    "Kyler",
	    "Kylie",
	    "Kyra",
	    "Lacey",
	    "Lacy",
	    "Ladarius",
	    "Lafayette",
	    "Laila",
	    "Laisha",
	    "Lamar",
	    "Lambert",
	    "Lamont",
	    "Lance",
	    "Landen",
	    "Lane",
	    "Laney",
	    "Larissa",
	    "Laron",
	    "Larry",
	    "Larue",
	    "Laura",
	    "Laurel",
	    "Lauren",
	    "Laurence",
	    "Lauretta",
	    "Lauriane",
	    "Laurianne",
	    "Laurie",
	    "Laurine",
	    "Laury",
	    "Lauryn",
	    "Lavada",
	    "Lavern",
	    "Laverna",
	    "Laverne",
	    "Lavina",
	    "Lavinia",
	    "Lavon",
	    "Lavonne",
	    "Lawrence",
	    "Lawson",
	    "Layla",
	    "Layne",
	    "Lazaro",
	    "Lea",
	    "Leann",
	    "Leanna",
	    "Leanne",
	    "Leatha",
	    "Leda",
	    "Lee",
	    "Leif",
	    "Leila",
	    "Leilani",
	    "Lela",
	    "Lelah",
	    "Leland",
	    "Lelia",
	    "Lempi",
	    "Lemuel",
	    "Lenna",
	    "Lennie",
	    "Lenny",
	    "Lenora",
	    "Lenore",
	    "Leo",
	    "Leola",
	    "Leon",
	    "Leonard",
	    "Leonardo",
	    "Leone",
	    "Leonel",
	    "Leonie",
	    "Leonor",
	    "Leonora",
	    "Leopold",
	    "Leopoldo",
	    "Leora",
	    "Lera",
	    "Lesley",
	    "Leslie",
	    "Lesly",
	    "Lessie",
	    "Lester",
	    "Leta",
	    "Letha",
	    "Letitia",
	    "Levi",
	    "Lew",
	    "Lewis",
	    "Lexi",
	    "Lexie",
	    "Lexus",
	    "Lia",
	    "Liam",
	    "Liana",
	    "Libbie",
	    "Libby",
	    "Lila",
	    "Lilian",
	    "Liliana",
	    "Liliane",
	    "Lilla",
	    "Lillian",
	    "Lilliana",
	    "Lillie",
	    "Lilly",
	    "Lily",
	    "Lilyan",
	    "Lina",
	    "Lincoln",
	    "Linda",
	    "Lindsay",
	    "Lindsey",
	    "Linnea",
	    "Linnie",
	    "Linwood",
	    "Lionel",
	    "Lisa",
	    "Lisandro",
	    "Lisette",
	    "Litzy",
	    "Liza",
	    "Lizeth",
	    "Lizzie",
	    "Llewellyn",
	    "Lloyd",
	    "Logan",
	    "Lois",
	    "Lola",
	    "Lolita",
	    "Loma",
	    "Lon",
	    "London",
	    "Lonie",
	    "Lonnie",
	    "Lonny",
	    "Lonzo",
	    "Lora",
	    "Loraine",
	    "Loren",
	    "Lorena",
	    "Lorenz",
	    "Lorenza",
	    "Lorenzo",
	    "Lori",
	    "Lorine",
	    "Lorna",
	    "Lottie",
	    "Lou",
	    "Louie",
	    "Louisa",
	    "Lourdes",
	    "Louvenia",
	    "Lowell",
	    "Loy",
	    "Loyal",
	    "Loyce",
	    "Lucas",
	    "Luciano",
	    "Lucie",
	    "Lucienne",
	    "Lucile",
	    "Lucinda",
	    "Lucio",
	    "Lucious",
	    "Lucius",
	    "Lucy",
	    "Ludie",
	    "Ludwig",
	    "Lue",
	    "Luella",
	    "Luigi",
	    "Luis",
	    "Luisa",
	    "Lukas",
	    "Lula",
	    "Lulu",
	    "Luna",
	    "Lupe",
	    "Lura",
	    "Lurline",
	    "Luther",
	    "Luz",
	    "Lyda",
	    "Lydia",
	    "Lyla",
	    "Lynn",
	    "Lyric",
	    "Lysanne",
	    "Mabel",
	    "Mabelle",
	    "Mable",
	    "Mac",
	    "Macey",
	    "Maci",
	    "Macie",
	    "Mack",
	    "Mackenzie",
	    "Macy",
	    "Madaline",
	    "Madalyn",
	    "Maddison",
	    "Madeline",
	    "Madelyn",
	    "Madelynn",
	    "Madge",
	    "Madie",
	    "Madilyn",
	    "Madisen",
	    "Madison",
	    "Madisyn",
	    "Madonna",
	    "Madyson",
	    "Mae",
	    "Maegan",
	    "Maeve",
	    "Mafalda",
	    "Magali",
	    "Magdalen",
	    "Magdalena",
	    "Maggie",
	    "Magnolia",
	    "Magnus",
	    "Maia",
	    "Maida",
	    "Maiya",
	    "Major",
	    "Makayla",
	    "Makenna",
	    "Makenzie",
	    "Malachi",
	    "Malcolm",
	    "Malika",
	    "Malinda",
	    "Mallie",
	    "Mallory",
	    "Malvina",
	    "Mandy",
	    "Manley",
	    "Manuel",
	    "Manuela",
	    "Mara",
	    "Marc",
	    "Marcel",
	    "Marcelina",
	    "Marcelino",
	    "Marcella",
	    "Marcelle",
	    "Marcellus",
	    "Marcelo",
	    "Marcia",
	    "Marco",
	    "Marcos",
	    "Marcus",
	    "Margaret",
	    "Margarete",
	    "Margarett",
	    "Margaretta",
	    "Margarette",
	    "Margarita",
	    "Marge",
	    "Margie",
	    "Margot",
	    "Margret",
	    "Marguerite",
	    "Maria",
	    "Mariah",
	    "Mariam",
	    "Marian",
	    "Mariana",
	    "Mariane",
	    "Marianna",
	    "Marianne",
	    "Mariano",
	    "Maribel",
	    "Marie",
	    "Mariela",
	    "Marielle",
	    "Marietta",
	    "Marilie",
	    "Marilou",
	    "Marilyne",
	    "Marina",
	    "Mario",
	    "Marion",
	    "Marisa",
	    "Marisol",
	    "Maritza",
	    "Marjolaine",
	    "Marjorie",
	    "Marjory",
	    "Mark",
	    "Markus",
	    "Marlee",
	    "Marlen",
	    "Marlene",
	    "Marley",
	    "Marlin",
	    "Marlon",
	    "Marques",
	    "Marquis",
	    "Marquise",
	    "Marshall",
	    "Marta",
	    "Martin",
	    "Martina",
	    "Martine",
	    "Marty",
	    "Marvin",
	    "Mary",
	    "Maryam",
	    "Maryjane",
	    "Maryse",
	    "Mason",
	    "Mateo",
	    "Mathew",
	    "Mathias",
	    "Mathilde",
	    "Matilda",
	    "Matilde",
	    "Matt",
	    "Matteo",
	    "Mattie",
	    "Maud",
	    "Maude",
	    "Maudie",
	    "Maureen",
	    "Maurice",
	    "Mauricio",
	    "Maurine",
	    "Maverick",
	    "Mavis",
	    "Max",
	    "Maxie",
	    "Maxime",
	    "Maximilian",
	    "Maximillia",
	    "Maximillian",
	    "Maximo",
	    "Maximus",
	    "Maxine",
	    "Maxwell",
	    "May",
	    "Maya",
	    "Maybell",
	    "Maybelle",
	    "Maye",
	    "Maymie",
	    "Maynard",
	    "Mayra",
	    "Mazie",
	    "Mckayla",
	    "Mckenna",
	    "Mckenzie",
	    "Meagan",
	    "Meaghan",
	    "Meda",
	    "Megane",
	    "Meggie",
	    "Meghan",
	    "Mekhi",
	    "Melany",
	    "Melba",
	    "Melisa",
	    "Melissa",
	    "Mellie",
	    "Melody",
	    "Melvin",
	    "Melvina",
	    "Melyna",
	    "Melyssa",
	    "Mercedes",
	    "Meredith",
	    "Merl",
	    "Merle",
	    "Merlin",
	    "Merritt",
	    "Mertie",
	    "Mervin",
	    "Meta",
	    "Mia",
	    "Micaela",
	    "Micah",
	    "Michael",
	    "Michaela",
	    "Michale",
	    "Micheal",
	    "Michel",
	    "Michele",
	    "Michelle",
	    "Miguel",
	    "Mikayla",
	    "Mike",
	    "Mikel",
	    "Milan",
	    "Miles",
	    "Milford",
	    "Miller",
	    "Millie",
	    "Milo",
	    "Milton",
	    "Mina",
	    "Minerva",
	    "Minnie",
	    "Miracle",
	    "Mireille",
	    "Mireya",
	    "Misael",
	    "Missouri",
	    "Misty",
	    "Mitchel",
	    "Mitchell",
	    "Mittie",
	    "Modesta",
	    "Modesto",
	    "Mohamed",
	    "Mohammad",
	    "Mohammed",
	    "Moises",
	    "Mollie",
	    "Molly",
	    "Mona",
	    "Monica",
	    "Monique",
	    "Monroe",
	    "Monserrat",
	    "Monserrate",
	    "Montana",
	    "Monte",
	    "Monty",
	    "Morgan",
	    "Moriah",
	    "Morris",
	    "Mortimer",
	    "Morton",
	    "Mose",
	    "Moses",
	    "Moshe",
	    "Mossie",
	    "Mozell",
	    "Mozelle",
	    "Muhammad",
	    "Muriel",
	    "Murl",
	    "Murphy",
	    "Murray",
	    "Mustafa",
	    "Mya",
	    "Myah",
	    "Mylene",
	    "Myles",
	    "Myra",
	    "Myriam",
	    "Myrl",
	    "Myrna",
	    "Myron",
	    "Myrtice",
	    "Myrtie",
	    "Myrtis",
	    "Myrtle",
	    "Nadia",
	    "Nakia",
	    "Name",
	    "Nannie",
	    "Naomi",
	    "Naomie",
	    "Napoleon",
	    "Narciso",
	    "Nash",
	    "Nasir",
	    "Nat",
	    "Natalia",
	    "Natalie",
	    "Natasha",
	    "Nathan",
	    "Nathanael",
	    "Nathanial",
	    "Nathaniel",
	    "Nathen",
	    "Nayeli",
	    "Neal",
	    "Ned",
	    "Nedra",
	    "Neha",
	    "Neil",
	    "Nelda",
	    "Nella",
	    "Nelle",
	    "Nellie",
	    "Nels",
	    "Nelson",
	    "Neoma",
	    "Nestor",
	    "Nettie",
	    "Neva",
	    "Newell",
	    "Newton",
	    "Nia",
	    "Nicholas",
	    "Nicholaus",
	    "Nichole",
	    "Nick",
	    "Nicklaus",
	    "Nickolas",
	    "Nico",
	    "Nicola",
	    "Nicolas",
	    "Nicole",
	    "Nicolette",
	    "Nigel",
	    "Nikita",
	    "Nikki",
	    "Nikko",
	    "Niko",
	    "Nikolas",
	    "Nils",
	    "Nina",
	    "Noah",
	    "Noble",
	    "Noe",
	    "Noel",
	    "Noelia",
	    "Noemi",
	    "Noemie",
	    "Noemy",
	    "Nola",
	    "Nolan",
	    "Nona",
	    "Nora",
	    "Norbert",
	    "Norberto",
	    "Norene",
	    "Norma",
	    "Norris",
	    "Norval",
	    "Norwood",
	    "Nova",
	    "Novella",
	    "Nya",
	    "Nyah",
	    "Nyasia",
	    "Obie",
	    "Oceane",
	    "Ocie",
	    "Octavia",
	    "Oda",
	    "Odell",
	    "Odessa",
	    "Odie",
	    "Ofelia",
	    "Okey",
	    "Ola",
	    "Olaf",
	    "Ole",
	    "Olen",
	    "Oleta",
	    "Olga",
	    "Olin",
	    "Oliver",
	    "Ollie",
	    "Oma",
	    "Omari",
	    "Omer",
	    "Ona",
	    "Onie",
	    "Opal",
	    "Ophelia",
	    "Ora",
	    "Oral",
	    "Oran",
	    "Oren",
	    "Orie",
	    "Orin",
	    "Orion",
	    "Orland",
	    "Orlando",
	    "Orlo",
	    "Orpha",
	    "Orrin",
	    "Orval",
	    "Orville",
	    "Osbaldo",
	    "Osborne",
	    "Oscar",
	    "Osvaldo",
	    "Oswald",
	    "Oswaldo",
	    "Otha",
	    "Otho",
	    "Otilia",
	    "Otis",
	    "Ottilie",
	    "Ottis",
	    "Otto",
	    "Ova",
	    "Owen",
	    "Ozella",
	    "Pablo",
	    "Paige",
	    "Palma",
	    "Pamela",
	    "Pansy",
	    "Paolo",
	    "Paris",
	    "Parker",
	    "Pascale",
	    "Pasquale",
	    "Pat",
	    "Patience",
	    "Patricia",
	    "Patrick",
	    "Patsy",
	    "Pattie",
	    "Paul",
	    "Paula",
	    "Pauline",
	    "Paxton",
	    "Payton",
	    "Pearl",
	    "Pearlie",
	    "Pearline",
	    "Pedro",
	    "Peggie",
	    "Penelope",
	    "Percival",
	    "Percy",
	    "Perry",
	    "Pete",
	    "Peter",
	    "Petra",
	    "Peyton",
	    "Philip",
	    "Phoebe",
	    "Phyllis",
	    "Pierce",
	    "Pierre",
	    "Pietro",
	    "Pink",
	    "Pinkie",
	    "Piper",
	    "Polly",
	    "Porter",
	    "Precious",
	    "Presley",
	    "Preston",
	    "Price",
	    "Prince",
	    "Princess",
	    "Priscilla",
	    "Providenci",
	    "Prudence",
	    "Queen",
	    "Queenie",
	    "Quentin",
	    "Quincy",
	    "Quinn",
	    "Quinten",
	    "Quinton",
	    "Rachael",
	    "Rachel",
	    "Rachelle",
	    "Rae",
	    "Raegan",
	    "Rafael",
	    "Rafaela",
	    "Raheem",
	    "Rahsaan",
	    "Rahul",
	    "Raina",
	    "Raleigh",
	    "Ralph",
	    "Ramiro",
	    "Ramon",
	    "Ramona",
	    "Randal",
	    "Randall",
	    "Randi",
	    "Randy",
	    "Ransom",
	    "Raoul",
	    "Raphael",
	    "Raphaelle",
	    "Raquel",
	    "Rashad",
	    "Rashawn",
	    "Rasheed",
	    "Raul",
	    "Raven",
	    "Ray",
	    "Raymond",
	    "Raymundo",
	    "Reagan",
	    "Reanna",
	    "Reba",
	    "Rebeca",
	    "Rebecca",
	    "Rebeka",
	    "Rebekah",
	    "Reece",
	    "Reed",
	    "Reese",
	    "Regan",
	    "Reggie",
	    "Reginald",
	    "Reid",
	    "Reilly",
	    "Reina",
	    "Reinhold",
	    "Remington",
	    "Rene",
	    "Renee",
	    "Ressie",
	    "Reta",
	    "Retha",
	    "Retta",
	    "Reuben",
	    "Reva",
	    "Rex",
	    "Rey",
	    "Reyes",
	    "Reymundo",
	    "Reyna",
	    "Reynold",
	    "Rhea",
	    "Rhett",
	    "Rhianna",
	    "Rhiannon",
	    "Rhoda",
	    "Ricardo",
	    "Richard",
	    "Richie",
	    "Richmond",
	    "Rick",
	    "Rickey",
	    "Rickie",
	    "Ricky",
	    "Rico",
	    "Rigoberto",
	    "Riley",
	    "Rita",
	    "River",
	    "Robb",
	    "Robbie",
	    "Robert",
	    "Roberta",
	    "Roberto",
	    "Robin",
	    "Robyn",
	    "Rocio",
	    "Rocky",
	    "Rod",
	    "Roderick",
	    "Rodger",
	    "Rodolfo",
	    "Rodrick",
	    "Rodrigo",
	    "Roel",
	    "Rogelio",
	    "Roger",
	    "Rogers",
	    "Rolando",
	    "Rollin",
	    "Roma",
	    "Romaine",
	    "Roman",
	    "Ron",
	    "Ronaldo",
	    "Ronny",
	    "Roosevelt",
	    "Rory",
	    "Rosa",
	    "Rosalee",
	    "Rosalia",
	    "Rosalind",
	    "Rosalinda",
	    "Rosalyn",
	    "Rosamond",
	    "Rosanna",
	    "Rosario",
	    "Roscoe",
	    "Rose",
	    "Rosella",
	    "Roselyn",
	    "Rosemarie",
	    "Rosemary",
	    "Rosendo",
	    "Rosetta",
	    "Rosie",
	    "Rosina",
	    "Roslyn",
	    "Ross",
	    "Rossie",
	    "Rowan",
	    "Rowena",
	    "Rowland",
	    "Roxane",
	    "Roxanne",
	    "Roy",
	    "Royal",
	    "Royce",
	    "Rozella",
	    "Ruben",
	    "Rubie",
	    "Ruby",
	    "Rubye",
	    "Rudolph",
	    "Rudy",
	    "Rupert",
	    "Russ",
	    "Russel",
	    "Russell",
	    "Rusty",
	    "Ruth",
	    "Ruthe",
	    "Ruthie",
	    "Ryan",
	    "Ryann",
	    "Ryder",
	    "Rylan",
	    "Rylee",
	    "Ryleigh",
	    "Ryley",
	    "Sabina",
	    "Sabrina",
	    "Sabryna",
	    "Sadie",
	    "Sadye",
	    "Sage",
	    "Saige",
	    "Sallie",
	    "Sally",
	    "Salma",
	    "Salvador",
	    "Salvatore",
	    "Sam",
	    "Samanta",
	    "Samantha",
	    "Samara",
	    "Samir",
	    "Sammie",
	    "Sammy",
	    "Samson",
	    "Sandra",
	    "Sandrine",
	    "Sandy",
	    "Sanford",
	    "Santa",
	    "Santiago",
	    "Santina",
	    "Santino",
	    "Santos",
	    "Sarah",
	    "Sarai",
	    "Sarina",
	    "Sasha",
	    "Saul",
	    "Savanah",
	    "Savanna",
	    "Savannah",
	    "Savion",
	    "Scarlett",
	    "Schuyler",
	    "Scot",
	    "Scottie",
	    "Scotty",
	    "Seamus",
	    "Sean",
	    "Sebastian",
	    "Sedrick",
	    "Selena",
	    "Selina",
	    "Selmer",
	    "Serena",
	    "Serenity",
	    "Seth",
	    "Shad",
	    "Shaina",
	    "Shakira",
	    "Shana",
	    "Shane",
	    "Shanel",
	    "Shanelle",
	    "Shania",
	    "Shanie",
	    "Shaniya",
	    "Shanna",
	    "Shannon",
	    "Shanny",
	    "Shanon",
	    "Shany",
	    "Sharon",
	    "Shaun",
	    "Shawn",
	    "Shawna",
	    "Shaylee",
	    "Shayna",
	    "Shayne",
	    "Shea",
	    "Sheila",
	    "Sheldon",
	    "Shemar",
	    "Sheridan",
	    "Sherman",
	    "Sherwood",
	    "Shirley",
	    "Shyann",
	    "Shyanne",
	    "Sibyl",
	    "Sid",
	    "Sidney",
	    "Sienna",
	    "Sierra",
	    "Sigmund",
	    "Sigrid",
	    "Sigurd",
	    "Silas",
	    "Sim",
	    "Simeon",
	    "Simone",
	    "Sincere",
	    "Sister",
	    "Skye",
	    "Skyla",
	    "Skylar",
	    "Sofia",
	    "Soledad",
	    "Solon",
	    "Sonia",
	    "Sonny",
	    "Sonya",
	    "Sophia",
	    "Sophie",
	    "Spencer",
	    "Stacey",
	    "Stacy",
	    "Stan",
	    "Stanford",
	    "Stanley",
	    "Stanton",
	    "Stefan",
	    "Stefanie",
	    "Stella",
	    "Stephan",
	    "Stephania",
	    "Stephanie",
	    "Stephany",
	    "Stephen",
	    "Stephon",
	    "Sterling",
	    "Steve",
	    "Stevie",
	    "Stewart",
	    "Stone",
	    "Stuart",
	    "Summer",
	    "Sunny",
	    "Susan",
	    "Susana",
	    "Susanna",
	    "Susie",
	    "Suzanne",
	    "Sven",
	    "Syble",
	    "Sydnee",
	    "Sydney",
	    "Sydni",
	    "Sydnie",
	    "Sylvan",
	    "Sylvester",
	    "Sylvia",
	    "Tabitha",
	    "Tad",
	    "Talia",
	    "Talon",
	    "Tamara",
	    "Tamia",
	    "Tania",
	    "Tanner",
	    "Tanya",
	    "Tara",
	    "Taryn",
	    "Tate",
	    "Tatum",
	    "Tatyana",
	    "Taurean",
	    "Tavares",
	    "Taya",
	    "Taylor",
	    "Teagan",
	    "Ted",
	    "Telly",
	    "Terence",
	    "Teresa",
	    "Terrance",
	    "Terrell",
	    "Terrence",
	    "Terrill",
	    "Terry",
	    "Tess",
	    "Tessie",
	    "Tevin",
	    "Thad",
	    "Thaddeus",
	    "Thalia",
	    "Thea",
	    "Thelma",
	    "Theo",
	    "Theodora",
	    "Theodore",
	    "Theresa",
	    "Therese",
	    "Theresia",
	    "Theron",
	    "Thomas",
	    "Thora",
	    "Thurman",
	    "Tia",
	    "Tiana",
	    "Tianna",
	    "Tiara",
	    "Tierra",
	    "Tiffany",
	    "Tillman",
	    "Timmothy",
	    "Timmy",
	    "Timothy",
	    "Tina",
	    "Tito",
	    "Titus",
	    "Tobin",
	    "Toby",
	    "Tod",
	    "Tom",
	    "Tomas",
	    "Tomasa",
	    "Tommie",
	    "Toney",
	    "Toni",
	    "Tony",
	    "Torey",
	    "Torrance",
	    "Torrey",
	    "Toy",
	    "Trace",
	    "Tracey",
	    "Tracy",
	    "Travis",
	    "Travon",
	    "Tre",
	    "Tremaine",
	    "Tremayne",
	    "Trent",
	    "Trenton",
	    "Tressa",
	    "Tressie",
	    "Treva",
	    "Trever",
	    "Trevion",
	    "Trevor",
	    "Trey",
	    "Trinity",
	    "Trisha",
	    "Tristian",
	    "Tristin",
	    "Triston",
	    "Troy",
	    "Trudie",
	    "Trycia",
	    "Trystan",
	    "Turner",
	    "Twila",
	    "Tyler",
	    "Tyra",
	    "Tyree",
	    "Tyreek",
	    "Tyrel",
	    "Tyrell",
	    "Tyrese",
	    "Tyrique",
	    "Tyshawn",
	    "Tyson",
	    "Ubaldo",
	    "Ulices",
	    "Ulises",
	    "Una",
	    "Unique",
	    "Urban",
	    "Uriah",
	    "Uriel",
	    "Ursula",
	    "Vada",
	    "Valentin",
	    "Valentina",
	    "Valentine",
	    "Valerie",
	    "Vallie",
	    "Van",
	    "Vance",
	    "Vanessa",
	    "Vaughn",
	    "Veda",
	    "Velda",
	    "Vella",
	    "Velma",
	    "Velva",
	    "Vena",
	    "Verda",
	    "Verdie",
	    "Vergie",
	    "Verla",
	    "Verlie",
	    "Vern",
	    "Verna",
	    "Verner",
	    "Vernice",
	    "Vernie",
	    "Vernon",
	    "Verona",
	    "Veronica",
	    "Vesta",
	    "Vicenta",
	    "Vicente",
	    "Vickie",
	    "Vicky",
	    "Victor",
	    "Victoria",
	    "Vida",
	    "Vidal",
	    "Vilma",
	    "Vince",
	    "Vincent",
	    "Vincenza",
	    "Vincenzo",
	    "Vinnie",
	    "Viola",
	    "Violet",
	    "Violette",
	    "Virgie",
	    "Virgil",
	    "Virginia",
	    "Virginie",
	    "Vita",
	    "Vito",
	    "Viva",
	    "Vivian",
	    "Viviane",
	    "Vivianne",
	    "Vivien",
	    "Vivienne",
	    "Vladimir",
	    "Wade",
	    "Waino",
	    "Waldo",
	    "Walker",
	    "Wallace",
	    "Walter",
	    "Walton",
	    "Wanda",
	    "Ward",
	    "Warren",
	    "Watson",
	    "Wava",
	    "Waylon",
	    "Wayne",
	    "Webster",
	    "Weldon",
	    "Wellington",
	    "Wendell",
	    "Wendy",
	    "Werner",
	    "Westley",
	    "Weston",
	    "Whitney",
	    "Wilber",
	    "Wilbert",
	    "Wilburn",
	    "Wiley",
	    "Wilford",
	    "Wilfred",
	    "Wilfredo",
	    "Wilfrid",
	    "Wilhelm",
	    "Wilhelmine",
	    "Will",
	    "Willa",
	    "Willard",
	    "William",
	    "Willie",
	    "Willis",
	    "Willow",
	    "Willy",
	    "Wilma",
	    "Wilmer",
	    "Wilson",
	    "Wilton",
	    "Winfield",
	    "Winifred",
	    "Winnifred",
	    "Winona",
	    "Winston",
	    "Woodrow",
	    "Wyatt",
	    "Wyman",
	    "Xander",
	    "Xavier",
	    "Xzavier",
	    "Yadira",
	    "Yasmeen",
	    "Yasmin",
	    "Yasmine",
	    "Yazmin",
	    "Yesenia",
	    "Yessenia",
	    "Yolanda",
	    "Yoshiko",
	    "Yvette",
	    "Yvonne",
	    "Zachariah",
	    "Zachary",
	    "Zachery",
	    "Zack",
	    "Zackary",
	    "Zackery",
	    "Zakary",
	    "Zander",
	    "Zane",
	    "Zaria",
	    "Zechariah",
	    "Zelda",
	    "Zella",
	    "Zelma",
	    "Zena",
	    "Zetta",
	    "Zion",
	    "Zita",
	    "Zoe",
	    "Zoey",
	    "Zoie",
	    "Zoila",
	    "Zola",
	    "Zora",
	    "Zula"
	  ],
	  "last_name": [
	    "Abbott",
	    "Abernathy",
	    "Abshire",
	    "Adams",
	    "Altenwerth",
	    "Anderson",
	    "Ankunding",
	    "Armstrong",
	    "Auer",
	    "Aufderhar",
	    "Bahringer",
	    "Bailey",
	    "Balistreri",
	    "Barrows",
	    "Bartell",
	    "Bartoletti",
	    "Barton",
	    "Bashirian",
	    "Batz",
	    "Bauch",
	    "Baumbach",
	    "Bayer",
	    "Beahan",
	    "Beatty",
	    "Bechtelar",
	    "Becker",
	    "Bednar",
	    "Beer",
	    "Beier",
	    "Berge",
	    "Bergnaum",
	    "Bergstrom",
	    "Bernhard",
	    "Bernier",
	    "Bins",
	    "Blanda",
	    "Blick",
	    "Block",
	    "Bode",
	    "Boehm",
	    "Bogan",
	    "Bogisich",
	    "Borer",
	    "Bosco",
	    "Botsford",
	    "Boyer",
	    "Boyle",
	    "Bradtke",
	    "Brakus",
	    "Braun",
	    "Breitenberg",
	    "Brekke",
	    "Brown",
	    "Bruen",
	    "Buckridge",
	    "Carroll",
	    "Carter",
	    "Cartwright",
	    "Casper",
	    "Cassin",
	    "Champlin",
	    "Christiansen",
	    "Cole",
	    "Collier",
	    "Collins",
	    "Conn",
	    "Connelly",
	    "Conroy",
	    "Considine",
	    "Corkery",
	    "Cormier",
	    "Corwin",
	    "Cremin",
	    "Crist",
	    "Crona",
	    "Cronin",
	    "Crooks",
	    "Cruickshank",
	    "Cummerata",
	    "Cummings",
	    "Dach",
	    "D'Amore",
	    "Daniel",
	    "Dare",
	    "Daugherty",
	    "Davis",
	    "Deckow",
	    "Denesik",
	    "Dibbert",
	    "Dickens",
	    "Dicki",
	    "Dickinson",
	    "Dietrich",
	    "Donnelly",
	    "Dooley",
	    "Douglas",
	    "Doyle",
	    "DuBuque",
	    "Durgan",
	    "Ebert",
	    "Effertz",
	    "Eichmann",
	    "Emard",
	    "Emmerich",
	    "Erdman",
	    "Ernser",
	    "Fadel",
	    "Fahey",
	    "Farrell",
	    "Fay",
	    "Feeney",
	    "Feest",
	    "Feil",
	    "Ferry",
	    "Fisher",
	    "Flatley",
	    "Frami",
	    "Franecki",
	    "Friesen",
	    "Fritsch",
	    "Funk",
	    "Gaylord",
	    "Gerhold",
	    "Gerlach",
	    "Gibson",
	    "Gislason",
	    "Gleason",
	    "Gleichner",
	    "Glover",
	    "Goldner",
	    "Goodwin",
	    "Gorczany",
	    "Gottlieb",
	    "Goyette",
	    "Grady",
	    "Graham",
	    "Grant",
	    "Green",
	    "Greenfelder",
	    "Greenholt",
	    "Grimes",
	    "Gulgowski",
	    "Gusikowski",
	    "Gutkowski",
	    "Gutmann",
	    "Haag",
	    "Hackett",
	    "Hagenes",
	    "Hahn",
	    "Haley",
	    "Halvorson",
	    "Hamill",
	    "Hammes",
	    "Hand",
	    "Hane",
	    "Hansen",
	    "Harber",
	    "Harris",
	    "Hartmann",
	    "Harvey",
	    "Hauck",
	    "Hayes",
	    "Heaney",
	    "Heathcote",
	    "Hegmann",
	    "Heidenreich",
	    "Heller",
	    "Herman",
	    "Hermann",
	    "Hermiston",
	    "Herzog",
	    "Hessel",
	    "Hettinger",
	    "Hickle",
	    "Hilll",
	    "Hills",
	    "Hilpert",
	    "Hintz",
	    "Hirthe",
	    "Hodkiewicz",
	    "Hoeger",
	    "Homenick",
	    "Hoppe",
	    "Howe",
	    "Howell",
	    "Hudson",
	    "Huel",
	    "Huels",
	    "Hyatt",
	    "Jacobi",
	    "Jacobs",
	    "Jacobson",
	    "Jakubowski",
	    "Jaskolski",
	    "Jast",
	    "Jenkins",
	    "Jerde",
	    "Johns",
	    "Johnson",
	    "Johnston",
	    "Jones",
	    "Kassulke",
	    "Kautzer",
	    "Keebler",
	    "Keeling",
	    "Kemmer",
	    "Kerluke",
	    "Kertzmann",
	    "Kessler",
	    "Kiehn",
	    "Kihn",
	    "Kilback",
	    "King",
	    "Kirlin",
	    "Klein",
	    "Kling",
	    "Klocko",
	    "Koch",
	    "Koelpin",
	    "Koepp",
	    "Kohler",
	    "Konopelski",
	    "Koss",
	    "Kovacek",
	    "Kozey",
	    "Krajcik",
	    "Kreiger",
	    "Kris",
	    "Kshlerin",
	    "Kub",
	    "Kuhic",
	    "Kuhlman",
	    "Kuhn",
	    "Kulas",
	    "Kunde",
	    "Kunze",
	    "Kuphal",
	    "Kutch",
	    "Kuvalis",
	    "Labadie",
	    "Lakin",
	    "Lang",
	    "Langosh",
	    "Langworth",
	    "Larkin",
	    "Larson",
	    "Leannon",
	    "Lebsack",
	    "Ledner",
	    "Leffler",
	    "Legros",
	    "Lehner",
	    "Lemke",
	    "Lesch",
	    "Leuschke",
	    "Lind",
	    "Lindgren",
	    "Littel",
	    "Little",
	    "Lockman",
	    "Lowe",
	    "Lubowitz",
	    "Lueilwitz",
	    "Luettgen",
	    "Lynch",
	    "Macejkovic",
	    "MacGyver",
	    "Maggio",
	    "Mann",
	    "Mante",
	    "Marks",
	    "Marquardt",
	    "Marvin",
	    "Mayer",
	    "Mayert",
	    "McClure",
	    "McCullough",
	    "McDermott",
	    "McGlynn",
	    "McKenzie",
	    "McLaughlin",
	    "Medhurst",
	    "Mertz",
	    "Metz",
	    "Miller",
	    "Mills",
	    "Mitchell",
	    "Moen",
	    "Mohr",
	    "Monahan",
	    "Moore",
	    "Morar",
	    "Morissette",
	    "Mosciski",
	    "Mraz",
	    "Mueller",
	    "Muller",
	    "Murazik",
	    "Murphy",
	    "Murray",
	    "Nader",
	    "Nicolas",
	    "Nienow",
	    "Nikolaus",
	    "Nitzsche",
	    "Nolan",
	    "Oberbrunner",
	    "O'Connell",
	    "O'Conner",
	    "O'Hara",
	    "O'Keefe",
	    "O'Kon",
	    "Okuneva",
	    "Olson",
	    "Ondricka",
	    "O'Reilly",
	    "Orn",
	    "Ortiz",
	    "Osinski",
	    "Pacocha",
	    "Padberg",
	    "Pagac",
	    "Parisian",
	    "Parker",
	    "Paucek",
	    "Pfannerstill",
	    "Pfeffer",
	    "Pollich",
	    "Pouros",
	    "Powlowski",
	    "Predovic",
	    "Price",
	    "Prohaska",
	    "Prosacco",
	    "Purdy",
	    "Quigley",
	    "Quitzon",
	    "Rath",
	    "Ratke",
	    "Rau",
	    "Raynor",
	    "Reichel",
	    "Reichert",
	    "Reilly",
	    "Reinger",
	    "Rempel",
	    "Renner",
	    "Reynolds",
	    "Rice",
	    "Rippin",
	    "Ritchie",
	    "Robel",
	    "Roberts",
	    "Rodriguez",
	    "Rogahn",
	    "Rohan",
	    "Rolfson",
	    "Romaguera",
	    "Roob",
	    "Rosenbaum",
	    "Rowe",
	    "Ruecker",
	    "Runolfsdottir",
	    "Runolfsson",
	    "Runte",
	    "Russel",
	    "Rutherford",
	    "Ryan",
	    "Sanford",
	    "Satterfield",
	    "Sauer",
	    "Sawayn",
	    "Schaden",
	    "Schaefer",
	    "Schamberger",
	    "Schiller",
	    "Schimmel",
	    "Schinner",
	    "Schmeler",
	    "Schmidt",
	    "Schmitt",
	    "Schneider",
	    "Schoen",
	    "Schowalter",
	    "Schroeder",
	    "Schulist",
	    "Schultz",
	    "Schumm",
	    "Schuppe",
	    "Schuster",
	    "Senger",
	    "Shanahan",
	    "Shields",
	    "Simonis",
	    "Sipes",
	    "Skiles",
	    "Smith",
	    "Smitham",
	    "Spencer",
	    "Spinka",
	    "Sporer",
	    "Stamm",
	    "Stanton",
	    "Stark",
	    "Stehr",
	    "Steuber",
	    "Stiedemann",
	    "Stokes",
	    "Stoltenberg",
	    "Stracke",
	    "Streich",
	    "Stroman",
	    "Strosin",
	    "Swaniawski",
	    "Swift",
	    "Terry",
	    "Thiel",
	    "Thompson",
	    "Tillman",
	    "Torp",
	    "Torphy",
	    "Towne",
	    "Toy",
	    "Trantow",
	    "Tremblay",
	    "Treutel",
	    "Tromp",
	    "Turcotte",
	    "Turner",
	    "Ullrich",
	    "Upton",
	    "Vandervort",
	    "Veum",
	    "Volkman",
	    "Von",
	    "VonRueden",
	    "Waelchi",
	    "Walker",
	    "Walsh",
	    "Walter",
	    "Ward",
	    "Waters",
	    "Watsica",
	    "Weber",
	    "Wehner",
	    "Weimann",
	    "Weissnat",
	    "Welch",
	    "West",
	    "White",
	    "Wiegand",
	    "Wilderman",
	    "Wilkinson",
	    "Will",
	    "Williamson",
	    "Willms",
	    "Windler",
	    "Wintheiser",
	    "Wisoky",
	    "Wisozk",
	    "Witting",
	    "Wiza",
	    "Wolf",
	    "Wolff",
	    "Wuckert",
	    "Wunsch",
	    "Wyman",
	    "Yost",
	    "Yundt",
	    "Zboncak",
	    "Zemlak",
	    "Ziemann",
	    "Zieme",
	    "Zulauf"
	  ],
	  "prefix": [
	    "Mr.",
	    "Mrs.",
	    "Ms.",
	    "Miss",
	    "Dr."
	  ],
	  "suffix": [
	    "Jr.",
	    "Sr.",
	    "I",
	    "II",
	    "III",
	    "IV",
	    "V",
	    "MD",
	    "DDS",
	    "PhD",
	    "DVM"
	  ],
	  "title": {
	    "descriptor": [
	      "Lead",
	      "Senior",
	      "Direct",
	      "Corporate",
	      "Dynamic",
	      "Future",
	      "Product",
	      "National",
	      "Regional",
	      "District",
	      "Central",
	      "Global",
	      "Customer",
	      "Investor",
	      "Dynamic",
	      "International",
	      "Legacy",
	      "Forward",
	      "Internal",
	      "Human",
	      "Chief",
	      "Principal"
	    ],
	    "level": [
	      "Solutions",
	      "Program",
	      "Brand",
	      "Security",
	      "Research",
	      "Marketing",
	      "Directives",
	      "Implementation",
	      "Integration",
	      "Functionality",
	      "Response",
	      "Paradigm",
	      "Tactics",
	      "Identity",
	      "Markets",
	      "Group",
	      "Division",
	      "Applications",
	      "Optimization",
	      "Operations",
	      "Infrastructure",
	      "Intranet",
	      "Communications",
	      "Web",
	      "Branding",
	      "Quality",
	      "Assurance",
	      "Mobility",
	      "Accounts",
	      "Data",
	      "Creative",
	      "Configuration",
	      "Accountability",
	      "Interactions",
	      "Factors",
	      "Usability",
	      "Metrics"
	    ],
	    "job": [
	      "Supervisor",
	      "Associate",
	      "Executive",
	      "Liason",
	      "Officer",
	      "Manager",
	      "Engineer",
	      "Specialist",
	      "Director",
	      "Coordinator",
	      "Administrator",
	      "Architect",
	      "Analyst",
	      "Designer",
	      "Planner",
	      "Orchestrator",
	      "Technician",
	      "Developer",
	      "Producer",
	      "Consultant",
	      "Assistant",
	      "Facilitator",
	      "Agent",
	      "Representative",
	      "Strategist"
	    ]
	  },
	  "name": [
	    "#{prefix} #{first_name} #{last_name}",
	    "#{first_name} #{last_name} #{suffix}",
	    "#{first_name} #{last_name}",
	    "#{first_name} #{last_name}",
	    "#{first_name} #{last_name}",
	    "#{first_name} #{last_name}"
	  ]
	};
	en.phone_number = {
	  "formats": [
	    "###-###-####",
	    "(###) ###-####",
	    "1-###-###-####",
	    "###.###.####",
	    "###-###-####",
	    "(###) ###-####",
	    "1-###-###-####",
	    "###.###.####",
	    "###-###-#### x###",
	    "(###) ###-#### x###",
	    "1-###-###-#### x###",
	    "###.###.#### x###",
	    "###-###-#### x####",
	    "(###) ###-#### x####",
	    "1-###-###-#### x####",
	    "###.###.#### x####",
	    "###-###-#### x#####",
	    "(###) ###-#### x#####",
	    "1-###-###-#### x#####",
	    "###.###.#### x#####"
	  ]
	};
	en.cell_phone = {
	  "formats": [
	    "###-###-####",
	    "(###) ###-####",
	    "1-###-###-####",
	    "###.###.####"
	  ]
	};
	en.business = {
	  "credit_card_numbers": [
	    "1234-2121-1221-1211",
	    "1212-1221-1121-1234",
	    "1211-1221-1234-2201",
	    "1228-1221-1221-1431"
	  ],
	  "credit_card_expiry_dates": [
	    "2011-10-12",
	    "2012-11-12",
	    "2015-11-11",
	    "2013-9-12"
	  ],
	  "credit_card_types": [
	    "visa",
	    "mastercard",
	    "americanexpress",
	    "discover"
	  ]
	};
	en.commerce = {
	  "color": [
	    "red",
	    "green",
	    "blue",
	    "yellow",
	    "purple",
	    "mint green",
	    "teal",
	    "white",
	    "black",
	    "orange",
	    "pink",
	    "grey",
	    "maroon",
	    "violet",
	    "turquoise",
	    "tan",
	    "sky blue",
	    "salmon",
	    "plum",
	    "orchid",
	    "olive",
	    "magenta",
	    "lime",
	    "ivory",
	    "indigo",
	    "gold",
	    "fuchsia",
	    "cyan",
	    "azure",
	    "lavender",
	    "silver"
	  ],
	  "department": [
	    "Books",
	    "Movies",
	    "Music",
	    "Games",
	    "Electronics",
	    "Computers",
	    "Home",
	    "Garden",
	    "Tools",
	    "Grocery",
	    "Health",
	    "Beauty",
	    "Toys",
	    "Kids",
	    "Baby",
	    "Clothing",
	    "Shoes",
	    "Jewelery",
	    "Sports",
	    "Outdoors",
	    "Automotive",
	    "Industrial"
	  ],
	  "product_name": {
	    "adjective": [
	      "Small",
	      "Ergonomic",
	      "Rustic",
	      "Intelligent",
	      "Gorgeous",
	      "Incredible",
	      "Fantastic",
	      "Practical",
	      "Sleek",
	      "Awesome"
	    ],
	    "material": [
	      "Steel",
	      "Wooden",
	      "Concrete",
	      "Plastic",
	      "Cotton",
	      "Granite",
	      "Rubber"
	    ],
	    "product": [
	      "Chair",
	      "Car",
	      "Computer",
	      "Gloves",
	      "Pants",
	      "Shirt",
	      "Table",
	      "Shoes",
	      "Hat"
	    ]
	  }
	};
	en.team = {
	  "creature": [
	    "ants",
	    "bats",
	    "bears",
	    "bees",
	    "birds",
	    "buffalo",
	    "cats",
	    "chickens",
	    "cattle",
	    "dogs",
	    "dolphins",
	    "ducks",
	    "elephants",
	    "fishes",
	    "foxes",
	    "frogs",
	    "geese",
	    "goats",
	    "horses",
	    "kangaroos",
	    "lions",
	    "monkeys",
	    "owls",
	    "oxen",
	    "penguins",
	    "people",
	    "pigs",
	    "rabbits",
	    "sheep",
	    "tigers",
	    "whales",
	    "wolves",
	    "zebras",
	    "banshees",
	    "crows",
	    "black cats",
	    "chimeras",
	    "ghosts",
	    "conspirators",
	    "dragons",
	    "dwarves",
	    "elves",
	    "enchanters",
	    "exorcists",
	    "sons",
	    "foes",
	    "giants",
	    "gnomes",
	    "goblins",
	    "gooses",
	    "griffins",
	    "lycanthropes",
	    "nemesis",
	    "ogres",
	    "oracles",
	    "prophets",
	    "sorcerors",
	    "spiders",
	    "spirits",
	    "vampires",
	    "warlocks",
	    "vixens",
	    "werewolves",
	    "witches",
	    "worshipers",
	    "zombies",
	    "druids"
	  ],
	  "name": [
	    "#{Address.state} #{creature}"
	  ]
	};
	en.hacker = {
	  "abbreviation": [
	    "TCP",
	    "HTTP",
	    "SDD",
	    "RAM",
	    "GB",
	    "CSS",
	    "SSL",
	    "AGP",
	    "SQL",
	    "FTP",
	    "PCI",
	    "AI",
	    "ADP",
	    "RSS",
	    "XML",
	    "EXE",
	    "COM",
	    "HDD",
	    "THX",
	    "SMTP",
	    "SMS",
	    "USB",
	    "PNG",
	    "SAS",
	    "IB",
	    "SCSI",
	    "JSON",
	    "XSS",
	    "JBOD"
	  ],
	  "adjective": [
	    "auxiliary",
	    "primary",
	    "back-end",
	    "digital",
	    "open-source",
	    "virtual",
	    "cross-platform",
	    "redundant",
	    "online",
	    "haptic",
	    "multi-byte",
	    "bluetooth",
	    "wireless",
	    "1080p",
	    "neural",
	    "optical",
	    "solid state",
	    "mobile"
	  ],
	  "noun": [
	    "driver",
	    "protocol",
	    "bandwidth",
	    "panel",
	    "microchip",
	    "program",
	    "port",
	    "card",
	    "array",
	    "interface",
	    "system",
	    "sensor",
	    "firewall",
	    "hard drive",
	    "pixel",
	    "alarm",
	    "feed",
	    "monitor",
	    "application",
	    "transmitter",
	    "bus",
	    "circuit",
	    "capacitor",
	    "matrix"
	  ],
	  "verb": [
	    "back up",
	    "bypass",
	    "hack",
	    "override",
	    "compress",
	    "copy",
	    "navigate",
	    "index",
	    "connect",
	    "generate",
	    "quantify",
	    "calculate",
	    "synthesize",
	    "input",
	    "transmit",
	    "program",
	    "reboot",
	    "parse"
	  ],
	  "ingverb": [
	    "backing up",
	    "bypassing",
	    "hacking",
	    "overriding",
	    "compressing",
	    "copying",
	    "navigating",
	    "indexing",
	    "connecting",
	    "generating",
	    "quantifying",
	    "calculating",
	    "synthesizing",
	    "transmitting",
	    "programming",
	    "parsing"
	  ]
	};
	en.app = {
	  "name": [
	    "Redhold",
	    "Treeflex",
	    "Trippledex",
	    "Kanlam",
	    "Bigtax",
	    "Daltfresh",
	    "Toughjoyfax",
	    "Mat Lam Tam",
	    "Otcom",
	    "Tres-Zap",
	    "Y-Solowarm",
	    "Tresom",
	    "Voltsillam",
	    "Biodex",
	    "Greenlam",
	    "Viva",
	    "Matsoft",
	    "Temp",
	    "Zoolab",
	    "Subin",
	    "Rank",
	    "Job",
	    "Stringtough",
	    "Tin",
	    "It",
	    "Home Ing",
	    "Zamit",
	    "Sonsing",
	    "Konklab",
	    "Alpha",
	    "Latlux",
	    "Voyatouch",
	    "Alphazap",
	    "Holdlamis",
	    "Zaam-Dox",
	    "Sub-Ex",
	    "Quo Lux",
	    "Bamity",
	    "Ventosanzap",
	    "Lotstring",
	    "Hatity",
	    "Tempsoft",
	    "Overhold",
	    "Fixflex",
	    "Konklux",
	    "Zontrax",
	    "Tampflex",
	    "Span",
	    "Namfix",
	    "Transcof",
	    "Stim",
	    "Fix San",
	    "Sonair",
	    "Stronghold",
	    "Fintone",
	    "Y-find",
	    "Opela",
	    "Lotlux",
	    "Ronstring",
	    "Zathin",
	    "Duobam",
	    "Keylex"
	  ],
	  "version": [
	    "0.#.#",
	    "0.##",
	    "#.##",
	    "#.#",
	    "#.#.#"
	  ],
	  "author": [
	    "#{Name.name}",
	    "#{Company.name}"
	  ]
	};
	
	en.finance = {};
	en.finance.account_type = ["Checking","Savings","Money Market", "Investment", "Home Loan", "Credit Card", "Auto Loan", "Personal Loan"];
	en.finance.transaction_type = ["deposit", "withdrawal", "payment", "invoice"];
	
	en.finance.currency = {
	  "UAE Dirham": {
	    "code": "AED",
	    "symbol": ""
	  },
	  "Afghani": {
	    "code": "AFN",
	    "symbol": "؋"
	  },
	  "Lek": {
	    "code": "ALL",
	    "symbol": "Lek"
	  },
	  "Armenian Dram": {
	    "code": "AMD",
	    "symbol": ""
	  },
	  "Netherlands Antillian Guilder": {
	    "code": "ANG",
	    "symbol": "ƒ"
	  },
	  "Kwanza": {
	    "code": "AOA",
	    "symbol": ""
	  },
	  "Argentine Peso": {
	    "code": "ARS",
	    "symbol": "$"
	  },
	  "Australian Dollar": {
	    "code": "AUD",
	    "symbol": "$"
	  },
	  "Aruban Guilder": {
	    "code": "AWG",
	    "symbol": "ƒ"
	  },
	  "Azerbaijanian Manat": {
	    "code": "AZN",
	    "symbol": "ман"
	  },
	  "Convertible Marks": {
	    "code": "BAM",
	    "symbol": "KM"
	  },
	  "Barbados Dollar": {
	    "code": "BBD",
	    "symbol": "$"
	  },
	  "Taka": {
	    "code": "BDT",
	    "symbol": ""
	  },
	  "Bulgarian Lev": {
	    "code": "BGN",
	    "symbol": "лв"
	  },
	  "Bahraini Dinar": {
	    "code": "BHD",
	    "symbol": ""
	  },
	  "Burundi Franc": {
	    "code": "BIF",
	    "symbol": ""
	  },
	  "Bermudian Dollar (customarily known as Bermuda Dollar)": {
	    "code": "BMD",
	    "symbol": "$"
	  },
	  "Brunei Dollar": {
	    "code": "BND",
	    "symbol": "$"
	  },
	  "Boliviano Mvdol": {
	    "code": "BOB BOV",
	    "symbol": "$b"
	  },
	  "Brazilian Real": {
	    "code": "BRL",
	    "symbol": "R$"
	  },
	  "Bahamian Dollar": {
	    "code": "BSD",
	    "symbol": "$"
	  },
	  "Pula": {
	    "code": "BWP",
	    "symbol": "P"
	  },
	  "Belarussian Ruble": {
	    "code": "BYR",
	    "symbol": "p."
	  },
	  "Belize Dollar": {
	    "code": "BZD",
	    "symbol": "BZ$"
	  },
	  "Canadian Dollar": {
	    "code": "CAD",
	    "symbol": "$"
	  },
	  "Congolese Franc": {
	    "code": "CDF",
	    "symbol": ""
	  },
	  "Swiss Franc": {
	    "code": "CHF",
	    "symbol": "CHF"
	  },
	  "Chilean Peso Unidades de fomento": {
	    "code": "CLP CLF",
	    "symbol": "$"
	  },
	  "Yuan Renminbi": {
	    "code": "CNY",
	    "symbol": "¥"
	  },
	  "Colombian Peso Unidad de Valor Real": {
	    "code": "COP COU",
	    "symbol": "$"
	  },
	  "Costa Rican Colon": {
	    "code": "CRC",
	    "symbol": "₡"
	  },
	  "Cuban Peso Peso Convertible": {
	    "code": "CUP CUC",
	    "symbol": "₱"
	  },
	  "Cape Verde Escudo": {
	    "code": "CVE",
	    "symbol": ""
	  },
	  "Czech Koruna": {
	    "code": "CZK",
	    "symbol": "Kč"
	  },
	  "Djibouti Franc": {
	    "code": "DJF",
	    "symbol": ""
	  },
	  "Danish Krone": {
	    "code": "DKK",
	    "symbol": "kr"
	  },
	  "Dominican Peso": {
	    "code": "DOP",
	    "symbol": "RD$"
	  },
	  "Algerian Dinar": {
	    "code": "DZD",
	    "symbol": ""
	  },
	  "Kroon": {
	    "code": "EEK",
	    "symbol": ""
	  },
	  "Egyptian Pound": {
	    "code": "EGP",
	    "symbol": "£"
	  },
	  "Nakfa": {
	    "code": "ERN",
	    "symbol": ""
	  },
	  "Ethiopian Birr": {
	    "code": "ETB",
	    "symbol": ""
	  },
	  "Euro": {
	    "code": "EUR",
	    "symbol": "€"
	  },
	  "Fiji Dollar": {
	    "code": "FJD",
	    "symbol": "$"
	  },
	  "Falkland Islands Pound": {
	    "code": "FKP",
	    "symbol": "£"
	  },
	  "Pound Sterling": {
	    "code": "GBP",
	    "symbol": "£"
	  },
	  "Lari": {
	    "code": "GEL",
	    "symbol": ""
	  },
	  "Cedi": {
	    "code": "GHS",
	    "symbol": ""
	  },
	  "Gibraltar Pound": {
	    "code": "GIP",
	    "symbol": "£"
	  },
	  "Dalasi": {
	    "code": "GMD",
	    "symbol": ""
	  },
	  "Guinea Franc": {
	    "code": "GNF",
	    "symbol": ""
	  },
	  "Quetzal": {
	    "code": "GTQ",
	    "symbol": "Q"
	  },
	  "Guyana Dollar": {
	    "code": "GYD",
	    "symbol": "$"
	  },
	  "Hong Kong Dollar": {
	    "code": "HKD",
	    "symbol": "$"
	  },
	  "Lempira": {
	    "code": "HNL",
	    "symbol": "L"
	  },
	  "Croatian Kuna": {
	    "code": "HRK",
	    "symbol": "kn"
	  },
	  "Gourde US Dollar": {
	    "code": "HTG USD",
	    "symbol": ""
	  },
	  "Forint": {
	    "code": "HUF",
	    "symbol": "Ft"
	  },
	  "Rupiah": {
	    "code": "IDR",
	    "symbol": "Rp"
	  },
	  "New Israeli Sheqel": {
	    "code": "ILS",
	    "symbol": "₪"
	  },
	  "Indian Rupee": {
	    "code": "INR",
	    "symbol": ""
	  },
	  "Indian Rupee Ngultrum": {
	    "code": "INR BTN",
	    "symbol": ""
	  },
	  "Iraqi Dinar": {
	    "code": "IQD",
	    "symbol": ""
	  },
	  "Iranian Rial": {
	    "code": "IRR",
	    "symbol": "﷼"
	  },
	  "Iceland Krona": {
	    "code": "ISK",
	    "symbol": "kr"
	  },
	  "Jamaican Dollar": {
	    "code": "JMD",
	    "symbol": "J$"
	  },
	  "Jordanian Dinar": {
	    "code": "JOD",
	    "symbol": ""
	  },
	  "Yen": {
	    "code": "JPY",
	    "symbol": "¥"
	  },
	  "Kenyan Shilling": {
	    "code": "KES",
	    "symbol": ""
	  },
	  "Som": {
	    "code": "KGS",
	    "symbol": "лв"
	  },
	  "Riel": {
	    "code": "KHR",
	    "symbol": "៛"
	  },
	  "Comoro Franc": {
	    "code": "KMF",
	    "symbol": ""
	  },
	  "North Korean Won": {
	    "code": "KPW",
	    "symbol": "₩"
	  },
	  "Won": {
	    "code": "KRW",
	    "symbol": "₩"
	  },
	  "Kuwaiti Dinar": {
	    "code": "KWD",
	    "symbol": ""
	  },
	  "Cayman Islands Dollar": {
	    "code": "KYD",
	    "symbol": "$"
	  },
	  "Tenge": {
	    "code": "KZT",
	    "symbol": "лв"
	  },
	  "Kip": {
	    "code": "LAK",
	    "symbol": "₭"
	  },
	  "Lebanese Pound": {
	    "code": "LBP",
	    "symbol": "£"
	  },
	  "Sri Lanka Rupee": {
	    "code": "LKR",
	    "symbol": "₨"
	  },
	  "Liberian Dollar": {
	    "code": "LRD",
	    "symbol": "$"
	  },
	  "Lithuanian Litas": {
	    "code": "LTL",
	    "symbol": "Lt"
	  },
	  "Latvian Lats": {
	    "code": "LVL",
	    "symbol": "Ls"
	  },
	  "Libyan Dinar": {
	    "code": "LYD",
	    "symbol": ""
	  },
	  "Moroccan Dirham": {
	    "code": "MAD",
	    "symbol": ""
	  },
	  "Moldovan Leu": {
	    "code": "MDL",
	    "symbol": ""
	  },
	  "Malagasy Ariary": {
	    "code": "MGA",
	    "symbol": ""
	  },
	  "Denar": {
	    "code": "MKD",
	    "symbol": "ден"
	  },
	  "Kyat": {
	    "code": "MMK",
	    "symbol": ""
	  },
	  "Tugrik": {
	    "code": "MNT",
	    "symbol": "₮"
	  },
	  "Pataca": {
	    "code": "MOP",
	    "symbol": ""
	  },
	  "Ouguiya": {
	    "code": "MRO",
	    "symbol": ""
	  },
	  "Mauritius Rupee": {
	    "code": "MUR",
	    "symbol": "₨"
	  },
	  "Rufiyaa": {
	    "code": "MVR",
	    "symbol": ""
	  },
	  "Kwacha": {
	    "code": "MWK",
	    "symbol": ""
	  },
	  "Mexican Peso Mexican Unidad de Inversion (UDI)": {
	    "code": "MXN MXV",
	    "symbol": "$"
	  },
	  "Malaysian Ringgit": {
	    "code": "MYR",
	    "symbol": "RM"
	  },
	  "Metical": {
	    "code": "MZN",
	    "symbol": "MT"
	  },
	  "Naira": {
	    "code": "NGN",
	    "symbol": "₦"
	  },
	  "Cordoba Oro": {
	    "code": "NIO",
	    "symbol": "C$"
	  },
	  "Norwegian Krone": {
	    "code": "NOK",
	    "symbol": "kr"
	  },
	  "Nepalese Rupee": {
	    "code": "NPR",
	    "symbol": "₨"
	  },
	  "New Zealand Dollar": {
	    "code": "NZD",
	    "symbol": "$"
	  },
	  "Rial Omani": {
	    "code": "OMR",
	    "symbol": "﷼"
	  },
	  "Balboa US Dollar": {
	    "code": "PAB USD",
	    "symbol": "B/."
	  },
	  "Nuevo Sol": {
	    "code": "PEN",
	    "symbol": "S/."
	  },
	  "Kina": {
	    "code": "PGK",
	    "symbol": ""
	  },
	  "Philippine Peso": {
	    "code": "PHP",
	    "symbol": "Php"
	  },
	  "Pakistan Rupee": {
	    "code": "PKR",
	    "symbol": "₨"
	  },
	  "Zloty": {
	    "code": "PLN",
	    "symbol": "zł"
	  },
	  "Guarani": {
	    "code": "PYG",
	    "symbol": "Gs"
	  },
	  "Qatari Rial": {
	    "code": "QAR",
	    "symbol": "﷼"
	  },
	  "New Leu": {
	    "code": "RON",
	    "symbol": "lei"
	  },
	  "Serbian Dinar": {
	    "code": "RSD",
	    "symbol": "Дин."
	  },
	  "Russian Ruble": {
	    "code": "RUB",
	    "symbol": "руб"
	  },
	  "Rwanda Franc": {
	    "code": "RWF",
	    "symbol": ""
	  },
	  "Saudi Riyal": {
	    "code": "SAR",
	    "symbol": "﷼"
	  },
	  "Solomon Islands Dollar": {
	    "code": "SBD",
	    "symbol": "$"
	  },
	  "Seychelles Rupee": {
	    "code": "SCR",
	    "symbol": "₨"
	  },
	  "Sudanese Pound": {
	    "code": "SDG",
	    "symbol": ""
	  },
	  "Swedish Krona": {
	    "code": "SEK",
	    "symbol": "kr"
	  },
	  "Singapore Dollar": {
	    "code": "SGD",
	    "symbol": "$"
	  },
	  "Saint Helena Pound": {
	    "code": "SHP",
	    "symbol": "£"
	  },
	  "Leone": {
	    "code": "SLL",
	    "symbol": ""
	  },
	  "Somali Shilling": {
	    "code": "SOS",
	    "symbol": "S"
	  },
	  "Surinam Dollar": {
	    "code": "SRD",
	    "symbol": "$"
	  },
	  "Dobra": {
	    "code": "STD",
	    "symbol": ""
	  },
	  "El Salvador Colon US Dollar": {
	    "code": "SVC USD",
	    "symbol": "$"
	  },
	  "Syrian Pound": {
	    "code": "SYP",
	    "symbol": "£"
	  },
	  "Lilangeni": {
	    "code": "SZL",
	    "symbol": ""
	  },
	  "Baht": {
	    "code": "THB",
	    "symbol": "฿"
	  },
	  "Somoni": {
	    "code": "TJS",
	    "symbol": ""
	  },
	  "Manat": {
	    "code": "TMT",
	    "symbol": ""
	  },
	  "Tunisian Dinar": {
	    "code": "TND",
	    "symbol": ""
	  },
	  "Pa'anga": {
	    "code": "TOP",
	    "symbol": ""
	  },
	  "Turkish Lira": {
	    "code": "TRY",
	    "symbol": "TL"
	  },
	  "Trinidad and Tobago Dollar": {
	    "code": "TTD",
	    "symbol": "TT$"
	  },
	  "New Taiwan Dollar": {
	    "code": "TWD",
	    "symbol": "NT$"
	  },
	  "Tanzanian Shilling": {
	    "code": "TZS",
	    "symbol": ""
	  },
	  "Hryvnia": {
	    "code": "UAH",
	    "symbol": "₴"
	  },
	  "Uganda Shilling": {
	    "code": "UGX",
	    "symbol": ""
	  },
	  "US Dollar": {
	    "code": "USD",
	    "symbol": "$"
	  },
	  "Peso Uruguayo Uruguay Peso en Unidades Indexadas": {
	    "code": "UYU UYI",
	    "symbol": "$U"
	  },
	  "Uzbekistan Sum": {
	    "code": "UZS",
	    "symbol": "лв"
	  },
	  "Bolivar Fuerte": {
	    "code": "VEF",
	    "symbol": "Bs"
	  },
	  "Dong": {
	    "code": "VND",
	    "symbol": "₫"
	  },
	  "Vatu": {
	    "code": "VUV",
	    "symbol": ""
	  },
	  "Tala": {
	    "code": "WST",
	    "symbol": ""
	  },
	  "CFA Franc BEAC": {
	    "code": "XAF",
	    "symbol": ""
	  },
	  "Silver": {
	    "code": "XAG",
	    "symbol": ""
	  },
	  "Gold": {
	    "code": "XAU",
	    "symbol": ""
	  },
	  "Bond Markets Units European Composite Unit (EURCO)": {
	    "code": "XBA",
	    "symbol": ""
	  },
	  "European Monetary Unit (E.M.U.-6)": {
	    "code": "XBB",
	    "symbol": ""
	  },
	  "European Unit of Account 9(E.U.A.-9)": {
	    "code": "XBC",
	    "symbol": ""
	  },
	  "European Unit of Account 17(E.U.A.-17)": {
	    "code": "XBD",
	    "symbol": ""
	  },
	  "East Caribbean Dollar": {
	    "code": "XCD",
	    "symbol": "$"
	  },
	  "SDR": {
	    "code": "XDR",
	    "symbol": ""
	  },
	  "UIC-Franc": {
	    "code": "XFU",
	    "symbol": ""
	  },
	  "CFA Franc BCEAO": {
	    "code": "XOF",
	    "symbol": ""
	  },
	  "Palladium": {
	    "code": "XPD",
	    "symbol": ""
	  },
	  "CFP Franc": {
	    "code": "XPF",
	    "symbol": ""
	  },
	  "Platinum": {
	    "code": "XPT",
	    "symbol": ""
	  },
	  "Codes specifically reserved for testing purposes": {
	    "code": "XTS",
	    "symbol": ""
	  },
	  "Yemeni Rial": {
	    "code": "YER",
	    "symbol": "﷼"
	  },
	  "Rand": {
	    "code": "ZAR",
	    "symbol": "R"
	  },
	  "Rand Loti": {
	    "code": "ZAR LSL",
	    "symbol": ""
	  },
	  "Rand Namibia Dollar": {
	    "code": "ZAR NAD",
	    "symbol": ""
	  },
	  "Zambian Kwacha": {
	    "code": "ZMK",
	    "symbol": ""
	  },
	  "Zimbabwe Dollar": {
	    "code": "ZWL",
	    "symbol": ""
	  }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)(module)))

/***/ },
/* 296 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var en_AU = {};
	module["exports"] = en_AU;
	en_AU.title = "Australia (English)";
	en_AU.name = {
	  "first_name": [
	    "William",
	    "Jack",
	    "Oliver",
	    "Joshua",
	    "Thomas",
	    "Lachlan",
	    "Cooper",
	    "Noah",
	    "Ethan",
	    "Lucas",
	    "James",
	    "Samuel",
	    "Jacob",
	    "Liam",
	    "Alexander",
	    "Benjamin",
	    "Max",
	    "Isaac",
	    "Daniel",
	    "Riley",
	    "Ryan",
	    "Charlie",
	    "Tyler",
	    "Jake",
	    "Matthew",
	    "Xavier",
	    "Harry",
	    "Jayden",
	    "Nicholas",
	    "Harrison",
	    "Levi",
	    "Luke",
	    "Adam",
	    "Henry",
	    "Aiden",
	    "Dylan",
	    "Oscar",
	    "Michael",
	    "Jackson",
	    "Logan",
	    "Joseph",
	    "Blake",
	    "Nathan",
	    "Connor",
	    "Elijah",
	    "Nate",
	    "Archie",
	    "Bailey",
	    "Marcus",
	    "Cameron",
	    "Jordan",
	    "Zachary",
	    "Caleb",
	    "Hunter",
	    "Ashton",
	    "Toby",
	    "Aidan",
	    "Hayden",
	    "Mason",
	    "Hamish",
	    "Edward",
	    "Angus",
	    "Eli",
	    "Sebastian",
	    "Christian",
	    "Patrick",
	    "Andrew",
	    "Anthony",
	    "Luca",
	    "Kai",
	    "Beau",
	    "Alex",
	    "George",
	    "Callum",
	    "Finn",
	    "Zac",
	    "Mitchell",
	    "Jett",
	    "Jesse",
	    "Gabriel",
	    "Leo",
	    "Declan",
	    "Charles",
	    "Jasper",
	    "Jonathan",
	    "Aaron",
	    "Hugo",
	    "David",
	    "Christopher",
	    "Chase",
	    "Owen",
	    "Justin",
	    "Ali",
	    "Darcy",
	    "Lincoln",
	    "Cody",
	    "Phoenix",
	    "Sam",
	    "John",
	    "Joel",
	    "Isabella",
	    "Ruby",
	    "Chloe",
	    "Olivia",
	    "Charlotte",
	    "Mia",
	    "Lily",
	    "Emily",
	    "Ella",
	    "Sienna",
	    "Sophie",
	    "Amelia",
	    "Grace",
	    "Ava",
	    "Zoe",
	    "Emma",
	    "Sophia",
	    "Matilda",
	    "Hannah",
	    "Jessica",
	    "Lucy",
	    "Georgia",
	    "Sarah",
	    "Abigail",
	    "Zara",
	    "Eva",
	    "Scarlett",
	    "Jasmine",
	    "Chelsea",
	    "Lilly",
	    "Ivy",
	    "Isla",
	    "Evie",
	    "Isabelle",
	    "Maddison",
	    "Layla",
	    "Summer",
	    "Annabelle",
	    "Alexis",
	    "Elizabeth",
	    "Bella",
	    "Holly",
	    "Lara",
	    "Madison",
	    "Alyssa",
	    "Maya",
	    "Tahlia",
	    "Claire",
	    "Hayley",
	    "Imogen",
	    "Jade",
	    "Ellie",
	    "Sofia",
	    "Addison",
	    "Molly",
	    "Phoebe",
	    "Alice",
	    "Savannah",
	    "Gabriella",
	    "Kayla",
	    "Mikayla",
	    "Abbey",
	    "Eliza",
	    "Willow",
	    "Alexandra",
	    "Poppy",
	    "Samantha",
	    "Stella",
	    "Amy",
	    "Amelie",
	    "Anna",
	    "Piper",
	    "Gemma",
	    "Isabel",
	    "Victoria",
	    "Stephanie",
	    "Caitlin",
	    "Heidi",
	    "Paige",
	    "Rose",
	    "Amber",
	    "Audrey",
	    "Claudia",
	    "Taylor",
	    "Madeline",
	    "Angelina",
	    "Natalie",
	    "Charli",
	    "Lauren",
	    "Ashley",
	    "Violet",
	    "Mackenzie",
	    "Abby",
	    "Skye",
	    "Lillian",
	    "Alana",
	    "Lola",
	    "Leah",
	    "Eve",
	    "Kiara"
	  ],
	  "last_name": [
	    "Smith",
	    "Jones",
	    "Williams",
	    "Brown",
	    "Wilson",
	    "Taylor",
	    "Johnson",
	    "White",
	    "Martin",
	    "Anderson",
	    "Thompson",
	    "Nguyen",
	    "Thomas",
	    "Walker",
	    "Harris",
	    "Lee",
	    "Ryan",
	    "Robinson",
	    "Kelly",
	    "King",
	    "Davis",
	    "Wright",
	    "Evans",
	    "Roberts",
	    "Green",
	    "Hall",
	    "Wood",
	    "Jackson",
	    "Clarke",
	    "Patel",
	    "Khan",
	    "Lewis",
	    "James",
	    "Phillips",
	    "Mason",
	    "Mitchell",
	    "Rose",
	    "Davies",
	    "Rodriguez",
	    "Cox",
	    "Alexander",
	    "Garden",
	    "Campbell",
	    "Johnston",
	    "Moore",
	    "Smyth",
	    "O'neill",
	    "Doherty",
	    "Stewart",
	    "Quinn",
	    "Murphy",
	    "Graham",
	    "Mclaughlin",
	    "Hamilton",
	    "Murray",
	    "Hughes",
	    "Robertson",
	    "Thomson",
	    "Scott",
	    "Macdonald",
	    "Reid",
	    "Clark",
	    "Ross",
	    "Young",
	    "Watson",
	    "Paterson",
	    "Morrison",
	    "Morgan",
	    "Griffiths",
	    "Edwards",
	    "Rees",
	    "Jenkins",
	    "Owen",
	    "Price",
	    "Moss",
	    "Richards",
	    "Abbott",
	    "Adams",
	    "Armstrong",
	    "Bahringer",
	    "Bailey",
	    "Barrows",
	    "Bartell",
	    "Bartoletti",
	    "Barton",
	    "Bauch",
	    "Baumbach",
	    "Bayer",
	    "Beahan",
	    "Beatty",
	    "Becker",
	    "Beier",
	    "Berge",
	    "Bergstrom",
	    "Bode",
	    "Bogan",
	    "Borer",
	    "Bosco",
	    "Botsford",
	    "Boyer",
	    "Boyle",
	    "Braun",
	    "Bruen",
	    "Carroll",
	    "Carter",
	    "Cartwright",
	    "Casper",
	    "Cassin",
	    "Champlin",
	    "Christiansen",
	    "Cole",
	    "Collier",
	    "Collins",
	    "Connelly",
	    "Conroy",
	    "Corkery",
	    "Cormier",
	    "Corwin",
	    "Cronin",
	    "Crooks",
	    "Cruickshank",
	    "Cummings",
	    "D'amore",
	    "Daniel",
	    "Dare",
	    "Daugherty",
	    "Dickens",
	    "Dickinson",
	    "Dietrich",
	    "Donnelly",
	    "Dooley",
	    "Douglas",
	    "Doyle",
	    "Durgan",
	    "Ebert",
	    "Emard",
	    "Emmerich",
	    "Erdman",
	    "Ernser",
	    "Fadel",
	    "Fahey",
	    "Farrell",
	    "Fay",
	    "Feeney",
	    "Feil",
	    "Ferry",
	    "Fisher",
	    "Flatley",
	    "Gibson",
	    "Gleason",
	    "Glover",
	    "Goldner",
	    "Goodwin",
	    "Grady",
	    "Grant",
	    "Greenfelder",
	    "Greenholt",
	    "Grimes",
	    "Gutmann",
	    "Hackett",
	    "Hahn",
	    "Haley",
	    "Hammes",
	    "Hand",
	    "Hane",
	    "Hansen",
	    "Harber",
	    "Hartmann",
	    "Harvey",
	    "Hayes",
	    "Heaney",
	    "Heathcote",
	    "Heller",
	    "Hermann",
	    "Hermiston",
	    "Hessel",
	    "Hettinger",
	    "Hickle",
	    "Hill",
	    "Hills",
	    "Hoppe",
	    "Howe",
	    "Howell",
	    "Hudson",
	    "Huel",
	    "Hyatt",
	    "Jacobi",
	    "Jacobs",
	    "Jacobson",
	    "Jerde",
	    "Johns",
	    "Keeling",
	    "Kemmer",
	    "Kessler",
	    "Kiehn",
	    "Kirlin",
	    "Klein",
	    "Koch",
	    "Koelpin",
	    "Kohler",
	    "Koss",
	    "Kovacek",
	    "Kreiger",
	    "Kris",
	    "Kuhlman",
	    "Kuhn",
	    "Kulas",
	    "Kunde",
	    "Kutch",
	    "Lakin",
	    "Lang",
	    "Langworth",
	    "Larkin",
	    "Larson",
	    "Leannon",
	    "Leffler",
	    "Little",
	    "Lockman",
	    "Lowe",
	    "Lynch",
	    "Mann",
	    "Marks",
	    "Marvin",
	    "Mayer",
	    "Mccullough",
	    "Mcdermott",
	    "Mckenzie",
	    "Miller",
	    "Mills",
	    "Monahan",
	    "Morissette",
	    "Mueller",
	    "Muller",
	    "Nader",
	    "Nicolas",
	    "Nolan",
	    "O'connell",
	    "O'conner",
	    "O'hara",
	    "O'keefe",
	    "Olson",
	    "O'reilly",
	    "Parisian",
	    "Parker",
	    "Quigley",
	    "Reilly",
	    "Reynolds",
	    "Rice",
	    "Ritchie",
	    "Rohan",
	    "Rolfson",
	    "Rowe",
	    "Russel",
	    "Rutherford",
	    "Sanford",
	    "Sauer",
	    "Schmidt",
	    "Schmitt",
	    "Schneider",
	    "Schroeder",
	    "Schultz",
	    "Shields",
	    "Smitham",
	    "Spencer",
	    "Stanton",
	    "Stark",
	    "Stokes",
	    "Swift",
	    "Tillman",
	    "Towne",
	    "Tremblay",
	    "Tromp",
	    "Turcotte",
	    "Turner",
	    "Walsh",
	    "Walter",
	    "Ward",
	    "Waters",
	    "Weber",
	    "Welch",
	    "West",
	    "Wilderman",
	    "Wilkinson",
	    "Williamson",
	    "Windler",
	    "Wolf"
	  ]
	};
	en_AU.company = {
	  "suffix": [
	    "Pty Ltd",
	    "and Sons",
	    "Corp",
	    "Group",
	    "Brothers",
	    "Partners"
	  ]
	};
	en_AU.internet = {
	  "domain_suffix": [
	    "com.au",
	    "com",
	    "net.au",
	    "net",
	    "org.au",
	    "org"
	  ]
	};
	en_AU.address = {
	  "state_abbr": [
	    "NSW",
	    "QLD",
	    "NT",
	    "SA",
	    "WA",
	    "TAS",
	    "ACT",
	    "VIC"
	  ],
	  "state": [
	    "New South Wales",
	    "Queensland",
	    "Northern Territory",
	    "South Australia",
	    "Western Australia",
	    "Tasmania",
	    "Australian Capital Territory",
	    "Victoria"
	  ],
	  "postcode": [
	    "0###",
	    "2###",
	    "3###",
	    "4###",
	    "5###",
	    "6###",
	    "7###"
	  ],
	  "building_number": [
	    "####",
	    "###",
	    "##"
	  ],
	  "street_suffix": [
	    "Avenue",
	    "Boulevard",
	    "Circle",
	    "Circuit",
	    "Court",
	    "Crescent",
	    "Crest",
	    "Drive",
	    "Estate Dr",
	    "Grove",
	    "Hill",
	    "Island",
	    "Junction",
	    "Knoll",
	    "Lane",
	    "Loop",
	    "Mall",
	    "Manor",
	    "Meadow",
	    "Mews",
	    "Parade",
	    "Parkway",
	    "Pass",
	    "Place",
	    "Plaza",
	    "Ridge",
	    "Road",
	    "Run",
	    "Square",
	    "Station St",
	    "Street",
	    "Summit",
	    "Terrace",
	    "Track",
	    "Trail",
	    "View Rd",
	    "Way"
	  ],
	  "default_country": [
	    "Australia"
	  ]
	};
	en_AU.phone_number = {
	  "formats": [
	    "0# #### ####",
	    "+61 # #### ####",
	    "04## ### ###",
	    "+61 4## ### ###"
	  ]
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)(module)))

/***/ },
/* 297 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var en_BORK = {};
	module["exports"] = en_BORK;
	en_BORK.title = "Bork (English)";
	en_BORK.lorem = {
	  "words": [
	    "Boot",
	    "I",
	    "Nu",
	    "Nur",
	    "Tu",
	    "Um",
	    "a",
	    "becoose-a",
	    "boot",
	    "bork",
	    "burn",
	    "chuuses",
	    "cumplete-a",
	    "cun",
	    "cunseqooences",
	    "curcoomstunces",
	    "dee",
	    "deeslikes",
	    "denuoonceeng",
	    "desures",
	    "du",
	    "eccuoont",
	    "ectooel",
	    "edfuntege-a",
	    "efueeds",
	    "egeeen",
	    "ell",
	    "ere-a",
	    "feend",
	    "foolt",
	    "frum",
	    "geefe-a",
	    "gesh",
	    "greet",
	    "heem",
	    "heppeeness",
	    "hes",
	    "hoo",
	    "hoomun",
	    "idea",
	    "ifer",
	    "in",
	    "incuoonter",
	    "injuy",
	    "itselff",
	    "ixcept",
	    "ixemple-a",
	    "ixerceese-a",
	    "ixpleeen",
	    "ixplurer",
	    "ixpuoond",
	    "ixtremely",
	    "knoo",
	    "lebureeuoos",
	    "lufes",
	    "meestekee",
	    "mester-booeelder",
	    "moost",
	    "mun",
	    "nu",
	    "nut",
	    "oobteeen",
	    "oocceseeunelly",
	    "ooccoor",
	    "ooff",
	    "oone-a",
	    "oor",
	    "peeen",
	    "peeenffool",
	    "physeecel",
	    "pleesoore-a",
	    "poorsooe-a",
	    "poorsooes",
	    "preeesing",
	    "prucoore-a",
	    "prudooces",
	    "reeght",
	    "reshunelly",
	    "resooltunt",
	    "sume-a",
	    "teecheengs",
	    "teke-a",
	    "thees",
	    "thet",
	    "thuse-a",
	    "treefiel",
	    "troot",
	    "tu",
	    "tueel",
	    "und",
	    "undertekes",
	    "unnuyeeng",
	    "uny",
	    "unyune-a",
	    "us",
	    "veell",
	    "veet",
	    "ves",
	    "vheech",
	    "vhu",
	    "yuoo",
	    "zee",
	    "zeere-a"
	  ]
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)(module)))

/***/ },
/* 298 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var en_CA = {};
	module["exports"] = en_CA;
	en_CA.title = "Canada (English)";
	en_CA.address = {
	  "postcode": [
	    "?#? #?#",
	    "?#?#?#"
	  ],
	  "state": [
	    "Alberta",
	    "British Columbia",
	    "Manitoba",
	    "New Brunswick",
	    "Newfoundland and Labrador",
	    "Nova Scotia",
	    "Northwest Territories",
	    "Nunavut",
	    "Ontario",
	    "Prince Edward Island",
	    "Quebec",
	    "Saskatchewan",
	    "Yukon"
	  ],
	  "state_abbr": [
	    "AB",
	    "BC",
	    "MB",
	    "NB",
	    "NL",
	    "NS",
	    "NU",
	    "NT",
	    "ON",
	    "PE",
	    "QC",
	    "SK",
	    "YK"
	  ],
	  "default_country": [
	    "Canada"
	  ]
	};
	en_CA.internet = {
	  "free_email": [
	    "gmail.com",
	    "yahoo.ca",
	    "hotmail.com"
	  ],
	  "domain_suffix": [
	    "ca",
	    "com",
	    "biz",
	    "info",
	    "name",
	    "net",
	    "org"
	  ]
	};
	en_CA.phone_number = {
	  "formats": [
	    "###-###-####",
	    "(###)###-####",
	    "###.###.####",
	    "1-###-###-####",
	    "###-###-#### x###",
	    "(###)###-#### x###",
	    "1-###-###-#### x###",
	    "###.###.#### x###",
	    "###-###-#### x####",
	    "(###)###-#### x####",
	    "1-###-###-#### x####",
	    "###.###.#### x####",
	    "###-###-#### x#####",
	    "(###)###-#### x#####",
	    "1-###-###-#### x#####",
	    "###.###.#### x#####"
	  ]
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)(module)))

/***/ },
/* 299 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var en_GB = {};
	module["exports"] = en_GB;
	en_GB.title = "Great Britain (English)";
	en_GB.address = {
	  "postcode": "/[A-PR-UWYZ][A-HK-Y]?[0-9][ABEHMNPRVWXY0-9]? [0-9][ABD-HJLN-UW-Z]{2}/",
	  "county": [
	    "Avon",
	    "Bedfordshire",
	    "Berkshire",
	    "Borders",
	    "Buckinghamshire",
	    "Cambridgeshire",
	    "Central",
	    "Cheshire",
	    "Cleveland",
	    "Clwyd",
	    "Cornwall",
	    "County Antrim",
	    "County Armagh",
	    "County Down",
	    "County Fermanagh",
	    "County Londonderry",
	    "County Tyrone",
	    "Cumbria",
	    "Derbyshire",
	    "Devon",
	    "Dorset",
	    "Dumfries and Galloway",
	    "Durham",
	    "Dyfed",
	    "East Sussex",
	    "Essex",
	    "Fife",
	    "Gloucestershire",
	    "Grampian",
	    "Greater Manchester",
	    "Gwent",
	    "Gwynedd County",
	    "Hampshire",
	    "Herefordshire",
	    "Hertfordshire",
	    "Highlands and Islands",
	    "Humberside",
	    "Isle of Wight",
	    "Kent",
	    "Lancashire",
	    "Leicestershire",
	    "Lincolnshire",
	    "Lothian",
	    "Merseyside",
	    "Mid Glamorgan",
	    "Norfolk",
	    "North Yorkshire",
	    "Northamptonshire",
	    "Northumberland",
	    "Nottinghamshire",
	    "Oxfordshire",
	    "Powys",
	    "Rutland",
	    "Shropshire",
	    "Somerset",
	    "South Glamorgan",
	    "South Yorkshire",
	    "Staffordshire",
	    "Strathclyde",
	    "Suffolk",
	    "Surrey",
	    "Tayside",
	    "Tyne and Wear",
	    "Warwickshire",
	    "West Glamorgan",
	    "West Midlands",
	    "West Sussex",
	    "West Yorkshire",
	    "Wiltshire",
	    "Worcestershire"
	  ],
	  "uk_country": [
	    "England",
	    "Scotland",
	    "Wales",
	    "Northern Ireland"
	  ],
	  "default_country": [
	    "England",
	    "Scotland",
	    "Wales",
	    "Northern Ireland"
	  ]
	};
	en_GB.internet = {
	  "domain_suffix": [
	    "co.uk",
	    "com",
	    "biz",
	    "info",
	    "name"
	  ]
	};
	en_GB.phone_number = {
	  "formats": [
	    "01#### #####",
	    "01### ######",
	    "01#1 ### ####",
	    "011# ### ####",
	    "02# #### ####",
	    "03## ### ####",
	    "055 #### ####",
	    "056 #### ####",
	    "0800 ### ####",
	    "08## ### ####",
	    "09## ### ####",
	    "016977 ####",
	    "01### #####",
	    "0500 ######",
	    "0800 ######"
	  ]
	};
	en_GB.cell_phone = {
	  "formats": [
	    "074## ######",
	    "075## ######",
	    "076## ######",
	    "077## ######",
	    "078## ######",
	    "079## ######"
	  ]
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)(module)))

/***/ },
/* 300 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var en_IND = {};
	module["exports"] = en_IND;
	en_IND.title = "India (English)";
	en_IND.name = {
	  "first_name": [
	    "Aadrika",
	    "Aanandinii",
	    "Aaratrika",
	    "Aarya",
	    "Arya",
	    "Aashritha",
	    "Aatmaja",
	    "Atmaja",
	    "Abhaya",
	    "Adwitiya",
	    "Agrata",
	    "Ahilya",
	    "Ahalya",
	    "Aishani",
	    "Akshainie",
	    "Akshata",
	    "Akshita",
	    "Akula",
	    "Ambar",
	    "Amodini",
	    "Amrita",
	    "Amritambu",
	    "Anala",
	    "Anamika",
	    "Ananda",
	    "Anandamayi",
	    "Ananta",
	    "Anila",
	    "Anjali",
	    "Anjushri",
	    "Anjushree",
	    "Annapurna",
	    "Anshula",
	    "Anuja",
	    "Anusuya",
	    "Anasuya",
	    "Anasooya",
	    "Anwesha",
	    "Apsara",
	    "Aruna",
	    "Asha",
	    "Aasa",
	    "Aasha",
	    "Aslesha",
	    "Atreyi",
	    "Atreyee",
	    "Avani",
	    "Abani",
	    "Avantika",
	    "Ayushmati",
	    "Baidehi",
	    "Vaidehi",
	    "Bala",
	    "Baala",
	    "Balamani",
	    "Basanti",
	    "Vasanti",
	    "Bela",
	    "Bhadra",
	    "Bhagirathi",
	    "Bhagwanti",
	    "Bhagwati",
	    "Bhamini",
	    "Bhanumati",
	    "Bhaanumati",
	    "Bhargavi",
	    "Bhavani",
	    "Bhilangana",
	    "Bilwa",
	    "Bilva",
	    "Buddhana",
	    "Chakrika",
	    "Chanda",
	    "Chandi",
	    "Chandni",
	    "Chandini",
	    "Chandani",
	    "Chandra",
	    "Chandira",
	    "Chandrabhaga",
	    "Chandrakala",
	    "Chandrakin",
	    "Chandramani",
	    "Chandrani",
	    "Chandraprabha",
	    "Chandraswaroopa",
	    "Chandravati",
	    "Chapala",
	    "Charumati",
	    "Charvi",
	    "Chatura",
	    "Chitrali",
	    "Chitramala",
	    "Chitrangada",
	    "Daksha",
	    "Dakshayani",
	    "Damayanti",
	    "Darshwana",
	    "Deepali",
	    "Dipali",
	    "Deeptimoyee",
	    "Deeptimayee",
	    "Devangana",
	    "Devani",
	    "Devasree",
	    "Devi",
	    "Daevi",
	    "Devika",
	    "Daevika",
	    "Dhaanyalakshmi",
	    "Dhanalakshmi",
	    "Dhana",
	    "Dhanadeepa",
	    "Dhara",
	    "Dharani",
	    "Dharitri",
	    "Dhatri",
	    "Diksha",
	    "Deeksha",
	    "Divya",
	    "Draupadi",
	    "Dulari",
	    "Durga",
	    "Durgeshwari",
	    "Ekaparnika",
	    "Elakshi",
	    "Enakshi",
	    "Esha",
	    "Eshana",
	    "Eshita",
	    "Gautami",
	    "Gayatri",
	    "Geeta",
	    "Geetanjali",
	    "Gitanjali",
	    "Gemine",
	    "Gemini",
	    "Girja",
	    "Girija",
	    "Gita",
	    "Hamsini",
	    "Harinakshi",
	    "Harita",
	    "Heema",
	    "Himadri",
	    "Himani",
	    "Hiranya",
	    "Indira",
	    "Jaimini",
	    "Jaya",
	    "Jyoti",
	    "Jyotsana",
	    "Kali",
	    "Kalinda",
	    "Kalpana",
	    "Kalyani",
	    "Kama",
	    "Kamala",
	    "Kamla",
	    "Kanchan",
	    "Kanishka",
	    "Kanti",
	    "Kashyapi",
	    "Kumari",
	    "Kumuda",
	    "Lakshmi",
	    "Laxmi",
	    "Lalita",
	    "Lavanya",
	    "Leela",
	    "Lila",
	    "Leela",
	    "Madhuri",
	    "Malti",
	    "Malati",
	    "Mandakini",
	    "Mandaakin",
	    "Mangala",
	    "Mangalya",
	    "Mani",
	    "Manisha",
	    "Manjusha",
	    "Meena",
	    "Mina",
	    "Meenakshi",
	    "Minakshi",
	    "Menka",
	    "Menaka",
	    "Mohana",
	    "Mohini",
	    "Nalini",
	    "Nikita",
	    "Ojaswini",
	    "Omana",
	    "Oormila",
	    "Urmila",
	    "Opalina",
	    "Opaline",
	    "Padma",
	    "Parvati",
	    "Poornima",
	    "Purnima",
	    "Pramila",
	    "Prasanna",
	    "Preity",
	    "Prema",
	    "Priya",
	    "Priyala",
	    "Pushti",
	    "Radha",
	    "Rageswari",
	    "Rageshwari",
	    "Rajinder",
	    "Ramaa",
	    "Rati",
	    "Rita",
	    "Rohana",
	    "Rukhmani",
	    "Rukmin",
	    "Rupinder",
	    "Sanya",
	    "Sarada",
	    "Sharda",
	    "Sarala",
	    "Sarla",
	    "Saraswati",
	    "Sarisha",
	    "Saroja",
	    "Shakti",
	    "Shakuntala",
	    "Shanti",
	    "Sharmila",
	    "Shashi",
	    "Shashikala",
	    "Sheela",
	    "Shivakari",
	    "Shobhana",
	    "Shresth",
	    "Shresthi",
	    "Shreya",
	    "Shreyashi",
	    "Shridevi",
	    "Shrishti",
	    "Shubha",
	    "Shubhaprada",
	    "Siddhi",
	    "Sitara",
	    "Sloka",
	    "Smita",
	    "Smriti",
	    "Soma",
	    "Subhashini",
	    "Subhasini",
	    "Sucheta",
	    "Sudeva",
	    "Sujata",
	    "Sukanya",
	    "Suma",
	    "Suma",
	    "Sumitra",
	    "Sunita",
	    "Suryakantam",
	    "Sushma",
	    "Swara",
	    "Swarnalata",
	    "Sweta",
	    "Shwet",
	    "Tanirika",
	    "Tanushree",
	    "Tanushri",
	    "Tanushri",
	    "Tanya",
	    "Tara",
	    "Trisha",
	    "Uma",
	    "Usha",
	    "Vaijayanti",
	    "Vaijayanthi",
	    "Baijayanti",
	    "Vaishvi",
	    "Vaishnavi",
	    "Vaishno",
	    "Varalakshmi",
	    "Vasudha",
	    "Vasundhara",
	    "Veda",
	    "Vedanshi",
	    "Vidya",
	    "Vimala",
	    "Vrinda",
	    "Vrund",
	    "Aadi",
	    "Aadidev",
	    "Aadinath",
	    "Aaditya",
	    "Aagam",
	    "Aagney",
	    "Aamod",
	    "Aanandaswarup",
	    "Anand Swarup",
	    "Aanjaneya",
	    "Anjaneya",
	    "Aaryan",
	    "Aryan",
	    "Aatmaj",
	    "Aatreya",
	    "Aayushmaan",
	    "Aayushman",
	    "Abhaidev",
	    "Abhaya",
	    "Abhirath",
	    "Abhisyanta",
	    "Acaryatanaya",
	    "Achalesvara",
	    "Acharyanandana",
	    "Acharyasuta",
	    "Achintya",
	    "Achyut",
	    "Adheesh",
	    "Adhiraj",
	    "Adhrit",
	    "Adikavi",
	    "Adinath",
	    "Aditeya",
	    "Aditya",
	    "Adityanandan",
	    "Adityanandana",
	    "Adripathi",
	    "Advaya",
	    "Agasti",
	    "Agastya",
	    "Agneya",
	    "Aagneya",
	    "Agnimitra",
	    "Agniprava",
	    "Agnivesh",
	    "Agrata",
	    "Ajit",
	    "Ajeet",
	    "Akroor",
	    "Akshaj",
	    "Akshat",
	    "Akshayakeerti",
	    "Alok",
	    "Aalok",
	    "Amaranaath",
	    "Amarnath",
	    "Amaresh",
	    "Ambar",
	    "Ameyatma",
	    "Amish",
	    "Amogh",
	    "Amrit",
	    "Anaadi",
	    "Anagh",
	    "Anal",
	    "Anand",
	    "Aanand",
	    "Anang",
	    "Anil",
	    "Anilaabh",
	    "Anilabh",
	    "Anish",
	    "Ankal",
	    "Anunay",
	    "Anurag",
	    "Anuraag",
	    "Archan",
	    "Arindam",
	    "Arjun",
	    "Arnesh",
	    "Arun",
	    "Ashlesh",
	    "Ashok",
	    "Atmanand",
	    "Atmananda",
	    "Avadhesh",
	    "Baalaaditya",
	    "Baladitya",
	    "Baalagopaal",
	    "Balgopal",
	    "Balagopal",
	    "Bahula",
	    "Bakula",
	    "Bala",
	    "Balaaditya",
	    "Balachandra",
	    "Balagovind",
	    "Bandhu",
	    "Bandhul",
	    "Bankim",
	    "Bankimchandra",
	    "Bhadrak",
	    "Bhadraksh",
	    "Bhadran",
	    "Bhagavaan",
	    "Bhagvan",
	    "Bharadwaj",
	    "Bhardwaj",
	    "Bharat",
	    "Bhargava",
	    "Bhasvan",
	    "Bhaasvan",
	    "Bhaswar",
	    "Bhaaswar",
	    "Bhaumik",
	    "Bhaves",
	    "Bheeshma",
	    "Bhisham",
	    "Bhishma",
	    "Bhima",
	    "Bhoj",
	    "Bhramar",
	    "Bhudev",
	    "Bhudeva",
	    "Bhupati",
	    "Bhoopati",
	    "Bhoopat",
	    "Bhupen",
	    "Bhushan",
	    "Bhooshan",
	    "Bhushit",
	    "Bhooshit",
	    "Bhuvanesh",
	    "Bhuvaneshwar",
	    "Bilva",
	    "Bodhan",
	    "Brahma",
	    "Brahmabrata",
	    "Brahmanandam",
	    "Brahmaanand",
	    "Brahmdev",
	    "Brajendra",
	    "Brajesh",
	    "Brijesh",
	    "Birjesh",
	    "Budhil",
	    "Chakor",
	    "Chakradhar",
	    "Chakravartee",
	    "Chakravarti",
	    "Chanakya",
	    "Chaanakya",
	    "Chandak",
	    "Chandan",
	    "Chandra",
	    "Chandraayan",
	    "Chandrabhan",
	    "Chandradev",
	    "Chandraketu",
	    "Chandramauli",
	    "Chandramohan",
	    "Chandran",
	    "Chandranath",
	    "Chapal",
	    "Charak",
	    "Charuchandra",
	    "Chaaruchandra",
	    "Charuvrat",
	    "Chatur",
	    "Chaturaanan",
	    "Chaturbhuj",
	    "Chetan",
	    "Chaten",
	    "Chaitan",
	    "Chetanaanand",
	    "Chidaakaash",
	    "Chidaatma",
	    "Chidambar",
	    "Chidambaram",
	    "Chidananda",
	    "Chinmayanand",
	    "Chinmayananda",
	    "Chiranjeev",
	    "Chiranjeeve",
	    "Chitraksh",
	    "Daiwik",
	    "Daksha",
	    "Damodara",
	    "Dandak",
	    "Dandapaani",
	    "Darshan",
	    "Datta",
	    "Dayaamay",
	    "Dayamayee",
	    "Dayaananda",
	    "Dayaanidhi",
	    "Kin",
	    "Deenabandhu",
	    "Deepan",
	    "Deepankar",
	    "Dipankar",
	    "Deependra",
	    "Dipendra",
	    "Deepesh",
	    "Dipesh",
	    "Deeptanshu",
	    "Deeptendu",
	    "Diptendu",
	    "Deeptiman",
	    "Deeptimoy",
	    "Deeptimay",
	    "Dev",
	    "Deb",
	    "Devadatt",
	    "Devagya",
	    "Devajyoti",
	    "Devak",
	    "Devdan",
	    "Deven",
	    "Devesh",
	    "Deveshwar",
	    "Devi",
	    "Devvrat",
	    "Dhananjay",
	    "Dhanapati",
	    "Dhanpati",
	    "Dhanesh",
	    "Dhanu",
	    "Dhanvin",
	    "Dharmaketu",
	    "Dhruv",
	    "Dhyanesh",
	    "Dhyaneshwar",
	    "Digambar",
	    "Digambara",
	    "Dinakar",
	    "Dinkar",
	    "Dinesh",
	    "Divaakar",
	    "Divakar",
	    "Deevakar",
	    "Divjot",
	    "Dron",
	    "Drona",
	    "Dwaipayan",
	    "Dwaipayana",
	    "Eekalabya",
	    "Ekalavya",
	    "Ekaksh",
	    "Ekaaksh",
	    "Ekaling",
	    "Ekdant",
	    "Ekadant",
	    "Gajaadhar",
	    "Gajadhar",
	    "Gajbaahu",
	    "Gajabahu",
	    "Ganak",
	    "Ganaka",
	    "Ganapati",
	    "Gandharv",
	    "Gandharva",
	    "Ganesh",
	    "Gangesh",
	    "Garud",
	    "Garuda",
	    "Gati",
	    "Gatik",
	    "Gaurang",
	    "Gauraang",
	    "Gauranga",
	    "Gouranga",
	    "Gautam",
	    "Gautama",
	    "Goutam",
	    "Ghanaanand",
	    "Ghanshyam",
	    "Ghanashyam",
	    "Giri",
	    "Girik",
	    "Girika",
	    "Girindra",
	    "Giriraaj",
	    "Giriraj",
	    "Girish",
	    "Gopal",
	    "Gopaal",
	    "Gopi",
	    "Gopee",
	    "Gorakhnath",
	    "Gorakhanatha",
	    "Goswamee",
	    "Goswami",
	    "Gotum",
	    "Gautam",
	    "Govinda",
	    "Gobinda",
	    "Gudakesha",
	    "Gudakesa",
	    "Gurdev",
	    "Guru",
	    "Hari",
	    "Harinarayan",
	    "Harit",
	    "Himadri",
	    "Hiranmay",
	    "Hiranmaya",
	    "Hiranya",
	    "Inder",
	    "Indra",
	    "Indra",
	    "Jagadish",
	    "Jagadisha",
	    "Jagathi",
	    "Jagdeep",
	    "Jagdish",
	    "Jagmeet",
	    "Jahnu",
	    "Jai",
	    "Javas",
	    "Jay",
	    "Jitendra",
	    "Jitender",
	    "Jyotis",
	    "Kailash",
	    "Kama",
	    "Kamalesh",
	    "Kamlesh",
	    "Kanak",
	    "Kanaka",
	    "Kannan",
	    "Kannen",
	    "Karan",
	    "Karthik",
	    "Kartik",
	    "Karunanidhi",
	    "Kashyap",
	    "Kiran",
	    "Kirti",
	    "Keerti",
	    "Krishna",
	    "Krishnadas",
	    "Krishnadasa",
	    "Kumar",
	    "Lai",
	    "Lakshman",
	    "Laxman",
	    "Lakshmidhar",
	    "Lakshminath",
	    "Lal",
	    "Laal",
	    "Mahendra",
	    "Mohinder",
	    "Mahesh",
	    "Maheswar",
	    "Mani",
	    "Manik",
	    "Manikya",
	    "Manoj",
	    "Marut",
	    "Mayoor",
	    "Meghnad",
	    "Meghnath",
	    "Mohan",
	    "Mukesh",
	    "Mukul",
	    "Nagabhushanam",
	    "Nanda",
	    "Narayan",
	    "Narendra",
	    "Narinder",
	    "Naveen",
	    "Navin",
	    "Nawal",
	    "Naval",
	    "Nimit",
	    "Niranjan",
	    "Nirbhay",
	    "Niro",
	    "Param",
	    "Paramartha",
	    "Pran",
	    "Pranay",
	    "Prasad",
	    "Prathamesh",
	    "Prayag",
	    "Prem",
	    "Puneet",
	    "Purushottam",
	    "Rahul",
	    "Raj",
	    "Rajan",
	    "Rajendra",
	    "Rajinder",
	    "Rajiv",
	    "Rakesh",
	    "Ramesh",
	    "Rameshwar",
	    "Ranjit",
	    "Ranjeet",
	    "Ravi",
	    "Ritesh",
	    "Rohan",
	    "Rohit",
	    "Rudra",
	    "Sachin",
	    "Sameer",
	    "Samir",
	    "Sanjay",
	    "Sanka",
	    "Sarvin",
	    "Satish",
	    "Satyen",
	    "Shankar",
	    "Shantanu",
	    "Shashi",
	    "Sher",
	    "Shiv",
	    "Siddarth",
	    "Siddhran",
	    "Som",
	    "Somu",
	    "Somnath",
	    "Subhash",
	    "Subodh",
	    "Suman",
	    "Suresh",
	    "Surya",
	    "Suryakant",
	    "Suryakanta",
	    "Sushil",
	    "Susheel",
	    "Swami",
	    "Swapnil",
	    "Tapan",
	    "Tara",
	    "Tarun",
	    "Tej",
	    "Tejas",
	    "Trilochan",
	    "Trilochana",
	    "Trilok",
	    "Trilokesh",
	    "Triloki",
	    "Triloki Nath",
	    "Trilokanath",
	    "Tushar",
	    "Udai",
	    "Udit",
	    "Ujjawal",
	    "Ujjwal",
	    "Umang",
	    "Upendra",
	    "Uttam",
	    "Vasudev",
	    "Vasudeva",
	    "Vedang",
	    "Vedanga",
	    "Vidhya",
	    "Vidur",
	    "Vidhur",
	    "Vijay",
	    "Vimal",
	    "Vinay",
	    "Vishnu",
	    "Bishnu",
	    "Vishwamitra",
	    "Vyas",
	    "Yogendra",
	    "Yoginder",
	    "Yogesh"
	  ],
	  "last_name": [
	    "Abbott",
	    "Achari",
	    "Acharya",
	    "Adiga",
	    "Agarwal",
	    "Ahluwalia",
	    "Ahuja",
	    "Arora",
	    "Asan",
	    "Bandopadhyay",
	    "Banerjee",
	    "Bharadwaj",
	    "Bhat",
	    "Butt",
	    "Bhattacharya",
	    "Bhattathiri",
	    "Chaturvedi",
	    "Chattopadhyay",
	    "Chopra",
	    "Desai",
	    "Deshpande",
	    "Devar",
	    "Dhawan",
	    "Dubashi",
	    "Dutta",
	    "Dwivedi",
	    "Embranthiri",
	    "Ganaka",
	    "Gandhi",
	    "Gill",
	    "Gowda",
	    "Guha",
	    "Guneta",
	    "Gupta",
	    "Iyer",
	    "Iyengar",
	    "Jain",
	    "Jha",
	    "Johar",
	    "Joshi",
	    "Kakkar",
	    "Kaniyar",
	    "Kapoor",
	    "Kaul",
	    "Kaur",
	    "Khan",
	    "Khanna",
	    "Khatri",
	    "Kocchar",
	    "Mahajan",
	    "Malik",
	    "Marar",
	    "Menon",
	    "Mehra",
	    "Mehrotra",
	    "Mishra",
	    "Mukhopadhyay",
	    "Nayar",
	    "Naik",
	    "Nair",
	    "Nambeesan",
	    "Namboothiri",
	    "Nehru",
	    "Pandey",
	    "Panicker",
	    "Patel",
	    "Patil",
	    "Pilla",
	    "Pillai",
	    "Pothuvaal",
	    "Prajapat",
	    "Rana",
	    "Reddy",
	    "Saini",
	    "Sethi",
	    "Shah",
	    "Sharma",
	    "Shukla",
	    "Singh",
	    "Sinha",
	    "Somayaji",
	    "Tagore",
	    "Talwar",
	    "Tandon",
	    "Trivedi",
	    "Varrier",
	    "Varma",
	    "Varman",
	    "Verma"
	  ]
	};
	en_IND.address = {
	  "postcode": [
	    "?#? #?#"
	  ],
	  "state": [
	    "Andra Pradesh",
	    "Arunachal Pradesh",
	    "Assam",
	    "Bihar",
	    "Chhattisgarh",
	    "Goa",
	    "Gujarat",
	    "Haryana",
	    "Himachal Pradesh",
	    "Jammu and Kashmir",
	    "Jharkhand",
	    "Karnataka",
	    "Kerala",
	    "Madya Pradesh",
	    "Maharashtra",
	    "Manipur",
	    "Meghalaya",
	    "Mizoram",
	    "Nagaland",
	    "Orissa",
	    "Punjab",
	    "Rajasthan",
	    "Sikkim",
	    "Tamil Nadu",
	    "Tripura",
	    "Uttaranchal",
	    "Uttar Pradesh",
	    "West Bengal",
	    "Andaman and Nicobar Islands",
	    "Chandigarh",
	    "Dadar and Nagar Haveli",
	    "Daman and Diu",
	    "Delhi",
	    "Lakshadweep",
	    "Pondicherry"
	  ],
	  "state_abbr": [
	    "AP",
	    "AR",
	    "AS",
	    "BR",
	    "CG",
	    "DL",
	    "GA",
	    "GJ",
	    "HR",
	    "HP",
	    "JK",
	    "JS",
	    "KA",
	    "KL",
	    "MP",
	    "MH",
	    "MN",
	    "ML",
	    "MZ",
	    "NL",
	    "OR",
	    "PB",
	    "RJ",
	    "SK",
	    "TN",
	    "TR",
	    "UK",
	    "UP",
	    "WB",
	    "AN",
	    "CH",
	    "DN",
	    "DD",
	    "LD",
	    "PY"
	  ],
	  "default_country": [
	    "India",
	    "Indian Republic",
	    "Bharat",
	    "Hindustan"
	  ]
	};
	en_IND.internet = {
	  "free_email": [
	    "gmail.com",
	    "yahoo.co.in",
	    "hotmail.com"
	  ],
	  "domain_suffix": [
	    "in",
	    "com",
	    "biz",
	    "info",
	    "name",
	    "net",
	    "org",
	    "co.in"
	  ]
	};
	en_IND.company = {
	  "suffix": [
	    "Pvt Ltd",
	    "Limited",
	    "Ltd",
	    "and Sons",
	    "Corp",
	    "Group",
	    "Brothers"
	  ]
	};
	en_IND.phone_number = {
	  "formats": [
	    "+91###-###-####",
	    "+91##########",
	    "+91-###-#######"
	  ]
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)(module)))

/***/ },
/* 301 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var en_US = {};
	module["exports"] = en_US;
	en_US.title = "United States (English)";
	en_US.internet = {
	  "domain_suffix": [
	    "com",
	    "us",
	    "biz",
	    "info",
	    "name",
	    "net",
	    "org"
	  ]
	};
	en_US.address = {
	  "default_country": [
	    "United States",
	    "United States of America",
	    "USA"
	  ],
	  "postcode_by_state": {
	    "AL": "350##",
	    "AK": "995##",
	    "AS": "967##",
	    "AZ": "850##",
	    "AR": "717##",
	    "CA": "900##",
	    "CO": "800##",
	    "CT": "061##",
	    "DC": "204##",
	    "DE": "198##",
	    "FL": "322##",
	    "GA": "301##",
	    "HI": "967##",
	    "ID": "832##",
	    "IL": "600##",
	    "IN": "463##",
	    "IA": "510##",
	    "KS": "666##",
	    "KY": "404##",
	    "LA": "701##",
	    "ME": "042##",
	    "MD": "210##",
	    "MA": "026##",
	    "MI": "480##",
	    "MN": "555##",
	    "MS": "387##",
	    "MO": "650##",
	    "MT": "590##",
	    "NE": "688##",
	    "NV": "898##",
	    "NH": "036##",
	    "NJ": "076##",
	    "NM": "880##",
	    "NY": "122##",
	    "NC": "288##",
	    "ND": "586##",
	    "OH": "444##",
	    "OK": "730##",
	    "OR": "979##",
	    "PA": "186##",
	    "RI": "029##",
	    "SC": "299##",
	    "SD": "577##",
	    "TN": "383##",
	    "TX": "798##",
	    "UT": "847##",
	    "VT": "050##",
	    "VA": "222##",
	    "WA": "990##",
	    "WV": "247##",
	    "WI": "549##",
	    "WY": "831##"
	  }
	};
	en_US.phone_number = {
	  "area_code": [
	    "201",
	    "202",
	    "203",
	    "205",
	    "206",
	    "207",
	    "208",
	    "209",
	    "210",
	    "212",
	    "213",
	    "214",
	    "215",
	    "216",
	    "217",
	    "218",
	    "219",
	    "224",
	    "225",
	    "227",
	    "228",
	    "229",
	    "231",
	    "234",
	    "239",
	    "240",
	    "248",
	    "251",
	    "252",
	    "253",
	    "254",
	    "256",
	    "260",
	    "262",
	    "267",
	    "269",
	    "270",
	    "276",
	    "281",
	    "283",
	    "301",
	    "302",
	    "303",
	    "304",
	    "305",
	    "307",
	    "308",
	    "309",
	    "310",
	    "312",
	    "313",
	    "314",
	    "315",
	    "316",
	    "317",
	    "318",
	    "319",
	    "320",
	    "321",
	    "323",
	    "330",
	    "331",
	    "334",
	    "336",
	    "337",
	    "339",
	    "347",
	    "351",
	    "352",
	    "360",
	    "361",
	    "386",
	    "401",
	    "402",
	    "404",
	    "405",
	    "406",
	    "407",
	    "408",
	    "409",
	    "410",
	    "412",
	    "413",
	    "414",
	    "415",
	    "417",
	    "419",
	    "423",
	    "424",
	    "425",
	    "434",
	    "435",
	    "440",
	    "443",
	    "445",
	    "464",
	    "469",
	    "470",
	    "475",
	    "478",
	    "479",
	    "480",
	    "484",
	    "501",
	    "502",
	    "503",
	    "504",
	    "505",
	    "507",
	    "508",
	    "509",
	    "510",
	    "512",
	    "513",
	    "515",
	    "516",
	    "517",
	    "518",
	    "520",
	    "530",
	    "540",
	    "541",
	    "551",
	    "557",
	    "559",
	    "561",
	    "562",
	    "563",
	    "564",
	    "567",
	    "570",
	    "571",
	    "573",
	    "574",
	    "580",
	    "585",
	    "586",
	    "601",
	    "602",
	    "603",
	    "605",
	    "606",
	    "607",
	    "608",
	    "609",
	    "610",
	    "612",
	    "614",
	    "615",
	    "616",
	    "617",
	    "618",
	    "619",
	    "620",
	    "623",
	    "626",
	    "630",
	    "631",
	    "636",
	    "641",
	    "646",
	    "650",
	    "651",
	    "660",
	    "661",
	    "662",
	    "667",
	    "678",
	    "682",
	    "701",
	    "702",
	    "703",
	    "704",
	    "706",
	    "707",
	    "708",
	    "712",
	    "713",
	    "714",
	    "715",
	    "716",
	    "717",
	    "718",
	    "719",
	    "720",
	    "724",
	    "727",
	    "731",
	    "732",
	    "734",
	    "737",
	    "740",
	    "754",
	    "757",
	    "760",
	    "763",
	    "765",
	    "770",
	    "772",
	    "773",
	    "774",
	    "775",
	    "781",
	    "785",
	    "786",
	    "801",
	    "802",
	    "803",
	    "804",
	    "805",
	    "806",
	    "808",
	    "810",
	    "812",
	    "813",
	    "814",
	    "815",
	    "816",
	    "817",
	    "818",
	    "828",
	    "830",
	    "831",
	    "832",
	    "835",
	    "843",
	    "845",
	    "847",
	    "848",
	    "850",
	    "856",
	    "857",
	    "858",
	    "859",
	    "860",
	    "862",
	    "863",
	    "864",
	    "865",
	    "870",
	    "872",
	    "878",
	    "901",
	    "903",
	    "904",
	    "906",
	    "907",
	    "908",
	    "909",
	    "910",
	    "912",
	    "913",
	    "914",
	    "915",
	    "916",
	    "917",
	    "918",
	    "919",
	    "920",
	    "925",
	    "928",
	    "931",
	    "936",
	    "937",
	    "940",
	    "941",
	    "947",
	    "949",
	    "952",
	    "954",
	    "956",
	    "959",
	    "970",
	    "971",
	    "972",
	    "973",
	    "975",
	    "978",
	    "979",
	    "980",
	    "984",
	    "985",
	    "989"
	  ],
	  "exchange_code": [
	    "201",
	    "202",
	    "203",
	    "205",
	    "206",
	    "207",
	    "208",
	    "209",
	    "210",
	    "212",
	    "213",
	    "214",
	    "215",
	    "216",
	    "217",
	    "218",
	    "219",
	    "224",
	    "225",
	    "227",
	    "228",
	    "229",
	    "231",
	    "234",
	    "239",
	    "240",
	    "248",
	    "251",
	    "252",
	    "253",
	    "254",
	    "256",
	    "260",
	    "262",
	    "267",
	    "269",
	    "270",
	    "276",
	    "281",
	    "283",
	    "301",
	    "302",
	    "303",
	    "304",
	    "305",
	    "307",
	    "308",
	    "309",
	    "310",
	    "312",
	    "313",
	    "314",
	    "315",
	    "316",
	    "317",
	    "318",
	    "319",
	    "320",
	    "321",
	    "323",
	    "330",
	    "331",
	    "334",
	    "336",
	    "337",
	    "339",
	    "347",
	    "351",
	    "352",
	    "360",
	    "361",
	    "386",
	    "401",
	    "402",
	    "404",
	    "405",
	    "406",
	    "407",
	    "408",
	    "409",
	    "410",
	    "412",
	    "413",
	    "414",
	    "415",
	    "417",
	    "419",
	    "423",
	    "424",
	    "425",
	    "434",
	    "435",
	    "440",
	    "443",
	    "445",
	    "464",
	    "469",
	    "470",
	    "475",
	    "478",
	    "479",
	    "480",
	    "484",
	    "501",
	    "502",
	    "503",
	    "504",
	    "505",
	    "507",
	    "508",
	    "509",
	    "510",
	    "512",
	    "513",
	    "515",
	    "516",
	    "517",
	    "518",
	    "520",
	    "530",
	    "540",
	    "541",
	    "551",
	    "557",
	    "559",
	    "561",
	    "562",
	    "563",
	    "564",
	    "567",
	    "570",
	    "571",
	    "573",
	    "574",
	    "580",
	    "585",
	    "586",
	    "601",
	    "602",
	    "603",
	    "605",
	    "606",
	    "607",
	    "608",
	    "609",
	    "610",
	    "612",
	    "614",
	    "615",
	    "616",
	    "617",
	    "618",
	    "619",
	    "620",
	    "623",
	    "626",
	    "630",
	    "631",
	    "636",
	    "641",
	    "646",
	    "650",
	    "651",
	    "660",
	    "661",
	    "662",
	    "667",
	    "678",
	    "682",
	    "701",
	    "702",
	    "703",
	    "704",
	    "706",
	    "707",
	    "708",
	    "712",
	    "713",
	    "714",
	    "715",
	    "716",
	    "717",
	    "718",
	    "719",
	    "720",
	    "724",
	    "727",
	    "731",
	    "732",
	    "734",
	    "737",
	    "740",
	    "754",
	    "757",
	    "760",
	    "763",
	    "765",
	    "770",
	    "772",
	    "773",
	    "774",
	    "775",
	    "781",
	    "785",
	    "786",
	    "801",
	    "802",
	    "803",
	    "804",
	    "805",
	    "806",
	    "808",
	    "810",
	    "812",
	    "813",
	    "814",
	    "815",
	    "816",
	    "817",
	    "818",
	    "828",
	    "830",
	    "831",
	    "832",
	    "835",
	    "843",
	    "845",
	    "847",
	    "848",
	    "850",
	    "856",
	    "857",
	    "858",
	    "859",
	    "860",
	    "862",
	    "863",
	    "864",
	    "865",
	    "870",
	    "872",
	    "878",
	    "901",
	    "903",
	    "904",
	    "906",
	    "907",
	    "908",
	    "909",
	    "910",
	    "912",
	    "913",
	    "914",
	    "915",
	    "916",
	    "917",
	    "918",
	    "919",
	    "920",
	    "925",
	    "928",
	    "931",
	    "936",
	    "937",
	    "940",
	    "941",
	    "947",
	    "949",
	    "952",
	    "954",
	    "956",
	    "959",
	    "970",
	    "971",
	    "972",
	    "973",
	    "975",
	    "978",
	    "979",
	    "980",
	    "984",
	    "985",
	    "989"
	  ]
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)(module)))

/***/ },
/* 302 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var en_au_ocker = {};
	module["exports"] = en_au_ocker;
	en_au_ocker.title = "Australia Ocker (English)";
	en_au_ocker.name = {
	  "first_name": [
	    "Charlotte",
	    "Ava",
	    "Chloe",
	    "Emily",
	    "Olivia",
	    "Zoe",
	    "Lily",
	    "Sophie",
	    "Amelia",
	    "Sofia",
	    "Ella",
	    "Isabella",
	    "Ruby",
	    "Sienna",
	    "Mia+3",
	    "Grace",
	    "Emma",
	    "Ivy",
	    "Layla",
	    "Abigail",
	    "Isla",
	    "Hannah",
	    "Zara",
	    "Lucy",
	    "Evie",
	    "Annabelle",
	    "Madison",
	    "Alice",
	    "Georgia",
	    "Maya",
	    "Madeline",
	    "Audrey",
	    "Scarlett",
	    "Isabelle",
	    "Chelsea",
	    "Mila",
	    "Holly",
	    "Indiana",
	    "Poppy",
	    "Harper",
	    "Sarah",
	    "Alyssa",
	    "Jasmine",
	    "Imogen",
	    "Hayley",
	    "Pheobe",
	    "Eva",
	    "Evelyn",
	    "Mackenzie",
	    "Ayla",
	    "Oliver",
	    "Jack",
	    "Jackson",
	    "William",
	    "Ethan",
	    "Charlie",
	    "Lucas",
	    "Cooper",
	    "Lachlan",
	    "Noah",
	    "Liam",
	    "Alexander",
	    "Max",
	    "Isaac",
	    "Thomas",
	    "Xavier",
	    "Oscar",
	    "Benjamin",
	    "Aiden",
	    "Mason",
	    "Samuel",
	    "James",
	    "Levi",
	    "Riley",
	    "Harrison",
	    "Ryan",
	    "Henry",
	    "Jacob",
	    "Joshua",
	    "Leo",
	    "Zach",
	    "Harry",
	    "Hunter",
	    "Flynn",
	    "Archie",
	    "Tyler",
	    "Elijah",
	    "Hayden",
	    "Jayden",
	    "Blake",
	    "Archer",
	    "Ashton",
	    "Sebastian",
	    "Zachery",
	    "Lincoln",
	    "Mitchell",
	    "Luca",
	    "Nathan",
	    "Kai",
	    "Connor",
	    "Tom",
	    "Nigel",
	    "Matt",
	    "Sean"
	  ],
	  "last_name": [
	    "Smith",
	    "Jones",
	    "Williams",
	    "Brown",
	    "Wilson",
	    "Taylor",
	    "Morton",
	    "White",
	    "Martin",
	    "Anderson",
	    "Thompson",
	    "Nguyen",
	    "Thomas",
	    "Walker",
	    "Harris",
	    "Lee",
	    "Ryan",
	    "Robinson",
	    "Kelly",
	    "King",
	    "Rausch",
	    "Ridge",
	    "Connolly",
	    "LeQuesne"
	  ],
	  "ocker_first_name": [
	    "Bazza",
	    "Bluey",
	    "Davo",
	    "Johno",
	    "Shano",
	    "Shazza"
	  ]
	};
	en_au_ocker.company = {
	  "suffix": [
	    "Pty Ltd",
	    "and Sons",
	    "Corp",
	    "Group",
	    "Brothers",
	    "Partners"
	  ]
	};
	en_au_ocker.internet = {
	  "domain_suffix": [
	    "com.au",
	    "com",
	    "net.au",
	    "net",
	    "org.au",
	    "org"
	  ]
	};
	en_au_ocker.address = {
	  "street_root": [
	    "Ramsay Street",
	    "Bonnie Doon",
	    "Cavill Avenue",
	    "Queen Street"
	  ],
	  "street_name": [
	    "#{street_root}"
	  ],
	  "city_prefix": [
	    "Bondi",
	    "Burleigh Heads",
	    "Carlton",
	    "Fitzroy",
	    "Fremantle",
	    "Glenelg",
	    "Manly",
	    "Noosa",
	    "Stones Corner",
	    "St Kilda",
	    "Surry Hills",
	    "Yarra Valley"
	  ],
	  "city": [
	    "#{city_prefix}"
	  ],
	  "state_abbr": [
	    "NSW",
	    "QLD",
	    "NT",
	    "SA",
	    "WA",
	    "TAS",
	    "ACT",
	    "VIC"
	  ],
	  "region": [
	    "South East Queensland",
	    "Wide Bay Burnett",
	    "Margaret River",
	    "Port Pirie",
	    "Gippsland",
	    "Elizabeth",
	    "Barossa"
	  ],
	  "state": [
	    "New South Wales",
	    "Queensland",
	    "Northern Territory",
	    "South Australia",
	    "Western Australia",
	    "Tasmania",
	    "Australian Capital Territory",
	    "Victoria"
	  ],
	  "postcode": [
	    "0###",
	    "2###",
	    "3###",
	    "4###",
	    "5###",
	    "6###",
	    "7###"
	  ],
	  "building_number": [
	    "####",
	    "###",
	    "##"
	  ],
	  "street_suffix": [
	    "Avenue",
	    "Boulevard",
	    "Circle",
	    "Circuit",
	    "Court",
	    "Crescent",
	    "Crest",
	    "Drive",
	    "Estate Dr",
	    "Grove",
	    "Hill",
	    "Island",
	    "Junction",
	    "Knoll",
	    "Lane",
	    "Loop",
	    "Mall",
	    "Manor",
	    "Meadow",
	    "Mews",
	    "Parade",
	    "Parkway",
	    "Pass",
	    "Place",
	    "Plaza",
	    "Ridge",
	    "Road",
	    "Run",
	    "Square",
	    "Station St",
	    "Street",
	    "Summit",
	    "Terrace",
	    "Track",
	    "Trail",
	    "View Rd",
	    "Way"
	  ],
	  "default_country": [
	    "Australia"
	  ]
	};
	en_au_ocker.phone_number = {
	  "formats": [
	    "0# #### ####",
	    "+61 # #### ####",
	    "04## ### ###",
	    "+61 4## ### ###"
	  ]
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)(module)))

/***/ },
/* 303 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var es = {};
	module["exports"] = es;
	es.title = "Spanish";
	es.address = {
	  "city_prefix": [
	    "Parla",
	    "Telde",
	    "Baracaldo",
	    "San Fernando",
	    "Torrevieja",
	    "Lugo",
	    "Santiago de Compostela",
	    "Gerona",
	    "Cáceres",
	    "Lorca",
	    "Coslada",
	    "Talavera de la Reina",
	    "El Puerto de Santa María",
	    "Cornellá de Llobregat",
	    "Avilés",
	    "Palencia",
	    "Gecho",
	    "Orihuela",
	    "Pontevedra",
	    "Pozuelo de Alarcón",
	    "Toledo",
	    "El Ejido",
	    "Guadalajara",
	    "Gandía",
	    "Ceuta",
	    "Ferrol",
	    "Chiclana de la Frontera",
	    "Manresa",
	    "Roquetas de Mar",
	    "Ciudad Real",
	    "Rubí",
	    "Benidorm",
	    "San Sebastían de los Reyes",
	    "Ponferrada",
	    "Zamora",
	    "Alcalá de Guadaira",
	    "Fuengirola",
	    "Mijas",
	    "Sanlúcar de Barrameda",
	    "La Línea de la Concepción",
	    "Majadahonda",
	    "Sagunto",
	    "El Prat de LLobregat",
	    "Viladecans",
	    "Linares",
	    "Alcoy",
	    "Irún",
	    "Estepona",
	    "Torremolinos",
	    "Rivas-Vaciamadrid",
	    "Molina de Segura",
	    "Paterna",
	    "Granollers",
	    "Santa Lucía de Tirajana",
	    "Motril",
	    "Cerdañola del Vallés",
	    "Arrecife",
	    "Segovia",
	    "Torrelavega",
	    "Elda",
	    "Mérida",
	    "Ávila",
	    "Valdemoro",
	    "Cuenta",
	    "Collado Villalba",
	    "Benalmádena",
	    "Mollet del Vallés",
	    "Puertollano",
	    "Madrid",
	    "Barcelona",
	    "Valencia",
	    "Sevilla",
	    "Zaragoza",
	    "Málaga",
	    "Murcia",
	    "Palma de Mallorca",
	    "Las Palmas de Gran Canaria",
	    "Bilbao",
	    "Córdoba",
	    "Alicante",
	    "Valladolid",
	    "Vigo",
	    "Gijón",
	    "Hospitalet de LLobregat",
	    "La Coruña",
	    "Granada",
	    "Vitoria",
	    "Elche",
	    "Santa Cruz de Tenerife",
	    "Oviedo",
	    "Badalona",
	    "Cartagena",
	    "Móstoles",
	    "Jerez de la Frontera",
	    "Tarrasa",
	    "Sabadell",
	    "Alcalá de Henares",
	    "Pamplona",
	    "Fuenlabrada",
	    "Almería",
	    "San Sebastián",
	    "Leganés",
	    "Santander",
	    "Burgos",
	    "Castellón de la Plana",
	    "Alcorcón",
	    "Albacete",
	    "Getafe",
	    "Salamanca",
	    "Huelva",
	    "Logroño",
	    "Badajoz",
	    "San Cristróbal de la Laguna",
	    "León",
	    "Tarragona",
	    "Cádiz",
	    "Lérida",
	    "Marbella",
	    "Mataró",
	    "Dos Hermanas",
	    "Santa Coloma de Gramanet",
	    "Jaén",
	    "Algeciras",
	    "Torrejón de Ardoz",
	    "Orense",
	    "Alcobendas",
	    "Reus",
	    "Calahorra",
	    "Inca"
	  ],
	  "country": [
	    "Afganistán",
	    "Albania",
	    "Argelia",
	    "Andorra",
	    "Angola",
	    "Argentina",
	    "Armenia",
	    "Aruba",
	    "Australia",
	    "Austria",
	    "Azerbayán",
	    "Bahamas",
	    "Barein",
	    "Bangladesh",
	    "Barbados",
	    "Bielorusia",
	    "Bélgica",
	    "Belice",
	    "Bermuda",
	    "Bután",
	    "Bolivia",
	    "Bosnia Herzegovina",
	    "Botswana",
	    "Brasil",
	    "Bulgaria",
	    "Burkina Faso",
	    "Burundi",
	    "Camboya",
	    "Camerún",
	    "Canada",
	    "Cabo Verde",
	    "Islas Caimán",
	    "Chad",
	    "Chile",
	    "China",
	    "Isla de Navidad",
	    "Colombia",
	    "Comodos",
	    "Congo",
	    "Costa Rica",
	    "Costa de Marfil",
	    "Croacia",
	    "Cuba",
	    "Chipre",
	    "República Checa",
	    "Dinamarca",
	    "Dominica",
	    "República Dominicana",
	    "Ecuador",
	    "Egipto",
	    "El Salvador",
	    "Guinea Ecuatorial",
	    "Eritrea",
	    "Estonia",
	    "Etiopía",
	    "Islas Faro",
	    "Fiji",
	    "Finlandia",
	    "Francia",
	    "Gabón",
	    "Gambia",
	    "Georgia",
	    "Alemania",
	    "Ghana",
	    "Grecia",
	    "Groenlandia",
	    "Granada",
	    "Guadalupe",
	    "Guam",
	    "Guatemala",
	    "Guinea",
	    "Guinea-Bisau",
	    "Guayana",
	    "Haiti",
	    "Honduras",
	    "Hong Kong",
	    "Hungria",
	    "Islandia",
	    "India",
	    "Indonesia",
	    "Iran",
	    "Irak",
	    "Irlanda",
	    "Italia",
	    "Jamaica",
	    "Japón",
	    "Jordania",
	    "Kazajistan",
	    "Kenia",
	    "Kiribati",
	    "Corea",
	    "Kuwait",
	    "Letonia",
	    "Líbano",
	    "Liberia",
	    "Liechtenstein",
	    "Lituania",
	    "Luxemburgo",
	    "Macao",
	    "Macedonia",
	    "Madagascar",
	    "Malawi",
	    "Malasia",
	    "Maldivas",
	    "Mali",
	    "Malta",
	    "Martinica",
	    "Mauritania",
	    "Méjico",
	    "Micronesia",
	    "Moldavia",
	    "Mónaco",
	    "Mongolia",
	    "Montenegro",
	    "Montserrat",
	    "Marruecos",
	    "Mozambique",
	    "Namibia",
	    "Nauru",
	    "Nepal",
	    "Holanda",
	    "Nueva Zelanda",
	    "Nicaragua",
	    "Niger",
	    "Nigeria",
	    "Noruega",
	    "Omán",
	    "Pakistan",
	    "Panamá",
	    "Papúa Nueva Guinea",
	    "Paraguay",
	    "Perú",
	    "Filipinas",
	    "Poland",
	    "Portugal",
	    "Puerto Rico",
	    "Rusia",
	    "Ruanda",
	    "Samoa",
	    "San Marino",
	    "Santo Tomé y Principe",
	    "Arabia Saudí",
	    "Senegal",
	    "Serbia",
	    "Seychelles",
	    "Sierra Leona",
	    "Singapur",
	    "Eslovaquia",
	    "Eslovenia",
	    "Somalia",
	    "España",
	    "Sri Lanka",
	    "Sudán",
	    "Suriname",
	    "Suecia",
	    "Suiza",
	    "Siria",
	    "Taiwan",
	    "Tajikistan",
	    "Tanzania",
	    "Tailandia",
	    "Timor-Leste",
	    "Togo",
	    "Tonga",
	    "Trinidad y Tobago",
	    "Tunez",
	    "Turquia",
	    "Uganda",
	    "Ucrania",
	    "Emiratos Árabes Unidos",
	    "Reino Unido",
	    "Estados Unidos de América",
	    "Uruguay",
	    "Uzbekistan",
	    "Vanuatu",
	    "Venezuela",
	    "Vietnam",
	    "Yemen",
	    "Zambia",
	    "Zimbabwe"
	  ],
	  "building_number": [
	    " s/n.",
	    ", #",
	    ", ##",
	    " #",
	    " ##"
	  ],
	  "street_suffix": [
	    "Aldea",
	    "Apartamento",
	    "Arrabal",
	    "Arroyo",
	    "Avenida",
	    "Bajada",
	    "Barranco",
	    "Barrio",
	    "Bloque",
	    "Calle",
	    "Calleja",
	    "Camino",
	    "Carretera",
	    "Caserio",
	    "Colegio",
	    "Colonia",
	    "Conjunto",
	    "Cuesta",
	    "Chalet",
	    "Edificio",
	    "Entrada",
	    "Escalinata",
	    "Explanada",
	    "Extramuros",
	    "Extrarradio",
	    "Ferrocarril",
	    "Glorieta",
	    "Gran Subida",
	    "Grupo",
	    "Huerta",
	    "Jardines",
	    "Lado",
	    "Lugar",
	    "Manzana",
	    "Masía",
	    "Mercado",
	    "Monte",
	    "Muelle",
	    "Municipio",
	    "Parcela",
	    "Parque",
	    "Partida",
	    "Pasaje",
	    "Paseo",
	    "Plaza",
	    "Poblado",
	    "Polígono",
	    "Prolongación",
	    "Puente",
	    "Puerta",
	    "Quinta",
	    "Ramal",
	    "Rambla",
	    "Rampa",
	    "Riera",
	    "Rincón",
	    "Ronda",
	    "Rua",
	    "Salida",
	    "Sector",
	    "Sección",
	    "Senda",
	    "Solar",
	    "Subida",
	    "Terrenos",
	    "Torrente",
	    "Travesía",
	    "Urbanización",
	    "Vía",
	    "Vía Pública"
	  ],
	  "secondary_address": [
	    "Esc. ###",
	    "Puerta ###"
	  ],
	  "postcode": [
	    "#####"
	  ],
	  "province": [
	    "Álava",
	    "Albacete",
	    "Alicante",
	    "Almería",
	    "Asturias",
	    "Ávila",
	    "Badajoz",
	    "Barcelona",
	    "Burgos",
	    "Cantabria",
	    "Castellón",
	    "Ciudad Real",
	    "Cuenca",
	    "Cáceres",
	    "Cádiz",
	    "Córdoba",
	    "Gerona",
	    "Granada",
	    "Guadalajara",
	    "Guipúzcoa",
	    "Huelva",
	    "Huesca",
	    "Islas Baleares",
	    "Jaén",
	    "La Coruña",
	    "La Rioja",
	    "Las Palmas",
	    "León",
	    "Lugo",
	    "lérida",
	    "Madrid",
	    "Murcia",
	    "Málaga",
	    "Navarra",
	    "Orense",
	    "Palencia",
	    "Pontevedra",
	    "Salamanca",
	    "Santa Cruz de Tenerife",
	    "Segovia",
	    "Sevilla",
	    "Soria",
	    "Tarragona",
	    "Teruel",
	    "Toledo",
	    "Valencia",
	    "Valladolid",
	    "Vizcaya",
	    "Zamora",
	    "Zaragoza"
	  ],
	  "state": [
	    "Andalucía",
	    "Aragón",
	    "Principado de Asturias",
	    "Baleares",
	    "Canarias",
	    "Cantabria",
	    "Castilla-La Mancha",
	    "Castilla y León",
	    "Cataluña",
	    "Comunidad Valenciana",
	    "Extremadura",
	    "Galicia",
	    "La Rioja",
	    "Comunidad de Madrid",
	    "Navarra",
	    "País Vasco",
	    "Región de Murcia"
	  ],
	  "state_abbr": [
	    "And",
	    "Ara",
	    "Ast",
	    "Bal",
	    "Can",
	    "Cbr",
	    "Man",
	    "Leo",
	    "Cat",
	    "Com",
	    "Ext",
	    "Gal",
	    "Rio",
	    "Mad",
	    "Nav",
	    "Vas",
	    "Mur"
	  ],
	  "time_zone": [
	    "Pacífico/Midway",
	    "Pacífico/Pago_Pago",
	    "Pacífico/Honolulu",
	    "America/Juneau",
	    "America/Los_Angeles",
	    "America/Tijuana",
	    "America/Denver",
	    "America/Phoenix",
	    "America/Chihuahua",
	    "America/Mazatlan",
	    "America/Chicago",
	    "America/Regina",
	    "America/Mexico_City",
	    "America/Mexico_City",
	    "America/Monterrey",
	    "America/Guatemala",
	    "America/New_York",
	    "America/Indiana/Indianapolis",
	    "America/Bogota",
	    "America/Lima",
	    "America/Lima",
	    "America/Halifax",
	    "America/Caracas",
	    "America/La_Paz",
	    "America/Santiago",
	    "America/St_Johns",
	    "America/Sao_Paulo",
	    "America/Argentina/Buenos_Aires",
	    "America/Guyana",
	    "America/Godthab",
	    "Atlantic/South_Georgia",
	    "Atlantic/Azores",
	    "Atlantic/Cape_Verde",
	    "Europa/Dublin",
	    "Europa/London",
	    "Europa/Lisbon",
	    "Europa/London",
	    "Africa/Casablanca",
	    "Africa/Monrovia",
	    "Etc/UTC",
	    "Europa/Belgrade",
	    "Europa/Bratislava",
	    "Europa/Budapest",
	    "Europa/Ljubljana",
	    "Europa/Prague",
	    "Europa/Sarajevo",
	    "Europa/Skopje",
	    "Europa/Warsaw",
	    "Europa/Zagreb",
	    "Europa/Brussels",
	    "Europa/Copenhagen",
	    "Europa/Madrid",
	    "Europa/Paris",
	    "Europa/Amsterdam",
	    "Europa/Berlin",
	    "Europa/Berlin",
	    "Europa/Rome",
	    "Europa/Stockholm",
	    "Europa/Vienna",
	    "Africa/Algiers",
	    "Europa/Bucharest",
	    "Africa/Cairo",
	    "Europa/Helsinki",
	    "Europa/Kiev",
	    "Europa/Riga",
	    "Europa/Sofia",
	    "Europa/Tallinn",
	    "Europa/Vilnius",
	    "Europa/Athens",
	    "Europa/Istanbul",
	    "Europa/Minsk",
	    "Asia/Jerusalen",
	    "Africa/Harare",
	    "Africa/Johannesburg",
	    "Europa/Moscú",
	    "Europa/Moscú",
	    "Europa/Moscú",
	    "Asia/Kuwait",
	    "Asia/Riyadh",
	    "Africa/Nairobi",
	    "Asia/Baghdad",
	    "Asia/Tehran",
	    "Asia/Muscat",
	    "Asia/Muscat",
	    "Asia/Baku",
	    "Asia/Tbilisi",
	    "Asia/Yerevan",
	    "Asia/Kabul",
	    "Asia/Yekaterinburg",
	    "Asia/Karachi",
	    "Asia/Karachi",
	    "Asia/Tashkent",
	    "Asia/Kolkata",
	    "Asia/Kolkata",
	    "Asia/Kolkata",
	    "Asia/Kolkata",
	    "Asia/Kathmandu",
	    "Asia/Dhaka",
	    "Asia/Dhaka",
	    "Asia/Colombo",
	    "Asia/Almaty",
	    "Asia/Novosibirsk",
	    "Asia/Rangoon",
	    "Asia/Bangkok",
	    "Asia/Bangkok",
	    "Asia/Jakarta",
	    "Asia/Krasnoyarsk",
	    "Asia/Shanghai",
	    "Asia/Chongqing",
	    "Asia/Hong_Kong",
	    "Asia/Urumqi",
	    "Asia/Kuala_Lumpur",
	    "Asia/Singapore",
	    "Asia/Taipei",
	    "Australia/Perth",
	    "Asia/Irkutsk",
	    "Asia/Ulaanbaatar",
	    "Asia/Seoul",
	    "Asia/Tokyo",
	    "Asia/Tokyo",
	    "Asia/Tokyo",
	    "Asia/Yakutsk",
	    "Australia/Darwin",
	    "Australia/Adelaide",
	    "Australia/Melbourne",
	    "Australia/Melbourne",
	    "Australia/Sydney",
	    "Australia/Brisbane",
	    "Australia/Hobart",
	    "Asia/Vladivostok",
	    "Pacífico/Guam",
	    "Pacífico/Port_Moresby",
	    "Asia/Magadan",
	    "Asia/Magadan",
	    "Pacífico/Noumea",
	    "Pacífico/Fiji",
	    "Asia/Kamchatka",
	    "Pacífico/Majuro",
	    "Pacífico/Auckland",
	    "Pacífico/Auckland",
	    "Pacífico/Tongatapu",
	    "Pacífico/Fakaofo",
	    "Pacífico/Apia"
	  ],
	  "city": [
	    "#{city_prefix}"
	  ],
	  "street_name": [
	    "#{street_suffix} #{Name.first_name}",
	    "#{street_suffix} #{Name.first_name} #{Name.last_name}"
	  ],
	  "street_address": [
	    "#{street_name}#{building_number}",
	    "#{street_name}#{building_number} #{secondary_address}"
	  ],
	  "default_country": [
	    "España"
	  ]
	};
	es.company = {
	  "suffix": [
	    "S.L.",
	    "e Hijos",
	    "S.A.",
	    "Hermanos"
	  ],
	  "noun": [
	      "habilidad",
	      "acceso",
	      "adaptador",
	      "algoritmo",
	      "alianza",
	      "analista",
	      "aplicación",
	      "enfoque",
	      "arquitectura",
	      "archivo",
	      "inteligencia artificial",
	      "array",
	      "actitud",
	      "medición",
	      "gestión presupuestaria",
	      "capacidad",
	      "desafío",
	      "circuito",
	      "colaboración",
	      "complejidad",
	      "concepto",
	      "conglomeración",
	      "contingencia",
	      "núcleo",
	      "fidelidad",
	      "base de datos",
	      "data-warehouse",
	      "definición",
	      "emulación",
	      "codificar",
	      "encriptar",
	      "extranet",
	      "firmware",
	      "flexibilidad",
	      "focus group",
	      "previsión",
	      "base de trabajo",
	      "función",
	      "funcionalidad",
	      "Interfaz Gráfica",
	      "groupware",
	      "Interfaz gráfico de usuario",
	      "hardware",
	      "Soporte",
	      "jerarquía",
	      "conjunto",
	      "implementación",
	      "infraestructura",
	      "iniciativa",
	      "instalación",
	      "conjunto de instrucciones",
	      "interfaz",
	      "intranet",
	      "base del conocimiento",
	      "red de area local",
	      "aprovechar",
	      "matrices",
	      "metodologías",
	      "middleware",
	      "migración",
	      "modelo",
	      "moderador",
	      "monitorizar",
	      "arquitectura abierta",
	      "sistema abierto",
	      "orquestar",
	      "paradigma",
	      "paralelismo",
	      "política",
	      "portal",
	      "estructura de precios",
	      "proceso de mejora",
	      "producto",
	      "productividad",
	      "proyecto",
	      "proyección",
	      "protocolo",
	      "línea segura",
	      "software",
	      "solución",
	      "estandardización",
	      "estrategia",
	      "estructura",
	      "éxito",
	      "superestructura",
	      "soporte",
	      "sinergia",
	      "mediante",
	      "marco de tiempo",
	      "caja de herramientas",
	      "utilización",
	      "website",
	      "fuerza de trabajo"
	    ],
	    "descriptor": [
	      "24 horas",
	      "24/7",
	      "3rd generación",
	      "4th generación",
	      "5th generación",
	      "6th generación",
	      "analizada",
	      "asimétrica",
	      "asíncrona",
	      "monitorizada por red",
	      "bidireccional",
	      "bifurcada",
	      "generada por el cliente",
	      "cliente servidor",
	      "coherente",
	      "cohesiva",
	      "compuesto",
	      "sensible al contexto",
	      "basado en el contexto",
	      "basado en contenido",
	      "dedicada",
	      "generado por la demanda",
	      "didactica",
	      "direccional",
	      "discreta",
	      "dinámica",
	      "potenciada",
	      "acompasada",
	      "ejecutiva",
	      "explícita",
	      "tolerante a fallos",
	      "innovadora",
	      "amplio ábanico",
	      "global",
	      "heurística",
	      "alto nivel",
	      "holística",
	      "homogénea",
	      "hibrida",
	      "incremental",
	      "intangible",
	      "interactiva",
	      "intermedia",
	      "local",
	      "logística",
	      "maximizada",
	      "metódica",
	      "misión crítica",
	      "móbil",
	      "modular",
	      "motivadora",
	      "multimedia",
	      "multiestado",
	      "multitarea",
	      "nacional",
	      "basado en necesidades",
	      "neutral",
	      "nueva generación",
	      "no-volátil",
	      "orientado a objetos",
	      "óptima",
	      "optimizada",
	      "radical",
	      "tiempo real",
	      "recíproca",
	      "regional",
	      "escalable",
	      "secundaria",
	      "orientada a soluciones",
	      "estable",
	      "estatica",
	      "sistemática",
	      "sistémica",
	      "tangible",
	      "terciaria",
	      "transicional",
	      "uniforme",
	      "valor añadido",
	      "vía web",
	      "defectos cero",
	      "tolerancia cero"
	    ],
	    "adjective": [
	      "Adaptativo",
	      "Avanzado",
	      "Asimilado",
	      "Automatizado",
	      "Equilibrado",
	      "Centrado en el negocio",
	      "Centralizado",
	      "Clonado",
	      "Compatible",
	      "Configurable",
	      "Multi grupo",
	      "Multi plataforma",
	      "Centrado en el usuario",
	      "Configurable",
	      "Descentralizado",
	      "Digitalizado",
	      "Distribuido",
	      "Diverso",
	      "Reducido",
	      "Mejorado",
	      "Para toda la empresa",
	      "Ergonomico",
	      "Exclusivo",
	      "Expandido",
	      "Extendido",
	      "Cara a cara",
	      "Enfocado",
	      "Totalmente configurable",
	      "Fundamental",
	      "Orígenes",
	      "Horizontal",
	      "Implementado",
	      "Innovador",
	      "Integrado",
	      "Intuitivo",
	      "Inverso",
	      "Gestionado",
	      "Obligatorio",
	      "Monitorizado",
	      "Multi canal",
	      "Multi lateral",
	      "Multi capa",
	      "En red",
	      "Orientado a objetos",
	      "Open-source",
	      "Operativo",
	      "Optimizado",
	      "Opcional",
	      "Organico",
	      "Organizado",
	      "Perseverando",
	      "Persistente",
	      "en fases",
	      "Polarizado",
	      "Pre-emptivo",
	      "Proactivo",
	      "Enfocado a benficios",
	      "Profundo",
	      "Programable",
	      "Progresivo",
	      "Public-key",
	      "Enfocado en la calidad",
	      "Reactivo",
	      "Realineado",
	      "Re-contextualizado",
	      "Re-implementado",
	      "Reducido",
	      "Ingenieria inversa",
	      "Robusto",
	      "Fácil",
	      "Seguro",
	      "Auto proporciona",
	      "Compartible",
	      "Intercambiable",
	      "Sincronizado",
	      "Orientado a equipos",
	      "Total",
	      "Universal",
	      "Mejorado",
	      "Actualizable",
	      "Centrado en el usuario",
	      "Amigable",
	      "Versatil",
	      "Virtual",
	      "Visionario"
	  ],
	  "name": [
	    "#{Name.last_name} #{suffix}",
	    "#{Name.last_name} y #{Name.last_name}",
	    "#{Name.last_name} #{Name.last_name} #{suffix}",
	    "#{Name.last_name}, #{Name.last_name} y #{Name.last_name} Asociados"
	  ]
	};
	es.internet = {
	  "free_email": [
	    "gmail.com",
	    "yahoo.com",
	    "hotmail.com"
	  ],
	  "domain_suffix": [
	    "com",
	    "es",
	    "info",
	    "com.es",
	    "org"
	  ]
	};
	es.name = {
	  "first_name": [
	    "Adán",
	    "Agustín",
	    "Alberto",
	    "Alejandro",
	    "Alfonso",
	    "Alfredo",
	    "Andrés",
	    "Antonio",
	    "Armando",
	    "Arturo",
	    "Benito",
	    "Benjamín",
	    "Bernardo",
	    "Carlos",
	    "César",
	    "Claudio",
	    "Clemente",
	    "Cristian",
	    "Cristobal",
	    "Daniel",
	    "David",
	    "Diego",
	    "Eduardo",
	    "Emilio",
	    "Enrique",
	    "Ernesto",
	    "Esteban",
	    "Federico",
	    "Felipe",
	    "Fernando",
	    "Francisco",
	    "Gabriel",
	    "Gerardo",
	    "Germán",
	    "Gilberto",
	    "Gonzalo",
	    "Gregorio",
	    "Guillermo",
	    "Gustavo",
	    "Hernán",
	    "Homero",
	    "Horacio",
	    "Hugo",
	    "Ignacio",
	    "Jacobo",
	    "Jaime",
	    "Javier",
	    "Jerónimo",
	    "Jesús",
	    "Joaquín",
	    "Jorge",
	    "Jorge Luis",
	    "José",
	    "José Eduardo",
	    "José Emilio",
	    "José Luis",
	    "José María",
	    "Juan",
	    "Juan Carlos",
	    "Julio",
	    "Julio César",
	    "Lorenzo",
	    "Lucas",
	    "Luis",
	    "Luis Miguel",
	    "Manuel",
	    "Marco Antonio",
	    "Marcos",
	    "Mariano",
	    "Mario",
	    "Martín",
	    "Mateo",
	    "Miguel",
	    "Miguel Ángel",
	    "Nicolás",
	    "Octavio",
	    "Óscar",
	    "Pablo",
	    "Patricio",
	    "Pedro",
	    "Rafael",
	    "Ramiro",
	    "Ramón",
	    "Raúl",
	    "Ricardo",
	    "Roberto",
	    "Rodrigo",
	    "Rubén",
	    "Salvador",
	    "Samuel",
	    "Sancho",
	    "Santiago",
	    "Sergio",
	    "Teodoro",
	    "Timoteo",
	    "Tomás",
	    "Vicente",
	    "Víctor",
	    "Adela",
	    "Adriana",
	    "Alejandra",
	    "Alicia",
	    "Amalia",
	    "Ana",
	    "Ana Luisa",
	    "Ana María",
	    "Andrea",
	    "Anita",
	    "Ángela",
	    "Antonia",
	    "Ariadna",
	    "Barbara",
	    "Beatriz",
	    "Berta",
	    "Blanca",
	    "Caridad",
	    "Carla",
	    "Carlota",
	    "Carmen",
	    "Carolina",
	    "Catalina",
	    "Cecilia",
	    "Clara",
	    "Claudia",
	    "Concepción",
	    "Conchita",
	    "Cristina",
	    "Daniela",
	    "Débora",
	    "Diana",
	    "Dolores",
	    "Lola",
	    "Dorotea",
	    "Elena",
	    "Elisa",
	    "Eloisa",
	    "Elsa",
	    "Elvira",
	    "Emilia",
	    "Esperanza",
	    "Estela",
	    "Ester",
	    "Eva",
	    "Florencia",
	    "Francisca",
	    "Gabriela",
	    "Gloria",
	    "Graciela",
	    "Guadalupe",
	    "Guillermina",
	    "Inés",
	    "Irene",
	    "Isabel",
	    "Isabela",
	    "Josefina",
	    "Juana",
	    "Julia",
	    "Laura",
	    "Leonor",
	    "Leticia",
	    "Lilia",
	    "Lorena",
	    "Lourdes",
	    "Lucia",
	    "Luisa",
	    "Luz",
	    "Magdalena",
	    "Manuela",
	    "Marcela",
	    "Margarita",
	    "María",
	    "María del Carmen",
	    "María Cristina",
	    "María Elena",
	    "María Eugenia",
	    "María José",
	    "María Luisa",
	    "María Soledad",
	    "María Teresa",
	    "Mariana",
	    "Maricarmen",
	    "Marilu",
	    "Marisol",
	    "Marta",
	    "Mayte",
	    "Mercedes",
	    "Micaela",
	    "Mónica",
	    "Natalia",
	    "Norma",
	    "Olivia",
	    "Patricia",
	    "Pilar",
	    "Ramona",
	    "Raquel",
	    "Rebeca",
	    "Reina",
	    "Rocio",
	    "Rosa",
	    "Rosalia",
	    "Rosario",
	    "Sara",
	    "Silvia",
	    "Sofia",
	    "Soledad",
	    "Sonia",
	    "Susana",
	    "Teresa",
	    "Verónica",
	    "Victoria",
	    "Virginia",
	    "Yolanda"
	  ],
	  "last_name": [
	    "Abeyta",
	    "Abrego",
	    "Abreu",
	    "Acevedo",
	    "Acosta",
	    "Acuña",
	    "Adame",
	    "Adorno",
	    "Agosto",
	    "Aguayo",
	    "Águilar",
	    "Aguilera",
	    "Aguirre",
	    "Alanis",
	    "Alaniz",
	    "Alarcón",
	    "Alba",
	    "Alcala",
	    "Alcántar",
	    "Alcaraz",
	    "Alejandro",
	    "Alemán",
	    "Alfaro",
	    "Alicea",
	    "Almanza",
	    "Almaraz",
	    "Almonte",
	    "Alonso",
	    "Alonzo",
	    "Altamirano",
	    "Alva",
	    "Alvarado",
	    "Alvarez",
	    "Amador",
	    "Amaya",
	    "Anaya",
	    "Anguiano",
	    "Angulo",
	    "Aparicio",
	    "Apodaca",
	    "Aponte",
	    "Aragón",
	    "Araña",
	    "Aranda",
	    "Arce",
	    "Archuleta",
	    "Arellano",
	    "Arenas",
	    "Arevalo",
	    "Arguello",
	    "Arias",
	    "Armas",
	    "Armendáriz",
	    "Armenta",
	    "Armijo",
	    "Arredondo",
	    "Arreola",
	    "Arriaga",
	    "Arroyo",
	    "Arteaga",
	    "Atencio",
	    "Ávalos",
	    "Ávila",
	    "Avilés",
	    "Ayala",
	    "Baca",
	    "Badillo",
	    "Báez",
	    "Baeza",
	    "Bahena",
	    "Balderas",
	    "Ballesteros",
	    "Banda",
	    "Bañuelos",
	    "Barajas",
	    "Barela",
	    "Barragán",
	    "Barraza",
	    "Barrera",
	    "Barreto",
	    "Barrientos",
	    "Barrios",
	    "Batista",
	    "Becerra",
	    "Beltrán",
	    "Benavides",
	    "Benavídez",
	    "Benítez",
	    "Bermúdez",
	    "Bernal",
	    "Berríos",
	    "Bétancourt",
	    "Blanco",
	    "Bonilla",
	    "Borrego",
	    "Botello",
	    "Bravo",
	    "Briones",
	    "Briseño",
	    "Brito",
	    "Bueno",
	    "Burgos",
	    "Bustamante",
	    "Bustos",
	    "Caballero",
	    "Cabán",
	    "Cabrera",
	    "Cadena",
	    "Caldera",
	    "Calderón",
	    "Calvillo",
	    "Camacho",
	    "Camarillo",
	    "Campos",
	    "Canales",
	    "Candelaria",
	    "Cano",
	    "Cantú",
	    "Caraballo",
	    "Carbajal",
	    "Cardenas",
	    "Cardona",
	    "Carmona",
	    "Carranza",
	    "Carrasco",
	    "Carrasquillo",
	    "Carreón",
	    "Carrera",
	    "Carrero",
	    "Carrillo",
	    "Carrion",
	    "Carvajal",
	    "Casanova",
	    "Casares",
	    "Casárez",
	    "Casas",
	    "Casillas",
	    "Castañeda",
	    "Castellanos",
	    "Castillo",
	    "Castro",
	    "Cavazos",
	    "Cazares",
	    "Ceballos",
	    "Cedillo",
	    "Ceja",
	    "Centeno",
	    "Cepeda",
	    "Cerda",
	    "Cervantes",
	    "Cervántez",
	    "Chacón",
	    "Chapa",
	    "Chavarría",
	    "Chávez",
	    "Cintrón",
	    "Cisneros",
	    "Collado",
	    "Collazo",
	    "Colón",
	    "Colunga",
	    "Concepción",
	    "Contreras",
	    "Cordero",
	    "Córdova",
	    "Cornejo",
	    "Corona",
	    "Coronado",
	    "Corral",
	    "Corrales",
	    "Correa",
	    "Cortés",
	    "Cortez",
	    "Cotto",
	    "Covarrubias",
	    "Crespo",
	    "Cruz",
	    "Cuellar",
	    "Curiel",
	    "Dávila",
	    "de Anda",
	    "de Jesús",
	    "Delacrúz",
	    "Delafuente",
	    "Delagarza",
	    "Delao",
	    "Delapaz",
	    "Delarosa",
	    "Delatorre",
	    "Deleón",
	    "Delgadillo",
	    "Delgado",
	    "Delrío",
	    "Delvalle",
	    "Díaz",
	    "Domínguez",
	    "Domínquez",
	    "Duarte",
	    "Dueñas",
	    "Duran",
	    "Echevarría",
	    "Elizondo",
	    "Enríquez",
	    "Escalante",
	    "Escamilla",
	    "Escobar",
	    "Escobedo",
	    "Esparza",
	    "Espinal",
	    "Espino",
	    "Espinosa",
	    "Espinoza",
	    "Esquibel",
	    "Esquivel",
	    "Estévez",
	    "Estrada",
	    "Fajardo",
	    "Farías",
	    "Feliciano",
	    "Fernández",
	    "Ferrer",
	    "Fierro",
	    "Figueroa",
	    "Flores",
	    "Flórez",
	    "Fonseca",
	    "Franco",
	    "Frías",
	    "Fuentes",
	    "Gaitán",
	    "Galarza",
	    "Galindo",
	    "Gallardo",
	    "Gallegos",
	    "Galván",
	    "Gálvez",
	    "Gamboa",
	    "Gamez",
	    "Gaona",
	    "Garay",
	    "García",
	    "Garibay",
	    "Garica",
	    "Garrido",
	    "Garza",
	    "Gastélum",
	    "Gaytán",
	    "Gil",
	    "Girón",
	    "Godínez",
	    "Godoy",
	    "Gómez",
	    "Gonzales",
	    "González",
	    "Gollum",
	    "Gracia",
	    "Granado",
	    "Granados",
	    "Griego",
	    "Grijalva",
	    "Guajardo",
	    "Guardado",
	    "Guerra",
	    "Guerrero",
	    "Guevara",
	    "Guillen",
	    "Gurule",
	    "Gutiérrez",
	    "Guzmán",
	    "Haro",
	    "Henríquez",
	    "Heredia",
	    "Hernádez",
	    "Hernandes",
	    "Hernández",
	    "Herrera",
	    "Hidalgo",
	    "Hinojosa",
	    "Holguín",
	    "Huerta",
	    "Hurtado",
	    "Ibarra",
	    "Iglesias",
	    "Irizarry",
	    "Jaime",
	    "Jaimes",
	    "Jáquez",
	    "Jaramillo",
	    "Jasso",
	    "Jiménez",
	    "Jimínez",
	    "Juárez",
	    "Jurado",
	    "Laboy",
	    "Lara",
	    "Laureano",
	    "Leal",
	    "Lebrón",
	    "Ledesma",
	    "Leiva",
	    "Lemus",
	    "León",
	    "Lerma",
	    "Leyva",
	    "Limón",
	    "Linares",
	    "Lira",
	    "Llamas",
	    "Loera",
	    "Lomeli",
	    "Longoria",
	    "López",
	    "Lovato",
	    "Loya",
	    "Lozada",
	    "Lozano",
	    "Lucero",
	    "Lucio",
	    "Luevano",
	    "Lugo",
	    "Luna",
	    "Macías",
	    "Madera",
	    "Madrid",
	    "Madrigal",
	    "Maestas",
	    "Magaña",
	    "Malave",
	    "Maldonado",
	    "Manzanares",
	    "Mares",
	    "Marín",
	    "Márquez",
	    "Marrero",
	    "Marroquín",
	    "Martínez",
	    "Mascareñas",
	    "Mata",
	    "Mateo",
	    "Matías",
	    "Matos",
	    "Maya",
	    "Mayorga",
	    "Medina",
	    "Medrano",
	    "Mejía",
	    "Meléndez",
	    "Melgar",
	    "Mena",
	    "Menchaca",
	    "Méndez",
	    "Mendoza",
	    "Menéndez",
	    "Meraz",
	    "Mercado",
	    "Merino",
	    "Mesa",
	    "Meza",
	    "Miramontes",
	    "Miranda",
	    "Mireles",
	    "Mojica",
	    "Molina",
	    "Mondragón",
	    "Monroy",
	    "Montalvo",
	    "Montañez",
	    "Montaño",
	    "Montemayor",
	    "Montenegro",
	    "Montero",
	    "Montes",
	    "Montez",
	    "Montoya",
	    "Mora",
	    "Morales",
	    "Moreno",
	    "Mota",
	    "Moya",
	    "Munguía",
	    "Muñiz",
	    "Muñoz",
	    "Murillo",
	    "Muro",
	    "Nájera",
	    "Naranjo",
	    "Narváez",
	    "Nava",
	    "Navarrete",
	    "Navarro",
	    "Nazario",
	    "Negrete",
	    "Negrón",
	    "Nevárez",
	    "Nieto",
	    "Nieves",
	    "Niño",
	    "Noriega",
	    "Núñez",
	    "Ocampo",
	    "Ocasio",
	    "Ochoa",
	    "Ojeda",
	    "Olivares",
	    "Olivárez",
	    "Olivas",
	    "Olivera",
	    "Olivo",
	    "Olmos",
	    "Olvera",
	    "Ontiveros",
	    "Oquendo",
	    "Ordóñez",
	    "Orellana",
	    "Ornelas",
	    "Orosco",
	    "Orozco",
	    "Orta",
	    "Ortega",
	    "Ortiz",
	    "Osorio",
	    "Otero",
	    "Ozuna",
	    "Pabón",
	    "Pacheco",
	    "Padilla",
	    "Padrón",
	    "Páez",
	    "Pagan",
	    "Palacios",
	    "Palomino",
	    "Palomo",
	    "Pantoja",
	    "Paredes",
	    "Parra",
	    "Partida",
	    "Patiño",
	    "Paz",
	    "Pedraza",
	    "Pedroza",
	    "Pelayo",
	    "Peña",
	    "Perales",
	    "Peralta",
	    "Perea",
	    "Peres",
	    "Pérez",
	    "Pichardo",
	    "Piña",
	    "Pineda",
	    "Pizarro",
	    "Polanco",
	    "Ponce",
	    "Porras",
	    "Portillo",
	    "Posada",
	    "Prado",
	    "Preciado",
	    "Prieto",
	    "Puente",
	    "Puga",
	    "Pulido",
	    "Quesada",
	    "Quezada",
	    "Quiñones",
	    "Quiñónez",
	    "Quintana",
	    "Quintanilla",
	    "Quintero",
	    "Quiroz",
	    "Rael",
	    "Ramírez",
	    "Ramón",
	    "Ramos",
	    "Rangel",
	    "Rascón",
	    "Raya",
	    "Razo",
	    "Regalado",
	    "Rendón",
	    "Rentería",
	    "Reséndez",
	    "Reyes",
	    "Reyna",
	    "Reynoso",
	    "Rico",
	    "Rincón",
	    "Riojas",
	    "Ríos",
	    "Rivas",
	    "Rivera",
	    "Rivero",
	    "Robledo",
	    "Robles",
	    "Rocha",
	    "Rodarte",
	    "Rodrígez",
	    "Rodríguez",
	    "Rodríquez",
	    "Rojas",
	    "Rojo",
	    "Roldán",
	    "Rolón",
	    "Romero",
	    "Romo",
	    "Roque",
	    "Rosado",
	    "Rosales",
	    "Rosario",
	    "Rosas",
	    "Roybal",
	    "Rubio",
	    "Ruelas",
	    "Ruiz",
	    "Saavedra",
	    "Sáenz",
	    "Saiz",
	    "Salas",
	    "Salazar",
	    "Salcedo",
	    "Salcido",
	    "Saldaña",
	    "Saldivar",
	    "Salgado",
	    "Salinas",
	    "Samaniego",
	    "Sanabria",
	    "Sanches",
	    "Sánchez",
	    "Sandoval",
	    "Santacruz",
	    "Santana",
	    "Santiago",
	    "Santillán",
	    "Sarabia",
	    "Sauceda",
	    "Saucedo",
	    "Sedillo",
	    "Segovia",
	    "Segura",
	    "Sepúlveda",
	    "Serna",
	    "Serrano",
	    "Serrato",
	    "Sevilla",
	    "Sierra",
	    "Sisneros",
	    "Solano",
	    "Solís",
	    "Soliz",
	    "Solorio",
	    "Solorzano",
	    "Soria",
	    "Sosa",
	    "Sotelo",
	    "Soto",
	    "Suárez",
	    "Tafoya",
	    "Tamayo",
	    "Tamez",
	    "Tapia",
	    "Tejada",
	    "Tejeda",
	    "Téllez",
	    "Tello",
	    "Terán",
	    "Terrazas",
	    "Tijerina",
	    "Tirado",
	    "Toledo",
	    "Toro",
	    "Torres",
	    "Tórrez",
	    "Tovar",
	    "Trejo",
	    "Treviño",
	    "Trujillo",
	    "Ulibarri",
	    "Ulloa",
	    "Urbina",
	    "Ureña",
	    "Urías",
	    "Uribe",
	    "Urrutia",
	    "Vaca",
	    "Valadez",
	    "Valdés",
	    "Valdez",
	    "Valdivia",
	    "Valencia",
	    "Valentín",
	    "Valenzuela",
	    "Valladares",
	    "Valle",
	    "Vallejo",
	    "Valles",
	    "Valverde",
	    "Vanegas",
	    "Varela",
	    "Vargas",
	    "Vásquez",
	    "Vázquez",
	    "Vega",
	    "Vela",
	    "Velasco",
	    "Velásquez",
	    "Velázquez",
	    "Vélez",
	    "Véliz",
	    "Venegas",
	    "Vera",
	    "Verdugo",
	    "Verduzco",
	    "Vergara",
	    "Viera",
	    "Vigil",
	    "Villa",
	    "Villagómez",
	    "Villalobos",
	    "Villalpando",
	    "Villanueva",
	    "Villareal",
	    "Villarreal",
	    "Villaseñor",
	    "Villegas",
	    "Yáñez",
	    "Ybarra",
	    "Zambrano",
	    "Zamora",
	    "Zamudio",
	    "Zapata",
	    "Zaragoza",
	    "Zarate",
	    "Zavala",
	    "Zayas",
	    "Zelaya",
	    "Zepeda",
	    "Zúñiga"
	  ],
	  "prefix": [
	    "Sr.",
	    "Sra.",
	    "Sta."
	  ],
	  "suffix": [
	    "Jr.",
	    "Sr.",
	    "I",
	    "II",
	    "III",
	    "IV",
	    "V",
	    "MD",
	    "DDS",
	    "PhD",
	    "DVM"
	  ],
	  "title": {
	    "descriptor": [
	      "Jefe",
	      "Senior",
	      "Directo",
	      "Corporativo",
	      "Dinánmico",
	      "Futuro",
	      "Producto",
	      "Nacional",
	      "Regional",
	      "Distrito",
	      "Central",
	      "Global",
	      "Cliente",
	      "Inversor",
	      "International",
	      "Heredado",
	      "Adelante",
	      "Interno",
	      "Humano",
	      "Gerente",
	      "Director"
	    ],
	    "level": [
	      "Soluciones",
	      "Programa",
	      "Marca",
	      "Seguridada",
	      "Investigación",
	      "Marketing",
	      "Normas",
	      "Implementación",
	      "Integración",
	      "Funcionalidad",
	      "Respuesta",
	      "Paradigma",
	      "Tácticas",
	      "Identidad",
	      "Mercados",
	      "Grupo",
	      "División",
	      "Aplicaciones",
	      "Optimización",
	      "Operaciones",
	      "Infraestructura",
	      "Intranet",
	      "Comunicaciones",
	      "Web",
	      "Calidad",
	      "Seguro",
	      "Mobilidad",
	      "Cuentas",
	      "Datos",
	      "Creativo",
	      "Configuración",
	      "Contabilidad",
	      "Interacciones",
	      "Factores",
	      "Usabilidad",
	      "Métricas"
	    ],
	    "job": [
	      "Supervisor",
	      "Asociado",
	      "Ejecutivo",
	      "Relacciones",
	      "Oficial",
	      "Gerente",
	      "Ingeniero",
	      "Especialista",
	      "Director",
	      "Coordinador",
	      "Administrador",
	      "Arquitecto",
	      "Analista",
	      "Diseñador",
	      "Planificador",
	      "Técnico",
	      "Funcionario",
	      "Desarrollador",
	      "Productor",
	      "Consultor",
	      "Asistente",
	      "Facilitador",
	      "Agente",
	      "Representante",
	      "Estratega"
	    ]
	  },
	  "name": [
	    "#{prefix} #{first_name} #{last_name} #{last_name}",
	    "#{first_name} #{last_name} #{last_name}",
	    "#{first_name} #{last_name} #{last_name}",
	    "#{first_name} #{last_name} #{last_name}",
	    "#{first_name} #{last_name} #{last_name}"
	  ]
	};
	es.phone_number = {
	  "formats": [
	    "9##-###-###",
	    "9##.###.###",
	    "9## ### ###",
	    "9########"
	  ]
	};
	es.cell_phone = {
	  "formats": [
	    "6##-###-###",
	    "6##.###.###",
	    "6## ### ###",
	    "6########"
	  ]
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)(module)))

/***/ },
/* 304 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var fa = {};
	module["exports"] = fa;
	fa.title = "Farsi";
	fa.name = {
	  "first_name": [
	    "آبان دخت",
	    "آبتین",
	    "آتوسا",
	    "آفر",
	    "آفره دخت",
	    "آذرنوش‌",
	    "آذین",
	    "آراه",
	    "آرزو",
	    "آرش",
	    "آرتین",
	    "آرتام",
	    "آرتمن",
	    "آرشام",
	    "آرمان",
	    "آرمین",
	    "آرمیتا",
	    "آریا فر",
	    "آریا",
	    "آریا مهر",
	    "آرین",
	    "آزاده",
	    "آزرم",
	    "آزرمدخت",
	    "آزیتا",
	    "آناهیتا",
	    "آونگ",
	    "آهو",
	    "آیدا",
	    "اتسز",
	    "اختر",
	    "ارد",
	    "ارد شیر",
	    "اردوان",
	    "ارژن",
	    "ارژنگ",
	    "ارسلان",
	    "ارغوان",
	    "ارمغان",
	    "ارنواز",
	    "اروانه",
	    "استر",
	    "اسفندیار",
	    "اشکان",
	    "اشکبوس",
	    "افسانه",
	    "افسون",
	    "افشین",
	    "امید",
	    "انوش (‌ آنوشا )",
	    "انوشروان",
	    "اورنگ",
	    "اوژن",
	    "اوستا",
	    "اهورا",
	    "ایاز",
	    "ایران",
	    "ایراندخت",
	    "ایرج",
	    "ایزدیار",
	    "بابک",
	    "باپوک",
	    "باربد",
	    "بارمان",
	    "بامداد",
	    "بامشاد",
	    "بانو",
	    "بختیار",
	    "برانوش",
	    "بردیا",
	    "برزو",
	    "برزویه",
	    "برزین",
	    "برمک",
	    "بزرگمهر",
	    "بنفشه",
	    "بوژان",
	    "بویان",
	    "بهار",
	    "بهارک",
	    "بهاره",
	    "بهتاش",
	    "بهداد",
	    "بهرام",
	    "بهدیس",
	    "بهرخ",
	    "بهرنگ",
	    "بهروز",
	    "بهزاد",
	    "بهشاد",
	    "بهمن",
	    "بهناز",
	    "بهنام",
	    "بهنود",
	    "بهنوش",
	    "بیتا",
	    "بیژن",
	    "پارسا",
	    "پاکان",
	    "پاکتن",
	    "پاکدخت",
	    "پانته آ",
	    "پدرام",
	    "پرتو",
	    "پرشنگ",
	    "پرتو",
	    "پرستو",
	    "پرویز",
	    "پردیس",
	    "پرهام",
	    "پژمان",
	    "پژوا",
	    "پرنیا",
	    "پشنگ",
	    "پروانه",
	    "پروین",
	    "پری",
	    "پریچهر",
	    "پریدخت",
	    "پریسا",
	    "پرناز",
	    "پریوش",
	    "پریا",
	    "پوپک",
	    "پوران",
	    "پوراندخت",
	    "پوریا",
	    "پولاد",
	    "پویا",
	    "پونه",
	    "پیام",
	    "پیروز",
	    "پیمان",
	    "تابان",
	    "تاباندخت",
	    "تاجی",
	    "تارا",
	    "تاویار",
	    "ترانه",
	    "تناز",
	    "توران",
	    "توراندخت",
	    "تورج",
	    "تورتک",
	    "توفان",
	    "توژال",
	    "تیر داد",
	    "تینا",
	    "تینو",
	    "جابان",
	    "جامین",
	    "جاوید",
	    "جریره",
	    "جمشید",
	    "جوان",
	    "جویا",
	    "جهان",
	    "جهانبخت",
	    "جهانبخش",
	    "جهاندار",
	    "جهانگیر",
	    "جهان بانو",
	    "جهاندخت",
	    "جهان ناز",
	    "جیران",
	    "چابک",
	    "چالاک",
	    "چاوش",
	    "چترا",
	    "چوبین",
	    "چهرزاد",
	    "خاوردخت",
	    "خداداد",
	    "خدایار",
	    "خرم",
	    "خرمدخت",
	    "خسرو",
	    "خشایار",
	    "خورشید",
	    "دادمهر",
	    "دارا",
	    "داراب",
	    "داریا",
	    "داریوش",
	    "دانوش",
	    "داور‌",
	    "دایان",
	    "دریا",
	    "دل آرا",
	    "دل آویز",
	    "دلارام",
	    "دل انگیز",
	    "دلبر",
	    "دلبند",
	    "دلربا",
	    "دلشاد",
	    "دلکش",
	    "دلناز",
	    "دلنواز",
	    "دورشاسب",
	    "دنیا",
	    "دیااکو",
	    "دیانوش",
	    "دیبا",
	    "دیبا دخت",
	    "رابو",
	    "رابین",
	    "رادبانو",
	    "رادمان",
	    "رازبان",
	    "راژانه",
	    "راسا",
	    "رامتین",
	    "رامش",
	    "رامشگر",
	    "رامونا",
	    "رامیار",
	    "رامیلا",
	    "رامین",
	    "راویار",
	    "رژینا",
	    "رخپاک",
	    "رخسار",
	    "رخشانه",
	    "رخشنده",
	    "رزمیار",
	    "رستم",
	    "رکسانا",
	    "روبینا",
	    "رودابه",
	    "روزبه",
	    "روشنک",
	    "روناک",
	    "رهام",
	    "رهی",
	    "ریبار",
	    "راسپینا",
	    "زادبخت",
	    "زاد به",
	    "زاد چهر",
	    "زاد فر",
	    "زال",
	    "زادماسب",
	    "زاوا",
	    "زردشت",
	    "زرنگار",
	    "زری",
	    "زرین",
	    "زرینه",
	    "زمانه",
	    "زونا",
	    "زیبا",
	    "زیبار",
	    "زیما",
	    "زینو",
	    "ژاله",
	    "ژالان",
	    "ژیار",
	    "ژینا",
	    "ژیوار",
	    "سارا",
	    "سارک",
	    "سارنگ",
	    "ساره",
	    "ساسان",
	    "ساغر",
	    "سام",
	    "سامان",
	    "سانا",
	    "ساناز",
	    "سانیار",
	    "ساویز",
	    "ساهی",
	    "ساینا",
	    "سایه",
	    "سپنتا",
	    "سپند",
	    "سپهر",
	    "سپهرداد",
	    "سپیدار",
	    "سپید بانو",
	    "سپیده",
	    "ستاره",
	    "ستی",
	    "سرافراز",
	    "سرور",
	    "سروش",
	    "سرور",
	    "سوبا",
	    "سوبار",
	    "سنبله",
	    "سودابه",
	    "سوری",
	    "سورن",
	    "سورنا",
	    "سوزان",
	    "سوزه",
	    "سوسن",
	    "سومار",
	    "سولان",
	    "سولماز",
	    "سوگند",
	    "سهراب",
	    "سهره",
	    "سهند",
	    "سیامک",
	    "سیاوش",
	    "سیبوبه ‌",
	    "سیما",
	    "سیمدخت",
	    "سینا",
	    "سیمین",
	    "سیمین دخت",
	    "شاپرک",
	    "شادی",
	    "شادمهر",
	    "شاران",
	    "شاهپور",
	    "شاهدخت",
	    "شاهرخ",
	    "شاهین",
	    "شاهیندخت",
	    "شایسته",
	    "شباهنگ",
	    "شب بو",
	    "شبدیز",
	    "شبنم",
	    "شراره",
	    "شرمین",
	    "شروین",
	    "شکوفه",
	    "شکفته",
	    "شمشاد",
	    "شمین",
	    "شوان",
	    "شمیلا",
	    "شورانگیز",
	    "شوری",
	    "شهاب",
	    "شهبار",
	    "شهباز",
	    "شهبال",
	    "شهپر",
	    "شهداد",
	    "شهرآرا",
	    "شهرام",
	    "شهربانو",
	    "شهرزاد",
	    "شهرناز",
	    "شهرنوش",
	    "شهره",
	    "شهریار",
	    "شهرزاد",
	    "شهلا",
	    "شهنواز",
	    "شهین",
	    "شیبا",
	    "شیدا",
	    "شیده",
	    "شیردل",
	    "شیرزاد",
	    "شیرنگ",
	    "شیرو",
	    "شیرین دخت",
	    "شیما",
	    "شینا",
	    "شیرین",
	    "شیوا",
	    "طوس",
	    "طوطی",
	    "طهماسب",
	    "طهمورث",
	    "غوغا",
	    "غنچه",
	    "فتانه",
	    "فدا",
	    "فراز",
	    "فرامرز",
	    "فرانک",
	    "فراهان",
	    "فربد",
	    "فربغ",
	    "فرجاد",
	    "فرخ",
	    "فرخ پی",
	    "فرخ داد",
	    "فرخ رو",
	    "فرخ زاد",
	    "فرخ لقا",
	    "فرخ مهر",
	    "فرداد",
	    "فردیس",
	    "فرین",
	    "فرزاد",
	    "فرزام",
	    "فرزان",
	    "فرزانه",
	    "فرزین",
	    "فرشاد",
	    "فرشته",
	    "فرشید",
	    "فرمان",
	    "فرناز",
	    "فرنگیس",
	    "فرنود",
	    "فرنوش",
	    "فرنیا",
	    "فروتن",
	    "فرود",
	    "فروز",
	    "فروزان",
	    "فروزش",
	    "فروزنده",
	    "فروغ",
	    "فرهاد",
	    "فرهنگ",
	    "فرهود",
	    "فربار",
	    "فریبا",
	    "فرید",
	    "فریدخت",
	    "فریدون",
	    "فریمان",
	    "فریناز",
	    "فرینوش",
	    "فریوش",
	    "فیروز",
	    "فیروزه",
	    "قابوس",
	    "قباد",
	    "قدسی",
	    "کابان",
	    "کابوک",
	    "کارا",
	    "کارو",
	    "کاراکو",
	    "کامبخت",
	    "کامبخش",
	    "کامبیز",
	    "کامجو",
	    "کامدین",
	    "کامران",
	    "کامراوا",
	    "کامک",
	    "کامنوش",
	    "کامیار",
	    "کانیار",
	    "کاووس",
	    "کاوه",
	    "کتایون",
	    "کرشمه",
	    "کسری",
	    "کلاله",
	    "کمبوجیه",
	    "کوشا",
	    "کهبد",
	    "کهرام",
	    "کهزاد",
	    "کیارش",
	    "کیان",
	    "کیانا",
	    "کیانچهر",
	    "کیاندخت",
	    "کیانوش",
	    "کیاوش",
	    "کیخسرو",
	    "کیقباد",
	    "کیکاووس",
	    "کیوان",
	    "کیوان دخت",
	    "کیومرث",
	    "کیهان",
	    "کیاندخت",
	    "کیهانه",
	    "گرد آفرید",
	    "گردان",
	    "گرشا",
	    "گرشاسب",
	    "گرشین",
	    "گرگین",
	    "گزل",
	    "گشتاسب",
	    "گشسب",
	    "گشسب بانو",
	    "گل",
	    "گل آذین",
	    "گل آرا‌",
	    "گلاره",
	    "گل افروز",
	    "گلاله",
	    "گل اندام",
	    "گلاویز",
	    "گلباد",
	    "گلبار",
	    "گلبام",
	    "گلبان",
	    "گلبانو",
	    "گلبرگ",
	    "گلبو",
	    "گلبهار",
	    "گلبیز",
	    "گلپاره",
	    "گلپر",
	    "گلپری",
	    "گلپوش",
	    "گل پونه",
	    "گلچین",
	    "گلدخت",
	    "گلدیس",
	    "گلربا",
	    "گلرخ",
	    "گلرنگ",
	    "گلرو",
	    "گلشن",
	    "گلریز",
	    "گلزاد",
	    "گلزار",
	    "گلسا",
	    "گلشید",
	    "گلنار",
	    "گلناز",
	    "گلنسا",
	    "گلنواز",
	    "گلنوش",
	    "گلی",
	    "گودرز",
	    "گوماتو",
	    "گهر چهر",
	    "گوهر ناز",
	    "گیتی",
	    "گیسو",
	    "گیلدا",
	    "گیو",
	    "لادن",
	    "لاله",
	    "لاله رخ",
	    "لاله دخت",
	    "لبخند",
	    "لقاء",
	    "لومانا",
	    "لهراسب",
	    "مارال",
	    "ماری",
	    "مازیار",
	    "ماکان",
	    "مامک",
	    "مانا",
	    "ماندانا",
	    "مانوش",
	    "مانی",
	    "مانیا",
	    "ماهان",
	    "ماهاندخت",
	    "ماه برزین",
	    "ماه جهان",
	    "ماهچهر",
	    "ماهدخت",
	    "ماهور",
	    "ماهرخ",
	    "ماهزاد",
	    "مردآویز",
	    "مرداس",
	    "مرزبان",
	    "مرمر",
	    "مزدک",
	    "مژده",
	    "مژگان",
	    "مستان",
	    "مستانه",
	    "مشکاندخت",
	    "مشکناز",
	    "مشکین دخت",
	    "منیژه",
	    "منوچهر",
	    "مهبانو",
	    "مهبد",
	    "مه داد",
	    "مهتاب",
	    "مهدیس",
	    "مه جبین",
	    "مه دخت",
	    "مهر آذر",
	    "مهر آرا",
	    "مهر آسا",
	    "مهر آفاق",
	    "مهر افرین",
	    "مهرآب",
	    "مهرداد",
	    "مهر افزون",
	    "مهرام",
	    "مهران",
	    "مهراندخت",
	    "مهراندیش",
	    "مهرانفر",
	    "مهرانگیز",
	    "مهرداد",
	    "مهر دخت",
	    "مهرزاده ‌",
	    "مهرناز",
	    "مهرنوش",
	    "مهرنکار",
	    "مهرنیا",
	    "مهروز",
	    "مهری",
	    "مهریار",
	    "مهسا",
	    "مهستی",
	    "مه سیما",
	    "مهشاد",
	    "مهشید",
	    "مهنام",
	    "مهناز",
	    "مهنوش",
	    "مهوش",
	    "مهیار",
	    "مهین",
	    "مهین دخت",
	    "میترا",
	    "میخک",
	    "مینا",
	    "مینا دخت",
	    "مینو",
	    "مینودخت",
	    "مینو فر",
	    "نادر",
	    "ناز آفرین",
	    "نازبانو",
	    "نازپرور",
	    "نازچهر",
	    "نازفر",
	    "نازلی",
	    "نازی",
	    "نازیدخت",
	    "نامور",
	    "ناهید",
	    "ندا",
	    "نرسی",
	    "نرگس",
	    "نرمک",
	    "نرمین",
	    "نریمان",
	    "نسترن",
	    "نسرین",
	    "نسرین دخت",
	    "نسرین نوش",
	    "نکیسا",
	    "نگار",
	    "نگاره",
	    "نگارین",
	    "نگین",
	    "نوا",
	    "نوش",
	    "نوش آذر",
	    "نوش آور",
	    "نوشا",
	    "نوش آفرین",
	    "نوشدخت",
	    "نوشروان",
	    "نوشفر",
	    "نوشناز",
	    "نوشین",
	    "نوید",
	    "نوین",
	    "نوین دخت",
	    "نیش ا",
	    "نیک بین",
	    "نیک پی",
	    "نیک چهر",
	    "نیک خواه",
	    "نیکداد",
	    "نیکدخت",
	    "نیکدل",
	    "نیکزاد",
	    "نیلوفر",
	    "نیما",
	    "وامق",
	    "ورجاوند",
	    "وریا",
	    "وشمگیر",
	    "وهرز",
	    "وهسودان",
	    "ویدا",
	    "ویس",
	    "ویشتاسب",
	    "ویگن",
	    "هژیر",
	    "هخامنش",
	    "هربد( هیربد )",
	    "هرمز",
	    "همایون",
	    "هما",
	    "همادخت",
	    "همدم",
	    "همراز",
	    "همراه",
	    "هنگامه",
	    "هوتن",
	    "هور",
	    "هورتاش",
	    "هورچهر",
	    "هورداد",
	    "هوردخت",
	    "هورزاد",
	    "هورمند",
	    "هوروش",
	    "هوشنگ",
	    "هوشیار",
	    "هومان",
	    "هومن",
	    "هونام",
	    "هویدا",
	    "هیتاسب",
	    "هیرمند",
	    "هیما",
	    "هیوا",
	    "یادگار",
	    "یاسمن ( یاسمین )",
	    "یاشار",
	    "یاور",
	    "یزدان",
	    "یگانه",
	    "یوشیتا"
	  ],
	  "last_name": [
	    "عارف",
	    "عاشوری",
	    "عالی",
	    "عبادی",
	    "عبدالکریمی",
	    "عبدالملکی",
	    "عراقی",
	    "عزیزی",
	    "عصار",
	    "عقیلی",
	    "علم",
	    "علم‌الهدی",
	    "علی عسگری",
	    "علی‌آبادی",
	    "علیا",
	    "علی‌پور",
	    "علی‌زمانی",
	    "عنایت",
	    "غضنفری",
	    "غنی",
	    "فارسی",
	    "فاطمی",
	    "فانی",
	    "فتاحی",
	    "فرامرزی",
	    "فرج",
	    "فرشیدورد",
	    "فرمانفرمائیان",
	    "فروتن",
	    "فرهنگ",
	    "فریاد",
	    "فنایی",
	    "فنی‌زاده",
	    "فولادوند",
	    "فهمیده",
	    "قاضی",
	    "قانعی",
	    "قانونی",
	    "قمیشی",
	    "قنبری",
	    "قهرمان",
	    "قهرمانی",
	    "قهرمانیان",
	    "قهستانی",
	    "کاشی",
	    "کاکاوند",
	    "کامکار",
	    "کاملی",
	    "کاویانی",
	    "کدیور",
	    "کردبچه",
	    "کرمانی",
	    "کریمی",
	    "کلباسی",
	    "کمالی",
	    "کوشکی",
	    "کهنمویی",
	    "کیان",
	    "کیانی (نام خانوادگی)",
	    "کیمیایی",
	    "گل محمدی",
	    "گلپایگانی",
	    "گنجی",
	    "لاجوردی",
	    "لاچینی",
	    "لاهوتی",
	    "لنکرانی",
	    "لوکس",
	    "مجاهد",
	    "مجتبایی",
	    "مجتبوی",
	    "مجتهد شبستری",
	    "مجتهدی",
	    "مجرد",
	    "محجوب",
	    "محجوبی",
	    "محدثی",
	    "محمدرضایی",
	    "محمدی",
	    "مددی",
	    "مرادخانی",
	    "مرتضوی",
	    "مستوفی",
	    "مشا",
	    "مصاحب",
	    "مصباح",
	    "مصباح‌زاده",
	    "مطهری",
	    "مظفر",
	    "معارف",
	    "معروف",
	    "معین",
	    "مفتاح",
	    "مفتح",
	    "مقدم",
	    "ملایری",
	    "ملک",
	    "ملکیان",
	    "منوچهری",
	    "موحد",
	    "موسوی",
	    "موسویان",
	    "مهاجرانی",
	    "مهدی‌پور",
	    "میرباقری",
	    "میردامادی",
	    "میرزاده",
	    "میرسپاسی",
	    "میزبانی",
	    "ناظری",
	    "نامور",
	    "نجفی",
	    "ندوشن",
	    "نراقی",
	    "نعمت‌زاده",
	    "نقدی",
	    "نقیب‌زاده",
	    "نواب",
	    "نوبخت",
	    "نوبختی",
	    "نهاوندی",
	    "نیشابوری",
	    "نیلوفری",
	    "واثقی",
	    "واعظ",
	    "واعظ‌زاده",
	    "واعظی",
	    "وکیلی",
	    "هاشمی",
	    "هاشمی رفسنجانی",
	    "هاشمیان",
	    "هامون",
	    "هدایت",
	    "هراتی",
	    "هروی",
	    "همایون",
	    "همت",
	    "همدانی",
	    "هوشیار",
	    "هومن",
	    "یاحقی",
	    "یادگار",
	    "یثربی",
	    "یلدا"
	  ],
	  "prefix": [
	    "آقای",
	    "خانم",
	    "دکتر"
	  ]
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)(module)))

/***/ },
/* 305 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var fr = {};
	module["exports"] = fr;
	fr.title = "French";
	fr.address = {
	  "building_number": [
	    "####",
	    "###",
	    "##",
	    "#"
	  ],
	  "street_prefix": [
	    "Allée, Voie",
	    "Rue",
	    "Avenue",
	    "Boulevard",
	    "Quai",
	    "Passage",
	    "Impasse",
	    "Place"
	  ],
	  "secondary_address": [
	    "Apt. ###",
	    "# étage"
	  ],
	  "postcode": [
	    "#####"
	  ],
	  "state": [
	    "Alsace",
	    "Aquitaine",
	    "Auvergne",
	    "Basse-Normandie",
	    "Bourgogne",
	    "Bretagne",
	    "Centre",
	    "Champagne-Ardenne",
	    "Corse",
	    "Franche-Comté",
	    "Haute-Normandie",
	    "Île-de-France",
	    "Languedoc-Roussillon",
	    "Limousin",
	    "Lorraine",
	    "Midi-Pyrénées",
	    "Nord-Pas-de-Calais",
	    "Pays de la Loire",
	    "Picardie",
	    "Poitou-Charentes",
	    "Provence-Alpes-Côte d'Azur",
	    "Rhône-Alpes"
	  ],
	  "city_name": [
	    "Paris",
	    "Marseille",
	    "Lyon",
	    "Toulouse",
	    "Nice",
	    "Nantes",
	    "Strasbourg",
	    "Montpellier",
	    "Bordeaux",
	    "Lille13",
	    "Rennes",
	    "Reims",
	    "Le Havre",
	    "Saint-Étienne",
	    "Toulon",
	    "Grenoble",
	    "Dijon",
	    "Angers",
	    "Saint-Denis",
	    "Villeurbanne",
	    "Le Mans",
	    "Aix-en-Provence",
	    "Brest",
	    "Nîmes",
	    "Limoges",
	    "Clermont-Ferrand",
	    "Tours",
	    "Amiens",
	    "Metz",
	    "Perpignan",
	    "Besançon",
	    "Orléans",
	    "Boulogne-Billancourt",
	    "Mulhouse",
	    "Rouen",
	    "Caen",
	    "Nancy",
	    "Saint-Denis",
	    "Saint-Paul",
	    "Montreuil",
	    "Argenteuil",
	    "Roubaix",
	    "Dunkerque14",
	    "Tourcoing",
	    "Nanterre",
	    "Avignon",
	    "Créteil",
	    "Poitiers",
	    "Fort-de-France",
	    "Courbevoie",
	    "Versailles",
	    "Vitry-sur-Seine",
	    "Colombes",
	    "Pau",
	    "Aulnay-sous-Bois",
	    "Asnières-sur-Seine",
	    "Rueil-Malmaison",
	    "Saint-Pierre",
	    "Antibes",
	    "Saint-Maur-des-Fossés",
	    "Champigny-sur-Marne",
	    "La Rochelle",
	    "Aubervilliers",
	    "Calais",
	    "Cannes",
	    "Le Tampon",
	    "Béziers",
	    "Colmar",
	    "Bourges",
	    "Drancy",
	    "Mérignac",
	    "Saint-Nazaire",
	    "Valence",
	    "Ajaccio",
	    "Issy-les-Moulineaux",
	    "Villeneuve-d'Ascq",
	    "Levallois-Perret",
	    "Noisy-le-Grand",
	    "Quimper",
	    "La Seyne-sur-Mer",
	    "Antony",
	    "Troyes",
	    "Neuilly-sur-Seine",
	    "Sarcelles",
	    "Les Abymes",
	    "Vénissieux",
	    "Clichy",
	    "Lorient",
	    "Pessac",
	    "Ivry-sur-Seine",
	    "Cergy",
	    "Cayenne",
	    "Niort",
	    "Chambéry",
	    "Montauban",
	    "Saint-Quentin",
	    "Villejuif",
	    "Hyères",
	    "Beauvais",
	    "Cholet"
	  ],
	  "city": [
	    "#{city_name}"
	  ],
	  "street_suffix": [
	    "de l'Abbaye",
	    "Adolphe Mille",
	    "d'Alésia",
	    "d'Argenteuil",
	    "d'Assas",
	    "du Bac",
	    "de Paris",
	    "La Boétie",
	    "Bonaparte",
	    "de la Bûcherie",
	    "de Caumartin",
	    "Charlemagne",
	    "du Chat-qui-Pêche",
	    "de la Chaussée-d'Antin",
	    "du Dahomey",
	    "Dauphine",
	    "Delesseux",
	    "du Faubourg Saint-Honoré",
	    "du Faubourg-Saint-Denis",
	    "de la Ferronnerie",
	    "des Francs-Bourgeois",
	    "des Grands Augustins",
	    "de la Harpe",
	    "du Havre",
	    "de la Huchette",
	    "Joubert",
	    "Laffitte",
	    "Lepic",
	    "des Lombards",
	    "Marcadet",
	    "Molière",
	    "Monsieur-le-Prince",
	    "de Montmorency",
	    "Montorgueil",
	    "Mouffetard",
	    "de Nesle",
	    "Oberkampf",
	    "de l'Odéon",
	    "d'Orsel",
	    "de la Paix",
	    "des Panoramas",
	    "Pastourelle",
	    "Pierre Charron",
	    "de la Pompe",
	    "de Presbourg",
	    "de Provence",
	    "de Richelieu",
	    "de Rivoli",
	    "des Rosiers",
	    "Royale",
	    "d'Abbeville",
	    "Saint-Honoré",
	    "Saint-Bernard",
	    "Saint-Denis",
	    "Saint-Dominique",
	    "Saint-Jacques",
	    "Saint-Séverin",
	    "des Saussaies",
	    "de Seine",
	    "de Solférino",
	    "Du Sommerard",
	    "de Tilsitt",
	    "Vaneau",
	    "de Vaugirard",
	    "de la Victoire",
	    "Zadkine"
	  ],
	  "street_name": [
	    "#{street_prefix} #{street_suffix}"
	  ],
	  "street_address": [
	    "#{building_number} #{street_name}"
	  ],
	  "default_country": [
	    "France"
	  ]
	};
	fr.company = {
	  "suffix": [
	    "SARL",
	    "SA",
	    "EURL",
	    "SAS",
	    "SEM",
	    "SCOP",
	    "GIE",
	    "EI"
	  ],
	  "adjective": [
	      "Adaptive",
	      "Advanced",
	      "Ameliorated",
	      "Assimilated",
	      "Automated",
	      "Balanced",
	      "Business-focused",
	      "Centralized",
	      "Cloned",
	      "Compatible",
	      "Configurable",
	      "Cross-group",
	      "Cross-platform",
	      "Customer-focused",
	      "Customizable",
	      "Decentralized",
	      "De-engineered",
	      "Devolved",
	      "Digitized",
	      "Distributed",
	      "Diverse",
	      "Down-sized",
	      "Enhanced",
	      "Enterprise-wide",
	      "Ergonomic",
	      "Exclusive",
	      "Expanded",
	      "Extended",
	      "Face to face",
	      "Focused",
	      "Front-line",
	      "Fully-configurable",
	      "Function-based",
	      "Fundamental",
	      "Future-proofed",
	      "Grass-roots",
	      "Horizontal",
	      "Implemented",
	      "Innovative",
	      "Integrated",
	      "Intuitive",
	      "Inverse",
	      "Managed",
	      "Mandatory",
	      "Monitored",
	      "Multi-channelled",
	      "Multi-lateral",
	      "Multi-layered",
	      "Multi-tiered",
	      "Networked",
	      "Object-based",
	      "Open-architected",
	      "Open-source",
	      "Operative",
	      "Optimized",
	      "Optional",
	      "Organic",
	      "Organized",
	      "Persevering",
	      "Persistent",
	      "Phased",
	      "Polarised",
	      "Pre-emptive",
	      "Proactive",
	      "Profit-focused",
	      "Profound",
	      "Programmable",
	      "Progressive",
	      "Public-key",
	      "Quality-focused",
	      "Reactive",
	      "Realigned",
	      "Re-contextualized",
	      "Re-engineered",
	      "Reduced",
	      "Reverse-engineered",
	      "Right-sized",
	      "Robust",
	      "Seamless",
	      "Secured",
	      "Self-enabling",
	      "Sharable",
	      "Stand-alone",
	      "Streamlined",
	      "Switchable",
	      "Synchronised",
	      "Synergistic",
	      "Synergized",
	      "Team-oriented",
	      "Total",
	      "Triple-buffered",
	      "Universal",
	      "Up-sized",
	      "Upgradable",
	      "User-centric",
	      "User-friendly",
	      "Versatile",
	      "Virtual",
	      "Visionary",
	      "Vision-oriented"
	    ],
	    "descriptor":
	    [
	      "24 hour",
	      "24/7",
	      "3rd generation",
	      "4th generation",
	      "5th generation",
	      "6th generation",
	      "actuating",
	      "analyzing",
	      "asymmetric",
	      "asynchronous",
	      "attitude-oriented",
	      "background",
	      "bandwidth-monitored",
	      "bi-directional",
	      "bifurcated",
	      "bottom-line",
	      "clear-thinking",
	      "client-driven",
	      "client-server",
	      "coherent",
	      "cohesive",
	      "composite",
	      "context-sensitive",
	      "contextually-based",
	      "content-based",
	      "dedicated",
	      "demand-driven",
	      "didactic",
	      "directional",
	      "discrete",
	      "disintermediate",
	      "dynamic",
	      "eco-centric",
	      "empowering",
	      "encompassing",
	      "even-keeled",
	      "executive",
	      "explicit",
	      "exuding",
	      "fault-tolerant",
	      "foreground",
	      "fresh-thinking",
	      "full-range",
	      "global",
	      "grid-enabled",
	      "heuristic",
	      "high-level",
	      "holistic",
	      "homogeneous",
	      "human-resource",
	      "hybrid",
	      "impactful",
	      "incremental",
	      "intangible",
	      "interactive",
	      "intermediate",
	      "leading edge",
	      "local",
	      "logistical",
	      "maximized",
	      "methodical",
	      "mission-critical",
	      "mobile",
	      "modular",
	      "motivating",
	      "multimedia",
	      "multi-state",
	      "multi-tasking",
	      "national",
	      "needs-based",
	      "neutral",
	      "next generation",
	      "non-volatile",
	      "object-oriented",
	      "optimal",
	      "optimizing",
	      "radical",
	      "real-time",
	      "reciprocal",
	      "regional",
	      "responsive",
	      "scalable",
	      "secondary",
	      "solution-oriented",
	      "stable",
	      "static",
	      "systematic",
	      "systemic",
	      "system-worthy",
	      "tangible",
	      "tertiary",
	      "transitional",
	      "uniform",
	      "upward-trending",
	      "user-facing",
	      "value-added",
	      "web-enabled",
	      "well-modulated",
	      "zero administration",
	      "zero defect",
	      "zero tolerance"
	    ],
	    "noun":
	    [
	      "ability",
	      "access",
	      "adapter",
	      "algorithm",
	      "alliance",
	      "analyzer",
	      "application",
	      "approach",
	      "architecture",
	      "archive",
	      "artificial intelligence",
	      "array",
	      "attitude",
	      "benchmark",
	      "budgetary management",
	      "capability",
	      "capacity",
	      "challenge",
	      "circuit",
	      "collaboration",
	      "complexity",
	      "concept",
	      "conglomeration",
	      "contingency",
	      "core",
	      "customer loyalty",
	      "database",
	      "data-warehouse",
	      "definition",
	      "emulation",
	      "encoding",
	      "encryption",
	      "extranet",
	      "firmware",
	      "flexibility",
	      "focus group",
	      "forecast",
	      "frame",
	      "framework",
	      "function",
	      "functionalities",
	      "Graphic Interface",
	      "groupware",
	      "Graphical User Interface",
	      "hardware",
	      "help-desk",
	      "hierarchy",
	      "hub",
	      "implementation",
	      "info-mediaries",
	      "infrastructure",
	      "initiative",
	      "installation",
	      "instruction set",
	      "interface",
	      "internet solution",
	      "intranet",
	      "knowledge user",
	      "knowledge base",
	      "local area network",
	      "leverage",
	      "matrices",
	      "matrix",
	      "methodology",
	      "middleware",
	      "migration",
	      "model",
	      "moderator",
	      "monitoring",
	      "moratorium",
	      "neural-net",
	      "open architecture",
	      "open system",
	      "orchestration",
	      "paradigm",
	      "parallelism",
	      "policy",
	      "portal",
	      "pricing structure",
	      "process improvement",
	      "product",
	      "productivity",
	      "project",
	      "projection",
	      "protocol",
	      "secured line",
	      "service-desk",
	      "software",
	      "solution",
	      "standardization",
	      "strategy",
	      "structure",
	      "success",
	      "superstructure",
	      "support",
	      "synergy",
	      "system engine",
	      "task-force",
	      "throughput",
	      "time-frame",
	      "toolset",
	      "utilisation",
	      "website",
	      "workforce"
	  ],
	  "bs_verb": [
	      "implement",
	      "utilize",
	      "integrate",
	      "streamline",
	      "optimize",
	      "evolve",
	      "transform",
	      "embrace",
	      "enable",
	      "orchestrate",
	      "leverage",
	      "reinvent",
	      "aggregate",
	      "architect",
	      "enhance",
	      "incentivize",
	      "morph",
	      "empower",
	      "envisioneer",
	      "monetize",
	      "harness",
	      "facilitate",
	      "seize",
	      "disintermediate",
	      "synergize",
	      "strategize",
	      "deploy",
	      "brand",
	      "grow",
	      "target",
	      "syndicate",
	      "synthesize",
	      "deliver",
	      "mesh",
	      "incubate",
	      "engage",
	      "maximize",
	      "benchmark",
	      "expedite",
	      "reintermediate",
	      "whiteboard",
	      "visualize",
	      "repurpose",
	      "innovate",
	      "scale",
	      "unleash",
	      "drive",
	      "extend",
	      "engineer",
	      "revolutionize",
	      "generate",
	      "exploit",
	      "transition",
	      "e-enable",
	      "iterate",
	      "cultivate",
	      "matrix",
	      "productize",
	      "redefine",
	      "recontextualize"
	    ],
	    "bs_adjective":
	    [
	      "clicks-and-mortar",
	      "value-added",
	      "vertical",
	      "proactive",
	      "robust",
	      "revolutionary",
	      "scalable",
	      "leading-edge",
	      "innovative",
	      "intuitive",
	      "strategic",
	      "e-business",
	      "mission-critical",
	      "sticky",
	      "one-to-one",
	      "24/7",
	      "end-to-end",
	      "global",
	      "B2B",
	      "B2C",
	      "granular",
	      "frictionless",
	      "virtual",
	      "viral",
	      "dynamic",
	      "24/365",
	      "best-of-breed",
	      "killer",
	      "magnetic",
	      "bleeding-edge",
	      "web-enabled",
	      "interactive",
	      "dot-com",
	      "sexy",
	      "back-end",
	      "real-time",
	      "efficient",
	      "front-end",
	      "distributed",
	      "seamless",
	      "extensible",
	      "turn-key",
	      "world-class",
	      "open-source",
	      "cross-platform",
	      "cross-media",
	      "synergistic",
	      "bricks-and-clicks",
	      "out-of-the-box",
	      "enterprise",
	      "integrated",
	      "impactful",
	      "wireless",
	      "transparent",
	      "next-generation",
	      "cutting-edge",
	      "user-centric",
	      "visionary",
	      "customized",
	      "ubiquitous",
	      "plug-and-play",
	      "collaborative",
	      "compelling",
	      "holistic",
	      "rich"
	    ],
	    "bs_noun": [
	      "synergies",
	      "web-readiness",
	      "paradigms",
	      "markets",
	      "partnerships",
	      "infrastructures",
	      "platforms",
	      "initiatives",
	      "channels",
	      "eyeballs",
	      "communities",
	      "ROI",
	      "solutions",
	      "e-tailers",
	      "e-services",
	      "action-items",
	      "portals",
	      "niches",
	      "technologies",
	      "content",
	      "vortals",
	      "supply-chains",
	      "convergence",
	      "relationships",
	      "architectures",
	      "interfaces",
	      "e-markets",
	      "e-commerce",
	      "systems",
	      "bandwidth",
	      "infomediaries",
	      "models",
	      "mindshare",
	      "deliverables",
	      "users",
	      "schemas",
	      "networks",
	      "applications",
	      "metrics",
	      "e-business",
	      "functionalities",
	      "experiences",
	      "web services",
	      "methodologies"
	  ],
	  "name": [
	    "#{Name.last_name} #{suffix}",
	    "#{Name.last_name} et #{Name.last_name}"
	  ]
	};
	fr.internet = {
	  "free_email": [
	    "gmail.com",
	    "yahoo.fr",
	    "hotmail.fr"
	  ],
	  "domain_suffix": [
	    "com",
	    "fr",
	    "eu",
	    "info",
	    "name",
	    "net",
	    "org"
	  ]
	};
	fr.lorem = {
	  "words": [
	    "alias",
	    "consequatur",
	    "aut",
	    "perferendis",
	    "sit",
	    "voluptatem",
	    "accusantium",
	    "doloremque",
	    "aperiam",
	    "eaque",
	    "ipsa",
	    "quae",
	    "ab",
	    "illo",
	    "inventore",
	    "veritatis",
	    "et",
	    "quasi",
	    "architecto",
	    "beatae",
	    "vitae",
	    "dicta",
	    "sunt",
	    "explicabo",
	    "aspernatur",
	    "aut",
	    "odit",
	    "aut",
	    "fugit",
	    "sed",
	    "quia",
	    "consequuntur",
	    "magni",
	    "dolores",
	    "eos",
	    "qui",
	    "ratione",
	    "voluptatem",
	    "sequi",
	    "nesciunt",
	    "neque",
	    "dolorem",
	    "ipsum",
	    "quia",
	    "dolor",
	    "sit",
	    "amet",
	    "consectetur",
	    "adipisci",
	    "velit",
	    "sed",
	    "quia",
	    "non",
	    "numquam",
	    "eius",
	    "modi",
	    "tempora",
	    "incidunt",
	    "ut",
	    "labore",
	    "et",
	    "dolore",
	    "magnam",
	    "aliquam",
	    "quaerat",
	    "voluptatem",
	    "ut",
	    "enim",
	    "ad",
	    "minima",
	    "veniam",
	    "quis",
	    "nostrum",
	    "exercitationem",
	    "ullam",
	    "corporis",
	    "nemo",
	    "enim",
	    "ipsam",
	    "voluptatem",
	    "quia",
	    "voluptas",
	    "sit",
	    "suscipit",
	    "laboriosam",
	    "nisi",
	    "ut",
	    "aliquid",
	    "ex",
	    "ea",
	    "commodi",
	    "consequatur",
	    "quis",
	    "autem",
	    "vel",
	    "eum",
	    "iure",
	    "reprehenderit",
	    "qui",
	    "in",
	    "ea",
	    "voluptate",
	    "velit",
	    "esse",
	    "quam",
	    "nihil",
	    "molestiae",
	    "et",
	    "iusto",
	    "odio",
	    "dignissimos",
	    "ducimus",
	    "qui",
	    "blanditiis",
	    "praesentium",
	    "laudantium",
	    "totam",
	    "rem",
	    "voluptatum",
	    "deleniti",
	    "atque",
	    "corrupti",
	    "quos",
	    "dolores",
	    "et",
	    "quas",
	    "molestias",
	    "excepturi",
	    "sint",
	    "occaecati",
	    "cupiditate",
	    "non",
	    "provident",
	    "sed",
	    "ut",
	    "perspiciatis",
	    "unde",
	    "omnis",
	    "iste",
	    "natus",
	    "error",
	    "similique",
	    "sunt",
	    "in",
	    "culpa",
	    "qui",
	    "officia",
	    "deserunt",
	    "mollitia",
	    "animi",
	    "id",
	    "est",
	    "laborum",
	    "et",
	    "dolorum",
	    "fuga",
	    "et",
	    "harum",
	    "quidem",
	    "rerum",
	    "facilis",
	    "est",
	    "et",
	    "expedita",
	    "distinctio",
	    "nam",
	    "libero",
	    "tempore",
	    "cum",
	    "soluta",
	    "nobis",
	    "est",
	    "eligendi",
	    "optio",
	    "cumque",
	    "nihil",
	    "impedit",
	    "quo",
	    "porro",
	    "quisquam",
	    "est",
	    "qui",
	    "minus",
	    "id",
	    "quod",
	    "maxime",
	    "placeat",
	    "facere",
	    "possimus",
	    "omnis",
	    "voluptas",
	    "assumenda",
	    "est",
	    "omnis",
	    "dolor",
	    "repellendus",
	    "temporibus",
	    "autem",
	    "quibusdam",
	    "et",
	    "aut",
	    "consequatur",
	    "vel",
	    "illum",
	    "qui",
	    "dolorem",
	    "eum",
	    "fugiat",
	    "quo",
	    "voluptas",
	    "nulla",
	    "pariatur",
	    "at",
	    "vero",
	    "eos",
	    "et",
	    "accusamus",
	    "officiis",
	    "debitis",
	    "aut",
	    "rerum",
	    "necessitatibus",
	    "saepe",
	    "eveniet",
	    "ut",
	    "et",
	    "voluptates",
	    "repudiandae",
	    "sint",
	    "et",
	    "molestiae",
	    "non",
	    "recusandae",
	    "itaque",
	    "earum",
	    "rerum",
	    "hic",
	    "tenetur",
	    "a",
	    "sapiente",
	    "delectus",
	    "ut",
	    "aut",
	    "reiciendis",
	    "voluptatibus",
	    "maiores",
	    "doloribus",
	    "asperiores",
	    "repellat"
	  ],
	  "supplemental": [
	    "abbas",
	    "abduco",
	    "abeo",
	    "abscido",
	    "absconditus",
	    "absens",
	    "absorbeo",
	    "absque",
	    "abstergo",
	    "absum",
	    "abundans",
	    "abutor",
	    "accedo",
	    "accendo",
	    "acceptus",
	    "accipio",
	    "accommodo",
	    "accusator",
	    "acer",
	    "acerbitas",
	    "acervus",
	    "acidus",
	    "acies",
	    "acquiro",
	    "acsi",
	    "adamo",
	    "adaugeo",
	    "addo",
	    "adduco",
	    "ademptio",
	    "adeo",
	    "adeptio",
	    "adfectus",
	    "adfero",
	    "adficio",
	    "adflicto",
	    "adhaero",
	    "adhuc",
	    "adicio",
	    "adimpleo",
	    "adinventitias",
	    "adipiscor",
	    "adiuvo",
	    "administratio",
	    "admiratio",
	    "admitto",
	    "admoneo",
	    "admoveo",
	    "adnuo",
	    "adopto",
	    "adsidue",
	    "adstringo",
	    "adsuesco",
	    "adsum",
	    "adulatio",
	    "adulescens",
	    "adultus",
	    "aduro",
	    "advenio",
	    "adversus",
	    "advoco",
	    "aedificium",
	    "aeger",
	    "aegre",
	    "aegrotatio",
	    "aegrus",
	    "aeneus",
	    "aequitas",
	    "aequus",
	    "aer",
	    "aestas",
	    "aestivus",
	    "aestus",
	    "aetas",
	    "aeternus",
	    "ager",
	    "aggero",
	    "aggredior",
	    "agnitio",
	    "agnosco",
	    "ago",
	    "ait",
	    "aiunt",
	    "alienus",
	    "alii",
	    "alioqui",
	    "aliqua",
	    "alius",
	    "allatus",
	    "alo",
	    "alter",
	    "altus",
	    "alveus",
	    "amaritudo",
	    "ambitus",
	    "ambulo",
	    "amicitia",
	    "amiculum",
	    "amissio",
	    "amita",
	    "amitto",
	    "amo",
	    "amor",
	    "amoveo",
	    "amplexus",
	    "amplitudo",
	    "amplus",
	    "ancilla",
	    "angelus",
	    "angulus",
	    "angustus",
	    "animadverto",
	    "animi",
	    "animus",
	    "annus",
	    "anser",
	    "ante",
	    "antea",
	    "antepono",
	    "antiquus",
	    "aperio",
	    "aperte",
	    "apostolus",
	    "apparatus",
	    "appello",
	    "appono",
	    "appositus",
	    "approbo",
	    "apto",
	    "aptus",
	    "apud",
	    "aqua",
	    "ara",
	    "aranea",
	    "arbitro",
	    "arbor",
	    "arbustum",
	    "arca",
	    "arceo",
	    "arcesso",
	    "arcus",
	    "argentum",
	    "argumentum",
	    "arguo",
	    "arma",
	    "armarium",
	    "armo",
	    "aro",
	    "ars",
	    "articulus",
	    "artificiose",
	    "arto",
	    "arx",
	    "ascisco",
	    "ascit",
	    "asper",
	    "aspicio",
	    "asporto",
	    "assentator",
	    "astrum",
	    "atavus",
	    "ater",
	    "atqui",
	    "atrocitas",
	    "atrox",
	    "attero",
	    "attollo",
	    "attonbitus",
	    "auctor",
	    "auctus",
	    "audacia",
	    "audax",
	    "audentia",
	    "audeo",
	    "audio",
	    "auditor",
	    "aufero",
	    "aureus",
	    "auris",
	    "aurum",
	    "aut",
	    "autem",
	    "autus",
	    "auxilium",
	    "avaritia",
	    "avarus",
	    "aveho",
	    "averto",
	    "avoco",
	    "baiulus",
	    "balbus",
	    "barba",
	    "bardus",
	    "basium",
	    "beatus",
	    "bellicus",
	    "bellum",
	    "bene",
	    "beneficium",
	    "benevolentia",
	    "benigne",
	    "bestia",
	    "bibo",
	    "bis",
	    "blandior",
	    "bonus",
	    "bos",
	    "brevis",
	    "cado",
	    "caecus",
	    "caelestis",
	    "caelum",
	    "calamitas",
	    "calcar",
	    "calco",
	    "calculus",
	    "callide",
	    "campana",
	    "candidus",
	    "canis",
	    "canonicus",
	    "canto",
	    "capillus",
	    "capio",
	    "capitulus",
	    "capto",
	    "caput",
	    "carbo",
	    "carcer",
	    "careo",
	    "caries",
	    "cariosus",
	    "caritas",
	    "carmen",
	    "carpo",
	    "carus",
	    "casso",
	    "caste",
	    "casus",
	    "catena",
	    "caterva",
	    "cattus",
	    "cauda",
	    "causa",
	    "caute",
	    "caveo",
	    "cavus",
	    "cedo",
	    "celebrer",
	    "celer",
	    "celo",
	    "cena",
	    "cenaculum",
	    "ceno",
	    "censura",
	    "centum",
	    "cerno",
	    "cernuus",
	    "certe",
	    "certo",
	    "certus",
	    "cervus",
	    "cetera",
	    "charisma",
	    "chirographum",
	    "cibo",
	    "cibus",
	    "cicuta",
	    "cilicium",
	    "cimentarius",
	    "ciminatio",
	    "cinis",
	    "circumvenio",
	    "cito",
	    "civis",
	    "civitas",
	    "clam",
	    "clamo",
	    "claro",
	    "clarus",
	    "claudeo",
	    "claustrum",
	    "clementia",
	    "clibanus",
	    "coadunatio",
	    "coaegresco",
	    "coepi",
	    "coerceo",
	    "cogito",
	    "cognatus",
	    "cognomen",
	    "cogo",
	    "cohaero",
	    "cohibeo",
	    "cohors",
	    "colligo",
	    "colloco",
	    "collum",
	    "colo",
	    "color",
	    "coma",
	    "combibo",
	    "comburo",
	    "comedo",
	    "comes",
	    "cometes",
	    "comis",
	    "comitatus",
	    "commemoro",
	    "comminor",
	    "commodo",
	    "communis",
	    "comparo",
	    "compello",
	    "complectus",
	    "compono",
	    "comprehendo",
	    "comptus",
	    "conatus",
	    "concedo",
	    "concido",
	    "conculco",
	    "condico",
	    "conduco",
	    "confero",
	    "confido",
	    "conforto",
	    "confugo",
	    "congregatio",
	    "conicio",
	    "coniecto",
	    "conitor",
	    "coniuratio",
	    "conor",
	    "conqueror",
	    "conscendo",
	    "conservo",
	    "considero",
	    "conspergo",
	    "constans",
	    "consuasor",
	    "contabesco",
	    "contego",
	    "contigo",
	    "contra",
	    "conturbo",
	    "conventus",
	    "convoco",
	    "copia",
	    "copiose",
	    "cornu",
	    "corona",
	    "corpus",
	    "correptius",
	    "corrigo",
	    "corroboro",
	    "corrumpo",
	    "coruscus",
	    "cotidie",
	    "crapula",
	    "cras",
	    "crastinus",
	    "creator",
	    "creber",
	    "crebro",
	    "credo",
	    "creo",
	    "creptio",
	    "crepusculum",
	    "cresco",
	    "creta",
	    "cribro",
	    "crinis",
	    "cruciamentum",
	    "crudelis",
	    "cruentus",
	    "crur",
	    "crustulum",
	    "crux",
	    "cubicularis",
	    "cubitum",
	    "cubo",
	    "cui",
	    "cuius",
	    "culpa",
	    "culpo",
	    "cultellus",
	    "cultura",
	    "cum",
	    "cunabula",
	    "cunae",
	    "cunctatio",
	    "cupiditas",
	    "cupio",
	    "cuppedia",
	    "cupressus",
	    "cur",
	    "cura",
	    "curatio",
	    "curia",
	    "curiositas",
	    "curis",
	    "curo",
	    "curriculum",
	    "currus",
	    "cursim",
	    "curso",
	    "cursus",
	    "curto",
	    "curtus",
	    "curvo",
	    "curvus",
	    "custodia",
	    "damnatio",
	    "damno",
	    "dapifer",
	    "debeo",
	    "debilito",
	    "decens",
	    "decerno",
	    "decet",
	    "decimus",
	    "decipio",
	    "decor",
	    "decretum",
	    "decumbo",
	    "dedecor",
	    "dedico",
	    "deduco",
	    "defaeco",
	    "defendo",
	    "defero",
	    "defessus",
	    "defetiscor",
	    "deficio",
	    "defigo",
	    "defleo",
	    "defluo",
	    "defungo",
	    "degenero",
	    "degero",
	    "degusto",
	    "deinde",
	    "delectatio",
	    "delego",
	    "deleo",
	    "delibero",
	    "delicate",
	    "delinquo",
	    "deludo",
	    "demens",
	    "demergo",
	    "demitto",
	    "demo",
	    "demonstro",
	    "demoror",
	    "demulceo",
	    "demum",
	    "denego",
	    "denique",
	    "dens",
	    "denuncio",
	    "denuo",
	    "deorsum",
	    "depereo",
	    "depono",
	    "depopulo",
	    "deporto",
	    "depraedor",
	    "deprecator",
	    "deprimo",
	    "depromo",
	    "depulso",
	    "deputo",
	    "derelinquo",
	    "derideo",
	    "deripio",
	    "desidero",
	    "desino",
	    "desipio",
	    "desolo",
	    "desparatus",
	    "despecto",
	    "despirmatio",
	    "infit",
	    "inflammatio",
	    "paens",
	    "patior",
	    "patria",
	    "patrocinor",
	    "patruus",
	    "pauci",
	    "paulatim",
	    "pauper",
	    "pax",
	    "peccatus",
	    "pecco",
	    "pecto",
	    "pectus",
	    "pecunia",
	    "pecus",
	    "peior",
	    "pel",
	    "ocer",
	    "socius",
	    "sodalitas",
	    "sol",
	    "soleo",
	    "solio",
	    "solitudo",
	    "solium",
	    "sollers",
	    "sollicito",
	    "solum",
	    "solus",
	    "solutio",
	    "solvo",
	    "somniculosus",
	    "somnus",
	    "sonitus",
	    "sono",
	    "sophismata",
	    "sopor",
	    "sordeo",
	    "sortitus",
	    "spargo",
	    "speciosus",
	    "spectaculum",
	    "speculum",
	    "sperno",
	    "spero",
	    "spes",
	    "spiculum",
	    "spiritus",
	    "spoliatio",
	    "sponte",
	    "stabilis",
	    "statim",
	    "statua",
	    "stella",
	    "stillicidium",
	    "stipes",
	    "stips",
	    "sto",
	    "strenuus",
	    "strues",
	    "studio",
	    "stultus",
	    "suadeo",
	    "suasoria",
	    "sub",
	    "subito",
	    "subiungo",
	    "sublime",
	    "subnecto",
	    "subseco",
	    "substantia",
	    "subvenio",
	    "succedo",
	    "succurro",
	    "sufficio",
	    "suffoco",
	    "suffragium",
	    "suggero",
	    "sui",
	    "sulum",
	    "sum",
	    "summa",
	    "summisse",
	    "summopere",
	    "sumo",
	    "sumptus",
	    "supellex",
	    "super",
	    "suppellex",
	    "supplanto",
	    "suppono",
	    "supra",
	    "surculus",
	    "surgo",
	    "sursum",
	    "suscipio",
	    "suspendo",
	    "sustineo",
	    "suus",
	    "synagoga",
	    "tabella",
	    "tabernus",
	    "tabesco",
	    "tabgo",
	    "tabula",
	    "taceo",
	    "tactus",
	    "taedium",
	    "talio",
	    "talis",
	    "talus",
	    "tam",
	    "tamdiu",
	    "tamen",
	    "tametsi",
	    "tamisium",
	    "tamquam",
	    "tandem",
	    "tantillus",
	    "tantum",
	    "tardus",
	    "tego",
	    "temeritas",
	    "temperantia",
	    "templum",
	    "temptatio",
	    "tempus",
	    "tenax",
	    "tendo",
	    "teneo",
	    "tener",
	    "tenuis",
	    "tenus",
	    "tepesco",
	    "tepidus",
	    "ter",
	    "terebro",
	    "teres",
	    "terga",
	    "tergeo",
	    "tergiversatio",
	    "tergo",
	    "tergum",
	    "termes",
	    "terminatio",
	    "tero",
	    "terra",
	    "terreo",
	    "territo",
	    "terror",
	    "tersus",
	    "tertius",
	    "testimonium",
	    "texo",
	    "textilis",
	    "textor",
	    "textus",
	    "thalassinus",
	    "theatrum",
	    "theca",
	    "thema",
	    "theologus",
	    "thermae",
	    "thesaurus",
	    "thesis",
	    "thorax",
	    "thymbra",
	    "thymum",
	    "tibi",
	    "timidus",
	    "timor",
	    "titulus",
	    "tolero",
	    "tollo",
	    "tondeo",
	    "tonsor",
	    "torqueo",
	    "torrens",
	    "tot",
	    "totidem",
	    "toties",
	    "totus",
	    "tracto",
	    "trado",
	    "traho",
	    "trans",
	    "tredecim",
	    "tremo",
	    "trepide",
	    "tres",
	    "tribuo",
	    "tricesimus",
	    "triduana",
	    "triginta",
	    "tripudio",
	    "tristis",
	    "triumphus",
	    "trucido",
	    "truculenter",
	    "tubineus",
	    "tui",
	    "tum",
	    "tumultus",
	    "tunc",
	    "turba",
	    "turbo",
	    "turpe",
	    "turpis",
	    "tutamen",
	    "tutis",
	    "tyrannus",
	    "uberrime",
	    "ubi",
	    "ulciscor",
	    "ullus",
	    "ulterius",
	    "ultio",
	    "ultra",
	    "umbra",
	    "umerus",
	    "umquam",
	    "una",
	    "unde",
	    "undique",
	    "universe",
	    "unus",
	    "urbanus",
	    "urbs",
	    "uredo",
	    "usitas",
	    "usque",
	    "ustilo",
	    "ustulo",
	    "usus",
	    "uter",
	    "uterque",
	    "utilis",
	    "utique",
	    "utor",
	    "utpote",
	    "utrimque",
	    "utroque",
	    "utrum",
	    "uxor",
	    "vaco",
	    "vacuus",
	    "vado",
	    "vae",
	    "valde",
	    "valens",
	    "valeo",
	    "valetudo",
	    "validus",
	    "vallum",
	    "vapulus",
	    "varietas",
	    "varius",
	    "vehemens",
	    "vel",
	    "velociter",
	    "velum",
	    "velut",
	    "venia",
	    "venio",
	    "ventito",
	    "ventosus",
	    "ventus",
	    "venustas",
	    "ver",
	    "verbera",
	    "verbum",
	    "vere",
	    "verecundia",
	    "vereor",
	    "vergo",
	    "veritas",
	    "vero",
	    "versus",
	    "verto",
	    "verumtamen",
	    "verus",
	    "vesco",
	    "vesica",
	    "vesper",
	    "vespillo",
	    "vester",
	    "vestigium",
	    "vestrum",
	    "vetus",
	    "via",
	    "vicinus",
	    "vicissitudo",
	    "victoria",
	    "victus",
	    "videlicet",
	    "video",
	    "viduata",
	    "viduo",
	    "vigilo",
	    "vigor",
	    "vilicus",
	    "vilis",
	    "vilitas",
	    "villa",
	    "vinco",
	    "vinculum",
	    "vindico",
	    "vinitor",
	    "vinum",
	    "vir",
	    "virga",
	    "virgo",
	    "viridis",
	    "viriliter",
	    "virtus",
	    "vis",
	    "viscus",
	    "vita",
	    "vitiosus",
	    "vitium",
	    "vito",
	    "vivo",
	    "vix",
	    "vobis",
	    "vociferor",
	    "voco",
	    "volaticus",
	    "volo",
	    "volubilis",
	    "voluntarius",
	    "volup",
	    "volutabrum",
	    "volva",
	    "vomer",
	    "vomica",
	    "vomito",
	    "vorago",
	    "vorax",
	    "voro",
	    "vos",
	    "votum",
	    "voveo",
	    "vox",
	    "vulariter",
	    "vulgaris",
	    "vulgivagus",
	    "vulgo",
	    "vulgus",
	    "vulnero",
	    "vulnus",
	    "vulpes",
	    "vulticulus",
	    "vultuosus",
	    "xiphias"
	  ]
	};
	fr.name = {
	  "first_name": [
	    "Enzo",
	    "Lucas",
	    "Mathis",
	    "Nathan",
	    "Thomas",
	    "Hugo",
	    "Théo",
	    "Tom",
	    "Louis",
	    "Raphaël",
	    "Clément",
	    "Léo",
	    "Mathéo",
	    "Maxime",
	    "Alexandre",
	    "Antoine",
	    "Yanis",
	    "Paul",
	    "Baptiste",
	    "Alexis",
	    "Gabriel",
	    "Arthur",
	    "Jules",
	    "Ethan",
	    "Noah",
	    "Quentin",
	    "Axel",
	    "Evan",
	    "Mattéo",
	    "Romain",
	    "Valentin",
	    "Maxence",
	    "Noa",
	    "Adam",
	    "Nicolas",
	    "Julien",
	    "Mael",
	    "Pierre",
	    "Rayan",
	    "Victor",
	    "Mohamed",
	    "Adrien",
	    "Kylian",
	    "Sacha",
	    "Benjamin",
	    "Léa",
	    "Clara",
	    "Manon",
	    "Chloé",
	    "Camille",
	    "Ines",
	    "Sarah",
	    "Jade",
	    "Lola",
	    "Anaïs",
	    "Lucie",
	    "Océane",
	    "Lilou",
	    "Marie",
	    "Eva",
	    "Romane",
	    "Lisa",
	    "Zoe",
	    "Julie",
	    "Mathilde",
	    "Louise",
	    "Juliette",
	    "Clémence",
	    "Célia",
	    "Laura",
	    "Lena",
	    "Maëlys",
	    "Charlotte",
	    "Ambre",
	    "Maeva",
	    "Pauline",
	    "Lina",
	    "Jeanne",
	    "Lou",
	    "Noémie",
	    "Justine",
	    "Louna",
	    "Elisa",
	    "Alice",
	    "Emilie",
	    "Carla",
	    "Maëlle",
	    "Alicia",
	    "Mélissa"
	  ],
	  "last_name": [
	    "Martin",
	    "Bernard",
	    "Dubois",
	    "Thomas",
	    "Robert",
	    "Richard",
	    "Petit",
	    "Durand",
	    "Leroy",
	    "Moreau",
	    "Simon",
	    "Laurent",
	    "Lefebvre",
	    "Michel",
	    "Garcia",
	    "David",
	    "Bertrand",
	    "Roux",
	    "Vincent",
	    "Fournier",
	    "Morel",
	    "Girard",
	    "Andre",
	    "Lefevre",
	    "Mercier",
	    "Dupont",
	    "Lambert",
	    "Bonnet",
	    "Francois",
	    "Martinez",
	    "Legrand",
	    "Garnier",
	    "Faure",
	    "Rousseau",
	    "Blanc",
	    "Guerin",
	    "Muller",
	    "Henry",
	    "Roussel",
	    "Nicolas",
	    "Perrin",
	    "Morin",
	    "Mathieu",
	    "Clement",
	    "Gauthier",
	    "Dumont",
	    "Lopez",
	    "Fontaine",
	    "Chevalier",
	    "Robin",
	    "Masson",
	    "Sanchez",
	    "Gerard",
	    "Nguyen",
	    "Boyer",
	    "Denis",
	    "Lemaire",
	    "Duval",
	    "Joly",
	    "Gautier",
	    "Roger",
	    "Roche",
	    "Roy",
	    "Noel",
	    "Meyer",
	    "Lucas",
	    "Meunier",
	    "Jean",
	    "Perez",
	    "Marchand",
	    "Dufour",
	    "Blanchard",
	    "Marie",
	    "Barbier",
	    "Brun",
	    "Dumas",
	    "Brunet",
	    "Schmitt",
	    "Leroux",
	    "Colin",
	    "Fernandez",
	    "Pierre",
	    "Renard",
	    "Arnaud",
	    "Rolland",
	    "Caron",
	    "Aubert",
	    "Giraud",
	    "Leclerc",
	    "Vidal",
	    "Bourgeois",
	    "Renaud",
	    "Lemoine",
	    "Picard",
	    "Gaillard",
	    "Philippe",
	    "Leclercq",
	    "Lacroix",
	    "Fabre",
	    "Dupuis",
	    "Olivier",
	    "Rodriguez",
	    "Da silva",
	    "Hubert",
	    "Louis",
	    "Charles",
	    "Guillot",
	    "Riviere",
	    "Le gall",
	    "Guillaume",
	    "Adam",
	    "Rey",
	    "Moulin",
	    "Gonzalez",
	    "Berger",
	    "Lecomte",
	    "Menard",
	    "Fleury",
	    "Deschamps",
	    "Carpentier",
	    "Julien",
	    "Benoit",
	    "Paris",
	    "Maillard",
	    "Marchal",
	    "Aubry",
	    "Vasseur",
	    "Le roux",
	    "Renault",
	    "Jacquet",
	    "Collet",
	    "Prevost",
	    "Poirier",
	    "Charpentier",
	    "Royer",
	    "Huet",
	    "Baron",
	    "Dupuy",
	    "Pons",
	    "Paul",
	    "Laine",
	    "Carre",
	    "Breton",
	    "Remy",
	    "Schneider",
	    "Perrot",
	    "Guyot",
	    "Barre",
	    "Marty",
	    "Cousin"
	  ],
	  "prefix": [
	    "M",
	    "Mme",
	    "Mlle",
	    "Dr",
	    "Prof"
	  ],
	  "title": {
	    "job": [
	      "Superviseur",
	      "Executif",
	      "Manager",
	      "Ingenieur",
	      "Specialiste",
	      "Directeur",
	      "Coordinateur",
	      "Administrateur",
	      "Architecte",
	      "Analyste",
	      "Designer",
	      "Technicien",
	      "Developpeur",
	      "Producteur",
	      "Consultant",
	      "Assistant",
	      "Agent",
	      "Stagiaire"
	    ]
	  },
	  "name": [
	    "#{prefix} #{first_name} #{last_name}",
	    "#{first_name} #{last_name}",
	    "#{last_name} #{first_name}"
	  ]
	};
	fr.phone_number = {
	  "formats": [
	    "01########",
	    "02########",
	    "03########",
	    "04########",
	    "05########",
	    "06########",
	    "07########",
	    "+33 1########",
	    "+33 2########",
	    "+33 3########",
	    "+33 4########",
	    "+33 5########",
	    "+33 6########",
	    "+33 7########"
	  ]
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)(module)))

/***/ },
/* 306 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var ge = {};
	module["exports"] = ge;
	ge.title = "Georgian";
	ge.separator = " და ";
	ge.name = {
	  "first_name": [
	    "აგული",
	    "აგუნა",
	    "ადოლა",
	    "ავთანდილ",
	    "ავთო",
	    "აკაკი",
	    "აკო",
	    "ალეკო",
	    "ალექსანდრე",
	    "ალექსი",
	    "ალიო",
	    "ამირან",
	    "ანა",
	    "ანანო",
	    "ანზორ",
	    "ანნა",
	    "ანუკა",
	    "ანუკი",
	    "არჩილ",
	    "ასკილა",
	    "ასლანაზ",
	    "აჩიკო",
	    "ბადრი",
	    "ბაია",
	    "ბარბარე",
	    "ბაქარ",
	    "ბაჩა",
	    "ბაჩანა",
	    "ბაჭუა",
	    "ბაჭუკი",
	    "ბახვა",
	    "ბელა",
	    "ბერა",
	    "ბერდია",
	    "ბესიკ",
	    "ბესიკ",
	    "ბესო",
	    "ბექა",
	    "ბიძინა",
	    "ბიჭიკო",
	    "ბოჩია",
	    "ბოცო",
	    "ბროლა",
	    "ბუბუ",
	    "ბუდუ",
	    "ბუხუტი",
	    "გაგა",
	    "გაგი",
	    "გახა",
	    "გეგა",
	    "გეგი",
	    "გედია",
	    "გელა",
	    "გენადი",
	    "გვადი",
	    "გვანცა",
	    "გვანჯი",
	    "გვიტია",
	    "გვრიტა",
	    "გია",
	    "გიგა",
	    "გიგი",
	    "გიგილო",
	    "გიგლა",
	    "გიგოლი",
	    "გივი",
	    "გივიკო",
	    "გიორგი",
	    "გოგი",
	    "გოგიტა",
	    "გოგიჩა",
	    "გოგოთურ",
	    "გოგოლა",
	    "გოდერძი",
	    "გოლა",
	    "გოჩა",
	    "გრიგოლ",
	    "გუგა",
	    "გუგუ",
	    "გუგულა",
	    "გუგული",
	    "გუგუნა",
	    "გუკა",
	    "გულარისა",
	    "გულვარდი",
	    "გულვარდისა",
	    "გულთამზე",
	    "გულია",
	    "გულიკო",
	    "გულისა",
	    "გულნარა",
	    "გურამ",
	    "დავით",
	    "დალი",
	    "დარეჯან",
	    "დიანა",
	    "დიმიტრი",
	    "დოდო",
	    "დუტუ",
	    "ეთერ",
	    "ეთო",
	    "ეკა",
	    "ეკატერინე",
	    "ელგუჯა",
	    "ელენა",
	    "ელენე",
	    "ელზა",
	    "ელიკო",
	    "ელისო",
	    "ემზარ",
	    "ეშხა",
	    "ვალენტინა",
	    "ვალერი",
	    "ვანო",
	    "ვაჟა",
	    "ვაჟა",
	    "ვარდო",
	    "ვარსკვლავისა",
	    "ვასიკო",
	    "ვასილ",
	    "ვატო",
	    "ვახო",
	    "ვახტანგ",
	    "ვენერა",
	    "ვერა",
	    "ვერიკო",
	    "ზაზა",
	    "ზაირა",
	    "ზაურ",
	    "ზეზვა",
	    "ზვიად",
	    "ზინა",
	    "ზოია",
	    "ზუკა",
	    "ზურა",
	    "ზურაბ",
	    "ზურია",
	    "ზურიკო",
	    "თაზო",
	    "თათა",
	    "თათია",
	    "თათული",
	    "თაია",
	    "თაკო",
	    "თალიკო",
	    "თამაზ",
	    "თამარ",
	    "თამარა",
	    "თამთა",
	    "თამთიკე",
	    "თამი",
	    "თამილა",
	    "თამრიკო",
	    "თამრო",
	    "თამუნა",
	    "თამჩო",
	    "თანანა",
	    "თანდილა",
	    "თაყა",
	    "თეა",
	    "თებრონე",
	    "თეიმურაზ",
	    "თემურ",
	    "თენგიზ",
	    "თენგო",
	    "თეონა",
	    "თიკა",
	    "თიკო",
	    "თიკუნა",
	    "თინა",
	    "თინათინ",
	    "თინიკო",
	    "თმაგიშერა",
	    "თორნიკე",
	    "თუთა",
	    "თუთია",
	    "ია",
	    "იათამზე",
	    "იამზე",
	    "ივანე",
	    "ივერი",
	    "ივქირიონ",
	    "იზოლდა",
	    "ილია",
	    "ილიკო",
	    "იმედა",
	    "ინგა",
	    "იოსებ",
	    "ირაკლი",
	    "ირინა",
	    "ირინე",
	    "ირინკა",
	    "ირმა",
	    "იური",
	    "კაკო",
	    "კალე",
	    "კატო",
	    "კახა",
	    "კახაბერ",
	    "კეკელა",
	    "კესანე",
	    "კესო",
	    "კვირია",
	    "კიტა",
	    "კობა",
	    "კოკა",
	    "კონსტანტინე",
	    "კოსტა",
	    "კოტე",
	    "კუკური",
	    "ლადო",
	    "ლალი",
	    "ლამაზა",
	    "ლამარა",
	    "ლამზირა",
	    "ლაშა",
	    "ლევან",
	    "ლეილა",
	    "ლელა",
	    "ლენა",
	    "ლერწამისა",
	    "ლექსო",
	    "ლია",
	    "ლიანა",
	    "ლიზა",
	    "ლიზიკო",
	    "ლილე",
	    "ლილი",
	    "ლილიკო",
	    "ლომია",
	    "ლუიზა",
	    "მაგული",
	    "მადონა",
	    "მათიკო",
	    "მაია",
	    "მაიკო",
	    "მაისა",
	    "მაკა",
	    "მაკო",
	    "მაკუნა",
	    "მალხაზ",
	    "მამამზე",
	    "მამია",
	    "მამისა",
	    "მამისთვალი",
	    "მამისიმედი",
	    "მამუკა",
	    "მამულა",
	    "მანანა",
	    "მანჩო",
	    "მარადი",
	    "მარი",
	    "მარია",
	    "მარიამი",
	    "მარიკა",
	    "მარინა",
	    "მარინე",
	    "მარიტა",
	    "მაყვალა",
	    "მაყვალა",
	    "მაშიკო",
	    "მაშო",
	    "მაცაცო",
	    "მგელია",
	    "მგელიკა",
	    "მედეა",
	    "მეკაშო",
	    "მელანო",
	    "მერაბ",
	    "მერი",
	    "მეტია",
	    "მზაღო",
	    "მზევინარ",
	    "მზეთამზე",
	    "მზეთვალა",
	    "მზეონა",
	    "მზექალა",
	    "მზეხა",
	    "მზეხათუნი",
	    "მზია",
	    "მზირა",
	    "მზისადარ",
	    "მზისთანადარი",
	    "მზიულა",
	    "მთვარისა",
	    "მინდია",
	    "მიშა",
	    "მიშიკო",
	    "მიხეილ",
	    "მნათობი",
	    "მნათობისა",
	    "მოგელი",
	    "მონავარდისა",
	    "მურმან",
	    "მუხრან",
	    "ნაზი",
	    "ნაზიკო",
	    "ნათელა",
	    "ნათია",
	    "ნაირა",
	    "ნანა",
	    "ნანი",
	    "ნანიკო",
	    "ნანუკა",
	    "ნანული",
	    "ნარგიზი",
	    "ნასყიდა",
	    "ნატალია",
	    "ნატო",
	    "ნელი",
	    "ნენე",
	    "ნესტან",
	    "ნია",
	    "ნიაკო",
	    "ნიკა",
	    "ნიკოლოზ",
	    "ნინა",
	    "ნინაკა",
	    "ნინი",
	    "ნინიკო",
	    "ნინო",
	    "ნინუკა",
	    "ნინუცა",
	    "ნოდარ",
	    "ნოდო",
	    "ნონა",
	    "ნორა",
	    "ნუგზარ",
	    "ნუგო",
	    "ნუკა",
	    "ნუკი",
	    "ნუკრი",
	    "ნუნუ",
	    "ნუნუ",
	    "ნუნუკა",
	    "ნუცა",
	    "ნუცი",
	    "ოთარ",
	    "ოთია",
	    "ოთო",
	    "ომარ",
	    "ორბელ",
	    "ოტია",
	    "ოქროპირ",
	    "პაატა",
	    "პაპუნა",
	    "პატარკაცი",
	    "პატარქალი",
	    "პეპელა",
	    "პირვარდისა",
	    "პირიმზე",
	    "ჟამიერა",
	    "ჟამიტა",
	    "ჟამუტა",
	    "ჟუჟუნა",
	    "რამაზ",
	    "რევაზ",
	    "რეზი",
	    "რეზო",
	    "როზა",
	    "რომან",
	    "რუსკა",
	    "რუსუდან",
	    "საბა",
	    "სალი",
	    "სალომე",
	    "სანათა",
	    "სანდრო",
	    "სერგო",
	    "სესია",
	    "სეხნია",
	    "სვეტლანა",
	    "სიხარულა",
	    "სოსო",
	    "სოფიკო",
	    "სოფიო",
	    "სოფო",
	    "სულა",
	    "სულიკო",
	    "ტარიელ",
	    "ტასიკო",
	    "ტასო",
	    "ტატიანა",
	    "ტატო",
	    "ტეტია",
	    "ტურია",
	    "უმანკო",
	    "უტა",
	    "უჩა",
	    "ფაქიზო",
	    "ფაცია",
	    "ფეფელა",
	    "ფეფენა",
	    "ფეფიკო",
	    "ფეფო",
	    "ფოსო",
	    "ფოფო",
	    "ქაბატო",
	    "ქავთარი",
	    "ქალია",
	    "ქართლოს",
	    "ქეთათო",
	    "ქეთევან",
	    "ქეთი",
	    "ქეთინო",
	    "ქეთო",
	    "ქველი",
	    "ქიტესა",
	    "ქიშვარდი",
	    "ქობული",
	    "ქრისტესია",
	    "ქტისტეფორე",
	    "ქურციკა",
	    "ღარიბა",
	    "ღვთისავარი",
	    "ღვთისია",
	    "ღვთისო",
	    "ღვინია",
	    "ღუღუნა",
	    "ყაითამზა",
	    "ყაყიტა",
	    "ყვარყვარე",
	    "ყიასა",
	    "შაბური",
	    "შაკო",
	    "შალვა",
	    "შალიკო",
	    "შანშე",
	    "შარია",
	    "შაქარა",
	    "შაქრო",
	    "შოთა",
	    "შორენა",
	    "შოშია",
	    "შუქია",
	    "ჩიორა",
	    "ჩიტო",
	    "ჩიტო",
	    "ჩოყოლა",
	    "ცაგო",
	    "ცაგული",
	    "ცანგალა",
	    "ცარო",
	    "ცაცა",
	    "ცაცო",
	    "ციალა",
	    "ციკო",
	    "ცინარა",
	    "ცირა",
	    "ცისანა",
	    "ცისია",
	    "ცისკარა",
	    "ცისკარი",
	    "ცისმარა",
	    "ცისმარი",
	    "ციური",
	    "ციცი",
	    "ციცია",
	    "ციცინო",
	    "ცოტნე",
	    "ცოქალა",
	    "ცუცა",
	    "ცხვარი",
	    "ძაბული",
	    "ძამისა",
	    "ძაღინა",
	    "ძიძია",
	    "წათე",
	    "წყალობა",
	    "ჭაბუკა",
	    "ჭიაბერ",
	    "ჭიკჭიკა",
	    "ჭიჭია",
	    "ჭიჭიკო",
	    "ჭოლა",
	    "ხათუნა",
	    "ხარება",
	    "ხატია",
	    "ხახულა",
	    "ხახუტა",
	    "ხეჩუა",
	    "ხვიჩა",
	    "ხიზანა",
	    "ხირხელა",
	    "ხობელასი",
	    "ხოხია",
	    "ხოხიტა",
	    "ხუტა",
	    "ხუცია",
	    "ჯაბა",
	    "ჯავახი",
	    "ჯარჯი",
	    "ჯემალ",
	    "ჯონდო",
	    "ჯოტო",
	    "ჯუბი",
	    "ჯულიეტა",
	    "ჯუმბერ",
	    "ჰამლეტ"
	  ],
	  "last_name": [
	    "აბაზაძე",
	    "აბაშიძე",
	    "აბრამაშვილი",
	    "აბუსერიძე",
	    "აბშილავა",
	    "ავაზნელი",
	    "ავალიშვილი",
	    "ამილახვარი",
	    "ანთაძე",
	    "ასლამაზიშვილი",
	    "ასპანიძე",
	    "აშკარელი",
	    "ახალბედაშვილი",
	    "ახალკაცი",
	    "ახვლედიანი",
	    "ბარათაშვილი",
	    "ბარდაველიძე",
	    "ბახტაძე",
	    "ბედიანიძე",
	    "ბერიძე",
	    "ბერუაშვილი",
	    "ბეჟანიშვილი",
	    "ბოგველიშვილი",
	    "ბოტკოველი",
	    "გაბრიჩიძე",
	    "გაგნიძე",
	    "გამრეკელი",
	    "გელაშვილი",
	    "გზირიშვილი",
	    "გიგაური",
	    "გურამიშვილი",
	    "გურგენიძე",
	    "დადიანი",
	    "დავითიშვილი",
	    "დათუაშვილი",
	    "დარბაისელი",
	    "დეკანოიძე",
	    "დვალი",
	    "დოლაბერიძე",
	    "ედიშერაშვილი",
	    "ელიზბარაშვილი",
	    "ელიოზაშვილი",
	    "ერისთავი",
	    "ვარამაშვილი",
	    "ვარდიაშვილი",
	    "ვაჩნაძე",
	    "ვარდანიძე",
	    "ველიაშვილი",
	    "ველიჯანაშვილი",
	    "ზარანდია",
	    "ზარიძე",
	    "ზედგინიძე",
	    "ზუბიაშვილი",
	    "თაბაგარი",
	    "თავდგირიძე",
	    "თათარაშვილი",
	    "თამაზაშვილი",
	    "თამარაშვილი",
	    "თაქთაქიშვილი",
	    "თაყაიშვილი",
	    "თბილელი",
	    "თუხარელი",
	    "იაშვილი",
	    "იგითხანიშვილი",
	    "ინასარიძე",
	    "იშხნელი",
	    "კანდელაკი",
	    "კაცია",
	    "კერესელიძე",
	    "კვირიკაშვილი",
	    "კიკნაძე",
	    "კლდიაშვილი",
	    "კოვზაძე",
	    "კოპაძე",
	    "კოპტონაშვილი",
	    "კოშკელაშვილი",
	    "ლაბაძე",
	    "ლეკიშვილი",
	    "ლიქოკელი",
	    "ლოლაძე",
	    "ლურსმანაშვილი",
	    "მაისურაძე",
	    "მარტოლეკი",
	    "მაღალაძე",
	    "მახარაშვილი",
	    "მგალობლიშვილი",
	    "მეგრელიშვილი",
	    "მელაშვილი",
	    "მელიქიძე",
	    "მერაბიშვილი",
	    "მეფარიშვილი",
	    "მუჯირი",
	    "მჭედლიძე",
	    "მხეიძე",
	    "ნათაძე",
	    "ნაჭყებია",
	    "ნოზაძე",
	    "ოდიშვილი",
	    "ონოფრიშვილი",
	    "პარეხელაშვილი",
	    "პეტრიაშვილი",
	    "სააკაძე",
	    "სააკაშვილი",
	    "საგინაშვილი",
	    "სადუნიშვილი",
	    "საძაგლიშვილი",
	    "სებისკვერიძე",
	    "სეთური",
	    "სუთიაშვილი",
	    "სულაშვილი",
	    "ტაბაღუა",
	    "ტყეშელაშვილი",
	    "ულუმბელაშვილი",
	    "უნდილაძე",
	    "ქავთარაძე",
	    "ქართველიშვილი",
	    "ყაზბეგი",
	    "ყაუხჩიშვილი",
	    "შავლაშვილი",
	    "შალიკაშვილი",
	    "შონია",
	    "ჩიბუხაშვილი",
	    "ჩიხრაძე",
	    "ჩიქოვანი",
	    "ჩუბინიძე",
	    "ჩოლოყაშვილი",
	    "ჩოხელი",
	    "ჩხვიმიანი",
	    "ცალუღელაშვილი",
	    "ცაძიკიძე",
	    "ციციშვილი",
	    "ციხელაშვილი",
	    "ციხისთავი",
	    "ცხოვრებაძე",
	    "ცხომარია",
	    "წამალაიძე",
	    "წერეთელი",
	    "წიკლაური",
	    "წიფურია",
	    "ჭაბუკაშვილი",
	    "ჭავჭავაძე",
	    "ჭანტურია",
	    "ჭარელიძე",
	    "ჭიორელი",
	    "ჭუმბურიძე",
	    "ხაბაზი",
	    "ხარაძე",
	    "ხარატიშვილი",
	    "ხარატასშვილი",
	    "ხარისჭირაშვილი",
	    "ხარხელაური",
	    "ხაშმელაშვილი",
	    "ხეთაგური",
	    "ხიზამბარელი",
	    "ხიზანიშვილი",
	    "ხიმშიაშვილი",
	    "ხოსრუაშვილი",
	    "ხოჯივანიშვილი",
	    "ხუციშვილი",
	    "ჯაბადარი",
	    "ჯავახი",
	    "ჯავახიშვილი",
	    "ჯანელიძე",
	    "ჯაფარიძე",
	    "ჯაყელი",
	    "ჯაჯანიძე",
	    "ჯვარელია",
	    "ჯინიუზაშვილი",
	    "ჯუღაშვილი"
	  ],
	  "prefix": [
	    "ბ-ნი",
	    "ბატონი",
	    "ქ-ნი",
	    "ქალბატონი"
	  ],
	  "title": {
	    "descriptor": [
	      "გენერალური",
	      "მთავარი",
	      "სტაჟიორ",
	      "უმცროსი",
	      "ყოფილი",
	      "წამყვანი"
	    ],
	    "level": [
	      "აღრიცხვების",
	      "ბრენდინგის",
	      "ბრენიდს",
	      "ბუღალტერიის",
	      "განყოფილების",
	      "გაყიდვების",
	      "გუნდის",
	      "დახმარების",
	      "დიზაინის",
	      "თავდაცვის",
	      "ინფორმაციის",
	      "კვლევების",
	      "კომუნიკაციების",
	      "მარკეტინგის",
	      "ოპერაციათა",
	      "ოპტიმიზაციების",
	      "პიარ",
	      "პროგრამის",
	      "საქმეთა",
	      "ტაქტიკური",
	      "უსაფრთხოების",
	      "ფინანსთა",
	      "ქსელის",
	      "ხარისხის",
	      "ჯგუფის"
	    ],
	    "job": [
	      "აგენტი",
	      "ადვოკატი",
	      "ადმინისტრატორი",
	      "არქიტექტორი",
	      "ასისტენტი",
	      "აღმასრულებელი დირექტორი",
	      "დეველოპერი",
	      "დეკანი",
	      "დიზაინერი",
	      "დირექტორი",
	      "ელექტრიკოსი",
	      "ექსპერტი",
	      "ინჟინერი",
	      "იურისტი",
	      "კონსტრუქტორი",
	      "კონსულტანტი",
	      "კოორდინატორი",
	      "ლექტორი",
	      "მასაჟისტი",
	      "მემანქანე",
	      "მენეჯერი",
	      "მძღოლი",
	      "მწვრთნელი",
	      "ოპერატორი",
	      "ოფიცერი",
	      "პედაგოგი",
	      "პოლიციელი",
	      "პროგრამისტი",
	      "პროდიუსერი",
	      "პრორექტორი",
	      "ჟურნალისტი",
	      "რექტორი",
	      "სპეციალისტი",
	      "სტრატეგისტი",
	      "ტექნიკოსი",
	      "ფოტოგრაფი",
	      "წარმომადგენელი"
	    ]
	  },
	  "name": [
	    "#{prefix} #{first_name} #{last_name}",
	    "#{first_name} #{last_name}",
	    "#{first_name} #{last_name}",
	    "#{first_name} #{last_name}",
	    "#{first_name} #{last_name}",
	    "#{first_name} #{last_name}"
	  ]
	};
	ge.address = {
	  "city_prefix": [
	    "ახალი",
	    "ძველი",
	    "ზემო",
	    "ქვემო"
	  ],
	  "city_suffix": [
	    "სოფელი",
	    "ძირი",
	    "სკარი",
	    "დაბა"
	  ],
	  "city": [
	    "#{city_prefix} #{Name.first_name}#{city_suffix}",
	    "#{city_prefix} #{Name.first_name}",
	    "#{Name.first_name}#{city_suffix}",
	    "#{Name.first_name}#{city_suffix}",
	    "#{Name.last_name}#{city_suffix}",
	    "#{Name.last_name}#{city_suffix}"
	  ],
	  "country": [
	    "ავსტრალია",
	    "ავსტრია",
	    "ავღანეთი",
	    "აზავადი",
	    "აზერბაიჯანი",
	    "აზიაში",
	    "აზიის",
	    "ალბანეთი",
	    "ალჟირი",
	    "ამაღლება და ტრისტანი-და-კუნია",
	    "ამერიკის ვირჯინიის კუნძულები",
	    "ამერიკის სამოა",
	    "ამერიკის შეერთებული შტატები",
	    "ამერიკის",
	    "ანგილია",
	    "ანგოლა",
	    "ანდორა",
	    "ანტიგუა და ბარბუდა",
	    "არაბეთის საემიროები",
	    "არაბთა გაერთიანებული საამიროები",
	    "არაბული ქვეყნების ლიგის",
	    "არგენტინა",
	    "არუბა",
	    "არცნობილი ქვეყნების სია",
	    "აფრიკაში",
	    "აფრიკაშია",
	    "აღდგომის კუნძული",
	    "აღმ. ტიმორი",
	    "აღმოსავლეთი აფრიკა",
	    "აღმოსავლეთი ტიმორი",
	    "აშშ",
	    "აშშ-ის ვირჯინის კუნძულები",
	    "ახალი ზელანდია",
	    "ახალი კალედონია",
	    "ბანგლადეში",
	    "ბარბადოსი",
	    "ბაჰამის კუნძულები",
	    "ბაჰრეინი",
	    "ბელარუსი",
	    "ბელგია",
	    "ბელიზი",
	    "ბენინი",
	    "ბერმუდა",
	    "ბერმუდის კუნძულები",
	    "ბოლივია",
	    "ბოსნია და ჰერცეგოვინა",
	    "ბოტსვანა",
	    "ბრაზილია",
	    "ბრიტანეთის ვირჯინიის კუნძულები",
	    "ბრიტანეთის ვირჯინის კუნძულები",
	    "ბრიტანეთის ინდოეთის ოკეანის ტერიტორია",
	    "ბრუნეი",
	    "ბულგარეთი",
	    "ბურკინა ფასო",
	    "ბურკინა-ფასო",
	    "ბურუნდი",
	    "ბჰუტანი",
	    "გაბონი",
	    "გაერთიანებული სამეფო",
	    "გაეროს",
	    "გაიანა",
	    "გამბია",
	    "განა",
	    "გერმანია",
	    "გვადელუპა",
	    "გვატემალა",
	    "გვინეა",
	    "გვინეა-ბისაუ",
	    "გიბრალტარი",
	    "გრენადა",
	    "გრენლანდია",
	    "გუამი",
	    "დამოკიდებული ტერ.",
	    "დამოკიდებული ტერიტორია",
	    "დამოკიდებული",
	    "დანია",
	    "დასავლეთი აფრიკა",
	    "დასავლეთი საჰარა",
	    "დიდი ბრიტანეთი",
	    "დომინიკა",
	    "დომინიკელთა რესპუბლიკა",
	    "ეგვიპტე",
	    "ევროკავშირის",
	    "ევროპასთან",
	    "ევროპაშია",
	    "ევროპის ქვეყნები",
	    "ეთიოპია",
	    "ეკვადორი",
	    "ეკვატორული გვინეა",
	    "ეპარსეს კუნძული",
	    "ერაყი",
	    "ერიტრეა",
	    "ესპანეთი",
	    "ესპანეთის სუვერენული ტერიტორიები",
	    "ესტონეთი",
	    "ეშმორის და კარტიეს კუნძულები",
	    "ვანუატუ",
	    "ვატიკანი",
	    "ვენესუელა",
	    "ვიეტნამი",
	    "ზამბია",
	    "ზიმბაბვე",
	    "თურქეთი",
	    "თურქმენეთი",
	    "იამაიკა",
	    "იან მაიენი",
	    "იაპონია",
	    "იემენი",
	    "ინდოეთი",
	    "ინდონეზია",
	    "იორდანია",
	    "ირანი",
	    "ირლანდია",
	    "ისლანდია",
	    "ისრაელი",
	    "იტალია",
	    "კაბო-ვერდე",
	    "კაიმანის კუნძულები",
	    "კამბოჯა",
	    "კამერუნი",
	    "კანადა",
	    "კანარის კუნძულები",
	    "კარიბის ზღვის",
	    "კატარი",
	    "კენია",
	    "კვიპროსი",
	    "კინგმენის რიფი",
	    "კირიბატი",
	    "კლიპერტონი",
	    "კოლუმბია",
	    "კომორი",
	    "კომორის კუნძულები",
	    "კონგოს დემოკრატიული რესპუბლიკა",
	    "კონგოს რესპუბლიკა",
	    "კორეის რესპუბლიკა",
	    "კოსტა-რიკა",
	    "კოტ-დ’ივუარი",
	    "კუბა",
	    "კუკის კუნძულები",
	    "ლაოსი",
	    "ლატვია",
	    "ლესოთო",
	    "ლიბანი",
	    "ლიბერია",
	    "ლიბია",
	    "ლიტვა",
	    "ლიხტენშტაინი",
	    "ლუქსემბურგი",
	    "მადაგასკარი",
	    "მადეირა",
	    "მავრიკი",
	    "მავრიტანია",
	    "მაიოტა",
	    "მაკაო",
	    "მაკედონია",
	    "მალავი",
	    "მალაიზია",
	    "მალდივი",
	    "მალდივის კუნძულები",
	    "მალი",
	    "მალტა",
	    "მაროკო",
	    "მარტინიკა",
	    "მარშალის კუნძულები",
	    "მარჯნის ზღვის კუნძულები",
	    "მელილია",
	    "მექსიკა",
	    "მიანმარი",
	    "მიკრონეზია",
	    "მიკრონეზიის ფედერაციული შტატები",
	    "მიმდებარე კუნძულები",
	    "მოზამბიკი",
	    "მოლდოვა",
	    "მონაკო",
	    "მონსერატი",
	    "მონღოლეთი",
	    "ნამიბია",
	    "ნაურუ",
	    "ნაწილობრივ აფრიკაში",
	    "ნეპალი",
	    "ნიგერი",
	    "ნიგერია",
	    "ნიდერლანდი",
	    "ნიდერლანდის ანტილები",
	    "ნიკარაგუა",
	    "ნიუე",
	    "ნორვეგია",
	    "ნორფოლკის კუნძული",
	    "ოკეანეთის",
	    "ოკეანიას",
	    "ომანი",
	    "პაკისტანი",
	    "პალაუ",
	    "პალესტინა",
	    "პალმირა (ატოლი)",
	    "პანამა",
	    "პანტელერია",
	    "პაპუა-ახალი გვინეა",
	    "პარაგვაი",
	    "პერუ",
	    "პიტკერნის კუნძულები",
	    "პოლონეთი",
	    "პორტუგალია",
	    "პრინც-ედუარდის კუნძული",
	    "პუერტო-რიკო",
	    "რეუნიონი",
	    "როტუმა",
	    "რუანდა",
	    "რუმინეთი",
	    "რუსეთი",
	    "საბერძნეთი",
	    "სადავო ტერიტორიები",
	    "სალვადორი",
	    "სამოა",
	    "სამხ. კორეა",
	    "სამხრეთ ამერიკაშია",
	    "სამხრეთ ამერიკის",
	    "სამხრეთ აფრიკის რესპუბლიკა",
	    "სამხრეთი აფრიკა",
	    "სამხრეთი გეორგია და სამხრეთ სენდვიჩის კუნძულები",
	    "სამხრეთი სუდანი",
	    "სან-მარინო",
	    "სან-ტომე და პრინსიპი",
	    "საუდის არაბეთი",
	    "საფრანგეთი",
	    "საფრანგეთის გვიანა",
	    "საფრანგეთის პოლინეზია",
	    "საქართველო",
	    "საჰარის არაბთა დემოკრატიული რესპუბლიკა",
	    "სეიშელის კუნძულები",
	    "სენ-ბართელმი",
	    "სენ-მარტენი",
	    "სენ-პიერი და მიკელონი",
	    "სენეგალი",
	    "სენტ-ვინსენტი და გრენადინები",
	    "სენტ-კიტსი და ნევისი",
	    "სენტ-ლუსია",
	    "სერბეთი",
	    "სეუტა",
	    "სვაზილენდი",
	    "სვალბარდი",
	    "სიერა-ლეონე",
	    "სინგაპური",
	    "სირია",
	    "სლოვაკეთი",
	    "სლოვენია",
	    "სოკოტრა",
	    "სოლომონის კუნძულები",
	    "სომალი",
	    "სომალილენდი",
	    "სომხეთი",
	    "სუდანი",
	    "სუვერენული სახელმწიფოები",
	    "სურინამი",
	    "ტაივანი",
	    "ტაილანდი",
	    "ტანზანია",
	    "ტაჯიკეთი",
	    "ტერიტორიები",
	    "ტერქსისა და კაიკოსის კუნძულები",
	    "ტოგო",
	    "ტოკელაუ",
	    "ტონგა",
	    "ტრანსკონტინენტური ქვეყანა",
	    "ტრინიდადი და ტობაგო",
	    "ტუვალუ",
	    "ტუნისი",
	    "უგანდა",
	    "უზბეკეთი",
	    "უკრაინა",
	    "უნგრეთი",
	    "უოლისი და ფუტუნა",
	    "ურუგვაი",
	    "ფარერის კუნძულები",
	    "ფილიპინები",
	    "ფინეთი",
	    "ფიჯი",
	    "ფოლკლენდის კუნძულები",
	    "ქვეყნები",
	    "ქოქოსის კუნძულები",
	    "ქუვეითი",
	    "ღაზის სექტორი",
	    "ყაზახეთი",
	    "ყირგიზეთი",
	    "შვედეთი",
	    "შვეიცარია",
	    "შობის კუნძული",
	    "შრი-ლანკა",
	    "ჩადი",
	    "ჩერნოგორია",
	    "ჩეჩნეთის რესპუბლიკა იჩქერია",
	    "ჩეხეთი",
	    "ჩილე",
	    "ჩინეთი",
	    "ჩრდ. კორეა",
	    "ჩრდილოეთ ამერიკის",
	    "ჩრდილოეთ მარიანას კუნძულები",
	    "ჩრდილოეთი აფრიკა",
	    "ჩრდილოეთი კორეა",
	    "ჩრდილოეთი მარიანას კუნძულები",
	    "ცენტრალური აფრიკა",
	    "ცენტრალური აფრიკის რესპუბლიკა",
	    "წევრები",
	    "წმინდა ელენე",
	    "წმინდა ელენეს კუნძული",
	    "ხორვატია",
	    "ჯერსი",
	    "ჯიბუტი",
	    "ჰავაი",
	    "ჰაიტი",
	    "ჰერდი და მაკდონალდის კუნძულები",
	    "ჰონდურასი",
	    "ჰონკონგი"
	  ],
	  "building_number": [
	    "###",
	    "##",
	    "#"
	  ],
	  "street_suffix": [
	    "გამზ.",
	    "გამზირი",
	    "ქ.",
	    "ქუჩა",
	    "ჩიხი",
	    "ხეივანი"
	  ],
	  "secondary_address": [
	    "კორპ. ##",
	    "შენობა ###"
	  ],
	  "postcode": [
	    "01##"
	  ],
	  "city_name": [
	    "აბასთუმანი",
	    "აბაშა",
	    "ადიგენი",
	    "ამბროლაური",
	    "ანაკლია",
	    "ასპინძა",
	    "ახალგორი",
	    "ახალქალაქი",
	    "ახალციხე",
	    "ახმეტა",
	    "ბათუმი",
	    "ბაკურიანი",
	    "ბაღდათი",
	    "ბახმარო",
	    "ბოლნისი",
	    "ბორჯომი",
	    "გარდაბანი",
	    "გონიო",
	    "გორი",
	    "გრიგოლეთი",
	    "გუდაური",
	    "გურჯაანი",
	    "დედოფლისწყარო",
	    "დმანისი",
	    "დუშეთი",
	    "ვანი",
	    "ზესტაფონი",
	    "ზუგდიდი",
	    "თბილისი",
	    "თეთრიწყარო",
	    "თელავი",
	    "თერჯოლა",
	    "თიანეთი",
	    "კასპი",
	    "კვარიათი",
	    "კიკეთი",
	    "კოჯორი",
	    "ლაგოდეხი",
	    "ლანჩხუთი",
	    "ლენტეხი",
	    "მარნეული",
	    "მარტვილი",
	    "მესტია",
	    "მცხეთა",
	    "მწვანე კონცხი",
	    "ნინოწმინდა",
	    "ოზურგეთი",
	    "ონი",
	    "რუსთავი",
	    "საგარეჯო",
	    "საგურამო",
	    "საირმე",
	    "სამტრედია",
	    "სარფი",
	    "საჩხერე",
	    "სენაკი",
	    "სიღნაღი",
	    "სტეფანწმინდა",
	    "სურამი",
	    "ტაბახმელა",
	    "ტყიბული",
	    "ურეკი",
	    "ფოთი",
	    "ქარელი",
	    "ქედა",
	    "ქობულეთი",
	    "ქუთაისი",
	    "ყვარელი",
	    "შუახევი",
	    "ჩაქვი",
	    "ჩოხატაური",
	    "ცაგერი",
	    "ცხოროჭყუ",
	    "წავკისი",
	    "წალენჯიხა",
	    "წალკა",
	    "წაღვერი",
	    "წეროვანი",
	    "წნორი",
	    "წყალტუბო",
	    "წყნეთი",
	    "ჭიათურა",
	    "ხარაგაული",
	    "ხაშური",
	    "ხელვაჩაური",
	    "ხობი",
	    "ხონი",
	    "ხულო"
	  ],
	  "street_title": [
	    "აბაშიძის",
	    "აბესაძის",
	    "აბულაძის",
	    "აგლაძის",
	    "ადლერის",
	    "ავიაქიმიის",
	    "ავლაბრის",
	    "ათარბეგოვის",
	    "ათონელის",
	    "ალავერდოვის",
	    "ალექსიძის",
	    "ალილუევის",
	    "ალმასიანის",
	    "ამაღლების",
	    "ამირეჯიბის",
	    "ანაგის",
	    "ანდრონიკაშვილის",
	    "ანთელავას",
	    "ანჯაფარიძის",
	    "არაგვის",
	    "არდონის",
	    "არეშიძის",
	    "ასათიანის",
	    "ასკურავას",
	    "ასლანიდის",
	    "ატენის",
	    "აფხაზი",
	    "აღმაშენებლის",
	    "ახალშენის",
	    "ახვლედიანის",
	    "ბააზოვის",
	    "ბაბისხევის",
	    "ბაბუშკინის",
	    "ბაგრატიონის",
	    "ბალანჩივაძეების",
	    "ბალანჩივაძის",
	    "ბალანჩინის",
	    "ბალმაშევის",
	    "ბარამიძის",
	    "ბარნოვის",
	    "ბაშალეიშვილის",
	    "ბევრეთის",
	    "ბელინსკის",
	    "ბელოსტოკის",
	    "ბენაშვილის",
	    "ბეჟანიშვილის",
	    "ბერიძის",
	    "ბოლქვაძის",
	    "ბოცვაძის",
	    "ბოჭორიშვილის",
	    "ბოჭორიძის",
	    "ბუაჩიძის",
	    "ბუდაპეშტის",
	    "ბურკიაშვილის",
	    "ბურძგლას",
	    "გაბესკირიას",
	    "გაგარინის",
	    "გაზაფხულის",
	    "გამრეკელის",
	    "გამსახურდიას",
	    "გარეჯელის",
	    "გეგეჭკორის",
	    "გედაურის",
	    "გელოვანი",
	    "გელოვანის",
	    "გერცენის",
	    "გლდანის",
	    "გოგებაშვილის",
	    "გოგიბერიძის",
	    "გოგოლის",
	    "გონაშვილის",
	    "გორგასლის",
	    "გრანელის",
	    "გრიზოდუბოვას",
	    "გრინევიცკის",
	    "გრომოვას",
	    "გრუზინსკის",
	    "გუდიაშვილის",
	    "გულრიფშის",
	    "გულუას",
	    "გურამიშვილის",
	    "გურგენიძის",
	    "დადიანის",
	    "დავითაშვილის",
	    "დამაკავშირებელი",
	    "დარიალის",
	    "დედოფლისწყაროს",
	    "დეპუტატის",
	    "დიდგორის",
	    "დიდი",
	    "დიდუბის",
	    "დიუმას",
	    "დიღმის",
	    "დიღომში",
	    "დოლიძის",
	    "დუნდუას",
	    "დურმიშიძის",
	    "ელიავას",
	    "ენგელსის",
	    "ენგურის",
	    "ეპისკოპოსის",
	    "ერისთავი",
	    "ერისთავის",
	    "ვაზისუბნის",
	    "ვაკელის",
	    "ვართაგავას",
	    "ვატუტინის",
	    "ვაჩნაძის",
	    "ვაცეკის",
	    "ვეკუას",
	    "ვეშაპურის",
	    "ვირსალაძის",
	    "ვოლოდარსკის",
	    "ვორონინის",
	    "ზაარბრიუკენის",
	    "ზაზიაშვილის",
	    "ზაზიშვილის",
	    "ზაკომოლდინის",
	    "ზანდუკელის",
	    "ზაქარაიას",
	    "ზაქარიაძის",
	    "ზახაროვის",
	    "ზაჰესის",
	    "ზნაურის",
	    "ზურაბაშვილის",
	    "ზღვის",
	    "თაბუკაშვილის",
	    "თავაძის",
	    "თავისუფლების",
	    "თამარაშვილის",
	    "თაქთაქიშვილის",
	    "თბილელის",
	    "თელიას",
	    "თორაძის",
	    "თოფურიძის",
	    "იალბუზის",
	    "იამანიძის",
	    "იაშვილის",
	    "იბერიის",
	    "იერუსალიმის",
	    "ივანიძის",
	    "ივერიელის",
	    "იზაშვილის",
	    "ილურიძის",
	    "იმედაშვილის",
	    "იმედაძის",
	    "იმედის",
	    "ინანიშვილის",
	    "ინგოროყვას",
	    "ინდუსტრიალიზაციის",
	    "ინჟინრის",
	    "ინწკირველის",
	    "ირბახის",
	    "ირემაშვილის",
	    "ისაკაძის",
	    "ისპასჰანლის",
	    "იტალიის",
	    "იუნკერთა",
	    "კათალიკოსის",
	    "კაიროს",
	    "კაკაბაძის",
	    "კაკაბეთის",
	    "კაკლიანის",
	    "კალანდაძის",
	    "კალიაევის",
	    "კალინინის",
	    "კამალოვის",
	    "კამოს",
	    "კაშენის",
	    "კახოვკის",
	    "კედიას",
	    "კელაპტრიშვილის",
	    "კერესელიძის",
	    "კეცხოველის",
	    "კიბალჩიჩის",
	    "კიკნაძის",
	    "კიროვის",
	    "კობარეთის",
	    "კოლექტივიზაციის",
	    "კოლმეურნეობის",
	    "კოლხეთის",
	    "კომკავშირის",
	    "კომუნისტური",
	    "კონსტიტუციის",
	    "კოოპერაციის",
	    "კოსტავას",
	    "კოტეტიშვილის",
	    "კოჩეტკოვის",
	    "კოჯრის",
	    "კრონშტადტის",
	    "კროპოტკინის",
	    "კრუპსკაიას",
	    "კუიბიშევის",
	    "კურნატოვსკის",
	    "კურტანოვსკის",
	    "კუტუზოვის",
	    "ლაღიძის",
	    "ლელაშვილის",
	    "ლენინაშენის",
	    "ლენინგრადის",
	    "ლენინის",
	    "ლენის",
	    "ლეონიძის",
	    "ლვოვის",
	    "ლორთქიფანიძის",
	    "ლოტკინის",
	    "ლუბლიანის",
	    "ლუბოვსკის",
	    "ლუნაჩარსკის",
	    "ლუქსემბურგის",
	    "მაგნიტოგორსკის",
	    "მაზნიაშვილის",
	    "მაისურაძის",
	    "მამარდაშვილის",
	    "მამაცაშვილის",
	    "მანაგაძის",
	    "მანჯგალაძის",
	    "მარის",
	    "მარუაშვილის",
	    "მარქსის",
	    "მარჯანის",
	    "მატროსოვის",
	    "მაჭავარიანი",
	    "მახალდიანის",
	    "მახარაძის",
	    "მებაღიშვილის",
	    "მეგობრობის",
	    "მელაანის",
	    "მერკვილაძის",
	    "მესხიას",
	    "მესხის",
	    "მეტეხის",
	    "მეტრეველი",
	    "მეჩნიკოვის",
	    "მთავარანგელოზის",
	    "მიასნიკოვის",
	    "მილორავას",
	    "მიმინოშვილის",
	    "მიროტაძის",
	    "მიქატაძის",
	    "მიქელაძის",
	    "მონტინის",
	    "მორეტის",
	    "მოსკოვის",
	    "მრევლიშვილის",
	    "მუშკორის",
	    "მუჯირიშვილის",
	    "მშვიდობის",
	    "მცხეთის",
	    "ნადირაძის",
	    "ნაკაშიძის",
	    "ნარიმანოვის",
	    "ნასიძის",
	    "ნაფარეულის",
	    "ნეკრასოვის",
	    "ნიაღვრის",
	    "ნინიძის",
	    "ნიშნიანიძის",
	    "ობოლაძის",
	    "ონიანის",
	    "ოჟიოს",
	    "ორახელაშვილის",
	    "ორბელიანის",
	    "ორჯონიკიძის",
	    "ოქტომბრის",
	    "ოცდაექვსი",
	    "პავლოვის",
	    "პარალელურის",
	    "პარიზის",
	    "პეკინის",
	    "პეროვსკაიას",
	    "პეტეფის",
	    "პიონერის",
	    "პირველი",
	    "პისარევის",
	    "პლეხანოვის",
	    "პრავდის",
	    "პროლეტარიატის",
	    "ჟელიაბოვის",
	    "ჟვანიას",
	    "ჟორდანიას",
	    "ჟღენტი",
	    "ჟღენტის",
	    "რადიანის",
	    "რამიშვილი",
	    "რასკოვას",
	    "რენინგერის",
	    "რინგის",
	    "რიჟინაშვილის",
	    "რობაქიძის",
	    "რობესპიერის",
	    "რუსის",
	    "რუხაძის",
	    "რჩეულიშვილის",
	    "სააკაძის",
	    "საბადურის",
	    "საბაშვილის",
	    "საბურთალოს",
	    "საბჭოს",
	    "საგურამოს",
	    "სამრეკლოს",
	    "სამღერეთის",
	    "სანაკოევის",
	    "სარაჯიშვილის",
	    "საჯაიას",
	    "სევასტოპოლის",
	    "სერგი",
	    "სვანიძის",
	    "სვერდლოვის",
	    "სტახანოვის",
	    "სულთნიშნის",
	    "სურგულაძის",
	    "სხირტლაძის",
	    "ტაბიძის",
	    "ტატიშვილის",
	    "ტელმანის",
	    "ტერევერკოს",
	    "ტეტელაშვილის",
	    "ტოვსტონოგოვის",
	    "ტოროშელიძის",
	    "ტრაქტორის",
	    "ტრიკოტაჟის",
	    "ტურბინის",
	    "უბილავას",
	    "უბინაშვილის",
	    "უზნაძის",
	    "უკლებას",
	    "ულიანოვის",
	    "ურიდიას",
	    "ფაბრიციუსის",
	    "ფაღავას",
	    "ფერისცვალების",
	    "ფიგნერის",
	    "ფიზკულტურის",
	    "ფიოლეტოვის",
	    "ფიფიების",
	    "ფოცხიშვილის",
	    "ქართველიშვილის",
	    "ქართლელიშვილის",
	    "ქინქლაძის",
	    "ქიქოძის",
	    "ქსოვრელის",
	    "ქუთათელაძის",
	    "ქუთათელის",
	    "ქურდიანის",
	    "ღოღობერიძის",
	    "ღუდუშაურის",
	    "ყავლაშვილის",
	    "ყაზბეგის",
	    "ყარყარაშვილის",
	    "ყიფიანის",
	    "ყუშიტაშვილის",
	    "შანიძის",
	    "შარტავას",
	    "შატილოვის",
	    "შაუმიანის",
	    "შენგელაიას",
	    "შერვაშიძის",
	    "შეროზიას",
	    "შირშოვის",
	    "შმიდტის",
	    "შრომის",
	    "შუშინის",
	    "შჩორსის",
	    "ჩალაუბნის",
	    "ჩანტლაძის",
	    "ჩაპაევის",
	    "ჩაჩავას",
	    "ჩელუსკინელების",
	    "ჩერნიახოვსკის",
	    "ჩერქეზიშვილი",
	    "ჩერქეზიშვილის",
	    "ჩვიდმეტი",
	    "ჩიტაიას",
	    "ჩიტაძის",
	    "ჩიქვანაიას",
	    "ჩიქობავას",
	    "ჩიხლაძის",
	    "ჩოდრიშვილის",
	    "ჩოლოყაშვილის",
	    "ჩუღურეთის",
	    "ცაბაძის",
	    "ცაგარელის",
	    "ცეტკინის",
	    "ცინცაძის",
	    "ცისკარიშვილის",
	    "ცურტაველის",
	    "ცქიტიშვილის",
	    "ცხაკაიას",
	    "ძმობის",
	    "ძნელაძის",
	    "წერეთლის",
	    "წითელი",
	    "წითელწყაროს",
	    "წინამძღვრიშვილის",
	    "წულაძის",
	    "წულუკიძის",
	    "ჭაბუკიანის",
	    "ჭავჭავაძის",
	    "ჭანტურიას",
	    "ჭოველიძის",
	    "ჭონქაძის",
	    "ჭყონდიდელის",
	    "ხანძთელის",
	    "ხვამლის",
	    "ხვინგიას",
	    "ხვიჩიას",
	    "ხიმშიაშვილის",
	    "ხმელნიცკის",
	    "ხორნაბუჯის",
	    "ხრამჰესის",
	    "ხუციშვილის",
	    "ჯავახიშვილის",
	    "ჯაფარიძის",
	    "ჯიბლაძის",
	    "ჯორჯიაშვილის"
	  ],
	  "street_name": [
	    "#{street_title} #{street_suffix}"
	  ],
	  "street_address": [
	    "#{street_name} #{building_number}"
	  ],
	  "default_country": [
	    "საქართველო"
	  ]
	};
	ge.internet = {
	  "free_email": [
	    "gmail.com",
	    "yahoo.com",
	    "posta.ge"
	  ],
	  "domain_suffix": [
	    "ge",
	    "com",
	    "net",
	    "org",
	    "com.ge",
	    "org.ge"
	  ]
	};
	ge.company = {
	  "prefix": [
	    "შპს",
	    "სს",
	    "ააიპ",
	    "სსიპ"
	  ],
	  "suffix": [
	    "ჯგუფი",
	    "და კომპანია",
	    "სტუდია",
	    "გრუპი"
	  ],
	  "name": [
	    "#{prefix} #{Name.first_name}",
	    "#{prefix} #{Name.last_name}",
	    "#{prefix} #{Name.last_name} #{suffix}",
	    "#{prefix} #{Name.first_name} #{suffix}",
	    "#{prefix} #{Name.last_name}-#{Name.last_name}"
	  ]
	};
	ge.phone_number = {
	  "formats": [
	    "5##-###-###",
	    "5########",
	    "5## ## ## ##",
	    "5## ######",
	    "5## ### ###",
	    "995 5##-###-###",
	    "995 5########",
	    "995 5## ## ## ##",
	    "995 5## ######",
	    "995 5## ### ###",
	    "+995 5##-###-###",
	    "+995 5########",
	    "+995 5## ## ## ##",
	    "+995 5## ######",
	    "+995 5## ### ###",
	    "(+995) 5##-###-###",
	    "(+995) 5########",
	    "(+995) 5## ## ## ##",
	    "(+995) 5## ######",
	    "(+995) 5## ### ###"
	  ]
	};
	ge.cell_phone = {
	  "formats": [
	    "(+995 32) 2-##-##-##",
	    "032-2-##-##-##",
	    "032-2-######",
	    "032-2-###-###",
	    "032 2 ## ## ##",
	    "032 2 ######",
	    "2 ## ## ##",
	    "2######",
	    "2 ### ###"
	  ]
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)(module)))

/***/ },
/* 307 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var it = {};
	module["exports"] = it;
	it.title = "Italian";
	it.address = {
	  "city_prefix": [
	    "San",
	    "Borgo",
	    "Sesto",
	    "Quarto",
	    "Settimo"
	  ],
	  "city_suffix": [
	    "a mare",
	    "lido",
	    "ligure",
	    "del friuli",
	    "salentino",
	    "calabro",
	    "veneto",
	    "nell'emilia",
	    "umbro",
	    "laziale",
	    "terme",
	    "sardo"
	  ],
	  "country": [
	    "Afghanistan",
	    "Albania",
	    "Algeria",
	    "American Samoa",
	    "Andorra",
	    "Angola",
	    "Anguilla",
	    "Antartide (territori a sud del 60° parallelo)",
	    "Antigua e Barbuda",
	    "Argentina",
	    "Armenia",
	    "Aruba",
	    "Australia",
	    "Austria",
	    "Azerbaijan",
	    "Bahamas",
	    "Bahrain",
	    "Bangladesh",
	    "Barbados",
	    "Bielorussia",
	    "Belgio",
	    "Belize",
	    "Benin",
	    "Bermuda",
	    "Bhutan",
	    "Bolivia",
	    "Bosnia e Herzegovina",
	    "Botswana",
	    "Bouvet Island (Bouvetoya)",
	    "Brasile",
	    "Territorio dell'arcipelago indiano",
	    "Isole Vergini Britanniche",
	    "Brunei Darussalam",
	    "Bulgaria",
	    "Burkina Faso",
	    "Burundi",
	    "Cambogia",
	    "Cameroon",
	    "Canada",
	    "Capo Verde",
	    "Isole Cayman",
	    "Repubblica Centrale Africana",
	    "Chad",
	    "Cile",
	    "Cina",
	    "Isola di Pasqua",
	    "Isola di Cocos (Keeling)",
	    "Colombia",
	    "Comoros",
	    "Congo",
	    "Isole Cook",
	    "Costa Rica",
	    "Costa d'Avorio",
	    "Croazia",
	    "Cuba",
	    "Cipro",
	    "Repubblica Ceca",
	    "Danimarca",
	    "Gibuti",
	    "Repubblica Dominicana",
	    "Equador",
	    "Egitto",
	    "El Salvador",
	    "Guinea Equatoriale",
	    "Eritrea",
	    "Estonia",
	    "Etiopia",
	    "Isole Faroe",
	    "Isole Falkland (Malvinas)",
	    "Fiji",
	    "Finlandia",
	    "Francia",
	    "Guyana Francese",
	    "Polinesia Francese",
	    "Territori Francesi del sud",
	    "Gabon",
	    "Gambia",
	    "Georgia",
	    "Germania",
	    "Ghana",
	    "Gibilterra",
	    "Grecia",
	    "Groenlandia",
	    "Grenada",
	    "Guadalupa",
	    "Guam",
	    "Guatemala",
	    "Guernsey",
	    "Guinea",
	    "Guinea-Bissau",
	    "Guyana",
	    "Haiti",
	    "Heard Island and McDonald Islands",
	    "Città del Vaticano",
	    "Honduras",
	    "Hong Kong",
	    "Ungheria",
	    "Islanda",
	    "India",
	    "Indonesia",
	    "Iran",
	    "Iraq",
	    "Irlanda",
	    "Isola di Man",
	    "Israele",
	    "Italia",
	    "Giamaica",
	    "Giappone",
	    "Jersey",
	    "Giordania",
	    "Kazakhstan",
	    "Kenya",
	    "Kiribati",
	    "Korea",
	    "Kuwait",
	    "Republicca Kirgiza",
	    "Repubblica del Laos",
	    "Latvia",
	    "Libano",
	    "Lesotho",
	    "Liberia",
	    "Libyan Arab Jamahiriya",
	    "Liechtenstein",
	    "Lituania",
	    "Lussemburgo",
	    "Macao",
	    "Macedonia",
	    "Madagascar",
	    "Malawi",
	    "Malesia",
	    "Maldive",
	    "Mali",
	    "Malta",
	    "Isole Marshall",
	    "Martinica",
	    "Mauritania",
	    "Mauritius",
	    "Mayotte",
	    "Messico",
	    "Micronesia",
	    "Moldova",
	    "Principato di Monaco",
	    "Mongolia",
	    "Montenegro",
	    "Montserrat",
	    "Marocco",
	    "Mozambico",
	    "Myanmar",
	    "Namibia",
	    "Nauru",
	    "Nepal",
	    "Antille Olandesi",
	    "Olanda",
	    "Nuova Caledonia",
	    "Nuova Zelanda",
	    "Nicaragua",
	    "Niger",
	    "Nigeria",
	    "Niue",
	    "Isole Norfolk",
	    "Northern Mariana Islands",
	    "Norvegia",
	    "Oman",
	    "Pakistan",
	    "Palau",
	    "Palestina",
	    "Panama",
	    "Papua Nuova Guinea",
	    "Paraguay",
	    "Peru",
	    "Filippine",
	    "Pitcairn Islands",
	    "Polonia",
	    "Portogallo",
	    "Porto Rico",
	    "Qatar",
	    "Reunion",
	    "Romania",
	    "Russia",
	    "Rwanda",
	    "San Bartolomeo",
	    "Sant'Elena",
	    "Saint Kitts and Nevis",
	    "Saint Lucia",
	    "Saint Martin",
	    "Saint Pierre and Miquelon",
	    "Saint Vincent and the Grenadines",
	    "Samoa",
	    "San Marino",
	    "Sao Tome and Principe",
	    "Arabia Saudita",
	    "Senegal",
	    "Serbia",
	    "Seychelles",
	    "Sierra Leone",
	    "Singapore",
	    "Slovenia",
	    "Isole Solomon",
	    "Somalia",
	    "Sud Africa",
	    "Georgia del sud e South Sandwich Islands",
	    "Spagna",
	    "Sri Lanka",
	    "Sudan",
	    "Suriname",
	    "Svalbard & Jan Mayen Islands",
	    "Swaziland",
	    "Svezia",
	    "Svizzera",
	    "Siria",
	    "Taiwan",
	    "Tajikistan",
	    "Tanzania",
	    "Tailandia",
	    "Timor-Leste",
	    "Togo",
	    "Tokelau",
	    "Tonga",
	    "Trinidad e Tobago",
	    "Tunisia",
	    "Turchia",
	    "Turkmenistan",
	    "Isole di Turks and Caicos",
	    "Tuvalu",
	    "Uganda",
	    "Ucraina",
	    "Emirati Arabi Uniti",
	    "Regno Unito",
	    "Stati Uniti d'America",
	    "United States Minor Outlying Islands",
	    "Isole Vergini Statunitensi",
	    "Uruguay",
	    "Uzbekistan",
	    "Vanuatu",
	    "Venezuela",
	    "Vietnam",
	    "Wallis and Futuna",
	    "Western Sahara",
	    "Yemen",
	    "Zambia",
	    "Zimbabwe"
	  ],
	  "building_number": [
	    "###",
	    "##",
	    "#"
	  ],
	  "street_suffix": [
	    "Piazza",
	    "Strada",
	    "Via",
	    "Borgo",
	    "Contrada",
	    "Rotonda",
	    "Incrocio"
	  ],
	  "secondary_address": [
	    "Appartamento ##",
	    "Piano #"
	  ],
	  "postcode": [
	    "#####"
	  ],
	  "state": [
	    "Agrigento",
	    "Alessandria",
	    "Ancona",
	    "Aosta",
	    "Arezzo",
	    "Ascoli Piceno",
	    "Asti",
	    "Avellino",
	    "Bari",
	    "Barletta-Andria-Trani",
	    "Belluno",
	    "Benevento",
	    "Bergamo",
	    "Biella",
	    "Bologna",
	    "Bolzano",
	    "Brescia",
	    "Brindisi",
	    "Cagliari",
	    "Caltanissetta",
	    "Campobasso",
	    "Carbonia-Iglesias",
	    "Caserta",
	    "Catania",
	    "Catanzaro",
	    "Chieti",
	    "Como",
	    "Cosenza",
	    "Cremona",
	    "Crotone",
	    "Cuneo",
	    "Enna",
	    "Fermo",
	    "Ferrara",
	    "Firenze",
	    "Foggia",
	    "Forlì-Cesena",
	    "Frosinone",
	    "Genova",
	    "Gorizia",
	    "Grosseto",
	    "Imperia",
	    "Isernia",
	    "La Spezia",
	    "L'Aquila",
	    "Latina",
	    "Lecce",
	    "Lecco",
	    "Livorno",
	    "Lodi",
	    "Lucca",
	    "Macerata",
	    "Mantova",
	    "Massa-Carrara",
	    "Matera",
	    "Messina",
	    "Milano",
	    "Modena",
	    "Monza e della Brianza",
	    "Napoli",
	    "Novara",
	    "Nuoro",
	    "Olbia-Tempio",
	    "Oristano",
	    "Padova",
	    "Palermo",
	    "Parma",
	    "Pavia",
	    "Perugia",
	    "Pesaro e Urbino",
	    "Pescara",
	    "Piacenza",
	    "Pisa",
	    "Pistoia",
	    "Pordenone",
	    "Potenza",
	    "Prato",
	    "Ragusa",
	    "Ravenna",
	    "Reggio Calabria",
	    "Reggio Emilia",
	    "Rieti",
	    "Rimini",
	    "Roma",
	    "Rovigo",
	    "Salerno",
	    "Medio Campidano",
	    "Sassari",
	    "Savona",
	    "Siena",
	    "Siracusa",
	    "Sondrio",
	    "Taranto",
	    "Teramo",
	    "Terni",
	    "Torino",
	    "Ogliastra",
	    "Trapani",
	    "Trento",
	    "Treviso",
	    "Trieste",
	    "Udine",
	    "Varese",
	    "Venezia",
	    "Verbano-Cusio-Ossola",
	    "Vercelli",
	    "Verona",
	    "Vibo Valentia",
	    "Vicenza",
	    "Viterbo"
	  ],
	  "state_abbr": [
	    "AG",
	    "AL",
	    "AN",
	    "AO",
	    "AR",
	    "AP",
	    "AT",
	    "AV",
	    "BA",
	    "BT",
	    "BL",
	    "BN",
	    "BG",
	    "BI",
	    "BO",
	    "BZ",
	    "BS",
	    "BR",
	    "CA",
	    "CL",
	    "CB",
	    "CI",
	    "CE",
	    "CT",
	    "CZ",
	    "CH",
	    "CO",
	    "CS",
	    "CR",
	    "KR",
	    "CN",
	    "EN",
	    "FM",
	    "FE",
	    "FI",
	    "FG",
	    "FC",
	    "FR",
	    "GE",
	    "GO",
	    "GR",
	    "IM",
	    "IS",
	    "SP",
	    "AQ",
	    "LT",
	    "LE",
	    "LC",
	    "LI",
	    "LO",
	    "LU",
	    "MC",
	    "MN",
	    "MS",
	    "MT",
	    "ME",
	    "MI",
	    "MO",
	    "MB",
	    "NA",
	    "NO",
	    "NU",
	    "OT",
	    "OR",
	    "PD",
	    "PA",
	    "PR",
	    "PV",
	    "PG",
	    "PU",
	    "PE",
	    "PC",
	    "PI",
	    "PT",
	    "PN",
	    "PZ",
	    "PO",
	    "RG",
	    "RA",
	    "RC",
	    "RE",
	    "RI",
	    "RN",
	    "RM",
	    "RO",
	    "SA",
	    "VS",
	    "SS",
	    "SV",
	    "SI",
	    "SR",
	    "SO",
	    "TA",
	    "TE",
	    "TR",
	    "TO",
	    "OG",
	    "TP",
	    "TN",
	    "TV",
	    "TS",
	    "UD",
	    "VA",
	    "VE",
	    "VB",
	    "VC",
	    "VR",
	    "VV",
	    "VI",
	    "VT"
	  ],
	  "city": [
	    "#{city_prefix} #{Name.first_name} #{city_suffix}",
	    "#{city_prefix} #{Name.first_name}",
	    "#{Name.first_name} #{city_suffix}",
	    "#{Name.last_name} #{city_suffix}"
	  ],
	  "street_name": [
	    "#{street_suffix} #{Name.first_name}",
	    "#{street_suffix} #{Name.last_name}"
	  ],
	  "street_address": [
	    "#{street_name} #{building_number}",
	    "#{street_name} #{building_number}, #{secondary_address}"
	  ],
	  "default_country": [
	    "Italia"
	  ]
	};
	it.company = {
	  "suffix": [
	    "SPA",
	    "e figli",
	    "Group",
	    "s.r.l."
	  ],
	  "noun": [
	      "Abilità",
	      "Access",
	      "Adattatore",
	      "Algoritmo",
	      "Alleanza",
	      "Analizzatore",
	      "Applicazione",
	      "Approccio",
	      "Architettura",
	      "Archivio",
	      "Intelligenza artificiale",
	      "Array",
	      "Attitudine",
	      "Benchmark",
	      "Capacità",
	      "Sfida",
	      "Circuito",
	      "Collaborazione",
	      "Complessità",
	      "Concetto",
	      "Conglomerato",
	      "Contingenza",
	      "Core",
	      "Database",
	      "Data-warehouse",
	      "Definizione",
	      "Emulazione",
	      "Codifica",
	      "Criptazione",
	      "Firmware",
	      "Flessibilità",
	      "Previsione",
	      "Frame",
	      "framework",
	      "Funzione",
	      "Funzionalità",
	      "Interfaccia grafica",
	      "Hardware",
	      "Help-desk",
	      "Gerarchia",
	      "Hub",
	      "Implementazione",
	      "Infrastruttura",
	      "Iniziativa",
	      "Installazione",
	      "Set di istruzioni",
	      "Interfaccia",
	      "Soluzione internet",
	      "Intranet",
	      "Conoscenza base",
	      "Matrici",
	      "Matrice",
	      "Metodologia",
	      "Middleware",
	      "Migrazione",
	      "Modello",
	      "Moderazione",
	      "Monitoraggio",
	      "Moratoria",
	      "Rete",
	      "Architettura aperta",
	      "Sistema aperto",
	      "Orchestrazione",
	      "Paradigma",
	      "Parallelismo",
	      "Policy",
	      "Portale",
	      "Struttura di prezzo",
	      "Prodotto",
	      "Produttività",
	      "Progetto",
	      "Proiezione",
	      "Protocollo",
	      "Servizio clienti",
	      "Software",
	      "Soluzione",
	      "Standardizzazione",
	      "Strategia",
	      "Struttura",
	      "Successo",
	      "Sovrastruttura",
	      "Supporto",
	      "Sinergia",
	      "Task-force",
	      "Finestra temporale",
	      "Strumenti",
	      "Utilizzazione",
	      "Sito web",
	      "Forza lavoro"
	    ],
	    "descriptor":[
	      "adattiva",
	      "avanzata",
	      "migliorata",
	      "assimilata",
	      "automatizzata",
	      "bilanciata",
	      "centralizzata",
	      "compatibile",
	      "configurabile",
	      "cross-platform",
	      "decentralizzata",
	      "digitalizzata",
	      "distribuita",
	      "piccola",
	      "ergonomica",
	      "esclusiva",
	      "espansa",
	      "estesa",
	      "configurabile",
	      "fondamentale",
	      "orizzontale",
	      "implementata",
	      "innovativa",
	      "integrata",
	      "intuitiva",
	      "inversa",
	      "gestita",
	      "obbligatoria",
	      "monitorata",
	      "multi-canale",
	      "multi-laterale",
	      "open-source",
	      "operativa",
	      "ottimizzata",
	      "organica",
	      "persistente",
	      "polarizzata",
	      "proattiva",
	      "programmabile",
	      "progressiva",
	      "reattiva",
	      "riallineata",
	      "ricontestualizzata",
	      "ridotta",
	      "robusta",
	      "sicura",
	      "condivisibile",
	      "stand-alone",
	      "switchabile",
	      "sincronizzata",
	      "sinergica",
	      "totale",
	      "universale",
	      "user-friendly",
	      "versatile",
	      "virtuale",
	      "visionaria"
	    ],
	    "adjective":
	    [
	      "24 ore",
	      "24/7",
	      "terza generazione",
	      "quarta generazione",
	      "quinta generazione",
	      "sesta generazione",
	      "asimmetrica",
	      "asincrona",
	      "background",
	      "bi-direzionale",
	      "biforcata",
	      "bottom-line",
	      "coerente",
	      "coesiva",
	      "composita",
	      "sensibile al contesto",
	      "basta sul contesto",
	      "basata sul contenuto",
	      "dedicata",
	      "didattica",
	      "direzionale",
	      "discreta",
	      "dinamica",
	      "eco-centrica",
	      "esecutiva",
	      "esplicita",
	      "full-range",
	      "globale",
	      "euristica",
	      "alto livello",
	      "olistica",
	      "omogenea",
	      "ibrida",
	      "impattante",
	      "incrementale",
	      "intangibile",
	      "interattiva",
	      "intermediaria",
	      "locale",
	      "logistica",
	      "massimizzata",
	      "metodica",
	      "mission-critical",
	      "mobile",
	      "modulare",
	      "motivazionale",
	      "multimedia",
	      "multi-tasking",
	      "nazionale",
	      "neutrale",
	      "nextgeneration",
	      "non-volatile",
	      "object-oriented",
	      "ottima",
	      "ottimizzante",
	      "radicale",
	      "real-time",
	      "reciproca",
	      "regionale",
	      "responsiva",
	      "scalabile",
	      "secondaria",
	      "stabile",
	      "statica",
	      "sistematica",
	      "sistemica",
	      "tangibile",
	      "terziaria",
	      "uniforme",
	      "valore aggiunto"
	  ],
	  "bs_noun": [
	      "partnerships",
	      "comunità",
	      "ROI",
	      "soluzioni",
	      "e-services",
	      "nicchie",
	      "tecnologie",
	      "contenuti",
	      "supply-chains",
	      "convergenze",
	      "relazioni",
	      "architetture",
	      "interfacce",
	      "mercati",
	      "e-commerce",
	      "sistemi",
	      "modelli",
	      "schemi",
	      "reti",
	      "applicazioni",
	      "metriche",
	      "e-business",
	      "funzionalità",
	      "esperienze",
	      "webservices",
	      "metodologie"
	    ],
	    "bs_verb":
	    [
	      "implementate",
	      "utilizzo",
	      "integrate",
	      "ottimali",
	      "evolutive",
	      "abilitate",
	      "reinventate",
	      "aggregate",
	      "migliorate",
	      "incentivate",
	      "monetizzate",
	      "sinergizzate",
	      "strategiche",
	      "deploy",
	      "marchi",
	      "accrescitive",
	      "target",
	      "sintetizzate",
	      "spedizioni",
	      "massimizzate",
	      "innovazione",
	      "guida",
	      "estensioni",
	      "generate",
	      "exploit",
	      "transizionali",
	      "matrici",
	      "ricontestualizzate"
	    ],
	    "bs_adjective":
	    [
	      "valore aggiunto",
	      "verticalizzate",
	      "proattive",
	      "forti",
	      "rivoluzionari",
	      "scalabili",
	      "innovativi",
	      "intuitivi",
	      "strategici",
	      "e-business",
	      "mission-critical",
	      "24/7",
	      "globali",
	      "B2B",
	      "B2C",
	      "granulari",
	      "virtuali",
	      "virali",
	      "dinamiche",
	      "magnetiche",
	      "web",
	      "interattive",
	      "sexy",
	      "back-end",
	      "real-time",
	      "efficienti",
	      "front-end",
	      "distributivi",
	      "estensibili",
	      "mondiali",
	      "open-source",
	      "cross-platform",
	      "sinergiche",
	      "out-of-the-box",
	      "enterprise",
	      "integrate",
	      "di impatto",
	      "wireless",
	      "trasparenti",
	      "next-generation",
	      "cutting-edge",
	      "visionari",
	      "plug-and-play",
	      "collaborative",
	      "olistiche",
	      "ricche"
	  ],
	  "name": [
	    "#{Name.last_name} #{suffix}",
	    "#{Name.last_name}-#{Name.last_name} #{suffix}",
	    "#{Name.last_name}, #{Name.last_name} e #{Name.last_name} #{suffix}"
	  ]
	};
	it.internet = {
	  "free_email": [
	    "gmail.com",
	    "yahoo.com",
	    "hotmail.com",
	    "email.it",
	    "libero.it",
	    "yahoo.it"
	  ],
	  "domain_suffix": [
	    "com",
	    "com",
	    "com",
	    "net",
	    "org",
	    "it",
	    "it",
	    "it"
	  ]
	};
	it.name = {
	  "first_name": [
	    "Aaron",
	    "Akira",
	    "Alberto",
	    "Alessandro",
	    "Alighieri",
	    "Amedeo",
	    "Amos",
	    "Anselmo",
	    "Antonino",
	    "Arcibaldo",
	    "Armando",
	    "Artes",
	    "Audenico",
	    "Ausonio",
	    "Bacchisio",
	    "Battista",
	    "Bernardo",
	    "Boris",
	    "Caio",
	    "Carlo",
	    "Cecco",
	    "Cirino",
	    "Cleros",
	    "Costantino",
	    "Damiano",
	    "Danny",
	    "Davide",
	    "Demian",
	    "Dimitri",
	    "Domingo",
	    "Dylan",
	    "Edilio",
	    "Egidio",
	    "Elio",
	    "Emanuel",
	    "Enrico",
	    "Ercole",
	    "Ermes",
	    "Ethan",
	    "Eusebio",
	    "Evangelista",
	    "Fabiano",
	    "Ferdinando",
	    "Fiorentino",
	    "Flavio",
	    "Fulvio",
	    "Gabriele",
	    "Gastone",
	    "Germano",
	    "Giacinto",
	    "Gianantonio",
	    "Gianleonardo",
	    "Gianmarco",
	    "Gianriccardo",
	    "Gioacchino",
	    "Giordano",
	    "Giuliano",
	    "Graziano",
	    "Guido",
	    "Harry",
	    "Iacopo",
	    "Ilario",
	    "Ione",
	    "Italo",
	    "Jack",
	    "Jari",
	    "Joey",
	    "Joseph",
	    "Kai",
	    "Kociss",
	    "Laerte",
	    "Lauro",
	    "Leonardo",
	    "Liborio",
	    "Lorenzo",
	    "Ludovico",
	    "Maggiore",
	    "Manuele",
	    "Mariano",
	    "Marvin",
	    "Matteo",
	    "Mauro",
	    "Michael",
	    "Mirco",
	    "Modesto",
	    "Muzio",
	    "Nabil",
	    "Nathan",
	    "Nick",
	    "Noah",
	    "Odino",
	    "Olo",
	    "Oreste",
	    "Osea",
	    "Pablo",
	    "Patrizio",
	    "Piererminio",
	    "Pierfrancesco",
	    "Piersilvio",
	    "Priamo",
	    "Quarto",
	    "Quirino",
	    "Radames",
	    "Raniero",
	    "Renato",
	    "Rocco",
	    "Romeo",
	    "Rosalino",
	    "Rudy",
	    "Sabatino",
	    "Samuel",
	    "Santo",
	    "Sebastian",
	    "Serse",
	    "Silvano",
	    "Sirio",
	    "Tancredi",
	    "Terzo",
	    "Timoteo",
	    "Tolomeo",
	    "Trevis",
	    "Ubaldo",
	    "Ulrico",
	    "Valdo",
	    "Neri",
	    "Vinicio",
	    "Walter",
	    "Xavier",
	    "Yago",
	    "Zaccaria",
	    "Abramo",
	    "Adriano",
	    "Alan",
	    "Albino",
	    "Alessio",
	    "Alighiero",
	    "Amerigo",
	    "Anastasio",
	    "Antimo",
	    "Antonio",
	    "Arduino",
	    "Aroldo",
	    "Arturo",
	    "Augusto",
	    "Avide",
	    "Baldassarre",
	    "Bettino",
	    "Bortolo",
	    "Caligola",
	    "Carmelo",
	    "Celeste",
	    "Ciro",
	    "Costanzo",
	    "Dante",
	    "Danthon",
	    "Davis",
	    "Demis",
	    "Dindo",
	    "Domiziano",
	    "Edipo",
	    "Egisto",
	    "Eliziario",
	    "Emidio",
	    "Enzo",
	    "Eriberto",
	    "Erminio",
	    "Ettore",
	    "Eustachio",
	    "Fabio",
	    "Fernando",
	    "Fiorenzo",
	    "Folco",
	    "Furio",
	    "Gaetano",
	    "Gavino",
	    "Gerlando",
	    "Giacobbe",
	    "Giancarlo",
	    "Gianmaria",
	    "Giobbe",
	    "Giorgio",
	    "Giulio",
	    "Gregorio",
	    "Hector",
	    "Ian",
	    "Ippolito",
	    "Ivano",
	    "Jacopo",
	    "Jarno",
	    "Joannes",
	    "Joshua",
	    "Karim",
	    "Kris",
	    "Lamberto",
	    "Lazzaro",
	    "Leone",
	    "Lino",
	    "Loris",
	    "Luigi",
	    "Manfredi",
	    "Marco",
	    "Marino",
	    "Marzio",
	    "Mattia",
	    "Max",
	    "Michele",
	    "Mirko",
	    "Moreno",
	    "Nadir",
	    "Nazzareno",
	    "Nestore",
	    "Nico",
	    "Noel",
	    "Odone",
	    "Omar",
	    "Orfeo",
	    "Osvaldo",
	    "Pacifico",
	    "Pericle",
	    "Pietro",
	    "Primo",
	    "Quasimodo",
	    "Radio",
	    "Raoul",
	    "Renzo",
	    "Rodolfo",
	    "Romolo",
	    "Rosolino",
	    "Rufo",
	    "Sabino",
	    "Sandro",
	    "Sasha",
	    "Secondo",
	    "Sesto",
	    "Silverio",
	    "Siro",
	    "Tazio",
	    "Teseo",
	    "Timothy",
	    "Tommaso",
	    "Tristano",
	    "Umberto",
	    "Ariel",
	    "Artemide",
	    "Assia",
	    "Azue",
	    "Benedetta",
	    "Bibiana",
	    "Brigitta",
	    "Carmela",
	    "Cassiopea",
	    "Cesidia",
	    "Cira",
	    "Clea",
	    "Cleopatra",
	    "Clodovea",
	    "Concetta",
	    "Cosetta",
	    "Cristyn",
	    "Damiana",
	    "Danuta",
	    "Deborah",
	    "Demi",
	    "Diamante",
	    "Diana",
	    "Donatella",
	    "Doriana",
	    "Edvige",
	    "Elda",
	    "Elga",
	    "Elsa",
	    "Emilia",
	    "Enrica",
	    "Erminia",
	    "Eufemia",
	    "Evita",
	    "Fatima",
	    "Felicia",
	    "Filomena",
	    "Flaviana",
	    "Fortunata",
	    "Gelsomina",
	    "Genziana",
	    "Giacinta",
	    "Gilda",
	    "Giovanna",
	    "Giulietta",
	    "Grazia",
	    "Guendalina",
	    "Helga",
	    "Ileana",
	    "Ingrid",
	    "Irene",
	    "Isabel",
	    "Isira",
	    "Ivonne",
	    "Jelena",
	    "Jole",
	    "Claudia",
	    "Kayla",
	    "Kristel",
	    "Laura",
	    "Lucia",
	    "Lia",
	    "Lidia",
	    "Lisa",
	    "Loredana",
	    "Loretta",
	    "Luce",
	    "Lucrezia",
	    "Luna",
	    "Maika",
	    "Marcella",
	    "Maria",
	    "Mariagiulia",
	    "Marianita",
	    "Mariapia",
	    "Marieva",
	    "Marina",
	    "Maristella",
	    "Maruska",
	    "Matilde",
	    "Mecren",
	    "Mercedes",
	    "Mietta",
	    "Miriana",
	    "Miriam",
	    "Monia",
	    "Morgana",
	    "Naomi",
	    "Nayade",
	    "Nicoletta",
	    "Ninfa",
	    "Noemi",
	    "Nunzia",
	    "Olimpia",
	    "Oretta",
	    "Ortensia",
	    "Penelope",
	    "Piccarda",
	    "Prisca",
	    "Rebecca",
	    "Rita",
	    "Rosalba",
	    "Rosaria",
	    "Rosita",
	    "Ruth",
	    "Samira",
	    "Sarita",
	    "Selvaggia",
	    "Shaira",
	    "Sibilla",
	    "Soriana",
	    "Thea",
	    "Tosca",
	    "Ursula",
	    "Vania",
	    "Vera",
	    "Vienna",
	    "Violante",
	    "Vitalba",
	    "Zelida"
	  ],
	  "last_name": [
	    "Amato",
	    "Barbieri",
	    "Barone",
	    "Basile",
	    "Battaglia",
	    "Bellini",
	    "Benedetti",
	    "Bernardi",
	    "Bianc",
	    "Bianchi",
	    "Bruno",
	    "Caputo",
	    "Carbon",
	    "Caruso",
	    "Cattaneo",
	    "Colombo",
	    "Cont",
	    "Conte",
	    "Coppola",
	    "Costa",
	    "Costantin",
	    "D'amico",
	    "D'angelo",
	    "Damico",
	    "De Angelis",
	    "De luca",
	    "De rosa",
	    "De Santis",
	    "Donati",
	    "Esposito",
	    "Fabbri",
	    "Farin",
	    "Ferrara",
	    "Ferrari",
	    "Ferraro",
	    "Ferretti",
	    "Ferri",
	    "Fior",
	    "Fontana",
	    "Galli",
	    "Gallo",
	    "Gatti",
	    "Gentile",
	    "Giordano",
	    "Giuliani",
	    "Grassi",
	    "Grasso",
	    "Greco",
	    "Guerra",
	    "Leone",
	    "Lombardi",
	    "Lombardo",
	    "Longo",
	    "Mancini",
	    "Marchetti",
	    "Marian",
	    "Marini",
	    "Marino",
	    "Martinelli",
	    "Martini",
	    "Martino",
	    "Mazza",
	    "Messina",
	    "Milani",
	    "Montanari",
	    "Monti",
	    "Morelli",
	    "Moretti",
	    "Negri",
	    "Neri",
	    "Orlando",
	    "Pagano",
	    "Palmieri",
	    "Palumbo",
	    "Parisi",
	    "Pellegrini",
	    "Pellegrino",
	    "Piras",
	    "Ricci",
	    "Rinaldi",
	    "Riva",
	    "Rizzi",
	    "Rizzo",
	    "Romano",
	    "Ross",
	    "Rossetti",
	    "Ruggiero",
	    "Russo",
	    "Sala",
	    "Sanna",
	    "Santoro",
	    "Sartori",
	    "Serr",
	    "Silvestri",
	    "Sorrentino",
	    "Testa",
	    "Valentini",
	    "Villa",
	    "Vitale",
	    "Vitali"
	  ],
	  "prefix": [
	    "Sig.",
	    "Dott.",
	    "Dr.",
	    "Ing."
	  ],
	  "suffix": [],
	  "name": [
	    "#{prefix} #{first_name} #{last_name}",
	    "#{first_name} #{last_name}",
	    "#{first_name} #{last_name}",
	    "#{first_name} #{last_name}",
	    "#{first_name} #{last_name}",
	    "#{first_name} #{last_name}"
	  ]
	};
	it.phone_number = {
	  "formats": [
	    "+## ### ## ## ####",
	    "+## ## #######",
	    "+## ## ########",
	    "+## ### #######",
	    "+## ### ########",
	    "+## #### #######",
	    "+## #### ########",
	    "0## ### ####",
	    "+39 0## ### ###",
	    "3## ### ###",
	    "+39 3## ### ###"
	  ]
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)(module)))

/***/ },
/* 308 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var ja = {};
	module["exports"] = ja;
	ja.title = "Japanese";
	ja.address = {
	  "postcode": [
	    "###-####"
	  ],
	  "state": [
	    "北海道",
	    "青森県",
	    "岩手県",
	    "宮城県",
	    "秋田県",
	    "山形県",
	    "福島県",
	    "茨城県",
	    "栃木県",
	    "群馬県",
	    "埼玉県",
	    "千葉県",
	    "東京都",
	    "神奈川県",
	    "新潟県",
	    "富山県",
	    "石川県",
	    "福井県",
	    "山梨県",
	    "長野県",
	    "岐阜県",
	    "静岡県",
	    "愛知県",
	    "三重県",
	    "滋賀県",
	    "京都府",
	    "大阪府",
	    "兵庫県",
	    "奈良県",
	    "和歌山県",
	    "鳥取県",
	    "島根県",
	    "岡山県",
	    "広島県",
	    "山口県",
	    "徳島県",
	    "香川県",
	    "愛媛県",
	    "高知県",
	    "福岡県",
	    "佐賀県",
	    "長崎県",
	    "熊本県",
	    "大分県",
	    "宮崎県",
	    "鹿児島県",
	    "沖縄県"
	  ],
	  "state_abbr": [
	    "1",
	    "2",
	    "3",
	    "4",
	    "5",
	    "6",
	    "7",
	    "8",
	    "9",
	    "10",
	    "11",
	    "12",
	    "13",
	    "14",
	    "15",
	    "16",
	    "17",
	    "18",
	    "19",
	    "20",
	    "21",
	    "22",
	    "23",
	    "24",
	    "25",
	    "26",
	    "27",
	    "28",
	    "29",
	    "30",
	    "31",
	    "32",
	    "33",
	    "34",
	    "35",
	    "36",
	    "37",
	    "38",
	    "39",
	    "40",
	    "41",
	    "42",
	    "43",
	    "44",
	    "45",
	    "46",
	    "47"
	  ],
	  "city_prefix": [
	    "北",
	    "東",
	    "西",
	    "南",
	    "新",
	    "湖",
	    "港"
	  ],
	  "city_suffix": [
	    "市",
	    "区",
	    "町",
	    "村"
	  ],
	  "city": [
	    "#{city_prefix}#{Name.first_name}#{city_suffix}",
	    "#{Name.first_name}#{city_suffix}",
	    "#{city_prefix}#{Name.last_name}#{city_suffix}",
	    "#{Name.last_name}#{city_suffix}"
	  ],
	  "street_name": [
	    "#{Name.first_name}#{street_suffix}",
	    "#{Name.last_name}#{street_suffix}"
	  ]
	};
	ja.phone_number = {
	  "formats": [
	    "0####-#-####",
	    "0###-##-####",
	    "0##-###-####",
	    "0#-####-####"
	  ]
	};
	ja.cell_phone = {
	  "formats": [
	    "090-####-####",
	    "080-####-####",
	    "070-####-####"
	  ]
	};
	ja.name = {
	  "last_name": [
	    "佐藤",
	    "鈴木",
	    "高橋",
	    "田中",
	    "渡辺",
	    "伊藤",
	    "山本",
	    "中村",
	    "小林",
	    "加藤",
	    "吉田",
	    "山田",
	    "佐々木",
	    "山口",
	    "斎藤",
	    "松本",
	    "井上",
	    "木村",
	    "林",
	    "清水"
	  ],
	  "first_name": [
	    "大翔",
	    "蓮",
	    "颯太",
	    "樹",
	    "大和",
	    "陽翔",
	    "陸斗",
	    "太一",
	    "海翔",
	    "蒼空",
	    "翼",
	    "陽菜",
	    "結愛",
	    "結衣",
	    "杏",
	    "莉子",
	    "美羽",
	    "結菜",
	    "心愛",
	    "愛菜",
	    "美咲"
	  ],
	  "name": [
	    "#{last_name} #{first_name}"
	  ]
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)(module)))

/***/ },
/* 309 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var ko = {};
	module["exports"] = ko;
	ko.title = "Korean";
	ko.address = {
	  "postcode": [
	    "###-###"
	  ],
	  "state": [
	    "강원",
	    "경기",
	    "경남",
	    "경북",
	    "광주",
	    "대구",
	    "대전",
	    "부산",
	    "서울",
	    "울산",
	    "인천",
	    "전남",
	    "전북",
	    "제주",
	    "충남",
	    "충북",
	    "세종"
	  ],
	  "state_abbr": [
	    "강원",
	    "경기",
	    "경남",
	    "경북",
	    "광주",
	    "대구",
	    "대전",
	    "부산",
	    "서울",
	    "울산",
	    "인천",
	    "전남",
	    "전북",
	    "제주",
	    "충남",
	    "충북",
	    "세종"
	  ],
	  "city_suffix": [
	    "구",
	    "시",
	    "군"
	  ],
	  "city_name": [
	    "강릉",
	    "양양",
	    "인제",
	    "광주",
	    "구리",
	    "부천",
	    "밀양",
	    "통영",
	    "창원",
	    "거창",
	    "고성",
	    "양산",
	    "김천",
	    "구미",
	    "영주",
	    "광산",
	    "남",
	    "북",
	    "고창",
	    "군산",
	    "남원",
	    "동작",
	    "마포",
	    "송파",
	    "용산",
	    "부평",
	    "강화",
	    "수성"
	  ],
	  "city": [
	    "#{city_name}#{city_suffix}"
	  ],
	  "street_root": [
	    "상계",
	    "화곡",
	    "신정",
	    "목",
	    "잠실",
	    "면목",
	    "주안",
	    "안양",
	    "중",
	    "정왕",
	    "구로",
	    "신월",
	    "연산",
	    "부평",
	    "창",
	    "만수",
	    "중계",
	    "검단",
	    "시흥",
	    "상도",
	    "방배",
	    "장유",
	    "상",
	    "광명",
	    "신길",
	    "행신",
	    "대명",
	    "동탄"
	  ],
	  "street_suffix": [
	    "읍",
	    "면",
	    "동"
	  ],
	  "street_name": [
	    "#{street_root}#{street_suffix}"
	  ]
	};
	ko.phone_number = {
	  "formats": [
	    "0#-#####-####",
	    "0##-###-####",
	    "0##-####-####"
	  ]
	};
	ko.company = {
	  "suffix": [
	    "연구소",
	    "게임즈",
	    "그룹",
	    "전자",
	    "물산",
	    "코리아"
	  ],
	  "prefix": [
	    "주식회사",
	    "한국"
	  ],
	  "name": [
	    "#{prefix} #{Name.first_name}",
	    "#{Name.first_name} #{suffix}"
	  ]
	};
	ko.internet = {
	  "free_email": [
	    "gmail.com",
	    "yahoo.co.kr",
	    "hanmail.net",
	    "naver.com"
	  ],
	  "domain_suffix": [
	    "co.kr",
	    "com",
	    "biz",
	    "info",
	    "ne.kr",
	    "net",
	    "or.kr",
	    "org"
	  ]
	};
	ko.lorem = {
	  "words": [
	    "국가는",
	    "법률이",
	    "정하는",
	    "바에",
	    "의하여",
	    "재외국민을",
	    "보호할",
	    "의무를",
	    "진다.",
	    "모든",
	    "국민은",
	    "신체의",
	    "자유를",
	    "가진다.",
	    "국가는",
	    "전통문화의",
	    "계승·발전과",
	    "민족문화의",
	    "창달에",
	    "노력하여야",
	    "한다.",
	    "통신·방송의",
	    "시설기준과",
	    "신문의",
	    "기능을",
	    "보장하기",
	    "위하여",
	    "필요한",
	    "사항은",
	    "법률로",
	    "정한다.",
	    "헌법에",
	    "의하여",
	    "체결·공포된",
	    "조약과",
	    "일반적으로",
	    "승인된",
	    "국제법규는",
	    "국내법과",
	    "같은",
	    "효력을",
	    "가진다.",
	    "다만,",
	    "현행범인인",
	    "경우와",
	    "장기",
	    "3년",
	    "이상의",
	    "형에",
	    "해당하는",
	    "죄를",
	    "범하고",
	    "도피",
	    "또는",
	    "증거인멸의",
	    "염려가",
	    "있을",
	    "때에는",
	    "사후에",
	    "영장을",
	    "청구할",
	    "수",
	    "있다.",
	    "저작자·발명가·과학기술자와",
	    "예술가의",
	    "권리는",
	    "법률로써",
	    "보호한다.",
	    "형사피고인은",
	    "유죄의",
	    "판결이",
	    "확정될",
	    "때까지는",
	    "무죄로",
	    "추정된다.",
	    "모든",
	    "국민은",
	    "행위시의",
	    "법률에",
	    "의하여",
	    "범죄를",
	    "구성하지",
	    "아니하는",
	    "행위로",
	    "소추되지",
	    "아니하며,",
	    "동일한",
	    "범죄에",
	    "대하여",
	    "거듭",
	    "처벌받지",
	    "아니한다.",
	    "국가는",
	    "평생교육을",
	    "진흥하여야",
	    "한다.",
	    "모든",
	    "국민은",
	    "사생활의",
	    "비밀과",
	    "자유를",
	    "침해받지",
	    "아니한다.",
	    "의무교육은",
	    "무상으로",
	    "한다.",
	    "저작자·발명가·과학기술자와",
	    "예술가의",
	    "권리는",
	    "법률로써",
	    "보호한다.",
	    "국가는",
	    "모성의",
	    "보호를",
	    "위하여",
	    "노력하여야",
	    "한다.",
	    "헌법에",
	    "의하여",
	    "체결·공포된",
	    "조약과",
	    "일반적으로",
	    "승인된",
	    "국제법규는",
	    "국내법과",
	    "같은",
	    "효력을",
	    "가진다."
	  ]
	};
	ko.name = {
	  "last_name": [
	    "김",
	    "이",
	    "박",
	    "최",
	    "정",
	    "강",
	    "조",
	    "윤",
	    "장",
	    "임",
	    "오",
	    "한",
	    "신",
	    "서",
	    "권",
	    "황",
	    "안",
	    "송",
	    "류",
	    "홍"
	  ],
	  "first_name": [
	    "서연",
	    "민서",
	    "서현",
	    "지우",
	    "서윤",
	    "지민",
	    "수빈",
	    "하은",
	    "예은",
	    "윤서",
	    "민준",
	    "지후",
	    "지훈",
	    "준서",
	    "현우",
	    "예준",
	    "건우",
	    "현준",
	    "민재",
	    "우진",
	    "은주"
	  ],
	  "name": [
	    "#{last_name} #{first_name}"
	  ]
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)(module)))

/***/ },
/* 310 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var nb_NO = {};
	module["exports"] = nb_NO;
	nb_NO.title = "Norwegian";
	nb_NO.address = {
	  "city_root": [
	    "Fet",
	    "Gjes",
	    "Høy",
	    "Inn",
	    "Fager",
	    "Lille",
	    "Lo",
	    "Mal",
	    "Nord",
	    "Nær",
	    "Sand",
	    "Sme",
	    "Stav",
	    "Stor",
	    "Tand",
	    "Ut",
	    "Vest"
	  ],
	  "city_suffix": [
	    "berg",
	    "borg",
	    "by",
	    "bø",
	    "dal",
	    "eid",
	    "fjell",
	    "fjord",
	    "foss",
	    "grunn",
	    "hamn",
	    "havn",
	    "helle",
	    "mark",
	    "nes",
	    "odden",
	    "sand",
	    "sjøen",
	    "stad",
	    "strand",
	    "strøm",
	    "sund",
	    "vik",
	    "vær",
	    "våg",
	    "ø",
	    "øy",
	    "ås"
	  ],
	  "street_prefix": [
	    "Øvre",
	    "Nedre",
	    "Søndre",
	    "Gamle",
	    "Østre",
	    "Vestre"
	  ],
	  "street_root": [
	    "Eike",
	    "Bjørke",
	    "Gran",
	    "Vass",
	    "Furu",
	    "Litj",
	    "Lille",
	    "Høy",
	    "Fosse",
	    "Elve",
	    "Ku",
	    "Konvall",
	    "Soldugg",
	    "Hestemyr",
	    "Granitt",
	    "Hegge",
	    "Rogne",
	    "Fiol",
	    "Sol",
	    "Ting",
	    "Malm",
	    "Klokker",
	    "Preste",
	    "Dam",
	    "Geiterygg",
	    "Bekke",
	    "Berg",
	    "Kirke",
	    "Kors",
	    "Bru",
	    "Blåveis",
	    "Torg",
	    "Sjø"
	  ],
	  "street_suffix": [
	    "alléen",
	    "bakken",
	    "berget",
	    "bråten",
	    "eggen",
	    "engen",
	    "ekra",
	    "faret",
	    "flata",
	    "gata",
	    "gjerdet",
	    "grenda",
	    "gropa",
	    "hagen",
	    "haugen",
	    "havna",
	    "holtet",
	    "høgda",
	    "jordet",
	    "kollen",
	    "kroken",
	    "lia",
	    "lunden",
	    "lyngen",
	    "løkka",
	    "marka",
	    "moen",
	    "myra",
	    "plassen",
	    "ringen",
	    "roa",
	    "røa",
	    "skogen",
	    "skrenten",
	    "spranget",
	    "stien",
	    "stranda",
	    "stubben",
	    "stykket",
	    "svingen",
	    "tjernet",
	    "toppen",
	    "tunet",
	    "vollen",
	    "vika",
	    "åsen"
	  ],
	  "common_street_suffix": [
	    "sgate",
	    "svei",
	    "s Gate",
	    "s Vei",
	    "gata",
	    "veien"
	  ],
	  "building_number": [
	    "#",
	    "##"
	  ],
	  "secondary_address": [
	    "Leil. ###",
	    "Oppgang A",
	    "Oppgang B"
	  ],
	  "postcode": [
	    "####",
	    "####",
	    "####",
	    "0###"
	  ],
	  "state": [
	    ""
	  ],
	  "city": [
	    "#{city_root}#{city_suffix}"
	  ],
	  "street_name": [
	    "#{street_root}#{street_suffix}",
	    "#{street_prefix} #{street_root}#{street_suffix}",
	    "#{Name.first_name}#{common_street_suffix}",
	    "#{Name.last_name}#{common_street_suffix}"
	  ],
	  "street_address": [
	    "#{street_name} #{building_number}"
	  ],
	  "default_country": [
	    "Norge"
	  ]
	};
	nb_NO.company = {
	  "suffix": [
	    "Gruppen",
	    "AS",
	    "ASA",
	    "BA",
	    "RFH",
	    "og Sønner"
	  ],
	  "name": [
	    "#{Name.last_name} #{suffix}",
	    "#{Name.last_name}-#{Name.last_name}",
	    "#{Name.last_name}, #{Name.last_name} og #{Name.last_name}"
	  ]
	};
	nb_NO.internet = {
	  "domain_suffix": [
	    "no",
	    "com",
	    "net",
	    "org"
	  ]
	};
	nb_NO.name = {
	  "first_name": [
	    "Emma",
	    "Sara",
	    "Thea",
	    "Ida",
	    "Julie",
	    "Nora",
	    "Emilie",
	    "Ingrid",
	    "Hanna",
	    "Maria",
	    "Sofie",
	    "Anna",
	    "Malin",
	    "Amalie",
	    "Vilde",
	    "Frida",
	    "Andrea",
	    "Tuva",
	    "Victoria",
	    "Mia",
	    "Karoline",
	    "Mathilde",
	    "Martine",
	    "Linnea",
	    "Marte",
	    "Hedda",
	    "Marie",
	    "Helene",
	    "Silje",
	    "Leah",
	    "Maja",
	    "Elise",
	    "Oda",
	    "Kristine",
	    "Aurora",
	    "Kaja",
	    "Camilla",
	    "Mari",
	    "Maren",
	    "Mina",
	    "Selma",
	    "Jenny",
	    "Celine",
	    "Eline",
	    "Sunniva",
	    "Natalie",
	    "Tiril",
	    "Synne",
	    "Sandra",
	    "Madeleine",
	    "Markus",
	    "Mathias",
	    "Kristian",
	    "Jonas",
	    "Andreas",
	    "Alexander",
	    "Martin",
	    "Sander",
	    "Daniel",
	    "Magnus",
	    "Henrik",
	    "Tobias",
	    "Kristoffer",
	    "Emil",
	    "Adrian",
	    "Sebastian",
	    "Marius",
	    "Elias",
	    "Fredrik",
	    "Thomas",
	    "Sondre",
	    "Benjamin",
	    "Jakob",
	    "Oliver",
	    "Lucas",
	    "Oskar",
	    "Nikolai",
	    "Filip",
	    "Mats",
	    "William",
	    "Erik",
	    "Simen",
	    "Ole",
	    "Eirik",
	    "Isak",
	    "Kasper",
	    "Noah",
	    "Lars",
	    "Joakim",
	    "Johannes",
	    "Håkon",
	    "Sindre",
	    "Jørgen",
	    "Herman",
	    "Anders",
	    "Jonathan",
	    "Even",
	    "Theodor",
	    "Mikkel",
	    "Aksel"
	  ],
	  "feminine_name": [
	    "Emma",
	    "Sara",
	    "Thea",
	    "Ida",
	    "Julie",
	    "Nora",
	    "Emilie",
	    "Ingrid",
	    "Hanna",
	    "Maria",
	    "Sofie",
	    "Anna",
	    "Malin",
	    "Amalie",
	    "Vilde",
	    "Frida",
	    "Andrea",
	    "Tuva",
	    "Victoria",
	    "Mia",
	    "Karoline",
	    "Mathilde",
	    "Martine",
	    "Linnea",
	    "Marte",
	    "Hedda",
	    "Marie",
	    "Helene",
	    "Silje",
	    "Leah",
	    "Maja",
	    "Elise",
	    "Oda",
	    "Kristine",
	    "Aurora",
	    "Kaja",
	    "Camilla",
	    "Mari",
	    "Maren",
	    "Mina",
	    "Selma",
	    "Jenny",
	    "Celine",
	    "Eline",
	    "Sunniva",
	    "Natalie",
	    "Tiril",
	    "Synne",
	    "Sandra",
	    "Madeleine"
	  ],
	  "masculine_name": [
	    "Markus",
	    "Mathias",
	    "Kristian",
	    "Jonas",
	    "Andreas",
	    "Alexander",
	    "Martin",
	    "Sander",
	    "Daniel",
	    "Magnus",
	    "Henrik",
	    "Tobias",
	    "Kristoffer",
	    "Emil",
	    "Adrian",
	    "Sebastian",
	    "Marius",
	    "Elias",
	    "Fredrik",
	    "Thomas",
	    "Sondre",
	    "Benjamin",
	    "Jakob",
	    "Oliver",
	    "Lucas",
	    "Oskar",
	    "Nikolai",
	    "Filip",
	    "Mats",
	    "William",
	    "Erik",
	    "Simen",
	    "Ole",
	    "Eirik",
	    "Isak",
	    "Kasper",
	    "Noah",
	    "Lars",
	    "Joakim",
	    "Johannes",
	    "Håkon",
	    "Sindre",
	    "Jørgen",
	    "Herman",
	    "Anders",
	    "Jonathan",
	    "Even",
	    "Theodor",
	    "Mikkel",
	    "Aksel"
	  ],
	  "last_name": [
	    "Johansen",
	    "Hansen",
	    "Andersen",
	    "Kristiansen",
	    "Larsen",
	    "Olsen",
	    "Solberg",
	    "Andresen",
	    "Pedersen",
	    "Nilsen",
	    "Berg",
	    "Halvorsen",
	    "Karlsen",
	    "Svendsen",
	    "Jensen",
	    "Haugen",
	    "Martinsen",
	    "Eriksen",
	    "Sørensen",
	    "Johnsen",
	    "Myhrer",
	    "Johannessen",
	    "Nielsen",
	    "Hagen",
	    "Pettersen",
	    "Bakke",
	    "Skuterud",
	    "Løken",
	    "Gundersen",
	    "Strand",
	    "Jørgensen",
	    "Kvarme",
	    "Røed",
	    "Sæther",
	    "Stensrud",
	    "Moe",
	    "Kristoffersen",
	    "Jakobsen",
	    "Holm",
	    "Aas",
	    "Lie",
	    "Moen",
	    "Andreassen",
	    "Vedvik",
	    "Nguyen",
	    "Jacobsen",
	    "Torgersen",
	    "Ruud",
	    "Krogh",
	    "Christiansen",
	    "Bjerke",
	    "Aalerud",
	    "Borge",
	    "Sørlie",
	    "Berge",
	    "Østli",
	    "Ødegård",
	    "Torp",
	    "Henriksen",
	    "Haukelidsæter",
	    "Fjeld",
	    "Danielsen",
	    "Aasen",
	    "Fredriksen",
	    "Dahl",
	    "Berntsen",
	    "Arnesen",
	    "Wold",
	    "Thoresen",
	    "Solheim",
	    "Skoglund",
	    "Bakken",
	    "Amundsen",
	    "Solli",
	    "Smogeli",
	    "Kristensen",
	    "Glosli",
	    "Fossum",
	    "Evensen",
	    "Eide",
	    "Carlsen",
	    "Østby",
	    "Vegge",
	    "Tangen",
	    "Smedsrud",
	    "Olstad",
	    "Lunde",
	    "Kleven",
	    "Huseby",
	    "Bjørnstad",
	    "Ryan",
	    "Rasmussen",
	    "Nygård",
	    "Nordskaug",
	    "Nordby",
	    "Mathisen",
	    "Hopland",
	    "Gran",
	    "Finstad",
	    "Edvardsen"
	  ],
	  "prefix": [
	    "Dr.",
	    "Prof."
	  ],
	  "suffix": [
	    "Jr.",
	    "Sr.",
	    "I",
	    "II",
	    "III",
	    "IV",
	    "V"
	  ],
	  "name": [
	    "#{prefix} #{first_name} #{last_name}",
	    "#{first_name} #{last_name} #{suffix}",
	    "#{feminine_name} #{feminine_name} #{last_name}",
	    "#{masculine_name} #{masculine_name} #{last_name}",
	    "#{first_name} #{last_name} #{last_name}",
	    "#{first_name} #{last_name}"
	  ]
	};
	nb_NO.phone_number = {
	  "formats": [
	    "########",
	    "## ## ## ##",
	    "### ## ###",
	    "+47 ## ## ## ##"
	  ]
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)(module)))

/***/ },
/* 311 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var nep = {};
	module["exports"] = nep;
	nep.title = "Nepalese";
	nep.name = {
	  "first_name": [
	    "Aarav",
	    "Ajita",
	    "Amit",
	    "Amita",
	    "Amrit",
	    "Arijit",
	    "Ashmi",
	    "Asmita",
	    "Bibek",
	    "Bijay",
	    "Bikash",
	    "Bina",
	    "Bishal",
	    "Bishnu",
	    "Buddha",
	    "Deepika",
	    "Dipendra",
	    "Gagan",
	    "Ganesh",
	    "Khem",
	    "Krishna",
	    "Laxmi",
	    "Manisha",
	    "Nabin",
	    "Nikita",
	    "Niraj",
	    "Nischal",
	    "Padam",
	    "Pooja",
	    "Prabin",
	    "Prakash",
	    "Prashant",
	    "Prem",
	    "Purna",
	    "Rajendra",
	    "Rajina",
	    "Raju",
	    "Rakesh",
	    "Ranjan",
	    "Ratna",
	    "Sagar",
	    "Sandeep",
	    "Sanjay",
	    "Santosh",
	    "Sarita",
	    "Shilpa",
	    "Shirisha",
	    "Shristi",
	    "Siddhartha",
	    "Subash",
	    "Sumeet",
	    "Sunita",
	    "Suraj",
	    "Susan",
	    "Sushant"
	  ],
	  "last_name": [
	    "Adhikari",
	    "Aryal",
	    "Baral",
	    "Basnet",
	    "Bastola",
	    "Basynat",
	    "Bhandari",
	    "Bhattarai",
	    "Chettri",
	    "Devkota",
	    "Dhakal",
	    "Dongol",
	    "Ghale",
	    "Gurung",
	    "Gyawali",
	    "Hamal",
	    "Jung",
	    "KC",
	    "Kafle",
	    "Karki",
	    "Khadka",
	    "Koirala",
	    "Lama",
	    "Limbu",
	    "Magar",
	    "Maharjan",
	    "Niroula",
	    "Pandey",
	    "Pradhan",
	    "Rana",
	    "Raut",
	    "Sai",
	    "Shai",
	    "Shakya",
	    "Sherpa",
	    "Shrestha",
	    "Subedi",
	    "Tamang",
	    "Thapa"
	  ]
	};
	nep.address = {
	  "postcode": [
	    0
	  ],
	  "state": [
	    "Baglung",
	    "Banke",
	    "Bara",
	    "Bardiya",
	    "Bhaktapur",
	    "Bhojupu",
	    "Chitwan",
	    "Dailekh",
	    "Dang",
	    "Dhading",
	    "Dhankuta",
	    "Dhanusa",
	    "Dolakha",
	    "Dolpha",
	    "Gorkha",
	    "Gulmi",
	    "Humla",
	    "Ilam",
	    "Jajarkot",
	    "Jhapa",
	    "Jumla",
	    "Kabhrepalanchok",
	    "Kalikot",
	    "Kapilvastu",
	    "Kaski",
	    "Kathmandu",
	    "Lalitpur",
	    "Lamjung",
	    "Manang",
	    "Mohottari",
	    "Morang",
	    "Mugu",
	    "Mustang",
	    "Myagdi",
	    "Nawalparasi",
	    "Nuwakot",
	    "Palpa",
	    "Parbat",
	    "Parsa",
	    "Ramechhap",
	    "Rauswa",
	    "Rautahat",
	    "Rolpa",
	    "Rupandehi",
	    "Sankhuwasabha",
	    "Sarlahi",
	    "Sindhuli",
	    "Sindhupalchok",
	    "Sunsari",
	    "Surket",
	    "Syangja",
	    "Tanahu",
	    "Terhathum"
	  ],
	  "city": [
	    "Bhaktapur",
	    "Biratnagar",
	    "Birendranagar",
	    "Birgunj",
	    "Butwal",
	    "Damak",
	    "Dharan",
	    "Gaur",
	    "Gorkha",
	    "Hetauda",
	    "Itahari",
	    "Janakpur",
	    "Kathmandu",
	    "Lahan",
	    "Nepalgunj",
	    "Pokhara"
	  ],
	  "default_country": [
	    "Nepal"
	  ]
	};
	nep.internet = {
	  "free_email": [
	    "worldlink.com.np",
	    "gmail.com",
	    "yahoo.com",
	    "hotmail.com"
	  ],
	  "domain_suffix": [
	    "np",
	    "com",
	    "info",
	    "net",
	    "org"
	  ]
	};
	nep.company = {
	  "suffix": [
	    "Pvt Ltd",
	    "Group",
	    "Ltd",
	    "Limited"
	  ]
	};
	nep.phone_number = {
	  "formats": [
	    "##-#######",
	    "+977-#-#######",
	    "+977########"
	  ]
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)(module)))

/***/ },
/* 312 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var nl = {};
	module["exports"] = nl;
	nl.title = "Dutch";
	nl.address = {
	  "city_prefix": [
	    "Noord",
	    "Oost",
	    "West",
	    "Zuid",
	    "Nieuw",
	    "Oud"
	  ],
	  "city_suffix": [
	    "dam",
	    "berg",
	    " aan de Rijn",
	    " aan de IJssel",
	    "swaerd",
	    "endrecht",
	    "recht",
	    "ambacht",
	    "enmaes",
	    "wijk",
	    "sland",
	    "stroom",
	    "sluus",
	    "dijk",
	    "dorp",
	    "burg",
	    "veld",
	    "sluis",
	    "koop",
	    "lek",
	    "hout",
	    "geest",
	    "kerk",
	    "woude",
	    "hoven",
	    "hoten",
	    "ingen",
	    "plas",
	    "meer"
	  ],
	  "city": [
	    "#{Name.first_name}#{city_suffix}",
	    "#{Name.last_name}#{city_suffix}",
	    "#{city_prefix} #{Name.first_name}#{city_suffix}",
	    "#{city_prefix} #{Name.last_name}#{city_suffix}"
	  ],
	  "country": [
	    "Afghanistan",
	    "Akrotiri",
	    "Albanië",
	    "Algerije",
	    "Amerikaanse Maagdeneilanden",
	    "Amerikaans-Samoa",
	    "Andorra",
	    "Angola",
	    "Anguilla",
	    "Antarctica",
	    "Antigua en Barbuda",
	    "Arctic Ocean",
	    "Argentinië",
	    "Armenië",
	    "Aruba",
	    "Ashmore and Cartier Islands",
	    "Atlantic Ocean",
	    "Australië",
	    "Azerbeidzjan",
	    "Bahama's",
	    "Bahrein",
	    "Bangladesh",
	    "Barbados",
	    "Belarus",
	    "België",
	    "Belize",
	    "Benin",
	    "Bermuda",
	    "Bhutan",
	    "Bolivië",
	    "Bosnië-Herzegovina",
	    "Botswana",
	    "Bouvet Island",
	    "Brazilië",
	    "British Indian Ocean Territory",
	    "Britse Maagdeneilanden",
	    "Brunei",
	    "Bulgarije",
	    "Burkina Faso",
	    "Burundi",
	    "Cambodja",
	    "Canada",
	    "Caymaneilanden",
	    "Centraal-Afrikaanse Republiek",
	    "Chili",
	    "China",
	    "Christmas Island",
	    "Clipperton Island",
	    "Cocos (Keeling) Islands",
	    "Colombia",
	    "Comoren (Unie)",
	    "Congo (Democratische Republiek)",
	    "Congo (Volksrepubliek)",
	    "Cook",
	    "Coral Sea Islands",
	    "Costa Rica",
	    "Cuba",
	    "Cyprus",
	    "Denemarken",
	    "Dhekelia",
	    "Djibouti",
	    "Dominica",
	    "Dominicaanse Republiek",
	    "Duitsland",
	    "Ecuador",
	    "Egypte",
	    "El Salvador",
	    "Equatoriaal-Guinea",
	    "Eritrea",
	    "Estland",
	    "Ethiopië",
	    "European Union",
	    "Falkland",
	    "Faroe Islands",
	    "Fiji",
	    "Filipijnen",
	    "Finland",
	    "Frankrijk",
	    "Frans-Polynesië",
	    "French Southern and Antarctic Lands",
	    "Gabon",
	    "Gambia",
	    "Gaza Strip",
	    "Georgië",
	    "Ghana",
	    "Gibraltar",
	    "Grenada",
	    "Griekenland",
	    "Groenland",
	    "Guam",
	    "Guatemala",
	    "Guernsey",
	    "Guinea",
	    "Guinee-Bissau",
	    "Guyana",
	    "Haïti",
	    "Heard Island and McDonald Islands",
	    "Heilige Stoel",
	    "Honduras",
	    "Hongarije",
	    "Hongkong",
	    "Ierland",
	    "IJsland",
	    "India",
	    "Indian Ocean",
	    "Indonesië",
	    "Irak",
	    "Iran",
	    "Isle of Man",
	    "Israël",
	    "Italië",
	    "Ivoorkust",
	    "Jamaica",
	    "Jan Mayen",
	    "Japan",
	    "Jemen",
	    "Jersey",
	    "Jordanië",
	    "Kaapverdië",
	    "Kameroen",
	    "Kazachstan",
	    "Kenia",
	    "Kirgizstan",
	    "Kiribati",
	    "Koeweit",
	    "Kroatië",
	    "Laos",
	    "Lesotho",
	    "Letland",
	    "Libanon",
	    "Liberia",
	    "Libië",
	    "Liechtenstein",
	    "Litouwen",
	    "Luxemburg",
	    "Macao",
	    "Macedonië",
	    "Madagaskar",
	    "Malawi",
	    "Maldiven",
	    "Maleisië",
	    "Mali",
	    "Malta",
	    "Marokko",
	    "Marshall Islands",
	    "Mauritanië",
	    "Mauritius",
	    "Mayotte",
	    "Mexico",
	    "Micronesia, Federated States of",
	    "Moldavië",
	    "Monaco",
	    "Mongolië",
	    "Montenegro",
	    "Montserrat",
	    "Mozambique",
	    "Myanmar",
	    "Namibië",
	    "Nauru",
	    "Navassa Island",
	    "Nederland",
	    "Nederlandse Antillen",
	    "Nepal",
	    "Ngwane",
	    "Nicaragua",
	    "Nieuw-Caledonië",
	    "Nieuw-Zeeland",
	    "Niger",
	    "Nigeria",
	    "Niue",
	    "Noordelijke Marianen",
	    "Noord-Korea",
	    "Noorwegen",
	    "Norfolk Island",
	    "Oekraïne",
	    "Oezbekistan",
	    "Oman",
	    "Oostenrijk",
	    "Pacific Ocean",
	    "Pakistan",
	    "Palau",
	    "Panama",
	    "Papoea-Nieuw-Guinea",
	    "Paracel Islands",
	    "Paraguay",
	    "Peru",
	    "Pitcairn",
	    "Polen",
	    "Portugal",
	    "Puerto Rico",
	    "Qatar",
	    "Roemenië",
	    "Rusland",
	    "Rwanda",
	    "Saint Helena",
	    "Saint Lucia",
	    "Saint Vincent en de Grenadines",
	    "Saint-Pierre en Miquelon",
	    "Salomon",
	    "Samoa",
	    "San Marino",
	    "São Tomé en Principe",
	    "Saudi-Arabië",
	    "Senegal",
	    "Servië",
	    "Seychellen",
	    "Sierra Leone",
	    "Singapore",
	    "Sint-Kitts en Nevis",
	    "Slovenië",
	    "Slowakije",
	    "Soedan",
	    "Somalië",
	    "South Georgia and the South Sandwich Islands",
	    "Southern Ocean",
	    "Spanje",
	    "Spratly Islands",
	    "Sri Lanka",
	    "Suriname",
	    "Svalbard",
	    "Syrië",
	    "Tadzjikistan",
	    "Taiwan",
	    "Tanzania",
	    "Thailand",
	    "Timor Leste",
	    "Togo",
	    "Tokelau",
	    "Tonga",
	    "Trinidad en Tobago",
	    "Tsjaad",
	    "Tsjechië",
	    "Tunesië",
	    "Turkije",
	    "Turkmenistan",
	    "Turks-en Caicoseilanden",
	    "Tuvalu",
	    "Uganda",
	    "Uruguay",
	    "Vanuatu",
	    "Venezuela",
	    "Verenigd Koninkrijk",
	    "Verenigde Arabische Emiraten",
	    "Verenigde Staten van Amerika",
	    "Vietnam",
	    "Wake Island",
	    "Wallis en Futuna",
	    "Wereld",
	    "West Bank",
	    "Westelijke Sahara",
	    "Zambia",
	    "Zimbabwe",
	    "Zuid-Afrika",
	    "Zuid-Korea",
	    "Zweden",
	    "Zwitserland"
	  ],
	  "building_number": [
	    "#",
	    "##",
	    "###",
	    "###a",
	    "###b",
	    "###c",
	    "### I",
	    "### II",
	    "### III"
	  ],
	  "street_suffix": [
	    "straat",
	    "laan",
	    "weg",
	    "plantsoen",
	    "park"
	  ],
	  "secondary_address": [
	    "1 hoog",
	    "2 hoog",
	    "3 hoog"
	  ],
	  "street_name": [
	    "#{Name.first_name}#{street_suffix}",
	    "#{Name.last_name}#{street_suffix}"
	  ],
	  "street_address": [
	    "#{street_name} #{building_number}"
	  ],
	  "postcode": [
	    "#### ??"
	  ],
	  "state": [
	    "Noord-Holland",
	    "Zuid-Holland",
	    "Utrecht",
	    "Zeeland",
	    "Overijssel",
	    "Gelderland",
	    "Drenthe",
	    "Friesland",
	    "Groningen",
	    "Noord-Brabant",
	    "Limburg",
	    "Flevoland"
	  ],
	  "default_country": [
	    "Nederland"
	  ]
	};
	nl.company = {
	  "suffix": [
	    "BV",
	    "V.O.F.",
	    "Group",
	    "en Zonen"
	  ]
	};
	nl.internet = {
	  "free_email": [
	    "gmail.com",
	    "yahoo.com",
	    "hotmail.com"
	  ],
	  "domain_suffix": [
	    "nl",
	    "com",
	    "net",
	    "org"
	  ]
	};
	nl.lorem = {
	  "words": [
	    "alias",
	    "consequatur",
	    "aut",
	    "perferendis",
	    "sit",
	    "voluptatem",
	    "accusantium",
	    "doloremque",
	    "aperiam",
	    "eaque",
	    "ipsa",
	    "quae",
	    "ab",
	    "illo",
	    "inventore",
	    "veritatis",
	    "et",
	    "quasi",
	    "architecto",
	    "beatae",
	    "vitae",
	    "dicta",
	    "sunt",
	    "explicabo",
	    "aspernatur",
	    "aut",
	    "odit",
	    "aut",
	    "fugit",
	    "sed",
	    "quia",
	    "consequuntur",
	    "magni",
	    "dolores",
	    "eos",
	    "qui",
	    "ratione",
	    "voluptatem",
	    "sequi",
	    "nesciunt",
	    "neque",
	    "dolorem",
	    "ipsum",
	    "quia",
	    "dolor",
	    "sit",
	    "amet",
	    "consectetur",
	    "adipisci",
	    "velit",
	    "sed",
	    "quia",
	    "non",
	    "numquam",
	    "eius",
	    "modi",
	    "tempora",
	    "incidunt",
	    "ut",
	    "labore",
	    "et",
	    "dolore",
	    "magnam",
	    "aliquam",
	    "quaerat",
	    "voluptatem",
	    "ut",
	    "enim",
	    "ad",
	    "minima",
	    "veniam",
	    "quis",
	    "nostrum",
	    "exercitationem",
	    "ullam",
	    "corporis",
	    "nemo",
	    "enim",
	    "ipsam",
	    "voluptatem",
	    "quia",
	    "voluptas",
	    "sit",
	    "suscipit",
	    "laboriosam",
	    "nisi",
	    "ut",
	    "aliquid",
	    "ex",
	    "ea",
	    "commodi",
	    "consequatur",
	    "quis",
	    "autem",
	    "vel",
	    "eum",
	    "iure",
	    "reprehenderit",
	    "qui",
	    "in",
	    "ea",
	    "voluptate",
	    "velit",
	    "esse",
	    "quam",
	    "nihil",
	    "molestiae",
	    "et",
	    "iusto",
	    "odio",
	    "dignissimos",
	    "ducimus",
	    "qui",
	    "blanditiis",
	    "praesentium",
	    "laudantium",
	    "totam",
	    "rem",
	    "voluptatum",
	    "deleniti",
	    "atque",
	    "corrupti",
	    "quos",
	    "dolores",
	    "et",
	    "quas",
	    "molestias",
	    "excepturi",
	    "sint",
	    "occaecati",
	    "cupiditate",
	    "non",
	    "provident",
	    "sed",
	    "ut",
	    "perspiciatis",
	    "unde",
	    "omnis",
	    "iste",
	    "natus",
	    "error",
	    "similique",
	    "sunt",
	    "in",
	    "culpa",
	    "qui",
	    "officia",
	    "deserunt",
	    "mollitia",
	    "animi",
	    "id",
	    "est",
	    "laborum",
	    "et",
	    "dolorum",
	    "fuga",
	    "et",
	    "harum",
	    "quidem",
	    "rerum",
	    "facilis",
	    "est",
	    "et",
	    "expedita",
	    "distinctio",
	    "nam",
	    "libero",
	    "tempore",
	    "cum",
	    "soluta",
	    "nobis",
	    "est",
	    "eligendi",
	    "optio",
	    "cumque",
	    "nihil",
	    "impedit",
	    "quo",
	    "porro",
	    "quisquam",
	    "est",
	    "qui",
	    "minus",
	    "id",
	    "quod",
	    "maxime",
	    "placeat",
	    "facere",
	    "possimus",
	    "omnis",
	    "voluptas",
	    "assumenda",
	    "est",
	    "omnis",
	    "dolor",
	    "repellendus",
	    "temporibus",
	    "autem",
	    "quibusdam",
	    "et",
	    "aut",
	    "consequatur",
	    "vel",
	    "illum",
	    "qui",
	    "dolorem",
	    "eum",
	    "fugiat",
	    "quo",
	    "voluptas",
	    "nulla",
	    "pariatur",
	    "at",
	    "vero",
	    "eos",
	    "et",
	    "accusamus",
	    "officiis",
	    "debitis",
	    "aut",
	    "rerum",
	    "necessitatibus",
	    "saepe",
	    "eveniet",
	    "ut",
	    "et",
	    "voluptates",
	    "repudiandae",
	    "sint",
	    "et",
	    "molestiae",
	    "non",
	    "recusandae",
	    "itaque",
	    "earum",
	    "rerum",
	    "hic",
	    "tenetur",
	    "a",
	    "sapiente",
	    "delectus",
	    "ut",
	    "aut",
	    "reiciendis",
	    "voluptatibus",
	    "maiores",
	    "doloribus",
	    "asperiores",
	    "repellat"
	  ],
	  "supplemental": [
	    "abbas",
	    "abduco",
	    "abeo",
	    "abscido",
	    "absconditus",
	    "absens",
	    "absorbeo",
	    "absque",
	    "abstergo",
	    "absum",
	    "abundans",
	    "abutor",
	    "accedo",
	    "accendo",
	    "acceptus",
	    "accipio",
	    "accommodo",
	    "accusator",
	    "acer",
	    "acerbitas",
	    "acervus",
	    "acidus",
	    "acies",
	    "acquiro",
	    "acsi",
	    "adamo",
	    "adaugeo",
	    "addo",
	    "adduco",
	    "ademptio",
	    "adeo",
	    "adeptio",
	    "adfectus",
	    "adfero",
	    "adficio",
	    "adflicto",
	    "adhaero",
	    "adhuc",
	    "adicio",
	    "adimpleo",
	    "adinventitias",
	    "adipiscor",
	    "adiuvo",
	    "administratio",
	    "admiratio",
	    "admitto",
	    "admoneo",
	    "admoveo",
	    "adnuo",
	    "adopto",
	    "adsidue",
	    "adstringo",
	    "adsuesco",
	    "adsum",
	    "adulatio",
	    "adulescens",
	    "adultus",
	    "aduro",
	    "advenio",
	    "adversus",
	    "advoco",
	    "aedificium",
	    "aeger",
	    "aegre",
	    "aegrotatio",
	    "aegrus",
	    "aeneus",
	    "aequitas",
	    "aequus",
	    "aer",
	    "aestas",
	    "aestivus",
	    "aestus",
	    "aetas",
	    "aeternus",
	    "ager",
	    "aggero",
	    "aggredior",
	    "agnitio",
	    "agnosco",
	    "ago",
	    "ait",
	    "aiunt",
	    "alienus",
	    "alii",
	    "alioqui",
	    "aliqua",
	    "alius",
	    "allatus",
	    "alo",
	    "alter",
	    "altus",
	    "alveus",
	    "amaritudo",
	    "ambitus",
	    "ambulo",
	    "amicitia",
	    "amiculum",
	    "amissio",
	    "amita",
	    "amitto",
	    "amo",
	    "amor",
	    "amoveo",
	    "amplexus",
	    "amplitudo",
	    "amplus",
	    "ancilla",
	    "angelus",
	    "angulus",
	    "angustus",
	    "animadverto",
	    "animi",
	    "animus",
	    "annus",
	    "anser",
	    "ante",
	    "antea",
	    "antepono",
	    "antiquus",
	    "aperio",
	    "aperte",
	    "apostolus",
	    "apparatus",
	    "appello",
	    "appono",
	    "appositus",
	    "approbo",
	    "apto",
	    "aptus",
	    "apud",
	    "aqua",
	    "ara",
	    "aranea",
	    "arbitro",
	    "arbor",
	    "arbustum",
	    "arca",
	    "arceo",
	    "arcesso",
	    "arcus",
	    "argentum",
	    "argumentum",
	    "arguo",
	    "arma",
	    "armarium",
	    "armo",
	    "aro",
	    "ars",
	    "articulus",
	    "artificiose",
	    "arto",
	    "arx",
	    "ascisco",
	    "ascit",
	    "asper",
	    "aspicio",
	    "asporto",
	    "assentator",
	    "astrum",
	    "atavus",
	    "ater",
	    "atqui",
	    "atrocitas",
	    "atrox",
	    "attero",
	    "attollo",
	    "attonbitus",
	    "auctor",
	    "auctus",
	    "audacia",
	    "audax",
	    "audentia",
	    "audeo",
	    "audio",
	    "auditor",
	    "aufero",
	    "aureus",
	    "auris",
	    "aurum",
	    "aut",
	    "autem",
	    "autus",
	    "auxilium",
	    "avaritia",
	    "avarus",
	    "aveho",
	    "averto",
	    "avoco",
	    "baiulus",
	    "balbus",
	    "barba",
	    "bardus",
	    "basium",
	    "beatus",
	    "bellicus",
	    "bellum",
	    "bene",
	    "beneficium",
	    "benevolentia",
	    "benigne",
	    "bestia",
	    "bibo",
	    "bis",
	    "blandior",
	    "bonus",
	    "bos",
	    "brevis",
	    "cado",
	    "caecus",
	    "caelestis",
	    "caelum",
	    "calamitas",
	    "calcar",
	    "calco",
	    "calculus",
	    "callide",
	    "campana",
	    "candidus",
	    "canis",
	    "canonicus",
	    "canto",
	    "capillus",
	    "capio",
	    "capitulus",
	    "capto",
	    "caput",
	    "carbo",
	    "carcer",
	    "careo",
	    "caries",
	    "cariosus",
	    "caritas",
	    "carmen",
	    "carpo",
	    "carus",
	    "casso",
	    "caste",
	    "casus",
	    "catena",
	    "caterva",
	    "cattus",
	    "cauda",
	    "causa",
	    "caute",
	    "caveo",
	    "cavus",
	    "cedo",
	    "celebrer",
	    "celer",
	    "celo",
	    "cena",
	    "cenaculum",
	    "ceno",
	    "censura",
	    "centum",
	    "cerno",
	    "cernuus",
	    "certe",
	    "certo",
	    "certus",
	    "cervus",
	    "cetera",
	    "charisma",
	    "chirographum",
	    "cibo",
	    "cibus",
	    "cicuta",
	    "cilicium",
	    "cimentarius",
	    "ciminatio",
	    "cinis",
	    "circumvenio",
	    "cito",
	    "civis",
	    "civitas",
	    "clam",
	    "clamo",
	    "claro",
	    "clarus",
	    "claudeo",
	    "claustrum",
	    "clementia",
	    "clibanus",
	    "coadunatio",
	    "coaegresco",
	    "coepi",
	    "coerceo",
	    "cogito",
	    "cognatus",
	    "cognomen",
	    "cogo",
	    "cohaero",
	    "cohibeo",
	    "cohors",
	    "colligo",
	    "colloco",
	    "collum",
	    "colo",
	    "color",
	    "coma",
	    "combibo",
	    "comburo",
	    "comedo",
	    "comes",
	    "cometes",
	    "comis",
	    "comitatus",
	    "commemoro",
	    "comminor",
	    "commodo",
	    "communis",
	    "comparo",
	    "compello",
	    "complectus",
	    "compono",
	    "comprehendo",
	    "comptus",
	    "conatus",
	    "concedo",
	    "concido",
	    "conculco",
	    "condico",
	    "conduco",
	    "confero",
	    "confido",
	    "conforto",
	    "confugo",
	    "congregatio",
	    "conicio",
	    "coniecto",
	    "conitor",
	    "coniuratio",
	    "conor",
	    "conqueror",
	    "conscendo",
	    "conservo",
	    "considero",
	    "conspergo",
	    "constans",
	    "consuasor",
	    "contabesco",
	    "contego",
	    "contigo",
	    "contra",
	    "conturbo",
	    "conventus",
	    "convoco",
	    "copia",
	    "copiose",
	    "cornu",
	    "corona",
	    "corpus",
	    "correptius",
	    "corrigo",
	    "corroboro",
	    "corrumpo",
	    "coruscus",
	    "cotidie",
	    "crapula",
	    "cras",
	    "crastinus",
	    "creator",
	    "creber",
	    "crebro",
	    "credo",
	    "creo",
	    "creptio",
	    "crepusculum",
	    "cresco",
	    "creta",
	    "cribro",
	    "crinis",
	    "cruciamentum",
	    "crudelis",
	    "cruentus",
	    "crur",
	    "crustulum",
	    "crux",
	    "cubicularis",
	    "cubitum",
	    "cubo",
	    "cui",
	    "cuius",
	    "culpa",
	    "culpo",
	    "cultellus",
	    "cultura",
	    "cum",
	    "cunabula",
	    "cunae",
	    "cunctatio",
	    "cupiditas",
	    "cupio",
	    "cuppedia",
	    "cupressus",
	    "cur",
	    "cura",
	    "curatio",
	    "curia",
	    "curiositas",
	    "curis",
	    "curo",
	    "curriculum",
	    "currus",
	    "cursim",
	    "curso",
	    "cursus",
	    "curto",
	    "curtus",
	    "curvo",
	    "curvus",
	    "custodia",
	    "damnatio",
	    "damno",
	    "dapifer",
	    "debeo",
	    "debilito",
	    "decens",
	    "decerno",
	    "decet",
	    "decimus",
	    "decipio",
	    "decor",
	    "decretum",
	    "decumbo",
	    "dedecor",
	    "dedico",
	    "deduco",
	    "defaeco",
	    "defendo",
	    "defero",
	    "defessus",
	    "defetiscor",
	    "deficio",
	    "defigo",
	    "defleo",
	    "defluo",
	    "defungo",
	    "degenero",
	    "degero",
	    "degusto",
	    "deinde",
	    "delectatio",
	    "delego",
	    "deleo",
	    "delibero",
	    "delicate",
	    "delinquo",
	    "deludo",
	    "demens",
	    "demergo",
	    "demitto",
	    "demo",
	    "demonstro",
	    "demoror",
	    "demulceo",
	    "demum",
	    "denego",
	    "denique",
	    "dens",
	    "denuncio",
	    "denuo",
	    "deorsum",
	    "depereo",
	    "depono",
	    "depopulo",
	    "deporto",
	    "depraedor",
	    "deprecator",
	    "deprimo",
	    "depromo",
	    "depulso",
	    "deputo",
	    "derelinquo",
	    "derideo",
	    "deripio",
	    "desidero",
	    "desino",
	    "desipio",
	    "desolo",
	    "desparatus",
	    "despecto",
	    "despirmatio",
	    "infit",
	    "inflammatio",
	    "paens",
	    "patior",
	    "patria",
	    "patrocinor",
	    "patruus",
	    "pauci",
	    "paulatim",
	    "pauper",
	    "pax",
	    "peccatus",
	    "pecco",
	    "pecto",
	    "pectus",
	    "pecunia",
	    "pecus",
	    "peior",
	    "pel",
	    "ocer",
	    "socius",
	    "sodalitas",
	    "sol",
	    "soleo",
	    "solio",
	    "solitudo",
	    "solium",
	    "sollers",
	    "sollicito",
	    "solum",
	    "solus",
	    "solutio",
	    "solvo",
	    "somniculosus",
	    "somnus",
	    "sonitus",
	    "sono",
	    "sophismata",
	    "sopor",
	    "sordeo",
	    "sortitus",
	    "spargo",
	    "speciosus",
	    "spectaculum",
	    "speculum",
	    "sperno",
	    "spero",
	    "spes",
	    "spiculum",
	    "spiritus",
	    "spoliatio",
	    "sponte",
	    "stabilis",
	    "statim",
	    "statua",
	    "stella",
	    "stillicidium",
	    "stipes",
	    "stips",
	    "sto",
	    "strenuus",
	    "strues",
	    "studio",
	    "stultus",
	    "suadeo",
	    "suasoria",
	    "sub",
	    "subito",
	    "subiungo",
	    "sublime",
	    "subnecto",
	    "subseco",
	    "substantia",
	    "subvenio",
	    "succedo",
	    "succurro",
	    "sufficio",
	    "suffoco",
	    "suffragium",
	    "suggero",
	    "sui",
	    "sulum",
	    "sum",
	    "summa",
	    "summisse",
	    "summopere",
	    "sumo",
	    "sumptus",
	    "supellex",
	    "super",
	    "suppellex",
	    "supplanto",
	    "suppono",
	    "supra",
	    "surculus",
	    "surgo",
	    "sursum",
	    "suscipio",
	    "suspendo",
	    "sustineo",
	    "suus",
	    "synagoga",
	    "tabella",
	    "tabernus",
	    "tabesco",
	    "tabgo",
	    "tabula",
	    "taceo",
	    "tactus",
	    "taedium",
	    "talio",
	    "talis",
	    "talus",
	    "tam",
	    "tamdiu",
	    "tamen",
	    "tametsi",
	    "tamisium",
	    "tamquam",
	    "tandem",
	    "tantillus",
	    "tantum",
	    "tardus",
	    "tego",
	    "temeritas",
	    "temperantia",
	    "templum",
	    "temptatio",
	    "tempus",
	    "tenax",
	    "tendo",
	    "teneo",
	    "tener",
	    "tenuis",
	    "tenus",
	    "tepesco",
	    "tepidus",
	    "ter",
	    "terebro",
	    "teres",
	    "terga",
	    "tergeo",
	    "tergiversatio",
	    "tergo",
	    "tergum",
	    "termes",
	    "terminatio",
	    "tero",
	    "terra",
	    "terreo",
	    "territo",
	    "terror",
	    "tersus",
	    "tertius",
	    "testimonium",
	    "texo",
	    "textilis",
	    "textor",
	    "textus",
	    "thalassinus",
	    "theatrum",
	    "theca",
	    "thema",
	    "theologus",
	    "thermae",
	    "thesaurus",
	    "thesis",
	    "thorax",
	    "thymbra",
	    "thymum",
	    "tibi",
	    "timidus",
	    "timor",
	    "titulus",
	    "tolero",
	    "tollo",
	    "tondeo",
	    "tonsor",
	    "torqueo",
	    "torrens",
	    "tot",
	    "totidem",
	    "toties",
	    "totus",
	    "tracto",
	    "trado",
	    "traho",
	    "trans",
	    "tredecim",
	    "tremo",
	    "trepide",
	    "tres",
	    "tribuo",
	    "tricesimus",
	    "triduana",
	    "triginta",
	    "tripudio",
	    "tristis",
	    "triumphus",
	    "trucido",
	    "truculenter",
	    "tubineus",
	    "tui",
	    "tum",
	    "tumultus",
	    "tunc",
	    "turba",
	    "turbo",
	    "turpe",
	    "turpis",
	    "tutamen",
	    "tutis",
	    "tyrannus",
	    "uberrime",
	    "ubi",
	    "ulciscor",
	    "ullus",
	    "ulterius",
	    "ultio",
	    "ultra",
	    "umbra",
	    "umerus",
	    "umquam",
	    "una",
	    "unde",
	    "undique",
	    "universe",
	    "unus",
	    "urbanus",
	    "urbs",
	    "uredo",
	    "usitas",
	    "usque",
	    "ustilo",
	    "ustulo",
	    "usus",
	    "uter",
	    "uterque",
	    "utilis",
	    "utique",
	    "utor",
	    "utpote",
	    "utrimque",
	    "utroque",
	    "utrum",
	    "uxor",
	    "vaco",
	    "vacuus",
	    "vado",
	    "vae",
	    "valde",
	    "valens",
	    "valeo",
	    "valetudo",
	    "validus",
	    "vallum",
	    "vapulus",
	    "varietas",
	    "varius",
	    "vehemens",
	    "vel",
	    "velociter",
	    "velum",
	    "velut",
	    "venia",
	    "venio",
	    "ventito",
	    "ventosus",
	    "ventus",
	    "venustas",
	    "ver",
	    "verbera",
	    "verbum",
	    "vere",
	    "verecundia",
	    "vereor",
	    "vergo",
	    "veritas",
	    "vero",
	    "versus",
	    "verto",
	    "verumtamen",
	    "verus",
	    "vesco",
	    "vesica",
	    "vesper",
	    "vespillo",
	    "vester",
	    "vestigium",
	    "vestrum",
	    "vetus",
	    "via",
	    "vicinus",
	    "vicissitudo",
	    "victoria",
	    "victus",
	    "videlicet",
	    "video",
	    "viduata",
	    "viduo",
	    "vigilo",
	    "vigor",
	    "vilicus",
	    "vilis",
	    "vilitas",
	    "villa",
	    "vinco",
	    "vinculum",
	    "vindico",
	    "vinitor",
	    "vinum",
	    "vir",
	    "virga",
	    "virgo",
	    "viridis",
	    "viriliter",
	    "virtus",
	    "vis",
	    "viscus",
	    "vita",
	    "vitiosus",
	    "vitium",
	    "vito",
	    "vivo",
	    "vix",
	    "vobis",
	    "vociferor",
	    "voco",
	    "volaticus",
	    "volo",
	    "volubilis",
	    "voluntarius",
	    "volup",
	    "volutabrum",
	    "volva",
	    "vomer",
	    "vomica",
	    "vomito",
	    "vorago",
	    "vorax",
	    "voro",
	    "vos",
	    "votum",
	    "voveo",
	    "vox",
	    "vulariter",
	    "vulgaris",
	    "vulgivagus",
	    "vulgo",
	    "vulgus",
	    "vulnero",
	    "vulnus",
	    "vulpes",
	    "vulticulus",
	    "vultuosus",
	    "xiphias"
	  ]
	};
	nl.name = {
	  "first_name": [
	    "Amber",
	    "Anna",
	    "Anne",
	    "Anouk",
	    "Bas",
	    "Bram",
	    "Britt",
	    "Daan",
	    "Emma",
	    "Eva",
	    "Femke",
	    "Finn",
	    "Fleur",
	    "Iris",
	    "Isa",
	    "Jan",
	    "Jasper",
	    "Jayden",
	    "Jesse",
	    "Johannes",
	    "Julia",
	    "Julian",
	    "Kevin",
	    "Lars",
	    "Lieke",
	    "Lisa",
	    "Lotte",
	    "Lucas",
	    "Luuk",
	    "Maud",
	    "Max",
	    "Mike",
	    "Milan",
	    "Nick",
	    "Niels",
	    "Noa",
	    "Rick",
	    "Roos",
	    "Ruben",
	    "Sander",
	    "Sanne",
	    "Sem",
	    "Sophie",
	    "Stijn",
	    "Sven",
	    "Thijs",
	    "Thijs",
	    "Thomas",
	    "Tim",
	    "Tom"
	  ],
	  "tussenvoegsel": [
	    "van",
	    "van de",
	    "van den",
	    "van 't",
	    "van het",
	    "de",
	    "den"
	  ],
	  "last_name": [
	    "Bakker",
	    "Beek",
	    "Berg",
	    "Boer",
	    "Bos",
	    "Bosch",
	    "Brink",
	    "Broek",
	    "Brouwer",
	    "Bruin",
	    "Dam",
	    "Dekker",
	    "Dijk",
	    "Dijkstra",
	    "Graaf",
	    "Groot",
	    "Haan",
	    "Hendriks",
	    "Heuvel",
	    "Hoek",
	    "Jacobs",
	    "Jansen",
	    "Janssen",
	    "Jong",
	    "Klein",
	    "Kok",
	    "Koning",
	    "Koster",
	    "Leeuwen",
	    "Linden",
	    "Maas",
	    "Meer",
	    "Meijer",
	    "Mulder",
	    "Peters",
	    "Ruiter",
	    "Schouten",
	    "Smit",
	    "Smits",
	    "Stichting",
	    "Veen",
	    "Ven",
	    "Vermeulen",
	    "Visser",
	    "Vliet",
	    "Vos",
	    "Vries",
	    "Wal",
	    "Willems",
	    "Wit"
	  ],
	  "prefix": [
	    "Dhr.",
	    "Mevr. Dr.",
	    "Bsc",
	    "Msc",
	    "Prof."
	  ],
	  "suffix": [
	    "Jr.",
	    "Sr.",
	    "I",
	    "II",
	    "III",
	    "IV",
	    "V"
	  ],
	  "name": [
	    "#{prefix} #{first_name} #{last_name}",
	    "#{first_name} #{last_name} #{suffix}",
	    "#{first_name} #{last_name}",
	    "#{first_name} #{last_name}",
	    "#{first_name} #{tussenvoegsel} #{last_name}",
	    "#{first_name} #{tussenvoegsel} #{last_name}"
	  ]
	};
	nl.phone_number = {
	  "formats": [
	    "(####) ######",
	    "##########",
	    "06########",
	    "06 #### ####"
	  ]
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)(module)))

/***/ },
/* 313 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var pl = {};
	module["exports"] = pl;
	pl.title = "Polish";
	pl.name = {
	  "first_name": [
	    "Aaron",
	    "Abraham",
	    "Adam",
	    "Adrian",
	    "Atanazy",
	    "Agaton",
	    "Alan",
	    "Albert",
	    "Aleksander",
	    "Aleksy",
	    "Alfred",
	    "Alwar",
	    "Ambroży",
	    "Anatol",
	    "Andrzej",
	    "Antoni",
	    "Apollinary",
	    "Apollo",
	    "Arkady",
	    "Arkadiusz",
	    "Archibald",
	    "Arystarch",
	    "Arnold",
	    "Arseniusz",
	    "Artur",
	    "August",
	    "Baldwin",
	    "Bazyli",
	    "Benedykt",
	    "Beniamin",
	    "Bernard",
	    "Bertrand",
	    "Bertram",
	    "Borys",
	    "Brajan",
	    "Bruno",
	    "Cezary",
	    "Cecyliusz",
	    "Karol",
	    "Krystian",
	    "Krzysztof",
	    "Klarencjusz",
	    "Klaudiusz",
	    "Klemens",
	    "Konrad",
	    "Konstanty",
	    "Konstantyn",
	    "Kornel",
	    "Korneliusz",
	    "Korneli",
	    "Cyryl",
	    "Cyrus",
	    "Damian",
	    "Daniel",
	    "Dariusz",
	    "Dawid",
	    "Dionizy",
	    "Demetriusz",
	    "Dominik",
	    "Donald",
	    "Dorian",
	    "Edgar",
	    "Edmund",
	    "Edward",
	    "Edwin",
	    "Efrem",
	    "Efraim",
	    "Eliasz",
	    "Eleazar",
	    "Emil",
	    "Emanuel",
	    "Erast",
	    "Ernest",
	    "Eugeniusz",
	    "Eustracjusz",
	    "Fabian",
	    "Feliks",
	    "Florian",
	    "Franciszek",
	    "Fryderyk",
	    "Gabriel",
	    "Gedeon",
	    "Galfryd",
	    "Jerzy",
	    "Gerald",
	    "Gerazym",
	    "Gilbert",
	    "Gonsalwy",
	    "Grzegorz",
	    "Gwido",
	    "Harald",
	    "Henryk",
	    "Herbert",
	    "Herman",
	    "Hilary",
	    "Horacy",
	    "Hubert",
	    "Hugo",
	    "Ignacy",
	    "Igor",
	    "Hilarion",
	    "Innocenty",
	    "Hipolit",
	    "Ireneusz",
	    "Erwin",
	    "Izaak",
	    "Izajasz",
	    "Izydor",
	    "Jakub",
	    "Jeremi",
	    "Jeremiasz",
	    "Hieronim",
	    "Gerald",
	    "Joachim",
	    "Jan",
	    "Janusz",
	    "Jonatan",
	    "Józef",
	    "Jozue",
	    "Julian",
	    "Juliusz",
	    "Justyn",
	    "Kalistrat",
	    "Kazimierz",
	    "Wawrzyniec",
	    "Laurenty",
	    "Laurencjusz",
	    "Łazarz",
	    "Leon",
	    "Leonard",
	    "Leonid",
	    "Leon",
	    "Ludwik",
	    "Łukasz",
	    "Lucjan",
	    "Magnus",
	    "Makary",
	    "Marceli",
	    "Marek",
	    "Marcin",
	    "Mateusz",
	    "Maurycy",
	    "Maksym",
	    "Maksymilian",
	    "Michał",
	    "Miron",
	    "Modest",
	    "Mojżesz",
	    "Natan",
	    "Natanael",
	    "Nazariusz",
	    "Nazary",
	    "Nestor",
	    "Mikołaj",
	    "Nikodem",
	    "Olaf",
	    "Oleg",
	    "Oliwier",
	    "Onufry",
	    "Orestes",
	    "Oskar",
	    "Ansgary",
	    "Osmund",
	    "Pankracy",
	    "Pantaleon",
	    "Patryk",
	    "Patrycjusz",
	    "Patrycy",
	    "Paweł",
	    "Piotr",
	    "Filemon",
	    "Filip",
	    "Platon",
	    "Polikarp",
	    "Porfiry",
	    "Porfiriusz",
	    "Prokles",
	    "Prokul",
	    "Prokop",
	    "Kwintyn",
	    "Randolf",
	    "Rafał",
	    "Rajmund",
	    "Reginald",
	    "Rajnold",
	    "Ryszard",
	    "Robert",
	    "Roderyk",
	    "Roger",
	    "Roland",
	    "Roman",
	    "Romeo",
	    "Reginald",
	    "Rudolf",
	    "Samson",
	    "Samuel",
	    "Salwator",
	    "Sebastian",
	    "Serafin",
	    "Sergiusz",
	    "Seweryn",
	    "Zygmunt",
	    "Sylwester",
	    "Szymon",
	    "Salomon",
	    "Spirydion",
	    "Stanisław",
	    "Szczepan",
	    "Stefan",
	    "Terencjusz",
	    "Teodor",
	    "Tomasz",
	    "Tymoteusz",
	    "Tobiasz",
	    "Walenty",
	    "Walentyn",
	    "Walerian",
	    "Walery",
	    "Wiktor",
	    "Wincenty",
	    "Witalis",
	    "Włodzimierz",
	    "Władysław",
	    "Błażej",
	    "Walter",
	    "Walgierz",
	    "Wacław",
	    "Wilfryd",
	    "Wilhelm",
	    "Ksawery",
	    "Ksenofont",
	    "Jerzy",
	    "Zachariasz",
	    "Zachary",
	    "Ada",
	    "Adelajda",
	    "Agata",
	    "Agnieszka",
	    "Agrypina",
	    "Aida",
	    "Aleksandra",
	    "Alicja",
	    "Alina",
	    "Amanda",
	    "Anastazja",
	    "Angela",
	    "Andżelika",
	    "Angelina",
	    "Anna",
	    "Hanna",
	    "—",
	    "Antonina",
	    "Ariadna",
	    "Aurora",
	    "Barbara",
	    "Beatrycze",
	    "Berta",
	    "Brygida",
	    "Kamila",
	    "Karolina",
	    "Karolina",
	    "Kornelia",
	    "Katarzyna",
	    "Cecylia",
	    "Karolina",
	    "Chloe",
	    "Krystyna",
	    "Klara",
	    "Klaudia",
	    "Klementyna",
	    "Konstancja",
	    "Koralia",
	    "Daria",
	    "Diana",
	    "Dina",
	    "Dorota",
	    "Edyta",
	    "Eleonora",
	    "Eliza",
	    "Elżbieta",
	    "Izabela",
	    "Elwira",
	    "Emilia",
	    "Estera",
	    "Eudoksja",
	    "Eudokia",
	    "Eugenia",
	    "Ewa",
	    "Ewelina",
	    "Ferdynanda",
	    "Florencja",
	    "Franciszka",
	    "Gabriela",
	    "Gertruda",
	    "Gloria",
	    "Gracja",
	    "Jadwiga",
	    "Helena",
	    "Henryka",
	    "Nadzieja",
	    "Ida",
	    "Ilona",
	    "Helena",
	    "Irena",
	    "Irma",
	    "Izabela",
	    "Izolda",
	    "Jakubina",
	    "Joanna",
	    "Janina",
	    "Żaneta",
	    "Joanna",
	    "Ginewra",
	    "Józefina",
	    "Judyta",
	    "Julia",
	    "Julia",
	    "Julita",
	    "Justyna",
	    "Kira",
	    "Cyra",
	    "Kleopatra",
	    "Larysa",
	    "Laura",
	    "Laurencja",
	    "Laurentyna",
	    "Lea",
	    "Leila",
	    "Eleonora",
	    "Liliana",
	    "Lilianna",
	    "Lilia",
	    "Lilla",
	    "Liza",
	    "Eliza",
	    "Laura",
	    "Ludwika",
	    "Luiza",
	    "Łucja",
	    "Lucja",
	    "Lidia",
	    "Amabela",
	    "Magdalena",
	    "Malwina",
	    "Małgorzata",
	    "Greta",
	    "Marianna",
	    "Maryna",
	    "Marta",
	    "Martyna",
	    "Maria",
	    "Matylda",
	    "Maja",
	    "Maja",
	    "Melania",
	    "Michalina",
	    "Monika",
	    "Nadzieja",
	    "Noemi",
	    "Natalia",
	    "Nikola",
	    "Nina",
	    "Olga",
	    "Olimpia",
	    "Oliwia",
	    "Ofelia",
	    "Patrycja",
	    "Paula",
	    "Pelagia",
	    "Penelopa",
	    "Filipa",
	    "Paulina",
	    "Rachela",
	    "Rebeka",
	    "Regina",
	    "Renata",
	    "Rozalia",
	    "Róża",
	    "Roksana",
	    "Rufina",
	    "Ruta",
	    "Sabina",
	    "Sara",
	    "Serafina",
	    "Sybilla",
	    "Sylwia",
	    "Zofia",
	    "Stella",
	    "Stefania",
	    "Zuzanna",
	    "Tamara",
	    "Tacjana",
	    "Tekla",
	    "Teodora",
	    "Teresa",
	    "Walentyna",
	    "Waleria",
	    "Wanesa",
	    "Wiara",
	    "Weronika",
	    "Wiktoria",
	    "Wirginia",
	    "Bibiana",
	    "Bibianna",
	    "Wanda",
	    "Wilhelmina",
	    "Ksawera",
	    "Ksenia",
	    "Zoe"
	  ],
	  "last_name": [
	    "Adamczak",
	    "Adamczyk",
	    "Adamek",
	    "Adamiak",
	    "Adamiec",
	    "Adamowicz",
	    "Adamski",
	    "Adamus",
	    "Aleksandrowicz",
	    "Andrzejczak",
	    "Andrzejewski",
	    "Antczak",
	    "Augustyn",
	    "Augustyniak",
	    "Bagiński",
	    "Balcerzak",
	    "Banach",
	    "Banasiak",
	    "Banasik",
	    "Banaś",
	    "Baran",
	    "Baranowski",
	    "Barański",
	    "Bartczak",
	    "Bartkowiak",
	    "Bartnik",
	    "Bartosik",
	    "Bednarczyk",
	    "Bednarek",
	    "Bednarski",
	    "Bednarz",
	    "Białas",
	    "Białek",
	    "Białkowski",
	    "Bielak",
	    "Bielawski",
	    "Bielecki",
	    "Bielski",
	    "Bieniek",
	    "Biernacki",
	    "Biernat",
	    "Bieńkowski",
	    "Bilski",
	    "Bober",
	    "Bochenek",
	    "Bogucki",
	    "Bogusz",
	    "Borek",
	    "Borkowski",
	    "Borowiec",
	    "Borowski",
	    "Bożek",
	    "Broda",
	    "Brzeziński",
	    "Brzozowski",
	    "Buczek",
	    "Buczkowski",
	    "Buczyński",
	    "Budziński",
	    "Budzyński",
	    "Bujak",
	    "Bukowski",
	    "Burzyński",
	    "Bąk",
	    "Bąkowski",
	    "Błaszczak",
	    "Błaszczyk",
	    "Cebula",
	    "Chmiel",
	    "Chmielewski",
	    "Chmura",
	    "Chojnacki",
	    "Chojnowski",
	    "Cholewa",
	    "Chrzanowski",
	    "Chudzik",
	    "Cichocki",
	    "Cichoń",
	    "Cichy",
	    "Ciesielski",
	    "Cieśla",
	    "Cieślak",
	    "Cieślik",
	    "Ciszewski",
	    "Cybulski",
	    "Cygan",
	    "Czaja",
	    "Czajka",
	    "Czajkowski",
	    "Czapla",
	    "Czarnecki",
	    "Czech",
	    "Czechowski",
	    "Czekaj",
	    "Czerniak",
	    "Czerwiński",
	    "Czyż",
	    "Czyżewski",
	    "Dec",
	    "Dobosz",
	    "Dobrowolski",
	    "Dobrzyński",
	    "Domagała",
	    "Domański",
	    "Dominiak",
	    "Drabik",
	    "Drozd",
	    "Drozdowski",
	    "Drzewiecki",
	    "Dróżdż",
	    "Dubiel",
	    "Duda",
	    "Dudek",
	    "Dudziak",
	    "Dudzik",
	    "Dudziński",
	    "Duszyński",
	    "Dziedzic",
	    "Dziuba",
	    "Dąbek",
	    "Dąbkowski",
	    "Dąbrowski",
	    "Dębowski",
	    "Dębski",
	    "Długosz",
	    "Falkowski",
	    "Fijałkowski",
	    "Filipek",
	    "Filipiak",
	    "Filipowicz",
	    "Flak",
	    "Flis",
	    "Florczak",
	    "Florek",
	    "Frankowski",
	    "Frąckowiak",
	    "Frączek",
	    "Frątczak",
	    "Furman",
	    "Gadomski",
	    "Gajda",
	    "Gajewski",
	    "Gaweł",
	    "Gawlik",
	    "Gawron",
	    "Gawroński",
	    "Gałka",
	    "Gałązka",
	    "Gil",
	    "Godlewski",
	    "Golec",
	    "Gołąb",
	    "Gołębiewski",
	    "Gołębiowski",
	    "Grabowski",
	    "Graczyk",
	    "Grochowski",
	    "Grudzień",
	    "Gruszczyński",
	    "Gruszka",
	    "Grzegorczyk",
	    "Grzelak",
	    "Grzesiak",
	    "Grzesik",
	    "Grześkowiak",
	    "Grzyb",
	    "Grzybowski",
	    "Grzywacz",
	    "Gutowski",
	    "Guzik",
	    "Gwóźdź",
	    "Góra",
	    "Góral",
	    "Górecki",
	    "Górka",
	    "Górniak",
	    "Górny",
	    "Górski",
	    "Gąsior",
	    "Gąsiorowski",
	    "Głogowski",
	    "Głowacki",
	    "Głąb",
	    "Hajduk",
	    "Herman",
	    "Iwański",
	    "Izdebski",
	    "Jabłoński",
	    "Jackowski",
	    "Jagielski",
	    "Jagiełło",
	    "Jagodziński",
	    "Jakubiak",
	    "Jakubowski",
	    "Janas",
	    "Janiak",
	    "Janicki",
	    "Janik",
	    "Janiszewski",
	    "Jankowiak",
	    "Jankowski",
	    "Janowski",
	    "Janus",
	    "Janusz",
	    "Januszewski",
	    "Jaros",
	    "Jarosz",
	    "Jarząbek",
	    "Jasiński",
	    "Jastrzębski",
	    "Jaworski",
	    "Jaśkiewicz",
	    "Jezierski",
	    "Jurek",
	    "Jurkiewicz",
	    "Jurkowski",
	    "Juszczak",
	    "Jóźwiak",
	    "Jóźwik",
	    "Jędrzejczak",
	    "Jędrzejczyk",
	    "Jędrzejewski",
	    "Kacprzak",
	    "Kaczmarczyk",
	    "Kaczmarek",
	    "Kaczmarski",
	    "Kaczor",
	    "Kaczorowski",
	    "Kaczyński",
	    "Kaleta",
	    "Kalinowski",
	    "Kalisz",
	    "Kamiński",
	    "Kania",
	    "Kaniewski",
	    "Kapusta",
	    "Karaś",
	    "Karczewski",
	    "Karpiński",
	    "Karwowski",
	    "Kasperek",
	    "Kasprzak",
	    "Kasprzyk",
	    "Kaszuba",
	    "Kawa",
	    "Kawecki",
	    "Kałuża",
	    "Kaźmierczak",
	    "Kiełbasa",
	    "Kisiel",
	    "Kita",
	    "Klimczak",
	    "Klimek",
	    "Kmiecik",
	    "Kmieć",
	    "Knapik",
	    "Kobus",
	    "Kogut",
	    "Kolasa",
	    "Komorowski",
	    "Konieczna",
	    "Konieczny",
	    "Konopka",
	    "Kopczyński",
	    "Koper",
	    "Kopeć",
	    "Korzeniowski",
	    "Kos",
	    "Kosiński",
	    "Kosowski",
	    "Kostecki",
	    "Kostrzewa",
	    "Kot",
	    "Kotowski",
	    "Kowal",
	    "Kowalczuk",
	    "Kowalczyk",
	    "Kowalewski",
	    "Kowalik",
	    "Kowalski",
	    "Koza",
	    "Kozak",
	    "Kozieł",
	    "Kozioł",
	    "Kozłowski",
	    "Kołakowski",
	    "Kołodziej",
	    "Kołodziejczyk",
	    "Kołodziejski",
	    "Krajewski",
	    "Krakowiak",
	    "Krawczyk",
	    "Krawiec",
	    "Kruk",
	    "Krukowski",
	    "Krupa",
	    "Krupiński",
	    "Kruszewski",
	    "Krysiak",
	    "Krzemiński",
	    "Krzyżanowski",
	    "Król",
	    "Królikowski",
	    "Książek",
	    "Kubacki",
	    "Kubiak",
	    "Kubica",
	    "Kubicki",
	    "Kubik",
	    "Kuc",
	    "Kucharczyk",
	    "Kucharski",
	    "Kuchta",
	    "Kuciński",
	    "Kuczyński",
	    "Kujawa",
	    "Kujawski",
	    "Kula",
	    "Kulesza",
	    "Kulig",
	    "Kulik",
	    "Kuliński",
	    "Kurek",
	    "Kurowski",
	    "Kuś",
	    "Kwaśniewski",
	    "Kwiatkowski",
	    "Kwiecień",
	    "Kwieciński",
	    "Kędzierski",
	    "Kędziora",
	    "Kępa",
	    "Kłos",
	    "Kłosowski",
	    "Lach",
	    "Laskowski",
	    "Lasota",
	    "Lech",
	    "Lenart",
	    "Lesiak",
	    "Leszczyński",
	    "Lewandowski",
	    "Lewicki",
	    "Leśniak",
	    "Leśniewski",
	    "Lipiński",
	    "Lipka",
	    "Lipski",
	    "Lis",
	    "Lisiecki",
	    "Lisowski",
	    "Maciejewski",
	    "Maciąg",
	    "Mackiewicz",
	    "Madej",
	    "Maj",
	    "Majcher",
	    "Majchrzak",
	    "Majewski",
	    "Majka",
	    "Makowski",
	    "Malec",
	    "Malicki",
	    "Malinowski",
	    "Maliszewski",
	    "Marchewka",
	    "Marciniak",
	    "Marcinkowski",
	    "Marczak",
	    "Marek",
	    "Markiewicz",
	    "Markowski",
	    "Marszałek",
	    "Marzec",
	    "Masłowski",
	    "Matusiak",
	    "Matuszak",
	    "Matuszewski",
	    "Matysiak",
	    "Mazur",
	    "Mazurek",
	    "Mazurkiewicz",
	    "Maćkowiak",
	    "Małecki",
	    "Małek",
	    "Maślanka",
	    "Michalak",
	    "Michalczyk",
	    "Michalik",
	    "Michalski",
	    "Michałek",
	    "Michałowski",
	    "Mielczarek",
	    "Mierzejewski",
	    "Mika",
	    "Mikołajczak",
	    "Mikołajczyk",
	    "Mikulski",
	    "Milczarek",
	    "Milewski",
	    "Miller",
	    "Misiak",
	    "Misztal",
	    "Miśkiewicz",
	    "Modzelewski",
	    "Molenda",
	    "Morawski",
	    "Motyka",
	    "Mroczek",
	    "Mroczkowski",
	    "Mrozek",
	    "Mróz",
	    "Mucha",
	    "Murawski",
	    "Musiał",
	    "Muszyński",
	    "Młynarczyk",
	    "Napierała",
	    "Nawrocki",
	    "Nawrot",
	    "Niedziela",
	    "Niedzielski",
	    "Niedźwiecki",
	    "Niemczyk",
	    "Niemiec",
	    "Niewiadomski",
	    "Noga",
	    "Nowacki",
	    "Nowaczyk",
	    "Nowak",
	    "Nowakowski",
	    "Nowicki",
	    "Nowiński",
	    "Olczak",
	    "Olejniczak",
	    "Olejnik",
	    "Olszewski",
	    "Orzechowski",
	    "Orłowski",
	    "Osiński",
	    "Ossowski",
	    "Ostrowski",
	    "Owczarek",
	    "Paczkowski",
	    "Pająk",
	    "Pakuła",
	    "Paluch",
	    "Panek",
	    "Partyka",
	    "Pasternak",
	    "Paszkowski",
	    "Pawelec",
	    "Pawlak",
	    "Pawlicki",
	    "Pawlik",
	    "Pawlikowski",
	    "Pawłowski",
	    "Pałka",
	    "Piasecki",
	    "Piechota",
	    "Piekarski",
	    "Pietras",
	    "Pietruszka",
	    "Pietrzak",
	    "Pietrzyk",
	    "Pilarski",
	    "Pilch",
	    "Piotrowicz",
	    "Piotrowski",
	    "Piwowarczyk",
	    "Piórkowski",
	    "Piątek",
	    "Piątkowski",
	    "Piłat",
	    "Pluta",
	    "Podgórski",
	    "Polak",
	    "Popławski",
	    "Porębski",
	    "Prokop",
	    "Prus",
	    "Przybylski",
	    "Przybysz",
	    "Przybył",
	    "Przybyła",
	    "Ptak",
	    "Puchalski",
	    "Pytel",
	    "Płonka",
	    "Raczyński",
	    "Radecki",
	    "Radomski",
	    "Rak",
	    "Rakowski",
	    "Ratajczak",
	    "Robak",
	    "Rogala",
	    "Rogalski",
	    "Rogowski",
	    "Rojek",
	    "Romanowski",
	    "Rosa",
	    "Rosiak",
	    "Rosiński",
	    "Ruciński",
	    "Rudnicki",
	    "Rudziński",
	    "Rudzki",
	    "Rusin",
	    "Rutkowski",
	    "Rybak",
	    "Rybarczyk",
	    "Rybicki",
	    "Rzepka",
	    "Różański",
	    "Różycki",
	    "Sadowski",
	    "Sawicki",
	    "Serafin",
	    "Siedlecki",
	    "Sienkiewicz",
	    "Sieradzki",
	    "Sikora",
	    "Sikorski",
	    "Sitek",
	    "Siwek",
	    "Skalski",
	    "Skiba",
	    "Skibiński",
	    "Skoczylas",
	    "Skowron",
	    "Skowronek",
	    "Skowroński",
	    "Skrzypczak",
	    "Skrzypek",
	    "Skóra",
	    "Smoliński",
	    "Sobczak",
	    "Sobczyk",
	    "Sobieraj",
	    "Sobolewski",
	    "Socha",
	    "Sochacki",
	    "Sokołowski",
	    "Sokół",
	    "Sosnowski",
	    "Sowa",
	    "Sowiński",
	    "Sołtys",
	    "Sołtysiak",
	    "Sroka",
	    "Stachowiak",
	    "Stachowicz",
	    "Stachura",
	    "Stachurski",
	    "Stanek",
	    "Staniszewski",
	    "Stanisławski",
	    "Stankiewicz",
	    "Stasiak",
	    "Staszewski",
	    "Stawicki",
	    "Stec",
	    "Stefaniak",
	    "Stefański",
	    "Stelmach",
	    "Stolarczyk",
	    "Stolarski",
	    "Strzelczyk",
	    "Strzelecki",
	    "Stępień",
	    "Stępniak",
	    "Surma",
	    "Suski",
	    "Szafrański",
	    "Szatkowski",
	    "Szczepaniak",
	    "Szczepanik",
	    "Szczepański",
	    "Szczerba",
	    "Szcześniak",
	    "Szczygieł",
	    "Szczęsna",
	    "Szczęsny",
	    "Szeląg",
	    "Szewczyk",
	    "Szostak",
	    "Szulc",
	    "Szwarc",
	    "Szwed",
	    "Szydłowski",
	    "Szymański",
	    "Szymczak",
	    "Szymczyk",
	    "Szymkowiak",
	    "Szyszka",
	    "Sławiński",
	    "Słowik",
	    "Słowiński",
	    "Tarnowski",
	    "Tkaczyk",
	    "Tokarski",
	    "Tomala",
	    "Tomaszewski",
	    "Tomczak",
	    "Tomczyk",
	    "Tracz",
	    "Trojanowski",
	    "Trzciński",
	    "Trzeciak",
	    "Turek",
	    "Twardowski",
	    "Urban",
	    "Urbanek",
	    "Urbaniak",
	    "Urbanowicz",
	    "Urbańczyk",
	    "Urbański",
	    "Walczak",
	    "Walkowiak",
	    "Warchoł",
	    "Wasiak",
	    "Wasilewski",
	    "Wawrzyniak",
	    "Wesołowski",
	    "Wieczorek",
	    "Wierzbicki",
	    "Wilczek",
	    "Wilczyński",
	    "Wilk",
	    "Winiarski",
	    "Witczak",
	    "Witek",
	    "Witkowski",
	    "Wiącek",
	    "Więcek",
	    "Więckowski",
	    "Wiśniewski",
	    "Wnuk",
	    "Wojciechowski",
	    "Wojtas",
	    "Wojtasik",
	    "Wojtczak",
	    "Wojtkowiak",
	    "Wolak",
	    "Woliński",
	    "Wolny",
	    "Wolski",
	    "Woś",
	    "Woźniak",
	    "Wrona",
	    "Wroński",
	    "Wróbel",
	    "Wróblewski",
	    "Wypych",
	    "Wysocki",
	    "Wyszyński",
	    "Wójcicki",
	    "Wójcik",
	    "Wójtowicz",
	    "Wąsik",
	    "Węgrzyn",
	    "Włodarczyk",
	    "Włodarski",
	    "Zaborowski",
	    "Zabłocki",
	    "Zagórski",
	    "Zając",
	    "Zajączkowski",
	    "Zakrzewski",
	    "Zalewski",
	    "Zaremba",
	    "Zarzycki",
	    "Zaręba",
	    "Zawada",
	    "Zawadzki",
	    "Zdunek",
	    "Zieliński",
	    "Zielonka",
	    "Ziółkowski",
	    "Zięba",
	    "Ziętek",
	    "Zwoliński",
	    "Zych",
	    "Zygmunt",
	    "Łapiński",
	    "Łuczak",
	    "Łukasiewicz",
	    "Łukasik",
	    "Łukaszewski",
	    "Śliwa",
	    "Śliwiński",
	    "Ślusarczyk",
	    "Świderski",
	    "Świerczyński",
	    "Świątek",
	    "Żak",
	    "Żebrowski",
	    "Żmuda",
	    "Żuk",
	    "Żukowski",
	    "Żurawski",
	    "Żurek",
	    "Żyła"
	  ],
	  "prefix": [
	    "Pan",
	    "Pani"
	  ],
	  "title": {
	    "descriptor": [
	      "Lead",
	      "Senior",
	      "Direct",
	      "Corporate",
	      "Dynamic",
	      "Future",
	      "Product",
	      "National",
	      "Regional",
	      "District",
	      "Central",
	      "Global",
	      "Customer",
	      "Investor",
	      "Dynamic",
	      "International",
	      "Legacy",
	      "Forward",
	      "Internal",
	      "Human",
	      "Chief",
	      "Principal"
	    ],
	    "level": [
	      "Solutions",
	      "Program",
	      "Brand",
	      "Security",
	      "Research",
	      "Marketing",
	      "Directives",
	      "Implementation",
	      "Integration",
	      "Functionality",
	      "Response",
	      "Paradigm",
	      "Tactics",
	      "Identity",
	      "Markets",
	      "Group",
	      "Division",
	      "Applications",
	      "Optimization",
	      "Operations",
	      "Infrastructure",
	      "Intranet",
	      "Communications",
	      "Web",
	      "Branding",
	      "Quality",
	      "Assurance",
	      "Mobility",
	      "Accounts",
	      "Data",
	      "Creative",
	      "Configuration",
	      "Accountability",
	      "Interactions",
	      "Factors",
	      "Usability",
	      "Metrics"
	    ],
	    "job": [
	      "Supervisor",
	      "Associate",
	      "Executive",
	      "Liason",
	      "Officer",
	      "Manager",
	      "Engineer",
	      "Specialist",
	      "Director",
	      "Coordinator",
	      "Administrator",
	      "Architect",
	      "Analyst",
	      "Designer",
	      "Planner",
	      "Orchestrator",
	      "Technician",
	      "Developer",
	      "Producer",
	      "Consultant",
	      "Assistant",
	      "Facilitator",
	      "Agent",
	      "Representative",
	      "Strategist"
	    ]
	  },
	  "name": [
	    "#{prefix} #{first_name} #{last_name}",
	    "#{first_name} #{last_name}",
	    "#{first_name} #{last_name}",
	    "#{first_name} #{last_name}",
	    "#{first_name} #{last_name}",
	    "#{first_name} #{last_name}"
	  ]
	};
	pl.address = {
	  "country": [
	    "Afganistan",
	    "Albania",
	    "Algieria",
	    "Andora",
	    "Angola",
	    "Antigua i Barbuda",
	    "Arabia Saudyjska",
	    "Argentyna",
	    "Armenia",
	    "Australia",
	    "Austria",
	    "Azerbejdżan",
	    "Bahamy",
	    "Bahrajn",
	    "Bangladesz",
	    "Barbados",
	    "Belgia",
	    "Belize",
	    "Benin",
	    "Bhutan",
	    "Białoruś",
	    "Birma",
	    "Boliwia",
	    "Sucre",
	    "Bośnia i Hercegowina",
	    "Botswana",
	    "Brazylia",
	    "Brunei",
	    "Bułgaria",
	    "Burkina Faso",
	    "Burundi",
	    "Chile",
	    "Chiny",
	    "Chorwacja",
	    "Cypr",
	    "Czad",
	    "Czarnogóra",
	    "Czechy",
	    "Dania",
	    "Demokratyczna Republika Konga",
	    "Dominika",
	    "Dominikana",
	    "Dżibuti",
	    "Egipt",
	    "Ekwador",
	    "Erytrea",
	    "Estonia",
	    "Etiopia",
	    "Fidżi",
	    "Filipiny",
	    "Finlandia",
	    "Francja",
	    "Gabon",
	    "Gambia",
	    "Ghana",
	    "Grecja",
	    "Grenada",
	    "Gruzja",
	    "Gujana",
	    "Gwatemala",
	    "Gwinea",
	    "Gwinea Bissau",
	    "Gwinea Równikowa",
	    "Haiti",
	    "Hiszpania",
	    "Holandia",
	    "Haga",
	    "Honduras",
	    "Indie",
	    "Indonezja",
	    "Irak",
	    "Iran",
	    "Irlandia",
	    "Islandia",
	    "Izrael",
	    "Jamajka",
	    "Japonia",
	    "Jemen",
	    "Jordania",
	    "Kambodża",
	    "Kamerun",
	    "Kanada",
	    "Katar",
	    "Kazachstan",
	    "Kenia",
	    "Kirgistan",
	    "Kiribati",
	    "Kolumbia",
	    "Komory",
	    "Kongo",
	    "Korea Południowa",
	    "Korea Północna",
	    "Kostaryka",
	    "Kuba",
	    "Kuwejt",
	    "Laos",
	    "Lesotho",
	    "Liban",
	    "Liberia",
	    "Libia",
	    "Liechtenstein",
	    "Litwa",
	    "Luksemburg",
	    "Łotwa",
	    "Macedonia",
	    "Madagaskar",
	    "Malawi",
	    "Malediwy",
	    "Malezja",
	    "Mali",
	    "Malta",
	    "Maroko",
	    "Mauretania",
	    "Mauritius",
	    "Meksyk",
	    "Mikronezja",
	    "Mołdawia",
	    "Monako",
	    "Mongolia",
	    "Mozambik",
	    "Namibia",
	    "Nauru",
	    "Nepal",
	    "Niemcy",
	    "Niger",
	    "Nigeria",
	    "Nikaragua",
	    "Norwegia",
	    "Nowa Zelandia",
	    "Oman",
	    "Pakistan",
	    "Palau",
	    "Panama",
	    "Papua-Nowa Gwinea",
	    "Paragwaj",
	    "Peru",
	    "Polska",
	    "322 575",
	    "Portugalia",
	    "Republika Południowej Afryki",
	    "Republika Środkowoafrykańska",
	    "Republika Zielonego Przylądka",
	    "Rosja",
	    "Rumunia",
	    "Rwanda",
	    "Saint Kitts i Nevis",
	    "Saint Lucia",
	    "Saint Vincent i Grenadyny",
	    "Salwador",
	    "Samoa",
	    "San Marino",
	    "Senegal",
	    "Serbia",
	    "Seszele",
	    "Sierra Leone",
	    "Singapur",
	    "Słowacja",
	    "Słowenia",
	    "Somalia",
	    "Sri Lanka",
	    "Stany Zjednoczone",
	    "Suazi",
	    "Sudan",
	    "Sudan Południowy",
	    "Surinam",
	    "Syria",
	    "Szwajcaria",
	    "Szwecja",
	    "Tadżykistan",
	    "Tajlandia",
	    "Tanzania",
	    "Timor Wschodni",
	    "Togo",
	    "Tonga",
	    "Trynidad i Tobago",
	    "Tunezja",
	    "Turcja",
	    "Turkmenistan",
	    "Tuvalu",
	    "Funafuti",
	    "Uganda",
	    "Ukraina",
	    "Urugwaj",
	    2008,
	    "Uzbekistan",
	    "Vanuatu",
	    "Watykan",
	    "Wenezuela",
	    "Węgry",
	    "Wielka Brytania",
	    "Wietnam",
	    "Włochy",
	    "Wybrzeże Kości Słoniowej",
	    "Wyspy Marshalla",
	    "Wyspy Salomona",
	    "Wyspy Świętego Tomasza i Książęca",
	    "Zambia",
	    "Zimbabwe",
	    "Zjednoczone Emiraty Arabskie"
	  ],
	  "building_number": [
	    "#####",
	    "####",
	    "###"
	  ],
	  "street_prefix": [
	    "ul.",
	    "al."
	  ],
	  "secondary_address": [
	    "Apt. ###",
	    "Suite ###"
	  ],
	  "postcode": [
	    "##-###"
	  ],
	  "state": [
	    "Dolnośląskie",
	    "Kujawsko-pomorskie",
	    "Lubelskie",
	    "Lubuskie",
	    "Łódzkie",
	    "Małopolskie",
	    "Mazowieckie",
	    "Opolskie",
	    "Podkarpackie",
	    "Podlaskie",
	    "Pomorskie",
	    "Śląskie",
	    "Świętokrzyskie",
	    "Warmińsko-mazurskie",
	    "Wielkopolskie",
	    "Zachodniopomorskie"
	  ],
	  "state_abbr": [
	    "DŚ",
	    "KP",
	    "LB",
	    "LS",
	    "ŁD",
	    "MP",
	    "MZ",
	    "OP",
	    "PK",
	    "PL",
	    "PM",
	    "ŚL",
	    "ŚK",
	    "WM",
	    "WP",
	    "ZP"
	  ],
	  "city_name": [
	    "Aleksandrów Kujawski",
	    "Aleksandrów Łódzki",
	    "Alwernia",
	    "Andrychów",
	    "Annopol",
	    "Augustów",
	    "Babimost",
	    "Baborów",
	    "Baranów Sandomierski",
	    "Barcin",
	    "Barczewo",
	    "Bardo",
	    "Barlinek",
	    "Bartoszyce",
	    "Barwice",
	    "Bełchatów",
	    "Bełżyce",
	    "Będzin",
	    "Biała",
	    "Biała Piska",
	    "Biała Podlaska",
	    "Biała Rawska",
	    "Białobrzegi",
	    "Białogard",
	    "Biały Bór",
	    "Białystok",
	    "Biecz",
	    "Bielawa",
	    "Bielsk Podlaski",
	    "Bielsko-Biała",
	    "Bieruń",
	    "Bierutów",
	    "Bieżuń",
	    "Biłgoraj",
	    "Biskupiec",
	    "Bisztynek",
	    "Blachownia",
	    "Błaszki",
	    "Błażowa",
	    "Błonie",
	    "Bobolice",
	    "Bobowa",
	    "Bochnia",
	    "Bodzentyn",
	    "Bogatynia",
	    "Boguchwała",
	    "Boguszów-Gorce",
	    "Bojanowo",
	    "Bolesławiec",
	    "Bolków",
	    "Borek Wielkopolski",
	    "Borne Sulinowo",
	    "Braniewo",
	    "Brańsk",
	    "Brodnica",
	    "Brok",
	    "Brusy",
	    "Brwinów",
	    "Brzeg",
	    "Brzeg Dolny",
	    "Brzesko",
	    "Brzeszcze",
	    "Brześć Kujawski",
	    "Brzeziny",
	    "Brzostek",
	    "Brzozów",
	    "Buk",
	    "Bukowno",
	    "Busko-Zdrój",
	    "Bychawa",
	    "Byczyna",
	    "Bydgoszcz",
	    "Bystrzyca Kłodzka",
	    "Bytom",
	    "Bytom Odrzański",
	    "Bytów",
	    "Cedynia",
	    "Chełm",
	    "Chełmek",
	    "Chełmno",
	    "Chełmża",
	    "Chęciny",
	    "Chmielnik",
	    "Chocianów",
	    "Chociwel",
	    "Chodecz",
	    "Chodzież",
	    "Chojna",
	    "Chojnice",
	    "Chojnów",
	    "Choroszcz",
	    "Chorzele",
	    "Chorzów",
	    "Choszczno",
	    "Chrzanów",
	    "Ciechanowiec",
	    "Ciechanów",
	    "Ciechocinek",
	    "Cieszanów",
	    "Cieszyn",
	    "Ciężkowice",
	    "Cybinka",
	    "Czaplinek",
	    "Czarna Białostocka",
	    "Czarna Woda",
	    "Czarne",
	    "Czarnków",
	    "Czchów",
	    "Czechowice-Dziedzice",
	    "Czeladź",
	    "Czempiń",
	    "Czerniejewo",
	    "Czersk",
	    "Czerwieńsk",
	    "Czerwionka-Leszczyny",
	    "Częstochowa",
	    "Człopa",
	    "Człuchów",
	    "Czyżew",
	    "Ćmielów",
	    "Daleszyce",
	    "Darłowo",
	    "Dąbie",
	    "Dąbrowa Białostocka",
	    "Dąbrowa Górnicza",
	    "Dąbrowa Tarnowska",
	    "Debrzno",
	    "Dębica",
	    "Dęblin",
	    "Dębno",
	    "Dobczyce",
	    "Dobiegniew",
	    "Dobra (powiat łobeski)",
	    "Dobra (powiat turecki)",
	    "Dobre Miasto",
	    "Dobrodzień",
	    "Dobrzany",
	    "Dobrzyń nad Wisłą",
	    "Dolsk",
	    "Drawno",
	    "Drawsko Pomorskie",
	    "Drezdenko",
	    "Drobin",
	    "Drohiczyn",
	    "Drzewica",
	    "Dukla",
	    "Duszniki-Zdrój",
	    "Dynów",
	    "Działdowo",
	    "Działoszyce",
	    "Działoszyn",
	    "Dzierzgoń",
	    "Dzierżoniów",
	    "Dziwnów",
	    "Elbląg",
	    "Ełk",
	    "Frampol",
	    "Frombork",
	    "Garwolin",
	    "Gąbin",
	    "Gdańsk",
	    "Gdynia",
	    "Giżycko",
	    "Glinojeck",
	    "Gliwice",
	    "Głogów",
	    "Głogów Małopolski",
	    "Głogówek",
	    "Głowno",
	    "Głubczyce",
	    "Głuchołazy",
	    "Głuszyca",
	    "Gniew",
	    "Gniewkowo",
	    "Gniezno",
	    "Gogolin",
	    "Golczewo",
	    "Goleniów",
	    "Golina",
	    "Golub-Dobrzyń",
	    "Gołańcz",
	    "Gołdap",
	    "Goniądz",
	    "Gorlice",
	    "Gorzów Śląski",
	    "Gorzów Wielkopolski",
	    "Gostynin",
	    "Gostyń",
	    "Gościno",
	    "Gozdnica",
	    "Góra",
	    "Góra Kalwaria",
	    "Górowo Iławeckie",
	    "Górzno",
	    "Grabów nad Prosną",
	    "Grajewo",
	    "Grodków",
	    "Grodzisk Mazowiecki",
	    "Grodzisk Wielkopolski",
	    "Grójec",
	    "Grudziądz",
	    "Grybów",
	    "Gryfice",
	    "Gryfino",
	    "Gryfów Śląski",
	    "Gubin",
	    "Hajnówka",
	    "Halinów",
	    "Hel",
	    "Hrubieszów",
	    "Iława",
	    "Iłowa",
	    "Iłża",
	    "Imielin",
	    "Inowrocław",
	    "Ińsko",
	    "Iwonicz-Zdrój",
	    "Izbica Kujawska",
	    "Jabłonowo Pomorskie",
	    "Janikowo",
	    "Janowiec Wielkopolski",
	    "Janów Lubelski",
	    "Jarocin",
	    "Jarosław",
	    "Jasień",
	    "Jasło",
	    "Jastarnia",
	    "Jastrowie",
	    "Jastrzębie-Zdrój",
	    "Jawor",
	    "Jaworzno",
	    "Jaworzyna Śląska",
	    "Jedlicze",
	    "Jedlina-Zdrój",
	    "Jedwabne",
	    "Jelcz-Laskowice",
	    "Jelenia Góra",
	    "Jeziorany",
	    "Jędrzejów",
	    "Jordanów",
	    "Józefów (powiat biłgorajski)",
	    "Józefów (powiat otwocki)",
	    "Jutrosin",
	    "Kalety",
	    "Kalisz",
	    "Kalisz Pomorski",
	    "Kalwaria Zebrzydowska",
	    "Kałuszyn",
	    "Kamienna Góra",
	    "Kamień Krajeński",
	    "Kamień Pomorski",
	    "Kamieńsk",
	    "Kańczuga",
	    "Karczew",
	    "Kargowa",
	    "Karlino",
	    "Karpacz",
	    "Kartuzy",
	    "Katowice",
	    "Kazimierz Dolny",
	    "Kazimierza Wielka",
	    "Kąty Wrocławskie",
	    "Kcynia",
	    "Kędzierzyn-Koźle",
	    "Kępice",
	    "Kępno",
	    "Kętrzyn",
	    "Kęty",
	    "Kielce",
	    "Kietrz",
	    "Kisielice",
	    "Kleczew",
	    "Kleszczele",
	    "Kluczbork",
	    "Kłecko",
	    "Kłobuck",
	    "Kłodawa",
	    "Kłodzko",
	    "Knurów",
	    "Knyszyn",
	    "Kobylin",
	    "Kobyłka",
	    "Kock",
	    "Kolbuszowa",
	    "Kolno",
	    "Kolonowskie",
	    "Koluszki",
	    "Kołaczyce",
	    "Koło",
	    "Kołobrzeg",
	    "Koniecpol",
	    "Konin",
	    "Konstancin-Jeziorna",
	    "Konstantynów Łódzki",
	    "Końskie",
	    "Koprzywnica",
	    "Korfantów",
	    "Koronowo",
	    "Korsze",
	    "Kosów Lacki",
	    "Kostrzyn",
	    "Kostrzyn nad Odrą",
	    "Koszalin",
	    "Kościan",
	    "Kościerzyna",
	    "Kowal",
	    "Kowalewo Pomorskie",
	    "Kowary",
	    "Koziegłowy",
	    "Kozienice",
	    "Koźmin Wielkopolski",
	    "Kożuchów",
	    "Kórnik",
	    "Krajenka",
	    "Kraków",
	    "Krapkowice",
	    "Krasnobród",
	    "Krasnystaw",
	    "Kraśnik",
	    "Krobia",
	    "Krosno",
	    "Krosno Odrzańskie",
	    "Krośniewice",
	    "Krotoszyn",
	    "Kruszwica",
	    "Krynica Morska",
	    "Krynica-Zdrój",
	    "Krynki",
	    "Krzanowice",
	    "Krzepice",
	    "Krzeszowice",
	    "Krzywiń",
	    "Krzyż Wielkopolski",
	    "Książ Wielkopolski",
	    "Kudowa-Zdrój",
	    "Kunów",
	    "Kutno",
	    "Kuźnia Raciborska",
	    "Kwidzyn",
	    "Lądek-Zdrój",
	    "Legionowo",
	    "Legnica",
	    "Lesko",
	    "Leszno",
	    "Leśna",
	    "Leśnica",
	    "Lewin Brzeski",
	    "Leżajsk",
	    "Lębork",
	    "Lędziny",
	    "Libiąż",
	    "Lidzbark",
	    "Lidzbark Warmiński",
	    "Limanowa",
	    "Lipiany",
	    "Lipno",
	    "Lipsk",
	    "Lipsko",
	    "Lubaczów",
	    "Lubań",
	    "Lubartów",
	    "Lubawa",
	    "Lubawka",
	    "Lubień Kujawski",
	    "Lubin",
	    "Lublin",
	    "Lubliniec",
	    "Lubniewice",
	    "Lubomierz",
	    "Luboń",
	    "Lubraniec",
	    "Lubsko",
	    "Lwówek",
	    "Lwówek Śląski",
	    "Łabiszyn",
	    "Łańcut",
	    "Łapy",
	    "Łasin",
	    "Łask",
	    "Łaskarzew",
	    "Łaszczów",
	    "Łaziska Górne",
	    "Łazy",
	    "Łeba",
	    "Łęczna",
	    "Łęczyca",
	    "Łęknica",
	    "Łobez",
	    "Łobżenica",
	    "Łochów",
	    "Łomianki",
	    "Łomża",
	    "Łosice",
	    "Łowicz",
	    "Łódź",
	    "Łuków",
	    "Maków Mazowiecki",
	    "Maków Podhalański",
	    "Malbork",
	    "Małogoszcz",
	    "Małomice",
	    "Margonin",
	    "Marki",
	    "Maszewo",
	    "Miasteczko Śląskie",
	    "Miastko",
	    "Michałowo",
	    "Miechów",
	    "Miejska Górka",
	    "Mielec",
	    "Mieroszów",
	    "Mieszkowice",
	    "Międzybórz",
	    "Międzychód",
	    "Międzylesie",
	    "Międzyrzec Podlaski",
	    "Międzyrzecz",
	    "Międzyzdroje",
	    "Mikołajki",
	    "Mikołów",
	    "Mikstat",
	    "Milanówek",
	    "Milicz",
	    "Miłakowo",
	    "Miłomłyn",
	    "Miłosław",
	    "Mińsk Mazowiecki",
	    "Mirosławiec",
	    "Mirsk",
	    "Mława",
	    "Młynary",
	    "Mogielnica",
	    "Mogilno",
	    "Mońki",
	    "Morąg",
	    "Mordy",
	    "Moryń",
	    "Mosina",
	    "Mrągowo",
	    "Mrocza",
	    "Mszana Dolna",
	    "Mszczonów",
	    "Murowana Goślina",
	    "Muszyna",
	    "Mysłowice",
	    "Myszków",
	    "Myszyniec",
	    "Myślenice",
	    "Myślibórz",
	    "Nakło nad Notecią",
	    "Nałęczów",
	    "Namysłów",
	    "Narol",
	    "Nasielsk",
	    "Nekla",
	    "Nidzica",
	    "Niemcza",
	    "Niemodlin",
	    "Niepołomice",
	    "Nieszawa",
	    "Nisko",
	    "Nowa Dęba",
	    "Nowa Ruda",
	    "Nowa Sarzyna",
	    "Nowa Sól",
	    "Nowe",
	    "Nowe Brzesko",
	    "Nowe Miasteczko",
	    "Nowe Miasto Lubawskie",
	    "Nowe Miasto nad Pilicą",
	    "Nowe Skalmierzyce",
	    "Nowe Warpno",
	    "Nowogard",
	    "Nowogrodziec",
	    "Nowogród",
	    "Nowogród Bobrzański",
	    "Nowy Dwór Gdański",
	    "Nowy Dwór Mazowiecki",
	    "Nowy Sącz",
	    "Nowy Staw",
	    "Nowy Targ",
	    "Nowy Tomyśl",
	    "Nowy Wiśnicz",
	    "Nysa",
	    "Oborniki",
	    "Oborniki Śląskie",
	    "Obrzycko",
	    "Odolanów",
	    "Ogrodzieniec",
	    "Okonek",
	    "Olecko",
	    "Olesno",
	    "Oleszyce",
	    "Oleśnica",
	    "Olkusz",
	    "Olsztyn",
	    "Olsztynek",
	    "Olszyna",
	    "Oława",
	    "Opalenica",
	    "Opatów",
	    "Opoczno",
	    "Opole",
	    "Opole Lubelskie",
	    "Orneta",
	    "Orzesze",
	    "Orzysz",
	    "Osieczna",
	    "Osiek",
	    "Ostrołęka",
	    "Ostroróg",
	    "Ostrowiec Świętokrzyski",
	    "Ostróda",
	    "Ostrów Lubelski",
	    "Ostrów Mazowiecka",
	    "Ostrów Wielkopolski",
	    "Ostrzeszów",
	    "Ośno Lubuskie",
	    "Oświęcim",
	    "Otmuchów",
	    "Otwock",
	    "Ozimek",
	    "Ozorków",
	    "Ożarów",
	    "Ożarów Mazowiecki",
	    "Pabianice",
	    "Paczków",
	    "Pajęczno",
	    "Pakość",
	    "Parczew",
	    "Pasłęk",
	    "Pasym",
	    "Pelplin",
	    "Pełczyce",
	    "Piaseczno",
	    "Piaski",
	    "Piastów",
	    "Piechowice",
	    "Piekary Śląskie",
	    "Pieniężno",
	    "Pieńsk",
	    "Pieszyce",
	    "Pilawa",
	    "Pilica",
	    "Pilzno",
	    "Piła",
	    "Piława Górna",
	    "Pińczów",
	    "Pionki",
	    "Piotrków Kujawski",
	    "Piotrków Trybunalski",
	    "Pisz",
	    "Piwniczna-Zdrój",
	    "Pleszew",
	    "Płock",
	    "Płońsk",
	    "Płoty",
	    "Pniewy",
	    "Pobiedziska",
	    "Poddębice",
	    "Podkowa Leśna",
	    "Pogorzela",
	    "Polanica-Zdrój",
	    "Polanów",
	    "Police",
	    "Polkowice",
	    "Połaniec",
	    "Połczyn-Zdrój",
	    "Poniatowa",
	    "Poniec",
	    "Poręba",
	    "Poznań",
	    "Prabuty",
	    "Praszka",
	    "Prochowice",
	    "Proszowice",
	    "Prószków",
	    "Pruchnik",
	    "Prudnik",
	    "Prusice",
	    "Pruszcz Gdański",
	    "Pruszków",
	    "Przasnysz",
	    "Przecław",
	    "Przedbórz",
	    "Przedecz",
	    "Przemków",
	    "Przemyśl",
	    "Przeworsk",
	    "Przysucha",
	    "Pszczyna",
	    "Pszów",
	    "Puck",
	    "Puławy",
	    "Pułtusk",
	    "Puszczykowo",
	    "Pyrzyce",
	    "Pyskowice",
	    "Pyzdry",
	    "Rabka-Zdrój",
	    "Raciąż",
	    "Racibórz",
	    "Radków",
	    "Radlin",
	    "Radłów",
	    "Radom",
	    "Radomsko",
	    "Radomyśl Wielki",
	    "Radymno",
	    "Radziejów",
	    "Radzionków",
	    "Radzymin",
	    "Radzyń Chełmiński",
	    "Radzyń Podlaski",
	    "Rajgród",
	    "Rakoniewice",
	    "Raszków",
	    "Rawa Mazowiecka",
	    "Rawicz",
	    "Recz",
	    "Reda",
	    "Rejowiec Fabryczny",
	    "Resko",
	    "Reszel",
	    "Rogoźno",
	    "Ropczyce",
	    "Różan",
	    "Ruciane-Nida",
	    "Ruda Śląska",
	    "Rudnik nad Sanem",
	    "Rumia",
	    "Rybnik",
	    "Rychwał",
	    "Rydułtowy",
	    "Rydzyna",
	    "Ryglice",
	    "Ryki",
	    "Rymanów",
	    "Ryn",
	    "Rypin",
	    "Rzepin",
	    "Rzeszów",
	    "Rzgów",
	    "Sandomierz",
	    "Sanok",
	    "Sejny",
	    "Serock",
	    "Sędziszów",
	    "Sędziszów Małopolski",
	    "Sępopol",
	    "Sępólno Krajeńskie",
	    "Sianów",
	    "Siechnice",
	    "Siedlce",
	    "Siemianowice Śląskie",
	    "Siemiatycze",
	    "Sieniawa",
	    "Sieradz",
	    "Sieraków",
	    "Sierpc",
	    "Siewierz",
	    "Skalbmierz",
	    "Skała",
	    "Skarszewy",
	    "Skaryszew",
	    "Skarżysko-Kamienna",
	    "Skawina",
	    "Skępe",
	    "Skierniewice",
	    "Skoczów",
	    "Skoki",
	    "Skórcz",
	    "Skwierzyna",
	    "Sława",
	    "Sławków",
	    "Sławno",
	    "Słomniki",
	    "Słubice",
	    "Słupca",
	    "Słupsk",
	    "Sobótka",
	    "Sochaczew",
	    "Sokołów Małopolski",
	    "Sokołów Podlaski",
	    "Sokółka",
	    "Solec Kujawski",
	    "Sompolno",
	    "Sopot",
	    "Sosnowiec",
	    "Sośnicowice",
	    "Stalowa Wola",
	    "Starachowice",
	    "Stargard Szczeciński",
	    "Starogard Gdański",
	    "Stary Sącz",
	    "Staszów",
	    "Stawiski",
	    "Stawiszyn",
	    "Stąporków",
	    "Stęszew",
	    "Stoczek Łukowski",
	    "Stronie Śląskie",
	    "Strumień",
	    "Stryków",
	    "Strzegom",
	    "Strzelce Krajeńskie",
	    "Strzelce Opolskie",
	    "Strzelin",
	    "Strzelno",
	    "Strzyżów",
	    "Sucha Beskidzka",
	    "Suchań",
	    "Suchedniów",
	    "Suchowola",
	    "Sulechów",
	    "Sulejów",
	    "Sulejówek",
	    "Sulęcin",
	    "Sulmierzyce",
	    "Sułkowice",
	    "Supraśl",
	    "Suraż",
	    "Susz",
	    "Suwałki",
	    "Swarzędz",
	    "Syców",
	    "Szadek",
	    "Szamocin",
	    "Szamotuły",
	    "Szczawnica",
	    "Szczawno-Zdrój",
	    "Szczebrzeszyn",
	    "Szczecin",
	    "Szczecinek",
	    "Szczekociny",
	    "Szczucin",
	    "Szczuczyn",
	    "Szczyrk",
	    "Szczytna",
	    "Szczytno",
	    "Szepietowo",
	    "Szklarska Poręba",
	    "Szlichtyngowa",
	    "Szprotawa",
	    "Sztum",
	    "Szubin",
	    "Szydłowiec",
	    "Ścinawa",
	    "Ślesin",
	    "Śmigiel",
	    "Śrem",
	    "Środa Śląska",
	    "Środa Wielkopolska",
	    "Świątniki Górne",
	    "Świdnica",
	    "Świdnik",
	    "Świdwin",
	    "Świebodzice",
	    "Świebodzin",
	    "Świecie",
	    "Świeradów-Zdrój",
	    "Świerzawa",
	    "Świętochłowice",
	    "Świnoujście",
	    "Tarczyn",
	    "Tarnobrzeg",
	    "Tarnogród",
	    "Tarnowskie Góry",
	    "Tarnów",
	    "Tczew",
	    "Terespol",
	    "Tłuszcz",
	    "Tolkmicko",
	    "Tomaszów Lubelski",
	    "Tomaszów Mazowiecki",
	    "Toruń",
	    "Torzym",
	    "Toszek",
	    "Trzcianka",
	    "Trzciel",
	    "Trzcińsko-Zdrój",
	    "Trzebiatów",
	    "Trzebinia",
	    "Trzebnica",
	    "Trzemeszno",
	    "Tuchola",
	    "Tuchów",
	    "Tuczno",
	    "Tuliszków",
	    "Turek",
	    "Tuszyn",
	    "Twardogóra",
	    "Tychowo",
	    "Tychy",
	    "Tyczyn",
	    "Tykocin",
	    "Tyszowce",
	    "Ujazd",
	    "Ujście",
	    "Ulanów",
	    "Uniejów",
	    "Ustka",
	    "Ustroń",
	    "Ustrzyki Dolne",
	    "Wadowice",
	    "Wałbrzych",
	    "Wałcz",
	    "Warka",
	    "Warszawa",
	    "Warta",
	    "Wasilków",
	    "Wąbrzeźno",
	    "Wąchock",
	    "Wągrowiec",
	    "Wąsosz",
	    "Wejherowo",
	    "Węgliniec",
	    "Węgorzewo",
	    "Węgorzyno",
	    "Węgrów",
	    "Wiązów",
	    "Wieleń",
	    "Wielichowo",
	    "Wieliczka",
	    "Wieluń",
	    "Wieruszów",
	    "Więcbork",
	    "Wilamowice",
	    "Wisła",
	    "Witkowo",
	    "Witnica",
	    "Wleń",
	    "Władysławowo",
	    "Włocławek",
	    "Włodawa",
	    "Włoszczowa",
	    "Wodzisław Śląski",
	    "Wojcieszów",
	    "Wojkowice",
	    "Wojnicz",
	    "Wolbórz",
	    "Wolbrom",
	    "Wolin",
	    "Wolsztyn",
	    "Wołczyn",
	    "Wołomin",
	    "Wołów",
	    "Woźniki",
	    "Wrocław",
	    "Wronki",
	    "Września",
	    "Wschowa",
	    "Wyrzysk",
	    "Wysoka",
	    "Wysokie Mazowieckie",
	    "Wyszków",
	    "Wyszogród",
	    "Wyśmierzyce",
	    "Zabłudów",
	    "Zabrze",
	    "Zagórów",
	    "Zagórz",
	    "Zakliczyn",
	    "Zakopane",
	    "Zakroczym",
	    "Zalewo",
	    "Zambrów",
	    "Zamość",
	    "Zator",
	    "Zawadzkie",
	    "Zawichost",
	    "Zawidów",
	    "Zawiercie",
	    "Ząbki",
	    "Ząbkowice Śląskie",
	    "Zbąszynek",
	    "Zbąszyń",
	    "Zduny",
	    "Zduńska Wola",
	    "Zdzieszowice",
	    "Zelów",
	    "Zgierz",
	    "Zgorzelec",
	    "Zielona Góra",
	    "Zielonka",
	    "Ziębice",
	    "Złocieniec",
	    "Złoczew",
	    "Złotoryja",
	    "Złotów",
	    "Złoty Stok",
	    "Zwierzyniec",
	    "Zwoleń",
	    "Żabno",
	    "Żagań",
	    "Żarki",
	    "Żarów",
	    "Żary",
	    "Żelechów",
	    "Żerków",
	    "Żmigród",
	    "Żnin",
	    "Żory",
	    "Żukowo",
	    "Żuromin",
	    "Żychlin",
	    "Żyrardów",
	    "Żywiec"
	  ],
	  "city": [
	    "#{city_name}"
	  ],
	  "street_name": [
	    "#{street_prefix} #{Name.last_name}"
	  ],
	  "street_address": [
	    "#{street_name} #{building_number}"
	  ],
	  "default_country": [
	    "Polska"
	  ]
	};
	pl.company = {
	  "suffix": [
	    "Inc",
	    "and Sons",
	    "LLC",
	    "Group"
	  ],
	  "adjetive": [
	      "Adaptive",
	      "Advanced",
	      "Ameliorated",
	      "Assimilated",
	      "Automated",
	      "Balanced",
	      "Business-focused",
	      "Centralized",
	      "Cloned",
	      "Compatible",
	      "Configurable",
	      "Cross-group",
	      "Cross-platform",
	      "Customer-focused",
	      "Customizable",
	      "Decentralized",
	      "De-engineered",
	      "Devolved",
	      "Digitized",
	      "Distributed",
	      "Diverse",
	      "Down-sized",
	      "Enhanced",
	      "Enterprise-wide",
	      "Ergonomic",
	      "Exclusive",
	      "Expanded",
	      "Extended",
	      "Face to face",
	      "Focused",
	      "Front-line",
	      "Fully-configurable",
	      "Function-based",
	      "Fundamental",
	      "Future-proofed",
	      "Grass-roots",
	      "Horizontal",
	      "Implemented",
	      "Innovative",
	      "Integrated",
	      "Intuitive",
	      "Inverse",
	      "Managed",
	      "Mandatory",
	      "Monitored",
	      "Multi-channelled",
	      "Multi-lateral",
	      "Multi-layered",
	      "Multi-tiered",
	      "Networked",
	      "Object-based",
	      "Open-architected",
	      "Open-source",
	      "Operative",
	      "Optimized",
	      "Optional",
	      "Organic",
	      "Organized",
	      "Persevering",
	      "Persistent",
	      "Phased",
	      "Polarised",
	      "Pre-emptive",
	      "Proactive",
	      "Profit-focused",
	      "Profound",
	      "Programmable",
	      "Progressive",
	      "Public-key",
	      "Quality-focused",
	      "Reactive",
	      "Realigned",
	      "Re-contextualized",
	      "Re-engineered",
	      "Reduced",
	      "Reverse-engineered",
	      "Right-sized",
	      "Robust",
	      "Seamless",
	      "Secured",
	      "Self-enabling",
	      "Sharable",
	      "Stand-alone",
	      "Streamlined",
	      "Switchable",
	      "Synchronised",
	      "Synergistic",
	      "Synergized",
	      "Team-oriented",
	      "Total",
	      "Triple-buffered",
	      "Universal",
	      "Up-sized",
	      "Upgradable",
	      "User-centric",
	      "User-friendly",
	      "Versatile",
	      "Virtual",
	      "Visionary",
	      "Vision-oriented"
	    ],
	    "descriptor":[
	      "24 hour",
	      "24/7",
	      "3rd generation",
	      "4th generation",
	      "5th generation",
	      "6th generation",
	      "actuating",
	      "analyzing",
	      "asymmetric",
	      "asynchronous",
	      "attitude-oriented",
	      "background",
	      "bandwidth-monitored",
	      "bi-directional",
	      "bifurcated",
	      "bottom-line",
	      "clear-thinking",
	      "client-driven",
	      "client-server",
	      "coherent",
	      "cohesive",
	      "composite",
	      "context-sensitive",
	      "contextually-based",
	      "content-based",
	      "dedicated",
	      "demand-driven",
	      "didactic",
	      "directional",
	      "discrete",
	      "disintermediate",
	      "dynamic",
	      "eco-centric",
	      "empowering",
	      "encompassing",
	      "even-keeled",
	      "executive",
	      "explicit",
	      "exuding",
	      "fault-tolerant",
	      "foreground",
	      "fresh-thinking",
	      "full-range",
	      "global",
	      "grid-enabled",
	      "heuristic",
	      "high-level",
	      "holistic",
	      "homogeneous",
	      "human-resource",
	      "hybrid",
	      "impactful",
	      "incremental",
	      "intangible",
	      "interactive",
	      "intermediate",
	      "leading edge",
	      "local",
	      "logistical",
	      "maximized",
	      "methodical",
	      "mission-critical",
	      "mobile",
	      "modular",
	      "motivating",
	      "multimedia",
	      "multi-state",
	      "multi-tasking",
	      "national",
	      "needs-based",
	      "neutral",
	      "next generation",
	      "non-volatile",
	      "object-oriented",
	      "optimal",
	      "optimizing",
	      "radical",
	      "real-time",
	      "reciprocal",
	      "regional",
	      "responsive",
	      "scalable",
	      "secondary",
	      "solution-oriented",
	      "stable",
	      "static",
	      "systematic",
	      "systemic",
	      "system-worthy",
	      "tangible",
	      "tertiary",
	      "transitional",
	      "uniform",
	      "upward-trending",
	      "user-facing",
	      "value-added",
	      "web-enabled",
	      "well-modulated",
	      "zero administration",
	      "zero defect",
	      "zero tolerance"
	    ],
	    "noun": [
	      "ability",
	      "access",
	      "adapter",
	      "algorithm",
	      "alliance",
	      "analyzer",
	      "application",
	      "approach",
	      "architecture",
	      "archive",
	      "artificial intelligence",
	      "array",
	      "attitude",
	      "benchmark",
	      "budgetary management",
	      "capability",
	      "capacity",
	      "challenge",
	      "circuit",
	      "collaboration",
	      "complexity",
	      "concept",
	      "conglomeration",
	      "contingency",
	      "core",
	      "customer loyalty",
	      "database",
	      "data-warehouse",
	      "definition",
	      "emulation",
	      "encoding",
	      "encryption",
	      "extranet",
	      "firmware",
	      "flexibility",
	      "focus group",
	      "forecast",
	      "frame",
	      "framework",
	      "function",
	      "functionalities",
	      "Graphic Interface",
	      "groupware",
	      "Graphical User Interface",
	      "hardware",
	      "help-desk",
	      "hierarchy",
	      "hub",
	      "implementation",
	      "info-mediaries",
	      "infrastructure",
	      "initiative",
	      "installation",
	      "instruction set",
	      "interface",
	      "internet solution",
	      "intranet",
	      "knowledge user",
	      "knowledge base",
	      "local area network",
	      "leverage",
	      "matrices",
	      "matrix",
	      "methodology",
	      "middleware",
	      "migration",
	      "model",
	      "moderator",
	      "monitoring",
	      "moratorium",
	      "neural-net",
	      "open architecture",
	      "open system",
	      "orchestration",
	      "paradigm",
	      "parallelism",
	      "policy",
	      "portal",
	      "pricing structure",
	      "process improvement",
	      "product",
	      "productivity",
	      "project",
	      "projection",
	      "protocol",
	      "secured line",
	      "service-desk",
	      "software",
	      "solution",
	      "standardization",
	      "strategy",
	      "structure",
	      "success",
	      "superstructure",
	      "support",
	      "synergy",
	      "system engine",
	      "task-force",
	      "throughput",
	      "time-frame",
	      "toolset",
	      "utilisation",
	      "website",
	      "workforce"
	  ],
	  "bs_verb": [
	      "implement",
	      "utilize",
	      "integrate",
	      "streamline",
	      "optimize",
	      "evolve",
	      "transform",
	      "embrace",
	      "enable",
	      "orchestrate",
	      "leverage",
	      "reinvent",
	      "aggregate",
	      "architect",
	      "enhance",
	      "incentivize",
	      "morph",
	      "empower",
	      "envisioneer",
	      "monetize",
	      "harness",
	      "facilitate",
	      "seize",
	      "disintermediate",
	      "synergize",
	      "strategize",
	      "deploy",
	      "brand",
	      "grow",
	      "target",
	      "syndicate",
	      "synthesize",
	      "deliver",
	      "mesh",
	      "incubate",
	      "engage",
	      "maximize",
	      "benchmark",
	      "expedite",
	      "reintermediate",
	      "whiteboard",
	      "visualize",
	      "repurpose",
	      "innovate",
	      "scale",
	      "unleash",
	      "drive",
	      "extend",
	      "engineer",
	      "revolutionize",
	      "generate",
	      "exploit",
	      "transition",
	      "e-enable",
	      "iterate",
	      "cultivate",
	      "matrix",
	      "productize",
	      "redefine",
	      "recontextualize"
	    ],
	    "bs_adjective": [
	      "clicks-and-mortar",
	      "value-added",
	      "vertical",
	      "proactive",
	      "robust",
	      "revolutionary",
	      "scalable",
	      "leading-edge",
	      "innovative",
	      "intuitive",
	      "strategic",
	      "e-business",
	      "mission-critical",
	      "sticky",
	      "one-to-one",
	      "24/7",
	      "end-to-end",
	      "global",
	      "B2B",
	      "B2C",
	      "granular",
	      "frictionless",
	      "virtual",
	      "viral",
	      "dynamic",
	      "24/365",
	      "best-of-breed",
	      "killer",
	      "magnetic",
	      "bleeding-edge",
	      "web-enabled",
	      "interactive",
	      "dot-com",
	      "sexy",
	      "back-end",
	      "real-time",
	      "efficient",
	      "front-end",
	      "distributed",
	      "seamless",
	      "extensible",
	      "turn-key",
	      "world-class",
	      "open-source",
	      "cross-platform",
	      "cross-media",
	      "synergistic",
	      "bricks-and-clicks",
	      "out-of-the-box",
	      "enterprise",
	      "integrated",
	      "impactful",
	      "wireless",
	      "transparent",
	      "next-generation",
	      "cutting-edge",
	      "user-centric",
	      "visionary",
	      "customized",
	      "ubiquitous",
	      "plug-and-play",
	      "collaborative",
	      "compelling",
	      "holistic",
	      "rich"
	    ],
	    "bs_noun": [
	      "synergies",
	      "web-readiness",
	      "paradigms",
	      "markets",
	      "partnerships",
	      "infrastructures",
	      "platforms",
	      "initiatives",
	      "channels",
	      "eyeballs",
	      "communities",
	      "ROI",
	      "solutions",
	      "e-tailers",
	      "e-services",
	      "action-items",
	      "portals",
	      "niches",
	      "technologies",
	      "content",
	      "vortals",
	      "supply-chains",
	      "convergence",
	      "relationships",
	      "architectures",
	      "interfaces",
	      "e-markets",
	      "e-commerce",
	      "systems",
	      "bandwidth",
	      "infomediaries",
	      "models",
	      "mindshare",
	      "deliverables",
	      "users",
	      "schemas",
	      "networks",
	      "applications",
	      "metrics",
	      "e-business",
	      "functionalities",
	      "experiences",
	      "web services",
	      "methodologies"
	  ],
	  "name": [
	    "#{Name.last_name} #{suffix}",
	    "#{Name.last_name}-#{Name.last_name}",
	    "#{Name.last_name}, #{Name.last_name} and #{Name.last_name}"
	  ]
	};
	pl.internet = {
	  "free_email": [
	    "gmail.com",
	    "yahoo.com",
	    "hotmail.com"
	  ],
	  "domain_suffix": [
	    "com",
	    "pl",
	    "com.pl",
	    "net",
	    "org"
	  ]
	};
	pl.lorem = {
	  "words": [
	    "alias",
	    "consequatur",
	    "aut",
	    "perferendis",
	    "sit",
	    "voluptatem",
	    "accusantium",
	    "doloremque",
	    "aperiam",
	    "eaque",
	    "ipsa",
	    "quae",
	    "ab",
	    "illo",
	    "inventore",
	    "veritatis",
	    "et",
	    "quasi",
	    "architecto",
	    "beatae",
	    "vitae",
	    "dicta",
	    "sunt",
	    "explicabo",
	    "aspernatur",
	    "aut",
	    "odit",
	    "aut",
	    "fugit",
	    "sed",
	    "quia",
	    "consequuntur",
	    "magni",
	    "dolores",
	    "eos",
	    "qui",
	    "ratione",
	    "voluptatem",
	    "sequi",
	    "nesciunt",
	    "neque",
	    "dolorem",
	    "ipsum",
	    "quia",
	    "dolor",
	    "sit",
	    "amet",
	    "consectetur",
	    "adipisci",
	    "velit",
	    "sed",
	    "quia",
	    "non",
	    "numquam",
	    "eius",
	    "modi",
	    "tempora",
	    "incidunt",
	    "ut",
	    "labore",
	    "et",
	    "dolore",
	    "magnam",
	    "aliquam",
	    "quaerat",
	    "voluptatem",
	    "ut",
	    "enim",
	    "ad",
	    "minima",
	    "veniam",
	    "quis",
	    "nostrum",
	    "exercitationem",
	    "ullam",
	    "corporis",
	    "nemo",
	    "enim",
	    "ipsam",
	    "voluptatem",
	    "quia",
	    "voluptas",
	    "sit",
	    "suscipit",
	    "laboriosam",
	    "nisi",
	    "ut",
	    "aliquid",
	    "ex",
	    "ea",
	    "commodi",
	    "consequatur",
	    "quis",
	    "autem",
	    "vel",
	    "eum",
	    "iure",
	    "reprehenderit",
	    "qui",
	    "in",
	    "ea",
	    "voluptate",
	    "velit",
	    "esse",
	    "quam",
	    "nihil",
	    "molestiae",
	    "et",
	    "iusto",
	    "odio",
	    "dignissimos",
	    "ducimus",
	    "qui",
	    "blanditiis",
	    "praesentium",
	    "laudantium",
	    "totam",
	    "rem",
	    "voluptatum",
	    "deleniti",
	    "atque",
	    "corrupti",
	    "quos",
	    "dolores",
	    "et",
	    "quas",
	    "molestias",
	    "excepturi",
	    "sint",
	    "occaecati",
	    "cupiditate",
	    "non",
	    "provident",
	    "sed",
	    "ut",
	    "perspiciatis",
	    "unde",
	    "omnis",
	    "iste",
	    "natus",
	    "error",
	    "similique",
	    "sunt",
	    "in",
	    "culpa",
	    "qui",
	    "officia",
	    "deserunt",
	    "mollitia",
	    "animi",
	    "id",
	    "est",
	    "laborum",
	    "et",
	    "dolorum",
	    "fuga",
	    "et",
	    "harum",
	    "quidem",
	    "rerum",
	    "facilis",
	    "est",
	    "et",
	    "expedita",
	    "distinctio",
	    "nam",
	    "libero",
	    "tempore",
	    "cum",
	    "soluta",
	    "nobis",
	    "est",
	    "eligendi",
	    "optio",
	    "cumque",
	    "nihil",
	    "impedit",
	    "quo",
	    "porro",
	    "quisquam",
	    "est",
	    "qui",
	    "minus",
	    "id",
	    "quod",
	    "maxime",
	    "placeat",
	    "facere",
	    "possimus",
	    "omnis",
	    "voluptas",
	    "assumenda",
	    "est",
	    "omnis",
	    "dolor",
	    "repellendus",
	    "temporibus",
	    "autem",
	    "quibusdam",
	    "et",
	    "aut",
	    "consequatur",
	    "vel",
	    "illum",
	    "qui",
	    "dolorem",
	    "eum",
	    "fugiat",
	    "quo",
	    "voluptas",
	    "nulla",
	    "pariatur",
	    "at",
	    "vero",
	    "eos",
	    "et",
	    "accusamus",
	    "officiis",
	    "debitis",
	    "aut",
	    "rerum",
	    "necessitatibus",
	    "saepe",
	    "eveniet",
	    "ut",
	    "et",
	    "voluptates",
	    "repudiandae",
	    "sint",
	    "et",
	    "molestiae",
	    "non",
	    "recusandae",
	    "itaque",
	    "earum",
	    "rerum",
	    "hic",
	    "tenetur",
	    "a",
	    "sapiente",
	    "delectus",
	    "ut",
	    "aut",
	    "reiciendis",
	    "voluptatibus",
	    "maiores",
	    "doloribus",
	    "asperiores",
	    "repellat"
	  ],
	  "supplemental": [
	    "abbas",
	    "abduco",
	    "abeo",
	    "abscido",
	    "absconditus",
	    "absens",
	    "absorbeo",
	    "absque",
	    "abstergo",
	    "absum",
	    "abundans",
	    "abutor",
	    "accedo",
	    "accendo",
	    "acceptus",
	    "accipio",
	    "accommodo",
	    "accusator",
	    "acer",
	    "acerbitas",
	    "acervus",
	    "acidus",
	    "acies",
	    "acquiro",
	    "acsi",
	    "adamo",
	    "adaugeo",
	    "addo",
	    "adduco",
	    "ademptio",
	    "adeo",
	    "adeptio",
	    "adfectus",
	    "adfero",
	    "adficio",
	    "adflicto",
	    "adhaero",
	    "adhuc",
	    "adicio",
	    "adimpleo",
	    "adinventitias",
	    "adipiscor",
	    "adiuvo",
	    "administratio",
	    "admiratio",
	    "admitto",
	    "admoneo",
	    "admoveo",
	    "adnuo",
	    "adopto",
	    "adsidue",
	    "adstringo",
	    "adsuesco",
	    "adsum",
	    "adulatio",
	    "adulescens",
	    "adultus",
	    "aduro",
	    "advenio",
	    "adversus",
	    "advoco",
	    "aedificium",
	    "aeger",
	    "aegre",
	    "aegrotatio",
	    "aegrus",
	    "aeneus",
	    "aequitas",
	    "aequus",
	    "aer",
	    "aestas",
	    "aestivus",
	    "aestus",
	    "aetas",
	    "aeternus",
	    "ager",
	    "aggero",
	    "aggredior",
	    "agnitio",
	    "agnosco",
	    "ago",
	    "ait",
	    "aiunt",
	    "alienus",
	    "alii",
	    "alioqui",
	    "aliqua",
	    "alius",
	    "allatus",
	    "alo",
	    "alter",
	    "altus",
	    "alveus",
	    "amaritudo",
	    "ambitus",
	    "ambulo",
	    "amicitia",
	    "amiculum",
	    "amissio",
	    "amita",
	    "amitto",
	    "amo",
	    "amor",
	    "amoveo",
	    "amplexus",
	    "amplitudo",
	    "amplus",
	    "ancilla",
	    "angelus",
	    "angulus",
	    "angustus",
	    "animadverto",
	    "animi",
	    "animus",
	    "annus",
	    "anser",
	    "ante",
	    "antea",
	    "antepono",
	    "antiquus",
	    "aperio",
	    "aperte",
	    "apostolus",
	    "apparatus",
	    "appello",
	    "appono",
	    "appositus",
	    "approbo",
	    "apto",
	    "aptus",
	    "apud",
	    "aqua",
	    "ara",
	    "aranea",
	    "arbitro",
	    "arbor",
	    "arbustum",
	    "arca",
	    "arceo",
	    "arcesso",
	    "arcus",
	    "argentum",
	    "argumentum",
	    "arguo",
	    "arma",
	    "armarium",
	    "armo",
	    "aro",
	    "ars",
	    "articulus",
	    "artificiose",
	    "arto",
	    "arx",
	    "ascisco",
	    "ascit",
	    "asper",
	    "aspicio",
	    "asporto",
	    "assentator",
	    "astrum",
	    "atavus",
	    "ater",
	    "atqui",
	    "atrocitas",
	    "atrox",
	    "attero",
	    "attollo",
	    "attonbitus",
	    "auctor",
	    "auctus",
	    "audacia",
	    "audax",
	    "audentia",
	    "audeo",
	    "audio",
	    "auditor",
	    "aufero",
	    "aureus",
	    "auris",
	    "aurum",
	    "aut",
	    "autem",
	    "autus",
	    "auxilium",
	    "avaritia",
	    "avarus",
	    "aveho",
	    "averto",
	    "avoco",
	    "baiulus",
	    "balbus",
	    "barba",
	    "bardus",
	    "basium",
	    "beatus",
	    "bellicus",
	    "bellum",
	    "bene",
	    "beneficium",
	    "benevolentia",
	    "benigne",
	    "bestia",
	    "bibo",
	    "bis",
	    "blandior",
	    "bonus",
	    "bos",
	    "brevis",
	    "cado",
	    "caecus",
	    "caelestis",
	    "caelum",
	    "calamitas",
	    "calcar",
	    "calco",
	    "calculus",
	    "callide",
	    "campana",
	    "candidus",
	    "canis",
	    "canonicus",
	    "canto",
	    "capillus",
	    "capio",
	    "capitulus",
	    "capto",
	    "caput",
	    "carbo",
	    "carcer",
	    "careo",
	    "caries",
	    "cariosus",
	    "caritas",
	    "carmen",
	    "carpo",
	    "carus",
	    "casso",
	    "caste",
	    "casus",
	    "catena",
	    "caterva",
	    "cattus",
	    "cauda",
	    "causa",
	    "caute",
	    "caveo",
	    "cavus",
	    "cedo",
	    "celebrer",
	    "celer",
	    "celo",
	    "cena",
	    "cenaculum",
	    "ceno",
	    "censura",
	    "centum",
	    "cerno",
	    "cernuus",
	    "certe",
	    "certo",
	    "certus",
	    "cervus",
	    "cetera",
	    "charisma",
	    "chirographum",
	    "cibo",
	    "cibus",
	    "cicuta",
	    "cilicium",
	    "cimentarius",
	    "ciminatio",
	    "cinis",
	    "circumvenio",
	    "cito",
	    "civis",
	    "civitas",
	    "clam",
	    "clamo",
	    "claro",
	    "clarus",
	    "claudeo",
	    "claustrum",
	    "clementia",
	    "clibanus",
	    "coadunatio",
	    "coaegresco",
	    "coepi",
	    "coerceo",
	    "cogito",
	    "cognatus",
	    "cognomen",
	    "cogo",
	    "cohaero",
	    "cohibeo",
	    "cohors",
	    "colligo",
	    "colloco",
	    "collum",
	    "colo",
	    "color",
	    "coma",
	    "combibo",
	    "comburo",
	    "comedo",
	    "comes",
	    "cometes",
	    "comis",
	    "comitatus",
	    "commemoro",
	    "comminor",
	    "commodo",
	    "communis",
	    "comparo",
	    "compello",
	    "complectus",
	    "compono",
	    "comprehendo",
	    "comptus",
	    "conatus",
	    "concedo",
	    "concido",
	    "conculco",
	    "condico",
	    "conduco",
	    "confero",
	    "confido",
	    "conforto",
	    "confugo",
	    "congregatio",
	    "conicio",
	    "coniecto",
	    "conitor",
	    "coniuratio",
	    "conor",
	    "conqueror",
	    "conscendo",
	    "conservo",
	    "considero",
	    "conspergo",
	    "constans",
	    "consuasor",
	    "contabesco",
	    "contego",
	    "contigo",
	    "contra",
	    "conturbo",
	    "conventus",
	    "convoco",
	    "copia",
	    "copiose",
	    "cornu",
	    "corona",
	    "corpus",
	    "correptius",
	    "corrigo",
	    "corroboro",
	    "corrumpo",
	    "coruscus",
	    "cotidie",
	    "crapula",
	    "cras",
	    "crastinus",
	    "creator",
	    "creber",
	    "crebro",
	    "credo",
	    "creo",
	    "creptio",
	    "crepusculum",
	    "cresco",
	    "creta",
	    "cribro",
	    "crinis",
	    "cruciamentum",
	    "crudelis",
	    "cruentus",
	    "crur",
	    "crustulum",
	    "crux",
	    "cubicularis",
	    "cubitum",
	    "cubo",
	    "cui",
	    "cuius",
	    "culpa",
	    "culpo",
	    "cultellus",
	    "cultura",
	    "cum",
	    "cunabula",
	    "cunae",
	    "cunctatio",
	    "cupiditas",
	    "cupio",
	    "cuppedia",
	    "cupressus",
	    "cur",
	    "cura",
	    "curatio",
	    "curia",
	    "curiositas",
	    "curis",
	    "curo",
	    "curriculum",
	    "currus",
	    "cursim",
	    "curso",
	    "cursus",
	    "curto",
	    "curtus",
	    "curvo",
	    "curvus",
	    "custodia",
	    "damnatio",
	    "damno",
	    "dapifer",
	    "debeo",
	    "debilito",
	    "decens",
	    "decerno",
	    "decet",
	    "decimus",
	    "decipio",
	    "decor",
	    "decretum",
	    "decumbo",
	    "dedecor",
	    "dedico",
	    "deduco",
	    "defaeco",
	    "defendo",
	    "defero",
	    "defessus",
	    "defetiscor",
	    "deficio",
	    "defigo",
	    "defleo",
	    "defluo",
	    "defungo",
	    "degenero",
	    "degero",
	    "degusto",
	    "deinde",
	    "delectatio",
	    "delego",
	    "deleo",
	    "delibero",
	    "delicate",
	    "delinquo",
	    "deludo",
	    "demens",
	    "demergo",
	    "demitto",
	    "demo",
	    "demonstro",
	    "demoror",
	    "demulceo",
	    "demum",
	    "denego",
	    "denique",
	    "dens",
	    "denuncio",
	    "denuo",
	    "deorsum",
	    "depereo",
	    "depono",
	    "depopulo",
	    "deporto",
	    "depraedor",
	    "deprecator",
	    "deprimo",
	    "depromo",
	    "depulso",
	    "deputo",
	    "derelinquo",
	    "derideo",
	    "deripio",
	    "desidero",
	    "desino",
	    "desipio",
	    "desolo",
	    "desparatus",
	    "despecto",
	    "despirmatio",
	    "infit",
	    "inflammatio",
	    "paens",
	    "patior",
	    "patria",
	    "patrocinor",
	    "patruus",
	    "pauci",
	    "paulatim",
	    "pauper",
	    "pax",
	    "peccatus",
	    "pecco",
	    "pecto",
	    "pectus",
	    "pecunia",
	    "pecus",
	    "peior",
	    "pel",
	    "ocer",
	    "socius",
	    "sodalitas",
	    "sol",
	    "soleo",
	    "solio",
	    "solitudo",
	    "solium",
	    "sollers",
	    "sollicito",
	    "solum",
	    "solus",
	    "solutio",
	    "solvo",
	    "somniculosus",
	    "somnus",
	    "sonitus",
	    "sono",
	    "sophismata",
	    "sopor",
	    "sordeo",
	    "sortitus",
	    "spargo",
	    "speciosus",
	    "spectaculum",
	    "speculum",
	    "sperno",
	    "spero",
	    "spes",
	    "spiculum",
	    "spiritus",
	    "spoliatio",
	    "sponte",
	    "stabilis",
	    "statim",
	    "statua",
	    "stella",
	    "stillicidium",
	    "stipes",
	    "stips",
	    "sto",
	    "strenuus",
	    "strues",
	    "studio",
	    "stultus",
	    "suadeo",
	    "suasoria",
	    "sub",
	    "subito",
	    "subiungo",
	    "sublime",
	    "subnecto",
	    "subseco",
	    "substantia",
	    "subvenio",
	    "succedo",
	    "succurro",
	    "sufficio",
	    "suffoco",
	    "suffragium",
	    "suggero",
	    "sui",
	    "sulum",
	    "sum",
	    "summa",
	    "summisse",
	    "summopere",
	    "sumo",
	    "sumptus",
	    "supellex",
	    "super",
	    "suppellex",
	    "supplanto",
	    "suppono",
	    "supra",
	    "surculus",
	    "surgo",
	    "sursum",
	    "suscipio",
	    "suspendo",
	    "sustineo",
	    "suus",
	    "synagoga",
	    "tabella",
	    "tabernus",
	    "tabesco",
	    "tabgo",
	    "tabula",
	    "taceo",
	    "tactus",
	    "taedium",
	    "talio",
	    "talis",
	    "talus",
	    "tam",
	    "tamdiu",
	    "tamen",
	    "tametsi",
	    "tamisium",
	    "tamquam",
	    "tandem",
	    "tantillus",
	    "tantum",
	    "tardus",
	    "tego",
	    "temeritas",
	    "temperantia",
	    "templum",
	    "temptatio",
	    "tempus",
	    "tenax",
	    "tendo",
	    "teneo",
	    "tener",
	    "tenuis",
	    "tenus",
	    "tepesco",
	    "tepidus",
	    "ter",
	    "terebro",
	    "teres",
	    "terga",
	    "tergeo",
	    "tergiversatio",
	    "tergo",
	    "tergum",
	    "termes",
	    "terminatio",
	    "tero",
	    "terra",
	    "terreo",
	    "territo",
	    "terror",
	    "tersus",
	    "tertius",
	    "testimonium",
	    "texo",
	    "textilis",
	    "textor",
	    "textus",
	    "thalassinus",
	    "theatrum",
	    "theca",
	    "thema",
	    "theologus",
	    "thermae",
	    "thesaurus",
	    "thesis",
	    "thorax",
	    "thymbra",
	    "thymum",
	    "tibi",
	    "timidus",
	    "timor",
	    "titulus",
	    "tolero",
	    "tollo",
	    "tondeo",
	    "tonsor",
	    "torqueo",
	    "torrens",
	    "tot",
	    "totidem",
	    "toties",
	    "totus",
	    "tracto",
	    "trado",
	    "traho",
	    "trans",
	    "tredecim",
	    "tremo",
	    "trepide",
	    "tres",
	    "tribuo",
	    "tricesimus",
	    "triduana",
	    "triginta",
	    "tripudio",
	    "tristis",
	    "triumphus",
	    "trucido",
	    "truculenter",
	    "tubineus",
	    "tui",
	    "tum",
	    "tumultus",
	    "tunc",
	    "turba",
	    "turbo",
	    "turpe",
	    "turpis",
	    "tutamen",
	    "tutis",
	    "tyrannus",
	    "uberrime",
	    "ubi",
	    "ulciscor",
	    "ullus",
	    "ulterius",
	    "ultio",
	    "ultra",
	    "umbra",
	    "umerus",
	    "umquam",
	    "una",
	    "unde",
	    "undique",
	    "universe",
	    "unus",
	    "urbanus",
	    "urbs",
	    "uredo",
	    "usitas",
	    "usque",
	    "ustilo",
	    "ustulo",
	    "usus",
	    "uter",
	    "uterque",
	    "utilis",
	    "utique",
	    "utor",
	    "utpote",
	    "utrimque",
	    "utroque",
	    "utrum",
	    "uxor",
	    "vaco",
	    "vacuus",
	    "vado",
	    "vae",
	    "valde",
	    "valens",
	    "valeo",
	    "valetudo",
	    "validus",
	    "vallum",
	    "vapulus",
	    "varietas",
	    "varius",
	    "vehemens",
	    "vel",
	    "velociter",
	    "velum",
	    "velut",
	    "venia",
	    "venio",
	    "ventito",
	    "ventosus",
	    "ventus",
	    "venustas",
	    "ver",
	    "verbera",
	    "verbum",
	    "vere",
	    "verecundia",
	    "vereor",
	    "vergo",
	    "veritas",
	    "vero",
	    "versus",
	    "verto",
	    "verumtamen",
	    "verus",
	    "vesco",
	    "vesica",
	    "vesper",
	    "vespillo",
	    "vester",
	    "vestigium",
	    "vestrum",
	    "vetus",
	    "via",
	    "vicinus",
	    "vicissitudo",
	    "victoria",
	    "victus",
	    "videlicet",
	    "video",
	    "viduata",
	    "viduo",
	    "vigilo",
	    "vigor",
	    "vilicus",
	    "vilis",
	    "vilitas",
	    "villa",
	    "vinco",
	    "vinculum",
	    "vindico",
	    "vinitor",
	    "vinum",
	    "vir",
	    "virga",
	    "virgo",
	    "viridis",
	    "viriliter",
	    "virtus",
	    "vis",
	    "viscus",
	    "vita",
	    "vitiosus",
	    "vitium",
	    "vito",
	    "vivo",
	    "vix",
	    "vobis",
	    "vociferor",
	    "voco",
	    "volaticus",
	    "volo",
	    "volubilis",
	    "voluntarius",
	    "volup",
	    "volutabrum",
	    "volva",
	    "vomer",
	    "vomica",
	    "vomito",
	    "vorago",
	    "vorax",
	    "voro",
	    "vos",
	    "votum",
	    "voveo",
	    "vox",
	    "vulariter",
	    "vulgaris",
	    "vulgivagus",
	    "vulgo",
	    "vulgus",
	    "vulnero",
	    "vulnus",
	    "vulpes",
	    "vulticulus",
	    "vultuosus",
	    "xiphias"
	  ]
	};
	pl.phone_number = {
	  "formats": [
	    "12-###-##-##",
	    "13-###-##-##",
	    "14-###-##-##",
	    "15-###-##-##",
	    "16-###-##-##",
	    "17-###-##-##",
	    "18-###-##-##",
	    "22-###-##-##",
	    "23-###-##-##",
	    "24-###-##-##",
	    "25-###-##-##",
	    "29-###-##-##",
	    "32-###-##-##",
	    "33-###-##-##",
	    "34-###-##-##",
	    "41-###-##-##",
	    "42-###-##-##",
	    "43-###-##-##",
	    "44-###-##-##",
	    "46-###-##-##",
	    "48-###-##-##",
	    "52-###-##-##",
	    "54-###-##-##",
	    "55-###-##-##",
	    "56-###-##-##",
	    "58-###-##-##",
	    "59-###-##-##",
	    "61-###-##-##",
	    "62-###-##-##",
	    "63-###-##-##",
	    "65-###-##-##",
	    "67-###-##-##",
	    "68-###-##-##",
	    "71-###-##-##",
	    "74-###-##-##",
	    "75-###-##-##",
	    "76-###-##-##",
	    "77-###-##-##",
	    "81-###-##-##",
	    "82-###-##-##",
	    "83-###-##-##",
	    "84-###-##-##",
	    "85-###-##-##",
	    "86-###-##-##",
	    "87-###-##-##",
	    "89-###-##-##",
	    "91-###-##-##",
	    "94-###-##-##",
	    "95-###-##-##"
	  ]
	};
	pl.cell_phone = {
	  "formats": [
	    "50-###-##-##",
	    "51-###-##-##",
	    "53-###-##-##",
	    "57-###-##-##",
	    "60-###-##-##",
	    "66-###-##-##",
	    "69-###-##-##",
	    "72-###-##-##",
	    "73-###-##-##",
	    "78-###-##-##",
	    "79-###-##-##",
	    "88-###-##-##"
	  ]
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)(module)))

/***/ },
/* 314 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var pt_BR = {};
	module["exports"] = pt_BR;
	pt_BR.title = "Portuguese (Brazil)";
	pt_BR.address = {
	  "city_prefix": [
	    "Nova",
	    "Velha",
	    "Grande",
	    "Vila",
	    "Município de"
	  ],
	  "city_suffix": [
	    "do Descoberto",
	    "de Nossa Senhora",
	    "do Norte",
	    "do Sul"
	  ],
	  "country": [
	    "Afeganistão",
	    "Albânia",
	    "Algéria",
	    "Samoa",
	    "Andorra",
	    "Angola",
	    "Anguilla",
	    "Antigua and Barbada",
	    "Argentina",
	    "Armênia",
	    "Aruba",
	    "Austrália",
	    "Áustria",
	    "Alzerbajão",
	    "Bahamas",
	    "Barém",
	    "Bangladesh",
	    "Barbado",
	    "Belgrado",
	    "Bélgica",
	    "Belize",
	    "Benin",
	    "Bermuda",
	    "Bhutan",
	    "Bolívia",
	    "Bôsnia",
	    "Botuasuna",
	    "Bouvetoia",
	    "Brasil",
	    "Arquipélago de Chagos",
	    "Ilhas Virgens",
	    "Brunei",
	    "Bulgária",
	    "Burkina Faso",
	    "Burundi",
	    "Cambójia",
	    "Camarões",
	    "Canadá",
	    "Cabo Verde",
	    "Ilhas Caiman",
	    "República da África Central",
	    "Chad",
	    "Chile",
	    "China",
	    "Ilhas Natal",
	    "Ilhas Cocos",
	    "Colômbia",
	    "Comoros",
	    "Congo",
	    "Ilhas Cook",
	    "Costa Rica",
	    "Costa do Marfim",
	    "Croácia",
	    "Cuba",
	    "Cyprus",
	    "República Tcheca",
	    "Dinamarca",
	    "Djibouti",
	    "Dominica",
	    "República Dominicana",
	    "Equador",
	    "Egito",
	    "El Salvador",
	    "Guiné Equatorial",
	    "Eritrea",
	    "Estônia",
	    "Etiópia",
	    "Ilhas Faroe",
	    "Malvinas",
	    "Fiji",
	    "Finlândia",
	    "França",
	    "Guiné Francesa",
	    "Polinésia Francesa",
	    "Gabão",
	    "Gâmbia",
	    "Georgia",
	    "Alemanha",
	    "Gana",
	    "Gibraltar",
	    "Grécia",
	    "Groelândia",
	    "Granada",
	    "Guadalupe",
	    "Guano",
	    "Guatemala",
	    "Guernsey",
	    "Guiné",
	    "Guiné-Bissau",
	    "Guiana",
	    "Haiti",
	    "Heard Island and McDonald Islands",
	    "Vaticano",
	    "Honduras",
	    "Hong Kong",
	    "Hungria",
	    "Iceland",
	    "Índia",
	    "Indonésia",
	    "Irã",
	    "Iraque",
	    "Irlanda",
	    "Ilha de Man",
	    "Israel",
	    "Itália",
	    "Jamaica",
	    "Japão",
	    "Jersey",
	    "Jordânia",
	    "Cazaquistão",
	    "Quênia",
	    "Kiribati",
	    "Coreia do Norte",
	    "Coreia do Sul",
	    "Kuwait",
	    "Kyrgyz Republic",
	    "República Democrática de Lao People",
	    "Latvia",
	    "Líbano",
	    "Lesotho",
	    "Libéria",
	    "Libyan Arab Jamahiriya",
	    "Liechtenstein",
	    "Lituânia",
	    "Luxemburgo",
	    "Macao",
	    "Macedônia",
	    "Madagascar",
	    "Malawi",
	    "Malásia",
	    "Maldives",
	    "Mali",
	    "Malta",
	    "Ilhas Marshall",
	    "Martinica",
	    "Mauritânia",
	    "Mauritius",
	    "Mayotte",
	    "México",
	    "Micronésia",
	    "Moldova",
	    "Mônaco",
	    "Mongólia",
	    "Montenegro",
	    "Montserrat",
	    "Marrocos",
	    "Moçambique",
	    "Myanmar",
	    "Namibia",
	    "Nauru",
	    "Nepal",
	    "Antilhas Holandesas",
	    "Holanda",
	    "Nova Caledonia",
	    "Nova Zelândia",
	    "Nicarágua",
	    "Nigéria",
	    "Niue",
	    "Ilha Norfolk",
	    "Northern Mariana Islands",
	    "Noruega",
	    "Oman",
	    "Paquistão",
	    "Palau",
	    "Território da Palestina",
	    "Panamá",
	    "Nova Guiné Papua",
	    "Paraguai",
	    "Peru",
	    "Filipinas",
	    "Polônia",
	    "Portugal",
	    "Puerto Rico",
	    "Qatar",
	    "Romênia",
	    "Rússia",
	    "Ruanda",
	    "São Bartolomeu",
	    "Santa Helena",
	    "Santa Lúcia",
	    "Saint Martin",
	    "Saint Pierre and Miquelon",
	    "Saint Vincent and the Grenadines",
	    "Samoa",
	    "San Marino",
	    "Sao Tomé e Príncipe",
	    "Arábia Saudita",
	    "Senegal",
	    "Sérvia",
	    "Seychelles",
	    "Serra Leoa",
	    "Singapura",
	    "Eslováquia",
	    "Eslovênia",
	    "Ilhas Salomão",
	    "Somália",
	    "África do Sul",
	    "South Georgia and the South Sandwich Islands",
	    "Spanha",
	    "Sri Lanka",
	    "Sudão",
	    "Suriname",
	    "Svalbard & Jan Mayen Islands",
	    "Swaziland",
	    "Suécia",
	    "Suíça",
	    "Síria",
	    "Taiwan",
	    "Tajiquistão",
	    "Tanzânia",
	    "Tailândia",
	    "Timor-Leste",
	    "Togo",
	    "Tokelau",
	    "Tonga",
	    "Trinidá e Tobago",
	    "Tunísia",
	    "Turquia",
	    "Turcomenistão",
	    "Turks and Caicos Islands",
	    "Tuvalu",
	    "Uganda",
	    "Ucrânia",
	    "Emirados Árabes Unidos",
	    "Reino Unido",
	    "Estados Unidos da América",
	    "Estados Unidos das Ilhas Virgens",
	    "Uruguai",
	    "Uzbequistão",
	    "Vanuatu",
	    "Venezuela",
	    "Vietnã",
	    "Wallis and Futuna",
	    "Sahara",
	    "Yemen",
	    "Zâmbia",
	    "Zimbábue"
	  ],
	  "building_number": [
	    "#####",
	    "####",
	    "###"
	  ],
	  "street_suffix": [
	    "Rua",
	    "Avenida",
	    "Travessa",
	    "Ponte",
	    "Alameda",
	    "Marginal",
	    "Viela",
	    "Rodovia"
	  ],
	  "secondary_address": [
	    "Apto. ###",
	    "Sobrado ##",
	    "Casa #",
	    "Lote ##",
	    "Quadra ##"
	  ],
	  "postcode": [
	    "#####",
	    "#####-###"
	  ],
	  "state": [
	    "Acre",
	    "Alagoas",
	    "Amapá",
	    "Amazonas",
	    "Bahia",
	    "Ceará",
	    "Distrito Federal",
	    "Espírito Santo",
	    "Goiás",
	    "Maranhão",
	    "Mato Grosso",
	    "Mato Grosso do Sul",
	    "Minas Gerais",
	    "Pará",
	    "Paraíba",
	    "Paraná",
	    "Pernambuco",
	    "Piauí",
	    "Rio de Janeiro",
	    "Rio Grande do Norte",
	    "Rio Grande do Sul",
	    "Rondônia",
	    "Roraima",
	    "Santa Catarina",
	    "São Paulo",
	    "Sergipe",
	    "Tocantins"
	  ],
	  "state_abbr": [
	    "AC",
	    "AL",
	    "AP",
	    "AM",
	    "BA",
	    "CE",
	    "DF",
	    "ES",
	    "GO",
	    "MA",
	    "MT",
	    "MS",
	    "PA",
	    "PB",
	    "PR",
	    "PE",
	    "PI",
	    "RJ",
	    "RN",
	    "RS",
	    "RO",
	    "RR",
	    "SC",
	    "SP"
	  ],
	  "default_country": [
	    "Brasil"
	  ]
	};
	pt_BR.company = {
	  "suffix": [
	    "S.A.",
	    "LTDA",
	    "e Associados",
	    "Comércio"
	  ],
	  "name": [
	    "#{Name.last_name} #{suffix}",
	    "#{Name.last_name}-#{Name.last_name}",
	    "#{Name.last_name}, #{Name.last_name} e #{Name.last_name}"
	  ]
	};
	pt_BR.internet = {
	  "free_email": [
	    "gmail.com",
	    "yahoo.com",
	    "hotmail.com",
	    "live.com",
	    "bol.com.br"
	  ],
	  "domain_suffix": [
	    "br",
	    "com",
	    "biz",
	    "info",
	    "name",
	    "net",
	    "org"
	  ]
	};
	pt_BR.lorem = {
	  "words": [
	    "alias",
	    "consequatur",
	    "aut",
	    "perferendis",
	    "sit",
	    "voluptatem",
	    "accusantium",
	    "doloremque",
	    "aperiam",
	    "eaque",
	    "ipsa",
	    "quae",
	    "ab",
	    "illo",
	    "inventore",
	    "veritatis",
	    "et",
	    "quasi",
	    "architecto",
	    "beatae",
	    "vitae",
	    "dicta",
	    "sunt",
	    "explicabo",
	    "aspernatur",
	    "aut",
	    "odit",
	    "aut",
	    "fugit",
	    "sed",
	    "quia",
	    "consequuntur",
	    "magni",
	    "dolores",
	    "eos",
	    "qui",
	    "ratione",
	    "voluptatem",
	    "sequi",
	    "nesciunt",
	    "neque",
	    "dolorem",
	    "ipsum",
	    "quia",
	    "dolor",
	    "sit",
	    "amet",
	    "consectetur",
	    "adipisci",
	    "velit",
	    "sed",
	    "quia",
	    "non",
	    "numquam",
	    "eius",
	    "modi",
	    "tempora",
	    "incidunt",
	    "ut",
	    "labore",
	    "et",
	    "dolore",
	    "magnam",
	    "aliquam",
	    "quaerat",
	    "voluptatem",
	    "ut",
	    "enim",
	    "ad",
	    "minima",
	    "veniam",
	    "quis",
	    "nostrum",
	    "exercitationem",
	    "ullam",
	    "corporis",
	    "nemo",
	    "enim",
	    "ipsam",
	    "voluptatem",
	    "quia",
	    "voluptas",
	    "sit",
	    "suscipit",
	    "laboriosam",
	    "nisi",
	    "ut",
	    "aliquid",
	    "ex",
	    "ea",
	    "commodi",
	    "consequatur",
	    "quis",
	    "autem",
	    "vel",
	    "eum",
	    "iure",
	    "reprehenderit",
	    "qui",
	    "in",
	    "ea",
	    "voluptate",
	    "velit",
	    "esse",
	    "quam",
	    "nihil",
	    "molestiae",
	    "et",
	    "iusto",
	    "odio",
	    "dignissimos",
	    "ducimus",
	    "qui",
	    "blanditiis",
	    "praesentium",
	    "laudantium",
	    "totam",
	    "rem",
	    "voluptatum",
	    "deleniti",
	    "atque",
	    "corrupti",
	    "quos",
	    "dolores",
	    "et",
	    "quas",
	    "molestias",
	    "excepturi",
	    "sint",
	    "occaecati",
	    "cupiditate",
	    "non",
	    "provident",
	    "sed",
	    "ut",
	    "perspiciatis",
	    "unde",
	    "omnis",
	    "iste",
	    "natus",
	    "error",
	    "similique",
	    "sunt",
	    "in",
	    "culpa",
	    "qui",
	    "officia",
	    "deserunt",
	    "mollitia",
	    "animi",
	    "id",
	    "est",
	    "laborum",
	    "et",
	    "dolorum",
	    "fuga",
	    "et",
	    "harum",
	    "quidem",
	    "rerum",
	    "facilis",
	    "est",
	    "et",
	    "expedita",
	    "distinctio",
	    "nam",
	    "libero",
	    "tempore",
	    "cum",
	    "soluta",
	    "nobis",
	    "est",
	    "eligendi",
	    "optio",
	    "cumque",
	    "nihil",
	    "impedit",
	    "quo",
	    "porro",
	    "quisquam",
	    "est",
	    "qui",
	    "minus",
	    "id",
	    "quod",
	    "maxime",
	    "placeat",
	    "facere",
	    "possimus",
	    "omnis",
	    "voluptas",
	    "assumenda",
	    "est",
	    "omnis",
	    "dolor",
	    "repellendus",
	    "temporibus",
	    "autem",
	    "quibusdam",
	    "et",
	    "aut",
	    "consequatur",
	    "vel",
	    "illum",
	    "qui",
	    "dolorem",
	    "eum",
	    "fugiat",
	    "quo",
	    "voluptas",
	    "nulla",
	    "pariatur",
	    "at",
	    "vero",
	    "eos",
	    "et",
	    "accusamus",
	    "officiis",
	    "debitis",
	    "aut",
	    "rerum",
	    "necessitatibus",
	    "saepe",
	    "eveniet",
	    "ut",
	    "et",
	    "voluptates",
	    "repudiandae",
	    "sint",
	    "et",
	    "molestiae",
	    "non",
	    "recusandae",
	    "itaque",
	    "earum",
	    "rerum",
	    "hic",
	    "tenetur",
	    "a",
	    "sapiente",
	    "delectus",
	    "ut",
	    "aut",
	    "reiciendis",
	    "voluptatibus",
	    "maiores",
	    "doloribus",
	    "asperiores",
	    "repellat"
	  ]
	};
	pt_BR.name = {
	  "first_name": [
	    "Alessandro",
	    "Alessandra",
	    "Alexandre",
	    "Aline",
	    "Antônio",
	    "Breno",
	    "Bruna",
	    "Carlos",
	    "Carla",
	    "Célia",
	    "Cecília",
	    "César",
	    "Danilo",
	    "Dalila",
	    "Deneval",
	    "Eduardo",
	    "Eduarda",
	    "Esther",
	    "Elísio",
	    "Fábio",
	    "Fabrício",
	    "Fabrícia",
	    "Félix",
	    "Felícia",
	    "Feliciano",
	    "Frederico",
	    "Fabiano",
	    "Gustavo",
	    "Guilherme",
	    "Gúbio",
	    "Heitor",
	    "Hélio",
	    "Hugo",
	    "Isabel",
	    "Isabela",
	    "Ígor",
	    "João",
	    "Joana",
	    "Júlio César",
	    "Júlio",
	    "Júlia",
	    "Janaína",
	    "Karla",
	    "Kléber",
	    "Lucas",
	    "Lorena",
	    "Lorraine",
	    "Larissa",
	    "Ladislau",
	    "Marcos",
	    "Meire",
	    "Marcelo",
	    "Marcela",
	    "Margarida",
	    "Mércia",
	    "Márcia",
	    "Marli",
	    "Morgana",
	    "Maria",
	    "Norberto",
	    "Natália",
	    "Nataniel",
	    "Núbia",
	    "Ofélia",
	    "Paulo",
	    "Paula",
	    "Pablo",
	    "Pedro",
	    "Raul",
	    "Rafael",
	    "Rafaela",
	    "Ricardo",
	    "Roberto",
	    "Roberta",
	    "Sílvia",
	    "Sílvia",
	    "Silas",
	    "Suélen",
	    "Sara",
	    "Salvador",
	    "Sirineu",
	    "Talita",
	    "Tertuliano",
	    "Vicente",
	    "Víctor",
	    "Vitória",
	    "Yango",
	    "Yago",
	    "Yuri",
	    "Washington",
	    "Warley"
	  ],
	  "last_name": [
	    "Silva",
	    "Souza",
	    "Carvalho",
	    "Santos",
	    "Reis",
	    "Xavier",
	    "Franco",
	    "Braga",
	    "Macedo",
	    "Batista",
	    "Barros",
	    "Moraes",
	    "Costa",
	    "Pereira",
	    "Carvalho",
	    "Melo",
	    "Saraiva",
	    "Nogueira",
	    "Oliveira",
	    "Martins",
	    "Moreira",
	    "Albuquerque"
	  ],
	  "prefix": [
	    "Sr.",
	    "Sra.",
	    "Srta.",
	    "Dr."
	  ],
	  "suffix": [
	    "Jr.",
	    "Neto",
	    "Filho"
	  ]
	};
	pt_BR.phone_number = {
	  "formats": [
	    "(##) ####-####",
	    "+55 (##) ####-####",
	    "(##) #####-####"
	  ]
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)(module)))

/***/ },
/* 315 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var ru = {};
	module["exports"] = ru;
	ru.title = "Russian";
	ru.separator = " и ";
	ru.address = {
	  "country": [
	    "Австралия",
	    "Австрия",
	    "Азербайджан",
	    "Албания",
	    "Алжир",
	    "Американское Самоа (не признана)",
	    "Ангилья",
	    "Ангола",
	    "Андорра",
	    "Антарктика (не признана)",
	    "Антигуа и Барбуда",
	    "Антильские Острова (не признана)",
	    "Аомынь (не признана)",
	    "Аргентина",
	    "Армения",
	    "Афганистан",
	    "Багамские Острова",
	    "Бангладеш",
	    "Барбадос",
	    "Бахрейн",
	    "Беларусь",
	    "Белиз",
	    "Бельгия",
	    "Бенин",
	    "Болгария",
	    "Боливия",
	    "Босния и Герцеговина",
	    "Ботсвана",
	    "Бразилия",
	    "Бруней",
	    "Буркина-Фасо",
	    "Бурунди",
	    "Бутан",
	    "Вануату",
	    "Ватикан",
	    "Великобритания",
	    "Венгрия",
	    "Венесуэла",
	    "Восточный Тимор",
	    "Вьетнам",
	    "Габон",
	    "Гаити",
	    "Гайана",
	    "Гамбия",
	    "Гана",
	    "Гваделупа (не признана)",
	    "Гватемала",
	    "Гвиана (не признана)",
	    "Гвинея",
	    "Гвинея-Бисау",
	    "Германия",
	    "Гондурас",
	    "Гренада",
	    "Греция",
	    "Грузия",
	    "Дания",
	    "Джибути",
	    "Доминика",
	    "Доминиканская Республика",
	    "Египет",
	    "Замбия",
	    "Зимбабве",
	    "Израиль",
	    "Индия",
	    "Индонезия",
	    "Иордания",
	    "Ирак",
	    "Иран",
	    "Ирландия",
	    "Исландия",
	    "Испания",
	    "Италия",
	    "Йемен",
	    "Кабо-Верде",
	    "Казахстан",
	    "Камбоджа",
	    "Камерун",
	    "Канада",
	    "Катар",
	    "Кения",
	    "Кипр",
	    "Кирибати",
	    "Китай",
	    "Колумбия",
	    "Коморские Острова",
	    "Конго",
	    "Демократическая Республика",
	    "Корея (Северная)",
	    "Корея (Южная)",
	    "Косово",
	    "Коста-Рика",
	    "Кот-д'Ивуар",
	    "Куба",
	    "Кувейт",
	    "Кука острова",
	    "Кыргызстан",
	    "Лаос",
	    "Латвия",
	    "Лесото",
	    "Либерия",
	    "Ливан",
	    "Ливия",
	    "Литва",
	    "Лихтенштейн",
	    "Люксембург",
	    "Маврикий",
	    "Мавритания",
	    "Мадагаскар",
	    "Македония",
	    "Малави",
	    "Малайзия",
	    "Мали",
	    "Мальдивы",
	    "Мальта",
	    "Маршалловы Острова",
	    "Мексика",
	    "Микронезия",
	    "Мозамбик",
	    "Молдова",
	    "Монако",
	    "Монголия",
	    "Марокко",
	    "Мьянма",
	    "Намибия",
	    "Науру",
	    "Непал",
	    "Нигер",
	    "Нигерия",
	    "Нидерланды",
	    "Никарагуа",
	    "Новая Зеландия",
	    "Норвегия",
	    "Объединенные Арабские Эмираты",
	    "Оман",
	    "Пакистан",
	    "Палау",
	    "Панама",
	    "Папуа — Новая Гвинея",
	    "Парагвай",
	    "Перу",
	    "Польша",
	    "Португалия",
	    "Республика Конго",
	    "Россия",
	    "Руанда",
	    "Румыния",
	    "Сальвадор",
	    "Самоа",
	    "Сан-Марино",
	    "Сан-Томе и Принсипи",
	    "Саудовская Аравия",
	    "Свазиленд",
	    "Сейшельские острова",
	    "Сенегал",
	    "Сент-Винсент и Гренадины",
	    "Сент-Киттс и Невис",
	    "Сент-Люсия",
	    "Сербия",
	    "Сингапур",
	    "Сирия",
	    "Словакия",
	    "Словения",
	    "Соединенные Штаты Америки",
	    "Соломоновы Острова",
	    "Сомали",
	    "Судан",
	    "Суринам",
	    "Сьерра-Леоне",
	    "Таджикистан",
	    "Таиланд",
	    "Тайвань (не признана)",
	    "Тамил-Илам (не признана)",
	    "Танзания",
	    "Тёркс и Кайкос (не признана)",
	    "Того",
	    "Токелау (не признана)",
	    "Тонга",
	    "Тринидад и Тобаго",
	    "Тувалу",
	    "Тунис",
	    "Турецкая Республика Северного Кипра (не признана)",
	    "Туркменистан",
	    "Турция",
	    "Уганда",
	    "Узбекистан",
	    "Украина",
	    "Уругвай",
	    "Фарерские Острова (не признана)",
	    "Фиджи",
	    "Филиппины",
	    "Финляндия",
	    "Франция",
	    "Французская Полинезия (не признана)",
	    "Хорватия",
	    "Центральноафриканская Республика",
	    "Чад",
	    "Черногория",
	    "Чехия",
	    "Чили",
	    "Швейцария",
	    "Швеция",
	    "Шри-Ланка",
	    "Эквадор",
	    "Экваториальная Гвинея",
	    "Эритрея",
	    "Эстония",
	    "Эфиопия",
	    "Южно-Африканская Республика",
	    "Ямайка",
	    "Япония"
	  ],
	  "building_number": [
	    "###"
	  ],
	  "street_suffix": [
	    "ул.",
	    "улица",
	    "проспект",
	    "пр.",
	    "площадь",
	    "пл."
	  ],
	  "secondary_address": [
	    "кв. ###"
	  ],
	  "postcode": [
	    "######"
	  ],
	  "state": [
	    "Республика Адыгея",
	    "Республика Башкортостан",
	    "Республика Бурятия",
	    "Республика Алтай Республика Дагестан",
	    "Республика Ингушетия",
	    "Кабардино-Балкарская Республика",
	    "Республика Калмыкия",
	    "Республика Карачаево-Черкессия",
	    "Республика Карелия",
	    "Республика Коми",
	    "Республика Марий Эл",
	    "Республика Мордовия",
	    "Республика Саха (Якутия)",
	    "Республика Северная Осетия-Алания",
	    "Республика Татарстан",
	    "Республика Тыва",
	    "Удмуртская Республика",
	    "Республика Хакасия",
	    "Чувашская Республика",
	    "Алтайский край",
	    "Краснодарский край",
	    "Красноярский край",
	    "Приморский край",
	    "Ставропольский край",
	    "Хабаровский край",
	    "Амурская область",
	    "Архангельская область",
	    "Астраханская область",
	    "Белгородская область",
	    "Брянская область",
	    "Владимирская область",
	    "Волгоградская область",
	    "Вологодская область",
	    "Воронежская область",
	    "Ивановская область",
	    "Иркутская область",
	    "Калиниградская область",
	    "Калужская область",
	    "Камчатская область",
	    "Кемеровская область",
	    "Кировская область",
	    "Костромская область",
	    "Курганская область",
	    "Курская область",
	    "Ленинградская область",
	    "Липецкая область",
	    "Магаданская область",
	    "Московская область",
	    "Мурманская область",
	    "Нижегородская область",
	    "Новгородская область",
	    "Новосибирская область",
	    "Омская область",
	    "Оренбургская область",
	    "Орловская область",
	    "Пензенская область",
	    "Пермская область",
	    "Псковская область",
	    "Ростовская область",
	    "Рязанская область",
	    "Самарская область",
	    "Саратовская область",
	    "Сахалинская область",
	    "Свердловская область",
	    "Смоленская область",
	    "Тамбовская область",
	    "Тверская область",
	    "Томская область",
	    "Тульская область",
	    "Тюменская область",
	    "Ульяновская область",
	    "Челябинская область",
	    "Читинская область",
	    "Ярославская область",
	    "Еврейская автономная область",
	    "Агинский Бурятский авт. округ",
	    "Коми-Пермяцкий автономный округ",
	    "Корякский автономный округ",
	    "Ненецкий автономный округ",
	    "Таймырский (Долгано-Ненецкий) автономный округ",
	    "Усть-Ордынский Бурятский автономный округ",
	    "Ханты-Мансийский автономный округ",
	    "Чукотский автономный округ",
	    "Эвенкийский автономный округ",
	    "Ямало-Ненецкий автономный округ",
	    "Чеченская Республика"
	  ],
	  "street_title": [
	    "Советская",
	    "Молодежная",
	    "Центральная",
	    "Школьная",
	    "Новая",
	    "Садовая",
	    "Лесная",
	    "Набережная",
	    "Ленина",
	    "Мира",
	    "Октябрьская",
	    "Зеленая",
	    "Комсомольская",
	    "Заречная",
	    "Первомайская",
	    "Гагарина",
	    "Полевая",
	    "Луговая",
	    "Пионерская",
	    "Кирова",
	    "Юбилейная",
	    "Северная",
	    "Пролетарская",
	    "Степная",
	    "Пушкина",
	    "Калинина",
	    "Южная",
	    "Колхозная",
	    "Рабочая",
	    "Солнечная",
	    "Железнодорожная",
	    "Восточная",
	    "Заводская",
	    "Чапаева",
	    "Нагорная",
	    "Строителей",
	    "Береговая",
	    "Победы",
	    "Горького",
	    "Кооперативная",
	    "Красноармейская",
	    "Совхозная",
	    "Речная",
	    "Школьный",
	    "Спортивная",
	    "Озерная",
	    "Строительная",
	    "Парковая",
	    "Чкалова",
	    "Мичурина",
	    "речень улиц",
	    "Подгорная",
	    "Дружбы",
	    "Почтовая",
	    "Партизанская",
	    "Вокзальная",
	    "Лермонтова",
	    "Свободы",
	    "Дорожная",
	    "Дачная",
	    "Маяковского",
	    "Западная",
	    "Фрунзе",
	    "Дзержинского",
	    "Московская",
	    "Свердлова",
	    "Некрасова",
	    "Гоголя",
	    "Красная",
	    "Трудовая",
	    "Шоссейная",
	    "Чехова",
	    "Коммунистическая",
	    "Труда",
	    "Комарова",
	    "Матросова",
	    "Островского",
	    "Сосновая",
	    "Клубная",
	    "Куйбышева",
	    "Крупской",
	    "Березовая",
	    "Карла Маркса",
	    "8 Марта",
	    "Больничная",
	    "Садовый",
	    "Интернациональная",
	    "Суворова",
	    "Цветочная",
	    "Трактовая",
	    "Ломоносова",
	    "Горная",
	    "Космонавтов",
	    "Энергетиков",
	    "Шевченко",
	    "Весенняя",
	    "Механизаторов",
	    "Коммунальная",
	    "Лесной",
	    "40 лет Победы",
	    "Майская"
	  ],
	  "city_name": [
	    "Москва",
	    "Владимир",
	    "Санкт-Петербург",
	    "Новосибирск",
	    "Екатеринбург",
	    "Нижний Новгород",
	    "Самара",
	    "Казань",
	    "Омск",
	    "Челябинск",
	    "Ростов-на-Дону",
	    "Уфа",
	    "Волгоград",
	    "Пермь",
	    "Красноярск",
	    "Воронеж",
	    "Саратов",
	    "Краснодар",
	    "Тольятти",
	    "Ижевск",
	    "Барнаул",
	    "Ульяновск",
	    "Тюмень",
	    "Иркутск",
	    "Владивосток",
	    "Ярославль",
	    "Хабаровск",
	    "Махачкала",
	    "Оренбург",
	    "Новокузнецк",
	    "Томск",
	    "Кемерово",
	    "Рязань",
	    "Астрахань",
	    "Пенза",
	    "Липецк",
	    "Тула",
	    "Киров",
	    "Чебоксары",
	    "Курск",
	    "Брянскm Магнитогорск",
	    "Иваново",
	    "Тверь",
	    "Ставрополь",
	    "Белгород",
	    "Сочи"
	  ],
	  "city": [
	    "#{Address.city_name}"
	  ],
	  "street_name": [
	    "#{street_suffix} #{Address.street_title}",
	    "#{Address.street_title} #{street_suffix}"
	  ],
	  "street_address": [
	    "#{street_name}, #{building_number}"
	  ],
	  "default_country": [
	    "Россия"
	  ]
	};
	ru.internet = {
	  "free_email": [
	    "yandex.ru",
	    "ya.ru",
	    "mail.ru",
	    "gmail.com",
	    "yahoo.com",
	    "hotmail.com"
	  ],
	  "domain_suffix": [
	    "com",
	    "ru",
	    "info",
	    "рф",
	    "net",
	    "org"
	  ]
	};
	ru.name = {
	  "male_first_name": [
	    "Александр",
	    "Алексей",
	    "Альберт",
	    "Анатолий",
	    "Андрей",
	    "Антон",
	    "Аркадий",
	    "Арсений",
	    "Артём",
	    "Борис",
	    "Вадим",
	    "Валентин",
	    "Валерий",
	    "Василий",
	    "Виктор",
	    "Виталий",
	    "Владимир",
	    "Владислав",
	    "Вячеслав",
	    "Геннадий",
	    "Георгий",
	    "Герман",
	    "Григорий",
	    "Даниил",
	    "Денис",
	    "Дмитрий",
	    "Евгений",
	    "Егор",
	    "Иван",
	    "Игнатий",
	    "Игорь",
	    "Илья",
	    "Константин",
	    "Лаврентий",
	    "Леонид",
	    "Лука",
	    "Макар",
	    "Максим",
	    "Матвей",
	    "Михаил",
	    "Никита",
	    "Николай",
	    "Олег",
	    "Роман",
	    "Семён",
	    "Сергей",
	    "Станислав",
	    "Степан",
	    "Фёдор",
	    "Эдуард",
	    "Юрий",
	    "Ярослав"
	  ],
	  "male_middle_name": [
	    "Александрович",
	    "Алексеевич",
	    "Альбертович",
	    "Анатольевич",
	    "Андреевич",
	    "Антонович",
	    "Аркадьевич",
	    "Арсеньевич",
	    "Артёмович",
	    "Борисович",
	    "Вадимович",
	    "Валентинович",
	    "Валерьевич",
	    "Васильевич",
	    "Викторович",
	    "Витальевич",
	    "Владимирович",
	    "Владиславович",
	    "Вячеславович",
	    "Геннадьевич",
	    "Георгиевич",
	    "Германович",
	    "Григорьевич",
	    "Даниилович",
	    "Денисович",
	    "Дмитриевич",
	    "Евгеньевич",
	    "Егорович",
	    "Иванович",
	    "Игнатьевич",
	    "Игоревич",
	    "Ильич",
	    "Константинович",
	    "Лаврентьевич",
	    "Леонидович",
	    "Лукич",
	    "Макарович",
	    "Максимович",
	    "Матвеевич",
	    "Михайлович",
	    "Никитич",
	    "Николаевич",
	    "Олегович",
	    "Романович",
	    "Семёнович",
	    "Сергеевич",
	    "Станиславович",
	    "Степанович",
	    "Фёдорович",
	    "Эдуардович",
	    "Юрьевич",
	    "Ярославович"
	  ],
	  "male_last_name": [
	    "Смирнов",
	    "Иванов",
	    "Кузнецов",
	    "Попов",
	    "Соколов",
	    "Лебедев",
	    "Козлов",
	    "Новиков",
	    "Морозов",
	    "Петров",
	    "Волков",
	    "Соловьев",
	    "Васильев",
	    "Зайцев",
	    "Павлов",
	    "Семенов",
	    "Голубев",
	    "Виноградов",
	    "Богданов",
	    "Воробьев",
	    "Федоров",
	    "Михайлов",
	    "Беляев",
	    "Тарасов",
	    "Белов",
	    "Комаров",
	    "Орлов",
	    "Киселев",
	    "Макаров",
	    "Андреев",
	    "Ковалев",
	    "Ильин",
	    "Гусев",
	    "Титов",
	    "Кузьмин",
	    "Кудрявцев",
	    "Баранов",
	    "Куликов",
	    "Алексеев",
	    "Степанов",
	    "Яковлев",
	    "Сорокин",
	    "Сергеев",
	    "Романов",
	    "Захаров",
	    "Борисов",
	    "Королев",
	    "Герасимов",
	    "Пономарев",
	    "Григорьев",
	    "Лазарев",
	    "Медведев",
	    "Ершов",
	    "Никитин",
	    "Соболев",
	    "Рябов",
	    "Поляков",
	    "Цветков",
	    "Данилов",
	    "Жуков",
	    "Фролов",
	    "Журавлев",
	    "Николаев",
	    "Крылов",
	    "Максимов",
	    "Сидоров",
	    "Осипов",
	    "Белоусов",
	    "Федотов",
	    "Дорофеев",
	    "Егоров",
	    "Матвеев",
	    "Бобров",
	    "Дмитриев",
	    "Калинин",
	    "Анисимов",
	    "Петухов",
	    "Антонов",
	    "Тимофеев",
	    "Никифоров",
	    "Веселов",
	    "Филиппов",
	    "Марков",
	    "Большаков",
	    "Суханов",
	    "Миронов",
	    "Ширяев",
	    "Александров",
	    "Коновалов",
	    "Шестаков",
	    "Казаков",
	    "Ефимов",
	    "Денисов",
	    "Громов",
	    "Фомин",
	    "Давыдов",
	    "Мельников",
	    "Щербаков",
	    "Блинов",
	    "Колесников",
	    "Карпов",
	    "Афанасьев",
	    "Власов",
	    "Маслов",
	    "Исаков",
	    "Тихонов",
	    "Аксенов",
	    "Гаврилов",
	    "Родионов",
	    "Котов",
	    "Горбунов",
	    "Кудряшов",
	    "Быков",
	    "Зуев",
	    "Третьяков",
	    "Савельев",
	    "Панов",
	    "Рыбаков",
	    "Суворов",
	    "Абрамов",
	    "Воронов",
	    "Мухин",
	    "Архипов",
	    "Трофимов",
	    "Мартынов",
	    "Емельянов",
	    "Горшков",
	    "Чернов",
	    "Овчинников",
	    "Селезнев",
	    "Панфилов",
	    "Копылов",
	    "Михеев",
	    "Галкин",
	    "Назаров",
	    "Лобанов",
	    "Лукин",
	    "Беляков",
	    "Потапов",
	    "Некрасов",
	    "Хохлов",
	    "Жданов",
	    "Наумов",
	    "Шилов",
	    "Воронцов",
	    "Ермаков",
	    "Дроздов",
	    "Игнатьев",
	    "Савин",
	    "Логинов",
	    "Сафонов",
	    "Капустин",
	    "Кириллов",
	    "Моисеев",
	    "Елисеев",
	    "Кошелев",
	    "Костин",
	    "Горбачев",
	    "Орехов",
	    "Ефремов",
	    "Исаев",
	    "Евдокимов",
	    "Калашников",
	    "Кабанов",
	    "Носков",
	    "Юдин",
	    "Кулагин",
	    "Лапин",
	    "Прохоров",
	    "Нестеров",
	    "Харитонов",
	    "Агафонов",
	    "Муравьев",
	    "Ларионов",
	    "Федосеев",
	    "Зимин",
	    "Пахомов",
	    "Шубин",
	    "Игнатов",
	    "Филатов",
	    "Крюков",
	    "Рогов",
	    "Кулаков",
	    "Терентьев",
	    "Молчанов",
	    "Владимиров",
	    "Артемьев",
	    "Гурьев",
	    "Зиновьев",
	    "Гришин",
	    "Кононов",
	    "Дементьев",
	    "Ситников",
	    "Симонов",
	    "Мишин",
	    "Фадеев",
	    "Комиссаров",
	    "Мамонтов",
	    "Носов",
	    "Гуляев",
	    "Шаров",
	    "Устинов",
	    "Вишняков",
	    "Евсеев",
	    "Лаврентьев",
	    "Брагин",
	    "Константинов",
	    "Корнилов",
	    "Авдеев",
	    "Зыков",
	    "Бирюков",
	    "Шарапов",
	    "Никонов",
	    "Щукин",
	    "Дьячков",
	    "Одинцов",
	    "Сазонов",
	    "Якушев",
	    "Красильников",
	    "Гордеев",
	    "Самойлов",
	    "Князев",
	    "Беспалов",
	    "Уваров",
	    "Шашков",
	    "Бобылев",
	    "Доронин",
	    "Белозеров",
	    "Рожков",
	    "Самсонов",
	    "Мясников",
	    "Лихачев",
	    "Буров",
	    "Сысоев",
	    "Фомичев",
	    "Русаков",
	    "Стрелков",
	    "Гущин",
	    "Тетерин",
	    "Колобов",
	    "Субботин",
	    "Фокин",
	    "Блохин",
	    "Селиверстов",
	    "Пестов",
	    "Кондратьев",
	    "Силин",
	    "Меркушев",
	    "Лыткин",
	    "Туров"
	  ],
	  "female_first_name": [
	    "Анна",
	    "Алёна",
	    "Алевтина",
	    "Александра",
	    "Алина",
	    "Алла",
	    "Анастасия",
	    "Ангелина",
	    "Анжела",
	    "Анжелика",
	    "Антонида",
	    "Антонина",
	    "Анфиса",
	    "Арина",
	    "Валентина",
	    "Валерия",
	    "Варвара",
	    "Василиса",
	    "Вера",
	    "Вероника",
	    "Виктория",
	    "Галина",
	    "Дарья",
	    "Евгения",
	    "Екатерина",
	    "Елена",
	    "Елизавета",
	    "Жанна",
	    "Зинаида",
	    "Зоя",
	    "Ирина",
	    "Кира",
	    "Клавдия",
	    "Ксения",
	    "Лариса",
	    "Лидия",
	    "Любовь",
	    "Людмила",
	    "Маргарита",
	    "Марина",
	    "Мария",
	    "Надежда",
	    "Наталья",
	    "Нина",
	    "Оксана",
	    "Ольга",
	    "Раиса",
	    "Регина",
	    "Римма",
	    "Светлана",
	    "София",
	    "Таисия",
	    "Тамара",
	    "Татьяна",
	    "Ульяна",
	    "Юлия"
	  ],
	  "female_middle_name": [
	    "Александровна",
	    "Алексеевна",
	    "Альбертовна",
	    "Анатольевна",
	    "Андреевна",
	    "Антоновна",
	    "Аркадьевна",
	    "Арсеньевна",
	    "Артёмовна",
	    "Борисовна",
	    "Вадимовна",
	    "Валентиновна",
	    "Валерьевна",
	    "Васильевна",
	    "Викторовна",
	    "Витальевна",
	    "Владимировна",
	    "Владиславовна",
	    "Вячеславовна",
	    "Геннадьевна",
	    "Георгиевна",
	    "Германовна",
	    "Григорьевна",
	    "Данииловна",
	    "Денисовна",
	    "Дмитриевна",
	    "Евгеньевна",
	    "Егоровна",
	    "Ивановна",
	    "Игнатьевна",
	    "Игоревна",
	    "Ильинична",
	    "Константиновна",
	    "Лаврентьевна",
	    "Леонидовна",
	    "Макаровна",
	    "Максимовна",
	    "Матвеевна",
	    "Михайловна",
	    "Никитична",
	    "Николаевна",
	    "Олеговна",
	    "Романовна",
	    "Семёновна",
	    "Сергеевна",
	    "Станиславовна",
	    "Степановна",
	    "Фёдоровна",
	    "Эдуардовна",
	    "Юрьевна",
	    "Ярославовна"
	  ],
	  "female_last_name": [
	    "Смирнова",
	    "Иванова",
	    "Кузнецова",
	    "Попова",
	    "Соколова",
	    "Лебедева",
	    "Козлова",
	    "Новикова",
	    "Морозова",
	    "Петрова",
	    "Волкова",
	    "Соловьева",
	    "Васильева",
	    "Зайцева",
	    "Павлова",
	    "Семенова",
	    "Голубева",
	    "Виноградова",
	    "Богданова",
	    "Воробьева",
	    "Федорова",
	    "Михайлова",
	    "Беляева",
	    "Тарасова",
	    "Белова",
	    "Комарова",
	    "Орлова",
	    "Киселева",
	    "Макарова",
	    "Андреева",
	    "Ковалева",
	    "Ильина",
	    "Гусева",
	    "Титова",
	    "Кузьмина",
	    "Кудрявцева",
	    "Баранова",
	    "Куликова",
	    "Алексеева",
	    "Степанова",
	    "Яковлева",
	    "Сорокина",
	    "Сергеева",
	    "Романова",
	    "Захарова",
	    "Борисова",
	    "Королева",
	    "Герасимова",
	    "Пономарева",
	    "Григорьева",
	    "Лазарева",
	    "Медведева",
	    "Ершова",
	    "Никитина",
	    "Соболева",
	    "Рябова",
	    "Полякова",
	    "Цветкова",
	    "Данилова",
	    "Жукова",
	    "Фролова",
	    "Журавлева",
	    "Николаева",
	    "Крылова",
	    "Максимова",
	    "Сидорова",
	    "Осипова",
	    "Белоусова",
	    "Федотова",
	    "Дорофеева",
	    "Егорова",
	    "Матвеева",
	    "Боброва",
	    "Дмитриева",
	    "Калинина",
	    "Анисимова",
	    "Петухова",
	    "Антонова",
	    "Тимофеева",
	    "Никифорова",
	    "Веселова",
	    "Филиппова",
	    "Маркова",
	    "Большакова",
	    "Суханова",
	    "Миронова",
	    "Ширяева",
	    "Александрова",
	    "Коновалова",
	    "Шестакова",
	    "Казакова",
	    "Ефимова",
	    "Денисова",
	    "Громова",
	    "Фомина",
	    "Давыдова",
	    "Мельникова",
	    "Щербакова",
	    "Блинова",
	    "Колесникова",
	    "Карпова",
	    "Афанасьева",
	    "Власова",
	    "Маслова",
	    "Исакова",
	    "Тихонова",
	    "Аксенова",
	    "Гаврилова",
	    "Родионова",
	    "Котова",
	    "Горбунова",
	    "Кудряшова",
	    "Быкова",
	    "Зуева",
	    "Третьякова",
	    "Савельева",
	    "Панова",
	    "Рыбакова",
	    "Суворова",
	    "Абрамова",
	    "Воронова",
	    "Мухина",
	    "Архипова",
	    "Трофимова",
	    "Мартынова",
	    "Емельянова",
	    "Горшкова",
	    "Чернова",
	    "Овчинникова",
	    "Селезнева",
	    "Панфилова",
	    "Копылова",
	    "Михеева",
	    "Галкина",
	    "Назарова",
	    "Лобанова",
	    "Лукина",
	    "Белякова",
	    "Потапова",
	    "Некрасова",
	    "Хохлова",
	    "Жданова",
	    "Наумова",
	    "Шилова",
	    "Воронцова",
	    "Ермакова",
	    "Дроздова",
	    "Игнатьева",
	    "Савина",
	    "Логинова",
	    "Сафонова",
	    "Капустина",
	    "Кириллова",
	    "Моисеева",
	    "Елисеева",
	    "Кошелева",
	    "Костина",
	    "Горбачева",
	    "Орехова",
	    "Ефремова",
	    "Исаева",
	    "Евдокимова",
	    "Калашникова",
	    "Кабанова",
	    "Носкова",
	    "Юдина",
	    "Кулагина",
	    "Лапина",
	    "Прохорова",
	    "Нестерова",
	    "Харитонова",
	    "Агафонова",
	    "Муравьева",
	    "Ларионова",
	    "Федосеева",
	    "Зимина",
	    "Пахомова",
	    "Шубина",
	    "Игнатова",
	    "Филатова",
	    "Крюкова",
	    "Рогова",
	    "Кулакова",
	    "Терентьева",
	    "Молчанова",
	    "Владимирова",
	    "Артемьева",
	    "Гурьева",
	    "Зиновьева",
	    "Гришина",
	    "Кононова",
	    "Дементьева",
	    "Ситникова",
	    "Симонова",
	    "Мишина",
	    "Фадеева",
	    "Комиссарова",
	    "Мамонтова",
	    "Носова",
	    "Гуляева",
	    "Шарова",
	    "Устинова",
	    "Вишнякова",
	    "Евсеева",
	    "Лаврентьева",
	    "Брагина",
	    "Константинова",
	    "Корнилова",
	    "Авдеева",
	    "Зыкова",
	    "Бирюкова",
	    "Шарапова",
	    "Никонова",
	    "Щукина",
	    "Дьячкова",
	    "Одинцова",
	    "Сазонова",
	    "Якушева",
	    "Красильникова",
	    "Гордеева",
	    "Самойлова",
	    "Князева",
	    "Беспалова",
	    "Уварова",
	    "Шашкова",
	    "Бобылева",
	    "Доронина",
	    "Белозерова",
	    "Рожкова",
	    "Самсонова",
	    "Мясникова",
	    "Лихачева",
	    "Бурова",
	    "Сысоева",
	    "Фомичева",
	    "Русакова",
	    "Стрелкова",
	    "Гущина",
	    "Тетерина",
	    "Колобова",
	    "Субботина",
	    "Фокина",
	    "Блохина",
	    "Селиверстова",
	    "Пестова",
	    "Кондратьева",
	    "Силина",
	    "Меркушева",
	    "Лыткина",
	    "Турова"
	  ],
	  "name": [
	    "#{male_first_name} #{male_last_name}",
	    "#{male_last_name} #{male_first_name}",
	    "#{male_first_name} #{male_middle_name} #{male_last_name}",
	    "#{male_last_name} #{male_first_name} #{male_middle_name}",
	    "#{female_first_name} #{female_last_name}",
	    "#{female_last_name} #{female_first_name}",
	    "#{female_first_name} #{female_middle_name} #{female_last_name}",
	    "#{female_last_name} #{female_first_name} #{female_middle_name}"
	  ]
	};
	ru.phone_number = {
	  "formats": [
	    "(9##)###-##-##"
	  ]
	};
	ru.commerce = {
	  "color": [
	    "красный",
	    "зеленый",
	    "синий",
	    "желтый",
	    "багровый",
	    "мятный",
	    "зеленовато-голубой",
	    "белый",
	    "черный",
	    "оранжевый",
	    "розовый",
	    "серый",
	    "красно-коричневый",
	    "фиолетовый",
	    "бирюзовый",
	    "желто-коричневый",
	    "небесно голубой",
	    "оранжево-розовый",
	    "темно-фиолетовый",
	    "орхидный",
	    "оливковый",
	    "пурпурный",
	    "лимонный",
	    "кремовый",
	    "сине-фиолетовый",
	    "золотой",
	    "красно-пурпурный",
	    "голубой",
	    "лазурный",
	    "лиловый",
	    "серебряный"
	  ],
	  "department": [
	    "Книги",
	    "Фильмы",
	    "музыка",
	    "игры",
	    "Электроника",
	    "компьютеры",
	    "Дом",
	    "садинструмент",
	    "Бакалея",
	    "здоровье",
	    "красота",
	    "Игрушки",
	    "детское",
	    "для малышей",
	    "Одежда",
	    "обувь",
	    "украшения",
	    "Спорт",
	    "туризм",
	    "Автомобильное",
	    "промышленное"
	  ],
	  "product_name": {
	    "adjective": [
	      "Маленький",
	      "Эргономичный",
	      "Грубый",
	      "Интеллектуальный",
	      "Великолепный",
	      "Невероятный",
	      "Фантастический",
	      "Практчиный",
	      "Лоснящийся",
	      "Потрясающий"
	    ],
	    "material": [
	      "Стальной",
	      "Деревянный",
	      "Бетонный",
	      "Пластиковый",
	      "Хлопковый",
	      "Гранитный",
	      "Резиновый"
	    ],
	    "product": [
	      "Стул",
	      "Автомобиль",
	      "Компьютер",
	      "Берет",
	      "Кулон",
	      "Стол",
	      "Свитер",
	      "Ремень",
	      "Ботинок"
	    ]
	  }
	};
	ru.company = {
	  "prefix": [
	    "ИП",
	    "ООО",
	    "ЗАО",
	    "ОАО",
	    "НКО",
	    "ТСЖ",
	    "ОП"
	  ],
	  "suffix": [
	    "Снаб",
	    "Торг",
	    "Пром",
	    "Трейд",
	    "Сбыт"
	  ],
	  "name": [
	    "#{prefix} #{Name.female_first_name}",
	    "#{prefix} #{Name.male_first_name}",
	    "#{prefix} #{Name.male_last_name}",
	    "#{prefix} #{suffix}#{suffix}",
	    "#{prefix} #{suffix}#{suffix}#{suffix}",
	    "#{prefix} #{Address.city_name}#{suffix}",
	    "#{prefix} #{Address.city_name}#{suffix}#{suffix}",
	    "#{prefix} #{Address.city_name}#{suffix}#{suffix}#{suffix}"
	  ]
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)(module)))

/***/ },
/* 316 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var sk = {};
	module["exports"] = sk;
	sk.title = "Slovakian";
	sk.address = {
	  "city_prefix": [
	    "North",
	    "East",
	    "West",
	    "South",
	    "New",
	    "Lake",
	    "Port"
	  ],
	  "city_suffix": [
	    "town",
	    "ton",
	    "land",
	    "ville",
	    "berg",
	    "burgh",
	    "borough",
	    "bury",
	    "view",
	    "port",
	    "mouth",
	    "stad",
	    "furt",
	    "chester",
	    "mouth",
	    "fort",
	    "haven",
	    "side",
	    "shire"
	  ],
	  "country": [
	    "Afganistan",
	    "Afgánsky islamský štát",
	    "Albánsko",
	    "Albánska republika",
	    "Alžírsko",
	    "Alžírska demokratická ľudová republika",
	    "Andorra",
	    "Andorrské kniežatsvo",
	    "Angola",
	    "Angolská republika",
	    "Antigua a Barbuda",
	    "Antigua a Barbuda",
	    "Argentína",
	    "Argentínska republika",
	    "Arménsko",
	    "Arménska republika",
	    "Austrália",
	    "Austrálsky zväz",
	    "Azerbajdžan",
	    "Azerbajdžanská republika",
	    "Bahamy",
	    "Bahamské spoločenstvo",
	    "Bahrajn",
	    "Bahrajnské kráľovstvo",
	    "Bangladéš",
	    "Bangladéšska ľudová republika",
	    "Barbados",
	    "Barbados",
	    "Belgicko",
	    "Belgické kráľovstvo",
	    "Belize",
	    "Belize",
	    "Benin",
	    "Beninská republika",
	    "Bhután",
	    "Bhutánske kráľovstvo",
	    "Bielorusko",
	    "Bieloruská republika",
	    "Bolívia",
	    "Bolívijská republika",
	    "Bosna a Hercegovina",
	    "Republika Bosny a Hercegoviny",
	    "Botswana",
	    "Botswanská republika",
	    "Brazília",
	    "Brazílska federatívna republika",
	    "Brunej",
	    "Brunejský sultanát",
	    "Bulharsko",
	    "Bulharská republika",
	    "Burkina Faso",
	    "Burkina Faso",
	    "Burundi",
	    "Burundská republika",
	    "Cyprus",
	    "Cyperská republika",
	    "Čad",
	    "Republika Čad",
	    "Česko",
	    "Česká republika",
	    "Čína",
	    "Čínska ľudová republika",
	    "Dánsko",
	    "Dánsko kráľovstvo",
	    "Dominika",
	    "Spoločenstvo Dominika",
	    "Dominikánska republika",
	    "Dominikánska republika",
	    "Džibutsko",
	    "Džibutská republika",
	    "Egypt",
	    "Egyptská arabská republika",
	    "Ekvádor",
	    "Ekvádorská republika",
	    "Eritrea",
	    "Eritrejský štát",
	    "Estónsko",
	    "Estónska republika",
	    "Etiópia",
	    "Etiópska federatívna demokratická republika",
	    "Fidži",
	    "Republika ostrovy Fidži",
	    "Filipíny",
	    "Filipínska republika",
	    "Fínsko",
	    "Fínska republika",
	    "Francúzsko",
	    "Francúzska republika",
	    "Gabon",
	    "Gabonská republika",
	    "Gambia",
	    "Gambijská republika",
	    "Ghana",
	    "Ghanská republika",
	    "Grécko",
	    "Helénska republika",
	    "Grenada",
	    "Grenada",
	    "Gruzínsko",
	    "Gruzínsko",
	    "Guatemala",
	    "Guatemalská republika",
	    "Guinea",
	    "Guinejská republika",
	    "Guinea-Bissau",
	    "Republika Guinea-Bissau",
	    "Guayana",
	    "Guayanská republika",
	    "Haiti",
	    "Republika Haiti",
	    "Holandsko",
	    "Holandské kráľovstvo",
	    "Honduras",
	    "Honduraská republika",
	    "Chile",
	    "Čílska republika",
	    "Chorvátsko",
	    "Chorvátska republika",
	    "India",
	    "Indická republika",
	    "Indonézia",
	    "Indonézska republika",
	    "Irak",
	    "Iracká republika",
	    "Irán",
	    "Iránska islamská republika",
	    "Island",
	    "Islandská republika",
	    "Izrael",
	    "Štát Izrael",
	    "Írsko",
	    "Írska republika",
	    "Jamajka",
	    "Jamajka",
	    "Japonsko",
	    "Japonsko",
	    "Jemen",
	    "Jemenská republika",
	    "Jordánsko",
	    "Jordánske hášimovské kráľovstvo",
	    "Južná Afrika",
	    "Juhoafrická republika",
	    "Kambodža",
	    "Kambodžské kráľovstvo",
	    "Kamerun",
	    "Kamerunská republika",
	    "Kanada",
	    "Kanada",
	    "Kapverdy",
	    "Kapverdská republika",
	    "Katar",
	    "Štát Katar",
	    "Kazachstan",
	    "Kazašská republika",
	    "Keňa",
	    "Kenská republika",
	    "Kirgizsko",
	    "Kirgizská republika",
	    "Kiribati",
	    "Kiribatská republika",
	    "Kolumbia",
	    "Kolumbijská republika",
	    "Komory",
	    "Komorská únia",
	    "Kongo",
	    "Konžská demokratická republika",
	    "Kongo (\"Brazzaville\")",
	    "Konžská republika",
	    "Kórea (\"Južná\")",
	    "Kórejská republika",
	    "Kórea (\"Severná\")",
	    "Kórejská ľudovodemokratická republika",
	    "Kostarika",
	    "Kostarická republika",
	    "Kuba",
	    "Kubánska republika",
	    "Kuvajt",
	    "Kuvajtský štát",
	    "Laos",
	    "Laoská ľudovodemokratická republika",
	    "Lesotho",
	    "Lesothské kráľovstvo",
	    "Libanon",
	    "Libanonská republika",
	    "Libéria",
	    "Libérijská republika",
	    "Líbya",
	    "Líbyjská arabská ľudová socialistická džamáhírija",
	    "Lichtenštajnsko",
	    "Lichtenštajnské kniežatstvo",
	    "Litva",
	    "Litovská republika",
	    "Lotyšsko",
	    "Lotyšská republika",
	    "Luxembursko",
	    "Luxemburské veľkovojvodstvo",
	    "Macedónsko",
	    "Macedónska republika",
	    "Madagaskar",
	    "Madagaskarská republika",
	    "Maďarsko",
	    "Maďarská republika",
	    "Malajzia",
	    "Malajzia",
	    "Malawi",
	    "Malawijská republika",
	    "Maldivy",
	    "Maldivská republika",
	    "Mali",
	    "Malijská republika",
	    "Malta",
	    "Malta",
	    "Maroko",
	    "Marocké kráľovstvo",
	    "Marshallove ostrovy",
	    "Republika Marshallových ostrovy",
	    "Mauritánia",
	    "Mauritánska islamská republika",
	    "Maurícius",
	    "Maurícijská republika",
	    "Mexiko",
	    "Spojené štáty mexické",
	    "Mikronézia",
	    "Mikronézske federatívne štáty",
	    "Mjanmarsko",
	    "Mjanmarský zväz",
	    "Moldavsko",
	    "Moldavská republika",
	    "Monako",
	    "Monacké kniežatstvo",
	    "Mongolsko",
	    "Mongolsko",
	    "Mozambik",
	    "Mozambická republika",
	    "Namíbia",
	    "Namíbijská republika",
	    "Nauru",
	    "Naurská republika",
	    "Nemecko",
	    "Nemecká spolková republika",
	    "Nepál",
	    "Nepálske kráľovstvo",
	    "Niger",
	    "Nigerská republika",
	    "Nigéria",
	    "Nigérijská federatívna republika",
	    "Nikaragua",
	    "Nikaragujská republika",
	    "Nový Zéland",
	    "Nový Zéland",
	    "Nórsko",
	    "Nórske kráľovstvo",
	    "Omán",
	    "Ománsky sultanát",
	    "Pakistan",
	    "Pakistanská islamská republika",
	    "Palau",
	    "Palauská republika",
	    "Panama",
	    "Panamská republika",
	    "Papua-Nová Guinea",
	    "Nezávislý štát Papua-Nová Guinea",
	    "Paraguaj",
	    "Paraguajská republika",
	    "Peru",
	    "Peruánska republika",
	    "Pobrežie Slonoviny",
	    "Republika Pobrežie Slonoviny",
	    "Poľsko",
	    "Poľská republika",
	    "Portugalsko",
	    "Portugalská republika",
	    "Rakúsko",
	    "Rakúska republika",
	    "Rovníková Guinea",
	    "Republika Rovníková Guinea",
	    "Rumunsko",
	    "Rumunsko",
	    "Rusko",
	    "Ruská federácia",
	    "Rwanda",
	    "Rwandská republika",
	    "Salvádor",
	    "Salvádorská republika",
	    "Samoa",
	    "Nezávislý štát Samoa",
	    "San Maríno",
	    "Sanmarínska republika",
	    "Saudská Arábia",
	    "Kráľovstvo Saudskej Arábie",
	    "Senegal",
	    "Senegalská republika",
	    "Seychely",
	    "Seychelská republika",
	    "Sierra Leone",
	    "Republika Sierra Leone",
	    "Singapur",
	    "Singapurska republika",
	    "Slovensko",
	    "Slovenská republika",
	    "Slovinsko",
	    "Slovinská republika",
	    "Somálsko",
	    "Somálska demokratická republika",
	    "Spojené arabské emiráty",
	    "Spojené arabské emiráty",
	    "Spojené štáty americké",
	    "Spojené štáty americké",
	    "Srbsko a Čierna Hora",
	    "Srbsko a Čierna Hora",
	    "Srí Lanka",
	    "Demokratická socialistická republika Srí Lanka",
	    "Stredoafrická republika",
	    "Stredoafrická republika",
	    "Sudán",
	    "Sudánska republika",
	    "Surinam",
	    "Surinamská republika",
	    "Svazijsko",
	    "Svazijské kráľovstvo",
	    "Svätá Lucia",
	    "Svätá Lucia",
	    "Svätý Krištof a Nevis",
	    "Federácia Svätý Krištof a Nevis",
	    "Sv. Tomáš a Princov Ostrov",
	    "Demokratická republika Svätý Tomáš a Princov Ostrov",
	    "Sv. Vincent a Grenadíny",
	    "Svätý Vincent a Grenadíny",
	    "Sýria",
	    "Sýrska arabská republika",
	    "Šalamúnove ostrovy",
	    "Šalamúnove ostrovy",
	    "Španielsko",
	    "Španielske kráľovstvo",
	    "Švajčiarsko",
	    "Švajčiarska konfederácia",
	    "Švédsko",
	    "Švédske kráľovstvo",
	    "Tadžikistan",
	    "Tadžická republika",
	    "Taliansko",
	    "Talianska republika",
	    "Tanzánia",
	    "Tanzánijská zjednotená republika",
	    "Thajsko",
	    "Thajské kráľovstvo",
	    "Togo",
	    "Tožská republika",
	    "Tonga",
	    "Tonžské kráľovstvo",
	    "Trinidad a Tobago",
	    "Republika Trinidad a Tobago",
	    "Tunisko",
	    "Tuniská republika",
	    "Turecko",
	    "Turecká republika",
	    "Turkménsko",
	    "Turkménsko",
	    "Tuvalu",
	    "Tuvalu",
	    "Uganda",
	    "Ugandská republika",
	    "Ukrajina",
	    "Uruguaj",
	    "Uruguajská východná republika",
	    "Uzbekistan",
	    "Vanuatu",
	    "Vanuatská republika",
	    "Vatikán",
	    "Svätá Stolica",
	    "Veľká Británia",
	    "Spojené kráľovstvo Veľkej Británie a Severného Írska",
	    "Venezuela",
	    "Venezuelská bolívarovská republika",
	    "Vietnam",
	    "Vietnamská socialistická republika",
	    "Východný Timor",
	    "Demokratická republika Východný Timor",
	    "Zambia",
	    "Zambijská republika",
	    "Zimbabwe",
	    "Zimbabwianska republika"
	  ],
	  "building_number": [
	    "#",
	    "##",
	    "###"
	  ],
	  "secondary_address": [
	    "Apt. ###",
	    "Suite ###"
	  ],
	  "postcode": [
	    "#####",
	    "### ##",
	    "## ###"
	  ],
	  "state": [],
	  "state_abbr": [],
	  "time_zone": [
	    "Pacific/Midway",
	    "Pacific/Pago_Pago",
	    "Pacific/Honolulu",
	    "America/Juneau",
	    "America/Los_Angeles",
	    "America/Tijuana",
	    "America/Denver",
	    "America/Phoenix",
	    "America/Chihuahua",
	    "America/Mazatlan",
	    "America/Chicago",
	    "America/Regina",
	    "America/Mexico_City",
	    "America/Mexico_City",
	    "America/Monterrey",
	    "America/Guatemala",
	    "America/New_York",
	    "America/Indiana/Indianapolis",
	    "America/Bogota",
	    "America/Lima",
	    "America/Lima",
	    "America/Halifax",
	    "America/Caracas",
	    "America/La_Paz",
	    "America/Santiago",
	    "America/St_Johns",
	    "America/Sao_Paulo",
	    "America/Argentina/Buenos_Aires",
	    "America/Guyana",
	    "America/Godthab",
	    "Atlantic/South_Georgia",
	    "Atlantic/Azores",
	    "Atlantic/Cape_Verde",
	    "Europe/Dublin",
	    "Europe/London",
	    "Europe/Lisbon",
	    "Europe/London",
	    "Africa/Casablanca",
	    "Africa/Monrovia",
	    "Etc/UTC",
	    "Europe/Belgrade",
	    "Europe/Bratislava",
	    "Europe/Budapest",
	    "Europe/Ljubljana",
	    "Europe/Prague",
	    "Europe/Sarajevo",
	    "Europe/Skopje",
	    "Europe/Warsaw",
	    "Europe/Zagreb",
	    "Europe/Brussels",
	    "Europe/Copenhagen",
	    "Europe/Madrid",
	    "Europe/Paris",
	    "Europe/Amsterdam",
	    "Europe/Berlin",
	    "Europe/Berlin",
	    "Europe/Rome",
	    "Europe/Stockholm",
	    "Europe/Vienna",
	    "Africa/Algiers",
	    "Europe/Bucharest",
	    "Africa/Cairo",
	    "Europe/Helsinki",
	    "Europe/Kiev",
	    "Europe/Riga",
	    "Europe/Sofia",
	    "Europe/Tallinn",
	    "Europe/Vilnius",
	    "Europe/Athens",
	    "Europe/Istanbul",
	    "Europe/Minsk",
	    "Asia/Jerusalem",
	    "Africa/Harare",
	    "Africa/Johannesburg",
	    "Europe/Moscow",
	    "Europe/Moscow",
	    "Europe/Moscow",
	    "Asia/Kuwait",
	    "Asia/Riyadh",
	    "Africa/Nairobi",
	    "Asia/Baghdad",
	    "Asia/Tehran",
	    "Asia/Muscat",
	    "Asia/Muscat",
	    "Asia/Baku",
	    "Asia/Tbilisi",
	    "Asia/Yerevan",
	    "Asia/Kabul",
	    "Asia/Yekaterinburg",
	    "Asia/Karachi",
	    "Asia/Karachi",
	    "Asia/Tashkent",
	    "Asia/Kolkata",
	    "Asia/Kolkata",
	    "Asia/Kolkata",
	    "Asia/Kolkata",
	    "Asia/Kathmandu",
	    "Asia/Dhaka",
	    "Asia/Dhaka",
	    "Asia/Colombo",
	    "Asia/Almaty",
	    "Asia/Novosibirsk",
	    "Asia/Rangoon",
	    "Asia/Bangkok",
	    "Asia/Bangkok",
	    "Asia/Jakarta",
	    "Asia/Krasnoyarsk",
	    "Asia/Shanghai",
	    "Asia/Chongqing",
	    "Asia/Hong_Kong",
	    "Asia/Urumqi",
	    "Asia/Kuala_Lumpur",
	    "Asia/Singapore",
	    "Asia/Taipei",
	    "Australia/Perth",
	    "Asia/Irkutsk",
	    "Asia/Ulaanbaatar",
	    "Asia/Seoul",
	    "Asia/Tokyo",
	    "Asia/Tokyo",
	    "Asia/Tokyo",
	    "Asia/Yakutsk",
	    "Australia/Darwin",
	    "Australia/Adelaide",
	    "Australia/Melbourne",
	    "Australia/Melbourne",
	    "Australia/Sydney",
	    "Australia/Brisbane",
	    "Australia/Hobart",
	    "Asia/Vladivostok",
	    "Pacific/Guam",
	    "Pacific/Port_Moresby",
	    "Asia/Magadan",
	    "Asia/Magadan",
	    "Pacific/Noumea",
	    "Pacific/Fiji",
	    "Asia/Kamchatka",
	    "Pacific/Majuro",
	    "Pacific/Auckland",
	    "Pacific/Auckland",
	    "Pacific/Tongatapu",
	    "Pacific/Fakaofo",
	    "Pacific/Apia"
	  ],
	  "city_name": [
	    "Bánovce nad Bebravou",
	    "Banská Bystrica",
	    "Banská Štiavnica",
	    "Bardejov",
	    "Bratislava I",
	    "Bratislava II",
	    "Bratislava III",
	    "Bratislava IV",
	    "Bratislava V",
	    "Brezno",
	    "Bytča",
	    "Čadca",
	    "Detva",
	    "Dolný Kubín",
	    "Dunajská Streda",
	    "Galanta",
	    "Gelnica",
	    "Hlohovec",
	    "Humenné",
	    "Ilava",
	    "Kežmarok",
	    "Komárno",
	    "Košice I",
	    "Košice II",
	    "Košice III",
	    "Košice IV",
	    "Košice-okolie",
	    "Krupina",
	    "Kysucké Nové Mesto",
	    "Levice",
	    "Levoča",
	    "Liptovský Mikuláš",
	    "Lučenec",
	    "Malacky",
	    "Martin",
	    "Medzilaborce",
	    "Michalovce",
	    "Myjava",
	    "Námestovo",
	    "Nitra",
	    "Nové Mesto n.Váhom",
	    "Nové Zámky",
	    "Partizánske",
	    "Pezinok",
	    "Piešťany",
	    "Poltár",
	    "Poprad",
	    "Považská Bystrica",
	    "Prešov",
	    "Prievidza",
	    "Púchov",
	    "Revúca",
	    "Rimavská Sobota",
	    "Rožňava",
	    "Ružomberok",
	    "Sabinov",
	    "Šaľa",
	    "Senec",
	    "Senica",
	    "Skalica",
	    "Snina",
	    "Sobrance",
	    "Spišská Nová Ves",
	    "Stará Ľubovňa",
	    "Stropkov",
	    "Svidník",
	    "Topoľčany",
	    "Trebišov",
	    "Trenčín",
	    "Trnava",
	    "Turčianske Teplice",
	    "Tvrdošín",
	    "Veľký Krtíš",
	    "Vranov nad Topľou",
	    "Žarnovica",
	    "Žiar nad Hronom",
	    "Žilina",
	    "Zlaté Moravce",
	    "Zvolen"
	  ],
	  "city": [
	    "#{city_name}"
	  ],
	  "street": [
	    "Adámiho",
	    "Ahoj",
	    "Albína Brunovského",
	    "Albrechtova",
	    "Alejová",
	    "Alešova",
	    "Alibernetová",
	    "Alžbetínska",
	    "Alžbety Gwerkovej",
	    "Ambroseho",
	    "Ambrušova",
	    "Americká",
	    "Americké námestie",
	    "Americké námestie",
	    "Andreja Mráza",
	    "Andreja Plávku",
	    "Andrusovova",
	    "Anenská",
	    "Anenská",
	    "Antolská",
	    "Astronomická",
	    "Astrová",
	    "Azalková",
	    "Azovská",
	    "Babuškova",
	    "Bachova",
	    "Bajkalská",
	    "Bajkalská",
	    "Bajkalská",
	    "Bajkalská",
	    "Bajkalská",
	    "Bajkalská",
	    "Bajzova",
	    "Bancíkovej",
	    "Banícka",
	    "Baníkova",
	    "Banskobystrická",
	    "Banšelova",
	    "Bardejovská",
	    "Bartókova",
	    "Bartoňova",
	    "Bartoškova",
	    "Baštová",
	    "Bazová",
	    "Bažantia",
	    "Beblavého",
	    "Beckovská",
	    "Bedľová",
	    "Belániková",
	    "Belehradská",
	    "Belinského",
	    "Belopotockého",
	    "Beňadická",
	    "Bencúrova",
	    "Benediktiho",
	    "Beniakova",
	    "Bernolákova",
	    "Beskydská",
	    "Betliarska",
	    "Bezručova",
	    "Biela",
	    "Bielkova",
	    "Björnsonova",
	    "Blagoevova",
	    "Blatnická",
	    "Blumentálska",
	    "Blyskáčová",
	    "Bočná",
	    "Bohrova",
	    "Bohúňova",
	    "Bojnická",
	    "Borodáčova",
	    "Borská",
	    "Bosákova",
	    "Botanická",
	    "Bottova",
	    "Boženy Němcovej",
	    "Bôrik",
	    "Bradáčova",
	    "Bradlianska",
	    "Brančská",
	    "Bratská",
	    "Brestová",
	    "Brezovská",
	    "Briežky",
	    "Brnianska",
	    "Brodná",
	    "Brodská",
	    "Broskyňová",
	    "Břeclavská",
	    "Budatínska",
	    "Budatínska",
	    "Budatínska",
	    "Búdkova  cesta",
	    "Budovateľská",
	    "Budyšínska",
	    "Budyšínska",
	    "Buková",
	    "Bukureštská",
	    "Bulharská",
	    "Bulíkova",
	    "Bystrého",
	    "Bzovícka",
	    "Cablkova",
	    "Cesta na Červený most",
	    "Cesta na Červený most",
	    "Cesta na Senec",
	    "Cikkerova",
	    "Cintorínska",
	    "Cintulova",
	    "Cukrová",
	    "Cyrilova",
	    "Čajakova",
	    "Čajkovského",
	    "Čaklovská",
	    "Čalovská",
	    "Čapajevova",
	    "Čapkova",
	    "Čárskeho",
	    "Čavojského",
	    "Čečinová",
	    "Čelakovského",
	    "Čerešňová",
	    "Černyševského",
	    "Červeňova",
	    "Česká",
	    "Československých par",
	    "Čipkárska",
	    "Čmelíkova",
	    "Čmeľovec",
	    "Čulenova",
	    "Daliborovo námestie",
	    "Dankovského",
	    "Dargovská",
	    "Ďatelinová",
	    "Daxnerovo námestie",
	    "Devínska cesta",
	    "Dlhé diely I.",
	    "Dlhé diely II.",
	    "Dlhé diely III.",
	    "Dobrovičova",
	    "Dobrovičova",
	    "Dobrovského",
	    "Dobšinského",
	    "Dohnalova",
	    "Dohnányho",
	    "Doležalova",
	    "Dolná",
	    "Dolnozemská cesta",
	    "Domkárska",
	    "Domové role",
	    "Donnerova",
	    "Donovalova",
	    "Dostojevského rad",
	    "Dr. Vladimíra Clemen",
	    "Drevená",
	    "Drieňová",
	    "Drieňová",
	    "Drieňová",
	    "Drotárska cesta",
	    "Drotárska cesta",
	    "Drotárska cesta",
	    "Družicová",
	    "Družstevná",
	    "Dubnická",
	    "Dubová",
	    "Dúbravská cesta",
	    "Dudova",
	    "Dulovo námestie",
	    "Dulovo námestie",
	    "Dunajská",
	    "Dvořákovo nábrežie",
	    "Edisonova",
	    "Einsteinova",
	    "Elektrárenská",
	    "Exnárova",
	    "F. Kostku",
	    "Fadruszova",
	    "Fajnorovo nábrežie",
	    "Fándlyho",
	    "Farebná",
	    "Farská",
	    "Farského",
	    "Fazuľová",
	    "Fedinova",
	    "Ferienčíkova",
	    "Fialkové údolie",
	    "Fibichova",
	    "Filiálne nádražie",
	    "Flöglova",
	    "Floriánske námestie",
	    "Fraňa Kráľa",
	    "Francisciho",
	    "Francúzskych partizá",
	    "Františkánska",
	    "Františkánske námest",
	    "Furdekova",
	    "Furdekova",
	    "Gabčíkova",
	    "Gagarinova",
	    "Gagarinova",
	    "Gagarinova",
	    "Gajova",
	    "Galaktická",
	    "Galandova",
	    "Gallova",
	    "Galvaniho",
	    "Gašparíkova",
	    "Gaštanová",
	    "Gavlovičova",
	    "Gemerská",
	    "Gercenova",
	    "Gessayova",
	    "Gettingová",
	    "Godrova",
	    "Gogoľova",
	    "Goláňova",
	    "Gondova",
	    "Goralská",
	    "Gorazdova",
	    "Gorkého",
	    "Gregorovej",
	    "Grösslingova",
	    "Gruzínska",
	    "Gunduličova",
	    "Gusevova",
	    "Haanova",
	    "Haburská",
	    "Halašova",
	    "Hálkova",
	    "Hálova",
	    "Hamuliakova",
	    "Hanácka",
	    "Handlovská",
	    "Hany Meličkovej",
	    "Harmanecká",
	    "Hasičská",
	    "Hattalova",
	    "Havlíčkova",
	    "Havrania",
	    "Haydnova",
	    "Herlianska",
	    "Herlianska",
	    "Heydukova",
	    "Hlaváčikova",
	    "Hlavatého",
	    "Hlavné námestie",
	    "Hlboká cesta",
	    "Hlboká cesta",
	    "Hlivová",
	    "Hlučínska",
	    "Hodálova",
	    "Hodžovo námestie",
	    "Holekova",
	    "Holíčska",
	    "Hollého",
	    "Holubyho",
	    "Hontianska",
	    "Horárska",
	    "Horné Židiny",
	    "Horská",
	    "Horská",
	    "Hrad",
	    "Hradné údolie",
	    "Hrachová",
	    "Hraničná",
	    "Hrebendova",
	    "Hríbová",
	    "Hriňovská",
	    "Hrobákova",
	    "Hrobárska",
	    "Hroboňova",
	    "Hudecova",
	    "Humenské námestie",
	    "Hummelova",
	    "Hurbanovo námestie",
	    "Hurbanovo námestie",
	    "Hviezdoslavovo námes",
	    "Hýrošova",
	    "Chalupkova",
	    "Chemická",
	    "Chlumeckého",
	    "Chorvátska",
	    "Chorvátska",
	    "Iľjušinova",
	    "Ilkovičova",
	    "Inovecká",
	    "Inovecká",
	    "Iskerníková",
	    "Ivana Horvátha",
	    "Ivánska cesta",
	    "J.C.Hronského",
	    "Jabloňová",
	    "Jadrová",
	    "Jakabova",
	    "Jakubovo námestie",
	    "Jamnického",
	    "Jána Stanislava",
	    "Janáčkova",
	    "Jančova",
	    "Janíkove role",
	    "Jankolova",
	    "Jánošíkova",
	    "Jánoškova",
	    "Janotova",
	    "Jánska",
	    "Jantárová cesta",
	    "Jarabinková",
	    "Jarná",
	    "Jaroslavova",
	    "Jarošova",
	    "Jaseňová",
	    "Jasná",
	    "Jasovská",
	    "Jastrabia",
	    "Jašíkova",
	    "Javorinská",
	    "Javorová",
	    "Jazdecká",
	    "Jedlíkova",
	    "Jégého",
	    "Jelačičova",
	    "Jelenia",
	    "Jesenná",
	    "Jesenského",
	    "Jiráskova",
	    "Jiskrova",
	    "Jozefská",
	    "Junácka",
	    "Jungmannova",
	    "Jurigovo námestie",
	    "Jurovského",
	    "Jurská",
	    "Justičná",
	    "K lomu",
	    "K Železnej studienke",
	    "Kalinčiakova",
	    "Kamenárska",
	    "Kamenné námestie",
	    "Kapicova",
	    "Kapitulská",
	    "Kapitulský dvor",
	    "Kapucínska",
	    "Kapušianska",
	    "Karadžičova",
	    "Karadžičova",
	    "Karadžičova",
	    "Karadžičova",
	    "Karloveská",
	    "Karloveské rameno",
	    "Karpatská",
	    "Kašmírska",
	    "Kaštielska",
	    "Kaukazská",
	    "Kempelenova",
	    "Kežmarské námestie",
	    "Kladnianska",
	    "Klariská",
	    "Kláštorská",
	    "Klatovská",
	    "Klatovská",
	    "Klemensova",
	    "Klincová",
	    "Klobučnícka",
	    "Klokočova",
	    "Kľukatá",
	    "Kmeťovo námestie",
	    "Koceľova",
	    "Kočánkova",
	    "Kohútova",
	    "Kolárska",
	    "Kolískova",
	    "Kollárovo námestie",
	    "Kollárovo námestie",
	    "Kolmá",
	    "Komárňanská",
	    "Komárnická",
	    "Komárnická",
	    "Komenského námestie",
	    "Kominárska",
	    "Komonicová",
	    "Konopná",
	    "Konvalinková",
	    "Konventná",
	    "Kopanice",
	    "Kopčianska",
	    "Koperníkova",
	    "Korabinského",
	    "Koreničova",
	    "Kostlivého",
	    "Kostolná",
	    "Košická",
	    "Košická",
	    "Košická",
	    "Kováčska",
	    "Kovorobotnícka",
	    "Kozia",
	    "Koziarka",
	    "Kozmonautická",
	    "Krajná",
	    "Krakovská",
	    "Kráľovské údolie",
	    "Krasinského",
	    "Kraskova",
	    "Krásna",
	    "Krásnohorská",
	    "Krasovského",
	    "Krátka",
	    "Krčméryho",
	    "Kremnická",
	    "Kresánkova",
	    "Krivá",
	    "Križkova",
	    "Krížna",
	    "Krížna",
	    "Krížna",
	    "Krížna",
	    "Krmanova",
	    "Krompašská",
	    "Krupinská",
	    "Krupkova",
	    "Kubániho",
	    "Kubínska",
	    "Kuklovská",
	    "Kukučínova",
	    "Kukuričná",
	    "Kulíškova",
	    "Kultúrna",
	    "Kupeckého",
	    "Kúpeľná",
	    "Kutlíkova",
	    "Kutuzovova",
	    "Kuzmányho",
	    "Kvačalova",
	    "Kvetná",
	    "Kýčerského",
	    "Kyjevská",
	    "Kysucká",
	    "Laborecká",
	    "Lackova",
	    "Ladislava Sáru",
	    "Ľadová",
	    "Lachova",
	    "Ľaliová",
	    "Lamačská cesta",
	    "Lamačská cesta",
	    "Lamanského",
	    "Landererova",
	    "Langsfeldova",
	    "Ľanová",
	    "Laskomerského",
	    "Laučekova",
	    "Laurinská",
	    "Lazaretská",
	    "Lazaretská",
	    "Legerského",
	    "Legionárska",
	    "Legionárska",
	    "Lehockého",
	    "Lehockého",
	    "Lenardova",
	    "Lermontovova",
	    "Lesná",
	    "Leškova",
	    "Letecká",
	    "Letisko M.R.Štefánik",
	    "Letná",
	    "Levárska",
	    "Levická",
	    "Levočská",
	    "Lidická",
	    "Lietavská",
	    "Lichardova",
	    "Lipová",
	    "Lipovinová",
	    "Liptovská",
	    "Listová",
	    "Líščie nivy",
	    "Líščie údolie",
	    "Litovská",
	    "Lodná",
	    "Lombardiniho",
	    "Lomonosovova",
	    "Lopenícka",
	    "Lovinského",
	    "Ľubietovská",
	    "Ľubinská",
	    "Ľubľanská",
	    "Ľubochnianska",
	    "Ľubovnianska",
	    "Lúčna",
	    "Ľudové námestie",
	    "Ľudovíta Fullu",
	    "Luhačovická",
	    "Lužická",
	    "Lužná",
	    "Lýcejná",
	    "Lykovcová",
	    "M. Hella",
	    "Magnetová",
	    "Macharova",
	    "Majakovského",
	    "Majerníkova",
	    "Májkova",
	    "Májová",
	    "Makovického",
	    "Malá",
	    "Malé pálenisko",
	    "Malinová",
	    "Malý Draždiak",
	    "Malý trh",
	    "Mamateyova",
	    "Mamateyova",
	    "Mánesovo námestie",
	    "Mariánska",
	    "Marie Curie-Sklodows",
	    "Márie Medveďovej",
	    "Markova",
	    "Marótyho",
	    "Martákovej",
	    "Martinčekova",
	    "Martinčekova",
	    "Martinengova",
	    "Martinská",
	    "Mateja Bela",
	    "Matejkova",
	    "Matičná",
	    "Matúšova",
	    "Medená",
	    "Medzierka",
	    "Medzilaborecká",
	    "Merlotová",
	    "Mesačná",
	    "Mestská",
	    "Meteorová",
	    "Metodova",
	    "Mickiewiczova",
	    "Mierová",
	    "Michalská",
	    "Mikovíniho",
	    "Mikulášska",
	    "Miletičova",
	    "Miletičova",
	    "Mišíkova",
	    "Mišíkova",
	    "Mišíkova",
	    "Mliekárenská",
	    "Mlynarovičova",
	    "Mlynská dolina",
	    "Mlynská dolina",
	    "Mlynská dolina",
	    "Mlynské luhy",
	    "Mlynské nivy",
	    "Mlynské nivy",
	    "Mlynské nivy",
	    "Mlynské nivy",
	    "Mlynské nivy",
	    "Mlyny",
	    "Modranská",
	    "Mojmírova",
	    "Mokráň záhon",
	    "Mokrohájska cesta",
	    "Moldavská",
	    "Molecova",
	    "Moravská",
	    "Moskovská",
	    "Most SNP",
	    "Mostová",
	    "Mošovského",
	    "Motýlia",
	    "Moyzesova",
	    "Mozartova",
	    "Mraziarenská",
	    "Mudroňova",
	    "Mudroňova",
	    "Mudroňova",
	    "Muchovo námestie",
	    "Murgašova",
	    "Muškátová",
	    "Muštová",
	    "Múzejná",
	    "Myjavská",
	    "Mýtna",
	    "Mýtna",
	    "Na Baránku",
	    "Na Brezinách",
	    "Na Hrebienku",
	    "Na Kalvárii",
	    "Na Kampárke",
	    "Na kopci",
	    "Na križovatkách",
	    "Na lánoch",
	    "Na paši",
	    "Na piesku",
	    "Na Riviére",
	    "Na Sitine",
	    "Na Slavíne",
	    "Na stráni",
	    "Na Štyridsiatku",
	    "Na úvrati",
	    "Na vŕšku",
	    "Na výslní",
	    "Nábělkova",
	    "Nábrežie arm. gen. L",
	    "Nábrežná",
	    "Nad Dunajom",
	    "Nad lomom",
	    "Nad lúčkami",
	    "Nad lúčkami",
	    "Nad ostrovom",
	    "Nad Sihoťou",
	    "Námestie 1. mája",
	    "Námestie Alexandra D",
	    "Námestie Biely kríž",
	    "Námestie Hraničiarov",
	    "Námestie Jána Pavla",
	    "Námestie Ľudovíta Št",
	    "Námestie Martina Ben",
	    "Nám. M.R.Štefánika",
	    "Námestie slobody",
	    "Námestie slobody",
	    "Námestie SNP",
	    "Námestie SNP",
	    "Námestie sv. Františ",
	    "Narcisová",
	    "Nedbalova",
	    "Nekrasovova",
	    "Neronetová",
	    "Nerudova",
	    "Nevädzová",
	    "Nezábudková",
	    "Niťová",
	    "Nitrianska",
	    "Nížinná",
	    "Nobelova",
	    "Nobelovo námestie",
	    "Nová",
	    "Nová Rožňavská",
	    "Novackého",
	    "Nové pálenisko",
	    "Nové záhrady I",
	    "Nové záhrady II",
	    "Nové záhrady III",
	    "Nové záhrady IV",
	    "Nové záhrady V",
	    "Nové záhrady VI",
	    "Nové záhrady VII",
	    "Novinárska",
	    "Novobanská",
	    "Novohradská",
	    "Novosvetská",
	    "Novosvetská",
	    "Novosvetská",
	    "Obežná",
	    "Obchodná",
	    "Očovská",
	    "Odbojárov",
	    "Odborárska",
	    "Odborárske námestie",
	    "Odborárske námestie",
	    "Ohnicová",
	    "Okánikova",
	    "Okružná",
	    "Olbrachtova",
	    "Olejkárska",
	    "Ondavská",
	    "Ondrejovova",
	    "Oravská",
	    "Orechová cesta",
	    "Orechový rad",
	    "Oriešková",
	    "Ormisova",
	    "Osadná",
	    "Ostravská",
	    "Ostredková",
	    "Osuského",
	    "Osvetová",
	    "Otonelská",
	    "Ovručská",
	    "Ovsištské námestie",
	    "Pajštúnska",
	    "Palackého",
	    "Palárikova",
	    "Palárikova",
	    "Pálavská",
	    "Palisády",
	    "Palisády",
	    "Palisády",
	    "Palkovičova",
	    "Panenská",
	    "Pankúchova",
	    "Panónska cesta",
	    "Panská",
	    "Papánkovo námestie",
	    "Papraďová",
	    "Páričkova",
	    "Parková",
	    "Partizánska",
	    "Pasienky",
	    "Paulínyho",
	    "Pavlovičova",
	    "Pavlovova",
	    "Pavlovská",
	    "Pažického",
	    "Pažítková",
	    "Pečnianska",
	    "Pernecká",
	    "Pestovateľská",
	    "Peterská",
	    "Petzvalova",
	    "Pezinská",
	    "Piesočná",
	    "Piešťanská",
	    "Pifflova",
	    "Pilárikova",
	    "Pionierska",
	    "Pivoňková",
	    "Planckova",
	    "Planét",
	    "Plátenícka",
	    "Pluhová",
	    "Plynárenská",
	    "Plzenská",
	    "Pobrežná",
	    "Pod Bôrikom",
	    "Pod Kalváriou",
	    "Pod lesom",
	    "Pod Rovnicami",
	    "Pod vinicami",
	    "Podhorského",
	    "Podjavorinskej",
	    "Podlučinského",
	    "Podniková",
	    "Podtatranského",
	    "Pohronská",
	    "Polárna",
	    "Poloreckého",
	    "Poľná",
	    "Poľská",
	    "Poludníková",
	    "Porubského",
	    "Poštová",
	    "Považská",
	    "Povraznícka",
	    "Povraznícka",
	    "Pražská",
	    "Predstaničné námesti",
	    "Prepoštská",
	    "Prešernova",
	    "Prešovská",
	    "Prešovská",
	    "Prešovská",
	    "Pri Bielom kríži",
	    "Pri dvore",
	    "Pri Dynamitke",
	    "Pri Habánskom mlyne",
	    "Pri hradnej studni",
	    "Pri seči",
	    "Pri Starej Prachárni",
	    "Pri Starom háji",
	    "Pri Starom Mýte",
	    "Pri strelnici",
	    "Pri Suchom mlyne",
	    "Pri zvonici",
	    "Pribinova",
	    "Pribinova",
	    "Pribinova",
	    "Pribišova",
	    "Pribylinská",
	    "Priečna",
	    "Priekopy",
	    "Priemyselná",
	    "Priemyselná",
	    "Prievozská",
	    "Prievozská",
	    "Prievozská",
	    "Príkopova",
	    "Primaciálne námestie",
	    "Prístav",
	    "Prístavná",
	    "Prokofievova",
	    "Prokopa Veľkého",
	    "Prokopova",
	    "Prúdová",
	    "Prvosienková",
	    "Púpavová",
	    "Pustá",
	    "Puškinova",
	    "Račianska",
	    "Račianska",
	    "Račianske mýto",
	    "Radarová",
	    "Rádiová",
	    "Radlinského",
	    "Radničná",
	    "Radničné námestie",
	    "Radvanská",
	    "Rajská",
	    "Raketová",
	    "Rákosová",
	    "Rastislavova",
	    "Rázusovo nábrežie",
	    "Repná",
	    "Rešetkova",
	    "Revolučná",
	    "Révová",
	    "Revúcka",
	    "Rezedová",
	    "Riazanská",
	    "Riazanská",
	    "Ribayová",
	    "Riečna",
	    "Rigeleho",
	    "Rízlingová",
	    "Riznerova",
	    "Robotnícka",
	    "Romanova",
	    "Röntgenova",
	    "Rosná",
	    "Rovná",
	    "Rovniankova",
	    "Rovníková",
	    "Rozmarínová",
	    "Rožňavská",
	    "Rožňavská",
	    "Rožňavská",
	    "Rubinsteinova",
	    "Rudnayovo námestie",
	    "Rumančeková",
	    "Rusovská cesta",
	    "Ružičková",
	    "Ružinovská",
	    "Ružinovská",
	    "Ružinovská",
	    "Ružomberská",
	    "Ružová dolina",
	    "Ružová dolina",
	    "Rybárska brána",
	    "Rybné námestie",
	    "Rýdziková",
	    "Sabinovská",
	    "Sabinovská",
	    "Sad Janka Kráľa",
	    "Sadová",
	    "Sartorisova",
	    "Sasinkova",
	    "Seberíniho",
	    "Sečovská",
	    "Sedlárska",
	    "Sedmokrásková",
	    "Segnerova",
	    "Sekulská",
	    "Semianova",
	    "Senická",
	    "Senná",
	    "Schillerova",
	    "Schody pri starej vo",
	    "Sibírska",
	    "Sienkiewiczova",
	    "Silvánska",
	    "Sinokvetná",
	    "Skalická cesta",
	    "Skalná",
	    "Sklenárova",
	    "Sklenárska",
	    "Sládkovičova",
	    "Sladová",
	    "Slávičie údolie",
	    "Slavín",
	    "Slepá",
	    "Sliačska",
	    "Sliezska",
	    "Slivková",
	    "Slnečná",
	    "Slovanská",
	    "Slovinská",
	    "Slovnaftská",
	    "Slowackého",
	    "Smetanova",
	    "Smikova",
	    "Smolenická",
	    "Smolnícka",
	    "Smrečianska",
	    "Soferove schody",
	    "Socháňova",
	    "Sokolská",
	    "Solivarská",
	    "Sološnická",
	    "Somolického",
	    "Somolického",
	    "Sosnová",
	    "Spišská",
	    "Spojná",
	    "Spoločenská",
	    "Sputniková",
	    "Sreznevského",
	    "Srnčia",
	    "Stachanovská",
	    "Stálicová",
	    "Staničná",
	    "Stará Černicová",
	    "Stará Ivánska cesta",
	    "Stará Prievozská",
	    "Stará Vajnorská",
	    "Stará vinárska",
	    "Staré Grunty",
	    "Staré ihrisko",
	    "Staré záhrady",
	    "Starhradská",
	    "Starohájska",
	    "Staromestská",
	    "Staroturský chodník",
	    "Staviteľská",
	    "Stodolova",
	    "Stoklasová",
	    "Strakova",
	    "Strážnická",
	    "Strážny dom",
	    "Strečnianska",
	    "Stredná",
	    "Strelecká",
	    "Strmá cesta",
	    "Strojnícka",
	    "Stropkovská",
	    "Struková",
	    "Studená",
	    "Stuhová",
	    "Súbežná",
	    "Súhvezdná",
	    "Suché mýto",
	    "Suchohradská",
	    "Súkennícka",
	    "Súľovská",
	    "Sumbalova",
	    "Súmračná",
	    "Súťažná",
	    "Svätého Vincenta",
	    "Svätoplukova",
	    "Svätoplukova",
	    "Svätovojtešská",
	    "Svetlá",
	    "Svíbová",
	    "Svidnícka",
	    "Svoradova",
	    "Svrčia",
	    "Syslia",
	    "Šafárikovo námestie",
	    "Šafárikovo námestie",
	    "Šafránová",
	    "Šagátova",
	    "Šalviová",
	    "Šancová",
	    "Šancová",
	    "Šancová",
	    "Šancová",
	    "Šándorova",
	    "Šarišská",
	    "Šášovská",
	    "Šaštínska",
	    "Ševčenkova",
	    "Šintavská",
	    "Šípková",
	    "Škarniclova",
	    "Školská",
	    "Škovránčia",
	    "Škultétyho",
	    "Šoltésovej",
	    "Špieszova",
	    "Špitálska",
	    "Športová",
	    "Šrobárovo námestie",
	    "Šťastná",
	    "Štedrá",
	    "Štefánikova",
	    "Štefánikova",
	    "Štefánikova",
	    "Štefanovičova",
	    "Štefunkova",
	    "Štetinova",
	    "Štiavnická",
	    "Štúrova",
	    "Štyndlova",
	    "Šulekova",
	    "Šulekova",
	    "Šulekova",
	    "Šumavská",
	    "Šuňavcova",
	    "Šustekova",
	    "Švabinského",
	    "Tabaková",
	    "Tablicova",
	    "Táborská",
	    "Tajovského",
	    "Tallerova",
	    "Tehelná",
	    "Technická",
	    "Tekovská",
	    "Telocvičná",
	    "Tematínska",
	    "Teplická",
	    "Terchovská",
	    "Teslova",
	    "Tetmayerova",
	    "Thurzova",
	    "Tichá",
	    "Tilgnerova",
	    "Timravina",
	    "Tobrucká",
	    "Tokajícka",
	    "Tolstého",
	    "Tománkova",
	    "Tomášikova",
	    "Tomášikova",
	    "Tomášikova",
	    "Tomášikova",
	    "Tomášikova",
	    "Topoľčianska",
	    "Topoľová",
	    "Továrenská",
	    "Trebišovská",
	    "Trebišovská",
	    "Trebišovská",
	    "Trenčianska",
	    "Treskoňova",
	    "Trnavská cesta",
	    "Trnavská cesta",
	    "Trnavská cesta",
	    "Trnavská cesta",
	    "Trnavská cesta",
	    "Trnavské mýto",
	    "Tŕňová",
	    "Trojdomy",
	    "Tučkova",
	    "Tupolevova",
	    "Turbínova",
	    "Turčianska",
	    "Turnianska",
	    "Tvarožkova",
	    "Tylova",
	    "Tyršovo nábrežie",
	    "Údernícka",
	    "Údolná",
	    "Uhorková",
	    "Ukrajinská",
	    "Ulica 29. augusta",
	    "Ulica 29. augusta",
	    "Ulica 29. augusta",
	    "Ulica 29. augusta",
	    "Ulica Imricha Karvaš",
	    "Ulica Jozefa Krónera",
	    "Ulica Viktora Tegelh",
	    "Úprkova",
	    "Úradnícka",
	    "Uránová",
	    "Urbánkova",
	    "Ursínyho",
	    "Uršulínska",
	    "Úzka",
	    "V záhradách",
	    "Vajanského nábrežie",
	    "Vajnorská",
	    "Vajnorská",
	    "Vajnorská",
	    "Vajnorská",
	    "Vajnorská",
	    "Vajnorská",
	    "Vajnorská",
	    "Vajnorská",
	    "Vajnorská",
	    "Valašská",
	    "Valchárska",
	    "Vansovej",
	    "Vápenná",
	    "Varínska",
	    "Varšavská",
	    "Varšavská",
	    "Vavilovova",
	    "Vavrínova",
	    "Vazovova",
	    "Včelárska",
	    "Velehradská",
	    "Veltlínska",
	    "Ventúrska",
	    "Veterná",
	    "Veternicová",
	    "Vetvová",
	    "Viedenská cesta",
	    "Viedenská cesta",
	    "Vietnamská",
	    "Vígľašská",
	    "Vihorlatská",
	    "Viktorínova",
	    "Vilová",
	    "Vincenta Hložníka",
	    "Vínna",
	    "Vlastenecké námestie",
	    "Vlčkova",
	    "Vlčkova",
	    "Vlčkova",
	    "Vodný vrch",
	    "Votrubova",
	    "Vrábeľská",
	    "Vrakunská cesta",
	    "Vranovská",
	    "Vretenová",
	    "Vrchná",
	    "Vrútocká",
	    "Vyhliadka",
	    "Vyhnianska cesta",
	    "Vysoká",
	    "Vyšehradská",
	    "Vyšná",
	    "Wattova",
	    "Wilsonova",
	    "Wolkrova",
	    "Za Kasárňou",
	    "Za sokolovňou",
	    "Za Stanicou",
	    "Za tehelňou",
	    "Záborského",
	    "Zadunajská cesta",
	    "Záhorácka",
	    "Záhradnícka",
	    "Záhradnícka",
	    "Záhradnícka",
	    "Záhradnícka",
	    "Záhrebská",
	    "Záhrebská",
	    "Zálužická",
	    "Zámocká",
	    "Zámocké schody",
	    "Zámočnícka",
	    "Západná",
	    "Západný rad",
	    "Záporožská",
	    "Zátišie",
	    "Závodníkova",
	    "Zelená",
	    "Zelinárska",
	    "Zimná",
	    "Zlaté piesky",
	    "Zlaté schody",
	    "Znievska",
	    "Zohorská",
	    "Zochova",
	    "Zrinského",
	    "Zvolenská",
	    "Žabí majer",
	    "Žabotova",
	    "Žehrianska",
	    "Železná",
	    "Železničiarska",
	    "Žellova",
	    "Žiarska",
	    "Židovská",
	    "Žilinská",
	    "Žilinská",
	    "Živnostenská",
	    "Žižkova",
	    "Župné námestie"
	  ],
	  "street_name": [
	    "#{street}"
	  ],
	  "street_address": [
	    "#{street_name} #{building_number}"
	  ],
	  "default_country": [
	    "Slovensko"
	  ]
	};
	sk.company = {
	  "suffix": [
	    "s.r.o.",
	    "a.s.",
	    "v.o.s."
	  ],
	  "adjective": [
	      "Adaptive",
	      "Advanced",
	      "Ameliorated",
	      "Assimilated",
	      "Automated",
	      "Balanced",
	      "Business-focused",
	      "Centralized",
	      "Cloned",
	      "Compatible",
	      "Configurable",
	      "Cross-group",
	      "Cross-platform",
	      "Customer-focused",
	      "Customizable",
	      "Decentralized",
	      "De-engineered",
	      "Devolved",
	      "Digitized",
	      "Distributed",
	      "Diverse",
	      "Down-sized",
	      "Enhanced",
	      "Enterprise-wide",
	      "Ergonomic",
	      "Exclusive",
	      "Expanded",
	      "Extended",
	      "Face to face",
	      "Focused",
	      "Front-line",
	      "Fully-configurable",
	      "Function-based",
	      "Fundamental",
	      "Future-proofed",
	      "Grass-roots",
	      "Horizontal",
	      "Implemented",
	      "Innovative",
	      "Integrated",
	      "Intuitive",
	      "Inverse",
	      "Managed",
	      "Mandatory",
	      "Monitored",
	      "Multi-channelled",
	      "Multi-lateral",
	      "Multi-layered",
	      "Multi-tiered",
	      "Networked",
	      "Object-based",
	      "Open-architected",
	      "Open-source",
	      "Operative",
	      "Optimized",
	      "Optional",
	      "Organic",
	      "Organized",
	      "Persevering",
	      "Persistent",
	      "Phased",
	      "Polarised",
	      "Pre-emptive",
	      "Proactive",
	      "Profit-focused",
	      "Profound",
	      "Programmable",
	      "Progressive",
	      "Public-key",
	      "Quality-focused",
	      "Reactive",
	      "Realigned",
	      "Re-contextualized",
	      "Re-engineered",
	      "Reduced",
	      "Reverse-engineered",
	      "Right-sized",
	      "Robust",
	      "Seamless",
	      "Secured",
	      "Self-enabling",
	      "Sharable",
	      "Stand-alone",
	      "Streamlined",
	      "Switchable",
	      "Synchronised",
	      "Synergistic",
	      "Synergized",
	      "Team-oriented",
	      "Total",
	      "Triple-buffered",
	      "Universal",
	      "Up-sized",
	      "Upgradable",
	      "User-centric",
	      "User-friendly",
	      "Versatile",
	      "Virtual",
	      "Visionary",
	      "Vision-oriented"
	    ],
	    "descriptor":
	    [
	      "24 hour",
	      "24/7",
	      "3rd generation",
	      "4th generation",
	      "5th generation",
	      "6th generation",
	      "actuating",
	      "analyzing",
	      "asymmetric",
	      "asynchronous",
	      "attitude-oriented",
	      "background",
	      "bandwidth-monitored",
	      "bi-directional",
	      "bifurcated",
	      "bottom-line",
	      "clear-thinking",
	      "client-driven",
	      "client-server",
	      "coherent",
	      "cohesive",
	      "composite",
	      "context-sensitive",
	      "contextually-based",
	      "content-based",
	      "dedicated",
	      "demand-driven",
	      "didactic",
	      "directional",
	      "discrete",
	      "disintermediate",
	      "dynamic",
	      "eco-centric",
	      "empowering",
	      "encompassing",
	      "even-keeled",
	      "executive",
	      "explicit",
	      "exuding",
	      "fault-tolerant",
	      "foreground",
	      "fresh-thinking",
	      "full-range",
	      "global",
	      "grid-enabled",
	      "heuristic",
	      "high-level",
	      "holistic",
	      "homogeneous",
	      "human-resource",
	      "hybrid",
	      "impactful",
	      "incremental",
	      "intangible",
	      "interactive",
	      "intermediate",
	      "leading edge",
	      "local",
	      "logistical",
	      "maximized",
	      "methodical",
	      "mission-critical",
	      "mobile",
	      "modular",
	      "motivating",
	      "multimedia",
	      "multi-state",
	      "multi-tasking",
	      "national",
	      "needs-based",
	      "neutral",
	      "next generation",
	      "non-volatile",
	      "object-oriented",
	      "optimal",
	      "optimizing",
	      "radical",
	      "real-time",
	      "reciprocal",
	      "regional",
	      "responsive",
	      "scalable",
	      "secondary",
	      "solution-oriented",
	      "stable",
	      "static",
	      "systematic",
	      "systemic",
	      "system-worthy",
	      "tangible",
	      "tertiary",
	      "transitional",
	      "uniform",
	      "upward-trending",
	      "user-facing",
	      "value-added",
	      "web-enabled",
	      "well-modulated",
	      "zero administration",
	      "zero defect",
	      "zero tolerance"
	    ],
	    "noun":
	    [
	      "ability",
	      "access",
	      "adapter",
	      "algorithm",
	      "alliance",
	      "analyzer",
	      "application",
	      "approach",
	      "architecture",
	      "archive",
	      "artificial intelligence",
	      "array",
	      "attitude",
	      "benchmark",
	      "budgetary management",
	      "capability",
	      "capacity",
	      "challenge",
	      "circuit",
	      "collaboration",
	      "complexity",
	      "concept",
	      "conglomeration",
	      "contingency",
	      "core",
	      "customer loyalty",
	      "database",
	      "data-warehouse",
	      "definition",
	      "emulation",
	      "encoding",
	      "encryption",
	      "extranet",
	      "firmware",
	      "flexibility",
	      "focus group",
	      "forecast",
	      "frame",
	      "framework",
	      "function",
	      "functionalities",
	      "Graphic Interface",
	      "groupware",
	      "Graphical User Interface",
	      "hardware",
	      "help-desk",
	      "hierarchy",
	      "hub",
	      "implementation",
	      "info-mediaries",
	      "infrastructure",
	      "initiative",
	      "installation",
	      "instruction set",
	      "interface",
	      "internet solution",
	      "intranet",
	      "knowledge user",
	      "knowledge base",
	      "local area network",
	      "leverage",
	      "matrices",
	      "matrix",
	      "methodology",
	      "middleware",
	      "migration",
	      "model",
	      "moderator",
	      "monitoring",
	      "moratorium",
	      "neural-net",
	      "open architecture",
	      "open system",
	      "orchestration",
	      "paradigm",
	      "parallelism",
	      "policy",
	      "portal",
	      "pricing structure",
	      "process improvement",
	      "product",
	      "productivity",
	      "project",
	      "projection",
	      "protocol",
	      "secured line",
	      "service-desk",
	      "software",
	      "solution",
	      "standardization",
	      "strategy",
	      "structure",
	      "success",
	      "superstructure",
	      "support",
	      "synergy",
	      "system engine",
	      "task-force",
	      "throughput",
	      "time-frame",
	      "toolset",
	      "utilisation",
	      "website",
	      "workforce"
	  ],
	  "bs_verb": [
	      "implement",
	      "utilize",
	      "integrate",
	      "streamline",
	      "optimize",
	      "evolve",
	      "transform",
	      "embrace",
	      "enable",
	      "orchestrate",
	      "leverage",
	      "reinvent",
	      "aggregate",
	      "architect",
	      "enhance",
	      "incentivize",
	      "morph",
	      "empower",
	      "envisioneer",
	      "monetize",
	      "harness",
	      "facilitate",
	      "seize",
	      "disintermediate",
	      "synergize",
	      "strategize",
	      "deploy",
	      "brand",
	      "grow",
	      "target",
	      "syndicate",
	      "synthesize",
	      "deliver",
	      "mesh",
	      "incubate",
	      "engage",
	      "maximize",
	      "benchmark",
	      "expedite",
	      "reintermediate",
	      "whiteboard",
	      "visualize",
	      "repurpose",
	      "innovate",
	      "scale",
	      "unleash",
	      "drive",
	      "extend",
	      "engineer",
	      "revolutionize",
	      "generate",
	      "exploit",
	      "transition",
	      "e-enable",
	      "iterate",
	      "cultivate",
	      "matrix",
	      "productize",
	      "redefine",
	      "recontextualize"
	    ],
	    "bs_noun": [
	      "clicks-and-mortar",
	      "value-added",
	      "vertical",
	      "proactive",
	      "robust",
	      "revolutionary",
	      "scalable",
	      "leading-edge",
	      "innovative",
	      "intuitive",
	      "strategic",
	      "e-business",
	      "mission-critical",
	      "sticky",
	      "one-to-one",
	      "24/7",
	      "end-to-end",
	      "global",
	      "B2B",
	      "B2C",
	      "granular",
	      "frictionless",
	      "virtual",
	      "viral",
	      "dynamic",
	      "24/365",
	      "best-of-breed",
	      "killer",
	      "magnetic",
	      "bleeding-edge",
	      "web-enabled",
	      "interactive",
	      "dot-com",
	      "sexy",
	      "back-end",
	      "real-time",
	      "efficient",
	      "front-end",
	      "distributed",
	      "seamless",
	      "extensible",
	      "turn-key",
	      "world-class",
	      "open-source",
	      "cross-platform",
	      "cross-media",
	      "synergistic",
	      "bricks-and-clicks",
	      "out-of-the-box",
	      "enterprise",
	      "integrated",
	      "impactful",
	      "wireless",
	      "transparent",
	      "next-generation",
	      "cutting-edge",
	      "user-centric",
	      "visionary",
	      "customized",
	      "ubiquitous",
	      "plug-and-play",
	      "collaborative",
	      "compelling",
	      "holistic",
	      "rich",
	      "synergies",
	      "web-readiness",
	      "paradigms",
	      "markets",
	      "partnerships",
	      "infrastructures",
	      "platforms",
	      "initiatives",
	      "channels",
	      "eyeballs",
	      "communities",
	      "ROI",
	      "solutions",
	      "e-tailers",
	      "e-services",
	      "action-items",
	      "portals",
	      "niches",
	      "technologies",
	      "content",
	      "vortals",
	      "supply-chains",
	      "convergence",
	      "relationships",
	      "architectures",
	      "interfaces",
	      "e-markets",
	      "e-commerce",
	      "systems",
	      "bandwidth",
	      "infomediaries",
	      "models",
	      "mindshare",
	      "deliverables",
	      "users",
	      "schemas",
	      "networks",
	      "applications",
	      "metrics",
	      "e-business",
	      "functionalities",
	      "experiences",
	      "web services",
	      "methodologies"
	  ],
	  "name": [
	    "#{Name.last_name} #{suffix}",
	    "#{Name.last_name} #{suffix}",
	    "#{Name.man_last_name} a #{Name.man_last_name} #{suffix}"
	  ]
	};
	sk.internet = {
	  "free_email": [
	    "gmail.com",
	    "zoznam.sk",
	    "azet.sk"
	  ],
	  "domain_suffix": [
	    "sk",
	    "com",
	    "net",
	    "eu",
	    "org"
	  ]
	};
	sk.lorem = {
	  "words": [
	    "alias",
	    "consequatur",
	    "aut",
	    "perferendis",
	    "sit",
	    "voluptatem",
	    "accusantium",
	    "doloremque",
	    "aperiam",
	    "eaque",
	    "ipsa",
	    "quae",
	    "ab",
	    "illo",
	    "inventore",
	    "veritatis",
	    "et",
	    "quasi",
	    "architecto",
	    "beatae",
	    "vitae",
	    "dicta",
	    "sunt",
	    "explicabo",
	    "aspernatur",
	    "aut",
	    "odit",
	    "aut",
	    "fugit",
	    "sed",
	    "quia",
	    "consequuntur",
	    "magni",
	    "dolores",
	    "eos",
	    "qui",
	    "ratione",
	    "voluptatem",
	    "sequi",
	    "nesciunt",
	    "neque",
	    "dolorem",
	    "ipsum",
	    "quia",
	    "dolor",
	    "sit",
	    "amet",
	    "consectetur",
	    "adipisci",
	    "velit",
	    "sed",
	    "quia",
	    "non",
	    "numquam",
	    "eius",
	    "modi",
	    "tempora",
	    "incidunt",
	    "ut",
	    "labore",
	    "et",
	    "dolore",
	    "magnam",
	    "aliquam",
	    "quaerat",
	    "voluptatem",
	    "ut",
	    "enim",
	    "ad",
	    "minima",
	    "veniam",
	    "quis",
	    "nostrum",
	    "exercitationem",
	    "ullam",
	    "corporis",
	    "nemo",
	    "enim",
	    "ipsam",
	    "voluptatem",
	    "quia",
	    "voluptas",
	    "sit",
	    "suscipit",
	    "laboriosam",
	    "nisi",
	    "ut",
	    "aliquid",
	    "ex",
	    "ea",
	    "commodi",
	    "consequatur",
	    "quis",
	    "autem",
	    "vel",
	    "eum",
	    "iure",
	    "reprehenderit",
	    "qui",
	    "in",
	    "ea",
	    "voluptate",
	    "velit",
	    "esse",
	    "quam",
	    "nihil",
	    "molestiae",
	    "et",
	    "iusto",
	    "odio",
	    "dignissimos",
	    "ducimus",
	    "qui",
	    "blanditiis",
	    "praesentium",
	    "laudantium",
	    "totam",
	    "rem",
	    "voluptatum",
	    "deleniti",
	    "atque",
	    "corrupti",
	    "quos",
	    "dolores",
	    "et",
	    "quas",
	    "molestias",
	    "excepturi",
	    "sint",
	    "occaecati",
	    "cupiditate",
	    "non",
	    "provident",
	    "sed",
	    "ut",
	    "perspiciatis",
	    "unde",
	    "omnis",
	    "iste",
	    "natus",
	    "error",
	    "similique",
	    "sunt",
	    "in",
	    "culpa",
	    "qui",
	    "officia",
	    "deserunt",
	    "mollitia",
	    "animi",
	    "id",
	    "est",
	    "laborum",
	    "et",
	    "dolorum",
	    "fuga",
	    "et",
	    "harum",
	    "quidem",
	    "rerum",
	    "facilis",
	    "est",
	    "et",
	    "expedita",
	    "distinctio",
	    "nam",
	    "libero",
	    "tempore",
	    "cum",
	    "soluta",
	    "nobis",
	    "est",
	    "eligendi",
	    "optio",
	    "cumque",
	    "nihil",
	    "impedit",
	    "quo",
	    "porro",
	    "quisquam",
	    "est",
	    "qui",
	    "minus",
	    "id",
	    "quod",
	    "maxime",
	    "placeat",
	    "facere",
	    "possimus",
	    "omnis",
	    "voluptas",
	    "assumenda",
	    "est",
	    "omnis",
	    "dolor",
	    "repellendus",
	    "temporibus",
	    "autem",
	    "quibusdam",
	    "et",
	    "aut",
	    "consequatur",
	    "vel",
	    "illum",
	    "qui",
	    "dolorem",
	    "eum",
	    "fugiat",
	    "quo",
	    "voluptas",
	    "nulla",
	    "pariatur",
	    "at",
	    "vero",
	    "eos",
	    "et",
	    "accusamus",
	    "officiis",
	    "debitis",
	    "aut",
	    "rerum",
	    "necessitatibus",
	    "saepe",
	    "eveniet",
	    "ut",
	    "et",
	    "voluptates",
	    "repudiandae",
	    "sint",
	    "et",
	    "molestiae",
	    "non",
	    "recusandae",
	    "itaque",
	    "earum",
	    "rerum",
	    "hic",
	    "tenetur",
	    "a",
	    "sapiente",
	    "delectus",
	    "ut",
	    "aut",
	    "reiciendis",
	    "voluptatibus",
	    "maiores",
	    "doloribus",
	    "asperiores",
	    "repellat"
	  ],
	  "supplemental": [
	    "abbas",
	    "abduco",
	    "abeo",
	    "abscido",
	    "absconditus",
	    "absens",
	    "absorbeo",
	    "absque",
	    "abstergo",
	    "absum",
	    "abundans",
	    "abutor",
	    "accedo",
	    "accendo",
	    "acceptus",
	    "accipio",
	    "accommodo",
	    "accusator",
	    "acer",
	    "acerbitas",
	    "acervus",
	    "acidus",
	    "acies",
	    "acquiro",
	    "acsi",
	    "adamo",
	    "adaugeo",
	    "addo",
	    "adduco",
	    "ademptio",
	    "adeo",
	    "adeptio",
	    "adfectus",
	    "adfero",
	    "adficio",
	    "adflicto",
	    "adhaero",
	    "adhuc",
	    "adicio",
	    "adimpleo",
	    "adinventitias",
	    "adipiscor",
	    "adiuvo",
	    "administratio",
	    "admiratio",
	    "admitto",
	    "admoneo",
	    "admoveo",
	    "adnuo",
	    "adopto",
	    "adsidue",
	    "adstringo",
	    "adsuesco",
	    "adsum",
	    "adulatio",
	    "adulescens",
	    "adultus",
	    "aduro",
	    "advenio",
	    "adversus",
	    "advoco",
	    "aedificium",
	    "aeger",
	    "aegre",
	    "aegrotatio",
	    "aegrus",
	    "aeneus",
	    "aequitas",
	    "aequus",
	    "aer",
	    "aestas",
	    "aestivus",
	    "aestus",
	    "aetas",
	    "aeternus",
	    "ager",
	    "aggero",
	    "aggredior",
	    "agnitio",
	    "agnosco",
	    "ago",
	    "ait",
	    "aiunt",
	    "alienus",
	    "alii",
	    "alioqui",
	    "aliqua",
	    "alius",
	    "allatus",
	    "alo",
	    "alter",
	    "altus",
	    "alveus",
	    "amaritudo",
	    "ambitus",
	    "ambulo",
	    "amicitia",
	    "amiculum",
	    "amissio",
	    "amita",
	    "amitto",
	    "amo",
	    "amor",
	    "amoveo",
	    "amplexus",
	    "amplitudo",
	    "amplus",
	    "ancilla",
	    "angelus",
	    "angulus",
	    "angustus",
	    "animadverto",
	    "animi",
	    "animus",
	    "annus",
	    "anser",
	    "ante",
	    "antea",
	    "antepono",
	    "antiquus",
	    "aperio",
	    "aperte",
	    "apostolus",
	    "apparatus",
	    "appello",
	    "appono",
	    "appositus",
	    "approbo",
	    "apto",
	    "aptus",
	    "apud",
	    "aqua",
	    "ara",
	    "aranea",
	    "arbitro",
	    "arbor",
	    "arbustum",
	    "arca",
	    "arceo",
	    "arcesso",
	    "arcus",
	    "argentum",
	    "argumentum",
	    "arguo",
	    "arma",
	    "armarium",
	    "armo",
	    "aro",
	    "ars",
	    "articulus",
	    "artificiose",
	    "arto",
	    "arx",
	    "ascisco",
	    "ascit",
	    "asper",
	    "aspicio",
	    "asporto",
	    "assentator",
	    "astrum",
	    "atavus",
	    "ater",
	    "atqui",
	    "atrocitas",
	    "atrox",
	    "attero",
	    "attollo",
	    "attonbitus",
	    "auctor",
	    "auctus",
	    "audacia",
	    "audax",
	    "audentia",
	    "audeo",
	    "audio",
	    "auditor",
	    "aufero",
	    "aureus",
	    "auris",
	    "aurum",
	    "aut",
	    "autem",
	    "autus",
	    "auxilium",
	    "avaritia",
	    "avarus",
	    "aveho",
	    "averto",
	    "avoco",
	    "baiulus",
	    "balbus",
	    "barba",
	    "bardus",
	    "basium",
	    "beatus",
	    "bellicus",
	    "bellum",
	    "bene",
	    "beneficium",
	    "benevolentia",
	    "benigne",
	    "bestia",
	    "bibo",
	    "bis",
	    "blandior",
	    "bonus",
	    "bos",
	    "brevis",
	    "cado",
	    "caecus",
	    "caelestis",
	    "caelum",
	    "calamitas",
	    "calcar",
	    "calco",
	    "calculus",
	    "callide",
	    "campana",
	    "candidus",
	    "canis",
	    "canonicus",
	    "canto",
	    "capillus",
	    "capio",
	    "capitulus",
	    "capto",
	    "caput",
	    "carbo",
	    "carcer",
	    "careo",
	    "caries",
	    "cariosus",
	    "caritas",
	    "carmen",
	    "carpo",
	    "carus",
	    "casso",
	    "caste",
	    "casus",
	    "catena",
	    "caterva",
	    "cattus",
	    "cauda",
	    "causa",
	    "caute",
	    "caveo",
	    "cavus",
	    "cedo",
	    "celebrer",
	    "celer",
	    "celo",
	    "cena",
	    "cenaculum",
	    "ceno",
	    "censura",
	    "centum",
	    "cerno",
	    "cernuus",
	    "certe",
	    "certo",
	    "certus",
	    "cervus",
	    "cetera",
	    "charisma",
	    "chirographum",
	    "cibo",
	    "cibus",
	    "cicuta",
	    "cilicium",
	    "cimentarius",
	    "ciminatio",
	    "cinis",
	    "circumvenio",
	    "cito",
	    "civis",
	    "civitas",
	    "clam",
	    "clamo",
	    "claro",
	    "clarus",
	    "claudeo",
	    "claustrum",
	    "clementia",
	    "clibanus",
	    "coadunatio",
	    "coaegresco",
	    "coepi",
	    "coerceo",
	    "cogito",
	    "cognatus",
	    "cognomen",
	    "cogo",
	    "cohaero",
	    "cohibeo",
	    "cohors",
	    "colligo",
	    "colloco",
	    "collum",
	    "colo",
	    "color",
	    "coma",
	    "combibo",
	    "comburo",
	    "comedo",
	    "comes",
	    "cometes",
	    "comis",
	    "comitatus",
	    "commemoro",
	    "comminor",
	    "commodo",
	    "communis",
	    "comparo",
	    "compello",
	    "complectus",
	    "compono",
	    "comprehendo",
	    "comptus",
	    "conatus",
	    "concedo",
	    "concido",
	    "conculco",
	    "condico",
	    "conduco",
	    "confero",
	    "confido",
	    "conforto",
	    "confugo",
	    "congregatio",
	    "conicio",
	    "coniecto",
	    "conitor",
	    "coniuratio",
	    "conor",
	    "conqueror",
	    "conscendo",
	    "conservo",
	    "considero",
	    "conspergo",
	    "constans",
	    "consuasor",
	    "contabesco",
	    "contego",
	    "contigo",
	    "contra",
	    "conturbo",
	    "conventus",
	    "convoco",
	    "copia",
	    "copiose",
	    "cornu",
	    "corona",
	    "corpus",
	    "correptius",
	    "corrigo",
	    "corroboro",
	    "corrumpo",
	    "coruscus",
	    "cotidie",
	    "crapula",
	    "cras",
	    "crastinus",
	    "creator",
	    "creber",
	    "crebro",
	    "credo",
	    "creo",
	    "creptio",
	    "crepusculum",
	    "cresco",
	    "creta",
	    "cribro",
	    "crinis",
	    "cruciamentum",
	    "crudelis",
	    "cruentus",
	    "crur",
	    "crustulum",
	    "crux",
	    "cubicularis",
	    "cubitum",
	    "cubo",
	    "cui",
	    "cuius",
	    "culpa",
	    "culpo",
	    "cultellus",
	    "cultura",
	    "cum",
	    "cunabula",
	    "cunae",
	    "cunctatio",
	    "cupiditas",
	    "cupio",
	    "cuppedia",
	    "cupressus",
	    "cur",
	    "cura",
	    "curatio",
	    "curia",
	    "curiositas",
	    "curis",
	    "curo",
	    "curriculum",
	    "currus",
	    "cursim",
	    "curso",
	    "cursus",
	    "curto",
	    "curtus",
	    "curvo",
	    "curvus",
	    "custodia",
	    "damnatio",
	    "damno",
	    "dapifer",
	    "debeo",
	    "debilito",
	    "decens",
	    "decerno",
	    "decet",
	    "decimus",
	    "decipio",
	    "decor",
	    "decretum",
	    "decumbo",
	    "dedecor",
	    "dedico",
	    "deduco",
	    "defaeco",
	    "defendo",
	    "defero",
	    "defessus",
	    "defetiscor",
	    "deficio",
	    "defigo",
	    "defleo",
	    "defluo",
	    "defungo",
	    "degenero",
	    "degero",
	    "degusto",
	    "deinde",
	    "delectatio",
	    "delego",
	    "deleo",
	    "delibero",
	    "delicate",
	    "delinquo",
	    "deludo",
	    "demens",
	    "demergo",
	    "demitto",
	    "demo",
	    "demonstro",
	    "demoror",
	    "demulceo",
	    "demum",
	    "denego",
	    "denique",
	    "dens",
	    "denuncio",
	    "denuo",
	    "deorsum",
	    "depereo",
	    "depono",
	    "depopulo",
	    "deporto",
	    "depraedor",
	    "deprecator",
	    "deprimo",
	    "depromo",
	    "depulso",
	    "deputo",
	    "derelinquo",
	    "derideo",
	    "deripio",
	    "desidero",
	    "desino",
	    "desipio",
	    "desolo",
	    "desparatus",
	    "despecto",
	    "despirmatio",
	    "infit",
	    "inflammatio",
	    "paens",
	    "patior",
	    "patria",
	    "patrocinor",
	    "patruus",
	    "pauci",
	    "paulatim",
	    "pauper",
	    "pax",
	    "peccatus",
	    "pecco",
	    "pecto",
	    "pectus",
	    "pecunia",
	    "pecus",
	    "peior",
	    "pel",
	    "ocer",
	    "socius",
	    "sodalitas",
	    "sol",
	    "soleo",
	    "solio",
	    "solitudo",
	    "solium",
	    "sollers",
	    "sollicito",
	    "solum",
	    "solus",
	    "solutio",
	    "solvo",
	    "somniculosus",
	    "somnus",
	    "sonitus",
	    "sono",
	    "sophismata",
	    "sopor",
	    "sordeo",
	    "sortitus",
	    "spargo",
	    "speciosus",
	    "spectaculum",
	    "speculum",
	    "sperno",
	    "spero",
	    "spes",
	    "spiculum",
	    "spiritus",
	    "spoliatio",
	    "sponte",
	    "stabilis",
	    "statim",
	    "statua",
	    "stella",
	    "stillicidium",
	    "stipes",
	    "stips",
	    "sto",
	    "strenuus",
	    "strues",
	    "studio",
	    "stultus",
	    "suadeo",
	    "suasoria",
	    "sub",
	    "subito",
	    "subiungo",
	    "sublime",
	    "subnecto",
	    "subseco",
	    "substantia",
	    "subvenio",
	    "succedo",
	    "succurro",
	    "sufficio",
	    "suffoco",
	    "suffragium",
	    "suggero",
	    "sui",
	    "sulum",
	    "sum",
	    "summa",
	    "summisse",
	    "summopere",
	    "sumo",
	    "sumptus",
	    "supellex",
	    "super",
	    "suppellex",
	    "supplanto",
	    "suppono",
	    "supra",
	    "surculus",
	    "surgo",
	    "sursum",
	    "suscipio",
	    "suspendo",
	    "sustineo",
	    "suus",
	    "synagoga",
	    "tabella",
	    "tabernus",
	    "tabesco",
	    "tabgo",
	    "tabula",
	    "taceo",
	    "tactus",
	    "taedium",
	    "talio",
	    "talis",
	    "talus",
	    "tam",
	    "tamdiu",
	    "tamen",
	    "tametsi",
	    "tamisium",
	    "tamquam",
	    "tandem",
	    "tantillus",
	    "tantum",
	    "tardus",
	    "tego",
	    "temeritas",
	    "temperantia",
	    "templum",
	    "temptatio",
	    "tempus",
	    "tenax",
	    "tendo",
	    "teneo",
	    "tener",
	    "tenuis",
	    "tenus",
	    "tepesco",
	    "tepidus",
	    "ter",
	    "terebro",
	    "teres",
	    "terga",
	    "tergeo",
	    "tergiversatio",
	    "tergo",
	    "tergum",
	    "termes",
	    "terminatio",
	    "tero",
	    "terra",
	    "terreo",
	    "territo",
	    "terror",
	    "tersus",
	    "tertius",
	    "testimonium",
	    "texo",
	    "textilis",
	    "textor",
	    "textus",
	    "thalassinus",
	    "theatrum",
	    "theca",
	    "thema",
	    "theologus",
	    "thermae",
	    "thesaurus",
	    "thesis",
	    "thorax",
	    "thymbra",
	    "thymum",
	    "tibi",
	    "timidus",
	    "timor",
	    "titulus",
	    "tolero",
	    "tollo",
	    "tondeo",
	    "tonsor",
	    "torqueo",
	    "torrens",
	    "tot",
	    "totidem",
	    "toties",
	    "totus",
	    "tracto",
	    "trado",
	    "traho",
	    "trans",
	    "tredecim",
	    "tremo",
	    "trepide",
	    "tres",
	    "tribuo",
	    "tricesimus",
	    "triduana",
	    "triginta",
	    "tripudio",
	    "tristis",
	    "triumphus",
	    "trucido",
	    "truculenter",
	    "tubineus",
	    "tui",
	    "tum",
	    "tumultus",
	    "tunc",
	    "turba",
	    "turbo",
	    "turpe",
	    "turpis",
	    "tutamen",
	    "tutis",
	    "tyrannus",
	    "uberrime",
	    "ubi",
	    "ulciscor",
	    "ullus",
	    "ulterius",
	    "ultio",
	    "ultra",
	    "umbra",
	    "umerus",
	    "umquam",
	    "una",
	    "unde",
	    "undique",
	    "universe",
	    "unus",
	    "urbanus",
	    "urbs",
	    "uredo",
	    "usitas",
	    "usque",
	    "ustilo",
	    "ustulo",
	    "usus",
	    "uter",
	    "uterque",
	    "utilis",
	    "utique",
	    "utor",
	    "utpote",
	    "utrimque",
	    "utroque",
	    "utrum",
	    "uxor",
	    "vaco",
	    "vacuus",
	    "vado",
	    "vae",
	    "valde",
	    "valens",
	    "valeo",
	    "valetudo",
	    "validus",
	    "vallum",
	    "vapulus",
	    "varietas",
	    "varius",
	    "vehemens",
	    "vel",
	    "velociter",
	    "velum",
	    "velut",
	    "venia",
	    "venio",
	    "ventito",
	    "ventosus",
	    "ventus",
	    "venustas",
	    "ver",
	    "verbera",
	    "verbum",
	    "vere",
	    "verecundia",
	    "vereor",
	    "vergo",
	    "veritas",
	    "vero",
	    "versus",
	    "verto",
	    "verumtamen",
	    "verus",
	    "vesco",
	    "vesica",
	    "vesper",
	    "vespillo",
	    "vester",
	    "vestigium",
	    "vestrum",
	    "vetus",
	    "via",
	    "vicinus",
	    "vicissitudo",
	    "victoria",
	    "victus",
	    "videlicet",
	    "video",
	    "viduata",
	    "viduo",
	    "vigilo",
	    "vigor",
	    "vilicus",
	    "vilis",
	    "vilitas",
	    "villa",
	    "vinco",
	    "vinculum",
	    "vindico",
	    "vinitor",
	    "vinum",
	    "vir",
	    "virga",
	    "virgo",
	    "viridis",
	    "viriliter",
	    "virtus",
	    "vis",
	    "viscus",
	    "vita",
	    "vitiosus",
	    "vitium",
	    "vito",
	    "vivo",
	    "vix",
	    "vobis",
	    "vociferor",
	    "voco",
	    "volaticus",
	    "volo",
	    "volubilis",
	    "voluntarius",
	    "volup",
	    "volutabrum",
	    "volva",
	    "vomer",
	    "vomica",
	    "vomito",
	    "vorago",
	    "vorax",
	    "voro",
	    "vos",
	    "votum",
	    "voveo",
	    "vox",
	    "vulariter",
	    "vulgaris",
	    "vulgivagus",
	    "vulgo",
	    "vulgus",
	    "vulnero",
	    "vulnus",
	    "vulpes",
	    "vulticulus",
	    "vultuosus",
	    "xiphias"
	  ]
	};
	sk.name = {
	  "man_first_name": [
	    "Drahoslav",
	    "Severín",
	    "Alexej",
	    "Ernest",
	    "Rastislav",
	    "Radovan",
	    "Dobroslav",
	    "Dalibor",
	    "Vincent",
	    "Miloš",
	    "Timotej",
	    "Gejza",
	    "Bohuš",
	    "Alfonz",
	    "Gašpar",
	    "Emil",
	    "Erik",
	    "Blažej",
	    "Zdenko",
	    "Dezider",
	    "Arpád",
	    "Valentín",
	    "Pravoslav",
	    "Jaromír",
	    "Roman",
	    "Matej",
	    "Frederik",
	    "Viktor",
	    "Alexander",
	    "Radomír",
	    "Albín",
	    "Bohumil",
	    "Kazimír",
	    "Fridrich",
	    "Radoslav",
	    "Tomáš",
	    "Alan",
	    "Branislav",
	    "Bruno",
	    "Gregor",
	    "Vlastimil",
	    "Boleslav",
	    "Eduard",
	    "Jozef",
	    "Víťazoslav",
	    "Blahoslav",
	    "Beňadik",
	    "Adrián",
	    "Gabriel",
	    "Marián",
	    "Emanuel",
	    "Miroslav",
	    "Benjamín",
	    "Hugo",
	    "Richard",
	    "Izidor",
	    "Zoltán",
	    "Albert",
	    "Igor",
	    "Július",
	    "Aleš",
	    "Fedor",
	    "Rudolf",
	    "Valér",
	    "Marcel",
	    "Ervín",
	    "Slavomír",
	    "Vojtech",
	    "Juraj",
	    "Marek",
	    "Jaroslav",
	    "Žigmund",
	    "Florián",
	    "Roland",
	    "Pankrác",
	    "Servác",
	    "Bonifác",
	    "Svetozár",
	    "Bernard",
	    "Júlia",
	    "Urban",
	    "Dušan",
	    "Viliam",
	    "Ferdinand",
	    "Norbert",
	    "Róbert",
	    "Medard",
	    "Zlatko",
	    "Anton",
	    "Vasil",
	    "Vít",
	    "Adolf",
	    "Vratislav",
	    "Alfréd",
	    "Alojz",
	    "Ján",
	    "Tadeáš",
	    "Ladislav",
	    "Peter",
	    "Pavol",
	    "Miloslav",
	    "Prokop",
	    "Cyril",
	    "Metod",
	    "Patrik",
	    "Oliver",
	    "Ivan",
	    "Kamil",
	    "Henrich",
	    "Drahomír",
	    "Bohuslav",
	    "Iľja",
	    "Daniel",
	    "Vladimír",
	    "Jakub",
	    "Krištof",
	    "Ignác",
	    "Gustáv",
	    "Jerguš",
	    "Dominik",
	    "Oskar",
	    "Vavrinec",
	    "Ľubomír",
	    "Mojmír",
	    "Leonard",
	    "Tichomír",
	    "Filip",
	    "Bartolomej",
	    "Ľudovít",
	    "Samuel",
	    "Augustín",
	    "Belo",
	    "Oleg",
	    "Bystrík",
	    "Ctibor",
	    "Ľudomil",
	    "Konštantín",
	    "Ľuboslav",
	    "Matúš",
	    "Móric",
	    "Ľuboš",
	    "Ľubor",
	    "Vladislav",
	    "Cyprián",
	    "Václav",
	    "Michal",
	    "Jarolím",
	    "Arnold",
	    "Levoslav",
	    "František",
	    "Dionýz",
	    "Maximilián",
	    "Koloman",
	    "Boris",
	    "Lukáš",
	    "Kristián",
	    "Vendelín",
	    "Sergej",
	    "Aurel",
	    "Demeter",
	    "Denis",
	    "Hubert",
	    "Karol",
	    "Imrich",
	    "René",
	    "Bohumír",
	    "Teodor",
	    "Tibor",
	    "Maroš",
	    "Martin",
	    "Svätopluk",
	    "Stanislav",
	    "Leopold",
	    "Eugen",
	    "Félix",
	    "Klement",
	    "Kornel",
	    "Milan",
	    "Vratko",
	    "Ondrej",
	    "Andrej",
	    "Edmund",
	    "Oldrich",
	    "Oto",
	    "Mikuláš",
	    "Ambróz",
	    "Radúz",
	    "Bohdan",
	    "Adam",
	    "Štefan",
	    "Dávid",
	    "Silvester"
	  ],
	  "woman_first_name": [
	    "Alexandra",
	    "Karina",
	    "Daniela",
	    "Andrea",
	    "Antónia",
	    "Bohuslava",
	    "Dáša",
	    "Malvína",
	    "Kristína",
	    "Nataša",
	    "Bohdana",
	    "Drahomíra",
	    "Sára",
	    "Zora",
	    "Tamara",
	    "Ema",
	    "Tatiana",
	    "Erika",
	    "Veronika",
	    "Agáta",
	    "Dorota",
	    "Vanda",
	    "Zoja",
	    "Gabriela",
	    "Perla",
	    "Ida",
	    "Liana",
	    "Miloslava",
	    "Vlasta",
	    "Lívia",
	    "Eleonóra",
	    "Etela",
	    "Romana",
	    "Zlatica",
	    "Anežka",
	    "Bohumila",
	    "Františka",
	    "Angela",
	    "Matilda",
	    "Svetlana",
	    "Ľubica",
	    "Alena",
	    "Soňa",
	    "Vieroslava",
	    "Zita",
	    "Miroslava",
	    "Irena",
	    "Milena",
	    "Estera",
	    "Justína",
	    "Dana",
	    "Danica",
	    "Jela",
	    "Jaroslava",
	    "Jarmila",
	    "Lea",
	    "Anastázia",
	    "Galina",
	    "Lesana",
	    "Hermína",
	    "Monika",
	    "Ingrida",
	    "Viktória",
	    "Blažena",
	    "Žofia",
	    "Sofia",
	    "Gizela",
	    "Viola",
	    "Gertrúda",
	    "Zina",
	    "Júlia",
	    "Juliana",
	    "Želmíra",
	    "Ela",
	    "Vanesa",
	    "Iveta",
	    "Vilma",
	    "Petronela",
	    "Žaneta",
	    "Xénia",
	    "Karolína",
	    "Lenka",
	    "Laura",
	    "Stanislava",
	    "Margaréta",
	    "Dobroslava",
	    "Blanka",
	    "Valéria",
	    "Paulína",
	    "Sidónia",
	    "Adriána",
	    "Beáta",
	    "Petra",
	    "Melánia",
	    "Diana",
	    "Berta",
	    "Patrícia",
	    "Lujza",
	    "Amália",
	    "Milota",
	    "Nina",
	    "Margita",
	    "Kamila",
	    "Dušana",
	    "Magdaléna",
	    "Oľga",
	    "Anna",
	    "Hana",
	    "Božena",
	    "Marta",
	    "Libuša",
	    "Božidara",
	    "Dominika",
	    "Hortenzia",
	    "Jozefína",
	    "Štefánia",
	    "Ľubomíra",
	    "Zuzana",
	    "Darina",
	    "Marcela",
	    "Milica",
	    "Elena",
	    "Helena",
	    "Lýdia",
	    "Anabela",
	    "Jana",
	    "Silvia",
	    "Nikola",
	    "Ružena",
	    "Nora",
	    "Drahoslava",
	    "Linda",
	    "Melinda",
	    "Rebeka",
	    "Rozália",
	    "Regína",
	    "Alica",
	    "Marianna",
	    "Miriama",
	    "Martina",
	    "Mária",
	    "Jolana",
	    "Ľudomila",
	    "Ľudmila",
	    "Olympia",
	    "Eugénia",
	    "Ľuboslava",
	    "Zdenka",
	    "Edita",
	    "Michaela",
	    "Stela",
	    "Viera",
	    "Natália",
	    "Eliška",
	    "Brigita",
	    "Valentína",
	    "Terézia",
	    "Vladimíra",
	    "Hedviga",
	    "Uršuľa",
	    "Alojza",
	    "Kvetoslava",
	    "Sabína",
	    "Dobromila",
	    "Klára",
	    "Simona",
	    "Aurélia",
	    "Denisa",
	    "Renáta",
	    "Irma",
	    "Agnesa",
	    "Klaudia",
	    "Alžbeta",
	    "Elvíra",
	    "Cecília",
	    "Emília",
	    "Katarína",
	    "Henrieta",
	    "Bibiána",
	    "Barbora",
	    "Marína",
	    "Izabela",
	    "Hilda",
	    "Otília",
	    "Lucia",
	    "Branislava",
	    "Bronislava",
	    "Ivica",
	    "Albína",
	    "Kornélia",
	    "Sláva",
	    "Slávka",
	    "Judita",
	    "Dagmara",
	    "Adela",
	    "Nadežda",
	    "Eva",
	    "Filoména",
	    "Ivana",
	    "Milada"
	  ],
	  "man_last_name": [
	    "Antal",
	    "Babka",
	    "Bahna",
	    "Bahno",
	    "Baláž",
	    "Baran",
	    "Baranka",
	    "Bartovič",
	    "Bartoš",
	    "Bača",
	    "Bernolák",
	    "Beňo",
	    "Bicek",
	    "Bielik",
	    "Blaho",
	    "Bondra",
	    "Bosák",
	    "Boška",
	    "Brezina",
	    "Bukovský",
	    "Chalupka",
	    "Chudík",
	    "Cibula",
	    "Cibulka",
	    "Cibuľa",
	    "Cyprich",
	    "Cíger",
	    "Danko",
	    "Daňko",
	    "Daňo",
	    "Debnár",
	    "Dej",
	    "Dekýš",
	    "Doležal",
	    "Dočolomanský",
	    "Droppa",
	    "Dubovský",
	    "Dudek",
	    "Dula",
	    "Dulla",
	    "Dusík",
	    "Dvonč",
	    "Dzurjanin",
	    "Dávid",
	    "Fabian",
	    "Fabián",
	    "Fajnor",
	    "Farkašovský",
	    "Fico",
	    "Filc",
	    "Filip",
	    "Finka",
	    "Ftorek",
	    "Gašpar",
	    "Gašparovič",
	    "Gocník",
	    "Gregor",
	    "Greguš",
	    "Grznár",
	    "Hablák",
	    "Habšuda",
	    "Halda",
	    "Haluška",
	    "Halák",
	    "Hanko",
	    "Hanzal",
	    "Haščák",
	    "Heretik",
	    "Hečko",
	    "Hlaváček",
	    "Hlinka",
	    "Holub",
	    "Holuby",
	    "Hossa",
	    "Hoza",
	    "Hraško",
	    "Hric",
	    "Hrmo",
	    "Hrušovský",
	    "Huba",
	    "Ihnačák",
	    "Janeček",
	    "Janoška",
	    "Jantošovič",
	    "Janík",
	    "Janček",
	    "Jedľovský",
	    "Jendek",
	    "Jonata",
	    "Jurina",
	    "Jurkovič",
	    "Jurík",
	    "Jánošík",
	    "Kafenda",
	    "Kaliský",
	    "Karul",
	    "Keníž",
	    "Klapka",
	    "Kmeť",
	    "Kolesár",
	    "Kollár",
	    "Kolnik",
	    "Kolník",
	    "Kolár",
	    "Korec",
	    "Kostka",
	    "Kostrec",
	    "Kováč",
	    "Kováčik",
	    "Koza",
	    "Kočiš",
	    "Krajíček",
	    "Krajči",
	    "Krajčo",
	    "Krajčovič",
	    "Krajčír",
	    "Králik",
	    "Krúpa",
	    "Kubík",
	    "Kyseľ",
	    "Kállay",
	    "Labuda",
	    "Lepšík",
	    "Lipták",
	    "Lisický",
	    "Lubina",
	    "Lukáč",
	    "Lupták",
	    "Líška",
	    "Madej",
	    "Majeský",
	    "Malachovský",
	    "Malíšek",
	    "Mamojka",
	    "Marcinko",
	    "Marián",
	    "Masaryk",
	    "Maslo",
	    "Matiaško",
	    "Medveď",
	    "Melcer",
	    "Mečiar",
	    "Michalík",
	    "Mihalik",
	    "Mihál",
	    "Mihálik",
	    "Mikloško",
	    "Mikulík",
	    "Mikuš",
	    "Mikúš",
	    "Milota",
	    "Mináč",
	    "Mišík",
	    "Mojžiš",
	    "Mokroš",
	    "Mora",
	    "Moravčík",
	    "Mydlo",
	    "Nemec",
	    "Nitra",
	    "Novák",
	    "Obšut",
	    "Ondruš",
	    "Otčenáš",
	    "Pauko",
	    "Pavlikovský",
	    "Pavúk",
	    "Pašek",
	    "Paška",
	    "Paško",
	    "Pelikán",
	    "Petrovický",
	    "Petruška",
	    "Peško",
	    "Plch",
	    "Plekanec",
	    "Podhradský",
	    "Podkonický",
	    "Poliak",
	    "Pupák",
	    "Rak",
	    "Repiský",
	    "Romančík",
	    "Rus",
	    "Ružička",
	    "Rybníček",
	    "Rybár",
	    "Rybárik",
	    "Samson",
	    "Sedliak",
	    "Senko",
	    "Sklenka",
	    "Skokan",
	    "Skutecký",
	    "Slašťan",
	    "Sloboda",
	    "Slobodník",
	    "Slota",
	    "Slovák",
	    "Smrek",
	    "Stodola",
	    "Straka",
	    "Strnisko",
	    "Svrbík",
	    "Sámel",
	    "Sýkora",
	    "Tatar",
	    "Tatarka",
	    "Tatár",
	    "Tatárka",
	    "Thomka",
	    "Tomeček",
	    "Tomka",
	    "Tomko",
	    "Truben",
	    "Turčok",
	    "Uram",
	    "Urblík",
	    "Vajcík",
	    "Vajda",
	    "Valach",
	    "Valachovič",
	    "Valent",
	    "Valuška",
	    "Vanek",
	    "Vesel",
	    "Vicen",
	    "Višňovský",
	    "Vlach",
	    "Vojtek",
	    "Vydarený",
	    "Zajac",
	    "Zima",
	    "Zimka",
	    "Záborský",
	    "Zúbrik",
	    "Čapkovič",
	    "Čaplovič",
	    "Čarnogurský",
	    "Čierny",
	    "Čobrda",
	    "Ďaďo",
	    "Ďurica",
	    "Ďuriš",
	    "Šidlo",
	    "Šimonovič",
	    "Škriniar",
	    "Škultéty",
	    "Šmajda",
	    "Šoltés",
	    "Šoltýs",
	    "Štefan",
	    "Štefanka",
	    "Šulc",
	    "Šurka",
	    "Švehla",
	    "Šťastný"
	  ],
	  "woman_last_name": [
	    "Antalová",
	    "Babková",
	    "Bahnová",
	    "Balážová",
	    "Baranová",
	    "Baranková",
	    "Bartovičová",
	    "Bartošová",
	    "Bačová",
	    "Bernoláková",
	    "Beňová",
	    "Biceková",
	    "Bieliková",
	    "Blahová",
	    "Bondrová",
	    "Bosáková",
	    "Bošková",
	    "Brezinová",
	    "Bukovská",
	    "Chalupková",
	    "Chudíková",
	    "Cibulová",
	    "Cibulková",
	    "Cyprichová",
	    "Cígerová",
	    "Danková",
	    "Daňková",
	    "Daňová",
	    "Debnárová",
	    "Dejová",
	    "Dekýšová",
	    "Doležalová",
	    "Dočolomanská",
	    "Droppová",
	    "Dubovská",
	    "Dudeková",
	    "Dulová",
	    "Dullová",
	    "Dusíková",
	    "Dvončová",
	    "Dzurjaninová",
	    "Dávidová",
	    "Fabianová",
	    "Fabiánová",
	    "Fajnorová",
	    "Farkašovská",
	    "Ficová",
	    "Filcová",
	    "Filipová",
	    "Finková",
	    "Ftoreková",
	    "Gašparová",
	    "Gašparovičová",
	    "Gocníková",
	    "Gregorová",
	    "Gregušová",
	    "Grznárová",
	    "Habláková",
	    "Habšudová",
	    "Haldová",
	    "Halušková",
	    "Haláková",
	    "Hanková",
	    "Hanzalová",
	    "Haščáková",
	    "Heretiková",
	    "Hečková",
	    "Hlaváčeková",
	    "Hlinková",
	    "Holubová",
	    "Holubyová",
	    "Hossová",
	    "Hozová",
	    "Hrašková",
	    "Hricová",
	    "Hrmová",
	    "Hrušovská",
	    "Hubová",
	    "Ihnačáková",
	    "Janečeková",
	    "Janošková",
	    "Jantošovičová",
	    "Janíková",
	    "Jančeková",
	    "Jedľovská",
	    "Jendeková",
	    "Jonatová",
	    "Jurinová",
	    "Jurkovičová",
	    "Juríková",
	    "Jánošíková",
	    "Kafendová",
	    "Kaliská",
	    "Karulová",
	    "Kenížová",
	    "Klapková",
	    "Kmeťová",
	    "Kolesárová",
	    "Kollárová",
	    "Kolniková",
	    "Kolníková",
	    "Kolárová",
	    "Korecová",
	    "Kostkaová",
	    "Kostrecová",
	    "Kováčová",
	    "Kováčiková",
	    "Kozová",
	    "Kočišová",
	    "Krajíčeková",
	    "Krajčová",
	    "Krajčovičová",
	    "Krajčírová",
	    "Králiková",
	    "Krúpová",
	    "Kubíková",
	    "Kyseľová",
	    "Kállayová",
	    "Labudová",
	    "Lepšíková",
	    "Liptáková",
	    "Lisická",
	    "Lubinová",
	    "Lukáčová",
	    "Luptáková",
	    "Líšková",
	    "Madejová",
	    "Majeská",
	    "Malachovská",
	    "Malíšeková",
	    "Mamojková",
	    "Marcinková",
	    "Mariánová",
	    "Masaryková",
	    "Maslová",
	    "Matiašková",
	    "Medveďová",
	    "Melcerová",
	    "Mečiarová",
	    "Michalíková",
	    "Mihaliková",
	    "Mihálová",
	    "Miháliková",
	    "Miklošková",
	    "Mikulíková",
	    "Mikušová",
	    "Mikúšová",
	    "Milotová",
	    "Mináčová",
	    "Mišíková",
	    "Mojžišová",
	    "Mokrošová",
	    "Morová",
	    "Moravčíková",
	    "Mydlová",
	    "Nemcová",
	    "Nováková",
	    "Obšutová",
	    "Ondrušová",
	    "Otčenášová",
	    "Pauková",
	    "Pavlikovská",
	    "Pavúková",
	    "Pašeková",
	    "Pašková",
	    "Pelikánová",
	    "Petrovická",
	    "Petrušková",
	    "Pešková",
	    "Plchová",
	    "Plekanecová",
	    "Podhradská",
	    "Podkonická",
	    "Poliaková",
	    "Pupáková",
	    "Raková",
	    "Repiská",
	    "Romančíková",
	    "Rusová",
	    "Ružičková",
	    "Rybníčeková",
	    "Rybárová",
	    "Rybáriková",
	    "Samsonová",
	    "Sedliaková",
	    "Senková",
	    "Sklenková",
	    "Skokanová",
	    "Skutecká",
	    "Slašťanová",
	    "Slobodová",
	    "Slobodníková",
	    "Slotová",
	    "Slováková",
	    "Smreková",
	    "Stodolová",
	    "Straková",
	    "Strnisková",
	    "Svrbíková",
	    "Sámelová",
	    "Sýkorová",
	    "Tatarová",
	    "Tatarková",
	    "Tatárová",
	    "Tatárkaová",
	    "Thomková",
	    "Tomečeková",
	    "Tomková",
	    "Trubenová",
	    "Turčoková",
	    "Uramová",
	    "Urblíková",
	    "Vajcíková",
	    "Vajdová",
	    "Valachová",
	    "Valachovičová",
	    "Valentová",
	    "Valušková",
	    "Vaneková",
	    "Veselová",
	    "Vicenová",
	    "Višňovská",
	    "Vlachová",
	    "Vojteková",
	    "Vydarená",
	    "Zajacová",
	    "Zimová",
	    "Zimková",
	    "Záborská",
	    "Zúbriková",
	    "Čapkovičová",
	    "Čaplovičová",
	    "Čarnogurská",
	    "Čierná",
	    "Čobrdová",
	    "Ďaďová",
	    "Ďuricová",
	    "Ďurišová",
	    "Šidlová",
	    "Šimonovičová",
	    "Škriniarová",
	    "Škultétyová",
	    "Šmajdová",
	    "Šoltésová",
	    "Šoltýsová",
	    "Štefanová",
	    "Štefanková",
	    "Šulcová",
	    "Šurková",
	    "Švehlová",
	    "Šťastná"
	  ],
	  "prefix": [
	    "Ing.",
	    "Mgr.",
	    "JUDr.",
	    "MUDr."
	  ],
	  "suffix": [
	    "Phd."
	  ],
	  "title": {
	    "descriptor": [
	      "Lead",
	      "Senior",
	      "Direct",
	      "Corporate",
	      "Dynamic",
	      "Future",
	      "Product",
	      "National",
	      "Regional",
	      "District",
	      "Central",
	      "Global",
	      "Customer",
	      "Investor",
	      "Dynamic",
	      "International",
	      "Legacy",
	      "Forward",
	      "Internal",
	      "Human",
	      "Chief",
	      "Principal"
	    ],
	    "level": [
	      "Solutions",
	      "Program",
	      "Brand",
	      "Security",
	      "Research",
	      "Marketing",
	      "Directives",
	      "Implementation",
	      "Integration",
	      "Functionality",
	      "Response",
	      "Paradigm",
	      "Tactics",
	      "Identity",
	      "Markets",
	      "Group",
	      "Division",
	      "Applications",
	      "Optimization",
	      "Operations",
	      "Infrastructure",
	      "Intranet",
	      "Communications",
	      "Web",
	      "Branding",
	      "Quality",
	      "Assurance",
	      "Mobility",
	      "Accounts",
	      "Data",
	      "Creative",
	      "Configuration",
	      "Accountability",
	      "Interactions",
	      "Factors",
	      "Usability",
	      "Metrics"
	    ],
	    "job": [
	      "Supervisor",
	      "Associate",
	      "Executive",
	      "Liason",
	      "Officer",
	      "Manager",
	      "Engineer",
	      "Specialist",
	      "Director",
	      "Coordinator",
	      "Administrator",
	      "Architect",
	      "Analyst",
	      "Designer",
	      "Planner",
	      "Orchestrator",
	      "Technician",
	      "Developer",
	      "Producer",
	      "Consultant",
	      "Assistant",
	      "Facilitator",
	      "Agent",
	      "Representative",
	      "Strategist"
	    ]
	  },
	  "name": [
	    "#{prefix} #{man_first_name} #{man_last_name}",
	    "#{prefix} #{woman_first_name} #{woman_last_name}",
	    "#{man_first_name} #{man_last_name} #{suffix}",
	    "#{woman_first_name} #{woman_last_name} #{suffix}",
	    "#{man_first_name} #{man_last_name}",
	    "#{man_first_name} #{man_last_name}",
	    "#{man_first_name} #{man_last_name}",
	    "#{woman_first_name} #{woman_last_name}",
	    "#{woman_first_name} #{woman_last_name}",
	    "#{woman_first_name} #{woman_last_name}"
	  ]
	};
	sk.phone_number = {
	  "formats": [
	    "09## ### ###",
	    "0## #### ####",
	    "0# #### ####",
	    "+421 ### ### ###"
	  ]
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)(module)))

/***/ },
/* 317 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var sv = {};
	module["exports"] = sv;
	sv.title = "Swedish";
	sv.address = {
	  "city_prefix": [
	    "Söder",
	    "Norr",
	    "Väst",
	    "Öster",
	    "Aling",
	    "Ar",
	    "Av",
	    "Bo",
	    "Br",
	    "Bå",
	    "Ek",
	    "En",
	    "Esk",
	    "Fal",
	    "Gäv",
	    "Göte",
	    "Ha",
	    "Helsing",
	    "Karl",
	    "Krist",
	    "Kram",
	    "Kung",
	    "Kö",
	    "Lyck",
	    "Ny"
	  ],
	  "city_suffix": [
	    "stad",
	    "land",
	    "sås",
	    "ås",
	    "holm",
	    "tuna",
	    "sta",
	    "berg",
	    "löv",
	    "borg",
	    "mora",
	    "hamn",
	    "fors",
	    "köping",
	    "by",
	    "hult",
	    "torp",
	    "fred",
	    "vik"
	  ],
	  "country": [
	    "Ryssland",
	    "Kanada",
	    "Kina",
	    "USA",
	    "Brasilien",
	    "Australien",
	    "Indien",
	    "Argentina",
	    "Kazakstan",
	    "Algeriet",
	    "DR Kongo",
	    "Danmark",
	    "Färöarna",
	    "Grönland",
	    "Saudiarabien",
	    "Mexiko",
	    "Indonesien",
	    "Sudan",
	    "Libyen",
	    "Iran",
	    "Mongoliet",
	    "Peru",
	    "Tchad",
	    "Niger",
	    "Angola",
	    "Mali",
	    "Sydafrika",
	    "Colombia",
	    "Etiopien",
	    "Bolivia",
	    "Mauretanien",
	    "Egypten",
	    "Tanzania",
	    "Nigeria",
	    "Venezuela",
	    "Namibia",
	    "Pakistan",
	    "Moçambique",
	    "Turkiet",
	    "Chile",
	    "Zambia",
	    "Marocko",
	    "Västsahara",
	    "Burma",
	    "Afghanistan",
	    "Somalia",
	    "Centralafrikanska republiken",
	    "Sydsudan",
	    "Ukraina",
	    "Botswana",
	    "Madagaskar",
	    "Kenya",
	    "Frankrike",
	    "Franska Guyana",
	    "Jemen",
	    "Thailand",
	    "Spanien",
	    "Turkmenistan",
	    "Kamerun",
	    "Papua Nya Guinea",
	    "Sverige",
	    "Uzbekistan",
	    "Irak",
	    "Paraguay",
	    "Zimbabwe",
	    "Japan",
	    "Tyskland",
	    "Kongo",
	    "Finland",
	    "Malaysia",
	    "Vietnam",
	    "Norge",
	    "Svalbard",
	    "Jan Mayen",
	    "Elfenbenskusten",
	    "Polen",
	    "Italien",
	    "Filippinerna",
	    "Ecuador",
	    "Burkina Faso",
	    "Nya Zeeland",
	    "Gabon",
	    "Guinea",
	    "Storbritannien",
	    "Ghana",
	    "Rumänien",
	    "Laos",
	    "Uganda",
	    "Guyana",
	    "Oman",
	    "Vitryssland",
	    "Kirgizistan",
	    "Senegal",
	    "Syrien",
	    "Kambodja",
	    "Uruguay",
	    "Tunisien",
	    "Surinam",
	    "Nepal",
	    "Bangladesh",
	    "Tadzjikistan",
	    "Grekland",
	    "Nicaragua",
	    "Eritrea",
	    "Nordkorea",
	    "Malawi",
	    "Benin",
	    "Honduras",
	    "Liberia",
	    "Bulgarien",
	    "Kuba",
	    "Guatemala",
	    "Island",
	    "Sydkorea",
	    "Ungern",
	    "Portugal",
	    "Jordanien",
	    "Serbien",
	    "Azerbajdzjan",
	    "Österrike",
	    "Förenade Arabemiraten",
	    "Tjeckien",
	    "Panama",
	    "Sierra Leone",
	    "Irland",
	    "Georgien",
	    "Sri Lanka",
	    "Litauen",
	    "Lettland",
	    "Togo",
	    "Kroatien",
	    "Bosnien och Hercegovina",
	    "Costa Rica",
	    "Slovakien",
	    "Dominikanska republiken",
	    "Bhutan",
	    "Estland",
	    "Danmark",
	    "Färöarna",
	    "Grönland",
	    "Nederländerna",
	    "Schweiz",
	    "Guinea-Bissau",
	    "Taiwan",
	    "Moldavien",
	    "Belgien",
	    "Lesotho",
	    "Armenien",
	    "Albanien",
	    "Salomonöarna",
	    "Ekvatorialguinea",
	    "Burundi",
	    "Haiti",
	    "Rwanda",
	    "Makedonien",
	    "Djibouti",
	    "Belize",
	    "Israel",
	    "El Salvador",
	    "Slovenien",
	    "Fiji",
	    "Kuwait",
	    "Swaziland",
	    "Timor-Leste",
	    "Montenegro",
	    "Bahamas",
	    "Vanuatu",
	    "Qatar",
	    "Gambia",
	    "Jamaica",
	    "Kosovo",
	    "Libanon",
	    "Cypern",
	    "Brunei",
	    "Trinidad och Tobago",
	    "Kap Verde",
	    "Samoa",
	    "Luxemburg",
	    "Komorerna",
	    "Mauritius",
	    "São Tomé och Príncipe",
	    "Kiribati",
	    "Dominica",
	    "Tonga",
	    "Mikronesiens federerade stater",
	    "Singapore",
	    "Bahrain",
	    "Saint Lucia",
	    "Andorra",
	    "Palau",
	    "Seychellerna",
	    "Antigua och Barbuda",
	    "Barbados",
	    "Saint Vincent och Grenadinerna",
	    "Grenada",
	    "Malta",
	    "Maldiverna",
	    "Saint Kitts och Nevis",
	    "Marshallöarna",
	    "Liechtenstein",
	    "San Marino",
	    "Tuvalu",
	    "Nauru",
	    "Monaco",
	    "Vatikanstaten"
	  ],
	  "common_street_suffix": [
	    "s Väg",
	    "s Gata"
	  ],
	  "street_prefix": [
	    "Västra",
	    "Östra",
	    "Norra",
	    "Södra",
	    "Övre",
	    "Undre"
	  ],
	  "street_root": [
	    "Björk",
	    "Järnvägs",
	    "Ring",
	    "Skol",
	    "Skogs",
	    "Ny",
	    "Gran",
	    "Idrotts",
	    "Stor",
	    "Kyrk",
	    "Industri",
	    "Park",
	    "Strand",
	    "Skol",
	    "Trädgård",
	    "Ängs",
	    "Kyrko",
	    "Villa",
	    "Ek",
	    "Kvarn",
	    "Stations",
	    "Back",
	    "Furu",
	    "Gen",
	    "Fabriks",
	    "Åker",
	    "Bäck",
	    "Asp"
	  ],
	  "street_suffix": [
	    "vägen",
	    "gatan",
	    "gränden",
	    "gärdet",
	    "allén"
	  ],
	  "state": [
	    "Blekinge",
	    "Dalarna",
	    "Gotland",
	    "Gävleborg",
	    "Göteborg",
	    "Halland",
	    "Jämtland",
	    "Jönköping",
	    "Kalmar",
	    "Kronoberg",
	    "Norrbotten",
	    "Skaraborg",
	    "Skåne",
	    "Stockholm",
	    "Södermanland",
	    "Uppsala",
	    "Värmland",
	    "Västerbotten",
	    "Västernorrland",
	    "Västmanland",
	    "Älvsborg",
	    "Örebro",
	    "Östergötland"
	  ],
	  "city": [
	    "#{city_prefix}#{city_suffix}"
	  ],
	  "street_name": [
	    "#{street_root}#{street_suffix}",
	    "#{street_prefix} #{street_root}#{street_suffix}",
	    "#{Name.first_name}#{common_street_suffix}",
	    "#{Name.last_name}#{common_street_suffix}"
	  ],
	  "postcode": [
	    "#####"
	  ],
	  "building_number": [
	    "###",
	    "##",
	    "#"
	  ],
	  "secondary_address": [
	    "Lgh. ###",
	    "Hus ###"
	  ],
	  "street_address": [
	    "#{street_name} #{building_number}"
	  ],
	  "default_country": [
	    "Sverige"
	  ]
	};
	sv.company = {
	  "suffix": [
	    "Gruppen",
	    "AB",
	    "HB",
	    "Group",
	    "Investment",
	    "Kommanditbolag",
	    "Aktiebolag"
	  ],
	  "name": [
	    "#{Name.last_name} #{suffix}",
	    "#{Name.last_name}-#{Name.last_name}",
	    "#{Name.last_name}, #{Name.last_name} #{suffix}"
	  ]
	};
	sv.internet = {
	  "domain_suffix": [
	    "se",
	    "nu",
	    "info",
	    "com",
	    "org"
	  ]
	};
	sv.name = {
	  "first_name_women": [
	    "Maria",
	    "Anna",
	    "Margareta",
	    "Elisabeth",
	    "Eva",
	    "Birgitta",
	    "Kristina",
	    "Karin",
	    "Elisabet",
	    "Marie"
	  ],
	  "first_name_men": [
	    "Erik",
	    "Lars",
	    "Karl",
	    "Anders",
	    "Per",
	    "Johan",
	    "Nils",
	    "Lennart",
	    "Emil",
	    "Hans"
	  ],
	  "last_name": [
	    "Johansson",
	    "Andersson",
	    "Karlsson",
	    "Nilsson",
	    "Eriksson",
	    "Larsson",
	    "Olsson",
	    "Persson",
	    "Svensson",
	    "Gustafsson"
	  ],
	  "prefix": [
	    "Dr.",
	    "Prof.",
	    "PhD."
	  ],
	  "title": {
	    "descriptor": [
	      "Lead",
	      "Senior",
	      "Direct",
	      "Corporate",
	      "Dynamic",
	      "Future",
	      "Product",
	      "National",
	      "Regional",
	      "District",
	      "Central",
	      "Global",
	      "Customer",
	      "Investor",
	      "Dynamic",
	      "International",
	      "Legacy",
	      "Forward",
	      "Internal",
	      "Human",
	      "Chief",
	      "Principal"
	    ],
	    "level": [
	      "Solutions",
	      "Program",
	      "Brand",
	      "Security",
	      "Research",
	      "Marketing",
	      "Directives",
	      "Implementation",
	      "Integration",
	      "Functionality",
	      "Response",
	      "Paradigm",
	      "Tactics",
	      "Identity",
	      "Markets",
	      "Group",
	      "Division",
	      "Applications",
	      "Optimization",
	      "Operations",
	      "Infrastructure",
	      "Intranet",
	      "Communications",
	      "Web",
	      "Branding",
	      "Quality",
	      "Assurance",
	      "Mobility",
	      "Accounts",
	      "Data",
	      "Creative",
	      "Configuration",
	      "Accountability",
	      "Interactions",
	      "Factors",
	      "Usability",
	      "Metrics"
	    ],
	    "job": [
	      "Supervisor",
	      "Associate",
	      "Executive",
	      "Liason",
	      "Officer",
	      "Manager",
	      "Engineer",
	      "Specialist",
	      "Director",
	      "Coordinator",
	      "Administrator",
	      "Architect",
	      "Analyst",
	      "Designer",
	      "Planner",
	      "Orchestrator",
	      "Technician",
	      "Developer",
	      "Producer",
	      "Consultant",
	      "Assistant",
	      "Facilitator",
	      "Agent",
	      "Representative",
	      "Strategist"
	    ]
	  },
	  "name": [
	    "#{first_name_women} #{last_name}",
	    "#{first_name_men} #{last_name}",
	    "#{first_name_women} #{last_name}",
	    "#{first_name_men} #{last_name}",
	    "#{first_name_women} #{last_name}",
	    "#{first_name_men} #{last_name}",
	    "#{prefix} #{first_name_men} #{last_name}",
	    "#{prefix} #{first_name_women} #{last_name}"
	  ]
	};
	sv.phone_number = {
	  "formats": [
	    "####-#####",
	    "####-######"
	  ]
	};
	sv.cell_phone = {
	  "common_cell_prefix": [
	    56,
	    62,
	    59
	  ],
	  "formats": [
	    "#{common_cell_prefix}-###-####"
	  ]
	};
	sv.commerce = {
	  "color": [
	    "vit",
	    "silver",
	    "grå",
	    "svart",
	    "röd",
	    "grön",
	    "blå",
	    "gul",
	    "lila",
	    "indigo",
	    "guld",
	    "brun",
	    "rosa",
	    "purpur",
	    "korall"
	  ],
	  "department": [
	    "Böcker",
	    "Filmer",
	    "Musik",
	    "Spel",
	    "Elektronik",
	    "Datorer",
	    "Hem",
	    "Trädgård",
	    "Verktyg",
	    "Livsmedel",
	    "Hälsa",
	    "Skönhet",
	    "Leksaker",
	    "Klädsel",
	    "Skor",
	    "Smycken",
	    "Sport"
	  ],
	  "product_name": {
	    "adjective": [
	      "Liten",
	      "Ergonomisk",
	      "Robust",
	      "Intelligent",
	      "Söt",
	      "Otrolig",
	      "Fatastisk",
	      "Praktisk",
	      "Slimmad",
	      "Grym"
	    ],
	    "material": [
	      "Stål",
	      "Metall",
	      "Trä",
	      "Betong",
	      "Plast",
	      "Bomul",
	      "Grnit",
	      "Gummi",
	      "Latex"
	    ],
	    "product": [
	      "Stol",
	      "Bil",
	      "Dator",
	      "Handskar",
	      "Pants",
	      "Shirt",
	      "Table",
	      "Shoes",
	      "Hat"
	    ]
	  }
	};
	sv.team = {
	  "suffix": [
	    "IF",
	    "FF",
	    "BK",
	    "HK",
	    "AIF",
	    "SK",
	    "FC",
	    "SK",
	    "BoIS",
	    "FK",
	    "BIS",
	    "FIF",
	    "IK"
	  ],
	  "name": [
	    "#{Address.city} #{suffix}"
	  ]
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)(module)))

/***/ },
/* 318 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var tr = {};
	module["exports"] = tr;
	tr.title = "Turkish";
	tr.address = {
	
	    "city": [
	        "Adana",
	        "Adıyaman",
	        "Afyon",
	        "Ağrı",
	        "Amasya",
	        "Ankara",
	        "Antalya",
	        "Artvin",
	        "Aydın",
	        "Balıkesir",
	        "Bilecik",
	        "Bingöl",
	        "Bitlis",
	        "Bolu",
	        "Burdur",
	        "Bursa",
	        "Çanakkale",
	        "Çankırı",
	        "Çorum",
	        "Denizli",
	        "Diyarbakır",
	        "Edirne",
	        "Elazığ",
	        "Erzincan",
	        "Erzurum",
	        "Eskişehir",
	        "Gaziantep",
	        "Giresun",
	        "Gümüşhane",
	        "Hakkari",
	        "Hatay",
	        "Isparta",
	        "İçel (Mersin)",
	        "İstanbul",
	        "İzmir",
	        "Kars",
	        "Kastamonu",
	        "Kayseri",
	        "Kırklareli",
	        "Kırşehir",
	        "Kocaeli",
	        "Konya",
	        "Kütahya",
	        "Malatya",
	        "Manisa",
	        "K.maraş",
	        "Mardin",
	        "Muğla",
	        "Muş",
	        "Nevşehir",
	        "Niğde",
	        "Ordu",
	        "Rize",
	        "Sakarya",
	        "Samsun",
	        "Siirt",
	        "Sinop",
	        "Sivas",
	        "Tekirdağ",
	        "Tokat",
	        "Trabzon",
	        "Tunceli",
	        "Şanlıurfa",
	        "Uşak",
	        "Van",
	        "Yozgat",
	        "Zonguldak",
	        "Aksaray",
	        "Bayburt",
	        "Karaman",
	        "Kırıkkale",
	        "Batman",
	        "Şırnak",
	        "Bartın",
	        "Ardahan",
	        "Iğdır",
	        "Yalova",
	        "Karabük",
	        "Kilis",
	        "Osmaniye",
	        "Düzce"
	    ],
	    "street_root": [
	        "Atatürk Bulvarı",
	        "Alparslan Türkeş Bulvarı",
	        "Ali Çetinkaya Caddesi",
	        "Tevfik Fikret Caddesi",
	        "Kocatepe Caddesi",
	        "İsmet Paşa Caddesi",
	        "30 Ağustos Caddesi",
	        "İsmet Attila Caddesi",
	        "Namık Kemal Caddesi",
	        "Lütfi Karadirek Caddesi",
	        "Sarıkaya Caddesi",
	        "Yunus Emre Sokak",
	        "Dar Sokak",
	        "Fatih Sokak ",
	        "Harman Yolu Sokak ",
	        "Ergenekon Sokak  ",
	        "Ülkü Sokak",
	        "Sağlık Sokak",
	        "Okul Sokak",
	        "Harman Altı Sokak",
	        "Kaldırım Sokak",
	        "Mevlana Sokak",
	        "Gül Sokak",
	        "Sıran Söğüt Sokak",
	        "Güven Yaka Sokak",
	        "Saygılı Sokak",
	        "Menekşe Sokak",
	        "Dağınık Evler Sokak",
	        "Sevgi Sokak",
	        "Afyon Kaya Sokak",
	        "Oğuzhan Sokak",
	        "İbn-i Sina Sokak",
	        "Okul Sokak",
	        "Bahçe Sokak",
	        "Köypınar Sokak",
	        "Kekeçoğlu Sokak",
	        "Barış Sokak",
	        "Bayır Sokak",
	        "Kerimoğlu Sokak",
	        "Nalbant Sokak",
	        "Bandak Sokak"
	    ],
	    "country": [
	        "Afganistan",
	        "Almanya",
	        "Amerika Birleşik Devletleri",
	        "Amerikan Samoa",
	        "Andorra",
	        "Angola",
	        "Anguilla, İngiltere",
	        "Antigua ve Barbuda",
	        "Arjantin",
	        "Arnavutluk",
	        "Aruba, Hollanda",
	        "Avustralya",
	        "Avusturya",
	        "Azerbaycan",
	        "Bahama Adaları",
	        "Bahreyn",
	        "Bangladeş",
	        "Barbados",
	        "Belçika",
	        "Belize",
	        "Benin",
	        "Bermuda, İngiltere",
	        "Beyaz Rusya",
	        "Bhutan",
	        "Birleşik Arap Emirlikleri",
	        "Birmanya (Myanmar)",
	        "Bolivya",
	        "Bosna Hersek",
	        "Botswana",
	        "Brezilya",
	        "Brunei",
	        "Bulgaristan",
	        "Burkina Faso",
	        "Burundi",
	        "Cape Verde",
	        "Cayman Adaları, İngiltere",
	        "Cebelitarık, İngiltere",
	        "Cezayir",
	        "Christmas Adası , Avusturalya",
	        "Cibuti",
	        "Çad",
	        "Çek Cumhuriyeti",
	        "Çin",
	        "Danimarka",
	        "Doğu Timor",
	        "Dominik Cumhuriyeti",
	        "Dominika",
	        "Ekvator",
	        "Ekvator Ginesi",
	        "El Salvador",
	        "Endonezya",
	        "Eritre",
	        "Ermenistan",
	        "Estonya",
	        "Etiyopya",
	        "Fas",
	        "Fiji",
	        "Fildişi Sahili",
	        "Filipinler",
	        "Filistin",
	        "Finlandiya",
	        "Folkland Adaları, İngiltere",
	        "Fransa",
	        "Fransız Guyanası",
	        "Fransız Güney Eyaletleri (Kerguelen Adaları)",
	        "Fransız Polinezyası",
	        "Gabon",
	        "Galler",
	        "Gambiya",
	        "Gana",
	        "Gine",
	        "Gine-Bissau",
	        "Grenada",
	        "Grönland",
	        "Guadalup, Fransa",
	        "Guam, Amerika",
	        "Guatemala",
	        "Guyana",
	        "Güney Afrika",
	        "Güney Georgia ve Güney Sandviç Adaları, İngiltere",
	        "Güney Kıbrıs Rum Yönetimi",
	        "Güney Kore",
	        "Gürcistan H",
	        "Haiti",
	        "Hırvatistan",
	        "Hindistan",
	        "Hollanda",
	        "Hollanda Antilleri",
	        "Honduras",
	        "Irak",
	        "İngiltere",
	        "İran",
	        "İrlanda",
	        "İspanya",
	        "İsrail",
	        "İsveç",
	        "İsviçre",
	        "İtalya",
	        "İzlanda",
	        "Jamaika",
	        "Japonya",
	        "Johnston Atoll, Amerika",
	        "K.K.T.C.",
	        "Kamboçya",
	        "Kamerun",
	        "Kanada",
	        "Kanarya Adaları",
	        "Karadağ",
	        "Katar",
	        "Kazakistan",
	        "Kenya",
	        "Kırgızistan",
	        "Kiribati",
	        "Kolombiya",
	        "Komorlar",
	        "Kongo",
	        "Kongo Demokratik Cumhuriyeti",
	        "Kosova",
	        "Kosta Rika",
	        "Kuveyt",
	        "Kuzey İrlanda",
	        "Kuzey Kore",
	        "Kuzey Maryana Adaları",
	        "Küba",
	        "Laos",
	        "Lesotho",
	        "Letonya",
	        "Liberya",
	        "Libya",
	        "Liechtenstein",
	        "Litvanya",
	        "Lübnan",
	        "Lüksemburg",
	        "Macaristan",
	        "Madagaskar",
	        "Makau (Makao)",
	        "Makedonya",
	        "Malavi",
	        "Maldiv Adaları",
	        "Malezya",
	        "Mali",
	        "Malta",
	        "Marşal Adaları",
	        "Martinik, Fransa",
	        "Mauritius",
	        "Mayotte, Fransa",
	        "Meksika",
	        "Mısır",
	        "Midway Adaları, Amerika",
	        "Mikronezya",
	        "Moğolistan",
	        "Moldavya",
	        "Monako",
	        "Montserrat",
	        "Moritanya",
	        "Mozambik",
	        "Namibia",
	        "Nauru",
	        "Nepal",
	        "Nijer",
	        "Nijerya",
	        "Nikaragua",
	        "Niue, Yeni Zelanda",
	        "Norveç",
	        "Orta Afrika Cumhuriyeti",
	        "Özbekistan",
	        "Pakistan",
	        "Palau Adaları",
	        "Palmyra Atoll, Amerika",
	        "Panama",
	        "Papua Yeni Gine",
	        "Paraguay",
	        "Peru",
	        "Polonya",
	        "Portekiz",
	        "Porto Riko, Amerika",
	        "Reunion, Fransa",
	        "Romanya",
	        "Ruanda",
	        "Rusya Federasyonu",
	        "Saint Helena, İngiltere",
	        "Saint Martin, Fransa",
	        "Saint Pierre ve Miquelon, Fransa",
	        "Samoa",
	        "San Marino",
	        "Santa Kitts ve Nevis",
	        "Santa Lucia",
	        "Santa Vincent ve Grenadinler",
	        "Sao Tome ve Principe",
	        "Senegal",
	        "Seyşeller",
	        "Sırbistan",
	        "Sierra Leone",
	        "Singapur",
	        "Slovakya",
	        "Slovenya",
	        "Solomon Adaları",
	        "Somali",
	        "Sri Lanka",
	        "Sudan",
	        "Surinam",
	        "Suriye",
	        "Suudi Arabistan",
	        "Svalbard, Norveç",
	        "Svaziland",
	        "Şili",
	        "Tacikistan",
	        "Tanzanya",
	        "Tayland",
	        "Tayvan",
	        "Togo",
	        "Tonga",
	        "Trinidad ve Tobago",
	        "Tunus",
	        "Turks ve Caicos Adaları, İngiltere",
	        "Tuvalu",
	        "Türkiye",
	        "Türkmenistan",
	        "Uganda",
	        "Ukrayna",
	        "Umman",
	        "Uruguay",
	        "Ürdün",
	        "Vallis ve Futuna, Fransa",
	        "Vanuatu",
	        "Venezuela",
	        "Vietnam",
	        "Virgin Adaları, Amerika",
	        "Virgin Adaları, İngiltere",
	        "Wake Adaları, Amerika",
	        "Yemen",
	        "Yeni Kaledonya, Fransa",
	        "Yeni Zelanda",
	        "Yunanistan",
	        "Zambiya",
	        "Zimbabve"
	    ],
	    "postcode": [
	        "#####"
	    ],
	    "default_country": [
	        "Türkiye"
	    ],
	    "building_number": [
	        "###",
	        "##",
	        "#",
	        "##a",
	        "##b",
	        "##c"
	    ],
	    "street_name": [
	        "#{street_root}"
	    ],
	    "street_address": [
	        "#{street_name} #{building_number}"
	    ]
	};
	tr.internet = {
	    "domain_suffix": [
	        "com.tr",
	        "com",
	        "biz",
	        "info",
	        "name",
	        "gov.tr"
	    ]
	};
	tr.lorem = {
	    "words": [
	        "alias",
	        "consequatur",
	        "aut",
	        "perferendis",
	        "sit",
	        "voluptatem",
	        "accusantium",
	        "doloremque",
	        "aperiam",
	        "eaque",
	        "ipsa",
	        "quae",
	        "ab",
	        "illo",
	        "inventore",
	        "veritatis",
	        "et",
	        "quasi",
	        "architecto",
	        "beatae",
	        "vitae",
	        "dicta",
	        "sunt",
	        "explicabo",
	        "aspernatur",
	        "aut",
	        "odit",
	        "aut",
	        "fugit",
	        "sed",
	        "quia",
	        "consequuntur",
	        "magni",
	        "dolores",
	        "eos",
	        "qui",
	        "ratione",
	        "voluptatem",
	        "sequi",
	        "nesciunt",
	        "neque",
	        "dolorem",
	        "ipsum",
	        "quia",
	        "dolor",
	        "sit",
	        "amet",
	        "consectetur",
	        "adipisci",
	        "velit",
	        "sed",
	        "quia",
	        "non",
	        "numquam",
	        "eius",
	        "modi",
	        "tempora",
	        "incidunt",
	        "ut",
	        "labore",
	        "et",
	        "dolore",
	        "magnam",
	        "aliquam",
	        "quaerat",
	        "voluptatem",
	        "ut",
	        "enim",
	        "ad",
	        "minima",
	        "veniam",
	        "quis",
	        "nostrum",
	        "exercitationem",
	        "ullam",
	        "corporis",
	        "nemo",
	        "enim",
	        "ipsam",
	        "voluptatem",
	        "quia",
	        "voluptas",
	        "sit",
	        "suscipit",
	        "laboriosam",
	        "nisi",
	        "ut",
	        "aliquid",
	        "ex",
	        "ea",
	        "commodi",
	        "consequatur",
	        "quis",
	        "autem",
	        "vel",
	        "eum",
	        "iure",
	        "reprehenderit",
	        "qui",
	        "in",
	        "ea",
	        "voluptate",
	        "velit",
	        "esse",
	        "quam",
	        "nihil",
	        "molestiae",
	        "et",
	        "iusto",
	        "odio",
	        "dignissimos",
	        "ducimus",
	        "qui",
	        "blanditiis",
	        "praesentium",
	        "laudantium",
	        "totam",
	        "rem",
	        "voluptatum",
	        "deleniti",
	        "atque",
	        "corrupti",
	        "quos",
	        "dolores",
	        "et",
	        "quas",
	        "molestias",
	        "excepturi",
	        "sint",
	        "occaecati",
	        "cupiditate",
	        "non",
	        "provident",
	        "sed",
	        "ut",
	        "perspiciatis",
	        "unde",
	        "omnis",
	        "iste",
	        "natus",
	        "error",
	        "similique",
	        "sunt",
	        "in",
	        "culpa",
	        "qui",
	        "officia",
	        "deserunt",
	        "mollitia",
	        "animi",
	        "id",
	        "est",
	        "laborum",
	        "et",
	        "dolorum",
	        "fuga",
	        "et",
	        "harum",
	        "quidem",
	        "rerum",
	        "facilis",
	        "est",
	        "et",
	        "expedita",
	        "distinctio",
	        "nam",
	        "libero",
	        "tempore",
	        "cum",
	        "soluta",
	        "nobis",
	        "est",
	        "eligendi",
	        "optio",
	        "cumque",
	        "nihil",
	        "impedit",
	        "quo",
	        "porro",
	        "quisquam",
	        "est",
	        "qui",
	        "minus",
	        "id",
	        "quod",
	        "maxime",
	        "placeat",
	        "facere",
	        "possimus",
	        "omnis",
	        "voluptas",
	        "assumenda",
	        "est",
	        "omnis",
	        "dolor",
	        "repellendus",
	        "temporibus",
	        "autem",
	        "quibusdam",
	        "et",
	        "aut",
	        "consequatur",
	        "vel",
	        "illum",
	        "qui",
	        "dolorem",
	        "eum",
	        "fugiat",
	        "quo",
	        "voluptas",
	        "nulla",
	        "pariatur",
	        "at",
	        "vero",
	        "eos",
	        "et",
	        "accusamus",
	        "officiis",
	        "debitis",
	        "aut",
	        "rerum",
	        "necessitatibus",
	        "saepe",
	        "eveniet",
	        "ut",
	        "et",
	        "voluptates",
	        "repudiandae",
	        "sint",
	        "et",
	        "molestiae",
	        "non",
	        "recusandae",
	        "itaque",
	        "earum",
	        "rerum",
	        "hic",
	        "tenetur",
	        "a",
	        "sapiente",
	        "delectus",
	        "ut",
	        "aut",
	        "reiciendis",
	        "voluptatibus",
	        "maiores",
	        "doloribus",
	        "asperiores",
	        "repellat"
	    ]
	};
	tr.phone_number = {
	    "area_code": [
	        "392",
	        "510",
	        "512",
	        "522",
	        "562",
	        "564",
	        "592",
	        "594",
	        "800",
	        "811",
	        "822",
	        "850",
	        "888",
	        "898",
	        "900",
	        "322",
	        "416",
	        "272",
	        "472",
	        "382",
	        "358",
	        "312",
	        "242",
	        "478",
	        "466",
	        "256",
	        "266",
	        "378",
	        "488",
	        "458",
	        "228",
	        "426",
	        "434",
	        "374",
	        "248",
	        "224",
	        "286",
	        "376",
	        "364",
	        "258",
	        "412",
	        "380",
	        "284",
	        "424",
	        "446",
	        "442",
	        "222",
	        "342",
	        "454",
	        "456",
	        "438",
	        "326",
	        "476",
	        "246",
	        "216",
	        "212",
	        "232",
	        "344",
	        "370",
	        "338",
	        "474",
	        "366",
	        "352",
	        "318",
	        "288",
	        "386",
	        "348",
	        "262",
	        "332",
	        "274",
	        "422",
	        "236",
	        "482",
	        "324",
	        "252",
	        "436",
	        "384",
	        "388",
	        "452",
	        "328",
	        "464",
	        "264",
	        "362",
	        "484",
	        "368",
	        "346",
	        "414",
	        "486",
	        "282",
	        "356",
	        "462",
	        "428",
	        "276",
	        "432",
	        "226",
	        "354",
	        "372"
	    ],
	    "formats": [
	        "+90-###-###-##-##",
	        "+90-###-###-#-###"
	    ]
	};
	tr.cell_phone = {
	    "formats": [
	        "+90-53#-###-##-##",
	        "+90-54#-###-##-##",
	        "+90-55#-###-##-##",
	        "+90-50#-###-##-##"
	    ]
	};
	tr.name = {
	    "first_name": [
	        "Aba",
	        "Abak",
	        "Abaka",
	        "Abakan",
	        "Abakay",
	        "Abar",
	        "Abay",
	        "Abı",
	        "Abılay",
	        "Abluç",
	        "Abşar",
	        "Açığ",
	        "Açık",
	        "Açuk",
	        "Adalan",
	        "Adaldı",
	        "Adalmış",
	        "Adar",
	        "Adaş",
	        "Adberilgen",
	        "Adıgüzel",
	        "Adık",
	        "Adıkutlu",
	        "Adıkutlutaş",
	        "Adlı",
	        "Adlıbeğ",
	        "Adraman",
	        "Adsız",
	        "Afşar",
	        "Afşın",
	        "Ağabay",
	        "Ağakağan",
	        "Ağalak",
	        "Ağlamış",
	        "Ak",
	        "Akaş",
	        "Akata",
	        "Akbaş",
	        "Akbay",
	        "Akboğa",
	        "Akbörü",
	        "Akbudak",
	        "Akbuğra",
	        "Akbulak",
	        "Akça",
	        "Akçakoca",
	        "Akçora",
	        "Akdemir",
	        "Akdoğan",
	        "Akı",
	        "Akıbudak",
	        "Akım",
	        "Akın",
	        "Akınçı",
	        "Akkun",
	        "Akkunlu",
	        "Akkurt",
	        "Akkuş",
	        "Akpıra",
	        "Aksungur",
	        "Aktan",
	        "Al",
	        "Ala",
	        "Alaban",
	        "Alabörü",
	        "Aladağ",
	        "Aladoğan",
	        "Alakurt",
	        "Alayunt",
	        "Alayuntlu",
	        "Aldemir",
	        "Aldıgerey",
	        "Aldoğan",
	        "Algu",
	        "Alımga",
	        "Alka",
	        "Alkabölük",
	        "Alkaevli",
	        "Alkan",
	        "Alkaşı",
	        "Alkış",
	        "Alp",
	        "Alpagut",
	        "Alpamış",
	        "Alparsbeğ",
	        "Alparslan",
	        "Alpata",
	        "Alpay",
	        "Alpaya",
	        "Alpaykağan",
	        "Alpbamsı",
	        "Alpbilge",
	        "Alpdirek",
	        "Alpdoğan",
	        "Alper",
	        "Alperen",
	        "Alpertunga",
	        "Alpgerey",
	        "Alpış",
	        "Alpilig",
	        "Alpkara",
	        "Alpkutlu",
	        "Alpkülük",
	        "Alpşalçı",
	        "Alptegin",
	        "Alptuğrul",
	        "Alptunga",
	        "Alpturan",
	        "Alptutuk",
	        "Alpuluğ",
	        "Alpurungu",
	        "Alpurungututuk",
	        "Alpyörük",
	        "Altan",
	        "Altankağan",
	        "Altankan",
	        "Altay",
	        "Altın",
	        "Altınkağan",
	        "Altınkan",
	        "Altınoba",
	        "Altıntamgan",
	        "Altıntamgantarkan",
	        "Altıntarkan",
	        "Altıntay",
	        "Altmışkara",
	        "Altuga",
	        "Amaç",
	        "Amrak",
	        "Amul",
	        "Ançuk",
	        "Andarıman",
	        "Anıl",
	        "Ant",
	        "Apa",
	        "Apak",
	        "Apatarkan",
	        "Aprançur",
	        "Araboğa",
	        "Arademir",
	        "Aral",
	        "Arbay",
	        "Arbuz",
	        "Arçuk",
	        "Ardıç",
	        "Argıl",
	        "Argu",
	        "Argun",
	        "Arı",
	        "Arıboğa",
	        "Arık",
	        "Arıkağan",
	        "Arıkdoruk",
	        "Arınç",
	        "Arkın",
	        "Arkış",
	        "Armağan",
	        "Arnaç",
	        "Arpat",
	        "Arsal",
	        "Arsıl",
	        "Arslan",
	        "Arslanargun",
	        "Arslanbörü",
	        "Arslansungur",
	        "Arslantegin",
	        "Arslanyabgu",
	        "Arşun",
	        "Artıınal",
	        "Artuk",
	        "Artukaç",
	        "Artut",
	        "Aruk",
	        "Asartegin",
	        "Asığ",
	        "Asrı",
	        "Asuğ",
	        "Aşan",
	        "Aşanboğa",
	        "Aşantuğrul",
	        "Aşantudun",
	        "Aşıkbulmuş",
	        "Aşkın",
	        "Aştaloğul",
	        "Aşuk",
	        "Ataç",
	        "Atakağan",
	        "Atakan",
	        "Atalan",
	        "Ataldı",
	        "Atalmış",
	        "Ataman",
	        "Atasagun",
	        "Atasu",
	        "Atberilgen",
	        "Atıgay",
	        "Atıkutlu",
	        "Atıkutlutaş",
	        "Atıla",
	        "Atılgan",
	        "Atım",
	        "Atımer",
	        "Atış",
	        "Atlı",
	        "Atlıbeğ",
	        "Atlıkağan",
	        "Atmaca",
	        "Atsız",
	        "Atunçu",
	        "Avar",
	        "Avluç",
	        "Avşar",
	        "Ay",
	        "Ayaçı",
	        "Ayas",
	        "Ayaş",
	        "Ayaz",
	        "Aybalta",
	        "Ayban",
	        "Aybars",
	        "Aybeğ",
	        "Aydarkağan",
	        "Aydemir",
	        "Aydın",
	        "Aydınalp",
	        "Aydoğan",
	        "Aydoğdu",
	        "Aydoğmuş",
	        "Aygırak",
	        "Ayıtmış",
	        "Ayız",
	        "Ayızdağ",
	        "Aykağan",
	        "Aykan",
	        "Aykurt",
	        "Ayluç",
	        "Ayluçtarkan",
	        "Ayma",
	        "Ayruk",
	        "Aysılığ",
	        "Aytak",
	        "Ayyıldız",
	        "Azak",
	        "Azban",
	        "Azgan",
	        "Azganaz",
	        "Azıl",
	        "Babır",
	        "Babur",
	        "Baçara",
	        "Baççayman",
	        "Baçman",
	        "Badabul",
	        "Badruk",
	        "Badur",
	        "Bağa",
	        "Bağaalp",
	        "Bağaışbara",
	        "Bağan",
	        "Bağaşatulu",
	        "Bağatarkan",
	        "Bağatengrikağan",
	        "Bağatur",
	        "Bağaturçigşi",
	        "Bağaturgerey",
	        "Bağaturipi",
	        "Bağatursepi",
	        "Bağış",
	        "Bağtaş",
	        "Bakağul",
	        "Bakır",
	        "Bakırsokum",
	        "Baksı",
	        "Bakşı",
	        "Balaban",
	        "Balaka",
	        "Balakatay",
	        "Balamır",
	        "Balçar",
	        "Baldu",
	        "Balkık",
	        "Balta",
	        "Baltacı",
	        "Baltar",
	        "Baltır",
	        "Baltur",
	        "Bamsı",
	        "Bangu",
	        "Barak",
	        "Baraktöre",
	        "Baran",
	        "Barbeğ",
	        "Barboğa",
	        "Barbol",
	        "Barbulsun",
	        "Barça",
	        "Barçadoğdu",
	        "Barçadoğmuş",
	        "Barçadurdu",
	        "Barçadurmuş",
	        "Barçan",
	        "Barçatoyun",
	        "Bardıbay",
	        "Bargan",
	        "Barımtay",
	        "Barın",
	        "Barkan",
	        "Barkdoğdu",
	        "Barkdoğmuş",
	        "Barkdurdu",
	        "Barkdurmuş",
	        "Barkın",
	        "Barlas",
	        "Barlıbay",
	        "Barmaklak",
	        "Barmaklı",
	        "Barman",
	        "Bars",
	        "Barsbeğ",
	        "Barsboğa",
	        "Barsgan",
	        "Barskan",
	        "Barsurungu",
	        "Bartu",
	        "Basademir",
	        "Basan",
	        "Basanyalavaç",
	        "Basar",
	        "Basat",
	        "Baskın",
	        "Basmıl",
	        "Bastı",
	        "Bastuğrul",
	        "Basu",
	        "Basut",
	        "Başak",
	        "Başbuğ",
	        "Başçı",
	        "Başgan",
	        "Başkırt",
	        "Başkurt",
	        "Baştar",
	        "Batrak",
	        "Batu",
	        "Batuk",
	        "Batur",
	        "Baturalp",
	        "Bay",
	        "Bayançar",
	        "Bayankağan",
	        "Bayat",
	        "Bayazıt",
	        "Baybars",
	        "Baybayık",
	        "Baybiçen",
	        "Bayboğa",
	        "Baybora",
	        "Baybüre",
	        "Baydar",
	        "Baydemir",
	        "Baydur",
	        "Bayık",
	        "Bayınçur",
	        "Bayındır",
	        "Baykal",
	        "Baykara",
	        "Baykoca",
	        "Baykuzu",
	        "Baymünke",
	        "Bayna",
	        "Baynal",
	        "Baypüre",
	        "Bayrı",
	        "Bayraç",
	        "Bayrak",
	        "Bayram",
	        "Bayrın",
	        "Bayruk",
	        "Baysungur",
	        "Baytara",
	        "Baytaş",
	        "Bayunçur",
	        "Bayur",
	        "Bayurku",
	        "Bayutmuş",
	        "Bayuttu",
	        "Bazır",
	        "Beçeapa",
	        "Beçkem",
	        "Beğ",
	        "Beğarslan",
	        "Beğbars",
	        "Beğbilgeçikşin",
	        "Beğboğa",
	        "Beğçur",
	        "Beğdemir",
	        "Beğdilli",
	        "Beğdurmuş",
	        "Beğkulu",
	        "Beğtaş",
	        "Beğtegin",
	        "Beğtüzün",
	        "Begi",
	        "Begil",
	        "Begine",
	        "Begitutuk",
	        "Beglen",
	        "Begni",
	        "Bek",
	        "Bekazıl",
	        "Bekbekeç",
	        "Bekeç",
	        "Bekeçarslan",
	        "Bekeçarslantegin",
	        "Bekeçtegin",
	        "Beker",
	        "Beklemiş",
	        "Bektür",
	        "Belçir",
	        "Belek",
	        "Belgi",
	        "Belgüc",
	        "Beltir",
	        "Bengi",
	        "Bengü",
	        "Benlidemir",
	        "Berdibeğ",
	        "Berendey",
	        "Bergü",
	        "Berginsenge",
	        "Berk",
	        "Berke",
	        "Berkiş",
	        "Berkyaruk",
	        "Bermek",
	        "Besentegin",
	        "Betemir",
	        "Beyizçi",
	        "Beyrek",
	        "Beyrem",
	        "Bıçkı",
	        "Bıçkıcı",
	        "Bıdın",
	        "Bıtaybıkı",
	        "Bıtrı",
	        "Biçek",
	        "Bilge",
	        "Bilgebayunçur",
	        "Bilgebeğ",
	        "Bilgeçikşin",
	        "Bilgeışbara",
	        "Bilgeışbaratamgan",
	        "Bilgekağan",
	        "Bilgekan",
	        "Bilgekutluk",
	        "Bilgekülüçur",
	        "Bilgetaçam",
	        "Bilgetamgacı",
	        "Bilgetardu",
	        "Bilgetegin",
	        "Bilgetonyukuk",
	        "Bilgez",
	        "Bilgiç",
	        "Bilgin",
	        "Bilig",
	        "Biligköngülsengün",
	        "Bilik",
	        "Binbeği",
	        "Bindir",
	        "Boğa",
	        "Boğaç",
	        "Boğaçuk",
	        "Boldaz",
	        "Bolmuş",
	        "Bolsun",
	        "Bolun",
	        "Boncuk",
	        "Bongul",
	        "Bongulboğa",
	        "Bora",
	        "Boran",
	        "Borçul",
	        "Borlukçu",
	        "Bornak",
	        "Boyan",
	        "Boyankulu",
	        "Boylabağa",
	        "Boylabağatarkan",
	        "Boylakutlutarkan",
	        "Bozan",
	        "Bozbörü",
	        "Bozdoğan",
	        "Bozkurt",
	        "Bozkuş",
	        "Bozok",
	        "Bögde",
	        "Böge",
	        "Bögü",
	        "Bökde",
	        "Bökde",
	        "Böke",
	        "Bölen",
	        "Bölükbaşı",
	        "Bönek",
	        "Bönge",
	        "Börü",
	        "Börübars",
	        "Börüsengün",
	        "Börteçine",
	        "Buçan",
	        "Buçur",
	        "Budağ",
	        "Budak",
	        "Budunlu",
	        "Buğday",
	        "Buğra",
	        "Buğrakarakağan",
	        "Bukak",
	        "Bukaktutuk",
	        "Bulaçapan",
	        "Bulak",
	        "Bulan",
	        "Buldur",
	        "Bulgak",
	        "Bulmaz",
	        "Bulmuş",
	        "Buluç",
	        "Buluğ",
	        "Buluk",
	        "Buluş",
	        "Bulut",
	        "Bumın",
	        "Bunsuz",
	        "Burçak",
	        "Burguçan",
	        "Burkay",
	        "Burslan",
	        "Burulday",
	        "Burulgu",
	        "Burunduk",
	        "Buşulgan",
	        "Butak",
	        "Butuk",
	        "Buyan",
	        "Buyançuk",
	        "Buyandemir",
	        "Buyankara",
	        "Buyat",
	        "Buyraç",
	        "Buyruç",
	        "Buyruk",
	        "Buzaç",
	        "Buzaçtutuk",
	        "Büdüs",
	        "Büdüstudun",
	        "Bügü",
	        "Bügdüz",
	        "Bügdüzemen",
	        "Büge",
	        "Büğübilge",
	        "Bükdüz",
	        "Büke",
	        "Bükebuyraç",
	        "Bükebuyruç",
	        "Bükey",
	        "Büktegin",
	        "Büküşboğa",
	        "Bümen",
	        "Bünül",
	        "Büre",
	        "Bürgüt",
	        "Bürkek",
	        "Bürküt",
	        "Bürlük",
	        "Cebe",
	        "Ceyhun",
	        "Cılasun",
	        "Çaba",
	        "Çabdar",
	        "Çablı",
	        "Çabuş",
	        "Çağan",
	        "Çağatay",
	        "Çağlar",
	        "Çağlayan",
	        "Çağrı",
	        "Çağrıbeğ",
	        "Çağrıtegin",
	        "Çağru",
	        "Çalapkulu",
	        "Çankız",
	        "Çemen",
	        "Çemgen",
	        "Çeykün",
	        "Çıngır",
	        "Çiçek",
	        "Çiçem",
	        "Çiğdem",
	        "Çilenti",
	        "Çimen",
	        "Çobulmak",
	        "Çocukbörü",
	        "Çokramayul",
	        "Çolman",
	        "Çolpan",
	        "Çölü",
	        "Damla",
	        "Deniz",
	        "Dilek",
	        "Diri",
	        "Dizik",
	        "Duru",
	        "Dururbunsuz",
	        "Duygu",
	        "Ebin",
	        "Ebkızı",
	        "Ebren",
	        "Edil",
	        "Ediz",
	        "Egemen",
	        "Eğrim",
	        "Ekeç",
	        "Ekim",
	        "Ekin",
	        "Elkin",
	        "Elti",
	        "Engin",
	        "Erdem",
	        "Erdeni",
	        "Erdeniözük",
	        "Erdenikatun",
	        "Erentüz",
	        "Ergene",
	        "Ergenekatun",
	        "Erinç",
	        "Erke",
	        "Ermen",
	        "Erten",
	        "Ertenözük",
	        "Esen",
	        "Esenbike",
	        "Eser",
	        "Esin",
	        "Etil",
	        "Evin",
	        "Eyiz",
	        "Gelin",
	        "Gelincik",
	        "Gökbörü",
	        "Gökçe",
	        "Gökçegöl",
	        "Gökçen",
	        "Gökçiçek",
	        "Gökşin",
	        "Gönül",
	        "Görün",
	        "Gözde",
	        "Gülegen",
	        "Gülemen",
	        "Güler",
	        "Gülümser",
	        "Gümüş",
	        "Gün",
	        "Günay",
	        "Günçiçek",
	        "Gündoğdu",
	        "Gündoğmuş",
	        "Güneş",
	        "Günyaruk",
	        "Gürbüz",
	        "Güvercin",
	        "Güzey",
	        "Işığ",
	        "Işık",
	        "Işıl",
	        "Işılay",
	        "Ila",
	        "Ilaçın",
	        "Ilgın",
	        "Inanç",
	        "Irmak",
	        "Isığ",
	        "Isık",
	        "Iyık",
	        "Iyıktağ",
	        "İdil",
	        "İkeme",
	        "İkiçitoyun",
	        "İlbilge",
	        "İldike",
	        "İlgegü",
	        "İmrem",
	        "İnci",
	        "İnç",
	        "İrinç",
	        "İrinçköl",
	        "İrtiş",
	        "İtil",
	        "Kancı",
	        "Kançı",
	        "Kapgar",
	        "Karaca",
	        "Karaça",
	        "Karak",
	        "Kargılaç",
	        "Karlıgaç",
	        "Katun",
	        "Katunkız",
	        "Kayacık",
	        "Kayaçık",
	        "Kayça",
	        "Kaynak",
	        "Kazanç",
	        "Kazkatun",
	        "Kekik",
	        "Keklik",
	        "Kepez",
	        "Kesme",
	        "Keyken",
	        "Kezlik",
	        "Kımız",
	        "Kımızın",
	        "Kımızalma",
	        "Kımızalmıla",
	        "Kırçiçek",
	        "Kırgavul",
	        "Kırlangıç",
	        "Kıvanç",
	        "Kıvılcım",
	        "Kızdurmuş",
	        "Kızılalma"
	    ],
	    "last_name": [
	        "Abacı",
	        "Abadan",
	        "Aclan",
	        "Adal",
	        "Adan",
	        "Adıvar",
	        "Akal",
	        "Akan",
	        "Akar ",
	        "Akay",
	        "Akaydın",
	        "Akbulut",
	        "Akgül",
	        "Akışık",
	        "Akman",
	        "Akyürek",
	        "Akyüz",
	        "Akşit",
	        "Alnıaçık",
	        "Alpuğan",
	        "Alyanak",
	        "Arıcan",
	        "Arslanoğlu",
	        "Atakol",
	        "Atan",
	        "Avan",
	        "Ayaydın",
	        "Aybar",
	        "Aydan",
	        "Aykaç",
	        "Ayverdi",
	        "Ağaoğlu",
	        "Aşıkoğlu",
	        "Babacan",
	        "Babaoğlu",
	        "Bademci",
	        "Bakırcıoğlu",
	        "Balaban",
	        "Balcı",
	        "Barbarosoğlu",
	        "Baturalp",
	        "Baykam",
	        "Başoğlu",
	        "Berberoğlu",
	        "Beşerler",
	        "Beşok",
	        "Biçer",
	        "Bolatlı",
	        "Dalkıran",
	        "Dağdaş",
	        "Dağlaroğlu",
	        "Demirbaş",
	        "Demirel",
	        "Denkel",
	        "Dizdar ",
	        "Doğan ",
	        "Durak ",
	        "Durmaz",
	        "Duygulu",
	        "Düşenkalkar",
	        "Egeli",
	        "Ekici",
	        "Ekşioğlu",
	        "Eliçin",
	        "Elmastaşoğlu",
	        "Elçiboğa",
	        "Erbay",
	        "Erberk",
	        "Erbulak",
	        "Erdoğan",
	        "Erez",
	        "Erginsoy",
	        "Erkekli",
	        "Eronat",
	        "Ertepınar",
	        "Ertürk",
	        "Erçetin",
	        "Evliyaoğlu",
	        "Gönültaş",
	        "Gümüşpala",
	        "Günday",
	        "Gürmen",
	        "Hakyemez",
	        "Hamzaoğlu",
	        "Ilıcalı",
	        "Kahveci",
	        "Kaplangı",
	        "Karabulut",
	        "Karaböcek",
	        "Karadaş",
	        "Karaduman",
	        "Karaer",
	        "Kasapoğlu",
	        "Kavaklıoğlu",
	        "Kaya ",
	        "Keseroğlu",
	        "Keçeci",
	        "Kılıççı",
	        "Kıraç ",
	        "Kocabıyık",
	        "Korol",
	        "Koyuncu",
	        "Koç",
	        "Koçoğlu",
	        "Koçyiğit",
	        "Kuday",
	        "Kulaksızoğlu",
	        "Kumcuoğlu",
	        "Kunt",
	        "Kunter",
	        "Kurutluoğlu",
	        "Kutlay",
	        "Kuzucu",
	        "Körmükçü",
	        "Köybaşı",
	        "Köylüoğlu",
	        "Küçükler",
	        "Limoncuoğlu",
	        "Mayhoş",
	        "Menemencioğlu",
	        "Mertoğlu",
	        "Nalbantoğlu",
	        "Nebioğlu",
	        "Numanoğlu",
	        "Okumuş",
	        "Okur",
	        "Oraloğlu",
	        "Orbay",
	        "Ozansoy",
	        "Paksüt",
	        "Pekkan",
	        "Pektemek",
	        "Polat",
	        "Poyrazoğlu",
	        "Poçan",
	        "Sadıklar",
	        "Samancı",
	        "Sandalcı",
	        "Sarıoğlu",
	        "Saygıner",
	        "Sepetçi",
	        "Sezek",
	        "Sinanoğlu",
	        "Solmaz",
	        "Sözeri",
	        "Süleymanoğlu",
	        "Tahincioğlu",
	        "Tanrıkulu",
	        "Tazegül",
	        "Taşlı",
	        "Taşçı",
	        "Tekand",
	        "Tekelioğlu",
	        "Tokatlıoğlu",
	        "Tokgöz",
	        "Topaloğlu",
	        "Topçuoğlu",
	        "Toraman",
	        "Tunaboylu",
	        "Tunçeri",
	        "Tuğlu",
	        "Tuğluk",
	        "Türkdoğan",
	        "Türkyılmaz",
	        "Tütüncü",
	        "Tüzün",
	        "Uca",
	        "Uluhan",
	        "Velioğlu",
	        "Yalçın",
	        "Yazıcı",
	        "Yetkiner",
	        "Yeşilkaya",
	        "Yıldırım ",
	        "Yıldızoğlu",
	        "Yılmazer",
	        "Yorulmaz",
	        "Çamdalı",
	        "Çapanoğlu",
	        "Çatalbaş",
	        "Çağıran",
	        "Çetin",
	        "Çetiner",
	        "Çevik",
	        "Çörekçi",
	        "Önür",
	        "Örge",
	        "Öymen",
	        "Özberk",
	        "Özbey",
	        "Özbir",
	        "Özdenak",
	        "Özdoğan",
	        "Özgörkey",
	        "Özkara",
	        "Özkök ",
	        "Öztonga",
	        "Öztuna"
	
	    ],
	    "prefix": [
	        "Bay",
	        "Bayan",
	        "Dr.",
	        "Prof. Dr."
	    ],
	    "name": [
	        "#{prefix} #{first_name} #{last_name}",
	        "#{first_name} #{last_name}",
	        "#{first_name} #{last_name}",
	        "#{first_name} #{last_name}",
	        "#{first_name} #{last_name}",
	        "#{first_name} #{last_name}"
	    ]
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)(module)))

/***/ },
/* 319 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var vi = {};
	module["exports"] = vi;
	vi.title = "Vietnamese";
	vi.address = {
	  "city_root": [
	    "Bắc Giang",
	    "Bắc Kạn",
	    "Bắc Ninh",
	    "Cao Bằng",
	    "Điện Biên",
	    "Hà Giang",
	    "Hà Nam",
	    "Hà Tây",
	    "Hải Dương",
	    "TP Hải Phòng",
	    "Hòa Bình",
	    "Hưng Yên",
	    "Lai Châu",
	    "Lào Cai",
	    "Lạng Sơn",
	    "Nam Định",
	    "Ninh Bình",
	    "Phú Thọ",
	    "Quảng Ninh",
	    "Sơn La",
	    "Thái Bình",
	    "Thái Nguyên",
	    "Tuyên Quang",
	    "Vĩnh Phúc",
	    "Yên Bái",
	    "TP Đà Nẵng",
	    "Bình Định",
	    "Đắk Lắk",
	    "Đắk Nông",
	    "Gia Lai",
	    "Hà Tĩnh",
	    "Khánh Hòa",
	    "Kon Tum",
	    "Nghệ An",
	    "Phú Yên",
	    "Quảng Bình",
	    "Quảng Nam",
	    "Quảng Ngãi",
	    "Quảng Trị",
	    "Thanh Hóa",
	    "Thừa Thiên Huế",
	    "TP TP. Hồ Chí Minh",
	    "An Giang",
	    "Bà Rịa Vũng Tàu",
	    "Bạc Liêu",
	    "Bến Tre",
	    "Bình Dương",
	    "Bình Phước",
	    "Bình Thuận",
	    "Cà Mau",
	    "TP Cần Thơ",
	    "Đồng Nai",
	    "Đồng Tháp",
	    "Hậu Giang",
	    "Kiên Giang",
	    "Lâm Đồng",
	    "Long An",
	    "Ninh Thuận",
	    "Sóc Trăng",
	    "Tây Ninh",
	    "Tiền Giang",
	    "Trà Vinh",
	    "Vĩnh Long"
	  ],
	  "city": [
	    "#{city_root}"
	  ],
	  "postcode": "/[A-PR-UWYZ0-9][A-HK-Y0-9][AEHMNPRTVXY0-9]?[ABEHMNPRVWXY0-9]? {1,2}[0-9][ABD-HJLN-UW-Z]{2}/",
	  "county": [
	    "Avon",
	    "Bedfordshire",
	    "Berkshire",
	    "Borders",
	    "Buckinghamshire",
	    "Cambridgeshire",
	    "Central",
	    "Cheshire",
	    "Cleveland",
	    "Clwyd",
	    "Cornwall",
	    "County Antrim",
	    "County Armagh",
	    "County Down",
	    "County Fermanagh",
	    "County Londonderry",
	    "County Tyrone",
	    "Cumbria",
	    "Derbyshire",
	    "Devon",
	    "Dorset",
	    "Dumfries and Galloway",
	    "Durham",
	    "Dyfed",
	    "East Sussex",
	    "Essex",
	    "Fife",
	    "Gloucestershire",
	    "Grampian",
	    "Greater Manchester",
	    "Gwent",
	    "Gwynedd County",
	    "Hampshire",
	    "Herefordshire",
	    "Hertfordshire",
	    "Highlands and Islands",
	    "Humberside",
	    "Isle of Wight",
	    "Kent",
	    "Lancashire",
	    "Leicestershire",
	    "Lincolnshire",
	    "Lothian",
	    "Merseyside",
	    "Mid Glamorgan",
	    "Norfolk",
	    "North Yorkshire",
	    "Northamptonshire",
	    "Northumberland",
	    "Nottinghamshire",
	    "Oxfordshire",
	    "Powys",
	    "Rutland",
	    "Shropshire",
	    "Somerset",
	    "South Glamorgan",
	    "South Yorkshire",
	    "Staffordshire",
	    "Strathclyde",
	    "Suffolk",
	    "Surrey",
	    "Tayside",
	    "Tyne and Wear",
	    "Việt Nam",
	    "Warwickshire",
	    "West Glamorgan",
	    "West Midlands",
	    "West Sussex",
	    "West Yorkshire",
	    "Wiltshire",
	    "Worcestershire"
	  ],
	  "default_country": [
	    "Việt Nam"
	  ]
	};
	vi.internet = {
	  "domain_suffix": [
	    "com",
	    "net",
	    "info",
	    "vn",
	    "com.vn"
	  ]
	};
	vi.phone_number = {
	  "formats": [
	    "01#### #####",
	    "01### ######",
	    "01#1 ### ####",
	    "011# ### ####",
	    "02# #### ####",
	    "03## ### ####",
	    "055 #### ####",
	    "056 #### ####",
	    "0800 ### ####",
	    "08## ### ####",
	    "09## ### ####",
	    "016977 ####",
	    "01### #####",
	    "0500 ######",
	    "0800 ######"
	  ]
	};
	vi.cell_phone = {
	  "formats": [
	    "074## ######",
	    "075## ######",
	    "076## ######",
	    "077## ######",
	    "078## ######",
	    "079## ######"
	  ]
	};
	vi.name = {
	  "first_name": [
	    "Phạm",
	    "Nguyễn",
	    "Trần",
	    "Lê",
	    "Lý",
	    "Hoàng",
	    "Phan",
	    "Vũ",
	    "Tăng",
	    "Đặng",
	    "Bùi",
	    "Đỗ",
	    "Hồ",
	    "Ngô",
	    "Dương",
	    "Đào",
	    "Đoàn",
	    "Vương",
	    "Trịnh",
	    "Đinh",
	    "Lâm",
	    "Phùng",
	    "Mai",
	    "Tô",
	    "Trương",
	    "Hà"
	  ],
	  "last_name": [
	    "Nam",
	    "Trung",
	    "Thanh",
	    "Thị",
	    "Văn",
	    "Dương",
	    "Tăng",
	    "Quốc",
	    "Như",
	    "Phạm",
	    "Nguyễn",
	    "Trần",
	    "Lê",
	    "Lý",
	    "Hoàng",
	    "Phan",
	    "Vũ",
	    "Tăng",
	    "Đặng",
	    "Bùi",
	    "Đỗ",
	    "Hồ",
	    "Ngô",
	    "Dương",
	    "Đào",
	    "Đoàn",
	    "Vương",
	    "Trịnh",
	    "Đinh",
	    "Lâm",
	    "Phùng",
	    "Mai",
	    "Tô",
	    "Trương",
	    "Hà",
	    "Vinh",
	    "Nhung",
	    "Hòa",
	    "Tiến",
	    "Tâm",
	    "Bửu",
	    "Loan",
	    "Hiền",
	    "Hải",
	    "Vân",
	    "Kha",
	    "Minh",
	    "Nhân",
	    "Triệu",
	    "Tuân",
	    "Hữu",
	    "Đức",
	    "Phú",
	    "Khoa",
	    "Thắgn",
	    "Sơn",
	    "Dung",
	    "Tú",
	    "Trinh",
	    "Thảo",
	    "Sa",
	    "Kim",
	    "Long",
	    "Thi",
	    "Cường",
	    "Ngọc",
	    "Sinh",
	    "Khang",
	    "Phong",
	    "Thắm",
	    "Thu",
	    "Thủy",
	    "Nhàn"
	  ],
	  "name": [
	    "#{first_name} #{last_name}",
	    "#{first_name} #{last_name} #{last_name}",
	    "#{first_name} #{last_name} #{last_name} #{last_name}"
	  ]
	};
	vi.company = {
	  "prefix": [
	    "Công ty",
	    "Cty TNHH",
	    "Cty",
	    "Cửa hàng",
	    "Trung tâm",
	    "Chi nhánh"
	  ],
	  "name": [
	    "#{prefix} #{Name.last_name}"
	  ]
	};
	vi.lorem = {
	  "words": [
	    "đã",
	    "đang",
	    "ừ",
	    "ờ",
	    "á",
	    "không",
	    "biết",
	    "gì",
	    "hết",
	    "đâu",
	    "nha",
	    "thế",
	    "thì",
	    "là",
	    "đánh",
	    "đá",
	    "đập",
	    "phá",
	    "viết",
	    "vẽ",
	    "tô",
	    "thuê",
	    "mướn",
	    "mượn",
	    "mua",
	    "một",
	    "hai",
	    "ba",
	    "bốn",
	    "năm",
	    "sáu",
	    "bảy",
	    "tám",
	    "chín",
	    "mười",
	    "thôi",
	    "việc",
	    "nghỉ",
	    "làm",
	    "nhà",
	    "cửa",
	    "xe",
	    "đạp",
	    "ác",
	    "độc",
	    "khoảng",
	    "khoan",
	    "thuyền",
	    "tàu",
	    "bè",
	    "lầu",
	    "xanh",
	    "đỏ",
	    "tím",
	    "vàng",
	    "kim",
	    "chỉ",
	    "khâu",
	    "may",
	    "vá",
	    "em",
	    "anh",
	    "yêu",
	    "thương",
	    "thích",
	    "con",
	    "cái",
	    "bàn",
	    "ghế",
	    "tủ",
	    "quần",
	    "áo",
	    "nón",
	    "dép",
	    "giày",
	    "lỗi",
	    "được",
	    "ghét",
	    "giết",
	    "chết",
	    "hết",
	    "tôi",
	    "bạn",
	    "tui",
	    "trời",
	    "trăng",
	    "mây",
	    "gió",
	    "máy",
	    "hàng",
	    "hóa",
	    "leo",
	    "núi",
	    "bơi",
	    "biển",
	    "chìm",
	    "xuồng",
	    "nước",
	    "ngọt",
	    "ruộng",
	    "đồng",
	    "quê",
	    "hương"
	  ]
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)(module)))

/***/ },
/* 320 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var zh_CN = {};
	module["exports"] = zh_CN;
	zh_CN.title = "Chinese";
	zh_CN.address = {
	  "city_prefix": [
	    "长",
	    "上",
	    "南",
	    "西",
	    "北",
	    "诸",
	    "宁",
	    "珠",
	    "武",
	    "衡",
	    "成",
	    "福",
	    "厦",
	    "贵",
	    "吉",
	    "海",
	    "太",
	    "济",
	    "安",
	    "吉",
	    "包"
	  ],
	  "city_suffix": [
	    "沙市",
	    "京市",
	    "宁市",
	    "安市",
	    "乡县",
	    "海市",
	    "码市",
	    "汉市",
	    "阳市",
	    "都市",
	    "州市",
	    "门市",
	    "阳市",
	    "口市",
	    "原市",
	    "南市",
	    "徽市",
	    "林市",
	    "头市"
	  ],
	  "building_number": [
	    "#####",
	    "####",
	    "###",
	    "##",
	    "#"
	  ],
	  "street_suffix": [
	    "巷",
	    "街",
	    "路",
	    "桥",
	    "侬",
	    "旁",
	    "中心",
	    "栋"
	  ],
	  "postcode": [
	    "######"
	  ],
	  "state": [
	    "北京市",
	    "上海市",
	    "天津市",
	    "重庆市",
	    "黑龙江省",
	    "吉林省",
	    "辽宁省",
	    "内蒙古",
	    "河北省",
	    "新疆",
	    "甘肃省",
	    "青海省",
	    "陕西省",
	    "宁夏",
	    "河南省",
	    "山东省",
	    "山西省",
	    "安徽省",
	    "湖北省",
	    "湖南省",
	    "江苏省",
	    "四川省",
	    "贵州省",
	    "云南省",
	    "广西省",
	    "西藏",
	    "浙江省",
	    "江西省",
	    "广东省",
	    "福建省",
	    "台湾省",
	    "海南省",
	    "香港",
	    "澳门"
	  ],
	  "state_abbr": [
	    "京",
	    "沪",
	    "津",
	    "渝",
	    "黑",
	    "吉",
	    "辽",
	    "蒙",
	    "冀",
	    "新",
	    "甘",
	    "青",
	    "陕",
	    "宁",
	    "豫",
	    "鲁",
	    "晋",
	    "皖",
	    "鄂",
	    "湘",
	    "苏",
	    "川",
	    "黔",
	    "滇",
	    "桂",
	    "藏",
	    "浙",
	    "赣",
	    "粤",
	    "闽",
	    "台",
	    "琼",
	    "港",
	    "澳"
	  ],
	  "city": [
	    "#{city_prefix}#{city_suffix}"
	  ],
	  "street_name": [
	    "#{Name.last_name}#{street_suffix}"
	  ],
	  "street_address": [
	    "#{street_name}#{building_number}号"
	  ],
	  "default_country": [
	    "中国"
	  ]
	};
	zh_CN.name = {
	  "first_name": [
	    "王",
	    "李",
	    "张",
	    "刘",
	    "陈",
	    "杨",
	    "黄",
	    "吴",
	    "赵",
	    "周",
	    "徐",
	    "孙",
	    "马",
	    "朱",
	    "胡",
	    "林",
	    "郭",
	    "何",
	    "高",
	    "罗",
	    "郑",
	    "梁",
	    "谢",
	    "宋",
	    "唐",
	    "许",
	    "邓",
	    "冯",
	    "韩",
	    "曹",
	    "曾",
	    "彭",
	    "萧",
	    "蔡",
	    "潘",
	    "田",
	    "董",
	    "袁",
	    "于",
	    "余",
	    "叶",
	    "蒋",
	    "杜",
	    "苏",
	    "魏",
	    "程",
	    "吕",
	    "丁",
	    "沈",
	    "任",
	    "姚",
	    "卢",
	    "傅",
	    "钟",
	    "姜",
	    "崔",
	    "谭",
	    "廖",
	    "范",
	    "汪",
	    "陆",
	    "金",
	    "石",
	    "戴",
	    "贾",
	    "韦",
	    "夏",
	    "邱",
	    "方",
	    "侯",
	    "邹",
	    "熊",
	    "孟",
	    "秦",
	    "白",
	    "江",
	    "阎",
	    "薛",
	    "尹",
	    "段",
	    "雷",
	    "黎",
	    "史",
	    "龙",
	    "陶",
	    "贺",
	    "顾",
	    "毛",
	    "郝",
	    "龚",
	    "邵",
	    "万",
	    "钱",
	    "严",
	    "赖",
	    "覃",
	    "洪",
	    "武",
	    "莫",
	    "孔"
	  ],
	  "last_name": [
	    "绍齐",
	    "博文",
	    "梓晨",
	    "胤祥",
	    "瑞霖",
	    "明哲",
	    "天翊",
	    "凯瑞",
	    "健雄",
	    "耀杰",
	    "潇然",
	    "子涵",
	    "越彬",
	    "钰轩",
	    "智辉",
	    "致远",
	    "俊驰",
	    "雨泽",
	    "烨磊",
	    "晟睿",
	    "文昊",
	    "修洁",
	    "黎昕",
	    "远航",
	    "旭尧",
	    "鸿涛",
	    "伟祺",
	    "荣轩",
	    "越泽",
	    "浩宇",
	    "瑾瑜",
	    "皓轩",
	    "擎苍",
	    "擎宇",
	    "志泽",
	    "子轩",
	    "睿渊",
	    "弘文",
	    "哲瀚",
	    "雨泽",
	    "楷瑞",
	    "建辉",
	    "晋鹏",
	    "天磊",
	    "绍辉",
	    "泽洋",
	    "鑫磊",
	    "鹏煊",
	    "昊强",
	    "伟宸",
	    "博超",
	    "君浩",
	    "子骞",
	    "鹏涛",
	    "炎彬",
	    "鹤轩",
	    "越彬",
	    "风华",
	    "靖琪",
	    "明辉",
	    "伟诚",
	    "明轩",
	    "健柏",
	    "修杰",
	    "志泽",
	    "弘文",
	    "峻熙",
	    "嘉懿",
	    "煜城",
	    "懿轩",
	    "烨伟",
	    "苑博",
	    "伟泽",
	    "熠彤",
	    "鸿煊",
	    "博涛",
	    "烨霖",
	    "烨华",
	    "煜祺",
	    "智宸",
	    "正豪",
	    "昊然",
	    "明杰",
	    "立诚",
	    "立轩",
	    "立辉",
	    "峻熙",
	    "弘文",
	    "熠彤",
	    "鸿煊",
	    "烨霖",
	    "哲瀚",
	    "鑫鹏",
	    "昊天",
	    "思聪",
	    "展鹏",
	    "笑愚",
	    "志强",
	    "炫明",
	    "雪松",
	    "思源",
	    "智渊",
	    "思淼",
	    "晓啸",
	    "天宇",
	    "浩然",
	    "文轩",
	    "鹭洋",
	    "振家",
	    "乐驹",
	    "晓博",
	    "文博",
	    "昊焱",
	    "立果",
	    "金鑫",
	    "锦程",
	    "嘉熙",
	    "鹏飞",
	    "子默",
	    "思远",
	    "浩轩",
	    "语堂",
	    "聪健",
	    "明",
	    "文",
	    "果",
	    "思",
	    "鹏",
	    "驰",
	    "涛",
	    "琪",
	    "浩",
	    "航",
	    "彬"
	  ],
	  "name": [
	    "#{first_name}#{last_name}"
	  ]
	};
	zh_CN.phone_number = {
	  "formats": [
	    "###-########",
	    "####-########",
	    "###########"
	  ]
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)(module)))

/***/ },
/* 321 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var zh_TW = {};
	module["exports"] = zh_TW;
	zh_TW.title = "Chinese (Taiwan)";
	zh_TW.address = {
	  "city_prefix": [
	    "臺北",
	    "新北",
	    "桃園",
	    "臺中",
	    "臺南",
	    "高雄",
	    "基隆",
	    "新竹",
	    "嘉義",
	    "苗栗",
	    "彰化",
	    "南投",
	    "雲林",
	    "屏東",
	    "宜蘭",
	    "花蓮",
	    "臺東",
	    "澎湖",
	    "金門",
	    "連江"
	  ],
	  "city_suffix": [
	    "縣",
	    "市"
	  ],
	  "building_number": [
	    "####",
	    "###",
	    "##",
	    "#"
	  ],
	  "street_suffix": [
	    "街",
	    "路",
	    "北路",
	    "南路",
	    "東路",
	    "西路"
	  ],
	  "postcode": [
	    "######"
	  ],
	  "state": [
	    "福建省",
	    "台灣省"
	  ],
	  "state_abbr": [
	    "北",
	    "新北",
	    "桃",
	    "中",
	    "南",
	    "高",
	    "基",
	    "竹市",
	    "嘉市",
	    "竹縣",
	    "苗",
	    "彰",
	    "投",
	    "雲",
	    "嘉縣",
	    "宜",
	    "花",
	    "東",
	    "澎",
	    "金",
	    "馬"
	  ],
	  "city": [
	    "#{city_prefix}#{city_suffix}"
	  ],
	  "street_name": [
	    "#{Name.last_name}#{street_suffix}"
	  ],
	  "street_address": [
	    "#{street_name}#{building_number}號"
	  ],
	  "default_country": [
	    "Taiwan (R.O.C.)"
	  ]
	};
	zh_TW.name = {
	  "first_name": [
	    "王",
	    "李",
	    "張",
	    "劉",
	    "陳",
	    "楊",
	    "黃",
	    "吳",
	    "趙",
	    "週",
	    "徐",
	    "孫",
	    "馬",
	    "朱",
	    "胡",
	    "林",
	    "郭",
	    "何",
	    "高",
	    "羅",
	    "鄭",
	    "梁",
	    "謝",
	    "宋",
	    "唐",
	    "許",
	    "鄧",
	    "馮",
	    "韓",
	    "曹",
	    "曾",
	    "彭",
	    "蕭",
	    "蔡",
	    "潘",
	    "田",
	    "董",
	    "袁",
	    "於",
	    "餘",
	    "葉",
	    "蔣",
	    "杜",
	    "蘇",
	    "魏",
	    "程",
	    "呂",
	    "丁",
	    "沈",
	    "任",
	    "姚",
	    "盧",
	    "傅",
	    "鐘",
	    "姜",
	    "崔",
	    "譚",
	    "廖",
	    "範",
	    "汪",
	    "陸",
	    "金",
	    "石",
	    "戴",
	    "賈",
	    "韋",
	    "夏",
	    "邱",
	    "方",
	    "侯",
	    "鄒",
	    "熊",
	    "孟",
	    "秦",
	    "白",
	    "江",
	    "閻",
	    "薛",
	    "尹",
	    "段",
	    "雷",
	    "黎",
	    "史",
	    "龍",
	    "陶",
	    "賀",
	    "顧",
	    "毛",
	    "郝",
	    "龔",
	    "邵",
	    "萬",
	    "錢",
	    "嚴",
	    "賴",
	    "覃",
	    "洪",
	    "武",
	    "莫",
	    "孔"
	  ],
	  "last_name": [
	    "紹齊",
	    "博文",
	    "梓晨",
	    "胤祥",
	    "瑞霖",
	    "明哲",
	    "天翊",
	    "凱瑞",
	    "健雄",
	    "耀傑",
	    "瀟然",
	    "子涵",
	    "越彬",
	    "鈺軒",
	    "智輝",
	    "致遠",
	    "俊馳",
	    "雨澤",
	    "燁磊",
	    "晟睿",
	    "文昊",
	    "修潔",
	    "黎昕",
	    "遠航",
	    "旭堯",
	    "鴻濤",
	    "偉祺",
	    "榮軒",
	    "越澤",
	    "浩宇",
	    "瑾瑜",
	    "皓軒",
	    "擎蒼",
	    "擎宇",
	    "志澤",
	    "子軒",
	    "睿淵",
	    "弘文",
	    "哲瀚",
	    "雨澤",
	    "楷瑞",
	    "建輝",
	    "晉鵬",
	    "天磊",
	    "紹輝",
	    "澤洋",
	    "鑫磊",
	    "鵬煊",
	    "昊強",
	    "偉宸",
	    "博超",
	    "君浩",
	    "子騫",
	    "鵬濤",
	    "炎彬",
	    "鶴軒",
	    "越彬",
	    "風華",
	    "靖琪",
	    "明輝",
	    "偉誠",
	    "明軒",
	    "健柏",
	    "修傑",
	    "志澤",
	    "弘文",
	    "峻熙",
	    "嘉懿",
	    "煜城",
	    "懿軒",
	    "燁偉",
	    "苑博",
	    "偉澤",
	    "熠彤",
	    "鴻煊",
	    "博濤",
	    "燁霖",
	    "燁華",
	    "煜祺",
	    "智宸",
	    "正豪",
	    "昊然",
	    "明杰",
	    "立誠",
	    "立軒",
	    "立輝",
	    "峻熙",
	    "弘文",
	    "熠彤",
	    "鴻煊",
	    "燁霖",
	    "哲瀚",
	    "鑫鵬",
	    "昊天",
	    "思聰",
	    "展鵬",
	    "笑愚",
	    "志強",
	    "炫明",
	    "雪松",
	    "思源",
	    "智淵",
	    "思淼",
	    "曉嘯",
	    "天宇",
	    "浩然",
	    "文軒",
	    "鷺洋",
	    "振家",
	    "樂駒",
	    "曉博",
	    "文博",
	    "昊焱",
	    "立果",
	    "金鑫",
	    "錦程",
	    "嘉熙",
	    "鵬飛",
	    "子默",
	    "思遠",
	    "浩軒",
	    "語堂",
	    "聰健"
	  ],
	  "name": [
	    "#{first_name}#{last_name}"
	  ],
	};
	zh_TW.phone_number = {
	  "formats": [
	    "0#-#######",
	    "02-########",
	    "09##-######"
	  ]
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)(module)))

/***/ },
/* 322 */
/***/ function(module, exports, __webpack_require__) {

	var faker = __webpack_require__(11);
	var Helpers = __webpack_require__(54);
	
	var lorem = {
	    words: function (num) {
	        if (typeof num == 'undefined') { num = 3; }
	        return Helpers.shuffle(faker.definitions.lorem.words).slice(0, num);
	    },
	
	    sentence: function (wordCount, range) {
	        if (typeof wordCount == 'undefined') { wordCount = 3; }
	        if (typeof range == 'undefined') { range = 7; }
	
	        // strange issue with the node_min_test failing for captialize, please fix and add faker.lorem.back
	        //return  faker.lorem.words(wordCount + Helpers.randomNumber(range)).join(' ').capitalize();
	
	        return  faker.lorem.words(wordCount + faker.random.number(range)).join(' ');
	    },
	
	    sentences: function (sentenceCount) {
	        if (typeof sentenceCount == 'undefined') { sentenceCount = 3; }
	        var sentences = [];
	        for (sentenceCount; sentenceCount > 0; sentenceCount--) {
	            sentences.push(faker.lorem.sentence());
	        }
	        return sentences.join("\n");
	    },
	
	    paragraph: function (sentenceCount) {
	        if (typeof sentenceCount == 'undefined') { sentenceCount = 3; }
	        return faker.lorem.sentences(sentenceCount + faker.random.number(3));
	    },
	
	    paragraphs: function (paragraphCount) {
	        if (typeof paragraphCount == 'undefined') { paragraphCount = 3; }
	        var paragraphs = [];
	        for (paragraphCount; paragraphCount > 0; paragraphCount--) {
	            paragraphs.push(faker.lorem.paragraph());
	        }
	        return paragraphs.join("\n \r\t");
	    }
	};
	
	module.exports = lorem;


/***/ },
/* 323 */
/***/ function(module, exports, __webpack_require__) {

	var faker = __webpack_require__(11);
	
	var _name = {
	
	    firstName: function () {
	      if (typeof faker.definitions.name.male_first_name !== "undefined" && typeof faker.definitions.name.female_first_name !== "undefined") {
	        // some locale datasets ( like ru ) have first_name split by gender. since the name.first_name field does not exist in these datasets,
	        // we must randomly pick a name from either gender array so faker.name.firstName will return the correct locale data ( and not fallback )
	        var rand = faker.random.number(1);
	        if (rand === 0) {
	          return faker.random.array_element(faker.locales[faker.locale].name.male_first_name);
	        } else {
	          return faker.random.array_element(faker.locales[faker.locale].name.female_first_name);
	        }
	      }
	      return faker.random.array_element(faker.definitions.name.first_name);
	    },
	
	    lastName: function () {
	      if (typeof faker.definitions.name.male_last_name !== "undefined" && typeof faker.defintions.name.female_last_name !== "undefined") {
	        // some locale datasets ( like ru ) have last_name split by gender. i have no idea how last names can have genders, but also i do not speak russian
	        // see above comment of firstName method
	        var rand = faker.random.number(1);
	        if (rand === 0) {
	          return faker.random.array_element(faker.locales[faker.locale].name.male_last_name);
	        } else {
	          return faker.random.array_element(faker.locales[faker.locale].name.female_last_name);
	        }
	      }
	      return faker.random.array_element(faker.definitions.name.last_name);
	    },
	
	    findName: function (firstName, lastName) {
	        var r = faker.random.number(8);
	        firstName = firstName || faker.name.firstName();
	        lastName = lastName || faker.name.lastName();
	        switch (r) {
	        case 0:
	            return faker.name.prefix() + " " + firstName + " " + lastName;
	        case 1:
	            return firstName + " " + lastName + " " + faker.name.suffix();
	        }
	
	        return firstName + " " + lastName;
	    },
	
	    prefix: function () {
	        return faker.random.array_element(faker.definitions.name.prefix);
	    },
	
	    suffix: function () {
	        return faker.random.array_element(faker.definitions.name.suffix);
	    },
	
	    title: function() {
	        var descriptor  = faker.random.array_element(faker.definitions.name.title.descriptor),
	            level       = faker.random.array_element(faker.definitions.name.title.level),
	            job         = faker.random.array_element(faker.definitions.name.title.job);
	
	        return descriptor + " " + level + " " + job;
	    }
	
	};
	
	module.exports = _name;


/***/ },
/* 324 */
/***/ function(module, exports, __webpack_require__) {

	var faker = __webpack_require__(11);
	
	var phone = {
	    phoneNumber: function (format) {
	        format = format || faker.phone.phoneFormats();
	        return faker.helpers.replaceSymbolWithNumber(format);
	    },
	
	    // FIXME: this is strange passing in an array index.
	    phoneNumberFormat: function (phoneFormatsArrayIndex) {
	        phoneFormatsArrayIndex = phoneFormatsArrayIndex || 0;
	        return faker.helpers.replaceSymbolWithNumber(faker.definitions.phone_number.formats[phoneFormatsArrayIndex]);
	    },
	
	    phoneFormats: function () {
	      return faker.random.array_element(faker.definitions.phone_number.formats);
	    }
	
	};
	
	module.exports = phone;


/***/ },
/* 325 */
/***/ function(module, exports, __webpack_require__) {

	var mersenne = __webpack_require__(326);
	var faker = __webpack_require__(11);
	
	var random = {
	    // returns a single random number based on a max number or range
	    number: function (options) {
	
	        if (typeof options === "number") {
	          options = {
	            max: options
	          };
	        }
	
	        options = options || {};
	
	        if (typeof options.min === "undefined") {
	          options.min = 0;
	        }
	
	        if (typeof options.max === "undefined") {
	          options.max = 1;
	        }
	        if (typeof options.precision === "undefined") {
	          options.precision = 1;
	        }
	
	        // Make the range inclusive of the max value
	        var max = options.max;
	        if (max >= 0) {
	          max += options.precision;
	        } 
	          
	        var randomNumber = options.precision * Math.floor(
	          mersenne.rand(max / options.precision, options.min / options.precision));
	
	        return randomNumber;
	
	    },
	
	    // takes an array and returns a random element of the array
	    array_element: function (array) {
	        array = array || ["a", "b", "c"];
	        var r = faker.random.number({ max: array.length - 1 });
	        return array[r];
	    },
	
	    // takes an object and returns the randomly key or value
	    object_element: function (object, field) {
	        object = object || {};
	        var array = Object.keys(object);
	        var key = faker.random.array_element(array);
	
	        return field === "key" ? key : object[key];
	    },
	
	    uuid : function () {
	        var RFC4122_TEMPLATE = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx';
	        var replacePlaceholders = function (placeholder) {
	            var random = Math.random()*16|0;
	            var value = placeholder == 'x' ? random : (random &0x3 | 0x8);
	            return value.toString(16);
	        };
	        return RFC4122_TEMPLATE.replace(/[xy]/g, replacePlaceholders);
	    },
	
	    boolean: function () {
	        return !!faker.random.number(1)
	    }
	};
	
	module.exports = random;


/***/ },
/* 326 */
/***/ function(module, exports) {

	// this program is a JavaScript version of Mersenne Twister, with concealment and encapsulation in class,
	// an almost straight conversion from the original program, mt19937ar.c,
	// translated by y. okada on July 17, 2006.
	// and modified a little at july 20, 2006, but there are not any substantial differences.
	// in this program, procedure descriptions and comments of original source code were not removed.
	// lines commented with //c// were originally descriptions of c procedure. and a few following lines are appropriate JavaScript descriptions.
	// lines commented with /* and */ are original comments.
	// lines commented with // are additional comments in this JavaScript version.
	// before using this version, create at least one instance of MersenneTwister19937 class, and initialize the each state, given below in c comments, of all the instances.
	/*
	   A C-program for MT19937, with initialization improved 2002/1/26.
	   Coded by Takuji Nishimura and Makoto Matsumoto.
	
	   Before using, initialize the state by using init_genrand(seed)
	   or init_by_array(init_key, key_length).
	
	   Copyright (C) 1997 - 2002, Makoto Matsumoto and Takuji Nishimura,
	   All rights reserved.
	
	   Redistribution and use in source and binary forms, with or without
	   modification, are permitted provided that the following conditions
	   are met:
	
	     1. Redistributions of source code must retain the above copyright
	        notice, this list of conditions and the following disclaimer.
	
	     2. Redistributions in binary form must reproduce the above copyright
	        notice, this list of conditions and the following disclaimer in the
	        documentation and/or other materials provided with the distribution.
	
	     3. The names of its contributors may not be used to endorse or promote
	        products derived from this software without specific prior written
	        permission.
	
	   THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
	   "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
	   LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
	   A PARTICULAR PURPOSE ARE DISCLAIMED.  IN NO EVENT SHALL THE COPYRIGHT OWNER OR
	   CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
	   EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO,
	   PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	   PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
	   LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
	   NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
	   SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	
	
	   Any feedback is very welcome.
	   http://www.math.sci.hiroshima-u.ac.jp/~m-mat/MT/emt.html
	   email: m-mat @ math.sci.hiroshima-u.ac.jp (remove space)
	*/
	
	function MersenneTwister19937()
	{
		/* constants should be scoped inside the class */
		var N, M, MATRIX_A, UPPER_MASK, LOWER_MASK;
		/* Period parameters */
		//c//#define N 624
		//c//#define M 397
		//c//#define MATRIX_A 0x9908b0dfUL   /* constant vector a */
		//c//#define UPPER_MASK 0x80000000UL /* most significant w-r bits */
		//c//#define LOWER_MASK 0x7fffffffUL /* least significant r bits */
		N = 624;
		M = 397;
		MATRIX_A = 0x9908b0df;   /* constant vector a */
		UPPER_MASK = 0x80000000; /* most significant w-r bits */
		LOWER_MASK = 0x7fffffff; /* least significant r bits */
		//c//static unsigned long mt[N]; /* the array for the state vector  */
		//c//static int mti=N+1; /* mti==N+1 means mt[N] is not initialized */
		var mt = new Array(N);   /* the array for the state vector  */
		var mti = N+1;           /* mti==N+1 means mt[N] is not initialized */
	
		function unsigned32 (n1) // returns a 32-bits unsiged integer from an operand to which applied a bit operator.
		{
			return n1 < 0 ? (n1 ^ UPPER_MASK) + UPPER_MASK : n1;
		}
	
		function subtraction32 (n1, n2) // emulates lowerflow of a c 32-bits unsiged integer variable, instead of the operator -. these both arguments must be non-negative integers expressible using unsigned 32 bits.
		{
			return n1 < n2 ? unsigned32((0x100000000 - (n2 - n1)) & 0xffffffff) : n1 - n2;
		}
	
		function addition32 (n1, n2) // emulates overflow of a c 32-bits unsiged integer variable, instead of the operator +. these both arguments must be non-negative integers expressible using unsigned 32 bits.
		{
			return unsigned32((n1 + n2) & 0xffffffff)
		}
	
		function multiplication32 (n1, n2) // emulates overflow of a c 32-bits unsiged integer variable, instead of the operator *. these both arguments must be non-negative integers expressible using unsigned 32 bits.
		{
			var sum = 0;
			for (var i = 0; i < 32; ++i){
				if ((n1 >>> i) & 0x1){
					sum = addition32(sum, unsigned32(n2 << i));
				}
			}
			return sum;
		}
	
		/* initializes mt[N] with a seed */
		//c//void init_genrand(unsigned long s)
		this.init_genrand = function (s)
		{
			//c//mt[0]= s & 0xffffffff;
			mt[0]= unsigned32(s & 0xffffffff);
			for (mti=1; mti<N; mti++) {
				mt[mti] = 
				//c//(1812433253 * (mt[mti-1] ^ (mt[mti-1] >> 30)) + mti);
				addition32(multiplication32(1812433253, unsigned32(mt[mti-1] ^ (mt[mti-1] >>> 30))), mti);
				/* See Knuth TAOCP Vol2. 3rd Ed. P.106 for multiplier. */
				/* In the previous versions, MSBs of the seed affect   */
				/* only MSBs of the array mt[].                        */
				/* 2002/01/09 modified by Makoto Matsumoto             */
				//c//mt[mti] &= 0xffffffff;
				mt[mti] = unsigned32(mt[mti] & 0xffffffff);
				/* for >32 bit machines */
			}
		}
	
		/* initialize by an array with array-length */
		/* init_key is the array for initializing keys */
		/* key_length is its length */
		/* slight change for C++, 2004/2/26 */
		//c//void init_by_array(unsigned long init_key[], int key_length)
		this.init_by_array = function (init_key, key_length)
		{
			//c//int i, j, k;
			var i, j, k;
			//c//init_genrand(19650218);
			this.init_genrand(19650218);
			i=1; j=0;
			k = (N>key_length ? N : key_length);
			for (; k; k--) {
				//c//mt[i] = (mt[i] ^ ((mt[i-1] ^ (mt[i-1] >> 30)) * 1664525))
				//c//	+ init_key[j] + j; /* non linear */
				mt[i] = addition32(addition32(unsigned32(mt[i] ^ multiplication32(unsigned32(mt[i-1] ^ (mt[i-1] >>> 30)), 1664525)), init_key[j]), j);
				mt[i] = 
				//c//mt[i] &= 0xffffffff; /* for WORDSIZE > 32 machines */
				unsigned32(mt[i] & 0xffffffff);
				i++; j++;
				if (i>=N) { mt[0] = mt[N-1]; i=1; }
				if (j>=key_length) j=0;
			}
			for (k=N-1; k; k--) {
				//c//mt[i] = (mt[i] ^ ((mt[i-1] ^ (mt[i-1] >> 30)) * 1566083941))
				//c//- i; /* non linear */
				mt[i] = subtraction32(unsigned32((dbg=mt[i]) ^ multiplication32(unsigned32(mt[i-1] ^ (mt[i-1] >>> 30)), 1566083941)), i);
				//c//mt[i] &= 0xffffffff; /* for WORDSIZE > 32 machines */
				mt[i] = unsigned32(mt[i] & 0xffffffff);
				i++;
				if (i>=N) { mt[0] = mt[N-1]; i=1; }
			}
			mt[0] = 0x80000000; /* MSB is 1; assuring non-zero initial array */
		}
	
	    /* moved outside of genrand_int32() by jwatte 2010-11-17; generate less garbage */
	    var mag01 = [0x0, MATRIX_A];
	
		/* generates a random number on [0,0xffffffff]-interval */
		//c//unsigned long genrand_int32(void)
		this.genrand_int32 = function ()
		{
			//c//unsigned long y;
			//c//static unsigned long mag01[2]={0x0UL, MATRIX_A};
			var y;
			/* mag01[x] = x * MATRIX_A  for x=0,1 */
	
			if (mti >= N) { /* generate N words at one time */
				//c//int kk;
				var kk;
	
				if (mti == N+1)   /* if init_genrand() has not been called, */
					//c//init_genrand(5489); /* a default initial seed is used */
					this.init_genrand(5489); /* a default initial seed is used */
	
				for (kk=0;kk<N-M;kk++) {
					//c//y = (mt[kk]&UPPER_MASK)|(mt[kk+1]&LOWER_MASK);
					//c//mt[kk] = mt[kk+M] ^ (y >> 1) ^ mag01[y & 0x1];
					y = unsigned32((mt[kk]&UPPER_MASK)|(mt[kk+1]&LOWER_MASK));
					mt[kk] = unsigned32(mt[kk+M] ^ (y >>> 1) ^ mag01[y & 0x1]);
				}
				for (;kk<N-1;kk++) {
					//c//y = (mt[kk]&UPPER_MASK)|(mt[kk+1]&LOWER_MASK);
					//c//mt[kk] = mt[kk+(M-N)] ^ (y >> 1) ^ mag01[y & 0x1];
					y = unsigned32((mt[kk]&UPPER_MASK)|(mt[kk+1]&LOWER_MASK));
					mt[kk] = unsigned32(mt[kk+(M-N)] ^ (y >>> 1) ^ mag01[y & 0x1]);
				}
				//c//y = (mt[N-1]&UPPER_MASK)|(mt[0]&LOWER_MASK);
				//c//mt[N-1] = mt[M-1] ^ (y >> 1) ^ mag01[y & 0x1];
				y = unsigned32((mt[N-1]&UPPER_MASK)|(mt[0]&LOWER_MASK));
				mt[N-1] = unsigned32(mt[M-1] ^ (y >>> 1) ^ mag01[y & 0x1]);
				mti = 0;
			}
	
			y = mt[mti++];
	
			/* Tempering */
			//c//y ^= (y >> 11);
			//c//y ^= (y << 7) & 0x9d2c5680;
			//c//y ^= (y << 15) & 0xefc60000;
			//c//y ^= (y >> 18);
			y = unsigned32(y ^ (y >>> 11));
			y = unsigned32(y ^ ((y << 7) & 0x9d2c5680));
			y = unsigned32(y ^ ((y << 15) & 0xefc60000));
			y = unsigned32(y ^ (y >>> 18));
	
			return y;
		}
	
		/* generates a random number on [0,0x7fffffff]-interval */
		//c//long genrand_int31(void)
		this.genrand_int31 = function ()
		{
			//c//return (genrand_int32()>>1);
			return (this.genrand_int32()>>>1);
		}
	
		/* generates a random number on [0,1]-real-interval */
		//c//double genrand_real1(void)
		this.genrand_real1 = function ()
		{
			//c//return genrand_int32()*(1.0/4294967295.0);
			return this.genrand_int32()*(1.0/4294967295.0);
			/* divided by 2^32-1 */
		}
	
		/* generates a random number on [0,1)-real-interval */
		//c//double genrand_real2(void)
		this.genrand_real2 = function ()
		{
			//c//return genrand_int32()*(1.0/4294967296.0);
			return this.genrand_int32()*(1.0/4294967296.0);
			/* divided by 2^32 */
		}
	
		/* generates a random number on (0,1)-real-interval */
		//c//double genrand_real3(void)
		this.genrand_real3 = function ()
		{
			//c//return ((genrand_int32()) + 0.5)*(1.0/4294967296.0);
			return ((this.genrand_int32()) + 0.5)*(1.0/4294967296.0);
			/* divided by 2^32 */
		}
	
		/* generates a random number on [0,1) with 53-bit resolution*/
		//c//double genrand_res53(void)
		this.genrand_res53 = function ()
		{
			//c//unsigned long a=genrand_int32()>>5, b=genrand_int32()>>6;
			var a=this.genrand_int32()>>>5, b=this.genrand_int32()>>>6;
			return(a*67108864.0+b)*(1.0/9007199254740992.0);
		}
		/* These real versions are due to Isaku Wada, 2002/01/09 added */
	}
	
	//  Exports: Public API
	
	//  Export the twister class
	exports.MersenneTwister19937 = MersenneTwister19937;
	
	//  Export a simplified function to generate random numbers
	var gen = new MersenneTwister19937;
	gen.init_genrand((new Date).getTime() % 1000000000);
	
	// Added max, min range functionality, Marak Squires Sept 11 2014
	exports.rand = function(max, min) {
	    if (!max)
	        {
	        min = 0;
	        max = 32768;
	        }
	    return Math.floor(gen.genrand_real2() * (max - min) + min);
	}
	exports.seed = function(S) {
	    if (typeof(S) != 'number')
	        {
	        throw new Error("seed(S) must take numeric argument; is " + typeof(S));
	        }
	    gen.init_genrand(S);
	}
	exports.seed_array = function(A) {
	    if (typeof(A) != 'object')
	        {
	        throw new Error("seed_array(A) must take array of numbers; is " + typeof(A));
	        }
	    gen.init_by_array(A);
	}
	


/***/ },
/* 327 */
/***/ function(module, exports, __webpack_require__) {

	/*
	 * password-generator
	 * Copyright(c) 2011-2013 Bermi Ferrer <bermi@bermilabs.com>
	 * MIT Licensed
	 */
	(function (root) {
	
	  var localName, consonant, letter, password, vowel;
	  letter = /[a-zA-Z]$/;
	  vowel = /[aeiouAEIOU]$/;
	  consonant = /[bcdfghjklmnpqrstvwxyzBCDFGHJKLMNPQRSTVWXYZ]$/;
	
	
	  // Defines the name of the local variable the passwordGenerator library will use
	  // this is specially useful if window.passwordGenerator is already being used
	  // by your application and you want a different name. For example:
	  //    // Declare before including the passwordGenerator library
	  //    var localPasswordGeneratorLibraryName = 'pass';
	  localName = root.localPasswordGeneratorLibraryName || "generatePassword",
	
	  password = function (length, memorable, pattern, prefix) {
	    var char, n;
	    if (length == null) {
	      length = 10;
	    }
	    if (memorable == null) {
	      memorable = true;
	    }
	    if (pattern == null) {
	      pattern = /\w/;
	    }
	    if (prefix == null) {
	      prefix = '';
	    }
	    if (prefix.length >= length) {
	      return prefix;
	    }
	    if (memorable) {
	      if (prefix.match(consonant)) {
	        pattern = vowel;
	      } else {
	        pattern = consonant;
	      }
	    }
	    n = Math.floor(Math.random() * 94) + 33;
	    char = String.fromCharCode(n);
	    if (memorable) {
	      char = char.toLowerCase();
	    }
	    if (!char.match(pattern)) {
	      return password(length, memorable, pattern, prefix);
	    }
	    return password(length, memorable, pattern, "" + prefix + char);
	  };
	
	
	  (( true) ? exports : root)[localName] = password;
	  if (true) {
	    if (typeof module !== 'undefined' && module.exports) {
	      module.exports = password;
	    }
	  }
	
	  // Establish the root object, `window` in the browser, or `global` on the server.
	}(this));

/***/ },
/* 328 */
/***/ function(module, exports) {

	/*
	
	Copyright (c) 2012-2014 Jeffrey Mealo
	
	Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated
	documentation files (the "Software"), to deal in the Software without restriction, including without limitation
	the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and
	to permit persons to whom the Software is furnished to do so, subject to the following conditions:
	
	The above copyright notice and this permission notice shall be included in all copies or substantial portions of the
	Software.
	
	THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE
	WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
	COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	------------------------------------------------------------------------------------------------------------------------
	
	Based loosely on Luka Pusic's PHP Script: http://360percents.com/posts/php-random-user-agent-generator/
	
	The license for that script is as follows:
	
	"THE BEER-WARE LICENSE" (Revision 42):
	
	<pusic93@gmail.com> wrote this file. As long as you retain this notice you can do whatever you want with this stuff.
	If we meet some day, and you think this stuff is worth it, you can buy me a beer in return. Luka Pusic
	*/
	
	function rnd(a, b) {
	    //calling rnd() with no arguments is identical to rnd(0, 100)
	    a = a || 0;
	    b = b || 100;
	
	    if (typeof b === 'number' && typeof a === 'number') {
	        //rnd(int min, int max) returns integer between min, max
	        return (function (min, max) {
	            if (min > max) {
	                throw new RangeError('expected min <= max; got min = ' + min + ', max = ' + max);
	            }
	            return Math.floor(Math.random() * (max - min + 1)) + min;
	        }(a, b));
	    }
	
	    if (Object.prototype.toString.call(a) === "[object Array]") {
	        //returns a random element from array (a), even weighting
	        return a[Math.floor(Math.random() * a.length)];
	    }
	
	    if (a && typeof a === 'object') {
	        //returns a random key from the passed object; keys are weighted by the decimal probability in their value
	        return (function (obj) {
	            var rand = rnd(0, 100) / 100, min = 0, max = 0, key, return_val;
	
	            for (key in obj) {
	                if (obj.hasOwnProperty(key)) {
	                    max = obj[key] + min;
	                    return_val = key;
	                    if (rand >= min && rand <= max) {
	                        break;
	                    }
	                    min = min + obj[key];
	                }
	            }
	
	            return return_val;
	        }(a));
	    }
	
	    throw new TypeError('Invalid arguments passed to rnd. (' + (b ? a + ', ' + b : a) + ')');
	}
	
	function randomLang() {
	    return rnd(['AB', 'AF', 'AN', 'AR', 'AS', 'AZ', 'BE', 'BG', 'BN', 'BO', 'BR', 'BS', 'CA', 'CE', 'CO', 'CS',
	                'CU', 'CY', 'DA', 'DE', 'EL', 'EN', 'EO', 'ES', 'ET', 'EU', 'FA', 'FI', 'FJ', 'FO', 'FR', 'FY',
	                'GA', 'GD', 'GL', 'GV', 'HE', 'HI', 'HR', 'HT', 'HU', 'HY', 'ID', 'IS', 'IT', 'JA', 'JV', 'KA',
	                'KG', 'KO', 'KU', 'KW', 'KY', 'LA', 'LB', 'LI', 'LN', 'LT', 'LV', 'MG', 'MK', 'MN', 'MO', 'MS',
	                'MT', 'MY', 'NB', 'NE', 'NL', 'NN', 'NO', 'OC', 'PL', 'PT', 'RM', 'RO', 'RU', 'SC', 'SE', 'SK',
	                'SL', 'SO', 'SQ', 'SR', 'SV', 'SW', 'TK', 'TR', 'TY', 'UK', 'UR', 'UZ', 'VI', 'VO', 'YI', 'ZH']);
	}
	
	function randomBrowserAndOS() {
	    var browser = rnd({
	        chrome:    .45132810566,
	        iexplorer: .27477061836,
	        firefox:   .19384170608,
	        safari:    .06186781118,
	        opera:     .01574236955
	    }),
	    os = {
	        chrome:  {win: .89,  mac: .09 , lin: .02},
	        firefox: {win: .83,  mac: .16,  lin: .01},
	        opera:   {win: .91,  mac: .03 , lin: .06},
	        safari:  {win: .04 , mac: .96  },
	        iexplorer: ['win']
	    };
	
	    return [browser, rnd(os[browser])];
	}
	
	function randomProc(arch) {
	    var procs = {
	        lin:['i686', 'x86_64'],
	        mac: {'Intel' : .48, 'PPC': .01, 'U; Intel':.48, 'U; PPC' :.01},
	        win:['', 'WOW64', 'Win64; x64']
	    };
	    return rnd(procs[arch]);
	}
	
	function randomRevision(dots) {
	    var return_val = '';
	    //generate a random revision
	    //dots = 2 returns .x.y where x & y are between 0 and 9
	    for (var x = 0; x < dots; x++) {
	        return_val += '.' + rnd(0, 9);
	    }
	    return return_val;
	}
	
	var version_string = {
	    net: function () {
	        return [rnd(1, 4), rnd(0, 9), rnd(10000, 99999), rnd(0, 9)].join('.');
	    },
	    nt: function () {
	        return rnd(5, 6) + '.' + rnd(0, 3);
	    },
	    ie: function () {
	        return rnd(7, 11);
	    },
	    trident: function () {
	        return rnd(3, 7) + '.' + rnd(0, 1);
	    },
	    osx: function (delim) {
	        return [10, rnd(5, 10), rnd(0, 9)].join(delim || '.');
	    },
	    chrome: function () {
	        return [rnd(13, 39), 0, rnd(800, 899), 0].join('.');
	    },
	    presto: function () {
	        return '2.9.' + rnd(160, 190);
	    },
	    presto2: function () {
	        return rnd(10, 12) + '.00';
	    },
	    safari: function () {
	        return rnd(531, 538) + '.' + rnd(0, 2) + '.' + rnd(0,2);
	    }
	};
	
	var browser = {
	    firefox: function firefox(arch) {
	        //https://developer.mozilla.org/en-US/docs/Gecko_user_agent_string_reference
	        var firefox_ver = rnd(5, 15) + randomRevision(2),
	            gecko_ver = 'Gecko/20100101 Firefox/' + firefox_ver,
	            proc = randomProc(arch),
	            os_ver = (arch === 'win') ? '(Windows NT ' + version_string.nt() + ((proc) ? '; ' + proc : '')
	            : (arch === 'mac') ? '(Macintosh; ' + proc + ' Mac OS X ' + version_string.osx()
	            : '(X11; Linux ' + proc;
	
	        return 'Mozilla/5.0 ' + os_ver + '; rv:' + firefox_ver.slice(0, -2) + ') ' + gecko_ver;
	    },
	
	    iexplorer: function iexplorer() {
	        var ver = version_string.ie();
	
	        if (ver >= 11) {
	            //http://msdn.microsoft.com/en-us/library/ie/hh869301(v=vs.85).aspx
	            return 'Mozilla/5.0 (Windows NT 6.' + rnd(1,3) + '; Trident/7.0; ' + rnd(['Touch; ', '']) + 'rv:11.0) like Gecko';
	        }
	
	        //http://msdn.microsoft.com/en-us/library/ie/ms537503(v=vs.85).aspx
	        return 'Mozilla/5.0 (compatible; MSIE ' + ver + '.0; Windows NT ' + version_string.nt() + '; Trident/' +
	            version_string.trident() + ((rnd(0, 1) === 1) ? '; .NET CLR ' + version_string.net() : '') + ')';
	    },
	
	    opera: function opera(arch) {
	        //http://www.opera.com/docs/history/
	        var presto_ver = ' Presto/' + version_string.presto() + ' Version/' + version_string.presto2() + ')',
	            os_ver = (arch === 'win') ? '(Windows NT ' + version_string.nt() + '; U; ' + randomLang() + presto_ver
	            : (arch === 'lin') ? '(X11; Linux ' + randomProc(arch) + '; U; ' + randomLang() + presto_ver
	            : '(Macintosh; Intel Mac OS X ' + version_string.osx() + ' U; ' + randomLang() + ' Presto/' +
	            version_string.presto() + ' Version/' + version_string.presto2() + ')';
	
	        return 'Opera/' + rnd(9, 14) + '.' + rnd(0, 99) + ' ' + os_ver;
	    },
	
	    safari: function safari(arch) {
	        var safari = version_string.safari(),
	            ver = rnd(4, 7) + '.' + rnd(0,1) + '.' + rnd(0,10),
	            os_ver = (arch === 'mac') ? '(Macintosh; ' + randomProc('mac') + ' Mac OS X '+ version_string.osx('_') + ' rv:' + rnd(2, 6) + '.0; '+ randomLang() + ') '
	            : '(Windows; U; Windows NT ' + version_string.nt() + ')';
	
	        return 'Mozilla/5.0 ' + os_ver + 'AppleWebKit/' + safari + ' (KHTML, like Gecko) Version/' + ver + ' Safari/' + safari;
	    },
	
	    chrome: function chrome(arch) {
	        var safari = version_string.safari(),
	            os_ver = (arch === 'mac') ? '(Macintosh; ' + randomProc('mac') + ' Mac OS X ' + version_string.osx('_') + ') '
	            : (arch === 'win') ? '(Windows; U; Windows NT ' + version_string.nt() + ')'
	            : '(X11; Linux ' + randomProc(arch);
	
	        return 'Mozilla/5.0 ' + os_ver + ' AppleWebKit/' + safari + ' (KHTML, like Gecko) Chrome/' + version_string.chrome() + ' Safari/' + safari;
	    }
	};
	
	exports.generate = function generate() {
	    var random = randomBrowserAndOS();
	    return browser[random[0]](random[1]);
	};


/***/ },
/* 329 */
/***/ function(module, exports) {

	module.exports = "<p><em>New to React DnD? <a href=\"docs-overview.html\">Read the overview</a> before jumping into the docs.</em></p>\n<h1>FAQ<a id=\"faq\">&nbsp;</a></h1><h2>Usage<a id=\"usage\">&nbsp;</a></h2><h3>What is the @ syntax I see in the ES7 code examples?<a id=\"what-is-the-syntax-i-see-in-the-es7-code-examples-\">&nbsp;</a></h3><p>First of all, you don&#39;t have to use ES6 or ES7 for React DnD. They make some of the code patterns more succinct, but it&#39;s up to you whether to enable these transformations.</p>\n<p>When I say “ES7”, I mean ES6 + a few extensions that <em>might</em> make it into ES7 (also known as ES2016). What I mark as the ES7 code in the docs is actually ES6 code + <a href=\"https://gist.github.com/jeffmo/054df782c05639da2adb\">class properties</a> + <a href=\"https://github.com/wycats/javascript-decorators\">decorators</a>. You can enable these features by putting <code>{ &quot;stage&quot;: 0 }</code> into your <a href=\"https://babeljs.io/docs/usage/babelrc/\">.babelrc</a> file. You can also <a href=\"https://babeljs.io/docs/usage/experimental/\">enable them individually</a>.</p>\n<p>The <code>@</code> syntax desugars into the simple function calls.<br/>You can see that in every example on the website that uses it, such as:</p>\n<hr/>\n<code class=\"codeBlock\"><span class=\"token keyword\" >var</span> <span class=\"token qualifier\" >Drag</span><span class=\"token qualifier\" >Source</span> <span class=\"token operator\" >=</span> <span class=\"token function\" >require<span class=\"token punctuation\" >(</span></span><span class=\"token string\" >'react-dnd'</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >.</span><span class=\"token qualifier\" >Drag</span><span class=\"token qualifier\" >Source</span><span class=\"token punctuation\" >;</span>\n\n<span class=\"token keyword\" >var</span> <span class=\"token qualifier\" >My</span><span class=\"token qualifier\" >Component</span> <span class=\"token operator\" >=</span> <span class=\"token qualifier\" >React</span><span class=\"token punctuation\" >.</span><span class=\"token function\" >createClass<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >{</span>\n  <span class=\"token comment\" spellcheck=\"true\">/* ... */</span>\n<span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n\nmodule<span class=\"token punctuation\" >.</span>exports <span class=\"token operator\" >=</span> <span class=\"token function\" >DragSource<span class=\"token punctuation\" >(</span></span>type<span class=\"token punctuation\" >,</span> spec<span class=\"token punctuation\" >,</span> collect<span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >(</span><span class=\"token qualifier\" >My</span><span class=\"token qualifier\" >Component</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span></code><hr/>\n<code class=\"codeBlock\"><span class=\"token keyword\" >import</span> <span class=\"token punctuation\" >{</span> <span class=\"token qualifier\" >Drag</span><span class=\"token qualifier\" >Source</span> <span class=\"token punctuation\" >}</span> from <span class=\"token string\" >'react-dnd'</span><span class=\"token punctuation\" >;</span>\n\n<span class=\"token keyword\" >class</span> <span class=\"token class-name\" >MyComponent</span> <span class=\"token punctuation\" >{</span>\n  <span class=\"token comment\" spellcheck=\"true\">/* ... */</span>\n<span class=\"token punctuation\" >}</span>\n\n<span class=\"token keyword\" >export</span> <span class=\"token keyword\" >default</span> <span class=\"token function\" >DragSource<span class=\"token punctuation\" >(</span></span>type<span class=\"token punctuation\" >,</span> spec<span class=\"token punctuation\" >,</span> collect<span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >(</span><span class=\"token qualifier\" >My</span><span class=\"token qualifier\" >Component</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span></code><hr/>\n<code class=\"codeBlock\"><span class=\"token keyword\" >import</span> <span class=\"token punctuation\" >{</span> <span class=\"token qualifier\" >Drag</span><span class=\"token qualifier\" >Source</span> <span class=\"token punctuation\" >}</span> from <span class=\"token string\" >'react-dnd'</span><span class=\"token punctuation\" >;</span>\n\n@<span class=\"token function\" >DragSource<span class=\"token punctuation\" >(</span></span>type<span class=\"token punctuation\" >,</span> spec<span class=\"token punctuation\" >,</span> collect<span class=\"token punctuation\" >)</span>\n<span class=\"token keyword\" >export</span> <span class=\"token keyword\" >default</span> <span class=\"token keyword\" >class</span> <span class=\"token class-name\" >MyComponent</span> <span class=\"token punctuation\" >{</span>\n  <span class=\"token comment\" spellcheck=\"true\">/* ... */</span>\n<span class=\"token punctuation\" >}</span></code><hr/>\n<h3>Where do I get the precompiled version?<a id=\"where-do-i-get-the-precompiled-version-\">&nbsp;</a></h3><p>Grab it from the <a href=\"https://github.com/pljenkins/react-dnd/tree/master/dist\">dist folder</a> in the repo.<br/>It exports <code>ReactDnD</code> (watch the casing!) and <code>ReactDnD.HTML5</code> for the <a href=\"docs-html5-backend.html\"><code>HTML5</code> backend</a>.</p>\n<h3>How do I test React DnD components and their interaction?<a id=\"how-do-i-test-react-dnd-components-and-their-interaction-\">&nbsp;</a></h3><p>See the <a href=\"docs-testing.html\">testing</a> tutorial for examples.</p>\n<h3>How do I make the component draggable only by a small handle?<a id=\"how-do-i-make-the-component-draggable-only-by-a-small-handle-\">&nbsp;</a></h3><p>Specify the container node as the <code>dragPreview</code>, but only make the drag handle a <code>dragSource()</code>.<br/>See the <a href=\"examples-customize-handles-and-previews.html\">custom drag handle example</a>.</p>\n<h3>How do I constrain the drag preview movement?<a id=\"how-do-i-constrain-the-drag-preview-movement-\">&nbsp;</a></h3><p>By default, you can&#39;t constrain the drag preview movement because the drag preview is drawn by the browser. You can, however, use a <a href=\"examples-drag-around-custom-drag-layer.html\">custom drag layer</a> where you&#39;re free to rendering anything, with any snapping or constraints.</p>\n<h3>How do I register a drag source or a drop target when the type depends on props?<a id=\"how-do-i-register-a-drag-source-or-a-drop-target-when-the-type-depends-on-props-\">&nbsp;</a></h3><p>Both <a href=\"docs-drag-source.html\"><code>DragSource</code></a> and <a href=\"docs-drop-target.html\"><code>DropTarget</code></a> let you pass a function as the first parameter instead of a string or a symbol. If you pass a function, it will be given the current props, and it should return a string, a symbol, or (for drop targets only) an array of either.</p>\n<h3>How do I combine several drag sources and drop targets in a single component?<a id=\"how-do-i-combine-several-drag-sources-and-drop-targets-in-a-single-component-\">&nbsp;</a></h3><p>Because <a href=\"docs-drag-source.html\"><code>DragSource</code></a> and <a href=\"docs-drop-target.html\"><code>DropTarget</code></a> use the partial application, you may compose them using a functional composition helper such as <a href=\"https://lodash.com/docs#flow\"><code>_.flow</code></a>. In ES7, you can just stack the decorators to achieve the same effect.</p>\n<hr/>\n<code class=\"codeBlock\"><span class=\"token keyword\" >var</span> <span class=\"token qualifier\" >Drag</span><span class=\"token qualifier\" >Source</span> <span class=\"token operator\" >=</span> <span class=\"token function\" >require<span class=\"token punctuation\" >(</span></span><span class=\"token string\" >'react-dnd'</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >.</span><span class=\"token qualifier\" >Drag</span><span class=\"token qualifier\" >Source</span><span class=\"token punctuation\" >;</span>\n<span class=\"token keyword\" >var</span> <span class=\"token qualifier\" >Drop</span><span class=\"token qualifier\" >Target</span> <span class=\"token operator\" >=</span> <span class=\"token function\" >require<span class=\"token punctuation\" >(</span></span><span class=\"token string\" >'react-dnd'</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >.</span><span class=\"token qualifier\" >Drop</span><span class=\"token qualifier\" >Target</span><span class=\"token punctuation\" >;</span>\n<span class=\"token keyword\" >var</span> flow <span class=\"token operator\" >=</span> <span class=\"token function\" >require<span class=\"token punctuation\" >(</span></span><span class=\"token string\" >'lodash/function/flow'</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n\n<span class=\"token keyword\" >var</span> <span class=\"token qualifier\" >Your</span><span class=\"token qualifier\" >Component</span> <span class=\"token operator\" >=</span> <span class=\"token qualifier\" >React</span><span class=\"token punctuation\" >.</span><span class=\"token function\" >createClass<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >{</span>\n  <span class=\"token comment\" spellcheck=\"true\">/* ... */</span>\n<span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n\nmodule<span class=\"token punctuation\" >.</span>exports <span class=\"token operator\" >=</span> <span class=\"token function\" >flow<span class=\"token punctuation\" >(</span></span>\n  <span class=\"token function\" >DragSource<span class=\"token punctuation\" >(</span></span><span class=\"token comment\" spellcheck=\"true\">/* ... */</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >,</span>\n  <span class=\"token function\" >DropTarget<span class=\"token punctuation\" >(</span></span><span class=\"token comment\" spellcheck=\"true\">/* ... */</span><span class=\"token punctuation\" >)</span>\n<span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >(</span><span class=\"token qualifier\" >Your</span><span class=\"token qualifier\" >Component</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span></code><hr/>\n<code class=\"codeBlock\"><span class=\"token keyword\" >import</span> <span class=\"token punctuation\" >{</span> <span class=\"token qualifier\" >Drag</span><span class=\"token qualifier\" >Source</span> <span class=\"token punctuation\" >}</span> from <span class=\"token string\" >'react-dnd'</span><span class=\"token punctuation\" >;</span>\n<span class=\"token keyword\" >import</span> flow from <span class=\"token string\" >'lodash/function/flow'</span><span class=\"token punctuation\" >;</span>\n\n<span class=\"token keyword\" >class</span> <span class=\"token class-name\" >YourComponent</span> <span class=\"token punctuation\" >{</span>\n  <span class=\"token comment\" spellcheck=\"true\">/* ... */</span>\n<span class=\"token punctuation\" >}</span>\n\n<span class=\"token keyword\" >export</span> <span class=\"token keyword\" >default</span> <span class=\"token function\" >flow<span class=\"token punctuation\" >(</span></span>\n  <span class=\"token function\" >DragSource<span class=\"token punctuation\" >(</span></span><span class=\"token comment\" spellcheck=\"true\">/* ... */</span><span class=\"token punctuation\" >)</span>\n  <span class=\"token function\" >DropTarget<span class=\"token punctuation\" >(</span></span><span class=\"token comment\" spellcheck=\"true\">/* ... */</span><span class=\"token punctuation\" >)</span>\n<span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >(</span><span class=\"token qualifier\" >Your</span><span class=\"token qualifier\" >Component</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span></code><hr/>\n<code class=\"codeBlock\"><span class=\"token keyword\" >import</span> <span class=\"token punctuation\" >{</span> <span class=\"token qualifier\" >Drag</span><span class=\"token qualifier\" >Source</span> <span class=\"token punctuation\" >}</span> from <span class=\"token string\" >'react-dnd'</span><span class=\"token punctuation\" >;</span>\n\n@<span class=\"token function\" >DragSource<span class=\"token punctuation\" >(</span></span><span class=\"token comment\" spellcheck=\"true\">/* ... */</span><span class=\"token punctuation\" >)</span>\n@<span class=\"token function\" >DropTarget<span class=\"token punctuation\" >(</span></span><span class=\"token comment\" spellcheck=\"true\">/* ... */</span><span class=\"token punctuation\" >)</span>\n<span class=\"token keyword\" >export</span> <span class=\"token keyword\" >default</span> <span class=\"token keyword\" >class</span> <span class=\"token class-name\" >YourComponent</span> <span class=\"token punctuation\" >{</span>\n  <span class=\"token comment\" spellcheck=\"true\">/* ... */</span>\n<span class=\"token punctuation\" >}</span></code><hr/>\n<h3>How do I register a drop target for the native files?<a id=\"how-do-i-register-a-drop-target-for-the-native-files-\">&nbsp;</a></h3><p>If you are using the <a href=\"docs-html5-backend.html\"><code>HTML5</code> backend</a>, you can register a drop target for one of the <code>NativeTypes</code> it exports:</p>\n<hr/>\n<code class=\"codeBlock\"><span class=\"token keyword\" >var</span> <span class=\"token qualifier\" >React</span> <span class=\"token operator\" >=</span> <span class=\"token function\" >require<span class=\"token punctuation\" >(</span></span><span class=\"token string\" >'react'</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n<span class=\"token keyword\" >var</span> <span class=\"token qualifier\" >Native</span><span class=\"token qualifier\" >Types</span> <span class=\"token operator\" >=</span> <span class=\"token function\" >require<span class=\"token punctuation\" >(</span></span><span class=\"token string\" >'react-dnd/modules/backends/HTML5'</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >.</span><span class=\"token qualifier\" >Native</span><span class=\"token qualifier\" >Types</span><span class=\"token punctuation\" >;</span>\n<span class=\"token keyword\" >var</span> <span class=\"token qualifier\" >Drop</span><span class=\"token qualifier\" >Target</span> <span class=\"token operator\" >=</span> <span class=\"token function\" >require<span class=\"token punctuation\" >(</span></span><span class=\"token string\" >'react-dnd'</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >.</span><span class=\"token qualifier\" >Drop</span><span class=\"token qualifier\" >Target</span><span class=\"token punctuation\" >;</span>\n\n<span class=\"token keyword\" >var</span> fileTarget <span class=\"token operator\" >=</span> <span class=\"token punctuation\" >{</span>\n  drop<span class=\"token punctuation\" >:</span> <span class=\"token block-keyword\" >function</span> <span class=\"token punctuation\" >(</span>props<span class=\"token punctuation\" >,</span> monitor<span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n    console<span class=\"token punctuation\" >.</span><span class=\"token function\" >log<span class=\"token punctuation\" >(</span></span>monitor<span class=\"token punctuation\" >.</span><span class=\"token function\" >getItem<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >.</span>files<span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n  <span class=\"token punctuation\" >}</span>\n<span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >;</span>\n\n<span class=\"token keyword\" >var</span> <span class=\"token qualifier\" >File</span><span class=\"token qualifier\" >Drop</span><span class=\"token qualifier\" >Zone</span> <span class=\"token operator\" >=</span> <span class=\"token qualifier\" >React</span><span class=\"token punctuation\" >.</span><span class=\"token function\" >createClass<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >{</span>\n  <span class=\"token function\" >render<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n    <span class=\"token keyword\" >var</span> connectDropTarget <span class=\"token operator\" >=</span> <span class=\"token var\" >this</span><span class=\"token punctuation\" >.</span>props<span class=\"token punctuation\" >.</span>connectDropTarget<span class=\"token punctuation\" >;</span>\n    <span class=\"token keyword\" >var</span> isOver <span class=\"token operator\" >=</span> <span class=\"token var\" >this</span><span class=\"token punctuation\" >.</span>props<span class=\"token punctuation\" >.</span>isOver<span class=\"token punctuation\" >;</span>\n    <span class=\"token keyword\" >var</span> canDrop <span class=\"token operator\" >=</span> <span class=\"token var\" >this</span><span class=\"token punctuation\" >.</span>props<span class=\"token punctuation\" >.</span>canDrop<span class=\"token punctuation\" >;</span>\n\n    <span class=\"token keyword\" >return</span> <span class=\"token function\" >connectDropTarget<span class=\"token punctuation\" >(</span></span>\n      <span class=\"token operator\" >&lt;</span>div<span class=\"token operator\" >></span>\n        <span class=\"token punctuation\" >{</span><span class=\"token operator\" >!</span>isOver <span class=\"token operator\" >&amp;&amp;</span> <span class=\"token operator\" >!</span>canDrop <span class=\"token operator\" >&amp;&amp;</span> <span class=\"token string\" >'Drag files from the hard drive'</span><span class=\"token punctuation\" >}</span>\n        <span class=\"token punctuation\" >{</span><span class=\"token operator\" >!</span>isOver <span class=\"token operator\" >&amp;&amp;</span> canDrop <span class=\"token operator\" >&amp;&amp;</span> <span class=\"token string\" >'Drag the files here'</span><span class=\"token punctuation\" >}</span>\n        <span class=\"token punctuation\" >{</span>isOver <span class=\"token operator\" >&amp;&amp;</span> <span class=\"token string\" >'Drop the files'</span><span class=\"token punctuation\" >}</span>\n      <span class=\"token operator\" >&lt;</span><span class=\"token operator\" >/</span>div<span class=\"token operator\" >></span>\n    <span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n  <span class=\"token punctuation\" >}</span>\n<span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n\nmodule<span class=\"token punctuation\" >.</span>exports <span class=\"token operator\" >=</span> <span class=\"token function\" >DropTarget<span class=\"token punctuation\" >(</span></span><span class=\"token qualifier\" >Native</span><span class=\"token qualifier\" >Types</span><span class=\"token punctuation\" >.</span>FILE<span class=\"token punctuation\" >,</span> fileTarget<span class=\"token punctuation\" >,</span> <span class=\"token block-keyword\" >function</span> <span class=\"token punctuation\" >(</span>connect<span class=\"token punctuation\" >,</span> monitor<span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n  <span class=\"token keyword\" >return</span> <span class=\"token punctuation\" >{</span>\n    connectDropTarget<span class=\"token punctuation\" >:</span> connect<span class=\"token punctuation\" >.</span><span class=\"token function\" >dropTarget<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >,</span>\n    isOver<span class=\"token punctuation\" >:</span> monitor<span class=\"token punctuation\" >.</span><span class=\"token function\" >isOver<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >,</span>\n    canDrop<span class=\"token punctuation\" >:</span> monitor<span class=\"token punctuation\" >.</span><span class=\"token function\" >canDrop<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span>\n  <span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >;</span>\n<span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >(</span><span class=\"token qualifier\" >File</span><span class=\"token qualifier\" >Drop</span><span class=\"token qualifier\" >Zone</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span></code><hr/>\n<code class=\"codeBlock\"><span class=\"token keyword\" >import</span> <span class=\"token qualifier\" >React</span><span class=\"token punctuation\" >,</span> <span class=\"token punctuation\" >{</span> <span class=\"token qualifier\" >Component</span> <span class=\"token punctuation\" >}</span> from <span class=\"token string\" >'react'</span><span class=\"token punctuation\" >;</span>\n<span class=\"token keyword\" >import</span> <span class=\"token punctuation\" >{</span> <span class=\"token qualifier\" >Native</span><span class=\"token qualifier\" >Types</span> <span class=\"token punctuation\" >}</span> from <span class=\"token string\" >'react-dnd/modules/backends/HTML5'</span><span class=\"token punctuation\" >;</span>\n<span class=\"token keyword\" >import</span> <span class=\"token punctuation\" >{</span> <span class=\"token qualifier\" >Drop</span><span class=\"token qualifier\" >Target</span> <span class=\"token punctuation\" >}</span> from <span class=\"token string\" >'react-dnd'</span><span class=\"token punctuation\" >;</span>\n\n<span class=\"token keyword\" >const</span> fileTarget <span class=\"token operator\" >=</span> <span class=\"token punctuation\" >{</span>\n  <span class=\"token function\" >drop<span class=\"token punctuation\" >(</span></span>props<span class=\"token punctuation\" >,</span> monitor<span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n    console<span class=\"token punctuation\" >.</span><span class=\"token function\" >log<span class=\"token punctuation\" >(</span></span>monitor<span class=\"token punctuation\" >.</span><span class=\"token function\" >getItem<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >.</span>files<span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n  <span class=\"token punctuation\" >}</span>\n<span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >;</span>\n\n<span class=\"token keyword\" >class</span> <span class=\"token class-name\" >FileDropZone</span> <span class=\"token keyword\" >extends</span> <span class=\"token class-name\" >Component</span> <span class=\"token punctuation\" >{</span>\n  <span class=\"token function\" >render<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n    <span class=\"token keyword\" >const</span> <span class=\"token punctuation\" >{</span> connectDropTarget<span class=\"token punctuation\" >,</span> isOver<span class=\"token punctuation\" >,</span> canDrop <span class=\"token punctuation\" >}</span> <span class=\"token operator\" >=</span> <span class=\"token var\" >this</span><span class=\"token punctuation\" >.</span>props<span class=\"token punctuation\" >;</span>\n    <span class=\"token keyword\" >return</span> <span class=\"token function\" >connectDropTarget<span class=\"token punctuation\" >(</span></span>\n      <span class=\"token operator\" >&lt;</span>div<span class=\"token operator\" >></span>\n        <span class=\"token punctuation\" >{</span><span class=\"token operator\" >!</span>isOver <span class=\"token operator\" >&amp;&amp;</span> <span class=\"token operator\" >!</span>canDrop <span class=\"token operator\" >&amp;&amp;</span> <span class=\"token string\" >'Drag files from the hard drive'</span><span class=\"token punctuation\" >}</span>\n        <span class=\"token punctuation\" >{</span><span class=\"token operator\" >!</span>isOver <span class=\"token operator\" >&amp;&amp;</span> canDrop <span class=\"token operator\" >&amp;&amp;</span> <span class=\"token string\" >'Drag the files here'</span><span class=\"token punctuation\" >}</span>\n        <span class=\"token punctuation\" >{</span>isOver <span class=\"token operator\" >&amp;&amp;</span> <span class=\"token string\" >'Drop the files'</span><span class=\"token punctuation\" >}</span>\n      <span class=\"token operator\" >&lt;</span><span class=\"token operator\" >/</span>div<span class=\"token operator\" >></span>\n    <span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n  <span class=\"token punctuation\" >}</span>\n<span class=\"token punctuation\" >}</span>\n\n<span class=\"token keyword\" >export</span> <span class=\"token keyword\" >default</span> <span class=\"token function\" >DropTarget<span class=\"token punctuation\" >(</span></span><span class=\"token qualifier\" >Native</span><span class=\"token qualifier\" >Types</span><span class=\"token punctuation\" >.</span>FILE<span class=\"token punctuation\" >,</span> fileTarget<span class=\"token punctuation\" >,</span> <span class=\"token punctuation\" >(</span>connect<span class=\"token punctuation\" >,</span> monitor<span class=\"token punctuation\" >)</span> <span class=\"token operator\" >=</span><span class=\"token operator\" >></span> <span class=\"token punctuation\" >(</span><span class=\"token punctuation\" >{</span>\n  connectDropTarget<span class=\"token punctuation\" >:</span> connect<span class=\"token punctuation\" >.</span><span class=\"token function\" >dropTarget<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >,</span>\n  isOver<span class=\"token punctuation\" >:</span> monitor<span class=\"token punctuation\" >.</span><span class=\"token function\" >isOver<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >,</span>\n  canDrop<span class=\"token punctuation\" >:</span> monitor<span class=\"token punctuation\" >.</span><span class=\"token function\" >canDrop<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span>\n<span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >(</span><span class=\"token qualifier\" >File</span><span class=\"token qualifier\" >Drop</span><span class=\"token qualifier\" >Zone</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span></code><hr/>\n<code class=\"codeBlock\"><span class=\"token keyword\" >import</span> <span class=\"token qualifier\" >React</span><span class=\"token punctuation\" >,</span> <span class=\"token punctuation\" >{</span> <span class=\"token qualifier\" >Component</span> <span class=\"token punctuation\" >}</span> from <span class=\"token string\" >'react'</span><span class=\"token punctuation\" >;</span>\n<span class=\"token keyword\" >import</span> <span class=\"token punctuation\" >{</span> <span class=\"token qualifier\" >Native</span><span class=\"token qualifier\" >Types</span> <span class=\"token punctuation\" >}</span> from <span class=\"token string\" >'react-dnd/modules/backends/HTML5'</span><span class=\"token punctuation\" >;</span>\n<span class=\"token keyword\" >import</span> <span class=\"token punctuation\" >{</span> <span class=\"token qualifier\" >Drop</span><span class=\"token qualifier\" >Target</span> <span class=\"token punctuation\" >}</span> from <span class=\"token string\" >'react-dnd'</span><span class=\"token punctuation\" >;</span>\n\n<span class=\"token keyword\" >const</span> fileTarget <span class=\"token operator\" >=</span> <span class=\"token punctuation\" >{</span>\n  <span class=\"token function\" >drop<span class=\"token punctuation\" >(</span></span>props<span class=\"token punctuation\" >,</span> monitor<span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n    console<span class=\"token punctuation\" >.</span><span class=\"token function\" >log<span class=\"token punctuation\" >(</span></span>monitor<span class=\"token punctuation\" >.</span><span class=\"token function\" >getItem<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >.</span>files<span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n  <span class=\"token punctuation\" >}</span>\n<span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >;</span>\n\n@<span class=\"token function\" >DropTarget<span class=\"token punctuation\" >(</span></span><span class=\"token qualifier\" >Native</span><span class=\"token qualifier\" >Types</span><span class=\"token punctuation\" >.</span>FILE<span class=\"token punctuation\" >,</span> fileTarget<span class=\"token punctuation\" >,</span> <span class=\"token punctuation\" >(</span>connect<span class=\"token punctuation\" >,</span> monitor<span class=\"token punctuation\" >)</span> <span class=\"token operator\" >=</span><span class=\"token operator\" >></span> <span class=\"token punctuation\" >(</span><span class=\"token punctuation\" >{</span>\n  connectDropTarget<span class=\"token punctuation\" >:</span> connect<span class=\"token punctuation\" >.</span><span class=\"token function\" >dropTarget<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >,</span>\n  isOver<span class=\"token punctuation\" >:</span> monitor<span class=\"token punctuation\" >.</span><span class=\"token function\" >isOver<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >,</span>\n  canDrop<span class=\"token punctuation\" >:</span> monitor<span class=\"token punctuation\" >.</span><span class=\"token function\" >canDrop<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span>\n<span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >)</span>\n<span class=\"token keyword\" >export</span> <span class=\"token keyword\" >default</span> <span class=\"token keyword\" >class</span> <span class=\"token class-name\" >FileDropZone</span> <span class=\"token keyword\" >extends</span> <span class=\"token class-name\" >Component</span> <span class=\"token punctuation\" >{</span>\n  <span class=\"token function\" >render<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n    <span class=\"token keyword\" >const</span> <span class=\"token punctuation\" >{</span> connectDropTarget<span class=\"token punctuation\" >,</span> isOver<span class=\"token punctuation\" >,</span> canDrop <span class=\"token punctuation\" >}</span> <span class=\"token operator\" >=</span> <span class=\"token var\" >this</span><span class=\"token punctuation\" >.</span>props<span class=\"token punctuation\" >;</span>\n    <span class=\"token keyword\" >return</span> <span class=\"token function\" >connectDropTarget<span class=\"token punctuation\" >(</span></span>\n      <span class=\"token operator\" >&lt;</span>div<span class=\"token operator\" >></span>\n        <span class=\"token punctuation\" >{</span><span class=\"token operator\" >!</span>isOver <span class=\"token operator\" >&amp;&amp;</span> <span class=\"token operator\" >!</span>canDrop <span class=\"token operator\" >&amp;&amp;</span> <span class=\"token string\" >'Drag files from the hard drive'</span><span class=\"token punctuation\" >}</span>\n        <span class=\"token punctuation\" >{</span><span class=\"token operator\" >!</span>isOver <span class=\"token operator\" >&amp;&amp;</span> canDrop <span class=\"token operator\" >&amp;&amp;</span> <span class=\"token string\" >'Drag the files here'</span><span class=\"token punctuation\" >}</span>\n        <span class=\"token punctuation\" >{</span>isOver <span class=\"token operator\" >&amp;&amp;</span> <span class=\"token string\" >'Drop the files'</span><span class=\"token punctuation\" >}</span>\n      <span class=\"token operator\" >&lt;</span><span class=\"token operator\" >/</span>div<span class=\"token operator\" >></span>\n    <span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n  <span class=\"token punctuation\" >}</span>\n<span class=\"token punctuation\" >}</span></code><hr/>\n<h3>How do I write a custom backend?<a id=\"how-do-i-write-a-custom-backend-\">&nbsp;</a></h3><p>This is not currently documented, but you can take cues from the built-in <a href=\"docs-html5-backend.html\"><code>HTML5</code></a> and <a href=\"docs-test-backend.html\"><code>Test</code></a> backend implementations. The backend contract includes <code>setup()</code> and <code>teardown()</code> methods, and <code>connectDragSource()</code>, <code>connectDragPreview()</code> and <code>connectDropTarget()</code> methods that pass the DOM nodes to the backend. Contributions to the documentation are welcome.</p>\n<h3>I am getting a “Super expression must either be null or a function, not undefined” error<a id=\"i-am-getting-a-super-expression-must-either-be-null-or-a-function-not-undefined-error\">&nbsp;</a></h3><p>React DnD requires React 0.13. Make sure you are using at least that version.</p>\n<h3>Why won&#39;t my static methods and properties work?<a id=\"why-won-39-t-my-static-methods-and-properties-work-\">&nbsp;</a></h3><p>Consider this example:</p>\n<hr/>\n<code class=\"codeBlock\"><span class=\"token keyword\" >var</span> <span class=\"token qualifier\" >Page</span> <span class=\"token operator\" >=</span> <span class=\"token qualifier\" >React</span><span class=\"token punctuation\" >.</span><span class=\"token function\" >createClass<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >{</span>\n  statics<span class=\"token punctuation\" >:</span> <span class=\"token punctuation\" >{</span>\n    willTransitionTo<span class=\"token punctuation\" >:</span> <span class=\"token block-keyword\" >function</span> <span class=\"token punctuation\" >(</span>transition<span class=\"token punctuation\" >,</span> params<span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n      <span class=\"token comment\" spellcheck=\"true\">/* ... */</span>\n    <span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >,</span>\n  <span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >,</span>\n\n  render<span class=\"token punctuation\" >:</span> <span class=\"token block-keyword\" >function</span> <span class=\"token punctuation\" >(</span><span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n    <span class=\"token comment\" spellcheck=\"true\">/* ... */</span>\n  <span class=\"token punctuation\" >}</span>\n<span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n\nmodule<span class=\"token punctuation\" >.</span>exports <span class=\"token operator\" >=</span> <span class=\"token function\" >DragDropContext<span class=\"token punctuation\" >(</span></span>HTML5Backend<span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >(</span><span class=\"token qualifier\" >Page</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span></code><hr/>\n<code class=\"codeBlock\"><span class=\"token keyword\" >class</span> <span class=\"token class-name\" >Page</span> <span class=\"token punctuation\" >{</span>\n  <span class=\"token keyword\" >static</span> <span class=\"token function\" >willTransitionTo<span class=\"token punctuation\" >(</span></span>transition<span class=\"token punctuation\" >,</span> params<span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n    <span class=\"token comment\" spellcheck=\"true\">/* ... */</span>\n  <span class=\"token punctuation\" >}</span>\n\n  <span class=\"token function\" >render<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n    <span class=\"token comment\" spellcheck=\"true\">/* ... */</span>\n  <span class=\"token punctuation\" >}</span>\n<span class=\"token punctuation\" >}</span>\n\n<span class=\"token keyword\" >export</span> <span class=\"token keyword\" >default</span> <span class=\"token function\" >DragDropContext<span class=\"token punctuation\" >(</span></span>HTML5Backend<span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >(</span><span class=\"token qualifier\" >Page</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span></code><hr/>\n<code class=\"codeBlock\">@<span class=\"token function\" >DragDropContext<span class=\"token punctuation\" >(</span></span>HTML5Backend<span class=\"token punctuation\" >)</span>\n<span class=\"token keyword\" >export</span> <span class=\"token keyword\" >default</span> <span class=\"token keyword\" >class</span> <span class=\"token class-name\" >Page</span> <span class=\"token punctuation\" >{</span>\n  <span class=\"token keyword\" >static</span> <span class=\"token function\" >willTransitionTo<span class=\"token punctuation\" >(</span></span>transition<span class=\"token punctuation\" >,</span> params<span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n    <span class=\"token comment\" spellcheck=\"true\">/* ... */</span>\n  <span class=\"token punctuation\" >}</span>\n\n  <span class=\"token function\" >render<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n    <span class=\"token comment\" spellcheck=\"true\">/* ... */</span>\n  <span class=\"token punctuation\" >}</span>\n<span class=\"token punctuation\" >}</span></code><hr/>\n<p>It might surprise you that your route handler&#39;s <code>willTransitionTo</code> (or a similar method) won&#39;t get triggered in this case! React DnD doesn&#39;t proxy your components&#39; static methods and properties. This is too fragile and full of edge cases, so you must do it yourself. It&#39;s not hard! Just put your statics onto the components returned by React DnD instead:</p>\n<hr/>\n<code class=\"codeBlock\"><span class=\"token keyword\" >var</span> <span class=\"token qualifier\" >Page</span> <span class=\"token operator\" >=</span> <span class=\"token qualifier\" >React</span><span class=\"token punctuation\" >.</span><span class=\"token function\" >createClass<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >{</span>\n  render<span class=\"token punctuation\" >:</span> <span class=\"token block-keyword\" >function</span> <span class=\"token punctuation\" >(</span><span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n    <span class=\"token comment\" spellcheck=\"true\">/* ... */</span>\n  <span class=\"token punctuation\" >}</span>\n<span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n\n<span class=\"token qualifier\" >Page</span> <span class=\"token operator\" >=</span> <span class=\"token function\" >DragDropContext<span class=\"token punctuation\" >(</span></span>HTML5Backend<span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >(</span><span class=\"token qualifier\" >Page</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n<span class=\"token qualifier\" >Page</span><span class=\"token punctuation\" >.</span>willTransitionTo <span class=\"token operator\" >=</span> <span class=\"token block-keyword\" >function</span> <span class=\"token punctuation\" >(</span>transition<span class=\"token punctuation\" >,</span> params<span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n  <span class=\"token comment\" spellcheck=\"true\">/* ... */</span>\n<span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >;</span>\n\nmodule<span class=\"token punctuation\" >.</span>exports <span class=\"token operator\" >=</span> <span class=\"token qualifier\" >Page</span><span class=\"token punctuation\" >;</span></code><hr/>\n<code class=\"codeBlock\"><span class=\"token keyword\" >class</span> <span class=\"token class-name\" >Page</span> <span class=\"token punctuation\" >{</span>\n  <span class=\"token function\" >render<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n    <span class=\"token comment\" spellcheck=\"true\">/* ... */</span>\n  <span class=\"token punctuation\" >}</span>\n<span class=\"token punctuation\" >}</span>\n\n<span class=\"token qualifier\" >Page</span> <span class=\"token operator\" >=</span> <span class=\"token function\" >DragDropContext<span class=\"token punctuation\" >(</span></span>HTML5Backend<span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >(</span><span class=\"token qualifier\" >Page</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n<span class=\"token qualifier\" >Page</span><span class=\"token punctuation\" >.</span>willTransitionTo <span class=\"token operator\" >=</span> <span class=\"token block-keyword\" >function</span> <span class=\"token punctuation\" >(</span>transition<span class=\"token punctuation\" >,</span> params<span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n  <span class=\"token comment\" spellcheck=\"true\">/* ... */</span>\n<span class=\"token punctuation\" >}</span>\n\n<span class=\"token keyword\" >export</span> <span class=\"token keyword\" >default</span> <span class=\"token qualifier\" >Page</span><span class=\"token punctuation\" >;</span></code><hr/>\n<code class=\"codeBlock\"><span class=\"token comment\" spellcheck=\"true\">// You can write your own decorator like this\n</span><span class=\"token block-keyword\" >function</span> <span class=\"token function\" >assignStatics<span class=\"token punctuation\" >(</span></span>a<span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n  <span class=\"token keyword\" >return</span> b <span class=\"token operator\" >=</span><span class=\"token operator\" >></span> <span class=\"token qualifier\" >Object</span><span class=\"token punctuation\" >.</span><span class=\"token function\" >assign<span class=\"token punctuation\" >(</span></span>b<span class=\"token punctuation\" >,</span> a<span class=\"token punctuation\" >)</span>\n<span class=\"token punctuation\" >}</span>\n\n@<span class=\"token function\" >assignStatics<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >{</span>\n  <span class=\"token function\" >willTransitionTo<span class=\"token punctuation\" >(</span></span>transition<span class=\"token punctuation\" >,</span> params<span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n    <span class=\"token comment\" spellcheck=\"true\">/* ... */</span>\n  <span class=\"token punctuation\" >}</span>\n<span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >)</span>\n@<span class=\"token function\" >DragDropContext<span class=\"token punctuation\" >(</span></span>HTML5Backend<span class=\"token punctuation\" >)</span>\n<span class=\"token keyword\" >export</span> <span class=\"token keyword\" >default</span> <span class=\"token keyword\" >class</span> <span class=\"token class-name\" >Page</span> <span class=\"token punctuation\" >{</span>\n  <span class=\"token function\" >render<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n    <span class=\"token comment\" spellcheck=\"true\">/* ... */</span>\n  <span class=\"token punctuation\" >}</span>\n<span class=\"token punctuation\" >}</span></code><hr/>\n<h2>Meta<a id=\"meta\">&nbsp;</a></h2><h3>Is this Dungeons &amp; Dragons?<a id=\"is-this-dungeons-amp-dragons-\">&nbsp;</a></h3><p>I know, it&#39;s only drag and drop, <a href=\"http://www.youtube.com/watch?v=JGaBlygm0UY\">but I like it</a>.</p>\n<h3>How stable is it?<a id=\"how-stable-is-it-\">&nbsp;</a></h3><p><a href=\"http://stampsy.com\">Stampsy</a> has been using this library, as well as its non-React predecessor that it was based on, since 2013. It&#39;s central to the Stampsy user experience, because all the content is created in a drag and drop post editor that uses React DnD.</p>\n<h3>What is the roadmap?<a id=\"what-is-the-roadmap-\">&nbsp;</a></h3><p>The next big feature to be added is the support for the touch events backend. This is necessary to make React DnD work on mobile devices. I will be busy in June preparing for my <a href=\"https://www.react-europe.org/\">React Europe</a> talk, so expect the touch support to land in July or August.</p>\n<h3>Who made it and why?<a id=\"who-made-it-and-why-\">&nbsp;</a></h3><p>React DnD was created by <a href=\"http://github.com/pljenkins\">Dan Abramov</a>.</p>\n<p>Its aim is to expose a powerful API that is browser-agnostic, data-centric, works great with React and Flux, and is testable and extensible. Read <a href=\"https://medium.com/@dan_abramov/the-future-of-drag-and-drop-apis-249dfea7a15f\">The Future of the Drag and Drop API</a> for some context.</p>\n<p>It is loosely based on the pre-React code written at Stampsy by <a href=\"https://github.com/cavinsmith\">Andrew Kuznetsov</a>. Later it received valuable contributions from <a href=\"https://github.com/alexkuz\">Alexander Kuznetsov</a> and <a href=\"https://github.com/nelix\">Nathan Hutchison</a>.</p>\n<p>React DnD would not have reached the 1.0 release without the generous donations from:</p>\n<ul>\n<li><a href=\"https://macropod.com/\">Macropod</a>, a company developing team productivity software;</li>\n<li><a href=\"https://webflow.com/\">Webflow</a>, a company creating a professional responsive website builder.</li>\n</ul>\n<p><a href=\"http://kkga.me/\">Gadzhi Kharkharov</a> styled the website, and the <a href=\"https://github.com/facebook/fixed-data-table\">fixed-data-table</a> project provided the website template.</p>\n<h3>How Do I Contribute?<a id=\"how-do-i-contribute-\">&nbsp;</a></h3><p>Contributing the documentation for the underlying <a href=\"https://github.com/pljenkins/dnd-core\">DnD Core</a> library would be a huge help, as it is currently not documented at all, but its concepts leak in some advanced scenarios such as <a href=\"docs-testing.html\">writing tests</a>.</p>\n<p>Porting the library to other modern frameworks such as Cycle, Mercury, or Deku, is also appreciated. Such ports would be able to reuse DnD Core logic and the existing backends.</p>\n<p>Please let me know via the <a href=\"https://github.com/pljenkins/react-dnd/issues\">issue tracker</a> if you create advanced examples such as a Kanban board application, or write a blog post or record a screencast about React DnD, so I can link to it.</p>\n<p>While DnD Core is fully tested, React DnD does not currently have any unit tests. Writing them is a great and eagerly desired contribution.</p>\n<p>Whether you are a company or an individual, if you enjoy using React DnD, consider donating to my PayPal address: <code>dan.abramov@me.com</code>. I left my full-time job to work on the open source projects. Your donations help me fund the current and the future development.</p>\n<p>⚛</p>\n";

/***/ },
/* 330 */
/***/ function(module, exports) {

	module.exports = "<h1>Overview<a id=\"overview\">&nbsp;</a></h1><p>React DnD is unlike most of the drag and drop libraries out there, and it can be intimidating if you&#39;ve never used it before. However, once you get a taste of a few concepts at the heart of its design, it starts to make sense. I suggest you read about these concepts before the rest of the docs.</p>\n<p>Some of these concepts may seem to have a certain resemblance to the <a href=\"http://facebook.github.io/flux/\">Flux architecture</a>.<br/>This is not a coincidence, as React DnD uses Flux internally.</p>\n<h3>Backends<a id=\"backends\">&nbsp;</a></h3><p>React DnD is built on top of the <a href=\"https://developer.mozilla.org/en-US/docs/Web/Guide/HTML/Drag_and_drop\">HTML5 drag and drop API</a>. It is a reasonable default because it screenshots the dragged DOM node and uses it as a “drag preview” out of the box. It&#39;s handy that you don&#39;t have to do any drawing as the cursor moves. This API is also the only way to handle the file drop events.</p>\n<p>Unfortunately, the HTML5 drag and drop API also has some downsides. It does not work on touch screens, and it provides less customization opportunities on IE than in other browsers.</p>\n<p>This is why <strong>the HTML5 drag and drop support is implemented in a pluggable way</strong> in React DnD. You don&#39;t have to use it. You can write a different implementation, based on touch events, mouse events, or something else entirely. Such pluggable implementations are called the <em>backends</em> in React DnD. Only the <a href=\"docs-html5-backend.html\">HTML5 backend</a> comes with the library, but more may be added in the future.</p>\n<p>The backends perform a similar role to that of React&#39;s synthetic event system: <strong>they abstract away the browser differences and process the native DOM events.</strong> Despite the similarities, React DnD backends do not have a dependency on React or its synthetic event system. Under the hood, all the backends do is translate the DOM events into the internal Flux actions that React DnD can process.</p>\n<h3>Items and Types<a id=\"items-and-types\">&nbsp;</a></h3><p>Like Flux, React DnD uses data, and not the views, as the source of truth. When you drag something across the screen, we don&#39;t say that a component, or a DOM node is being dragged. Instead, we say that an <em>item</em> of a certain <em>type</em> is being dragged.</p>\n<p>What is an item? An <em>item</em> is a plain JavaScript object <em>describing</em> what&#39;s being dragged. For example, in a Kanban board application, when you drag a card, an item might look like <code>{ cardId: 42 }</code>. In a Chess game, when you pick up a piece, the item might look like <code>{ fromCell: &#39;C5&#39;, piece: &#39;queen&#39; }</code>. <strong>Describing the dragged data as a plain object helps you keep the components decoupled and unaware of each other.</strong></p>\n<p>What is a type, then? A <em>type</em> is a string (or a <a href=\"https://developer.mozilla.org/en/docs/Web/JavaScript/Reference/Global_Objects/Symbol\">symbol</a>) uniquely identifying <em>a whole class of items</em> in your application. In a Kanban board app, you might have a <code>&#39;card&#39;</code> type representing the draggable cards and a <code>&#39;list&#39;</code> type for the draggable lists of those cards. In Chess, you might only have a single <code>&#39;piece&#39;</code> type.</p>\n<p>Types are useful because, as your app grows, you might want to make more things draggable, but you don&#39;t necessarily want all the existing drop targets to suddenly start reacting to the new items. <strong>The types let you specify which drag sources and drop targets are compatible.</strong> You&#39;re probably going to have an enumeration of the type constants in your application, just like you may have an enumeration of the Flux action types.</p>\n<h3>Monitors<a id=\"monitors\">&nbsp;</a></h3><p>Drag and drop is inherently stateful. Either a drag operation is in progress, or it isn&#39;t. Either there is a current type and a current item, or there isn&#39;t. This state has to live somewhere.</p>\n<p>React DnD exposes this state to your components via a few tiny wrappers over the internal state storage called the <em>monitors</em>. <strong>The monitors let you update the props of your components in response to the drag and drop state changes.</strong></p>\n<p>For each component that needs to track the drag and drop state, you can define a <em>collecting function</em> that retrieves the relevant bits of it from the monitors. React DnD then takes care of timely calling your collecting function and merging its return value into your components&#39; props.</p>\n<p>Let&#39;s say you want to highlight the Chess cells when a piece is being dragged. A collecting function for the <code>Cell</code> component might look like this:</p>\n<code class=\"codeBlock\"><span class=\"token block-keyword\" >function</span> <span class=\"token function\" >collect<span class=\"token punctuation\" >(</span></span>monitor<span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n  <span class=\"token keyword\" >return</span> <span class=\"token punctuation\" >{</span>\n    highlighted<span class=\"token punctuation\" >:</span> monitor<span class=\"token punctuation\" >.</span><span class=\"token function\" >canDrop<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >,</span>\n    hovered<span class=\"token punctuation\" >:</span> monitor<span class=\"token punctuation\" >.</span><span class=\"token function\" >isOver<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span>\n  <span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >;</span>\n<span class=\"token punctuation\" >}</span></code><p>It instructs React DnD to pass the up-to-date values of <code>highlighted</code> and <code>hovered</code> to all the <code>Cell</code> instances as props.</p>\n<h3>Connectors<a id=\"connectors\">&nbsp;</a></h3><p>If the backend handles the DOM events, but the components use React to describe the DOM, how does the backend know which DOM nodes to listen to? Enter the <em>connectors</em>. <strong>The connectors let you assign one of the predefined roles (a drag source, a drag preview, or a drop target) to the DOM nodes</strong> in your <code>render</code> function.</p>\n<p>In fact, a connector is passed as a second argument to the <em>collecting function</em> we described above. Let&#39;s see how we can use it to specify the drag source:</p>\n<code class=\"codeBlock\"><span class=\"token block-keyword\" >function</span> <span class=\"token function\" >collect<span class=\"token punctuation\" >(</span></span>connect<span class=\"token punctuation\" >,</span> monitor<span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n  <span class=\"token keyword\" >return</span> <span class=\"token punctuation\" >{</span>\n    highlighted<span class=\"token punctuation\" >:</span> monitor<span class=\"token punctuation\" >.</span><span class=\"token function\" >canDrop<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >,</span>\n    hovered<span class=\"token punctuation\" >:</span> monitor<span class=\"token punctuation\" >.</span><span class=\"token function\" >isOver<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >,</span>\n    connectDropTarget<span class=\"token punctuation\" >:</span> connect<span class=\"token punctuation\" >.</span><span class=\"token function\" >dropTarget<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span>\n  <span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >;</span>\n<span class=\"token punctuation\" >}</span></code><p>In the component&#39;s <code>render</code> method, we are then able to access both the data obtained from the monitor, and the function obtained from the connector:</p>\n<hr/>\n<code class=\"codeBlock\">render<span class=\"token punctuation\" >:</span> <span class=\"token block-keyword\" >function</span> <span class=\"token punctuation\" >(</span><span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n  <span class=\"token keyword\" >var</span> highlighted <span class=\"token operator\" >=</span> <span class=\"token var\" >this</span><span class=\"token punctuation\" >.</span>props<span class=\"token punctuation\" >.</span>highlighted<span class=\"token punctuation\" >;</span>\n  <span class=\"token keyword\" >var</span> hovered <span class=\"token operator\" >=</span> <span class=\"token var\" >this</span><span class=\"token punctuation\" >.</span>props<span class=\"token punctuation\" >.</span>hovered<span class=\"token punctuation\" >;</span>\n  <span class=\"token keyword\" >var</span> connectDropTarget <span class=\"token operator\" >=</span> <span class=\"token var\" >this</span><span class=\"token punctuation\" >.</span>props<span class=\"token punctuation\" >.</span>connectDropTarget<span class=\"token punctuation\" >;</span>\n\n  <span class=\"token keyword\" >return</span> <span class=\"token function\" >connectDropTarget<span class=\"token punctuation\" >(</span></span>\n    <span class=\"token operator\" >&lt;</span>div className<span class=\"token operator\" >=</span><span class=\"token punctuation\" >{</span><span class=\"token function\" >classSet<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >{</span>\n      <span class=\"token string\" >'Cell'</span><span class=\"token punctuation\" >:</span> <span class=\"token primitive\" >true</span><span class=\"token punctuation\" >,</span>\n      <span class=\"token string\" >'Cell--highlighted'</span><span class=\"token punctuation\" >:</span> highlighted<span class=\"token punctuation\" >,</span>\n      <span class=\"token string\" >'Cell--hovered'</span><span class=\"token punctuation\" >:</span> hovered\n    <span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >}</span><span class=\"token operator\" >></span>\n      <span class=\"token punctuation\" >{</span><span class=\"token var\" >this</span><span class=\"token punctuation\" >.</span>props<span class=\"token punctuation\" >.</span>children<span class=\"token punctuation\" >}</span>\n    <span class=\"token operator\" >&lt;</span><span class=\"token operator\" >/</span>div<span class=\"token operator\" >></span>\n  <span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n<span class=\"token punctuation\" >}</span></code><hr/>\n<code class=\"codeBlock\"><span class=\"token function\" >render<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n  <span class=\"token keyword\" >const</span> <span class=\"token punctuation\" >{</span> highlighted<span class=\"token punctuation\" >,</span> hovered<span class=\"token punctuation\" >,</span> connectDropTarget <span class=\"token punctuation\" >}</span> <span class=\"token operator\" >=</span> <span class=\"token var\" >this</span><span class=\"token punctuation\" >.</span>props<span class=\"token punctuation\" >;</span>\n\n  <span class=\"token keyword\" >return</span> <span class=\"token function\" >connectDropTarget<span class=\"token punctuation\" >(</span></span>\n    <span class=\"token operator\" >&lt;</span>div className<span class=\"token operator\" >=</span><span class=\"token punctuation\" >{</span><span class=\"token function\" >classSet<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >{</span>\n      <span class=\"token string\" >'Cell'</span><span class=\"token punctuation\" >:</span> <span class=\"token primitive\" >true</span><span class=\"token punctuation\" >,</span>\n      <span class=\"token string\" >'Cell--highlighted'</span><span class=\"token punctuation\" >:</span> highlighted<span class=\"token punctuation\" >,</span>\n      <span class=\"token string\" >'Cell--hovered'</span><span class=\"token punctuation\" >:</span> hovered\n    <span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >}</span><span class=\"token operator\" >></span>\n      <span class=\"token punctuation\" >{</span><span class=\"token var\" >this</span><span class=\"token punctuation\" >.</span>props<span class=\"token punctuation\" >.</span>children<span class=\"token punctuation\" >}</span>\n    <span class=\"token operator\" >&lt;</span><span class=\"token operator\" >/</span>div<span class=\"token operator\" >></span>\n  <span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n<span class=\"token punctuation\" >}</span></code><hr/>\n<hr/>\n<p>The <code>connectDropTarget</code> call tells React DnD that the root DOM node of our component is a valid drop target, and that its hover and drop events should be handled by the backend. Internally it works by attaching a <a href=\"https://facebook.github.io/react/docs/more-about-refs.html#the-ref-callback-attribute\">callback ref</a> to the React element you gave it. The function returned by the connector is memoized, so it doesn&#39;t break the <code>shouldComponentUpdate</code> optimizations.</p>\n<h3>Drag Sources and Drop Targets<a id=\"drag-sources-and-drop-targets\">&nbsp;</a></h3><p>So far we have covered the backends which work with the DOM, the data, as represented by the items and types, and the collecting functions that, thanks to the monitors and the connectors, let you describe what props React DnD should inject into your components.</p>\n<p>But how do we configure our components to actually have those props injected? How do we perform the side effects in response to the drag and drop events? Meet the <em>drag sources</em> and the <em>drop targets</em>, the primary abstraction units of React DnD. <strong>They really tie the types, the items, the side effects, and the collecting functions together with your components.</strong></p>\n<p>Whenever you want to make a component or some part of it draggable, you need to wrap that component into a <em>drag source</em> declaration. Every drag source is registered for a certain <em>type</em>, and has to implement a method producing an <em>item</em> from the component&#39;s props. It can also optionally specify a few other methods for handling the drag and drop events. The drag source declaration also lets you specify the <em>collecting function</em> for the given component.</p>\n<p>The <em>drop targets</em> are very similar to the drag sources. The only difference is that a single drop target may register for several item types at once, and instead of producing an item, it may handle its hover or drop.</p>\n<h3>Higher-Order Components and ES7 decorators<a id=\"higher-order-components-and-es7-decorators\">&nbsp;</a></h3><p>How do you wrap your components? What does wrapping even mean? If you have not worked with higher-order components before, go ahead and read <a href=\"https://medium.com/@dan_abramov/mixins-are-dead-long-live-higher-order-components-94a0d2f9e750\">this article</a>, as it explains the concept in detail.</p>\n<p><strong>A higher-order component is just a function that takes a React component class, and returns another React component class.</strong> The wrapping component provided by the library renders <em>your</em> component in its <code>render</code> method and forwards the props to it, but also adds some useful behavior.</p>\n<p>In React DnD, <a href=\"docs-drag-source.html\"><code>DragSource</code></a> and <a href=\"docs-drop-target.html\"><code>DropTarget</code></a>, as well as a few other top-level exported functions, are in fact higher-order components. They breathe the drag and drop magic into your components.</p>\n<p>One caveat of using them is that they require <em>two</em> function applications. For example, here&#39;s how to wrap <code>YourComponent</code> in a <a href=\"docs-drag-source.html\"><code>DragSource</code></a>:</p>\n<hr/>\n<code class=\"codeBlock\"><span class=\"token keyword\" >var</span> <span class=\"token qualifier\" >Drag</span><span class=\"token qualifier\" >Source</span> <span class=\"token operator\" >=</span> <span class=\"token function\" >require<span class=\"token punctuation\" >(</span></span><span class=\"token string\" >'react-dnd'</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >.</span><span class=\"token qualifier\" >Drag</span><span class=\"token qualifier\" >Source</span><span class=\"token punctuation\" >;</span>\n\n<span class=\"token keyword\" >var</span> <span class=\"token qualifier\" >Your</span><span class=\"token qualifier\" >Component</span> <span class=\"token operator\" >=</span> <span class=\"token qualifier\" >React</span><span class=\"token punctuation\" >.</span><span class=\"token function\" >createClass<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >{</span>\n  <span class=\"token comment\" spellcheck=\"true\">/* ... */</span>\n<span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n\nmodule<span class=\"token punctuation\" >.</span>exports <span class=\"token operator\" >=</span> <span class=\"token function\" >DragSource<span class=\"token punctuation\" >(</span></span><span class=\"token comment\" spellcheck=\"true\">/* ... */</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >(</span><span class=\"token qualifier\" >Your</span><span class=\"token qualifier\" >Component</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span></code><hr/>\n<code class=\"codeBlock\"><span class=\"token keyword\" >import</span> <span class=\"token punctuation\" >{</span> <span class=\"token qualifier\" >Drag</span><span class=\"token qualifier\" >Source</span> <span class=\"token punctuation\" >}</span> from <span class=\"token string\" >'react-dnd'</span><span class=\"token punctuation\" >;</span>\n\n<span class=\"token keyword\" >class</span> <span class=\"token class-name\" >YourComponent</span> <span class=\"token punctuation\" >{</span>\n  <span class=\"token comment\" spellcheck=\"true\">/* ... */</span>\n<span class=\"token punctuation\" >}</span>\n\n<span class=\"token keyword\" >export</span> <span class=\"token keyword\" >default</span> <span class=\"token function\" >DragSource<span class=\"token punctuation\" >(</span></span><span class=\"token comment\" spellcheck=\"true\">/* ... */</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >(</span><span class=\"token qualifier\" >Your</span><span class=\"token qualifier\" >Component</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span></code><hr/>\n<hr/>\n<p>Notice how, after specifying the <a href=\"docs-drag-source.html\"><code>DragSource</code></a> parameters in the first function call, there is a <em>second</em> function call, where you finally pass your class. This is called <a href=\"http://en.wikipedia.org/wiki/Currying\">currying</a>, or <a href=\"http://en.wikipedia.org/wiki/Partial_application\">partial application</a>, and is necessary for the <a href=\"http://github.com/wycats/javascript-decorators\">ES7 decorator syntax</a> to work out of the box:</p>\n<hr/>\n<hr/>\n<hr/>\n<code class=\"codeBlock\"><span class=\"token keyword\" >import</span> <span class=\"token punctuation\" >{</span> <span class=\"token qualifier\" >Drag</span><span class=\"token qualifier\" >Source</span> <span class=\"token punctuation\" >}</span> from <span class=\"token string\" >'react-dnd'</span><span class=\"token punctuation\" >;</span>\n\n@<span class=\"token function\" >DragSource<span class=\"token punctuation\" >(</span></span><span class=\"token comment\" spellcheck=\"true\">/* ... */</span><span class=\"token punctuation\" >)</span>\n<span class=\"token keyword\" >export</span> <span class=\"token keyword\" >default</span> <span class=\"token keyword\" >class</span> <span class=\"token class-name\" >YourComponent</span> <span class=\"token punctuation\" >{</span>\n  <span class=\"token comment\" spellcheck=\"true\">/* ... */</span>\n<span class=\"token punctuation\" >}</span></code><hr/>\n<p>You don&#39;t have to use this syntax, but if you like it, you can enable it by transpiling your code with <a href=\"http://babeljs.io\">Babel</a>, and putting <code>{ &quot;stage&quot;: 1 }</code> into your <a href=\"https://babeljs.io/docs/usage/babelrc/\">.babelrc file</a>.</p>\n<p>Even if you don&#39;t plan to use ES7, the partial application can still be handy, because you can combine several <a href=\"docs-drag-source.html\"><code>DragSource</code></a> and <a href=\"docs-drop-target.html\"><code>DropTarget</code></a> declarations in ES5 or ES6 using a functional composition helper such as <a href=\"https://lodash.com/docs#flow\"><code>_.flow</code></a>. In ES7, you can just stack the decorators to achieve the same effect.</p>\n<hr/>\n<code class=\"codeBlock\"><span class=\"token keyword\" >var</span> <span class=\"token qualifier\" >Drag</span><span class=\"token qualifier\" >Source</span> <span class=\"token operator\" >=</span> <span class=\"token function\" >require<span class=\"token punctuation\" >(</span></span><span class=\"token string\" >'react-dnd'</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >.</span><span class=\"token qualifier\" >Drag</span><span class=\"token qualifier\" >Source</span><span class=\"token punctuation\" >;</span>\n<span class=\"token keyword\" >var</span> <span class=\"token qualifier\" >Drop</span><span class=\"token qualifier\" >Target</span> <span class=\"token operator\" >=</span> <span class=\"token function\" >require<span class=\"token punctuation\" >(</span></span><span class=\"token string\" >'react-dnd'</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >.</span><span class=\"token qualifier\" >Drop</span><span class=\"token qualifier\" >Target</span><span class=\"token punctuation\" >;</span>\n<span class=\"token keyword\" >var</span> flow <span class=\"token operator\" >=</span> <span class=\"token function\" >require<span class=\"token punctuation\" >(</span></span><span class=\"token string\" >'lodash/function/flow'</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n\n<span class=\"token keyword\" >var</span> <span class=\"token qualifier\" >Your</span><span class=\"token qualifier\" >Component</span> <span class=\"token operator\" >=</span> <span class=\"token qualifier\" >React</span><span class=\"token punctuation\" >.</span><span class=\"token function\" >createClass<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >{</span>\n  <span class=\"token comment\" spellcheck=\"true\">/* ... */</span>\n<span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n\nmodule<span class=\"token punctuation\" >.</span>exports <span class=\"token operator\" >=</span> <span class=\"token function\" >flow<span class=\"token punctuation\" >(</span></span>\n  <span class=\"token function\" >DragSource<span class=\"token punctuation\" >(</span></span><span class=\"token comment\" spellcheck=\"true\">/* ... */</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >,</span>\n  <span class=\"token function\" >DropTarget<span class=\"token punctuation\" >(</span></span><span class=\"token comment\" spellcheck=\"true\">/* ... */</span><span class=\"token punctuation\" >)</span>\n<span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >(</span><span class=\"token qualifier\" >Your</span><span class=\"token qualifier\" >Component</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span></code><hr/>\n<code class=\"codeBlock\"><span class=\"token keyword\" >import</span> <span class=\"token punctuation\" >{</span> <span class=\"token qualifier\" >Drag</span><span class=\"token qualifier\" >Source</span> <span class=\"token punctuation\" >}</span> from <span class=\"token string\" >'react-dnd'</span><span class=\"token punctuation\" >;</span>\n<span class=\"token keyword\" >import</span> flow from <span class=\"token string\" >'lodash/function/flow'</span><span class=\"token punctuation\" >;</span>\n\n<span class=\"token keyword\" >class</span> <span class=\"token class-name\" >YourComponent</span> <span class=\"token punctuation\" >{</span>\n  <span class=\"token comment\" spellcheck=\"true\">/* ... */</span>\n<span class=\"token punctuation\" >}</span>\n\n<span class=\"token keyword\" >export</span> <span class=\"token keyword\" >default</span> <span class=\"token function\" >flow<span class=\"token punctuation\" >(</span></span>\n  <span class=\"token function\" >DragSource<span class=\"token punctuation\" >(</span></span><span class=\"token comment\" spellcheck=\"true\">/* ... */</span><span class=\"token punctuation\" >)</span>\n  <span class=\"token function\" >DropTarget<span class=\"token punctuation\" >(</span></span><span class=\"token comment\" spellcheck=\"true\">/* ... */</span><span class=\"token punctuation\" >)</span>\n<span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >(</span><span class=\"token qualifier\" >Your</span><span class=\"token qualifier\" >Component</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span></code><hr/>\n<code class=\"codeBlock\"><span class=\"token keyword\" >import</span> <span class=\"token punctuation\" >{</span> <span class=\"token qualifier\" >Drag</span><span class=\"token qualifier\" >Source</span> <span class=\"token punctuation\" >}</span> from <span class=\"token string\" >'react-dnd'</span><span class=\"token punctuation\" >;</span>\n\n@<span class=\"token function\" >DragSource<span class=\"token punctuation\" >(</span></span><span class=\"token comment\" spellcheck=\"true\">/* ... */</span><span class=\"token punctuation\" >)</span>\n@<span class=\"token function\" >DropTarget<span class=\"token punctuation\" >(</span></span><span class=\"token comment\" spellcheck=\"true\">/* ... */</span><span class=\"token punctuation\" >)</span>\n<span class=\"token keyword\" >export</span> <span class=\"token keyword\" >default</span> <span class=\"token keyword\" >class</span> <span class=\"token class-name\" >YourComponent</span> <span class=\"token punctuation\" >{</span>\n  <span class=\"token comment\" spellcheck=\"true\">/* ... */</span>\n<span class=\"token punctuation\" >}</span></code><hr/>\n<h3>Putting It All Together<a id=\"putting-it-all-together\">&nbsp;</a></h3><p>Below is an example of wrapping an existing <code>Card</code> component into a drag source.</p>\n<hr/>\n<code class=\"codeBlock\"><span class=\"token keyword\" >var</span> <span class=\"token qualifier\" >React</span> <span class=\"token operator\" >=</span> <span class=\"token function\" >require<span class=\"token punctuation\" >(</span></span><span class=\"token string\" >'react'</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n<span class=\"token keyword\" >var</span> <span class=\"token qualifier\" >Drag</span><span class=\"token qualifier\" >Source</span> <span class=\"token operator\" >=</span> <span class=\"token function\" >require<span class=\"token punctuation\" >(</span></span><span class=\"token string\" >'react-dnd'</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >.</span><span class=\"token qualifier\" >Drag</span><span class=\"token qualifier\" >Source</span><span class=\"token punctuation\" >;</span>\n\n<span class=\"token comment\" spellcheck=\"true\">// Drag sources and drop targets only interact\n</span><span class=\"token comment\" spellcheck=\"true\">// if they have the same string type.\n</span><span class=\"token comment\" spellcheck=\"true\">// You want to keep types in a separate file with\n</span><span class=\"token comment\" spellcheck=\"true\">// the rest of your app's constants.\n</span><span class=\"token keyword\" >var</span> <span class=\"token qualifier\" >Types</span> <span class=\"token operator\" >=</span> <span class=\"token punctuation\" >{</span>\n  CARD<span class=\"token punctuation\" >:</span> <span class=\"token string\" >'card'</span>\n<span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >;</span>\n\n<span class=\"token comment\" spellcheck=\"true\">/**\n * Specifies the drag source contract.\n * Only `beginDrag` function is required.\n */</span>\n<span class=\"token keyword\" >var</span> cardSource <span class=\"token operator\" >=</span> <span class=\"token punctuation\" >{</span>\n  beginDrag<span class=\"token punctuation\" >:</span> <span class=\"token block-keyword\" >function</span> <span class=\"token punctuation\" >(</span>props<span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n    <span class=\"token comment\" spellcheck=\"true\">// Return the data describing the dragged item\n</span>    <span class=\"token keyword\" >var</span> item <span class=\"token operator\" >=</span> <span class=\"token punctuation\" >{</span> id<span class=\"token punctuation\" >:</span> props<span class=\"token punctuation\" >.</span>id <span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >;</span>\n    <span class=\"token keyword\" >return</span> item<span class=\"token punctuation\" >;</span>\n  <span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >,</span>\n\n  endDrag<span class=\"token punctuation\" >:</span> <span class=\"token block-keyword\" >function</span> <span class=\"token punctuation\" >(</span>props<span class=\"token punctuation\" >,</span> monitor<span class=\"token punctuation\" >,</span> component<span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n    <span class=\"token block-keyword\" >if</span> <span class=\"token punctuation\" >(</span><span class=\"token operator\" >!</span>monitor<span class=\"token punctuation\" >.</span><span class=\"token function\" >didDrop<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n      <span class=\"token keyword\" >return</span><span class=\"token punctuation\" >;</span>\n    <span class=\"token punctuation\" >}</span>\n\n    <span class=\"token comment\" spellcheck=\"true\">// When dropped on a compatible target, do something\n</span>    <span class=\"token keyword\" >var</span> item <span class=\"token operator\" >=</span> monitor<span class=\"token punctuation\" >.</span><span class=\"token function\" >getItem<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n    <span class=\"token keyword\" >var</span> dropResult <span class=\"token operator\" >=</span> monitor<span class=\"token punctuation\" >.</span><span class=\"token function\" >getDropResult<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n    <span class=\"token qualifier\" >Card</span><span class=\"token qualifier\" >Actions</span><span class=\"token punctuation\" >.</span><span class=\"token function\" >moveCardToList<span class=\"token punctuation\" >(</span></span>item<span class=\"token punctuation\" >.</span>id<span class=\"token punctuation\" >,</span> dropResult<span class=\"token punctuation\" >.</span>listId<span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n  <span class=\"token punctuation\" >}</span>\n<span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >;</span>\n\n<span class=\"token comment\" spellcheck=\"true\">/**\n * Specifies which props to inject into your component.\n */</span>\n<span class=\"token block-keyword\" >function</span> <span class=\"token function\" >collect<span class=\"token punctuation\" >(</span></span>connect<span class=\"token punctuation\" >,</span> monitor<span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n  <span class=\"token keyword\" >return</span> <span class=\"token punctuation\" >{</span>\n    <span class=\"token comment\" spellcheck=\"true\">// Call this function inside render()\n</span>    <span class=\"token comment\" spellcheck=\"true\">// to let React DnD handle the drag events:\n</span>    connectDragSource<span class=\"token punctuation\" >:</span> connect<span class=\"token punctuation\" >.</span><span class=\"token function\" >dragSource<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >,</span>\n    <span class=\"token comment\" spellcheck=\"true\">// You can ask the monitor about the current drag state:\n</span>    isDragging<span class=\"token punctuation\" >:</span> monitor<span class=\"token punctuation\" >.</span><span class=\"token function\" >isDragging<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span>\n  <span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >;</span>\n<span class=\"token punctuation\" >}</span>\n\n<span class=\"token keyword\" >var</span> <span class=\"token qualifier\" >Card</span> <span class=\"token operator\" >=</span> <span class=\"token qualifier\" >React</span><span class=\"token punctuation\" >.</span><span class=\"token function\" >createClass<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >{</span>\n  render<span class=\"token punctuation\" >:</span> <span class=\"token block-keyword\" >function</span> <span class=\"token punctuation\" >(</span><span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n    <span class=\"token comment\" spellcheck=\"true\">// Your component receives its own props as usual\n</span>    <span class=\"token keyword\" >var</span> id <span class=\"token operator\" >=</span> <span class=\"token var\" >this</span><span class=\"token punctuation\" >.</span>props<span class=\"token punctuation\" >.</span>id<span class=\"token punctuation\" >;</span>\n\n    <span class=\"token comment\" spellcheck=\"true\">// These two props are injected by React DnD,\n</span>    <span class=\"token comment\" spellcheck=\"true\">// as defined by your `collect` function above:\n</span>    <span class=\"token keyword\" >var</span> isDragging <span class=\"token operator\" >=</span> <span class=\"token var\" >this</span><span class=\"token punctuation\" >.</span>props<span class=\"token punctuation\" >.</span>isDragging<span class=\"token punctuation\" >;</span>\n    <span class=\"token keyword\" >var</span> connectDragSource <span class=\"token operator\" >=</span> <span class=\"token var\" >this</span><span class=\"token punctuation\" >.</span>props<span class=\"token punctuation\" >.</span>connectDragSource<span class=\"token punctuation\" >;</span>\n\n    <span class=\"token keyword\" >return</span> <span class=\"token function\" >connectDragSource<span class=\"token punctuation\" >(</span></span>\n      <span class=\"token operator\" >&lt;</span>div<span class=\"token operator\" >></span>\n        I am a draggable card number <span class=\"token punctuation\" >{</span>id<span class=\"token punctuation\" >}</span>\n        <span class=\"token punctuation\" >{</span>isDragging <span class=\"token operator\" >&amp;&amp;</span> <span class=\"token string\" >' (and I am being dragged now)'</span><span class=\"token punctuation\" >}</span>\n      <span class=\"token operator\" >&lt;</span><span class=\"token operator\" >/</span>div<span class=\"token operator\" >></span>\n    <span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n  <span class=\"token punctuation\" >}</span>\n<span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n\n<span class=\"token comment\" spellcheck=\"true\">// Export the wrapped version\n</span>module<span class=\"token punctuation\" >.</span>exports <span class=\"token operator\" >=</span> <span class=\"token function\" >DragSource<span class=\"token punctuation\" >(</span></span><span class=\"token qualifier\" >Types</span><span class=\"token punctuation\" >.</span>CARD<span class=\"token punctuation\" >,</span> cardSource<span class=\"token punctuation\" >,</span> collect<span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >(</span><span class=\"token qualifier\" >Card</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span></code><hr/>\n<code class=\"codeBlock\"><span class=\"token keyword\" >import</span> <span class=\"token qualifier\" >React</span> from <span class=\"token string\" >'react'</span><span class=\"token punctuation\" >;</span>\n<span class=\"token keyword\" >import</span> <span class=\"token punctuation\" >{</span> <span class=\"token qualifier\" >Drag</span><span class=\"token qualifier\" >Source</span> <span class=\"token punctuation\" >}</span> from <span class=\"token string\" >'react-dnd'</span><span class=\"token punctuation\" >;</span>\n\n<span class=\"token comment\" spellcheck=\"true\">// Drag sources and drop targets only interact\n</span><span class=\"token comment\" spellcheck=\"true\">// if they have the same string type.\n</span><span class=\"token comment\" spellcheck=\"true\">// You want to keep types in a separate file with\n</span><span class=\"token comment\" spellcheck=\"true\">// the rest of your app's constants.\n</span><span class=\"token keyword\" >const</span> <span class=\"token qualifier\" >Types</span> <span class=\"token operator\" >=</span> <span class=\"token punctuation\" >{</span>\n  CARD<span class=\"token punctuation\" >:</span> <span class=\"token string\" >'card'</span>\n<span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >;</span>\n\n<span class=\"token comment\" spellcheck=\"true\">/**\n * Specifies the drag source contract.\n * Only `beginDrag` function is required.\n */</span>\n<span class=\"token keyword\" >const</span> cardSource <span class=\"token operator\" >=</span> <span class=\"token punctuation\" >{</span>\n  <span class=\"token function\" >beginDrag<span class=\"token punctuation\" >(</span></span>props<span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n    <span class=\"token comment\" spellcheck=\"true\">// Return the data describing the dragged item\n</span>    <span class=\"token keyword\" >const</span> item <span class=\"token operator\" >=</span> <span class=\"token punctuation\" >{</span> id<span class=\"token punctuation\" >:</span> props<span class=\"token punctuation\" >.</span>id <span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >;</span>\n    <span class=\"token keyword\" >return</span> item<span class=\"token punctuation\" >;</span>\n  <span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >,</span>\n\n  <span class=\"token function\" >endDrag<span class=\"token punctuation\" >(</span></span>props<span class=\"token punctuation\" >,</span> monitor<span class=\"token punctuation\" >,</span> component<span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n    <span class=\"token block-keyword\" >if</span> <span class=\"token punctuation\" >(</span><span class=\"token operator\" >!</span>monitor<span class=\"token punctuation\" >.</span><span class=\"token function\" >didDrop<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n      <span class=\"token keyword\" >return</span><span class=\"token punctuation\" >;</span>\n    <span class=\"token punctuation\" >}</span>\n\n    <span class=\"token comment\" spellcheck=\"true\">// When dropped on a compatible target, do something\n</span>    <span class=\"token keyword\" >const</span> item <span class=\"token operator\" >=</span> monitor<span class=\"token punctuation\" >.</span><span class=\"token function\" >getItem<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n    <span class=\"token keyword\" >const</span> dropResult <span class=\"token operator\" >=</span> monitor<span class=\"token punctuation\" >.</span><span class=\"token function\" >getDropResult<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n    <span class=\"token qualifier\" >Card</span><span class=\"token qualifier\" >Actions</span><span class=\"token punctuation\" >.</span><span class=\"token function\" >moveCardToList<span class=\"token punctuation\" >(</span></span>item<span class=\"token punctuation\" >.</span>id<span class=\"token punctuation\" >,</span> dropResult<span class=\"token punctuation\" >.</span>listId<span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n  <span class=\"token punctuation\" >}</span>\n<span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >;</span>\n\n<span class=\"token comment\" spellcheck=\"true\">/**\n * Specifies which props to inject into your component.\n */</span>\n<span class=\"token block-keyword\" >function</span> <span class=\"token function\" >collect<span class=\"token punctuation\" >(</span></span>connect<span class=\"token punctuation\" >,</span> monitor<span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n  <span class=\"token keyword\" >return</span> <span class=\"token punctuation\" >{</span>\n    <span class=\"token comment\" spellcheck=\"true\">// Call this function inside render()\n</span>    <span class=\"token comment\" spellcheck=\"true\">// to let React DnD handle the drag events:\n</span>    connectDragSource<span class=\"token punctuation\" >:</span> connect<span class=\"token punctuation\" >.</span><span class=\"token function\" >dragSource<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >,</span>\n    <span class=\"token comment\" spellcheck=\"true\">// You can ask the monitor about the current drag state:\n</span>    isDragging<span class=\"token punctuation\" >:</span> monitor<span class=\"token punctuation\" >.</span><span class=\"token function\" >isDragging<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span>\n  <span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >;</span>\n<span class=\"token punctuation\" >}</span>\n\n<span class=\"token keyword\" >class</span> <span class=\"token class-name\" >Card</span> <span class=\"token punctuation\" >{</span>\n  <span class=\"token function\" >render<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n    <span class=\"token comment\" spellcheck=\"true\">// Your component receives its own props as usual\n</span>    <span class=\"token keyword\" >const</span> <span class=\"token punctuation\" >{</span> id <span class=\"token punctuation\" >}</span> <span class=\"token operator\" >=</span> <span class=\"token var\" >this</span><span class=\"token punctuation\" >.</span>props<span class=\"token punctuation\" >;</span>\n\n    <span class=\"token comment\" spellcheck=\"true\">// These two props are injected by React DnD,\n</span>    <span class=\"token comment\" spellcheck=\"true\">// as defined by your `collect` function above:\n</span>    <span class=\"token keyword\" >const</span> <span class=\"token punctuation\" >{</span> isDragging<span class=\"token punctuation\" >,</span> connectDragSource <span class=\"token punctuation\" >}</span> <span class=\"token operator\" >=</span> <span class=\"token var\" >this</span><span class=\"token punctuation\" >.</span>props<span class=\"token punctuation\" >;</span>\n\n    <span class=\"token keyword\" >return</span> <span class=\"token function\" >connectDragSource<span class=\"token punctuation\" >(</span></span>\n      <span class=\"token operator\" >&lt;</span>div<span class=\"token operator\" >></span>\n        I am a draggable card number <span class=\"token punctuation\" >{</span>id<span class=\"token punctuation\" >}</span>\n        <span class=\"token punctuation\" >{</span>isDragging <span class=\"token operator\" >&amp;&amp;</span> <span class=\"token string\" >' (and I am being dragged now)'</span><span class=\"token punctuation\" >}</span>\n      <span class=\"token operator\" >&lt;</span><span class=\"token operator\" >/</span>div<span class=\"token operator\" >></span>\n    <span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n  <span class=\"token punctuation\" >}</span>\n<span class=\"token punctuation\" >}</span>\n\n<span class=\"token comment\" spellcheck=\"true\">// Export the wrapped version\n</span><span class=\"token keyword\" >export</span> <span class=\"token keyword\" >default</span> <span class=\"token function\" >DragSource<span class=\"token punctuation\" >(</span></span><span class=\"token qualifier\" >Types</span><span class=\"token punctuation\" >.</span>CARD<span class=\"token punctuation\" >,</span> cardSource<span class=\"token punctuation\" >,</span> collect<span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >(</span><span class=\"token qualifier\" >Card</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span></code><hr/>\n<code class=\"codeBlock\"><span class=\"token keyword\" >import</span> <span class=\"token qualifier\" >React</span> from <span class=\"token string\" >'react'</span><span class=\"token punctuation\" >;</span>\n<span class=\"token keyword\" >import</span> <span class=\"token punctuation\" >{</span> <span class=\"token qualifier\" >Drag</span><span class=\"token qualifier\" >Source</span> <span class=\"token punctuation\" >}</span> from <span class=\"token string\" >'react-dnd'</span><span class=\"token punctuation\" >;</span>\n\n<span class=\"token comment\" spellcheck=\"true\">// Drag sources and drop targets only interact\n</span><span class=\"token comment\" spellcheck=\"true\">// if they have the same string type.\n</span><span class=\"token comment\" spellcheck=\"true\">// You want to keep types in a separate file with\n</span><span class=\"token comment\" spellcheck=\"true\">// the rest of your app's constants.\n</span><span class=\"token keyword\" >const</span> <span class=\"token qualifier\" >Types</span> <span class=\"token operator\" >=</span> <span class=\"token punctuation\" >{</span>\n  CARD<span class=\"token punctuation\" >:</span> <span class=\"token string\" >'card'</span>\n<span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >;</span>\n\n<span class=\"token comment\" spellcheck=\"true\">/**\n * Specifies the drag source contract.\n * Only `beginDrag` function is required.\n */</span>\n<span class=\"token keyword\" >const</span> cardSource <span class=\"token operator\" >=</span> <span class=\"token punctuation\" >{</span>\n  <span class=\"token function\" >beginDrag<span class=\"token punctuation\" >(</span></span>props<span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n    <span class=\"token comment\" spellcheck=\"true\">// Return the data describing the dragged item\n</span>    <span class=\"token keyword\" >const</span> item <span class=\"token operator\" >=</span> <span class=\"token punctuation\" >{</span> id<span class=\"token punctuation\" >:</span> props<span class=\"token punctuation\" >.</span>id <span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >;</span>\n    <span class=\"token keyword\" >return</span> item<span class=\"token punctuation\" >;</span>\n  <span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >,</span>\n\n  <span class=\"token function\" >endDrag<span class=\"token punctuation\" >(</span></span>props<span class=\"token punctuation\" >,</span> monitor<span class=\"token punctuation\" >,</span> component<span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n    <span class=\"token block-keyword\" >if</span> <span class=\"token punctuation\" >(</span><span class=\"token operator\" >!</span>monitor<span class=\"token punctuation\" >.</span><span class=\"token function\" >didDrop<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n      <span class=\"token keyword\" >return</span><span class=\"token punctuation\" >;</span>\n    <span class=\"token punctuation\" >}</span>\n\n    <span class=\"token comment\" spellcheck=\"true\">// When dropped on a compatible target, do something\n</span>    <span class=\"token keyword\" >const</span> item <span class=\"token operator\" >=</span> monitor<span class=\"token punctuation\" >.</span><span class=\"token function\" >getItem<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n    <span class=\"token keyword\" >const</span> dropResult <span class=\"token operator\" >=</span> monitor<span class=\"token punctuation\" >.</span><span class=\"token function\" >getDropResult<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n    <span class=\"token qualifier\" >Card</span><span class=\"token qualifier\" >Actions</span><span class=\"token punctuation\" >.</span><span class=\"token function\" >moveCardToList<span class=\"token punctuation\" >(</span></span>item<span class=\"token punctuation\" >.</span>id<span class=\"token punctuation\" >,</span> dropResult<span class=\"token punctuation\" >.</span>listId<span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n  <span class=\"token punctuation\" >}</span>\n<span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >;</span>\n\n<span class=\"token comment\" spellcheck=\"true\">// Use the decorator syntax\n</span>@<span class=\"token function\" >DragSource<span class=\"token punctuation\" >(</span></span><span class=\"token qualifier\" >Types</span><span class=\"token punctuation\" >.</span>CARD<span class=\"token punctuation\" >,</span> cardSource<span class=\"token punctuation\" >,</span> <span class=\"token punctuation\" >(</span>connect<span class=\"token punctuation\" >,</span> monitor<span class=\"token punctuation\" >)</span> <span class=\"token operator\" >=</span><span class=\"token operator\" >></span> <span class=\"token punctuation\" >(</span><span class=\"token punctuation\" >{</span>\n  <span class=\"token comment\" spellcheck=\"true\">// Call this function inside render()\n</span>  <span class=\"token comment\" spellcheck=\"true\">// to let React DnD handle the drag events:\n</span>  connectDragSource<span class=\"token punctuation\" >:</span> connect<span class=\"token punctuation\" >.</span><span class=\"token function\" >dragSource<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >,</span>\n  <span class=\"token comment\" spellcheck=\"true\">// You can ask the monitor about the current drag state:\n</span>  isDragging<span class=\"token punctuation\" >:</span> monitor<span class=\"token punctuation\" >.</span><span class=\"token function\" >isDragging<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span>\n<span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >)</span>\n<span class=\"token keyword\" >export</span> <span class=\"token keyword\" >default</span> <span class=\"token keyword\" >class</span> <span class=\"token class-name\" >Card</span> <span class=\"token punctuation\" >{</span>\n  <span class=\"token function\" >render<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n    <span class=\"token comment\" spellcheck=\"true\">// Your component receives its own props as usual\n</span>    <span class=\"token keyword\" >const</span> <span class=\"token punctuation\" >{</span> id <span class=\"token punctuation\" >}</span> <span class=\"token operator\" >=</span> <span class=\"token var\" >this</span><span class=\"token punctuation\" >.</span>props<span class=\"token punctuation\" >;</span>\n\n    <span class=\"token comment\" spellcheck=\"true\">// These two props are injected by React DnD,\n</span>    <span class=\"token comment\" spellcheck=\"true\">// as defined by your `collect` function above:\n</span>    <span class=\"token keyword\" >const</span> <span class=\"token punctuation\" >{</span> isDragging<span class=\"token punctuation\" >,</span> connectDragSource <span class=\"token punctuation\" >}</span> <span class=\"token operator\" >=</span> <span class=\"token var\" >this</span><span class=\"token punctuation\" >.</span>props<span class=\"token punctuation\" >;</span>\n\n    <span class=\"token keyword\" >return</span> <span class=\"token function\" >connectDragSource<span class=\"token punctuation\" >(</span></span>\n      <span class=\"token operator\" >&lt;</span>div<span class=\"token operator\" >></span>\n        I am a draggable card number <span class=\"token punctuation\" >{</span>id<span class=\"token punctuation\" >}</span>\n        <span class=\"token punctuation\" >{</span>isDragging <span class=\"token operator\" >&amp;&amp;</span> <span class=\"token string\" >' (and I am being dragged now)'</span><span class=\"token punctuation\" >}</span>\n      <span class=\"token operator\" >&lt;</span><span class=\"token operator\" >/</span>div<span class=\"token operator\" >></span>\n    <span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n  <span class=\"token punctuation\" >}</span>\n<span class=\"token punctuation\" >}</span></code><hr/>\n<p>Now you know enough about React DnD to explore the rest of the documentation!<br/>The <a href=\"docs-tutorial.html\">tutorial</a> is a great place to start.</p>\n";

/***/ },
/* 331 */
/***/ function(module, exports) {

	module.exports = "<p><em>New to React DnD? <a href=\"docs-overview.html\">Read the overview</a> before jumping into the docs.</em></p>\n<h1>Testing<a id=\"testing\">&nbsp;</a></h1><p>React DnD is test-friendly. The whole drag and drop interaction, including the rendering of your components, as well as the side effects you perform in response to the drag and drop events, can be tested.</p>\n<p>There are several different approaches to testing React components. React DnD is not opinionated and lets you use either of them. <strong>Neither of those approaches require the browser event system to be available.</strong></p>\n<p>A few test examples are included with the React DnD inside its <code>examples</code> folder. Run <code>npm install</code> and <code>npm test</code> inside the <code>react-dnd</code> root folder to start them.</p>\n<h3>Testing the Components in Isolation<a id=\"testing-the-components-in-isolation\">&nbsp;</a></h3><p>If you are only interested in testing the <em>rendering</em> of your components in isolation, and not their interaction, you may use the <code>DecoratedComponent</code> static property available on any class wrapped with React DnD to access the original class. You may then test it with the different props without any dependency on React DnD, supplying an identity function to stub the connector methods.</p>\n<hr/>\n<code class=\"codeBlock\"><span class=\"token keyword\" >var</span> <span class=\"token qualifier\" >React</span> <span class=\"token operator\" >=</span> <span class=\"token function\" >require<span class=\"token punctuation\" >(</span></span><span class=\"token string\" >'react'</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n<span class=\"token keyword\" >var</span> <span class=\"token qualifier\" >Test</span><span class=\"token qualifier\" >Utils</span> <span class=\"token operator\" >=</span> <span class=\"token function\" >require<span class=\"token punctuation\" >(</span></span><span class=\"token string\" >'react/lib/ReactTestUtils'</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n<span class=\"token keyword\" >var</span> expect <span class=\"token operator\" >=</span> <span class=\"token function\" >require<span class=\"token punctuation\" >(</span></span><span class=\"token string\" >'expect'</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n\n<span class=\"token function\" >it<span class=\"token punctuation\" >(</span></span><span class=\"token string\" >'can be tested independently'</span><span class=\"token punctuation\" >,</span> <span class=\"token block-keyword\" >function</span> <span class=\"token punctuation\" >(</span><span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n  <span class=\"token comment\" spellcheck=\"true\">// Obtain the reference to the component before React DnD wrapping\n</span>  <span class=\"token keyword\" >var</span> <span class=\"token qualifier\" >Original</span><span class=\"token qualifier\" >Box</span> <span class=\"token operator\" >=</span> <span class=\"token qualifier\" >Box</span><span class=\"token punctuation\" >.</span><span class=\"token qualifier\" >Decorated</span><span class=\"token qualifier\" >Component</span><span class=\"token punctuation\" >;</span>\n\n  <span class=\"token comment\" spellcheck=\"true\">// Stub the React DnD connector functions with an identity function\n</span>  <span class=\"token keyword\" >var</span> identity <span class=\"token operator\" >=</span> <span class=\"token block-keyword\" >function</span> <span class=\"token punctuation\" >(</span>el<span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span> <span class=\"token keyword\" >return</span> el<span class=\"token punctuation\" >;</span> <span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >;</span>\n\n  <span class=\"token comment\" spellcheck=\"true\">// Render with one set of props and test\n</span>  <span class=\"token keyword\" >var</span> root <span class=\"token operator\" >=</span> <span class=\"token qualifier\" >Test</span><span class=\"token qualifier\" >Utils</span><span class=\"token punctuation\" >.</span><span class=\"token function\" >renderIntoDocument<span class=\"token punctuation\" >(</span></span>\n    <span class=\"token operator\" >&lt;</span><span class=\"token qualifier\" >Original</span><span class=\"token qualifier\" >Box</span> name<span class=\"token operator\" >=</span><span class=\"token string\" >'test'</span>\n                 connectDragSource<span class=\"token operator\" >=</span><span class=\"token punctuation\" >{</span>identity<span class=\"token punctuation\" >}</span> <span class=\"token operator\" >/</span><span class=\"token operator\" >></span>\n  <span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n  <span class=\"token keyword\" >var</span> div <span class=\"token operator\" >=</span> <span class=\"token qualifier\" >Test</span><span class=\"token qualifier\" >Utils</span><span class=\"token punctuation\" >.</span><span class=\"token function\" >findRenderedDOMComponentWithTag<span class=\"token punctuation\" >(</span></span>root<span class=\"token punctuation\" >,</span> <span class=\"token string\" >'div'</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n  <span class=\"token function\" >expect<span class=\"token punctuation\" >(</span></span>div<span class=\"token punctuation\" >.</span>props<span class=\"token punctuation\" >.</span>style<span class=\"token punctuation\" >.</span>opacity<span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >.</span><span class=\"token function\" >toEqual<span class=\"token punctuation\" >(</span></span><span class=\"token number\" >1</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n\n  <span class=\"token comment\" spellcheck=\"true\">// Render with another set of props and test\n</span>  root <span class=\"token operator\" >=</span> <span class=\"token qualifier\" >Test</span><span class=\"token qualifier\" >Utils</span><span class=\"token punctuation\" >.</span><span class=\"token function\" >renderIntoDocument<span class=\"token punctuation\" >(</span></span>\n    <span class=\"token operator\" >&lt;</span><span class=\"token qualifier\" >Original</span><span class=\"token qualifier\" >Box</span> name<span class=\"token operator\" >=</span><span class=\"token string\" >'test'</span>\n                 connectDragSource<span class=\"token operator\" >=</span><span class=\"token punctuation\" >{</span>identity<span class=\"token punctuation\" >}</span>\n                 isDragging <span class=\"token operator\" >/</span><span class=\"token operator\" >></span>\n  <span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n  div <span class=\"token operator\" >=</span> <span class=\"token qualifier\" >Test</span><span class=\"token qualifier\" >Utils</span><span class=\"token punctuation\" >.</span><span class=\"token function\" >findRenderedDOMComponentWithTag<span class=\"token punctuation\" >(</span></span>root<span class=\"token punctuation\" >,</span> <span class=\"token string\" >'div'</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n  <span class=\"token function\" >expect<span class=\"token punctuation\" >(</span></span>div<span class=\"token punctuation\" >.</span>props<span class=\"token punctuation\" >.</span>style<span class=\"token punctuation\" >.</span>opacity<span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >.</span><span class=\"token function\" >toEqual<span class=\"token punctuation\" >(</span></span><span class=\"token number\" >0.4</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n<span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span></code><hr/>\n<code class=\"codeBlock\"><span class=\"token keyword\" >import</span> <span class=\"token qualifier\" >React</span> from <span class=\"token string\" >'react'</span><span class=\"token punctuation\" >;</span>\n<span class=\"token keyword\" >import</span> <span class=\"token qualifier\" >Test</span><span class=\"token qualifier\" >Utils</span> from <span class=\"token string\" >'react/lib/ReactTestUtils'</span><span class=\"token punctuation\" >;</span>\n<span class=\"token keyword\" >import</span> expect from <span class=\"token string\" >'expect'</span><span class=\"token punctuation\" >;</span>\n\n<span class=\"token function\" >it<span class=\"token punctuation\" >(</span></span><span class=\"token string\" >'can be tested independently'</span><span class=\"token punctuation\" >,</span> <span class=\"token punctuation\" >(</span><span class=\"token punctuation\" >)</span> <span class=\"token operator\" >=</span><span class=\"token operator\" >></span> <span class=\"token punctuation\" >{</span>\n  <span class=\"token comment\" spellcheck=\"true\">// Obtain the reference to the component before React DnD wrapping\n</span>  <span class=\"token keyword\" >const</span> <span class=\"token qualifier\" >Original</span><span class=\"token qualifier\" >Box</span> <span class=\"token operator\" >=</span> <span class=\"token qualifier\" >Box</span><span class=\"token punctuation\" >.</span><span class=\"token qualifier\" >Decorated</span><span class=\"token qualifier\" >Component</span><span class=\"token punctuation\" >;</span>\n\n  <span class=\"token comment\" spellcheck=\"true\">// Stub the React DnD connector functions with an identity function\n</span>  <span class=\"token keyword\" >const</span> identity <span class=\"token operator\" >=</span> el <span class=\"token operator\" >=</span><span class=\"token operator\" >></span> el<span class=\"token punctuation\" >;</span>\n\n  <span class=\"token comment\" spellcheck=\"true\">// Render with one set of props and test\n</span>  <span class=\"token keyword\" >let</span> root <span class=\"token operator\" >=</span> <span class=\"token qualifier\" >Test</span><span class=\"token qualifier\" >Utils</span><span class=\"token punctuation\" >.</span><span class=\"token function\" >renderIntoDocument<span class=\"token punctuation\" >(</span></span>\n    <span class=\"token operator\" >&lt;</span><span class=\"token qualifier\" >Original</span><span class=\"token qualifier\" >Box</span> name<span class=\"token operator\" >=</span><span class=\"token string\" >'test'</span>\n                 connectDragSource<span class=\"token operator\" >=</span><span class=\"token punctuation\" >{</span>identity<span class=\"token punctuation\" >}</span> <span class=\"token operator\" >/</span><span class=\"token operator\" >></span>\n  <span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n  <span class=\"token keyword\" >let</span> div <span class=\"token operator\" >=</span> <span class=\"token qualifier\" >Test</span><span class=\"token qualifier\" >Utils</span><span class=\"token punctuation\" >.</span><span class=\"token function\" >findRenderedDOMComponentWithTag<span class=\"token punctuation\" >(</span></span>root<span class=\"token punctuation\" >,</span> <span class=\"token string\" >'div'</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n  <span class=\"token function\" >expect<span class=\"token punctuation\" >(</span></span>div<span class=\"token punctuation\" >.</span>props<span class=\"token punctuation\" >.</span>style<span class=\"token punctuation\" >.</span>opacity<span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >.</span><span class=\"token function\" >toEqual<span class=\"token punctuation\" >(</span></span><span class=\"token number\" >1</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n\n  <span class=\"token comment\" spellcheck=\"true\">// Render with another set of props and test\n</span>  root <span class=\"token operator\" >=</span> <span class=\"token qualifier\" >Test</span><span class=\"token qualifier\" >Utils</span><span class=\"token punctuation\" >.</span><span class=\"token function\" >renderIntoDocument<span class=\"token punctuation\" >(</span></span>\n    <span class=\"token operator\" >&lt;</span><span class=\"token qualifier\" >Original</span><span class=\"token qualifier\" >Box</span> name<span class=\"token operator\" >=</span><span class=\"token string\" >'test'</span>\n                 connectDragSource<span class=\"token operator\" >=</span><span class=\"token punctuation\" >{</span>identity<span class=\"token punctuation\" >}</span>\n                 isDragging <span class=\"token operator\" >/</span><span class=\"token operator\" >></span>\n  <span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n  div <span class=\"token operator\" >=</span> <span class=\"token qualifier\" >Test</span><span class=\"token qualifier\" >Utils</span><span class=\"token punctuation\" >.</span><span class=\"token function\" >findRenderedDOMComponentWithTag<span class=\"token punctuation\" >(</span></span>root<span class=\"token punctuation\" >,</span> <span class=\"token string\" >'div'</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n  <span class=\"token function\" >expect<span class=\"token punctuation\" >(</span></span>div<span class=\"token punctuation\" >.</span>props<span class=\"token punctuation\" >.</span>style<span class=\"token punctuation\" >.</span>opacity<span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >.</span><span class=\"token function\" >toEqual<span class=\"token punctuation\" >(</span></span><span class=\"token number\" >0.4</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n<span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span></code><hr/>\n<hr/>\n<h3>Testing the Drag and Drop Interaction<a id=\"testing-the-drag-and-drop-interaction\">&nbsp;</a></h3><p>If you want to test the whole interaction, and not just the individual component rendering, you should use the <a href=\"docs-test-backend.html\">test backend</a> that ships with React DnD. <strong>The test backend does not require the DOM</strong> so you can also use it with <a href=\"https://facebook.github.io/react/docs/test-utils.html#shallow-rendering\"><code>ReactShallowRenderer</code></a> just fine.</p>\n<p>This is currently the least documented part of React DnD because it exposes the underlying concepts from the <a href=\"https://github.com/pljenkins/dnd-core\">DnD Core</a>, the library powering React DnD inside. You can learn more about the test backend and its methods from the <a href=\"https://github.com/pljenkins/dnd-core/tree/v1.1.0/src/__tests__\">DnD Core tests</a>.</p>\n<p>Here is an example to get you started:</p>\n<hr/>\n<code class=\"codeBlock\"><span class=\"token keyword\" >var</span> <span class=\"token qualifier\" >React</span> <span class=\"token operator\" >=</span> <span class=\"token function\" >require<span class=\"token punctuation\" >(</span></span><span class=\"token string\" >'react'</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n<span class=\"token keyword\" >var</span> <span class=\"token qualifier\" >Component</span> <span class=\"token operator\" >=</span> <span class=\"token qualifier\" >React</span><span class=\"token punctuation\" >.</span><span class=\"token qualifier\" >Component</span><span class=\"token punctuation\" >;</span>\n<span class=\"token keyword\" >var</span> <span class=\"token qualifier\" >Test</span><span class=\"token qualifier\" >Backend</span> <span class=\"token operator\" >=</span> <span class=\"token function\" >require<span class=\"token punctuation\" >(</span></span><span class=\"token string\" >'react-dnd/modules/backends/Test'</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n<span class=\"token keyword\" >var</span> <span class=\"token qualifier\" >Drag</span><span class=\"token qualifier\" >Drop</span><span class=\"token qualifier\" >Context</span> <span class=\"token operator\" >=</span> <span class=\"token function\" >require<span class=\"token punctuation\" >(</span></span><span class=\"token string\" >'react-dnd'</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >.</span><span class=\"token qualifier\" >Drag</span><span class=\"token qualifier\" >Drop</span><span class=\"token qualifier\" >Context</span><span class=\"token punctuation\" >;</span>\n<span class=\"token keyword\" >var</span> <span class=\"token qualifier\" >Test</span><span class=\"token qualifier\" >Utils</span> <span class=\"token operator\" >=</span> <span class=\"token function\" >require<span class=\"token punctuation\" >(</span></span><span class=\"token string\" >'react/lib/ReactTestUtils'</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n<span class=\"token keyword\" >var</span> expect <span class=\"token operator\" >=</span> <span class=\"token function\" >require<span class=\"token punctuation\" >(</span></span><span class=\"token string\" >'expect'</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n\n<span class=\"token comment\" spellcheck=\"true\">/**\n * Wraps a component into a DragDropContext that uses the TestBackend.\n */</span>\n<span class=\"token block-keyword\" >function</span> <span class=\"token function\" >wrapInTestContext<span class=\"token punctuation\" >(</span></span><span class=\"token qualifier\" >Decorated</span><span class=\"token qualifier\" >Component</span><span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n  <span class=\"token keyword\" >return</span> <span class=\"token function\" >DragDropContext<span class=\"token punctuation\" >(</span></span><span class=\"token qualifier\" >Test</span><span class=\"token qualifier\" >Backend</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >(</span>\n    <span class=\"token qualifier\" >React</span><span class=\"token punctuation\" >.</span><span class=\"token function\" >createClass<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >{</span>\n      render<span class=\"token punctuation\" >:</span> <span class=\"token block-keyword\" >function</span> <span class=\"token punctuation\" >(</span><span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n        <span class=\"token keyword\" >return</span> <span class=\"token operator\" >&lt;</span><span class=\"token qualifier\" >Decorated</span><span class=\"token qualifier\" >Component</span> <span class=\"token punctuation\" >{</span><span class=\"token punctuation\" >.</span><span class=\"token punctuation\" >.</span><span class=\"token punctuation\" >.</span><span class=\"token var\" >this</span><span class=\"token punctuation\" >.</span>props<span class=\"token punctuation\" >}</span> <span class=\"token operator\" >/</span><span class=\"token operator\" >></span><span class=\"token punctuation\" >;</span>\n      <span class=\"token punctuation\" >}</span>\n    <span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >)</span>\n  <span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n<span class=\"token punctuation\" >}</span>\n\n<span class=\"token function\" >it<span class=\"token punctuation\" >(</span></span><span class=\"token string\" >'can be tested with the testing backend'</span><span class=\"token punctuation\" >,</span> <span class=\"token block-keyword\" >function</span> <span class=\"token punctuation\" >(</span><span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n  <span class=\"token comment\" spellcheck=\"true\">// Render with the test context that uses the test backend\n</span>  <span class=\"token keyword\" >var</span> <span class=\"token qualifier\" >Box</span><span class=\"token qualifier\" >Context</span> <span class=\"token operator\" >=</span> <span class=\"token function\" >wrapInTestContext<span class=\"token punctuation\" >(</span></span><span class=\"token qualifier\" >Box</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n  <span class=\"token keyword\" >var</span> root <span class=\"token operator\" >=</span> <span class=\"token qualifier\" >Test</span><span class=\"token qualifier\" >Utils</span><span class=\"token punctuation\" >.</span><span class=\"token function\" >renderIntoDocument<span class=\"token punctuation\" >(</span></span><span class=\"token operator\" >&lt;</span><span class=\"token qualifier\" >Box</span><span class=\"token qualifier\" >Context</span> name<span class=\"token operator\" >=</span><span class=\"token string\" >'test'</span> <span class=\"token operator\" >/</span><span class=\"token operator\" >></span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n\n  <span class=\"token comment\" spellcheck=\"true\">// Obtain a reference to the backend\n</span>  <span class=\"token keyword\" >var</span> backend <span class=\"token operator\" >=</span> root<span class=\"token punctuation\" >.</span><span class=\"token function\" >getManager<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >.</span><span class=\"token function\" >getBackend<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n\n  <span class=\"token comment\" spellcheck=\"true\">// Test that the opacity is 1\n</span>  <span class=\"token keyword\" >let</span> div <span class=\"token operator\" >=</span> <span class=\"token qualifier\" >Test</span><span class=\"token qualifier\" >Utils</span><span class=\"token punctuation\" >.</span><span class=\"token function\" >findRenderedDOMComponentWithTag<span class=\"token punctuation\" >(</span></span>root<span class=\"token punctuation\" >,</span> <span class=\"token string\" >'div'</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n  <span class=\"token function\" >expect<span class=\"token punctuation\" >(</span></span>div<span class=\"token punctuation\" >.</span>props<span class=\"token punctuation\" >.</span>style<span class=\"token punctuation\" >.</span>opacity<span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >.</span><span class=\"token function\" >toEqual<span class=\"token punctuation\" >(</span></span><span class=\"token number\" >1</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n\n  <span class=\"token comment\" spellcheck=\"true\">// Find the drag source ID and use it to simulate the dragging operation\n</span>  <span class=\"token keyword\" >var</span> box <span class=\"token operator\" >=</span> <span class=\"token qualifier\" >Test</span><span class=\"token qualifier\" >Utils</span><span class=\"token punctuation\" >.</span><span class=\"token function\" >findRenderedComponentWithType<span class=\"token punctuation\" >(</span></span>root<span class=\"token punctuation\" >,</span> <span class=\"token qualifier\" >Box</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n  backend<span class=\"token punctuation\" >.</span><span class=\"token function\" >simulateBeginDrag<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >[</span>box<span class=\"token punctuation\" >.</span><span class=\"token function\" >getHandlerId<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >]</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n\n  <span class=\"token comment\" spellcheck=\"true\">// Optionally you can pass in a clientOffset for testing operations that\n</span>  <span class=\"token comment\" spellcheck=\"true\">// depend on mouse movements.\n</span>  <span class=\"token comment\" spellcheck=\"true\">// backend.simulateBeginDrag([box.getHandlerId()], {\n</span>  <span class=\"token comment\" spellcheck=\"true\">//   clientOffset: { x: 0, y: 0 },\n</span>  <span class=\"token comment\" spellcheck=\"true\">//   getSourceClientOffset: () => { x: 0, y: 0 },\n</span>  <span class=\"token comment\" spellcheck=\"true\">// });\n</span>\n  <span class=\"token comment\" spellcheck=\"true\">// Verify that the div changed its opacity\n</span>  div <span class=\"token operator\" >=</span> <span class=\"token qualifier\" >Test</span><span class=\"token qualifier\" >Utils</span><span class=\"token punctuation\" >.</span><span class=\"token function\" >findRenderedDOMComponentWithTag<span class=\"token punctuation\" >(</span></span>root<span class=\"token punctuation\" >,</span> <span class=\"token string\" >'div'</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n  <span class=\"token function\" >expect<span class=\"token punctuation\" >(</span></span>div<span class=\"token punctuation\" >.</span>props<span class=\"token punctuation\" >.</span>style<span class=\"token punctuation\" >.</span>opacity<span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >.</span><span class=\"token function\" >toEqual<span class=\"token punctuation\" >(</span></span><span class=\"token number\" >0.4</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n\n  <span class=\"token comment\" spellcheck=\"true\">// See other backend.simulate* methods for more!\n</span><span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span></code><hr/>\n<code class=\"codeBlock\"><span class=\"token keyword\" >import</span> <span class=\"token qualifier\" >React</span><span class=\"token punctuation\" >,</span> <span class=\"token punctuation\" >{</span> <span class=\"token qualifier\" >Component</span> <span class=\"token punctuation\" >}</span> from <span class=\"token string\" >'react'</span><span class=\"token punctuation\" >;</span>\n<span class=\"token keyword\" >import</span> <span class=\"token qualifier\" >Test</span><span class=\"token qualifier\" >Backend</span> from <span class=\"token string\" >'react-dnd/modules/backends/Test'</span><span class=\"token punctuation\" >;</span>\n<span class=\"token keyword\" >import</span> <span class=\"token punctuation\" >{</span> <span class=\"token qualifier\" >Drag</span><span class=\"token qualifier\" >Drop</span><span class=\"token qualifier\" >Context</span> <span class=\"token punctuation\" >}</span> from <span class=\"token string\" >'react-dnd'</span><span class=\"token punctuation\" >;</span>\n<span class=\"token keyword\" >import</span> <span class=\"token qualifier\" >Test</span><span class=\"token qualifier\" >Utils</span> from <span class=\"token string\" >'react/lib/ReactTestUtils'</span><span class=\"token punctuation\" >;</span>\n<span class=\"token keyword\" >import</span> expect from <span class=\"token string\" >'expect'</span><span class=\"token punctuation\" >;</span>\n\n<span class=\"token comment\" spellcheck=\"true\">/**\n * Wraps a component into a DragDropContext that uses the TestBackend.\n */</span>\n<span class=\"token block-keyword\" >function</span> <span class=\"token function\" >wrapInTestContext<span class=\"token punctuation\" >(</span></span><span class=\"token qualifier\" >Decorated</span><span class=\"token qualifier\" >Component</span><span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n  <span class=\"token keyword\" >return</span> <span class=\"token function\" >DragDropContext<span class=\"token punctuation\" >(</span></span><span class=\"token qualifier\" >Test</span><span class=\"token qualifier\" >Backend</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >(</span>\n    <span class=\"token keyword\" >class</span> <span class=\"token class-name\" >TestContextContainer</span> <span class=\"token keyword\" >extends</span> <span class=\"token class-name\" >Component</span> <span class=\"token punctuation\" >{</span>\n      <span class=\"token function\" >render<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n        <span class=\"token keyword\" >return</span> <span class=\"token operator\" >&lt;</span><span class=\"token qualifier\" >Decorated</span><span class=\"token qualifier\" >Component</span> <span class=\"token punctuation\" >{</span><span class=\"token punctuation\" >.</span><span class=\"token punctuation\" >.</span><span class=\"token punctuation\" >.</span><span class=\"token var\" >this</span><span class=\"token punctuation\" >.</span>props<span class=\"token punctuation\" >}</span> <span class=\"token operator\" >/</span><span class=\"token operator\" >></span><span class=\"token punctuation\" >;</span>\n      <span class=\"token punctuation\" >}</span>\n    <span class=\"token punctuation\" >}</span>\n  <span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n<span class=\"token punctuation\" >}</span>\n\n<span class=\"token function\" >it<span class=\"token punctuation\" >(</span></span><span class=\"token string\" >'can be tested with the testing backend'</span><span class=\"token punctuation\" >,</span> <span class=\"token punctuation\" >(</span><span class=\"token punctuation\" >)</span> <span class=\"token operator\" >=</span><span class=\"token operator\" >></span> <span class=\"token punctuation\" >{</span>\n  <span class=\"token comment\" spellcheck=\"true\">// Render with the test context that uses the test backend\n</span>  <span class=\"token keyword\" >const</span> <span class=\"token qualifier\" >Box</span><span class=\"token qualifier\" >Context</span> <span class=\"token operator\" >=</span> <span class=\"token function\" >wrapInTestContext<span class=\"token punctuation\" >(</span></span><span class=\"token qualifier\" >Box</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n  <span class=\"token keyword\" >const</span> root <span class=\"token operator\" >=</span> <span class=\"token qualifier\" >Test</span><span class=\"token qualifier\" >Utils</span><span class=\"token punctuation\" >.</span><span class=\"token function\" >renderIntoDocument<span class=\"token punctuation\" >(</span></span><span class=\"token operator\" >&lt;</span><span class=\"token qualifier\" >Box</span><span class=\"token qualifier\" >Context</span> name<span class=\"token operator\" >=</span><span class=\"token string\" >'test'</span> <span class=\"token operator\" >/</span><span class=\"token operator\" >></span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n\n  <span class=\"token comment\" spellcheck=\"true\">// Obtain a reference to the backend\n</span>  <span class=\"token keyword\" >const</span> backend <span class=\"token operator\" >=</span> root<span class=\"token punctuation\" >.</span><span class=\"token function\" >getManager<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >.</span><span class=\"token function\" >getBackend<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n\n  <span class=\"token comment\" spellcheck=\"true\">// Test that the opacity is 1\n</span>  <span class=\"token keyword\" >let</span> div <span class=\"token operator\" >=</span> <span class=\"token qualifier\" >Test</span><span class=\"token qualifier\" >Utils</span><span class=\"token punctuation\" >.</span><span class=\"token function\" >findRenderedDOMComponentWithTag<span class=\"token punctuation\" >(</span></span>root<span class=\"token punctuation\" >,</span> <span class=\"token string\" >'div'</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n  <span class=\"token function\" >expect<span class=\"token punctuation\" >(</span></span>div<span class=\"token punctuation\" >.</span>props<span class=\"token punctuation\" >.</span>style<span class=\"token punctuation\" >.</span>opacity<span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >.</span><span class=\"token function\" >toEqual<span class=\"token punctuation\" >(</span></span><span class=\"token number\" >1</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n\n  <span class=\"token comment\" spellcheck=\"true\">// Find the drag source ID and use it to simulate the dragging operation\n</span>  <span class=\"token keyword\" >const</span> box <span class=\"token operator\" >=</span> <span class=\"token qualifier\" >Test</span><span class=\"token qualifier\" >Utils</span><span class=\"token punctuation\" >.</span><span class=\"token function\" >findRenderedComponentWithType<span class=\"token punctuation\" >(</span></span>root<span class=\"token punctuation\" >,</span> <span class=\"token qualifier\" >Box</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n  backend<span class=\"token punctuation\" >.</span><span class=\"token function\" >simulateBeginDrag<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >[</span>box<span class=\"token punctuation\" >.</span><span class=\"token function\" >getHandlerId<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >]</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n\n  <span class=\"token comment\" spellcheck=\"true\">// Verify that the div changed its opacity\n</span>  div <span class=\"token operator\" >=</span> <span class=\"token qualifier\" >Test</span><span class=\"token qualifier\" >Utils</span><span class=\"token punctuation\" >.</span><span class=\"token function\" >findRenderedDOMComponentWithTag<span class=\"token punctuation\" >(</span></span>root<span class=\"token punctuation\" >,</span> <span class=\"token string\" >'div'</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n  <span class=\"token function\" >expect<span class=\"token punctuation\" >(</span></span>div<span class=\"token punctuation\" >.</span>props<span class=\"token punctuation\" >.</span>style<span class=\"token punctuation\" >.</span>opacity<span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >.</span><span class=\"token function\" >toEqual<span class=\"token punctuation\" >(</span></span><span class=\"token number\" >0.4</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n\n  <span class=\"token comment\" spellcheck=\"true\">// See other backend.simulate* methods for more!\n</span><span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span></code><hr/>\n<code class=\"codeBlock\"><span class=\"token keyword\" >import</span> <span class=\"token qualifier\" >React</span><span class=\"token punctuation\" >,</span> <span class=\"token punctuation\" >{</span> <span class=\"token qualifier\" >Component</span> <span class=\"token punctuation\" >}</span> from <span class=\"token string\" >'react'</span><span class=\"token punctuation\" >;</span>\n<span class=\"token keyword\" >import</span> <span class=\"token qualifier\" >Test</span><span class=\"token qualifier\" >Backend</span> from <span class=\"token string\" >'react-dnd/modules/backends/Test'</span><span class=\"token punctuation\" >;</span>\n<span class=\"token keyword\" >import</span> <span class=\"token punctuation\" >{</span> <span class=\"token qualifier\" >Drag</span><span class=\"token qualifier\" >Drop</span><span class=\"token qualifier\" >Context</span> <span class=\"token punctuation\" >}</span> from <span class=\"token string\" >'react-dnd'</span><span class=\"token punctuation\" >;</span>\n<span class=\"token keyword\" >import</span> <span class=\"token qualifier\" >Test</span><span class=\"token qualifier\" >Utils</span> from <span class=\"token string\" >'react/lib/ReactTestUtils'</span><span class=\"token punctuation\" >;</span>\n<span class=\"token keyword\" >import</span> expect from <span class=\"token string\" >'expect'</span><span class=\"token punctuation\" >;</span>\n\n<span class=\"token comment\" spellcheck=\"true\">/**\n * Wraps a component into a DragDropContext that uses the TestBackend.\n */</span>\n<span class=\"token block-keyword\" >function</span> <span class=\"token function\" >wrapInTestContext<span class=\"token punctuation\" >(</span></span><span class=\"token qualifier\" >Decorated</span><span class=\"token qualifier\" >Component</span><span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n  @<span class=\"token function\" >DragDropContext<span class=\"token punctuation\" >(</span></span><span class=\"token qualifier\" >Test</span><span class=\"token qualifier\" >Backend</span><span class=\"token punctuation\" >)</span>\n  <span class=\"token keyword\" >class</span> <span class=\"token class-name\" >TestContextContainer</span> <span class=\"token keyword\" >extends</span> <span class=\"token class-name\" >Component</span> <span class=\"token punctuation\" >{</span>\n    <span class=\"token function\" >render<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n      <span class=\"token keyword\" >return</span> <span class=\"token operator\" >&lt;</span><span class=\"token qualifier\" >Decorated</span><span class=\"token qualifier\" >Component</span> <span class=\"token punctuation\" >{</span><span class=\"token punctuation\" >.</span><span class=\"token punctuation\" >.</span><span class=\"token punctuation\" >.</span><span class=\"token var\" >this</span><span class=\"token punctuation\" >.</span>props<span class=\"token punctuation\" >}</span> <span class=\"token operator\" >/</span><span class=\"token operator\" >></span><span class=\"token punctuation\" >;</span>\n    <span class=\"token punctuation\" >}</span>\n  <span class=\"token punctuation\" >}</span>\n\n  <span class=\"token keyword\" >return</span> <span class=\"token qualifier\" >Test</span><span class=\"token qualifier\" >Context</span><span class=\"token qualifier\" >Container</span><span class=\"token punctuation\" >;</span>\n<span class=\"token punctuation\" >}</span>\n\n<span class=\"token function\" >it<span class=\"token punctuation\" >(</span></span><span class=\"token string\" >'can be tested with the testing backend'</span><span class=\"token punctuation\" >,</span> <span class=\"token punctuation\" >(</span><span class=\"token punctuation\" >)</span> <span class=\"token operator\" >=</span><span class=\"token operator\" >></span> <span class=\"token punctuation\" >{</span>\n  <span class=\"token comment\" spellcheck=\"true\">// Render with the test context that uses the test backend\n</span>  <span class=\"token keyword\" >const</span> <span class=\"token qualifier\" >Box</span><span class=\"token qualifier\" >Context</span> <span class=\"token operator\" >=</span> <span class=\"token function\" >wrapInTestContext<span class=\"token punctuation\" >(</span></span><span class=\"token qualifier\" >Box</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n  <span class=\"token keyword\" >const</span> root <span class=\"token operator\" >=</span> <span class=\"token qualifier\" >Test</span><span class=\"token qualifier\" >Utils</span><span class=\"token punctuation\" >.</span><span class=\"token function\" >renderIntoDocument<span class=\"token punctuation\" >(</span></span><span class=\"token operator\" >&lt;</span><span class=\"token qualifier\" >Box</span><span class=\"token qualifier\" >Context</span> name<span class=\"token operator\" >=</span><span class=\"token string\" >'test'</span> <span class=\"token operator\" >/</span><span class=\"token operator\" >></span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n\n  <span class=\"token comment\" spellcheck=\"true\">// Obtain a reference to the backend\n</span>  <span class=\"token keyword\" >const</span> backend <span class=\"token operator\" >=</span> root<span class=\"token punctuation\" >.</span><span class=\"token function\" >getManager<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >.</span><span class=\"token function\" >getBackend<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n\n  <span class=\"token comment\" spellcheck=\"true\">// Test that the opacity is 1\n</span>  <span class=\"token keyword\" >let</span> div <span class=\"token operator\" >=</span> <span class=\"token qualifier\" >Test</span><span class=\"token qualifier\" >Utils</span><span class=\"token punctuation\" >.</span><span class=\"token function\" >findRenderedDOMComponentWithTag<span class=\"token punctuation\" >(</span></span>root<span class=\"token punctuation\" >,</span> <span class=\"token string\" >'div'</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n  <span class=\"token function\" >expect<span class=\"token punctuation\" >(</span></span>div<span class=\"token punctuation\" >.</span>props<span class=\"token punctuation\" >.</span>style<span class=\"token punctuation\" >.</span>opacity<span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >.</span><span class=\"token function\" >toEqual<span class=\"token punctuation\" >(</span></span><span class=\"token number\" >1</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n\n  <span class=\"token comment\" spellcheck=\"true\">// Find the drag source ID and use it to simulate the dragging operation\n</span>  <span class=\"token keyword\" >const</span> box <span class=\"token operator\" >=</span> <span class=\"token qualifier\" >Test</span><span class=\"token qualifier\" >Utils</span><span class=\"token punctuation\" >.</span><span class=\"token function\" >findRenderedComponentWithType<span class=\"token punctuation\" >(</span></span>root<span class=\"token punctuation\" >,</span> <span class=\"token qualifier\" >Box</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n  backend<span class=\"token punctuation\" >.</span><span class=\"token function\" >simulateBeginDrag<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >[</span>box<span class=\"token punctuation\" >.</span><span class=\"token function\" >getHandlerId<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >]</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n\n  <span class=\"token comment\" spellcheck=\"true\">// Verify that the div changed its opacity\n</span>  div <span class=\"token operator\" >=</span> <span class=\"token qualifier\" >Test</span><span class=\"token qualifier\" >Utils</span><span class=\"token punctuation\" >.</span><span class=\"token function\" >findRenderedDOMComponentWithTag<span class=\"token punctuation\" >(</span></span>root<span class=\"token punctuation\" >,</span> <span class=\"token string\" >'div'</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n  <span class=\"token function\" >expect<span class=\"token punctuation\" >(</span></span>div<span class=\"token punctuation\" >.</span>props<span class=\"token punctuation\" >.</span>style<span class=\"token punctuation\" >.</span>opacity<span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >.</span><span class=\"token function\" >toEqual<span class=\"token punctuation\" >(</span></span><span class=\"token number\" >0.4</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n\n  <span class=\"token comment\" spellcheck=\"true\">// See other backend.simulate* methods for more!\n</span><span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span></code><hr/>\n";

/***/ },
/* 332 */
/***/ function(module, exports) {

	module.exports = "<h1>Troubleshooting<a id=\"troubleshooting\">&nbsp;</a></h1><p>This page is dedicated to the problems you might bump into while using React DnD.</p>\n<!-- Do not edit title. It is referenced from the code. -->\n<h3>Could not find the drag and drop manager in the context<a id=\"could-not-find-the-drag-and-drop-manager-in-the-context\">&nbsp;</a></h3><p>There are several ways this error might have happened:</p>\n<ol>\n<li><p>You wrapped some component with a <a href=\"docs-drag-source.html\"><code>DragSource</code></a>, <a href=\"docs-drop-target.html\"><code>DropTarget</code></a>, or <a href=\"docs-drag-layer.html\"><code>DragLayer</code></a>, but forgot to wrap your top-level component with the <a href=\"docs-drag-drop-context.html\"><code>DragDropContext</code></a>.</p>\n</li>\n<li><p>You <em>have</em> wrapped the top-level component with the <a href=\"docs-drag-drop-context.html\"><code>DragDropContext</code></a> but exported an unwrapped version by mistake.</p>\n</li>\n<li><p>You are using a component in an isolated environment like a unit test. See the second point for instructions to stub it.</p>\n</li>\n<li><p>The context is lost for some other reason. <a href=\"https://github.com/pljenkins/react-dnd/issues/new\">Please file an issue</a> if you can reproduce it on a small project.</p>\n</li>\n</ol>\n<h4>Wrap top-level component with a <code>DragDropContext</code><a id=\"wrap-top-level-component-with-a-code-dragdropcontext-code-\">&nbsp;</a></h4><p>To fix this error, find the top-level component in your app. Usually, this is the root route handler. It doesn&#39;t have to be the topmost component, but it has to be higher in the hierarchy than any of your component using React DnD. Wrap this component with a <a href=\"docs-drag-drop-context.html\"><code>DragDropContext</code></a> call. It is important to specify a <em>backend</em> as the only argument in that call. Currently React DnD only provides an <a href=\"docs-html5-backend.html\"><code>HTML5</code> backend</a>, but touch backend support is coming in the future.</p>\n<h4>Stub the context inside the unit tests<a id=\"stub-the-context-inside-the-unit-tests\">&nbsp;</a></h4><p>If you have this error in a test, <a href=\"docs-testing.html\">read the testing guide</a> for instructions on stubbing the context.</p>\n<h4>Make sure you that don&#39;t have duplicate React<a id=\"make-sure-you-that-don-39-t-have-duplicate-react\">&nbsp;</a></h4><p>This problem may also appear if you have a duplicate React installation in your Browserify or Webpack build. <a href=\"https://medium.com/@dan_abramov/two-weird-tricks-that-fix-react-7cf9bbdef375\">This article</a> explains both the problem and the solution to it.</p>\n<!-- Do not edit title. It is referenced from the code. -->\n<h3>React DnD does not provide a default export<a id=\"react-dnd-does-not-provide-a-default-export\">&nbsp;</a></h3><p>React DnD does not provide a <a href=\"http://www.2ality.com/2014/09/es6-modules-final.html\">default export</a>.<br/>Mind the difference:</p>\n<hr/>\n<code class=\"codeBlock\"><span class=\"token comment\" spellcheck=\"true\">// Wrong:\n</span><span class=\"token keyword\" >var</span> <span class=\"token qualifier\" >Drag</span><span class=\"token qualifier\" >Source</span> <span class=\"token operator\" >=</span> <span class=\"token function\" >require<span class=\"token punctuation\" >(</span></span><span class=\"token string\" >'react-dnd'</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n\n<span class=\"token comment\" spellcheck=\"true\">// Correct:\n</span><span class=\"token keyword\" >var</span> <span class=\"token qualifier\" >Drag</span><span class=\"token qualifier\" >Source</span> <span class=\"token operator\" >=</span> <span class=\"token function\" >require<span class=\"token punctuation\" >(</span></span><span class=\"token string\" >'react-dnd'</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >.</span><span class=\"token qualifier\" >Drag</span><span class=\"token qualifier\" >Source</span><span class=\"token punctuation\" >;</span></code><hr/>\n<code class=\"codeBlock\"><span class=\"token comment\" spellcheck=\"true\">// Wrong:\n</span><span class=\"token keyword\" >import</span> <span class=\"token qualifier\" >Drag</span><span class=\"token qualifier\" >Source</span> from <span class=\"token string\" >'react-dnd'</span><span class=\"token punctuation\" >;</span>\n\n<span class=\"token comment\" spellcheck=\"true\">// Correct:\n</span><span class=\"token keyword\" >import</span> <span class=\"token punctuation\" >{</span> <span class=\"token qualifier\" >Drag</span><span class=\"token qualifier\" >Source</span> <span class=\"token punctuation\" >}</span> from <span class=\"token string\" >'react-dnd'</span><span class=\"token punctuation\" >;</span></code><hr/>\n<hr/>\n<h3>You seem to be applying the arguments in the wrong order<a id=\"you-seem-to-be-applying-the-arguments-in-the-wrong-order\">&nbsp;</a></h3><p>For the <a href=\"docs-drag-source.html\"><code>DragSource</code></a>, <a href=\"docs-drop-target.html\"><code>DropTarget</code></a>, <a href=\"docs-drag-layer.html\"><code>DragLayer</code></a>, and the <a href=\"docs-drag-drop-context.html\"><code>DragDropContext</code></a>, it is important that you first pass them the configuration arguments, and <em>then</em> inject your React component in a second call.</p>\n<hr/>\n<code class=\"codeBlock\"><span class=\"token comment\" spellcheck=\"true\">// Wrong:\n</span>module<span class=\"token punctuation\" >.</span>exports <span class=\"token operator\" >=</span> <span class=\"token function\" >DragSource<span class=\"token punctuation\" >(</span></span><span class=\"token qualifier\" >Your</span><span class=\"token qualifier\" >Component</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >(</span><span class=\"token comment\" spellcheck=\"true\">/* ... */</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\nmodule<span class=\"token punctuation\" >.</span>exports <span class=\"token operator\" >=</span> <span class=\"token function\" >DragSource<span class=\"token punctuation\" >(</span></span><span class=\"token qualifier\" >Your</span><span class=\"token qualifier\" >Component</span><span class=\"token punctuation\" >,</span> <span class=\"token comment\" spellcheck=\"true\">/* ... */</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n\n<span class=\"token comment\" spellcheck=\"true\">// Correct:\n</span>module<span class=\"token punctuation\" >.</span>exports <span class=\"token operator\" >=</span> <span class=\"token function\" >DragSource<span class=\"token punctuation\" >(</span></span><span class=\"token comment\" spellcheck=\"true\">/* ... */</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >(</span><span class=\"token qualifier\" >Your</span><span class=\"token qualifier\" >Component</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span></code><hr/>\n<code class=\"codeBlock\"><span class=\"token comment\" spellcheck=\"true\">// Wrong:\n</span><span class=\"token keyword\" >export</span> <span class=\"token keyword\" >default</span> <span class=\"token function\" >DragSource<span class=\"token punctuation\" >(</span></span><span class=\"token qualifier\" >Your</span><span class=\"token qualifier\" >Component</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >(</span><span class=\"token comment\" spellcheck=\"true\">/* ... */</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n<span class=\"token keyword\" >export</span> <span class=\"token keyword\" >default</span> <span class=\"token function\" >DragSource<span class=\"token punctuation\" >(</span></span><span class=\"token qualifier\" >Your</span><span class=\"token qualifier\" >Component</span><span class=\"token punctuation\" >,</span> <span class=\"token comment\" spellcheck=\"true\">/* ... */</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n\n<span class=\"token comment\" spellcheck=\"true\">// Correct:\n</span><span class=\"token keyword\" >export</span> <span class=\"token keyword\" >default</span> <span class=\"token function\" >DragSource<span class=\"token punctuation\" >(</span></span><span class=\"token comment\" spellcheck=\"true\">/* ... */</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >(</span><span class=\"token qualifier\" >Your</span><span class=\"token qualifier\" >Component</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span></code><hr/>\n<hr/>\n<p>Remember, <strong>the component comes last!</strong></p>\n<p>You may ask why I chose such a weird API. In fact it&#39;s not <em>too</em> weird, but the neat part about it is that, if you enable the <a href=\"https://github.com/wycats/javascript-decorators\">ES7 decorators</a> in <a href=\"https://babeljs.io\">Babel</a> by putting <code>{ &quot;stage&quot;: 1 }</code> in your <a href=\"https://babeljs.io/docs/usage/babelrc/\">.babelrc file</a>, you can write them naturally:</p>\n<hr/>\n<hr/>\n<hr/>\n<code class=\"codeBlock\">@<span class=\"token function\" >DragSource<span class=\"token punctuation\" >(</span></span><span class=\"token comment\" spellcheck=\"true\">/* ... */</span><span class=\"token punctuation\" >)</span>\n<span class=\"token keyword\" >export</span> <span class=\"token keyword\" >default</span> <span class=\"token keyword\" >class</span> <span class=\"token class-name\" >YourComponent</span> <span class=\"token punctuation\" >{</span> <span class=\"token punctuation\" >}</span></code><hr/>\n<p>You may not use ES7 decorators today (linters don&#39;t understand them), but this API lets you switch to the decorators when they are more mature, and also has <a href=\"docs-faq.html#how-do-i-combine-several-drag-sources-and-drop-targets-in-a-single-component-\">nicer composition semantics</a> in ES5 or ES6.</p>\n";

/***/ },
/* 333 */
/***/ function(module, exports) {

	module.exports = "<h1>Tutorial<a id=\"tutorial\">&nbsp;</a></h1><p>Now that you&#39;ve read <a href=\"docs-overview.html\">the overview</a>, it&#39;s the adventure time! Even if you have not, you can skip it for now, because ⅔ of our time we&#39;ll be busy identifying and building normal React components, just like in the classic <a href=\"https://facebook.github.io/react/blog/2013/11/05/thinking-in-react.html\">Thinking in React</a> tutorial. Adding the drag and drop support is just the icing on the cake.</p>\n<p>In this tutorial, we&#39;re going to build a Chess game with React and React DnD. Just kidding! Writing a full-blown Chess game is totally out of scope of this tutorial. <strong>What we&#39;re going to build is a tiny app with a Chess board and a lonely Knight. The Knight will be draggable according to the Chess rules.</strong></p>\n<p>We will use this example to demonstrate the data-driven approach of React DnD. You will learn how to create a drag source and a drop target, wire them together with your components, and change their appearance in response to the drag and drop events.</p>\n<p>If you&#39;re new to React and know a thing or two about it, but yet have to gain some experience building components, this tutorial can also serve as an introduction to the React mode of thinking and the React workflow. <strong>If you are a seasoned React developer and only came here for the drag and drop part, feel free to skip to the third and the final chapter of this tutorial.</strong></p>\n<p>Enough talk! It&#39;s time to set up a build workflow for our little project. I use <a href=\"http://webpack.github.io/\">Webpack</a>, you might be using <a href=\"http://browserify.org/\">Browserify</a>. I don&#39;t want to get into that now, so just set up an empty React project in whatever way is most convenient for you. If you&#39;re feeling lazy, you are free to clone <a href=\"https://github.com/pljenkins/react-hot-boilerplate\">React Hot Boilerplate</a> and work on top of it. In fact, that&#39;s what I&#39;m going to do myself.</p>\n<p>In this tutorial, the code examples are available simultaneously in ES5, ES6, and <a href=\"docs-faq.html\">ES7</a>. If you want to follow along using ES6 or ES7, you will need to set up a compilation step using <a href=\"https://babeljs.io/\">Babel</a>. It&#39;s easy to <a href=\"https://babeljs.io/docs/using-babel/\">make it work with the tool of your choice</a> so we&#39;re going to skip this step, too, and assume you&#39;ve dealt with it and you are ready to write code now. The boilerplate project <a href=\"https://github.com/pljenkins/react-hot-boilerplate\">I linked to before</a> already includes Babel.</p>\n<p>The app we&#39;re going to build is <a href=\"examples-chessboard-tutorial-app.html\">available as an example on this website</a>.</p>\n<h2>Identifying the Components<a id=\"identifying-the-components\">&nbsp;</a></h2><p>We&#39;re going to start by creating some React components first, with no thoughts of the drag and drop interaction. Which components is our Lonely Knight app going to be made of? I can think of a few:</p>\n<ul>\n<li><code>Knight</code>, our lonely knight piece;</li>\n<li><code>Square</code>, a single square on the board;</li>\n<li><code>Board</code>, the whole board with 64 squares.</li>\n</ul>\n<p>Let&#39;s consider their props.</p>\n<ul>\n<li><p><code>Knight</code> probably needs no props. It has a position, but there&#39;s no reason for the <code>Knight</code> to know it, because it can be positioned by being placed into a <code>Square</code> as a child.</p>\n</li>\n<li><p>It is tempting to give <code>Square</code> its position via props, but this, again, is not necessary, because the only information it really needs for the rendering is the color. I&#39;m going to make <code>Square</code> white by default, and add a <code>black</code> boolean prop. And of course <code>Square</code> may accept a single child: the chess piece that is currently on it. I chose white as the default background color to match the browser defaults.</p>\n</li>\n<li><p>The <code>Board</code> is tricky. It makes no sense to pass <code>Square</code>s as children to it, because what else could a board contain? Therefore it probably owns the <code>Square</code>s. But then, it also need to own the <code>Knight</code> because this guy needs to be placed inside one of those <code>Square</code>s. This means that the <code>Board</code> needs to know the knight&#39;s current position. In a real Chess game, the <code>Board</code> would accept a data structure describing all the pieces, their colors and positions, but for us, a <code>knightPosition</code> prop will suffice. We will use two-item arrays as coordinates, with <code>[0, 0]</code> referring to the A8 square. Why A8 instead of A1? To match the browser coordinate orientation. I tried it another way and it just messed with my head too much.</p>\n</li>\n</ul>\n<p>Where will the current state live? I really don&#39;t want to put it into the <code>Board</code> component. It&#39;s a good idea to have as little state in your components as possible, and because the <code>Board</code> will already have some layout logic, I don&#39;t want to also burden it with managing the state.</p>\n<p>The good news is, it doesn&#39;t matter at this point. We&#39;re just going to write the components as if the state existed <em>somewhere</em>, and make sure that they render correctly when they receive it via props, and think about managing the state afterwards!</p>\n<h2>Creating the Components<a id=\"creating-the-components\">&nbsp;</a></h2><p>I prefer to start bottom-up, because this way I&#39;m always working with something that already exists. If I were to build the <code>Board</code> first, I wouldn&#39;t see my results until I&#39;m done with the <code>Square</code>. On the other hand, I can build and see the <code>Square</code> right away without even thinking of the <code>Board</code>. I think that the immediate feedback loop is important (you can tell that by <a href=\"https://pljenkins.github.io/react-hot-loader\">another project I work on</a>).</p>\n<p>In fact I&#39;m going to start with the <code>Knight</code>. It doesn&#39;t have any props at all, and it the easiest one to build:</p>\n<hr/>\n<code class=\"codeBlock\"><span class=\"token keyword\" >var</span> <span class=\"token qualifier\" >React</span> <span class=\"token operator\" >=</span> <span class=\"token function\" >require<span class=\"token punctuation\" >(</span></span><span class=\"token string\" >'react'</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n\n<span class=\"token keyword\" >var</span> <span class=\"token qualifier\" >Knight</span> <span class=\"token operator\" >=</span> <span class=\"token qualifier\" >React</span><span class=\"token punctuation\" >.</span><span class=\"token function\" >createClass<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >{</span>\n  render<span class=\"token punctuation\" >:</span> <span class=\"token block-keyword\" >function</span> <span class=\"token punctuation\" >(</span><span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n    <span class=\"token keyword\" >return</span> <span class=\"token operator\" >&lt;</span>span<span class=\"token operator\" >></span>♘<span class=\"token operator\" >&lt;</span><span class=\"token operator\" >/</span>span<span class=\"token operator\" >></span><span class=\"token punctuation\" >;</span>\n  <span class=\"token punctuation\" >}</span>\n<span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n\nmodule<span class=\"token punctuation\" >.</span>exports <span class=\"token operator\" >=</span> <span class=\"token qualifier\" >Knight</span><span class=\"token punctuation\" >;</span></code><hr/>\n<code class=\"codeBlock\"><span class=\"token keyword\" >import</span> <span class=\"token qualifier\" >React</span> from <span class=\"token string\" >'react'</span><span class=\"token punctuation\" >;</span>\n\n<span class=\"token keyword\" >export</span> <span class=\"token keyword\" >default</span> <span class=\"token keyword\" >class</span> <span class=\"token class-name\" >Knight</span> <span class=\"token punctuation\" >{</span>\n  <span class=\"token function\" >render<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n    <span class=\"token keyword\" >return</span> <span class=\"token operator\" >&lt;</span>span<span class=\"token operator\" >></span>♘<span class=\"token operator\" >&lt;</span><span class=\"token operator\" >/</span>span<span class=\"token operator\" >></span><span class=\"token punctuation\" >;</span>\n  <span class=\"token punctuation\" >}</span>\n<span class=\"token punctuation\" >}</span></code><hr/>\n<hr/>\n<p>Yes, ♘ is the Unicode knight! It&#39;s gorgeous. We could&#39;ve made its color a prop, but in our example we&#39;re not going to have any black knights, so there is no need for that.</p>\n<p>It seems to render fine, but just to be sure, I immediately changed my entry point to test it:</p>\n<hr/>\n<code class=\"codeBlock\"><span class=\"token keyword\" >var</span> <span class=\"token qualifier\" >React</span> <span class=\"token operator\" >=</span> <span class=\"token function\" >require<span class=\"token punctuation\" >(</span></span><span class=\"token string\" >'react'</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n<span class=\"token keyword\" >var</span> <span class=\"token qualifier\" >Knight</span> <span class=\"token operator\" >=</span> <span class=\"token function\" >require<span class=\"token punctuation\" >(</span></span><span class=\"token string\" >'./Knight'</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n\n<span class=\"token qualifier\" >React</span><span class=\"token punctuation\" >.</span><span class=\"token function\" >render<span class=\"token punctuation\" >(</span></span><span class=\"token operator\" >&lt;</span><span class=\"token qualifier\" >Knight</span> <span class=\"token operator\" >/</span><span class=\"token operator\" >></span><span class=\"token punctuation\" >,</span> document<span class=\"token punctuation\" >.</span><span class=\"token function\" >getElementById<span class=\"token punctuation\" >(</span></span><span class=\"token string\" >'root'</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span></code><hr/>\n<code class=\"codeBlock\"><span class=\"token keyword\" >import</span> <span class=\"token qualifier\" >React</span> from <span class=\"token string\" >'react'</span><span class=\"token punctuation\" >;</span>\n<span class=\"token keyword\" >import</span> <span class=\"token qualifier\" >Knight</span> from <span class=\"token string\" >'./Knight'</span><span class=\"token punctuation\" >;</span>\n\n<span class=\"token qualifier\" >React</span><span class=\"token punctuation\" >.</span><span class=\"token function\" >render<span class=\"token punctuation\" >(</span></span><span class=\"token operator\" >&lt;</span><span class=\"token qualifier\" >Knight</span> <span class=\"token operator\" >/</span><span class=\"token operator\" >></span><span class=\"token punctuation\" >,</span> document<span class=\"token punctuation\" >.</span><span class=\"token function\" >getElementById<span class=\"token punctuation\" >(</span></span><span class=\"token string\" >'root'</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span></code><hr/>\n<hr/>\n<p><img src='http://i.imgur.com/NktjTMn.png' width='512' height='384' alt='Screenshot'></p>\n<p>I&#39;m going to do this every time I work on another component, so that I always have something to render. In a larger app, I would use a component playground like <a href=\"https://github.com/skidding/cosmos\">cosmos</a> so I&#39;d never write the components in the dark.</p>\n<p>I see my <code>Knight</code> on the screen! Time to go ahead and implement the <code>Square</code> now. Here is my first stab:</p>\n<hr/>\n<code class=\"codeBlock\"><span class=\"token keyword\" >var</span> <span class=\"token qualifier\" >React</span> <span class=\"token operator\" >=</span> <span class=\"token function\" >require<span class=\"token punctuation\" >(</span></span><span class=\"token string\" >'react'</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n<span class=\"token keyword\" >var</span> <span class=\"token qualifier\" >Prop</span><span class=\"token qualifier\" >Types</span> <span class=\"token operator\" >=</span> <span class=\"token qualifier\" >React</span><span class=\"token punctuation\" >.</span><span class=\"token qualifier\" >Prop</span><span class=\"token qualifier\" >Types</span><span class=\"token punctuation\" >;</span>\n\n<span class=\"token keyword\" >var</span> <span class=\"token qualifier\" >Square</span> <span class=\"token operator\" >=</span> <span class=\"token qualifier\" >React</span><span class=\"token punctuation\" >.</span><span class=\"token function\" >createClass<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >{</span>\n  propTypes <span class=\"token operator\" >=</span> <span class=\"token punctuation\" >{</span>\n    black<span class=\"token punctuation\" >:</span> <span class=\"token qualifier\" >Prop</span><span class=\"token qualifier\" >Types</span><span class=\"token punctuation\" >.</span>bool\n  <span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >,</span>\n\n  render<span class=\"token punctuation\" >:</span> <span class=\"token block-keyword\" >function</span> <span class=\"token punctuation\" >(</span><span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n    <span class=\"token keyword\" >var</span> black <span class=\"token operator\" >=</span> <span class=\"token var\" >this</span><span class=\"token punctuation\" >.</span>props<span class=\"token punctuation\" >.</span>black<span class=\"token punctuation\" >;</span>\n    <span class=\"token keyword\" >var</span> fill <span class=\"token operator\" >=</span> black <span class=\"token operator\" >?</span> <span class=\"token string\" >'black'</span> <span class=\"token punctuation\" >:</span> <span class=\"token string\" >'white'</span><span class=\"token punctuation\" >;</span>\n\n    <span class=\"token keyword\" >return</span> <span class=\"token operator\" >&lt;</span>div style<span class=\"token operator\" >=</span><span class=\"token punctuation\" >{</span><span class=\"token punctuation\" >{</span> backgroundColor<span class=\"token punctuation\" >:</span> fill <span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >}</span> <span class=\"token operator\" >/</span><span class=\"token operator\" >></span><span class=\"token punctuation\" >;</span>\n  <span class=\"token punctuation\" >}</span>\n<span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n\nmodule<span class=\"token punctuation\" >.</span>exports <span class=\"token operator\" >=</span> <span class=\"token qualifier\" >Square</span><span class=\"token punctuation\" >;</span></code><hr/>\n<code class=\"codeBlock\"><span class=\"token keyword\" >import</span> <span class=\"token qualifier\" >React</span><span class=\"token punctuation\" >,</span> <span class=\"token punctuation\" >{</span> <span class=\"token qualifier\" >Prop</span><span class=\"token qualifier\" >Types</span> <span class=\"token punctuation\" >}</span> from <span class=\"token string\" >'react'</span><span class=\"token punctuation\" >;</span>\n\n<span class=\"token keyword\" >export</span> <span class=\"token keyword\" >default</span> <span class=\"token keyword\" >class</span> <span class=\"token class-name\" >Square</span> <span class=\"token punctuation\" >{</span>\n  <span class=\"token function\" >render<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n    <span class=\"token keyword\" >const</span> <span class=\"token punctuation\" >{</span> black <span class=\"token punctuation\" >}</span> <span class=\"token operator\" >=</span> <span class=\"token var\" >this</span><span class=\"token punctuation\" >.</span>props<span class=\"token punctuation\" >;</span>\n    <span class=\"token keyword\" >const</span> fill <span class=\"token operator\" >=</span> black <span class=\"token operator\" >?</span> <span class=\"token string\" >'black'</span> <span class=\"token punctuation\" >:</span> <span class=\"token string\" >'white'</span><span class=\"token punctuation\" >;</span>\n\n    <span class=\"token keyword\" >return</span> <span class=\"token operator\" >&lt;</span>div style<span class=\"token operator\" >=</span><span class=\"token punctuation\" >{</span><span class=\"token punctuation\" >{</span> backgroundColor<span class=\"token punctuation\" >:</span> fill <span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >}</span> <span class=\"token operator\" >/</span><span class=\"token operator\" >></span><span class=\"token punctuation\" >;</span>\n  <span class=\"token punctuation\" >}</span>\n<span class=\"token punctuation\" >}</span>\n\n<span class=\"token qualifier\" >Square</span><span class=\"token punctuation\" >.</span>propTypes <span class=\"token operator\" >=</span> <span class=\"token punctuation\" >{</span>\n  black<span class=\"token punctuation\" >:</span> <span class=\"token qualifier\" >Prop</span><span class=\"token qualifier\" >Types</span><span class=\"token punctuation\" >.</span>bool\n<span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >;</span></code><hr/>\n<code class=\"codeBlock\"><span class=\"token keyword\" >import</span> <span class=\"token qualifier\" >React</span><span class=\"token punctuation\" >,</span> <span class=\"token punctuation\" >{</span> <span class=\"token qualifier\" >Prop</span><span class=\"token qualifier\" >Types</span> <span class=\"token punctuation\" >}</span> from <span class=\"token string\" >'react'</span><span class=\"token punctuation\" >;</span>\n\n<span class=\"token keyword\" >export</span> <span class=\"token keyword\" >default</span> <span class=\"token keyword\" >class</span> <span class=\"token class-name\" >Square</span> <span class=\"token punctuation\" >{</span>\n  <span class=\"token keyword\" >static</span> propTypes <span class=\"token operator\" >=</span> <span class=\"token punctuation\" >{</span>\n    black<span class=\"token punctuation\" >:</span> <span class=\"token qualifier\" >Prop</span><span class=\"token qualifier\" >Types</span><span class=\"token punctuation\" >.</span>bool\n  <span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >;</span>\n\n  <span class=\"token function\" >render<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n    <span class=\"token keyword\" >const</span> <span class=\"token punctuation\" >{</span> black <span class=\"token punctuation\" >}</span> <span class=\"token operator\" >=</span> <span class=\"token var\" >this</span><span class=\"token punctuation\" >.</span>props<span class=\"token punctuation\" >;</span>\n    <span class=\"token keyword\" >const</span> fill <span class=\"token operator\" >=</span> black <span class=\"token operator\" >?</span> <span class=\"token string\" >'black'</span> <span class=\"token punctuation\" >:</span> <span class=\"token string\" >'white'</span><span class=\"token punctuation\" >;</span>\n\n    <span class=\"token keyword\" >return</span> <span class=\"token operator\" >&lt;</span>div style<span class=\"token operator\" >=</span><span class=\"token punctuation\" >{</span><span class=\"token punctuation\" >{</span> backgroundColor<span class=\"token punctuation\" >:</span> fill <span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >}</span> <span class=\"token operator\" >/</span><span class=\"token operator\" >></span><span class=\"token punctuation\" >;</span>\n  <span class=\"token punctuation\" >}</span>\n<span class=\"token punctuation\" >}</span></code><hr/>\n<p>Now I change the entry point code to see how the <code>Knight</code> looks inside a <code>Square</code>:</p>\n<hr/>\n<code class=\"codeBlock\"><span class=\"token keyword\" >var</span> <span class=\"token qualifier\" >React</span> <span class=\"token operator\" >=</span> <span class=\"token function\" >require<span class=\"token punctuation\" >(</span></span><span class=\"token string\" >'react'</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n<span class=\"token keyword\" >var</span> <span class=\"token qualifier\" >Knight</span> <span class=\"token operator\" >=</span> <span class=\"token function\" >require<span class=\"token punctuation\" >(</span></span><span class=\"token string\" >'./Knight'</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n<span class=\"token keyword\" >var</span> <span class=\"token qualifier\" >Square</span> <span class=\"token operator\" >=</span> <span class=\"token function\" >require<span class=\"token punctuation\" >(</span></span><span class=\"token string\" >'./Square'</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n\n<span class=\"token qualifier\" >React</span><span class=\"token punctuation\" >.</span><span class=\"token function\" >render<span class=\"token punctuation\" >(</span></span>\n  <span class=\"token operator\" >&lt;</span><span class=\"token qualifier\" >Square</span> black<span class=\"token operator\" >></span>\n    <span class=\"token operator\" >&lt;</span><span class=\"token qualifier\" >Knight</span> <span class=\"token operator\" >/</span><span class=\"token operator\" >></span>\n  <span class=\"token operator\" >&lt;</span><span class=\"token operator\" >/</span><span class=\"token qualifier\" >Square</span><span class=\"token operator\" >></span><span class=\"token punctuation\" >,</span>\n  document<span class=\"token punctuation\" >.</span><span class=\"token function\" >getElementById<span class=\"token punctuation\" >(</span></span><span class=\"token string\" >'root'</span><span class=\"token punctuation\" >)</span>\n<span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span></code><hr/>\n<code class=\"codeBlock\"><span class=\"token keyword\" >import</span> <span class=\"token qualifier\" >React</span> from <span class=\"token string\" >'react'</span><span class=\"token punctuation\" >;</span>\n<span class=\"token keyword\" >import</span> <span class=\"token qualifier\" >Knight</span> from <span class=\"token string\" >'./Knight'</span><span class=\"token punctuation\" >;</span>\n<span class=\"token keyword\" >import</span> <span class=\"token qualifier\" >Square</span> from <span class=\"token string\" >'./Square'</span><span class=\"token punctuation\" >;</span>\n\n<span class=\"token qualifier\" >React</span><span class=\"token punctuation\" >.</span><span class=\"token function\" >render<span class=\"token punctuation\" >(</span></span>\n  <span class=\"token operator\" >&lt;</span><span class=\"token qualifier\" >Square</span> black<span class=\"token operator\" >></span>\n    <span class=\"token operator\" >&lt;</span><span class=\"token qualifier\" >Knight</span> <span class=\"token operator\" >/</span><span class=\"token operator\" >></span>\n  <span class=\"token operator\" >&lt;</span><span class=\"token operator\" >/</span><span class=\"token qualifier\" >Square</span><span class=\"token operator\" >></span><span class=\"token punctuation\" >,</span>\n  document<span class=\"token punctuation\" >.</span><span class=\"token function\" >getElementById<span class=\"token punctuation\" >(</span></span><span class=\"token string\" >'root'</span><span class=\"token punctuation\" >)</span>\n<span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span></code><hr/>\n<hr/>\n<p>Sadly, the screen is empty. I made a few mistakes:</p>\n<ul>\n<li><p>I forgot to give <code>Square</code> any dimensions so it just collapses. I don&#39;t want it to have any fixed size, so I&#39;ll give it <code>width: &#39;100%&#39;</code> and <code>height: &#39;100%&#39;</code> to fill the container.</p>\n</li>\n<li><p>I forgot to put <code>{this.props.children}</code> inside the <code>div</code> returned by the <code>Square</code>, so it ignores the <code>Knight</code> passed to it.</p>\n</li>\n</ul>\n<p>Even after correcting these two mistakes, I still can&#39;t see my <code>Knight</code> when the <code>Square</code> is <code>black</code>. That&#39;s because the default page body text color is black, so it is not visible on the black <code>Square</code>. I could have fixed this by giving <code>Knight</code> a color prop, but a much simpler fix is to set a corresponding <code>color</code> style in the same place where I set <code>backgroundColor</code>. This version of <code>Square</code> corrects the mistakes and works equally great with both colors:</p>\n<hr/>\n<code class=\"codeBlock\"><span class=\"token keyword\" >var</span> <span class=\"token qualifier\" >React</span> <span class=\"token operator\" >=</span> <span class=\"token function\" >require<span class=\"token punctuation\" >(</span></span><span class=\"token string\" >'react'</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n<span class=\"token keyword\" >var</span> <span class=\"token qualifier\" >Prop</span><span class=\"token qualifier\" >Types</span> <span class=\"token operator\" >=</span> <span class=\"token qualifier\" >React</span><span class=\"token punctuation\" >.</span><span class=\"token qualifier\" >Prop</span><span class=\"token qualifier\" >Types</span><span class=\"token punctuation\" >;</span>\n\n<span class=\"token keyword\" >var</span> <span class=\"token qualifier\" >Square</span> <span class=\"token operator\" >=</span> <span class=\"token qualifier\" >React</span><span class=\"token punctuation\" >.</span><span class=\"token function\" >createClass<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >{</span>\n  propTypes<span class=\"token punctuation\" >:</span> <span class=\"token punctuation\" >{</span>\n    black<span class=\"token punctuation\" >:</span> <span class=\"token qualifier\" >Prop</span><span class=\"token qualifier\" >Types</span><span class=\"token punctuation\" >.</span>bool\n  <span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >,</span>\n\n  render<span class=\"token punctuation\" >:</span> <span class=\"token block-keyword\" >function</span> <span class=\"token punctuation\" >(</span><span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n    <span class=\"token keyword\" >var</span> black <span class=\"token operator\" >=</span> <span class=\"token var\" >this</span><span class=\"token punctuation\" >.</span>props<span class=\"token punctuation\" >.</span>black<span class=\"token punctuation\" >;</span>\n    <span class=\"token keyword\" >var</span> fill <span class=\"token operator\" >=</span> black <span class=\"token operator\" >?</span> <span class=\"token string\" >'black'</span> <span class=\"token punctuation\" >:</span> <span class=\"token string\" >'white'</span><span class=\"token punctuation\" >;</span>\n    <span class=\"token keyword\" >var</span> stroke <span class=\"token operator\" >=</span> black <span class=\"token operator\" >?</span> <span class=\"token string\" >'white'</span> <span class=\"token punctuation\" >:</span> <span class=\"token string\" >'black'</span><span class=\"token punctuation\" >;</span>\n\n    <span class=\"token keyword\" >return</span> <span class=\"token punctuation\" >(</span>\n      <span class=\"token operator\" >&lt;</span>div style<span class=\"token operator\" >=</span><span class=\"token punctuation\" >{</span><span class=\"token punctuation\" >{</span>\n        backgroundColor<span class=\"token punctuation\" >:</span> fill<span class=\"token punctuation\" >,</span>\n        color<span class=\"token punctuation\" >:</span> stroke<span class=\"token punctuation\" >,</span>\n        width<span class=\"token punctuation\" >:</span> <span class=\"token string\" >'100%'</span><span class=\"token punctuation\" >,</span>\n        height<span class=\"token punctuation\" >:</span> <span class=\"token string\" >'100%'</span>\n      <span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >}</span><span class=\"token operator\" >></span>\n        <span class=\"token punctuation\" >{</span><span class=\"token var\" >this</span><span class=\"token punctuation\" >.</span>props<span class=\"token punctuation\" >.</span>children<span class=\"token punctuation\" >}</span>\n      <span class=\"token operator\" >&lt;</span><span class=\"token operator\" >/</span>div<span class=\"token operator\" >></span>\n    <span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n  <span class=\"token punctuation\" >}</span>\n<span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n\nmodule<span class=\"token punctuation\" >.</span>exports <span class=\"token operator\" >=</span> <span class=\"token qualifier\" >Square</span><span class=\"token punctuation\" >;</span></code><hr/>\n<code class=\"codeBlock\"><span class=\"token keyword\" >import</span> <span class=\"token qualifier\" >React</span><span class=\"token punctuation\" >,</span> <span class=\"token punctuation\" >{</span> <span class=\"token qualifier\" >Prop</span><span class=\"token qualifier\" >Types</span> <span class=\"token punctuation\" >}</span> from <span class=\"token string\" >'react'</span><span class=\"token punctuation\" >;</span>\n\n<span class=\"token keyword\" >export</span> <span class=\"token keyword\" >default</span> <span class=\"token keyword\" >class</span> <span class=\"token class-name\" >Square</span> <span class=\"token punctuation\" >{</span>\n  <span class=\"token function\" >render<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n    <span class=\"token keyword\" >const</span> <span class=\"token punctuation\" >{</span> black <span class=\"token punctuation\" >}</span> <span class=\"token operator\" >=</span> <span class=\"token var\" >this</span><span class=\"token punctuation\" >.</span>props<span class=\"token punctuation\" >;</span>\n    <span class=\"token keyword\" >const</span> fill <span class=\"token operator\" >=</span> black <span class=\"token operator\" >?</span> <span class=\"token string\" >'black'</span> <span class=\"token punctuation\" >:</span> <span class=\"token string\" >'white'</span><span class=\"token punctuation\" >;</span>\n    <span class=\"token keyword\" >const</span> stroke <span class=\"token operator\" >=</span> black <span class=\"token operator\" >?</span> <span class=\"token string\" >'white'</span> <span class=\"token punctuation\" >:</span> <span class=\"token string\" >'black'</span><span class=\"token punctuation\" >;</span>\n\n    <span class=\"token keyword\" >return</span> <span class=\"token punctuation\" >(</span>\n      <span class=\"token operator\" >&lt;</span>div style<span class=\"token operator\" >=</span><span class=\"token punctuation\" >{</span><span class=\"token punctuation\" >{</span>\n        backgroundColor<span class=\"token punctuation\" >:</span> fill<span class=\"token punctuation\" >,</span>\n        color<span class=\"token punctuation\" >:</span> stroke<span class=\"token punctuation\" >,</span>\n        width<span class=\"token punctuation\" >:</span> <span class=\"token string\" >'100%'</span><span class=\"token punctuation\" >,</span>\n        height<span class=\"token punctuation\" >:</span> <span class=\"token string\" >'100%'</span>\n      <span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >}</span><span class=\"token operator\" >></span>\n        <span class=\"token punctuation\" >{</span><span class=\"token var\" >this</span><span class=\"token punctuation\" >.</span>props<span class=\"token punctuation\" >.</span>children<span class=\"token punctuation\" >}</span>\n      <span class=\"token operator\" >&lt;</span><span class=\"token operator\" >/</span>div<span class=\"token operator\" >></span>\n    <span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n  <span class=\"token punctuation\" >}</span>\n<span class=\"token punctuation\" >}</span>\n\n<span class=\"token qualifier\" >Square</span><span class=\"token punctuation\" >.</span>propTypes <span class=\"token operator\" >=</span> <span class=\"token punctuation\" >{</span>\n  black<span class=\"token punctuation\" >:</span> <span class=\"token qualifier\" >Prop</span><span class=\"token qualifier\" >Types</span><span class=\"token punctuation\" >.</span>bool\n<span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >;</span></code><hr/>\n<code class=\"codeBlock\"><span class=\"token keyword\" >import</span> <span class=\"token qualifier\" >React</span><span class=\"token punctuation\" >,</span> <span class=\"token punctuation\" >{</span> <span class=\"token qualifier\" >Prop</span><span class=\"token qualifier\" >Types</span> <span class=\"token punctuation\" >}</span> from <span class=\"token string\" >'react'</span><span class=\"token punctuation\" >;</span>\n\n<span class=\"token keyword\" >export</span> <span class=\"token keyword\" >default</span> <span class=\"token keyword\" >class</span> <span class=\"token class-name\" >Square</span> <span class=\"token punctuation\" >{</span>\n  <span class=\"token keyword\" >static</span> propTypes <span class=\"token operator\" >=</span> <span class=\"token punctuation\" >{</span>\n    black<span class=\"token punctuation\" >:</span> <span class=\"token qualifier\" >Prop</span><span class=\"token qualifier\" >Types</span><span class=\"token punctuation\" >.</span>bool\n  <span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >;</span>\n\n  <span class=\"token function\" >render<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n    <span class=\"token keyword\" >const</span> <span class=\"token punctuation\" >{</span> black <span class=\"token punctuation\" >}</span> <span class=\"token operator\" >=</span> <span class=\"token var\" >this</span><span class=\"token punctuation\" >.</span>props<span class=\"token punctuation\" >;</span>\n    <span class=\"token keyword\" >const</span> fill <span class=\"token operator\" >=</span> black <span class=\"token operator\" >?</span> <span class=\"token string\" >'black'</span> <span class=\"token punctuation\" >:</span> <span class=\"token string\" >'white'</span><span class=\"token punctuation\" >;</span>\n    <span class=\"token keyword\" >const</span> stroke <span class=\"token operator\" >=</span> black <span class=\"token operator\" >?</span> <span class=\"token string\" >'white'</span> <span class=\"token punctuation\" >:</span> <span class=\"token string\" >'black'</span><span class=\"token punctuation\" >;</span>\n\n    <span class=\"token keyword\" >return</span> <span class=\"token punctuation\" >(</span>\n      <span class=\"token operator\" >&lt;</span>div style<span class=\"token operator\" >=</span><span class=\"token punctuation\" >{</span><span class=\"token punctuation\" >{</span>\n        backgroundColor<span class=\"token punctuation\" >:</span> fill<span class=\"token punctuation\" >,</span>\n        color<span class=\"token punctuation\" >:</span> stroke<span class=\"token punctuation\" >,</span>\n        width<span class=\"token punctuation\" >:</span> <span class=\"token string\" >'100%'</span><span class=\"token punctuation\" >,</span>\n        height<span class=\"token punctuation\" >:</span> <span class=\"token string\" >'100%'</span>\n      <span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >}</span><span class=\"token operator\" >></span>\n        <span class=\"token punctuation\" >{</span><span class=\"token var\" >this</span><span class=\"token punctuation\" >.</span>props<span class=\"token punctuation\" >.</span>children<span class=\"token punctuation\" >}</span>\n      <span class=\"token operator\" >&lt;</span><span class=\"token operator\" >/</span>div<span class=\"token operator\" >></span>\n    <span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n  <span class=\"token punctuation\" >}</span>\n<span class=\"token punctuation\" >}</span></code><hr/>\n<p><img src='http://i.imgur.com/jvgv6DV.png' width='512' height='384' alt='Screenshot'></p>\n<p>Finally, time to get started with the <code>Board</code>! I&#39;m going to start with an extremely naïve version that just draws the same single square:</p>\n<hr/>\n<code class=\"codeBlock\"><span class=\"token keyword\" >var</span> <span class=\"token qualifier\" >React</span> <span class=\"token operator\" >=</span> <span class=\"token function\" >require<span class=\"token punctuation\" >(</span></span><span class=\"token string\" >'react'</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n<span class=\"token keyword\" >var</span> <span class=\"token qualifier\" >Prop</span><span class=\"token qualifier\" >Types</span> <span class=\"token operator\" >=</span> <span class=\"token qualifier\" >React</span><span class=\"token punctuation\" >.</span><span class=\"token qualifier\" >Prop</span><span class=\"token qualifier\" >Types</span><span class=\"token punctuation\" >;</span>\n<span class=\"token keyword\" >var</span> <span class=\"token qualifier\" >Square</span> <span class=\"token operator\" >=</span> <span class=\"token function\" >require<span class=\"token punctuation\" >(</span></span><span class=\"token string\" >'./Square'</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n<span class=\"token keyword\" >var</span> <span class=\"token qualifier\" >Knight</span> <span class=\"token operator\" >=</span> <span class=\"token function\" >require<span class=\"token punctuation\" >(</span></span><span class=\"token string\" >'./Knight'</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n\n<span class=\"token keyword\" >var</span> <span class=\"token qualifier\" >Board</span> <span class=\"token operator\" >=</span> <span class=\"token qualifier\" >React</span><span class=\"token punctuation\" >.</span><span class=\"token function\" >createClass<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >{</span>\n  propTypes<span class=\"token punctuation\" >:</span> <span class=\"token punctuation\" >{</span>\n    knightPosition<span class=\"token punctuation\" >:</span> <span class=\"token qualifier\" >Prop</span><span class=\"token qualifier\" >Types</span><span class=\"token punctuation\" >.</span><span class=\"token function\" >arrayOf<span class=\"token punctuation\" >(</span></span>\n      <span class=\"token qualifier\" >Prop</span><span class=\"token qualifier\" >Types</span><span class=\"token punctuation\" >.</span>number<span class=\"token punctuation\" >.</span>isRequired\n    <span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >.</span>isRequired\n  <span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >,</span>\n\n  render<span class=\"token punctuation\" >:</span> <span class=\"token block-keyword\" >function</span> <span class=\"token punctuation\" >(</span><span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n    <span class=\"token keyword\" >return</span> <span class=\"token punctuation\" >(</span>\n      <span class=\"token operator\" >&lt;</span>div<span class=\"token operator\" >></span>\n        <span class=\"token operator\" >&lt;</span><span class=\"token qualifier\" >Square</span> black<span class=\"token operator\" >></span>\n          <span class=\"token operator\" >&lt;</span><span class=\"token qualifier\" >Knight</span> <span class=\"token operator\" >/</span><span class=\"token operator\" >></span>\n        <span class=\"token operator\" >&lt;</span><span class=\"token operator\" >/</span><span class=\"token qualifier\" >Square</span><span class=\"token operator\" >></span>\n      <span class=\"token operator\" >&lt;</span><span class=\"token operator\" >/</span>div<span class=\"token operator\" >></span>\n    <span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n  <span class=\"token punctuation\" >}</span>\n<span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n\nmodule<span class=\"token punctuation\" >.</span>exports <span class=\"token operator\" >=</span> <span class=\"token qualifier\" >Board</span><span class=\"token punctuation\" >;</span></code><hr/>\n<code class=\"codeBlock\"><span class=\"token keyword\" >import</span> <span class=\"token qualifier\" >React</span><span class=\"token punctuation\" >,</span> <span class=\"token punctuation\" >{</span> <span class=\"token qualifier\" >Prop</span><span class=\"token qualifier\" >Types</span> <span class=\"token punctuation\" >}</span> from <span class=\"token string\" >'react'</span><span class=\"token punctuation\" >;</span>\n<span class=\"token keyword\" >import</span> <span class=\"token qualifier\" >Square</span> from <span class=\"token string\" >'./Square'</span><span class=\"token punctuation\" >;</span>\n<span class=\"token keyword\" >import</span> <span class=\"token qualifier\" >Knight</span> from <span class=\"token string\" >'./Knight'</span><span class=\"token punctuation\" >;</span>\n\n<span class=\"token keyword\" >export</span> <span class=\"token keyword\" >default</span> <span class=\"token keyword\" >class</span> <span class=\"token class-name\" >Board</span> <span class=\"token punctuation\" >{</span>\n  <span class=\"token function\" >render<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n    <span class=\"token keyword\" >return</span> <span class=\"token punctuation\" >(</span>\n      <span class=\"token operator\" >&lt;</span>div<span class=\"token operator\" >></span>\n        <span class=\"token operator\" >&lt;</span><span class=\"token qualifier\" >Square</span> black<span class=\"token operator\" >></span>\n          <span class=\"token operator\" >&lt;</span><span class=\"token qualifier\" >Knight</span> <span class=\"token operator\" >/</span><span class=\"token operator\" >></span>\n        <span class=\"token operator\" >&lt;</span><span class=\"token operator\" >/</span><span class=\"token qualifier\" >Square</span><span class=\"token operator\" >></span>\n      <span class=\"token operator\" >&lt;</span><span class=\"token operator\" >/</span>div<span class=\"token operator\" >></span>\n    <span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n  <span class=\"token punctuation\" >}</span>\n<span class=\"token punctuation\" >}</span>\n\n<span class=\"token qualifier\" >Board</span><span class=\"token punctuation\" >.</span>propTypes <span class=\"token operator\" >=</span> <span class=\"token punctuation\" >{</span>\n  knightPosition<span class=\"token punctuation\" >:</span> <span class=\"token qualifier\" >Prop</span><span class=\"token qualifier\" >Types</span><span class=\"token punctuation\" >.</span><span class=\"token function\" >arrayOf<span class=\"token punctuation\" >(</span></span>\n    <span class=\"token qualifier\" >Prop</span><span class=\"token qualifier\" >Types</span><span class=\"token punctuation\" >.</span>number<span class=\"token punctuation\" >.</span>isRequired\n  <span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >.</span>isRequired\n<span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >;</span></code><hr/>\n<code class=\"codeBlock\"><span class=\"token keyword\" >import</span> <span class=\"token qualifier\" >React</span><span class=\"token punctuation\" >,</span> <span class=\"token punctuation\" >{</span> <span class=\"token qualifier\" >Prop</span><span class=\"token qualifier\" >Types</span> <span class=\"token punctuation\" >}</span> from <span class=\"token string\" >'react'</span><span class=\"token punctuation\" >;</span>\n<span class=\"token keyword\" >import</span> <span class=\"token qualifier\" >Square</span> from <span class=\"token string\" >'./Square'</span><span class=\"token punctuation\" >;</span>\n<span class=\"token keyword\" >import</span> <span class=\"token qualifier\" >Knight</span> from <span class=\"token string\" >'./Knight'</span><span class=\"token punctuation\" >;</span>\n\n<span class=\"token keyword\" >export</span> <span class=\"token keyword\" >default</span> <span class=\"token keyword\" >class</span> <span class=\"token class-name\" >Board</span> <span class=\"token punctuation\" >{</span>\n  <span class=\"token keyword\" >static</span> propTypes <span class=\"token operator\" >=</span> <span class=\"token punctuation\" >{</span>\n    knightPosition<span class=\"token punctuation\" >:</span> <span class=\"token qualifier\" >Prop</span><span class=\"token qualifier\" >Types</span><span class=\"token punctuation\" >.</span><span class=\"token function\" >arrayOf<span class=\"token punctuation\" >(</span></span>\n      <span class=\"token qualifier\" >Prop</span><span class=\"token qualifier\" >Types</span><span class=\"token punctuation\" >.</span>number<span class=\"token punctuation\" >.</span>isRequired\n    <span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >.</span>isRequired\n  <span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >;</span>\n\n  <span class=\"token function\" >render<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n    <span class=\"token keyword\" >return</span> <span class=\"token punctuation\" >(</span>\n      <span class=\"token operator\" >&lt;</span>div<span class=\"token operator\" >></span>\n        <span class=\"token operator\" >&lt;</span><span class=\"token qualifier\" >Square</span> black<span class=\"token operator\" >></span>\n          <span class=\"token operator\" >&lt;</span><span class=\"token qualifier\" >Knight</span> <span class=\"token operator\" >/</span><span class=\"token operator\" >></span>\n        <span class=\"token operator\" >&lt;</span><span class=\"token operator\" >/</span><span class=\"token qualifier\" >Square</span><span class=\"token operator\" >></span>\n      <span class=\"token operator\" >&lt;</span><span class=\"token operator\" >/</span>div<span class=\"token operator\" >></span>\n    <span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n  <span class=\"token punctuation\" >}</span>\n<span class=\"token punctuation\" >}</span></code><hr/>\n<p>My only intention so far is to make it render, so that I can start tweaking it:</p>\n<hr/>\n<code class=\"codeBlock\"><span class=\"token keyword\" >var</span> <span class=\"token qualifier\" >React</span> <span class=\"token operator\" >=</span> <span class=\"token function\" >require<span class=\"token punctuation\" >(</span></span><span class=\"token string\" >'react'</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n<span class=\"token keyword\" >var</span> <span class=\"token qualifier\" >Board</span> <span class=\"token operator\" >=</span> <span class=\"token function\" >require<span class=\"token punctuation\" >(</span></span><span class=\"token string\" >'./Board'</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n\n<span class=\"token qualifier\" >React</span><span class=\"token punctuation\" >.</span><span class=\"token function\" >render<span class=\"token punctuation\" >(</span></span>\n  <span class=\"token operator\" >&lt;</span><span class=\"token qualifier\" >Board</span> knightPosition<span class=\"token operator\" >=</span><span class=\"token punctuation\" >{</span><span class=\"token punctuation\" >[</span><span class=\"token number\" >0</span><span class=\"token punctuation\" >,</span> <span class=\"token number\" >0</span><span class=\"token punctuation\" >]</span><span class=\"token punctuation\" >}</span> <span class=\"token operator\" >/</span><span class=\"token operator\" >></span><span class=\"token punctuation\" >,</span>\n  document<span class=\"token punctuation\" >.</span><span class=\"token function\" >getElementById<span class=\"token punctuation\" >(</span></span><span class=\"token string\" >'root'</span><span class=\"token punctuation\" >)</span>\n<span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span></code><hr/>\n<code class=\"codeBlock\"><span class=\"token keyword\" >import</span> <span class=\"token qualifier\" >React</span> from <span class=\"token string\" >'react'</span><span class=\"token punctuation\" >;</span>\n<span class=\"token keyword\" >import</span> <span class=\"token qualifier\" >Board</span> from <span class=\"token string\" >'./Board'</span><span class=\"token punctuation\" >;</span>\n\n<span class=\"token qualifier\" >React</span><span class=\"token punctuation\" >.</span><span class=\"token function\" >render<span class=\"token punctuation\" >(</span></span>\n  <span class=\"token operator\" >&lt;</span><span class=\"token qualifier\" >Board</span> knightPosition<span class=\"token operator\" >=</span><span class=\"token punctuation\" >{</span><span class=\"token punctuation\" >[</span><span class=\"token number\" >0</span><span class=\"token punctuation\" >,</span> <span class=\"token number\" >0</span><span class=\"token punctuation\" >]</span><span class=\"token punctuation\" >}</span> <span class=\"token operator\" >/</span><span class=\"token operator\" >></span><span class=\"token punctuation\" >,</span>\n  document<span class=\"token punctuation\" >.</span><span class=\"token function\" >getElementById<span class=\"token punctuation\" >(</span></span><span class=\"token string\" >'root'</span><span class=\"token punctuation\" >)</span>\n<span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span></code><hr/>\n<hr/>\n<p>Indeed, I can see the same single square. I&#39;m now going to add a whole bunch of them! But I don&#39;t know where to start. What do I put in <code>render</code>? Some kind of a <code>for</code> loop? A <code>map</code> over some array?</p>\n<p>To be honest, I don&#39;t want to think about it now. I already know how to render a single square with or without a knight. I also know the knight&#39;s position thanks to the <code>knightPosition</code> prop. This means I can write the <code>renderSquare</code> method and not worry about rendering the whole board just yet.</p>\n<p>My first attempt at <code>renderSquare</code> looks like this:</p>\n<hr/>\n<code class=\"codeBlock\">renderSquare<span class=\"token punctuation\" >:</span> <span class=\"token block-keyword\" >function</span> <span class=\"token punctuation\" >(</span>x<span class=\"token punctuation\" >,</span> y<span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n  <span class=\"token keyword\" >var</span> black <span class=\"token operator\" >=</span> <span class=\"token punctuation\" >(</span>x <span class=\"token operator\" >+</span> y<span class=\"token punctuation\" >)</span> <span class=\"token operator\" >%</span> <span class=\"token number\" >2</span> <span class=\"token operator\" >===</span> <span class=\"token number\" >1</span><span class=\"token punctuation\" >;</span>\n\n  <span class=\"token keyword\" >var</span> knightX <span class=\"token operator\" >=</span> <span class=\"token var\" >this</span><span class=\"token punctuation\" >.</span>props<span class=\"token punctuation\" >.</span>knightPosition<span class=\"token punctuation\" >[</span><span class=\"token number\" >0</span><span class=\"token punctuation\" >]</span><span class=\"token punctuation\" >;</span>\n  <span class=\"token keyword\" >var</span> knightY <span class=\"token operator\" >=</span> <span class=\"token var\" >this</span><span class=\"token punctuation\" >.</span>props<span class=\"token punctuation\" >.</span>knightPosition<span class=\"token punctuation\" >[</span><span class=\"token number\" >1</span><span class=\"token punctuation\" >]</span><span class=\"token punctuation\" >;</span>\n  <span class=\"token keyword\" >var</span> piece <span class=\"token operator\" >=</span> <span class=\"token punctuation\" >(</span>x <span class=\"token operator\" >===</span> knightX <span class=\"token operator\" >&amp;&amp;</span> y <span class=\"token operator\" >===</span> knightY<span class=\"token punctuation\" >)</span> <span class=\"token operator\" >?</span>\n    <span class=\"token operator\" >&lt;</span><span class=\"token qualifier\" >Knight</span> <span class=\"token operator\" >/</span><span class=\"token operator\" >></span> <span class=\"token punctuation\" >:</span>\n    <span class=\"token primitive\" >null</span><span class=\"token punctuation\" >;</span>\n\n  <span class=\"token keyword\" >return</span> <span class=\"token punctuation\" >(</span>\n    <span class=\"token operator\" >&lt;</span><span class=\"token qualifier\" >Square</span> black<span class=\"token operator\" >=</span><span class=\"token punctuation\" >{</span>black<span class=\"token punctuation\" >}</span><span class=\"token operator\" >></span>\n      <span class=\"token punctuation\" >{</span>piece<span class=\"token punctuation\" >}</span>\n    <span class=\"token operator\" >&lt;</span><span class=\"token operator\" >/</span><span class=\"token qualifier\" >Square</span><span class=\"token operator\" >></span>\n  <span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n<span class=\"token punctuation\" >}</span></code><hr/>\n<code class=\"codeBlock\"><span class=\"token function\" >renderSquare<span class=\"token punctuation\" >(</span></span>x<span class=\"token punctuation\" >,</span> y<span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n  <span class=\"token keyword\" >const</span> black <span class=\"token operator\" >=</span> <span class=\"token punctuation\" >(</span>x <span class=\"token operator\" >+</span> y<span class=\"token punctuation\" >)</span> <span class=\"token operator\" >%</span> <span class=\"token number\" >2</span> <span class=\"token operator\" >===</span> <span class=\"token number\" >1</span><span class=\"token punctuation\" >;</span>\n\n  <span class=\"token keyword\" >const</span> <span class=\"token punctuation\" >[</span>knightX<span class=\"token punctuation\" >,</span> knightY<span class=\"token punctuation\" >]</span> <span class=\"token operator\" >=</span> <span class=\"token var\" >this</span><span class=\"token punctuation\" >.</span>props<span class=\"token punctuation\" >.</span>knightPosition<span class=\"token punctuation\" >;</span>\n  <span class=\"token keyword\" >const</span> piece <span class=\"token operator\" >=</span> <span class=\"token punctuation\" >(</span>x <span class=\"token operator\" >===</span> knightX <span class=\"token operator\" >&amp;&amp;</span> y <span class=\"token operator\" >===</span> knightY<span class=\"token punctuation\" >)</span> <span class=\"token operator\" >?</span>\n    <span class=\"token operator\" >&lt;</span><span class=\"token qualifier\" >Knight</span> <span class=\"token operator\" >/</span><span class=\"token operator\" >></span> <span class=\"token punctuation\" >:</span>\n    <span class=\"token primitive\" >null</span><span class=\"token punctuation\" >;</span>\n\n  <span class=\"token keyword\" >return</span> <span class=\"token punctuation\" >(</span>\n    <span class=\"token operator\" >&lt;</span><span class=\"token qualifier\" >Square</span> black<span class=\"token operator\" >=</span><span class=\"token punctuation\" >{</span>black<span class=\"token punctuation\" >}</span><span class=\"token operator\" >></span>\n      <span class=\"token punctuation\" >{</span>piece<span class=\"token punctuation\" >}</span>\n    <span class=\"token operator\" >&lt;</span><span class=\"token operator\" >/</span><span class=\"token qualifier\" >Square</span><span class=\"token operator\" >></span>\n  <span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n<span class=\"token punctuation\" >}</span></code><hr/>\n<hr/>\n<p>I can already give it a whirl by changing <code>render</code> to be</p>\n<hr/>\n<code class=\"codeBlock\">render<span class=\"token punctuation\" >:</span> <span class=\"token block-keyword\" >function</span> <span class=\"token punctuation\" >(</span><span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n  <span class=\"token keyword\" >return</span> <span class=\"token punctuation\" >(</span>\n    <span class=\"token operator\" >&lt;</span>div style<span class=\"token operator\" >=</span><span class=\"token punctuation\" >{</span><span class=\"token punctuation\" >{</span>\n      width<span class=\"token punctuation\" >:</span> <span class=\"token string\" >'100%'</span><span class=\"token punctuation\" >,</span>\n      height<span class=\"token punctuation\" >:</span> <span class=\"token string\" >'100%'</span>\n    <span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >}</span><span class=\"token operator\" >></span>\n      <span class=\"token punctuation\" >{</span><span class=\"token var\" >this</span><span class=\"token punctuation\" >.</span><span class=\"token function\" >renderSquare<span class=\"token punctuation\" >(</span></span><span class=\"token number\" >0</span><span class=\"token punctuation\" >,</span> <span class=\"token number\" >0</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >}</span>\n      <span class=\"token punctuation\" >{</span><span class=\"token var\" >this</span><span class=\"token punctuation\" >.</span><span class=\"token function\" >renderSquare<span class=\"token punctuation\" >(</span></span><span class=\"token number\" >1</span><span class=\"token punctuation\" >,</span> <span class=\"token number\" >0</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >}</span>\n      <span class=\"token punctuation\" >{</span><span class=\"token var\" >this</span><span class=\"token punctuation\" >.</span><span class=\"token function\" >renderSquare<span class=\"token punctuation\" >(</span></span><span class=\"token number\" >2</span><span class=\"token punctuation\" >,</span> <span class=\"token number\" >0</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >}</span>\n    <span class=\"token operator\" >&lt;</span><span class=\"token operator\" >/</span>div<span class=\"token operator\" >></span>\n  <span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n<span class=\"token punctuation\" >}</span></code><hr/>\n<code class=\"codeBlock\"><span class=\"token function\" >render<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n  <span class=\"token keyword\" >return</span> <span class=\"token punctuation\" >(</span>\n    <span class=\"token operator\" >&lt;</span>div style<span class=\"token operator\" >=</span><span class=\"token punctuation\" >{</span><span class=\"token punctuation\" >{</span>\n      width<span class=\"token punctuation\" >:</span> <span class=\"token string\" >'100%'</span><span class=\"token punctuation\" >,</span>\n      height<span class=\"token punctuation\" >:</span> <span class=\"token string\" >'100%'</span>\n    <span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >}</span><span class=\"token operator\" >></span>\n      <span class=\"token punctuation\" >{</span><span class=\"token var\" >this</span><span class=\"token punctuation\" >.</span><span class=\"token function\" >renderSquare<span class=\"token punctuation\" >(</span></span><span class=\"token number\" >0</span><span class=\"token punctuation\" >,</span> <span class=\"token number\" >0</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >}</span>\n      <span class=\"token punctuation\" >{</span><span class=\"token var\" >this</span><span class=\"token punctuation\" >.</span><span class=\"token function\" >renderSquare<span class=\"token punctuation\" >(</span></span><span class=\"token number\" >1</span><span class=\"token punctuation\" >,</span> <span class=\"token number\" >0</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >}</span>\n      <span class=\"token punctuation\" >{</span><span class=\"token var\" >this</span><span class=\"token punctuation\" >.</span><span class=\"token function\" >renderSquare<span class=\"token punctuation\" >(</span></span><span class=\"token number\" >2</span><span class=\"token punctuation\" >,</span> <span class=\"token number\" >0</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >}</span>\n    <span class=\"token operator\" >&lt;</span><span class=\"token operator\" >/</span>div<span class=\"token operator\" >></span>\n  <span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n<span class=\"token punctuation\" >}</span></code><hr/>\n<hr/>\n<p><img src='http://i.imgur.com/Br30DLg.png' width='512' height='384' alt='Screenshot'></p>\n<p>At this point, I realize that I forgot to give my squares any layout. I&#39;m going to try <a href=\"https://developer.mozilla.org/en/CSS/Using_CSS_flexible_boxes\">Flexbox</a> because why not. I added some styles to the root <code>div</code>, and also wrapped the <code>Square</code>s into <code>div</code>s so I could lay them out. Generally it&#39;s a good idea to keep components encapsulated and ignorant of how they&#39;re being laid out, even if this means adding wrapper <code>div</code>s.</p>\n<hr/>\n<code class=\"codeBlock\"><span class=\"token keyword\" >var</span> <span class=\"token qualifier\" >React</span> <span class=\"token operator\" >=</span> <span class=\"token function\" >require<span class=\"token punctuation\" >(</span></span><span class=\"token string\" >'react'</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n<span class=\"token keyword\" >var</span> <span class=\"token qualifier\" >Prop</span><span class=\"token qualifier\" >Types</span> <span class=\"token operator\" >=</span> <span class=\"token qualifier\" >React</span><span class=\"token punctuation\" >.</span><span class=\"token qualifier\" >Prop</span><span class=\"token qualifier\" >Types</span><span class=\"token punctuation\" >;</span>\n<span class=\"token keyword\" >var</span> <span class=\"token qualifier\" >Square</span> <span class=\"token operator\" >=</span> <span class=\"token function\" >require<span class=\"token punctuation\" >(</span></span><span class=\"token string\" >'./Square'</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n<span class=\"token keyword\" >var</span> <span class=\"token qualifier\" >Knight</span> <span class=\"token operator\" >=</span> <span class=\"token function\" >require<span class=\"token punctuation\" >(</span></span><span class=\"token string\" >'./Knight'</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n\n<span class=\"token keyword\" >var</span> <span class=\"token qualifier\" >Board</span> <span class=\"token operator\" >=</span> <span class=\"token qualifier\" >React</span><span class=\"token punctuation\" >.</span><span class=\"token function\" >createClass<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >{</span>\n  propTypes<span class=\"token punctuation\" >:</span> <span class=\"token punctuation\" >{</span>\n    knightPosition<span class=\"token punctuation\" >:</span> <span class=\"token qualifier\" >Prop</span><span class=\"token qualifier\" >Types</span><span class=\"token punctuation\" >.</span><span class=\"token function\" >arrayOf<span class=\"token punctuation\" >(</span></span>\n      <span class=\"token qualifier\" >Prop</span><span class=\"token qualifier\" >Types</span><span class=\"token punctuation\" >.</span>number<span class=\"token punctuation\" >.</span>isRequired\n    <span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >.</span>isRequired\n  <span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >,</span>\n\n  renderSquare<span class=\"token punctuation\" >:</span> <span class=\"token block-keyword\" >function</span> <span class=\"token punctuation\" >(</span>i<span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n    <span class=\"token keyword\" >var</span> x <span class=\"token operator\" >=</span> i <span class=\"token operator\" >%</span> <span class=\"token number\" >8</span><span class=\"token punctuation\" >;</span>\n    <span class=\"token keyword\" >var</span> y <span class=\"token operator\" >=</span> <span class=\"token qualifier\" >Math</span><span class=\"token punctuation\" >.</span><span class=\"token function\" >floor<span class=\"token punctuation\" >(</span></span>i <span class=\"token operator\" >/</span> <span class=\"token number\" >8</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n    <span class=\"token keyword\" >var</span> black <span class=\"token operator\" >=</span> <span class=\"token punctuation\" >(</span>x <span class=\"token operator\" >+</span> y<span class=\"token punctuation\" >)</span> <span class=\"token operator\" >%</span> <span class=\"token number\" >2</span> <span class=\"token operator\" >===</span> <span class=\"token number\" >1</span><span class=\"token punctuation\" >;</span>\n\n    <span class=\"token keyword\" >var</span> knightX <span class=\"token operator\" >=</span> <span class=\"token var\" >this</span><span class=\"token punctuation\" >.</span>props<span class=\"token punctuation\" >.</span>knightPosition<span class=\"token punctuation\" >[</span><span class=\"token number\" >0</span><span class=\"token punctuation\" >]</span><span class=\"token punctuation\" >;</span>\n    <span class=\"token keyword\" >var</span> knightY <span class=\"token operator\" >=</span> <span class=\"token var\" >this</span><span class=\"token punctuation\" >.</span>props<span class=\"token punctuation\" >.</span>knightPosition<span class=\"token punctuation\" >[</span><span class=\"token number\" >1</span><span class=\"token punctuation\" >]</span><span class=\"token punctuation\" >;</span>\n    <span class=\"token keyword\" >var</span> piece <span class=\"token operator\" >=</span> <span class=\"token punctuation\" >(</span>x <span class=\"token operator\" >===</span> knightX <span class=\"token operator\" >&amp;&amp;</span> y <span class=\"token operator\" >===</span> knightY<span class=\"token punctuation\" >)</span> <span class=\"token operator\" >?</span>\n      <span class=\"token operator\" >&lt;</span><span class=\"token qualifier\" >Knight</span> <span class=\"token operator\" >/</span><span class=\"token operator\" >></span> <span class=\"token punctuation\" >:</span>\n      <span class=\"token primitive\" >null</span><span class=\"token punctuation\" >;</span>\n\n    <span class=\"token keyword\" >return</span> <span class=\"token punctuation\" >(</span>\n      <span class=\"token operator\" >&lt;</span>div key<span class=\"token operator\" >=</span><span class=\"token punctuation\" >{</span>i<span class=\"token punctuation\" >}</span>\n           style<span class=\"token operator\" >=</span><span class=\"token punctuation\" >{</span><span class=\"token punctuation\" >{</span> width<span class=\"token punctuation\" >:</span> <span class=\"token string\" >'12.5%'</span><span class=\"token punctuation\" >,</span> height<span class=\"token punctuation\" >:</span> <span class=\"token string\" >'12.5%'</span> <span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >}</span><span class=\"token operator\" >></span>\n        <span class=\"token operator\" >&lt;</span><span class=\"token qualifier\" >Square</span> black<span class=\"token operator\" >=</span><span class=\"token punctuation\" >{</span>black<span class=\"token punctuation\" >}</span><span class=\"token operator\" >></span>\n          <span class=\"token punctuation\" >{</span>piece<span class=\"token punctuation\" >}</span>\n        <span class=\"token operator\" >&lt;</span><span class=\"token operator\" >/</span><span class=\"token qualifier\" >Square</span><span class=\"token operator\" >></span>\n      <span class=\"token operator\" >&lt;</span><span class=\"token operator\" >/</span>div<span class=\"token operator\" >></span>\n    <span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n  <span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >,</span>\n\n  render<span class=\"token punctuation\" >:</span> <span class=\"token block-keyword\" >function</span> <span class=\"token punctuation\" >(</span><span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n    <span class=\"token keyword\" >var</span> squares <span class=\"token operator\" >=</span> <span class=\"token punctuation\" >[</span><span class=\"token punctuation\" >]</span><span class=\"token punctuation\" >;</span>\n    <span class=\"token block-keyword\" >for</span> <span class=\"token punctuation\" >(</span><span class=\"token keyword\" >let</span> i <span class=\"token operator\" >=</span> <span class=\"token number\" >0</span><span class=\"token punctuation\" >;</span> i <span class=\"token operator\" >&lt;</span> <span class=\"token number\" >64</span><span class=\"token punctuation\" >;</span> i<span class=\"token operator\" >++</span><span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n      squares<span class=\"token punctuation\" >.</span><span class=\"token function\" >push<span class=\"token punctuation\" >(</span></span><span class=\"token var\" >this</span><span class=\"token punctuation\" >.</span><span class=\"token function\" >renderSquare<span class=\"token punctuation\" >(</span></span>i<span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n    <span class=\"token punctuation\" >}</span>\n\n    <span class=\"token keyword\" >return</span> <span class=\"token punctuation\" >(</span>\n      <span class=\"token operator\" >&lt;</span>div style<span class=\"token operator\" >=</span><span class=\"token punctuation\" >{</span><span class=\"token punctuation\" >{</span>\n        width<span class=\"token punctuation\" >:</span> <span class=\"token string\" >'100%'</span><span class=\"token punctuation\" >,</span>\n        height<span class=\"token punctuation\" >:</span> <span class=\"token string\" >'100%'</span><span class=\"token punctuation\" >,</span>\n        display<span class=\"token punctuation\" >:</span> <span class=\"token string\" >'flex'</span><span class=\"token punctuation\" >,</span>\n        flexWrap<span class=\"token punctuation\" >:</span> <span class=\"token string\" >'wrap'</span>\n      <span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >}</span><span class=\"token operator\" >></span>\n        <span class=\"token punctuation\" >{</span>squares<span class=\"token punctuation\" >}</span>\n      <span class=\"token operator\" >&lt;</span><span class=\"token operator\" >/</span>div<span class=\"token operator\" >></span>\n    <span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n  <span class=\"token punctuation\" >}</span>\n<span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n\nmodule<span class=\"token punctuation\" >.</span>exports <span class=\"token operator\" >=</span> <span class=\"token qualifier\" >Board</span><span class=\"token punctuation\" >;</span></code><hr/>\n<code class=\"codeBlock\"><span class=\"token keyword\" >import</span> <span class=\"token qualifier\" >React</span><span class=\"token punctuation\" >,</span> <span class=\"token punctuation\" >{</span> <span class=\"token qualifier\" >Prop</span><span class=\"token qualifier\" >Types</span> <span class=\"token punctuation\" >}</span> from <span class=\"token string\" >'react'</span><span class=\"token punctuation\" >;</span>\n<span class=\"token keyword\" >import</span> <span class=\"token qualifier\" >Square</span> from <span class=\"token string\" >'./Square'</span><span class=\"token punctuation\" >;</span>\n<span class=\"token keyword\" >import</span> <span class=\"token qualifier\" >Knight</span> from <span class=\"token string\" >'./Knight'</span><span class=\"token punctuation\" >;</span>\n\n<span class=\"token keyword\" >export</span> <span class=\"token keyword\" >default</span> <span class=\"token keyword\" >class</span> <span class=\"token class-name\" >Board</span> <span class=\"token punctuation\" >{</span>\n  <span class=\"token function\" >renderSquare<span class=\"token punctuation\" >(</span></span>i<span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n    <span class=\"token keyword\" >const</span> x <span class=\"token operator\" >=</span> i <span class=\"token operator\" >%</span> <span class=\"token number\" >8</span><span class=\"token punctuation\" >;</span>\n    <span class=\"token keyword\" >const</span> y <span class=\"token operator\" >=</span> <span class=\"token qualifier\" >Math</span><span class=\"token punctuation\" >.</span><span class=\"token function\" >floor<span class=\"token punctuation\" >(</span></span>i <span class=\"token operator\" >/</span> <span class=\"token number\" >8</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n    <span class=\"token keyword\" >const</span> black <span class=\"token operator\" >=</span> <span class=\"token punctuation\" >(</span>x <span class=\"token operator\" >+</span> y<span class=\"token punctuation\" >)</span> <span class=\"token operator\" >%</span> <span class=\"token number\" >2</span> <span class=\"token operator\" >===</span> <span class=\"token number\" >1</span><span class=\"token punctuation\" >;</span>\n\n    <span class=\"token keyword\" >const</span> <span class=\"token punctuation\" >[</span>knightX<span class=\"token punctuation\" >,</span> knightY<span class=\"token punctuation\" >]</span> <span class=\"token operator\" >=</span> <span class=\"token var\" >this</span><span class=\"token punctuation\" >.</span>props<span class=\"token punctuation\" >.</span>knightPosition<span class=\"token punctuation\" >;</span>\n    <span class=\"token keyword\" >const</span> piece <span class=\"token operator\" >=</span> <span class=\"token punctuation\" >(</span>x <span class=\"token operator\" >===</span> knightX <span class=\"token operator\" >&amp;&amp;</span> y <span class=\"token operator\" >===</span> knightY<span class=\"token punctuation\" >)</span> <span class=\"token operator\" >?</span>\n      <span class=\"token operator\" >&lt;</span><span class=\"token qualifier\" >Knight</span> <span class=\"token operator\" >/</span><span class=\"token operator\" >></span> <span class=\"token punctuation\" >:</span>\n      <span class=\"token primitive\" >null</span><span class=\"token punctuation\" >;</span>\n\n    <span class=\"token keyword\" >return</span> <span class=\"token punctuation\" >(</span>\n      <span class=\"token operator\" >&lt;</span>div key<span class=\"token operator\" >=</span><span class=\"token punctuation\" >{</span>i<span class=\"token punctuation\" >}</span>\n           style<span class=\"token operator\" >=</span><span class=\"token punctuation\" >{</span><span class=\"token punctuation\" >{</span> width<span class=\"token punctuation\" >:</span> <span class=\"token string\" >'12.5%'</span><span class=\"token punctuation\" >,</span> height<span class=\"token punctuation\" >:</span> <span class=\"token string\" >'12.5%'</span> <span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >}</span><span class=\"token operator\" >></span>\n        <span class=\"token operator\" >&lt;</span><span class=\"token qualifier\" >Square</span> black<span class=\"token operator\" >=</span><span class=\"token punctuation\" >{</span>black<span class=\"token punctuation\" >}</span><span class=\"token operator\" >></span>\n          <span class=\"token punctuation\" >{</span>piece<span class=\"token punctuation\" >}</span>\n        <span class=\"token operator\" >&lt;</span><span class=\"token operator\" >/</span><span class=\"token qualifier\" >Square</span><span class=\"token operator\" >></span>\n      <span class=\"token operator\" >&lt;</span><span class=\"token operator\" >/</span>div<span class=\"token operator\" >></span>\n    <span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n  <span class=\"token punctuation\" >}</span>\n\n  <span class=\"token function\" >render<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n    <span class=\"token keyword\" >const</span> squares <span class=\"token operator\" >=</span> <span class=\"token punctuation\" >[</span><span class=\"token punctuation\" >]</span><span class=\"token punctuation\" >;</span>\n    <span class=\"token block-keyword\" >for</span> <span class=\"token punctuation\" >(</span><span class=\"token keyword\" >let</span> i <span class=\"token operator\" >=</span> <span class=\"token number\" >0</span><span class=\"token punctuation\" >;</span> i <span class=\"token operator\" >&lt;</span> <span class=\"token number\" >64</span><span class=\"token punctuation\" >;</span> i<span class=\"token operator\" >++</span><span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n      squares<span class=\"token punctuation\" >.</span><span class=\"token function\" >push<span class=\"token punctuation\" >(</span></span><span class=\"token var\" >this</span><span class=\"token punctuation\" >.</span><span class=\"token function\" >renderSquare<span class=\"token punctuation\" >(</span></span>i<span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n    <span class=\"token punctuation\" >}</span>\n\n    <span class=\"token keyword\" >return</span> <span class=\"token punctuation\" >(</span>\n      <span class=\"token operator\" >&lt;</span>div style<span class=\"token operator\" >=</span><span class=\"token punctuation\" >{</span><span class=\"token punctuation\" >{</span>\n        width<span class=\"token punctuation\" >:</span> <span class=\"token string\" >'100%'</span><span class=\"token punctuation\" >,</span>\n        height<span class=\"token punctuation\" >:</span> <span class=\"token string\" >'100%'</span><span class=\"token punctuation\" >,</span>\n        display<span class=\"token punctuation\" >:</span> <span class=\"token string\" >'flex'</span><span class=\"token punctuation\" >,</span>\n        flexWrap<span class=\"token punctuation\" >:</span> <span class=\"token string\" >'wrap'</span>\n      <span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >}</span><span class=\"token operator\" >></span>\n        <span class=\"token punctuation\" >{</span>squares<span class=\"token punctuation\" >}</span>\n      <span class=\"token operator\" >&lt;</span><span class=\"token operator\" >/</span>div<span class=\"token operator\" >></span>\n    <span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n  <span class=\"token punctuation\" >}</span>\n<span class=\"token punctuation\" >}</span>\n\n<span class=\"token qualifier\" >Board</span><span class=\"token punctuation\" >.</span>propTypes <span class=\"token operator\" >=</span> <span class=\"token punctuation\" >{</span>\n  knightPosition<span class=\"token punctuation\" >:</span> <span class=\"token qualifier\" >Prop</span><span class=\"token qualifier\" >Types</span><span class=\"token punctuation\" >.</span><span class=\"token function\" >arrayOf<span class=\"token punctuation\" >(</span></span>\n    <span class=\"token qualifier\" >Prop</span><span class=\"token qualifier\" >Types</span><span class=\"token punctuation\" >.</span>number<span class=\"token punctuation\" >.</span>isRequired\n  <span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >.</span>isRequired\n<span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >;</span></code><hr/>\n<code class=\"codeBlock\"><span class=\"token keyword\" >import</span> <span class=\"token qualifier\" >React</span><span class=\"token punctuation\" >,</span> <span class=\"token punctuation\" >{</span> <span class=\"token qualifier\" >Prop</span><span class=\"token qualifier\" >Types</span> <span class=\"token punctuation\" >}</span> from <span class=\"token string\" >'react'</span><span class=\"token punctuation\" >;</span>\n<span class=\"token keyword\" >import</span> <span class=\"token qualifier\" >Square</span> from <span class=\"token string\" >'./Square'</span><span class=\"token punctuation\" >;</span>\n<span class=\"token keyword\" >import</span> <span class=\"token qualifier\" >Knight</span> from <span class=\"token string\" >'./Knight'</span><span class=\"token punctuation\" >;</span>\n\n<span class=\"token keyword\" >export</span> <span class=\"token keyword\" >default</span> <span class=\"token keyword\" >class</span> <span class=\"token class-name\" >Board</span> <span class=\"token punctuation\" >{</span>\n  <span class=\"token keyword\" >static</span> propTypes <span class=\"token operator\" >=</span> <span class=\"token punctuation\" >{</span>\n    knightPosition<span class=\"token punctuation\" >:</span> <span class=\"token qualifier\" >Prop</span><span class=\"token qualifier\" >Types</span><span class=\"token punctuation\" >.</span><span class=\"token function\" >arrayOf<span class=\"token punctuation\" >(</span></span>\n      <span class=\"token qualifier\" >Prop</span><span class=\"token qualifier\" >Types</span><span class=\"token punctuation\" >.</span>number<span class=\"token punctuation\" >.</span>isRequired\n    <span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >.</span>isRequired\n  <span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >;</span>\n\n  <span class=\"token function\" >renderSquare<span class=\"token punctuation\" >(</span></span>i<span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n    <span class=\"token keyword\" >const</span> x <span class=\"token operator\" >=</span> i <span class=\"token operator\" >%</span> <span class=\"token number\" >8</span><span class=\"token punctuation\" >;</span>\n    <span class=\"token keyword\" >const</span> y <span class=\"token operator\" >=</span> <span class=\"token qualifier\" >Math</span><span class=\"token punctuation\" >.</span><span class=\"token function\" >floor<span class=\"token punctuation\" >(</span></span>i <span class=\"token operator\" >/</span> <span class=\"token number\" >8</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n    <span class=\"token keyword\" >const</span> black <span class=\"token operator\" >=</span> <span class=\"token punctuation\" >(</span>x <span class=\"token operator\" >+</span> y<span class=\"token punctuation\" >)</span> <span class=\"token operator\" >%</span> <span class=\"token number\" >2</span> <span class=\"token operator\" >===</span> <span class=\"token number\" >1</span><span class=\"token punctuation\" >;</span>\n\n    <span class=\"token keyword\" >const</span> <span class=\"token punctuation\" >[</span>knightX<span class=\"token punctuation\" >,</span> knightY<span class=\"token punctuation\" >]</span> <span class=\"token operator\" >=</span> <span class=\"token var\" >this</span><span class=\"token punctuation\" >.</span>props<span class=\"token punctuation\" >.</span>knightPosition<span class=\"token punctuation\" >;</span>\n    <span class=\"token keyword\" >const</span> piece <span class=\"token operator\" >=</span> <span class=\"token punctuation\" >(</span>x <span class=\"token operator\" >===</span> knightX <span class=\"token operator\" >&amp;&amp;</span> y <span class=\"token operator\" >===</span> knightY<span class=\"token punctuation\" >)</span> <span class=\"token operator\" >?</span>\n      <span class=\"token operator\" >&lt;</span><span class=\"token qualifier\" >Knight</span> <span class=\"token operator\" >/</span><span class=\"token operator\" >></span> <span class=\"token punctuation\" >:</span>\n      <span class=\"token primitive\" >null</span><span class=\"token punctuation\" >;</span>\n\n    <span class=\"token keyword\" >return</span> <span class=\"token punctuation\" >(</span>\n      <span class=\"token operator\" >&lt;</span>div key<span class=\"token operator\" >=</span><span class=\"token punctuation\" >{</span>i<span class=\"token punctuation\" >}</span>\n           style<span class=\"token operator\" >=</span><span class=\"token punctuation\" >{</span><span class=\"token punctuation\" >{</span> width<span class=\"token punctuation\" >:</span> <span class=\"token string\" >'12.5%'</span><span class=\"token punctuation\" >,</span> height<span class=\"token punctuation\" >:</span> <span class=\"token string\" >'12.5%'</span> <span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >}</span><span class=\"token operator\" >></span>\n        <span class=\"token operator\" >&lt;</span><span class=\"token qualifier\" >Square</span> black<span class=\"token operator\" >=</span><span class=\"token punctuation\" >{</span>black<span class=\"token punctuation\" >}</span><span class=\"token operator\" >></span>\n          <span class=\"token punctuation\" >{</span>piece<span class=\"token punctuation\" >}</span>\n        <span class=\"token operator\" >&lt;</span><span class=\"token operator\" >/</span><span class=\"token qualifier\" >Square</span><span class=\"token operator\" >></span>\n      <span class=\"token operator\" >&lt;</span><span class=\"token operator\" >/</span>div<span class=\"token operator\" >></span>\n    <span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n  <span class=\"token punctuation\" >}</span>\n\n  <span class=\"token function\" >render<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n    <span class=\"token keyword\" >const</span> squares <span class=\"token operator\" >=</span> <span class=\"token punctuation\" >[</span><span class=\"token punctuation\" >]</span><span class=\"token punctuation\" >;</span>\n    <span class=\"token block-keyword\" >for</span> <span class=\"token punctuation\" >(</span><span class=\"token keyword\" >let</span> i <span class=\"token operator\" >=</span> <span class=\"token number\" >0</span><span class=\"token punctuation\" >;</span> i <span class=\"token operator\" >&lt;</span> <span class=\"token number\" >64</span><span class=\"token punctuation\" >;</span> i<span class=\"token operator\" >++</span><span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n      squares<span class=\"token punctuation\" >.</span><span class=\"token function\" >push<span class=\"token punctuation\" >(</span></span><span class=\"token var\" >this</span><span class=\"token punctuation\" >.</span><span class=\"token function\" >renderSquare<span class=\"token punctuation\" >(</span></span>i<span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n    <span class=\"token punctuation\" >}</span>\n\n    <span class=\"token keyword\" >return</span> <span class=\"token punctuation\" >(</span>\n      <span class=\"token operator\" >&lt;</span>div style<span class=\"token operator\" >=</span><span class=\"token punctuation\" >{</span><span class=\"token punctuation\" >{</span>\n        width<span class=\"token punctuation\" >:</span> <span class=\"token string\" >'100%'</span><span class=\"token punctuation\" >,</span>\n        height<span class=\"token punctuation\" >:</span> <span class=\"token string\" >'100%'</span><span class=\"token punctuation\" >,</span>\n        display<span class=\"token punctuation\" >:</span> <span class=\"token string\" >'flex'</span><span class=\"token punctuation\" >,</span>\n        flexWrap<span class=\"token punctuation\" >:</span> <span class=\"token string\" >'wrap'</span>\n      <span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >}</span><span class=\"token operator\" >></span>\n        <span class=\"token punctuation\" >{</span>squares<span class=\"token punctuation\" >}</span>\n      <span class=\"token operator\" >&lt;</span><span class=\"token operator\" >/</span>div<span class=\"token operator\" >></span>\n    <span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n  <span class=\"token punctuation\" >}</span>\n<span class=\"token punctuation\" >}</span></code><hr/>\n<p><img src='http://i.imgur.com/RsQDI4Y.png' width='512' height='384' alt='Screenshot'></p>\n<p>It looks pretty awesome! I don&#39;t know how to constrain the <code>Board</code> to maintain a square aspect ratio, but this should be easy to add later.</p>\n<p>Think about it for a moment. We just went from nothing to being able to move the <code>Knight</code> on a beautiful <code>Board</code> by changing the <code>knightPosition</code>:</p>\n<hr/>\n<code class=\"codeBlock\"><span class=\"token keyword\" >var</span> <span class=\"token qualifier\" >React</span> <span class=\"token operator\" >=</span> <span class=\"token function\" >require<span class=\"token punctuation\" >(</span></span><span class=\"token string\" >'react'</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n<span class=\"token keyword\" >var</span> <span class=\"token qualifier\" >Board</span> <span class=\"token operator\" >=</span> <span class=\"token function\" >require<span class=\"token punctuation\" >(</span></span><span class=\"token string\" >'./Board'</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n\n<span class=\"token qualifier\" >React</span><span class=\"token punctuation\" >.</span><span class=\"token function\" >render<span class=\"token punctuation\" >(</span></span>\n  <span class=\"token operator\" >&lt;</span><span class=\"token qualifier\" >Board</span> knightPosition<span class=\"token operator\" >=</span><span class=\"token punctuation\" >{</span><span class=\"token punctuation\" >[</span><span class=\"token number\" >4</span><span class=\"token punctuation\" >,</span> <span class=\"token number\" >7</span><span class=\"token punctuation\" >]</span><span class=\"token punctuation\" >}</span> <span class=\"token operator\" >/</span><span class=\"token operator\" >></span><span class=\"token punctuation\" >,</span>\n  document<span class=\"token punctuation\" >.</span><span class=\"token function\" >getElementById<span class=\"token punctuation\" >(</span></span><span class=\"token string\" >'root'</span><span class=\"token punctuation\" >)</span>\n<span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span></code><hr/>\n<code class=\"codeBlock\"><span class=\"token keyword\" >import</span> <span class=\"token qualifier\" >React</span> from <span class=\"token string\" >'react'</span><span class=\"token punctuation\" >;</span>\n<span class=\"token keyword\" >import</span> <span class=\"token qualifier\" >Board</span> from <span class=\"token string\" >'./Board'</span><span class=\"token punctuation\" >;</span>\n\n<span class=\"token qualifier\" >React</span><span class=\"token punctuation\" >.</span><span class=\"token function\" >render<span class=\"token punctuation\" >(</span></span>\n  <span class=\"token operator\" >&lt;</span><span class=\"token qualifier\" >Board</span> knightPosition<span class=\"token operator\" >=</span><span class=\"token punctuation\" >{</span><span class=\"token punctuation\" >[</span><span class=\"token number\" >4</span><span class=\"token punctuation\" >,</span> <span class=\"token number\" >7</span><span class=\"token punctuation\" >]</span><span class=\"token punctuation\" >}</span> <span class=\"token operator\" >/</span><span class=\"token operator\" >></span><span class=\"token punctuation\" >,</span>\n  document<span class=\"token punctuation\" >.</span><span class=\"token function\" >getElementById<span class=\"token punctuation\" >(</span></span><span class=\"token string\" >'root'</span><span class=\"token punctuation\" >)</span>\n<span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span></code><hr/>\n<hr/>\n<p><img src='http://i.imgur.com/0fNBn5a.png' width='512' height='384' alt='Screenshot'></p>\n<p>Declarative much? That&#39;s why people love working with React.</p>\n<h2>Adding the State<a id=\"adding-the-state\">&nbsp;</a></h2><p>We want to make the <code>Knight</code> draggable. It&#39;s a noble goal, but we need to see past it. What we really mean is that we want to keep the current <code>knightPosition</code> in some kind of state storage, and have some way to change it.</p>\n<p>Because setting up this state requires some thought, we won&#39;t try to implement dragging at the same time. Instead, we&#39;ll start with a simpler implementation. We will move the <code>Knight</code> when you click a particular <code>Square</code>, but only if this is allowed by the Chess rules. Implementing this logic should give us enough insight into managing the state, so we can replace clicking with the drag and drop once we&#39;ve dealt with that.</p>\n<p>React is not opinionated about the state management or the data flow; you can use <a href=\"https://facebook.github.io/flux/\">Flux</a>, <a href=\"https://github.com/Reactive-Extensions/RxJS\">Rx</a> or <s>even Backbone</s> nah, <a href=\"http://martinfowler.com/bliki/CQRS.html\">avoid fat models and separate your reads from writes</a>.</p>\n<p>I don&#39;t want to bother with installing or setting up Flux for this simple example, so I&#39;m going to follow a simpler pattern. It won&#39;t scale as well as Flux, but I also don&#39;t need it to. I have not decided on the API for my state manager yet, but I&#39;m going to call it <code>Game</code>, and it will definitely need to have some way of signaling data changes to my React code.</p>\n<p>Since I know this much, I can rewrite my <code>index.js</code> with a hypothetical <code>Game</code> that doesn&#39;t exist yet. Note that this time, I&#39;m writing my code in blind, not being able to run it yet. This is because I&#39;m still figuring out the API:</p>\n<hr/>\n<code class=\"codeBlock\"><span class=\"token keyword\" >var</span> <span class=\"token qualifier\" >React</span> <span class=\"token operator\" >=</span> <span class=\"token function\" >require<span class=\"token punctuation\" >(</span></span><span class=\"token string\" >'react'</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n<span class=\"token keyword\" >var</span> <span class=\"token qualifier\" >Board</span> <span class=\"token operator\" >=</span> <span class=\"token function\" >require<span class=\"token punctuation\" >(</span></span><span class=\"token string\" >'./Board'</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n<span class=\"token keyword\" >var</span> observe <span class=\"token operator\" >=</span> <span class=\"token function\" >require<span class=\"token punctuation\" >(</span></span><span class=\"token string\" >'./Game'</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >.</span>observe<span class=\"token punctuation\" >;</span>\n\n<span class=\"token keyword\" >var</span> rootEl <span class=\"token operator\" >=</span> document<span class=\"token punctuation\" >.</span><span class=\"token function\" >getElementById<span class=\"token punctuation\" >(</span></span><span class=\"token string\" >'root'</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n\n<span class=\"token function\" >observe<span class=\"token punctuation\" >(</span></span><span class=\"token block-keyword\" >function</span> <span class=\"token punctuation\" >(</span>knightPosition<span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n  <span class=\"token qualifier\" >React</span><span class=\"token punctuation\" >.</span><span class=\"token function\" >render<span class=\"token punctuation\" >(</span></span>\n    <span class=\"token operator\" >&lt;</span><span class=\"token qualifier\" >Board</span> knightPosition<span class=\"token operator\" >=</span><span class=\"token punctuation\" >{</span>knightPosition<span class=\"token punctuation\" >}</span> <span class=\"token operator\" >/</span><span class=\"token operator\" >></span><span class=\"token punctuation\" >,</span>\n    rootEl\n  <span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n<span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span></code><hr/>\n<code class=\"codeBlock\"><span class=\"token keyword\" >import</span> <span class=\"token qualifier\" >React</span> from <span class=\"token string\" >'react'</span><span class=\"token punctuation\" >;</span>\n<span class=\"token keyword\" >import</span> <span class=\"token qualifier\" >Board</span> from <span class=\"token string\" >'./Board'</span><span class=\"token punctuation\" >;</span>\n<span class=\"token keyword\" >import</span> <span class=\"token punctuation\" >{</span> observe <span class=\"token punctuation\" >}</span> from <span class=\"token string\" >'./Game'</span><span class=\"token punctuation\" >;</span>\n\n<span class=\"token keyword\" >const</span> rootEl <span class=\"token operator\" >=</span> document<span class=\"token punctuation\" >.</span><span class=\"token function\" >getElementById<span class=\"token punctuation\" >(</span></span><span class=\"token string\" >'root'</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n\n<span class=\"token function\" >observe<span class=\"token punctuation\" >(</span></span>knightPosition <span class=\"token operator\" >=</span><span class=\"token operator\" >></span>\n  <span class=\"token qualifier\" >React</span><span class=\"token punctuation\" >.</span><span class=\"token function\" >render<span class=\"token punctuation\" >(</span></span>\n    <span class=\"token operator\" >&lt;</span><span class=\"token qualifier\" >Board</span> knightPosition<span class=\"token operator\" >=</span><span class=\"token punctuation\" >{</span>knightPosition<span class=\"token punctuation\" >}</span> <span class=\"token operator\" >/</span><span class=\"token operator\" >></span><span class=\"token punctuation\" >,</span>\n    rootEl\n  <span class=\"token punctuation\" >)</span>\n<span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span></code><hr/>\n<hr/>\n<p>What is this <code>observe</code> function I import? It&#39;s just the most minimal way I can think of to subscribe to a changing state. I could&#39;ve made it an <code>EventEmitter</code> but why on Earth even <em>go there</em> when all I need is a single change event? I could have made <code>Game</code> an object model, but why do that, when all I need is a stream of values?</p>\n<p>Just to verify that this subscription API makes some sense, I&#39;m going to write a fake <code>Game</code> that emits random positions:</p>\n<hr/>\n<code class=\"codeBlock\">exports<span class=\"token punctuation\" >.</span>observe <span class=\"token operator\" >=</span> <span class=\"token block-keyword\" >function</span> <span class=\"token punctuation\" >(</span>receive<span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n  <span class=\"token function\" >setInterval<span class=\"token punctuation\" >(</span></span><span class=\"token block-keyword\" >function</span> <span class=\"token punctuation\" >(</span><span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n    <span class=\"token function\" >receive<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >[</span>\n      <span class=\"token qualifier\" >Math</span><span class=\"token punctuation\" >.</span><span class=\"token function\" >floor<span class=\"token punctuation\" >(</span></span><span class=\"token qualifier\" >Math</span><span class=\"token punctuation\" >.</span><span class=\"token function\" >random<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span> <span class=\"token operator\" >*</span> <span class=\"token number\" >8</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >,</span>\n      <span class=\"token qualifier\" >Math</span><span class=\"token punctuation\" >.</span><span class=\"token function\" >floor<span class=\"token punctuation\" >(</span></span><span class=\"token qualifier\" >Math</span><span class=\"token punctuation\" >.</span><span class=\"token function\" >random<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span> <span class=\"token operator\" >*</span> <span class=\"token number\" >8</span><span class=\"token punctuation\" >)</span>\n    <span class=\"token punctuation\" >]</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n  <span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >,</span> <span class=\"token number\" >500</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n<span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >;</span></code><hr/>\n<code class=\"codeBlock\"><span class=\"token keyword\" >export</span> <span class=\"token block-keyword\" >function</span> <span class=\"token function\" >observe<span class=\"token punctuation\" >(</span></span>receive<span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n  <span class=\"token function\" >setInterval<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >(</span><span class=\"token punctuation\" >)</span> <span class=\"token operator\" >=</span><span class=\"token operator\" >></span> <span class=\"token function\" >receive<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >[</span>\n    <span class=\"token qualifier\" >Math</span><span class=\"token punctuation\" >.</span><span class=\"token function\" >floor<span class=\"token punctuation\" >(</span></span><span class=\"token qualifier\" >Math</span><span class=\"token punctuation\" >.</span><span class=\"token function\" >random<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span> <span class=\"token operator\" >*</span> <span class=\"token number\" >8</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >,</span>\n    <span class=\"token qualifier\" >Math</span><span class=\"token punctuation\" >.</span><span class=\"token function\" >floor<span class=\"token punctuation\" >(</span></span><span class=\"token qualifier\" >Math</span><span class=\"token punctuation\" >.</span><span class=\"token function\" >random<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span> <span class=\"token operator\" >*</span> <span class=\"token number\" >8</span><span class=\"token punctuation\" >)</span>\n  <span class=\"token punctuation\" >]</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >,</span> <span class=\"token number\" >500</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n<span class=\"token punctuation\" >}</span></code><hr/>\n<hr/>\n<p>Nothing feels as good as being back into the rendering game!</p>\n<p><img src='https://s3.amazonaws.com/f.cl.ly/items/1K0s0n0r0C0e2P2N2D1d/Screen%20Recording%202015-05-15%20at%2012.06%20pm.gif' width='404' height='445' alt='Screenshot'></p>\n<p>This is obviously not very useful. If we want some interactivity, we&#39;re going to need a way to modify the <code>Game</code> state from our components. For now, I&#39;m going to keep it simple and expose a <code>moveKnight</code> function that directly modifies the internal state. This is not going to fare well in a moderately complex app where different state storages may be interested in updating their state in response to a single user action, but in our case this will suffice:</p>\n<hr/>\n<code class=\"codeBlock\"><span class=\"token keyword\" >var</span> knightPosition <span class=\"token operator\" >=</span> <span class=\"token punctuation\" >[</span><span class=\"token number\" >0</span><span class=\"token punctuation\" >,</span> <span class=\"token number\" >0</span><span class=\"token punctuation\" >]</span><span class=\"token punctuation\" >;</span>\n<span class=\"token keyword\" >var</span> observer <span class=\"token operator\" >=</span> <span class=\"token primitive\" >null</span><span class=\"token punctuation\" >;</span>\n\n<span class=\"token block-keyword\" >function</span> <span class=\"token function\" >emitChange<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n  <span class=\"token function\" >observer<span class=\"token punctuation\" >(</span></span>knightPosition<span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n<span class=\"token punctuation\" >}</span>\n\nexports<span class=\"token punctuation\" >.</span>observe <span class=\"token operator\" >=</span> <span class=\"token block-keyword\" >function</span> <span class=\"token punctuation\" >(</span>o<span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n  <span class=\"token block-keyword\" >if</span> <span class=\"token punctuation\" >(</span>observer<span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n    <span class=\"token keyword\" >throw</span> <span class=\"token keyword\" >new</span> <span class=\"token class-name\" >Error</span><span class=\"token punctuation\" >(</span><span class=\"token string\" >'Multiple observers not implemented.'</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n  <span class=\"token punctuation\" >}</span>\n\n  observer <span class=\"token operator\" >=</span> o<span class=\"token punctuation\" >;</span>\n  <span class=\"token function\" >emitChange<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n<span class=\"token punctuation\" >}</span>\n\nexports<span class=\"token punctuation\" >.</span>moveKnight <span class=\"token operator\" >=</span> <span class=\"token block-keyword\" >function</span> <span class=\"token punctuation\" >(</span>toX<span class=\"token punctuation\" >,</span> toY<span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n  knightPosition <span class=\"token operator\" >=</span> <span class=\"token punctuation\" >[</span>toX<span class=\"token punctuation\" >,</span> toY<span class=\"token punctuation\" >]</span><span class=\"token punctuation\" >;</span>\n  <span class=\"token function\" >emitChange<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n<span class=\"token punctuation\" >}</span></code><hr/>\n<code class=\"codeBlock\"><span class=\"token keyword\" >let</span> knightPosition <span class=\"token operator\" >=</span> <span class=\"token punctuation\" >[</span><span class=\"token number\" >0</span><span class=\"token punctuation\" >,</span> <span class=\"token number\" >0</span><span class=\"token punctuation\" >]</span><span class=\"token punctuation\" >;</span>\n<span class=\"token keyword\" >let</span> observer <span class=\"token operator\" >=</span> <span class=\"token primitive\" >null</span><span class=\"token punctuation\" >;</span>\n\n<span class=\"token block-keyword\" >function</span> <span class=\"token function\" >emitChange<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n  <span class=\"token function\" >observer<span class=\"token punctuation\" >(</span></span>knightPosition<span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n<span class=\"token punctuation\" >}</span>\n\n<span class=\"token keyword\" >export</span> <span class=\"token block-keyword\" >function</span> <span class=\"token function\" >observe<span class=\"token punctuation\" >(</span></span>o<span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n  <span class=\"token block-keyword\" >if</span> <span class=\"token punctuation\" >(</span>observer<span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n    <span class=\"token keyword\" >throw</span> <span class=\"token keyword\" >new</span> <span class=\"token class-name\" >Error</span><span class=\"token punctuation\" >(</span><span class=\"token string\" >'Multiple observers not implemented.'</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n  <span class=\"token punctuation\" >}</span>\n\n  observer <span class=\"token operator\" >=</span> o<span class=\"token punctuation\" >;</span>\n  <span class=\"token function\" >emitChange<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n<span class=\"token punctuation\" >}</span>\n\n<span class=\"token keyword\" >export</span> <span class=\"token block-keyword\" >function</span> <span class=\"token function\" >moveKnight<span class=\"token punctuation\" >(</span></span>toX<span class=\"token punctuation\" >,</span> toY<span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n  knightPosition <span class=\"token operator\" >=</span> <span class=\"token punctuation\" >[</span>toX<span class=\"token punctuation\" >,</span> toY<span class=\"token punctuation\" >]</span><span class=\"token punctuation\" >;</span>\n  <span class=\"token function\" >emitChange<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n<span class=\"token punctuation\" >}</span></code><hr/>\n<hr/>\n<p>Now, let&#39;s go back to our components. Our goal at this point is to move the <code>Knight</code> to a <code>Square</code> that was clicked. One way to do that is to call <code>moveKnight</code> from the <code>Square</code> itself. However, this would require us to pass the <code>Square</code> its position. Here is a good rule of thumb:</p>\n<blockquote>\n<p>If a component doesn&#39;t need some data for rendering, it doesn&#39;t need that data at all.</p>\n</blockquote>\n<p>The <code>Square</code> does not need to know its position to render. Therefore, it&#39;s best to avoid coupling it to the <code>moveKnight</code> method at this point. Instead, we are going to add an <code>onClick</code> handler to the <code>div</code> that wraps the <code>Square</code> inside the <code>Board</code>:</p>\n<hr/>\n<code class=\"codeBlock\"><span class=\"token keyword\" >var</span> <span class=\"token qualifier\" >React</span> <span class=\"token operator\" >=</span> <span class=\"token function\" >require<span class=\"token punctuation\" >(</span></span><span class=\"token string\" >'react'</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n<span class=\"token keyword\" >var</span> <span class=\"token qualifier\" >Prop</span><span class=\"token qualifier\" >Types</span> <span class=\"token operator\" >=</span> <span class=\"token qualifier\" >React</span><span class=\"token punctuation\" >.</span><span class=\"token qualifier\" >Prop</span><span class=\"token qualifier\" >Types</span><span class=\"token punctuation\" >;</span>\n<span class=\"token keyword\" >var</span> <span class=\"token qualifier\" >Square</span> <span class=\"token operator\" >=</span> <span class=\"token function\" >require<span class=\"token punctuation\" >(</span></span><span class=\"token string\" >'./Square'</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n<span class=\"token keyword\" >var</span> <span class=\"token qualifier\" >Knight</span> <span class=\"token operator\" >=</span> <span class=\"token function\" >require<span class=\"token punctuation\" >(</span></span><span class=\"token string\" >'./Knight'</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n<span class=\"token keyword\" >var</span> moveKnight <span class=\"token operator\" >=</span> <span class=\"token function\" >require<span class=\"token punctuation\" >(</span></span><span class=\"token string\" >'./Game'</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >.</span>moveKnight<span class=\"token punctuation\" >;</span>\n\n<span class=\"token comment\" spellcheck=\"true\">/* ... */</span>\n\nrenderSquare<span class=\"token punctuation\" >:</span> <span class=\"token block-keyword\" >function</span> <span class=\"token punctuation\" >(</span>i<span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n  <span class=\"token keyword\" >var</span> x <span class=\"token operator\" >=</span> i <span class=\"token operator\" >%</span> <span class=\"token number\" >8</span><span class=\"token punctuation\" >;</span>\n  <span class=\"token keyword\" >var</span> y <span class=\"token operator\" >=</span> <span class=\"token qualifier\" >Math</span><span class=\"token punctuation\" >.</span><span class=\"token function\" >floor<span class=\"token punctuation\" >(</span></span>i <span class=\"token operator\" >/</span> <span class=\"token number\" >8</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n  <span class=\"token keyword\" >var</span> black <span class=\"token operator\" >=</span> <span class=\"token punctuation\" >(</span>x <span class=\"token operator\" >+</span> y<span class=\"token punctuation\" >)</span> <span class=\"token operator\" >%</span> <span class=\"token number\" >2</span> <span class=\"token operator\" >===</span> <span class=\"token number\" >1</span><span class=\"token punctuation\" >;</span>\n\n  <span class=\"token keyword\" >var</span> knightX <span class=\"token operator\" >=</span> <span class=\"token var\" >this</span><span class=\"token punctuation\" >.</span>props<span class=\"token punctuation\" >.</span>knightPosition<span class=\"token punctuation\" >[</span><span class=\"token number\" >0</span><span class=\"token punctuation\" >]</span><span class=\"token punctuation\" >;</span>\n  <span class=\"token keyword\" >var</span> knightY <span class=\"token operator\" >=</span> <span class=\"token var\" >this</span><span class=\"token punctuation\" >.</span>props<span class=\"token punctuation\" >.</span>knightPosition<span class=\"token punctuation\" >[</span><span class=\"token number\" >1</span><span class=\"token punctuation\" >]</span><span class=\"token punctuation\" >;</span>\n  <span class=\"token keyword\" >var</span> piece <span class=\"token operator\" >=</span> <span class=\"token punctuation\" >(</span>x <span class=\"token operator\" >===</span> knightX <span class=\"token operator\" >&amp;&amp;</span> y <span class=\"token operator\" >===</span> knightY<span class=\"token punctuation\" >)</span> <span class=\"token operator\" >?</span>\n    <span class=\"token operator\" >&lt;</span><span class=\"token qualifier\" >Knight</span> <span class=\"token operator\" >/</span><span class=\"token operator\" >></span> <span class=\"token punctuation\" >:</span>\n    <span class=\"token primitive\" >null</span><span class=\"token punctuation\" >;</span>\n\n  <span class=\"token keyword\" >return</span> <span class=\"token punctuation\" >(</span>\n    <span class=\"token operator\" >&lt;</span>div key<span class=\"token operator\" >=</span><span class=\"token punctuation\" >{</span>i<span class=\"token punctuation\" >}</span>\n         style<span class=\"token operator\" >=</span><span class=\"token punctuation\" >{</span><span class=\"token punctuation\" >{</span> width<span class=\"token punctuation\" >:</span> <span class=\"token string\" >'12.5%'</span><span class=\"token punctuation\" >,</span> height<span class=\"token punctuation\" >:</span> <span class=\"token string\" >'12.5%'</span> <span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >}</span>\n         onClick<span class=\"token operator\" >=</span><span class=\"token punctuation\" >{</span><span class=\"token var\" >this</span><span class=\"token punctuation\" >.</span>handleSquareClick<span class=\"token punctuation\" >.</span><span class=\"token function\" >bind<span class=\"token punctuation\" >(</span></span><span class=\"token var\" >this</span><span class=\"token punctuation\" >,</span> x<span class=\"token punctuation\" >,</span> y<span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >}</span><span class=\"token operator\" >></span>\n      <span class=\"token operator\" >&lt;</span><span class=\"token qualifier\" >Square</span> black<span class=\"token operator\" >=</span><span class=\"token punctuation\" >{</span>black<span class=\"token punctuation\" >}</span><span class=\"token operator\" >></span>\n        <span class=\"token punctuation\" >{</span>piece<span class=\"token punctuation\" >}</span>\n      <span class=\"token operator\" >&lt;</span><span class=\"token operator\" >/</span><span class=\"token qualifier\" >Square</span><span class=\"token operator\" >></span>\n    <span class=\"token operator\" >&lt;</span><span class=\"token operator\" >/</span>div<span class=\"token operator\" >></span>\n  <span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n<span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >,</span>\n\nhandleSquareClick<span class=\"token punctuation\" >:</span> <span class=\"token block-keyword\" >function</span> <span class=\"token punctuation\" >(</span>toX<span class=\"token punctuation\" >,</span> toY<span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n  <span class=\"token function\" >moveKnight<span class=\"token punctuation\" >(</span></span>toX<span class=\"token punctuation\" >,</span> toY<span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n<span class=\"token punctuation\" >}</span></code><hr/>\n<code class=\"codeBlock\"><span class=\"token keyword\" >import</span> <span class=\"token qualifier\" >React</span><span class=\"token punctuation\" >,</span> <span class=\"token punctuation\" >{</span> <span class=\"token qualifier\" >Prop</span><span class=\"token qualifier\" >Types</span> <span class=\"token punctuation\" >}</span> from <span class=\"token string\" >'react'</span><span class=\"token punctuation\" >;</span>\n<span class=\"token keyword\" >import</span> <span class=\"token qualifier\" >Square</span> from <span class=\"token string\" >'./Square'</span><span class=\"token punctuation\" >;</span>\n<span class=\"token keyword\" >import</span> <span class=\"token qualifier\" >Knight</span> from <span class=\"token string\" >'./Knight'</span><span class=\"token punctuation\" >;</span>\n<span class=\"token keyword\" >import</span> <span class=\"token punctuation\" >{</span> moveKnight <span class=\"token punctuation\" >}</span> from <span class=\"token string\" >'./Game'</span><span class=\"token punctuation\" >;</span>\n\n<span class=\"token comment\" spellcheck=\"true\">/* ... */</span>\n\n<span class=\"token function\" >renderSquare<span class=\"token punctuation\" >(</span></span>i<span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n  <span class=\"token keyword\" >const</span> x <span class=\"token operator\" >=</span> i <span class=\"token operator\" >%</span> <span class=\"token number\" >8</span><span class=\"token punctuation\" >;</span>\n  <span class=\"token keyword\" >const</span> y <span class=\"token operator\" >=</span> <span class=\"token qualifier\" >Math</span><span class=\"token punctuation\" >.</span><span class=\"token function\" >floor<span class=\"token punctuation\" >(</span></span>i <span class=\"token operator\" >/</span> <span class=\"token number\" >8</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n  <span class=\"token keyword\" >const</span> black <span class=\"token operator\" >=</span> <span class=\"token punctuation\" >(</span>x <span class=\"token operator\" >+</span> y<span class=\"token punctuation\" >)</span> <span class=\"token operator\" >%</span> <span class=\"token number\" >2</span> <span class=\"token operator\" >===</span> <span class=\"token number\" >1</span><span class=\"token punctuation\" >;</span>\n\n  <span class=\"token keyword\" >const</span> <span class=\"token punctuation\" >[</span>knightX<span class=\"token punctuation\" >,</span> knightY<span class=\"token punctuation\" >]</span> <span class=\"token operator\" >=</span> <span class=\"token var\" >this</span><span class=\"token punctuation\" >.</span>props<span class=\"token punctuation\" >.</span>knightPosition<span class=\"token punctuation\" >;</span>\n  <span class=\"token keyword\" >const</span> piece <span class=\"token operator\" >=</span> <span class=\"token punctuation\" >(</span>x <span class=\"token operator\" >===</span> knightX <span class=\"token operator\" >&amp;&amp;</span> y <span class=\"token operator\" >===</span> knightY<span class=\"token punctuation\" >)</span> <span class=\"token operator\" >?</span>\n    <span class=\"token operator\" >&lt;</span><span class=\"token qualifier\" >Knight</span> <span class=\"token operator\" >/</span><span class=\"token operator\" >></span> <span class=\"token punctuation\" >:</span>\n    <span class=\"token primitive\" >null</span><span class=\"token punctuation\" >;</span>\n\n  <span class=\"token keyword\" >return</span> <span class=\"token punctuation\" >(</span>\n    <span class=\"token operator\" >&lt;</span>div key<span class=\"token operator\" >=</span><span class=\"token punctuation\" >{</span>i<span class=\"token punctuation\" >}</span>\n         style<span class=\"token operator\" >=</span><span class=\"token punctuation\" >{</span><span class=\"token punctuation\" >{</span> width<span class=\"token punctuation\" >:</span> <span class=\"token string\" >'12.5%'</span><span class=\"token punctuation\" >,</span> height<span class=\"token punctuation\" >:</span> <span class=\"token string\" >'12.5%'</span> <span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >}</span>\n         onClick<span class=\"token operator\" >=</span><span class=\"token punctuation\" >{</span><span class=\"token punctuation\" >(</span><span class=\"token punctuation\" >)</span> <span class=\"token operator\" >=</span><span class=\"token operator\" >></span> <span class=\"token var\" >this</span><span class=\"token punctuation\" >.</span><span class=\"token function\" >handleSquareClick<span class=\"token punctuation\" >(</span></span>x<span class=\"token punctuation\" >,</span> y<span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >}</span><span class=\"token operator\" >></span>\n      <span class=\"token operator\" >&lt;</span><span class=\"token qualifier\" >Square</span> black<span class=\"token operator\" >=</span><span class=\"token punctuation\" >{</span>black<span class=\"token punctuation\" >}</span><span class=\"token operator\" >></span>\n        <span class=\"token punctuation\" >{</span>piece<span class=\"token punctuation\" >}</span>\n      <span class=\"token operator\" >&lt;</span><span class=\"token operator\" >/</span><span class=\"token qualifier\" >Square</span><span class=\"token operator\" >></span>\n    <span class=\"token operator\" >&lt;</span><span class=\"token operator\" >/</span>div<span class=\"token operator\" >></span>\n  <span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n<span class=\"token punctuation\" >}</span>\n\n<span class=\"token function\" >handleSquareClick<span class=\"token punctuation\" >(</span></span>toX<span class=\"token punctuation\" >,</span> toY<span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n  <span class=\"token function\" >moveKnight<span class=\"token punctuation\" >(</span></span>toX<span class=\"token punctuation\" >,</span> toY<span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n<span class=\"token punctuation\" >}</span></code><hr/>\n<hr/>\n<p>We could have also added an <code>onClick</code> prop to <code>Square</code> and used it instead, but since we&#39;re going to remove the click handler in favor of the drag and drop interface later anyway, why bother.</p>\n<p>The last missing piece right now is the Chess rule check. The <code>Knight</code> can&#39;t just move to an arbitrary square, it is only allowed to make <a href=\"http://en.wikipedia.org/wiki/Knight_%28chess%29#Movement\">L-shaped moves</a>. I&#39;m adding a <code>canMoveKnight(toX, toY)</code> function to the <code>Game</code> and changing the initial position to A2 to match the Chess rules:</p>\n<hr/>\n<code class=\"codeBlock\"><span class=\"token keyword\" >var</span> knightPosition <span class=\"token operator\" >=</span> <span class=\"token punctuation\" >[</span><span class=\"token number\" >1</span><span class=\"token punctuation\" >,</span> <span class=\"token number\" >7</span><span class=\"token punctuation\" >]</span><span class=\"token punctuation\" >;</span>\n\n<span class=\"token comment\" spellcheck=\"true\">/* ... */</span>\n\nexports<span class=\"token punctuation\" >.</span>canMoveKnight <span class=\"token operator\" >=</span> <span class=\"token block-keyword\" >function</span> <span class=\"token punctuation\" >(</span>toX<span class=\"token punctuation\" >,</span> toY<span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n  <span class=\"token keyword\" >const</span> x <span class=\"token operator\" >=</span> knightPosition<span class=\"token punctuation\" >[</span><span class=\"token number\" >0</span><span class=\"token punctuation\" >]</span><span class=\"token punctuation\" >;</span>\n  <span class=\"token keyword\" >const</span> y <span class=\"token operator\" >=</span> knightPosition<span class=\"token punctuation\" >[</span><span class=\"token number\" >1</span><span class=\"token punctuation\" >]</span><span class=\"token punctuation\" >;</span>\n  <span class=\"token keyword\" >const</span> dx <span class=\"token operator\" >=</span> toX <span class=\"token operator\" >-</span> x<span class=\"token punctuation\" >;</span>\n  <span class=\"token keyword\" >const</span> dy <span class=\"token operator\" >=</span> toY <span class=\"token operator\" >-</span> y<span class=\"token punctuation\" >;</span>\n\n  <span class=\"token keyword\" >return</span> <span class=\"token punctuation\" >(</span><span class=\"token qualifier\" >Math</span><span class=\"token punctuation\" >.</span><span class=\"token function\" >abs<span class=\"token punctuation\" >(</span></span>dx<span class=\"token punctuation\" >)</span> <span class=\"token operator\" >===</span> <span class=\"token number\" >2</span> <span class=\"token operator\" >&amp;&amp;</span> <span class=\"token qualifier\" >Math</span><span class=\"token punctuation\" >.</span><span class=\"token function\" >abs<span class=\"token punctuation\" >(</span></span>dy<span class=\"token punctuation\" >)</span> <span class=\"token operator\" >===</span> <span class=\"token number\" >1</span><span class=\"token punctuation\" >)</span> <span class=\"token operator\" >||</span>\n         <span class=\"token punctuation\" >(</span><span class=\"token qualifier\" >Math</span><span class=\"token punctuation\" >.</span><span class=\"token function\" >abs<span class=\"token punctuation\" >(</span></span>dx<span class=\"token punctuation\" >)</span> <span class=\"token operator\" >===</span> <span class=\"token number\" >1</span> <span class=\"token operator\" >&amp;&amp;</span> <span class=\"token qualifier\" >Math</span><span class=\"token punctuation\" >.</span><span class=\"token function\" >abs<span class=\"token punctuation\" >(</span></span>dy<span class=\"token punctuation\" >)</span> <span class=\"token operator\" >===</span> <span class=\"token number\" >2</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n<span class=\"token punctuation\" >}</span></code><hr/>\n<code class=\"codeBlock\"><span class=\"token keyword\" >let</span> knightPosition <span class=\"token operator\" >=</span> <span class=\"token punctuation\" >[</span><span class=\"token number\" >1</span><span class=\"token punctuation\" >,</span> <span class=\"token number\" >7</span><span class=\"token punctuation\" >]</span><span class=\"token punctuation\" >;</span>\n\n<span class=\"token comment\" spellcheck=\"true\">/* ... */</span>\n\n<span class=\"token keyword\" >export</span> <span class=\"token block-keyword\" >function</span> <span class=\"token function\" >canMoveKnight<span class=\"token punctuation\" >(</span></span>toX<span class=\"token punctuation\" >,</span> toY<span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n  <span class=\"token keyword\" >const</span> <span class=\"token punctuation\" >[</span>x<span class=\"token punctuation\" >,</span> y<span class=\"token punctuation\" >]</span> <span class=\"token operator\" >=</span> knightPosition<span class=\"token punctuation\" >;</span>\n  <span class=\"token keyword\" >const</span> dx <span class=\"token operator\" >=</span> toX <span class=\"token operator\" >-</span> x<span class=\"token punctuation\" >;</span>\n  <span class=\"token keyword\" >const</span> dy <span class=\"token operator\" >=</span> toY <span class=\"token operator\" >-</span> y<span class=\"token punctuation\" >;</span>\n\n  <span class=\"token keyword\" >return</span> <span class=\"token punctuation\" >(</span><span class=\"token qualifier\" >Math</span><span class=\"token punctuation\" >.</span><span class=\"token function\" >abs<span class=\"token punctuation\" >(</span></span>dx<span class=\"token punctuation\" >)</span> <span class=\"token operator\" >===</span> <span class=\"token number\" >2</span> <span class=\"token operator\" >&amp;&amp;</span> <span class=\"token qualifier\" >Math</span><span class=\"token punctuation\" >.</span><span class=\"token function\" >abs<span class=\"token punctuation\" >(</span></span>dy<span class=\"token punctuation\" >)</span> <span class=\"token operator\" >===</span> <span class=\"token number\" >1</span><span class=\"token punctuation\" >)</span> <span class=\"token operator\" >||</span>\n         <span class=\"token punctuation\" >(</span><span class=\"token qualifier\" >Math</span><span class=\"token punctuation\" >.</span><span class=\"token function\" >abs<span class=\"token punctuation\" >(</span></span>dx<span class=\"token punctuation\" >)</span> <span class=\"token operator\" >===</span> <span class=\"token number\" >1</span> <span class=\"token operator\" >&amp;&amp;</span> <span class=\"token qualifier\" >Math</span><span class=\"token punctuation\" >.</span><span class=\"token function\" >abs<span class=\"token punctuation\" >(</span></span>dy<span class=\"token punctuation\" >)</span> <span class=\"token operator\" >===</span> <span class=\"token number\" >2</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n<span class=\"token punctuation\" >}</span></code><hr/>\n<hr/>\n<p>Finally, I&#39;m adding a <code>canMoveKnight</code> check to the <code>handleSquareClick</code> method:</p>\n<hr/>\n<code class=\"codeBlock\">handleSquareClick<span class=\"token punctuation\" >:</span> <span class=\"token block-keyword\" >function</span> <span class=\"token punctuation\" >(</span>toX<span class=\"token punctuation\" >,</span> toY<span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n  <span class=\"token block-keyword\" >if</span> <span class=\"token punctuation\" >(</span><span class=\"token function\" >canMoveKnight<span class=\"token punctuation\" >(</span></span>toX<span class=\"token punctuation\" >,</span> toY<span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n    <span class=\"token function\" >moveKnight<span class=\"token punctuation\" >(</span></span>toX<span class=\"token punctuation\" >,</span> toY<span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n  <span class=\"token punctuation\" >}</span>\n<span class=\"token punctuation\" >}</span></code><hr/>\n<code class=\"codeBlock\"><span class=\"token function\" >handleSquareClick<span class=\"token punctuation\" >(</span></span>toX<span class=\"token punctuation\" >,</span> toY<span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n  <span class=\"token block-keyword\" >if</span> <span class=\"token punctuation\" >(</span><span class=\"token function\" >canMoveKnight<span class=\"token punctuation\" >(</span></span>toX<span class=\"token punctuation\" >,</span> toY<span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n    <span class=\"token function\" >moveKnight<span class=\"token punctuation\" >(</span></span>toX<span class=\"token punctuation\" >,</span> toY<span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n  <span class=\"token punctuation\" >}</span>\n<span class=\"token punctuation\" >}</span></code><hr/>\n<hr/>\n<p><img src='https://s3.amazonaws.com/f.cl.ly/items/1F371u301l1H2X3o0g1h/Screen%20Recording%202015-05-15%20at%2012.08%20pm.gif' width='404' height='445' alt='Screenshot'></p>\n<p>Working great so far!</p>\n<h2>Adding the Drag and Drop Interaction<a id=\"adding-the-drag-and-drop-interaction\">&nbsp;</a></h2><p>This is the part that actually prompted me to write this tutorial. We are now going to see how easy React DnD makes it to add some drag and drop interaction to your existing components.</p>\n<p>This part assumes you are at least somewhat familiar with the concepts presented in the <a href=\"docs-overview.html\">overview</a>, such as the backends, the collecting functions, the types, the items, the drag sources, and the drop targets. If you didn&#39;t understand everything, it&#39;s fine, but make sure you at least give it a chance before jumping into the coding process.</p>\n<p>We&#39;re going to start by running <code>npm install --save react-dnd</code>. The first thing we need to set up in our app is the <a href=\"docs-drag-drop-context.html\"><code>DragDropContext</code></a>. We need it to specify that we&#39;re going to use the <a href=\"docs-html5-backend.html\"><code>HTML5</code> backend</a> in our app.</p>\n<p>Because the <code>Board</code> is the top-level component in our app, I&#39;m going to put the <a href=\"docs-drag-drop-context.html\"><code>DragDropContext</code></a> on it:</p>\n<hr/>\n<code class=\"codeBlock\"><span class=\"token keyword\" >var</span> <span class=\"token qualifier\" >React</span> <span class=\"token operator\" >=</span> <span class=\"token function\" >require<span class=\"token punctuation\" >(</span></span><span class=\"token string\" >'react'</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n<span class=\"token keyword\" >var</span> <span class=\"token qualifier\" >Drag</span><span class=\"token qualifier\" >Drop</span><span class=\"token qualifier\" >Context</span> <span class=\"token operator\" >=</span> <span class=\"token function\" >require<span class=\"token punctuation\" >(</span></span><span class=\"token string\" >'react-dnd'</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >.</span><span class=\"token qualifier\" >Drag</span><span class=\"token qualifier\" >Drop</span><span class=\"token qualifier\" >Context</span><span class=\"token punctuation\" >;</span>\n<span class=\"token keyword\" >var</span> HTML5Backend <span class=\"token operator\" >=</span> <span class=\"token function\" >require<span class=\"token punctuation\" >(</span></span><span class=\"token string\" >'react-dnd/modules/backends/HTML5'</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n\n<span class=\"token keyword\" >var</span> <span class=\"token qualifier\" >Board</span> <span class=\"token operator\" >=</span> <span class=\"token qualifier\" >React</span><span class=\"token punctuation\" >.</span><span class=\"token function\" >createClass<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >{</span>\n  <span class=\"token comment\" spellcheck=\"true\">/* ... */</span>\n<span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n\nmodule<span class=\"token punctuation\" >.</span>exports <span class=\"token operator\" >=</span> <span class=\"token function\" >DragDropContext<span class=\"token punctuation\" >(</span></span>HTML5Backend<span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >(</span><span class=\"token qualifier\" >Board</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span></code><hr/>\n<code class=\"codeBlock\"><span class=\"token keyword\" >import</span> <span class=\"token qualifier\" >React</span> from <span class=\"token string\" >'react'</span><span class=\"token punctuation\" >;</span>\n<span class=\"token keyword\" >import</span> <span class=\"token punctuation\" >{</span> <span class=\"token qualifier\" >Drag</span><span class=\"token qualifier\" >Drop</span><span class=\"token qualifier\" >Context</span> <span class=\"token punctuation\" >}</span> from <span class=\"token string\" >'react-dnd'</span><span class=\"token punctuation\" >;</span>\n<span class=\"token keyword\" >import</span> HTML5Backend from <span class=\"token string\" >'react-dnd/modules/backends/HTML5'</span><span class=\"token punctuation\" >;</span>\n\n<span class=\"token keyword\" >class</span> <span class=\"token class-name\" >Board</span> <span class=\"token punctuation\" >{</span>\n  <span class=\"token comment\" spellcheck=\"true\">/* ... */</span>\n<span class=\"token punctuation\" >}</span>\n\n<span class=\"token keyword\" >export</span> <span class=\"token keyword\" >default</span> <span class=\"token function\" >DragDropContext<span class=\"token punctuation\" >(</span></span>HTML5Backend<span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >(</span><span class=\"token qualifier\" >Board</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span></code><hr/>\n<code class=\"codeBlock\"><span class=\"token keyword\" >import</span> <span class=\"token qualifier\" >React</span> from <span class=\"token string\" >'react'</span><span class=\"token punctuation\" >;</span>\n<span class=\"token keyword\" >import</span> <span class=\"token punctuation\" >{</span> <span class=\"token qualifier\" >Drag</span><span class=\"token qualifier\" >Drop</span><span class=\"token qualifier\" >Context</span> <span class=\"token punctuation\" >}</span> from <span class=\"token string\" >'react-dnd'</span><span class=\"token punctuation\" >;</span>\n<span class=\"token keyword\" >import</span> HTML5Backend from <span class=\"token string\" >'react-dnd/modules/backends/HTML5'</span><span class=\"token punctuation\" >;</span>\n\n@<span class=\"token function\" >DragDropContext<span class=\"token punctuation\" >(</span></span>HTML5Backend<span class=\"token punctuation\" >)</span>\n<span class=\"token keyword\" >export</span> <span class=\"token keyword\" >default</span> <span class=\"token keyword\" >class</span> <span class=\"token class-name\" >Board</span> <span class=\"token punctuation\" >{</span>\n  <span class=\"token comment\" spellcheck=\"true\">/* ... */</span>\n<span class=\"token punctuation\" >}</span></code><hr/>\n<p>Next, I&#39;m going to create the constants for the draggable item types. We&#39;re only going to have a single item type in our game, a <code>KNIGHT</code>. I&#39;m creating a <code>Constants</code> module that exports it:</p>\n<hr/>\n<code class=\"codeBlock\">exports<span class=\"token punctuation\" >.</span><span class=\"token qualifier\" >Item</span><span class=\"token qualifier\" >Types</span> <span class=\"token operator\" >=</span> <span class=\"token punctuation\" >{</span>\n  KNIGHT<span class=\"token punctuation\" >:</span> <span class=\"token string\" >'knight'</span>\n<span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >;</span></code><hr/>\n<code class=\"codeBlock\"><span class=\"token keyword\" >export</span> <span class=\"token keyword\" >const</span> <span class=\"token qualifier\" >Item</span><span class=\"token qualifier\" >Types</span> <span class=\"token operator\" >=</span> <span class=\"token punctuation\" >{</span>\n  KNIGHT<span class=\"token punctuation\" >:</span> <span class=\"token string\" >'knight'</span>\n<span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >;</span></code><hr/>\n<hr/>\n<p>The preparation work is done now. Let&#39;s make the <code>Knight</code> draggable!</p>\n<p>The <a href=\"http://localhost:8080/docs-drag-source.html\"><code>DragSource</code></a> higher-order component accepts three parameters: <code>type</code>, <code>spec</code>, and <code>collect</code>. Our <code>type</code> is the constant we just defined, so now we need to write a drag source specification and a collecting function. For the <code>Knight</code>, the drag source specification is going to be ridiculously simple:</p>\n<hr/>\n<code class=\"codeBlock\"><span class=\"token keyword\" >var</span> knightSource <span class=\"token operator\" >=</span> <span class=\"token punctuation\" >{</span>\n  beginDrag<span class=\"token punctuation\" >:</span> <span class=\"token block-keyword\" >function</span> <span class=\"token punctuation\" >(</span>props<span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n    <span class=\"token keyword\" >return</span> <span class=\"token punctuation\" >{</span><span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >;</span>\n  <span class=\"token punctuation\" >}</span>\n<span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >;</span></code><hr/>\n<code class=\"codeBlock\"><span class=\"token keyword\" >const</span> knightSource <span class=\"token operator\" >=</span> <span class=\"token punctuation\" >{</span>\n  <span class=\"token function\" >beginDrag<span class=\"token punctuation\" >(</span></span>props<span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n    <span class=\"token keyword\" >return</span> <span class=\"token punctuation\" >{</span><span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >;</span>\n  <span class=\"token punctuation\" >}</span>\n<span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >;</span></code><hr/>\n<hr/>\n<p>This is because there is nothing to describe: there is literally a single draggable object in the whole application! If we had a bunch of chess pieces, it might be a good idea to use the <code>props</code> parameter and return something like <code>{ pieceId: props.id }</code>. In our case, an empty object will suffice.</p>\n<p>Next, we&#39;re going to write a collecting function. What props does the <code>Knight</code> need? It will sure need a way to specify the drag source node. It would also be nice to slightly dim the <code>Knight</code>&#39;s opacity while it is being dragged. Therefore, it needs to know whether it is currently being dragged.</p>\n<p>Here is the collecting function I wrote for it:</p>\n<code class=\"codeBlock\"><span class=\"token block-keyword\" >function</span> <span class=\"token function\" >collect<span class=\"token punctuation\" >(</span></span>connect<span class=\"token punctuation\" >,</span> monitor<span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n  <span class=\"token keyword\" >return</span> <span class=\"token punctuation\" >{</span>\n    connectDragSource<span class=\"token punctuation\" >:</span> connect<span class=\"token punctuation\" >.</span><span class=\"token function\" >dragSource<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >,</span>\n    isDragging<span class=\"token punctuation\" >:</span> monitor<span class=\"token punctuation\" >.</span><span class=\"token function\" >isDragging<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span>\n  <span class=\"token punctuation\" >}</span>\n<span class=\"token punctuation\" >}</span></code><p>Let&#39;s take a look at the whole <code>Knight</code> component now, including the <code>DragSource</code> call and the updated <code>render</code> function:</p>\n<hr/>\n<code class=\"codeBlock\"><span class=\"token keyword\" >var</span> <span class=\"token qualifier\" >React</span> <span class=\"token operator\" >=</span> <span class=\"token function\" >require<span class=\"token punctuation\" >(</span></span><span class=\"token string\" >'react'</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n<span class=\"token keyword\" >var</span> <span class=\"token qualifier\" >Prop</span><span class=\"token qualifier\" >Types</span> <span class=\"token operator\" >=</span> <span class=\"token qualifier\" >React</span><span class=\"token punctuation\" >.</span><span class=\"token qualifier\" >Prop</span><span class=\"token qualifier\" >Types</span><span class=\"token punctuation\" >;</span>\n<span class=\"token keyword\" >var</span> <span class=\"token qualifier\" >Item</span><span class=\"token qualifier\" >Types</span> <span class=\"token operator\" >=</span> <span class=\"token function\" >require<span class=\"token punctuation\" >(</span></span><span class=\"token string\" >'./Constants'</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >.</span><span class=\"token qualifier\" >Item</span><span class=\"token qualifier\" >Types</span><span class=\"token punctuation\" >;</span>\n<span class=\"token keyword\" >var</span> <span class=\"token qualifier\" >Drag</span><span class=\"token qualifier\" >Source</span> <span class=\"token operator\" >=</span> <span class=\"token function\" >require<span class=\"token punctuation\" >(</span></span><span class=\"token string\" >'react-dnd'</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >.</span><span class=\"token qualifier\" >Drag</span><span class=\"token qualifier\" >Source</span><span class=\"token punctuation\" >;</span>\n\n<span class=\"token keyword\" >var</span> knightSource <span class=\"token operator\" >=</span> <span class=\"token punctuation\" >{</span>\n  beginDrag<span class=\"token punctuation\" >:</span> <span class=\"token block-keyword\" >function</span> <span class=\"token punctuation\" >(</span>props<span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n    <span class=\"token keyword\" >return</span> <span class=\"token punctuation\" >{</span><span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >;</span>\n  <span class=\"token punctuation\" >}</span>\n<span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >;</span>\n\n<span class=\"token block-keyword\" >function</span> <span class=\"token function\" >collect<span class=\"token punctuation\" >(</span></span>connect<span class=\"token punctuation\" >,</span> monitor<span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n  <span class=\"token keyword\" >return</span> <span class=\"token punctuation\" >{</span>\n    connectDragSource<span class=\"token punctuation\" >:</span> connect<span class=\"token punctuation\" >.</span><span class=\"token function\" >dragSource<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >,</span>\n    isDragging<span class=\"token punctuation\" >:</span> monitor<span class=\"token punctuation\" >.</span><span class=\"token function\" >isDragging<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span>\n  <span class=\"token punctuation\" >}</span>\n<span class=\"token punctuation\" >}</span>\n\n<span class=\"token keyword\" >var</span> <span class=\"token qualifier\" >Knight</span> <span class=\"token operator\" >=</span> <span class=\"token qualifier\" >React</span><span class=\"token punctuation\" >.</span><span class=\"token function\" >createClass<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >{</span>\n  propTypes<span class=\"token punctuation\" >:</span> <span class=\"token punctuation\" >{</span>\n    connectDragSource<span class=\"token punctuation\" >:</span> <span class=\"token qualifier\" >Prop</span><span class=\"token qualifier\" >Types</span><span class=\"token punctuation\" >.</span>func<span class=\"token punctuation\" >.</span>isRequired<span class=\"token punctuation\" >,</span>\n    isDragging<span class=\"token punctuation\" >:</span> <span class=\"token qualifier\" >Prop</span><span class=\"token qualifier\" >Types</span><span class=\"token punctuation\" >.</span>bool<span class=\"token punctuation\" >.</span>isRequired\n  <span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >,</span>\n\n  render<span class=\"token punctuation\" >:</span> <span class=\"token block-keyword\" >function</span> <span class=\"token punctuation\" >(</span><span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n    <span class=\"token keyword\" >var</span> connectDragSource <span class=\"token operator\" >=</span> <span class=\"token var\" >this</span><span class=\"token punctuation\" >.</span>props<span class=\"token punctuation\" >.</span>connectDragSource<span class=\"token punctuation\" >;</span>\n    <span class=\"token keyword\" >var</span> isDragging <span class=\"token operator\" >=</span> <span class=\"token var\" >this</span><span class=\"token punctuation\" >.</span>props<span class=\"token punctuation\" >.</span>isDragging<span class=\"token punctuation\" >;</span>\n\n    <span class=\"token keyword\" >return</span> <span class=\"token function\" >connectDragSource<span class=\"token punctuation\" >(</span></span>\n      <span class=\"token operator\" >&lt;</span>div style<span class=\"token operator\" >=</span><span class=\"token punctuation\" >{</span><span class=\"token punctuation\" >{</span>\n        opacity<span class=\"token punctuation\" >:</span> isDragging <span class=\"token operator\" >?</span> <span class=\"token number\" >0.5</span> <span class=\"token punctuation\" >:</span> <span class=\"token number\" >1</span><span class=\"token punctuation\" >,</span>\n        fontSize<span class=\"token punctuation\" >:</span> <span class=\"token number\" >25</span><span class=\"token punctuation\" >,</span>\n        fontWeight<span class=\"token punctuation\" >:</span> <span class=\"token string\" >'bold'</span><span class=\"token punctuation\" >,</span>\n        cursor<span class=\"token punctuation\" >:</span> <span class=\"token string\" >'move'</span>\n      <span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >}</span><span class=\"token operator\" >></span>\n        ♘\n      <span class=\"token operator\" >&lt;</span><span class=\"token operator\" >/</span>div<span class=\"token operator\" >></span>\n    <span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n  <span class=\"token punctuation\" >}</span>\n<span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n\nmodule<span class=\"token punctuation\" >.</span>exports <span class=\"token operator\" >=</span> <span class=\"token function\" >DragSource<span class=\"token punctuation\" >(</span></span><span class=\"token qualifier\" >Item</span><span class=\"token qualifier\" >Types</span><span class=\"token punctuation\" >.</span>KNIGHT<span class=\"token punctuation\" >,</span> knightSource<span class=\"token punctuation\" >,</span> collect<span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >(</span><span class=\"token qualifier\" >Knight</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span></code><hr/>\n<code class=\"codeBlock\"><span class=\"token keyword\" >import</span> <span class=\"token qualifier\" >React</span><span class=\"token punctuation\" >,</span> <span class=\"token punctuation\" >{</span> <span class=\"token qualifier\" >Prop</span><span class=\"token qualifier\" >Types</span> <span class=\"token punctuation\" >}</span> from <span class=\"token string\" >'react'</span><span class=\"token punctuation\" >;</span>\n<span class=\"token keyword\" >import</span> <span class=\"token punctuation\" >{</span> <span class=\"token qualifier\" >Item</span><span class=\"token qualifier\" >Types</span> <span class=\"token punctuation\" >}</span> from <span class=\"token string\" >'./Constants'</span><span class=\"token punctuation\" >;</span>\n<span class=\"token keyword\" >import</span> <span class=\"token punctuation\" >{</span> <span class=\"token qualifier\" >Drag</span><span class=\"token qualifier\" >Source</span> <span class=\"token punctuation\" >}</span> from <span class=\"token string\" >'react-dnd'</span><span class=\"token punctuation\" >;</span>\n\n<span class=\"token keyword\" >const</span> knightSource <span class=\"token operator\" >=</span> <span class=\"token punctuation\" >{</span>\n  <span class=\"token function\" >beginDrag<span class=\"token punctuation\" >(</span></span>props<span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n    <span class=\"token keyword\" >return</span> <span class=\"token punctuation\" >{</span><span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >;</span>\n  <span class=\"token punctuation\" >}</span>\n<span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >;</span>\n\n<span class=\"token block-keyword\" >function</span> <span class=\"token function\" >collect<span class=\"token punctuation\" >(</span></span>connect<span class=\"token punctuation\" >,</span> monitor<span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n  <span class=\"token keyword\" >return</span> <span class=\"token punctuation\" >{</span>\n    connectDragSource<span class=\"token punctuation\" >:</span> connect<span class=\"token punctuation\" >.</span><span class=\"token function\" >dragSource<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >,</span>\n    isDragging<span class=\"token punctuation\" >:</span> monitor<span class=\"token punctuation\" >.</span><span class=\"token function\" >isDragging<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span>\n  <span class=\"token punctuation\" >}</span>\n<span class=\"token punctuation\" >}</span>\n\n<span class=\"token keyword\" >class</span> <span class=\"token class-name\" >Knight</span> <span class=\"token punctuation\" >{</span>\n  <span class=\"token function\" >render<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n    <span class=\"token keyword\" >const</span> <span class=\"token punctuation\" >{</span> connectDragSource<span class=\"token punctuation\" >,</span> isDragging <span class=\"token punctuation\" >}</span> <span class=\"token operator\" >=</span> <span class=\"token var\" >this</span><span class=\"token punctuation\" >.</span>props<span class=\"token punctuation\" >;</span>\n    <span class=\"token keyword\" >return</span> <span class=\"token function\" >connectDragSource<span class=\"token punctuation\" >(</span></span>\n      <span class=\"token operator\" >&lt;</span>div style<span class=\"token operator\" >=</span><span class=\"token punctuation\" >{</span><span class=\"token punctuation\" >{</span>\n        opacity<span class=\"token punctuation\" >:</span> isDragging <span class=\"token operator\" >?</span> <span class=\"token number\" >0.5</span> <span class=\"token punctuation\" >:</span> <span class=\"token number\" >1</span><span class=\"token punctuation\" >,</span>\n        fontSize<span class=\"token punctuation\" >:</span> <span class=\"token number\" >25</span><span class=\"token punctuation\" >,</span>\n        fontWeight<span class=\"token punctuation\" >:</span> <span class=\"token string\" >'bold'</span><span class=\"token punctuation\" >,</span>\n        cursor<span class=\"token punctuation\" >:</span> <span class=\"token string\" >'move'</span>\n      <span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >}</span><span class=\"token operator\" >></span>\n        ♘\n      <span class=\"token operator\" >&lt;</span><span class=\"token operator\" >/</span>div<span class=\"token operator\" >></span>\n    <span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n  <span class=\"token punctuation\" >}</span>\n<span class=\"token punctuation\" >}</span>\n\n<span class=\"token qualifier\" >Knight</span><span class=\"token punctuation\" >.</span>propTypes <span class=\"token operator\" >=</span> <span class=\"token punctuation\" >{</span>\n  connectDragSource<span class=\"token punctuation\" >:</span> <span class=\"token qualifier\" >Prop</span><span class=\"token qualifier\" >Types</span><span class=\"token punctuation\" >.</span>func<span class=\"token punctuation\" >.</span>isRequired<span class=\"token punctuation\" >,</span>\n  isDragging<span class=\"token punctuation\" >:</span> <span class=\"token qualifier\" >Prop</span><span class=\"token qualifier\" >Types</span><span class=\"token punctuation\" >.</span>bool<span class=\"token punctuation\" >.</span>isRequired\n<span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >;</span>\n\n<span class=\"token keyword\" >export</span> <span class=\"token keyword\" >default</span> <span class=\"token function\" >DragSource<span class=\"token punctuation\" >(</span></span><span class=\"token qualifier\" >Item</span><span class=\"token qualifier\" >Types</span><span class=\"token punctuation\" >.</span>KNIGHT<span class=\"token punctuation\" >,</span> knightSource<span class=\"token punctuation\" >,</span> collect<span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >(</span><span class=\"token qualifier\" >Knight</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span></code><hr/>\n<code class=\"codeBlock\"><span class=\"token keyword\" >import</span> <span class=\"token qualifier\" >React</span><span class=\"token punctuation\" >,</span> <span class=\"token punctuation\" >{</span> <span class=\"token qualifier\" >Prop</span><span class=\"token qualifier\" >Types</span> <span class=\"token punctuation\" >}</span> from <span class=\"token string\" >'react'</span><span class=\"token punctuation\" >;</span>\n<span class=\"token keyword\" >import</span> <span class=\"token punctuation\" >{</span> <span class=\"token qualifier\" >Item</span><span class=\"token qualifier\" >Types</span> <span class=\"token punctuation\" >}</span> from <span class=\"token string\" >'./Constants'</span><span class=\"token punctuation\" >;</span>\n<span class=\"token keyword\" >import</span> <span class=\"token punctuation\" >{</span> <span class=\"token qualifier\" >Drag</span><span class=\"token qualifier\" >Source</span> <span class=\"token punctuation\" >}</span> from <span class=\"token string\" >'react-dnd'</span><span class=\"token punctuation\" >;</span>\n\n<span class=\"token keyword\" >const</span> knightSource <span class=\"token operator\" >=</span> <span class=\"token punctuation\" >{</span>\n  <span class=\"token function\" >beginDrag<span class=\"token punctuation\" >(</span></span>props<span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n    <span class=\"token keyword\" >return</span> <span class=\"token punctuation\" >{</span><span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >;</span>\n  <span class=\"token punctuation\" >}</span>\n<span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >;</span>\n\n<span class=\"token block-keyword\" >function</span> <span class=\"token function\" >collect<span class=\"token punctuation\" >(</span></span>connect<span class=\"token punctuation\" >,</span> monitor<span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n  <span class=\"token keyword\" >return</span> <span class=\"token punctuation\" >{</span>\n    connectDragSource<span class=\"token punctuation\" >:</span> connect<span class=\"token punctuation\" >.</span><span class=\"token function\" >dragSource<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >,</span>\n    isDragging<span class=\"token punctuation\" >:</span> monitor<span class=\"token punctuation\" >.</span><span class=\"token function\" >isDragging<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span>\n  <span class=\"token punctuation\" >}</span>\n<span class=\"token punctuation\" >}</span>\n\n@<span class=\"token function\" >DragSource<span class=\"token punctuation\" >(</span></span><span class=\"token qualifier\" >Item</span><span class=\"token qualifier\" >Types</span><span class=\"token punctuation\" >.</span>KNIGHT<span class=\"token punctuation\" >,</span> knightSource<span class=\"token punctuation\" >,</span> collect<span class=\"token punctuation\" >)</span>\n<span class=\"token keyword\" >export</span> <span class=\"token keyword\" >default</span> <span class=\"token keyword\" >class</span> <span class=\"token class-name\" >Knight</span> <span class=\"token punctuation\" >{</span>\n  <span class=\"token keyword\" >static</span> propTypes <span class=\"token operator\" >=</span> <span class=\"token punctuation\" >{</span>\n    connectDragSource<span class=\"token punctuation\" >:</span> <span class=\"token qualifier\" >Prop</span><span class=\"token qualifier\" >Types</span><span class=\"token punctuation\" >.</span>func<span class=\"token punctuation\" >.</span>isRequired<span class=\"token punctuation\" >,</span>\n    isDragging<span class=\"token punctuation\" >:</span> <span class=\"token qualifier\" >Prop</span><span class=\"token qualifier\" >Types</span><span class=\"token punctuation\" >.</span>bool<span class=\"token punctuation\" >.</span>isRequired\n  <span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >;</span>\n\n  <span class=\"token function\" >render<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n    <span class=\"token keyword\" >const</span> <span class=\"token punctuation\" >{</span> connectDragSource<span class=\"token punctuation\" >,</span> isDragging <span class=\"token punctuation\" >}</span> <span class=\"token operator\" >=</span> <span class=\"token var\" >this</span><span class=\"token punctuation\" >.</span>props<span class=\"token punctuation\" >;</span>\n    <span class=\"token keyword\" >return</span> <span class=\"token function\" >connectDragSource<span class=\"token punctuation\" >(</span></span>\n      <span class=\"token operator\" >&lt;</span>div style<span class=\"token operator\" >=</span><span class=\"token punctuation\" >{</span><span class=\"token punctuation\" >{</span>\n        opacity<span class=\"token punctuation\" >:</span> isDragging <span class=\"token operator\" >?</span> <span class=\"token number\" >0.5</span> <span class=\"token punctuation\" >:</span> <span class=\"token number\" >1</span><span class=\"token punctuation\" >,</span>\n        fontSize<span class=\"token punctuation\" >:</span> <span class=\"token number\" >25</span><span class=\"token punctuation\" >,</span>\n        fontWeight<span class=\"token punctuation\" >:</span> <span class=\"token string\" >'bold'</span><span class=\"token punctuation\" >,</span>\n        cursor<span class=\"token punctuation\" >:</span> <span class=\"token string\" >'move'</span>\n      <span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >}</span><span class=\"token operator\" >></span>\n        ♘\n      <span class=\"token operator\" >&lt;</span><span class=\"token operator\" >/</span>div<span class=\"token operator\" >></span>\n    <span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n  <span class=\"token punctuation\" >}</span>\n<span class=\"token punctuation\" >}</span></code><hr/>\n<p><img src='https://s3.amazonaws.com/f.cl.ly/items/3L1d0C203C0s1r1H2H0m/Screen%20Recording%202015-05-15%20at%2001.11%20pm.gif' width='404' height='445' alt='Screenshot'></p>\n<p>The <code>Knight</code> is now a drag source, but there are no drop targets to handle the drop yet. We&#39;re going to make the <code>Square</code> a drop target now.</p>\n<p>This time, we can&#39;t avoid passing the position to the <code>Square</code>. After all, how can the <code>Square</code> know where to move the dragged knight if the <code>Square</code> doesn&#39;t know its own position? On the other hand, it still feels wrong because the <code>Square</code> as an entity in our application has not changed, and if it used to be simple, why complicate it? When you face this dilemma, it&#39;s time to separate the <a href=\"https://medium.com/@dan_abramov/smart-and-dumb-components-7ca2f9a7c7d0\">smart and dumb components</a>.</p>\n<p>I&#39;m going to introduce a new component called the <code>BoardSquare</code>. It renders the good old <code>Square</code>, but is also aware of its position. In fact, it&#39;s encapsulating some of the logic that the <code>renderSquare</code> method inside the <code>Board</code> used to do. React components are often extracted from such render submethods when the time is right.</p>\n<p>Here is the <code>BoardSquare</code> I extracted:</p>\n<hr/>\n<code class=\"codeBlock\"><span class=\"token keyword\" >var</span> <span class=\"token qualifier\" >React</span> <span class=\"token operator\" >=</span> <span class=\"token function\" >require<span class=\"token punctuation\" >(</span></span><span class=\"token string\" >'react'</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n<span class=\"token keyword\" >var</span> <span class=\"token qualifier\" >Prop</span><span class=\"token qualifier\" >Types</span> <span class=\"token operator\" >=</span> <span class=\"token qualifier\" >React</span><span class=\"token punctuation\" >.</span><span class=\"token qualifier\" >Prop</span><span class=\"token qualifier\" >Types</span><span class=\"token punctuation\" >;</span>\n<span class=\"token keyword\" >var</span> <span class=\"token qualifier\" >Square</span> <span class=\"token operator\" >=</span> <span class=\"token function\" >require<span class=\"token punctuation\" >(</span></span><span class=\"token string\" >'./Square'</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n\n<span class=\"token keyword\" >var</span> <span class=\"token qualifier\" >Board</span><span class=\"token qualifier\" >Square</span> <span class=\"token operator\" >=</span> <span class=\"token qualifier\" >React</span><span class=\"token punctuation\" >.</span><span class=\"token function\" >createClass<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >{</span>\n  propTypes<span class=\"token punctuation\" >:</span> <span class=\"token punctuation\" >{</span>\n    x<span class=\"token punctuation\" >:</span> <span class=\"token qualifier\" >Prop</span><span class=\"token qualifier\" >Types</span><span class=\"token punctuation\" >.</span>number<span class=\"token punctuation\" >.</span>isRequired<span class=\"token punctuation\" >,</span>\n    y<span class=\"token punctuation\" >:</span> <span class=\"token qualifier\" >Prop</span><span class=\"token qualifier\" >Types</span><span class=\"token punctuation\" >.</span>number<span class=\"token punctuation\" >.</span>isRequired\n  <span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >,</span>\n\n  render<span class=\"token punctuation\" >:</span> <span class=\"token block-keyword\" >function</span> <span class=\"token punctuation\" >(</span><span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n    <span class=\"token keyword\" >var</span> x <span class=\"token operator\" >=</span> <span class=\"token var\" >this</span><span class=\"token punctuation\" >.</span>props<span class=\"token punctuation\" >.</span>x<span class=\"token punctuation\" >;</span>\n    <span class=\"token keyword\" >var</span> y <span class=\"token operator\" >=</span> <span class=\"token var\" >this</span><span class=\"token punctuation\" >.</span>props<span class=\"token punctuation\" >.</span>y<span class=\"token punctuation\" >;</span>\n    <span class=\"token keyword\" >var</span> black <span class=\"token operator\" >=</span> <span class=\"token punctuation\" >(</span>x <span class=\"token operator\" >+</span> y<span class=\"token punctuation\" >)</span> <span class=\"token operator\" >%</span> <span class=\"token number\" >2</span> <span class=\"token operator\" >===</span> <span class=\"token number\" >1</span><span class=\"token punctuation\" >;</span>\n\n    <span class=\"token keyword\" >return</span> <span class=\"token punctuation\" >(</span>\n      <span class=\"token operator\" >&lt;</span><span class=\"token qualifier\" >Square</span> black<span class=\"token operator\" >=</span><span class=\"token punctuation\" >{</span>black<span class=\"token punctuation\" >}</span><span class=\"token operator\" >></span>\n        <span class=\"token punctuation\" >{</span><span class=\"token var\" >this</span><span class=\"token punctuation\" >.</span>props<span class=\"token punctuation\" >.</span>children<span class=\"token punctuation\" >}</span>\n      <span class=\"token operator\" >&lt;</span><span class=\"token operator\" >/</span><span class=\"token qualifier\" >Square</span><span class=\"token operator\" >></span>\n    <span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n  <span class=\"token punctuation\" >}</span>\n<span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n\nmodule<span class=\"token punctuation\" >.</span>exports <span class=\"token operator\" >=</span> <span class=\"token qualifier\" >Board</span><span class=\"token qualifier\" >Square</span><span class=\"token punctuation\" >;</span></code><hr/>\n<code class=\"codeBlock\"><span class=\"token keyword\" >import</span> <span class=\"token qualifier\" >React</span><span class=\"token punctuation\" >,</span> <span class=\"token punctuation\" >{</span> <span class=\"token qualifier\" >Prop</span><span class=\"token qualifier\" >Types</span> <span class=\"token punctuation\" >}</span> from <span class=\"token string\" >'react'</span><span class=\"token punctuation\" >;</span>\n<span class=\"token keyword\" >import</span> <span class=\"token qualifier\" >Square</span> from <span class=\"token string\" >'./Square'</span><span class=\"token punctuation\" >;</span>\n\n<span class=\"token keyword\" >export</span> <span class=\"token keyword\" >default</span> <span class=\"token keyword\" >class</span> <span class=\"token class-name\" >BoardSquare</span> <span class=\"token punctuation\" >{</span>\n  <span class=\"token function\" >render<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n    <span class=\"token keyword\" >const</span> <span class=\"token punctuation\" >{</span> x<span class=\"token punctuation\" >,</span> y <span class=\"token punctuation\" >}</span> <span class=\"token operator\" >=</span> <span class=\"token var\" >this</span><span class=\"token punctuation\" >.</span>props<span class=\"token punctuation\" >;</span>\n    <span class=\"token keyword\" >const</span> black <span class=\"token operator\" >=</span> <span class=\"token punctuation\" >(</span>x <span class=\"token operator\" >+</span> y<span class=\"token punctuation\" >)</span> <span class=\"token operator\" >%</span> <span class=\"token number\" >2</span> <span class=\"token operator\" >===</span> <span class=\"token number\" >1</span><span class=\"token punctuation\" >;</span>\n\n    <span class=\"token keyword\" >return</span> <span class=\"token punctuation\" >(</span>\n      <span class=\"token operator\" >&lt;</span><span class=\"token qualifier\" >Square</span> black<span class=\"token operator\" >=</span><span class=\"token punctuation\" >{</span>black<span class=\"token punctuation\" >}</span><span class=\"token operator\" >></span>\n        <span class=\"token punctuation\" >{</span><span class=\"token var\" >this</span><span class=\"token punctuation\" >.</span>props<span class=\"token punctuation\" >.</span>children<span class=\"token punctuation\" >}</span>\n      <span class=\"token operator\" >&lt;</span><span class=\"token operator\" >/</span><span class=\"token qualifier\" >Square</span><span class=\"token operator\" >></span>\n    <span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n  <span class=\"token punctuation\" >}</span>\n<span class=\"token punctuation\" >}</span>\n\n<span class=\"token qualifier\" >Board</span><span class=\"token qualifier\" >Square</span><span class=\"token punctuation\" >.</span>propTypes <span class=\"token operator\" >=</span> <span class=\"token punctuation\" >{</span>\n  x<span class=\"token punctuation\" >:</span> <span class=\"token qualifier\" >Prop</span><span class=\"token qualifier\" >Types</span><span class=\"token punctuation\" >.</span>number<span class=\"token punctuation\" >.</span>isRequired<span class=\"token punctuation\" >,</span>\n  y<span class=\"token punctuation\" >:</span> <span class=\"token qualifier\" >Prop</span><span class=\"token qualifier\" >Types</span><span class=\"token punctuation\" >.</span>number<span class=\"token punctuation\" >.</span>isRequired\n<span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >;</span></code><hr/>\n<code class=\"codeBlock\"><span class=\"token keyword\" >import</span> <span class=\"token qualifier\" >React</span><span class=\"token punctuation\" >,</span> <span class=\"token punctuation\" >{</span> <span class=\"token qualifier\" >Prop</span><span class=\"token qualifier\" >Types</span> <span class=\"token punctuation\" >}</span> from <span class=\"token string\" >'react'</span><span class=\"token punctuation\" >;</span>\n<span class=\"token keyword\" >import</span> <span class=\"token qualifier\" >Square</span> from <span class=\"token string\" >'./Square'</span><span class=\"token punctuation\" >;</span>\n\n<span class=\"token keyword\" >export</span> <span class=\"token keyword\" >default</span> <span class=\"token keyword\" >class</span> <span class=\"token class-name\" >BoardSquare</span> <span class=\"token punctuation\" >{</span>\n  <span class=\"token keyword\" >static</span> propTypes <span class=\"token operator\" >=</span> <span class=\"token punctuation\" >{</span>\n    x<span class=\"token punctuation\" >:</span> <span class=\"token qualifier\" >Prop</span><span class=\"token qualifier\" >Types</span><span class=\"token punctuation\" >.</span>number<span class=\"token punctuation\" >.</span>isRequired<span class=\"token punctuation\" >,</span>\n    y<span class=\"token punctuation\" >:</span> <span class=\"token qualifier\" >Prop</span><span class=\"token qualifier\" >Types</span><span class=\"token punctuation\" >.</span>number<span class=\"token punctuation\" >.</span>isRequired\n  <span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >;</span>\n\n  <span class=\"token function\" >render<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n    <span class=\"token keyword\" >const</span> <span class=\"token punctuation\" >{</span> x<span class=\"token punctuation\" >,</span> y <span class=\"token punctuation\" >}</span> <span class=\"token operator\" >=</span> <span class=\"token var\" >this</span><span class=\"token punctuation\" >.</span>props<span class=\"token punctuation\" >;</span>\n    <span class=\"token keyword\" >const</span> black <span class=\"token operator\" >=</span> <span class=\"token punctuation\" >(</span>x <span class=\"token operator\" >+</span> y<span class=\"token punctuation\" >)</span> <span class=\"token operator\" >%</span> <span class=\"token number\" >2</span> <span class=\"token operator\" >===</span> <span class=\"token number\" >1</span><span class=\"token punctuation\" >;</span>\n\n    <span class=\"token keyword\" >return</span> <span class=\"token punctuation\" >(</span>\n      <span class=\"token operator\" >&lt;</span><span class=\"token qualifier\" >Square</span> black<span class=\"token operator\" >=</span><span class=\"token punctuation\" >{</span>black<span class=\"token punctuation\" >}</span><span class=\"token operator\" >></span>\n        <span class=\"token punctuation\" >{</span><span class=\"token var\" >this</span><span class=\"token punctuation\" >.</span>props<span class=\"token punctuation\" >.</span>children<span class=\"token punctuation\" >}</span>\n      <span class=\"token operator\" >&lt;</span><span class=\"token operator\" >/</span><span class=\"token qualifier\" >Square</span><span class=\"token operator\" >></span>\n    <span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n  <span class=\"token punctuation\" >}</span>\n<span class=\"token punctuation\" >}</span></code><hr/>\n<p>I also changed the <code>Board</code> to use it:</p>\n<hr/>\n<code class=\"codeBlock\">renderSquare<span class=\"token punctuation\" >:</span> <span class=\"token block-keyword\" >function</span> <span class=\"token punctuation\" >(</span>i<span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n  <span class=\"token keyword\" >var</span> x <span class=\"token operator\" >=</span> i <span class=\"token operator\" >%</span> <span class=\"token number\" >8</span><span class=\"token punctuation\" >;</span>\n  <span class=\"token keyword\" >var</span> y <span class=\"token operator\" >=</span> <span class=\"token qualifier\" >Math</span><span class=\"token punctuation\" >.</span><span class=\"token function\" >floor<span class=\"token punctuation\" >(</span></span>i <span class=\"token operator\" >/</span> <span class=\"token number\" >8</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n\n  <span class=\"token keyword\" >return</span> <span class=\"token punctuation\" >(</span>\n    <span class=\"token operator\" >&lt;</span>div key<span class=\"token operator\" >=</span><span class=\"token punctuation\" >{</span>i<span class=\"token punctuation\" >}</span>\n         style<span class=\"token operator\" >=</span><span class=\"token punctuation\" >{</span><span class=\"token punctuation\" >{</span> width<span class=\"token punctuation\" >:</span> <span class=\"token string\" >'12.5%'</span><span class=\"token punctuation\" >,</span> height<span class=\"token punctuation\" >:</span> <span class=\"token string\" >'12.5%'</span> <span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >}</span><span class=\"token operator\" >></span>\n      <span class=\"token operator\" >&lt;</span><span class=\"token qualifier\" >Board</span><span class=\"token qualifier\" >Square</span> x<span class=\"token operator\" >=</span><span class=\"token punctuation\" >{</span>x<span class=\"token punctuation\" >}</span>\n                   y<span class=\"token operator\" >=</span><span class=\"token punctuation\" >{</span>y<span class=\"token punctuation\" >}</span><span class=\"token operator\" >></span>\n        <span class=\"token punctuation\" >{</span><span class=\"token var\" >this</span><span class=\"token punctuation\" >.</span><span class=\"token function\" >renderPiece<span class=\"token punctuation\" >(</span></span>x<span class=\"token punctuation\" >,</span> y<span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >}</span>\n      <span class=\"token operator\" >&lt;</span><span class=\"token operator\" >/</span><span class=\"token qualifier\" >Board</span><span class=\"token qualifier\" >Square</span><span class=\"token operator\" >></span>\n    <span class=\"token operator\" >&lt;</span><span class=\"token operator\" >/</span>div<span class=\"token operator\" >></span>\n  <span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n<span class=\"token punctuation\" >}</span>\n\nrenderPiece<span class=\"token punctuation\" >:</span> <span class=\"token block-keyword\" >function</span> <span class=\"token punctuation\" >(</span>x<span class=\"token punctuation\" >,</span> y<span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n  <span class=\"token keyword\" >var</span> knightX <span class=\"token operator\" >=</span> <span class=\"token var\" >this</span><span class=\"token punctuation\" >.</span>props<span class=\"token punctuation\" >.</span>knightPosition<span class=\"token punctuation\" >[</span><span class=\"token number\" >0</span><span class=\"token punctuation\" >]</span>\n  <span class=\"token keyword\" >var</span> knightY <span class=\"token operator\" >=</span> <span class=\"token var\" >this</span><span class=\"token punctuation\" >.</span>props<span class=\"token punctuation\" >.</span>knightPosition<span class=\"token punctuation\" >[</span><span class=\"token number\" >1</span><span class=\"token punctuation\" >]</span><span class=\"token punctuation\" >;</span>\n\n  <span class=\"token block-keyword\" >if</span> <span class=\"token punctuation\" >(</span>x <span class=\"token operator\" >===</span> knightX <span class=\"token operator\" >&amp;&amp;</span> y <span class=\"token operator\" >===</span> knightY<span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n    <span class=\"token keyword\" >return</span> <span class=\"token operator\" >&lt;</span><span class=\"token qualifier\" >Knight</span> <span class=\"token operator\" >/</span><span class=\"token operator\" >></span><span class=\"token punctuation\" >;</span>\n  <span class=\"token punctuation\" >}</span>\n<span class=\"token punctuation\" >}</span></code><hr/>\n<code class=\"codeBlock\"><span class=\"token function\" >renderSquare<span class=\"token punctuation\" >(</span></span>i<span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n  <span class=\"token keyword\" >const</span> x <span class=\"token operator\" >=</span> i <span class=\"token operator\" >%</span> <span class=\"token number\" >8</span><span class=\"token punctuation\" >;</span>\n  <span class=\"token keyword\" >const</span> y <span class=\"token operator\" >=</span> <span class=\"token qualifier\" >Math</span><span class=\"token punctuation\" >.</span><span class=\"token function\" >floor<span class=\"token punctuation\" >(</span></span>i <span class=\"token operator\" >/</span> <span class=\"token number\" >8</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n  <span class=\"token keyword\" >return</span> <span class=\"token punctuation\" >(</span>\n    <span class=\"token operator\" >&lt;</span>div key<span class=\"token operator\" >=</span><span class=\"token punctuation\" >{</span>i<span class=\"token punctuation\" >}</span>\n         style<span class=\"token operator\" >=</span><span class=\"token punctuation\" >{</span><span class=\"token punctuation\" >{</span> width<span class=\"token punctuation\" >:</span> <span class=\"token string\" >'12.5%'</span><span class=\"token punctuation\" >,</span> height<span class=\"token punctuation\" >:</span> <span class=\"token string\" >'12.5%'</span> <span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >}</span><span class=\"token operator\" >></span>\n      <span class=\"token operator\" >&lt;</span><span class=\"token qualifier\" >Board</span><span class=\"token qualifier\" >Square</span> x<span class=\"token operator\" >=</span><span class=\"token punctuation\" >{</span>x<span class=\"token punctuation\" >}</span>\n                   y<span class=\"token operator\" >=</span><span class=\"token punctuation\" >{</span>y<span class=\"token punctuation\" >}</span><span class=\"token operator\" >></span>\n        <span class=\"token punctuation\" >{</span><span class=\"token var\" >this</span><span class=\"token punctuation\" >.</span><span class=\"token function\" >renderPiece<span class=\"token punctuation\" >(</span></span>x<span class=\"token punctuation\" >,</span> y<span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >}</span>\n      <span class=\"token operator\" >&lt;</span><span class=\"token operator\" >/</span><span class=\"token qualifier\" >Board</span><span class=\"token qualifier\" >Square</span><span class=\"token operator\" >></span>\n    <span class=\"token operator\" >&lt;</span><span class=\"token operator\" >/</span>div<span class=\"token operator\" >></span>\n  <span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n<span class=\"token punctuation\" >}</span>\n\n<span class=\"token function\" >renderPiece<span class=\"token punctuation\" >(</span></span>x<span class=\"token punctuation\" >,</span> y<span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n  <span class=\"token keyword\" >const</span> <span class=\"token punctuation\" >[</span>knightX<span class=\"token punctuation\" >,</span> knightY<span class=\"token punctuation\" >]</span> <span class=\"token operator\" >=</span> <span class=\"token var\" >this</span><span class=\"token punctuation\" >.</span>props<span class=\"token punctuation\" >.</span>knightPosition<span class=\"token punctuation\" >;</span>\n  <span class=\"token block-keyword\" >if</span> <span class=\"token punctuation\" >(</span>x <span class=\"token operator\" >===</span> knightX <span class=\"token operator\" >&amp;&amp;</span> y <span class=\"token operator\" >===</span> knightY<span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n    <span class=\"token keyword\" >return</span> <span class=\"token operator\" >&lt;</span><span class=\"token qualifier\" >Knight</span> <span class=\"token operator\" >/</span><span class=\"token operator\" >></span><span class=\"token punctuation\" >;</span>\n  <span class=\"token punctuation\" >}</span>\n<span class=\"token punctuation\" >}</span></code><hr/>\n<hr/>\n<p>Let&#39;s now wrap the <code>BoardSquare</code> with a <a href=\"docs-drop-target.html\"><code>DropTarget</code></a>. I&#39;m going to write a drop target specification that only handles the <code>drop</code> event:</p>\n<hr/>\n<code class=\"codeBlock\"><span class=\"token keyword\" >var</span> squareTarget <span class=\"token operator\" >=</span> <span class=\"token punctuation\" >{</span>\n  drop<span class=\"token punctuation\" >:</span> <span class=\"token block-keyword\" >function</span> <span class=\"token punctuation\" >(</span>props<span class=\"token punctuation\" >,</span> monitor<span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n    <span class=\"token function\" >moveKnight<span class=\"token punctuation\" >(</span></span>props<span class=\"token punctuation\" >.</span>x<span class=\"token punctuation\" >,</span> props<span class=\"token punctuation\" >.</span>y<span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n  <span class=\"token punctuation\" >}</span>\n<span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >;</span></code><hr/>\n<code class=\"codeBlock\"><span class=\"token keyword\" >const</span> squareTarget <span class=\"token operator\" >=</span> <span class=\"token punctuation\" >{</span>\n  <span class=\"token function\" >drop<span class=\"token punctuation\" >(</span></span>props<span class=\"token punctuation\" >,</span> monitor<span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n    <span class=\"token function\" >moveKnight<span class=\"token punctuation\" >(</span></span>props<span class=\"token punctuation\" >.</span>x<span class=\"token punctuation\" >,</span> props<span class=\"token punctuation\" >.</span>y<span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n  <span class=\"token punctuation\" >}</span>\n<span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >;</span></code><hr/>\n<hr/>\n<p>See? The <code>drop</code> method receives the <code>props</code> of the <code>BoardSquare</code> so it knows <em>where</em> to move the knight when it drops. In a real app, I might also use <code>monitor.getItem()</code> to retrieve <em>the dragged item</em> that the drag source returned from <code>beginDrag</code>, but since we only have a single draggable thing in the whole application, I don&#39;t need it.</p>\n<p>In my collecting function, I&#39;m going to obtain the function to connect my drop target node, and I&#39;m also going to ask the monitor whether the pointer is currently over the <code>BoardSquare</code> so I can highlight it:</p>\n<code class=\"codeBlock\"><span class=\"token block-keyword\" >function</span> <span class=\"token function\" >collect<span class=\"token punctuation\" >(</span></span>connect<span class=\"token punctuation\" >,</span> monitor<span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n  <span class=\"token keyword\" >return</span> <span class=\"token punctuation\" >{</span>\n    connectDropTarget<span class=\"token punctuation\" >:</span> connect<span class=\"token punctuation\" >.</span><span class=\"token function\" >dropTarget<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >,</span>\n    isOver<span class=\"token punctuation\" >:</span> monitor<span class=\"token punctuation\" >.</span><span class=\"token function\" >isOver<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span>\n  <span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >;</span>\n<span class=\"token punctuation\" >}</span></code><p>After changing the <code>render</code> function to connect the drop target and show the highlight overlay, here is what <code>BoardSquare</code> came to be:</p>\n<hr/>\n<code class=\"codeBlock\"><span class=\"token keyword\" >var</span> <span class=\"token qualifier\" >React</span> <span class=\"token operator\" >=</span> <span class=\"token function\" >require<span class=\"token punctuation\" >(</span></span><span class=\"token string\" >'react'</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n<span class=\"token keyword\" >var</span> <span class=\"token qualifier\" >Prop</span><span class=\"token qualifier\" >Types</span> <span class=\"token operator\" >=</span> <span class=\"token qualifier\" >React</span><span class=\"token punctuation\" >.</span><span class=\"token qualifier\" >Prop</span><span class=\"token qualifier\" >Types</span><span class=\"token punctuation\" >;</span>\n<span class=\"token keyword\" >var</span> <span class=\"token qualifier\" >Square</span> <span class=\"token operator\" >=</span> <span class=\"token function\" >require<span class=\"token punctuation\" >(</span></span><span class=\"token string\" >'./Square'</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n<span class=\"token keyword\" >var</span> canMoveKnight <span class=\"token operator\" >=</span> <span class=\"token function\" >require<span class=\"token punctuation\" >(</span></span><span class=\"token string\" >'./Game'</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >.</span>canMoveKnight<span class=\"token punctuation\" >;</span>\n<span class=\"token keyword\" >var</span> moveKnight <span class=\"token operator\" >=</span> <span class=\"token function\" >require<span class=\"token punctuation\" >(</span></span><span class=\"token string\" >'./Game'</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >.</span>moveKnight<span class=\"token punctuation\" >;</span>\n<span class=\"token keyword\" >var</span> <span class=\"token qualifier\" >Item</span><span class=\"token qualifier\" >Types</span> <span class=\"token operator\" >=</span> <span class=\"token function\" >require<span class=\"token punctuation\" >(</span></span><span class=\"token string\" >'./Constants'</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >.</span><span class=\"token qualifier\" >Item</span><span class=\"token qualifier\" >Types</span><span class=\"token punctuation\" >;</span>\n<span class=\"token keyword\" >var</span> <span class=\"token qualifier\" >Drop</span><span class=\"token qualifier\" >Target</span> <span class=\"token operator\" >=</span> <span class=\"token function\" >require<span class=\"token punctuation\" >(</span></span><span class=\"token string\" >'react-dnd'</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >.</span><span class=\"token qualifier\" >Drop</span><span class=\"token qualifier\" >Target</span><span class=\"token punctuation\" >;</span>\n\n<span class=\"token keyword\" >var</span> squareTarget <span class=\"token operator\" >=</span> <span class=\"token punctuation\" >{</span>\n  drop<span class=\"token punctuation\" >:</span> <span class=\"token block-keyword\" >function</span> <span class=\"token punctuation\" >(</span>props<span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n    <span class=\"token function\" >moveKnight<span class=\"token punctuation\" >(</span></span>props<span class=\"token punctuation\" >.</span>x<span class=\"token punctuation\" >,</span> props<span class=\"token punctuation\" >.</span>y<span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n  <span class=\"token punctuation\" >}</span>\n<span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >;</span>\n\n<span class=\"token block-keyword\" >function</span> <span class=\"token function\" >collect<span class=\"token punctuation\" >(</span></span>connect<span class=\"token punctuation\" >,</span> monitor<span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n  <span class=\"token keyword\" >return</span> <span class=\"token punctuation\" >{</span>\n    connectDropTarget<span class=\"token punctuation\" >:</span> connect<span class=\"token punctuation\" >.</span><span class=\"token function\" >dropTarget<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >,</span>\n    isOver<span class=\"token punctuation\" >:</span> monitor<span class=\"token punctuation\" >.</span><span class=\"token function\" >isOver<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span>\n  <span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >;</span>\n<span class=\"token punctuation\" >}</span>\n\n<span class=\"token keyword\" >var</span> <span class=\"token qualifier\" >Board</span><span class=\"token qualifier\" >Square</span> <span class=\"token operator\" >=</span> <span class=\"token qualifier\" >React</span><span class=\"token punctuation\" >.</span><span class=\"token function\" >createClass<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >{</span>\n  propTypes<span class=\"token punctuation\" >:</span> <span class=\"token punctuation\" >{</span>\n    x<span class=\"token punctuation\" >:</span> <span class=\"token qualifier\" >Prop</span><span class=\"token qualifier\" >Types</span><span class=\"token punctuation\" >.</span>number<span class=\"token punctuation\" >.</span>isRequired<span class=\"token punctuation\" >,</span>\n    y<span class=\"token punctuation\" >:</span> <span class=\"token qualifier\" >Prop</span><span class=\"token qualifier\" >Types</span><span class=\"token punctuation\" >.</span>number<span class=\"token punctuation\" >.</span>isRequired<span class=\"token punctuation\" >,</span>\n    isOver<span class=\"token punctuation\" >:</span> <span class=\"token qualifier\" >Prop</span><span class=\"token qualifier\" >Types</span><span class=\"token punctuation\" >.</span>bool<span class=\"token punctuation\" >.</span>isRequired\n  <span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >,</span>\n\n  render<span class=\"token punctuation\" >:</span> <span class=\"token block-keyword\" >function</span> <span class=\"token punctuation\" >(</span><span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n    <span class=\"token keyword\" >var</span> x <span class=\"token operator\" >=</span> <span class=\"token var\" >this</span><span class=\"token punctuation\" >.</span>props<span class=\"token punctuation\" >.</span>x<span class=\"token punctuation\" >;</span>\n    <span class=\"token keyword\" >var</span> y <span class=\"token operator\" >=</span> <span class=\"token var\" >this</span><span class=\"token punctuation\" >.</span>props<span class=\"token punctuation\" >.</span>y<span class=\"token punctuation\" >;</span>\n    <span class=\"token keyword\" >var</span> connectDropTarget <span class=\"token operator\" >=</span> <span class=\"token var\" >this</span><span class=\"token punctuation\" >.</span>props<span class=\"token punctuation\" >.</span>connectDropTarget<span class=\"token punctuation\" >;</span>\n    <span class=\"token keyword\" >var</span> isOver <span class=\"token operator\" >=</span> <span class=\"token var\" >this</span><span class=\"token punctuation\" >.</span>props<span class=\"token punctuation\" >.</span>isOver<span class=\"token punctuation\" >;</span>\n    <span class=\"token keyword\" >var</span> black <span class=\"token operator\" >=</span> <span class=\"token punctuation\" >(</span>x <span class=\"token operator\" >+</span> y<span class=\"token punctuation\" >)</span> <span class=\"token operator\" >%</span> <span class=\"token number\" >2</span> <span class=\"token operator\" >===</span> <span class=\"token number\" >1</span><span class=\"token punctuation\" >;</span>\n\n    <span class=\"token keyword\" >return</span> <span class=\"token function\" >connectDropTarget<span class=\"token punctuation\" >(</span></span>\n      <span class=\"token operator\" >&lt;</span>div style<span class=\"token operator\" >=</span><span class=\"token punctuation\" >{</span><span class=\"token punctuation\" >{</span>\n        position<span class=\"token punctuation\" >:</span> <span class=\"token string\" >'relative'</span><span class=\"token punctuation\" >,</span>\n        width<span class=\"token punctuation\" >:</span> <span class=\"token string\" >'100%'</span><span class=\"token punctuation\" >,</span>\n        height<span class=\"token punctuation\" >:</span> <span class=\"token string\" >'100%'</span>\n      <span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >}</span><span class=\"token operator\" >></span>\n        <span class=\"token operator\" >&lt;</span><span class=\"token qualifier\" >Square</span> black<span class=\"token operator\" >=</span><span class=\"token punctuation\" >{</span>black<span class=\"token punctuation\" >}</span><span class=\"token operator\" >></span>\n          <span class=\"token punctuation\" >{</span><span class=\"token var\" >this</span><span class=\"token punctuation\" >.</span>props<span class=\"token punctuation\" >.</span>children<span class=\"token punctuation\" >}</span>\n        <span class=\"token operator\" >&lt;</span><span class=\"token operator\" >/</span><span class=\"token qualifier\" >Square</span><span class=\"token operator\" >></span>\n        <span class=\"token punctuation\" >{</span>isOver <span class=\"token operator\" >&amp;&amp;</span>\n          <span class=\"token operator\" >&lt;</span>div style<span class=\"token operator\" >=</span><span class=\"token punctuation\" >{</span><span class=\"token punctuation\" >{</span>\n            position<span class=\"token punctuation\" >:</span> <span class=\"token string\" >'absolute'</span><span class=\"token punctuation\" >,</span>\n            top<span class=\"token punctuation\" >:</span> <span class=\"token number\" >0</span><span class=\"token punctuation\" >,</span>\n            left<span class=\"token punctuation\" >:</span> <span class=\"token number\" >0</span><span class=\"token punctuation\" >,</span>\n            height<span class=\"token punctuation\" >:</span> <span class=\"token string\" >'100%'</span><span class=\"token punctuation\" >,</span>\n            width<span class=\"token punctuation\" >:</span> <span class=\"token string\" >'100%'</span><span class=\"token punctuation\" >,</span>\n            zIndex<span class=\"token punctuation\" >:</span> <span class=\"token number\" >1</span><span class=\"token punctuation\" >,</span>\n            opacity<span class=\"token punctuation\" >:</span> <span class=\"token number\" >0.5</span><span class=\"token punctuation\" >,</span>\n            backgroundColor<span class=\"token punctuation\" >:</span> <span class=\"token string\" >'yellow'</span><span class=\"token punctuation\" >,</span>\n          <span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >}</span> <span class=\"token operator\" >/</span><span class=\"token operator\" >></span>\n        <span class=\"token punctuation\" >}</span>\n      <span class=\"token operator\" >&lt;</span><span class=\"token operator\" >/</span>div<span class=\"token operator\" >></span>\n    <span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n  <span class=\"token punctuation\" >}</span>\n<span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n\nmodule<span class=\"token punctuation\" >.</span>exports <span class=\"token operator\" >=</span> <span class=\"token function\" >DropTarget<span class=\"token punctuation\" >(</span></span><span class=\"token qualifier\" >Item</span><span class=\"token qualifier\" >Types</span><span class=\"token punctuation\" >.</span>KNIGHT<span class=\"token punctuation\" >,</span> squareTarget<span class=\"token punctuation\" >,</span> collect<span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >(</span><span class=\"token qualifier\" >Board</span><span class=\"token qualifier\" >Square</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span></code><hr/>\n<code class=\"codeBlock\"><span class=\"token keyword\" >import</span> <span class=\"token qualifier\" >React</span><span class=\"token punctuation\" >,</span> <span class=\"token punctuation\" >{</span> <span class=\"token qualifier\" >Prop</span><span class=\"token qualifier\" >Types</span> <span class=\"token punctuation\" >}</span> from <span class=\"token string\" >'react'</span><span class=\"token punctuation\" >;</span>\n<span class=\"token keyword\" >import</span> <span class=\"token qualifier\" >Square</span> from <span class=\"token string\" >'./Square'</span><span class=\"token punctuation\" >;</span>\n<span class=\"token keyword\" >import</span> <span class=\"token punctuation\" >{</span> canMoveKnight<span class=\"token punctuation\" >,</span> moveKnight <span class=\"token punctuation\" >}</span> from <span class=\"token string\" >'./Game'</span><span class=\"token punctuation\" >;</span>\n<span class=\"token keyword\" >import</span> <span class=\"token punctuation\" >{</span> <span class=\"token qualifier\" >Item</span><span class=\"token qualifier\" >Types</span> <span class=\"token punctuation\" >}</span> from <span class=\"token string\" >'./Constants'</span><span class=\"token punctuation\" >;</span>\n<span class=\"token keyword\" >import</span> <span class=\"token punctuation\" >{</span> <span class=\"token qualifier\" >Drop</span><span class=\"token qualifier\" >Target</span> <span class=\"token punctuation\" >}</span> from <span class=\"token string\" >'react-dnd'</span><span class=\"token punctuation\" >;</span>\n\n<span class=\"token keyword\" >const</span> squareTarget <span class=\"token operator\" >=</span> <span class=\"token punctuation\" >{</span>\n  <span class=\"token function\" >drop<span class=\"token punctuation\" >(</span></span>props<span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n    <span class=\"token function\" >moveKnight<span class=\"token punctuation\" >(</span></span>props<span class=\"token punctuation\" >.</span>x<span class=\"token punctuation\" >,</span> props<span class=\"token punctuation\" >.</span>y<span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n  <span class=\"token punctuation\" >}</span>\n<span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >;</span>\n\n<span class=\"token block-keyword\" >function</span> <span class=\"token function\" >collect<span class=\"token punctuation\" >(</span></span>connect<span class=\"token punctuation\" >,</span> monitor<span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n  <span class=\"token keyword\" >return</span> <span class=\"token punctuation\" >{</span>\n    connectDropTarget<span class=\"token punctuation\" >:</span> connect<span class=\"token punctuation\" >.</span><span class=\"token function\" >dropTarget<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >,</span>\n    isOver<span class=\"token punctuation\" >:</span> monitor<span class=\"token punctuation\" >.</span><span class=\"token function\" >isOver<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span>\n  <span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >;</span>\n<span class=\"token punctuation\" >}</span>\n\n<span class=\"token keyword\" >class</span> <span class=\"token class-name\" >BoardSquare</span> <span class=\"token punctuation\" >{</span>\n  <span class=\"token function\" >render<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n    <span class=\"token keyword\" >const</span> <span class=\"token punctuation\" >{</span> x<span class=\"token punctuation\" >,</span> y<span class=\"token punctuation\" >,</span> connectDropTarget<span class=\"token punctuation\" >,</span> isOver <span class=\"token punctuation\" >}</span> <span class=\"token operator\" >=</span> <span class=\"token var\" >this</span><span class=\"token punctuation\" >.</span>props<span class=\"token punctuation\" >;</span>\n    <span class=\"token keyword\" >const</span> black <span class=\"token operator\" >=</span> <span class=\"token punctuation\" >(</span>x <span class=\"token operator\" >+</span> y<span class=\"token punctuation\" >)</span> <span class=\"token operator\" >%</span> <span class=\"token number\" >2</span> <span class=\"token operator\" >===</span> <span class=\"token number\" >1</span><span class=\"token punctuation\" >;</span>\n\n    <span class=\"token keyword\" >return</span> <span class=\"token function\" >connectDropTarget<span class=\"token punctuation\" >(</span></span>\n      <span class=\"token operator\" >&lt;</span>div style<span class=\"token operator\" >=</span><span class=\"token punctuation\" >{</span><span class=\"token punctuation\" >{</span>\n        position<span class=\"token punctuation\" >:</span> <span class=\"token string\" >'relative'</span><span class=\"token punctuation\" >,</span>\n        width<span class=\"token punctuation\" >:</span> <span class=\"token string\" >'100%'</span><span class=\"token punctuation\" >,</span>\n        height<span class=\"token punctuation\" >:</span> <span class=\"token string\" >'100%'</span>\n      <span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >}</span><span class=\"token operator\" >></span>\n        <span class=\"token operator\" >&lt;</span><span class=\"token qualifier\" >Square</span> black<span class=\"token operator\" >=</span><span class=\"token punctuation\" >{</span>black<span class=\"token punctuation\" >}</span><span class=\"token operator\" >></span>\n          <span class=\"token punctuation\" >{</span><span class=\"token var\" >this</span><span class=\"token punctuation\" >.</span>props<span class=\"token punctuation\" >.</span>children<span class=\"token punctuation\" >}</span>\n        <span class=\"token operator\" >&lt;</span><span class=\"token operator\" >/</span><span class=\"token qualifier\" >Square</span><span class=\"token operator\" >></span>\n        <span class=\"token punctuation\" >{</span>isOver <span class=\"token operator\" >&amp;&amp;</span>\n          <span class=\"token operator\" >&lt;</span>div style<span class=\"token operator\" >=</span><span class=\"token punctuation\" >{</span><span class=\"token punctuation\" >{</span>\n            position<span class=\"token punctuation\" >:</span> <span class=\"token string\" >'absolute'</span><span class=\"token punctuation\" >,</span>\n            top<span class=\"token punctuation\" >:</span> <span class=\"token number\" >0</span><span class=\"token punctuation\" >,</span>\n            left<span class=\"token punctuation\" >:</span> <span class=\"token number\" >0</span><span class=\"token punctuation\" >,</span>\n            height<span class=\"token punctuation\" >:</span> <span class=\"token string\" >'100%'</span><span class=\"token punctuation\" >,</span>\n            width<span class=\"token punctuation\" >:</span> <span class=\"token string\" >'100%'</span><span class=\"token punctuation\" >,</span>\n            zIndex<span class=\"token punctuation\" >:</span> <span class=\"token number\" >1</span><span class=\"token punctuation\" >,</span>\n            opacity<span class=\"token punctuation\" >:</span> <span class=\"token number\" >0.5</span><span class=\"token punctuation\" >,</span>\n            backgroundColor<span class=\"token punctuation\" >:</span> <span class=\"token string\" >'yellow'</span><span class=\"token punctuation\" >,</span>\n          <span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >}</span> <span class=\"token operator\" >/</span><span class=\"token operator\" >></span>\n        <span class=\"token punctuation\" >}</span>\n      <span class=\"token operator\" >&lt;</span><span class=\"token operator\" >/</span>div<span class=\"token operator\" >></span>\n    <span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n  <span class=\"token punctuation\" >}</span>\n<span class=\"token punctuation\" >}</span>\n\n<span class=\"token qualifier\" >Board</span><span class=\"token qualifier\" >Square</span><span class=\"token punctuation\" >.</span>propTypes <span class=\"token operator\" >=</span> <span class=\"token punctuation\" >{</span>\n  x<span class=\"token punctuation\" >:</span> <span class=\"token qualifier\" >Prop</span><span class=\"token qualifier\" >Types</span><span class=\"token punctuation\" >.</span>number<span class=\"token punctuation\" >.</span>isRequired<span class=\"token punctuation\" >,</span>\n  y<span class=\"token punctuation\" >:</span> <span class=\"token qualifier\" >Prop</span><span class=\"token qualifier\" >Types</span><span class=\"token punctuation\" >.</span>number<span class=\"token punctuation\" >.</span>isRequired<span class=\"token punctuation\" >,</span>\n  isOver<span class=\"token punctuation\" >:</span> <span class=\"token qualifier\" >Prop</span><span class=\"token qualifier\" >Types</span><span class=\"token punctuation\" >.</span>bool<span class=\"token punctuation\" >.</span>isRequired\n<span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >;</span>\n\n<span class=\"token keyword\" >export</span> <span class=\"token keyword\" >default</span> <span class=\"token function\" >DropTarget<span class=\"token punctuation\" >(</span></span><span class=\"token qualifier\" >Item</span><span class=\"token qualifier\" >Types</span><span class=\"token punctuation\" >.</span>KNIGHT<span class=\"token punctuation\" >,</span> squareTarget<span class=\"token punctuation\" >,</span> collect<span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >(</span><span class=\"token qualifier\" >Board</span><span class=\"token qualifier\" >Square</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span></code><hr/>\n<code class=\"codeBlock\"><span class=\"token keyword\" >import</span> <span class=\"token qualifier\" >React</span><span class=\"token punctuation\" >,</span> <span class=\"token punctuation\" >{</span> <span class=\"token qualifier\" >Prop</span><span class=\"token qualifier\" >Types</span> <span class=\"token punctuation\" >}</span> from <span class=\"token string\" >'react'</span><span class=\"token punctuation\" >;</span>\n<span class=\"token keyword\" >import</span> <span class=\"token qualifier\" >Square</span> from <span class=\"token string\" >'./Square'</span><span class=\"token punctuation\" >;</span>\n<span class=\"token keyword\" >import</span> <span class=\"token punctuation\" >{</span> canMoveKnight<span class=\"token punctuation\" >,</span> moveKnight <span class=\"token punctuation\" >}</span> from <span class=\"token string\" >'./Game'</span><span class=\"token punctuation\" >;</span>\n<span class=\"token keyword\" >import</span> <span class=\"token punctuation\" >{</span> <span class=\"token qualifier\" >Item</span><span class=\"token qualifier\" >Types</span> <span class=\"token punctuation\" >}</span> from <span class=\"token string\" >'./Constants'</span><span class=\"token punctuation\" >;</span>\n<span class=\"token keyword\" >import</span> <span class=\"token punctuation\" >{</span> <span class=\"token qualifier\" >Drop</span><span class=\"token qualifier\" >Target</span> <span class=\"token punctuation\" >}</span> from <span class=\"token string\" >'react-dnd'</span><span class=\"token punctuation\" >;</span>\n\n<span class=\"token keyword\" >const</span> squareTarget <span class=\"token operator\" >=</span> <span class=\"token punctuation\" >{</span>\n  <span class=\"token function\" >drop<span class=\"token punctuation\" >(</span></span>props<span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n    <span class=\"token function\" >moveKnight<span class=\"token punctuation\" >(</span></span>props<span class=\"token punctuation\" >.</span>x<span class=\"token punctuation\" >,</span> props<span class=\"token punctuation\" >.</span>y<span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n  <span class=\"token punctuation\" >}</span>\n<span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >;</span>\n\n<span class=\"token block-keyword\" >function</span> <span class=\"token function\" >collect<span class=\"token punctuation\" >(</span></span>connect<span class=\"token punctuation\" >,</span> monitor<span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n  <span class=\"token keyword\" >return</span> <span class=\"token punctuation\" >{</span>\n    connectDropTarget<span class=\"token punctuation\" >:</span> connect<span class=\"token punctuation\" >.</span><span class=\"token function\" >dropTarget<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >,</span>\n    isOver<span class=\"token punctuation\" >:</span> monitor<span class=\"token punctuation\" >.</span><span class=\"token function\" >isOver<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span>\n  <span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >;</span>\n<span class=\"token punctuation\" >}</span>\n\n@<span class=\"token function\" >DropTarget<span class=\"token punctuation\" >(</span></span><span class=\"token qualifier\" >Item</span><span class=\"token qualifier\" >Types</span><span class=\"token punctuation\" >.</span>KNIGHT<span class=\"token punctuation\" >,</span> squareTarget<span class=\"token punctuation\" >,</span> collect<span class=\"token punctuation\" >)</span>\n<span class=\"token keyword\" >export</span> <span class=\"token keyword\" >default</span> <span class=\"token keyword\" >class</span> <span class=\"token class-name\" >BoardSquare</span> <span class=\"token punctuation\" >{</span>\n  <span class=\"token keyword\" >static</span> propTypes <span class=\"token operator\" >=</span> <span class=\"token punctuation\" >{</span>\n    x<span class=\"token punctuation\" >:</span> <span class=\"token qualifier\" >Prop</span><span class=\"token qualifier\" >Types</span><span class=\"token punctuation\" >.</span>number<span class=\"token punctuation\" >.</span>isRequired<span class=\"token punctuation\" >,</span>\n    y<span class=\"token punctuation\" >:</span> <span class=\"token qualifier\" >Prop</span><span class=\"token qualifier\" >Types</span><span class=\"token punctuation\" >.</span>number<span class=\"token punctuation\" >.</span>isRequired<span class=\"token punctuation\" >,</span>\n    isOver<span class=\"token punctuation\" >:</span> <span class=\"token qualifier\" >Prop</span><span class=\"token qualifier\" >Types</span><span class=\"token punctuation\" >.</span>bool<span class=\"token punctuation\" >.</span>isRequired\n  <span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >;</span>\n\n  <span class=\"token function\" >render<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n    <span class=\"token keyword\" >const</span> <span class=\"token punctuation\" >{</span> x<span class=\"token punctuation\" >,</span> y<span class=\"token punctuation\" >,</span> connectDropTarget<span class=\"token punctuation\" >,</span> isOver <span class=\"token punctuation\" >}</span> <span class=\"token operator\" >=</span> <span class=\"token var\" >this</span><span class=\"token punctuation\" >.</span>props<span class=\"token punctuation\" >;</span>\n    <span class=\"token keyword\" >const</span> black <span class=\"token operator\" >=</span> <span class=\"token punctuation\" >(</span>x <span class=\"token operator\" >+</span> y<span class=\"token punctuation\" >)</span> <span class=\"token operator\" >%</span> <span class=\"token number\" >2</span> <span class=\"token operator\" >===</span> <span class=\"token number\" >1</span><span class=\"token punctuation\" >;</span>\n\n    <span class=\"token keyword\" >return</span> <span class=\"token function\" >connectDropTarget<span class=\"token punctuation\" >(</span></span>\n      <span class=\"token operator\" >&lt;</span>div style<span class=\"token operator\" >=</span><span class=\"token punctuation\" >{</span><span class=\"token punctuation\" >{</span>\n        position<span class=\"token punctuation\" >:</span> <span class=\"token string\" >'relative'</span><span class=\"token punctuation\" >,</span>\n        width<span class=\"token punctuation\" >:</span> <span class=\"token string\" >'100%'</span><span class=\"token punctuation\" >,</span>\n        height<span class=\"token punctuation\" >:</span> <span class=\"token string\" >'100%'</span>\n      <span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >}</span><span class=\"token operator\" >></span>\n        <span class=\"token operator\" >&lt;</span><span class=\"token qualifier\" >Square</span> black<span class=\"token operator\" >=</span><span class=\"token punctuation\" >{</span>black<span class=\"token punctuation\" >}</span><span class=\"token operator\" >></span>\n          <span class=\"token punctuation\" >{</span><span class=\"token var\" >this</span><span class=\"token punctuation\" >.</span>props<span class=\"token punctuation\" >.</span>children<span class=\"token punctuation\" >}</span>\n        <span class=\"token operator\" >&lt;</span><span class=\"token operator\" >/</span><span class=\"token qualifier\" >Square</span><span class=\"token operator\" >></span>\n        <span class=\"token punctuation\" >{</span>isOver <span class=\"token operator\" >&amp;&amp;</span>\n          <span class=\"token operator\" >&lt;</span>div style<span class=\"token operator\" >=</span><span class=\"token punctuation\" >{</span><span class=\"token punctuation\" >{</span>\n            position<span class=\"token punctuation\" >:</span> <span class=\"token string\" >'absolute'</span><span class=\"token punctuation\" >,</span>\n            top<span class=\"token punctuation\" >:</span> <span class=\"token number\" >0</span><span class=\"token punctuation\" >,</span>\n            left<span class=\"token punctuation\" >:</span> <span class=\"token number\" >0</span><span class=\"token punctuation\" >,</span>\n            height<span class=\"token punctuation\" >:</span> <span class=\"token string\" >'100%'</span><span class=\"token punctuation\" >,</span>\n            width<span class=\"token punctuation\" >:</span> <span class=\"token string\" >'100%'</span><span class=\"token punctuation\" >,</span>\n            zIndex<span class=\"token punctuation\" >:</span> <span class=\"token number\" >1</span><span class=\"token punctuation\" >,</span>\n            opacity<span class=\"token punctuation\" >:</span> <span class=\"token number\" >0.5</span><span class=\"token punctuation\" >,</span>\n            backgroundColor<span class=\"token punctuation\" >:</span> <span class=\"token string\" >'yellow'</span><span class=\"token punctuation\" >,</span>\n          <span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >}</span> <span class=\"token operator\" >/</span><span class=\"token operator\" >></span>\n        <span class=\"token punctuation\" >}</span>\n      <span class=\"token operator\" >&lt;</span><span class=\"token operator\" >/</span>div<span class=\"token operator\" >></span>\n    <span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n  <span class=\"token punctuation\" >}</span>\n<span class=\"token punctuation\" >}</span></code><hr/>\n<p><img src='https://s3.amazonaws.com/f.cl.ly/items/2U43301g421U3I2X2p0P/Screen%20Recording%202015-05-15%20at%2001.55%20pm.gif' width='404' height='445' alt='Screenshot'></p>\n<p>This is starting to look good! There is just one change left to complete this tutorial. We want to highlight the <code>BoardSquare</code>s that represent the valid moves, and only process the drop if it happened over one of those valid <code>BoardSquare</code>s.</p>\n<p>Thankfully, it is really easy to do with React DnD. I just need to define a <code>canDrop</code> method in my drop target specification:</p>\n<hr/>\n<code class=\"codeBlock\">canDrop<span class=\"token punctuation\" >:</span> <span class=\"token block-keyword\" >function</span> <span class=\"token punctuation\" >(</span>props<span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n  <span class=\"token keyword\" >return</span> <span class=\"token function\" >canMoveKnight<span class=\"token punctuation\" >(</span></span>props<span class=\"token punctuation\" >.</span>x<span class=\"token punctuation\" >,</span> props<span class=\"token punctuation\" >.</span>y<span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n<span class=\"token punctuation\" >}</span></code><hr/>\n<code class=\"codeBlock\"><span class=\"token function\" >canDrop<span class=\"token punctuation\" >(</span></span>props<span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n  <span class=\"token keyword\" >return</span> <span class=\"token function\" >canMoveKnight<span class=\"token punctuation\" >(</span></span>props<span class=\"token punctuation\" >.</span>x<span class=\"token punctuation\" >,</span> props<span class=\"token punctuation\" >.</span>y<span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n<span class=\"token punctuation\" >}</span></code><hr/>\n<hr/>\n<p>I&#39;m also adding <code>monitor.canDrop()</code> to my collecting function, as well as some overlay rendering code to the component:</p>\n<hr/>\n<code class=\"codeBlock\"><span class=\"token keyword\" >var</span> <span class=\"token qualifier\" >React</span> <span class=\"token operator\" >=</span> <span class=\"token function\" >require<span class=\"token punctuation\" >(</span></span><span class=\"token string\" >'react'</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n<span class=\"token keyword\" >var</span> <span class=\"token qualifier\" >Prop</span><span class=\"token qualifier\" >Types</span> <span class=\"token operator\" >=</span> <span class=\"token qualifier\" >React</span><span class=\"token punctuation\" >.</span><span class=\"token qualifier\" >Prop</span><span class=\"token qualifier\" >Types</span><span class=\"token punctuation\" >;</span>\n<span class=\"token keyword\" >var</span> <span class=\"token qualifier\" >Square</span> <span class=\"token operator\" >=</span> <span class=\"token function\" >require<span class=\"token punctuation\" >(</span></span><span class=\"token string\" >'./Square'</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n<span class=\"token keyword\" >var</span> canMoveKnight <span class=\"token operator\" >=</span> <span class=\"token function\" >require<span class=\"token punctuation\" >(</span></span><span class=\"token string\" >'./Game'</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >.</span>canMoveKnight<span class=\"token punctuation\" >;</span>\n<span class=\"token keyword\" >var</span> moveKnight <span class=\"token operator\" >=</span> <span class=\"token function\" >require<span class=\"token punctuation\" >(</span></span><span class=\"token string\" >'./Game'</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >.</span>moveKnight<span class=\"token punctuation\" >;</span>\n<span class=\"token keyword\" >var</span> <span class=\"token qualifier\" >Item</span><span class=\"token qualifier\" >Types</span> <span class=\"token operator\" >=</span> <span class=\"token function\" >require<span class=\"token punctuation\" >(</span></span><span class=\"token string\" >'./Constants'</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >.</span><span class=\"token qualifier\" >Item</span><span class=\"token qualifier\" >Types</span><span class=\"token punctuation\" >;</span>\n<span class=\"token keyword\" >var</span> <span class=\"token qualifier\" >Drop</span><span class=\"token qualifier\" >Target</span> <span class=\"token operator\" >=</span> <span class=\"token function\" >require<span class=\"token punctuation\" >(</span></span><span class=\"token string\" >'react-dnd'</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >.</span><span class=\"token qualifier\" >Drop</span><span class=\"token qualifier\" >Target</span><span class=\"token punctuation\" >;</span>\n\n<span class=\"token keyword\" >var</span> squareTarget <span class=\"token operator\" >=</span> <span class=\"token punctuation\" >{</span>\n  canDrop<span class=\"token punctuation\" >:</span> <span class=\"token block-keyword\" >function</span> <span class=\"token punctuation\" >(</span>props<span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n    <span class=\"token keyword\" >return</span> <span class=\"token function\" >canMoveKnight<span class=\"token punctuation\" >(</span></span>props<span class=\"token punctuation\" >.</span>x<span class=\"token punctuation\" >,</span> props<span class=\"token punctuation\" >.</span>y<span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n  <span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >,</span>\n\n  drop<span class=\"token punctuation\" >:</span> <span class=\"token block-keyword\" >function</span> <span class=\"token punctuation\" >(</span>props<span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n    <span class=\"token function\" >moveKnight<span class=\"token punctuation\" >(</span></span>props<span class=\"token punctuation\" >.</span>x<span class=\"token punctuation\" >,</span> props<span class=\"token punctuation\" >.</span>y<span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n  <span class=\"token punctuation\" >}</span>\n<span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >;</span>\n\n<span class=\"token block-keyword\" >function</span> <span class=\"token function\" >collect<span class=\"token punctuation\" >(</span></span>connect<span class=\"token punctuation\" >,</span> monitor<span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n  <span class=\"token keyword\" >return</span> <span class=\"token punctuation\" >{</span>\n    connectDropTarget<span class=\"token punctuation\" >:</span> connect<span class=\"token punctuation\" >.</span><span class=\"token function\" >dropTarget<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >,</span>\n    isOver<span class=\"token punctuation\" >:</span> monitor<span class=\"token punctuation\" >.</span><span class=\"token function\" >isOver<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >,</span>\n    canDrop<span class=\"token punctuation\" >:</span> monitor<span class=\"token punctuation\" >.</span><span class=\"token function\" >canDrop<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span>\n  <span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >;</span>\n<span class=\"token punctuation\" >}</span>\n\n<span class=\"token keyword\" >var</span> <span class=\"token qualifier\" >Board</span><span class=\"token qualifier\" >Square</span> <span class=\"token operator\" >=</span> <span class=\"token qualifier\" >React</span><span class=\"token punctuation\" >.</span><span class=\"token function\" >createClass<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >{</span>\n  propTypes<span class=\"token punctuation\" >:</span> <span class=\"token punctuation\" >{</span>\n    x<span class=\"token punctuation\" >:</span> <span class=\"token qualifier\" >Prop</span><span class=\"token qualifier\" >Types</span><span class=\"token punctuation\" >.</span>number<span class=\"token punctuation\" >.</span>isRequired<span class=\"token punctuation\" >,</span>\n    y<span class=\"token punctuation\" >:</span> <span class=\"token qualifier\" >Prop</span><span class=\"token qualifier\" >Types</span><span class=\"token punctuation\" >.</span>number<span class=\"token punctuation\" >.</span>isRequired<span class=\"token punctuation\" >,</span>\n    isOver<span class=\"token punctuation\" >:</span> <span class=\"token qualifier\" >Prop</span><span class=\"token qualifier\" >Types</span><span class=\"token punctuation\" >.</span>bool<span class=\"token punctuation\" >.</span>isRequired<span class=\"token punctuation\" >,</span>\n    canDrop<span class=\"token punctuation\" >:</span> <span class=\"token qualifier\" >Prop</span><span class=\"token qualifier\" >Types</span><span class=\"token punctuation\" >.</span>bool<span class=\"token punctuation\" >.</span>isRequired\n  <span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >,</span>\n\n  renderOverlay<span class=\"token punctuation\" >:</span> <span class=\"token block-keyword\" >function</span> <span class=\"token punctuation\" >(</span>color<span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n    <span class=\"token keyword\" >return</span> <span class=\"token punctuation\" >(</span>\n      <span class=\"token operator\" >&lt;</span>div style<span class=\"token operator\" >=</span><span class=\"token punctuation\" >{</span><span class=\"token punctuation\" >{</span>\n        position<span class=\"token punctuation\" >:</span> <span class=\"token string\" >'absolute'</span><span class=\"token punctuation\" >,</span>\n        top<span class=\"token punctuation\" >:</span> <span class=\"token number\" >0</span><span class=\"token punctuation\" >,</span>\n        left<span class=\"token punctuation\" >:</span> <span class=\"token number\" >0</span><span class=\"token punctuation\" >,</span>\n        height<span class=\"token punctuation\" >:</span> <span class=\"token string\" >'100%'</span><span class=\"token punctuation\" >,</span>\n        width<span class=\"token punctuation\" >:</span> <span class=\"token string\" >'100%'</span><span class=\"token punctuation\" >,</span>\n        zIndex<span class=\"token punctuation\" >:</span> <span class=\"token number\" >1</span><span class=\"token punctuation\" >,</span>\n        opacity<span class=\"token punctuation\" >:</span> <span class=\"token number\" >0.5</span><span class=\"token punctuation\" >,</span>\n        backgroundColor<span class=\"token punctuation\" >:</span> color<span class=\"token punctuation\" >,</span>\n      <span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >}</span> <span class=\"token operator\" >/</span><span class=\"token operator\" >></span>\n    <span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n  <span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >,</span>\n\n  render<span class=\"token punctuation\" >:</span> <span class=\"token block-keyword\" >function</span> <span class=\"token punctuation\" >(</span><span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n    <span class=\"token keyword\" >var</span> x <span class=\"token operator\" >=</span> <span class=\"token var\" >this</span><span class=\"token punctuation\" >.</span>props<span class=\"token punctuation\" >.</span>x<span class=\"token punctuation\" >;</span>\n    <span class=\"token keyword\" >var</span> y <span class=\"token operator\" >=</span> <span class=\"token var\" >this</span><span class=\"token punctuation\" >.</span>props<span class=\"token punctuation\" >.</span>y<span class=\"token punctuation\" >;</span>\n    <span class=\"token keyword\" >var</span> connectDropTarget <span class=\"token operator\" >=</span> <span class=\"token var\" >this</span><span class=\"token punctuation\" >.</span>props<span class=\"token punctuation\" >.</span>connectDropTarget<span class=\"token punctuation\" >;</span>\n    <span class=\"token keyword\" >var</span> isOver <span class=\"token operator\" >=</span> <span class=\"token var\" >this</span><span class=\"token punctuation\" >.</span>props<span class=\"token punctuation\" >.</span>isOver<span class=\"token punctuation\" >;</span>\n    <span class=\"token keyword\" >var</span> black <span class=\"token operator\" >=</span> <span class=\"token punctuation\" >(</span>x <span class=\"token operator\" >+</span> y<span class=\"token punctuation\" >)</span> <span class=\"token operator\" >%</span> <span class=\"token number\" >2</span> <span class=\"token operator\" >===</span> <span class=\"token number\" >1</span><span class=\"token punctuation\" >;</span>\n\n    <span class=\"token keyword\" >return</span> <span class=\"token function\" >connectDropTarget<span class=\"token punctuation\" >(</span></span>\n      <span class=\"token operator\" >&lt;</span>div style<span class=\"token operator\" >=</span><span class=\"token punctuation\" >{</span><span class=\"token punctuation\" >{</span>\n        position<span class=\"token punctuation\" >:</span> <span class=\"token string\" >'relative'</span><span class=\"token punctuation\" >,</span>\n        width<span class=\"token punctuation\" >:</span> <span class=\"token string\" >'100%'</span><span class=\"token punctuation\" >,</span>\n        height<span class=\"token punctuation\" >:</span> <span class=\"token string\" >'100%'</span>\n      <span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >}</span><span class=\"token operator\" >></span>\n        <span class=\"token operator\" >&lt;</span><span class=\"token qualifier\" >Square</span> black<span class=\"token operator\" >=</span><span class=\"token punctuation\" >{</span>black<span class=\"token punctuation\" >}</span><span class=\"token operator\" >></span>\n          <span class=\"token punctuation\" >{</span><span class=\"token var\" >this</span><span class=\"token punctuation\" >.</span>props<span class=\"token punctuation\" >.</span>children<span class=\"token punctuation\" >}</span>\n        <span class=\"token operator\" >&lt;</span><span class=\"token operator\" >/</span><span class=\"token qualifier\" >Square</span><span class=\"token operator\" >></span>\n        <span class=\"token punctuation\" >{</span>isOver <span class=\"token operator\" >&amp;&amp;</span> <span class=\"token operator\" >!</span>canDrop <span class=\"token operator\" >&amp;&amp;</span> <span class=\"token var\" >this</span><span class=\"token punctuation\" >.</span><span class=\"token function\" >renderOverlay<span class=\"token punctuation\" >(</span></span><span class=\"token string\" >'red'</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >}</span>\n        <span class=\"token punctuation\" >{</span><span class=\"token operator\" >!</span>isOver <span class=\"token operator\" >&amp;&amp;</span> canDrop <span class=\"token operator\" >&amp;&amp;</span> <span class=\"token var\" >this</span><span class=\"token punctuation\" >.</span><span class=\"token function\" >renderOverlay<span class=\"token punctuation\" >(</span></span><span class=\"token string\" >'yellow'</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >}</span>\n        <span class=\"token punctuation\" >{</span>isOver <span class=\"token operator\" >&amp;&amp;</span> canDrop <span class=\"token operator\" >&amp;&amp;</span> <span class=\"token var\" >this</span><span class=\"token punctuation\" >.</span><span class=\"token function\" >renderOverlay<span class=\"token punctuation\" >(</span></span><span class=\"token string\" >'green'</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >}</span>\n      <span class=\"token operator\" >&lt;</span><span class=\"token operator\" >/</span>div<span class=\"token operator\" >></span>\n    <span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n  <span class=\"token punctuation\" >}</span>\n<span class=\"token punctuation\" >}</span>\n\nmodule<span class=\"token punctuation\" >.</span>exports <span class=\"token operator\" >=</span> <span class=\"token function\" >DropTarget<span class=\"token punctuation\" >(</span></span><span class=\"token qualifier\" >Item</span><span class=\"token qualifier\" >Types</span><span class=\"token punctuation\" >.</span>KNIGHT<span class=\"token punctuation\" >,</span> squareTarget<span class=\"token punctuation\" >,</span> collect<span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >(</span><span class=\"token qualifier\" >Board</span><span class=\"token qualifier\" >Square</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span></code><hr/>\n<code class=\"codeBlock\"><span class=\"token keyword\" >import</span> <span class=\"token qualifier\" >React</span><span class=\"token punctuation\" >,</span> <span class=\"token punctuation\" >{</span> <span class=\"token qualifier\" >Prop</span><span class=\"token qualifier\" >Types</span> <span class=\"token punctuation\" >}</span> from <span class=\"token string\" >'react'</span><span class=\"token punctuation\" >;</span>\n<span class=\"token keyword\" >import</span> <span class=\"token qualifier\" >Square</span> from <span class=\"token string\" >'./Square'</span><span class=\"token punctuation\" >;</span>\n<span class=\"token keyword\" >import</span> <span class=\"token punctuation\" >{</span> canMoveKnight<span class=\"token punctuation\" >,</span> moveKnight <span class=\"token punctuation\" >}</span> from <span class=\"token string\" >'./Game'</span><span class=\"token punctuation\" >;</span>\n<span class=\"token keyword\" >import</span> <span class=\"token punctuation\" >{</span> <span class=\"token qualifier\" >Item</span><span class=\"token qualifier\" >Types</span> <span class=\"token punctuation\" >}</span> from <span class=\"token string\" >'./Constants'</span><span class=\"token punctuation\" >;</span>\n<span class=\"token keyword\" >import</span> <span class=\"token punctuation\" >{</span> <span class=\"token qualifier\" >Drop</span><span class=\"token qualifier\" >Target</span> <span class=\"token punctuation\" >}</span> from <span class=\"token string\" >'react-dnd'</span><span class=\"token punctuation\" >;</span>\n\n<span class=\"token keyword\" >const</span> squareTarget <span class=\"token operator\" >=</span> <span class=\"token punctuation\" >{</span>\n  <span class=\"token function\" >canDrop<span class=\"token punctuation\" >(</span></span>props<span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n    <span class=\"token keyword\" >return</span> <span class=\"token function\" >canMoveKnight<span class=\"token punctuation\" >(</span></span>props<span class=\"token punctuation\" >.</span>x<span class=\"token punctuation\" >,</span> props<span class=\"token punctuation\" >.</span>y<span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n  <span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >,</span>\n\n  <span class=\"token function\" >drop<span class=\"token punctuation\" >(</span></span>props<span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n    <span class=\"token function\" >moveKnight<span class=\"token punctuation\" >(</span></span>props<span class=\"token punctuation\" >.</span>x<span class=\"token punctuation\" >,</span> props<span class=\"token punctuation\" >.</span>y<span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n  <span class=\"token punctuation\" >}</span>\n<span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >;</span>\n\n<span class=\"token block-keyword\" >function</span> <span class=\"token function\" >collect<span class=\"token punctuation\" >(</span></span>connect<span class=\"token punctuation\" >,</span> monitor<span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n  <span class=\"token keyword\" >return</span> <span class=\"token punctuation\" >{</span>\n    connectDropTarget<span class=\"token punctuation\" >:</span> connect<span class=\"token punctuation\" >.</span><span class=\"token function\" >dropTarget<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >,</span>\n    isOver<span class=\"token punctuation\" >:</span> monitor<span class=\"token punctuation\" >.</span><span class=\"token function\" >isOver<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >,</span>\n    canDrop<span class=\"token punctuation\" >:</span> monitor<span class=\"token punctuation\" >.</span><span class=\"token function\" >canDrop<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span>\n  <span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >;</span>\n<span class=\"token punctuation\" >}</span>\n\n<span class=\"token keyword\" >class</span> <span class=\"token class-name\" >BoardSquare</span> <span class=\"token punctuation\" >{</span>\n  <span class=\"token function\" >renderOverlay<span class=\"token punctuation\" >(</span></span>color<span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n    <span class=\"token keyword\" >return</span> <span class=\"token punctuation\" >(</span>\n      <span class=\"token operator\" >&lt;</span>div style<span class=\"token operator\" >=</span><span class=\"token punctuation\" >{</span><span class=\"token punctuation\" >{</span>\n        position<span class=\"token punctuation\" >:</span> <span class=\"token string\" >'absolute'</span><span class=\"token punctuation\" >,</span>\n        top<span class=\"token punctuation\" >:</span> <span class=\"token number\" >0</span><span class=\"token punctuation\" >,</span>\n        left<span class=\"token punctuation\" >:</span> <span class=\"token number\" >0</span><span class=\"token punctuation\" >,</span>\n        height<span class=\"token punctuation\" >:</span> <span class=\"token string\" >'100%'</span><span class=\"token punctuation\" >,</span>\n        width<span class=\"token punctuation\" >:</span> <span class=\"token string\" >'100%'</span><span class=\"token punctuation\" >,</span>\n        zIndex<span class=\"token punctuation\" >:</span> <span class=\"token number\" >1</span><span class=\"token punctuation\" >,</span>\n        opacity<span class=\"token punctuation\" >:</span> <span class=\"token number\" >0.5</span><span class=\"token punctuation\" >,</span>\n        backgroundColor<span class=\"token punctuation\" >:</span> color<span class=\"token punctuation\" >,</span>\n      <span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >}</span> <span class=\"token operator\" >/</span><span class=\"token operator\" >></span>\n    <span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n  <span class=\"token punctuation\" >}</span>\n\n  <span class=\"token function\" >render<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n    <span class=\"token keyword\" >const</span> <span class=\"token punctuation\" >{</span> x<span class=\"token punctuation\" >,</span> y<span class=\"token punctuation\" >,</span> connectDropTarget<span class=\"token punctuation\" >,</span> isOver<span class=\"token punctuation\" >,</span> canDrop <span class=\"token punctuation\" >}</span> <span class=\"token operator\" >=</span> <span class=\"token var\" >this</span><span class=\"token punctuation\" >.</span>props<span class=\"token punctuation\" >;</span>\n    <span class=\"token keyword\" >const</span> black <span class=\"token operator\" >=</span> <span class=\"token punctuation\" >(</span>x <span class=\"token operator\" >+</span> y<span class=\"token punctuation\" >)</span> <span class=\"token operator\" >%</span> <span class=\"token number\" >2</span> <span class=\"token operator\" >===</span> <span class=\"token number\" >1</span><span class=\"token punctuation\" >;</span>\n\n    <span class=\"token keyword\" >return</span> <span class=\"token function\" >connectDropTarget<span class=\"token punctuation\" >(</span></span>\n      <span class=\"token operator\" >&lt;</span>div style<span class=\"token operator\" >=</span><span class=\"token punctuation\" >{</span><span class=\"token punctuation\" >{</span> position<span class=\"token punctuation\" >:</span> <span class=\"token string\" >'relative'</span> <span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >}</span><span class=\"token operator\" >></span>\n        <span class=\"token operator\" >&lt;</span><span class=\"token qualifier\" >Square</span> black<span class=\"token operator\" >=</span><span class=\"token punctuation\" >{</span>black<span class=\"token punctuation\" >}</span><span class=\"token operator\" >></span>\n          <span class=\"token punctuation\" >{</span><span class=\"token var\" >this</span><span class=\"token punctuation\" >.</span>props<span class=\"token punctuation\" >.</span>children<span class=\"token punctuation\" >}</span>\n        <span class=\"token operator\" >&lt;</span><span class=\"token operator\" >/</span><span class=\"token qualifier\" >Square</span><span class=\"token operator\" >></span>\n        <span class=\"token punctuation\" >{</span>isOver <span class=\"token operator\" >&amp;&amp;</span> <span class=\"token operator\" >!</span>canDrop <span class=\"token operator\" >&amp;&amp;</span> <span class=\"token var\" >this</span><span class=\"token punctuation\" >.</span><span class=\"token function\" >renderOverlay<span class=\"token punctuation\" >(</span></span><span class=\"token string\" >'red'</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >}</span>\n        <span class=\"token punctuation\" >{</span><span class=\"token operator\" >!</span>isOver <span class=\"token operator\" >&amp;&amp;</span> canDrop <span class=\"token operator\" >&amp;&amp;</span> <span class=\"token var\" >this</span><span class=\"token punctuation\" >.</span><span class=\"token function\" >renderOverlay<span class=\"token punctuation\" >(</span></span><span class=\"token string\" >'yellow'</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >}</span>\n        <span class=\"token punctuation\" >{</span>isOver <span class=\"token operator\" >&amp;&amp;</span> canDrop <span class=\"token operator\" >&amp;&amp;</span> <span class=\"token var\" >this</span><span class=\"token punctuation\" >.</span><span class=\"token function\" >renderOverlay<span class=\"token punctuation\" >(</span></span><span class=\"token string\" >'green'</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >}</span>\n      <span class=\"token operator\" >&lt;</span><span class=\"token operator\" >/</span>div<span class=\"token operator\" >></span>\n    <span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n  <span class=\"token punctuation\" >}</span>\n<span class=\"token punctuation\" >}</span>\n\n<span class=\"token qualifier\" >Board</span><span class=\"token qualifier\" >Square</span><span class=\"token punctuation\" >.</span>propTypes <span class=\"token operator\" >=</span> <span class=\"token punctuation\" >{</span>\n  x<span class=\"token punctuation\" >:</span> <span class=\"token qualifier\" >Prop</span><span class=\"token qualifier\" >Types</span><span class=\"token punctuation\" >.</span>number<span class=\"token punctuation\" >.</span>isRequired<span class=\"token punctuation\" >,</span>\n  y<span class=\"token punctuation\" >:</span> <span class=\"token qualifier\" >Prop</span><span class=\"token qualifier\" >Types</span><span class=\"token punctuation\" >.</span>number<span class=\"token punctuation\" >.</span>isRequired<span class=\"token punctuation\" >,</span>\n  isOver<span class=\"token punctuation\" >:</span> <span class=\"token qualifier\" >Prop</span><span class=\"token qualifier\" >Types</span><span class=\"token punctuation\" >.</span>bool<span class=\"token punctuation\" >.</span>isRequired<span class=\"token punctuation\" >,</span>\n  canDrop<span class=\"token punctuation\" >:</span> <span class=\"token qualifier\" >Prop</span><span class=\"token qualifier\" >Types</span><span class=\"token punctuation\" >.</span>bool<span class=\"token punctuation\" >.</span>isRequired\n<span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >;</span>\n\n<span class=\"token keyword\" >export</span> <span class=\"token keyword\" >default</span> <span class=\"token function\" >DropTarget<span class=\"token punctuation\" >(</span></span><span class=\"token qualifier\" >Item</span><span class=\"token qualifier\" >Types</span><span class=\"token punctuation\" >.</span>KNIGHT<span class=\"token punctuation\" >,</span> squareTarget<span class=\"token punctuation\" >,</span> collect<span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >(</span><span class=\"token qualifier\" >Board</span><span class=\"token qualifier\" >Square</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span></code><hr/>\n<code class=\"codeBlock\"><span class=\"token keyword\" >import</span> <span class=\"token qualifier\" >React</span><span class=\"token punctuation\" >,</span> <span class=\"token punctuation\" >{</span> <span class=\"token qualifier\" >Prop</span><span class=\"token qualifier\" >Types</span> <span class=\"token punctuation\" >}</span> from <span class=\"token string\" >'react'</span><span class=\"token punctuation\" >;</span>\n<span class=\"token keyword\" >import</span> <span class=\"token qualifier\" >Square</span> from <span class=\"token string\" >'./Square'</span><span class=\"token punctuation\" >;</span>\n<span class=\"token keyword\" >import</span> <span class=\"token punctuation\" >{</span> canMoveKnight<span class=\"token punctuation\" >,</span> moveKnight <span class=\"token punctuation\" >}</span> from <span class=\"token string\" >'./Game'</span><span class=\"token punctuation\" >;</span>\n<span class=\"token keyword\" >import</span> <span class=\"token punctuation\" >{</span> <span class=\"token qualifier\" >Item</span><span class=\"token qualifier\" >Types</span> <span class=\"token punctuation\" >}</span> from <span class=\"token string\" >'./Constants'</span><span class=\"token punctuation\" >;</span>\n<span class=\"token keyword\" >import</span> <span class=\"token punctuation\" >{</span> <span class=\"token qualifier\" >Drop</span><span class=\"token qualifier\" >Target</span> <span class=\"token punctuation\" >}</span> from <span class=\"token string\" >'react-dnd'</span><span class=\"token punctuation\" >;</span>\n\n<span class=\"token keyword\" >const</span> squareTarget <span class=\"token operator\" >=</span> <span class=\"token punctuation\" >{</span>\n  <span class=\"token function\" >canDrop<span class=\"token punctuation\" >(</span></span>props<span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n    <span class=\"token keyword\" >return</span> <span class=\"token function\" >canMoveKnight<span class=\"token punctuation\" >(</span></span>props<span class=\"token punctuation\" >.</span>x<span class=\"token punctuation\" >,</span> props<span class=\"token punctuation\" >.</span>y<span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n  <span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >,</span>\n\n  <span class=\"token function\" >drop<span class=\"token punctuation\" >(</span></span>props<span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n    <span class=\"token function\" >moveKnight<span class=\"token punctuation\" >(</span></span>props<span class=\"token punctuation\" >.</span>x<span class=\"token punctuation\" >,</span> props<span class=\"token punctuation\" >.</span>y<span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n  <span class=\"token punctuation\" >}</span>\n<span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >;</span>\n\n<span class=\"token block-keyword\" >function</span> <span class=\"token function\" >collect<span class=\"token punctuation\" >(</span></span>connect<span class=\"token punctuation\" >,</span> monitor<span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n  <span class=\"token keyword\" >return</span> <span class=\"token punctuation\" >{</span>\n    connectDropTarget<span class=\"token punctuation\" >:</span> connect<span class=\"token punctuation\" >.</span><span class=\"token function\" >dropTarget<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >,</span>\n    isOver<span class=\"token punctuation\" >:</span> monitor<span class=\"token punctuation\" >.</span><span class=\"token function\" >isOver<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >,</span>\n    canDrop<span class=\"token punctuation\" >:</span> monitor<span class=\"token punctuation\" >.</span><span class=\"token function\" >canDrop<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span>\n  <span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >;</span>\n<span class=\"token punctuation\" >}</span>\n\n@<span class=\"token function\" >DropTarget<span class=\"token punctuation\" >(</span></span><span class=\"token qualifier\" >Item</span><span class=\"token qualifier\" >Types</span><span class=\"token punctuation\" >.</span>KNIGHT<span class=\"token punctuation\" >,</span> squareTarget<span class=\"token punctuation\" >,</span> collect<span class=\"token punctuation\" >)</span>\n<span class=\"token keyword\" >export</span> <span class=\"token keyword\" >default</span> <span class=\"token keyword\" >class</span> <span class=\"token class-name\" >BoardSquare</span> <span class=\"token punctuation\" >{</span>\n  <span class=\"token keyword\" >static</span> propTypes <span class=\"token operator\" >=</span> <span class=\"token punctuation\" >{</span>\n    x<span class=\"token punctuation\" >:</span> <span class=\"token qualifier\" >Prop</span><span class=\"token qualifier\" >Types</span><span class=\"token punctuation\" >.</span>number<span class=\"token punctuation\" >.</span>isRequired<span class=\"token punctuation\" >,</span>\n    y<span class=\"token punctuation\" >:</span> <span class=\"token qualifier\" >Prop</span><span class=\"token qualifier\" >Types</span><span class=\"token punctuation\" >.</span>number<span class=\"token punctuation\" >.</span>isRequired<span class=\"token punctuation\" >,</span>\n    isOver<span class=\"token punctuation\" >:</span> <span class=\"token qualifier\" >Prop</span><span class=\"token qualifier\" >Types</span><span class=\"token punctuation\" >.</span>bool<span class=\"token punctuation\" >.</span>isRequired<span class=\"token punctuation\" >,</span>\n    canDrop<span class=\"token punctuation\" >:</span> <span class=\"token qualifier\" >Prop</span><span class=\"token qualifier\" >Types</span><span class=\"token punctuation\" >.</span>bool<span class=\"token punctuation\" >.</span>isRequired\n  <span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >;</span>\n\n  <span class=\"token function\" >renderOverlay<span class=\"token punctuation\" >(</span></span>color<span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n    <span class=\"token keyword\" >return</span> <span class=\"token punctuation\" >(</span>\n      <span class=\"token operator\" >&lt;</span>div style<span class=\"token operator\" >=</span><span class=\"token punctuation\" >{</span><span class=\"token punctuation\" >{</span>\n        position<span class=\"token punctuation\" >:</span> <span class=\"token string\" >'absolute'</span><span class=\"token punctuation\" >,</span>\n        top<span class=\"token punctuation\" >:</span> <span class=\"token number\" >0</span><span class=\"token punctuation\" >,</span>\n        left<span class=\"token punctuation\" >:</span> <span class=\"token number\" >0</span><span class=\"token punctuation\" >,</span>\n        height<span class=\"token punctuation\" >:</span> <span class=\"token string\" >'100%'</span><span class=\"token punctuation\" >,</span>\n        width<span class=\"token punctuation\" >:</span> <span class=\"token string\" >'100%'</span><span class=\"token punctuation\" >,</span>\n        zIndex<span class=\"token punctuation\" >:</span> <span class=\"token number\" >1</span><span class=\"token punctuation\" >,</span>\n        opacity<span class=\"token punctuation\" >:</span> <span class=\"token number\" >0.5</span><span class=\"token punctuation\" >,</span>\n        backgroundColor<span class=\"token punctuation\" >:</span> color<span class=\"token punctuation\" >,</span>\n      <span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >}</span> <span class=\"token operator\" >/</span><span class=\"token operator\" >></span>\n    <span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n  <span class=\"token punctuation\" >}</span>\n\n  <span class=\"token function\" >render<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n    <span class=\"token keyword\" >const</span> <span class=\"token punctuation\" >{</span> x<span class=\"token punctuation\" >,</span> y<span class=\"token punctuation\" >,</span> connectDropTarget<span class=\"token punctuation\" >,</span> isOver<span class=\"token punctuation\" >,</span> canDrop <span class=\"token punctuation\" >}</span> <span class=\"token operator\" >=</span> <span class=\"token var\" >this</span><span class=\"token punctuation\" >.</span>props<span class=\"token punctuation\" >;</span>\n    <span class=\"token keyword\" >const</span> black <span class=\"token operator\" >=</span> <span class=\"token punctuation\" >(</span>x <span class=\"token operator\" >+</span> y<span class=\"token punctuation\" >)</span> <span class=\"token operator\" >%</span> <span class=\"token number\" >2</span> <span class=\"token operator\" >===</span> <span class=\"token number\" >1</span><span class=\"token punctuation\" >;</span>\n\n    <span class=\"token keyword\" >return</span> <span class=\"token function\" >connectDropTarget<span class=\"token punctuation\" >(</span></span>\n      <span class=\"token operator\" >&lt;</span>div style<span class=\"token operator\" >=</span><span class=\"token punctuation\" >{</span><span class=\"token punctuation\" >{</span> position<span class=\"token punctuation\" >:</span> <span class=\"token string\" >'relative'</span> <span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >}</span><span class=\"token operator\" >></span>\n        <span class=\"token operator\" >&lt;</span><span class=\"token qualifier\" >Square</span> black<span class=\"token operator\" >=</span><span class=\"token punctuation\" >{</span>black<span class=\"token punctuation\" >}</span><span class=\"token operator\" >></span>\n          <span class=\"token punctuation\" >{</span><span class=\"token var\" >this</span><span class=\"token punctuation\" >.</span>props<span class=\"token punctuation\" >.</span>children<span class=\"token punctuation\" >}</span>\n        <span class=\"token operator\" >&lt;</span><span class=\"token operator\" >/</span><span class=\"token qualifier\" >Square</span><span class=\"token operator\" >></span>\n        <span class=\"token punctuation\" >{</span>isOver <span class=\"token operator\" >&amp;&amp;</span> <span class=\"token operator\" >!</span>canDrop <span class=\"token operator\" >&amp;&amp;</span> <span class=\"token var\" >this</span><span class=\"token punctuation\" >.</span><span class=\"token function\" >renderOverlay<span class=\"token punctuation\" >(</span></span><span class=\"token string\" >'red'</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >}</span>\n        <span class=\"token punctuation\" >{</span><span class=\"token operator\" >!</span>isOver <span class=\"token operator\" >&amp;&amp;</span> canDrop <span class=\"token operator\" >&amp;&amp;</span> <span class=\"token var\" >this</span><span class=\"token punctuation\" >.</span><span class=\"token function\" >renderOverlay<span class=\"token punctuation\" >(</span></span><span class=\"token string\" >'yellow'</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >}</span>\n        <span class=\"token punctuation\" >{</span>isOver <span class=\"token operator\" >&amp;&amp;</span> canDrop <span class=\"token operator\" >&amp;&amp;</span> <span class=\"token var\" >this</span><span class=\"token punctuation\" >.</span><span class=\"token function\" >renderOverlay<span class=\"token punctuation\" >(</span></span><span class=\"token string\" >'green'</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >}</span>\n      <span class=\"token operator\" >&lt;</span><span class=\"token operator\" >/</span>div<span class=\"token operator\" >></span>\n    <span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n  <span class=\"token punctuation\" >}</span>\n<span class=\"token punctuation\" >}</span></code><hr/>\n<p><img src='https://s3.amazonaws.com/f.cl.ly/items/0X3c342g0i3u100p1o18/Screen%20Recording%202015-05-15%20at%2002.05%20pm.gif' width='404' height='445' alt='Screenshot'></p>\n<h3>Final Touches<a id=\"final-touches\">&nbsp;</a></h3><p>This tutorial guided you through creating the React components, making the design decisions about them and the app&#39;s data layer, and finally adding the drag and drop interaction. My intention was to show you that React DnD fits great with the philosophy of React, and that you should think about the app architecture first before diving into implementing the complex interactions.</p>\n<p>The last thing I want to demonstrate is drag preview customization. Sure, the browser will screenshot the DOM node, but what if we want to show something different?</p>\n<p>We are lucky again, because it is easy to do with React DnD. We just need to add a <code>connect.dragPreview()</code> to the collecting function of the <code>Knight</code>:</p>\n<code class=\"codeBlock\"><span class=\"token block-keyword\" >function</span> <span class=\"token function\" >collect<span class=\"token punctuation\" >(</span></span>connect<span class=\"token punctuation\" >,</span> monitor<span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n  <span class=\"token keyword\" >return</span> <span class=\"token punctuation\" >{</span>\n    connectDragSource<span class=\"token punctuation\" >:</span> connect<span class=\"token punctuation\" >.</span><span class=\"token function\" >dragSource<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >,</span>\n    connectDragPreview<span class=\"token punctuation\" >:</span> connect<span class=\"token punctuation\" >.</span><span class=\"token function\" >dragPreview<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >,</span>\n    isDragging<span class=\"token punctuation\" >:</span> monitor<span class=\"token punctuation\" >.</span><span class=\"token function\" >isDragging<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span>\n  <span class=\"token punctuation\" >}</span>\n<span class=\"token punctuation\" >}</span></code><p>This lets us use <code>connectDragPreview</code> in <code>render</code> method, just like we used <code>connectDragSource</code>, or even in <code>componentDidMount</code> with a custom image:</p>\n<hr/>\n<code class=\"codeBlock\">componentDidMount<span class=\"token punctuation\" >:</span> <span class=\"token block-keyword\" >function</span> <span class=\"token punctuation\" >(</span><span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n  <span class=\"token keyword\" >var</span> connectDragPreview <span class=\"token operator\" >=</span> <span class=\"token var\" >this</span><span class=\"token punctuation\" >.</span>props<span class=\"token punctuation\" >.</span>connectDragPreview<span class=\"token punctuation\" >;</span>\n  <span class=\"token keyword\" >var</span> img <span class=\"token operator\" >=</span> <span class=\"token keyword\" >new</span> <span class=\"token class-name\" >Image</span><span class=\"token punctuation\" >(</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n  img<span class=\"token punctuation\" >.</span>src <span class=\"token operator\" >=</span> 'data<span class=\"token punctuation\" >:</span>image<span class=\"token operator\" >/</span>png<span class=\"token punctuation\" >;</span>base64<span class=\"token punctuation\" >,</span>iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAAAXNSR0IArs4c6QAAAAlwSFlzAAALEwAACxMBAJqcGAAAAVlpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IlhNUCBDb3JlIDUuNC4wIj4KICAgPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4KICAgICAgPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIKICAgICAgICAgICAgeG1sbnM6dGlmZj0iaHR0cDovL25zLmFkb2JlLmNvbS90aWZmLzEuMC8iPgogICAgICAgICA8dGlmZjpPcmllbnRhdGlvbj4xPC90aWZmOk9yaWVudGF0aW9uPgogICAgICA8L3JkZjpEZXNjcmlwdGlvbj4KICAgPC9yZGY6UkRGPgo8L3g6eG1wbWV0YT4KTMInWQAAOD1JREFUeAHtnQm8nHdZ75939pkzZ805OVtyktMkTZOmTZrupaWUlkJBBUSKKIJ6URBRP16vF71yBVHB<span class=\"token operator\" >+</span>5ErcvWjotWiVJZ6QfbSUmhLpemSpkmaNHvOvi9zZt9n7vf3nx7oLXCygJBq3mTOzLz7<span class=\"token operator\" >++</span>zP73n<span class=\"token operator\" >+</span><span class=\"token operator\" >/</span>zE7v5ynwHkKnKfAeQqcp8B5CpynwHkKnKfAeQqcp8B5CpynwHkKnKfAeQqcp8DKFHj60Xsu<span class=\"token operator\" >/</span>dB73<span class=\"token operator\" >/</span>bJB<span class=\"token operator\" >+</span><span class=\"token number\" >75</span><span class=\"token operator\" >+</span>PUr7<span class=\"token operator\" >/</span>nvuzXw73v6c<span class=\"token comment\" spellcheck=\"true\">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';\n</span>  img<span class=\"token punctuation\" >.</span>onload <span class=\"token operator\" >=</span> <span class=\"token block-keyword\" >function</span> <span class=\"token punctuation\" >(</span><span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n    <span class=\"token function\" >connectDragPreview<span class=\"token punctuation\" >(</span></span>img<span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n  <span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >;</span>\n<span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >,</span></code><hr/>\n<code class=\"codeBlock\"><span class=\"token function\" >componentDidMount<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n  <span class=\"token keyword\" >const</span> img <span class=\"token operator\" >=</span> <span class=\"token keyword\" >new</span> <span class=\"token class-name\" >Image</span><span class=\"token punctuation\" >(</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n  img<span class=\"token punctuation\" >.</span>src <span class=\"token operator\" >=</span> 'data<span class=\"token punctuation\" >:</span>image<span class=\"token operator\" >/</span>png<span class=\"token punctuation\" >;</span>base64<span class=\"token punctuation\" >,</span>iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAAAXNSR0IArs4c6QAAAAlwSFlzAAALEwAACxMBAJqcGAAAAVlpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IlhNUCBDb3JlIDUuNC4wIj4KICAgPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4KICAgICAgPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIKICAgICAgICAgICAgeG1sbnM6dGlmZj0iaHR0cDovL25zLmFkb2JlLmNvbS90aWZmLzEuMC8iPgogICAgICAgICA8dGlmZjpPcmllbnRhdGlvbj4xPC90aWZmOk9yaWVudGF0aW9uPgogICAgICA8L3JkZjpEZXNjcmlwdGlvbj4KICAgPC9yZGY6UkRGPgo8L3g6eG1wbWV0YT4KTMInWQAAOD1JREFUeAHtnQm8nHdZ75939pkzZ805OVtyktMkTZOmTZrupaWUlkJBBUSKKIJ6URBRP16vF71yBVHB<span class=\"token operator\" >+</span>5ErcvWjotWiVJZ6QfbSUmhLpemSpkmaNHvOvi9zZt9n7vf3nx7oLXCygJBq3mTOzLz7<span class=\"token operator\" >++</span>zP73n<span class=\"token operator\" >+</span><span class=\"token operator\" >/</span>zE7v5ynwHkKnKfAeQqcp8B5CpynwHkKnKfAeQqcp8B5CpynwHkKnKfAeQqcp8DKFHj60Xsu<span class=\"token operator\" >/</span>dB73<span class=\"token operator\" >/</span>bJB<span class=\"token operator\" >+</span><span class=\"token number\" >75</span><span class=\"token operator\" >+</span>PUr7<span class=\"token operator\" >/</span>nvuzXw73v6c<span class=\"token comment\" spellcheck=\"true\">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';\n</span>  img<span class=\"token punctuation\" >.</span>onload <span class=\"token operator\" >=</span> <span class=\"token punctuation\" >(</span><span class=\"token punctuation\" >)</span> <span class=\"token operator\" >=</span><span class=\"token operator\" >></span> <span class=\"token var\" >this</span><span class=\"token punctuation\" >.</span>props<span class=\"token punctuation\" >.</span><span class=\"token function\" >connectDragPreview<span class=\"token punctuation\" >(</span></span>img<span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n<span class=\"token punctuation\" >}</span></code><hr/>\n<hr/>\n<p>Happy dragging and dropping.</p>\n<p><img src='https://s3.amazonaws.com/f.cl.ly/items/1F2g2F0D470X0d0k2A1U/Screen%20Recording%202015-05-15%20at%2002.22%20pm.gif' width='404' height='445' alt='Screenshot'></p>\n<p>Now go and <a href=\"examples-chessboard-tutorial-app.html\">play with it</a>!</p>\n";

/***/ },
/* 334 */
/***/ function(module, exports) {

	module.exports = "<p><em>New to React DnD? <a href=\"docs-overview.html\">Read the overview</a> before jumping into the docs.</em></p>\n<h1>DragDropContext<a id=\"dragdropcontext\">&nbsp;</a></h1><p>Wrap the root component of your application with <code>DragDropContext</code> to set up React DnD.<br/>This lets you specify the backend, and sets up the shared DnD state behind the scenes.</p>\n<h3>Usage<a id=\"usage\">&nbsp;</a></h3><hr/>\n<code class=\"codeBlock\"><span class=\"token keyword\" >var</span> HTML5Backend <span class=\"token operator\" >=</span> <span class=\"token function\" >require<span class=\"token punctuation\" >(</span></span><span class=\"token string\" >'react-dnd/modules/backends/HTML5'</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n<span class=\"token keyword\" >var</span> <span class=\"token qualifier\" >Drag</span><span class=\"token qualifier\" >Drop</span><span class=\"token qualifier\" >Context</span> <span class=\"token operator\" >=</span> <span class=\"token function\" >require<span class=\"token punctuation\" >(</span></span><span class=\"token string\" >'react-dnd'</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >.</span><span class=\"token qualifier\" >Drag</span><span class=\"token qualifier\" >Drop</span><span class=\"token qualifier\" >Context</span><span class=\"token punctuation\" >;</span>\n\n<span class=\"token keyword\" >var</span> <span class=\"token qualifier\" >Your</span><span class=\"token qualifier\" >App</span> <span class=\"token operator\" >=</span> <span class=\"token qualifier\" >React</span><span class=\"token punctuation\" >.</span><span class=\"token function\" >createClass<span class=\"token punctuation\" >(</span></span>\n  <span class=\"token comment\" spellcheck=\"true\">/* ... */</span>\n<span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n\nmodule<span class=\"token punctuation\" >.</span>exports <span class=\"token operator\" >=</span> <span class=\"token function\" >DragDropContext<span class=\"token punctuation\" >(</span></span>HTML5Backend<span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >(</span><span class=\"token qualifier\" >Your</span><span class=\"token qualifier\" >App</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span></code><hr/>\n<code class=\"codeBlock\"><span class=\"token keyword\" >import</span> HTML5Backend from <span class=\"token string\" >'react-dnd/modules/backends/HTML5'</span><span class=\"token punctuation\" >;</span>\n<span class=\"token keyword\" >import</span> <span class=\"token punctuation\" >{</span> <span class=\"token qualifier\" >Drag</span><span class=\"token qualifier\" >Drop</span><span class=\"token qualifier\" >Context</span> <span class=\"token punctuation\" >}</span> from <span class=\"token string\" >'react-dnd'</span><span class=\"token punctuation\" >;</span>\n\n<span class=\"token keyword\" >class</span> <span class=\"token class-name\" >YourApp</span> <span class=\"token punctuation\" >{</span>\n  <span class=\"token comment\" spellcheck=\"true\">/* ... */</span>\n<span class=\"token punctuation\" >}</span>\n\n<span class=\"token keyword\" >export</span> <span class=\"token keyword\" >default</span> <span class=\"token function\" >DragDropContext<span class=\"token punctuation\" >(</span></span>HTML5Backend<span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >(</span><span class=\"token qualifier\" >Your</span><span class=\"token qualifier\" >App</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span></code><hr/>\n<code class=\"codeBlock\"><span class=\"token keyword\" >import</span> HTML5Backend from <span class=\"token string\" >'react-dnd/modules/backends/HTML5'</span><span class=\"token punctuation\" >;</span>\n<span class=\"token keyword\" >import</span> <span class=\"token punctuation\" >{</span> <span class=\"token qualifier\" >Drag</span><span class=\"token qualifier\" >Drop</span><span class=\"token qualifier\" >Context</span> <span class=\"token punctuation\" >}</span> from <span class=\"token string\" >'react-dnd'</span><span class=\"token punctuation\" >;</span>\n\n@<span class=\"token function\" >DragDropContext<span class=\"token punctuation\" >(</span></span>HTML5Backend<span class=\"token punctuation\" >)</span>\n<span class=\"token keyword\" >export</span> <span class=\"token keyword\" >default</span> <span class=\"token keyword\" >class</span> <span class=\"token class-name\" >YourApp</span> <span class=\"token punctuation\" >{</span>\n  <span class=\"token comment\" spellcheck=\"true\">/* ... */</span>\n<span class=\"token punctuation\" >}</span></code><hr/>\n<h3>Parameters<a id=\"parameters\">&nbsp;</a></h3><ul>\n<li><strong><code>backend</code></strong>: Required. A React DnD backend. Unless you&#39;re writing a custom one, you probably want to use the <a href=\"docs-html5-backend.html\">HTML5 backend</a> that ships with React DnD.</li>\n</ul>\n<h3>Return Value<a id=\"return-value\">&nbsp;</a></h3><p><code>DragDropContext</code> wraps your component and returns another React component.<br/>For easier <a href=\"docs-testing.html\">testing</a>, it provides an API to reach into the internals:</p>\n<h4>Static Properties<a id=\"static-properties\">&nbsp;</a></h4><ul>\n<li><strong><code>DecoratedComponent</code></strong>: Returns the wrapped component type.</li>\n</ul>\n<h4>Instance Methods<a id=\"instance-methods\">&nbsp;</a></h4><ul>\n<li><p><strong><code>getDecoratedComponentInstance()</code></strong>: Returns the wrapped component instance.</p>\n</li>\n<li><p><strong><code>getManager()</code></strong>: Returns the internal manager that provides access to the underlying backend. This part is currently not documented, but you can refer to the <a href=\"docs-testing.html\">testing</a> tutorial for a usage example.</p>\n</li>\n</ul>\n";

/***/ },
/* 335 */
/***/ function(module, exports) {

	module.exports = "<p><em>New to React DnD? <a href=\"docs-overview.html\">Read the overview</a> before jumping into the docs.</em></p>\n<h1>DragLayer<a id=\"draglayer\">&nbsp;</a></h1><p><strong>This is an advanced feature.</strong>  </p>\n<p>For the most use cases, the default rendering of the <a href=\"docs-html5-backend.html\"><code>HTML5</code> backend</a> should suffice. However, its drag preview has certain limitations. For example, it has to be an existing node screenshot or an image, and it cannot change midflight.</p>\n<p>Sometimes you might want to perform the custom rendering. This also becomes necessary if you&#39;re using a custom backend. <code>DragLayer</code> lets you perform the rendering of the drag preview yourself using just the React components. It is a higher-order component accepting one required parameter that is described below.</p>\n<p>To use <code>DragLayer</code>, don&#39;t forget to wrap the top-level component of your app in a <a href=\"docs-drag-drop-context.html\"><code>DragDropContext</code></a>.</p>\n<h3>Signature<a id=\"signature\">&nbsp;</a></h3><p><code>DragLayer</code> uses partial application. After specifying its only parameter with the first call, you need to pass your React component class as the only parameter in the second call. This signature makes <code>DragLayer</code> usable as an ES7 decorator. Read the <a href=\"docs-overview.html\">overview</a> for a more detailed explanation of the decorators and the higher-order components.</p>\n<hr/>\n<code class=\"codeBlock\"><span class=\"token keyword\" >var</span> <span class=\"token qualifier\" >Drag</span><span class=\"token qualifier\" >Layer</span> <span class=\"token operator\" >=</span> <span class=\"token function\" >require<span class=\"token punctuation\" >(</span></span><span class=\"token string\" >'react-dnd'</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >.</span><span class=\"token qualifier\" >Drag</span><span class=\"token qualifier\" >Layer</span><span class=\"token punctuation\" >;</span>\n\n<span class=\"token keyword\" >var</span> <span class=\"token qualifier\" >Custom</span><span class=\"token qualifier\" >Drag</span><span class=\"token qualifier\" >Layer</span> <span class=\"token operator\" >=</span> <span class=\"token qualifier\" >React</span><span class=\"token punctuation\" >.</span><span class=\"token function\" >createClass<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >{</span>\n  <span class=\"token comment\" spellcheck=\"true\">/* ... */</span>\n<span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n\nmodule<span class=\"token punctuation\" >.</span>exports <span class=\"token operator\" >=</span> <span class=\"token function\" >DragLayer<span class=\"token punctuation\" >(</span></span>collect<span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >(</span><span class=\"token qualifier\" >Custom</span><span class=\"token qualifier\" >Drag</span><span class=\"token qualifier\" >Layer</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span></code><hr/>\n<code class=\"codeBlock\"><span class=\"token keyword\" >import</span> <span class=\"token punctuation\" >{</span> <span class=\"token qualifier\" >Drag</span><span class=\"token qualifier\" >Layer</span> <span class=\"token punctuation\" >}</span> from <span class=\"token string\" >'react-dnd'</span><span class=\"token punctuation\" >;</span>\n\n<span class=\"token keyword\" >class</span> <span class=\"token class-name\" >CustomDragLayer</span> <span class=\"token punctuation\" >{</span>\n  <span class=\"token comment\" spellcheck=\"true\">/* ... */</span>\n<span class=\"token punctuation\" >}</span>\n\n<span class=\"token keyword\" >export</span> <span class=\"token keyword\" >default</span> <span class=\"token function\" >DragLayer<span class=\"token punctuation\" >(</span></span>collect<span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >(</span><span class=\"token qualifier\" >Custom</span><span class=\"token qualifier\" >Drag</span><span class=\"token qualifier\" >Layer</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span></code><hr/>\n<code class=\"codeBlock\"><span class=\"token keyword\" >import</span> <span class=\"token punctuation\" >{</span> <span class=\"token qualifier\" >Drag</span><span class=\"token qualifier\" >Layer</span> <span class=\"token punctuation\" >}</span> from <span class=\"token string\" >'react-dnd'</span><span class=\"token punctuation\" >;</span>\n\n@<span class=\"token function\" >DragLayer<span class=\"token punctuation\" >(</span></span>collect<span class=\"token punctuation\" >)</span>\n<span class=\"token keyword\" >export</span> <span class=\"token keyword\" >default</span> <span class=\"token keyword\" >class</span> <span class=\"token class-name\" >CustomDragLayer</span> <span class=\"token punctuation\" >{</span>\n  <span class=\"token comment\" spellcheck=\"true\">/* ... */</span>\n<span class=\"token punctuation\" >}</span></code><hr/>\n<h3>Parameters<a id=\"parameters\">&nbsp;</a></h3><ul>\n<li><p><strong><code>collect</code></strong>: Required. The collecting function. It should return a plain object of the props to inject into your component. It receives a single <code>monitor</code> parameter. Read the <a href=\"docs-overview.html\">overview</a> for an introduction to the monitors and the collecting function. See the collecting function described in detail in the next section.</p>\n</li>\n<li><p><strong><code>options</code></strong>: Optional. A plain object. If some of the props to your component are not scalar (that is, are not primitive values or functions), specifying a custom <code>arePropsEqual(props, otherProps)</code> function inside the <code>options</code> object can improve the performance. Unless you have performance problems, don&#39;t worry about it.</p>\n</li>\n</ul>\n<h3>The Collecting Function<a id=\"the-collecting-function\">&nbsp;</a></h3><p>The collecting function signature is similar to the collecting functions of <a href=\"docs-drag-source.html\"><code>DragSource</code></a> and <a href=\"docs-drop-target.html\"><code>DropTarget</code></a>, except that it doesn&#39;t have a <code>connect</code> parameter because the drag layer is not interactive and only <em>reflects</em> the drag state. The collecting function is called any time the global drag state changes, including the coordinate changes, so that your component can provide a timely updated custom drag preview. You can ask the <code>monitor</code> for the client coordinates of the dragged item.</p>\n<h4>Parameters<a id=\"parameters\">&nbsp;</a></h4><ul>\n<li><strong><code>monitor</code></strong>: An instance of <a href=\"docs-drag-layer-monitor.html\"><code>DragLayerMonitor</code></a>. You can use it to query the information about the current drag state, including the coordinates. Read the <a href=\"docs-drag-layer-monitor.html\"><code>DragLayerMonitor</code> documentation</a> for a complete list of <code>monitor</code> methods, or read the <a href=\"docs-overview.html\">overview</a> for an introduction to the monitors.</li>\n</ul>\n<h3>Return Value<a id=\"return-value\">&nbsp;</a></h3><p><code>DragLayer</code> wraps your component and returns another React component.<br/>For easier <a href=\"docs-testing.html\">testing</a>, it provides an API to reach into the internals:</p>\n<h4>Static Properties<a id=\"static-properties\">&nbsp;</a></h4><ul>\n<li><strong><code>DecoratedComponent</code></strong>: Returns the wrapped component type.</li>\n</ul>\n<h4>Instance Methods<a id=\"instance-methods\">&nbsp;</a></h4><ul>\n<li><strong><code>getDecoratedComponentInstance()</code></strong>: Returns the wrapped component instance.</li>\n</ul>\n<h3>Example<a id=\"example\">&nbsp;</a></h3><hr/>\n<code class=\"codeBlock\"><span class=\"token keyword\" >var</span> <span class=\"token qualifier\" >React</span> <span class=\"token operator\" >=</span> <span class=\"token function\" >require<span class=\"token punctuation\" >(</span></span><span class=\"token string\" >'react'</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n<span class=\"token keyword\" >var</span> <span class=\"token qualifier\" >Prop</span><span class=\"token qualifier\" >Types</span> <span class=\"token operator\" >=</span> <span class=\"token qualifier\" >React</span><span class=\"token punctuation\" >.</span><span class=\"token qualifier\" >Prop</span><span class=\"token qualifier\" >Types</span><span class=\"token punctuation\" >;</span>\n<span class=\"token keyword\" >var</span> <span class=\"token qualifier\" >Item</span><span class=\"token qualifier\" >Types</span> <span class=\"token operator\" >=</span> <span class=\"token function\" >require<span class=\"token punctuation\" >(</span></span><span class=\"token string\" >'./ItemTypes'</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n<span class=\"token keyword\" >var</span> <span class=\"token qualifier\" >Box</span><span class=\"token qualifier\" >Drag</span><span class=\"token qualifier\" >Preview</span> <span class=\"token operator\" >=</span> <span class=\"token function\" >require<span class=\"token punctuation\" >(</span></span><span class=\"token string\" >'./BoxDragPreview'</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n<span class=\"token keyword\" >var</span> <span class=\"token qualifier\" >Drag</span><span class=\"token qualifier\" >Layer</span> <span class=\"token operator\" >=</span> <span class=\"token function\" >require<span class=\"token punctuation\" >(</span></span><span class=\"token string\" >'react-dnd'</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >.</span><span class=\"token qualifier\" >Drag</span><span class=\"token qualifier\" >Layer</span><span class=\"token punctuation\" >;</span>\n\n<span class=\"token keyword\" >var</span> layerStyles <span class=\"token operator\" >=</span> <span class=\"token punctuation\" >{</span>\n  position<span class=\"token punctuation\" >:</span> <span class=\"token string\" >'fixed'</span><span class=\"token punctuation\" >,</span>\n  pointerEvents<span class=\"token punctuation\" >:</span> <span class=\"token string\" >'none'</span><span class=\"token punctuation\" >,</span>\n  zIndex<span class=\"token punctuation\" >:</span> <span class=\"token number\" >100</span><span class=\"token punctuation\" >,</span>\n  left<span class=\"token punctuation\" >:</span> <span class=\"token number\" >0</span><span class=\"token punctuation\" >,</span>\n  top<span class=\"token punctuation\" >:</span> <span class=\"token number\" >0</span><span class=\"token punctuation\" >,</span>\n  width<span class=\"token punctuation\" >:</span> <span class=\"token string\" >'100%'</span><span class=\"token punctuation\" >,</span>\n  height<span class=\"token punctuation\" >:</span> <span class=\"token string\" >'100%'</span>\n<span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >;</span>\n\n<span class=\"token block-keyword\" >function</span> <span class=\"token function\" >getItemStyles<span class=\"token punctuation\" >(</span></span>props<span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n  <span class=\"token keyword\" >var</span> currentOffset <span class=\"token operator\" >=</span> props<span class=\"token punctuation\" >.</span>currentOffset<span class=\"token punctuation\" >;</span>\n  <span class=\"token block-keyword\" >if</span> <span class=\"token punctuation\" >(</span><span class=\"token operator\" >!</span>currentOffset<span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n    <span class=\"token keyword\" >return</span> <span class=\"token punctuation\" >{</span>\n      display<span class=\"token punctuation\" >:</span> <span class=\"token string\" >'none'</span>\n    <span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >;</span>\n  <span class=\"token punctuation\" >}</span>\n\n  <span class=\"token keyword\" >var</span> x <span class=\"token operator\" >=</span> currentOffset<span class=\"token punctuation\" >.</span>x<span class=\"token punctuation\" >;</span>\n  <span class=\"token keyword\" >var</span> y <span class=\"token operator\" >=</span> currentOffset<span class=\"token punctuation\" >.</span>y<span class=\"token punctuation\" >;</span>\n  <span class=\"token keyword\" >const</span> transform <span class=\"token operator\" >=</span> <span class=\"token string\" >'translate('</span> <span class=\"token operator\" >+</span> x <span class=\"token operator\" >+</span> <span class=\"token string\" >'px, '</span> <span class=\"token operator\" >+</span> y <span class=\"token operator\" >+</span> <span class=\"token string\" >'px)'</span><span class=\"token punctuation\" >;</span>\n  <span class=\"token keyword\" >return</span> <span class=\"token punctuation\" >{</span>\n    transform<span class=\"token punctuation\" >:</span> transform<span class=\"token punctuation\" >,</span>\n    <span class=\"token qualifier\" >Webkit</span><span class=\"token qualifier\" >Transform</span><span class=\"token punctuation\" >:</span> transform\n  <span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >;</span>\n<span class=\"token punctuation\" >}</span>\n\n<span class=\"token block-keyword\" >function</span> <span class=\"token function\" >collect<span class=\"token punctuation\" >(</span></span>monitor<span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n  <span class=\"token keyword\" >return</span> <span class=\"token punctuation\" >{</span>\n    item<span class=\"token punctuation\" >:</span> monitor<span class=\"token punctuation\" >.</span><span class=\"token function\" >getItem<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >,</span>\n    itemType<span class=\"token punctuation\" >:</span> monitor<span class=\"token punctuation\" >.</span><span class=\"token function\" >getItemType<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >,</span>\n    currentOffset<span class=\"token punctuation\" >:</span> monitor<span class=\"token punctuation\" >.</span><span class=\"token function\" >getSourceClientOffset<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >,</span>\n    isDragging<span class=\"token punctuation\" >:</span> monitor<span class=\"token punctuation\" >.</span><span class=\"token function\" >isDragging<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span>\n  <span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >;</span>\n<span class=\"token punctuation\" >}</span>\n\n<span class=\"token keyword\" >var</span> <span class=\"token qualifier\" >Custom</span><span class=\"token qualifier\" >Drag</span><span class=\"token qualifier\" >Layer</span> <span class=\"token operator\" >=</span> <span class=\"token qualifier\" >React</span><span class=\"token punctuation\" >.</span><span class=\"token function\" >createClass<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >{</span>\n  propTypes<span class=\"token punctuation\" >:</span> <span class=\"token punctuation\" >{</span>\n    item<span class=\"token punctuation\" >:</span> <span class=\"token qualifier\" >Prop</span><span class=\"token qualifier\" >Types</span><span class=\"token punctuation\" >.</span>object<span class=\"token punctuation\" >,</span>\n    itemType<span class=\"token punctuation\" >:</span> <span class=\"token qualifier\" >Prop</span><span class=\"token qualifier\" >Types</span><span class=\"token punctuation\" >.</span>string<span class=\"token punctuation\" >,</span>\n    currentOffset<span class=\"token punctuation\" >:</span> <span class=\"token qualifier\" >Prop</span><span class=\"token qualifier\" >Types</span><span class=\"token punctuation\" >.</span><span class=\"token function\" >shape<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >{</span>\n      x<span class=\"token punctuation\" >:</span> <span class=\"token qualifier\" >Prop</span><span class=\"token qualifier\" >Types</span><span class=\"token punctuation\" >.</span>number<span class=\"token punctuation\" >.</span>isRequired<span class=\"token punctuation\" >,</span>\n      y<span class=\"token punctuation\" >:</span> <span class=\"token qualifier\" >Prop</span><span class=\"token qualifier\" >Types</span><span class=\"token punctuation\" >.</span>number<span class=\"token punctuation\" >.</span>isRequired\n    <span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >,</span>\n    isDragging<span class=\"token punctuation\" >:</span> <span class=\"token qualifier\" >Prop</span><span class=\"token qualifier\" >Types</span><span class=\"token punctuation\" >.</span>bool<span class=\"token punctuation\" >.</span>isRequired\n  <span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >,</span>\n\n  renderItem<span class=\"token punctuation\" >:</span> <span class=\"token block-keyword\" >function</span> <span class=\"token punctuation\" >(</span>type<span class=\"token punctuation\" >,</span> item<span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n    <span class=\"token keyword\" >switch</span> <span class=\"token punctuation\" >(</span>type<span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n    <span class=\"token keyword\" >case</span> <span class=\"token qualifier\" >Item</span><span class=\"token qualifier\" >Types</span><span class=\"token punctuation\" >.</span>BOX<span class=\"token punctuation\" >:</span>\n      <span class=\"token keyword\" >return</span> <span class=\"token punctuation\" >(</span>\n        <span class=\"token operator\" >&lt;</span><span class=\"token qualifier\" >Box</span><span class=\"token qualifier\" >Drag</span><span class=\"token qualifier\" >Preview</span> title<span class=\"token operator\" >=</span><span class=\"token punctuation\" >{</span>item<span class=\"token punctuation\" >.</span>title<span class=\"token punctuation\" >}</span> <span class=\"token operator\" >/</span><span class=\"token operator\" >></span>\n      <span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n    <span class=\"token punctuation\" >}</span>\n  <span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >,</span>\n\n  render<span class=\"token punctuation\" >:</span> <span class=\"token block-keyword\" >function</span> <span class=\"token punctuation\" >(</span><span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n    <span class=\"token keyword\" >var</span> item <span class=\"token operator\" >=</span> <span class=\"token var\" >this</span><span class=\"token punctuation\" >.</span>props<span class=\"token punctuation\" >.</span>item<span class=\"token punctuation\" >;</span>\n    <span class=\"token keyword\" >var</span> itemType <span class=\"token operator\" >=</span> <span class=\"token var\" >this</span><span class=\"token punctuation\" >.</span>props<span class=\"token punctuation\" >.</span>itemType<span class=\"token punctuation\" >;</span>\n    <span class=\"token keyword\" >var</span> isDragging <span class=\"token operator\" >=</span> <span class=\"token var\" >this</span><span class=\"token punctuation\" >.</span>props<span class=\"token punctuation\" >.</span>isDragging<span class=\"token punctuation\" >;</span>\n    <span class=\"token block-keyword\" >if</span> <span class=\"token punctuation\" >(</span><span class=\"token operator\" >!</span>isDragging<span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n      <span class=\"token keyword\" >return</span> <span class=\"token primitive\" >null</span><span class=\"token punctuation\" >;</span>\n    <span class=\"token punctuation\" >}</span>\n\n    <span class=\"token keyword\" >return</span> <span class=\"token punctuation\" >(</span>\n      <span class=\"token operator\" >&lt;</span>div style<span class=\"token operator\" >=</span><span class=\"token punctuation\" >{</span>layerStyles<span class=\"token punctuation\" >}</span><span class=\"token operator\" >></span>\n        <span class=\"token operator\" >&lt;</span>div style<span class=\"token operator\" >=</span><span class=\"token punctuation\" >{</span><span class=\"token function\" >getItemStyles<span class=\"token punctuation\" >(</span></span><span class=\"token var\" >this</span><span class=\"token punctuation\" >.</span>props<span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >}</span><span class=\"token operator\" >></span>\n          <span class=\"token punctuation\" >{</span><span class=\"token var\" >this</span><span class=\"token punctuation\" >.</span><span class=\"token function\" >renderItem<span class=\"token punctuation\" >(</span></span>itemType<span class=\"token punctuation\" >,</span> item<span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >}</span>\n        <span class=\"token operator\" >&lt;</span><span class=\"token operator\" >/</span>div<span class=\"token operator\" >></span>\n      <span class=\"token operator\" >&lt;</span><span class=\"token operator\" >/</span>div<span class=\"token operator\" >></span>\n    <span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n  <span class=\"token punctuation\" >}</span>\n<span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n\nmodule<span class=\"token punctuation\" >.</span>exports <span class=\"token operator\" >=</span> <span class=\"token function\" >DragLayer<span class=\"token punctuation\" >(</span></span>collect<span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >(</span><span class=\"token qualifier\" >Custom</span><span class=\"token qualifier\" >Drag</span><span class=\"token qualifier\" >Layer</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span></code><hr/>\n<code class=\"codeBlock\"><span class=\"token keyword\" >import</span> <span class=\"token qualifier\" >React</span><span class=\"token punctuation\" >,</span> <span class=\"token punctuation\" >{</span> <span class=\"token qualifier\" >Prop</span><span class=\"token qualifier\" >Types</span> <span class=\"token punctuation\" >}</span> from <span class=\"token string\" >'react'</span><span class=\"token punctuation\" >;</span>\n<span class=\"token keyword\" >import</span> <span class=\"token qualifier\" >Item</span><span class=\"token qualifier\" >Types</span> from <span class=\"token string\" >'./ItemTypes'</span><span class=\"token punctuation\" >;</span>\n<span class=\"token keyword\" >import</span> <span class=\"token qualifier\" >Box</span><span class=\"token qualifier\" >Drag</span><span class=\"token qualifier\" >Preview</span> from <span class=\"token string\" >'./BoxDragPreview'</span><span class=\"token punctuation\" >;</span>\n<span class=\"token keyword\" >import</span> snapToGrid from <span class=\"token string\" >'./snapToGrid'</span><span class=\"token punctuation\" >;</span>\n<span class=\"token keyword\" >import</span> <span class=\"token punctuation\" >{</span> <span class=\"token qualifier\" >Drag</span><span class=\"token qualifier\" >Layer</span> <span class=\"token punctuation\" >}</span> from <span class=\"token string\" >'react-dnd'</span><span class=\"token punctuation\" >;</span>\n\n<span class=\"token keyword\" >const</span> layerStyles <span class=\"token operator\" >=</span> <span class=\"token punctuation\" >{</span>\n  position<span class=\"token punctuation\" >:</span> <span class=\"token string\" >'fixed'</span><span class=\"token punctuation\" >,</span>\n  pointerEvents<span class=\"token punctuation\" >:</span> <span class=\"token string\" >'none'</span><span class=\"token punctuation\" >,</span>\n  zIndex<span class=\"token punctuation\" >:</span> <span class=\"token number\" >100</span><span class=\"token punctuation\" >,</span>\n  left<span class=\"token punctuation\" >:</span> <span class=\"token number\" >0</span><span class=\"token punctuation\" >,</span>\n  top<span class=\"token punctuation\" >:</span> <span class=\"token number\" >0</span><span class=\"token punctuation\" >,</span>\n  width<span class=\"token punctuation\" >:</span> <span class=\"token string\" >'100%'</span><span class=\"token punctuation\" >,</span>\n  height<span class=\"token punctuation\" >:</span> <span class=\"token string\" >'100%'</span>\n<span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >;</span>\n\n<span class=\"token block-keyword\" >function</span> <span class=\"token function\" >getItemStyles<span class=\"token punctuation\" >(</span></span>props<span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n  <span class=\"token keyword\" >const</span> <span class=\"token punctuation\" >{</span> currentOffset <span class=\"token punctuation\" >}</span> <span class=\"token operator\" >=</span> props<span class=\"token punctuation\" >;</span>\n  <span class=\"token block-keyword\" >if</span> <span class=\"token punctuation\" >(</span><span class=\"token operator\" >!</span>currentOffset<span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n    <span class=\"token keyword\" >return</span> <span class=\"token punctuation\" >{</span>\n      display<span class=\"token punctuation\" >:</span> <span class=\"token string\" >'none'</span>\n    <span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >;</span>\n  <span class=\"token punctuation\" >}</span>\n\n  <span class=\"token keyword\" >const</span> <span class=\"token punctuation\" >{</span> x<span class=\"token punctuation\" >,</span> y <span class=\"token punctuation\" >}</span> <span class=\"token operator\" >=</span> currentOffset<span class=\"token punctuation\" >;</span>\n  <span class=\"token keyword\" >const</span> transform <span class=\"token operator\" >=</span> `<span class=\"token function\" >translate<span class=\"token punctuation\" >(</span></span>$<span class=\"token punctuation\" >{</span>x<span class=\"token punctuation\" >}</span>px<span class=\"token punctuation\" >,</span> $<span class=\"token punctuation\" >{</span>y<span class=\"token punctuation\" >}</span>px<span class=\"token punctuation\" >)</span>`<span class=\"token punctuation\" >;</span>\n  <span class=\"token keyword\" >return</span> <span class=\"token punctuation\" >{</span>\n    transform<span class=\"token punctuation\" >:</span> transform<span class=\"token punctuation\" >,</span>\n    <span class=\"token qualifier\" >Webkit</span><span class=\"token qualifier\" >Transform</span><span class=\"token punctuation\" >:</span> transform\n  <span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >;</span>\n<span class=\"token punctuation\" >}</span>\n\n<span class=\"token keyword\" >class</span> <span class=\"token class-name\" >CustomDragLayer</span> <span class=\"token punctuation\" >{</span>\n  <span class=\"token function\" >renderItem<span class=\"token punctuation\" >(</span></span>type<span class=\"token punctuation\" >,</span> item<span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n    <span class=\"token keyword\" >switch</span> <span class=\"token punctuation\" >(</span>type<span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n    <span class=\"token keyword\" >case</span> <span class=\"token qualifier\" >Item</span><span class=\"token qualifier\" >Types</span><span class=\"token punctuation\" >.</span>BOX<span class=\"token punctuation\" >:</span>\n      <span class=\"token keyword\" >return</span> <span class=\"token punctuation\" >(</span>\n        <span class=\"token operator\" >&lt;</span><span class=\"token qualifier\" >Box</span><span class=\"token qualifier\" >Drag</span><span class=\"token qualifier\" >Preview</span> title<span class=\"token operator\" >=</span><span class=\"token punctuation\" >{</span>item<span class=\"token punctuation\" >.</span>title<span class=\"token punctuation\" >}</span> <span class=\"token operator\" >/</span><span class=\"token operator\" >></span>\n      <span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n    <span class=\"token punctuation\" >}</span>\n  <span class=\"token punctuation\" >}</span>\n\n  <span class=\"token function\" >render<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n    <span class=\"token keyword\" >const</span> <span class=\"token punctuation\" >{</span> item<span class=\"token punctuation\" >,</span> itemType<span class=\"token punctuation\" >,</span> isDragging <span class=\"token punctuation\" >}</span> <span class=\"token operator\" >=</span> <span class=\"token var\" >this</span><span class=\"token punctuation\" >.</span>props<span class=\"token punctuation\" >;</span>\n    <span class=\"token block-keyword\" >if</span> <span class=\"token punctuation\" >(</span><span class=\"token operator\" >!</span>isDragging<span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n      <span class=\"token keyword\" >return</span> <span class=\"token primitive\" >null</span><span class=\"token punctuation\" >;</span>\n    <span class=\"token punctuation\" >}</span>\n\n    <span class=\"token keyword\" >return</span> <span class=\"token punctuation\" >(</span>\n      <span class=\"token operator\" >&lt;</span>div style<span class=\"token operator\" >=</span><span class=\"token punctuation\" >{</span>layerStyles<span class=\"token punctuation\" >}</span><span class=\"token operator\" >></span>\n        <span class=\"token operator\" >&lt;</span>div style<span class=\"token operator\" >=</span><span class=\"token punctuation\" >{</span><span class=\"token function\" >getItemStyles<span class=\"token punctuation\" >(</span></span><span class=\"token var\" >this</span><span class=\"token punctuation\" >.</span>props<span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >}</span><span class=\"token operator\" >></span>\n          <span class=\"token punctuation\" >{</span><span class=\"token var\" >this</span><span class=\"token punctuation\" >.</span><span class=\"token function\" >renderItem<span class=\"token punctuation\" >(</span></span>itemType<span class=\"token punctuation\" >,</span> item<span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >}</span>\n        <span class=\"token operator\" >&lt;</span><span class=\"token operator\" >/</span>div<span class=\"token operator\" >></span>\n      <span class=\"token operator\" >&lt;</span><span class=\"token operator\" >/</span>div<span class=\"token operator\" >></span>\n    <span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n  <span class=\"token punctuation\" >}</span>\n<span class=\"token punctuation\" >}</span>\n\n<span class=\"token qualifier\" >Custom</span><span class=\"token qualifier\" >Drag</span><span class=\"token qualifier\" >Layer</span><span class=\"token punctuation\" >.</span>propTypes <span class=\"token operator\" >=</span> <span class=\"token punctuation\" >{</span>\n  item<span class=\"token punctuation\" >:</span> <span class=\"token qualifier\" >Prop</span><span class=\"token qualifier\" >Types</span><span class=\"token punctuation\" >.</span>object<span class=\"token punctuation\" >,</span>\n  itemType<span class=\"token punctuation\" >:</span> <span class=\"token qualifier\" >Prop</span><span class=\"token qualifier\" >Types</span><span class=\"token punctuation\" >.</span>string<span class=\"token punctuation\" >,</span>\n  currentOffset<span class=\"token punctuation\" >:</span> <span class=\"token qualifier\" >Prop</span><span class=\"token qualifier\" >Types</span><span class=\"token punctuation\" >.</span><span class=\"token function\" >shape<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >{</span>\n    x<span class=\"token punctuation\" >:</span> <span class=\"token qualifier\" >Prop</span><span class=\"token qualifier\" >Types</span><span class=\"token punctuation\" >.</span>number<span class=\"token punctuation\" >.</span>isRequired<span class=\"token punctuation\" >,</span>\n    y<span class=\"token punctuation\" >:</span> <span class=\"token qualifier\" >Prop</span><span class=\"token qualifier\" >Types</span><span class=\"token punctuation\" >.</span>number<span class=\"token punctuation\" >.</span>isRequired\n  <span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >,</span>\n  isDragging<span class=\"token punctuation\" >:</span> <span class=\"token qualifier\" >Prop</span><span class=\"token qualifier\" >Types</span><span class=\"token punctuation\" >.</span>bool<span class=\"token punctuation\" >.</span>isRequired\n<span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >;</span>\n\n<span class=\"token block-keyword\" >function</span> <span class=\"token function\" >collect<span class=\"token punctuation\" >(</span></span>monitor<span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n  <span class=\"token keyword\" >return</span> <span class=\"token punctuation\" >{</span>\n    item<span class=\"token punctuation\" >:</span> monitor<span class=\"token punctuation\" >.</span><span class=\"token function\" >getItem<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >,</span>\n    itemType<span class=\"token punctuation\" >:</span> monitor<span class=\"token punctuation\" >.</span><span class=\"token function\" >getItemType<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >,</span>\n    currentOffset<span class=\"token punctuation\" >:</span> monitor<span class=\"token punctuation\" >.</span><span class=\"token function\" >getSourceClientOffset<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >,</span>\n    isDragging<span class=\"token punctuation\" >:</span> monitor<span class=\"token punctuation\" >.</span><span class=\"token function\" >isDragging<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span>\n  <span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >;</span>\n<span class=\"token punctuation\" >}</span>\n\n<span class=\"token keyword\" >export</span> <span class=\"token keyword\" >default</span> <span class=\"token function\" >DragLayer<span class=\"token punctuation\" >(</span></span>collect<span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >(</span><span class=\"token qualifier\" >Custom</span><span class=\"token qualifier\" >Drag</span><span class=\"token qualifier\" >Layer</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span></code><hr/>\n<code class=\"codeBlock\"><span class=\"token keyword\" >import</span> <span class=\"token qualifier\" >React</span><span class=\"token punctuation\" >,</span> <span class=\"token punctuation\" >{</span> <span class=\"token qualifier\" >Prop</span><span class=\"token qualifier\" >Types</span> <span class=\"token punctuation\" >}</span> from <span class=\"token string\" >'react'</span><span class=\"token punctuation\" >;</span>\n<span class=\"token keyword\" >import</span> <span class=\"token qualifier\" >Item</span><span class=\"token qualifier\" >Types</span> from <span class=\"token string\" >'./ItemTypes'</span><span class=\"token punctuation\" >;</span>\n<span class=\"token keyword\" >import</span> <span class=\"token qualifier\" >Box</span><span class=\"token qualifier\" >Drag</span><span class=\"token qualifier\" >Preview</span> from <span class=\"token string\" >'./BoxDragPreview'</span><span class=\"token punctuation\" >;</span>\n<span class=\"token keyword\" >import</span> snapToGrid from <span class=\"token string\" >'./snapToGrid'</span><span class=\"token punctuation\" >;</span>\n<span class=\"token keyword\" >import</span> <span class=\"token punctuation\" >{</span> <span class=\"token qualifier\" >Drag</span><span class=\"token qualifier\" >Layer</span> <span class=\"token punctuation\" >}</span> from <span class=\"token string\" >'react-dnd'</span><span class=\"token punctuation\" >;</span>\n\n<span class=\"token keyword\" >const</span> layerStyles <span class=\"token operator\" >=</span> <span class=\"token punctuation\" >{</span>\n  position<span class=\"token punctuation\" >:</span> <span class=\"token string\" >'fixed'</span><span class=\"token punctuation\" >,</span>\n  pointerEvents<span class=\"token punctuation\" >:</span> <span class=\"token string\" >'none'</span><span class=\"token punctuation\" >,</span>\n  zIndex<span class=\"token punctuation\" >:</span> <span class=\"token number\" >100</span><span class=\"token punctuation\" >,</span>\n  left<span class=\"token punctuation\" >:</span> <span class=\"token number\" >0</span><span class=\"token punctuation\" >,</span>\n  top<span class=\"token punctuation\" >:</span> <span class=\"token number\" >0</span><span class=\"token punctuation\" >,</span>\n  width<span class=\"token punctuation\" >:</span> <span class=\"token string\" >'100%'</span><span class=\"token punctuation\" >,</span>\n  height<span class=\"token punctuation\" >:</span> <span class=\"token string\" >'100%'</span>\n<span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >;</span>\n\n<span class=\"token block-keyword\" >function</span> <span class=\"token function\" >getItemStyles<span class=\"token punctuation\" >(</span></span>props<span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n  <span class=\"token keyword\" >const</span> <span class=\"token punctuation\" >{</span> currentOffset <span class=\"token punctuation\" >}</span> <span class=\"token operator\" >=</span> props<span class=\"token punctuation\" >;</span>\n  <span class=\"token block-keyword\" >if</span> <span class=\"token punctuation\" >(</span><span class=\"token operator\" >!</span>currentOffset<span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n    <span class=\"token keyword\" >return</span> <span class=\"token punctuation\" >{</span>\n      display<span class=\"token punctuation\" >:</span> <span class=\"token string\" >'none'</span>\n    <span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >;</span>\n  <span class=\"token punctuation\" >}</span>\n\n  <span class=\"token keyword\" >const</span> <span class=\"token punctuation\" >{</span> x<span class=\"token punctuation\" >,</span> y <span class=\"token punctuation\" >}</span> <span class=\"token operator\" >=</span> currentOffset<span class=\"token punctuation\" >;</span>\n  <span class=\"token keyword\" >const</span> transform <span class=\"token operator\" >=</span> `<span class=\"token function\" >translate<span class=\"token punctuation\" >(</span></span>$<span class=\"token punctuation\" >{</span>x<span class=\"token punctuation\" >}</span>px<span class=\"token punctuation\" >,</span> $<span class=\"token punctuation\" >{</span>y<span class=\"token punctuation\" >}</span>px<span class=\"token punctuation\" >)</span>`<span class=\"token punctuation\" >;</span>\n  <span class=\"token keyword\" >return</span> <span class=\"token punctuation\" >{</span>\n    transform<span class=\"token punctuation\" >:</span> transform<span class=\"token punctuation\" >,</span>\n    <span class=\"token qualifier\" >Webkit</span><span class=\"token qualifier\" >Transform</span><span class=\"token punctuation\" >:</span> transform\n  <span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >;</span>\n<span class=\"token punctuation\" >}</span>\n\n@<span class=\"token function\" >DragLayer<span class=\"token punctuation\" >(</span></span>monitor <span class=\"token operator\" >=</span><span class=\"token operator\" >></span> <span class=\"token punctuation\" >(</span><span class=\"token punctuation\" >{</span>\n  item<span class=\"token punctuation\" >:</span> monitor<span class=\"token punctuation\" >.</span><span class=\"token function\" >getItem<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >,</span>\n  itemType<span class=\"token punctuation\" >:</span> monitor<span class=\"token punctuation\" >.</span><span class=\"token function\" >getItemType<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >,</span>\n  currentOffset<span class=\"token punctuation\" >:</span> monitor<span class=\"token punctuation\" >.</span><span class=\"token function\" >getSourceClientOffset<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >,</span>\n  isDragging<span class=\"token punctuation\" >:</span> monitor<span class=\"token punctuation\" >.</span><span class=\"token function\" >isDragging<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span>\n<span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >)</span>\n<span class=\"token keyword\" >export</span> <span class=\"token keyword\" >default</span> <span class=\"token keyword\" >class</span> <span class=\"token class-name\" >CustomDragLayer</span> <span class=\"token punctuation\" >{</span>\n  <span class=\"token keyword\" >static</span> propTypes <span class=\"token operator\" >=</span> <span class=\"token punctuation\" >{</span>\n    item<span class=\"token punctuation\" >:</span> <span class=\"token qualifier\" >Prop</span><span class=\"token qualifier\" >Types</span><span class=\"token punctuation\" >.</span>object<span class=\"token punctuation\" >,</span>\n    itemType<span class=\"token punctuation\" >:</span> <span class=\"token qualifier\" >Prop</span><span class=\"token qualifier\" >Types</span><span class=\"token punctuation\" >.</span>string<span class=\"token punctuation\" >,</span>\n    currentOffset<span class=\"token punctuation\" >:</span> <span class=\"token qualifier\" >Prop</span><span class=\"token qualifier\" >Types</span><span class=\"token punctuation\" >.</span><span class=\"token function\" >shape<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >{</span>\n      x<span class=\"token punctuation\" >:</span> <span class=\"token qualifier\" >Prop</span><span class=\"token qualifier\" >Types</span><span class=\"token punctuation\" >.</span>number<span class=\"token punctuation\" >.</span>isRequired<span class=\"token punctuation\" >,</span>\n      y<span class=\"token punctuation\" >:</span> <span class=\"token qualifier\" >Prop</span><span class=\"token qualifier\" >Types</span><span class=\"token punctuation\" >.</span>number<span class=\"token punctuation\" >.</span>isRequired\n    <span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >,</span>\n    isDragging<span class=\"token punctuation\" >:</span> <span class=\"token qualifier\" >Prop</span><span class=\"token qualifier\" >Types</span><span class=\"token punctuation\" >.</span>bool<span class=\"token punctuation\" >.</span>isRequired\n  <span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >;</span>\n\n  <span class=\"token function\" >renderItem<span class=\"token punctuation\" >(</span></span>type<span class=\"token punctuation\" >,</span> item<span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n    <span class=\"token keyword\" >switch</span> <span class=\"token punctuation\" >(</span>type<span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n    <span class=\"token keyword\" >case</span> <span class=\"token qualifier\" >Item</span><span class=\"token qualifier\" >Types</span><span class=\"token punctuation\" >.</span>BOX<span class=\"token punctuation\" >:</span>\n      <span class=\"token keyword\" >return</span> <span class=\"token punctuation\" >(</span>\n        <span class=\"token operator\" >&lt;</span><span class=\"token qualifier\" >Box</span><span class=\"token qualifier\" >Drag</span><span class=\"token qualifier\" >Preview</span> title<span class=\"token operator\" >=</span><span class=\"token punctuation\" >{</span>item<span class=\"token punctuation\" >.</span>title<span class=\"token punctuation\" >}</span> <span class=\"token operator\" >/</span><span class=\"token operator\" >></span>\n      <span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n    <span class=\"token punctuation\" >}</span>\n  <span class=\"token punctuation\" >}</span>\n\n  <span class=\"token function\" >render<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n    <span class=\"token keyword\" >const</span> <span class=\"token punctuation\" >{</span> item<span class=\"token punctuation\" >,</span> itemType<span class=\"token punctuation\" >,</span> isDragging <span class=\"token punctuation\" >}</span> <span class=\"token operator\" >=</span> <span class=\"token var\" >this</span><span class=\"token punctuation\" >.</span>props<span class=\"token punctuation\" >;</span>\n    <span class=\"token block-keyword\" >if</span> <span class=\"token punctuation\" >(</span><span class=\"token operator\" >!</span>isDragging<span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n      <span class=\"token keyword\" >return</span> <span class=\"token primitive\" >null</span><span class=\"token punctuation\" >;</span>\n    <span class=\"token punctuation\" >}</span>\n\n    <span class=\"token keyword\" >return</span> <span class=\"token punctuation\" >(</span>\n      <span class=\"token operator\" >&lt;</span>div style<span class=\"token operator\" >=</span><span class=\"token punctuation\" >{</span>layerStyles<span class=\"token punctuation\" >}</span><span class=\"token operator\" >></span>\n        <span class=\"token operator\" >&lt;</span>div style<span class=\"token operator\" >=</span><span class=\"token punctuation\" >{</span><span class=\"token function\" >getItemStyles<span class=\"token punctuation\" >(</span></span><span class=\"token var\" >this</span><span class=\"token punctuation\" >.</span>props<span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >}</span><span class=\"token operator\" >></span>\n          <span class=\"token punctuation\" >{</span><span class=\"token var\" >this</span><span class=\"token punctuation\" >.</span><span class=\"token function\" >renderItem<span class=\"token punctuation\" >(</span></span>itemType<span class=\"token punctuation\" >,</span> item<span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >}</span>\n        <span class=\"token operator\" >&lt;</span><span class=\"token operator\" >/</span>div<span class=\"token operator\" >></span>\n      <span class=\"token operator\" >&lt;</span><span class=\"token operator\" >/</span>div<span class=\"token operator\" >></span>\n    <span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n  <span class=\"token punctuation\" >}</span>\n<span class=\"token punctuation\" >}</span></code><hr/>\n";

/***/ },
/* 336 */
/***/ function(module, exports) {

	module.exports = "<p><em>New to React DnD? <a href=\"docs-overview.html\">Read the overview</a> before jumping into the docs.</em></p>\n<h1>DragSource<a id=\"dragsource\">&nbsp;</a></h1><p>Wrap your component with <code>DragSource</code> to make it draggable. <code>DragSource</code> is a higher-order component accepting three required parameters. They are described in detail below.</p>\n<p>To use <code>DragSource</code>, don&#39;t forget to wrap the top-level component of your app in a <a href=\"docs-drag-drop-context.html\"><code>DragDropContext</code></a>.</p>\n<h3>Signature<a id=\"signature\">&nbsp;</a></h3><p><code>DragSource</code> uses partial application. After specifying its parameters with the first call, you need to pass your React component class as the only parameter in the second call. This signature makes <code>DragSource</code> usable as an ES7 decorator. Read the <a href=\"docs-overview.html\">overview</a> for a more detailed explanation of the decorators and the higher-order components.</p>\n<hr/>\n<code class=\"codeBlock\"><span class=\"token keyword\" >var</span> <span class=\"token qualifier\" >Drag</span><span class=\"token qualifier\" >Source</span> <span class=\"token operator\" >=</span> <span class=\"token function\" >require<span class=\"token punctuation\" >(</span></span><span class=\"token string\" >'react-dnd'</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >.</span><span class=\"token qualifier\" >Drag</span><span class=\"token qualifier\" >Source</span><span class=\"token punctuation\" >;</span>\n\n<span class=\"token keyword\" >var</span> <span class=\"token qualifier\" >My</span><span class=\"token qualifier\" >Component</span> <span class=\"token operator\" >=</span> <span class=\"token qualifier\" >React</span><span class=\"token punctuation\" >.</span><span class=\"token function\" >createClass<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >{</span>\n  <span class=\"token comment\" spellcheck=\"true\">/* ... */</span>\n<span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n\nmodule<span class=\"token punctuation\" >.</span>exports <span class=\"token operator\" >=</span> <span class=\"token function\" >DragSource<span class=\"token punctuation\" >(</span></span>type<span class=\"token punctuation\" >,</span> spec<span class=\"token punctuation\" >,</span> collect<span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >(</span><span class=\"token qualifier\" >My</span><span class=\"token qualifier\" >Component</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span></code><hr/>\n<code class=\"codeBlock\"><span class=\"token keyword\" >import</span> <span class=\"token punctuation\" >{</span> <span class=\"token qualifier\" >Drag</span><span class=\"token qualifier\" >Source</span> <span class=\"token punctuation\" >}</span> from <span class=\"token string\" >'react-dnd'</span><span class=\"token punctuation\" >;</span>\n\n<span class=\"token keyword\" >class</span> <span class=\"token class-name\" >MyComponent</span> <span class=\"token punctuation\" >{</span>\n  <span class=\"token comment\" spellcheck=\"true\">/* ... */</span>\n<span class=\"token punctuation\" >}</span>\n\n<span class=\"token keyword\" >export</span> <span class=\"token keyword\" >default</span> <span class=\"token function\" >DragSource<span class=\"token punctuation\" >(</span></span>type<span class=\"token punctuation\" >,</span> spec<span class=\"token punctuation\" >,</span> collect<span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >(</span><span class=\"token qualifier\" >My</span><span class=\"token qualifier\" >Component</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span></code><hr/>\n<code class=\"codeBlock\"><span class=\"token keyword\" >import</span> <span class=\"token punctuation\" >{</span> <span class=\"token qualifier\" >Drag</span><span class=\"token qualifier\" >Source</span> <span class=\"token punctuation\" >}</span> from <span class=\"token string\" >'react-dnd'</span><span class=\"token punctuation\" >;</span>\n\n@<span class=\"token function\" >DragSource<span class=\"token punctuation\" >(</span></span>type<span class=\"token punctuation\" >,</span> spec<span class=\"token punctuation\" >,</span> collect<span class=\"token punctuation\" >)</span>\n<span class=\"token keyword\" >export</span> <span class=\"token keyword\" >default</span> <span class=\"token keyword\" >class</span> <span class=\"token class-name\" >MyComponent</span> <span class=\"token punctuation\" >{</span>\n  <span class=\"token comment\" spellcheck=\"true\">/* ... */</span>\n<span class=\"token punctuation\" >}</span></code><hr/>\n<h3>Parameters<a id=\"parameters\">&nbsp;</a></h3><ul>\n<li><p><strong><code>type</code></strong>: Required. Either a string, an ES6 symbol, or a function that returns either given the component&#39;s <code>props</code>. Only the <a href=\"docs-drop-target.html\">drop targets</a> registered for the same type will react to the items produced by this drag source. Read the <a href=\"docs-overview.html\">overview</a> to learn more about the items and types.</p>\n</li>\n<li><p><strong><code>spec</code></strong>: Required. A plain JavaScript object with a few allowed methods on it. It describes how the drag source reacts to the drag and drop events. See the drag source specification described in detail in the next section.</p>\n</li>\n<li><p><strong><code>collect</code></strong>: Required. The collecting function. It should return a plain object of the props to inject into your component. It receives two parameters: <code>monitor</code> and <code>connect</code>. Read the <a href=\"docs-overview.html\">overview</a> for an introduction to the monitors, the connectors, and the collecting function. See the collecting function described in detail after the next section.</p>\n</li>\n<li><p><strong><code>options</code></strong>: Optional. A plain object. If some of the props to your component are not scalar (that is, are not primitive values or functions), specifying a custom <code>arePropsEqual(props, otherProps)</code> function inside the <code>options</code> object can improve the performance. Unless you have performance problems, don&#39;t worry about it.</p>\n</li>\n</ul>\n<h3>Drag Source Specification<a id=\"drag-source-specification\">&nbsp;</a></h3><p>The second <code>spec</code> parameter must be a plain object implementing the drag source specification. Below is the list of all methods that it may have.</p>\n<h4>Specification Methods<a id=\"specification-methods\">&nbsp;</a></h4><ul>\n<li><p><strong><code>beginDrag(props, monitor, component)</code></strong>: Required. When the dragging starts, <code>beginDrag</code> is called. You must return a plain JavaScript object describing the data being dragged. What you return is the <em>only</em> information available to the drop targets about the drag source so it&#39;s important to pick the <em>minimal</em> data they need to know. You may be tempted to put a reference to the <code>component</code> into it, but you should try very hard to avoid doing this because it couples the drag sources and drop targets. It&#39;s a good idea to return something like <code>{ id: props.id }</code> from this method.</p>\n</li>\n<li><p><strong><code>endDrag(props, monitor, component)</code></strong>: Optional. When the dragging stops, <code>endDrag</code> is called. For every <code>beginDrag</code> call, a corresponding <code>endDrag</code> call is guaranteed. You may call <code>monitor.didDrop()</code> to check whether or not the drop was handled by a compatible drop target. If it was handled, and the drop target specified a <em>drop result</em> by returning a plain object from its <code>drop()</code> method, it will be available as <code>monitor.getDropResult()</code>. This method is a good place to fire a Flux action. <em>Note: If the component is unmounted while dragging, <code>component</code> parameter is set to be <code>null</code>.</em></p>\n</li>\n<li><p><strong><code>canDrag(props, monitor)</code></strong>: Optional. Use it to specify whether the dragging is currently allowed. If you want to always allow it, just omit this method. Specifying it is handy if you&#39;d like to disable dragging based on some predicate over <code>props</code>. <em>Note: You may not call <code>monitor.canDrag()</code> inside this method.</em></p>\n</li>\n<li><p><strong><code>isDragging(props, monitor)</code></strong>: Optional. By default, only the drag source that initiated the drag operation is considered to be dragging. You can override this behavior by defining a custom <code>isDragging</code> method. It might return something like <code>props.id === monitor.getItem().id</code>. Do this if the original component may be unmounted during the dragging and later “resurrected” with a different parent. For example, when moving a card across the lists in a Kanban board, you want it to retain the dragged appearance—even though technically, the component gets unmounted and a different one gets mounted every time you move it to another list. <em>Note: You may not call <code>monitor.isDragging()</code> inside this method.</em></p>\n</li>\n</ul>\n<h4>Specification Method Parameters<a id=\"specification-method-parameters\">&nbsp;</a></h4><ul>\n<li><p><strong><code>props</code></strong>: Your component&#39;s current props.</p>\n</li>\n<li><p><strong><code>monitor</code></strong>: An instance of <a href=\"docs-drag-source-monitor.html\"><code>DragSourceMonitor</code></a>. Use it to query the information about the current drag state, such as the currently dragged item and its type, the current and initial coordinates and offsets, and whether it was dropped yet. Read the <a href=\"docs-drag-source-monitor.html\"><code>DragSourceMonitor</code> documentation</a> for a complete list of <code>monitor</code> methods, or read the <a href=\"docs-overview.html\">overview</a> for an introduction to the monitors.</p>\n</li>\n<li><p><strong><code>component</code></strong>: When specified, it is the instance of your component. Use it to access the underlying DOM node for position or size measurements, or to call <code>setState</code>, and other component methods. It is purposefully missing from <code>isDragging</code> and <code>canDrag</code> because the instance may not be available by the time they are called. If you want these methods to depend on the component&#39;s state, consider lifting the state to the parent component, so that you can just use <code>props</code>. Generally your code will be cleaner if you rely on <code>props</code> instead whenever possible.</p>\n</li>\n</ul>\n<h3>The Collecting Function<a id=\"the-collecting-function\">&nbsp;</a></h3><p>Just specifying the drag source <code>type</code> and <code>spec</code> is not quite enough.<br/>There&#39;s still a few more things we need to take care of:</p>\n<ul>\n<li>connect the React DnD event handlers to some node in the component;</li>\n<li>pass some knowledge about the dragging state to our component.</li>\n</ul>\n<p>All communication between the React components happens via props, so it makes sense that React DnD injects special props into your component. However it gives you the freedom to name them and decide what props your component will receive.</p>\n<p>Your <em>collecting function</em> will be called by React DnD with a <em>connector</em> that lets you connect nodes to the DnD backend, and a <em>monitor</em> to query information about the drag state. It should return a plain object of props to inject into your component.</p>\n<p>If you&#39;re new to these concepts, the <a href=\"docs-overview.html\">overview</a> should give you a good idea about them.</p>\n<h4>Parameters<a id=\"parameters\">&nbsp;</a></h4><ul>\n<li><p><strong><code>connect</code></strong>: An instance of <a href=\"docs-drag-source-connector.html\"><code>DragSourceConnector</code></a>. It has two methods: <code>dragPreview()</code> and <code>dragSource()</code>. Of them, <code>dragSource()</code> is the one you&#39;ll use the most. It returns a function you need to pass down to your component to connect the source DOM node to the React DnD backend. If you return something like <code>{ connectDragSource: connect.dragSource() }</code> from your <code>collect</code> function, the component will receive <code>connectDragSource</code> as a prop so you can mark the relevant node inside its <code>render()</code> as draggable: <code>return this.props.connectDragSource(&lt;div&gt;...&lt;/div&gt;)</code>. You can see this pattern in action in the example at the end of this file. Read the <a href=\"docs-drag-source-connector.html\"><code>DragSourceConnector</code> documentation</a> for a complete list of <code>connect</code> methods, or read the <a href=\"docs-overview.html\">overview</a> for an introduction to the connectors.</p>\n</li>\n<li><p><strong><code>monitor</code></strong>: An instance of <a href=\"docs-drag-source-monitor.html\"><code>DragSourceMonitor</code></a>. It is precisely the same <code>monitor</code> you receive in the drag source specification methods, and you can use it to query the information about the current drag state. Read the <a href=\"docs-drag-source-monitor.html\"><code>DragSourceMonitor</code> documentation</a> for a complete list of <code>monitor</code> methods, or read the <a href=\"docs-overview.html\">overview</a> for an introduction to the monitors.</p>\n</li>\n</ul>\n<h3>Return Value<a id=\"return-value\">&nbsp;</a></h3><p><code>DragSource</code> wraps your component and returns another React component.<br/>For easier <a href=\"docs-testing.html\">testing</a>, it provides an API to reach into the internals:</p>\n<h4>Static Properties<a id=\"static-properties\">&nbsp;</a></h4><ul>\n<li><strong><code>DecoratedComponent</code></strong>: Returns the wrapped component type.</li>\n</ul>\n<h4>Instance Methods<a id=\"instance-methods\">&nbsp;</a></h4><ul>\n<li><p><strong><code>getDecoratedComponentInstance()</code></strong>: Returns the wrapped component instance.</p>\n</li>\n<li><p><strong><code>getHandlerId()</code></strong>: Returns the drag source ID that can be used to simulate the drag and drop events with the testing backend. Refer to the <a href=\"docs-testing.html\">testing</a> tutorial for a usage example.</p>\n</li>\n</ul>\n<h3>Nesting Behavior<a id=\"nesting-behavior\">&nbsp;</a></h3><p>If a drag source is nested in another drag source, the innermost drag source of the compatible type wins. Drag sources that return <code>false</code> from <code>canDrag</code> are skipped. The chosen drag source is the only one that will receive <code>beginDrag</code> and, subsequently, <code>endDrag</code>. There is no propagation once the drag source is determined.</p>\n<h3>Example<a id=\"example\">&nbsp;</a></h3><p>Check out <a href=\"docs-tutorial.html\">the tutorial</a> for more real examples!</p>\n<hr/>\n<code class=\"codeBlock\"><span class=\"token keyword\" >var</span> <span class=\"token qualifier\" >React</span> <span class=\"token operator\" >=</span> <span class=\"token function\" >require<span class=\"token punctuation\" >(</span></span><span class=\"token string\" >'react'</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n<span class=\"token keyword\" >var</span> <span class=\"token qualifier\" >Drag</span><span class=\"token qualifier\" >Source</span> <span class=\"token operator\" >=</span> <span class=\"token function\" >require<span class=\"token punctuation\" >(</span></span><span class=\"token string\" >'react-dnd'</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >.</span><span class=\"token qualifier\" >Drag</span><span class=\"token qualifier\" >Source</span><span class=\"token punctuation\" >;</span>\n\n<span class=\"token comment\" spellcheck=\"true\">// Drag sources and drop targets only interact\n</span><span class=\"token comment\" spellcheck=\"true\">// if they have the same string type.\n</span><span class=\"token comment\" spellcheck=\"true\">// You want to keep types in a separate file with\n</span><span class=\"token comment\" spellcheck=\"true\">// the rest of your app's constants.\n</span><span class=\"token keyword\" >var</span> <span class=\"token qualifier\" >Types</span> <span class=\"token operator\" >=</span> <span class=\"token punctuation\" >{</span>\n  CARD<span class=\"token punctuation\" >:</span> <span class=\"token string\" >'card'</span>\n<span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >;</span>\n\n<span class=\"token comment\" spellcheck=\"true\">/**\n * Specifies the drag source contract.\n * Only `beginDrag` function is required.\n */</span>\n<span class=\"token keyword\" >var</span> cardSource <span class=\"token operator\" >=</span> <span class=\"token punctuation\" >{</span>\n  canDrag<span class=\"token punctuation\" >:</span> <span class=\"token block-keyword\" >function</span> <span class=\"token punctuation\" >(</span>props<span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n    <span class=\"token comment\" spellcheck=\"true\">// You can disallow drag based on props\n</span>    <span class=\"token keyword\" >return</span> props<span class=\"token punctuation\" >.</span>isReady<span class=\"token punctuation\" >;</span>\n  <span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >,</span>\n\n  beginDrag<span class=\"token punctuation\" >:</span> <span class=\"token block-keyword\" >function</span> <span class=\"token punctuation\" >(</span>props<span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n    <span class=\"token comment\" spellcheck=\"true\">// Return the data describing the dragged item\n</span>    <span class=\"token keyword\" >var</span> item <span class=\"token operator\" >=</span> <span class=\"token punctuation\" >{</span> id<span class=\"token punctuation\" >:</span> props<span class=\"token punctuation\" >.</span>id <span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >;</span>\n    <span class=\"token keyword\" >return</span> item<span class=\"token punctuation\" >;</span>\n  <span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >,</span>\n\n  isDragging<span class=\"token punctuation\" >:</span> <span class=\"token block-keyword\" >function</span> <span class=\"token punctuation\" >(</span>props<span class=\"token punctuation\" >,</span> monitor<span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n    <span class=\"token comment\" spellcheck=\"true\">// If your component gets unmounted while dragged\n</span>    <span class=\"token comment\" spellcheck=\"true\">// (like a card in Kanban board dragged between lists)\n</span>    <span class=\"token comment\" spellcheck=\"true\">// you can implement something like this to keep its\n</span>    <span class=\"token comment\" spellcheck=\"true\">// appearance dragged:\n</span>    <span class=\"token keyword\" >return</span> monitor<span class=\"token punctuation\" >.</span><span class=\"token function\" >getItem<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >.</span>id <span class=\"token operator\" >===</span> props<span class=\"token punctuation\" >.</span>id<span class=\"token punctuation\" >;</span>\n  <span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >,</span>\n\n  endDrag<span class=\"token punctuation\" >:</span> <span class=\"token block-keyword\" >function</span> <span class=\"token punctuation\" >(</span>props<span class=\"token punctuation\" >,</span> monitor<span class=\"token punctuation\" >,</span> component<span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n    <span class=\"token block-keyword\" >if</span> <span class=\"token punctuation\" >(</span><span class=\"token operator\" >!</span>monitor<span class=\"token punctuation\" >.</span><span class=\"token function\" >didDrop<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n      <span class=\"token comment\" spellcheck=\"true\">// You can check whether the drop was successful\n</span>      <span class=\"token comment\" spellcheck=\"true\">// or if the drag ended but nobody handled the drop\n</span>      <span class=\"token keyword\" >return</span><span class=\"token punctuation\" >;</span>\n    <span class=\"token punctuation\" >}</span>\n\n    <span class=\"token comment\" spellcheck=\"true\">// When dropped on a compatible target, do something.\n</span>    <span class=\"token comment\" spellcheck=\"true\">// Read the original dragged item from getItem():\n</span>    <span class=\"token keyword\" >var</span> item <span class=\"token operator\" >=</span> monitor<span class=\"token punctuation\" >.</span><span class=\"token function\" >getItem<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n\n    <span class=\"token comment\" spellcheck=\"true\">// You may also read the drop result from the drop target\n</span>    <span class=\"token comment\" spellcheck=\"true\">// that handled the drop, if it returned an object from\n</span>    <span class=\"token comment\" spellcheck=\"true\">// its drop() method.\n</span>    <span class=\"token keyword\" >var</span> dropResult <span class=\"token operator\" >=</span> monitor<span class=\"token punctuation\" >.</span><span class=\"token function\" >getDropResult<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n\n    <span class=\"token comment\" spellcheck=\"true\">// This is a good place to call some Flux action\n</span>    <span class=\"token qualifier\" >Card</span><span class=\"token qualifier\" >Actions</span><span class=\"token punctuation\" >.</span><span class=\"token function\" >moveCardToList<span class=\"token punctuation\" >(</span></span>item<span class=\"token punctuation\" >.</span>id<span class=\"token punctuation\" >,</span> dropResult<span class=\"token punctuation\" >.</span>listId<span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n  <span class=\"token punctuation\" >}</span>\n<span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >;</span>\n\n<span class=\"token comment\" spellcheck=\"true\">/**\n * Specifies which props to inject into your component.\n */</span>\n<span class=\"token block-keyword\" >function</span> <span class=\"token function\" >collect<span class=\"token punctuation\" >(</span></span>connect<span class=\"token punctuation\" >,</span> monitor<span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n  <span class=\"token keyword\" >return</span> <span class=\"token punctuation\" >{</span>\n    <span class=\"token comment\" spellcheck=\"true\">// Call this function inside render()\n</span>    <span class=\"token comment\" spellcheck=\"true\">// to let React DnD handle the drag events:\n</span>    connectDragSource<span class=\"token punctuation\" >:</span> connect<span class=\"token punctuation\" >.</span><span class=\"token function\" >dragSource<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >,</span>\n    <span class=\"token comment\" spellcheck=\"true\">// You can ask the monitor about the current drag state:\n</span>    isDragging<span class=\"token punctuation\" >:</span> monitor<span class=\"token punctuation\" >.</span><span class=\"token function\" >isDragging<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span>\n  <span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >;</span>\n<span class=\"token punctuation\" >}</span>\n\n<span class=\"token keyword\" >var</span> <span class=\"token qualifier\" >Card</span> <span class=\"token operator\" >=</span> <span class=\"token qualifier\" >React</span><span class=\"token punctuation\" >.</span><span class=\"token function\" >createClass<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >{</span>\n  render<span class=\"token punctuation\" >:</span> <span class=\"token block-keyword\" >function</span> <span class=\"token punctuation\" >(</span><span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n    <span class=\"token comment\" spellcheck=\"true\">// Your component receives its own props as usual\n</span>    <span class=\"token keyword\" >var</span> id <span class=\"token operator\" >=</span> <span class=\"token var\" >this</span><span class=\"token punctuation\" >.</span>props<span class=\"token punctuation\" >.</span>id<span class=\"token punctuation\" >;</span>\n\n    <span class=\"token comment\" spellcheck=\"true\">// These props are injected by React DnD,\n</span>    <span class=\"token comment\" spellcheck=\"true\">// as defined by your `collect` function above:\n</span>    <span class=\"token keyword\" >var</span> isDragging <span class=\"token operator\" >=</span> <span class=\"token var\" >this</span><span class=\"token punctuation\" >.</span>props<span class=\"token punctuation\" >.</span>isDragging<span class=\"token punctuation\" >;</span>\n    <span class=\"token keyword\" >var</span> connectDragSource <span class=\"token operator\" >=</span> <span class=\"token var\" >this</span><span class=\"token punctuation\" >.</span>props<span class=\"token punctuation\" >.</span>connectDragSource<span class=\"token punctuation\" >;</span>\n\n    <span class=\"token keyword\" >return</span> <span class=\"token function\" >connectDragSource<span class=\"token punctuation\" >(</span></span>\n      <span class=\"token operator\" >&lt;</span>div<span class=\"token operator\" >></span>\n        I am a draggable card number <span class=\"token punctuation\" >{</span>id<span class=\"token punctuation\" >}</span>\n        <span class=\"token punctuation\" >{</span>isDragging <span class=\"token operator\" >&amp;&amp;</span> <span class=\"token string\" >' (and I am being dragged now)'</span><span class=\"token punctuation\" >}</span>\n      <span class=\"token operator\" >&lt;</span><span class=\"token operator\" >/</span>div<span class=\"token operator\" >></span>\n    <span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n  <span class=\"token punctuation\" >}</span>\n<span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n\nmodule<span class=\"token punctuation\" >.</span>exports <span class=\"token operator\" >=</span> <span class=\"token function\" >DragSource<span class=\"token punctuation\" >(</span></span><span class=\"token qualifier\" >Types</span><span class=\"token punctuation\" >.</span>CARD<span class=\"token punctuation\" >,</span> cardSource<span class=\"token punctuation\" >,</span> collect<span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >(</span><span class=\"token qualifier\" >Card</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span></code><hr/>\n<code class=\"codeBlock\"><span class=\"token keyword\" >import</span> <span class=\"token qualifier\" >React</span> from <span class=\"token string\" >'react'</span><span class=\"token punctuation\" >;</span>\n<span class=\"token keyword\" >import</span> <span class=\"token punctuation\" >{</span> <span class=\"token qualifier\" >Drag</span><span class=\"token qualifier\" >Source</span> <span class=\"token punctuation\" >}</span> from <span class=\"token string\" >'react-dnd'</span><span class=\"token punctuation\" >;</span>\n\n<span class=\"token comment\" spellcheck=\"true\">// Drag sources and drop targets only interact\n</span><span class=\"token comment\" spellcheck=\"true\">// if they have the same string type.\n</span><span class=\"token comment\" spellcheck=\"true\">// You want to keep types in a separate file with\n</span><span class=\"token comment\" spellcheck=\"true\">// the rest of your app's constants.\n</span><span class=\"token keyword\" >const</span> <span class=\"token qualifier\" >Types</span> <span class=\"token operator\" >=</span> <span class=\"token punctuation\" >{</span>\n  CARD<span class=\"token punctuation\" >:</span> <span class=\"token string\" >'card'</span>\n<span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >;</span>\n\n<span class=\"token comment\" spellcheck=\"true\">/**\n * Specifies the drag source contract.\n * Only `beginDrag` function is required.\n */</span>\n<span class=\"token keyword\" >const</span> cardSource <span class=\"token operator\" >=</span> <span class=\"token punctuation\" >{</span>\n  <span class=\"token function\" >canDrag<span class=\"token punctuation\" >(</span></span>props<span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n    <span class=\"token comment\" spellcheck=\"true\">// You can disallow drag based on props\n</span>    <span class=\"token keyword\" >return</span> props<span class=\"token punctuation\" >.</span>isReady<span class=\"token punctuation\" >;</span>\n  <span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >,</span>\n\n  <span class=\"token function\" >isDragging<span class=\"token punctuation\" >(</span></span>props<span class=\"token punctuation\" >,</span> monitor<span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n    <span class=\"token comment\" spellcheck=\"true\">// If your component gets unmounted while dragged\n</span>    <span class=\"token comment\" spellcheck=\"true\">// (like a card in Kanban board dragged between lists)\n</span>    <span class=\"token comment\" spellcheck=\"true\">// you can implement something like this to keep its\n</span>    <span class=\"token comment\" spellcheck=\"true\">// appearance dragged:\n</span>    <span class=\"token keyword\" >return</span> monitor<span class=\"token punctuation\" >.</span><span class=\"token function\" >getItem<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >.</span>id <span class=\"token operator\" >===</span> props<span class=\"token punctuation\" >.</span>id<span class=\"token punctuation\" >;</span>\n  <span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >,</span>\n\n  <span class=\"token function\" >beginDrag<span class=\"token punctuation\" >(</span></span>props<span class=\"token punctuation\" >,</span> monitor<span class=\"token punctuation\" >,</span> component<span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n    <span class=\"token comment\" spellcheck=\"true\">// Return the data describing the dragged item\n</span>    <span class=\"token keyword\" >const</span> item <span class=\"token operator\" >=</span> <span class=\"token punctuation\" >{</span> id<span class=\"token punctuation\" >:</span> props<span class=\"token punctuation\" >.</span>id <span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >;</span>\n    <span class=\"token keyword\" >return</span> item<span class=\"token punctuation\" >;</span>\n  <span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >,</span>\n\n  <span class=\"token function\" >endDrag<span class=\"token punctuation\" >(</span></span>props<span class=\"token punctuation\" >,</span> monitor<span class=\"token punctuation\" >,</span> component<span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n    <span class=\"token block-keyword\" >if</span> <span class=\"token punctuation\" >(</span><span class=\"token operator\" >!</span>monitor<span class=\"token punctuation\" >.</span><span class=\"token function\" >didDrop<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n      <span class=\"token comment\" spellcheck=\"true\">// You can check whether the drop was successful\n</span>      <span class=\"token comment\" spellcheck=\"true\">// or if the drag ended but nobody handled the drop\n</span>      <span class=\"token keyword\" >return</span><span class=\"token punctuation\" >;</span>\n    <span class=\"token punctuation\" >}</span>\n\n    <span class=\"token comment\" spellcheck=\"true\">// When dropped on a compatible target, do something.\n</span>    <span class=\"token comment\" spellcheck=\"true\">// Read the original dragged item from getItem():\n</span>    <span class=\"token keyword\" >const</span> item <span class=\"token operator\" >=</span> monitor<span class=\"token punctuation\" >.</span><span class=\"token function\" >getItem<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n\n    <span class=\"token comment\" spellcheck=\"true\">// You may also read the drop result from the drop target\n</span>    <span class=\"token comment\" spellcheck=\"true\">// that handled the drop, if it returned an object from\n</span>    <span class=\"token comment\" spellcheck=\"true\">// its drop() method.\n</span>    <span class=\"token keyword\" >const</span> dropResult <span class=\"token operator\" >=</span> monitor<span class=\"token punctuation\" >.</span><span class=\"token function\" >getDropResult<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n\n    <span class=\"token comment\" spellcheck=\"true\">// This is a good place to call some Flux action\n</span>    <span class=\"token qualifier\" >Card</span><span class=\"token qualifier\" >Actions</span><span class=\"token punctuation\" >.</span><span class=\"token function\" >moveCardToList<span class=\"token punctuation\" >(</span></span>item<span class=\"token punctuation\" >.</span>id<span class=\"token punctuation\" >,</span> dropResult<span class=\"token punctuation\" >.</span>listId<span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n  <span class=\"token punctuation\" >}</span>\n<span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >;</span>\n\n<span class=\"token comment\" spellcheck=\"true\">/**\n * Specifies which props to inject into your component.\n */</span>\n<span class=\"token block-keyword\" >function</span> <span class=\"token function\" >collect<span class=\"token punctuation\" >(</span></span>connect<span class=\"token punctuation\" >,</span> monitor<span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n  <span class=\"token keyword\" >return</span> <span class=\"token punctuation\" >{</span>\n    <span class=\"token comment\" spellcheck=\"true\">// Call this function inside render()\n</span>    <span class=\"token comment\" spellcheck=\"true\">// to let React DnD handle the drag events:\n</span>    connectDragSource<span class=\"token punctuation\" >:</span> connect<span class=\"token punctuation\" >.</span><span class=\"token function\" >dragSource<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >,</span>\n    <span class=\"token comment\" spellcheck=\"true\">// You can ask the monitor about the current drag state:\n</span>    isDragging<span class=\"token punctuation\" >:</span> monitor<span class=\"token punctuation\" >.</span><span class=\"token function\" >isDragging<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span>\n  <span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >;</span>\n<span class=\"token punctuation\" >}</span>\n\n<span class=\"token keyword\" >class</span> <span class=\"token class-name\" >Card</span> <span class=\"token punctuation\" >{</span>\n  <span class=\"token function\" >render<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n    <span class=\"token comment\" spellcheck=\"true\">// Your component receives its own props as usual\n</span>    <span class=\"token keyword\" >const</span> <span class=\"token punctuation\" >{</span> id <span class=\"token punctuation\" >}</span> <span class=\"token operator\" >=</span> <span class=\"token var\" >this</span><span class=\"token punctuation\" >.</span>props<span class=\"token punctuation\" >;</span>\n\n    <span class=\"token comment\" spellcheck=\"true\">// These props are injected by React DnD,\n</span>    <span class=\"token comment\" spellcheck=\"true\">// as defined by your `collect` function above:\n</span>    <span class=\"token keyword\" >const</span> <span class=\"token punctuation\" >{</span> isDragging<span class=\"token punctuation\" >,</span> connectDragSource <span class=\"token punctuation\" >}</span> <span class=\"token operator\" >=</span> <span class=\"token var\" >this</span><span class=\"token punctuation\" >.</span>props<span class=\"token punctuation\" >;</span>\n\n    <span class=\"token keyword\" >return</span> <span class=\"token function\" >connectDragSource<span class=\"token punctuation\" >(</span></span>\n      <span class=\"token operator\" >&lt;</span>div<span class=\"token operator\" >></span>\n        I am a draggable card number <span class=\"token punctuation\" >{</span>id<span class=\"token punctuation\" >}</span>\n        <span class=\"token punctuation\" >{</span>isDragging <span class=\"token operator\" >&amp;&amp;</span> <span class=\"token string\" >' (and I am being dragged now)'</span><span class=\"token punctuation\" >}</span>\n      <span class=\"token operator\" >&lt;</span><span class=\"token operator\" >/</span>div<span class=\"token operator\" >></span>\n    <span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n  <span class=\"token punctuation\" >}</span>\n<span class=\"token punctuation\" >}</span>\n\n<span class=\"token keyword\" >export</span> <span class=\"token keyword\" >default</span> <span class=\"token function\" >DragSource<span class=\"token punctuation\" >(</span></span><span class=\"token qualifier\" >Types</span><span class=\"token punctuation\" >.</span>CARD<span class=\"token punctuation\" >,</span> cardSource<span class=\"token punctuation\" >,</span> collect<span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >(</span><span class=\"token qualifier\" >Card</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span></code><hr/>\n<code class=\"codeBlock\"><span class=\"token keyword\" >import</span> <span class=\"token qualifier\" >React</span> from <span class=\"token string\" >'react'</span><span class=\"token punctuation\" >;</span>\n<span class=\"token keyword\" >import</span> <span class=\"token punctuation\" >{</span> <span class=\"token qualifier\" >Drag</span><span class=\"token qualifier\" >Source</span> <span class=\"token punctuation\" >}</span> from <span class=\"token string\" >'react-dnd'</span><span class=\"token punctuation\" >;</span>\n\n<span class=\"token comment\" spellcheck=\"true\">// Drag sources and drop targets only interact\n</span><span class=\"token comment\" spellcheck=\"true\">// if they have the same string type.\n</span><span class=\"token comment\" spellcheck=\"true\">// You want to keep types in a separate file with\n</span><span class=\"token comment\" spellcheck=\"true\">// the rest of your app's constants.\n</span><span class=\"token keyword\" >const</span> <span class=\"token qualifier\" >Types</span> <span class=\"token operator\" >=</span> <span class=\"token punctuation\" >{</span>\n  CARD<span class=\"token punctuation\" >:</span> <span class=\"token string\" >'card'</span>\n<span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >;</span>\n\n<span class=\"token comment\" spellcheck=\"true\">/**\n * Specifies the drag source contract.\n * Only `beginDrag` function is required.\n */</span>\n<span class=\"token keyword\" >const</span> cardSource <span class=\"token operator\" >=</span> <span class=\"token punctuation\" >{</span>\n  <span class=\"token function\" >canDrag<span class=\"token punctuation\" >(</span></span>props<span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n    <span class=\"token comment\" spellcheck=\"true\">// You can disallow drag based on props\n</span>    <span class=\"token keyword\" >return</span> props<span class=\"token punctuation\" >.</span>isReady<span class=\"token punctuation\" >;</span>\n  <span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >,</span>\n\n  <span class=\"token function\" >isDragging<span class=\"token punctuation\" >(</span></span>props<span class=\"token punctuation\" >,</span> monitor<span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n    <span class=\"token comment\" spellcheck=\"true\">// If your component gets unmounted while dragged\n</span>    <span class=\"token comment\" spellcheck=\"true\">// (like a card in Kanban board dragged between lists)\n</span>    <span class=\"token comment\" spellcheck=\"true\">// you can implement something like this to keep its\n</span>    <span class=\"token comment\" spellcheck=\"true\">// appearance dragged:\n</span>    <span class=\"token keyword\" >return</span> monitor<span class=\"token punctuation\" >.</span><span class=\"token function\" >getItem<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >.</span>id <span class=\"token operator\" >===</span> props<span class=\"token punctuation\" >.</span>id<span class=\"token punctuation\" >;</span>\n  <span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >,</span>\n\n  <span class=\"token function\" >beginDrag<span class=\"token punctuation\" >(</span></span>props<span class=\"token punctuation\" >,</span> monitor<span class=\"token punctuation\" >,</span> component<span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n    <span class=\"token comment\" spellcheck=\"true\">// Return the data describing the dragged item\n</span>    <span class=\"token keyword\" >const</span> item <span class=\"token operator\" >=</span> <span class=\"token punctuation\" >{</span> id<span class=\"token punctuation\" >:</span> props<span class=\"token punctuation\" >.</span>id <span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >;</span>\n    <span class=\"token keyword\" >return</span> item<span class=\"token punctuation\" >;</span>\n  <span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >,</span>\n\n  <span class=\"token function\" >endDrag<span class=\"token punctuation\" >(</span></span>props<span class=\"token punctuation\" >,</span> monitor<span class=\"token punctuation\" >,</span> component<span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n    <span class=\"token block-keyword\" >if</span> <span class=\"token punctuation\" >(</span><span class=\"token operator\" >!</span>monitor<span class=\"token punctuation\" >.</span><span class=\"token function\" >didDrop<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n      <span class=\"token comment\" spellcheck=\"true\">// You can check whether the drop was successful\n</span>      <span class=\"token comment\" spellcheck=\"true\">// or if the drag ended but nobody handled the drop\n</span>      <span class=\"token keyword\" >return</span><span class=\"token punctuation\" >;</span>\n    <span class=\"token punctuation\" >}</span>\n\n    <span class=\"token comment\" spellcheck=\"true\">// When dropped on a compatible target, do something.\n</span>    <span class=\"token comment\" spellcheck=\"true\">// Read the original dragged item from getItem():\n</span>    <span class=\"token keyword\" >const</span> item <span class=\"token operator\" >=</span> monitor<span class=\"token punctuation\" >.</span><span class=\"token function\" >getItem<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n\n    <span class=\"token comment\" spellcheck=\"true\">// You may also read the drop result from the drop target\n</span>    <span class=\"token comment\" spellcheck=\"true\">// that handled the drop, if it returned an object from\n</span>    <span class=\"token comment\" spellcheck=\"true\">// its drop() method.\n</span>    <span class=\"token keyword\" >const</span> dropResult <span class=\"token operator\" >=</span> monitor<span class=\"token punctuation\" >.</span><span class=\"token function\" >getDropResult<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n\n    <span class=\"token comment\" spellcheck=\"true\">// This is a good place to call some Flux action\n</span>    <span class=\"token qualifier\" >Card</span><span class=\"token qualifier\" >Actions</span><span class=\"token punctuation\" >.</span><span class=\"token function\" >moveCardToList<span class=\"token punctuation\" >(</span></span>item<span class=\"token punctuation\" >.</span>id<span class=\"token punctuation\" >,</span> dropResult<span class=\"token punctuation\" >.</span>listId<span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n  <span class=\"token punctuation\" >}</span>\n<span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >;</span>\n\n@<span class=\"token function\" >DragSource<span class=\"token punctuation\" >(</span></span><span class=\"token qualifier\" >Types</span><span class=\"token punctuation\" >.</span>CARD<span class=\"token punctuation\" >,</span> cardSource<span class=\"token punctuation\" >,</span> <span class=\"token punctuation\" >(</span>connect<span class=\"token punctuation\" >,</span> monitor<span class=\"token punctuation\" >)</span> <span class=\"token operator\" >=</span><span class=\"token operator\" >></span> <span class=\"token punctuation\" >(</span><span class=\"token punctuation\" >{</span>\n  <span class=\"token comment\" spellcheck=\"true\">// Call this function inside render()\n</span>  <span class=\"token comment\" spellcheck=\"true\">// to let React DnD handle the drag events:\n</span>  connectDragSource<span class=\"token punctuation\" >:</span> connect<span class=\"token punctuation\" >.</span><span class=\"token function\" >dragSource<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >,</span>\n  <span class=\"token comment\" spellcheck=\"true\">// You can ask the monitor about the current drag state:\n</span>  isDragging<span class=\"token punctuation\" >:</span> monitor<span class=\"token punctuation\" >.</span><span class=\"token function\" >isDragging<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span>\n<span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >)</span>\n<span class=\"token keyword\" >export</span> <span class=\"token keyword\" >default</span> <span class=\"token keyword\" >class</span> <span class=\"token class-name\" >Card</span> <span class=\"token punctuation\" >{</span>\n  <span class=\"token function\" >render<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n    <span class=\"token comment\" spellcheck=\"true\">// Your component receives its own props as usual\n</span>    <span class=\"token keyword\" >const</span> <span class=\"token punctuation\" >{</span> id <span class=\"token punctuation\" >}</span> <span class=\"token operator\" >=</span> <span class=\"token var\" >this</span><span class=\"token punctuation\" >.</span>props<span class=\"token punctuation\" >;</span>\n\n    <span class=\"token comment\" spellcheck=\"true\">// These props are injected by React DnD,\n</span>    <span class=\"token comment\" spellcheck=\"true\">// as defined by your `collect` function above:\n</span>    <span class=\"token keyword\" >const</span> <span class=\"token punctuation\" >{</span> isDragging<span class=\"token punctuation\" >,</span> connectDragSource <span class=\"token punctuation\" >}</span> <span class=\"token operator\" >=</span> <span class=\"token var\" >this</span><span class=\"token punctuation\" >.</span>props<span class=\"token punctuation\" >;</span>\n\n    <span class=\"token keyword\" >return</span> <span class=\"token function\" >connectDragSource<span class=\"token punctuation\" >(</span></span>\n      <span class=\"token operator\" >&lt;</span>div<span class=\"token operator\" >></span>\n        I am a draggable card number <span class=\"token punctuation\" >{</span>id<span class=\"token punctuation\" >}</span>\n        <span class=\"token punctuation\" >{</span>isDragging <span class=\"token operator\" >&amp;&amp;</span> <span class=\"token string\" >' (and I am being dragged now)'</span><span class=\"token punctuation\" >}</span>\n      <span class=\"token operator\" >&lt;</span><span class=\"token operator\" >/</span>div<span class=\"token operator\" >></span>\n    <span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n  <span class=\"token punctuation\" >}</span>\n<span class=\"token punctuation\" >}</span></code><hr/>\n<h2>Type Definitions<a id=\"type-definitions\">&nbsp;</a></h2><code class=\"codeBlock\">type <span class=\"token qualifier\" >React</span><span class=\"token qualifier\" >Props</span> <span class=\"token operator\" >=</span> <span class=\"token qualifier\" >Object</span><span class=\"token punctuation\" >;</span>\n\ntype <span class=\"token qualifier\" >Drag</span><span class=\"token qualifier\" >Source</span><span class=\"token qualifier\" >Type</span> <span class=\"token operator\" >=</span>\n  string <span class=\"token operator\" >|</span>\n  symbol <span class=\"token operator\" >|</span>\n  <span class=\"token punctuation\" >(</span>props<span class=\"token punctuation\" >:</span> <span class=\"token qualifier\" >React</span><span class=\"token qualifier\" >Props</span><span class=\"token punctuation\" >)</span> <span class=\"token operator\" >=</span><span class=\"token operator\" >></span> string <span class=\"token operator\" >|</span> symbol<span class=\"token punctuation\" >;</span>\n\ntype <span class=\"token qualifier\" >Drag</span><span class=\"token qualifier\" >Source</span><span class=\"token qualifier\" >Spec</span> <span class=\"token operator\" >=</span> <span class=\"token punctuation\" >{</span>\n  beginDrag<span class=\"token punctuation\" >:</span> <span class=\"token punctuation\" >(</span>\n    props<span class=\"token punctuation\" >:</span> <span class=\"token qualifier\" >React</span><span class=\"token qualifier\" >Props</span><span class=\"token punctuation\" >,</span>\n    monitor<span class=\"token punctuation\" >:</span> <span class=\"token qualifier\" >Drag</span><span class=\"token qualifier\" >Source</span><span class=\"token qualifier\" >Monitor</span><span class=\"token punctuation\" >,</span>\n    component<span class=\"token punctuation\" >:</span> <span class=\"token qualifier\" >Your</span><span class=\"token qualifier\" >React</span><span class=\"token qualifier\" >Class</span>\n  <span class=\"token punctuation\" >)</span> <span class=\"token operator\" >=</span><span class=\"token operator\" >></span> <span class=\"token qualifier\" >Object</span><span class=\"token punctuation\" >;</span>\n\n  endDrag<span class=\"token punctuation\" >:</span> <span class=\"token operator\" >?</span><span class=\"token punctuation\" >(</span>\n    props<span class=\"token punctuation\" >:</span> <span class=\"token qualifier\" >React</span><span class=\"token qualifier\" >Props</span><span class=\"token punctuation\" >,</span>\n    monitor<span class=\"token punctuation\" >:</span> <span class=\"token qualifier\" >Drag</span><span class=\"token qualifier\" >Source</span><span class=\"token qualifier\" >Monitor</span><span class=\"token punctuation\" >,</span>\n    component<span class=\"token punctuation\" >:</span> <span class=\"token operator\" >?</span><span class=\"token qualifier\" >Your</span><span class=\"token qualifier\" >React</span><span class=\"token qualifier\" >Class</span>\n  <span class=\"token punctuation\" >)</span> <span class=\"token operator\" >=</span><span class=\"token operator\" >></span> <span class=\"token keyword\" >void</span><span class=\"token punctuation\" >;</span>\n\n  canDrag<span class=\"token punctuation\" >:</span> <span class=\"token operator\" >?</span><span class=\"token punctuation\" >(</span>\n    props<span class=\"token punctuation\" >:</span> <span class=\"token qualifier\" >React</span><span class=\"token qualifier\" >Props</span><span class=\"token punctuation\" >,</span>\n    monitor<span class=\"token punctuation\" >:</span> <span class=\"token qualifier\" >Drag</span><span class=\"token qualifier\" >Source</span><span class=\"token qualifier\" >Monitor</span>\n  <span class=\"token punctuation\" >)</span> <span class=\"token operator\" >=</span><span class=\"token operator\" >></span> boolean<span class=\"token punctuation\" >;</span>\n\n  isDragging<span class=\"token punctuation\" >:</span> <span class=\"token operator\" >?</span><span class=\"token punctuation\" >(</span>\n    props<span class=\"token punctuation\" >:</span> <span class=\"token qualifier\" >Object</span><span class=\"token punctuation\" >,</span>\n    monitor<span class=\"token punctuation\" >:</span> <span class=\"token qualifier\" >Drag</span><span class=\"token qualifier\" >Source</span><span class=\"token qualifier\" >Monitor</span>\n  <span class=\"token punctuation\" >)</span> <span class=\"token operator\" >=</span><span class=\"token operator\" >></span> boolean<span class=\"token punctuation\" >;</span>\n<span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >;</span>\n\ntype <span class=\"token qualifier\" >Drag</span><span class=\"token qualifier\" >Source</span><span class=\"token qualifier\" >Options</span> <span class=\"token operator\" >=</span> <span class=\"token punctuation\" >{</span>\n  arePropsEqual<span class=\"token punctuation\" >:</span> <span class=\"token operator\" >?</span><span class=\"token punctuation\" >(</span><span class=\"token qualifier\" >Object</span><span class=\"token punctuation\" >,</span> <span class=\"token qualifier\" >Object</span><span class=\"token punctuation\" >)</span> <span class=\"token operator\" >=</span><span class=\"token operator\" >></span> boolean\n<span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >;</span>\n\n<span class=\"token qualifier\" >Drag</span><span class=\"token qualifier\" >Source</span><span class=\"token punctuation\" >:</span> <span class=\"token punctuation\" >(</span>\n  type<span class=\"token punctuation\" >:</span> <span class=\"token qualifier\" >Drag</span><span class=\"token qualifier\" >Source</span><span class=\"token qualifier\" >Type</span><span class=\"token punctuation\" >,</span>\n  spec<span class=\"token punctuation\" >:</span> <span class=\"token qualifier\" >Drag</span><span class=\"token qualifier\" >Source</span><span class=\"token qualifier\" >Spec</span><span class=\"token punctuation\" >,</span>\n  collect<span class=\"token punctuation\" >:</span> <span class=\"token punctuation\" >(</span>\n    connect<span class=\"token punctuation\" >:</span> <span class=\"token qualifier\" >Drag</span><span class=\"token qualifier\" >Source</span><span class=\"token qualifier\" >Connector</span><span class=\"token punctuation\" >,</span>\n    monitor<span class=\"token punctuation\" >:</span> <span class=\"token qualifier\" >Drag</span><span class=\"token qualifier\" >Source</span><span class=\"token qualifier\" >Monitor</span>\n  <span class=\"token punctuation\" >)</span> <span class=\"token operator\" >=</span><span class=\"token operator\" >></span> <span class=\"token qualifier\" >Object</span><span class=\"token punctuation\" >,</span>\n  options<span class=\"token punctuation\" >:</span> <span class=\"token operator\" >?</span><span class=\"token qualifier\" >Drag</span><span class=\"token qualifier\" >Source</span><span class=\"token qualifier\" >Options</span>\n<span class=\"token punctuation\" >)</span> <span class=\"token operator\" >=</span><span class=\"token operator\" >></span> <span class=\"token punctuation\" >(</span>\n  component<span class=\"token punctuation\" >:</span> <span class=\"token qualifier\" >Your</span><span class=\"token qualifier\" >React</span><span class=\"token qualifier\" >Class</span>\n<span class=\"token punctuation\" >)</span> <span class=\"token operator\" >=</span><span class=\"token operator\" >></span> <span class=\"token qualifier\" >React</span><span class=\"token qualifier\" >Class</span></code>";

/***/ },
/* 337 */
/***/ function(module, exports) {

	module.exports = "<p><em>New to React DnD? <a href=\"docs-overview.html\">Read the overview</a> before jumping into the docs.</em></p>\n<h1>DropTarget<a id=\"droptarget\">&nbsp;</a></h1><p>Wrap your component with <code>DropTarget</code> to make it react to the compatible items being dragged, hovered, or dropped on it. <code>DropTarget</code> is a higher-order component.</p>\n<p>To use <code>DropTarget</code>, don&#39;t forget to wrap the top-level component of your app in a <a href=\"docs-drag-drop-context.html\"><code>DragDropContext</code></a>.</p>\n<h3>Signature<a id=\"signature\">&nbsp;</a></h3><p><code>DropTarget</code> uses partial application. After specifying its parameters with the first call, you need to pass your React component class as the only parameter in the second call. This signature makes <code>DropTarget</code> usable as an ES7 decorator. Read the <a href=\"docs-overview.html\">overview</a> for a more detailed explanation of the decorators and the higher-order components.</p>\n<hr/>\n<code class=\"codeBlock\"><span class=\"token keyword\" >var</span> <span class=\"token qualifier\" >Drop</span><span class=\"token qualifier\" >Target</span> <span class=\"token operator\" >=</span> <span class=\"token function\" >require<span class=\"token punctuation\" >(</span></span><span class=\"token string\" >'react-dnd'</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >.</span><span class=\"token qualifier\" >Drop</span><span class=\"token qualifier\" >Target</span><span class=\"token punctuation\" >;</span>\n\n<span class=\"token keyword\" >var</span> <span class=\"token qualifier\" >My</span><span class=\"token qualifier\" >Component</span> <span class=\"token operator\" >=</span> <span class=\"token qualifier\" >React</span><span class=\"token punctuation\" >.</span><span class=\"token function\" >createClass<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >{</span>\n  <span class=\"token comment\" spellcheck=\"true\">/* ... */</span>\n<span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n\nmodule<span class=\"token punctuation\" >.</span>exports <span class=\"token operator\" >=</span> <span class=\"token function\" >DropTarget<span class=\"token punctuation\" >(</span></span>types<span class=\"token punctuation\" >,</span> spec<span class=\"token punctuation\" >,</span> collect<span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >(</span><span class=\"token qualifier\" >My</span><span class=\"token qualifier\" >Component</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span></code><hr/>\n<code class=\"codeBlock\"><span class=\"token keyword\" >import</span> <span class=\"token punctuation\" >{</span> <span class=\"token qualifier\" >Drop</span><span class=\"token qualifier\" >Target</span> <span class=\"token punctuation\" >}</span> from <span class=\"token string\" >'react-dnd'</span><span class=\"token punctuation\" >;</span>\n\n<span class=\"token keyword\" >class</span> <span class=\"token class-name\" >MyComponent</span> <span class=\"token punctuation\" >{</span>\n  <span class=\"token comment\" spellcheck=\"true\">/* ... */</span>\n<span class=\"token punctuation\" >}</span>\n\n<span class=\"token keyword\" >export</span> <span class=\"token keyword\" >default</span> <span class=\"token function\" >DropTarget<span class=\"token punctuation\" >(</span></span>types<span class=\"token punctuation\" >,</span> spec<span class=\"token punctuation\" >,</span> collect<span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >(</span><span class=\"token qualifier\" >My</span><span class=\"token qualifier\" >Component</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span></code><hr/>\n<code class=\"codeBlock\"><span class=\"token keyword\" >import</span> <span class=\"token punctuation\" >{</span> <span class=\"token qualifier\" >Drop</span><span class=\"token qualifier\" >Target</span> <span class=\"token punctuation\" >}</span> from <span class=\"token string\" >'react-dnd'</span><span class=\"token punctuation\" >;</span>\n\n@<span class=\"token function\" >DropTarget<span class=\"token punctuation\" >(</span></span>types<span class=\"token punctuation\" >,</span> spec<span class=\"token punctuation\" >,</span> collect<span class=\"token punctuation\" >)</span>\n<span class=\"token keyword\" >export</span> <span class=\"token keyword\" >default</span> <span class=\"token keyword\" >class</span> <span class=\"token class-name\" >MyComponent</span> <span class=\"token punctuation\" >{</span>\n  <span class=\"token comment\" spellcheck=\"true\">/* ... */</span>\n<span class=\"token punctuation\" >}</span></code><hr/>\n<h3>Parameters<a id=\"parameters\">&nbsp;</a></h3><ul>\n<li><p><strong><code>types</code></strong>: Required. A string, an ES6 symbol, an array of either, or a function that returns either of those, given component&#39;s <code>props</code>. This drop target will only react to the items produced by the <a href=\"docs-drag-source.html\">drag sources</a> of the specified type or types. Read the <a href=\"docs-overview.html\">overview</a> to learn more about the items and types.</p>\n</li>\n<li><p><strong><code>spec</code></strong>: Required. A plain JavaScript object with a few allowed methods on it. It describes how the drop target reacts to the drag and drop events. See the drop target specification described in detail in the next section.</p>\n</li>\n<li><p><strong><code>collect</code></strong>: Required. The collecting function. It should return a plain object of the props to inject into your component. It receives two parameters: <code>monitor</code> and <code>connect</code>. Read the <a href=\"docs-overview.html\">overview</a> for an introduction to the monitors, the connectors, and the collecting function. See the collecting function described in detail after the next section.</p>\n</li>\n<li><p><strong><code>options</code></strong>: Optional. A plain object. If some of the props to your component are not scalar (that is, are not primitive values or functions), specifying a custom <code>arePropsEqual(props, otherProps)</code> function inside the <code>options</code> object can improve the performance. Unless you have performance problems, don&#39;t worry about it.</p>\n</li>\n</ul>\n<h3>Drop Target Specification<a id=\"drop-target-specification\">&nbsp;</a></h3><p>The second <code>spec</code> parameter must be a plain object implementing the drop target specification. Below is the list of all methods that it may have.</p>\n<h4>Specification Methods<a id=\"specification-methods\">&nbsp;</a></h4><ul>\n<li><p><strong><code>drop(props, monitor, component)</code></strong>: Optional. Called when a compatible item is dropped on the target. You may either return undefined, or a plain object. If you return an object, it is going to become <em>the drop result</em> and will be available to the drag source in its <code>endDrag</code> method as <code>monitor.getDropResult()</code>. This is useful in case you want to perform different actions depending on which target received the drop. If you have nested drop targets, you can test whether a nested target has already handled <code>drop</code> by checking <code>monitor.didDrop()</code> and <code>monitor.getDropResult()</code>. Both this method and the source&#39;s <code>endDrag</code> method are good places to fire Flux actions. This method will not be called if <code>canDrop()</code> is defined and returns <code>false</code>.</p>\n</li>\n<li><p><strong><code>hover(props, monitor, component)</code></strong>: Optional. Called when an item is hovered over the component. You can check <code>monitor.isOver({ shallow: true })</code> to test whether the hover happens over <em>just</em> the current target, or over a nested one. Unlike <code>drop()</code>, this method will be called even if <code>canDrop()</code> is defined and returns <code>false</code>. You can check <code>monitor.canDrop()</code> to test whether this is the case.</p>\n</li>\n<li><p><strong><code>canDrop(props, monitor)</code></strong>: Optional. Use it to specify whether the drop target is able to accept the item. If you want to always allow it, just omit this method. Specifying it is handy if you&#39;d like to disable dropping based on some predicate over <code>props</code> or <code>monitor.getItem()</code>. <em>Note: You may not call <code>monitor.canDrop()</code> inside this method.</em></p>\n</li>\n</ul>\n<p><strong>The spec offers no methods to handle enter or leave events by purpose.</strong> Instead, return the result of <code>monitor.isOver()</code> call from your <em>collecting function</em>, so that you can use <code>componentWillReceiveProps</code> or <code>componentDidUpdate</code> React hooks to process the entering and the leaving events in your component. You may also check <code>monitor.isOver({ shallow: true })</code> if don&#39;t want the nested drop targets to count.</p>\n<h4>Specification Method Parameters<a id=\"specification-method-parameters\">&nbsp;</a></h4><ul>\n<li><p><strong><code>props</code></strong>: Your component&#39;s current props.</p>\n</li>\n<li><p><strong><code>monitor</code></strong>: An instance of <a href=\"docs-drop-target-monitor.html\"><code>DropTargetMonitor</code></a>. Use it to query the information about the current drag state, such as the currently dragged item and its type, the current and initial coordinates and offsets, whether it is over the current target, and whether it can be dropped. Read the <a href=\"docs-drop-target-monitor.html\"><code>DropTargetMonitor</code> documentation</a> for a complete list of <code>monitor</code> methods, or read the <a href=\"docs-overview.html\">overview</a> for an introduction to the monitors.</p>\n</li>\n<li><p><strong><code>component</code></strong>: When specified, it is the instance of your component. Use it to access the underlying DOM node for position or size measurements, or to call <code>setState</code>, and other component methods. It is purposefully missing from <code>canDrop</code> because the instance may not be available by the time it is called. If you want this method to depend on the component&#39;s state, consider lifting the state to the parent component, so that you can just use <code>props</code>. Generally your code will be cleaner if you rely on <code>props</code> instead whenever possible.</p>\n</li>\n</ul>\n<h3>The Collecting Function<a id=\"the-collecting-function\">&nbsp;</a></h3><p>Just specifying the drop target <code>types</code> and <code>spec</code> is not quite enough.<br/>There&#39;s still a few more things we need to take care of:</p>\n<ul>\n<li>connect the React DnD event handlers to some node in the component;</li>\n<li>pass some knowledge about the dragging state to our component.</li>\n</ul>\n<p>All communication between the React components happens via props, so it makes sense that React DnD injects special props into your component. However it gives you the freedom to name them and decide what props your component will receive.</p>\n<p>Your <em>collecting function</em> will be called by React DnD with a <em>connector</em> that lets you connect nodes to the DnD backend, and a <em>monitor</em> to query information about the drag state. It should return a plain object of props to inject into your component.</p>\n<p>If you&#39;re new to these concepts, the <a href=\"docs-overview.html\">overview</a> should give you a good idea about them.</p>\n<h4>Parameters<a id=\"parameters\">&nbsp;</a></h4><ul>\n<li><p><strong><code>connect</code></strong>: An instance of <a href=\"docs-drop-target-connector.html\"><code>DropTargetConnector</code></a>. It only has a single <code>dropTarget()</code> method. It returns a function you need to pass down to your component to connect the target DOM node to the React DnD backend. If you return something like <code>{ connectDropTarget: connect.dropTarget() }</code> from your <code>collect</code> function, the component will receive <code>connectDropTarget</code> as a prop so you can mark the relevant node inside its <code>render()</code> as droppable: <code>return this.props.connectDropTarget(&lt;div&gt;...&lt;/div&gt;)</code>. You can see this pattern in action in the example at the end of this file. Read the <a href=\"docs-drop-target-connector.html\"><code>DropTargetConnector</code> documentation</a> for a complete list of <code>connect</code> methods, or read the <a href=\"docs-overview.html\">overview</a> for an introduction to the connectors.</p>\n</li>\n<li><p><strong><code>monitor</code></strong>: An instance of <a href=\"docs-drop-target-monitor.html\"><code>DropTargetMonitor</code></a>. It is precisely the same <code>monitor</code> you receive in the drop target specification methods, and you can use it to query the information about the current drag state. Read the <a href=\"docs-drop-target-monitor.html\"><code>DropTargetMonitor</code> documentation</a> for a complete list of <code>monitor</code> methods, or read the <a href=\"docs-overview.html\">overview</a> for an introduction to the monitors.</p>\n</li>\n</ul>\n<h3>Return Value<a id=\"return-value\">&nbsp;</a></h3><p><code>DropTarget</code> wraps your component and returns another React component.<br/>For easier <a href=\"docs-testing.html\">testing</a>, it provides an API to reach into the internals:</p>\n<h4>Static Properties<a id=\"static-properties\">&nbsp;</a></h4><ul>\n<li><strong><code>DecoratedComponent</code></strong>: Returns the wrapped component type.</li>\n</ul>\n<h4>Instance Methods<a id=\"instance-methods\">&nbsp;</a></h4><ul>\n<li><p><strong><code>getDecoratedComponentInstance()</code></strong>: Returns the wrapped component instance.</p>\n</li>\n<li><p><strong><code>getHandlerId()</code></strong>: Returns the drag source ID that can be used to simulate the drag and drop events with the testing backend. Refer to the <a href=\"docs-testing.html\">testing</a> tutorial for a usage example.</p>\n</li>\n</ul>\n<h3>Nesting Behavior<a id=\"nesting-behavior\">&nbsp;</a></h3><p>If a drop target is nested in another drop target, both <code>hover()</code> and <code>drop()</code> bubble from the innermost target up the chain. There is no way to cancel the propagation by design. Instead, any drop target may compare <code>monitor.isOver()</code> and <code>monitor.isOver({ shallow: true })</code> to verify whether a child, or just the current drop target is being hovered. When dropping, any drop target in the chain may check whether it is the first in chain by testing if <code>monitor.didDrop()</code> returns <code>false</code>. Any parent drop target may override the drop result specified by the child drop target by explicitly returning another drop result from <code>drop()</code>. If a parent target returns <code>undefined</code> from its <code>drop()</code> handler, it does not change the existing drop result that may have been specified by a nested drop target. The drop targets that return <code>false</code> from <code>canDrop()</code> are exluded from the <code>drop()</code> dispatch.</p>\n<h3>Handling Files and URLs<a id=\"handling-files-and-urls\">&nbsp;</a></h3><p>When using the <a href=\"docs-html5-backend.html\"><code>HTML5</code> backend</a>, you can handle the file drops just by registering a drop target for <code>HTML5Backend.NativeTypes.FILE</code> or <code>HTML5Backend.NativeTypes.URL</code> built-in types. Due to the browser security restrictions, <code>monitor.getItem()</code> does not provide any information about the files or the URLs until they are dropped.</p>\n<h3>Example<a id=\"example\">&nbsp;</a></h3><p>Check out <a href=\"docs-tutorial.html\">the tutorial</a> for more real examples!</p>\n<hr/>\n<code class=\"codeBlock\"><span class=\"token keyword\" >var</span> <span class=\"token qualifier\" >React</span> <span class=\"token operator\" >=</span> <span class=\"token function\" >require<span class=\"token punctuation\" >(</span></span><span class=\"token string\" >'react'</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n<span class=\"token keyword\" >var</span> <span class=\"token qualifier\" >Drop</span><span class=\"token qualifier\" >Target</span> <span class=\"token operator\" >=</span> <span class=\"token function\" >require<span class=\"token punctuation\" >(</span></span><span class=\"token string\" >'react-dnd'</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >.</span><span class=\"token qualifier\" >Drop</span><span class=\"token qualifier\" >Target</span><span class=\"token punctuation\" >;</span>\n\n<span class=\"token comment\" spellcheck=\"true\">// Drag sources and drop targets only interact\n</span><span class=\"token comment\" spellcheck=\"true\">// if they have the same string type.\n</span><span class=\"token comment\" spellcheck=\"true\">// You want to keep types in a separate file with\n</span><span class=\"token comment\" spellcheck=\"true\">// the rest of your app's constants.\n</span><span class=\"token keyword\" >var</span> <span class=\"token qualifier\" >Types</span> <span class=\"token operator\" >=</span> <span class=\"token punctuation\" >{</span>\n  CHESSPIECE<span class=\"token punctuation\" >:</span> <span class=\"token string\" >'chesspiece'</span>\n<span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >;</span>\n\n<span class=\"token comment\" spellcheck=\"true\">/**\n * Specifies the drop target contract.\n * All methods are optional.\n */</span>\n<span class=\"token keyword\" >var</span> chessSquareTarget <span class=\"token operator\" >=</span> <span class=\"token punctuation\" >{</span>\n  canDrop<span class=\"token punctuation\" >:</span> <span class=\"token block-keyword\" >function</span> <span class=\"token punctuation\" >(</span>props<span class=\"token punctuation\" >,</span> monitor<span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n    <span class=\"token comment\" spellcheck=\"true\">// You can disallow drop based on props or item\n</span>    <span class=\"token keyword\" >var</span> item <span class=\"token operator\" >=</span> monitor<span class=\"token punctuation\" >.</span><span class=\"token function\" >getItem<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n    <span class=\"token keyword\" >return</span> <span class=\"token function\" >canMakeChessMove<span class=\"token punctuation\" >(</span></span>item<span class=\"token punctuation\" >.</span>fromPosition<span class=\"token punctuation\" >,</span> props<span class=\"token punctuation\" >.</span>position<span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n  <span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >,</span>\n\n  hover<span class=\"token punctuation\" >:</span> <span class=\"token block-keyword\" >function</span> <span class=\"token punctuation\" >(</span>props<span class=\"token punctuation\" >,</span> monitor<span class=\"token punctuation\" >,</span> component<span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n    <span class=\"token comment\" spellcheck=\"true\">// This is fired very often and lets you perform side effects\n</span>    <span class=\"token comment\" spellcheck=\"true\">// in response to the hover. You can't handle enter and leave\n</span>    <span class=\"token comment\" spellcheck=\"true\">// here—if you need them, put monitor.isOver() into collect() so you\n</span>    <span class=\"token comment\" spellcheck=\"true\">// can just use componentWillReceiveProps() to handle enter/leave.\n</span>\n    <span class=\"token comment\" spellcheck=\"true\">// You can access the coordinates if you need them\n</span>    <span class=\"token keyword\" >var</span> clientOffset <span class=\"token operator\" >=</span> monitor<span class=\"token punctuation\" >.</span><span class=\"token function\" >getClientOffset<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n    <span class=\"token keyword\" >var</span> componentRect <span class=\"token operator\" >=</span> <span class=\"token function\" >findDOMNode<span class=\"token punctuation\" >(</span></span>component<span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >.</span><span class=\"token function\" >getBoundingClientRect<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n\n    <span class=\"token comment\" spellcheck=\"true\">// You can check whether we're over a nested drop target\n</span>    <span class=\"token keyword\" >var</span> isJustOverThisOne <span class=\"token operator\" >=</span> monitor<span class=\"token punctuation\" >.</span><span class=\"token function\" >isOver<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >{</span> shallow<span class=\"token punctuation\" >:</span> <span class=\"token primitive\" >true</span> <span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n\n    <span class=\"token comment\" spellcheck=\"true\">// You will receive hover() even for items for which canDrop() is false\n</span>    <span class=\"token keyword\" >var</span> canDrop <span class=\"token operator\" >=</span> monitor<span class=\"token punctuation\" >.</span><span class=\"token function\" >canDrop<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n  <span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >,</span>\n\n  drop<span class=\"token punctuation\" >:</span> <span class=\"token block-keyword\" >function</span> <span class=\"token punctuation\" >(</span>props<span class=\"token punctuation\" >,</span> monitor<span class=\"token punctuation\" >,</span> component<span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n    <span class=\"token block-keyword\" >if</span> <span class=\"token punctuation\" >(</span>monitor<span class=\"token punctuation\" >.</span><span class=\"token function\" >didDrop<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n      <span class=\"token comment\" spellcheck=\"true\">// If you want, you can check whether some nested\n</span>      <span class=\"token comment\" spellcheck=\"true\">// target already handled drop\n</span>      <span class=\"token keyword\" >return</span><span class=\"token punctuation\" >;</span>\n    <span class=\"token punctuation\" >}</span>\n\n    <span class=\"token comment\" spellcheck=\"true\">// Obtain the dragged item\n</span>    <span class=\"token keyword\" >var</span> item <span class=\"token operator\" >=</span> monitor<span class=\"token punctuation\" >.</span><span class=\"token function\" >getItem<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n\n    <span class=\"token comment\" spellcheck=\"true\">// You can do something with it\n</span>    <span class=\"token qualifier\" >Chess</span><span class=\"token qualifier\" >Actions</span><span class=\"token punctuation\" >.</span><span class=\"token function\" >movePiece<span class=\"token punctuation\" >(</span></span>item<span class=\"token punctuation\" >.</span>fromPosition<span class=\"token punctuation\" >,</span> props<span class=\"token punctuation\" >.</span>position<span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n\n    <span class=\"token comment\" spellcheck=\"true\">// You can also do nothing and return a drop result,\n</span>    <span class=\"token comment\" spellcheck=\"true\">// which will be available as monitor.getDropResult()\n</span>    <span class=\"token comment\" spellcheck=\"true\">// in the drag source's endDrag() method\n</span>    <span class=\"token keyword\" >return</span> <span class=\"token punctuation\" >{</span> moved<span class=\"token punctuation\" >:</span> <span class=\"token primitive\" >true</span> <span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >;</span>\n  <span class=\"token punctuation\" >}</span>\n<span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >;</span>\n\n<span class=\"token comment\" spellcheck=\"true\">/**\n * Specifies which props to inject into your component.\n */</span>\n<span class=\"token block-keyword\" >function</span> <span class=\"token function\" >collect<span class=\"token punctuation\" >(</span></span>connect<span class=\"token punctuation\" >,</span> monitor<span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n  <span class=\"token keyword\" >return</span> <span class=\"token punctuation\" >{</span>\n    <span class=\"token comment\" spellcheck=\"true\">// Call this function inside render()\n</span>    <span class=\"token comment\" spellcheck=\"true\">// to let React DnD handle the drag events:\n</span>    connectDropTarget<span class=\"token punctuation\" >:</span> connect<span class=\"token punctuation\" >.</span><span class=\"token function\" >dropTarget<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >,</span>\n    <span class=\"token comment\" spellcheck=\"true\">// You can ask the monitor about the current drag state:\n</span>    isOver<span class=\"token punctuation\" >:</span> monitor<span class=\"token punctuation\" >.</span><span class=\"token function\" >isOver<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >,</span>\n    isOverCurrent<span class=\"token punctuation\" >:</span> monitor<span class=\"token punctuation\" >.</span><span class=\"token function\" >isOver<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >{</span> shallow<span class=\"token punctuation\" >:</span> <span class=\"token primitive\" >true</span> <span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >,</span>\n    canDrop<span class=\"token punctuation\" >:</span> monitor<span class=\"token punctuation\" >.</span><span class=\"token function\" >canDrop<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >,</span>\n    itemType<span class=\"token punctuation\" >:</span> monitor<span class=\"token punctuation\" >.</span><span class=\"token function\" >getItemType<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span>\n  <span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >;</span>\n<span class=\"token punctuation\" >}</span>\n\n<span class=\"token keyword\" >var</span> <span class=\"token qualifier\" >Chess</span><span class=\"token qualifier\" >Square</span> <span class=\"token operator\" >=</span> <span class=\"token qualifier\" >React</span><span class=\"token punctuation\" >.</span><span class=\"token function\" >createClass<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >{</span>\n  componentWillReceiveProps<span class=\"token punctuation\" >:</span> <span class=\"token block-keyword\" >function</span> <span class=\"token punctuation\" >(</span>nextProps<span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n    <span class=\"token block-keyword\" >if</span> <span class=\"token punctuation\" >(</span><span class=\"token operator\" >!</span><span class=\"token var\" >this</span><span class=\"token punctuation\" >.</span>props<span class=\"token punctuation\" >.</span>isOver <span class=\"token operator\" >&amp;&amp;</span> nextProps<span class=\"token punctuation\" >.</span>isOver<span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n      <span class=\"token comment\" spellcheck=\"true\">// You can use this as enter handler\n</span>    <span class=\"token punctuation\" >}</span>\n\n    <span class=\"token block-keyword\" >if</span> <span class=\"token punctuation\" >(</span><span class=\"token var\" >this</span><span class=\"token punctuation\" >.</span>props<span class=\"token punctuation\" >.</span>isOver <span class=\"token operator\" >&amp;&amp;</span> <span class=\"token operator\" >!</span>nextProps<span class=\"token punctuation\" >.</span>isOver<span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n      <span class=\"token comment\" spellcheck=\"true\">// You can use this as leave handler\n</span>    <span class=\"token punctuation\" >}</span>\n\n    <span class=\"token block-keyword\" >if</span> <span class=\"token punctuation\" >(</span><span class=\"token var\" >this</span><span class=\"token punctuation\" >.</span>props<span class=\"token punctuation\" >.</span>isOverCurrent <span class=\"token operator\" >&amp;&amp;</span> <span class=\"token operator\" >!</span>nextProps<span class=\"token punctuation\" >.</span>isOverCurrent<span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n      <span class=\"token comment\" spellcheck=\"true\">// You can be more specific and track enter/leave\n</span>      <span class=\"token comment\" spellcheck=\"true\">// shallowly, not including nested targets\n</span>    <span class=\"token punctuation\" >}</span>\n  <span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >,</span>\n\n  render<span class=\"token punctuation\" >:</span> <span class=\"token block-keyword\" >function</span> <span class=\"token punctuation\" >(</span><span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n    <span class=\"token comment\" spellcheck=\"true\">// Your component receives its own props as usual\n</span>    <span class=\"token keyword\" >var</span> position <span class=\"token operator\" >=</span> <span class=\"token var\" >this</span><span class=\"token punctuation\" >.</span>props<span class=\"token punctuation\" >.</span>position<span class=\"token punctuation\" >;</span>\n\n    <span class=\"token comment\" spellcheck=\"true\">// These props are injected by React DnD,\n</span>    <span class=\"token comment\" spellcheck=\"true\">// as defined by your `collect` function above:\n</span>    <span class=\"token keyword\" >var</span> isOver <span class=\"token operator\" >=</span> <span class=\"token var\" >this</span><span class=\"token punctuation\" >.</span>props<span class=\"token punctuation\" >.</span>isOver<span class=\"token punctuation\" >;</span>\n    <span class=\"token keyword\" >var</span> canDrop <span class=\"token operator\" >=</span> <span class=\"token var\" >this</span><span class=\"token punctuation\" >.</span>props<span class=\"token punctuation\" >.</span>canDrop<span class=\"token punctuation\" >;</span>\n    <span class=\"token keyword\" >var</span> connectDropTarget <span class=\"token operator\" >=</span> <span class=\"token var\" >this</span><span class=\"token punctuation\" >.</span>props<span class=\"token punctuation\" >.</span>connectDropTarget<span class=\"token punctuation\" >;</span>\n\n    <span class=\"token keyword\" >return</span> <span class=\"token function\" >connectDropTarget<span class=\"token punctuation\" >(</span></span>\n      <span class=\"token operator\" >&lt;</span>div className<span class=\"token operator\" >=</span><span class=\"token string\" >'Cell'</span><span class=\"token operator\" >></span>\n        <span class=\"token punctuation\" >{</span>isOver <span class=\"token operator\" >&amp;&amp;</span> canDrop <span class=\"token operator\" >&amp;&amp;</span> <span class=\"token operator\" >&lt;</span>div <span class=\"token keyword\" >class</span><span class=\"token operator\" >=</span><span class=\"token string\" >'green'</span> <span class=\"token operator\" >/</span><span class=\"token operator\" >></span><span class=\"token punctuation\" >}</span>\n        <span class=\"token punctuation\" >{</span><span class=\"token operator\" >!</span>isOver <span class=\"token operator\" >&amp;&amp;</span> canDrop <span class=\"token operator\" >&amp;&amp;</span> <span class=\"token operator\" >&lt;</span>div <span class=\"token keyword\" >class</span><span class=\"token operator\" >=</span><span class=\"token string\" >'yellow'</span> <span class=\"token operator\" >/</span><span class=\"token operator\" >></span><span class=\"token punctuation\" >}</span>\n        <span class=\"token punctuation\" >{</span>isOver <span class=\"token operator\" >&amp;&amp;</span> <span class=\"token operator\" >!</span>canDrop <span class=\"token operator\" >&amp;&amp;</span> <span class=\"token operator\" >&lt;</span>div <span class=\"token keyword\" >class</span><span class=\"token operator\" >=</span><span class=\"token string\" >'red'</span> <span class=\"token operator\" >/</span><span class=\"token operator\" >></span><span class=\"token punctuation\" >}</span>\n      <span class=\"token operator\" >&lt;</span><span class=\"token operator\" >/</span>div<span class=\"token operator\" >></span>\n    <span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n  <span class=\"token punctuation\" >}</span>\n<span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n\nmodule<span class=\"token punctuation\" >.</span>exports <span class=\"token operator\" >=</span> <span class=\"token function\" >DropTarget<span class=\"token punctuation\" >(</span></span><span class=\"token qualifier\" >Types</span><span class=\"token punctuation\" >.</span>CHESSPIECE<span class=\"token punctuation\" >,</span> chessSquareTarget<span class=\"token punctuation\" >,</span> collect<span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >(</span><span class=\"token qualifier\" >Chess</span><span class=\"token qualifier\" >Square</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span></code><hr/>\n<code class=\"codeBlock\"><span class=\"token keyword\" >import</span> <span class=\"token qualifier\" >React</span> from <span class=\"token string\" >'react'</span><span class=\"token punctuation\" >;</span>\n<span class=\"token keyword\" >import</span> <span class=\"token punctuation\" >{</span> <span class=\"token qualifier\" >Drop</span><span class=\"token qualifier\" >Target</span> <span class=\"token punctuation\" >}</span> from <span class=\"token string\" >'react-dnd'</span><span class=\"token punctuation\" >;</span>\n\n<span class=\"token comment\" spellcheck=\"true\">// Drag sources and drop targets only interact\n</span><span class=\"token comment\" spellcheck=\"true\">// if they have the same string type.\n</span><span class=\"token comment\" spellcheck=\"true\">// You want to keep types in a separate file with\n</span><span class=\"token comment\" spellcheck=\"true\">// the rest of your app's constants.\n</span><span class=\"token keyword\" >const</span> <span class=\"token qualifier\" >Types</span> <span class=\"token operator\" >=</span> <span class=\"token punctuation\" >{</span>\n  CHESSPIECE<span class=\"token punctuation\" >:</span> <span class=\"token string\" >'chesspiece'</span>\n<span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >;</span>\n\n<span class=\"token comment\" spellcheck=\"true\">/**\n * Specifies the drop target contract.\n * All methods are optional.\n */</span>\n<span class=\"token keyword\" >const</span> chessSquareTarget <span class=\"token operator\" >=</span> <span class=\"token punctuation\" >{</span>\n  <span class=\"token function\" >canDrop<span class=\"token punctuation\" >(</span></span>props<span class=\"token punctuation\" >,</span> monitor<span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n    <span class=\"token comment\" spellcheck=\"true\">// You can disallow drop based on props or item\n</span>    <span class=\"token keyword\" >const</span> item <span class=\"token operator\" >=</span> monitor<span class=\"token punctuation\" >.</span><span class=\"token function\" >getItem<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n    <span class=\"token keyword\" >return</span> <span class=\"token function\" >canMakeChessMove<span class=\"token punctuation\" >(</span></span>item<span class=\"token punctuation\" >.</span>fromPosition<span class=\"token punctuation\" >,</span> props<span class=\"token punctuation\" >.</span>position<span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n  <span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >,</span>\n\n  <span class=\"token function\" >hover<span class=\"token punctuation\" >(</span></span>props<span class=\"token punctuation\" >,</span> monitor<span class=\"token punctuation\" >,</span> component<span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n    <span class=\"token comment\" spellcheck=\"true\">// This is fired very often and lets you perform side effects\n</span>    <span class=\"token comment\" spellcheck=\"true\">// in response to the hover. You can't handle enter and leave\n</span>    <span class=\"token comment\" spellcheck=\"true\">// here—if you need them, put monitor.isOver() into collect() so you\n</span>    <span class=\"token comment\" spellcheck=\"true\">// can just use componentWillReceiveProps() to handle enter/leave.\n</span>\n    <span class=\"token comment\" spellcheck=\"true\">// You can access the coordinates if you need them\n</span>    <span class=\"token keyword\" >const</span> clientOffset <span class=\"token operator\" >=</span> monitor<span class=\"token punctuation\" >.</span><span class=\"token function\" >getClientOffset<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n    <span class=\"token keyword\" >const</span> componentRect <span class=\"token operator\" >=</span> <span class=\"token function\" >findDOMNode<span class=\"token punctuation\" >(</span></span>component<span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >.</span><span class=\"token function\" >getBoundingClientRect<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n\n    <span class=\"token comment\" spellcheck=\"true\">// You can check whether we're over a nested drop target\n</span>    <span class=\"token keyword\" >const</span> isJustOverThisOne <span class=\"token operator\" >=</span> monitor<span class=\"token punctuation\" >.</span><span class=\"token function\" >isOver<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >{</span> shallow<span class=\"token punctuation\" >:</span> <span class=\"token primitive\" >true</span> <span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n\n    <span class=\"token comment\" spellcheck=\"true\">// You will receive hover() even for items for which canDrop() is false\n</span>    <span class=\"token keyword\" >const</span> canDrop <span class=\"token operator\" >=</span> monitor<span class=\"token punctuation\" >.</span><span class=\"token function\" >canDrop<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n  <span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >,</span>\n\n  <span class=\"token function\" >drop<span class=\"token punctuation\" >(</span></span>props<span class=\"token punctuation\" >,</span> monitor<span class=\"token punctuation\" >,</span> component<span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n    <span class=\"token block-keyword\" >if</span> <span class=\"token punctuation\" >(</span>monitor<span class=\"token punctuation\" >.</span><span class=\"token function\" >didDrop<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n      <span class=\"token comment\" spellcheck=\"true\">// If you want, you can check whether some nested\n</span>      <span class=\"token comment\" spellcheck=\"true\">// target already handled drop\n</span>      <span class=\"token keyword\" >return</span><span class=\"token punctuation\" >;</span>\n    <span class=\"token punctuation\" >}</span>\n\n    <span class=\"token comment\" spellcheck=\"true\">// Obtain the dragged item\n</span>    <span class=\"token keyword\" >const</span> item <span class=\"token operator\" >=</span> monitor<span class=\"token punctuation\" >.</span><span class=\"token function\" >getItem<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n\n    <span class=\"token comment\" spellcheck=\"true\">// You can do something with it\n</span>    <span class=\"token qualifier\" >Chess</span><span class=\"token qualifier\" >Actions</span><span class=\"token punctuation\" >.</span><span class=\"token function\" >movePiece<span class=\"token punctuation\" >(</span></span>item<span class=\"token punctuation\" >.</span>fromPosition<span class=\"token punctuation\" >,</span> props<span class=\"token punctuation\" >.</span>position<span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n\n    <span class=\"token comment\" spellcheck=\"true\">// You can also do nothing and return a drop result,\n</span>    <span class=\"token comment\" spellcheck=\"true\">// which will be available as monitor.getDropResult()\n</span>    <span class=\"token comment\" spellcheck=\"true\">// in the drag source's endDrag() method\n</span>    <span class=\"token keyword\" >return</span> <span class=\"token punctuation\" >{</span> moved<span class=\"token punctuation\" >:</span> <span class=\"token primitive\" >true</span> <span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >;</span>\n  <span class=\"token punctuation\" >}</span>\n<span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >;</span>\n\n<span class=\"token comment\" spellcheck=\"true\">/**\n * Specifies which props to inject into your component.\n */</span>\n<span class=\"token block-keyword\" >function</span> <span class=\"token function\" >collect<span class=\"token punctuation\" >(</span></span>connect<span class=\"token punctuation\" >,</span> monitor<span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n  <span class=\"token keyword\" >return</span> <span class=\"token punctuation\" >{</span>\n    <span class=\"token comment\" spellcheck=\"true\">// Call this function inside render()\n</span>    <span class=\"token comment\" spellcheck=\"true\">// to let React DnD handle the drag events:\n</span>    connectDropTarget<span class=\"token punctuation\" >:</span> connect<span class=\"token punctuation\" >.</span><span class=\"token function\" >dropTarget<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >,</span>\n    <span class=\"token comment\" spellcheck=\"true\">// You can ask the monitor about the current drag state:\n</span>    isOver<span class=\"token punctuation\" >:</span> monitor<span class=\"token punctuation\" >.</span><span class=\"token function\" >isOver<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >,</span>\n    isOverCurrent<span class=\"token punctuation\" >:</span> monitor<span class=\"token punctuation\" >.</span><span class=\"token function\" >isOver<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >{</span> shallow<span class=\"token punctuation\" >:</span> <span class=\"token primitive\" >true</span> <span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >,</span>\n    canDrop<span class=\"token punctuation\" >:</span> monitor<span class=\"token punctuation\" >.</span><span class=\"token function\" >canDrop<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >,</span>\n    itemType<span class=\"token punctuation\" >:</span> monitor<span class=\"token punctuation\" >.</span><span class=\"token function\" >getItemType<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span>\n  <span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >;</span>\n<span class=\"token punctuation\" >}</span>\n\n<span class=\"token keyword\" >class</span> <span class=\"token class-name\" >ChessSquare</span> <span class=\"token punctuation\" >{</span>\n  <span class=\"token function\" >componentWillReceiveProps<span class=\"token punctuation\" >(</span></span>nextProps<span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n    <span class=\"token block-keyword\" >if</span> <span class=\"token punctuation\" >(</span><span class=\"token operator\" >!</span><span class=\"token var\" >this</span><span class=\"token punctuation\" >.</span>props<span class=\"token punctuation\" >.</span>isOver <span class=\"token operator\" >&amp;&amp;</span> nextProps<span class=\"token punctuation\" >.</span>isOver<span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n      <span class=\"token comment\" spellcheck=\"true\">// You can use this as enter handler\n</span>    <span class=\"token punctuation\" >}</span>\n\n    <span class=\"token block-keyword\" >if</span> <span class=\"token punctuation\" >(</span><span class=\"token var\" >this</span><span class=\"token punctuation\" >.</span>props<span class=\"token punctuation\" >.</span>isOver <span class=\"token operator\" >&amp;&amp;</span> <span class=\"token operator\" >!</span>nextProps<span class=\"token punctuation\" >.</span>isOver<span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n      <span class=\"token comment\" spellcheck=\"true\">// You can use this as leave handler\n</span>    <span class=\"token punctuation\" >}</span>\n\n    <span class=\"token block-keyword\" >if</span> <span class=\"token punctuation\" >(</span><span class=\"token var\" >this</span><span class=\"token punctuation\" >.</span>props<span class=\"token punctuation\" >.</span>isOverCurrent <span class=\"token operator\" >&amp;&amp;</span> <span class=\"token operator\" >!</span>nextProps<span class=\"token punctuation\" >.</span>isOverCurrent<span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n      <span class=\"token comment\" spellcheck=\"true\">// You can be more specific and track enter/leave\n</span>      <span class=\"token comment\" spellcheck=\"true\">// shallowly, not including nested targets\n</span>    <span class=\"token punctuation\" >}</span>\n  <span class=\"token punctuation\" >}</span>\n\n  <span class=\"token function\" >render<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n    <span class=\"token comment\" spellcheck=\"true\">// Your component receives its own props as usual\n</span>    <span class=\"token keyword\" >const</span> <span class=\"token punctuation\" >{</span> position <span class=\"token punctuation\" >}</span> <span class=\"token operator\" >=</span> <span class=\"token var\" >this</span><span class=\"token punctuation\" >.</span>props<span class=\"token punctuation\" >;</span>\n\n    <span class=\"token comment\" spellcheck=\"true\">// These props are injected by React DnD,\n</span>    <span class=\"token comment\" spellcheck=\"true\">// as defined by your `collect` function above:\n</span>    <span class=\"token keyword\" >const</span> <span class=\"token punctuation\" >{</span> isOver<span class=\"token punctuation\" >,</span> canDrop<span class=\"token punctuation\" >,</span> connectDropTarget <span class=\"token punctuation\" >}</span> <span class=\"token operator\" >=</span> <span class=\"token var\" >this</span><span class=\"token punctuation\" >.</span>props<span class=\"token punctuation\" >;</span>\n\n    <span class=\"token keyword\" >return</span> <span class=\"token function\" >connectDropTarget<span class=\"token punctuation\" >(</span></span>\n      <span class=\"token operator\" >&lt;</span>div className<span class=\"token operator\" >=</span><span class=\"token string\" >'Cell'</span><span class=\"token operator\" >></span>\n        <span class=\"token punctuation\" >{</span>isOver <span class=\"token operator\" >&amp;&amp;</span> canDrop <span class=\"token operator\" >&amp;&amp;</span> <span class=\"token operator\" >&lt;</span>div <span class=\"token keyword\" >class</span><span class=\"token operator\" >=</span><span class=\"token string\" >'green'</span> <span class=\"token operator\" >/</span><span class=\"token operator\" >></span><span class=\"token punctuation\" >}</span>\n        <span class=\"token punctuation\" >{</span><span class=\"token operator\" >!</span>isOver <span class=\"token operator\" >&amp;&amp;</span> canDrop <span class=\"token operator\" >&amp;&amp;</span> <span class=\"token operator\" >&lt;</span>div <span class=\"token keyword\" >class</span><span class=\"token operator\" >=</span><span class=\"token string\" >'yellow'</span> <span class=\"token operator\" >/</span><span class=\"token operator\" >></span><span class=\"token punctuation\" >}</span>\n        <span class=\"token punctuation\" >{</span>isOver <span class=\"token operator\" >&amp;&amp;</span> <span class=\"token operator\" >!</span>canDrop <span class=\"token operator\" >&amp;&amp;</span> <span class=\"token operator\" >&lt;</span>div <span class=\"token keyword\" >class</span><span class=\"token operator\" >=</span><span class=\"token string\" >'red'</span> <span class=\"token operator\" >/</span><span class=\"token operator\" >></span><span class=\"token punctuation\" >}</span>\n      <span class=\"token operator\" >&lt;</span><span class=\"token operator\" >/</span>div<span class=\"token operator\" >></span>\n    <span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n  <span class=\"token punctuation\" >}</span>\n<span class=\"token punctuation\" >}</span>\n\n<span class=\"token keyword\" >export</span> <span class=\"token keyword\" >default</span> <span class=\"token function\" >DropTarget<span class=\"token punctuation\" >(</span></span><span class=\"token qualifier\" >Types</span><span class=\"token punctuation\" >.</span>CHESSPIECE<span class=\"token punctuation\" >,</span> chessSquareTarget<span class=\"token punctuation\" >,</span> collect<span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >(</span><span class=\"token qualifier\" >Chess</span><span class=\"token qualifier\" >Square</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span></code><hr/>\n<code class=\"codeBlock\"><span class=\"token keyword\" >import</span> <span class=\"token qualifier\" >React</span> from <span class=\"token string\" >'react'</span><span class=\"token punctuation\" >;</span>\n<span class=\"token keyword\" >import</span> <span class=\"token punctuation\" >{</span> <span class=\"token qualifier\" >Drop</span><span class=\"token qualifier\" >Target</span> <span class=\"token punctuation\" >}</span> from <span class=\"token string\" >'react-dnd'</span><span class=\"token punctuation\" >;</span>\n\n<span class=\"token comment\" spellcheck=\"true\">// Drag sources and drop targets only interact\n</span><span class=\"token comment\" spellcheck=\"true\">// if they have the same string type.\n</span><span class=\"token comment\" spellcheck=\"true\">// You want to keep types in a separate file with\n</span><span class=\"token comment\" spellcheck=\"true\">// the rest of your app's constants.\n</span><span class=\"token keyword\" >const</span> <span class=\"token qualifier\" >Types</span> <span class=\"token operator\" >=</span> <span class=\"token punctuation\" >{</span>\n  CHESSPIECE<span class=\"token punctuation\" >:</span> <span class=\"token string\" >'chesspiece'</span>\n<span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >;</span>\n\n<span class=\"token comment\" spellcheck=\"true\">/**\n * Specifies the drop target contract.\n * All methods are optional.\n */</span>\n<span class=\"token keyword\" >const</span> chessSquareTarget <span class=\"token operator\" >=</span> <span class=\"token punctuation\" >{</span>\n  <span class=\"token function\" >canDrop<span class=\"token punctuation\" >(</span></span>props<span class=\"token punctuation\" >,</span> monitor<span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n    <span class=\"token comment\" spellcheck=\"true\">// You can disallow drop based on props or item\n</span>    <span class=\"token keyword\" >const</span> item <span class=\"token operator\" >=</span> monitor<span class=\"token punctuation\" >.</span><span class=\"token function\" >getItem<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n    <span class=\"token keyword\" >return</span> <span class=\"token function\" >canMakeChessMove<span class=\"token punctuation\" >(</span></span>item<span class=\"token punctuation\" >.</span>fromPosition<span class=\"token punctuation\" >,</span> props<span class=\"token punctuation\" >.</span>position<span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n  <span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >,</span>\n\n  <span class=\"token function\" >hover<span class=\"token punctuation\" >(</span></span>props<span class=\"token punctuation\" >,</span> monitor<span class=\"token punctuation\" >,</span> component<span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n    <span class=\"token comment\" spellcheck=\"true\">// This is fired very often and lets you perform side effects\n</span>    <span class=\"token comment\" spellcheck=\"true\">// in response to the hover. You can't handle enter and leave\n</span>    <span class=\"token comment\" spellcheck=\"true\">// here—if you need them, put monitor.isOver() into collect() so you\n</span>    <span class=\"token comment\" spellcheck=\"true\">// can just use componentWillReceiveProps() to handle enter/leave.\n</span>\n    <span class=\"token comment\" spellcheck=\"true\">// You can access the coordinates if you need them\n</span>    <span class=\"token keyword\" >const</span> clientOffset <span class=\"token operator\" >=</span> monitor<span class=\"token punctuation\" >.</span><span class=\"token function\" >getClientOffset<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n    <span class=\"token keyword\" >const</span> componentRect <span class=\"token operator\" >=</span> <span class=\"token function\" >findDOMNode<span class=\"token punctuation\" >(</span></span>component<span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >.</span><span class=\"token function\" >getBoundingClientRect<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n\n    <span class=\"token comment\" spellcheck=\"true\">// You can check whether we're over a nested drop target\n</span>    <span class=\"token keyword\" >const</span> isJustOverThisOne <span class=\"token operator\" >=</span> monitor<span class=\"token punctuation\" >.</span><span class=\"token function\" >isOver<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >{</span> shallow<span class=\"token punctuation\" >:</span> <span class=\"token primitive\" >true</span> <span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n\n    <span class=\"token comment\" spellcheck=\"true\">// You will receive hover() even for items for which canDrop() is false\n</span>    <span class=\"token keyword\" >const</span> canDrop <span class=\"token operator\" >=</span> monitor<span class=\"token punctuation\" >.</span><span class=\"token function\" >canDrop<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n  <span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >,</span>\n\n  <span class=\"token function\" >drop<span class=\"token punctuation\" >(</span></span>props<span class=\"token punctuation\" >,</span> monitor<span class=\"token punctuation\" >,</span> component<span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n    <span class=\"token block-keyword\" >if</span> <span class=\"token punctuation\" >(</span>monitor<span class=\"token punctuation\" >.</span><span class=\"token function\" >didDrop<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n      <span class=\"token comment\" spellcheck=\"true\">// If you want, you can check whether some nested\n</span>      <span class=\"token comment\" spellcheck=\"true\">// target already handled drop\n</span>      <span class=\"token keyword\" >return</span><span class=\"token punctuation\" >;</span>\n    <span class=\"token punctuation\" >}</span>\n\n    <span class=\"token comment\" spellcheck=\"true\">// Obtain the dragged item\n</span>    <span class=\"token keyword\" >const</span> item <span class=\"token operator\" >=</span> monitor<span class=\"token punctuation\" >.</span><span class=\"token function\" >getItem<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n\n    <span class=\"token comment\" spellcheck=\"true\">// You can do something with it\n</span>    <span class=\"token qualifier\" >Chess</span><span class=\"token qualifier\" >Actions</span><span class=\"token punctuation\" >.</span><span class=\"token function\" >movePiece<span class=\"token punctuation\" >(</span></span>item<span class=\"token punctuation\" >.</span>fromPosition<span class=\"token punctuation\" >,</span> props<span class=\"token punctuation\" >.</span>position<span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n\n    <span class=\"token comment\" spellcheck=\"true\">// You can also do nothing and return a drop result,\n</span>    <span class=\"token comment\" spellcheck=\"true\">// which will be available as monitor.getDropResult()\n</span>    <span class=\"token comment\" spellcheck=\"true\">// in the drag source's endDrag() method\n</span>    <span class=\"token keyword\" >return</span> <span class=\"token punctuation\" >{</span> moved<span class=\"token punctuation\" >:</span> <span class=\"token primitive\" >true</span> <span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >;</span>\n  <span class=\"token punctuation\" >}</span>\n<span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >;</span>\n\n@<span class=\"token function\" >DropTarget<span class=\"token punctuation\" >(</span></span><span class=\"token qualifier\" >Types</span><span class=\"token punctuation\" >.</span>CHESSPIECE<span class=\"token punctuation\" >,</span> chessSquareTarget<span class=\"token punctuation\" >,</span> <span class=\"token punctuation\" >(</span>connect<span class=\"token punctuation\" >,</span> monitor<span class=\"token punctuation\" >)</span> <span class=\"token operator\" >=</span><span class=\"token operator\" >></span> <span class=\"token punctuation\" >(</span><span class=\"token punctuation\" >{</span>\n  <span class=\"token comment\" spellcheck=\"true\">// Call this function inside render()\n</span>  <span class=\"token comment\" spellcheck=\"true\">// to let React DnD handle the drag events:\n</span>  connectDropTarget<span class=\"token punctuation\" >:</span> connect<span class=\"token punctuation\" >.</span><span class=\"token function\" >dropTarget<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >,</span>\n  <span class=\"token comment\" spellcheck=\"true\">// You can ask the monitor about the current drag state:\n</span>  isOver<span class=\"token punctuation\" >:</span> monitor<span class=\"token punctuation\" >.</span><span class=\"token function\" >isOver<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >,</span>\n  isOverCurrent<span class=\"token punctuation\" >:</span> monitor<span class=\"token punctuation\" >.</span><span class=\"token function\" >isOver<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >{</span> shallow<span class=\"token punctuation\" >:</span> <span class=\"token primitive\" >true</span> <span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >,</span>\n  canDrop<span class=\"token punctuation\" >:</span> monitor<span class=\"token punctuation\" >.</span><span class=\"token function\" >canDrop<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >,</span>\n  itemType<span class=\"token punctuation\" >:</span> monitor<span class=\"token punctuation\" >.</span><span class=\"token function\" >getItemType<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span>\n<span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >)</span>\n<span class=\"token keyword\" >export</span> <span class=\"token keyword\" >default</span> <span class=\"token keyword\" >class</span> <span class=\"token class-name\" >ChessSquare</span> <span class=\"token punctuation\" >{</span>\n  <span class=\"token function\" >componentWillReceiveProps<span class=\"token punctuation\" >(</span></span>nextProps<span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n    <span class=\"token block-keyword\" >if</span> <span class=\"token punctuation\" >(</span><span class=\"token operator\" >!</span><span class=\"token var\" >this</span><span class=\"token punctuation\" >.</span>props<span class=\"token punctuation\" >.</span>isOver <span class=\"token operator\" >&amp;&amp;</span> nextProps<span class=\"token punctuation\" >.</span>isOver<span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n      <span class=\"token comment\" spellcheck=\"true\">// You can use this as enter handler\n</span>    <span class=\"token punctuation\" >}</span>\n\n    <span class=\"token block-keyword\" >if</span> <span class=\"token punctuation\" >(</span><span class=\"token var\" >this</span><span class=\"token punctuation\" >.</span>props<span class=\"token punctuation\" >.</span>isOver <span class=\"token operator\" >&amp;&amp;</span> <span class=\"token operator\" >!</span>nextProps<span class=\"token punctuation\" >.</span>isOver<span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n      <span class=\"token comment\" spellcheck=\"true\">// You can use this as leave handler\n</span>    <span class=\"token punctuation\" >}</span>\n\n    <span class=\"token block-keyword\" >if</span> <span class=\"token punctuation\" >(</span><span class=\"token var\" >this</span><span class=\"token punctuation\" >.</span>props<span class=\"token punctuation\" >.</span>isOverCurrent <span class=\"token operator\" >&amp;&amp;</span> <span class=\"token operator\" >!</span>nextProps<span class=\"token punctuation\" >.</span>isOverCurrent<span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n      <span class=\"token comment\" spellcheck=\"true\">// You can be more specific and track enter/leave\n</span>      <span class=\"token comment\" spellcheck=\"true\">// shallowly, not including nested targets\n</span>    <span class=\"token punctuation\" >}</span>\n  <span class=\"token punctuation\" >}</span>\n\n  <span class=\"token function\" >render<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n    <span class=\"token comment\" spellcheck=\"true\">// Your component receives its own props as usual\n</span>    <span class=\"token keyword\" >const</span> <span class=\"token punctuation\" >{</span> position <span class=\"token punctuation\" >}</span> <span class=\"token operator\" >=</span> <span class=\"token var\" >this</span><span class=\"token punctuation\" >.</span>props<span class=\"token punctuation\" >;</span>\n\n    <span class=\"token comment\" spellcheck=\"true\">// These props are injected by React DnD,\n</span>    <span class=\"token comment\" spellcheck=\"true\">// as defined by your `collect` function above:\n</span>    <span class=\"token keyword\" >const</span> <span class=\"token punctuation\" >{</span> isOver<span class=\"token punctuation\" >,</span> canDrop<span class=\"token punctuation\" >,</span> connectDropTarget <span class=\"token punctuation\" >}</span> <span class=\"token operator\" >=</span> <span class=\"token var\" >this</span><span class=\"token punctuation\" >.</span>props<span class=\"token punctuation\" >;</span>\n\n    <span class=\"token keyword\" >return</span> <span class=\"token function\" >connectDropTarget<span class=\"token punctuation\" >(</span></span>\n      <span class=\"token operator\" >&lt;</span>div className<span class=\"token operator\" >=</span><span class=\"token string\" >'Cell'</span><span class=\"token operator\" >></span>\n        <span class=\"token punctuation\" >{</span>isOver <span class=\"token operator\" >&amp;&amp;</span> canDrop <span class=\"token operator\" >&amp;&amp;</span> <span class=\"token operator\" >&lt;</span>div <span class=\"token keyword\" >class</span><span class=\"token operator\" >=</span><span class=\"token string\" >'green'</span> <span class=\"token operator\" >/</span><span class=\"token operator\" >></span><span class=\"token punctuation\" >}</span>\n        <span class=\"token punctuation\" >{</span><span class=\"token operator\" >!</span>isOver <span class=\"token operator\" >&amp;&amp;</span> canDrop <span class=\"token operator\" >&amp;&amp;</span> <span class=\"token operator\" >&lt;</span>div <span class=\"token keyword\" >class</span><span class=\"token operator\" >=</span><span class=\"token string\" >'yellow'</span> <span class=\"token operator\" >/</span><span class=\"token operator\" >></span><span class=\"token punctuation\" >}</span>\n        <span class=\"token punctuation\" >{</span>isOver <span class=\"token operator\" >&amp;&amp;</span> <span class=\"token operator\" >!</span>canDrop <span class=\"token operator\" >&amp;&amp;</span> <span class=\"token operator\" >&lt;</span>div <span class=\"token keyword\" >class</span><span class=\"token operator\" >=</span><span class=\"token string\" >'red'</span> <span class=\"token operator\" >/</span><span class=\"token operator\" >></span><span class=\"token punctuation\" >}</span>\n      <span class=\"token operator\" >&lt;</span><span class=\"token operator\" >/</span>div<span class=\"token operator\" >></span>\n    <span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n  <span class=\"token punctuation\" >}</span>\n<span class=\"token punctuation\" >}</span></code><hr/>\n<h2>Type Definitions<a id=\"type-definitions\">&nbsp;</a></h2><code class=\"codeBlock\">type <span class=\"token qualifier\" >React</span><span class=\"token qualifier\" >Props</span> <span class=\"token operator\" >=</span> <span class=\"token qualifier\" >Object</span><span class=\"token punctuation\" >;</span>\n\ntype <span class=\"token qualifier\" >Drop</span><span class=\"token qualifier\" >Target</span><span class=\"token qualifier\" >Types</span> <span class=\"token operator\" >=</span>\n  string <span class=\"token operator\" >|</span>\n  symbol <span class=\"token operator\" >|</span>\n  <span class=\"token qualifier\" >Array</span><span class=\"token operator\" >&lt;</span>string <span class=\"token operator\" >|</span> symbol<span class=\"token operator\" >></span> <span class=\"token operator\" >|</span>\n  <span class=\"token punctuation\" >(</span>props<span class=\"token punctuation\" >:</span> <span class=\"token qualifier\" >React</span><span class=\"token qualifier\" >Props</span><span class=\"token punctuation\" >)</span> <span class=\"token operator\" >=</span><span class=\"token operator\" >></span> string <span class=\"token operator\" >|</span> symbol <span class=\"token operator\" >|</span> <span class=\"token qualifier\" >Array</span><span class=\"token operator\" >&lt;</span>string <span class=\"token operator\" >|</span> symbol<span class=\"token operator\" >></span><span class=\"token punctuation\" >;</span>\n\ntype <span class=\"token qualifier\" >Drop</span><span class=\"token qualifier\" >Target</span><span class=\"token qualifier\" >Spec</span> <span class=\"token operator\" >=</span> <span class=\"token punctuation\" >{</span>\n  drop<span class=\"token punctuation\" >:</span> <span class=\"token operator\" >?</span><span class=\"token punctuation\" >(</span>\n    props<span class=\"token punctuation\" >:</span> <span class=\"token qualifier\" >React</span><span class=\"token qualifier\" >Props</span><span class=\"token punctuation\" >,</span>\n    monitor<span class=\"token punctuation\" >:</span> <span class=\"token qualifier\" >Drop</span><span class=\"token qualifier\" >Target</span><span class=\"token qualifier\" >Monitor</span><span class=\"token punctuation\" >,</span>\n    component<span class=\"token punctuation\" >:</span> <span class=\"token qualifier\" >Your</span><span class=\"token qualifier\" >React</span><span class=\"token qualifier\" >Class</span>\n  <span class=\"token punctuation\" >)</span> <span class=\"token operator\" >=</span><span class=\"token operator\" >></span> <span class=\"token operator\" >?</span><span class=\"token qualifier\" >Object</span><span class=\"token punctuation\" >;</span>\n\n  hover<span class=\"token punctuation\" >:</span> <span class=\"token operator\" >?</span><span class=\"token punctuation\" >(</span>\n    props<span class=\"token punctuation\" >:</span> <span class=\"token qualifier\" >React</span><span class=\"token qualifier\" >Props</span><span class=\"token punctuation\" >,</span>\n    monitor<span class=\"token punctuation\" >:</span> <span class=\"token qualifier\" >Drop</span><span class=\"token qualifier\" >Target</span><span class=\"token punctuation\" >,</span>\n    component<span class=\"token punctuation\" >:</span> <span class=\"token operator\" >?</span><span class=\"token qualifier\" >Your</span><span class=\"token qualifier\" >React</span><span class=\"token qualifier\" >Class</span>\n  <span class=\"token punctuation\" >)</span> <span class=\"token operator\" >=</span><span class=\"token operator\" >></span> <span class=\"token keyword\" >void</span><span class=\"token punctuation\" >;</span>\n\n  canDrop<span class=\"token punctuation\" >:</span> <span class=\"token operator\" >?</span><span class=\"token punctuation\" >(</span>\n    props<span class=\"token punctuation\" >:</span> <span class=\"token qualifier\" >React</span><span class=\"token qualifier\" >Props</span><span class=\"token punctuation\" >,</span>\n    monitor<span class=\"token punctuation\" >:</span> <span class=\"token qualifier\" >Drop</span><span class=\"token qualifier\" >Target</span>\n  <span class=\"token punctuation\" >)</span> <span class=\"token operator\" >=</span><span class=\"token operator\" >></span> boolean<span class=\"token punctuation\" >;</span>\n<span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >;</span>\n\ntype <span class=\"token qualifier\" >Drop</span><span class=\"token qualifier\" >Target</span><span class=\"token qualifier\" >Options</span> <span class=\"token operator\" >=</span> <span class=\"token punctuation\" >{</span>\n  arePropsEqual<span class=\"token punctuation\" >:</span> <span class=\"token operator\" >?</span><span class=\"token punctuation\" >(</span><span class=\"token qualifier\" >Object</span><span class=\"token punctuation\" >,</span> <span class=\"token qualifier\" >Object</span><span class=\"token punctuation\" >)</span> <span class=\"token operator\" >=</span><span class=\"token operator\" >></span> boolean\n<span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >;</span>\n\n<span class=\"token qualifier\" >Drop</span><span class=\"token qualifier\" >Target</span><span class=\"token punctuation\" >:</span> <span class=\"token punctuation\" >(</span>\n  type<span class=\"token punctuation\" >:</span> <span class=\"token qualifier\" >Drop</span><span class=\"token qualifier\" >Target</span><span class=\"token qualifier\" >Types</span><span class=\"token punctuation\" >,</span>\n  spec<span class=\"token punctuation\" >:</span> <span class=\"token qualifier\" >Drop</span><span class=\"token qualifier\" >Target</span><span class=\"token qualifier\" >Spec</span><span class=\"token punctuation\" >,</span>\n  collect<span class=\"token punctuation\" >:</span> <span class=\"token punctuation\" >(</span>\n    connect<span class=\"token punctuation\" >:</span> <span class=\"token qualifier\" >Drop</span><span class=\"token qualifier\" >Target</span><span class=\"token qualifier\" >Connector</span><span class=\"token punctuation\" >,</span>\n    monitor<span class=\"token punctuation\" >:</span> <span class=\"token qualifier\" >Drop</span><span class=\"token qualifier\" >Target</span><span class=\"token qualifier\" >Monitor</span>\n  <span class=\"token punctuation\" >)</span> <span class=\"token operator\" >=</span><span class=\"token operator\" >></span> <span class=\"token qualifier\" >Object</span><span class=\"token punctuation\" >,</span>\n  options<span class=\"token punctuation\" >:</span> <span class=\"token operator\" >?</span><span class=\"token qualifier\" >Drop</span><span class=\"token qualifier\" >Target</span><span class=\"token qualifier\" >Options</span>\n<span class=\"token punctuation\" >)</span> <span class=\"token operator\" >=</span><span class=\"token operator\" >></span> <span class=\"token punctuation\" >(</span>\n  component<span class=\"token punctuation\" >:</span> <span class=\"token qualifier\" >Your</span><span class=\"token qualifier\" >React</span><span class=\"token qualifier\" >Class</span>\n<span class=\"token punctuation\" >)</span> <span class=\"token operator\" >=</span><span class=\"token operator\" >></span> <span class=\"token qualifier\" >React</span><span class=\"token qualifier\" >Class</span></code>";

/***/ },
/* 338 */
/***/ function(module, exports) {

	module.exports = "<p><em>New to React DnD? <a href=\"docs-overview.html\">Read the overview</a> before jumping into the docs.</em></p>\n<h1>DragSourceConnector<a id=\"dragsourceconnector\">&nbsp;</a></h1><p><code>DragSourceConnector</code> is an object passed to a collecting function of the <a href=\"docs-drag-source.html\"><code>DragSource</code></a>. Its methods return functions that let you assign the roles to your component&#39;s DOM nodes.</p>\n<h3>Methods<a id=\"methods\">&nbsp;</a></h3><p>Call the <code>DragSourceConnector</code> methods inside your <em>collecting function</em>. This will pass the returned functions to your component as props. You can then use them inside <code>render</code> or <code>componentDidMount</code> to indicate the DOM node roles. Internally they work by attaching a <a href=\"https://facebook.github.io/react/docs/more-about-refs.html#the-ref-callback-attribute\">callback ref</a> to the React elements you give them. These callbacks connect the DOM nodes of your component to the chosen DnD backend.</p>\n<ul>\n<li><p><strong><code>dragSource() =&gt; (elementOrNode, options?)</code></strong>: Returns a function that must be used inside the component to assign the drag source role to a node. By returning <code>{ connectDragSource: connect.dragSource() }</code> from your collecting function, you can mark any React element as the draggable node. To do that, replace any <code>element</code> with <code>this.props.connectDragSource(element)</code> inside the <code>render</code> function.</p>\n</li>\n<li><p><strong><code>dragPreview() =&gt; (elementOrNode, options?)</code></strong>: Optional. Returns a function that may be used inside the component to assign the drag preview role to a node. By returning <code>{ connectDragPreview: connect.dragPreview() }</code> from your collecting function, you can mark any React element as the drag preview node. To do that, replace any <code>element</code> with <code>this.props.connectDragPreview(element)</code> inside the <code>render</code> function. The drag preview is the node that will be screenshotted by the <a href=\"docs-html5-backend.html\"><code>HTML5</code> backend</a> when the drag begins. For example, if you want to make something draggable by a small custom handle, you can mark this handle as the <code>dragSource()</code>, but also mark an outer, larger component node as the <code>dragPreview()</code>. Thus the larger drag preview appears on the screenshot, but only the smaller drag source is actually draggable. Another possible customization is passing an <a href=\"https://developer.mozilla.org/en-US/docs/Web/API/HTMLImageElement/Image\"><code>Image</code></a> instance to <code>dragPreview</code> from a lifecycle method like <code>componentDidMount</code>. This lets you use the actual images for drag previews. (Note that IE does not support this customization). See the example code below for the different usage examples.</p>\n</li>\n</ul>\n<h3>Method Options<a id=\"method-options\">&nbsp;</a></h3><p>The functions returned by the connector methods also accept options. They need to be passed <em>inside the component</em>, for example, <code>this.props.connectDragSource(&lt;div&gt;...&lt;/div&gt;, { dropEffect: &#39;copy&#39; })</code>. The options described below are supported by the <a href=\"./docs-html5-backend.html\">HTML5 backend</a>, but may not be supported by the third-party or custom backends.</p>\n<h4><strong>Options for <code>dragSource</code></strong><a id=\"-strong-options-for-code-dragsource-code-strong-\">&nbsp;</a></h4><ul>\n<li><code>dropEffect</code>: Optional. A string. By default, <code>&#39;move&#39;</code>. In the browsers that support this feature, specifying <code>&#39;copy&#39;</code> shows a special “copying” cursor, while <code>&#39;move&#39;</code> corresponds to the “move” cursor. You might want to use this option to provide a hint to the user about whether an action is destructive.</li>\n</ul>\n<h4><strong>Options for <code>dragPreview</code></strong><a id=\"-strong-options-for-code-dragpreview-code-strong-\">&nbsp;</a></h4><ul>\n<li><p><code>captureDraggingState</code>: Optional. A boolean. By default, <code>false</code>. If <code>true</code>, the component will learn that it is being dragged immediately as the drag starts instead of the next tick. This means that the screenshotting would occur with <code>monitor.isDragging()</code> already being <code>true</code>, and if you apply any styling like a decreased opacity to the dragged element, this styling will also be reflected on the screenshot. This is rarely desirable, so <code>false</code> is a sensible default. However, you might want to set it to <code>true</code> in rare cases, such as if you want to make the custom drag layers work in IE and you need to hide the original element without resorting to an empty drag preview which IE doesn&#39;t support.</p>\n</li>\n<li><p><code>anchorX</code>: Optional. A number betwen <code>0</code> and <code>1</code>. By default, <code>0.5</code>. Specifies how the offset relative to the drag source node is translated into the the horizontal offset of the drag preview when their sizes don&#39;t match. <code>0</code> means “dock the preview to the left”, <code>0.5</code> means “interpolate linearly” and <code>1</code> means “dock the preview to the right”.</p>\n</li>\n<li><p><code>anchorY</code>: Optional. A number betwen <code>0</code> and <code>1</code>. By default, <code>0.5</code>. Specifies how the offset relative to the drag source node is translated into the the vertical offset of the drag preview when their sizes don&#39;t match. <code>0</code> means “dock the preview to the top, <code>0.5</code> means “interpolate linearly” and <code>1</code> means “dock the preview to the bottom.</p>\n</li>\n</ul>\n<h3>Example<a id=\"example\">&nbsp;</a></h3><p>Check out <a href=\"docs-tutorial.html\">the tutorial</a> for more real examples!</p>\n<hr/>\n<code class=\"codeBlock\"><span class=\"token keyword\" >var</span> <span class=\"token qualifier\" >React</span> <span class=\"token operator\" >=</span> <span class=\"token function\" >require<span class=\"token punctuation\" >(</span></span><span class=\"token string\" >'react'</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n<span class=\"token keyword\" >var</span> <span class=\"token qualifier\" >Drag</span><span class=\"token qualifier\" >Source</span> <span class=\"token operator\" >=</span> <span class=\"token function\" >require<span class=\"token punctuation\" >(</span></span><span class=\"token string\" >'react-dnd'</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >.</span><span class=\"token qualifier\" >Drag</span><span class=\"token qualifier\" >Source</span><span class=\"token punctuation\" >;</span>\n\n<span class=\"token comment\" spellcheck=\"true\">/* ... */</span>\n\n<span class=\"token block-keyword\" >function</span> <span class=\"token function\" >collect<span class=\"token punctuation\" >(</span></span>connect<span class=\"token punctuation\" >,</span> monitor<span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n  <span class=\"token keyword\" >return</span> <span class=\"token punctuation\" >{</span>\n    connectDragSource<span class=\"token punctuation\" >:</span> connect<span class=\"token punctuation\" >.</span><span class=\"token function\" >dragSource<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >,</span>\n    connectDragPreview<span class=\"token punctuation\" >:</span> connect<span class=\"token punctuation\" >.</span><span class=\"token function\" >dragPreview<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span>\n  <span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >;</span>\n<span class=\"token punctuation\" >}</span>\n\n<span class=\"token keyword\" >var</span> <span class=\"token qualifier\" >Component</span><span class=\"token qualifier\" >With</span><span class=\"token qualifier\" >Copy</span><span class=\"token qualifier\" >Effect</span> <span class=\"token operator\" >=</span> <span class=\"token qualifier\" >React</span><span class=\"token punctuation\" >.</span><span class=\"token function\" >createClass<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >{</span>\n  render<span class=\"token punctuation\" >:</span> <span class=\"token block-keyword\" >function</span> <span class=\"token punctuation\" >(</span><span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n    <span class=\"token keyword\" >var</span> connectDragSource <span class=\"token operator\" >=</span> <span class=\"token var\" >this</span><span class=\"token punctuation\" >.</span>props<span class=\"token punctuation\" >.</span>connectDragSource<span class=\"token punctuation\" >;</span>\n\n    <span class=\"token keyword\" >return</span> <span class=\"token function\" >connectDragSource<span class=\"token punctuation\" >(</span></span>\n      <span class=\"token operator\" >&lt;</span>div<span class=\"token operator\" >></span>\n        <span class=\"token qualifier\" >This</span> div shows a plus icon <span class=\"token keyword\" >in</span> some browsers<span class=\"token punctuation\" >.</span>\n      <span class=\"token operator\" >&lt;</span><span class=\"token operator\" >/</span>div<span class=\"token operator\" >></span><span class=\"token punctuation\" >,</span>\n      <span class=\"token punctuation\" >{</span> dropEffect<span class=\"token punctuation\" >:</span> <span class=\"token string\" >'copy'</span> <span class=\"token punctuation\" >}</span>\n    <span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n  <span class=\"token punctuation\" >}</span>\n<span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n<span class=\"token qualifier\" >Component</span><span class=\"token qualifier\" >With</span><span class=\"token qualifier\" >Copy</span><span class=\"token qualifier\" >Effect</span> <span class=\"token operator\" >=</span> <span class=\"token function\" >DragSource<span class=\"token punctuation\" >(</span></span><span class=\"token comment\" spellcheck=\"true\">/* ... */</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >(</span><span class=\"token qualifier\" >Component</span><span class=\"token qualifier\" >With</span><span class=\"token qualifier\" >Copy</span><span class=\"token qualifier\" >Effect</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n\n<span class=\"token keyword\" >var</span> <span class=\"token qualifier\" >Component</span><span class=\"token qualifier\" >With</span><span class=\"token qualifier\" >Handle</span> <span class=\"token operator\" >=</span> <span class=\"token qualifier\" >React</span><span class=\"token punctuation\" >.</span><span class=\"token function\" >createClass<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >{</span>\n  render<span class=\"token punctuation\" >:</span> <span class=\"token block-keyword\" >function</span> <span class=\"token punctuation\" >(</span><span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n    <span class=\"token keyword\" >var</span> connectDragSource <span class=\"token operator\" >=</span> <span class=\"token var\" >this</span><span class=\"token punctuation\" >.</span>props<span class=\"token punctuation\" >.</span>connectDragSource<span class=\"token punctuation\" >;</span>\n    <span class=\"token keyword\" >var</span> connectDragPreview <span class=\"token operator\" >=</span> <span class=\"token var\" >this</span><span class=\"token punctuation\" >.</span>props<span class=\"token punctuation\" >.</span>connectDragPreview<span class=\"token punctuation\" >;</span>\n\n    <span class=\"token keyword\" >return</span> <span class=\"token function\" >connectDragPreview<span class=\"token punctuation\" >(</span></span>\n      <span class=\"token operator\" >&lt;</span>div<span class=\"token operator\" >></span>\n        <span class=\"token qualifier\" >This</span> div is draggable by a handle<span class=\"token operator\" >!</span>\n        <span class=\"token punctuation\" >{</span><span class=\"token function\" >connectDragSource<span class=\"token punctuation\" >(</span></span>\n          <span class=\"token operator\" >&lt;</span>div<span class=\"token operator\" >></span>drag me<span class=\"token operator\" >&lt;</span><span class=\"token operator\" >/</span>div<span class=\"token operator\" >></span>\n        <span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >}</span>\n      <span class=\"token operator\" >&lt;</span><span class=\"token operator\" >/</span>div<span class=\"token operator\" >></span>\n    <span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n  <span class=\"token punctuation\" >}</span>\n<span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n<span class=\"token qualifier\" >Component</span><span class=\"token qualifier\" >With</span><span class=\"token qualifier\" >Handle</span> <span class=\"token operator\" >=</span> <span class=\"token function\" >DragSource<span class=\"token punctuation\" >(</span></span><span class=\"token comment\" spellcheck=\"true\">/* ... */</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >(</span><span class=\"token qualifier\" >Component</span><span class=\"token qualifier\" >With</span><span class=\"token qualifier\" >Handle</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n\n<span class=\"token keyword\" >var</span> <span class=\"token qualifier\" >Component</span><span class=\"token qualifier\" >With</span><span class=\"token qualifier\" >Image</span><span class=\"token qualifier\" >Preview</span> <span class=\"token operator\" >=</span> <span class=\"token qualifier\" >React</span><span class=\"token punctuation\" >.</span><span class=\"token function\" >createClass<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >{</span>\n  componentDidMount<span class=\"token punctuation\" >:</span> <span class=\"token block-keyword\" >function</span> <span class=\"token punctuation\" >(</span><span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n    <span class=\"token keyword\" >var</span> connectDragPreview <span class=\"token operator\" >=</span> <span class=\"token var\" >this</span><span class=\"token punctuation\" >.</span>props<span class=\"token punctuation\" >.</span>connectDragPreview<span class=\"token punctuation\" >;</span>\n\n    <span class=\"token keyword\" >var</span> img <span class=\"token operator\" >=</span> <span class=\"token keyword\" >new</span> <span class=\"token class-name\" >Image</span><span class=\"token punctuation\" >(</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n    img<span class=\"token punctuation\" >.</span>src <span class=\"token operator\" >=</span> <span class=\"token string\" >'http://mysite.com/image.jpg'</span><span class=\"token punctuation\" >;</span>\n    img<span class=\"token punctuation\" >.</span>onload <span class=\"token operator\" >=</span> <span class=\"token block-keyword\" >function</span> <span class=\"token punctuation\" >(</span><span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n      <span class=\"token function\" >connectDragPreview<span class=\"token punctuation\" >(</span></span>img<span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n    <span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >;</span>\n  <span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >,</span>\n\n  render<span class=\"token punctuation\" >:</span> <span class=\"token block-keyword\" >function</span> <span class=\"token punctuation\" >(</span><span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n    <span class=\"token keyword\" >var</span> connectDragSource <span class=\"token operator\" >=</span> <span class=\"token var\" >this</span><span class=\"token punctuation\" >.</span>props<span class=\"token punctuation\" >.</span>connectDragSource<span class=\"token punctuation\" >;</span>\n\n    <span class=\"token keyword\" >return</span> <span class=\"token function\" >connectDragSource<span class=\"token punctuation\" >(</span></span>\n      <span class=\"token operator\" >&lt;</span>div<span class=\"token operator\" >></span>\n        <span class=\"token qualifier\" >This</span> div shows an image when dragged<span class=\"token operator\" >!</span>\n      <span class=\"token operator\" >&lt;</span><span class=\"token operator\" >/</span>div<span class=\"token operator\" >></span>\n    <span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n  <span class=\"token punctuation\" >}</span>\n<span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n<span class=\"token qualifier\" >Component</span><span class=\"token qualifier\" >With</span><span class=\"token qualifier\" >Image</span><span class=\"token qualifier\" >Preview</span> <span class=\"token operator\" >=</span> <span class=\"token function\" >DragSource<span class=\"token punctuation\" >(</span></span><span class=\"token comment\" spellcheck=\"true\">/* ... */</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >(</span><span class=\"token qualifier\" >Component</span><span class=\"token qualifier\" >With</span><span class=\"token qualifier\" >Image</span><span class=\"token qualifier\" >Preview</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span></code><hr/>\n<code class=\"codeBlock\"><span class=\"token keyword\" >import</span> <span class=\"token qualifier\" >React</span> from <span class=\"token string\" >'react'</span><span class=\"token punctuation\" >;</span>\n<span class=\"token keyword\" >import</span> <span class=\"token punctuation\" >{</span> <span class=\"token qualifier\" >Drag</span><span class=\"token qualifier\" >Source</span> <span class=\"token punctuation\" >}</span> from <span class=\"token string\" >'react-dnd'</span><span class=\"token punctuation\" >;</span>\n\n<span class=\"token comment\" spellcheck=\"true\">/* ... */</span>\n\n<span class=\"token block-keyword\" >function</span> <span class=\"token function\" >collect<span class=\"token punctuation\" >(</span></span>connect<span class=\"token punctuation\" >,</span> monitor<span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n  <span class=\"token keyword\" >return</span> <span class=\"token punctuation\" >{</span>\n    connectDragSource<span class=\"token punctuation\" >:</span> connect<span class=\"token punctuation\" >.</span><span class=\"token function\" >dragSource<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >,</span>\n    connectDragPreview<span class=\"token punctuation\" >:</span> connect<span class=\"token punctuation\" >.</span><span class=\"token function\" >dragPreview<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span>\n  <span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >;</span>\n<span class=\"token punctuation\" >}</span>\n\n<span class=\"token keyword\" >class</span> <span class=\"token class-name\" >ComponentWithCopyEffect</span> <span class=\"token punctuation\" >{</span>\n  <span class=\"token function\" >render<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n    <span class=\"token keyword\" >const</span> <span class=\"token punctuation\" >{</span> connectDragSource <span class=\"token punctuation\" >}</span> <span class=\"token operator\" >=</span> <span class=\"token var\" >this</span><span class=\"token punctuation\" >.</span>props<span class=\"token punctuation\" >;</span>\n\n    <span class=\"token keyword\" >return</span> <span class=\"token function\" >connectDragSource<span class=\"token punctuation\" >(</span></span>\n      <span class=\"token operator\" >&lt;</span>div<span class=\"token operator\" >></span>\n        <span class=\"token qualifier\" >This</span> div shows a plus icon <span class=\"token keyword\" >in</span> some browsers<span class=\"token punctuation\" >.</span>\n      <span class=\"token operator\" >&lt;</span><span class=\"token operator\" >/</span>div<span class=\"token operator\" >></span><span class=\"token punctuation\" >,</span>\n      <span class=\"token punctuation\" >{</span> dropEffect<span class=\"token punctuation\" >:</span> <span class=\"token string\" >'copy'</span> <span class=\"token punctuation\" >}</span>\n    <span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n  <span class=\"token punctuation\" >}</span>\n<span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n<span class=\"token qualifier\" >Component</span><span class=\"token qualifier\" >With</span><span class=\"token qualifier\" >Copy</span><span class=\"token qualifier\" >Effect</span> <span class=\"token operator\" >=</span> <span class=\"token function\" >DragSource<span class=\"token punctuation\" >(</span></span><span class=\"token comment\" spellcheck=\"true\">/* ... */</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >(</span><span class=\"token qualifier\" >Component</span><span class=\"token qualifier\" >With</span><span class=\"token qualifier\" >Copy</span><span class=\"token qualifier\" >Effect</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n\n<span class=\"token keyword\" >class</span> <span class=\"token class-name\" >ComponentWithHandle</span> <span class=\"token punctuation\" >{</span>\n  <span class=\"token function\" >render<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n    <span class=\"token keyword\" >const</span> <span class=\"token punctuation\" >{</span> connectDragSource<span class=\"token punctuation\" >,</span> connectDragPreview <span class=\"token punctuation\" >}</span> <span class=\"token operator\" >=</span> <span class=\"token var\" >this</span><span class=\"token punctuation\" >.</span>props<span class=\"token punctuation\" >;</span>\n\n    <span class=\"token keyword\" >return</span> <span class=\"token function\" >connectDragPreview<span class=\"token punctuation\" >(</span></span>\n      <span class=\"token operator\" >&lt;</span>div<span class=\"token operator\" >></span>\n        <span class=\"token qualifier\" >This</span> div is draggable by a handle<span class=\"token operator\" >!</span>\n        <span class=\"token punctuation\" >{</span><span class=\"token function\" >connectDragSource<span class=\"token punctuation\" >(</span></span>\n          <span class=\"token operator\" >&lt;</span>div<span class=\"token operator\" >></span>drag me<span class=\"token operator\" >&lt;</span><span class=\"token operator\" >/</span>div<span class=\"token operator\" >></span>\n        <span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >}</span>\n      <span class=\"token operator\" >&lt;</span><span class=\"token operator\" >/</span>div<span class=\"token operator\" >></span>\n    <span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n  <span class=\"token punctuation\" >}</span>\n<span class=\"token punctuation\" >}</span>\n<span class=\"token qualifier\" >Component</span><span class=\"token qualifier\" >With</span><span class=\"token qualifier\" >Handle</span> <span class=\"token operator\" >=</span> <span class=\"token function\" >DragSource<span class=\"token punctuation\" >(</span></span><span class=\"token comment\" spellcheck=\"true\">/* ... */</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >(</span><span class=\"token qualifier\" >Component</span><span class=\"token qualifier\" >With</span><span class=\"token qualifier\" >Handle</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n\n<span class=\"token keyword\" >class</span> <span class=\"token class-name\" >ComponentWithImagePreview</span> <span class=\"token punctuation\" >{</span>\n  <span class=\"token function\" >componentDidMount<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n    <span class=\"token keyword\" >const</span> <span class=\"token punctuation\" >{</span> connectDragPreview <span class=\"token punctuation\" >}</span> <span class=\"token operator\" >=</span> <span class=\"token var\" >this</span><span class=\"token punctuation\" >.</span>props<span class=\"token punctuation\" >;</span>\n\n    <span class=\"token keyword\" >const</span> img <span class=\"token operator\" >=</span> <span class=\"token keyword\" >new</span> <span class=\"token class-name\" >Image</span><span class=\"token punctuation\" >(</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n    img<span class=\"token punctuation\" >.</span>src <span class=\"token operator\" >=</span> <span class=\"token string\" >'http://mysite.com/image.jpg'</span><span class=\"token punctuation\" >;</span>\n    img<span class=\"token punctuation\" >.</span>onload <span class=\"token operator\" >=</span> <span class=\"token punctuation\" >(</span><span class=\"token punctuation\" >)</span> <span class=\"token operator\" >=</span><span class=\"token operator\" >></span> <span class=\"token function\" >connectDragPreview<span class=\"token punctuation\" >(</span></span>img<span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n  <span class=\"token punctuation\" >}</span>\n\n  <span class=\"token function\" >render<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n    <span class=\"token keyword\" >const</span> <span class=\"token punctuation\" >{</span> connectDragSource <span class=\"token punctuation\" >}</span> <span class=\"token operator\" >=</span> <span class=\"token var\" >this</span><span class=\"token punctuation\" >.</span>props<span class=\"token punctuation\" >;</span>\n\n    <span class=\"token keyword\" >return</span> <span class=\"token function\" >connectDragSource<span class=\"token punctuation\" >(</span></span>\n      <span class=\"token operator\" >&lt;</span>div<span class=\"token operator\" >></span>\n        <span class=\"token qualifier\" >This</span> div shows an image when dragged<span class=\"token operator\" >!</span>\n      <span class=\"token operator\" >&lt;</span><span class=\"token operator\" >/</span>div<span class=\"token operator\" >></span>\n    <span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n  <span class=\"token punctuation\" >}</span>\n<span class=\"token punctuation\" >}</span>\n<span class=\"token qualifier\" >Component</span><span class=\"token qualifier\" >With</span><span class=\"token qualifier\" >Image</span><span class=\"token qualifier\" >Preview</span> <span class=\"token operator\" >=</span> <span class=\"token function\" >DragSource<span class=\"token punctuation\" >(</span></span><span class=\"token comment\" spellcheck=\"true\">/* ... */</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >(</span><span class=\"token qualifier\" >Component</span><span class=\"token qualifier\" >With</span><span class=\"token qualifier\" >Image</span><span class=\"token qualifier\" >Preview</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span></code><hr/>\n<code class=\"codeBlock\"><span class=\"token keyword\" >import</span> <span class=\"token qualifier\" >React</span> from <span class=\"token string\" >'react'</span><span class=\"token punctuation\" >;</span>\n<span class=\"token keyword\" >import</span> <span class=\"token punctuation\" >{</span> <span class=\"token qualifier\" >Drag</span><span class=\"token qualifier\" >Source</span> <span class=\"token punctuation\" >}</span> from <span class=\"token string\" >'react-dnd'</span><span class=\"token punctuation\" >;</span>\n\n<span class=\"token comment\" spellcheck=\"true\">/* ... */</span>\n\n<span class=\"token block-keyword\" >function</span> <span class=\"token function\" >collect<span class=\"token punctuation\" >(</span></span>connect<span class=\"token punctuation\" >,</span> monitor<span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n  <span class=\"token keyword\" >return</span> <span class=\"token punctuation\" >{</span>\n    connectDragSource<span class=\"token punctuation\" >:</span> connect<span class=\"token punctuation\" >.</span><span class=\"token function\" >dragSource<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >,</span>\n    connectDragPreview<span class=\"token punctuation\" >:</span> connect<span class=\"token punctuation\" >.</span><span class=\"token function\" >dragPreview<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span>\n  <span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >;</span>\n<span class=\"token punctuation\" >}</span>\n\n@<span class=\"token function\" >DragSource<span class=\"token punctuation\" >(</span></span><span class=\"token comment\" spellcheck=\"true\">/* ... */</span><span class=\"token punctuation\" >)</span>\n<span class=\"token keyword\" >class</span> <span class=\"token class-name\" >ComponentWithCopyEffect</span> <span class=\"token punctuation\" >{</span>\n  <span class=\"token function\" >render<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n    <span class=\"token keyword\" >const</span> <span class=\"token punctuation\" >{</span> connectDragSource <span class=\"token punctuation\" >}</span> <span class=\"token operator\" >=</span> <span class=\"token var\" >this</span><span class=\"token punctuation\" >.</span>props<span class=\"token punctuation\" >;</span>\n\n    <span class=\"token keyword\" >return</span> <span class=\"token function\" >connectDragSource<span class=\"token punctuation\" >(</span></span>\n      <span class=\"token operator\" >&lt;</span>div<span class=\"token operator\" >></span>\n        <span class=\"token qualifier\" >This</span> div shows a plus icon <span class=\"token keyword\" >in</span> some browsers<span class=\"token punctuation\" >.</span>\n      <span class=\"token operator\" >&lt;</span><span class=\"token operator\" >/</span>div<span class=\"token operator\" >></span><span class=\"token punctuation\" >,</span>\n      <span class=\"token punctuation\" >{</span> dropEffect<span class=\"token punctuation\" >:</span> <span class=\"token string\" >'copy'</span> <span class=\"token punctuation\" >}</span>\n    <span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n  <span class=\"token punctuation\" >}</span>\n<span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n\n@<span class=\"token function\" >DragSource<span class=\"token punctuation\" >(</span></span><span class=\"token comment\" spellcheck=\"true\">/* ... */</span><span class=\"token punctuation\" >)</span>\n<span class=\"token keyword\" >class</span> <span class=\"token class-name\" >ComponentWithHandle</span> <span class=\"token punctuation\" >{</span>\n  <span class=\"token function\" >render<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n    <span class=\"token keyword\" >const</span> <span class=\"token punctuation\" >{</span> connectDragSource<span class=\"token punctuation\" >,</span> connectDragPreview <span class=\"token punctuation\" >}</span> <span class=\"token operator\" >=</span> <span class=\"token var\" >this</span><span class=\"token punctuation\" >.</span>props<span class=\"token punctuation\" >;</span>\n\n    <span class=\"token keyword\" >return</span> <span class=\"token function\" >connectDragPreview<span class=\"token punctuation\" >(</span></span>\n      <span class=\"token operator\" >&lt;</span>div<span class=\"token operator\" >></span>\n        <span class=\"token qualifier\" >This</span> div is draggable by a handle<span class=\"token operator\" >!</span>\n        <span class=\"token punctuation\" >{</span><span class=\"token function\" >connectDragSource<span class=\"token punctuation\" >(</span></span>\n          <span class=\"token operator\" >&lt;</span>div<span class=\"token operator\" >></span>drag me<span class=\"token operator\" >&lt;</span><span class=\"token operator\" >/</span>div<span class=\"token operator\" >></span>\n        <span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >}</span>\n      <span class=\"token operator\" >&lt;</span><span class=\"token operator\" >/</span>div<span class=\"token operator\" >></span>\n    <span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n  <span class=\"token punctuation\" >}</span>\n<span class=\"token punctuation\" >}</span>\n\n@<span class=\"token function\" >DragSource<span class=\"token punctuation\" >(</span></span><span class=\"token comment\" spellcheck=\"true\">/* ... */</span><span class=\"token punctuation\" >)</span>\n<span class=\"token keyword\" >class</span> <span class=\"token class-name\" >ComponentWithImagePreview</span> <span class=\"token punctuation\" >{</span>\n  <span class=\"token function\" >componentDidMount<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n    <span class=\"token keyword\" >const</span> <span class=\"token punctuation\" >{</span> connectDragPreview <span class=\"token punctuation\" >}</span> <span class=\"token operator\" >=</span> <span class=\"token var\" >this</span><span class=\"token punctuation\" >.</span>props<span class=\"token punctuation\" >;</span>\n\n    <span class=\"token keyword\" >const</span> img <span class=\"token operator\" >=</span> <span class=\"token keyword\" >new</span> <span class=\"token class-name\" >Image</span><span class=\"token punctuation\" >(</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n    img<span class=\"token punctuation\" >.</span>src <span class=\"token operator\" >=</span> <span class=\"token string\" >'http://mysite.com/image.jpg'</span><span class=\"token punctuation\" >;</span>\n    img<span class=\"token punctuation\" >.</span>onload <span class=\"token operator\" >=</span> <span class=\"token punctuation\" >(</span><span class=\"token punctuation\" >)</span> <span class=\"token operator\" >=</span><span class=\"token operator\" >></span> <span class=\"token function\" >connectDragPreview<span class=\"token punctuation\" >(</span></span>img<span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n  <span class=\"token punctuation\" >}</span>\n\n  <span class=\"token function\" >render<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n    <span class=\"token keyword\" >const</span> <span class=\"token punctuation\" >{</span> connectDragSource <span class=\"token punctuation\" >}</span> <span class=\"token operator\" >=</span> <span class=\"token var\" >this</span><span class=\"token punctuation\" >.</span>props<span class=\"token punctuation\" >;</span>\n\n    <span class=\"token keyword\" >return</span> <span class=\"token function\" >connectDragSource<span class=\"token punctuation\" >(</span></span>\n      <span class=\"token operator\" >&lt;</span>div<span class=\"token operator\" >></span>\n        <span class=\"token qualifier\" >This</span> div shows an image when dragged<span class=\"token operator\" >!</span>\n      <span class=\"token operator\" >&lt;</span><span class=\"token operator\" >/</span>div<span class=\"token operator\" >></span>\n    <span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n  <span class=\"token punctuation\" >}</span>\n<span class=\"token punctuation\" >}</span></code><hr/>\n";

/***/ },
/* 339 */
/***/ function(module, exports) {

	module.exports = "<p><em>New to React DnD? <a href=\"docs-overview.html\">Read the overview</a> before jumping into the docs.</em></p>\n<h1>DropTargetConnector<a id=\"droptargetconnector\">&nbsp;</a></h1><p><code>DropTargetConnector</code> is an object passed to a collecting function of the <a href=\"docs-drop-target.html\"><code>DropTarget</code></a>. Its only method <code>dropTarget()</code> returns a function that lets you assign the drop target role to one of your component&#39;s DOM nodes.</p>\n<h3>Methods<a id=\"methods\">&nbsp;</a></h3><p>Call the <code>DropTargetConnector</code>&#39;s <code>dropTarget()</code> method inside your <em>collecting function</em>. This will pass the returned function to your component as a prop. You can then use it inside <code>render</code> or <code>componentDidMount</code> to indicate a DOM node should react to drop target events. Internally it works by attaching a <a href=\"https://facebook.github.io/react/docs/more-about-refs.html#the-ref-callback-attribute\">callback ref</a> to the React element you give it. This callback connects the DOM node of your component to the chosen DnD backend.</p>\n<ul>\n<li><strong><code>dropTarget() =&gt; (elementOrNode)</code></strong>: Returns a function that must be used inside the component to assign the drop target role to a node. By returning <code>{ connectDropTarget: connect.dropTarget() }</code> from your collecting function, you can mark any React element as the droppable node. To do that, replace any <code>element</code> with <code>this.props.connectDropTarget(element)</code> inside the <code>render</code> function.</li>\n</ul>\n<h3>Example<a id=\"example\">&nbsp;</a></h3><p>Check out <a href=\"docs-tutorial.html\">the tutorial</a> for more real examples!</p>\n<hr/>\n<code class=\"codeBlock\"><span class=\"token keyword\" >var</span> <span class=\"token qualifier\" >React</span> <span class=\"token operator\" >=</span> <span class=\"token function\" >require<span class=\"token punctuation\" >(</span></span><span class=\"token string\" >'react'</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n<span class=\"token keyword\" >var</span> <span class=\"token qualifier\" >Drop</span><span class=\"token qualifier\" >Target</span> <span class=\"token operator\" >=</span> <span class=\"token function\" >require<span class=\"token punctuation\" >(</span></span><span class=\"token string\" >'react-dnd'</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >.</span><span class=\"token qualifier\" >Drop</span><span class=\"token qualifier\" >Target</span><span class=\"token punctuation\" >;</span>\n\n<span class=\"token comment\" spellcheck=\"true\">/* ... */</span>\n\n<span class=\"token block-keyword\" >function</span> <span class=\"token function\" >collect<span class=\"token punctuation\" >(</span></span>connect<span class=\"token punctuation\" >,</span> monitor<span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n  <span class=\"token keyword\" >return</span> <span class=\"token punctuation\" >{</span>\n    connectDropTarget<span class=\"token punctuation\" >:</span> connect<span class=\"token punctuation\" >.</span><span class=\"token function\" >dropTarget<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span>\n  <span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >;</span>\n<span class=\"token punctuation\" >}</span>\n\n<span class=\"token keyword\" >var</span> <span class=\"token qualifier\" >Drop</span><span class=\"token qualifier\" >Zone</span> <span class=\"token operator\" >=</span> <span class=\"token qualifier\" >React</span><span class=\"token punctuation\" >.</span><span class=\"token function\" >createClass<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >{</span>\n  render<span class=\"token punctuation\" >:</span> <span class=\"token block-keyword\" >function</span> <span class=\"token punctuation\" >(</span><span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n    <span class=\"token keyword\" >var</span> connectDropTarget <span class=\"token operator\" >=</span> <span class=\"token var\" >this</span><span class=\"token punctuation\" >.</span>props<span class=\"token punctuation\" >.</span>connectDropTarget<span class=\"token punctuation\" >;</span>\n\n    <span class=\"token keyword\" >return</span> <span class=\"token function\" >connectDropTarget<span class=\"token punctuation\" >(</span></span>\n      <span class=\"token operator\" >&lt;</span>div<span class=\"token operator\" >></span>\n        <span class=\"token qualifier\" >You</span> can drop here<span class=\"token operator\" >!</span>\n      <span class=\"token operator\" >&lt;</span><span class=\"token operator\" >/</span>div<span class=\"token operator\" >></span>\n    <span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n  <span class=\"token punctuation\" >}</span>\n<span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n\nmodule<span class=\"token punctuation\" >.</span>exports <span class=\"token operator\" >=</span> <span class=\"token function\" >DropTarget<span class=\"token punctuation\" >(</span></span><span class=\"token comment\" spellcheck=\"true\">/* ... */</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >(</span><span class=\"token qualifier\" >Drop</span><span class=\"token qualifier\" >Zone</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span></code><hr/>\n<code class=\"codeBlock\"><span class=\"token keyword\" >import</span> <span class=\"token qualifier\" >React</span> from <span class=\"token string\" >'react'</span><span class=\"token punctuation\" >;</span>\n<span class=\"token keyword\" >import</span> <span class=\"token punctuation\" >{</span> <span class=\"token qualifier\" >Drop</span><span class=\"token qualifier\" >Target</span> <span class=\"token punctuation\" >}</span> from <span class=\"token string\" >'react-dnd'</span><span class=\"token punctuation\" >;</span>\n\n<span class=\"token comment\" spellcheck=\"true\">/* ... */</span>\n\n<span class=\"token block-keyword\" >function</span> <span class=\"token function\" >collect<span class=\"token punctuation\" >(</span></span>connect<span class=\"token punctuation\" >,</span> monitor<span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n  <span class=\"token keyword\" >return</span> <span class=\"token punctuation\" >{</span>\n    connectDropTarget<span class=\"token punctuation\" >:</span> connect<span class=\"token punctuation\" >.</span><span class=\"token function\" >dropTarget<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span>\n  <span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >;</span>\n<span class=\"token punctuation\" >}</span>\n\n<span class=\"token keyword\" >class</span> <span class=\"token class-name\" >DropZone</span> <span class=\"token punctuation\" >{</span>\n  <span class=\"token function\" >render<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n    <span class=\"token keyword\" >const</span> <span class=\"token punctuation\" >{</span> connectDropTarget <span class=\"token punctuation\" >}</span> <span class=\"token operator\" >=</span> <span class=\"token var\" >this</span><span class=\"token punctuation\" >.</span>props<span class=\"token punctuation\" >;</span>\n\n    <span class=\"token keyword\" >return</span> <span class=\"token function\" >connectDropTarget<span class=\"token punctuation\" >(</span></span>\n      <span class=\"token operator\" >&lt;</span>div<span class=\"token operator\" >></span>\n        <span class=\"token qualifier\" >You</span> can drop here<span class=\"token operator\" >!</span>\n      <span class=\"token operator\" >&lt;</span><span class=\"token operator\" >/</span>div<span class=\"token operator\" >></span>\n    <span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n  <span class=\"token punctuation\" >}</span>\n<span class=\"token punctuation\" >}</span>\n\n<span class=\"token keyword\" >export</span> <span class=\"token keyword\" >default</span> <span class=\"token function\" >DropTarget<span class=\"token punctuation\" >(</span></span><span class=\"token comment\" spellcheck=\"true\">/* ... */</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >(</span><span class=\"token qualifier\" >Drop</span><span class=\"token qualifier\" >Zone</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span></code><hr/>\n<code class=\"codeBlock\"><span class=\"token keyword\" >import</span> <span class=\"token qualifier\" >React</span> from <span class=\"token string\" >'react'</span><span class=\"token punctuation\" >;</span>\n<span class=\"token keyword\" >import</span> <span class=\"token punctuation\" >{</span> <span class=\"token qualifier\" >Drop</span><span class=\"token qualifier\" >Target</span> <span class=\"token punctuation\" >}</span> from <span class=\"token string\" >'react-dnd'</span><span class=\"token punctuation\" >;</span>\n\n<span class=\"token comment\" spellcheck=\"true\">/* ... */</span>\n\n<span class=\"token block-keyword\" >function</span> <span class=\"token function\" >collect<span class=\"token punctuation\" >(</span></span>connect<span class=\"token punctuation\" >,</span> monitor<span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n  <span class=\"token keyword\" >return</span> <span class=\"token punctuation\" >{</span>\n    connectDropTarget<span class=\"token punctuation\" >:</span> connect<span class=\"token punctuation\" >.</span><span class=\"token function\" >dropTarget<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span>\n  <span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >;</span>\n<span class=\"token punctuation\" >}</span>\n\n@<span class=\"token function\" >DropTarget<span class=\"token punctuation\" >(</span></span><span class=\"token comment\" spellcheck=\"true\">/* ... */</span><span class=\"token punctuation\" >)</span>\n<span class=\"token keyword\" >export</span> <span class=\"token keyword\" >default</span> <span class=\"token keyword\" >class</span> <span class=\"token class-name\" >DropZone</span> <span class=\"token punctuation\" >{</span>\n  <span class=\"token function\" >render<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n    <span class=\"token keyword\" >const</span> <span class=\"token punctuation\" >{</span> connectDropTarget <span class=\"token punctuation\" >}</span> <span class=\"token operator\" >=</span> <span class=\"token var\" >this</span><span class=\"token punctuation\" >.</span>props<span class=\"token punctuation\" >;</span>\n\n    <span class=\"token keyword\" >return</span> <span class=\"token function\" >connectDropTarget<span class=\"token punctuation\" >(</span></span>\n      <span class=\"token operator\" >&lt;</span>div<span class=\"token operator\" >></span>\n        <span class=\"token qualifier\" >You</span> can drop here<span class=\"token operator\" >!</span>\n      <span class=\"token operator\" >&lt;</span><span class=\"token operator\" >/</span>div<span class=\"token operator\" >></span>\n    <span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n  <span class=\"token punctuation\" >}</span>\n<span class=\"token punctuation\" >}</span></code><hr/>\n";

/***/ },
/* 340 */
/***/ function(module, exports) {

	module.exports = "<p><em>New to React DnD? <a href=\"docs-overview.html\">Read the overview</a> before jumping into the docs.</em></p>\n<h1>DragLayerMonitor<a id=\"draglayermonitor\">&nbsp;</a></h1><p><code>DragLayerMonitor</code> is an object passed to a collecting function of the <a href=\"docs-drag-layer.html\"><code>DragLayer</code></a>. Its methods let you get information about the global drag state.</p>\n<h3>Methods<a id=\"methods\">&nbsp;</a></h3><ul>\n<li><p><strong><code>isDragging()</code></strong>: Returns <code>true</code> if a drag operation is in progress. Returns <code>false</code> otherwise.</p>\n</li>\n<li><p><strong><code>getItemType()</code></strong>: Returns a string or an ES6 symbol identifying the type of the current dragged item. Returns <code>null</code> if no item is being dragged.</p>\n</li>\n<li><p><strong><code>getItem()</code></strong>: Returns a plain object representing the currently dragged item. Every drag source must specify it by returning an object from its <code>beginDrag()</code> method. Returns <code>null</code> if no item is being dragged.</p>\n</li>\n<li><p><strong><code>getInitialClientOffset()</code></strong>: Returns the <code>{ x, y }</code> client offset of the pointer at the time when the current drag operation has started. Returns <code>null</code> if no item is being dragged.</p>\n</li>\n<li><p><strong><code>getInitialSourceClientOffset()</code></strong>: Returns the <code>{ x, y }</code> client offset of the drag source component&#39;s root DOM node at the time when the current drag operation has started. Returns <code>null</code> if no item is being dragged.</p>\n</li>\n<li><p><strong><code>getClientOffset</code></strong>: Returns the last recorded <code>{ x, y }</code> client offset of the pointer while a drag operation is in progress. Returns <code>null</code> if no item is being dragged.</p>\n</li>\n<li><p><strong><code>getDifferenceFromInitialOffset()</code></strong>: Returns the <code>{ x, y }</code> difference between the last recorded client offset of the pointer and the client offset when current the drag operation has started. Returns <code>null</code> if no item is being dragged.</p>\n</li>\n<li><p><strong><code>getSourceClientOffset()</code></strong>: Returns the projected <code>{ x, y }</code> client offset of the drag source component&#39;s root DOM node, based on its position at the time when the current drag operation has started, and the movement difference. Returns <code>null</code> if no item is being dragged.</p>\n</li>\n</ul>\n";

/***/ },
/* 341 */
/***/ function(module, exports) {

	module.exports = "<p><em>New to React DnD? <a href=\"docs-overview.html\">Read the overview</a> before jumping into the docs.</em></p>\n<h1>DragSourceMonitor<a id=\"dragsourcemonitor\">&nbsp;</a></h1><p><code>DragSourceMonitor</code> is an object passed to a collecting function of the <a href=\"docs-drag-source.html\"><code>DragSource</code></a>. Its methods let you get information about the drag state of a specific drag source. The specific drag source bound to that monitor is called the monitor&#39;s <em>owner</em> below.</p>\n<h3>Methods<a id=\"methods\">&nbsp;</a></h3><ul>\n<li><p><strong><code>canDrag()</code></strong>: Returns <code>true</code> if no drag operation is in progress, and the owner&#39;s <code>canDrag()</code> returns <code>true</code> or is not defined.</p>\n</li>\n<li><p><strong><code>isDragging()</code></strong>: Returns <code>true</code> if there is a drag operation is in progress, and either the owner initiated the drag, or its <code>isDragging()</code> is defined and returns <code>true</code>.</p>\n</li>\n<li><p><strong><code>getItemType()</code></strong>: Returns a string or an ES6 symbol identifying the type of the current dragged item. Returns <code>null</code> if no item is being dragged.</p>\n</li>\n<li><p><strong><code>getItem()</code></strong>: Returns a plain object representing the currently dragged item. Every drag source must specify it by returning an object from its <code>beginDrag()</code> method. Returns <code>null</code> if no item is being dragged.</p>\n</li>\n<li><p><strong><code>getDropResult()</code></strong>: Returns a plain object representing the last recorded drop result. The drop targets may optionally specify it by returning an object from their <code>drop()</code> methods. When a chain of <code>drop()</code> is dispatched for the nested targets, bottom up, any parent that explicitly returns its own result from <code>drop()</code> overrides the child drop result previously set by the child. Returns <code>null</code> if called outside <code>endDrag()</code>.</p>\n</li>\n<li><p><strong><code>didDrop()</code></strong> Returns <code>true</code> if some drop target has handled the drop event, <code>false</code> otherwise. Even if a target did not return a drop result, <code>didDrop()</code> returns <code>true</code>. Use it inside <code>endDrag()</code> to test whether any drop target has handled the drop. Returns <code>false</code> if called outside <code>endDrag()</code>.</p>\n</li>\n<li><p><strong><code>getInitialClientOffset()</code></strong>: Returns the <code>{ x, y }</code> client offset of the pointer at the time when the current drag operation has started. Returns <code>null</code> if no item is being dragged.</p>\n</li>\n<li><p><strong><code>getInitialSourceClientOffset()</code></strong>: Returns the <code>{ x, y }</code> client offset of the drag source component&#39;s root DOM node at the time when the current drag operation has started. Returns <code>null</code> if no item is being dragged.</p>\n</li>\n<li><p><strong><code>getClientOffset</code></strong>: Returns the last recorded <code>{ x, y }</code> client offset of the pointer while a drag operation is in progress. Returns <code>null</code> if no item is being dragged.</p>\n</li>\n<li><p><strong><code>getDifferenceFromInitialOffset()</code></strong>: Returns the <code>{ x, y }</code> difference between the last recorded client offset of the pointer and the client offset when current the drag operation has started. Returns <code>null</code> if no item is being dragged.</p>\n</li>\n<li><p><strong><code>getSourceClientOffset()</code></strong>: Returns the projected <code>{ x, y }</code> client offset of the drag source component&#39;s root DOM node, based on its position at the time when the current drag operation has started, and the movement difference. Returns <code>null</code> if no item is being dragged.</p>\n</li>\n</ul>\n";

/***/ },
/* 342 */
/***/ function(module, exports) {

	module.exports = "<p><em>New to React DnD? <a href=\"docs-overview.html\">Read the overview</a> before jumping into the docs.</em></p>\n<h1>DropTargetMonitor<a id=\"droptargetmonitor\">&nbsp;</a></h1><p><code>DropTargetMonitor</code> is an object passed to a collecting function of the <a href=\"docs-drop-target.html\"><code>DropTarget</code></a>. Its methods let you get information about the drag state of a specific drop target. The specific drop target bound to that monitor is called the monitor&#39;s <em>owner</em> below.</p>\n<h3>Methods<a id=\"methods\">&nbsp;</a></h3><ul>\n<li><p><strong><code>canDrop()</code></strong>: Returns <code>true</code> if no drag operation is in progress, and the owner&#39;s <code>canDrop()</code> returns <code>true</code> or is not defined.</p>\n</li>\n<li><p><strong><code>isOver(options)</code></strong>: Returns <code>true</code> if there is a drag operation is in progress, and the pointer is currently hovering over the owner. You may optionally pass <code>{ shallow: true }</code> to strictly check whether <em>only</em> the owner is being hovered, as opposed to a nested target.</p>\n</li>\n<li><p><strong><code>getItemType()</code></strong>: Returns a string or an ES6 symbol identifying the type of the current dragged item. Returns <code>null</code> if no item is being dragged.</p>\n</li>\n<li><p><strong><code>getItem()</code></strong>: Returns a plain object representing the currently dragged item. Every drag source must specify it by returning an object from its <code>beginDrag()</code> method. Returns <code>null</code> if no item is being dragged.</p>\n</li>\n<li><p><strong><code>getDropResult()</code></strong>: Returns a plain object representing the last recorded drop result. The drop targets may optionally specify it by returning an object from their <code>drop()</code> methods. When a chain of <code>drop()</code> is dispatched for the nested targets, bottom up, any parent that explicitly returns its own result from <code>drop()</code> overrides the drop result previously set by the child. Returns <code>null</code> if called outside <code>drop()</code>.</p>\n</li>\n<li><p><strong><code>didDrop()</code></strong> Returns <code>true</code> if some drop target has handled the drop event, <code>false</code> otherwise. Even if a target did not return a drop result, <code>didDrop()</code> returns <code>true</code>. Use it inside <code>drop()</code> to test whether any nested drop target has already handled the drop. Returns <code>false</code> if called outside <code>drop()</code>.</p>\n</li>\n<li><p><strong><code>getInitialClientOffset()</code></strong>: Returns the <code>{ x, y }</code> client offset of the pointer at the time when the current drag operation has started. Returns <code>null</code> if no item is being dragged.</p>\n</li>\n<li><p><strong><code>getInitialSourceClientOffset()</code></strong>: Returns the <code>{ x, y }</code> client offset of the drag source component&#39;s root DOM node at the time when the current drag operation has started. Returns <code>null</code> if no item is being dragged.</p>\n</li>\n<li><p><strong><code>getClientOffset()</code></strong>: Returns the last recorded <code>{ x, y }</code> client offset of the pointer while a drag operation is in progress. Returns <code>null</code> if no item is being dragged.</p>\n</li>\n<li><p><strong><code>getDifferenceFromInitialOffset()</code></strong>: Returns the <code>{ x, y }</code> difference between the last recorded client offset of the pointer and the client offset when current the drag operation has started. Returns <code>null</code> if no item is being dragged.</p>\n</li>\n<li><p><strong><code>getSourceClientOffset()</code></strong>: Returns the projected <code>{ x, y }</code> client offset of the drag source component&#39;s root DOM node, based on its position at the time when the current drag operation has started, and the movement difference. Returns <code>null</code> if no item is being dragged.</p>\n</li>\n</ul>\n";

/***/ },
/* 343 */
/***/ function(module, exports) {

	module.exports = "<p><em>New to React DnD? <a href=\"docs-overview.html\">Read the overview</a> before jumping into the docs.</em></p>\n<h1>HTML5<a id=\"html5\">&nbsp;</a></h1><p>This is the only backend currently shipping with React DnD. It uses <a href=\"https://developer.mozilla.org/en-US/docs/Web/Guide/HTML/Drag_and_drop\">the HTML5 drag and drop API</a> under the hood and hides <a href=\"http://quirksmode.org/blog/archives/2009/09/the_html5_drag.html\">its quirks</a>.</p>\n<h3>Importing<a id=\"importing\">&nbsp;</a></h3><ul>\n<li>In the UMD build it is available as <code>ReactDnD.HTML5</code>;</li>\n<li>In the CommonJS build, you can import it from <code>react-dnd/modules/backends/HTML5</code>.</li>\n</ul>\n<p>It is not a top-level export by purpose so that you don&#39;t need to include it if you use a custom backend.</p>\n<h3>Extras<a id=\"extras\">&nbsp;</a></h3><p>Aside from the default export, <code>HTML5</code> module also provides a few extras:</p>\n<ul>\n<li><p><strong><code>getEmptyImage()</code></strong>: a function returning a transparent empty <a href=\"https://developer.mozilla.org/en-US/docs/Web/API/HTMLImageElement/Image\"><code>Image</code></a>. Use <code>connect.dragPreview()</code> of the <a href=\"docs-drag-source-connector.html\">DragSourceConnector</a> to hide the browser-drawn drag preview completely. Handy for drawing the <a href=\"docs-drag-layer.html\">custom drag layers with <code>DragLayer</code></a>. Note that the custom drag previews don&#39;t work in IE.</p>\n</li>\n<li><p><strong><code>NativeTypes</code></strong>: an enumeration of three constants, <code>NativeTypes.FILE</code>, <code>NativeTypes.URL</code> and <code>NativeTypes.TEXT</code>. You may register the <a href=\"docs-drop-target.html\">drop targets</a> for these types to handle the drop of the native files, URLs, or the regular page text.</p>\n</li>\n</ul>\n<h3>Usage<a id=\"usage\">&nbsp;</a></h3><hr/>\n<code class=\"codeBlock\"><span class=\"token keyword\" >var</span> HTML5Backend <span class=\"token operator\" >=</span> <span class=\"token function\" >require<span class=\"token punctuation\" >(</span></span><span class=\"token string\" >'react-dnd/modules/backends/HTML5'</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n<span class=\"token keyword\" >var</span> <span class=\"token qualifier\" >Drag</span><span class=\"token qualifier\" >Drop</span><span class=\"token qualifier\" >Context</span> <span class=\"token operator\" >=</span> <span class=\"token function\" >require<span class=\"token punctuation\" >(</span></span><span class=\"token string\" >'react-dnd'</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >.</span><span class=\"token qualifier\" >Drag</span><span class=\"token qualifier\" >Drop</span><span class=\"token qualifier\" >Context</span><span class=\"token punctuation\" >;</span>\n\n<span class=\"token keyword\" >var</span> <span class=\"token qualifier\" >Your</span><span class=\"token qualifier\" >App</span> <span class=\"token operator\" >=</span> <span class=\"token qualifier\" >React</span><span class=\"token punctuation\" >.</span><span class=\"token function\" >createClass<span class=\"token punctuation\" >(</span></span>\n  <span class=\"token comment\" spellcheck=\"true\">/* ... */</span>\n<span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n\nmodule<span class=\"token punctuation\" >.</span>exports <span class=\"token operator\" >=</span> <span class=\"token function\" >DragDropContext<span class=\"token punctuation\" >(</span></span>HTML5Backend<span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >(</span><span class=\"token qualifier\" >Your</span><span class=\"token qualifier\" >App</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span></code><hr/>\n<code class=\"codeBlock\"><span class=\"token keyword\" >import</span> HTML5Backend from <span class=\"token string\" >'react-dnd/modules/backends/HTML5'</span><span class=\"token punctuation\" >;</span>\n<span class=\"token keyword\" >import</span> <span class=\"token punctuation\" >{</span> <span class=\"token qualifier\" >Drag</span><span class=\"token qualifier\" >Drop</span><span class=\"token qualifier\" >Context</span> <span class=\"token punctuation\" >}</span> from <span class=\"token string\" >'react-dnd'</span><span class=\"token punctuation\" >;</span>\n\n<span class=\"token keyword\" >class</span> <span class=\"token class-name\" >YourApp</span> <span class=\"token punctuation\" >{</span>\n  <span class=\"token comment\" spellcheck=\"true\">/* ... */</span>\n<span class=\"token punctuation\" >}</span>\n\n<span class=\"token keyword\" >export</span> <span class=\"token keyword\" >default</span> <span class=\"token function\" >DragDropContext<span class=\"token punctuation\" >(</span></span>HTML5Backend<span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >(</span><span class=\"token qualifier\" >Your</span><span class=\"token qualifier\" >App</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span></code><hr/>\n<code class=\"codeBlock\"><span class=\"token keyword\" >import</span> HTML5Backend from <span class=\"token string\" >'react-dnd/modules/backends/HTML5'</span><span class=\"token punctuation\" >;</span>\n<span class=\"token keyword\" >import</span> <span class=\"token punctuation\" >{</span> <span class=\"token qualifier\" >Drag</span><span class=\"token qualifier\" >Drop</span><span class=\"token qualifier\" >Context</span> <span class=\"token punctuation\" >}</span> from <span class=\"token string\" >'react-dnd'</span><span class=\"token punctuation\" >;</span>\n\n@<span class=\"token function\" >DragDropContext<span class=\"token punctuation\" >(</span></span>HTML5Backend<span class=\"token punctuation\" >)</span>\n<span class=\"token keyword\" >export</span> <span class=\"token keyword\" >default</span> <span class=\"token keyword\" >class</span> <span class=\"token class-name\" >YourApp</span> <span class=\"token punctuation\" >{</span>\n  <span class=\"token comment\" spellcheck=\"true\">/* ... */</span>\n<span class=\"token punctuation\" >}</span></code><hr/>\n";

/***/ },
/* 344 */
/***/ function(module, exports) {

	module.exports = "<p><em>New to React DnD? <a href=\"docs-overview.html\">Read the overview</a> before jumping into the docs.</em></p>\n<h1>Test<a id=\"test\">&nbsp;</a></h1><p>The <code>Test</code> backend lets you test the drag and drop interaction of your components even without the DOM.<br/>Due to time constraints, this is currently the most underdocumented part of React DnD, but you are welcome to learn from the usage example in the <a href=\"docs-testing.html\">testing</a> tutorial, and contribute to the docs.</p>\n<h3>Importing<a id=\"importing\">&nbsp;</a></h3><p>It is only available in the CommonJS build.<br/>Import it from <code>react-dnd/modules/backends/Test</code>.</p>\n<h3>Usage<a id=\"usage\">&nbsp;</a></h3><p>See the second example in the <a href=\"docs-testing.html\">testing</a> tutorial.</p>\n";

/***/ },
/* 345 */
/***/ function(module, exports) {

	module.exports = "<p>React DnD is a set of React <a href=\"https://medium.com/@dan_abramov/mixins-are-dead-long-live-higher-order-components-94a0d2f9e750\">higher-order</a> components to help you build complex drag and drop interfaces while keeping your components decoupled. It is a perfect fit for apps like Trello and Storify, where dragging transfers data between different parts of the application, and the components change their appearance and the application state in response to the drag and drop events.</p>\n<h2>Installation<a id=\"installation\">&nbsp;</a></h2><code class=\"codeBlock\">npm install <span class=\"token operator\" >--</span>save react<span class=\"token operator\" >-</span>dnd</code><p>You can also grab the standalone build from <a href=\"https://github.com/pljenkins/react-dnd/tree/master/dist\">the repo&#39;s <code>dist</code> folder</a>.</p>\n<h2>What&#39;s It Look Like?<a id=\"what-39-s-it-look-like-\">&nbsp;</a></h2><hr/>\n<code class=\"codeBlock\"><span class=\"token comment\" spellcheck=\"true\">// Let's make &lt;Card text='Write the docs' /> draggable!\n</span>\n<span class=\"token keyword\" >var</span> <span class=\"token qualifier\" >React</span> <span class=\"token operator\" >=</span> <span class=\"token function\" >require<span class=\"token punctuation\" >(</span></span><span class=\"token string\" >'react'</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n<span class=\"token keyword\" >var</span> <span class=\"token qualifier\" >Drag</span><span class=\"token qualifier\" >Source</span> <span class=\"token operator\" >=</span> <span class=\"token function\" >require<span class=\"token punctuation\" >(</span></span><span class=\"token string\" >'react-dnd'</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >.</span><span class=\"token qualifier\" >Drag</span><span class=\"token qualifier\" >Source</span><span class=\"token punctuation\" >;</span>\n<span class=\"token keyword\" >var</span> <span class=\"token qualifier\" >Item</span><span class=\"token qualifier\" >Types</span> <span class=\"token operator\" >=</span> <span class=\"token function\" >require<span class=\"token punctuation\" >(</span></span><span class=\"token string\" >'./Constants'</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >.</span><span class=\"token qualifier\" >Item</span><span class=\"token qualifier\" >Types</span><span class=\"token punctuation\" >;</span>\n<span class=\"token keyword\" >var</span> <span class=\"token qualifier\" >Prop</span><span class=\"token qualifier\" >Types</span> <span class=\"token operator\" >=</span> <span class=\"token qualifier\" >React</span><span class=\"token punctuation\" >.</span><span class=\"token qualifier\" >Prop</span><span class=\"token qualifier\" >Types</span><span class=\"token punctuation\" >;</span>\n\n<span class=\"token comment\" spellcheck=\"true\">/**\n * Implements the drag source contract.\n */</span>\n<span class=\"token keyword\" >var</span> cardSource <span class=\"token operator\" >=</span> <span class=\"token punctuation\" >{</span>\n  beginDrag<span class=\"token punctuation\" >:</span> <span class=\"token block-keyword\" >function</span> <span class=\"token punctuation\" >(</span>props<span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n    <span class=\"token keyword\" >return</span> <span class=\"token punctuation\" >{</span>\n      text<span class=\"token punctuation\" >:</span> props<span class=\"token punctuation\" >.</span>text\n    <span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >;</span>\n  <span class=\"token punctuation\" >}</span>\n<span class=\"token punctuation\" >}</span>\n\n<span class=\"token comment\" spellcheck=\"true\">/**\n * Specifies the props to inject into your component.\n */</span>\n<span class=\"token block-keyword\" >function</span> <span class=\"token function\" >collect<span class=\"token punctuation\" >(</span></span>connect<span class=\"token punctuation\" >,</span> monitor<span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n  <span class=\"token keyword\" >return</span> <span class=\"token punctuation\" >{</span>\n    connectDragSource<span class=\"token punctuation\" >:</span> connect<span class=\"token punctuation\" >.</span><span class=\"token function\" >dragSource<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >,</span>\n    isDragging<span class=\"token punctuation\" >:</span> monitor<span class=\"token punctuation\" >.</span><span class=\"token function\" >isDragging<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span>\n  <span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >;</span>\n<span class=\"token punctuation\" >}</span>\n\n<span class=\"token keyword\" >var</span> <span class=\"token qualifier\" >Card</span> <span class=\"token operator\" >=</span> <span class=\"token qualifier\" >React</span><span class=\"token punctuation\" >.</span><span class=\"token function\" >createClass<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >{</span>\n  propTypes<span class=\"token punctuation\" >:</span> <span class=\"token punctuation\" >{</span>\n    text<span class=\"token punctuation\" >:</span> <span class=\"token qualifier\" >Prop</span><span class=\"token qualifier\" >Types</span><span class=\"token punctuation\" >.</span>string<span class=\"token punctuation\" >.</span>isRequired<span class=\"token punctuation\" >,</span>\n\n    <span class=\"token comment\" spellcheck=\"true\">// Injected by React DnD:\n</span>    isDragging<span class=\"token punctuation\" >:</span> <span class=\"token qualifier\" >Prop</span><span class=\"token qualifier\" >Types</span><span class=\"token punctuation\" >.</span>bool<span class=\"token punctuation\" >.</span>isRequired<span class=\"token punctuation\" >,</span>\n    connectDragSource<span class=\"token punctuation\" >:</span> <span class=\"token qualifier\" >Prop</span><span class=\"token qualifier\" >Types</span><span class=\"token punctuation\" >.</span>func<span class=\"token punctuation\" >.</span>isRequired\n  <span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >,</span>\n\n  render<span class=\"token punctuation\" >:</span> <span class=\"token block-keyword\" >function</span> <span class=\"token punctuation\" >(</span><span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n    <span class=\"token keyword\" >var</span> isDragging <span class=\"token operator\" >=</span> <span class=\"token var\" >this</span><span class=\"token punctuation\" >.</span>props<span class=\"token punctuation\" >.</span>isDragging<span class=\"token punctuation\" >;</span>\n    <span class=\"token keyword\" >var</span> connectDragSource <span class=\"token operator\" >=</span> <span class=\"token var\" >this</span><span class=\"token punctuation\" >.</span>props<span class=\"token punctuation\" >.</span>connectDragSource<span class=\"token punctuation\" >;</span>\n    <span class=\"token keyword\" >var</span> text <span class=\"token operator\" >=</span> <span class=\"token var\" >this</span><span class=\"token punctuation\" >.</span>props<span class=\"token punctuation\" >.</span>text<span class=\"token punctuation\" >;</span>\n\n    <span class=\"token keyword\" >return</span> <span class=\"token function\" >connectDragSource<span class=\"token punctuation\" >(</span></span>\n      <span class=\"token operator\" >&lt;</span>div style<span class=\"token operator\" >=</span><span class=\"token punctuation\" >{</span><span class=\"token punctuation\" >{</span> opacity<span class=\"token punctuation\" >:</span> isDragging <span class=\"token operator\" >?</span> <span class=\"token number\" >0.5</span> <span class=\"token punctuation\" >:</span> <span class=\"token number\" >1</span> <span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >}</span><span class=\"token operator\" >></span>\n        <span class=\"token punctuation\" >{</span>text<span class=\"token punctuation\" >}</span>\n      <span class=\"token operator\" >&lt;</span><span class=\"token operator\" >/</span>div<span class=\"token operator\" >></span>\n    <span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n  <span class=\"token punctuation\" >}</span>\n<span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n\n<span class=\"token comment\" spellcheck=\"true\">// Export the wrapped component:\n</span>module<span class=\"token punctuation\" >.</span>exports <span class=\"token operator\" >=</span> <span class=\"token function\" >DragSource<span class=\"token punctuation\" >(</span></span><span class=\"token qualifier\" >Item</span><span class=\"token qualifier\" >Types</span><span class=\"token punctuation\" >.</span>CARD<span class=\"token punctuation\" >,</span> cardSource<span class=\"token punctuation\" >,</span> collect<span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >(</span><span class=\"token qualifier\" >Card</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span></code><hr/>\n<code class=\"codeBlock\"><span class=\"token comment\" spellcheck=\"true\">// Let's make &lt;Card text='Write the docs' /> draggable!\n</span>\n<span class=\"token keyword\" >import</span> <span class=\"token qualifier\" >React</span><span class=\"token punctuation\" >,</span> <span class=\"token punctuation\" >{</span> <span class=\"token qualifier\" >Prop</span><span class=\"token qualifier\" >Types</span> <span class=\"token punctuation\" >}</span> from <span class=\"token string\" >'react'</span><span class=\"token punctuation\" >;</span>\n<span class=\"token keyword\" >import</span> <span class=\"token punctuation\" >{</span> <span class=\"token qualifier\" >Drag</span><span class=\"token qualifier\" >Source</span> <span class=\"token punctuation\" >}</span> from <span class=\"token string\" >'react-dnd'</span><span class=\"token punctuation\" >;</span>\n<span class=\"token keyword\" >import</span> <span class=\"token punctuation\" >{</span> <span class=\"token qualifier\" >Item</span><span class=\"token qualifier\" >Types</span> <span class=\"token punctuation\" >}</span> from <span class=\"token string\" >'./Constants'</span><span class=\"token punctuation\" >;</span>\n\n<span class=\"token comment\" spellcheck=\"true\">/**\n * Implements the drag source contract.\n */</span>\n<span class=\"token keyword\" >const</span> cardSource <span class=\"token operator\" >=</span> <span class=\"token punctuation\" >{</span>\n  <span class=\"token function\" >beginDrag<span class=\"token punctuation\" >(</span></span>props<span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n    <span class=\"token keyword\" >return</span> <span class=\"token punctuation\" >{</span>\n      text<span class=\"token punctuation\" >:</span> props<span class=\"token punctuation\" >.</span>text\n    <span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >;</span>\n  <span class=\"token punctuation\" >}</span>\n<span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >;</span>\n\n<span class=\"token comment\" spellcheck=\"true\">/**\n * Specifies the props to inject into your component.\n */</span>\n<span class=\"token block-keyword\" >function</span> <span class=\"token function\" >collect<span class=\"token punctuation\" >(</span></span>connect<span class=\"token punctuation\" >,</span> monitor<span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n  <span class=\"token keyword\" >return</span> <span class=\"token punctuation\" >{</span>\n    connectDragSource<span class=\"token punctuation\" >:</span> connect<span class=\"token punctuation\" >.</span><span class=\"token function\" >dragSource<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >,</span>\n    isDragging<span class=\"token punctuation\" >:</span> monitor<span class=\"token punctuation\" >.</span><span class=\"token function\" >isDragging<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span>\n  <span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >;</span>\n<span class=\"token punctuation\" >}</span>\n\n<span class=\"token keyword\" >const</span> propTypes <span class=\"token operator\" >=</span> <span class=\"token punctuation\" >{</span>\n  text<span class=\"token punctuation\" >:</span> <span class=\"token qualifier\" >Prop</span><span class=\"token qualifier\" >Types</span><span class=\"token punctuation\" >.</span>string<span class=\"token punctuation\" >.</span>isRequired<span class=\"token punctuation\" >,</span>\n\n  <span class=\"token comment\" spellcheck=\"true\">// Injected by React DnD:\n</span>  isDragging<span class=\"token punctuation\" >:</span> <span class=\"token qualifier\" >Prop</span><span class=\"token qualifier\" >Types</span><span class=\"token punctuation\" >.</span>bool<span class=\"token punctuation\" >.</span>isRequired<span class=\"token punctuation\" >,</span>\n  connectDragSource<span class=\"token punctuation\" >:</span> <span class=\"token qualifier\" >Prop</span><span class=\"token qualifier\" >Types</span><span class=\"token punctuation\" >.</span>func<span class=\"token punctuation\" >.</span>isRequired\n<span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >;</span>\n\n<span class=\"token keyword\" >class</span> <span class=\"token class-name\" >Card</span> <span class=\"token punctuation\" >{</span>\n  <span class=\"token function\" >render<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n    <span class=\"token keyword\" >const</span> <span class=\"token punctuation\" >{</span> isDragging<span class=\"token punctuation\" >,</span> connectDragSource<span class=\"token punctuation\" >,</span> text <span class=\"token punctuation\" >}</span> <span class=\"token operator\" >=</span> <span class=\"token var\" >this</span><span class=\"token punctuation\" >.</span>props<span class=\"token punctuation\" >;</span>\n    <span class=\"token keyword\" >return</span> <span class=\"token function\" >connectDragSource<span class=\"token punctuation\" >(</span></span>\n      <span class=\"token operator\" >&lt;</span>div style<span class=\"token operator\" >=</span><span class=\"token punctuation\" >{</span><span class=\"token punctuation\" >{</span> opacity<span class=\"token punctuation\" >:</span> isDragging <span class=\"token operator\" >?</span> <span class=\"token number\" >0.5</span> <span class=\"token punctuation\" >:</span> <span class=\"token number\" >1</span> <span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >}</span><span class=\"token operator\" >></span>\n        <span class=\"token punctuation\" >{</span>text<span class=\"token punctuation\" >}</span>\n      <span class=\"token operator\" >&lt;</span><span class=\"token operator\" >/</span>div<span class=\"token operator\" >></span>\n    <span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n  <span class=\"token punctuation\" >}</span>\n<span class=\"token punctuation\" >}</span>\n\n<span class=\"token qualifier\" >Card</span><span class=\"token punctuation\" >.</span>propTypes <span class=\"token operator\" >=</span> propTypes<span class=\"token punctuation\" >;</span>\n\n<span class=\"token comment\" spellcheck=\"true\">// Export the wrapped component:\n</span><span class=\"token keyword\" >export</span> <span class=\"token keyword\" >default</span> <span class=\"token function\" >DragSource<span class=\"token punctuation\" >(</span></span><span class=\"token qualifier\" >Item</span><span class=\"token qualifier\" >Types</span><span class=\"token punctuation\" >.</span>CARD<span class=\"token punctuation\" >,</span> cardSource<span class=\"token punctuation\" >,</span> collect<span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >(</span><span class=\"token qualifier\" >Card</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span></code><hr/>\n<code class=\"codeBlock\"><span class=\"token comment\" spellcheck=\"true\">// Let's make &lt;Card text='Write the docs' /> draggable!\n</span>\n<span class=\"token keyword\" >import</span> <span class=\"token qualifier\" >React</span><span class=\"token punctuation\" >,</span> <span class=\"token punctuation\" >{</span> <span class=\"token qualifier\" >Prop</span><span class=\"token qualifier\" >Types</span> <span class=\"token punctuation\" >}</span> from <span class=\"token string\" >'react'</span><span class=\"token punctuation\" >;</span>\n<span class=\"token keyword\" >import</span> <span class=\"token punctuation\" >{</span> <span class=\"token qualifier\" >Drag</span><span class=\"token qualifier\" >Source</span> <span class=\"token punctuation\" >}</span> from <span class=\"token string\" >'react-dnd'</span><span class=\"token punctuation\" >;</span>\n<span class=\"token keyword\" >import</span> <span class=\"token punctuation\" >{</span> <span class=\"token qualifier\" >Item</span><span class=\"token qualifier\" >Types</span> <span class=\"token punctuation\" >}</span> from <span class=\"token string\" >'./Constants'</span><span class=\"token punctuation\" >;</span>\n\n<span class=\"token comment\" spellcheck=\"true\">/**\n * Implements the drag source contract.\n */</span>\n<span class=\"token keyword\" >const</span> cardSource <span class=\"token operator\" >=</span> <span class=\"token punctuation\" >{</span>\n  <span class=\"token function\" >beginDrag<span class=\"token punctuation\" >(</span></span>props<span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n    <span class=\"token keyword\" >return</span> <span class=\"token punctuation\" >{</span>\n      text<span class=\"token punctuation\" >:</span> props<span class=\"token punctuation\" >.</span>text\n    <span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >;</span>\n  <span class=\"token punctuation\" >}</span>\n<span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >;</span>\n\n@<span class=\"token function\" >DragSource<span class=\"token punctuation\" >(</span></span><span class=\"token qualifier\" >Item</span><span class=\"token qualifier\" >Types</span><span class=\"token punctuation\" >.</span>CARD<span class=\"token punctuation\" >,</span> cardSource<span class=\"token punctuation\" >,</span> <span class=\"token punctuation\" >(</span>connect<span class=\"token punctuation\" >,</span> monitor<span class=\"token punctuation\" >)</span> <span class=\"token operator\" >=</span><span class=\"token operator\" >></span> <span class=\"token punctuation\" >(</span><span class=\"token punctuation\" >{</span>\n  connectDragSource<span class=\"token punctuation\" >:</span> connect<span class=\"token punctuation\" >.</span><span class=\"token function\" >dragSource<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >,</span>\n  isDragging<span class=\"token punctuation\" >:</span> monitor<span class=\"token punctuation\" >.</span><span class=\"token function\" >isDragging<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span>\n<span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >)</span>\n<span class=\"token keyword\" >export</span> <span class=\"token keyword\" >default</span> <span class=\"token keyword\" >class</span> <span class=\"token class-name\" >Card</span> <span class=\"token punctuation\" >{</span>\n  <span class=\"token keyword\" >static</span> propTypes <span class=\"token operator\" >=</span> <span class=\"token punctuation\" >{</span>\n    text<span class=\"token punctuation\" >:</span> <span class=\"token qualifier\" >Prop</span><span class=\"token qualifier\" >Types</span><span class=\"token punctuation\" >.</span>string<span class=\"token punctuation\" >.</span>isRequired<span class=\"token punctuation\" >,</span>\n\n    <span class=\"token comment\" spellcheck=\"true\">// Injected by React DnD:\n</span>    connectDragSource<span class=\"token punctuation\" >:</span> <span class=\"token qualifier\" >Prop</span><span class=\"token qualifier\" >Types</span><span class=\"token punctuation\" >.</span>func<span class=\"token punctuation\" >.</span>isRequired<span class=\"token punctuation\" >,</span>\n    isDragging<span class=\"token punctuation\" >:</span> <span class=\"token qualifier\" >Prop</span><span class=\"token qualifier\" >Types</span><span class=\"token punctuation\" >.</span>bool<span class=\"token punctuation\" >.</span>isRequired\n  <span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >;</span>\n\n  <span class=\"token function\" >render<span class=\"token punctuation\" >(</span></span><span class=\"token punctuation\" >)</span> <span class=\"token punctuation\" >{</span>\n    <span class=\"token keyword\" >const</span> <span class=\"token punctuation\" >{</span> isDragging<span class=\"token punctuation\" >,</span> connectDragSource<span class=\"token punctuation\" >,</span> text <span class=\"token punctuation\" >}</span> <span class=\"token operator\" >=</span> <span class=\"token var\" >this</span><span class=\"token punctuation\" >.</span>props<span class=\"token punctuation\" >;</span>\n    <span class=\"token keyword\" >return</span> <span class=\"token function\" >connectDragSource<span class=\"token punctuation\" >(</span></span>\n      <span class=\"token operator\" >&lt;</span>div style<span class=\"token operator\" >=</span><span class=\"token punctuation\" >{</span><span class=\"token punctuation\" >{</span> opacity<span class=\"token punctuation\" >:</span> isDragging <span class=\"token operator\" >?</span> <span class=\"token number\" >0.5</span> <span class=\"token punctuation\" >:</span> <span class=\"token number\" >1</span> <span class=\"token punctuation\" >}</span><span class=\"token punctuation\" >}</span><span class=\"token operator\" >></span>\n        <span class=\"token punctuation\" >{</span>text<span class=\"token punctuation\" >}</span>\n      <span class=\"token operator\" >&lt;</span><span class=\"token operator\" >/</span>div<span class=\"token operator\" >></span>\n    <span class=\"token punctuation\" >)</span><span class=\"token punctuation\" >;</span>\n  <span class=\"token punctuation\" >}</span>\n<span class=\"token punctuation\" >}</span></code><hr/>\n<h2>Features<a id=\"features\">&nbsp;</a></h2><h3>It works with your components<a id=\"it-works-with-your-components\">&nbsp;</a></h3><p>Instead of providing readymade widgets, React DnD wraps your components and injects props into them. If you use React Router or Flummox, you already know this pattern.</p>\n<h3>It embraces unidirectional data flow<a id=\"it-embraces-unidirectional-data-flow\">&nbsp;</a></h3><p>React DnD fully embraces the declarative rendering paradigm of React and doesn&#39;t mutate the DOM. It is a great complement to Flux and other architectures with the unidirectional data flow. In fact it is built on Flux.</p>\n<h3>It hides the platform quirks<a id=\"it-hides-the-platform-quirks\">&nbsp;</a></h3><p>HTML5 drag and drop has an awkward API full of pitfalls and browser inconsistencies. React DnD handles them internally for you, so you can focus on developing your application instead of working around the browser bugs.</p>\n<h3>It is extensible and testable<a id=\"it-is-extensible-and-testable\">&nbsp;</a></h3><p>React DnD uses the HTML5 drag and drop under the hood, but it also lets you supply a custom “backend”. You can create a custom DnD backend based on the touch events, the mouse events, or something else entirely. For example, a built-in simulation backend lets you test drag and drop interaction of your components in a Node environment.</p>\n<h3>It is ready for the future<a id=\"it-is-ready-for-the-future\">&nbsp;</a></h3><p>React DnD does not export mixins, and works equally great with any components, whether they are created using ES6 classes, <code>createClass</code> or alternative React frameworks such as Omniscient. Its API shines with ES7 decorators if you like to be on the bleeding edge, but it also feels natural in both ES5 and ES6.</p>\n<h2>Touch Support<a id=\"touch-support\">&nbsp;</a></h2><p>React DnD does not work on mobile browsers yet because it currently relies on the HTML5 drag and drop API which no mobile browsers implement. However, because React DnD is extensible, it is possible to add touch support using a custom backend <a href=\"https://github.com/pljenkins/react-dnd/blob/ba8359ab3d7c76592357e078561d0e9d96afbcb0/src/backends/Touch.js\">with about 200 lines of code</a>. This is currently a proof of concept, but any contributions in this direction are welcome. Touch support will be a priority for the upcoming 1.x releases.</p>\n<h2>Non-Goals<a id=\"non-goals\">&nbsp;</a></h2><p>React DnD gives you a set of powerful primitives, but it does not contain any readymade components. It&#39;s lower level than <a href=\"https://jqueryui.com/\">jQuery UI</a> or <a href=\"http://interactjs.io/\">interact.js</a> and is focused on getting the drag and drop interaction right, leaving its visual aspects such as axis constraints or snapping to you. For example, React DnD doesn&#39;t plan to provide a <code>Sortable</code> component. Instead it makes it easy for you to build your own, with any rendering customizations that you need.</p>\n<h2>Support and Contributions<a id=\"support-and-contributions\">&nbsp;</a></h2><p>Issues and potential improvements are discussed on <a href=\"https://github.com/pljenkins/react-dnd/issues\">Github</a>.<br/>The <a href=\"https://gitter.im/pljenkins/react-dnd\">Gitter room</a> is another good place to get support.</p>\n<h2>License<a id=\"license\">&nbsp;</a></h2><p>React DnD is licensed as MIT. Use it as you will.</p>\n";

/***/ },
/* 346 */
/***/ function(module, exports, __webpack_require__) {

	var baseIndexOf = __webpack_require__(75),
	    cacheIndexOf = __webpack_require__(76),
	    createCache = __webpack_require__(77),
	    isArrayLike = __webpack_require__(22),
	    restParam = __webpack_require__(39);
	
	/**
	 * Creates an array of unique values that are included in all of the provided
	 * arrays using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	 * for equality comparisons.
	 *
	 * @static
	 * @memberOf _
	 * @category Array
	 * @param {...Array} [arrays] The arrays to inspect.
	 * @returns {Array} Returns the new array of shared values.
	 * @example
	 * _.intersection([1, 2], [4, 2], [2, 1]);
	 * // => [2]
	 */
	var intersection = restParam(function(arrays) {
	  var othLength = arrays.length,
	      othIndex = othLength,
	      caches = Array(length),
	      indexOf = baseIndexOf,
	      isCommon = true,
	      result = [];
	
	  while (othIndex--) {
	    var value = arrays[othIndex] = isArrayLike(value = arrays[othIndex]) ? value : [];
	    caches[othIndex] = (isCommon && value.length >= 120) ? createCache(othIndex && value) : null;
	  }
	  var array = arrays[0],
	      index = -1,
	      length = array ? array.length : 0,
	      seen = caches[0];
	
	  outer:
	  while (++index < length) {
	    value = array[index];
	    if ((seen ? cacheIndexOf(seen, value) : indexOf(result, value, 0)) < 0) {
	      var othIndex = othLength;
	      while (--othIndex) {
	        var cache = caches[othIndex];
	        if ((cache ? cacheIndexOf(cache, value) : indexOf(arrays[othIndex], value, 0)) < 0) {
	          continue outer;
	        }
	      }
	      if (seen) {
	        seen.push(value);
	      }
	      result.push(value);
	    }
	  }
	  return result;
	});
	
	module.exports = intersection;


/***/ },
/* 347 */
/***/ function(module, exports, __webpack_require__) {

	var baseFlatten = __webpack_require__(360),
	    baseUniq = __webpack_require__(125),
	    restParam = __webpack_require__(39);
	
	/**
	 * Creates an array of unique values, in order, from all of the provided arrays
	 * using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	 * for equality comparisons.
	 *
	 * @static
	 * @memberOf _
	 * @category Array
	 * @param {...Array} [arrays] The arrays to inspect.
	 * @returns {Array} Returns the new array of combined values.
	 * @example
	 *
	 * _.union([1, 2], [4, 2], [2, 1]);
	 * // => [1, 2, 4]
	 */
	var union = restParam(function(arrays) {
	  return baseUniq(baseFlatten(arrays, false, true));
	});
	
	module.exports = union;


/***/ },
/* 348 */
/***/ function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(123),
	    baseDifference = __webpack_require__(124),
	    baseUniq = __webpack_require__(125),
	    isArrayLike = __webpack_require__(22);
	
	/**
	 * Creates an array of unique values that is the [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
	 * of the provided arrays.
	 *
	 * @static
	 * @memberOf _
	 * @category Array
	 * @param {...Array} [arrays] The arrays to inspect.
	 * @returns {Array} Returns the new array of values.
	 * @example
	 *
	 * _.xor([1, 2], [4, 2]);
	 * // => [1, 4]
	 */
	function xor() {
	  var index = -1,
	      length = arguments.length;
	
	  while (++index < length) {
	    var array = arguments[index];
	    if (isArrayLike(array)) {
	      var result = result
	        ? arrayPush(baseDifference(result, array), baseDifference(array, result))
	        : array;
	    }
	  }
	  return result ? baseUniq(result) : [];
	}
	
	module.exports = xor;


/***/ },
/* 349 */
/***/ function(module, exports, __webpack_require__) {

	var baseRandom = __webpack_require__(364),
	    isIterateeCall = __webpack_require__(127),
	    toArray = __webpack_require__(381),
	    toIterable = __webpack_require__(377);
	
	/* Native method references for those with the same name as other `lodash` methods. */
	var nativeMin = Math.min;
	
	/**
	 * Gets a random element or `n` random elements from a collection.
	 *
	 * @static
	 * @memberOf _
	 * @category Collection
	 * @param {Array|Object|string} collection The collection to sample.
	 * @param {number} [n] The number of elements to sample.
	 * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	 * @returns {*} Returns the random sample(s).
	 * @example
	 *
	 * _.sample([1, 2, 3, 4]);
	 * // => 2
	 *
	 * _.sample([1, 2, 3, 4], 2);
	 * // => [3, 1]
	 */
	function sample(collection, n, guard) {
	  if (guard ? isIterateeCall(collection, n, guard) : n == null) {
	    collection = toIterable(collection);
	    var length = collection.length;
	    return length > 0 ? collection[baseRandom(0, length - 1)] : undefined;
	  }
	  var index = -1,
	      result = toArray(collection),
	      length = result.length,
	      lastIndex = length - 1;
	
	  n = nativeMin(n < 0 ? 0 : (+n || 0), length);
	  while (++index < n) {
	    var rand = baseRandom(index, lastIndex),
	        value = result[rand];
	
	    result[rand] = result[index];
	    result[index] = value;
	  }
	  result.length = n;
	  return result;
	}
	
	module.exports = sample;


/***/ },
/* 350 */
/***/ function(module, exports, __webpack_require__) {

	var sample = __webpack_require__(349);
	
	/** Used as references for `-Infinity` and `Infinity`. */
	var POSITIVE_INFINITY = Number.POSITIVE_INFINITY;
	
	/**
	 * Creates an array of shuffled values, using a version of the
	 * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
	 *
	 * @static
	 * @memberOf _
	 * @category Collection
	 * @param {Array|Object|string} collection The collection to shuffle.
	 * @returns {Array} Returns the new shuffled array.
	 * @example
	 *
	 * _.shuffle([1, 2, 3, 4]);
	 * // => [4, 1, 3, 2]
	 */
	function shuffle(collection) {
	  return sample(collection, POSITIVE_INFINITY);
	}
	
	module.exports = shuffle;


/***/ },
/* 351 */
/***/ function(module, exports, __webpack_require__) {

	var MapCache = __webpack_require__(353);
	
	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/**
	 * Creates a function that memoizes the result of `func`. If `resolver` is
	 * provided it determines the cache key for storing the result based on the
	 * arguments provided to the memoized function. By default, the first argument
	 * provided to the memoized function is coerced to a string and used as the
	 * cache key. The `func` is invoked with the `this` binding of the memoized
	 * function.
	 *
	 * **Note:** The cache is exposed as the `cache` property on the memoized
	 * function. Its creation may be customized by replacing the `_.memoize.Cache`
	 * constructor with one whose instances implement the [`Map`](http://ecma-international.org/ecma-262/6.0/#sec-properties-of-the-map-prototype-object)
	 * method interface of `get`, `has`, and `set`.
	 *
	 * @static
	 * @memberOf _
	 * @category Function
	 * @param {Function} func The function to have its output memoized.
	 * @param {Function} [resolver] The function to resolve the cache key.
	 * @returns {Function} Returns the new memoizing function.
	 * @example
	 *
	 * var upperCase = _.memoize(function(string) {
	 *   return string.toUpperCase();
	 * });
	 *
	 * upperCase('fred');
	 * // => 'FRED'
	 *
	 * // modifying the result cache
	 * upperCase.cache.set('fred', 'BARNEY');
	 * upperCase('fred');
	 * // => 'BARNEY'
	 *
	 * // replacing `_.memoize.Cache`
	 * var object = { 'user': 'fred' };
	 * var other = { 'user': 'barney' };
	 * var identity = _.memoize(_.identity);
	 *
	 * identity(object);
	 * // => { 'user': 'fred' }
	 * identity(other);
	 * // => { 'user': 'fred' }
	 *
	 * _.memoize.Cache = WeakMap;
	 * var identity = _.memoize(_.identity);
	 *
	 * identity(object);
	 * // => { 'user': 'fred' }
	 * identity(other);
	 * // => { 'user': 'barney' }
	 */
	function memoize(func, resolver) {
	  if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  var memoized = function() {
	    var args = arguments,
	        key = resolver ? resolver.apply(this, args) : args[0],
	        cache = memoized.cache;
	
	    if (cache.has(key)) {
	      return cache.get(key);
	    }
	    var result = func.apply(this, args);
	    memoized.cache = cache.set(key, result);
	    return result;
	  };
	  memoized.cache = new memoize.Cache;
	  return memoized;
	}
	
	// Assign cache to `_.memoize`.
	memoize.Cache = MapCache;
	
	module.exports = memoize;


/***/ },
/* 352 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, global) {/**
	 * @license
	 * lodash 3.10.1 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern -d -o ./index.js`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	;(function() {
	
	  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
	  var undefined;
	
	  /** Used as the semantic version number. */
	  var VERSION = '3.10.1';
	
	  /** Used to compose bitmasks for wrapper metadata. */
	  var BIND_FLAG = 1,
	      BIND_KEY_FLAG = 2,
	      CURRY_BOUND_FLAG = 4,
	      CURRY_FLAG = 8,
	      CURRY_RIGHT_FLAG = 16,
	      PARTIAL_FLAG = 32,
	      PARTIAL_RIGHT_FLAG = 64,
	      ARY_FLAG = 128,
	      REARG_FLAG = 256;
	
	  /** Used as default options for `_.trunc`. */
	  var DEFAULT_TRUNC_LENGTH = 30,
	      DEFAULT_TRUNC_OMISSION = '...';
	
	  /** Used to detect when a function becomes hot. */
	  var HOT_COUNT = 150,
	      HOT_SPAN = 16;
	
	  /** Used as the size to enable large array optimizations. */
	  var LARGE_ARRAY_SIZE = 200;
	
	  /** Used to indicate the type of lazy iteratees. */
	  var LAZY_FILTER_FLAG = 1,
	      LAZY_MAP_FLAG = 2;
	
	  /** Used as the `TypeError` message for "Functions" methods. */
	  var FUNC_ERROR_TEXT = 'Expected a function';
	
	  /** Used as the internal argument placeholder. */
	  var PLACEHOLDER = '__lodash_placeholder__';
	
	  /** `Object#toString` result references. */
	  var argsTag = '[object Arguments]',
	      arrayTag = '[object Array]',
	      boolTag = '[object Boolean]',
	      dateTag = '[object Date]',
	      errorTag = '[object Error]',
	      funcTag = '[object Function]',
	      mapTag = '[object Map]',
	      numberTag = '[object Number]',
	      objectTag = '[object Object]',
	      regexpTag = '[object RegExp]',
	      setTag = '[object Set]',
	      stringTag = '[object String]',
	      weakMapTag = '[object WeakMap]';
	
	  var arrayBufferTag = '[object ArrayBuffer]',
	      float32Tag = '[object Float32Array]',
	      float64Tag = '[object Float64Array]',
	      int8Tag = '[object Int8Array]',
	      int16Tag = '[object Int16Array]',
	      int32Tag = '[object Int32Array]',
	      uint8Tag = '[object Uint8Array]',
	      uint8ClampedTag = '[object Uint8ClampedArray]',
	      uint16Tag = '[object Uint16Array]',
	      uint32Tag = '[object Uint32Array]';
	
	  /** Used to match empty string literals in compiled template source. */
	  var reEmptyStringLeading = /\b__p \+= '';/g,
	      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
	      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
	
	  /** Used to match HTML entities and HTML characters. */
	  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39|#96);/g,
	      reUnescapedHtml = /[&<>"'`]/g,
	      reHasEscapedHtml = RegExp(reEscapedHtml.source),
	      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
	
	  /** Used to match template delimiters. */
	  var reEscape = /<%-([\s\S]+?)%>/g,
	      reEvaluate = /<%([\s\S]+?)%>/g,
	      reInterpolate = /<%=([\s\S]+?)%>/g;
	
	  /** Used to match property names within property paths. */
	  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\n\\]|\\.)*?\1)\]/,
	      reIsPlainProp = /^\w*$/,
	      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\n\\]|\\.)*?)\2)\]/g;
	
	  /**
	   * Used to match `RegExp` [syntax characters](http://ecma-international.org/ecma-262/6.0/#sec-patterns)
	   * and those outlined by [`EscapeRegExpPattern`](http://ecma-international.org/ecma-262/6.0/#sec-escaperegexppattern).
	   */
	  var reRegExpChars = /^[:!,]|[\\^$.*+?()[\]{}|\/]|(^[0-9a-fA-Fnrtuvx])|([\n\r\u2028\u2029])/g,
	      reHasRegExpChars = RegExp(reRegExpChars.source);
	
	  /** Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks). */
	  var reComboMark = /[\u0300-\u036f\ufe20-\ufe23]/g;
	
	  /** Used to match backslashes in property paths. */
	  var reEscapeChar = /\\(\\)?/g;
	
	  /** Used to match [ES template delimiters](http://ecma-international.org/ecma-262/6.0/#sec-template-literal-lexical-components). */
	  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
	
	  /** Used to match `RegExp` flags from their coerced string values. */
	  var reFlags = /\w*$/;
	
	  /** Used to detect hexadecimal string values. */
	  var reHasHexPrefix = /^0[xX]/;
	
	  /** Used to detect host constructors (Safari > 5). */
	  var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	  /** Used to detect unsigned integer values. */
	  var reIsUint = /^\d+$/;
	
	  /** Used to match latin-1 supplementary letters (excluding mathematical operators). */
	  var reLatin1 = /[\xc0-\xd6\xd8-\xde\xdf-\xf6\xf8-\xff]/g;
	
	  /** Used to ensure capturing order of template delimiters. */
	  var reNoMatch = /($^)/;
	
	  /** Used to match unescaped characters in compiled string literals. */
	  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
	
	  /** Used to match words to create compound words. */
	  var reWords = (function() {
	    var upper = '[A-Z\\xc0-\\xd6\\xd8-\\xde]',
	        lower = '[a-z\\xdf-\\xf6\\xf8-\\xff]+';
	
	    return RegExp(upper + '+(?=' + upper + lower + ')|' + upper + '?' + lower + '|' + upper + '+|[0-9]+', 'g');
	  }());
	
	  /** Used to assign default `context` object properties. */
	  var contextProps = [
	    'Array', 'ArrayBuffer', 'Date', 'Error', 'Float32Array', 'Float64Array',
	    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Math', 'Number',
	    'Object', 'RegExp', 'Set', 'String', '_', 'clearTimeout', 'isFinite',
	    'parseFloat', 'parseInt', 'setTimeout', 'TypeError', 'Uint8Array',
	    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap'
	  ];
	
	  /** Used to make template sourceURLs easier to identify. */
	  var templateCounter = -1;
	
	  /** Used to identify `toStringTag` values of typed arrays. */
	  var typedArrayTags = {};
	  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	  typedArrayTags[uint32Tag] = true;
	  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	  typedArrayTags[dateTag] = typedArrayTags[errorTag] =
	  typedArrayTags[funcTag] = typedArrayTags[mapTag] =
	  typedArrayTags[numberTag] = typedArrayTags[objectTag] =
	  typedArrayTags[regexpTag] = typedArrayTags[setTag] =
	  typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
	
	  /** Used to identify `toStringTag` values supported by `_.clone`. */
	  var cloneableTags = {};
	  cloneableTags[argsTag] = cloneableTags[arrayTag] =
	  cloneableTags[arrayBufferTag] = cloneableTags[boolTag] =
	  cloneableTags[dateTag] = cloneableTags[float32Tag] =
	  cloneableTags[float64Tag] = cloneableTags[int8Tag] =
	  cloneableTags[int16Tag] = cloneableTags[int32Tag] =
	  cloneableTags[numberTag] = cloneableTags[objectTag] =
	  cloneableTags[regexpTag] = cloneableTags[stringTag] =
	  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
	  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
	  cloneableTags[errorTag] = cloneableTags[funcTag] =
	  cloneableTags[mapTag] = cloneableTags[setTag] =
	  cloneableTags[weakMapTag] = false;
	
	  /** Used to map latin-1 supplementary letters to basic latin letters. */
	  var deburredLetters = {
	    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
	    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
	    '\xc7': 'C',  '\xe7': 'c',
	    '\xd0': 'D',  '\xf0': 'd',
	    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
	    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
	    '\xcC': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
	    '\xeC': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
	    '\xd1': 'N',  '\xf1': 'n',
	    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
	    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
	    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
	    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
	    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
	    '\xc6': 'Ae', '\xe6': 'ae',
	    '\xde': 'Th', '\xfe': 'th',
	    '\xdf': 'ss'
	  };
	
	  /** Used to map characters to HTML entities. */
	  var htmlEscapes = {
	    '&': '&amp;',
	    '<': '&lt;',
	    '>': '&gt;',
	    '"': '&quot;',
	    "'": '&#39;',
	    '`': '&#96;'
	  };
	
	  /** Used to map HTML entities to characters. */
	  var htmlUnescapes = {
	    '&amp;': '&',
	    '&lt;': '<',
	    '&gt;': '>',
	    '&quot;': '"',
	    '&#39;': "'",
	    '&#96;': '`'
	  };
	
	  /** Used to determine if values are of the language type `Object`. */
	  var objectTypes = {
	    'function': true,
	    'object': true
	  };
	
	  /** Used to escape characters for inclusion in compiled regexes. */
	  var regexpEscapes = {
	    '0': 'x30', '1': 'x31', '2': 'x32', '3': 'x33', '4': 'x34',
	    '5': 'x35', '6': 'x36', '7': 'x37', '8': 'x38', '9': 'x39',
	    'A': 'x41', 'B': 'x42', 'C': 'x43', 'D': 'x44', 'E': 'x45', 'F': 'x46',
	    'a': 'x61', 'b': 'x62', 'c': 'x63', 'd': 'x64', 'e': 'x65', 'f': 'x66',
	    'n': 'x6e', 'r': 'x72', 't': 'x74', 'u': 'x75', 'v': 'x76', 'x': 'x78'
	  };
	
	  /** Used to escape characters for inclusion in compiled string literals. */
	  var stringEscapes = {
	    '\\': '\\',
	    "'": "'",
	    '\n': 'n',
	    '\r': 'r',
	    '\u2028': 'u2028',
	    '\u2029': 'u2029'
	  };
	
	  /** Detect free variable `exports`. */
	  var freeExports = objectTypes[typeof exports] && exports && !exports.nodeType && exports;
	
	  /** Detect free variable `module`. */
	  var freeModule = objectTypes[typeof module] && module && !module.nodeType && module;
	
	  /** Detect free variable `global` from Node.js. */
	  var freeGlobal = freeExports && freeModule && typeof global == 'object' && global && global.Object && global;
	
	  /** Detect free variable `self`. */
	  var freeSelf = objectTypes[typeof self] && self && self.Object && self;
	
	  /** Detect free variable `window`. */
	  var freeWindow = objectTypes[typeof window] && window && window.Object && window;
	
	  /** Detect the popular CommonJS extension `module.exports`. */
	  var moduleExports = freeModule && freeModule.exports === freeExports && freeExports;
	
	  /**
	   * Used as a reference to the global object.
	   *
	   * The `this` value is used if it's the global object to avoid Greasemonkey's
	   * restricted `window` object, otherwise the `window` object is used.
	   */
	  var root = freeGlobal || ((freeWindow !== (this && this.window)) && freeWindow) || freeSelf || this;
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * The base implementation of `compareAscending` which compares values and
	   * sorts them in ascending order without guaranteeing a stable sort.
	   *
	   * @private
	   * @param {*} value The value to compare.
	   * @param {*} other The other value to compare.
	   * @returns {number} Returns the sort order indicator for `value`.
	   */
	  function baseCompareAscending(value, other) {
	    if (value !== other) {
	      var valIsNull = value === null,
	          valIsUndef = value === undefined,
	          valIsReflexive = value === value;
	
	      var othIsNull = other === null,
	          othIsUndef = other === undefined,
	          othIsReflexive = other === other;
	
	      if ((value > other && !othIsNull) || !valIsReflexive ||
	          (valIsNull && !othIsUndef && othIsReflexive) ||
	          (valIsUndef && othIsReflexive)) {
	        return 1;
	      }
	      if ((value < other && !valIsNull) || !othIsReflexive ||
	          (othIsNull && !valIsUndef && valIsReflexive) ||
	          (othIsUndef && valIsReflexive)) {
	        return -1;
	      }
	    }
	    return 0;
	  }
	
	  /**
	   * The base implementation of `_.findIndex` and `_.findLastIndex` without
	   * support for callback shorthands and `this` binding.
	   *
	   * @private
	   * @param {Array} array The array to search.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {boolean} [fromRight] Specify iterating from right to left.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseFindIndex(array, predicate, fromRight) {
	    var length = array.length,
	        index = fromRight ? length : -1;
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (predicate(array[index], index, array)) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.indexOf` without support for binary searches.
	   *
	   * @private
	   * @param {Array} array The array to search.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseIndexOf(array, value, fromIndex) {
	    if (value !== value) {
	      return indexOfNaN(array, fromIndex);
	    }
	    var index = fromIndex - 1,
	        length = array.length;
	
	    while (++index < length) {
	      if (array[index] === value) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.isFunction` without support for environments
	   * with incorrect `typeof` results.
	   *
	   * @private
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	   */
	  function baseIsFunction(value) {
	    // Avoid a Chakra JIT bug in compatibility modes of IE 11.
	    // See https://github.com/jashkenas/underscore/issues/1621 for more details.
	    return typeof value == 'function' || false;
	  }
	
	  /**
	   * Converts `value` to a string if it's not one. An empty string is returned
	   * for `null` or `undefined` values.
	   *
	   * @private
	   * @param {*} value The value to process.
	   * @returns {string} Returns the string.
	   */
	  function baseToString(value) {
	    return value == null ? '' : (value + '');
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimLeft` to get the index of the first character
	   * of `string` that is not found in `chars`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @param {string} chars The characters to find.
	   * @returns {number} Returns the index of the first character not found in `chars`.
	   */
	  function charsLeftIndex(string, chars) {
	    var index = -1,
	        length = string.length;
	
	    while (++index < length && chars.indexOf(string.charAt(index)) > -1) {}
	    return index;
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimRight` to get the index of the last character
	   * of `string` that is not found in `chars`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @param {string} chars The characters to find.
	   * @returns {number} Returns the index of the last character not found in `chars`.
	   */
	  function charsRightIndex(string, chars) {
	    var index = string.length;
	
	    while (index-- && chars.indexOf(string.charAt(index)) > -1) {}
	    return index;
	  }
	
	  /**
	   * Used by `_.sortBy` to compare transformed elements of a collection and stable
	   * sort them in ascending order.
	   *
	   * @private
	   * @param {Object} object The object to compare.
	   * @param {Object} other The other object to compare.
	   * @returns {number} Returns the sort order indicator for `object`.
	   */
	  function compareAscending(object, other) {
	    return baseCompareAscending(object.criteria, other.criteria) || (object.index - other.index);
	  }
	
	  /**
	   * Used by `_.sortByOrder` to compare multiple properties of a value to another
	   * and stable sort them.
	   *
	   * If `orders` is unspecified, all valuess are sorted in ascending order. Otherwise,
	   * a value is sorted in ascending order if its corresponding order is "asc", and
	   * descending if "desc".
	   *
	   * @private
	   * @param {Object} object The object to compare.
	   * @param {Object} other The other object to compare.
	   * @param {boolean[]} orders The order to sort by for each property.
	   * @returns {number} Returns the sort order indicator for `object`.
	   */
	  function compareMultiple(object, other, orders) {
	    var index = -1,
	        objCriteria = object.criteria,
	        othCriteria = other.criteria,
	        length = objCriteria.length,
	        ordersLength = orders.length;
	
	    while (++index < length) {
	      var result = baseCompareAscending(objCriteria[index], othCriteria[index]);
	      if (result) {
	        if (index >= ordersLength) {
	          return result;
	        }
	        var order = orders[index];
	        return result * ((order === 'asc' || order === true) ? 1 : -1);
	      }
	    }
	    // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
	    // that causes it, under certain circumstances, to provide the same value for
	    // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
	    // for more details.
	    //
	    // This also ensures a stable sort in V8 and other engines.
	    // See https://code.google.com/p/v8/issues/detail?id=90 for more details.
	    return object.index - other.index;
	  }
	
	  /**
	   * Used by `_.deburr` to convert latin-1 supplementary letters to basic latin letters.
	   *
	   * @private
	   * @param {string} letter The matched letter to deburr.
	   * @returns {string} Returns the deburred letter.
	   */
	  function deburrLetter(letter) {
	    return deburredLetters[letter];
	  }
	
	  /**
	   * Used by `_.escape` to convert characters to HTML entities.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  function escapeHtmlChar(chr) {
	    return htmlEscapes[chr];
	  }
	
	  /**
	   * Used by `_.escapeRegExp` to escape characters for inclusion in compiled regexes.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @param {string} leadingChar The capture group for a leading character.
	   * @param {string} whitespaceChar The capture group for a whitespace character.
	   * @returns {string} Returns the escaped character.
	   */
	  function escapeRegExpChar(chr, leadingChar, whitespaceChar) {
	    if (leadingChar) {
	      chr = regexpEscapes[chr];
	    } else if (whitespaceChar) {
	      chr = stringEscapes[chr];
	    }
	    return '\\' + chr;
	  }
	
	  /**
	   * Used by `_.template` to escape characters for inclusion in compiled string literals.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  function escapeStringChar(chr) {
	    return '\\' + stringEscapes[chr];
	  }
	
	  /**
	   * Gets the index at which the first occurrence of `NaN` is found in `array`.
	   *
	   * @private
	   * @param {Array} array The array to search.
	   * @param {number} fromIndex The index to search from.
	   * @param {boolean} [fromRight] Specify iterating from right to left.
	   * @returns {number} Returns the index of the matched `NaN`, else `-1`.
	   */
	  function indexOfNaN(array, fromIndex, fromRight) {
	    var length = array.length,
	        index = fromIndex + (fromRight ? 0 : -1);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      var other = array[index];
	      if (other !== other) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * Checks if `value` is object-like.
	   *
	   * @private
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	   */
	  function isObjectLike(value) {
	    return !!value && typeof value == 'object';
	  }
	
	  /**
	   * Used by `trimmedLeftIndex` and `trimmedRightIndex` to determine if a
	   * character code is whitespace.
	   *
	   * @private
	   * @param {number} charCode The character code to inspect.
	   * @returns {boolean} Returns `true` if `charCode` is whitespace, else `false`.
	   */
	  function isSpace(charCode) {
	    return ((charCode <= 160 && (charCode >= 9 && charCode <= 13) || charCode == 32 || charCode == 160) || charCode == 5760 || charCode == 6158 ||
	      (charCode >= 8192 && (charCode <= 8202 || charCode == 8232 || charCode == 8233 || charCode == 8239 || charCode == 8287 || charCode == 12288 || charCode == 65279)));
	  }
	
	  /**
	   * Replaces all `placeholder` elements in `array` with an internal placeholder
	   * and returns an array of their indexes.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {*} placeholder The placeholder to replace.
	   * @returns {Array} Returns the new array of placeholder indexes.
	   */
	  function replaceHolders(array, placeholder) {
	    var index = -1,
	        length = array.length,
	        resIndex = -1,
	        result = [];
	
	    while (++index < length) {
	      if (array[index] === placeholder) {
	        array[index] = PLACEHOLDER;
	        result[++resIndex] = index;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * An implementation of `_.uniq` optimized for sorted arrays without support
	   * for callback shorthands and `this` binding.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {Function} [iteratee] The function invoked per iteration.
	   * @returns {Array} Returns the new duplicate-value-free array.
	   */
	  function sortedUniq(array, iteratee) {
	    var seen,
	        index = -1,
	        length = array.length,
	        resIndex = -1,
	        result = [];
	
	    while (++index < length) {
	      var value = array[index],
	          computed = iteratee ? iteratee(value, index, array) : value;
	
	      if (!index || seen !== computed) {
	        seen = computed;
	        result[++resIndex] = value;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimLeft` to get the index of the first non-whitespace
	   * character of `string`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {number} Returns the index of the first non-whitespace character.
	   */
	  function trimmedLeftIndex(string) {
	    var index = -1,
	        length = string.length;
	
	    while (++index < length && isSpace(string.charCodeAt(index))) {}
	    return index;
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimRight` to get the index of the last non-whitespace
	   * character of `string`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {number} Returns the index of the last non-whitespace character.
	   */
	  function trimmedRightIndex(string) {
	    var index = string.length;
	
	    while (index-- && isSpace(string.charCodeAt(index))) {}
	    return index;
	  }
	
	  /**
	   * Used by `_.unescape` to convert HTML entities to characters.
	   *
	   * @private
	   * @param {string} chr The matched character to unescape.
	   * @returns {string} Returns the unescaped character.
	   */
	  function unescapeHtmlChar(chr) {
	    return htmlUnescapes[chr];
	  }
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * Create a new pristine `lodash` function using the given `context` object.
	   *
	   * @static
	   * @memberOf _
	   * @category Utility
	   * @param {Object} [context=root] The context object.
	   * @returns {Function} Returns a new `lodash` function.
	   * @example
	   *
	   * _.mixin({ 'foo': _.constant('foo') });
	   *
	   * var lodash = _.runInContext();
	   * lodash.mixin({ 'bar': lodash.constant('bar') });
	   *
	   * _.isFunction(_.foo);
	   * // => true
	   * _.isFunction(_.bar);
	   * // => false
	   *
	   * lodash.isFunction(lodash.foo);
	   * // => false
	   * lodash.isFunction(lodash.bar);
	   * // => true
	   *
	   * // using `context` to mock `Date#getTime` use in `_.now`
	   * var mock = _.runInContext({
	   *   'Date': function() {
	   *     return { 'getTime': getTimeMock };
	   *   }
	   * });
	   *
	   * // or creating a suped-up `defer` in Node.js
	   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
	   */
	  function runInContext(context) {
	    // Avoid issues with some ES3 environments that attempt to use values, named
	    // after built-in constructors like `Object`, for the creation of literals.
	    // ES5 clears this up by stating that literals must use built-in constructors.
	    // See https://es5.github.io/#x11.1.5 for more details.
	    context = context ? _.defaults(root.Object(), context, _.pick(root, contextProps)) : root;
	
	    /** Native constructor references. */
	    var Array = context.Array,
	        Date = context.Date,
	        Error = context.Error,
	        Function = context.Function,
	        Math = context.Math,
	        Number = context.Number,
	        Object = context.Object,
	        RegExp = context.RegExp,
	        String = context.String,
	        TypeError = context.TypeError;
	
	    /** Used for native method references. */
	    var arrayProto = Array.prototype,
	        objectProto = Object.prototype,
	        stringProto = String.prototype;
	
	    /** Used to resolve the decompiled source of functions. */
	    var fnToString = Function.prototype.toString;
	
	    /** Used to check objects for own properties. */
	    var hasOwnProperty = objectProto.hasOwnProperty;
	
	    /** Used to generate unique IDs. */
	    var idCounter = 0;
	
	    /**
	     * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	     * of values.
	     */
	    var objToString = objectProto.toString;
	
	    /** Used to restore the original `_` reference in `_.noConflict`. */
	    var oldDash = root._;
	
	    /** Used to detect if a method is native. */
	    var reIsNative = RegExp('^' +
	      fnToString.call(hasOwnProperty).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
	      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	    );
	
	    /** Native method references. */
	    var ArrayBuffer = context.ArrayBuffer,
	        clearTimeout = context.clearTimeout,
	        parseFloat = context.parseFloat,
	        pow = Math.pow,
	        propertyIsEnumerable = objectProto.propertyIsEnumerable,
	        Set = getNative(context, 'Set'),
	        setTimeout = context.setTimeout,
	        splice = arrayProto.splice,
	        Uint8Array = context.Uint8Array,
	        WeakMap = getNative(context, 'WeakMap');
	
	    /* Native method references for those with the same name as other `lodash` methods. */
	    var nativeCeil = Math.ceil,
	        nativeCreate = getNative(Object, 'create'),
	        nativeFloor = Math.floor,
	        nativeIsArray = getNative(Array, 'isArray'),
	        nativeIsFinite = context.isFinite,
	        nativeKeys = getNative(Object, 'keys'),
	        nativeMax = Math.max,
	        nativeMin = Math.min,
	        nativeNow = getNative(Date, 'now'),
	        nativeParseInt = context.parseInt,
	        nativeRandom = Math.random;
	
	    /** Used as references for `-Infinity` and `Infinity`. */
	    var NEGATIVE_INFINITY = Number.NEGATIVE_INFINITY,
	        POSITIVE_INFINITY = Number.POSITIVE_INFINITY;
	
	    /** Used as references for the maximum length and index of an array. */
	    var MAX_ARRAY_LENGTH = 4294967295,
	        MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
	        HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
	
	    /**
	     * Used as the [maximum length](http://ecma-international.org/ecma-262/6.0/#sec-number.max_safe_integer)
	     * of an array-like value.
	     */
	    var MAX_SAFE_INTEGER = 9007199254740991;
	
	    /** Used to store function metadata. */
	    var metaMap = WeakMap && new WeakMap;
	
	    /** Used to lookup unminified function names. */
	    var realNames = {};
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` object which wraps `value` to enable implicit chaining.
	     * Methods that operate on and return arrays, collections, and functions can
	     * be chained together. Methods that retrieve a single value or may return a
	     * primitive value will automatically end the chain returning the unwrapped
	     * value. Explicit chaining may be enabled using `_.chain`. The execution of
	     * chained methods is lazy, that is, execution is deferred until `_#value`
	     * is implicitly or explicitly called.
	     *
	     * Lazy evaluation allows several methods to support shortcut fusion. Shortcut
	     * fusion is an optimization strategy which merge iteratee calls; this can help
	     * to avoid the creation of intermediate data structures and greatly reduce the
	     * number of iteratee executions.
	     *
	     * Chaining is supported in custom builds as long as the `_#value` method is
	     * directly or indirectly included in the build.
	     *
	     * In addition to lodash methods, wrappers have `Array` and `String` methods.
	     *
	     * The wrapper `Array` methods are:
	     * `concat`, `join`, `pop`, `push`, `reverse`, `shift`, `slice`, `sort`,
	     * `splice`, and `unshift`
	     *
	     * The wrapper `String` methods are:
	     * `replace` and `split`
	     *
	     * The wrapper methods that support shortcut fusion are:
	     * `compact`, `drop`, `dropRight`, `dropRightWhile`, `dropWhile`, `filter`,
	     * `first`, `initial`, `last`, `map`, `pluck`, `reject`, `rest`, `reverse`,
	     * `slice`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, `toArray`,
	     * and `where`
	     *
	     * The chainable wrapper methods are:
	     * `after`, `ary`, `assign`, `at`, `before`, `bind`, `bindAll`, `bindKey`,
	     * `callback`, `chain`, `chunk`, `commit`, `compact`, `concat`, `constant`,
	     * `countBy`, `create`, `curry`, `debounce`, `defaults`, `defaultsDeep`,
	     * `defer`, `delay`, `difference`, `drop`, `dropRight`, `dropRightWhile`,
	     * `dropWhile`, `fill`, `filter`, `flatten`, `flattenDeep`, `flow`, `flowRight`,
	     * `forEach`, `forEachRight`, `forIn`, `forInRight`, `forOwn`, `forOwnRight`,
	     * `functions`, `groupBy`, `indexBy`, `initial`, `intersection`, `invert`,
	     * `invoke`, `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`,
	     * `matchesProperty`, `memoize`, `merge`, `method`, `methodOf`, `mixin`,
	     * `modArgs`, `negate`, `omit`, `once`, `pairs`, `partial`, `partialRight`,
	     * `partition`, `pick`, `plant`, `pluck`, `property`, `propertyOf`, `pull`,
	     * `pullAt`, `push`, `range`, `rearg`, `reject`, `remove`, `rest`, `restParam`,
	     * `reverse`, `set`, `shuffle`, `slice`, `sort`, `sortBy`, `sortByAll`,
	     * `sortByOrder`, `splice`, `spread`, `take`, `takeRight`, `takeRightWhile`,
	     * `takeWhile`, `tap`, `throttle`, `thru`, `times`, `toArray`, `toPlainObject`,
	     * `transform`, `union`, `uniq`, `unshift`, `unzip`, `unzipWith`, `values`,
	     * `valuesIn`, `where`, `without`, `wrap`, `xor`, `zip`, `zipObject`, `zipWith`
	     *
	     * The wrapper methods that are **not** chainable by default are:
	     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clone`, `cloneDeep`,
	     * `deburr`, `endsWith`, `escape`, `escapeRegExp`, `every`, `find`, `findIndex`,
	     * `findKey`, `findLast`, `findLastIndex`, `findLastKey`, `findWhere`, `first`,
	     * `floor`, `get`, `gt`, `gte`, `has`, `identity`, `includes`, `indexOf`,
	     * `inRange`, `isArguments`, `isArray`, `isBoolean`, `isDate`, `isElement`,
	     * `isEmpty`, `isEqual`, `isError`, `isFinite` `isFunction`, `isMatch`,
	     * `isNative`, `isNaN`, `isNull`, `isNumber`, `isObject`, `isPlainObject`,
	     * `isRegExp`, `isString`, `isUndefined`, `isTypedArray`, `join`, `kebabCase`,
	     * `last`, `lastIndexOf`, `lt`, `lte`, `max`, `min`, `noConflict`, `noop`,
	     * `now`, `pad`, `padLeft`, `padRight`, `parseInt`, `pop`, `random`, `reduce`,
	     * `reduceRight`, `repeat`, `result`, `round`, `runInContext`, `shift`, `size`,
	     * `snakeCase`, `some`, `sortedIndex`, `sortedLastIndex`, `startCase`,
	     * `startsWith`, `sum`, `template`, `trim`, `trimLeft`, `trimRight`, `trunc`,
	     * `unescape`, `uniqueId`, `value`, and `words`
	     *
	     * The wrapper method `sample` will return a wrapped value when `n` is provided,
	     * otherwise an unwrapped value is returned.
	     *
	     * @name _
	     * @constructor
	     * @category Chain
	     * @param {*} value The value to wrap in a `lodash` instance.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var wrapped = _([1, 2, 3]);
	     *
	     * // returns an unwrapped value
	     * wrapped.reduce(function(total, n) {
	     *   return total + n;
	     * });
	     * // => 6
	     *
	     * // returns a wrapped value
	     * var squares = wrapped.map(function(n) {
	     *   return n * n;
	     * });
	     *
	     * _.isArray(squares);
	     * // => false
	     *
	     * _.isArray(squares.value());
	     * // => true
	     */
	    function lodash(value) {
	      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
	        if (value instanceof LodashWrapper) {
	          return value;
	        }
	        if (hasOwnProperty.call(value, '__chain__') && hasOwnProperty.call(value, '__wrapped__')) {
	          return wrapperClone(value);
	        }
	      }
	      return new LodashWrapper(value);
	    }
	
	    /**
	     * The function whose prototype all chaining wrappers inherit from.
	     *
	     * @private
	     */
	    function baseLodash() {
	      // No operation performed.
	    }
	
	    /**
	     * The base constructor for creating `lodash` wrapper objects.
	     *
	     * @private
	     * @param {*} value The value to wrap.
	     * @param {boolean} [chainAll] Enable chaining for all wrapper methods.
	     * @param {Array} [actions=[]] Actions to peform to resolve the unwrapped value.
	     */
	    function LodashWrapper(value, chainAll, actions) {
	      this.__wrapped__ = value;
	      this.__actions__ = actions || [];
	      this.__chain__ = !!chainAll;
	    }
	
	    /**
	     * An object environment feature flags.
	     *
	     * @static
	     * @memberOf _
	     * @type Object
	     */
	    var support = lodash.support = {};
	
	    /**
	     * By default, the template delimiters used by lodash are like those in
	     * embedded Ruby (ERB). Change the following template settings to use
	     * alternative delimiters.
	     *
	     * @static
	     * @memberOf _
	     * @type Object
	     */
	    lodash.templateSettings = {
	
	      /**
	       * Used to detect `data` property values to be HTML-escaped.
	       *
	       * @memberOf _.templateSettings
	       * @type RegExp
	       */
	      'escape': reEscape,
	
	      /**
	       * Used to detect code to be evaluated.
	       *
	       * @memberOf _.templateSettings
	       * @type RegExp
	       */
	      'evaluate': reEvaluate,
	
	      /**
	       * Used to detect `data` property values to inject.
	       *
	       * @memberOf _.templateSettings
	       * @type RegExp
	       */
	      'interpolate': reInterpolate,
	
	      /**
	       * Used to reference the data object in the template text.
	       *
	       * @memberOf _.templateSettings
	       * @type string
	       */
	      'variable': '',
	
	      /**
	       * Used to import variables into the compiled template.
	       *
	       * @memberOf _.templateSettings
	       * @type Object
	       */
	      'imports': {
	
	        /**
	         * A reference to the `lodash` function.
	         *
	         * @memberOf _.templateSettings.imports
	         * @type Function
	         */
	        '_': lodash
	      }
	    };
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
	     *
	     * @private
	     * @param {*} value The value to wrap.
	     */
	    function LazyWrapper(value) {
	      this.__wrapped__ = value;
	      this.__actions__ = [];
	      this.__dir__ = 1;
	      this.__filtered__ = false;
	      this.__iteratees__ = [];
	      this.__takeCount__ = POSITIVE_INFINITY;
	      this.__views__ = [];
	    }
	
	    /**
	     * Creates a clone of the lazy wrapper object.
	     *
	     * @private
	     * @name clone
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the cloned `LazyWrapper` object.
	     */
	    function lazyClone() {
	      var result = new LazyWrapper(this.__wrapped__);
	      result.__actions__ = arrayCopy(this.__actions__);
	      result.__dir__ = this.__dir__;
	      result.__filtered__ = this.__filtered__;
	      result.__iteratees__ = arrayCopy(this.__iteratees__);
	      result.__takeCount__ = this.__takeCount__;
	      result.__views__ = arrayCopy(this.__views__);
	      return result;
	    }
	
	    /**
	     * Reverses the direction of lazy iteration.
	     *
	     * @private
	     * @name reverse
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the new reversed `LazyWrapper` object.
	     */
	    function lazyReverse() {
	      if (this.__filtered__) {
	        var result = new LazyWrapper(this);
	        result.__dir__ = -1;
	        result.__filtered__ = true;
	      } else {
	        result = this.clone();
	        result.__dir__ *= -1;
	      }
	      return result;
	    }
	
	    /**
	     * Extracts the unwrapped value from its lazy wrapper.
	     *
	     * @private
	     * @name value
	     * @memberOf LazyWrapper
	     * @returns {*} Returns the unwrapped value.
	     */
	    function lazyValue() {
	      var array = this.__wrapped__.value(),
	          dir = this.__dir__,
	          isArr = isArray(array),
	          isRight = dir < 0,
	          arrLength = isArr ? array.length : 0,
	          view = getView(0, arrLength, this.__views__),
	          start = view.start,
	          end = view.end,
	          length = end - start,
	          index = isRight ? end : (start - 1),
	          iteratees = this.__iteratees__,
	          iterLength = iteratees.length,
	          resIndex = 0,
	          takeCount = nativeMin(length, this.__takeCount__);
	
	      if (!isArr || arrLength < LARGE_ARRAY_SIZE || (arrLength == length && takeCount == length)) {
	        return baseWrapperValue((isRight && isArr) ? array.reverse() : array, this.__actions__);
	      }
	      var result = [];
	
	      outer:
	      while (length-- && resIndex < takeCount) {
	        index += dir;
	
	        var iterIndex = -1,
	            value = array[index];
	
	        while (++iterIndex < iterLength) {
	          var data = iteratees[iterIndex],
	              iteratee = data.iteratee,
	              type = data.type,
	              computed = iteratee(value);
	
	          if (type == LAZY_MAP_FLAG) {
	            value = computed;
	          } else if (!computed) {
	            if (type == LAZY_FILTER_FLAG) {
	              continue outer;
	            } else {
	              break outer;
	            }
	          }
	        }
	        result[resIndex++] = value;
	      }
	      return result;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a cache object to store key/value pairs.
	     *
	     * @private
	     * @static
	     * @name Cache
	     * @memberOf _.memoize
	     */
	    function MapCache() {
	      this.__data__ = {};
	    }
	
	    /**
	     * Removes `key` and its value from the cache.
	     *
	     * @private
	     * @name delete
	     * @memberOf _.memoize.Cache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed successfully, else `false`.
	     */
	    function mapDelete(key) {
	      return this.has(key) && delete this.__data__[key];
	    }
	
	    /**
	     * Gets the cached value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf _.memoize.Cache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the cached value.
	     */
	    function mapGet(key) {
	      return key == '__proto__' ? undefined : this.__data__[key];
	    }
	
	    /**
	     * Checks if a cached value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf _.memoize.Cache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function mapHas(key) {
	      return key != '__proto__' && hasOwnProperty.call(this.__data__, key);
	    }
	
	    /**
	     * Sets `value` to `key` of the cache.
	     *
	     * @private
	     * @name set
	     * @memberOf _.memoize.Cache
	     * @param {string} key The key of the value to cache.
	     * @param {*} value The value to cache.
	     * @returns {Object} Returns the cache object.
	     */
	    function mapSet(key, value) {
	      if (key != '__proto__') {
	        this.__data__[key] = value;
	      }
	      return this;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     *
	     * Creates a cache object to store unique values.
	     *
	     * @private
	     * @param {Array} [values] The values to cache.
	     */
	    function SetCache(values) {
	      var length = values ? values.length : 0;
	
	      this.data = { 'hash': nativeCreate(null), 'set': new Set };
	      while (length--) {
	        this.push(values[length]);
	      }
	    }
	
	    /**
	     * Checks if `value` is in `cache` mimicking the return signature of
	     * `_.indexOf` by returning `0` if the value is found, else `-1`.
	     *
	     * @private
	     * @param {Object} cache The cache to search.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns `0` if `value` is found, else `-1`.
	     */
	    function cacheIndexOf(cache, value) {
	      var data = cache.data,
	          result = (typeof value == 'string' || isObject(value)) ? data.set.has(value) : data.hash[value];
	
	      return result ? 0 : -1;
	    }
	
	    /**
	     * Adds `value` to the cache.
	     *
	     * @private
	     * @name push
	     * @memberOf SetCache
	     * @param {*} value The value to cache.
	     */
	    function cachePush(value) {
	      var data = this.data;
	      if (typeof value == 'string' || isObject(value)) {
	        data.set.add(value);
	      } else {
	        data.hash[value] = true;
	      }
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a new array joining `array` with `other`.
	     *
	     * @private
	     * @param {Array} array The array to join.
	     * @param {Array} other The other array to join.
	     * @returns {Array} Returns the new concatenated array.
	     */
	    function arrayConcat(array, other) {
	      var index = -1,
	          length = array.length,
	          othIndex = -1,
	          othLength = other.length,
	          result = Array(length + othLength);
	
	      while (++index < length) {
	        result[index] = array[index];
	      }
	      while (++othIndex < othLength) {
	        result[index++] = other[othIndex];
	      }
	      return result;
	    }
	
	    /**
	     * Copies the values of `source` to `array`.
	     *
	     * @private
	     * @param {Array} source The array to copy values from.
	     * @param {Array} [array=[]] The array to copy values to.
	     * @returns {Array} Returns `array`.
	     */
	    function arrayCopy(source, array) {
	      var index = -1,
	          length = source.length;
	
	      array || (array = Array(length));
	      while (++index < length) {
	        array[index] = source[index];
	      }
	      return array;
	    }
	
	    /**
	     * A specialized version of `_.forEach` for arrays without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array} Returns `array`.
	     */
	    function arrayEach(array, iteratee) {
	      var index = -1,
	          length = array.length;
	
	      while (++index < length) {
	        if (iteratee(array[index], index, array) === false) {
	          break;
	        }
	      }
	      return array;
	    }
	
	    /**
	     * A specialized version of `_.forEachRight` for arrays without support for
	     * callback shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array} Returns `array`.
	     */
	    function arrayEachRight(array, iteratee) {
	      var length = array.length;
	
	      while (length--) {
	        if (iteratee(array[length], length, array) === false) {
	          break;
	        }
	      }
	      return array;
	    }
	
	    /**
	     * A specialized version of `_.every` for arrays without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`.
	     */
	    function arrayEvery(array, predicate) {
	      var index = -1,
	          length = array.length;
	
	      while (++index < length) {
	        if (!predicate(array[index], index, array)) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * A specialized version of `baseExtremum` for arrays which invokes `iteratee`
	     * with one argument: (value).
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} comparator The function used to compare values.
	     * @param {*} exValue The initial extremum value.
	     * @returns {*} Returns the extremum value.
	     */
	    function arrayExtremum(array, iteratee, comparator, exValue) {
	      var index = -1,
	          length = array.length,
	          computed = exValue,
	          result = computed;
	
	      while (++index < length) {
	        var value = array[index],
	            current = +iteratee(value);
	
	        if (comparator(current, computed)) {
	          computed = current;
	          result = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `_.filter` for arrays without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     */
	    function arrayFilter(array, predicate) {
	      var index = -1,
	          length = array.length,
	          resIndex = -1,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index];
	        if (predicate(value, index, array)) {
	          result[++resIndex] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `_.map` for arrays without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     */
	    function arrayMap(array, iteratee) {
	      var index = -1,
	          length = array.length,
	          result = Array(length);
	
	      while (++index < length) {
	        result[index] = iteratee(array[index], index, array);
	      }
	      return result;
	    }
	
	    /**
	     * Appends the elements of `values` to `array`.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to append.
	     * @returns {Array} Returns `array`.
	     */
	    function arrayPush(array, values) {
	      var index = -1,
	          length = values.length,
	          offset = array.length;
	
	      while (++index < length) {
	        array[offset + index] = values[index];
	      }
	      return array;
	    }
	
	    /**
	     * A specialized version of `_.reduce` for arrays without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @param {boolean} [initFromArray] Specify using the first element of `array`
	     *  as the initial value.
	     * @returns {*} Returns the accumulated value.
	     */
	    function arrayReduce(array, iteratee, accumulator, initFromArray) {
	      var index = -1,
	          length = array.length;
	
	      if (initFromArray && length) {
	        accumulator = array[++index];
	      }
	      while (++index < length) {
	        accumulator = iteratee(accumulator, array[index], index, array);
	      }
	      return accumulator;
	    }
	
	    /**
	     * A specialized version of `_.reduceRight` for arrays without support for
	     * callback shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @param {boolean} [initFromArray] Specify using the last element of `array`
	     *  as the initial value.
	     * @returns {*} Returns the accumulated value.
	     */
	    function arrayReduceRight(array, iteratee, accumulator, initFromArray) {
	      var length = array.length;
	      if (initFromArray && length) {
	        accumulator = array[--length];
	      }
	      while (length--) {
	        accumulator = iteratee(accumulator, array[length], length, array);
	      }
	      return accumulator;
	    }
	
	    /**
	     * A specialized version of `_.some` for arrays without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     */
	    function arraySome(array, predicate) {
	      var index = -1,
	          length = array.length;
	
	      while (++index < length) {
	        if (predicate(array[index], index, array)) {
	          return true;
	        }
	      }
	      return false;
	    }
	
	    /**
	     * A specialized version of `_.sum` for arrays without support for callback
	     * shorthands and `this` binding..
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {number} Returns the sum.
	     */
	    function arraySum(array, iteratee) {
	      var length = array.length,
	          result = 0;
	
	      while (length--) {
	        result += +iteratee(array[length]) || 0;
	      }
	      return result;
	    }
	
	    /**
	     * Used by `_.defaults` to customize its `_.assign` use.
	     *
	     * @private
	     * @param {*} objectValue The destination object property value.
	     * @param {*} sourceValue The source object property value.
	     * @returns {*} Returns the value to assign to the destination object.
	     */
	    function assignDefaults(objectValue, sourceValue) {
	      return objectValue === undefined ? sourceValue : objectValue;
	    }
	
	    /**
	     * Used by `_.template` to customize its `_.assign` use.
	     *
	     * **Note:** This function is like `assignDefaults` except that it ignores
	     * inherited property values when checking if a property is `undefined`.
	     *
	     * @private
	     * @param {*} objectValue The destination object property value.
	     * @param {*} sourceValue The source object property value.
	     * @param {string} key The key associated with the object and source values.
	     * @param {Object} object The destination object.
	     * @returns {*} Returns the value to assign to the destination object.
	     */
	    function assignOwnDefaults(objectValue, sourceValue, key, object) {
	      return (objectValue === undefined || !hasOwnProperty.call(object, key))
	        ? sourceValue
	        : objectValue;
	    }
	
	    /**
	     * A specialized version of `_.assign` for customizing assigned values without
	     * support for argument juggling, multiple sources, and `this` binding `customizer`
	     * functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {Function} customizer The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     */
	    function assignWith(object, source, customizer) {
	      var index = -1,
	          props = keys(source),
	          length = props.length;
	
	      while (++index < length) {
	        var key = props[index],
	            value = object[key],
	            result = customizer(value, source[key], key, object, source);
	
	        if ((result === result ? (result !== value) : (value === value)) ||
	            (value === undefined && !(key in object))) {
	          object[key] = result;
	        }
	      }
	      return object;
	    }
	
	    /**
	     * The base implementation of `_.assign` without support for argument juggling,
	     * multiple sources, and `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @returns {Object} Returns `object`.
	     */
	    function baseAssign(object, source) {
	      return source == null
	        ? object
	        : baseCopy(source, keys(source), object);
	    }
	
	    /**
	     * The base implementation of `_.at` without support for string collections
	     * and individual key arguments.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {number[]|string[]} props The property names or indexes of elements to pick.
	     * @returns {Array} Returns the new array of picked elements.
	     */
	    function baseAt(collection, props) {
	      var index = -1,
	          isNil = collection == null,
	          isArr = !isNil && isArrayLike(collection),
	          length = isArr ? collection.length : 0,
	          propsLength = props.length,
	          result = Array(propsLength);
	
	      while(++index < propsLength) {
	        var key = props[index];
	        if (isArr) {
	          result[index] = isIndex(key, length) ? collection[key] : undefined;
	        } else {
	          result[index] = isNil ? undefined : collection[key];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Copies properties of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy properties from.
	     * @param {Array} props The property names to copy.
	     * @param {Object} [object={}] The object to copy properties to.
	     * @returns {Object} Returns `object`.
	     */
	    function baseCopy(source, props, object) {
	      object || (object = {});
	
	      var index = -1,
	          length = props.length;
	
	      while (++index < length) {
	        var key = props[index];
	        object[key] = source[key];
	      }
	      return object;
	    }
	
	    /**
	     * The base implementation of `_.callback` which supports specifying the
	     * number of arguments to provide to `func`.
	     *
	     * @private
	     * @param {*} [func=_.identity] The value to convert to a callback.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {number} [argCount] The number of arguments to provide to `func`.
	     * @returns {Function} Returns the callback.
	     */
	    function baseCallback(func, thisArg, argCount) {
	      var type = typeof func;
	      if (type == 'function') {
	        return thisArg === undefined
	          ? func
	          : bindCallback(func, thisArg, argCount);
	      }
	      if (func == null) {
	        return identity;
	      }
	      if (type == 'object') {
	        return baseMatches(func);
	      }
	      return thisArg === undefined
	        ? property(func)
	        : baseMatchesProperty(func, thisArg);
	    }
	
	    /**
	     * The base implementation of `_.clone` without support for argument juggling
	     * and `this` binding `customizer` functions.
	     *
	     * @private
	     * @param {*} value The value to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @param {Function} [customizer] The function to customize cloning values.
	     * @param {string} [key] The key of `value`.
	     * @param {Object} [object] The object `value` belongs to.
	     * @param {Array} [stackA=[]] Tracks traversed source objects.
	     * @param {Array} [stackB=[]] Associates clones with source counterparts.
	     * @returns {*} Returns the cloned value.
	     */
	    function baseClone(value, isDeep, customizer, key, object, stackA, stackB) {
	      var result;
	      if (customizer) {
	        result = object ? customizer(value, key, object) : customizer(value);
	      }
	      if (result !== undefined) {
	        return result;
	      }
	      if (!isObject(value)) {
	        return value;
	      }
	      var isArr = isArray(value);
	      if (isArr) {
	        result = initCloneArray(value);
	        if (!isDeep) {
	          return arrayCopy(value, result);
	        }
	      } else {
	        var tag = objToString.call(value),
	            isFunc = tag == funcTag;
	
	        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
	          result = initCloneObject(isFunc ? {} : value);
	          if (!isDeep) {
	            return baseAssign(result, value);
	          }
	        } else {
	          return cloneableTags[tag]
	            ? initCloneByTag(value, tag, isDeep)
	            : (object ? value : {});
	        }
	      }
	      // Check for circular references and return its corresponding clone.
	      stackA || (stackA = []);
	      stackB || (stackB = []);
	
	      var length = stackA.length;
	      while (length--) {
	        if (stackA[length] == value) {
	          return stackB[length];
	        }
	      }
	      // Add the source value to the stack of traversed objects and associate it with its clone.
	      stackA.push(value);
	      stackB.push(result);
	
	      // Recursively populate clone (susceptible to call stack limits).
	      (isArr ? arrayEach : baseForOwn)(value, function(subValue, key) {
	        result[key] = baseClone(subValue, isDeep, customizer, key, value, stackA, stackB);
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.create` without support for assigning
	     * properties to the created object.
	     *
	     * @private
	     * @param {Object} prototype The object to inherit from.
	     * @returns {Object} Returns the new object.
	     */
	    var baseCreate = (function() {
	      function object() {}
	      return function(prototype) {
	        if (isObject(prototype)) {
	          object.prototype = prototype;
	          var result = new object;
	          object.prototype = undefined;
	        }
	        return result || {};
	      };
	    }());
	
	    /**
	     * The base implementation of `_.delay` and `_.defer` which accepts an index
	     * of where to slice the arguments to provide to `func`.
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {Object} args The arguments provide to `func`.
	     * @returns {number} Returns the timer id.
	     */
	    function baseDelay(func, wait, args) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return setTimeout(function() { func.apply(undefined, args); }, wait);
	    }
	
	    /**
	     * The base implementation of `_.difference` which accepts a single array
	     * of values to exclude.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Array} values The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     */
	    function baseDifference(array, values) {
	      var length = array ? array.length : 0,
	          result = [];
	
	      if (!length) {
	        return result;
	      }
	      var index = -1,
	          indexOf = getIndexOf(),
	          isCommon = indexOf == baseIndexOf,
	          cache = (isCommon && values.length >= LARGE_ARRAY_SIZE) ? createCache(values) : null,
	          valuesLength = values.length;
	
	      if (cache) {
	        indexOf = cacheIndexOf;
	        isCommon = false;
	        values = cache;
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index];
	
	        if (isCommon && value === value) {
	          var valuesIndex = valuesLength;
	          while (valuesIndex--) {
	            if (values[valuesIndex] === value) {
	              continue outer;
	            }
	          }
	          result.push(value);
	        }
	        else if (indexOf(values, value, 0) < 0) {
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.forEach` without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object|string} Returns `collection`.
	     */
	    var baseEach = createBaseEach(baseForOwn);
	
	    /**
	     * The base implementation of `_.forEachRight` without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object|string} Returns `collection`.
	     */
	    var baseEachRight = createBaseEach(baseForOwnRight, true);
	
	    /**
	     * The base implementation of `_.every` without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`
	     */
	    function baseEvery(collection, predicate) {
	      var result = true;
	      baseEach(collection, function(value, index, collection) {
	        result = !!predicate(value, index, collection);
	        return result;
	      });
	      return result;
	    }
	
	    /**
	     * Gets the extremum value of `collection` invoking `iteratee` for each value
	     * in `collection` to generate the criterion by which the value is ranked.
	     * The `iteratee` is invoked with three arguments: (value, index|key, collection).
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} comparator The function used to compare values.
	     * @param {*} exValue The initial extremum value.
	     * @returns {*} Returns the extremum value.
	     */
	    function baseExtremum(collection, iteratee, comparator, exValue) {
	      var computed = exValue,
	          result = computed;
	
	      baseEach(collection, function(value, index, collection) {
	        var current = +iteratee(value, index, collection);
	        if (comparator(current, computed) || (current === exValue && current === result)) {
	          computed = current;
	          result = value;
	        }
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.fill` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     */
	    function baseFill(array, value, start, end) {
	      var length = array.length;
	
	      start = start == null ? 0 : (+start || 0);
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = (end === undefined || end > length) ? length : (+end || 0);
	      if (end < 0) {
	        end += length;
	      }
	      length = start > end ? 0 : (end >>> 0);
	      start >>>= 0;
	
	      while (start < length) {
	        array[start++] = value;
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.filter` without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     */
	    function baseFilter(collection, predicate) {
	      var result = [];
	      baseEach(collection, function(value, index, collection) {
	        if (predicate(value, index, collection)) {
	          result.push(value);
	        }
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.find`, `_.findLast`, `_.findKey`, and `_.findLastKey`,
	     * without support for callback shorthands and `this` binding, which iterates
	     * over `collection` using the provided `eachFunc`.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to search.
	     * @param {Function} predicate The function invoked per iteration.
	     * @param {Function} eachFunc The function to iterate over `collection`.
	     * @param {boolean} [retKey] Specify returning the key of the found element
	     *  instead of the element itself.
	     * @returns {*} Returns the found element or its key, else `undefined`.
	     */
	    function baseFind(collection, predicate, eachFunc, retKey) {
	      var result;
	      eachFunc(collection, function(value, key, collection) {
	        if (predicate(value, key, collection)) {
	          result = retKey ? key : value;
	          return false;
	        }
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.flatten` with added support for restricting
	     * flattening and specifying the start index.
	     *
	     * @private
	     * @param {Array} array The array to flatten.
	     * @param {boolean} [isDeep] Specify a deep flatten.
	     * @param {boolean} [isStrict] Restrict flattening to arrays-like objects.
	     * @param {Array} [result=[]] The initial result value.
	     * @returns {Array} Returns the new flattened array.
	     */
	    function baseFlatten(array, isDeep, isStrict, result) {
	      result || (result = []);
	
	      var index = -1,
	          length = array.length;
	
	      while (++index < length) {
	        var value = array[index];
	        if (isObjectLike(value) && isArrayLike(value) &&
	            (isStrict || isArray(value) || isArguments(value))) {
	          if (isDeep) {
	            // Recursively flatten arrays (susceptible to call stack limits).
	            baseFlatten(value, isDeep, isStrict, result);
	          } else {
	            arrayPush(result, value);
	          }
	        } else if (!isStrict) {
	          result[result.length] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `baseForIn` and `baseForOwn` which iterates
	     * over `object` properties returned by `keysFunc` invoking `iteratee` for
	     * each property. Iteratee functions may exit iteration early by explicitly
	     * returning `false`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseFor = createBaseFor();
	
	    /**
	     * This function is like `baseFor` except that it iterates over properties
	     * in the opposite order.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseForRight = createBaseFor(true);
	
	    /**
	     * The base implementation of `_.forIn` without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForIn(object, iteratee) {
	      return baseFor(object, iteratee, keysIn);
	    }
	
	    /**
	     * The base implementation of `_.forOwn` without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwn(object, iteratee) {
	      return baseFor(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.forOwnRight` without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwnRight(object, iteratee) {
	      return baseForRight(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.functions` which creates an array of
	     * `object` function property names filtered from those provided.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Array} props The property names to filter.
	     * @returns {Array} Returns the new array of filtered property names.
	     */
	    function baseFunctions(object, props) {
	      var index = -1,
	          length = props.length,
	          resIndex = -1,
	          result = [];
	
	      while (++index < length) {
	        var key = props[index];
	        if (isFunction(object[key])) {
	          result[++resIndex] = key;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `get` without support for string paths
	     * and default values.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array} path The path of the property to get.
	     * @param {string} [pathKey] The key representation of path.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseGet(object, path, pathKey) {
	      if (object == null) {
	        return;
	      }
	      if (pathKey !== undefined && pathKey in toObject(object)) {
	        path = [pathKey];
	      }
	      var index = 0,
	          length = path.length;
	
	      while (object != null && index < length) {
	        object = object[path[index++]];
	      }
	      return (index && index == length) ? object : undefined;
	    }
	
	    /**
	     * The base implementation of `_.isEqual` without support for `this` binding
	     * `customizer` functions.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {Function} [customizer] The function to customize comparing values.
	     * @param {boolean} [isLoose] Specify performing partial comparisons.
	     * @param {Array} [stackA] Tracks traversed `value` objects.
	     * @param {Array} [stackB] Tracks traversed `other` objects.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     */
	    function baseIsEqual(value, other, customizer, isLoose, stackA, stackB) {
	      if (value === other) {
	        return true;
	      }
	      if (value == null || other == null || (!isObject(value) && !isObjectLike(other))) {
	        return value !== value && other !== other;
	      }
	      return baseIsEqualDeep(value, other, baseIsEqual, customizer, isLoose, stackA, stackB);
	    }
	
	    /**
	     * A specialized version of `baseIsEqual` for arrays and objects which performs
	     * deep comparisons and tracks traversed objects enabling objects with circular
	     * references to be compared.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Function} [customizer] The function to customize comparing objects.
	     * @param {boolean} [isLoose] Specify performing partial comparisons.
	     * @param {Array} [stackA=[]] Tracks traversed `value` objects.
	     * @param {Array} [stackB=[]] Tracks traversed `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function baseIsEqualDeep(object, other, equalFunc, customizer, isLoose, stackA, stackB) {
	      var objIsArr = isArray(object),
	          othIsArr = isArray(other),
	          objTag = arrayTag,
	          othTag = arrayTag;
	
	      if (!objIsArr) {
	        objTag = objToString.call(object);
	        if (objTag == argsTag) {
	          objTag = objectTag;
	        } else if (objTag != objectTag) {
	          objIsArr = isTypedArray(object);
	        }
	      }
	      if (!othIsArr) {
	        othTag = objToString.call(other);
	        if (othTag == argsTag) {
	          othTag = objectTag;
	        } else if (othTag != objectTag) {
	          othIsArr = isTypedArray(other);
	        }
	      }
	      var objIsObj = objTag == objectTag,
	          othIsObj = othTag == objectTag,
	          isSameTag = objTag == othTag;
	
	      if (isSameTag && !(objIsArr || objIsObj)) {
	        return equalByTag(object, other, objTag);
	      }
	      if (!isLoose) {
	        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	        if (objIsWrapped || othIsWrapped) {
	          return equalFunc(objIsWrapped ? object.value() : object, othIsWrapped ? other.value() : other, customizer, isLoose, stackA, stackB);
	        }
	      }
	      if (!isSameTag) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      // For more information on detecting circular references see https://es5.github.io/#JO.
	      stackA || (stackA = []);
	      stackB || (stackB = []);
	
	      var length = stackA.length;
	      while (length--) {
	        if (stackA[length] == object) {
	          return stackB[length] == other;
	        }
	      }
	      // Add `object` and `other` to the stack of traversed objects.
	      stackA.push(object);
	      stackB.push(other);
	
	      var result = (objIsArr ? equalArrays : equalObjects)(object, other, equalFunc, customizer, isLoose, stackA, stackB);
	
	      stackA.pop();
	      stackB.pop();
	
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.isMatch` without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Array} matchData The propery names, values, and compare flags to match.
	     * @param {Function} [customizer] The function to customize comparing objects.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     */
	    function baseIsMatch(object, matchData, customizer) {
	      var index = matchData.length,
	          length = index,
	          noCustomizer = !customizer;
	
	      if (object == null) {
	        return !length;
	      }
	      object = toObject(object);
	      while (index--) {
	        var data = matchData[index];
	        if ((noCustomizer && data[2])
	              ? data[1] !== object[data[0]]
	              : !(data[0] in object)
	            ) {
	          return false;
	        }
	      }
	      while (++index < length) {
	        data = matchData[index];
	        var key = data[0],
	            objValue = object[key],
	            srcValue = data[1];
	
	        if (noCustomizer && data[2]) {
	          if (objValue === undefined && !(key in object)) {
	            return false;
	          }
	        } else {
	          var result = customizer ? customizer(objValue, srcValue, key) : undefined;
	          if (!(result === undefined ? baseIsEqual(srcValue, objValue, customizer, true) : result)) {
	            return false;
	          }
	        }
	      }
	      return true;
	    }
	
	    /**
	     * The base implementation of `_.map` without support for callback shorthands
	     * and `this` binding.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     */
	    function baseMap(collection, iteratee) {
	      var index = -1,
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value, key, collection) {
	        result[++index] = iteratee(value, key, collection);
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.matches` which does not clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new function.
	     */
	    function baseMatches(source) {
	      var matchData = getMatchData(source);
	      if (matchData.length == 1 && matchData[0][2]) {
	        var key = matchData[0][0],
	            value = matchData[0][1];
	
	        return function(object) {
	          if (object == null) {
	            return false;
	          }
	          return object[key] === value && (value !== undefined || (key in toObject(object)));
	        };
	      }
	      return function(object) {
	        return baseIsMatch(object, matchData);
	      };
	    }
	
	    /**
	     * The base implementation of `_.matchesProperty` which does not clone `srcValue`.
	     *
	     * @private
	     * @param {string} path The path of the property to get.
	     * @param {*} srcValue The value to compare.
	     * @returns {Function} Returns the new function.
	     */
	    function baseMatchesProperty(path, srcValue) {
	      var isArr = isArray(path),
	          isCommon = isKey(path) && isStrictComparable(srcValue),
	          pathKey = (path + '');
	
	      path = toPath(path);
	      return function(object) {
	        if (object == null) {
	          return false;
	        }
	        var key = pathKey;
	        object = toObject(object);
	        if ((isArr || !isCommon) && !(key in object)) {
	          object = path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
	          if (object == null) {
	            return false;
	          }
	          key = last(path);
	          object = toObject(object);
	        }
	        return object[key] === srcValue
	          ? (srcValue !== undefined || (key in object))
	          : baseIsEqual(srcValue, object[key], undefined, true);
	      };
	    }
	
	    /**
	     * The base implementation of `_.merge` without support for argument juggling,
	     * multiple sources, and `this` binding `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {Function} [customizer] The function to customize merged values.
	     * @param {Array} [stackA=[]] Tracks traversed source objects.
	     * @param {Array} [stackB=[]] Associates values with source counterparts.
	     * @returns {Object} Returns `object`.
	     */
	    function baseMerge(object, source, customizer, stackA, stackB) {
	      if (!isObject(object)) {
	        return object;
	      }
	      var isSrcArr = isArrayLike(source) && (isArray(source) || isTypedArray(source)),
	          props = isSrcArr ? undefined : keys(source);
	
	      arrayEach(props || source, function(srcValue, key) {
	        if (props) {
	          key = srcValue;
	          srcValue = source[key];
	        }
	        if (isObjectLike(srcValue)) {
	          stackA || (stackA = []);
	          stackB || (stackB = []);
	          baseMergeDeep(object, source, key, baseMerge, customizer, stackA, stackB);
	        }
	        else {
	          var value = object[key],
	              result = customizer ? customizer(value, srcValue, key, object, source) : undefined,
	              isCommon = result === undefined;
	
	          if (isCommon) {
	            result = srcValue;
	          }
	          if ((result !== undefined || (isSrcArr && !(key in object))) &&
	              (isCommon || (result === result ? (result !== value) : (value === value)))) {
	            object[key] = result;
	          }
	        }
	      });
	      return object;
	    }
	
	    /**
	     * A specialized version of `baseMerge` for arrays and objects which performs
	     * deep merges and tracks traversed objects enabling objects with circular
	     * references to be merged.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {string} key The key of the value to merge.
	     * @param {Function} mergeFunc The function to merge values.
	     * @param {Function} [customizer] The function to customize merged values.
	     * @param {Array} [stackA=[]] Tracks traversed source objects.
	     * @param {Array} [stackB=[]] Associates values with source counterparts.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function baseMergeDeep(object, source, key, mergeFunc, customizer, stackA, stackB) {
	      var length = stackA.length,
	          srcValue = source[key];
	
	      while (length--) {
	        if (stackA[length] == srcValue) {
	          object[key] = stackB[length];
	          return;
	        }
	      }
	      var value = object[key],
	          result = customizer ? customizer(value, srcValue, key, object, source) : undefined,
	          isCommon = result === undefined;
	
	      if (isCommon) {
	        result = srcValue;
	        if (isArrayLike(srcValue) && (isArray(srcValue) || isTypedArray(srcValue))) {
	          result = isArray(value)
	            ? value
	            : (isArrayLike(value) ? arrayCopy(value) : []);
	        }
	        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
	          result = isArguments(value)
	            ? toPlainObject(value)
	            : (isPlainObject(value) ? value : {});
	        }
	        else {
	          isCommon = false;
	        }
	      }
	      // Add the source value to the stack of traversed objects and associate
	      // it with its merged value.
	      stackA.push(srcValue);
	      stackB.push(result);
	
	      if (isCommon) {
	        // Recursively merge objects and arrays (susceptible to call stack limits).
	        object[key] = mergeFunc(result, srcValue, customizer, stackA, stackB);
	      } else if (result === result ? (result !== value) : (value === value)) {
	        object[key] = result;
	      }
	    }
	
	    /**
	     * The base implementation of `_.property` without support for deep paths.
	     *
	     * @private
	     * @param {string} key The key of the property to get.
	     * @returns {Function} Returns the new function.
	     */
	    function baseProperty(key) {
	      return function(object) {
	        return object == null ? undefined : object[key];
	      };
	    }
	
	    /**
	     * A specialized version of `baseProperty` which supports deep paths.
	     *
	     * @private
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new function.
	     */
	    function basePropertyDeep(path) {
	      var pathKey = (path + '');
	      path = toPath(path);
	      return function(object) {
	        return baseGet(object, path, pathKey);
	      };
	    }
	
	    /**
	     * The base implementation of `_.pullAt` without support for individual
	     * index arguments and capturing the removed elements.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {number[]} indexes The indexes of elements to remove.
	     * @returns {Array} Returns `array`.
	     */
	    function basePullAt(array, indexes) {
	      var length = array ? indexes.length : 0;
	      while (length--) {
	        var index = indexes[length];
	        if (index != previous && isIndex(index)) {
	          var previous = index;
	          splice.call(array, index, 1);
	        }
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.random` without support for argument juggling
	     * and returning floating-point numbers.
	     *
	     * @private
	     * @param {number} min The minimum possible value.
	     * @param {number} max The maximum possible value.
	     * @returns {number} Returns the random number.
	     */
	    function baseRandom(min, max) {
	      return min + nativeFloor(nativeRandom() * (max - min + 1));
	    }
	
	    /**
	     * The base implementation of `_.reduce` and `_.reduceRight` without support
	     * for callback shorthands and `this` binding, which iterates over `collection`
	     * using the provided `eachFunc`.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {*} accumulator The initial value.
	     * @param {boolean} initFromCollection Specify using the first or last element
	     *  of `collection` as the initial value.
	     * @param {Function} eachFunc The function to iterate over `collection`.
	     * @returns {*} Returns the accumulated value.
	     */
	    function baseReduce(collection, iteratee, accumulator, initFromCollection, eachFunc) {
	      eachFunc(collection, function(value, index, collection) {
	        accumulator = initFromCollection
	          ? (initFromCollection = false, value)
	          : iteratee(accumulator, value, index, collection);
	      });
	      return accumulator;
	    }
	
	    /**
	     * The base implementation of `setData` without support for hot loop detection.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var baseSetData = !metaMap ? identity : function(func, data) {
	      metaMap.set(func, data);
	      return func;
	    };
	
	    /**
	     * The base implementation of `_.slice` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseSlice(array, start, end) {
	      var index = -1,
	          length = array.length;
	
	      start = start == null ? 0 : (+start || 0);
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = (end === undefined || end > length) ? length : (+end || 0);
	      if (end < 0) {
	        end += length;
	      }
	      length = start > end ? 0 : ((end - start) >>> 0);
	      start >>>= 0;
	
	      var result = Array(length);
	      while (++index < length) {
	        result[index] = array[index + start];
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.some` without support for callback shorthands
	     * and `this` binding.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     */
	    function baseSome(collection, predicate) {
	      var result;
	
	      baseEach(collection, function(value, index, collection) {
	        result = predicate(value, index, collection);
	        return !result;
	      });
	      return !!result;
	    }
	
	    /**
	     * The base implementation of `_.sortBy` which uses `comparer` to define
	     * the sort order of `array` and replaces criteria objects with their
	     * corresponding values.
	     *
	     * @private
	     * @param {Array} array The array to sort.
	     * @param {Function} comparer The function to define sort order.
	     * @returns {Array} Returns `array`.
	     */
	    function baseSortBy(array, comparer) {
	      var length = array.length;
	
	      array.sort(comparer);
	      while (length--) {
	        array[length] = array[length].value;
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.sortByOrder` without param guards.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
	     * @param {boolean[]} orders The sort orders of `iteratees`.
	     * @returns {Array} Returns the new sorted array.
	     */
	    function baseSortByOrder(collection, iteratees, orders) {
	      var callback = getCallback(),
	          index = -1;
	
	      iteratees = arrayMap(iteratees, function(iteratee) { return callback(iteratee); });
	
	      var result = baseMap(collection, function(value) {
	        var criteria = arrayMap(iteratees, function(iteratee) { return iteratee(value); });
	        return { 'criteria': criteria, 'index': ++index, 'value': value };
	      });
	
	      return baseSortBy(result, function(object, other) {
	        return compareMultiple(object, other, orders);
	      });
	    }
	
	    /**
	     * The base implementation of `_.sum` without support for callback shorthands
	     * and `this` binding.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {number} Returns the sum.
	     */
	    function baseSum(collection, iteratee) {
	      var result = 0;
	      baseEach(collection, function(value, index, collection) {
	        result += +iteratee(value, index, collection) || 0;
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.uniq` without support for callback shorthands
	     * and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The function invoked per iteration.
	     * @returns {Array} Returns the new duplicate-value-free array.
	     */
	    function baseUniq(array, iteratee) {
	      var index = -1,
	          indexOf = getIndexOf(),
	          length = array.length,
	          isCommon = indexOf == baseIndexOf,
	          isLarge = isCommon && length >= LARGE_ARRAY_SIZE,
	          seen = isLarge ? createCache() : null,
	          result = [];
	
	      if (seen) {
	        indexOf = cacheIndexOf;
	        isCommon = false;
	      } else {
	        isLarge = false;
	        seen = iteratee ? [] : result;
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value, index, array) : value;
	
	        if (isCommon && value === value) {
	          var seenIndex = seen.length;
	          while (seenIndex--) {
	            if (seen[seenIndex] === computed) {
	              continue outer;
	            }
	          }
	          if (iteratee) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	        else if (indexOf(seen, computed, 0) < 0) {
	          if (iteratee || isLarge) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.values` and `_.valuesIn` which creates an
	     * array of `object` property values corresponding to the property names
	     * of `props`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array} props The property names to get values for.
	     * @returns {Object} Returns the array of property values.
	     */
	    function baseValues(object, props) {
	      var index = -1,
	          length = props.length,
	          result = Array(length);
	
	      while (++index < length) {
	        result[index] = object[props[index]];
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.dropRightWhile`, `_.dropWhile`, `_.takeRightWhile`,
	     * and `_.takeWhile` without support for callback shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {Function} predicate The function invoked per iteration.
	     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseWhile(array, predicate, isDrop, fromRight) {
	      var length = array.length,
	          index = fromRight ? length : -1;
	
	      while ((fromRight ? index-- : ++index < length) && predicate(array[index], index, array)) {}
	      return isDrop
	        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
	        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
	    }
	
	    /**
	     * The base implementation of `wrapperValue` which returns the result of
	     * performing a sequence of actions on the unwrapped `value`, where each
	     * successive action is supplied the return value of the previous.
	     *
	     * @private
	     * @param {*} value The unwrapped value.
	     * @param {Array} actions Actions to peform to resolve the unwrapped value.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseWrapperValue(value, actions) {
	      var result = value;
	      if (result instanceof LazyWrapper) {
	        result = result.value();
	      }
	      var index = -1,
	          length = actions.length;
	
	      while (++index < length) {
	        var action = actions[index];
	        result = action.func.apply(action.thisArg, arrayPush([result], action.args));
	      }
	      return result;
	    }
	
	    /**
	     * Performs a binary search of `array` to determine the index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function binaryIndex(array, value, retHighest) {
	      var low = 0,
	          high = array ? array.length : low;
	
	      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
	        while (low < high) {
	          var mid = (low + high) >>> 1,
	              computed = array[mid];
	
	          if ((retHighest ? (computed <= value) : (computed < value)) && computed !== null) {
	            low = mid + 1;
	          } else {
	            high = mid;
	          }
	        }
	        return high;
	      }
	      return binaryIndexBy(array, value, identity, retHighest);
	    }
	
	    /**
	     * This function is like `binaryIndex` except that it invokes `iteratee` for
	     * `value` and each element of `array` to compute their sort ranking. The
	     * iteratee is invoked with one argument; (value).
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function binaryIndexBy(array, value, iteratee, retHighest) {
	      value = iteratee(value);
	
	      var low = 0,
	          high = array ? array.length : 0,
	          valIsNaN = value !== value,
	          valIsNull = value === null,
	          valIsUndef = value === undefined;
	
	      while (low < high) {
	        var mid = nativeFloor((low + high) / 2),
	            computed = iteratee(array[mid]),
	            isDef = computed !== undefined,
	            isReflexive = computed === computed;
	
	        if (valIsNaN) {
	          var setLow = isReflexive || retHighest;
	        } else if (valIsNull) {
	          setLow = isReflexive && isDef && (retHighest || computed != null);
	        } else if (valIsUndef) {
	          setLow = isReflexive && (retHighest || isDef);
	        } else if (computed == null) {
	          setLow = false;
	        } else {
	          setLow = retHighest ? (computed <= value) : (computed < value);
	        }
	        if (setLow) {
	          low = mid + 1;
	        } else {
	          high = mid;
	        }
	      }
	      return nativeMin(high, MAX_ARRAY_INDEX);
	    }
	
	    /**
	     * A specialized version of `baseCallback` which only supports `this` binding
	     * and specifying the number of arguments to provide to `func`.
	     *
	     * @private
	     * @param {Function} func The function to bind.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {number} [argCount] The number of arguments to provide to `func`.
	     * @returns {Function} Returns the callback.
	     */
	    function bindCallback(func, thisArg, argCount) {
	      if (typeof func != 'function') {
	        return identity;
	      }
	      if (thisArg === undefined) {
	        return func;
	      }
	      switch (argCount) {
	        case 1: return function(value) {
	          return func.call(thisArg, value);
	        };
	        case 3: return function(value, index, collection) {
	          return func.call(thisArg, value, index, collection);
	        };
	        case 4: return function(accumulator, value, index, collection) {
	          return func.call(thisArg, accumulator, value, index, collection);
	        };
	        case 5: return function(value, other, key, object, source) {
	          return func.call(thisArg, value, other, key, object, source);
	        };
	      }
	      return function() {
	        return func.apply(thisArg, arguments);
	      };
	    }
	
	    /**
	     * Creates a clone of the given array buffer.
	     *
	     * @private
	     * @param {ArrayBuffer} buffer The array buffer to clone.
	     * @returns {ArrayBuffer} Returns the cloned array buffer.
	     */
	    function bufferClone(buffer) {
	      var result = new ArrayBuffer(buffer.byteLength),
	          view = new Uint8Array(result);
	
	      view.set(new Uint8Array(buffer));
	      return result;
	    }
	
	    /**
	     * Creates an array that is the composition of partially applied arguments,
	     * placeholders, and provided arguments into a single array of arguments.
	     *
	     * @private
	     * @param {Array|Object} args The provided arguments.
	     * @param {Array} partials The arguments to prepend to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgs(args, partials, holders) {
	      var holdersLength = holders.length,
	          argsIndex = -1,
	          argsLength = nativeMax(args.length - holdersLength, 0),
	          leftIndex = -1,
	          leftLength = partials.length,
	          result = Array(leftLength + argsLength);
	
	      while (++leftIndex < leftLength) {
	        result[leftIndex] = partials[leftIndex];
	      }
	      while (++argsIndex < holdersLength) {
	        result[holders[argsIndex]] = args[argsIndex];
	      }
	      while (argsLength--) {
	        result[leftIndex++] = args[argsIndex++];
	      }
	      return result;
	    }
	
	    /**
	     * This function is like `composeArgs` except that the arguments composition
	     * is tailored for `_.partialRight`.
	     *
	     * @private
	     * @param {Array|Object} args The provided arguments.
	     * @param {Array} partials The arguments to append to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgsRight(args, partials, holders) {
	      var holdersIndex = -1,
	          holdersLength = holders.length,
	          argsIndex = -1,
	          argsLength = nativeMax(args.length - holdersLength, 0),
	          rightIndex = -1,
	          rightLength = partials.length,
	          result = Array(argsLength + rightLength);
	
	      while (++argsIndex < argsLength) {
	        result[argsIndex] = args[argsIndex];
	      }
	      var offset = argsIndex;
	      while (++rightIndex < rightLength) {
	        result[offset + rightIndex] = partials[rightIndex];
	      }
	      while (++holdersIndex < holdersLength) {
	        result[offset + holders[holdersIndex]] = args[argsIndex++];
	      }
	      return result;
	    }
	
	    /**
	     * Creates a `_.countBy`, `_.groupBy`, `_.indexBy`, or `_.partition` function.
	     *
	     * @private
	     * @param {Function} setter The function to set keys and values of the accumulator object.
	     * @param {Function} [initializer] The function to initialize the accumulator object.
	     * @returns {Function} Returns the new aggregator function.
	     */
	    function createAggregator(setter, initializer) {
	      return function(collection, iteratee, thisArg) {
	        var result = initializer ? initializer() : {};
	        iteratee = getCallback(iteratee, thisArg, 3);
	
	        if (isArray(collection)) {
	          var index = -1,
	              length = collection.length;
	
	          while (++index < length) {
	            var value = collection[index];
	            setter(result, value, iteratee(value, index, collection), collection);
	          }
	        } else {
	          baseEach(collection, function(value, key, collection) {
	            setter(result, value, iteratee(value, key, collection), collection);
	          });
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a `_.assign`, `_.defaults`, or `_.merge` function.
	     *
	     * @private
	     * @param {Function} assigner The function to assign values.
	     * @returns {Function} Returns the new assigner function.
	     */
	    function createAssigner(assigner) {
	      return restParam(function(object, sources) {
	        var index = -1,
	            length = object == null ? 0 : sources.length,
	            customizer = length > 2 ? sources[length - 2] : undefined,
	            guard = length > 2 ? sources[2] : undefined,
	            thisArg = length > 1 ? sources[length - 1] : undefined;
	
	        if (typeof customizer == 'function') {
	          customizer = bindCallback(customizer, thisArg, 5);
	          length -= 2;
	        } else {
	          customizer = typeof thisArg == 'function' ? thisArg : undefined;
	          length -= (customizer ? 1 : 0);
	        }
	        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	          customizer = length < 3 ? undefined : customizer;
	          length = 1;
	        }
	        while (++index < length) {
	          var source = sources[index];
	          if (source) {
	            assigner(object, source, customizer);
	          }
	        }
	        return object;
	      });
	    }
	
	    /**
	     * Creates a `baseEach` or `baseEachRight` function.
	     *
	     * @private
	     * @param {Function} eachFunc The function to iterate over a collection.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseEach(eachFunc, fromRight) {
	      return function(collection, iteratee) {
	        var length = collection ? getLength(collection) : 0;
	        if (!isLength(length)) {
	          return eachFunc(collection, iteratee);
	        }
	        var index = fromRight ? length : -1,
	            iterable = toObject(collection);
	
	        while ((fromRight ? index-- : ++index < length)) {
	          if (iteratee(iterable[index], index, iterable) === false) {
	            break;
	          }
	        }
	        return collection;
	      };
	    }
	
	    /**
	     * Creates a base function for `_.forIn` or `_.forInRight`.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseFor(fromRight) {
	      return function(object, iteratee, keysFunc) {
	        var iterable = toObject(object),
	            props = keysFunc(object),
	            length = props.length,
	            index = fromRight ? length : -1;
	
	        while ((fromRight ? index-- : ++index < length)) {
	          var key = props[index];
	          if (iteratee(iterable[key], key, iterable) === false) {
	            break;
	          }
	        }
	        return object;
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` and invokes it with the `this`
	     * binding of `thisArg`.
	     *
	     * @private
	     * @param {Function} func The function to bind.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @returns {Function} Returns the new bound function.
	     */
	    function createBindWrapper(func, thisArg) {
	      var Ctor = createCtorWrapper(func);
	
	      function wrapper() {
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return fn.apply(thisArg, arguments);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `Set` cache object to optimize linear searches of large arrays.
	     *
	     * @private
	     * @param {Array} [values] The values to cache.
	     * @returns {null|Object} Returns the new cache object if `Set` is supported, else `null`.
	     */
	    function createCache(values) {
	      return (nativeCreate && Set) ? new SetCache(values) : null;
	    }
	
	    /**
	     * Creates a function that produces compound words out of the words in a
	     * given string.
	     *
	     * @private
	     * @param {Function} callback The function to combine each word.
	     * @returns {Function} Returns the new compounder function.
	     */
	    function createCompounder(callback) {
	      return function(string) {
	        var index = -1,
	            array = words(deburr(string)),
	            length = array.length,
	            result = '';
	
	        while (++index < length) {
	          result = callback(result, array[index], index);
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function that produces an instance of `Ctor` regardless of
	     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
	     *
	     * @private
	     * @param {Function} Ctor The constructor to wrap.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createCtorWrapper(Ctor) {
	      return function() {
	        // Use a `switch` statement to work with class constructors.
	        // See http://ecma-international.org/ecma-262/6.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
	        // for more details.
	        var args = arguments;
	        switch (args.length) {
	          case 0: return new Ctor;
	          case 1: return new Ctor(args[0]);
	          case 2: return new Ctor(args[0], args[1]);
	          case 3: return new Ctor(args[0], args[1], args[2]);
	          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
	          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
	          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
	          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
	        }
	        var thisBinding = baseCreate(Ctor.prototype),
	            result = Ctor.apply(thisBinding, args);
	
	        // Mimic the constructor's `return` behavior.
	        // See https://es5.github.io/#x13.2.2 for more details.
	        return isObject(result) ? result : thisBinding;
	      };
	    }
	
	    /**
	     * Creates a `_.curry` or `_.curryRight` function.
	     *
	     * @private
	     * @param {boolean} flag The curry bit flag.
	     * @returns {Function} Returns the new curry function.
	     */
	    function createCurry(flag) {
	      function curryFunc(func, arity, guard) {
	        if (guard && isIterateeCall(func, arity, guard)) {
	          arity = undefined;
	        }
	        var result = createWrapper(func, flag, undefined, undefined, undefined, undefined, undefined, arity);
	        result.placeholder = curryFunc.placeholder;
	        return result;
	      }
	      return curryFunc;
	    }
	
	    /**
	     * Creates a `_.defaults` or `_.defaultsDeep` function.
	     *
	     * @private
	     * @param {Function} assigner The function to assign values.
	     * @param {Function} customizer The function to customize assigned values.
	     * @returns {Function} Returns the new defaults function.
	     */
	    function createDefaults(assigner, customizer) {
	      return restParam(function(args) {
	        var object = args[0];
	        if (object == null) {
	          return object;
	        }
	        args.push(customizer);
	        return assigner.apply(undefined, args);
	      });
	    }
	
	    /**
	     * Creates a `_.max` or `_.min` function.
	     *
	     * @private
	     * @param {Function} comparator The function used to compare values.
	     * @param {*} exValue The initial extremum value.
	     * @returns {Function} Returns the new extremum function.
	     */
	    function createExtremum(comparator, exValue) {
	      return function(collection, iteratee, thisArg) {
	        if (thisArg && isIterateeCall(collection, iteratee, thisArg)) {
	          iteratee = undefined;
	        }
	        iteratee = getCallback(iteratee, thisArg, 3);
	        if (iteratee.length == 1) {
	          collection = isArray(collection) ? collection : toIterable(collection);
	          var result = arrayExtremum(collection, iteratee, comparator, exValue);
	          if (!(collection.length && result === exValue)) {
	            return result;
	          }
	        }
	        return baseExtremum(collection, iteratee, comparator, exValue);
	      };
	    }
	
	    /**
	     * Creates a `_.find` or `_.findLast` function.
	     *
	     * @private
	     * @param {Function} eachFunc The function to iterate over a collection.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new find function.
	     */
	    function createFind(eachFunc, fromRight) {
	      return function(collection, predicate, thisArg) {
	        predicate = getCallback(predicate, thisArg, 3);
	        if (isArray(collection)) {
	          var index = baseFindIndex(collection, predicate, fromRight);
	          return index > -1 ? collection[index] : undefined;
	        }
	        return baseFind(collection, predicate, eachFunc);
	      };
	    }
	
	    /**
	     * Creates a `_.findIndex` or `_.findLastIndex` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new find function.
	     */
	    function createFindIndex(fromRight) {
	      return function(array, predicate, thisArg) {
	        if (!(array && array.length)) {
	          return -1;
	        }
	        predicate = getCallback(predicate, thisArg, 3);
	        return baseFindIndex(array, predicate, fromRight);
	      };
	    }
	
	    /**
	     * Creates a `_.findKey` or `_.findLastKey` function.
	     *
	     * @private
	     * @param {Function} objectFunc The function to iterate over an object.
	     * @returns {Function} Returns the new find function.
	     */
	    function createFindKey(objectFunc) {
	      return function(object, predicate, thisArg) {
	        predicate = getCallback(predicate, thisArg, 3);
	        return baseFind(object, predicate, objectFunc, true);
	      };
	    }
	
	    /**
	     * Creates a `_.flow` or `_.flowRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new flow function.
	     */
	    function createFlow(fromRight) {
	      return function() {
	        var wrapper,
	            length = arguments.length,
	            index = fromRight ? length : -1,
	            leftIndex = 0,
	            funcs = Array(length);
	
	        while ((fromRight ? index-- : ++index < length)) {
	          var func = funcs[leftIndex++] = arguments[index];
	          if (typeof func != 'function') {
	            throw new TypeError(FUNC_ERROR_TEXT);
	          }
	          if (!wrapper && LodashWrapper.prototype.thru && getFuncName(func) == 'wrapper') {
	            wrapper = new LodashWrapper([], true);
	          }
	        }
	        index = wrapper ? -1 : length;
	        while (++index < length) {
	          func = funcs[index];
	
	          var funcName = getFuncName(func),
	              data = funcName == 'wrapper' ? getData(func) : undefined;
	
	          if (data && isLaziable(data[0]) && data[1] == (ARY_FLAG | CURRY_FLAG | PARTIAL_FLAG | REARG_FLAG) && !data[4].length && data[9] == 1) {
	            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
	          } else {
	            wrapper = (func.length == 1 && isLaziable(func)) ? wrapper[funcName]() : wrapper.thru(func);
	          }
	        }
	        return function() {
	          var args = arguments,
	              value = args[0];
	
	          if (wrapper && args.length == 1 && isArray(value) && value.length >= LARGE_ARRAY_SIZE) {
	            return wrapper.plant(value).value();
	          }
	          var index = 0,
	              result = length ? funcs[index].apply(this, args) : value;
	
	          while (++index < length) {
	            result = funcs[index].call(this, result);
	          }
	          return result;
	        };
	      };
	    }
	
	    /**
	     * Creates a function for `_.forEach` or `_.forEachRight`.
	     *
	     * @private
	     * @param {Function} arrayFunc The function to iterate over an array.
	     * @param {Function} eachFunc The function to iterate over a collection.
	     * @returns {Function} Returns the new each function.
	     */
	    function createForEach(arrayFunc, eachFunc) {
	      return function(collection, iteratee, thisArg) {
	        return (typeof iteratee == 'function' && thisArg === undefined && isArray(collection))
	          ? arrayFunc(collection, iteratee)
	          : eachFunc(collection, bindCallback(iteratee, thisArg, 3));
	      };
	    }
	
	    /**
	     * Creates a function for `_.forIn` or `_.forInRight`.
	     *
	     * @private
	     * @param {Function} objectFunc The function to iterate over an object.
	     * @returns {Function} Returns the new each function.
	     */
	    function createForIn(objectFunc) {
	      return function(object, iteratee, thisArg) {
	        if (typeof iteratee != 'function' || thisArg !== undefined) {
	          iteratee = bindCallback(iteratee, thisArg, 3);
	        }
	        return objectFunc(object, iteratee, keysIn);
	      };
	    }
	
	    /**
	     * Creates a function for `_.forOwn` or `_.forOwnRight`.
	     *
	     * @private
	     * @param {Function} objectFunc The function to iterate over an object.
	     * @returns {Function} Returns the new each function.
	     */
	    function createForOwn(objectFunc) {
	      return function(object, iteratee, thisArg) {
	        if (typeof iteratee != 'function' || thisArg !== undefined) {
	          iteratee = bindCallback(iteratee, thisArg, 3);
	        }
	        return objectFunc(object, iteratee);
	      };
	    }
	
	    /**
	     * Creates a function for `_.mapKeys` or `_.mapValues`.
	     *
	     * @private
	     * @param {boolean} [isMapKeys] Specify mapping keys instead of values.
	     * @returns {Function} Returns the new map function.
	     */
	    function createObjectMapper(isMapKeys) {
	      return function(object, iteratee, thisArg) {
	        var result = {};
	        iteratee = getCallback(iteratee, thisArg, 3);
	
	        baseForOwn(object, function(value, key, object) {
	          var mapped = iteratee(value, key, object);
	          key = isMapKeys ? mapped : key;
	          value = isMapKeys ? value : mapped;
	          result[key] = value;
	        });
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function for `_.padLeft` or `_.padRight`.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify padding from the right.
	     * @returns {Function} Returns the new pad function.
	     */
	    function createPadDir(fromRight) {
	      return function(string, length, chars) {
	        string = baseToString(string);
	        return (fromRight ? string : '') + createPadding(string, length, chars) + (fromRight ? '' : string);
	      };
	    }
	
	    /**
	     * Creates a `_.partial` or `_.partialRight` function.
	     *
	     * @private
	     * @param {boolean} flag The partial bit flag.
	     * @returns {Function} Returns the new partial function.
	     */
	    function createPartial(flag) {
	      var partialFunc = restParam(function(func, partials) {
	        var holders = replaceHolders(partials, partialFunc.placeholder);
	        return createWrapper(func, flag, undefined, partials, holders);
	      });
	      return partialFunc;
	    }
	
	    /**
	     * Creates a function for `_.reduce` or `_.reduceRight`.
	     *
	     * @private
	     * @param {Function} arrayFunc The function to iterate over an array.
	     * @param {Function} eachFunc The function to iterate over a collection.
	     * @returns {Function} Returns the new each function.
	     */
	    function createReduce(arrayFunc, eachFunc) {
	      return function(collection, iteratee, accumulator, thisArg) {
	        var initFromArray = arguments.length < 3;
	        return (typeof iteratee == 'function' && thisArg === undefined && isArray(collection))
	          ? arrayFunc(collection, iteratee, accumulator, initFromArray)
	          : baseReduce(collection, getCallback(iteratee, thisArg, 4), accumulator, initFromArray, eachFunc);
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` and invokes it with optional `this`
	     * binding of, partial application, and currying.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to reference.
	     * @param {number} bitmask The bitmask of flags. See `createWrapper` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [partialsRight] The arguments to append to those provided to the new function.
	     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createHybridWrapper(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
	      var isAry = bitmask & ARY_FLAG,
	          isBind = bitmask & BIND_FLAG,
	          isBindKey = bitmask & BIND_KEY_FLAG,
	          isCurry = bitmask & CURRY_FLAG,
	          isCurryBound = bitmask & CURRY_BOUND_FLAG,
	          isCurryRight = bitmask & CURRY_RIGHT_FLAG,
	          Ctor = isBindKey ? undefined : createCtorWrapper(func);
	
	      function wrapper() {
	        // Avoid `arguments` object use disqualifying optimizations by
	        // converting it to an array before providing it to other functions.
	        var length = arguments.length,
	            index = length,
	            args = Array(length);
	
	        while (index--) {
	          args[index] = arguments[index];
	        }
	        if (partials) {
	          args = composeArgs(args, partials, holders);
	        }
	        if (partialsRight) {
	          args = composeArgsRight(args, partialsRight, holdersRight);
	        }
	        if (isCurry || isCurryRight) {
	          var placeholder = wrapper.placeholder,
	              argsHolders = replaceHolders(args, placeholder);
	
	          length -= argsHolders.length;
	          if (length < arity) {
	            var newArgPos = argPos ? arrayCopy(argPos) : undefined,
	                newArity = nativeMax(arity - length, 0),
	                newsHolders = isCurry ? argsHolders : undefined,
	                newHoldersRight = isCurry ? undefined : argsHolders,
	                newPartials = isCurry ? args : undefined,
	                newPartialsRight = isCurry ? undefined : args;
	
	            bitmask |= (isCurry ? PARTIAL_FLAG : PARTIAL_RIGHT_FLAG);
	            bitmask &= ~(isCurry ? PARTIAL_RIGHT_FLAG : PARTIAL_FLAG);
	
	            if (!isCurryBound) {
	              bitmask &= ~(BIND_FLAG | BIND_KEY_FLAG);
	            }
	            var newData = [func, bitmask, thisArg, newPartials, newsHolders, newPartialsRight, newHoldersRight, newArgPos, ary, newArity],
	                result = createHybridWrapper.apply(undefined, newData);
	
	            if (isLaziable(func)) {
	              setData(result, newData);
	            }
	            result.placeholder = placeholder;
	            return result;
	          }
	        }
	        var thisBinding = isBind ? thisArg : this,
	            fn = isBindKey ? thisBinding[func] : func;
	
	        if (argPos) {
	          args = reorder(args, argPos);
	        }
	        if (isAry && ary < args.length) {
	          args.length = ary;
	        }
	        if (this && this !== root && this instanceof wrapper) {
	          fn = Ctor || createCtorWrapper(func);
	        }
	        return fn.apply(thisBinding, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates the padding required for `string` based on the given `length`.
	     * The `chars` string is truncated if the number of characters exceeds `length`.
	     *
	     * @private
	     * @param {string} string The string to create padding for.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the pad for `string`.
	     */
	    function createPadding(string, length, chars) {
	      var strLength = string.length;
	      length = +length;
	
	      if (strLength >= length || !nativeIsFinite(length)) {
	        return '';
	      }
	      var padLength = length - strLength;
	      chars = chars == null ? ' ' : (chars + '');
	      return repeat(chars, nativeCeil(padLength / chars.length)).slice(0, padLength);
	    }
	
	    /**
	     * Creates a function that wraps `func` and invokes it with the optional `this`
	     * binding of `thisArg` and the `partials` prepended to those provided to
	     * the wrapper.
	     *
	     * @private
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {number} bitmask The bitmask of flags. See `createWrapper` for more details.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {Array} partials The arguments to prepend to those provided to the new function.
	     * @returns {Function} Returns the new bound function.
	     */
	    function createPartialWrapper(func, bitmask, thisArg, partials) {
	      var isBind = bitmask & BIND_FLAG,
	          Ctor = createCtorWrapper(func);
	
	      function wrapper() {
	        // Avoid `arguments` object use disqualifying optimizations by
	        // converting it to an array before providing it `func`.
	        var argsIndex = -1,
	            argsLength = arguments.length,
	            leftIndex = -1,
	            leftLength = partials.length,
	            args = Array(leftLength + argsLength);
	
	        while (++leftIndex < leftLength) {
	          args[leftIndex] = partials[leftIndex];
	        }
	        while (argsLength--) {
	          args[leftIndex++] = arguments[++argsIndex];
	        }
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return fn.apply(isBind ? thisArg : this, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `_.ceil`, `_.floor`, or `_.round` function.
	     *
	     * @private
	     * @param {string} methodName The name of the `Math` method to use when rounding.
	     * @returns {Function} Returns the new round function.
	     */
	    function createRound(methodName) {
	      var func = Math[methodName];
	      return function(number, precision) {
	        precision = precision === undefined ? 0 : (+precision || 0);
	        if (precision) {
	          precision = pow(10, precision);
	          return func(number * precision) / precision;
	        }
	        return func(number);
	      };
	    }
	
	    /**
	     * Creates a `_.sortedIndex` or `_.sortedLastIndex` function.
	     *
	     * @private
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {Function} Returns the new index function.
	     */
	    function createSortedIndex(retHighest) {
	      return function(array, value, iteratee, thisArg) {
	        var callback = getCallback(iteratee);
	        return (iteratee == null && callback === baseCallback)
	          ? binaryIndex(array, value, retHighest)
	          : binaryIndexBy(array, value, callback(iteratee, thisArg, 1), retHighest);
	      };
	    }
	
	    /**
	     * Creates a function that either curries or invokes `func` with optional
	     * `this` binding and partially applied arguments.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to reference.
	     * @param {number} bitmask The bitmask of flags.
	     *  The bitmask may be composed of the following flags:
	     *     1 - `_.bind`
	     *     2 - `_.bindKey`
	     *     4 - `_.curry` or `_.curryRight` of a bound function
	     *     8 - `_.curry`
	     *    16 - `_.curryRight`
	     *    32 - `_.partial`
	     *    64 - `_.partialRight`
	     *   128 - `_.rearg`
	     *   256 - `_.ary`
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to be partially applied.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createWrapper(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
	      var isBindKey = bitmask & BIND_KEY_FLAG;
	      if (!isBindKey && typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var length = partials ? partials.length : 0;
	      if (!length) {
	        bitmask &= ~(PARTIAL_FLAG | PARTIAL_RIGHT_FLAG);
	        partials = holders = undefined;
	      }
	      length -= (holders ? holders.length : 0);
	      if (bitmask & PARTIAL_RIGHT_FLAG) {
	        var partialsRight = partials,
	            holdersRight = holders;
	
	        partials = holders = undefined;
	      }
	      var data = isBindKey ? undefined : getData(func),
	          newData = [func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity];
	
	      if (data) {
	        mergeData(newData, data);
	        bitmask = newData[1];
	        arity = newData[9];
	      }
	      newData[9] = arity == null
	        ? (isBindKey ? 0 : func.length)
	        : (nativeMax(arity - length, 0) || 0);
	
	      if (bitmask == BIND_FLAG) {
	        var result = createBindWrapper(newData[0], newData[2]);
	      } else if ((bitmask == PARTIAL_FLAG || bitmask == (BIND_FLAG | PARTIAL_FLAG)) && !newData[4].length) {
	        result = createPartialWrapper.apply(undefined, newData);
	      } else {
	        result = createHybridWrapper.apply(undefined, newData);
	      }
	      var setter = data ? baseSetData : setData;
	      return setter(result, newData);
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for arrays with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Array} array The array to compare.
	     * @param {Array} other The other array to compare.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Function} [customizer] The function to customize comparing arrays.
	     * @param {boolean} [isLoose] Specify performing partial comparisons.
	     * @param {Array} [stackA] Tracks traversed `value` objects.
	     * @param {Array} [stackB] Tracks traversed `other` objects.
	     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	     */
	    function equalArrays(array, other, equalFunc, customizer, isLoose, stackA, stackB) {
	      var index = -1,
	          arrLength = array.length,
	          othLength = other.length;
	
	      if (arrLength != othLength && !(isLoose && othLength > arrLength)) {
	        return false;
	      }
	      // Ignore non-index properties.
	      while (++index < arrLength) {
	        var arrValue = array[index],
	            othValue = other[index],
	            result = customizer ? customizer(isLoose ? othValue : arrValue, isLoose ? arrValue : othValue, index) : undefined;
	
	        if (result !== undefined) {
	          if (result) {
	            continue;
	          }
	          return false;
	        }
	        // Recursively compare arrays (susceptible to call stack limits).
	        if (isLoose) {
	          if (!arraySome(other, function(othValue) {
	                return arrValue === othValue || equalFunc(arrValue, othValue, customizer, isLoose, stackA, stackB);
	              })) {
	            return false;
	          }
	        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, customizer, isLoose, stackA, stackB))) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for comparing objects of
	     * the same `toStringTag`.
	     *
	     * **Note:** This function only supports comparing values with tags of
	     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {string} tag The `toStringTag` of the objects to compare.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalByTag(object, other, tag) {
	      switch (tag) {
	        case boolTag:
	        case dateTag:
	          // Coerce dates and booleans to numbers, dates to milliseconds and booleans
	          // to `1` or `0` treating invalid dates coerced to `NaN` as not equal.
	          return +object == +other;
	
	        case errorTag:
	          return object.name == other.name && object.message == other.message;
	
	        case numberTag:
	          // Treat `NaN` vs. `NaN` as equal.
	          return (object != +object)
	            ? other != +other
	            : object == +other;
	
	        case regexpTag:
	        case stringTag:
	          // Coerce regexes to strings and treat strings primitives and string
	          // objects as equal. See https://es5.github.io/#x15.10.6.4 for more details.
	          return object == (other + '');
	      }
	      return false;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for objects with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Function} [customizer] The function to customize comparing values.
	     * @param {boolean} [isLoose] Specify performing partial comparisons.
	     * @param {Array} [stackA] Tracks traversed `value` objects.
	     * @param {Array} [stackB] Tracks traversed `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalObjects(object, other, equalFunc, customizer, isLoose, stackA, stackB) {
	      var objProps = keys(object),
	          objLength = objProps.length,
	          othProps = keys(other),
	          othLength = othProps.length;
	
	      if (objLength != othLength && !isLoose) {
	        return false;
	      }
	      var index = objLength;
	      while (index--) {
	        var key = objProps[index];
	        if (!(isLoose ? key in other : hasOwnProperty.call(other, key))) {
	          return false;
	        }
	      }
	      var skipCtor = isLoose;
	      while (++index < objLength) {
	        key = objProps[index];
	        var objValue = object[key],
	            othValue = other[key],
	            result = customizer ? customizer(isLoose ? othValue : objValue, isLoose? objValue : othValue, key) : undefined;
	
	        // Recursively compare objects (susceptible to call stack limits).
	        if (!(result === undefined ? equalFunc(objValue, othValue, customizer, isLoose, stackA, stackB) : result)) {
	          return false;
	        }
	        skipCtor || (skipCtor = key == 'constructor');
	      }
	      if (!skipCtor) {
	        var objCtor = object.constructor,
	            othCtor = other.constructor;
	
	        // Non `Object` object instances with different constructors are not equal.
	        if (objCtor != othCtor &&
	            ('constructor' in object && 'constructor' in other) &&
	            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * Gets the appropriate "callback" function. If the `_.callback` method is
	     * customized this function returns the custom method, otherwise it returns
	     * the `baseCallback` function. If arguments are provided the chosen function
	     * is invoked with them and its result is returned.
	     *
	     * @private
	     * @returns {Function} Returns the chosen function or its result.
	     */
	    function getCallback(func, thisArg, argCount) {
	      var result = lodash.callback || callback;
	      result = result === callback ? baseCallback : result;
	      return argCount ? result(func, thisArg, argCount) : result;
	    }
	
	    /**
	     * Gets metadata for `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {*} Returns the metadata for `func`.
	     */
	    var getData = !metaMap ? noop : function(func) {
	      return metaMap.get(func);
	    };
	
	    /**
	     * Gets the name of `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {string} Returns the function name.
	     */
	    function getFuncName(func) {
	      var result = func.name,
	          array = realNames[result],
	          length = array ? array.length : 0;
	
	      while (length--) {
	        var data = array[length],
	            otherFunc = data.func;
	        if (otherFunc == null || otherFunc == func) {
	          return data.name;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Gets the appropriate "indexOf" function. If the `_.indexOf` method is
	     * customized this function returns the custom method, otherwise it returns
	     * the `baseIndexOf` function. If arguments are provided the chosen function
	     * is invoked with them and its result is returned.
	     *
	     * @private
	     * @returns {Function|number} Returns the chosen function or its result.
	     */
	    function getIndexOf(collection, target, fromIndex) {
	      var result = lodash.indexOf || indexOf;
	      result = result === indexOf ? baseIndexOf : result;
	      return collection ? result(collection, target, fromIndex) : result;
	    }
	
	    /**
	     * Gets the "length" property value of `object`.
	     *
	     * **Note:** This function is used to avoid a [JIT bug](https://bugs.webkit.org/show_bug.cgi?id=142792)
	     * that affects Safari on at least iOS 8.1-8.3 ARM64.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {*} Returns the "length" value.
	     */
	    var getLength = baseProperty('length');
	
	    /**
	     * Gets the propery names, values, and compare flags of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the match data of `object`.
	     */
	    function getMatchData(object) {
	      var result = pairs(object),
	          length = result.length;
	
	      while (length--) {
	        result[length][2] = isStrictComparable(result[length][1]);
	      }
	      return result;
	    }
	
	    /**
	     * Gets the native function at `key` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {string} key The key of the method to get.
	     * @returns {*} Returns the function if it's native, else `undefined`.
	     */
	    function getNative(object, key) {
	      var value = object == null ? undefined : object[key];
	      return isNative(value) ? value : undefined;
	    }
	
	    /**
	     * Gets the view, applying any `transforms` to the `start` and `end` positions.
	     *
	     * @private
	     * @param {number} start The start of the view.
	     * @param {number} end The end of the view.
	     * @param {Array} transforms The transformations to apply to the view.
	     * @returns {Object} Returns an object containing the `start` and `end`
	     *  positions of the view.
	     */
	    function getView(start, end, transforms) {
	      var index = -1,
	          length = transforms.length;
	
	      while (++index < length) {
	        var data = transforms[index],
	            size = data.size;
	
	        switch (data.type) {
	          case 'drop':      start += size; break;
	          case 'dropRight': end -= size; break;
	          case 'take':      end = nativeMin(end, start + size); break;
	          case 'takeRight': start = nativeMax(start, end - size); break;
	        }
	      }
	      return { 'start': start, 'end': end };
	    }
	
	    /**
	     * Initializes an array clone.
	     *
	     * @private
	     * @param {Array} array The array to clone.
	     * @returns {Array} Returns the initialized clone.
	     */
	    function initCloneArray(array) {
	      var length = array.length,
	          result = new array.constructor(length);
	
	      // Add array properties assigned by `RegExp#exec`.
	      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
	        result.index = array.index;
	        result.input = array.input;
	      }
	      return result;
	    }
	
	    /**
	     * Initializes an object clone.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneObject(object) {
	      var Ctor = object.constructor;
	      if (!(typeof Ctor == 'function' && Ctor instanceof Ctor)) {
	        Ctor = Object;
	      }
	      return new Ctor;
	    }
	
	    /**
	     * Initializes an object clone based on its `toStringTag`.
	     *
	     * **Note:** This function only supports cloning values with tags of
	     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @param {string} tag The `toStringTag` of the object to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneByTag(object, tag, isDeep) {
	      var Ctor = object.constructor;
	      switch (tag) {
	        case arrayBufferTag:
	          return bufferClone(object);
	
	        case boolTag:
	        case dateTag:
	          return new Ctor(+object);
	
	        case float32Tag: case float64Tag:
	        case int8Tag: case int16Tag: case int32Tag:
	        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
	          var buffer = object.buffer;
	          return new Ctor(isDeep ? bufferClone(buffer) : buffer, object.byteOffset, object.length);
	
	        case numberTag:
	        case stringTag:
	          return new Ctor(object);
	
	        case regexpTag:
	          var result = new Ctor(object.source, reFlags.exec(object));
	          result.lastIndex = object.lastIndex;
	      }
	      return result;
	    }
	
	    /**
	     * Invokes the method at `path` on `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {Array} args The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     */
	    function invokePath(object, path, args) {
	      if (object != null && !isKey(path, object)) {
	        path = toPath(path);
	        object = path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
	        path = last(path);
	      }
	      var func = object == null ? object : object[path];
	      return func == null ? undefined : func.apply(object, args);
	    }
	
	    /**
	     * Checks if `value` is array-like.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	     */
	    function isArrayLike(value) {
	      return value != null && isLength(getLength(value));
	    }
	
	    /**
	     * Checks if `value` is a valid array-like index.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	     */
	    function isIndex(value, length) {
	      value = (typeof value == 'number' || reIsUint.test(value)) ? +value : -1;
	      length = length == null ? MAX_SAFE_INTEGER : length;
	      return value > -1 && value % 1 == 0 && value < length;
	    }
	
	    /**
	     * Checks if the provided arguments are from an iteratee call.
	     *
	     * @private
	     * @param {*} value The potential iteratee value argument.
	     * @param {*} index The potential iteratee index or key argument.
	     * @param {*} object The potential iteratee object argument.
	     * @returns {boolean} Returns `true` if the arguments are from an iteratee call, else `false`.
	     */
	    function isIterateeCall(value, index, object) {
	      if (!isObject(object)) {
	        return false;
	      }
	      var type = typeof index;
	      if (type == 'number'
	          ? (isArrayLike(object) && isIndex(index, object.length))
	          : (type == 'string' && index in object)) {
	        var other = object[index];
	        return value === value ? (value === other) : (other !== other);
	      }
	      return false;
	    }
	
	    /**
	     * Checks if `value` is a property name and not a property path.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	     */
	    function isKey(value, object) {
	      var type = typeof value;
	      if ((type == 'string' && reIsPlainProp.test(value)) || type == 'number') {
	        return true;
	      }
	      if (isArray(value)) {
	        return false;
	      }
	      var result = !reIsDeepProp.test(value);
	      return result || (object != null && value in toObject(object));
	    }
	
	    /**
	     * Checks if `func` has a lazy counterpart.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` has a lazy counterpart, else `false`.
	     */
	    function isLaziable(func) {
	      var funcName = getFuncName(func);
	      if (!(funcName in LazyWrapper.prototype)) {
	        return false;
	      }
	      var other = lodash[funcName];
	      if (func === other) {
	        return true;
	      }
	      var data = getData(other);
	      return !!data && func === data[0];
	    }
	
	    /**
	     * Checks if `value` is a valid array-like length.
	     *
	     * **Note:** This function is based on [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	     */
	    function isLength(value) {
	      return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	    }
	
	    /**
	     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` if suitable for strict
	     *  equality comparisons, else `false`.
	     */
	    function isStrictComparable(value) {
	      return value === value && !isObject(value);
	    }
	
	    /**
	     * Merges the function metadata of `source` into `data`.
	     *
	     * Merging metadata reduces the number of wrappers required to invoke a function.
	     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
	     * may be applied regardless of execution order. Methods like `_.ary` and `_.rearg`
	     * augment function arguments, making the order in which they are executed important,
	     * preventing the merging of metadata. However, we make an exception for a safe
	     * common case where curried functions have `_.ary` and or `_.rearg` applied.
	     *
	     * @private
	     * @param {Array} data The destination metadata.
	     * @param {Array} source The source metadata.
	     * @returns {Array} Returns `data`.
	     */
	    function mergeData(data, source) {
	      var bitmask = data[1],
	          srcBitmask = source[1],
	          newBitmask = bitmask | srcBitmask,
	          isCommon = newBitmask < ARY_FLAG;
	
	      var isCombo =
	        (srcBitmask == ARY_FLAG && bitmask == CURRY_FLAG) ||
	        (srcBitmask == ARY_FLAG && bitmask == REARG_FLAG && data[7].length <= source[8]) ||
	        (srcBitmask == (ARY_FLAG | REARG_FLAG) && bitmask == CURRY_FLAG);
	
	      // Exit early if metadata can't be merged.
	      if (!(isCommon || isCombo)) {
	        return data;
	      }
	      // Use source `thisArg` if available.
	      if (srcBitmask & BIND_FLAG) {
	        data[2] = source[2];
	        // Set when currying a bound function.
	        newBitmask |= (bitmask & BIND_FLAG) ? 0 : CURRY_BOUND_FLAG;
	      }
	      // Compose partial arguments.
	      var value = source[3];
	      if (value) {
	        var partials = data[3];
	        data[3] = partials ? composeArgs(partials, value, source[4]) : arrayCopy(value);
	        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : arrayCopy(source[4]);
	      }
	      // Compose partial right arguments.
	      value = source[5];
	      if (value) {
	        partials = data[5];
	        data[5] = partials ? composeArgsRight(partials, value, source[6]) : arrayCopy(value);
	        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : arrayCopy(source[6]);
	      }
	      // Use source `argPos` if available.
	      value = source[7];
	      if (value) {
	        data[7] = arrayCopy(value);
	      }
	      // Use source `ary` if it's smaller.
	      if (srcBitmask & ARY_FLAG) {
	        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
	      }
	      // Use source `arity` if one is not provided.
	      if (data[9] == null) {
	        data[9] = source[9];
	      }
	      // Use source `func` and merge bitmasks.
	      data[0] = source[0];
	      data[1] = newBitmask;
	
	      return data;
	    }
	
	    /**
	     * Used by `_.defaultsDeep` to customize its `_.merge` use.
	     *
	     * @private
	     * @param {*} objectValue The destination object property value.
	     * @param {*} sourceValue The source object property value.
	     * @returns {*} Returns the value to assign to the destination object.
	     */
	    function mergeDefaults(objectValue, sourceValue) {
	      return objectValue === undefined ? sourceValue : merge(objectValue, sourceValue, mergeDefaults);
	    }
	
	    /**
	     * A specialized version of `_.pick` which picks `object` properties specified
	     * by `props`.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} props The property names to pick.
	     * @returns {Object} Returns the new object.
	     */
	    function pickByArray(object, props) {
	      object = toObject(object);
	
	      var index = -1,
	          length = props.length,
	          result = {};
	
	      while (++index < length) {
	        var key = props[index];
	        if (key in object) {
	          result[key] = object[key];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `_.pick` which picks `object` properties `predicate`
	     * returns truthy for.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {Object} Returns the new object.
	     */
	    function pickByCallback(object, predicate) {
	      var result = {};
	      baseForIn(object, function(value, key, object) {
	        if (predicate(value, key, object)) {
	          result[key] = value;
	        }
	      });
	      return result;
	    }
	
	    /**
	     * Reorder `array` according to the specified indexes where the element at
	     * the first index is assigned as the first element, the element at
	     * the second index is assigned as the second element, and so on.
	     *
	     * @private
	     * @param {Array} array The array to reorder.
	     * @param {Array} indexes The arranged array indexes.
	     * @returns {Array} Returns `array`.
	     */
	    function reorder(array, indexes) {
	      var arrLength = array.length,
	          length = nativeMin(indexes.length, arrLength),
	          oldArray = arrayCopy(array);
	
	      while (length--) {
	        var index = indexes[length];
	        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
	      }
	      return array;
	    }
	
	    /**
	     * Sets metadata for `func`.
	     *
	     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
	     * period of time, it will trip its breaker and transition to an identity function
	     * to avoid garbage collection pauses in V8. See [V8 issue 2070](https://code.google.com/p/v8/issues/detail?id=2070)
	     * for more details.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var setData = (function() {
	      var count = 0,
	          lastCalled = 0;
	
	      return function(key, value) {
	        var stamp = now(),
	            remaining = HOT_SPAN - (stamp - lastCalled);
	
	        lastCalled = stamp;
	        if (remaining > 0) {
	          if (++count >= HOT_COUNT) {
	            return key;
	          }
	        } else {
	          count = 0;
	        }
	        return baseSetData(key, value);
	      };
	    }());
	
	    /**
	     * A fallback implementation of `Object.keys` which creates an array of the
	     * own enumerable property names of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function shimKeys(object) {
	      var props = keysIn(object),
	          propsLength = props.length,
	          length = propsLength && object.length;
	
	      var allowIndexes = !!length && isLength(length) &&
	        (isArray(object) || isArguments(object));
	
	      var index = -1,
	          result = [];
	
	      while (++index < propsLength) {
	        var key = props[index];
	        if ((allowIndexes && isIndex(key, length)) || hasOwnProperty.call(object, key)) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Converts `value` to an array-like object if it's not one.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {Array|Object} Returns the array-like object.
	     */
	    function toIterable(value) {
	      if (value == null) {
	        return [];
	      }
	      if (!isArrayLike(value)) {
	        return values(value);
	      }
	      return isObject(value) ? value : Object(value);
	    }
	
	    /**
	     * Converts `value` to an object if it's not one.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {Object} Returns the object.
	     */
	    function toObject(value) {
	      return isObject(value) ? value : Object(value);
	    }
	
	    /**
	     * Converts `value` to property path array if it's not one.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {Array} Returns the property path array.
	     */
	    function toPath(value) {
	      if (isArray(value)) {
	        return value;
	      }
	      var result = [];
	      baseToString(value).replace(rePropName, function(match, number, quote, string) {
	        result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
	      });
	      return result;
	    }
	
	    /**
	     * Creates a clone of `wrapper`.
	     *
	     * @private
	     * @param {Object} wrapper The wrapper to clone.
	     * @returns {Object} Returns the cloned wrapper.
	     */
	    function wrapperClone(wrapper) {
	      return wrapper instanceof LazyWrapper
	        ? wrapper.clone()
	        : new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__, arrayCopy(wrapper.__actions__));
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an array of elements split into groups the length of `size`.
	     * If `collection` can't be split evenly, the final chunk will be the remaining
	     * elements.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to process.
	     * @param {number} [size=1] The length of each chunk.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Array} Returns the new array containing chunks.
	     * @example
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 2);
	     * // => [['a', 'b'], ['c', 'd']]
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 3);
	     * // => [['a', 'b', 'c'], ['d']]
	     */
	    function chunk(array, size, guard) {
	      if (guard ? isIterateeCall(array, size, guard) : size == null) {
	        size = 1;
	      } else {
	        size = nativeMax(nativeFloor(size) || 1, 1);
	      }
	      var index = 0,
	          length = array ? array.length : 0,
	          resIndex = -1,
	          result = Array(nativeCeil(length / size));
	
	      while (index < length) {
	        result[++resIndex] = baseSlice(array, index, (index += size));
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array with all falsey values removed. The values `false`, `null`,
	     * `0`, `""`, `undefined`, and `NaN` are falsey.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to compact.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.compact([0, 1, false, 2, '', 3]);
	     * // => [1, 2, 3]
	     */
	    function compact(array) {
	      var index = -1,
	          length = array ? array.length : 0,
	          resIndex = -1,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index];
	        if (value) {
	          result[++resIndex] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array of unique `array` values not included in the other
	     * provided arrays using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The arrays of values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.difference([1, 2, 3], [4, 2]);
	     * // => [1, 3]
	     */
	    var difference = restParam(function(array, values) {
	      return (isObjectLike(array) && isArrayLike(array))
	        ? baseDifference(array, baseFlatten(values, false, true))
	        : [];
	    });
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.drop([1, 2, 3]);
	     * // => [2, 3]
	     *
	     * _.drop([1, 2, 3], 2);
	     * // => [3]
	     *
	     * _.drop([1, 2, 3], 5);
	     * // => []
	     *
	     * _.drop([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function drop(array, n, guard) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      if (guard ? isIterateeCall(array, n, guard) : n == null) {
	        n = 1;
	      }
	      return baseSlice(array, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the end.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.dropRight([1, 2, 3]);
	     * // => [1, 2]
	     *
	     * _.dropRight([1, 2, 3], 2);
	     * // => [1]
	     *
	     * _.dropRight([1, 2, 3], 5);
	     * // => []
	     *
	     * _.dropRight([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function dropRight(array, n, guard) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      if (guard ? isIterateeCall(array, n, guard) : n == null) {
	        n = 1;
	      }
	      n = length - (+n || 0);
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the end.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * bound to `thisArg` and invoked with three arguments: (value, index, array).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that match the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.dropRightWhile([1, 2, 3], function(n) {
	     *   return n > 1;
	     * });
	     * // => [1]
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * // using the `_.matches` callback shorthand
	     * _.pluck(_.dropRightWhile(users, { 'user': 'pebbles', 'active': false }), 'user');
	     * // => ['barney', 'fred']
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.pluck(_.dropRightWhile(users, 'active', false), 'user');
	     * // => ['barney']
	     *
	     * // using the `_.property` callback shorthand
	     * _.pluck(_.dropRightWhile(users, 'active'), 'user');
	     * // => ['barney', 'fred', 'pebbles']
	     */
	    function dropRightWhile(array, predicate, thisArg) {
	      return (array && array.length)
	        ? baseWhile(array, getCallback(predicate, thisArg, 3), true, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the beginning.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * bound to `thisArg` and invoked with three arguments: (value, index, array).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.dropWhile([1, 2, 3], function(n) {
	     *   return n < 3;
	     * });
	     * // => [3]
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * // using the `_.matches` callback shorthand
	     * _.pluck(_.dropWhile(users, { 'user': 'barney', 'active': false }), 'user');
	     * // => ['fred', 'pebbles']
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.pluck(_.dropWhile(users, 'active', false), 'user');
	     * // => ['pebbles']
	     *
	     * // using the `_.property` callback shorthand
	     * _.pluck(_.dropWhile(users, 'active'), 'user');
	     * // => ['barney', 'fred', 'pebbles']
	     */
	    function dropWhile(array, predicate, thisArg) {
	      return (array && array.length)
	        ? baseWhile(array, getCallback(predicate, thisArg, 3), true)
	        : [];
	    }
	
	    /**
	     * Fills elements of `array` with `value` from `start` up to, but not
	     * including, `end`.
	     *
	     * **Note:** This method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.fill(array, 'a');
	     * console.log(array);
	     * // => ['a', 'a', 'a']
	     *
	     * _.fill(Array(3), 2);
	     * // => [2, 2, 2]
	     *
	     * _.fill([4, 6, 8], '*', 1, 2);
	     * // => [4, '*', 8]
	     */
	    function fill(array, value, start, end) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
	        start = 0;
	        end = length;
	      }
	      return baseFill(array, value, start, end);
	    }
	
	    /**
	     * This method is like `_.find` except that it returns the index of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to search.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.findIndex(users, function(chr) {
	     *   return chr.user == 'barney';
	     * });
	     * // => 0
	     *
	     * // using the `_.matches` callback shorthand
	     * _.findIndex(users, { 'user': 'fred', 'active': false });
	     * // => 1
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.findIndex(users, 'active', false);
	     * // => 0
	     *
	     * // using the `_.property` callback shorthand
	     * _.findIndex(users, 'active');
	     * // => 2
	     */
	    var findIndex = createFindIndex();
	
	    /**
	     * This method is like `_.findIndex` except that it iterates over elements
	     * of `collection` from right to left.
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to search.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.findLastIndex(users, function(chr) {
	     *   return chr.user == 'pebbles';
	     * });
	     * // => 2
	     *
	     * // using the `_.matches` callback shorthand
	     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
	     * // => 0
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.findLastIndex(users, 'active', false);
	     * // => 2
	     *
	     * // using the `_.property` callback shorthand
	     * _.findLastIndex(users, 'active');
	     * // => 0
	     */
	    var findLastIndex = createFindIndex(true);
	
	    /**
	     * Gets the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @alias head
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the first element of `array`.
	     * @example
	     *
	     * _.first([1, 2, 3]);
	     * // => 1
	     *
	     * _.first([]);
	     * // => undefined
	     */
	    function first(array) {
	      return array ? array[0] : undefined;
	    }
	
	    /**
	     * Flattens a nested array. If `isDeep` is `true` the array is recursively
	     * flattened, otherwise it is only flattened a single level.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @param {boolean} [isDeep] Specify a deep flatten.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flatten([1, [2, 3, [4]]]);
	     * // => [1, 2, 3, [4]]
	     *
	     * // using `isDeep`
	     * _.flatten([1, [2, 3, [4]]], true);
	     * // => [1, 2, 3, 4]
	     */
	    function flatten(array, isDeep, guard) {
	      var length = array ? array.length : 0;
	      if (guard && isIterateeCall(array, isDeep, guard)) {
	        isDeep = false;
	      }
	      return length ? baseFlatten(array, isDeep) : [];
	    }
	
	    /**
	     * Recursively flattens a nested array.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to recursively flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flattenDeep([1, [2, 3, [4]]]);
	     * // => [1, 2, 3, 4]
	     */
	    function flattenDeep(array) {
	      var length = array ? array.length : 0;
	      return length ? baseFlatten(array, true) : [];
	    }
	
	    /**
	     * Gets the index at which the first occurrence of `value` is found in `array`
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons. If `fromIndex` is negative, it is used as the offset
	     * from the end of `array`. If `array` is sorted providing `true` for `fromIndex`
	     * performs a faster binary search.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to search.
	     * @param {*} value The value to search for.
	     * @param {boolean|number} [fromIndex=0] The index to search from or `true`
	     *  to perform a binary search on a sorted array.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.indexOf([1, 2, 1, 2], 2);
	     * // => 1
	     *
	     * // using `fromIndex`
	     * _.indexOf([1, 2, 1, 2], 2, 2);
	     * // => 3
	     *
	     * // performing a binary search
	     * _.indexOf([1, 1, 2, 2], 2, true);
	     * // => 2
	     */
	    function indexOf(array, value, fromIndex) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return -1;
	      }
	      if (typeof fromIndex == 'number') {
	        fromIndex = fromIndex < 0 ? nativeMax(length + fromIndex, 0) : fromIndex;
	      } else if (fromIndex) {
	        var index = binaryIndex(array, value);
	        if (index < length &&
	            (value === value ? (value === array[index]) : (array[index] !== array[index]))) {
	          return index;
	        }
	        return -1;
	      }
	      return baseIndexOf(array, value, fromIndex || 0);
	    }
	
	    /**
	     * Gets all but the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.initial([1, 2, 3]);
	     * // => [1, 2]
	     */
	    function initial(array) {
	      return dropRight(array, 1);
	    }
	
	    /**
	     * Creates an array of unique values that are included in all of the provided
	     * arrays using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of shared values.
	     * @example
	     * _.intersection([1, 2], [4, 2], [2, 1]);
	     * // => [2]
	     */
	    var intersection = restParam(function(arrays) {
	      var othLength = arrays.length,
	          othIndex = othLength,
	          caches = Array(length),
	          indexOf = getIndexOf(),
	          isCommon = indexOf == baseIndexOf,
	          result = [];
	
	      while (othIndex--) {
	        var value = arrays[othIndex] = isArrayLike(value = arrays[othIndex]) ? value : [];
	        caches[othIndex] = (isCommon && value.length >= 120) ? createCache(othIndex && value) : null;
	      }
	      var array = arrays[0],
	          index = -1,
	          length = array ? array.length : 0,
	          seen = caches[0];
	
	      outer:
	      while (++index < length) {
	        value = array[index];
	        if ((seen ? cacheIndexOf(seen, value) : indexOf(result, value, 0)) < 0) {
	          var othIndex = othLength;
	          while (--othIndex) {
	            var cache = caches[othIndex];
	            if ((cache ? cacheIndexOf(cache, value) : indexOf(arrays[othIndex], value, 0)) < 0) {
	              continue outer;
	            }
	          }
	          if (seen) {
	            seen.push(value);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    });
	
	    /**
	     * Gets the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the last element of `array`.
	     * @example
	     *
	     * _.last([1, 2, 3]);
	     * // => 3
	     */
	    function last(array) {
	      var length = array ? array.length : 0;
	      return length ? array[length - 1] : undefined;
	    }
	
	    /**
	     * This method is like `_.indexOf` except that it iterates over elements of
	     * `array` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to search.
	     * @param {*} value The value to search for.
	     * @param {boolean|number} [fromIndex=array.length-1] The index to search from
	     *  or `true` to perform a binary search on a sorted array.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.lastIndexOf([1, 2, 1, 2], 2);
	     * // => 3
	     *
	     * // using `fromIndex`
	     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
	     * // => 1
	     *
	     * // performing a binary search
	     * _.lastIndexOf([1, 1, 2, 2], 2, true);
	     * // => 3
	     */
	    function lastIndexOf(array, value, fromIndex) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return -1;
	      }
	      var index = length;
	      if (typeof fromIndex == 'number') {
	        index = (fromIndex < 0 ? nativeMax(length + fromIndex, 0) : nativeMin(fromIndex || 0, length - 1)) + 1;
	      } else if (fromIndex) {
	        index = binaryIndex(array, value, true) - 1;
	        var other = array[index];
	        if (value === value ? (value === other) : (other !== other)) {
	          return index;
	        }
	        return -1;
	      }
	      if (value !== value) {
	        return indexOfNaN(array, index, true);
	      }
	      while (index--) {
	        if (array[index] === value) {
	          return index;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * Removes all provided values from `array` using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.without`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...*} [values] The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3, 1, 2, 3];
	     *
	     * _.pull(array, 2, 3);
	     * console.log(array);
	     * // => [1, 1]
	     */
	    function pull() {
	      var args = arguments,
	          array = args[0];
	
	      if (!(array && array.length)) {
	        return array;
	      }
	      var index = 0,
	          indexOf = getIndexOf(),
	          length = args.length;
	
	      while (++index < length) {
	        var fromIndex = 0,
	            value = args[index];
	
	        while ((fromIndex = indexOf(array, value, fromIndex)) > -1) {
	          splice.call(array, fromIndex, 1);
	        }
	      }
	      return array;
	    }
	
	    /**
	     * Removes elements from `array` corresponding to the given indexes and returns
	     * an array of the removed elements. Indexes may be specified as an array of
	     * indexes or as individual arguments.
	     *
	     * **Note:** Unlike `_.at`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...(number|number[])} [indexes] The indexes of elements to remove,
	     *  specified as individual indexes or arrays of indexes.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = [5, 10, 15, 20];
	     * var evens = _.pullAt(array, 1, 3);
	     *
	     * console.log(array);
	     * // => [5, 15]
	     *
	     * console.log(evens);
	     * // => [10, 20]
	     */
	    var pullAt = restParam(function(array, indexes) {
	      indexes = baseFlatten(indexes);
	
	      var result = baseAt(array, indexes);
	      basePullAt(array, indexes.sort(baseCompareAscending));
	      return result;
	    });
	
	    /**
	     * Removes all elements from `array` that `predicate` returns truthy for
	     * and returns an array of the removed elements. The predicate is bound to
	     * `thisArg` and invoked with three arguments: (value, index, array).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * **Note:** Unlike `_.filter`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = [1, 2, 3, 4];
	     * var evens = _.remove(array, function(n) {
	     *   return n % 2 == 0;
	     * });
	     *
	     * console.log(array);
	     * // => [1, 3]
	     *
	     * console.log(evens);
	     * // => [2, 4]
	     */
	    function remove(array, predicate, thisArg) {
	      var result = [];
	      if (!(array && array.length)) {
	        return result;
	      }
	      var index = -1,
	          indexes = [],
	          length = array.length;
	
	      predicate = getCallback(predicate, thisArg, 3);
	      while (++index < length) {
	        var value = array[index];
	        if (predicate(value, index, array)) {
	          result.push(value);
	          indexes.push(index);
	        }
	      }
	      basePullAt(array, indexes);
	      return result;
	    }
	
	    /**
	     * Gets all but the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @alias tail
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.rest([1, 2, 3]);
	     * // => [2, 3]
	     */
	    function rest(array) {
	      return drop(array, 1);
	    }
	
	    /**
	     * Creates a slice of `array` from `start` up to, but not including, `end`.
	     *
	     * **Note:** This method is used instead of `Array#slice` to support node
	     * lists in IE < 9 and to ensure dense arrays are returned.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function slice(array, start, end) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
	        start = 0;
	        end = length;
	      }
	      return baseSlice(array, start, end);
	    }
	
	    /**
	     * Uses a binary search to determine the lowest index at which `value` should
	     * be inserted into `array` in order to maintain its sort order. If an iteratee
	     * function is provided it is invoked for `value` and each element of `array`
	     * to compute their sort ranking. The iteratee is bound to `thisArg` and
	     * invoked with one argument; (value).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedIndex([30, 50], 40);
	     * // => 1
	     *
	     * _.sortedIndex([4, 4, 5, 5], 5);
	     * // => 2
	     *
	     * var dict = { 'data': { 'thirty': 30, 'forty': 40, 'fifty': 50 } };
	     *
	     * // using an iteratee function
	     * _.sortedIndex(['thirty', 'fifty'], 'forty', function(word) {
	     *   return this.data[word];
	     * }, dict);
	     * // => 1
	     *
	     * // using the `_.property` callback shorthand
	     * _.sortedIndex([{ 'x': 30 }, { 'x': 50 }], { 'x': 40 }, 'x');
	     * // => 1
	     */
	    var sortedIndex = createSortedIndex();
	
	    /**
	     * This method is like `_.sortedIndex` except that it returns the highest
	     * index at which `value` should be inserted into `array` in order to
	     * maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedLastIndex([4, 4, 5, 5], 5);
	     * // => 4
	     */
	    var sortedLastIndex = createSortedIndex(true);
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.take([1, 2, 3]);
	     * // => [1]
	     *
	     * _.take([1, 2, 3], 2);
	     * // => [1, 2]
	     *
	     * _.take([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.take([1, 2, 3], 0);
	     * // => []
	     */
	    function take(array, n, guard) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      if (guard ? isIterateeCall(array, n, guard) : n == null) {
	        n = 1;
	      }
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the end.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.takeRight([1, 2, 3]);
	     * // => [3]
	     *
	     * _.takeRight([1, 2, 3], 2);
	     * // => [2, 3]
	     *
	     * _.takeRight([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.takeRight([1, 2, 3], 0);
	     * // => []
	     */
	    function takeRight(array, n, guard) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      if (guard ? isIterateeCall(array, n, guard) : n == null) {
	        n = 1;
	      }
	      n = length - (+n || 0);
	      return baseSlice(array, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the end. Elements are
	     * taken until `predicate` returns falsey. The predicate is bound to `thisArg`
	     * and invoked with three arguments: (value, index, array).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.takeRightWhile([1, 2, 3], function(n) {
	     *   return n > 1;
	     * });
	     * // => [2, 3]
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * // using the `_.matches` callback shorthand
	     * _.pluck(_.takeRightWhile(users, { 'user': 'pebbles', 'active': false }), 'user');
	     * // => ['pebbles']
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.pluck(_.takeRightWhile(users, 'active', false), 'user');
	     * // => ['fred', 'pebbles']
	     *
	     * // using the `_.property` callback shorthand
	     * _.pluck(_.takeRightWhile(users, 'active'), 'user');
	     * // => []
	     */
	    function takeRightWhile(array, predicate, thisArg) {
	      return (array && array.length)
	        ? baseWhile(array, getCallback(predicate, thisArg, 3), false, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the beginning. Elements
	     * are taken until `predicate` returns falsey. The predicate is bound to
	     * `thisArg` and invoked with three arguments: (value, index, array).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.takeWhile([1, 2, 3], function(n) {
	     *   return n < 3;
	     * });
	     * // => [1, 2]
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false},
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * // using the `_.matches` callback shorthand
	     * _.pluck(_.takeWhile(users, { 'user': 'barney', 'active': false }), 'user');
	     * // => ['barney']
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.pluck(_.takeWhile(users, 'active', false), 'user');
	     * // => ['barney', 'fred']
	     *
	     * // using the `_.property` callback shorthand
	     * _.pluck(_.takeWhile(users, 'active'), 'user');
	     * // => []
	     */
	    function takeWhile(array, predicate, thisArg) {
	      return (array && array.length)
	        ? baseWhile(array, getCallback(predicate, thisArg, 3))
	        : [];
	    }
	
	    /**
	     * Creates an array of unique values, in order, from all of the provided arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.union([1, 2], [4, 2], [2, 1]);
	     * // => [1, 2, 4]
	     */
	    var union = restParam(function(arrays) {
	      return baseUniq(baseFlatten(arrays, false, true));
	    });
	
	    /**
	     * Creates a duplicate-free version of an array, using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons, in which only the first occurence of each element
	     * is kept. Providing `true` for `isSorted` performs a faster search algorithm
	     * for sorted arrays. If an iteratee function is provided it is invoked for
	     * each element in the array to generate the criterion by which uniqueness
	     * is computed. The `iteratee` is bound to `thisArg` and invoked with three
	     * arguments: (value, index, array).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @alias unique
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {boolean} [isSorted] Specify the array is sorted.
	     * @param {Function|Object|string} [iteratee] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Array} Returns the new duplicate-value-free array.
	     * @example
	     *
	     * _.uniq([2, 1, 2]);
	     * // => [2, 1]
	     *
	     * // using `isSorted`
	     * _.uniq([1, 1, 2], true);
	     * // => [1, 2]
	     *
	     * // using an iteratee function
	     * _.uniq([1, 2.5, 1.5, 2], function(n) {
	     *   return this.floor(n);
	     * }, Math);
	     * // => [1, 2.5]
	     *
	     * // using the `_.property` callback shorthand
	     * _.uniq([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */
	    function uniq(array, isSorted, iteratee, thisArg) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      if (isSorted != null && typeof isSorted != 'boolean') {
	        thisArg = iteratee;
	        iteratee = isIterateeCall(array, isSorted, thisArg) ? undefined : isSorted;
	        isSorted = false;
	      }
	      var callback = getCallback();
	      if (!(iteratee == null && callback === baseCallback)) {
	        iteratee = callback(iteratee, thisArg, 3);
	      }
	      return (isSorted && getIndexOf() == baseIndexOf)
	        ? sortedUniq(array, iteratee)
	        : baseUniq(array, iteratee);
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts an array of grouped
	     * elements and creates an array regrouping the elements to their pre-zip
	     * configuration.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip(['fred', 'barney'], [30, 40], [true, false]);
	     * // => [['fred', 30, true], ['barney', 40, false]]
	     *
	     * _.unzip(zipped);
	     * // => [['fred', 'barney'], [30, 40], [true, false]]
	     */
	    function unzip(array) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      var index = -1,
	          length = 0;
	
	      array = arrayFilter(array, function(group) {
	        if (isArrayLike(group)) {
	          length = nativeMax(group.length, length);
	          return true;
	        }
	      });
	      var result = Array(length);
	      while (++index < length) {
	        result[index] = arrayMap(array, baseProperty(index));
	      }
	      return result;
	    }
	
	    /**
	     * This method is like `_.unzip` except that it accepts an iteratee to specify
	     * how regrouped values should be combined. The `iteratee` is bound to `thisArg`
	     * and invoked with four arguments: (accumulator, value, index, group).
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @param {Function} [iteratee] The function to combine regrouped values.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
	     * // => [[1, 10, 100], [2, 20, 200]]
	     *
	     * _.unzipWith(zipped, _.add);
	     * // => [3, 30, 300]
	     */
	    function unzipWith(array, iteratee, thisArg) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      var result = unzip(array);
	      if (iteratee == null) {
	        return result;
	      }
	      iteratee = bindCallback(iteratee, thisArg, 4);
	      return arrayMap(result, function(group) {
	        return arrayReduce(group, iteratee, undefined, true);
	      });
	    }
	
	    /**
	     * Creates an array excluding all provided values using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to filter.
	     * @param {...*} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.without([1, 2, 1, 3], 1, 2);
	     * // => [3]
	     */
	    var without = restParam(function(array, values) {
	      return isArrayLike(array)
	        ? baseDifference(array, values)
	        : [];
	    });
	
	    /**
	     * Creates an array of unique values that is the [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
	     * of the provided arrays.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of values.
	     * @example
	     *
	     * _.xor([1, 2], [4, 2]);
	     * // => [1, 4]
	     */
	    function xor() {
	      var index = -1,
	          length = arguments.length;
	
	      while (++index < length) {
	        var array = arguments[index];
	        if (isArrayLike(array)) {
	          var result = result
	            ? arrayPush(baseDifference(result, array), baseDifference(array, result))
	            : array;
	        }
	      }
	      return result ? baseUniq(result) : [];
	    }
	
	    /**
	     * Creates an array of grouped elements, the first of which contains the first
	     * elements of the given arrays, the second of which contains the second elements
	     * of the given arrays, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zip(['fred', 'barney'], [30, 40], [true, false]);
	     * // => [['fred', 30, true], ['barney', 40, false]]
	     */
	    var zip = restParam(unzip);
	
	    /**
	     * The inverse of `_.pairs`; this method returns an object composed from arrays
	     * of property names and values. Provide either a single two dimensional array,
	     * e.g. `[[key1, value1], [key2, value2]]` or two arrays, one of property names
	     * and one of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @alias object
	     * @category Array
	     * @param {Array} props The property names.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObject([['fred', 30], ['barney', 40]]);
	     * // => { 'fred': 30, 'barney': 40 }
	     *
	     * _.zipObject(['fred', 'barney'], [30, 40]);
	     * // => { 'fred': 30, 'barney': 40 }
	     */
	    function zipObject(props, values) {
	      var index = -1,
	          length = props ? props.length : 0,
	          result = {};
	
	      if (length && !values && !isArray(props[0])) {
	        values = [];
	      }
	      while (++index < length) {
	        var key = props[index];
	        if (values) {
	          result[key] = values[index];
	        } else if (key) {
	          result[key[0]] = key[1];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts an iteratee to specify
	     * how grouped values should be combined. The `iteratee` is bound to `thisArg`
	     * and invoked with four arguments: (accumulator, value, index, group).
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @param {Function} [iteratee] The function to combine grouped values.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zipWith([1, 2], [10, 20], [100, 200], _.add);
	     * // => [111, 222]
	     */
	    var zipWith = restParam(function(arrays) {
	      var length = arrays.length,
	          iteratee = length > 2 ? arrays[length - 2] : undefined,
	          thisArg = length > 1 ? arrays[length - 1] : undefined;
	
	      if (length > 2 && typeof iteratee == 'function') {
	        length -= 2;
	      } else {
	        iteratee = (length > 1 && typeof thisArg == 'function') ? (--length, thisArg) : undefined;
	        thisArg = undefined;
	      }
	      arrays.length = length;
	      return unzipWith(arrays, iteratee, thisArg);
	    });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` object that wraps `value` with explicit method
	     * chaining enabled.
	     *
	     * @static
	     * @memberOf _
	     * @category Chain
	     * @param {*} value The value to wrap.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36 },
	     *   { 'user': 'fred',    'age': 40 },
	     *   { 'user': 'pebbles', 'age': 1 }
	     * ];
	     *
	     * var youngest = _.chain(users)
	     *   .sortBy('age')
	     *   .map(function(chr) {
	     *     return chr.user + ' is ' + chr.age;
	     *   })
	     *   .first()
	     *   .value();
	     * // => 'pebbles is 1'
	     */
	    function chain(value) {
	      var result = lodash(value);
	      result.__chain__ = true;
	      return result;
	    }
	
	    /**
	     * This method invokes `interceptor` and returns `value`. The interceptor is
	     * bound to `thisArg` and invoked with one argument; (value). The purpose of
	     * this method is to "tap into" a method chain in order to perform operations
	     * on intermediate results within the chain.
	     *
	     * @static
	     * @memberOf _
	     * @category Chain
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @param {*} [thisArg] The `this` binding of `interceptor`.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * _([1, 2, 3])
	     *  .tap(function(array) {
	     *    array.pop();
	     *  })
	     *  .reverse()
	     *  .value();
	     * // => [2, 1]
	     */
	    function tap(value, interceptor, thisArg) {
	      interceptor.call(thisArg, value);
	      return value;
	    }
	
	    /**
	     * This method is like `_.tap` except that it returns the result of `interceptor`.
	     *
	     * @static
	     * @memberOf _
	     * @category Chain
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @param {*} [thisArg] The `this` binding of `interceptor`.
	     * @returns {*} Returns the result of `interceptor`.
	     * @example
	     *
	     * _('  abc  ')
	     *  .chain()
	     *  .trim()
	     *  .thru(function(value) {
	     *    return [value];
	     *  })
	     *  .value();
	     * // => ['abc']
	     */
	    function thru(value, interceptor, thisArg) {
	      return interceptor.call(thisArg, value);
	    }
	
	    /**
	     * Enables explicit method chaining on the wrapper object.
	     *
	     * @name chain
	     * @memberOf _
	     * @category Chain
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * // without explicit chaining
	     * _(users).first();
	     * // => { 'user': 'barney', 'age': 36 }
	     *
	     * // with explicit chaining
	     * _(users).chain()
	     *   .first()
	     *   .pick('user')
	     *   .value();
	     * // => { 'user': 'barney' }
	     */
	    function wrapperChain() {
	      return chain(this);
	    }
	
	    /**
	     * Executes the chained sequence and returns the wrapped result.
	     *
	     * @name commit
	     * @memberOf _
	     * @category Chain
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2];
	     * var wrapped = _(array).push(3);
	     *
	     * console.log(array);
	     * // => [1, 2]
	     *
	     * wrapped = wrapped.commit();
	     * console.log(array);
	     * // => [1, 2, 3]
	     *
	     * wrapped.last();
	     * // => 3
	     *
	     * console.log(array);
	     * // => [1, 2, 3]
	     */
	    function wrapperCommit() {
	      return new LodashWrapper(this.value(), this.__chain__);
	    }
	
	    /**
	     * Creates a new array joining a wrapped array with any additional arrays
	     * and/or values.
	     *
	     * @name concat
	     * @memberOf _
	     * @category Chain
	     * @param {...*} [values] The values to concatenate.
	     * @returns {Array} Returns the new concatenated array.
	     * @example
	     *
	     * var array = [1];
	     * var wrapped = _(array).concat(2, [3], [[4]]);
	     *
	     * console.log(wrapped.value());
	     * // => [1, 2, 3, [4]]
	     *
	     * console.log(array);
	     * // => [1]
	     */
	    var wrapperConcat = restParam(function(values) {
	      values = baseFlatten(values);
	      return this.thru(function(array) {
	        return arrayConcat(isArray(array) ? array : [toObject(array)], values);
	      });
	    });
	
	    /**
	     * Creates a clone of the chained sequence planting `value` as the wrapped value.
	     *
	     * @name plant
	     * @memberOf _
	     * @category Chain
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2];
	     * var wrapped = _(array).map(function(value) {
	     *   return Math.pow(value, 2);
	     * });
	     *
	     * var other = [3, 4];
	     * var otherWrapped = wrapped.plant(other);
	     *
	     * otherWrapped.value();
	     * // => [9, 16]
	     *
	     * wrapped.value();
	     * // => [1, 4]
	     */
	    function wrapperPlant(value) {
	      var result,
	          parent = this;
	
	      while (parent instanceof baseLodash) {
	        var clone = wrapperClone(parent);
	        if (result) {
	          previous.__wrapped__ = clone;
	        } else {
	          result = clone;
	        }
	        var previous = clone;
	        parent = parent.__wrapped__;
	      }
	      previous.__wrapped__ = value;
	      return result;
	    }
	
	    /**
	     * Reverses the wrapped array so the first element becomes the last, the
	     * second element becomes the second to last, and so on.
	     *
	     * **Note:** This method mutates the wrapped array.
	     *
	     * @name reverse
	     * @memberOf _
	     * @category Chain
	     * @returns {Object} Returns the new reversed `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _(array).reverse().value()
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */
	    function wrapperReverse() {
	      var value = this.__wrapped__;
	
	      var interceptor = function(value) {
	        return (wrapped && wrapped.__dir__ < 0) ? value : value.reverse();
	      };
	      if (value instanceof LazyWrapper) {
	        var wrapped = value;
	        if (this.__actions__.length) {
	          wrapped = new LazyWrapper(this);
	        }
	        wrapped = wrapped.reverse();
	        wrapped.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
	        return new LodashWrapper(wrapped, this.__chain__);
	      }
	      return this.thru(interceptor);
	    }
	
	    /**
	     * Produces the result of coercing the unwrapped value to a string.
	     *
	     * @name toString
	     * @memberOf _
	     * @category Chain
	     * @returns {string} Returns the coerced string value.
	     * @example
	     *
	     * _([1, 2, 3]).toString();
	     * // => '1,2,3'
	     */
	    function wrapperToString() {
	      return (this.value() + '');
	    }
	
	    /**
	     * Executes the chained sequence to extract the unwrapped value.
	     *
	     * @name value
	     * @memberOf _
	     * @alias run, toJSON, valueOf
	     * @category Chain
	     * @returns {*} Returns the resolved unwrapped value.
	     * @example
	     *
	     * _([1, 2, 3]).value();
	     * // => [1, 2, 3]
	     */
	    function wrapperValue() {
	      return baseWrapperValue(this.__wrapped__, this.__actions__);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an array of elements corresponding to the given keys, or indexes,
	     * of `collection`. Keys may be specified as individual arguments or as arrays
	     * of keys.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {...(number|number[]|string|string[])} [props] The property names
	     *  or indexes of elements to pick, specified individually or in arrays.
	     * @returns {Array} Returns the new array of picked elements.
	     * @example
	     *
	     * _.at(['a', 'b', 'c'], [0, 2]);
	     * // => ['a', 'c']
	     *
	     * _.at(['barney', 'fred', 'pebbles'], 0, 2);
	     * // => ['barney', 'pebbles']
	     */
	    var at = restParam(function(collection, props) {
	      return baseAt(collection, baseFlatten(props));
	    });
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` through `iteratee`. The corresponding value
	     * of each key is the number of times the key was returned by `iteratee`.
	     * The `iteratee` is bound to `thisArg` and invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.countBy([4.3, 6.1, 6.4], function(n) {
	     *   return Math.floor(n);
	     * });
	     * // => { '4': 1, '6': 2 }
	     *
	     * _.countBy([4.3, 6.1, 6.4], function(n) {
	     *   return this.floor(n);
	     * }, Math);
	     * // => { '4': 1, '6': 2 }
	     *
	     * _.countBy(['one', 'two', 'three'], 'length');
	     * // => { '3': 2, '5': 1 }
	     */
	    var countBy = createAggregator(function(result, value, key) {
	      hasOwnProperty.call(result, key) ? ++result[key] : (result[key] = 1);
	    });
	
	    /**
	     * Checks if `predicate` returns truthy for **all** elements of `collection`.
	     * The predicate is bound to `thisArg` and invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @alias all
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.every([true, 1, null, 'yes'], Boolean);
	     * // => false
	     *
	     * var users = [
	     *   { 'user': 'barney', 'active': false },
	     *   { 'user': 'fred',   'active': false }
	     * ];
	     *
	     * // using the `_.matches` callback shorthand
	     * _.every(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.every(users, 'active', false);
	     * // => true
	     *
	     * // using the `_.property` callback shorthand
	     * _.every(users, 'active');
	     * // => false
	     */
	    function every(collection, predicate, thisArg) {
	      var func = isArray(collection) ? arrayEvery : baseEvery;
	      if (thisArg && isIterateeCall(collection, predicate, thisArg)) {
	        predicate = undefined;
	      }
	      if (typeof predicate != 'function' || thisArg !== undefined) {
	        predicate = getCallback(predicate, thisArg, 3);
	      }
	      return func(collection, predicate);
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning an array of all elements
	     * `predicate` returns truthy for. The predicate is bound to `thisArg` and
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @alias select
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Array} Returns the new filtered array.
	     * @example
	     *
	     * _.filter([4, 5, 6], function(n) {
	     *   return n % 2 == 0;
	     * });
	     * // => [4, 6]
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // using the `_.matches` callback shorthand
	     * _.pluck(_.filter(users, { 'age': 36, 'active': true }), 'user');
	     * // => ['barney']
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.pluck(_.filter(users, 'active', false), 'user');
	     * // => ['fred']
	     *
	     * // using the `_.property` callback shorthand
	     * _.pluck(_.filter(users, 'active'), 'user');
	     * // => ['barney']
	     */
	    function filter(collection, predicate, thisArg) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      predicate = getCallback(predicate, thisArg, 3);
	      return func(collection, predicate);
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning the first element
	     * `predicate` returns truthy for. The predicate is bound to `thisArg` and
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @alias detect
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to search.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': true },
	     *   { 'user': 'fred',    'age': 40, 'active': false },
	     *   { 'user': 'pebbles', 'age': 1,  'active': true }
	     * ];
	     *
	     * _.result(_.find(users, function(chr) {
	     *   return chr.age < 40;
	     * }), 'user');
	     * // => 'barney'
	     *
	     * // using the `_.matches` callback shorthand
	     * _.result(_.find(users, { 'age': 1, 'active': true }), 'user');
	     * // => 'pebbles'
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.result(_.find(users, 'active', false), 'user');
	     * // => 'fred'
	     *
	     * // using the `_.property` callback shorthand
	     * _.result(_.find(users, 'active'), 'user');
	     * // => 'barney'
	     */
	    var find = createFind(baseEach);
	
	    /**
	     * This method is like `_.find` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to search.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * _.findLast([1, 2, 3, 4], function(n) {
	     *   return n % 2 == 1;
	     * });
	     * // => 3
	     */
	    var findLast = createFind(baseEachRight, true);
	
	    /**
	     * Performs a deep comparison between each element in `collection` and the
	     * source object, returning the first element that has equivalent property
	     * values.
	     *
	     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
	     * numbers, `Object` objects, regexes, and strings. Objects are compared by
	     * their own, not inherited, enumerable properties. For comparing a single
	     * own or inherited property value see `_.matchesProperty`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to search.
	     * @param {Object} source The object of property values to match.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * _.result(_.findWhere(users, { 'age': 36, 'active': true }), 'user');
	     * // => 'barney'
	     *
	     * _.result(_.findWhere(users, { 'age': 40, 'active': false }), 'user');
	     * // => 'fred'
	     */
	    function findWhere(collection, source) {
	      return find(collection, baseMatches(source));
	    }
	
	    /**
	     * Iterates over elements of `collection` invoking `iteratee` for each element.
	     * The `iteratee` is bound to `thisArg` and invoked with three arguments:
	     * (value, index|key, collection). Iteratee functions may exit iteration early
	     * by explicitly returning `false`.
	     *
	     * **Note:** As with other "Collections" methods, objects with a "length" property
	     * are iterated like arrays. To avoid this behavior `_.forIn` or `_.forOwn`
	     * may be used for object iteration.
	     *
	     * @static
	     * @memberOf _
	     * @alias each
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Array|Object|string} Returns `collection`.
	     * @example
	     *
	     * _([1, 2]).forEach(function(n) {
	     *   console.log(n);
	     * }).value();
	     * // => logs each value from left to right and returns the array
	     *
	     * _.forEach({ 'a': 1, 'b': 2 }, function(n, key) {
	     *   console.log(n, key);
	     * });
	     * // => logs each value-key pair and returns the object (iteration order is not guaranteed)
	     */
	    var forEach = createForEach(arrayEach, baseEach);
	
	    /**
	     * This method is like `_.forEach` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @alias eachRight
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Array|Object|string} Returns `collection`.
	     * @example
	     *
	     * _([1, 2]).forEachRight(function(n) {
	     *   console.log(n);
	     * }).value();
	     * // => logs each value from right to left and returns the array
	     */
	    var forEachRight = createForEach(arrayEachRight, baseEachRight);
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` through `iteratee`. The corresponding value
	     * of each key is an array of the elements responsible for generating the key.
	     * The `iteratee` is bound to `thisArg` and invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.groupBy([4.2, 6.1, 6.4], function(n) {
	     *   return Math.floor(n);
	     * });
	     * // => { '4': [4.2], '6': [6.1, 6.4] }
	     *
	     * _.groupBy([4.2, 6.1, 6.4], function(n) {
	     *   return this.floor(n);
	     * }, Math);
	     * // => { '4': [4.2], '6': [6.1, 6.4] }
	     *
	     * // using the `_.property` callback shorthand
	     * _.groupBy(['one', 'two', 'three'], 'length');
	     * // => { '3': ['one', 'two'], '5': ['three'] }
	     */
	    var groupBy = createAggregator(function(result, value, key) {
	      if (hasOwnProperty.call(result, key)) {
	        result[key].push(value);
	      } else {
	        result[key] = [value];
	      }
	    });
	
	    /**
	     * Checks if `value` is in `collection` using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons. If `fromIndex` is negative, it is used as the offset
	     * from the end of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @alias contains, include
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to search.
	     * @param {*} target The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.reduce`.
	     * @returns {boolean} Returns `true` if a matching element is found, else `false`.
	     * @example
	     *
	     * _.includes([1, 2, 3], 1);
	     * // => true
	     *
	     * _.includes([1, 2, 3], 1, 2);
	     * // => false
	     *
	     * _.includes({ 'user': 'fred', 'age': 40 }, 'fred');
	     * // => true
	     *
	     * _.includes('pebbles', 'eb');
	     * // => true
	     */
	    function includes(collection, target, fromIndex, guard) {
	      var length = collection ? getLength(collection) : 0;
	      if (!isLength(length)) {
	        collection = values(collection);
	        length = collection.length;
	      }
	      if (typeof fromIndex != 'number' || (guard && isIterateeCall(target, fromIndex, guard))) {
	        fromIndex = 0;
	      } else {
	        fromIndex = fromIndex < 0 ? nativeMax(length + fromIndex, 0) : (fromIndex || 0);
	      }
	      return (typeof collection == 'string' || !isArray(collection) && isString(collection))
	        ? (fromIndex <= length && collection.indexOf(target, fromIndex) > -1)
	        : (!!length && getIndexOf(collection, target, fromIndex) > -1);
	    }
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` through `iteratee`. The corresponding value
	     * of each key is the last element responsible for generating the key. The
	     * iteratee function is bound to `thisArg` and invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * var keyData = [
	     *   { 'dir': 'left', 'code': 97 },
	     *   { 'dir': 'right', 'code': 100 }
	     * ];
	     *
	     * _.indexBy(keyData, 'dir');
	     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
	     *
	     * _.indexBy(keyData, function(object) {
	     *   return String.fromCharCode(object.code);
	     * });
	     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
	     *
	     * _.indexBy(keyData, function(object) {
	     *   return this.fromCharCode(object.code);
	     * }, String);
	     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
	     */
	    var indexBy = createAggregator(function(result, value, key) {
	      result[key] = value;
	    });
	
	    /**
	     * Invokes the method at `path` of each element in `collection`, returning
	     * an array of the results of each invoked method. Any additional arguments
	     * are provided to each invoked method. If `methodName` is a function it is
	     * invoked for, and `this` bound to, each element in `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Array|Function|string} path The path of the method to invoke or
	     *  the function invoked per iteration.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.invoke([[5, 1, 7], [3, 2, 1]], 'sort');
	     * // => [[1, 5, 7], [1, 2, 3]]
	     *
	     * _.invoke([123, 456], String.prototype.split, '');
	     * // => [['1', '2', '3'], ['4', '5', '6']]
	     */
	    var invoke = restParam(function(collection, path, args) {
	      var index = -1,
	          isFunc = typeof path == 'function',
	          isProp = isKey(path),
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value) {
	        var func = isFunc ? path : ((isProp && value != null) ? value[path] : undefined);
	        result[++index] = func ? func.apply(value, args) : invokePath(value, path, args);
	      });
	      return result;
	    });
	
	    /**
	     * Creates an array of values by running each element in `collection` through
	     * `iteratee`. The `iteratee` is bound to `thisArg` and invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
	     *
	     * The guarded methods are:
	     * `ary`, `callback`, `chunk`, `clone`, `create`, `curry`, `curryRight`,
	     * `drop`, `dropRight`, `every`, `fill`, `flatten`, `invert`, `max`, `min`,
	     * `parseInt`, `slice`, `sortBy`, `take`, `takeRight`, `template`, `trim`,
	     * `trimLeft`, `trimRight`, `trunc`, `random`, `range`, `sample`, `some`,
	     * `sum`, `uniq`, and `words`
	     *
	     * @static
	     * @memberOf _
	     * @alias collect
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Array} Returns the new mapped array.
	     * @example
	     *
	     * function timesThree(n) {
	     *   return n * 3;
	     * }
	     *
	     * _.map([1, 2], timesThree);
	     * // => [3, 6]
	     *
	     * _.map({ 'a': 1, 'b': 2 }, timesThree);
	     * // => [3, 6] (iteration order is not guaranteed)
	     *
	     * var users = [
	     *   { 'user': 'barney' },
	     *   { 'user': 'fred' }
	     * ];
	     *
	     * // using the `_.property` callback shorthand
	     * _.map(users, 'user');
	     * // => ['barney', 'fred']
	     */
	    function map(collection, iteratee, thisArg) {
	      var func = isArray(collection) ? arrayMap : baseMap;
	      iteratee = getCallback(iteratee, thisArg, 3);
	      return func(collection, iteratee);
	    }
	
	    /**
	     * Creates an array of elements split into two groups, the first of which
	     * contains elements `predicate` returns truthy for, while the second of which
	     * contains elements `predicate` returns falsey for. The predicate is bound
	     * to `thisArg` and invoked with three arguments: (value, index|key, collection).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Array} Returns the array of grouped elements.
	     * @example
	     *
	     * _.partition([1, 2, 3], function(n) {
	     *   return n % 2;
	     * });
	     * // => [[1, 3], [2]]
	     *
	     * _.partition([1.2, 2.3, 3.4], function(n) {
	     *   return this.floor(n) % 2;
	     * }, Math);
	     * // => [[1.2, 3.4], [2.3]]
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': false },
	     *   { 'user': 'fred',    'age': 40, 'active': true },
	     *   { 'user': 'pebbles', 'age': 1,  'active': false }
	     * ];
	     *
	     * var mapper = function(array) {
	     *   return _.pluck(array, 'user');
	     * };
	     *
	     * // using the `_.matches` callback shorthand
	     * _.map(_.partition(users, { 'age': 1, 'active': false }), mapper);
	     * // => [['pebbles'], ['barney', 'fred']]
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.map(_.partition(users, 'active', false), mapper);
	     * // => [['barney', 'pebbles'], ['fred']]
	     *
	     * // using the `_.property` callback shorthand
	     * _.map(_.partition(users, 'active'), mapper);
	     * // => [['fred'], ['barney', 'pebbles']]
	     */
	    var partition = createAggregator(function(result, value, key) {
	      result[key ? 0 : 1].push(value);
	    }, function() { return [[], []]; });
	
	    /**
	     * Gets the property value of `path` from all elements in `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Array|string} path The path of the property to pluck.
	     * @returns {Array} Returns the property values.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * _.pluck(users, 'user');
	     * // => ['barney', 'fred']
	     *
	     * var userIndex = _.indexBy(users, 'user');
	     * _.pluck(userIndex, 'age');
	     * // => [36, 40] (iteration order is not guaranteed)
	     */
	    function pluck(collection, path) {
	      return map(collection, property(path));
	    }
	
	    /**
	     * Reduces `collection` to a value which is the accumulated result of running
	     * each element in `collection` through `iteratee`, where each successive
	     * invocation is supplied the return value of the previous. If `accumulator`
	     * is not provided the first element of `collection` is used as the initial
	     * value. The `iteratee` is bound to `thisArg` and invoked with four arguments:
	     * (accumulator, value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.reduce`, `_.reduceRight`, and `_.transform`.
	     *
	     * The guarded methods are:
	     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `sortByAll`,
	     * and `sortByOrder`
	     *
	     * @static
	     * @memberOf _
	     * @alias foldl, inject
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {*} Returns the accumulated value.
	     * @example
	     *
	     * _.reduce([1, 2], function(total, n) {
	     *   return total + n;
	     * });
	     * // => 3
	     *
	     * _.reduce({ 'a': 1, 'b': 2 }, function(result, n, key) {
	     *   result[key] = n * 3;
	     *   return result;
	     * }, {});
	     * // => { 'a': 3, 'b': 6 } (iteration order is not guaranteed)
	     */
	    var reduce = createReduce(arrayReduce, baseEach);
	
	    /**
	     * This method is like `_.reduce` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @alias foldr
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {*} Returns the accumulated value.
	     * @example
	     *
	     * var array = [[0, 1], [2, 3], [4, 5]];
	     *
	     * _.reduceRight(array, function(flattened, other) {
	     *   return flattened.concat(other);
	     * }, []);
	     * // => [4, 5, 2, 3, 0, 1]
	     */
	    var reduceRight = createReduce(arrayReduceRight, baseEachRight);
	
	    /**
	     * The opposite of `_.filter`; this method returns the elements of `collection`
	     * that `predicate` does **not** return truthy for.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Array} Returns the new filtered array.
	     * @example
	     *
	     * _.reject([1, 2, 3, 4], function(n) {
	     *   return n % 2 == 0;
	     * });
	     * // => [1, 3]
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': true }
	     * ];
	     *
	     * // using the `_.matches` callback shorthand
	     * _.pluck(_.reject(users, { 'age': 40, 'active': true }), 'user');
	     * // => ['barney']
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.pluck(_.reject(users, 'active', false), 'user');
	     * // => ['fred']
	     *
	     * // using the `_.property` callback shorthand
	     * _.pluck(_.reject(users, 'active'), 'user');
	     * // => ['barney']
	     */
	    function reject(collection, predicate, thisArg) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      predicate = getCallback(predicate, thisArg, 3);
	      return func(collection, function(value, index, collection) {
	        return !predicate(value, index, collection);
	      });
	    }
	
	    /**
	     * Gets a random element or `n` random elements from a collection.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to sample.
	     * @param {number} [n] The number of elements to sample.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {*} Returns the random sample(s).
	     * @example
	     *
	     * _.sample([1, 2, 3, 4]);
	     * // => 2
	     *
	     * _.sample([1, 2, 3, 4], 2);
	     * // => [3, 1]
	     */
	    function sample(collection, n, guard) {
	      if (guard ? isIterateeCall(collection, n, guard) : n == null) {
	        collection = toIterable(collection);
	        var length = collection.length;
	        return length > 0 ? collection[baseRandom(0, length - 1)] : undefined;
	      }
	      var index = -1,
	          result = toArray(collection),
	          length = result.length,
	          lastIndex = length - 1;
	
	      n = nativeMin(n < 0 ? 0 : (+n || 0), length);
	      while (++index < n) {
	        var rand = baseRandom(index, lastIndex),
	            value = result[rand];
	
	        result[rand] = result[index];
	        result[index] = value;
	      }
	      result.length = n;
	      return result;
	    }
	
	    /**
	     * Creates an array of shuffled values, using a version of the
	     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     * @example
	     *
	     * _.shuffle([1, 2, 3, 4]);
	     * // => [4, 1, 3, 2]
	     */
	    function shuffle(collection) {
	      return sample(collection, POSITIVE_INFINITY);
	    }
	
	    /**
	     * Gets the size of `collection` by returning its length for array-like
	     * values or the number of own enumerable properties for objects.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to inspect.
	     * @returns {number} Returns the size of `collection`.
	     * @example
	     *
	     * _.size([1, 2, 3]);
	     * // => 3
	     *
	     * _.size({ 'a': 1, 'b': 2 });
	     * // => 2
	     *
	     * _.size('pebbles');
	     * // => 7
	     */
	    function size(collection) {
	      var length = collection ? getLength(collection) : 0;
	      return isLength(length) ? length : keys(collection).length;
	    }
	
	    /**
	     * Checks if `predicate` returns truthy for **any** element of `collection`.
	     * The function returns as soon as it finds a passing value and does not iterate
	     * over the entire collection. The predicate is bound to `thisArg` and invoked
	     * with three arguments: (value, index|key, collection).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @alias any
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.some([null, 0, 'yes', false], Boolean);
	     * // => true
	     *
	     * var users = [
	     *   { 'user': 'barney', 'active': true },
	     *   { 'user': 'fred',   'active': false }
	     * ];
	     *
	     * // using the `_.matches` callback shorthand
	     * _.some(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.some(users, 'active', false);
	     * // => true
	     *
	     * // using the `_.property` callback shorthand
	     * _.some(users, 'active');
	     * // => true
	     */
	    function some(collection, predicate, thisArg) {
	      var func = isArray(collection) ? arraySome : baseSome;
	      if (thisArg && isIterateeCall(collection, predicate, thisArg)) {
	        predicate = undefined;
	      }
	      if (typeof predicate != 'function' || thisArg !== undefined) {
	        predicate = getCallback(predicate, thisArg, 3);
	      }
	      return func(collection, predicate);
	    }
	
	    /**
	     * Creates an array of elements, sorted in ascending order by the results of
	     * running each element in a collection through `iteratee`. This method performs
	     * a stable sort, that is, it preserves the original sort order of equal elements.
	     * The `iteratee` is bound to `thisArg` and invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * _.sortBy([1, 2, 3], function(n) {
	     *   return Math.sin(n);
	     * });
	     * // => [3, 1, 2]
	     *
	     * _.sortBy([1, 2, 3], function(n) {
	     *   return this.sin(n);
	     * }, Math);
	     * // => [3, 1, 2]
	     *
	     * var users = [
	     *   { 'user': 'fred' },
	     *   { 'user': 'pebbles' },
	     *   { 'user': 'barney' }
	     * ];
	     *
	     * // using the `_.property` callback shorthand
	     * _.pluck(_.sortBy(users, 'user'), 'user');
	     * // => ['barney', 'fred', 'pebbles']
	     */
	    function sortBy(collection, iteratee, thisArg) {
	      if (collection == null) {
	        return [];
	      }
	      if (thisArg && isIterateeCall(collection, iteratee, thisArg)) {
	        iteratee = undefined;
	      }
	      var index = -1;
	      iteratee = getCallback(iteratee, thisArg, 3);
	
	      var result = baseMap(collection, function(value, key, collection) {
	        return { 'criteria': iteratee(value, key, collection), 'index': ++index, 'value': value };
	      });
	      return baseSortBy(result, compareAscending);
	    }
	
	    /**
	     * This method is like `_.sortBy` except that it can sort by multiple iteratees
	     * or property names.
	     *
	     * If a property name is provided for an iteratee the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If an object is provided for an iteratee the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {...(Function|Function[]|Object|Object[]|string|string[])} iteratees
	     *  The iteratees to sort by, specified as individual values or arrays of values.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 42 },
	     *   { 'user': 'barney', 'age': 34 }
	     * ];
	     *
	     * _.map(_.sortByAll(users, ['user', 'age']), _.values);
	     * // => [['barney', 34], ['barney', 36], ['fred', 42], ['fred', 48]]
	     *
	     * _.map(_.sortByAll(users, 'user', function(chr) {
	     *   return Math.floor(chr.age / 10);
	     * }), _.values);
	     * // => [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 42]]
	     */
	    var sortByAll = restParam(function(collection, iteratees) {
	      if (collection == null) {
	        return [];
	      }
	      var guard = iteratees[2];
	      if (guard && isIterateeCall(iteratees[0], iteratees[1], guard)) {
	        iteratees.length = 1;
	      }
	      return baseSortByOrder(collection, baseFlatten(iteratees), []);
	    });
	
	    /**
	     * This method is like `_.sortByAll` except that it allows specifying the
	     * sort orders of the iteratees to sort by. If `orders` is unspecified, all
	     * values are sorted in ascending order. Otherwise, a value is sorted in
	     * ascending order if its corresponding order is "asc", and descending if "desc".
	     *
	     * If a property name is provided for an iteratee the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If an object is provided for an iteratee the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
	     * @param {boolean[]} [orders] The sort orders of `iteratees`.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.reduce`.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 34 },
	     *   { 'user': 'fred',   'age': 42 },
	     *   { 'user': 'barney', 'age': 36 }
	     * ];
	     *
	     * // sort by `user` in ascending order and by `age` in descending order
	     * _.map(_.sortByOrder(users, ['user', 'age'], ['asc', 'desc']), _.values);
	     * // => [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 42]]
	     */
	    function sortByOrder(collection, iteratees, orders, guard) {
	      if (collection == null) {
	        return [];
	      }
	      if (guard && isIterateeCall(iteratees, orders, guard)) {
	        orders = undefined;
	      }
	      if (!isArray(iteratees)) {
	        iteratees = iteratees == null ? [] : [iteratees];
	      }
	      if (!isArray(orders)) {
	        orders = orders == null ? [] : [orders];
	      }
	      return baseSortByOrder(collection, iteratees, orders);
	    }
	
	    /**
	     * Performs a deep comparison between each element in `collection` and the
	     * source object, returning an array of all elements that have equivalent
	     * property values.
	     *
	     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
	     * numbers, `Object` objects, regexes, and strings. Objects are compared by
	     * their own, not inherited, enumerable properties. For comparing a single
	     * own or inherited property value see `_.matchesProperty`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to search.
	     * @param {Object} source The object of property values to match.
	     * @returns {Array} Returns the new filtered array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false, 'pets': ['hoppy'] },
	     *   { 'user': 'fred',   'age': 40, 'active': true, 'pets': ['baby puss', 'dino'] }
	     * ];
	     *
	     * _.pluck(_.where(users, { 'age': 36, 'active': false }), 'user');
	     * // => ['barney']
	     *
	     * _.pluck(_.where(users, { 'pets': ['dino'] }), 'user');
	     * // => ['fred']
	     */
	    function where(collection, source) {
	      return filter(collection, baseMatches(source));
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Gets the number of milliseconds that have elapsed since the Unix epoch
	     * (1 January 1970 00:00:00 UTC).
	     *
	     * @static
	     * @memberOf _
	     * @category Date
	     * @example
	     *
	     * _.defer(function(stamp) {
	     *   console.log(_.now() - stamp);
	     * }, _.now());
	     * // => logs the number of milliseconds it took for the deferred function to be invoked
	     */
	    var now = nativeNow || function() {
	      return new Date().getTime();
	    };
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The opposite of `_.before`; this method creates a function that invokes
	     * `func` once it is called `n` or more times.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {number} n The number of calls before `func` is invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var saves = ['profile', 'settings'];
	     *
	     * var done = _.after(saves.length, function() {
	     *   console.log('done saving!');
	     * });
	     *
	     * _.forEach(saves, function(type) {
	     *   asyncSave({ 'type': type, 'complete': done });
	     * });
	     * // => logs 'done saving!' after the two async saves have completed
	     */
	    function after(n, func) {
	      if (typeof func != 'function') {
	        if (typeof n == 'function') {
	          var temp = n;
	          n = func;
	          func = temp;
	        } else {
	          throw new TypeError(FUNC_ERROR_TEXT);
	        }
	      }
	      n = nativeIsFinite(n = +n) ? n : 0;
	      return function() {
	        if (--n < 1) {
	          return func.apply(this, arguments);
	        }
	      };
	    }
	
	    /**
	     * Creates a function that accepts up to `n` arguments ignoring any
	     * additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @param {number} [n=func.length] The arity cap.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
	     * // => [6, 8, 10]
	     */
	    function ary(func, n, guard) {
	      if (guard && isIterateeCall(func, n, guard)) {
	        n = undefined;
	      }
	      n = (func && n == null) ? func.length : nativeMax(+n || 0, 0);
	      return createWrapper(func, ARY_FLAG, undefined, undefined, undefined, undefined, n);
	    }
	
	    /**
	     * Creates a function that invokes `func`, with the `this` binding and arguments
	     * of the created function, while it is called less than `n` times. Subsequent
	     * calls to the created function return the result of the last `func` invocation.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {number} n The number of calls at which `func` is no longer invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * jQuery('#add').on('click', _.before(5, addContactToList));
	     * // => allows adding up to 4 contacts to the list
	     */
	    function before(n, func) {
	      var result;
	      if (typeof func != 'function') {
	        if (typeof n == 'function') {
	          var temp = n;
	          n = func;
	          func = temp;
	        } else {
	          throw new TypeError(FUNC_ERROR_TEXT);
	        }
	      }
	      return function() {
	        if (--n > 0) {
	          result = func.apply(this, arguments);
	        }
	        if (n <= 1) {
	          func = undefined;
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of `thisArg`
	     * and prepends any additional `_.bind` arguments to those provided to the
	     * bound function.
	     *
	     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** Unlike native `Function#bind` this method does not set the "length"
	     * property of bound functions.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to bind.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * var greet = function(greeting, punctuation) {
	     *   return greeting + ' ' + this.user + punctuation;
	     * };
	     *
	     * var object = { 'user': 'fred' };
	     *
	     * var bound = _.bind(greet, object, 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * // using placeholders
	     * var bound = _.bind(greet, object, _, '!');
	     * bound('hi');
	     * // => 'hi fred!'
	     */
	    var bind = restParam(function(func, thisArg, partials) {
	      var bitmask = BIND_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, bind.placeholder);
	        bitmask |= PARTIAL_FLAG;
	      }
	      return createWrapper(func, bitmask, thisArg, partials, holders);
	    });
	
	    /**
	     * Binds methods of an object to the object itself, overwriting the existing
	     * method. Method names may be specified as individual arguments or as arrays
	     * of method names. If no method names are provided all enumerable function
	     * properties, own and inherited, of `object` are bound.
	     *
	     * **Note:** This method does not set the "length" property of bound functions.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Object} object The object to bind and assign the bound methods to.
	     * @param {...(string|string[])} [methodNames] The object method names to bind,
	     *  specified as individual method names or arrays of method names.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var view = {
	     *   'label': 'docs',
	     *   'onClick': function() {
	     *     console.log('clicked ' + this.label);
	     *   }
	     * };
	     *
	     * _.bindAll(view);
	     * jQuery('#docs').on('click', view.onClick);
	     * // => logs 'clicked docs' when the element is clicked
	     */
	    var bindAll = restParam(function(object, methodNames) {
	      methodNames = methodNames.length ? baseFlatten(methodNames) : functions(object);
	
	      var index = -1,
	          length = methodNames.length;
	
	      while (++index < length) {
	        var key = methodNames[index];
	        object[key] = createWrapper(object[key], BIND_FLAG, object);
	      }
	      return object;
	    });
	
	    /**
	     * Creates a function that invokes the method at `object[key]` and prepends
	     * any additional `_.bindKey` arguments to those provided to the bound function.
	     *
	     * This method differs from `_.bind` by allowing bound functions to reference
	     * methods that may be redefined or don't yet exist.
	     * See [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
	     * for more details.
	     *
	     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Object} object The object the method belongs to.
	     * @param {string} key The key of the method.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * var object = {
	     *   'user': 'fred',
	     *   'greet': function(greeting, punctuation) {
	     *     return greeting + ' ' + this.user + punctuation;
	     *   }
	     * };
	     *
	     * var bound = _.bindKey(object, 'greet', 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * object.greet = function(greeting, punctuation) {
	     *   return greeting + 'ya ' + this.user + punctuation;
	     * };
	     *
	     * bound('!');
	     * // => 'hiya fred!'
	     *
	     * // using placeholders
	     * var bound = _.bindKey(object, 'greet', _, '!');
	     * bound('hi');
	     * // => 'hiya fred!'
	     */
	    var bindKey = restParam(function(object, key, partials) {
	      var bitmask = BIND_FLAG | BIND_KEY_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, bindKey.placeholder);
	        bitmask |= PARTIAL_FLAG;
	      }
	      return createWrapper(key, bitmask, object, partials, holders);
	    });
	
	    /**
	     * Creates a function that accepts one or more arguments of `func` that when
	     * called either invokes `func` returning its result, if all `func` arguments
	     * have been provided, or returns a function that accepts one or more of the
	     * remaining `func` arguments, and so on. The arity of `func` may be specified
	     * if `func.length` is not sufficient.
	     *
	     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method does not set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curry(abc);
	     *
	     * curried(1)(2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // using placeholders
	     * curried(1)(_, 3)(2);
	     * // => [1, 2, 3]
	     */
	    var curry = createCurry(CURRY_FLAG);
	
	    /**
	     * This method is like `_.curry` except that arguments are applied to `func`
	     * in the manner of `_.partialRight` instead of `_.partial`.
	     *
	     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method does not set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curryRight(abc);
	     *
	     * curried(3)(2)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(2, 3)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // using placeholders
	     * curried(3)(1, _)(2);
	     * // => [1, 2, 3]
	     */
	    var curryRight = createCurry(CURRY_RIGHT_FLAG);
	
	    /**
	     * Creates a debounced function that delays invoking `func` until after `wait`
	     * milliseconds have elapsed since the last time the debounced function was
	     * invoked. The debounced function comes with a `cancel` method to cancel
	     * delayed invocations. Provide an options object to indicate that `func`
	     * should be invoked on the leading and/or trailing edge of the `wait` timeout.
	     * Subsequent calls to the debounced function return the result of the last
	     * `func` invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is invoked
	     * on the trailing edge of the timeout only if the the debounced function is
	     * invoked more than once during the `wait` timeout.
	     *
	     * See [David Corbacho's article](http://drupalmotion.com/article/debounce-and-throttle-visual-explanation)
	     * for details over the differences between `_.debounce` and `_.throttle`.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to debounce.
	     * @param {number} [wait=0] The number of milliseconds to delay.
	     * @param {Object} [options] The options object.
	     * @param {boolean} [options.leading=false] Specify invoking on the leading
	     *  edge of the timeout.
	     * @param {number} [options.maxWait] The maximum time `func` is allowed to be
	     *  delayed before it is invoked.
	     * @param {boolean} [options.trailing=true] Specify invoking on the trailing
	     *  edge of the timeout.
	     * @returns {Function} Returns the new debounced function.
	     * @example
	     *
	     * // avoid costly calculations while the window size is in flux
	     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	     *
	     * // invoke `sendMail` when the click event is fired, debouncing subsequent calls
	     * jQuery('#postbox').on('click', _.debounce(sendMail, 300, {
	     *   'leading': true,
	     *   'trailing': false
	     * }));
	     *
	     * // ensure `batchLog` is invoked once after 1 second of debounced calls
	     * var source = new EventSource('/stream');
	     * jQuery(source).on('message', _.debounce(batchLog, 250, {
	     *   'maxWait': 1000
	     * }));
	     *
	     * // cancel a debounced call
	     * var todoChanges = _.debounce(batchLog, 1000);
	     * Object.observe(models.todo, todoChanges);
	     *
	     * Object.observe(models, function(changes) {
	     *   if (_.find(changes, { 'user': 'todo', 'type': 'delete'})) {
	     *     todoChanges.cancel();
	     *   }
	     * }, ['delete']);
	     *
	     * // ...at some point `models.todo` is changed
	     * models.todo.completed = true;
	     *
	     * // ...before 1 second has passed `models.todo` is deleted
	     * // which cancels the debounced `todoChanges` call
	     * delete models.todo;
	     */
	    function debounce(func, wait, options) {
	      var args,
	          maxTimeoutId,
	          result,
	          stamp,
	          thisArg,
	          timeoutId,
	          trailingCall,
	          lastCalled = 0,
	          maxWait = false,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      wait = wait < 0 ? 0 : (+wait || 0);
	      if (options === true) {
	        var leading = true;
	        trailing = false;
	      } else if (isObject(options)) {
	        leading = !!options.leading;
	        maxWait = 'maxWait' in options && nativeMax(+options.maxWait || 0, wait);
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	
	      function cancel() {
	        if (timeoutId) {
	          clearTimeout(timeoutId);
	        }
	        if (maxTimeoutId) {
	          clearTimeout(maxTimeoutId);
	        }
	        lastCalled = 0;
	        maxTimeoutId = timeoutId = trailingCall = undefined;
	      }
	
	      function complete(isCalled, id) {
	        if (id) {
	          clearTimeout(id);
	        }
	        maxTimeoutId = timeoutId = trailingCall = undefined;
	        if (isCalled) {
	          lastCalled = now();
	          result = func.apply(thisArg, args);
	          if (!timeoutId && !maxTimeoutId) {
	            args = thisArg = undefined;
	          }
	        }
	      }
	
	      function delayed() {
	        var remaining = wait - (now() - stamp);
	        if (remaining <= 0 || remaining > wait) {
	          complete(trailingCall, maxTimeoutId);
	        } else {
	          timeoutId = setTimeout(delayed, remaining);
	        }
	      }
	
	      function maxDelayed() {
	        complete(trailing, timeoutId);
	      }
	
	      function debounced() {
	        args = arguments;
	        stamp = now();
	        thisArg = this;
	        trailingCall = trailing && (timeoutId || !leading);
	
	        if (maxWait === false) {
	          var leadingCall = leading && !timeoutId;
	        } else {
	          if (!maxTimeoutId && !leading) {
	            lastCalled = stamp;
	          }
	          var remaining = maxWait - (stamp - lastCalled),
	              isCalled = remaining <= 0 || remaining > maxWait;
	
	          if (isCalled) {
	            if (maxTimeoutId) {
	              maxTimeoutId = clearTimeout(maxTimeoutId);
	            }
	            lastCalled = stamp;
	            result = func.apply(thisArg, args);
	          }
	          else if (!maxTimeoutId) {
	            maxTimeoutId = setTimeout(maxDelayed, remaining);
	          }
	        }
	        if (isCalled && timeoutId) {
	          timeoutId = clearTimeout(timeoutId);
	        }
	        else if (!timeoutId && wait !== maxWait) {
	          timeoutId = setTimeout(delayed, wait);
	        }
	        if (leadingCall) {
	          isCalled = true;
	          result = func.apply(thisArg, args);
	        }
	        if (isCalled && !timeoutId && !maxTimeoutId) {
	          args = thisArg = undefined;
	        }
	        return result;
	      }
	      debounced.cancel = cancel;
	      return debounced;
	    }
	
	    /**
	     * Defers invoking the `func` until the current call stack has cleared. Any
	     * additional arguments are provided to `func` when it is invoked.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to defer.
	     * @param {...*} [args] The arguments to invoke the function with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.defer(function(text) {
	     *   console.log(text);
	     * }, 'deferred');
	     * // logs 'deferred' after one or more milliseconds
	     */
	    var defer = restParam(function(func, args) {
	      return baseDelay(func, 1, args);
	    });
	
	    /**
	     * Invokes `func` after `wait` milliseconds. Any additional arguments are
	     * provided to `func` when it is invoked.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {...*} [args] The arguments to invoke the function with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.delay(function(text) {
	     *   console.log(text);
	     * }, 1000, 'later');
	     * // => logs 'later' after one second
	     */
	    var delay = restParam(function(func, wait, args) {
	      return baseDelay(func, wait, args);
	    });
	
	    /**
	     * Creates a function that returns the result of invoking the provided
	     * functions with the `this` binding of the created function, where each
	     * successive invocation is supplied the return value of the previous.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {...Function} [funcs] Functions to invoke.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flow(_.add, square);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flow = createFlow();
	
	    /**
	     * This method is like `_.flow` except that it creates a function that
	     * invokes the provided functions from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @alias backflow, compose
	     * @category Function
	     * @param {...Function} [funcs] Functions to invoke.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flowRight(square, _.add);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flowRight = createFlow(true);
	
	    /**
	     * Creates a function that memoizes the result of `func`. If `resolver` is
	     * provided it determines the cache key for storing the result based on the
	     * arguments provided to the memoized function. By default, the first argument
	     * provided to the memoized function is coerced to a string and used as the
	     * cache key. The `func` is invoked with the `this` binding of the memoized
	     * function.
	     *
	     * **Note:** The cache is exposed as the `cache` property on the memoized
	     * function. Its creation may be customized by replacing the `_.memoize.Cache`
	     * constructor with one whose instances implement the [`Map`](http://ecma-international.org/ecma-262/6.0/#sec-properties-of-the-map-prototype-object)
	     * method interface of `get`, `has`, and `set`.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to have its output memoized.
	     * @param {Function} [resolver] The function to resolve the cache key.
	     * @returns {Function} Returns the new memoizing function.
	     * @example
	     *
	     * var upperCase = _.memoize(function(string) {
	     *   return string.toUpperCase();
	     * });
	     *
	     * upperCase('fred');
	     * // => 'FRED'
	     *
	     * // modifying the result cache
	     * upperCase.cache.set('fred', 'BARNEY');
	     * upperCase('fred');
	     * // => 'BARNEY'
	     *
	     * // replacing `_.memoize.Cache`
	     * var object = { 'user': 'fred' };
	     * var other = { 'user': 'barney' };
	     * var identity = _.memoize(_.identity);
	     *
	     * identity(object);
	     * // => { 'user': 'fred' }
	     * identity(other);
	     * // => { 'user': 'fred' }
	     *
	     * _.memoize.Cache = WeakMap;
	     * var identity = _.memoize(_.identity);
	     *
	     * identity(object);
	     * // => { 'user': 'fred' }
	     * identity(other);
	     * // => { 'user': 'barney' }
	     */
	    function memoize(func, resolver) {
	      if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var memoized = function() {
	        var args = arguments,
	            key = resolver ? resolver.apply(this, args) : args[0],
	            cache = memoized.cache;
	
	        if (cache.has(key)) {
	          return cache.get(key);
	        }
	        var result = func.apply(this, args);
	        memoized.cache = cache.set(key, result);
	        return result;
	      };
	      memoized.cache = new memoize.Cache;
	      return memoized;
	    }
	
	    /**
	     * Creates a function that runs each argument through a corresponding
	     * transform function.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to wrap.
	     * @param {...(Function|Function[])} [transforms] The functions to transform
	     * arguments, specified as individual functions or arrays of functions.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * function doubled(n) {
	     *   return n * 2;
	     * }
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var modded = _.modArgs(function(x, y) {
	     *   return [x, y];
	     * }, square, doubled);
	     *
	     * modded(1, 2);
	     * // => [1, 4]
	     *
	     * modded(5, 10);
	     * // => [25, 20]
	     */
	    var modArgs = restParam(function(func, transforms) {
	      transforms = baseFlatten(transforms);
	      if (typeof func != 'function' || !arrayEvery(transforms, baseIsFunction)) {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var length = transforms.length;
	      return restParam(function(args) {
	        var index = nativeMin(args.length, length);
	        while (index--) {
	          args[index] = transforms[index](args[index]);
	        }
	        return func.apply(this, args);
	      });
	    });
	
	    /**
	     * Creates a function that negates the result of the predicate `func`. The
	     * `func` predicate is invoked with the `this` binding and arguments of the
	     * created function.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} predicate The predicate to negate.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * function isEven(n) {
	     *   return n % 2 == 0;
	     * }
	     *
	     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
	     * // => [1, 3, 5]
	     */
	    function negate(predicate) {
	      if (typeof predicate != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return function() {
	        return !predicate.apply(this, arguments);
	      };
	    }
	
	    /**
	     * Creates a function that is restricted to invoking `func` once. Repeat calls
	     * to the function return the value of the first call. The `func` is invoked
	     * with the `this` binding and arguments of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var initialize = _.once(createApplication);
	     * initialize();
	     * initialize();
	     * // `initialize` invokes `createApplication` once
	     */
	    function once(func) {
	      return before(2, func);
	    }
	
	    /**
	     * Creates a function that invokes `func` with `partial` arguments prepended
	     * to those provided to the new function. This method is like `_.bind` except
	     * it does **not** alter the `this` binding.
	     *
	     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method does not set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * var greet = function(greeting, name) {
	     *   return greeting + ' ' + name;
	     * };
	     *
	     * var sayHelloTo = _.partial(greet, 'hello');
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     *
	     * // using placeholders
	     * var greetFred = _.partial(greet, _, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     */
	    var partial = createPartial(PARTIAL_FLAG);
	
	    /**
	     * This method is like `_.partial` except that partially applied arguments
	     * are appended to those provided to the new function.
	     *
	     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method does not set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * var greet = function(greeting, name) {
	     *   return greeting + ' ' + name;
	     * };
	     *
	     * var greetFred = _.partialRight(greet, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     *
	     * // using placeholders
	     * var sayHelloTo = _.partialRight(greet, 'hello', _);
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     */
	    var partialRight = createPartial(PARTIAL_RIGHT_FLAG);
	
	    /**
	     * Creates a function that invokes `func` with arguments arranged according
	     * to the specified indexes where the argument value at the first index is
	     * provided as the first argument, the argument value at the second index is
	     * provided as the second argument, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to rearrange arguments for.
	     * @param {...(number|number[])} indexes The arranged argument indexes,
	     *  specified as individual indexes or arrays of indexes.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var rearged = _.rearg(function(a, b, c) {
	     *   return [a, b, c];
	     * }, 2, 0, 1);
	     *
	     * rearged('b', 'c', 'a')
	     * // => ['a', 'b', 'c']
	     *
	     * var map = _.rearg(_.map, [1, 0]);
	     * map(function(n) {
	     *   return n * 3;
	     * }, [1, 2, 3]);
	     * // => [3, 6, 9]
	     */
	    var rearg = restParam(function(func, indexes) {
	      return createWrapper(func, REARG_FLAG, undefined, undefined, undefined, baseFlatten(indexes));
	    });
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * created function and arguments from `start` and beyond provided as an array.
	     *
	     * **Note:** This method is based on the [rest parameter](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Functions/rest_parameters).
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.restParam(function(what, names) {
	     *   return what + ' ' + _.initial(names).join(', ') +
	     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
	     * });
	     *
	     * say('hello', 'fred', 'barney', 'pebbles');
	     * // => 'hello fred, barney, & pebbles'
	     */
	    function restParam(func, start) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      start = nativeMax(start === undefined ? (func.length - 1) : (+start || 0), 0);
	      return function() {
	        var args = arguments,
	            index = -1,
	            length = nativeMax(args.length - start, 0),
	            rest = Array(length);
	
	        while (++index < length) {
	          rest[index] = args[start + index];
	        }
	        switch (start) {
	          case 0: return func.call(this, rest);
	          case 1: return func.call(this, args[0], rest);
	          case 2: return func.call(this, args[0], args[1], rest);
	        }
	        var otherArgs = Array(start + 1);
	        index = -1;
	        while (++index < start) {
	          otherArgs[index] = args[index];
	        }
	        otherArgs[start] = rest;
	        return func.apply(this, otherArgs);
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the created
	     * function and an array of arguments much like [`Function#apply`](https://es5.github.io/#x15.3.4.3).
	     *
	     * **Note:** This method is based on the [spread operator](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/Spread_operator).
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to spread arguments over.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.spread(function(who, what) {
	     *   return who + ' says ' + what;
	     * });
	     *
	     * say(['fred', 'hello']);
	     * // => 'fred says hello'
	     *
	     * // with a Promise
	     * var numbers = Promise.all([
	     *   Promise.resolve(40),
	     *   Promise.resolve(36)
	     * ]);
	     *
	     * numbers.then(_.spread(function(x, y) {
	     *   return x + y;
	     * }));
	     * // => a Promise of 76
	     */
	    function spread(func) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return function(array) {
	        return func.apply(this, array);
	      };
	    }
	
	    /**
	     * Creates a throttled function that only invokes `func` at most once per
	     * every `wait` milliseconds. The throttled function comes with a `cancel`
	     * method to cancel delayed invocations. Provide an options object to indicate
	     * that `func` should be invoked on the leading and/or trailing edge of the
	     * `wait` timeout. Subsequent calls to the throttled function return the
	     * result of the last `func` call.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is invoked
	     * on the trailing edge of the timeout only if the the throttled function is
	     * invoked more than once during the `wait` timeout.
	     *
	     * See [David Corbacho's article](http://drupalmotion.com/article/debounce-and-throttle-visual-explanation)
	     * for details over the differences between `_.throttle` and `_.debounce`.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to throttle.
	     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
	     * @param {Object} [options] The options object.
	     * @param {boolean} [options.leading=true] Specify invoking on the leading
	     *  edge of the timeout.
	     * @param {boolean} [options.trailing=true] Specify invoking on the trailing
	     *  edge of the timeout.
	     * @returns {Function} Returns the new throttled function.
	     * @example
	     *
	     * // avoid excessively updating the position while scrolling
	     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
	     *
	     * // invoke `renewToken` when the click event is fired, but not more than once every 5 minutes
	     * jQuery('.interactive').on('click', _.throttle(renewToken, 300000, {
	     *   'trailing': false
	     * }));
	     *
	     * // cancel a trailing throttled call
	     * jQuery(window).on('popstate', throttled.cancel);
	     */
	    function throttle(func, wait, options) {
	      var leading = true,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      if (options === false) {
	        leading = false;
	      } else if (isObject(options)) {
	        leading = 'leading' in options ? !!options.leading : leading;
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	      return debounce(func, wait, { 'leading': leading, 'maxWait': +wait, 'trailing': trailing });
	    }
	
	    /**
	     * Creates a function that provides `value` to the wrapper function as its
	     * first argument. Any additional arguments provided to the function are
	     * appended to those provided to the wrapper function. The wrapper is invoked
	     * with the `this` binding of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {*} value The value to wrap.
	     * @param {Function} wrapper The wrapper function.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var p = _.wrap(_.escape, function(func, text) {
	     *   return '<p>' + func(text) + '</p>';
	     * });
	     *
	     * p('fred, barney, & pebbles');
	     * // => '<p>fred, barney, &amp; pebbles</p>'
	     */
	    function wrap(value, wrapper) {
	      wrapper = wrapper == null ? identity : wrapper;
	      return createWrapper(wrapper, PARTIAL_FLAG, undefined, [value], []);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a clone of `value`. If `isDeep` is `true` nested objects are cloned,
	     * otherwise they are assigned by reference. If `customizer` is provided it is
	     * invoked to produce the cloned values. If `customizer` returns `undefined`
	     * cloning is handled by the method instead. The `customizer` is bound to
	     * `thisArg` and invoked with two argument; (value [, index|key, object]).
	     *
	     * **Note:** This method is loosely based on the
	     * [structured clone algorithm](http://www.w3.org/TR/html5/infrastructure.html#internal-structured-cloning-algorithm).
	     * The enumerable properties of `arguments` objects and objects created by
	     * constructors other than `Object` are cloned to plain `Object` objects. An
	     * empty object is returned for uncloneable values such as functions, DOM nodes,
	     * Maps, Sets, and WeakMaps.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @param {Function} [customizer] The function to customize cloning values.
	     * @param {*} [thisArg] The `this` binding of `customizer`.
	     * @returns {*} Returns the cloned value.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney' },
	     *   { 'user': 'fred' }
	     * ];
	     *
	     * var shallow = _.clone(users);
	     * shallow[0] === users[0];
	     * // => true
	     *
	     * var deep = _.clone(users, true);
	     * deep[0] === users[0];
	     * // => false
	     *
	     * // using a customizer callback
	     * var el = _.clone(document.body, function(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(false);
	     *   }
	     * });
	     *
	     * el === document.body
	     * // => false
	     * el.nodeName
	     * // => BODY
	     * el.childNodes.length;
	     * // => 0
	     */
	    function clone(value, isDeep, customizer, thisArg) {
	      if (isDeep && typeof isDeep != 'boolean' && isIterateeCall(value, isDeep, customizer)) {
	        isDeep = false;
	      }
	      else if (typeof isDeep == 'function') {
	        thisArg = customizer;
	        customizer = isDeep;
	        isDeep = false;
	      }
	      return typeof customizer == 'function'
	        ? baseClone(value, isDeep, bindCallback(customizer, thisArg, 1))
	        : baseClone(value, isDeep);
	    }
	
	    /**
	     * Creates a deep clone of `value`. If `customizer` is provided it is invoked
	     * to produce the cloned values. If `customizer` returns `undefined` cloning
	     * is handled by the method instead. The `customizer` is bound to `thisArg`
	     * and invoked with two argument; (value [, index|key, object]).
	     *
	     * **Note:** This method is loosely based on the
	     * [structured clone algorithm](http://www.w3.org/TR/html5/infrastructure.html#internal-structured-cloning-algorithm).
	     * The enumerable properties of `arguments` objects and objects created by
	     * constructors other than `Object` are cloned to plain `Object` objects. An
	     * empty object is returned for uncloneable values such as functions, DOM nodes,
	     * Maps, Sets, and WeakMaps.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to deep clone.
	     * @param {Function} [customizer] The function to customize cloning values.
	     * @param {*} [thisArg] The `this` binding of `customizer`.
	     * @returns {*} Returns the deep cloned value.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney' },
	     *   { 'user': 'fred' }
	     * ];
	     *
	     * var deep = _.cloneDeep(users);
	     * deep[0] === users[0];
	     * // => false
	     *
	     * // using a customizer callback
	     * var el = _.cloneDeep(document.body, function(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(true);
	     *   }
	     * });
	     *
	     * el === document.body
	     * // => false
	     * el.nodeName
	     * // => BODY
	     * el.childNodes.length;
	     * // => 20
	     */
	    function cloneDeep(value, customizer, thisArg) {
	      return typeof customizer == 'function'
	        ? baseClone(value, true, bindCallback(customizer, thisArg, 1))
	        : baseClone(value, true);
	    }
	
	    /**
	     * Checks if `value` is greater than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`, else `false`.
	     * @example
	     *
	     * _.gt(3, 1);
	     * // => true
	     *
	     * _.gt(3, 3);
	     * // => false
	     *
	     * _.gt(1, 3);
	     * // => false
	     */
	    function gt(value, other) {
	      return value > other;
	    }
	
	    /**
	     * Checks if `value` is greater than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than or equal to `other`, else `false`.
	     * @example
	     *
	     * _.gte(3, 1);
	     * // => true
	     *
	     * _.gte(3, 3);
	     * // => true
	     *
	     * _.gte(1, 3);
	     * // => false
	     */
	    function gte(value, other) {
	      return value >= other;
	    }
	
	    /**
	     * Checks if `value` is classified as an `arguments` object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isArguments(function() { return arguments; }());
	     * // => true
	     *
	     * _.isArguments([1, 2, 3]);
	     * // => false
	     */
	    function isArguments(value) {
	      return isObjectLike(value) && isArrayLike(value) &&
	        hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
	    }
	
	    /**
	     * Checks if `value` is classified as an `Array` object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isArray([1, 2, 3]);
	     * // => true
	     *
	     * _.isArray(function() { return arguments; }());
	     * // => false
	     */
	    var isArray = nativeIsArray || function(value) {
	      return isObjectLike(value) && isLength(value.length) && objToString.call(value) == arrayTag;
	    };
	
	    /**
	     * Checks if `value` is classified as a boolean primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isBoolean(false);
	     * // => true
	     *
	     * _.isBoolean(null);
	     * // => false
	     */
	    function isBoolean(value) {
	      return value === true || value === false || (isObjectLike(value) && objToString.call(value) == boolTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Date` object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isDate(new Date);
	     * // => true
	     *
	     * _.isDate('Mon April 23 2012');
	     * // => false
	     */
	    function isDate(value) {
	      return isObjectLike(value) && objToString.call(value) == dateTag;
	    }
	
	    /**
	     * Checks if `value` is a DOM element.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
	     * @example
	     *
	     * _.isElement(document.body);
	     * // => true
	     *
	     * _.isElement('<body>');
	     * // => false
	     */
	    function isElement(value) {
	      return !!value && value.nodeType === 1 && isObjectLike(value) && !isPlainObject(value);
	    }
	
	    /**
	     * Checks if `value` is empty. A value is considered empty unless it is an
	     * `arguments` object, array, string, or jQuery-like collection with a length
	     * greater than `0` or an object with own enumerable properties.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {Array|Object|string} value The value to inspect.
	     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
	     * @example
	     *
	     * _.isEmpty(null);
	     * // => true
	     *
	     * _.isEmpty(true);
	     * // => true
	     *
	     * _.isEmpty(1);
	     * // => true
	     *
	     * _.isEmpty([1, 2, 3]);
	     * // => false
	     *
	     * _.isEmpty({ 'a': 1 });
	     * // => false
	     */
	    function isEmpty(value) {
	      if (value == null) {
	        return true;
	      }
	      if (isArrayLike(value) && (isArray(value) || isString(value) || isArguments(value) ||
	          (isObjectLike(value) && isFunction(value.splice)))) {
	        return !value.length;
	      }
	      return !keys(value).length;
	    }
	
	    /**
	     * Performs a deep comparison between two values to determine if they are
	     * equivalent. If `customizer` is provided it is invoked to compare values.
	     * If `customizer` returns `undefined` comparisons are handled by the method
	     * instead. The `customizer` is bound to `thisArg` and invoked with three
	     * arguments: (value, other [, index|key]).
	     *
	     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
	     * numbers, `Object` objects, regexes, and strings. Objects are compared by
	     * their own, not inherited, enumerable properties. Functions and DOM nodes
	     * are **not** supported. Provide a customizer function to extend support
	     * for comparing other values.
	     *
	     * @static
	     * @memberOf _
	     * @alias eq
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {Function} [customizer] The function to customize value comparisons.
	     * @param {*} [thisArg] The `this` binding of `customizer`.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'user': 'fred' };
	     * var other = { 'user': 'fred' };
	     *
	     * object == other;
	     * // => false
	     *
	     * _.isEqual(object, other);
	     * // => true
	     *
	     * // using a customizer callback
	     * var array = ['hello', 'goodbye'];
	     * var other = ['hi', 'goodbye'];
	     *
	     * _.isEqual(array, other, function(value, other) {
	     *   if (_.every([value, other], RegExp.prototype.test, /^h(?:i|ello)$/)) {
	     *     return true;
	     *   }
	     * });
	     * // => true
	     */
	    function isEqual(value, other, customizer, thisArg) {
	      customizer = typeof customizer == 'function' ? bindCallback(customizer, thisArg, 3) : undefined;
	      var result = customizer ? customizer(value, other) : undefined;
	      return  result === undefined ? baseIsEqual(value, other, customizer) : !!result;
	    }
	
	    /**
	     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
	     * `SyntaxError`, `TypeError`, or `URIError` object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
	     * @example
	     *
	     * _.isError(new Error);
	     * // => true
	     *
	     * _.isError(Error);
	     * // => false
	     */
	    function isError(value) {
	      return isObjectLike(value) && typeof value.message == 'string' && objToString.call(value) == errorTag;
	    }
	
	    /**
	     * Checks if `value` is a finite primitive number.
	     *
	     * **Note:** This method is based on [`Number.isFinite`](http://ecma-international.org/ecma-262/6.0/#sec-number.isfinite).
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
	     * @example
	     *
	     * _.isFinite(10);
	     * // => true
	     *
	     * _.isFinite('10');
	     * // => false
	     *
	     * _.isFinite(true);
	     * // => false
	     *
	     * _.isFinite(Object(10));
	     * // => false
	     *
	     * _.isFinite(Infinity);
	     * // => false
	     */
	    function isFinite(value) {
	      return typeof value == 'number' && nativeIsFinite(value);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Function` object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isFunction(_);
	     * // => true
	     *
	     * _.isFunction(/abc/);
	     * // => false
	     */
	    function isFunction(value) {
	      // The use of `Object#toString` avoids issues with the `typeof` operator
	      // in older versions of Chrome and Safari which return 'function' for regexes
	      // and Safari 8 equivalents which return 'object' for typed array constructors.
	      return isObject(value) && objToString.call(value) == funcTag;
	    }
	
	    /**
	     * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
	     * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	     * @example
	     *
	     * _.isObject({});
	     * // => true
	     *
	     * _.isObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isObject(1);
	     * // => false
	     */
	    function isObject(value) {
	      // Avoid a V8 JIT bug in Chrome 19-20.
	      // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
	      var type = typeof value;
	      return !!value && (type == 'object' || type == 'function');
	    }
	
	    /**
	     * Performs a deep comparison between `object` and `source` to determine if
	     * `object` contains equivalent property values. If `customizer` is provided
	     * it is invoked to compare values. If `customizer` returns `undefined`
	     * comparisons are handled by the method instead. The `customizer` is bound
	     * to `thisArg` and invoked with three arguments: (value, other, index|key).
	     *
	     * **Note:** This method supports comparing properties of arrays, booleans,
	     * `Date` objects, numbers, `Object` objects, regexes, and strings. Functions
	     * and DOM nodes are **not** supported. Provide a customizer function to extend
	     * support for comparing other values.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Function} [customizer] The function to customize value comparisons.
	     * @param {*} [thisArg] The `this` binding of `customizer`.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * var object = { 'user': 'fred', 'age': 40 };
	     *
	     * _.isMatch(object, { 'age': 40 });
	     * // => true
	     *
	     * _.isMatch(object, { 'age': 36 });
	     * // => false
	     *
	     * // using a customizer callback
	     * var object = { 'greeting': 'hello' };
	     * var source = { 'greeting': 'hi' };
	     *
	     * _.isMatch(object, source, function(value, other) {
	     *   return _.every([value, other], RegExp.prototype.test, /^h(?:i|ello)$/) || undefined;
	     * });
	     * // => true
	     */
	    function isMatch(object, source, customizer, thisArg) {
	      customizer = typeof customizer == 'function' ? bindCallback(customizer, thisArg, 3) : undefined;
	      return baseIsMatch(object, getMatchData(source), customizer);
	    }
	
	    /**
	     * Checks if `value` is `NaN`.
	     *
	     * **Note:** This method is not the same as [`isNaN`](https://es5.github.io/#x15.1.2.4)
	     * which returns `true` for `undefined` and other non-numeric values.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	     * @example
	     *
	     * _.isNaN(NaN);
	     * // => true
	     *
	     * _.isNaN(new Number(NaN));
	     * // => true
	     *
	     * isNaN(undefined);
	     * // => true
	     *
	     * _.isNaN(undefined);
	     * // => false
	     */
	    function isNaN(value) {
	      // An `NaN` primitive is the only value that is not equal to itself.
	      // Perform the `toStringTag` check first to avoid errors with some host objects in IE.
	      return isNumber(value) && value != +value;
	    }
	
	    /**
	     * Checks if `value` is a native function.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function, else `false`.
	     * @example
	     *
	     * _.isNative(Array.prototype.push);
	     * // => true
	     *
	     * _.isNative(_);
	     * // => false
	     */
	    function isNative(value) {
	      if (value == null) {
	        return false;
	      }
	      if (isFunction(value)) {
	        return reIsNative.test(fnToString.call(value));
	      }
	      return isObjectLike(value) && reIsHostCtor.test(value);
	    }
	
	    /**
	     * Checks if `value` is `null`.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
	     * @example
	     *
	     * _.isNull(null);
	     * // => true
	     *
	     * _.isNull(void 0);
	     * // => false
	     */
	    function isNull(value) {
	      return value === null;
	    }
	
	    /**
	     * Checks if `value` is classified as a `Number` primitive or object.
	     *
	     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are classified
	     * as numbers, use the `_.isFinite` method.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isNumber(8.4);
	     * // => true
	     *
	     * _.isNumber(NaN);
	     * // => true
	     *
	     * _.isNumber('8.4');
	     * // => false
	     */
	    function isNumber(value) {
	      return typeof value == 'number' || (isObjectLike(value) && objToString.call(value) == numberTag);
	    }
	
	    /**
	     * Checks if `value` is a plain object, that is, an object created by the
	     * `Object` constructor or one with a `[[Prototype]]` of `null`.
	     *
	     * **Note:** This method assumes objects created by the `Object` constructor
	     * have no inherited enumerable properties.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * _.isPlainObject(new Foo);
	     * // => false
	     *
	     * _.isPlainObject([1, 2, 3]);
	     * // => false
	     *
	     * _.isPlainObject({ 'x': 0, 'y': 0 });
	     * // => true
	     *
	     * _.isPlainObject(Object.create(null));
	     * // => true
	     */
	    function isPlainObject(value) {
	      var Ctor;
	
	      // Exit early for non `Object` objects.
	      if (!(isObjectLike(value) && objToString.call(value) == objectTag && !isArguments(value)) ||
	          (!hasOwnProperty.call(value, 'constructor') && (Ctor = value.constructor, typeof Ctor == 'function' && !(Ctor instanceof Ctor)))) {
	        return false;
	      }
	      // IE < 9 iterates inherited properties before own properties. If the first
	      // iterated property is an object's own property then there are no inherited
	      // enumerable properties.
	      var result;
	      // In most environments an object's own properties are iterated before
	      // its inherited properties. If the last iterated property is an object's
	      // own property then there are no inherited enumerable properties.
	      baseForIn(value, function(subValue, key) {
	        result = key;
	      });
	      return result === undefined || hasOwnProperty.call(value, result);
	    }
	
	    /**
	     * Checks if `value` is classified as a `RegExp` object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isRegExp(/abc/);
	     * // => true
	     *
	     * _.isRegExp('/abc/');
	     * // => false
	     */
	    function isRegExp(value) {
	      return isObject(value) && objToString.call(value) == regexpTag;
	    }
	
	    /**
	     * Checks if `value` is classified as a `String` primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isString('abc');
	     * // => true
	     *
	     * _.isString(1);
	     * // => false
	     */
	    function isString(value) {
	      return typeof value == 'string' || (isObjectLike(value) && objToString.call(value) == stringTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a typed array.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isTypedArray(new Uint8Array);
	     * // => true
	     *
	     * _.isTypedArray([]);
	     * // => false
	     */
	    function isTypedArray(value) {
	      return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[objToString.call(value)];
	    }
	
	    /**
	     * Checks if `value` is `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
	     * @example
	     *
	     * _.isUndefined(void 0);
	     * // => true
	     *
	     * _.isUndefined(null);
	     * // => false
	     */
	    function isUndefined(value) {
	      return value === undefined;
	    }
	
	    /**
	     * Checks if `value` is less than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`, else `false`.
	     * @example
	     *
	     * _.lt(1, 3);
	     * // => true
	     *
	     * _.lt(3, 3);
	     * // => false
	     *
	     * _.lt(3, 1);
	     * // => false
	     */
	    function lt(value, other) {
	      return value < other;
	    }
	
	    /**
	     * Checks if `value` is less than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than or equal to `other`, else `false`.
	     * @example
	     *
	     * _.lte(1, 3);
	     * // => true
	     *
	     * _.lte(3, 3);
	     * // => true
	     *
	     * _.lte(3, 1);
	     * // => false
	     */
	    function lte(value, other) {
	      return value <= other;
	    }
	
	    /**
	     * Converts `value` to an array.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the converted array.
	     * @example
	     *
	     * (function() {
	     *   return _.toArray(arguments).slice(1);
	     * }(1, 2, 3));
	     * // => [2, 3]
	     */
	    function toArray(value) {
	      var length = value ? getLength(value) : 0;
	      if (!isLength(length)) {
	        return values(value);
	      }
	      if (!length) {
	        return [];
	      }
	      return arrayCopy(value);
	    }
	
	    /**
	     * Converts `value` to a plain object flattening inherited enumerable
	     * properties of `value` to own properties of the plain object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Object} Returns the converted plain object.
	     * @example
	     *
	     * function Foo() {
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.assign({ 'a': 1 }, new Foo);
	     * // => { 'a': 1, 'b': 2 }
	     *
	     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
	     * // => { 'a': 1, 'b': 2, 'c': 3 }
	     */
	    function toPlainObject(value) {
	      return baseCopy(value, keysIn(value));
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Recursively merges own enumerable properties of the source object(s), that
	     * don't resolve to `undefined` into the destination object. Subsequent sources
	     * overwrite property assignments of previous sources. If `customizer` is
	     * provided it is invoked to produce the merged values of the destination and
	     * source properties. If `customizer` returns `undefined` merging is handled
	     * by the method instead. The `customizer` is bound to `thisArg` and invoked
	     * with five arguments: (objectValue, sourceValue, key, object, source).
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @param {*} [thisArg] The `this` binding of `customizer`.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var users = {
	     *   'data': [{ 'user': 'barney' }, { 'user': 'fred' }]
	     * };
	     *
	     * var ages = {
	     *   'data': [{ 'age': 36 }, { 'age': 40 }]
	     * };
	     *
	     * _.merge(users, ages);
	     * // => { 'data': [{ 'user': 'barney', 'age': 36 }, { 'user': 'fred', 'age': 40 }] }
	     *
	     * // using a customizer callback
	     * var object = {
	     *   'fruits': ['apple'],
	     *   'vegetables': ['beet']
	     * };
	     *
	     * var other = {
	     *   'fruits': ['banana'],
	     *   'vegetables': ['carrot']
	     * };
	     *
	     * _.merge(object, other, function(a, b) {
	     *   if (_.isArray(a)) {
	     *     return a.concat(b);
	     *   }
	     * });
	     * // => { 'fruits': ['apple', 'banana'], 'vegetables': ['beet', 'carrot'] }
	     */
	    var merge = createAssigner(baseMerge);
	
	    /**
	     * Assigns own enumerable properties of source object(s) to the destination
	     * object. Subsequent sources overwrite property assignments of previous sources.
	     * If `customizer` is provided it is invoked to produce the assigned values.
	     * The `customizer` is bound to `thisArg` and invoked with five arguments:
	     * (objectValue, sourceValue, key, object, source).
	     *
	     * **Note:** This method mutates `object` and is based on
	     * [`Object.assign`](http://ecma-international.org/ecma-262/6.0/#sec-object.assign).
	     *
	     * @static
	     * @memberOf _
	     * @alias extend
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @param {*} [thisArg] The `this` binding of `customizer`.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * _.assign({ 'user': 'barney' }, { 'age': 40 }, { 'user': 'fred' });
	     * // => { 'user': 'fred', 'age': 40 }
	     *
	     * // using a customizer callback
	     * var defaults = _.partialRight(_.assign, function(value, other) {
	     *   return _.isUndefined(value) ? other : value;
	     * });
	     *
	     * defaults({ 'user': 'barney' }, { 'age': 36 }, { 'user': 'fred' });
	     * // => { 'user': 'barney', 'age': 36 }
	     */
	    var assign = createAssigner(function(object, source, customizer) {
	      return customizer
	        ? assignWith(object, source, customizer)
	        : baseAssign(object, source);
	    });
	
	    /**
	     * Creates an object that inherits from the given `prototype` object. If a
	     * `properties` object is provided its own enumerable properties are assigned
	     * to the created object.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} prototype The object to inherit from.
	     * @param {Object} [properties] The properties to assign to the object.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * function Shape() {
	     *   this.x = 0;
	     *   this.y = 0;
	     * }
	     *
	     * function Circle() {
	     *   Shape.call(this);
	     * }
	     *
	     * Circle.prototype = _.create(Shape.prototype, {
	     *   'constructor': Circle
	     * });
	     *
	     * var circle = new Circle;
	     * circle instanceof Circle;
	     * // => true
	     *
	     * circle instanceof Shape;
	     * // => true
	     */
	    function create(prototype, properties, guard) {
	      var result = baseCreate(prototype);
	      if (guard && isIterateeCall(prototype, properties, guard)) {
	        properties = undefined;
	      }
	      return properties ? baseAssign(result, properties) : result;
	    }
	
	    /**
	     * Assigns own enumerable properties of source object(s) to the destination
	     * object for all destination properties that resolve to `undefined`. Once a
	     * property is set, additional values of the same property are ignored.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * _.defaults({ 'user': 'barney' }, { 'age': 36 }, { 'user': 'fred' });
	     * // => { 'user': 'barney', 'age': 36 }
	     */
	    var defaults = createDefaults(assign, assignDefaults);
	
	    /**
	     * This method is like `_.defaults` except that it recursively assigns
	     * default properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * _.defaultsDeep({ 'user': { 'name': 'barney' } }, { 'user': { 'name': 'fred', 'age': 36 } });
	     * // => { 'user': { 'name': 'barney', 'age': 36 } }
	     *
	     */
	    var defaultsDeep = createDefaults(merge, mergeDefaults);
	
	    /**
	     * This method is like `_.find` except that it returns the key of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to search.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {string|undefined} Returns the key of the matched element, else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findKey(users, function(chr) {
	     *   return chr.age < 40;
	     * });
	     * // => 'barney' (iteration order is not guaranteed)
	     *
	     * // using the `_.matches` callback shorthand
	     * _.findKey(users, { 'age': 1, 'active': true });
	     * // => 'pebbles'
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.findKey(users, 'active', false);
	     * // => 'fred'
	     *
	     * // using the `_.property` callback shorthand
	     * _.findKey(users, 'active');
	     * // => 'barney'
	     */
	    var findKey = createFindKey(baseForOwn);
	
	    /**
	     * This method is like `_.findKey` except that it iterates over elements of
	     * a collection in the opposite order.
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to search.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {string|undefined} Returns the key of the matched element, else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findLastKey(users, function(chr) {
	     *   return chr.age < 40;
	     * });
	     * // => returns `pebbles` assuming `_.findKey` returns `barney`
	     *
	     * // using the `_.matches` callback shorthand
	     * _.findLastKey(users, { 'age': 36, 'active': true });
	     * // => 'barney'
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.findLastKey(users, 'active', false);
	     * // => 'fred'
	     *
	     * // using the `_.property` callback shorthand
	     * _.findLastKey(users, 'active');
	     * // => 'pebbles'
	     */
	    var findLastKey = createFindKey(baseForOwnRight);
	
	    /**
	     * Iterates over own and inherited enumerable properties of an object invoking
	     * `iteratee` for each property. The `iteratee` is bound to `thisArg` and invoked
	     * with three arguments: (value, key, object). Iteratee functions may exit
	     * iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forIn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => logs 'a', 'b', and 'c' (iteration order is not guaranteed)
	     */
	    var forIn = createForIn(baseFor);
	
	    /**
	     * This method is like `_.forIn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forInRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => logs 'c', 'b', and 'a' assuming `_.forIn ` logs 'a', 'b', and 'c'
	     */
	    var forInRight = createForIn(baseForRight);
	
	    /**
	     * Iterates over own enumerable properties of an object invoking `iteratee`
	     * for each property. The `iteratee` is bound to `thisArg` and invoked with
	     * three arguments: (value, key, object). Iteratee functions may exit iteration
	     * early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => logs 'a' and 'b' (iteration order is not guaranteed)
	     */
	    var forOwn = createForOwn(baseForOwn);
	
	    /**
	     * This method is like `_.forOwn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwnRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => logs 'b' and 'a' assuming `_.forOwn` logs 'a' and 'b'
	     */
	    var forOwnRight = createForOwn(baseForOwnRight);
	
	    /**
	     * Creates an array of function property names from all enumerable properties,
	     * own and inherited, of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @alias methods
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the new array of property names.
	     * @example
	     *
	     * _.functions(_);
	     * // => ['after', 'ary', 'assign', ...]
	     */
	    function functions(object) {
	      return baseFunctions(object, keysIn(object));
	    }
	
	    /**
	     * Gets the property value at `path` of `object`. If the resolved value is
	     * `undefined` the `defaultValue` is used in its place.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} [defaultValue] The value returned if the resolved value is `undefined`.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.get(object, 'a[0].b.c');
	     * // => 3
	     *
	     * _.get(object, ['a', '0', 'b', 'c']);
	     * // => 3
	     *
	     * _.get(object, 'a.b.c', 'default');
	     * // => 'default'
	     */
	    function get(object, path, defaultValue) {
	      var result = object == null ? undefined : baseGet(object, toPath(path), path + '');
	      return result === undefined ? defaultValue : result;
	    }
	
	    /**
	     * Checks if `path` is a direct property.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` is a direct property, else `false`.
	     * @example
	     *
	     * var object = { 'a': { 'b': { 'c': 3 } } };
	     *
	     * _.has(object, 'a');
	     * // => true
	     *
	     * _.has(object, 'a.b.c');
	     * // => true
	     *
	     * _.has(object, ['a', 'b', 'c']);
	     * // => true
	     */
	    function has(object, path) {
	      if (object == null) {
	        return false;
	      }
	      var result = hasOwnProperty.call(object, path);
	      if (!result && !isKey(path)) {
	        path = toPath(path);
	        object = path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
	        if (object == null) {
	          return false;
	        }
	        path = last(path);
	        result = hasOwnProperty.call(object, path);
	      }
	      return result || (isLength(object.length) && isIndex(path, object.length) &&
	        (isArray(object) || isArguments(object)));
	    }
	
	    /**
	     * Creates an object composed of the inverted keys and values of `object`.
	     * If `object` contains duplicate values, subsequent values overwrite property
	     * assignments of previous values unless `multiValue` is `true`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @param {boolean} [multiValue] Allow multiple values per key.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invert(object);
	     * // => { '1': 'c', '2': 'b' }
	     *
	     * // with `multiValue`
	     * _.invert(object, true);
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     */
	    function invert(object, multiValue, guard) {
	      if (guard && isIterateeCall(object, multiValue, guard)) {
	        multiValue = undefined;
	      }
	      var index = -1,
	          props = keys(object),
	          length = props.length,
	          result = {};
	
	      while (++index < length) {
	        var key = props[index],
	            value = object[key];
	
	        if (multiValue) {
	          if (hasOwnProperty.call(result, value)) {
	            result[value].push(key);
	          } else {
	            result[value] = [key];
	          }
	        }
	        else {
	          result[value] = key;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array of the own enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects. See the
	     * [ES spec](http://ecma-international.org/ecma-262/6.0/#sec-object.keys)
	     * for more details.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keys(new Foo);
	     * // => ['a', 'b'] (iteration order is not guaranteed)
	     *
	     * _.keys('hi');
	     * // => ['0', '1']
	     */
	    var keys = !nativeKeys ? shimKeys : function(object) {
	      var Ctor = object == null ? undefined : object.constructor;
	      if ((typeof Ctor == 'function' && Ctor.prototype === object) ||
	          (typeof object != 'function' && isArrayLike(object))) {
	        return shimKeys(object);
	      }
	      return isObject(object) ? nativeKeys(object) : [];
	    };
	
	    /**
	     * Creates an array of the own and inherited enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keysIn(new Foo);
	     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	     */
	    function keysIn(object) {
	      if (object == null) {
	        return [];
	      }
	      if (!isObject(object)) {
	        object = Object(object);
	      }
	      var length = object.length;
	      length = (length && isLength(length) &&
	        (isArray(object) || isArguments(object)) && length) || 0;
	
	      var Ctor = object.constructor,
	          index = -1,
	          isProto = typeof Ctor == 'function' && Ctor.prototype === object,
	          result = Array(length),
	          skipIndexes = length > 0;
	
	      while (++index < length) {
	        result[index] = (index + '');
	      }
	      for (var key in object) {
	        if (!(skipIndexes && isIndex(key, length)) &&
	            !(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The opposite of `_.mapValues`; this method creates an object with the
	     * same values as `object` and keys generated by running each own enumerable
	     * property of `object` through `iteratee`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Object} Returns the new mapped object.
	     * @example
	     *
	     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   return key + value;
	     * });
	     * // => { 'a1': 1, 'b2': 2 }
	     */
	    var mapKeys = createObjectMapper(true);
	
	    /**
	     * Creates an object with the same keys as `object` and values generated by
	     * running each own enumerable property of `object` through `iteratee`. The
	     * iteratee function is bound to `thisArg` and invoked with three arguments:
	     * (value, key, object).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Object} Returns the new mapped object.
	     * @example
	     *
	     * _.mapValues({ 'a': 1, 'b': 2 }, function(n) {
	     *   return n * 3;
	     * });
	     * // => { 'a': 3, 'b': 6 }
	     *
	     * var users = {
	     *   'fred':    { 'user': 'fred',    'age': 40 },
	     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
	     * };
	     *
	     * // using the `_.property` callback shorthand
	     * _.mapValues(users, 'age');
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     */
	    var mapValues = createObjectMapper();
	
	    /**
	     * The opposite of `_.pick`; this method creates an object composed of the
	     * own and inherited enumerable properties of `object` that are not omitted.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function|...(string|string[])} [predicate] The function invoked per
	     *  iteration or property names to omit, specified as individual property
	     *  names or arrays of property names.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'user': 'fred', 'age': 40 };
	     *
	     * _.omit(object, 'age');
	     * // => { 'user': 'fred' }
	     *
	     * _.omit(object, _.isNumber);
	     * // => { 'user': 'fred' }
	     */
	    var omit = restParam(function(object, props) {
	      if (object == null) {
	        return {};
	      }
	      if (typeof props[0] != 'function') {
	        var props = arrayMap(baseFlatten(props), String);
	        return pickByArray(object, baseDifference(keysIn(object), props));
	      }
	      var predicate = bindCallback(props[0], props[1], 3);
	      return pickByCallback(object, function(value, key, object) {
	        return !predicate(value, key, object);
	      });
	    });
	
	    /**
	     * Creates a two dimensional array of the key-value pairs for `object`,
	     * e.g. `[[key1, value1], [key2, value2]]`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the new array of key-value pairs.
	     * @example
	     *
	     * _.pairs({ 'barney': 36, 'fred': 40 });
	     * // => [['barney', 36], ['fred', 40]] (iteration order is not guaranteed)
	     */
	    function pairs(object) {
	      object = toObject(object);
	
	      var index = -1,
	          props = keys(object),
	          length = props.length,
	          result = Array(length);
	
	      while (++index < length) {
	        var key = props[index];
	        result[index] = [key, object[key]];
	      }
	      return result;
	    }
	
	    /**
	     * Creates an object composed of the picked `object` properties. Property
	     * names may be specified as individual arguments or as arrays of property
	     * names. If `predicate` is provided it is invoked for each property of `object`
	     * picking the properties `predicate` returns truthy for. The predicate is
	     * bound to `thisArg` and invoked with three arguments: (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function|...(string|string[])} [predicate] The function invoked per
	     *  iteration or property names to pick, specified as individual property
	     *  names or arrays of property names.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'user': 'fred', 'age': 40 };
	     *
	     * _.pick(object, 'user');
	     * // => { 'user': 'fred' }
	     *
	     * _.pick(object, _.isString);
	     * // => { 'user': 'fred' }
	     */
	    var pick = restParam(function(object, props) {
	      if (object == null) {
	        return {};
	      }
	      return typeof props[0] == 'function'
	        ? pickByCallback(object, bindCallback(props[0], props[1], 3))
	        : pickByArray(object, baseFlatten(props));
	    });
	
	    /**
	     * This method is like `_.get` except that if the resolved value is a function
	     * it is invoked with the `this` binding of its parent object and its result
	     * is returned.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to resolve.
	     * @param {*} [defaultValue] The value returned if the resolved value is `undefined`.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
	     *
	     * _.result(object, 'a[0].b.c1');
	     * // => 3
	     *
	     * _.result(object, 'a[0].b.c2');
	     * // => 4
	     *
	     * _.result(object, 'a.b.c', 'default');
	     * // => 'default'
	     *
	     * _.result(object, 'a.b.c', _.constant('default'));
	     * // => 'default'
	     */
	    function result(object, path, defaultValue) {
	      var result = object == null ? undefined : object[path];
	      if (result === undefined) {
	        if (object != null && !isKey(path, object)) {
	          path = toPath(path);
	          object = path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
	          result = object == null ? undefined : object[last(path)];
	        }
	        result = result === undefined ? defaultValue : result;
	      }
	      return isFunction(result) ? result.call(object) : result;
	    }
	
	    /**
	     * Sets the property value of `path` on `object`. If a portion of `path`
	     * does not exist it is created.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to augment.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.set(object, 'a[0].b.c', 4);
	     * console.log(object.a[0].b.c);
	     * // => 4
	     *
	     * _.set(object, 'x[0].y.z', 5);
	     * console.log(object.x[0].y.z);
	     * // => 5
	     */
	    function set(object, path, value) {
	      if (object == null) {
	        return object;
	      }
	      var pathKey = (path + '');
	      path = (object[pathKey] != null || isKey(path, object)) ? [pathKey] : toPath(path);
	
	      var index = -1,
	          length = path.length,
	          lastIndex = length - 1,
	          nested = object;
	
	      while (nested != null && ++index < length) {
	        var key = path[index];
	        if (isObject(nested)) {
	          if (index == lastIndex) {
	            nested[key] = value;
	          } else if (nested[key] == null) {
	            nested[key] = isIndex(path[index + 1]) ? [] : {};
	          }
	        }
	        nested = nested[key];
	      }
	      return object;
	    }
	
	    /**
	     * An alternative to `_.reduce`; this method transforms `object` to a new
	     * `accumulator` object which is the result of running each of its own enumerable
	     * properties through `iteratee`, with each invocation potentially mutating
	     * the `accumulator` object. The `iteratee` is bound to `thisArg` and invoked
	     * with four arguments: (accumulator, value, key, object). Iteratee functions
	     * may exit iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Array|Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The custom accumulator value.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {*} Returns the accumulated value.
	     * @example
	     *
	     * _.transform([2, 3, 4], function(result, n) {
	     *   result.push(n *= n);
	     *   return n % 2 == 0;
	     * });
	     * // => [4, 9]
	     *
	     * _.transform({ 'a': 1, 'b': 2 }, function(result, n, key) {
	     *   result[key] = n * 3;
	     * });
	     * // => { 'a': 3, 'b': 6 }
	     */
	    function transform(object, iteratee, accumulator, thisArg) {
	      var isArr = isArray(object) || isTypedArray(object);
	      iteratee = getCallback(iteratee, thisArg, 4);
	
	      if (accumulator == null) {
	        if (isArr || isObject(object)) {
	          var Ctor = object.constructor;
	          if (isArr) {
	            accumulator = isArray(object) ? new Ctor : [];
	          } else {
	            accumulator = baseCreate(isFunction(Ctor) ? Ctor.prototype : undefined);
	          }
	        } else {
	          accumulator = {};
	        }
	      }
	      (isArr ? arrayEach : baseForOwn)(object, function(value, index, object) {
	        return iteratee(accumulator, value, index, object);
	      });
	      return accumulator;
	    }
	
	    /**
	     * Creates an array of the own enumerable property values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.values(new Foo);
	     * // => [1, 2] (iteration order is not guaranteed)
	     *
	     * _.values('hi');
	     * // => ['h', 'i']
	     */
	    function values(object) {
	      return baseValues(object, keys(object));
	    }
	
	    /**
	     * Creates an array of the own and inherited enumerable property values
	     * of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.valuesIn(new Foo);
	     * // => [1, 2, 3] (iteration order is not guaranteed)
	     */
	    function valuesIn(object) {
	      return baseValues(object, keysIn(object));
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Checks if `n` is between `start` and up to but not including, `end`. If
	     * `end` is not specified it is set to `start` with `start` then set to `0`.
	     *
	     * @static
	     * @memberOf _
	     * @category Number
	     * @param {number} n The number to check.
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `n` is in the range, else `false`.
	     * @example
	     *
	     * _.inRange(3, 2, 4);
	     * // => true
	     *
	     * _.inRange(4, 8);
	     * // => true
	     *
	     * _.inRange(4, 2);
	     * // => false
	     *
	     * _.inRange(2, 2);
	     * // => false
	     *
	     * _.inRange(1.2, 2);
	     * // => true
	     *
	     * _.inRange(5.2, 4);
	     * // => false
	     */
	    function inRange(value, start, end) {
	      start = +start || 0;
	      if (end === undefined) {
	        end = start;
	        start = 0;
	      } else {
	        end = +end || 0;
	      }
	      return value >= nativeMin(start, end) && value < nativeMax(start, end);
	    }
	
	    /**
	     * Produces a random number between `min` and `max` (inclusive). If only one
	     * argument is provided a number between `0` and the given number is returned.
	     * If `floating` is `true`, or either `min` or `max` are floats, a floating-point
	     * number is returned instead of an integer.
	     *
	     * @static
	     * @memberOf _
	     * @category Number
	     * @param {number} [min=0] The minimum possible value.
	     * @param {number} [max=1] The maximum possible value.
	     * @param {boolean} [floating] Specify returning a floating-point number.
	     * @returns {number} Returns the random number.
	     * @example
	     *
	     * _.random(0, 5);
	     * // => an integer between 0 and 5
	     *
	     * _.random(5);
	     * // => also an integer between 0 and 5
	     *
	     * _.random(5, true);
	     * // => a floating-point number between 0 and 5
	     *
	     * _.random(1.2, 5.2);
	     * // => a floating-point number between 1.2 and 5.2
	     */
	    function random(min, max, floating) {
	      if (floating && isIterateeCall(min, max, floating)) {
	        max = floating = undefined;
	      }
	      var noMin = min == null,
	          noMax = max == null;
	
	      if (floating == null) {
	        if (noMax && typeof min == 'boolean') {
	          floating = min;
	          min = 1;
	        }
	        else if (typeof max == 'boolean') {
	          floating = max;
	          noMax = true;
	        }
	      }
	      if (noMin && noMax) {
	        max = 1;
	        noMax = false;
	      }
	      min = +min || 0;
	      if (noMax) {
	        max = min;
	        min = 0;
	      } else {
	        max = +max || 0;
	      }
	      if (floating || min % 1 || max % 1) {
	        var rand = nativeRandom();
	        return nativeMin(min + (rand * (max - min + parseFloat('1e-' + ((rand + '').length - 1)))), max);
	      }
	      return baseRandom(min, max);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the camel cased string.
	     * @example
	     *
	     * _.camelCase('Foo Bar');
	     * // => 'fooBar'
	     *
	     * _.camelCase('--foo-bar');
	     * // => 'fooBar'
	     *
	     * _.camelCase('__foo_bar__');
	     * // => 'fooBar'
	     */
	    var camelCase = createCompounder(function(result, word, index) {
	      word = word.toLowerCase();
	      return result + (index ? (word.charAt(0).toUpperCase() + word.slice(1)) : word);
	    });
	
	    /**
	     * Capitalizes the first character of `string`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to capitalize.
	     * @returns {string} Returns the capitalized string.
	     * @example
	     *
	     * _.capitalize('fred');
	     * // => 'Fred'
	     */
	    function capitalize(string) {
	      string = baseToString(string);
	      return string && (string.charAt(0).toUpperCase() + string.slice(1));
	    }
	
	    /**
	     * Deburrs `string` by converting [latin-1 supplementary letters](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
	     * to basic latin letters and removing [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to deburr.
	     * @returns {string} Returns the deburred string.
	     * @example
	     *
	     * _.deburr('déjà vu');
	     * // => 'deja vu'
	     */
	    function deburr(string) {
	      string = baseToString(string);
	      return string && string.replace(reLatin1, deburrLetter).replace(reComboMark, '');
	    }
	
	    /**
	     * Checks if `string` ends with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to search.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=string.length] The position to search from.
	     * @returns {boolean} Returns `true` if `string` ends with `target`, else `false`.
	     * @example
	     *
	     * _.endsWith('abc', 'c');
	     * // => true
	     *
	     * _.endsWith('abc', 'b');
	     * // => false
	     *
	     * _.endsWith('abc', 'b', 2);
	     * // => true
	     */
	    function endsWith(string, target, position) {
	      string = baseToString(string);
	      target = (target + '');
	
	      var length = string.length;
	      position = position === undefined
	        ? length
	        : nativeMin(position < 0 ? 0 : (+position || 0), length);
	
	      position -= target.length;
	      return position >= 0 && string.indexOf(target, position) == position;
	    }
	
	    /**
	     * Converts the characters "&", "<", ">", '"', "'", and "\`", in `string` to
	     * their corresponding HTML entities.
	     *
	     * **Note:** No other characters are escaped. To escape additional characters
	     * use a third-party library like [_he_](https://mths.be/he).
	     *
	     * Though the ">" character is escaped for symmetry, characters like
	     * ">" and "/" don't need escaping in HTML and have no special meaning
	     * unless they're part of a tag or unquoted attribute value.
	     * See [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
	     * (under "semi-related fun fact") for more details.
	     *
	     * Backticks are escaped because in Internet Explorer < 9, they can break out
	     * of attribute values or HTML comments. See [#59](https://html5sec.org/#59),
	     * [#102](https://html5sec.org/#102), [#108](https://html5sec.org/#108), and
	     * [#133](https://html5sec.org/#133) of the [HTML5 Security Cheatsheet](https://html5sec.org/)
	     * for more details.
	     *
	     * When working with HTML you should always [quote attribute values](http://wonko.com/post/html-escaping)
	     * to reduce XSS vectors.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escape('fred, barney, & pebbles');
	     * // => 'fred, barney, &amp; pebbles'
	     */
	    function escape(string) {
	      // Reset `lastIndex` because in IE < 9 `String#replace` does not.
	      string = baseToString(string);
	      return (string && reHasUnescapedHtml.test(string))
	        ? string.replace(reUnescapedHtml, escapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Escapes the `RegExp` special characters "\", "/", "^", "$", ".", "|", "?",
	     * "*", "+", "(", ")", "[", "]", "{" and "}" in `string`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escapeRegExp('[lodash](https://lodash.com/)');
	     * // => '\[lodash\]\(https:\/\/lodash\.com\/\)'
	     */
	    function escapeRegExp(string) {
	      string = baseToString(string);
	      return (string && reHasRegExpChars.test(string))
	        ? string.replace(reRegExpChars, escapeRegExpChar)
	        : (string || '(?:)');
	    }
	
	    /**
	     * Converts `string` to [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the kebab cased string.
	     * @example
	     *
	     * _.kebabCase('Foo Bar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('fooBar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('__foo_bar__');
	     * // => 'foo-bar'
	     */
	    var kebabCase = createCompounder(function(result, word, index) {
	      return result + (index ? '-' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Pads `string` on the left and right sides if it's shorter than `length`.
	     * Padding characters are truncated if they can't be evenly divided by `length`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.pad('abc', 8);
	     * // => '  abc   '
	     *
	     * _.pad('abc', 8, '_-');
	     * // => '_-abc_-_'
	     *
	     * _.pad('abc', 3);
	     * // => 'abc'
	     */
	    function pad(string, length, chars) {
	      string = baseToString(string);
	      length = +length;
	
	      var strLength = string.length;
	      if (strLength >= length || !nativeIsFinite(length)) {
	        return string;
	      }
	      var mid = (length - strLength) / 2,
	          leftLength = nativeFloor(mid),
	          rightLength = nativeCeil(mid);
	
	      chars = createPadding('', rightLength, chars);
	      return chars.slice(0, leftLength) + string + chars;
	    }
	
	    /**
	     * Pads `string` on the left side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padLeft('abc', 6);
	     * // => '   abc'
	     *
	     * _.padLeft('abc', 6, '_-');
	     * // => '_-_abc'
	     *
	     * _.padLeft('abc', 3);
	     * // => 'abc'
	     */
	    var padLeft = createPadDir();
	
	    /**
	     * Pads `string` on the right side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padRight('abc', 6);
	     * // => 'abc   '
	     *
	     * _.padRight('abc', 6, '_-');
	     * // => 'abc_-_'
	     *
	     * _.padRight('abc', 3);
	     * // => 'abc'
	     */
	    var padRight = createPadDir(true);
	
	    /**
	     * Converts `string` to an integer of the specified radix. If `radix` is
	     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a hexadecimal,
	     * in which case a `radix` of `16` is used.
	     *
	     * **Note:** This method aligns with the [ES5 implementation](https://es5.github.io/#E)
	     * of `parseInt`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} string The string to convert.
	     * @param {number} [radix] The radix to interpret `value` by.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.parseInt('08');
	     * // => 8
	     *
	     * _.map(['6', '08', '10'], _.parseInt);
	     * // => [6, 8, 10]
	     */
	    function parseInt(string, radix, guard) {
	      // Firefox < 21 and Opera < 15 follow ES3 for `parseInt`.
	      // Chrome fails to trim leading <BOM> whitespace characters.
	      // See https://code.google.com/p/v8/issues/detail?id=3109 for more details.
	      if (guard ? isIterateeCall(string, radix, guard) : radix == null) {
	        radix = 0;
	      } else if (radix) {
	        radix = +radix;
	      }
	      string = trim(string);
	      return nativeParseInt(string, radix || (reHasHexPrefix.test(string) ? 16 : 10));
	    }
	
	    /**
	     * Repeats the given string `n` times.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to repeat.
	     * @param {number} [n=0] The number of times to repeat the string.
	     * @returns {string} Returns the repeated string.
	     * @example
	     *
	     * _.repeat('*', 3);
	     * // => '***'
	     *
	     * _.repeat('abc', 2);
	     * // => 'abcabc'
	     *
	     * _.repeat('abc', 0);
	     * // => ''
	     */
	    function repeat(string, n) {
	      var result = '';
	      string = baseToString(string);
	      n = +n;
	      if (n < 1 || !string || !nativeIsFinite(n)) {
	        return result;
	      }
	      // Leverage the exponentiation by squaring algorithm for a faster repeat.
	      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
	      do {
	        if (n % 2) {
	          result += string;
	        }
	        n = nativeFloor(n / 2);
	        string += string;
	      } while (n);
	
	      return result;
	    }
	
	    /**
	     * Converts `string` to [snake case](https://en.wikipedia.org/wiki/Snake_case).
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the snake cased string.
	     * @example
	     *
	     * _.snakeCase('Foo Bar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('fooBar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('--foo-bar');
	     * // => 'foo_bar'
	     */
	    var snakeCase = createCompounder(function(result, word, index) {
	      return result + (index ? '_' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Converts `string` to [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the start cased string.
	     * @example
	     *
	     * _.startCase('--foo-bar');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('fooBar');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('__foo_bar__');
	     * // => 'Foo Bar'
	     */
	    var startCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + (word.charAt(0).toUpperCase() + word.slice(1));
	    });
	
	    /**
	     * Checks if `string` starts with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to search.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=0] The position to search from.
	     * @returns {boolean} Returns `true` if `string` starts with `target`, else `false`.
	     * @example
	     *
	     * _.startsWith('abc', 'a');
	     * // => true
	     *
	     * _.startsWith('abc', 'b');
	     * // => false
	     *
	     * _.startsWith('abc', 'b', 1);
	     * // => true
	     */
	    function startsWith(string, target, position) {
	      string = baseToString(string);
	      position = position == null
	        ? 0
	        : nativeMin(position < 0 ? 0 : (+position || 0), string.length);
	
	      return string.lastIndexOf(target, position) == position;
	    }
	
	    /**
	     * Creates a compiled template function that can interpolate data properties
	     * in "interpolate" delimiters, HTML-escape interpolated data properties in
	     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
	     * properties may be accessed as free variables in the template. If a setting
	     * object is provided it takes precedence over `_.templateSettings` values.
	     *
	     * **Note:** In the development build `_.template` utilizes
	     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
	     * for easier debugging.
	     *
	     * For more information on precompiling templates see
	     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
	     *
	     * For more information on Chrome extension sandboxes see
	     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The template string.
	     * @param {Object} [options] The options object.
	     * @param {RegExp} [options.escape] The HTML "escape" delimiter.
	     * @param {RegExp} [options.evaluate] The "evaluate" delimiter.
	     * @param {Object} [options.imports] An object to import into the template as free variables.
	     * @param {RegExp} [options.interpolate] The "interpolate" delimiter.
	     * @param {string} [options.sourceURL] The sourceURL of the template's compiled source.
	     * @param {string} [options.variable] The data object variable name.
	     * @param- {Object} [otherOptions] Enables the legacy `options` param signature.
	     * @returns {Function} Returns the compiled template function.
	     * @example
	     *
	     * // using the "interpolate" delimiter to create a compiled template
	     * var compiled = _.template('hello <%= user %>!');
	     * compiled({ 'user': 'fred' });
	     * // => 'hello fred!'
	     *
	     * // using the HTML "escape" delimiter to escape data property values
	     * var compiled = _.template('<b><%- value %></b>');
	     * compiled({ 'value': '<script>' });
	     * // => '<b>&lt;script&gt;</b>'
	     *
	     * // using the "evaluate" delimiter to execute JavaScript and generate HTML
	     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // using the internal `print` function in "evaluate" delimiters
	     * var compiled = _.template('<% print("hello " + user); %>!');
	     * compiled({ 'user': 'barney' });
	     * // => 'hello barney!'
	     *
	     * // using the ES delimiter as an alternative to the default "interpolate" delimiter
	     * var compiled = _.template('hello ${ user }!');
	     * compiled({ 'user': 'pebbles' });
	     * // => 'hello pebbles!'
	     *
	     * // using custom template delimiters
	     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
	     * var compiled = _.template('hello {{ user }}!');
	     * compiled({ 'user': 'mustache' });
	     * // => 'hello mustache!'
	     *
	     * // using backslashes to treat delimiters as plain text
	     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
	     * compiled({ 'value': 'ignored' });
	     * // => '<%- value %>'
	     *
	     * // using the `imports` option to import `jQuery` as `jq`
	     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
	     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // using the `sourceURL` option to specify a custom sourceURL for the template
	     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
	     * compiled(data);
	     * // => find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector
	     *
	     * // using the `variable` option to ensure a with-statement isn't used in the compiled template
	     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
	     * compiled.source;
	     * // => function(data) {
	     * //   var __t, __p = '';
	     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
	     * //   return __p;
	     * // }
	     *
	     * // using the `source` property to inline compiled templates for meaningful
	     * // line numbers in error messages and a stack trace
	     * fs.writeFileSync(path.join(cwd, 'jst.js'), '\
	     *   var JST = {\
	     *     "main": ' + _.template(mainText).source + '\
	     *   };\
	     * ');
	     */
	    function template(string, options, otherOptions) {
	      // Based on John Resig's `tmpl` implementation (http://ejohn.org/blog/javascript-micro-templating/)
	      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
	      var settings = lodash.templateSettings;
	
	      if (otherOptions && isIterateeCall(string, options, otherOptions)) {
	        options = otherOptions = undefined;
	      }
	      string = baseToString(string);
	      options = assignWith(baseAssign({}, otherOptions || options), settings, assignOwnDefaults);
	
	      var imports = assignWith(baseAssign({}, options.imports), settings.imports, assignOwnDefaults),
	          importsKeys = keys(imports),
	          importsValues = baseValues(imports, importsKeys);
	
	      var isEscaping,
	          isEvaluating,
	          index = 0,
	          interpolate = options.interpolate || reNoMatch,
	          source = "__p += '";
	
	      // Compile the regexp to match each delimiter.
	      var reDelimiters = RegExp(
	        (options.escape || reNoMatch).source + '|' +
	        interpolate.source + '|' +
	        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
	        (options.evaluate || reNoMatch).source + '|$'
	      , 'g');
	
	      // Use a sourceURL for easier debugging.
	      var sourceURL = '//# sourceURL=' +
	        ('sourceURL' in options
	          ? options.sourceURL
	          : ('lodash.templateSources[' + (++templateCounter) + ']')
	        ) + '\n';
	
	      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
	        interpolateValue || (interpolateValue = esTemplateValue);
	
	        // Escape characters that can't be included in string literals.
	        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
	
	        // Replace delimiters with snippets.
	        if (escapeValue) {
	          isEscaping = true;
	          source += "' +\n__e(" + escapeValue + ") +\n'";
	        }
	        if (evaluateValue) {
	          isEvaluating = true;
	          source += "';\n" + evaluateValue + ";\n__p += '";
	        }
	        if (interpolateValue) {
	          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
	        }
	        index = offset + match.length;
	
	        // The JS engine embedded in Adobe products requires returning the `match`
	        // string in order to produce the correct `offset` value.
	        return match;
	      });
	
	      source += "';\n";
	
	      // If `variable` is not specified wrap a with-statement around the generated
	      // code to add the data object to the top of the scope chain.
	      var variable = options.variable;
	      if (!variable) {
	        source = 'with (obj) {\n' + source + '\n}\n';
	      }
	      // Cleanup code by stripping empty strings.
	      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
	        .replace(reEmptyStringMiddle, '$1')
	        .replace(reEmptyStringTrailing, '$1;');
	
	      // Frame code as the function body.
	      source = 'function(' + (variable || 'obj') + ') {\n' +
	        (variable
	          ? ''
	          : 'obj || (obj = {});\n'
	        ) +
	        "var __t, __p = ''" +
	        (isEscaping
	           ? ', __e = _.escape'
	           : ''
	        ) +
	        (isEvaluating
	          ? ', __j = Array.prototype.join;\n' +
	            "function print() { __p += __j.call(arguments, '') }\n"
	          : ';\n'
	        ) +
	        source +
	        'return __p\n}';
	
	      var result = attempt(function() {
	        return Function(importsKeys, sourceURL + 'return ' + source).apply(undefined, importsValues);
	      });
	
	      // Provide the compiled function's source by its `toString` method or
	      // the `source` property as a convenience for inlining compiled templates.
	      result.source = source;
	      if (isError(result)) {
	        throw result;
	      }
	      return result;
	    }
	
	    /**
	     * Removes leading and trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trim('  abc  ');
	     * // => 'abc'
	     *
	     * _.trim('-_-abc-_-', '_-');
	     * // => 'abc'
	     *
	     * _.map(['  foo  ', '  bar  '], _.trim);
	     * // => ['foo', 'bar']
	     */
	    function trim(string, chars, guard) {
	      var value = string;
	      string = baseToString(string);
	      if (!string) {
	        return string;
	      }
	      if (guard ? isIterateeCall(value, chars, guard) : chars == null) {
	        return string.slice(trimmedLeftIndex(string), trimmedRightIndex(string) + 1);
	      }
	      chars = (chars + '');
	      return string.slice(charsLeftIndex(string, chars), charsRightIndex(string, chars) + 1);
	    }
	
	    /**
	     * Removes leading whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimLeft('  abc  ');
	     * // => 'abc  '
	     *
	     * _.trimLeft('-_-abc-_-', '_-');
	     * // => 'abc-_-'
	     */
	    function trimLeft(string, chars, guard) {
	      var value = string;
	      string = baseToString(string);
	      if (!string) {
	        return string;
	      }
	      if (guard ? isIterateeCall(value, chars, guard) : chars == null) {
	        return string.slice(trimmedLeftIndex(string));
	      }
	      return string.slice(charsLeftIndex(string, (chars + '')));
	    }
	
	    /**
	     * Removes trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimRight('  abc  ');
	     * // => '  abc'
	     *
	     * _.trimRight('-_-abc-_-', '_-');
	     * // => '-_-abc'
	     */
	    function trimRight(string, chars, guard) {
	      var value = string;
	      string = baseToString(string);
	      if (!string) {
	        return string;
	      }
	      if (guard ? isIterateeCall(value, chars, guard) : chars == null) {
	        return string.slice(0, trimmedRightIndex(string) + 1);
	      }
	      return string.slice(0, charsRightIndex(string, (chars + '')) + 1);
	    }
	
	    /**
	     * Truncates `string` if it's longer than the given maximum string length.
	     * The last characters of the truncated string are replaced with the omission
	     * string which defaults to "...".
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to truncate.
	     * @param {Object|number} [options] The options object or maximum string length.
	     * @param {number} [options.length=30] The maximum string length.
	     * @param {string} [options.omission='...'] The string to indicate text is omitted.
	     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {string} Returns the truncated string.
	     * @example
	     *
	     * _.trunc('hi-diddly-ho there, neighborino');
	     * // => 'hi-diddly-ho there, neighbo...'
	     *
	     * _.trunc('hi-diddly-ho there, neighborino', 24);
	     * // => 'hi-diddly-ho there, n...'
	     *
	     * _.trunc('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': ' '
	     * });
	     * // => 'hi-diddly-ho there,...'
	     *
	     * _.trunc('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': /,? +/
	     * });
	     * // => 'hi-diddly-ho there...'
	     *
	     * _.trunc('hi-diddly-ho there, neighborino', {
	     *   'omission': ' [...]'
	     * });
	     * // => 'hi-diddly-ho there, neig [...]'
	     */
	    function trunc(string, options, guard) {
	      if (guard && isIterateeCall(string, options, guard)) {
	        options = undefined;
	      }
	      var length = DEFAULT_TRUNC_LENGTH,
	          omission = DEFAULT_TRUNC_OMISSION;
	
	      if (options != null) {
	        if (isObject(options)) {
	          var separator = 'separator' in options ? options.separator : separator;
	          length = 'length' in options ? (+options.length || 0) : length;
	          omission = 'omission' in options ? baseToString(options.omission) : omission;
	        } else {
	          length = +options || 0;
	        }
	      }
	      string = baseToString(string);
	      if (length >= string.length) {
	        return string;
	      }
	      var end = length - omission.length;
	      if (end < 1) {
	        return omission;
	      }
	      var result = string.slice(0, end);
	      if (separator == null) {
	        return result + omission;
	      }
	      if (isRegExp(separator)) {
	        if (string.slice(end).search(separator)) {
	          var match,
	              newEnd,
	              substring = string.slice(0, end);
	
	          if (!separator.global) {
	            separator = RegExp(separator.source, (reFlags.exec(separator) || '') + 'g');
	          }
	          separator.lastIndex = 0;
	          while ((match = separator.exec(substring))) {
	            newEnd = match.index;
	          }
	          result = result.slice(0, newEnd == null ? end : newEnd);
	        }
	      } else if (string.indexOf(separator, end) != end) {
	        var index = result.lastIndexOf(separator);
	        if (index > -1) {
	          result = result.slice(0, index);
	        }
	      }
	      return result + omission;
	    }
	
	    /**
	     * The inverse of `_.escape`; this method converts the HTML entities
	     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, `&#39;`, and `&#96;` in `string` to their
	     * corresponding characters.
	     *
	     * **Note:** No other HTML entities are unescaped. To unescape additional HTML
	     * entities use a third-party library like [_he_](https://mths.be/he).
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to unescape.
	     * @returns {string} Returns the unescaped string.
	     * @example
	     *
	     * _.unescape('fred, barney, &amp; pebbles');
	     * // => 'fred, barney, & pebbles'
	     */
	    function unescape(string) {
	      string = baseToString(string);
	      return (string && reHasEscapedHtml.test(string))
	        ? string.replace(reEscapedHtml, unescapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Splits `string` into an array of its words.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {RegExp|string} [pattern] The pattern to match words.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Array} Returns the words of `string`.
	     * @example
	     *
	     * _.words('fred, barney, & pebbles');
	     * // => ['fred', 'barney', 'pebbles']
	     *
	     * _.words('fred, barney, & pebbles', /[^, ]+/g);
	     * // => ['fred', 'barney', '&', 'pebbles']
	     */
	    function words(string, pattern, guard) {
	      if (guard && isIterateeCall(string, pattern, guard)) {
	        pattern = undefined;
	      }
	      string = baseToString(string);
	      return string.match(pattern || reWords) || [];
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Attempts to invoke `func`, returning either the result or the caught error
	     * object. Any additional arguments are provided to `func` when it is invoked.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {Function} func The function to attempt.
	     * @returns {*} Returns the `func` result or error object.
	     * @example
	     *
	     * // avoid throwing errors for invalid selectors
	     * var elements = _.attempt(function(selector) {
	     *   return document.querySelectorAll(selector);
	     * }, '>_>');
	     *
	     * if (_.isError(elements)) {
	     *   elements = [];
	     * }
	     */
	    var attempt = restParam(function(func, args) {
	      try {
	        return func.apply(undefined, args);
	      } catch(e) {
	        return isError(e) ? e : new Error(e);
	      }
	    });
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of `thisArg`
	     * and arguments of the created function. If `func` is a property name the
	     * created callback returns the property value for a given element. If `func`
	     * is an object the created callback returns `true` for elements that contain
	     * the equivalent object properties, otherwise it returns `false`.
	     *
	     * @static
	     * @memberOf _
	     * @alias iteratee
	     * @category Utility
	     * @param {*} [func=_.identity] The value to convert to a callback.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Function} Returns the callback.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * // wrap to create custom callback shorthands
	     * _.callback = _.wrap(_.callback, function(callback, func, thisArg) {
	     *   var match = /^(.+?)__([gl]t)(.+)$/.exec(func);
	     *   if (!match) {
	     *     return callback(func, thisArg);
	     *   }
	     *   return function(object) {
	     *     return match[2] == 'gt'
	     *       ? object[match[1]] > match[3]
	     *       : object[match[1]] < match[3];
	     *   };
	     * });
	     *
	     * _.filter(users, 'age__gt36');
	     * // => [{ 'user': 'fred', 'age': 40 }]
	     */
	    function callback(func, thisArg, guard) {
	      if (guard && isIterateeCall(func, thisArg, guard)) {
	        thisArg = undefined;
	      }
	      return isObjectLike(func)
	        ? matches(func)
	        : baseCallback(func, thisArg);
	    }
	
	    /**
	     * Creates a function that returns `value`.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {*} value The value to return from the new function.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var object = { 'user': 'fred' };
	     * var getter = _.constant(object);
	     *
	     * getter() === object;
	     * // => true
	     */
	    function constant(value) {
	      return function() {
	        return value;
	      };
	    }
	
	    /**
	     * This method returns the first argument provided to it.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {*} value Any value.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * var object = { 'user': 'fred' };
	     *
	     * _.identity(object) === object;
	     * // => true
	     */
	    function identity(value) {
	      return value;
	    }
	
	    /**
	     * Creates a function that performs a deep comparison between a given object
	     * and `source`, returning `true` if the given object has equivalent property
	     * values, else `false`.
	     *
	     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
	     * numbers, `Object` objects, regexes, and strings. Objects are compared by
	     * their own, not inherited, enumerable properties. For comparing a single
	     * own or inherited property value see `_.matchesProperty`.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * _.filter(users, _.matches({ 'age': 40, 'active': false }));
	     * // => [{ 'user': 'fred', 'age': 40, 'active': false }]
	     */
	    function matches(source) {
	      return baseMatches(baseClone(source, true));
	    }
	
	    /**
	     * Creates a function that compares the property value of `path` on a given
	     * object to `value`.
	     *
	     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
	     * numbers, `Object` objects, regexes, and strings. Objects are compared by
	     * their own, not inherited, enumerable properties.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney' },
	     *   { 'user': 'fred' }
	     * ];
	     *
	     * _.find(users, _.matchesProperty('user', 'fred'));
	     * // => { 'user': 'fred' }
	     */
	    function matchesProperty(path, srcValue) {
	      return baseMatchesProperty(path, baseClone(srcValue, true));
	    }
	
	    /**
	     * Creates a function that invokes the method at `path` on a given object.
	     * Any additional arguments are provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': { 'c': _.constant(2) } } },
	     *   { 'a': { 'b': { 'c': _.constant(1) } } }
	     * ];
	     *
	     * _.map(objects, _.method('a.b.c'));
	     * // => [2, 1]
	     *
	     * _.invoke(_.sortBy(objects, _.method(['a', 'b', 'c'])), 'a.b.c');
	     * // => [1, 2]
	     */
	    var method = restParam(function(path, args) {
	      return function(object) {
	        return invokePath(object, path, args);
	      };
	    });
	
	    /**
	     * The opposite of `_.method`; this method creates a function that invokes
	     * the method at a given path on `object`. Any additional arguments are
	     * provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {Object} object The object to query.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var array = _.times(3, _.constant),
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
	     * // => [2, 0]
	     */
	    var methodOf = restParam(function(object, args) {
	      return function(path) {
	        return invokePath(object, path, args);
	      };
	    });
	
	    /**
	     * Adds all own enumerable function properties of a source object to the
	     * destination object. If `object` is a function then methods are added to
	     * its prototype as well.
	     *
	     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
	     * avoid conflicts caused by modifying the original.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {Function|Object} [object=lodash] The destination object.
	     * @param {Object} source The object of functions to add.
	     * @param {Object} [options] The options object.
	     * @param {boolean} [options.chain=true] Specify whether the functions added
	     *  are chainable.
	     * @returns {Function|Object} Returns `object`.
	     * @example
	     *
	     * function vowels(string) {
	     *   return _.filter(string, function(v) {
	     *     return /[aeiou]/i.test(v);
	     *   });
	     * }
	     *
	     * _.mixin({ 'vowels': vowels });
	     * _.vowels('fred');
	     * // => ['e']
	     *
	     * _('fred').vowels().value();
	     * // => ['e']
	     *
	     * _.mixin({ 'vowels': vowels }, { 'chain': false });
	     * _('fred').vowels();
	     * // => ['e']
	     */
	    function mixin(object, source, options) {
	      if (options == null) {
	        var isObj = isObject(source),
	            props = isObj ? keys(source) : undefined,
	            methodNames = (props && props.length) ? baseFunctions(source, props) : undefined;
	
	        if (!(methodNames ? methodNames.length : isObj)) {
	          methodNames = false;
	          options = source;
	          source = object;
	          object = this;
	        }
	      }
	      if (!methodNames) {
	        methodNames = baseFunctions(source, keys(source));
	      }
	      var chain = true,
	          index = -1,
	          isFunc = isFunction(object),
	          length = methodNames.length;
	
	      if (options === false) {
	        chain = false;
	      } else if (isObject(options) && 'chain' in options) {
	        chain = options.chain;
	      }
	      while (++index < length) {
	        var methodName = methodNames[index],
	            func = source[methodName];
	
	        object[methodName] = func;
	        if (isFunc) {
	          object.prototype[methodName] = (function(func) {
	            return function() {
	              var chainAll = this.__chain__;
	              if (chain || chainAll) {
	                var result = object(this.__wrapped__),
	                    actions = result.__actions__ = arrayCopy(this.__actions__);
	
	                actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
	                result.__chain__ = chainAll;
	                return result;
	              }
	              return func.apply(object, arrayPush([this.value()], arguments));
	            };
	          }(func));
	        }
	      }
	      return object;
	    }
	
	    /**
	     * Reverts the `_` variable to its previous value and returns a reference to
	     * the `lodash` function.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @returns {Function} Returns the `lodash` function.
	     * @example
	     *
	     * var lodash = _.noConflict();
	     */
	    function noConflict() {
	      root._ = oldDash;
	      return this;
	    }
	
	    /**
	     * A no-operation function that returns `undefined` regardless of the
	     * arguments it receives.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @example
	     *
	     * var object = { 'user': 'fred' };
	     *
	     * _.noop(object) === undefined;
	     * // => true
	     */
	    function noop() {
	      // No operation performed.
	    }
	
	    /**
	     * Creates a function that returns the property value at `path` on a
	     * given object.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': { 'c': 2 } } },
	     *   { 'a': { 'b': { 'c': 1 } } }
	     * ];
	     *
	     * _.map(objects, _.property('a.b.c'));
	     * // => [2, 1]
	     *
	     * _.pluck(_.sortBy(objects, _.property(['a', 'b', 'c'])), 'a.b.c');
	     * // => [1, 2]
	     */
	    function property(path) {
	      return isKey(path) ? baseProperty(path) : basePropertyDeep(path);
	    }
	
	    /**
	     * The opposite of `_.property`; this method creates a function that returns
	     * the property value at a given path on `object`.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {Object} object The object to query.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var array = [0, 1, 2],
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
	     * // => [2, 0]
	     */
	    function propertyOf(object) {
	      return function(path) {
	        return baseGet(object, toPath(path), path + '');
	      };
	    }
	
	    /**
	     * Creates an array of numbers (positive and/or negative) progressing from
	     * `start` up to, but not including, `end`. If `end` is not specified it is
	     * set to `start` with `start` then set to `0`. If `end` is less than `start`
	     * a zero-length range is created unless a negative `step` is specified.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the new array of numbers.
	     * @example
	     *
	     * _.range(4);
	     * // => [0, 1, 2, 3]
	     *
	     * _.range(1, 5);
	     * // => [1, 2, 3, 4]
	     *
	     * _.range(0, 20, 5);
	     * // => [0, 5, 10, 15]
	     *
	     * _.range(0, -4, -1);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.range(0);
	     * // => []
	     */
	    function range(start, end, step) {
	      if (step && isIterateeCall(start, end, step)) {
	        end = step = undefined;
	      }
	      start = +start || 0;
	      step = step == null ? 1 : (+step || 0);
	
	      if (end == null) {
	        end = start;
	        start = 0;
	      } else {
	        end = +end || 0;
	      }
	      // Use `Array(length)` so engines like Chakra and V8 avoid slower modes.
	      // See https://youtu.be/XAqIpGU8ZZk#t=17m25s for more details.
	      var index = -1,
	          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
	          result = Array(length);
	
	      while (++index < length) {
	        result[index] = start;
	        start += step;
	      }
	      return result;
	    }
	
	    /**
	     * Invokes the iteratee function `n` times, returning an array of the results
	     * of each invocation. The `iteratee` is bound to `thisArg` and invoked with
	     * one argument; (index).
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {number} n The number of times to invoke `iteratee`.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * var diceRolls = _.times(3, _.partial(_.random, 1, 6, false));
	     * // => [3, 6, 4]
	     *
	     * _.times(3, function(n) {
	     *   mage.castSpell(n);
	     * });
	     * // => invokes `mage.castSpell(n)` three times with `n` of `0`, `1`, and `2`
	     *
	     * _.times(3, function(n) {
	     *   this.cast(n);
	     * }, mage);
	     * // => also invokes `mage.castSpell(n)` three times
	     */
	    function times(n, iteratee, thisArg) {
	      n = nativeFloor(n);
	
	      // Exit early to avoid a JSC JIT bug in Safari 8
	      // where `Array(0)` is treated as `Array(1)`.
	      if (n < 1 || !nativeIsFinite(n)) {
	        return [];
	      }
	      var index = -1,
	          result = Array(nativeMin(n, MAX_ARRAY_LENGTH));
	
	      iteratee = bindCallback(iteratee, thisArg, 1);
	      while (++index < n) {
	        if (index < MAX_ARRAY_LENGTH) {
	          result[index] = iteratee(index);
	        } else {
	          iteratee(index);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Generates a unique ID. If `prefix` is provided the ID is appended to it.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {string} [prefix] The value to prefix the ID with.
	     * @returns {string} Returns the unique ID.
	     * @example
	     *
	     * _.uniqueId('contact_');
	     * // => 'contact_104'
	     *
	     * _.uniqueId();
	     * // => '105'
	     */
	    function uniqueId(prefix) {
	      var id = ++idCounter;
	      return baseToString(prefix) + id;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Adds two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @category Math
	     * @param {number} augend The first number to add.
	     * @param {number} addend The second number to add.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * _.add(6, 4);
	     * // => 10
	     */
	    function add(augend, addend) {
	      return (+augend || 0) + (+addend || 0);
	    }
	
	    /**
	     * Calculates `n` rounded up to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @category Math
	     * @param {number} n The number to round up.
	     * @param {number} [precision=0] The precision to round up to.
	     * @returns {number} Returns the rounded up number.
	     * @example
	     *
	     * _.ceil(4.006);
	     * // => 5
	     *
	     * _.ceil(6.004, 2);
	     * // => 6.01
	     *
	     * _.ceil(6040, -2);
	     * // => 6100
	     */
	    var ceil = createRound('ceil');
	
	    /**
	     * Calculates `n` rounded down to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @category Math
	     * @param {number} n The number to round down.
	     * @param {number} [precision=0] The precision to round down to.
	     * @returns {number} Returns the rounded down number.
	     * @example
	     *
	     * _.floor(4.006);
	     * // => 4
	     *
	     * _.floor(0.046, 2);
	     * // => 0.04
	     *
	     * _.floor(4060, -2);
	     * // => 4000
	     */
	    var floor = createRound('floor');
	
	    /**
	     * Gets the maximum value of `collection`. If `collection` is empty or falsey
	     * `-Infinity` is returned. If an iteratee function is provided it is invoked
	     * for each value in `collection` to generate the criterion by which the value
	     * is ranked. The `iteratee` is bound to `thisArg` and invoked with three
	     * arguments: (value, index, collection).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Math
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [iteratee] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * _.max([4, 2, 8, 6]);
	     * // => 8
	     *
	     * _.max([]);
	     * // => -Infinity
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * _.max(users, function(chr) {
	     *   return chr.age;
	     * });
	     * // => { 'user': 'fred', 'age': 40 }
	     *
	     * // using the `_.property` callback shorthand
	     * _.max(users, 'age');
	     * // => { 'user': 'fred', 'age': 40 }
	     */
	    var max = createExtremum(gt, NEGATIVE_INFINITY);
	
	    /**
	     * Gets the minimum value of `collection`. If `collection` is empty or falsey
	     * `Infinity` is returned. If an iteratee function is provided it is invoked
	     * for each value in `collection` to generate the criterion by which the value
	     * is ranked. The `iteratee` is bound to `thisArg` and invoked with three
	     * arguments: (value, index, collection).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Math
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [iteratee] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * _.min([4, 2, 8, 6]);
	     * // => 2
	     *
	     * _.min([]);
	     * // => Infinity
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * _.min(users, function(chr) {
	     *   return chr.age;
	     * });
	     * // => { 'user': 'barney', 'age': 36 }
	     *
	     * // using the `_.property` callback shorthand
	     * _.min(users, 'age');
	     * // => { 'user': 'barney', 'age': 36 }
	     */
	    var min = createExtremum(lt, POSITIVE_INFINITY);
	
	    /**
	     * Calculates `n` rounded to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @category Math
	     * @param {number} n The number to round.
	     * @param {number} [precision=0] The precision to round to.
	     * @returns {number} Returns the rounded number.
	     * @example
	     *
	     * _.round(4.006);
	     * // => 4
	     *
	     * _.round(4.006, 2);
	     * // => 4.01
	     *
	     * _.round(4060, -2);
	     * // => 4100
	     */
	    var round = createRound('round');
	
	    /**
	     * Gets the sum of the values in `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @category Math
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [iteratee] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * _.sum([4, 6]);
	     * // => 10
	     *
	     * _.sum({ 'a': 4, 'b': 6 });
	     * // => 10
	     *
	     * var objects = [
	     *   { 'n': 4 },
	     *   { 'n': 6 }
	     * ];
	     *
	     * _.sum(objects, function(object) {
	     *   return object.n;
	     * });
	     * // => 10
	     *
	     * // using the `_.property` callback shorthand
	     * _.sum(objects, 'n');
	     * // => 10
	     */
	    function sum(collection, iteratee, thisArg) {
	      if (thisArg && isIterateeCall(collection, iteratee, thisArg)) {
	        iteratee = undefined;
	      }
	      iteratee = getCallback(iteratee, thisArg, 3);
	      return iteratee.length == 1
	        ? arraySum(isArray(collection) ? collection : toIterable(collection), iteratee)
	        : baseSum(collection, iteratee);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    // Ensure wrappers are instances of `baseLodash`.
	    lodash.prototype = baseLodash.prototype;
	
	    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
	    LodashWrapper.prototype.constructor = LodashWrapper;
	
	    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
	    LazyWrapper.prototype.constructor = LazyWrapper;
	
	    // Add functions to the `Map` cache.
	    MapCache.prototype['delete'] = mapDelete;
	    MapCache.prototype.get = mapGet;
	    MapCache.prototype.has = mapHas;
	    MapCache.prototype.set = mapSet;
	
	    // Add functions to the `Set` cache.
	    SetCache.prototype.push = cachePush;
	
	    // Assign cache to `_.memoize`.
	    memoize.Cache = MapCache;
	
	    // Add functions that return wrapped values when chaining.
	    lodash.after = after;
	    lodash.ary = ary;
	    lodash.assign = assign;
	    lodash.at = at;
	    lodash.before = before;
	    lodash.bind = bind;
	    lodash.bindAll = bindAll;
	    lodash.bindKey = bindKey;
	    lodash.callback = callback;
	    lodash.chain = chain;
	    lodash.chunk = chunk;
	    lodash.compact = compact;
	    lodash.constant = constant;
	    lodash.countBy = countBy;
	    lodash.create = create;
	    lodash.curry = curry;
	    lodash.curryRight = curryRight;
	    lodash.debounce = debounce;
	    lodash.defaults = defaults;
	    lodash.defaultsDeep = defaultsDeep;
	    lodash.defer = defer;
	    lodash.delay = delay;
	    lodash.difference = difference;
	    lodash.drop = drop;
	    lodash.dropRight = dropRight;
	    lodash.dropRightWhile = dropRightWhile;
	    lodash.dropWhile = dropWhile;
	    lodash.fill = fill;
	    lodash.filter = filter;
	    lodash.flatten = flatten;
	    lodash.flattenDeep = flattenDeep;
	    lodash.flow = flow;
	    lodash.flowRight = flowRight;
	    lodash.forEach = forEach;
	    lodash.forEachRight = forEachRight;
	    lodash.forIn = forIn;
	    lodash.forInRight = forInRight;
	    lodash.forOwn = forOwn;
	    lodash.forOwnRight = forOwnRight;
	    lodash.functions = functions;
	    lodash.groupBy = groupBy;
	    lodash.indexBy = indexBy;
	    lodash.initial = initial;
	    lodash.intersection = intersection;
	    lodash.invert = invert;
	    lodash.invoke = invoke;
	    lodash.keys = keys;
	    lodash.keysIn = keysIn;
	    lodash.map = map;
	    lodash.mapKeys = mapKeys;
	    lodash.mapValues = mapValues;
	    lodash.matches = matches;
	    lodash.matchesProperty = matchesProperty;
	    lodash.memoize = memoize;
	    lodash.merge = merge;
	    lodash.method = method;
	    lodash.methodOf = methodOf;
	    lodash.mixin = mixin;
	    lodash.modArgs = modArgs;
	    lodash.negate = negate;
	    lodash.omit = omit;
	    lodash.once = once;
	    lodash.pairs = pairs;
	    lodash.partial = partial;
	    lodash.partialRight = partialRight;
	    lodash.partition = partition;
	    lodash.pick = pick;
	    lodash.pluck = pluck;
	    lodash.property = property;
	    lodash.propertyOf = propertyOf;
	    lodash.pull = pull;
	    lodash.pullAt = pullAt;
	    lodash.range = range;
	    lodash.rearg = rearg;
	    lodash.reject = reject;
	    lodash.remove = remove;
	    lodash.rest = rest;
	    lodash.restParam = restParam;
	    lodash.set = set;
	    lodash.shuffle = shuffle;
	    lodash.slice = slice;
	    lodash.sortBy = sortBy;
	    lodash.sortByAll = sortByAll;
	    lodash.sortByOrder = sortByOrder;
	    lodash.spread = spread;
	    lodash.take = take;
	    lodash.takeRight = takeRight;
	    lodash.takeRightWhile = takeRightWhile;
	    lodash.takeWhile = takeWhile;
	    lodash.tap = tap;
	    lodash.throttle = throttle;
	    lodash.thru = thru;
	    lodash.times = times;
	    lodash.toArray = toArray;
	    lodash.toPlainObject = toPlainObject;
	    lodash.transform = transform;
	    lodash.union = union;
	    lodash.uniq = uniq;
	    lodash.unzip = unzip;
	    lodash.unzipWith = unzipWith;
	    lodash.values = values;
	    lodash.valuesIn = valuesIn;
	    lodash.where = where;
	    lodash.without = without;
	    lodash.wrap = wrap;
	    lodash.xor = xor;
	    lodash.zip = zip;
	    lodash.zipObject = zipObject;
	    lodash.zipWith = zipWith;
	
	    // Add aliases.
	    lodash.backflow = flowRight;
	    lodash.collect = map;
	    lodash.compose = flowRight;
	    lodash.each = forEach;
	    lodash.eachRight = forEachRight;
	    lodash.extend = assign;
	    lodash.iteratee = callback;
	    lodash.methods = functions;
	    lodash.object = zipObject;
	    lodash.select = filter;
	    lodash.tail = rest;
	    lodash.unique = uniq;
	
	    // Add functions to `lodash.prototype`.
	    mixin(lodash, lodash);
	
	    /*------------------------------------------------------------------------*/
	
	    // Add functions that return unwrapped values when chaining.
	    lodash.add = add;
	    lodash.attempt = attempt;
	    lodash.camelCase = camelCase;
	    lodash.capitalize = capitalize;
	    lodash.ceil = ceil;
	    lodash.clone = clone;
	    lodash.cloneDeep = cloneDeep;
	    lodash.deburr = deburr;
	    lodash.endsWith = endsWith;
	    lodash.escape = escape;
	    lodash.escapeRegExp = escapeRegExp;
	    lodash.every = every;
	    lodash.find = find;
	    lodash.findIndex = findIndex;
	    lodash.findKey = findKey;
	    lodash.findLast = findLast;
	    lodash.findLastIndex = findLastIndex;
	    lodash.findLastKey = findLastKey;
	    lodash.findWhere = findWhere;
	    lodash.first = first;
	    lodash.floor = floor;
	    lodash.get = get;
	    lodash.gt = gt;
	    lodash.gte = gte;
	    lodash.has = has;
	    lodash.identity = identity;
	    lodash.includes = includes;
	    lodash.indexOf = indexOf;
	    lodash.inRange = inRange;
	    lodash.isArguments = isArguments;
	    lodash.isArray = isArray;
	    lodash.isBoolean = isBoolean;
	    lodash.isDate = isDate;
	    lodash.isElement = isElement;
	    lodash.isEmpty = isEmpty;
	    lodash.isEqual = isEqual;
	    lodash.isError = isError;
	    lodash.isFinite = isFinite;
	    lodash.isFunction = isFunction;
	    lodash.isMatch = isMatch;
	    lodash.isNaN = isNaN;
	    lodash.isNative = isNative;
	    lodash.isNull = isNull;
	    lodash.isNumber = isNumber;
	    lodash.isObject = isObject;
	    lodash.isPlainObject = isPlainObject;
	    lodash.isRegExp = isRegExp;
	    lodash.isString = isString;
	    lodash.isTypedArray = isTypedArray;
	    lodash.isUndefined = isUndefined;
	    lodash.kebabCase = kebabCase;
	    lodash.last = last;
	    lodash.lastIndexOf = lastIndexOf;
	    lodash.lt = lt;
	    lodash.lte = lte;
	    lodash.max = max;
	    lodash.min = min;
	    lodash.noConflict = noConflict;
	    lodash.noop = noop;
	    lodash.now = now;
	    lodash.pad = pad;
	    lodash.padLeft = padLeft;
	    lodash.padRight = padRight;
	    lodash.parseInt = parseInt;
	    lodash.random = random;
	    lodash.reduce = reduce;
	    lodash.reduceRight = reduceRight;
	    lodash.repeat = repeat;
	    lodash.result = result;
	    lodash.round = round;
	    lodash.runInContext = runInContext;
	    lodash.size = size;
	    lodash.snakeCase = snakeCase;
	    lodash.some = some;
	    lodash.sortedIndex = sortedIndex;
	    lodash.sortedLastIndex = sortedLastIndex;
	    lodash.startCase = startCase;
	    lodash.startsWith = startsWith;
	    lodash.sum = sum;
	    lodash.template = template;
	    lodash.trim = trim;
	    lodash.trimLeft = trimLeft;
	    lodash.trimRight = trimRight;
	    lodash.trunc = trunc;
	    lodash.unescape = unescape;
	    lodash.uniqueId = uniqueId;
	    lodash.words = words;
	
	    // Add aliases.
	    lodash.all = every;
	    lodash.any = some;
	    lodash.contains = includes;
	    lodash.eq = isEqual;
	    lodash.detect = find;
	    lodash.foldl = reduce;
	    lodash.foldr = reduceRight;
	    lodash.head = first;
	    lodash.include = includes;
	    lodash.inject = reduce;
	
	    mixin(lodash, (function() {
	      var source = {};
	      baseForOwn(lodash, function(func, methodName) {
	        if (!lodash.prototype[methodName]) {
	          source[methodName] = func;
	        }
	      });
	      return source;
	    }()), false);
	
	    /*------------------------------------------------------------------------*/
	
	    // Add functions capable of returning wrapped and unwrapped values when chaining.
	    lodash.sample = sample;
	
	    lodash.prototype.sample = function(n) {
	      if (!this.__chain__ && n == null) {
	        return sample(this.value());
	      }
	      return this.thru(function(value) {
	        return sample(value, n);
	      });
	    };
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The semantic version number.
	     *
	     * @static
	     * @memberOf _
	     * @type string
	     */
	    lodash.VERSION = VERSION;
	
	    // Assign default placeholders.
	    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
	      lodash[methodName].placeholder = lodash;
	    });
	
	    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
	    arrayEach(['drop', 'take'], function(methodName, index) {
	      LazyWrapper.prototype[methodName] = function(n) {
	        var filtered = this.__filtered__;
	        if (filtered && !index) {
	          return new LazyWrapper(this);
	        }
	        n = n == null ? 1 : nativeMax(nativeFloor(n) || 0, 0);
	
	        var result = this.clone();
	        if (filtered) {
	          result.__takeCount__ = nativeMin(result.__takeCount__, n);
	        } else {
	          result.__views__.push({ 'size': n, 'type': methodName + (result.__dir__ < 0 ? 'Right' : '') });
	        }
	        return result;
	      };
	
	      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
	        return this.reverse()[methodName](n).reverse();
	      };
	    });
	
	    // Add `LazyWrapper` methods that accept an `iteratee` value.
	    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
	      var type = index + 1,
	          isFilter = type != LAZY_MAP_FLAG;
	
	      LazyWrapper.prototype[methodName] = function(iteratee, thisArg) {
	        var result = this.clone();
	        result.__iteratees__.push({ 'iteratee': getCallback(iteratee, thisArg, 1), 'type': type });
	        result.__filtered__ = result.__filtered__ || isFilter;
	        return result;
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.first` and `_.last`.
	    arrayEach(['first', 'last'], function(methodName, index) {
	      var takeName = 'take' + (index ? 'Right' : '');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this[takeName](1).value()[0];
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.initial` and `_.rest`.
	    arrayEach(['initial', 'rest'], function(methodName, index) {
	      var dropName = 'drop' + (index ? '' : 'Right');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.pluck` and `_.where`.
	    arrayEach(['pluck', 'where'], function(methodName, index) {
	      var operationName = index ? 'filter' : 'map',
	          createCallback = index ? baseMatches : property;
	
	      LazyWrapper.prototype[methodName] = function(value) {
	        return this[operationName](createCallback(value));
	      };
	    });
	
	    LazyWrapper.prototype.compact = function() {
	      return this.filter(identity);
	    };
	
	    LazyWrapper.prototype.reject = function(predicate, thisArg) {
	      predicate = getCallback(predicate, thisArg, 1);
	      return this.filter(function(value) {
	        return !predicate(value);
	      });
	    };
	
	    LazyWrapper.prototype.slice = function(start, end) {
	      start = start == null ? 0 : (+start || 0);
	
	      var result = this;
	      if (result.__filtered__ && (start > 0 || end < 0)) {
	        return new LazyWrapper(result);
	      }
	      if (start < 0) {
	        result = result.takeRight(-start);
	      } else if (start) {
	        result = result.drop(start);
	      }
	      if (end !== undefined) {
	        end = (+end || 0);
	        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
	      }
	      return result;
	    };
	
	    LazyWrapper.prototype.takeRightWhile = function(predicate, thisArg) {
	      return this.reverse().takeWhile(predicate, thisArg).reverse();
	    };
	
	    LazyWrapper.prototype.toArray = function() {
	      return this.take(POSITIVE_INFINITY);
	    };
	
	    // Add `LazyWrapper` methods to `lodash.prototype`.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var checkIteratee = /^(?:filter|map|reject)|While$/.test(methodName),
	          retUnwrapped = /^(?:first|last)$/.test(methodName),
	          lodashFunc = lodash[retUnwrapped ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName];
	
	      if (!lodashFunc) {
	        return;
	      }
	      lodash.prototype[methodName] = function() {
	        var args = retUnwrapped ? [1] : arguments,
	            chainAll = this.__chain__,
	            value = this.__wrapped__,
	            isHybrid = !!this.__actions__.length,
	            isLazy = value instanceof LazyWrapper,
	            iteratee = args[0],
	            useLazy = isLazy || isArray(value);
	
	        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
	          // Avoid lazy use if the iteratee has a "length" value other than `1`.
	          isLazy = useLazy = false;
	        }
	        var interceptor = function(value) {
	          return (retUnwrapped && chainAll)
	            ? lodashFunc(value, 1)[0]
	            : lodashFunc.apply(undefined, arrayPush([value], args));
	        };
	
	        var action = { 'func': thru, 'args': [interceptor], 'thisArg': undefined },
	            onlyLazy = isLazy && !isHybrid;
	
	        if (retUnwrapped && !chainAll) {
	          if (onlyLazy) {
	            value = value.clone();
	            value.__actions__.push(action);
	            return func.call(value);
	          }
	          return lodashFunc.call(undefined, this.value())[0];
	        }
	        if (!retUnwrapped && useLazy) {
	          value = onlyLazy ? value : new LazyWrapper(this);
	          var result = func.apply(value, args);
	          result.__actions__.push(action);
	          return new LodashWrapper(result, chainAll);
	        }
	        return this.thru(interceptor);
	      };
	    });
	
	    // Add `Array` and `String` methods to `lodash.prototype`.
	    arrayEach(['join', 'pop', 'push', 'replace', 'shift', 'sort', 'splice', 'split', 'unshift'], function(methodName) {
	      var func = (/^(?:replace|split)$/.test(methodName) ? stringProto : arrayProto)[methodName],
	          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
	          retUnwrapped = /^(?:join|pop|replace|shift)$/.test(methodName);
	
	      lodash.prototype[methodName] = function() {
	        var args = arguments;
	        if (retUnwrapped && !this.__chain__) {
	          return func.apply(this.value(), args);
	        }
	        return this[chainName](function(value) {
	          return func.apply(value, args);
	        });
	      };
	    });
	
	    // Map minified function names to their real names.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var lodashFunc = lodash[methodName];
	      if (lodashFunc) {
	        var key = lodashFunc.name,
	            names = realNames[key] || (realNames[key] = []);
	
	        names.push({ 'name': methodName, 'func': lodashFunc });
	      }
	    });
	
	    realNames[createHybridWrapper(undefined, BIND_KEY_FLAG).name] = [{ 'name': 'wrapper', 'func': undefined }];
	
	    // Add functions to the lazy wrapper.
	    LazyWrapper.prototype.clone = lazyClone;
	    LazyWrapper.prototype.reverse = lazyReverse;
	    LazyWrapper.prototype.value = lazyValue;
	
	    // Add chaining functions to the `lodash` wrapper.
	    lodash.prototype.chain = wrapperChain;
	    lodash.prototype.commit = wrapperCommit;
	    lodash.prototype.concat = wrapperConcat;
	    lodash.prototype.plant = wrapperPlant;
	    lodash.prototype.reverse = wrapperReverse;
	    lodash.prototype.toString = wrapperToString;
	    lodash.prototype.run = lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
	
	    // Add function aliases to the `lodash` wrapper.
	    lodash.prototype.collect = lodash.prototype.map;
	    lodash.prototype.head = lodash.prototype.first;
	    lodash.prototype.select = lodash.prototype.filter;
	    lodash.prototype.tail = lodash.prototype.rest;
	
	    return lodash;
	  }
	
	  /*--------------------------------------------------------------------------*/
	
	  // Export lodash.
	  var _ = runInContext();
	
	  // Some AMD build optimizers like r.js check for condition patterns like the following:
	  if (true) {
	    // Expose lodash to the global object when an AMD loader is present to avoid
	    // errors in cases where lodash is loaded by a script tag and not intended
	    // as an AMD module. See http://requirejs.org/docs/errors.html#mismatch for
	    // more details.
	    root._ = _;
	
	    // Define as an anonymous module so, through path mapping, it can be
	    // referenced as the "underscore" module.
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	      return _;
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  }
	  // Check for `exports` after `define` in case a build optimizer adds an `exports` object.
	  else if (freeExports && freeModule) {
	    // Export for Node.js or RingoJS.
	    if (moduleExports) {
	      (freeModule.exports = _)._ = _;
	    }
	    // Export for Rhino with CommonJS support.
	    else {
	      freeExports._ = _;
	    }
	  }
	  else {
	    // Export for a browser or Rhino.
	    root._ = _;
	  }
	}.call(this));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)(module), (function() { return this; }())))

/***/ },
/* 353 */
/***/ function(module, exports, __webpack_require__) {

	var mapDelete = __webpack_require__(372),
	    mapGet = __webpack_require__(373),
	    mapHas = __webpack_require__(374),
	    mapSet = __webpack_require__(375);
	
	/**
	 * Creates a cache object to store key/value pairs.
	 *
	 * @private
	 * @static
	 * @name Cache
	 * @memberOf _.memoize
	 */
	function MapCache() {
	  this.__data__ = {};
	}
	
	// Add functions to the `Map` cache.
	MapCache.prototype['delete'] = mapDelete;
	MapCache.prototype.get = mapGet;
	MapCache.prototype.has = mapHas;
	MapCache.prototype.set = mapSet;
	
	module.exports = MapCache;


/***/ },
/* 354 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var cachePush = __webpack_require__(367),
	    getNative = __webpack_require__(55);
	
	/** Native method references. */
	var Set = getNative(global, 'Set');
	
	/* Native method references for those with the same name as other `lodash` methods. */
	var nativeCreate = getNative(Object, 'create');
	
	/**
	 *
	 * Creates a cache object to store unique values.
	 *
	 * @private
	 * @param {Array} [values] The values to cache.
	 */
	function SetCache(values) {
	  var length = values ? values.length : 0;
	
	  this.data = { 'hash': nativeCreate(null), 'set': new Set };
	  while (length--) {
	    this.push(values[length]);
	  }
	}
	
	// Add functions to the `Set` cache.
	SetCache.prototype.push = cachePush;
	
	module.exports = SetCache;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 355 */
/***/ function(module, exports) {

	/**
	 * Copies the values of `source` to `array`.
	 *
	 * @private
	 * @param {Array} source The array to copy values from.
	 * @param {Array} [array=[]] The array to copy values to.
	 * @returns {Array} Returns `array`.
	 */
	function arrayCopy(source, array) {
	  var index = -1,
	      length = source.length;
	
	  array || (array = Array(length));
	  while (++index < length) {
	    array[index] = source[index];
	  }
	  return array;
	}
	
	module.exports = arrayCopy;


/***/ },
/* 356 */
/***/ function(module, exports) {

	/**
	 * Used by `_.defaults` to customize its `_.assign` use.
	 *
	 * @private
	 * @param {*} objectValue The destination object property value.
	 * @param {*} sourceValue The source object property value.
	 * @returns {*} Returns the value to assign to the destination object.
	 */
	function assignDefaults(objectValue, sourceValue) {
	  return objectValue === undefined ? sourceValue : objectValue;
	}
	
	module.exports = assignDefaults;


/***/ },
/* 357 */
/***/ function(module, exports, __webpack_require__) {

	var keys = __webpack_require__(79);
	
	/**
	 * A specialized version of `_.assign` for customizing assigned values without
	 * support for argument juggling, multiple sources, and `this` binding `customizer`
	 * functions.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @param {Function} customizer The function to customize assigned values.
	 * @returns {Object} Returns `object`.
	 */
	function assignWith(object, source, customizer) {
	  var index = -1,
	      props = keys(source),
	      length = props.length;
	
	  while (++index < length) {
	    var key = props[index],
	        value = object[key],
	        result = customizer(value, source[key], key, object, source);
	
	    if ((result === result ? (result !== value) : (value === value)) ||
	        (value === undefined && !(key in object))) {
	      object[key] = result;
	    }
	  }
	  return object;
	}
	
	module.exports = assignWith;


/***/ },
/* 358 */
/***/ function(module, exports, __webpack_require__) {

	var baseCopy = __webpack_require__(359),
	    keys = __webpack_require__(79);
	
	/**
	 * The base implementation of `_.assign` without support for argument juggling,
	 * multiple sources, and `customizer` functions.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @returns {Object} Returns `object`.
	 */
	function baseAssign(object, source) {
	  return source == null
	    ? object
	    : baseCopy(source, keys(source), object);
	}
	
	module.exports = baseAssign;


/***/ },
/* 359 */
/***/ function(module, exports) {

	/**
	 * Copies properties of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy properties from.
	 * @param {Array} props The property names to copy.
	 * @param {Object} [object={}] The object to copy properties to.
	 * @returns {Object} Returns `object`.
	 */
	function baseCopy(source, props, object) {
	  object || (object = {});
	
	  var index = -1,
	      length = props.length;
	
	  while (++index < length) {
	    var key = props[index];
	    object[key] = source[key];
	  }
	  return object;
	}
	
	module.exports = baseCopy;


/***/ },
/* 360 */
/***/ function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(123),
	    isArguments = __webpack_require__(56),
	    isArray = __webpack_require__(23),
	    isArrayLike = __webpack_require__(22),
	    isObjectLike = __webpack_require__(41);
	
	/**
	 * The base implementation of `_.flatten` with added support for restricting
	 * flattening and specifying the start index.
	 *
	 * @private
	 * @param {Array} array The array to flatten.
	 * @param {boolean} [isDeep] Specify a deep flatten.
	 * @param {boolean} [isStrict] Restrict flattening to arrays-like objects.
	 * @param {Array} [result=[]] The initial result value.
	 * @returns {Array} Returns the new flattened array.
	 */
	function baseFlatten(array, isDeep, isStrict, result) {
	  result || (result = []);
	
	  var index = -1,
	      length = array.length;
	
	  while (++index < length) {
	    var value = array[index];
	    if (isObjectLike(value) && isArrayLike(value) &&
	        (isStrict || isArray(value) || isArguments(value))) {
	      if (isDeep) {
	        // Recursively flatten arrays (susceptible to call stack limits).
	        baseFlatten(value, isDeep, isStrict, result);
	      } else {
	        arrayPush(result, value);
	      }
	    } else if (!isStrict) {
	      result[result.length] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = baseFlatten;


/***/ },
/* 361 */
/***/ function(module, exports, __webpack_require__) {

	var createBaseFor = __webpack_require__(369);
	
	/**
	 * The base implementation of `baseForIn` and `baseForOwn` which iterates
	 * over `object` properties returned by `keysFunc` invoking `iteratee` for
	 * each property. Iteratee functions may exit iteration early by explicitly
	 * returning `false`.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @returns {Object} Returns `object`.
	 */
	var baseFor = createBaseFor();
	
	module.exports = baseFor;


/***/ },
/* 362 */
/***/ function(module, exports, __webpack_require__) {

	var baseFor = __webpack_require__(361),
	    keysIn = __webpack_require__(128);
	
	/**
	 * The base implementation of `_.forIn` without support for callback
	 * shorthands and `this` binding.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Object} Returns `object`.
	 */
	function baseForIn(object, iteratee) {
	  return baseFor(object, iteratee, keysIn);
	}
	
	module.exports = baseForIn;


/***/ },
/* 363 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.property` without support for deep paths.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @returns {Function} Returns the new function.
	 */
	function baseProperty(key) {
	  return function(object) {
	    return object == null ? undefined : object[key];
	  };
	}
	
	module.exports = baseProperty;


/***/ },
/* 364 */
/***/ function(module, exports) {

	/* Native method references for those with the same name as other `lodash` methods. */
	var nativeFloor = Math.floor,
	    nativeRandom = Math.random;
	
	/**
	 * The base implementation of `_.random` without support for argument juggling
	 * and returning floating-point numbers.
	 *
	 * @private
	 * @param {number} min The minimum possible value.
	 * @param {number} max The maximum possible value.
	 * @returns {number} Returns the random number.
	 */
	function baseRandom(min, max) {
	  return min + nativeFloor(nativeRandom() * (max - min + 1));
	}
	
	module.exports = baseRandom;


/***/ },
/* 365 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.values` and `_.valuesIn` which creates an
	 * array of `object` property values corresponding to the property names
	 * of `props`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array} props The property names to get values for.
	 * @returns {Object} Returns the array of property values.
	 */
	function baseValues(object, props) {
	  var index = -1,
	      length = props.length,
	      result = Array(length);
	
	  while (++index < length) {
	    result[index] = object[props[index]];
	  }
	  return result;
	}
	
	module.exports = baseValues;


/***/ },
/* 366 */
/***/ function(module, exports, __webpack_require__) {

	var identity = __webpack_require__(384);
	
	/**
	 * A specialized version of `baseCallback` which only supports `this` binding
	 * and specifying the number of arguments to provide to `func`.
	 *
	 * @private
	 * @param {Function} func The function to bind.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {number} [argCount] The number of arguments to provide to `func`.
	 * @returns {Function} Returns the callback.
	 */
	function bindCallback(func, thisArg, argCount) {
	  if (typeof func != 'function') {
	    return identity;
	  }
	  if (thisArg === undefined) {
	    return func;
	  }
	  switch (argCount) {
	    case 1: return function(value) {
	      return func.call(thisArg, value);
	    };
	    case 3: return function(value, index, collection) {
	      return func.call(thisArg, value, index, collection);
	    };
	    case 4: return function(accumulator, value, index, collection) {
	      return func.call(thisArg, accumulator, value, index, collection);
	    };
	    case 5: return function(value, other, key, object, source) {
	      return func.call(thisArg, value, other, key, object, source);
	    };
	  }
	  return function() {
	    return func.apply(thisArg, arguments);
	  };
	}
	
	module.exports = bindCallback;


/***/ },
/* 367 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(15);
	
	/**
	 * Adds `value` to the cache.
	 *
	 * @private
	 * @name push
	 * @memberOf SetCache
	 * @param {*} value The value to cache.
	 */
	function cachePush(value) {
	  var data = this.data;
	  if (typeof value == 'string' || isObject(value)) {
	    data.set.add(value);
	  } else {
	    data.hash[value] = true;
	  }
	}
	
	module.exports = cachePush;


/***/ },
/* 368 */
/***/ function(module, exports, __webpack_require__) {

	var bindCallback = __webpack_require__(366),
	    isIterateeCall = __webpack_require__(127),
	    restParam = __webpack_require__(39);
	
	/**
	 * Creates a `_.assign`, `_.defaults`, or `_.merge` function.
	 *
	 * @private
	 * @param {Function} assigner The function to assign values.
	 * @returns {Function} Returns the new assigner function.
	 */
	function createAssigner(assigner) {
	  return restParam(function(object, sources) {
	    var index = -1,
	        length = object == null ? 0 : sources.length,
	        customizer = length > 2 ? sources[length - 2] : undefined,
	        guard = length > 2 ? sources[2] : undefined,
	        thisArg = length > 1 ? sources[length - 1] : undefined;
	
	    if (typeof customizer == 'function') {
	      customizer = bindCallback(customizer, thisArg, 5);
	      length -= 2;
	    } else {
	      customizer = typeof thisArg == 'function' ? thisArg : undefined;
	      length -= (customizer ? 1 : 0);
	    }
	    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	      customizer = length < 3 ? undefined : customizer;
	      length = 1;
	    }
	    while (++index < length) {
	      var source = sources[index];
	      if (source) {
	        assigner(object, source, customizer);
	      }
	    }
	    return object;
	  });
	}
	
	module.exports = createAssigner;


/***/ },
/* 369 */
/***/ function(module, exports, __webpack_require__) {

	var toObject = __webpack_require__(378);
	
	/**
	 * Creates a base function for `_.forIn` or `_.forInRight`.
	 *
	 * @private
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseFor(fromRight) {
	  return function(object, iteratee, keysFunc) {
	    var iterable = toObject(object),
	        props = keysFunc(object),
	        length = props.length,
	        index = fromRight ? length : -1;
	
	    while ((fromRight ? index-- : ++index < length)) {
	      var key = props[index];
	      if (iteratee(iterable[key], key, iterable) === false) {
	        break;
	      }
	    }
	    return object;
	  };
	}
	
	module.exports = createBaseFor;


/***/ },
/* 370 */
/***/ function(module, exports, __webpack_require__) {

	var restParam = __webpack_require__(39);
	
	/**
	 * Creates a `_.defaults` or `_.defaultsDeep` function.
	 *
	 * @private
	 * @param {Function} assigner The function to assign values.
	 * @param {Function} customizer The function to customize assigned values.
	 * @returns {Function} Returns the new defaults function.
	 */
	function createDefaults(assigner, customizer) {
	  return restParam(function(args) {
	    var object = args[0];
	    if (object == null) {
	      return object;
	    }
	    args.push(customizer);
	    return assigner.apply(undefined, args);
	  });
	}
	
	module.exports = createDefaults;


/***/ },
/* 371 */
/***/ function(module, exports) {

	/**
	 * Gets the index at which the first occurrence of `NaN` is found in `array`.
	 *
	 * @private
	 * @param {Array} array The array to search.
	 * @param {number} fromIndex The index to search from.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {number} Returns the index of the matched `NaN`, else `-1`.
	 */
	function indexOfNaN(array, fromIndex, fromRight) {
	  var length = array.length,
	      index = fromIndex + (fromRight ? 0 : -1);
	
	  while ((fromRight ? index-- : ++index < length)) {
	    var other = array[index];
	    if (other !== other) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	module.exports = indexOfNaN;


/***/ },
/* 372 */
/***/ function(module, exports) {

	/**
	 * Removes `key` and its value from the cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf _.memoize.Cache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed successfully, else `false`.
	 */
	function mapDelete(key) {
	  return this.has(key) && delete this.__data__[key];
	}
	
	module.exports = mapDelete;


/***/ },
/* 373 */
/***/ function(module, exports) {

	/**
	 * Gets the cached value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf _.memoize.Cache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the cached value.
	 */
	function mapGet(key) {
	  return key == '__proto__' ? undefined : this.__data__[key];
	}
	
	module.exports = mapGet;


/***/ },
/* 374 */
/***/ function(module, exports) {

	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Checks if a cached value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf _.memoize.Cache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapHas(key) {
	  return key != '__proto__' && hasOwnProperty.call(this.__data__, key);
	}
	
	module.exports = mapHas;


/***/ },
/* 375 */
/***/ function(module, exports) {

	/**
	 * Sets `value` to `key` of the cache.
	 *
	 * @private
	 * @name set
	 * @memberOf _.memoize.Cache
	 * @param {string} key The key of the value to cache.
	 * @param {*} value The value to cache.
	 * @returns {Object} Returns the cache object.
	 */
	function mapSet(key, value) {
	  if (key != '__proto__') {
	    this.__data__[key] = value;
	  }
	  return this;
	}
	
	module.exports = mapSet;


/***/ },
/* 376 */
/***/ function(module, exports, __webpack_require__) {

	var isArguments = __webpack_require__(56),
	    isArray = __webpack_require__(23),
	    isIndex = __webpack_require__(78),
	    isLength = __webpack_require__(40),
	    keysIn = __webpack_require__(128);
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A fallback implementation of `Object.keys` which creates an array of the
	 * own enumerable property names of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function shimKeys(object) {
	  var props = keysIn(object),
	      propsLength = props.length,
	      length = propsLength && object.length;
	
	  var allowIndexes = !!length && isLength(length) &&
	    (isArray(object) || isArguments(object));
	
	  var index = -1,
	      result = [];
	
	  while (++index < propsLength) {
	    var key = props[index];
	    if ((allowIndexes && isIndex(key, length)) || hasOwnProperty.call(object, key)) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = shimKeys;


/***/ },
/* 377 */
/***/ function(module, exports, __webpack_require__) {

	var isArrayLike = __webpack_require__(22),
	    isObject = __webpack_require__(15),
	    values = __webpack_require__(129);
	
	/**
	 * Converts `value` to an array-like object if it's not one.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {Array|Object} Returns the array-like object.
	 */
	function toIterable(value) {
	  if (value == null) {
	    return [];
	  }
	  if (!isArrayLike(value)) {
	    return values(value);
	  }
	  return isObject(value) ? value : Object(value);
	}
	
	module.exports = toIterable;


/***/ },
/* 378 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(15);
	
	/**
	 * Converts `value` to an object if it's not one.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {Object} Returns the object.
	 */
	function toObject(value) {
	  return isObject(value) ? value : Object(value);
	}
	
	module.exports = toObject;


/***/ },
/* 379 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(15);
	
	/** `Object#toString` result references. */
	var funcTag = '[object Function]';
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objToString = objectProto.toString;
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in older versions of Chrome and Safari which return 'function' for regexes
	  // and Safari 8 which returns 'object' for typed array constructors.
	  return isObject(value) && objToString.call(value) == funcTag;
	}
	
	module.exports = isFunction;


/***/ },
/* 380 */
/***/ function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(379),
	    isObjectLike = __webpack_require__(41);
	
	/** Used to detect host constructors (Safari > 5). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var fnToString = Function.prototype.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  fnToString.call(hasOwnProperty).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/**
	 * Checks if `value` is a native function.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function, else `false`.
	 * @example
	 *
	 * _.isNative(Array.prototype.push);
	 * // => true
	 *
	 * _.isNative(_);
	 * // => false
	 */
	function isNative(value) {
	  if (value == null) {
	    return false;
	  }
	  if (isFunction(value)) {
	    return reIsNative.test(fnToString.call(value));
	  }
	  return isObjectLike(value) && reIsHostCtor.test(value);
	}
	
	module.exports = isNative;


/***/ },
/* 381 */
/***/ function(module, exports, __webpack_require__) {

	var arrayCopy = __webpack_require__(355),
	    getLength = __webpack_require__(126),
	    isLength = __webpack_require__(40),
	    values = __webpack_require__(129);
	
	/**
	 * Converts `value` to an array.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {Array} Returns the converted array.
	 * @example
	 *
	 * (function() {
	 *   return _.toArray(arguments).slice(1);
	 * }(1, 2, 3));
	 * // => [2, 3]
	 */
	function toArray(value) {
	  var length = value ? getLength(value) : 0;
	  if (!isLength(length)) {
	    return values(value);
	  }
	  if (!length) {
	    return [];
	  }
	  return arrayCopy(value);
	}
	
	module.exports = toArray;


/***/ },
/* 382 */
/***/ function(module, exports, __webpack_require__) {

	var assignWith = __webpack_require__(357),
	    baseAssign = __webpack_require__(358),
	    createAssigner = __webpack_require__(368);
	
	/**
	 * Assigns own enumerable properties of source object(s) to the destination
	 * object. Subsequent sources overwrite property assignments of previous sources.
	 * If `customizer` is provided it's invoked to produce the assigned values.
	 * The `customizer` is bound to `thisArg` and invoked with five arguments:
	 * (objectValue, sourceValue, key, object, source).
	 *
	 * **Note:** This method mutates `object` and is based on
	 * [`Object.assign`](http://ecma-international.org/ecma-262/6.0/#sec-object.assign).
	 *
	 * @static
	 * @memberOf _
	 * @alias extend
	 * @category Object
	 * @param {Object} object The destination object.
	 * @param {...Object} [sources] The source objects.
	 * @param {Function} [customizer] The function to customize assigned values.
	 * @param {*} [thisArg] The `this` binding of `customizer`.
	 * @returns {Object} Returns `object`.
	 * @example
	 *
	 * _.assign({ 'user': 'barney' }, { 'age': 40 }, { 'user': 'fred' });
	 * // => { 'user': 'fred', 'age': 40 }
	 *
	 * // using a customizer callback
	 * var defaults = _.partialRight(_.assign, function(value, other) {
	 *   return _.isUndefined(value) ? other : value;
	 * });
	 *
	 * defaults({ 'user': 'barney' }, { 'age': 36 }, { 'user': 'fred' });
	 * // => { 'user': 'barney', 'age': 36 }
	 */
	var assign = createAssigner(function(object, source, customizer) {
	  return customizer
	    ? assignWith(object, source, customizer)
	    : baseAssign(object, source);
	});
	
	module.exports = assign;


/***/ },
/* 383 */
/***/ function(module, exports, __webpack_require__) {

	var assign = __webpack_require__(382),
	    assignDefaults = __webpack_require__(356),
	    createDefaults = __webpack_require__(370);
	
	/**
	 * Assigns own enumerable properties of source object(s) to the destination
	 * object for all destination properties that resolve to `undefined`. Once a
	 * property is set, additional values of the same property are ignored.
	 *
	 * **Note:** This method mutates `object`.
	 *
	 * @static
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The destination object.
	 * @param {...Object} [sources] The source objects.
	 * @returns {Object} Returns `object`.
	 * @example
	 *
	 * _.defaults({ 'user': 'barney' }, { 'age': 36 }, { 'user': 'fred' });
	 * // => { 'user': 'barney', 'age': 36 }
	 */
	var defaults = createDefaults(assign, assignDefaults);
	
	module.exports = defaults;


/***/ },
/* 384 */
/***/ function(module, exports) {

	/**
	 * This method returns the first argument provided to it.
	 *
	 * @static
	 * @memberOf _
	 * @category Utility
	 * @param {*} value Any value.
	 * @returns {*} Returns `value`.
	 * @example
	 *
	 * var object = { 'user': 'fred' };
	 *
	 * _.identity(object) === object;
	 * // => true
	 */
	function identity(value) {
	  return value;
	}
	
	module.exports = identity;


/***/ },
/* 385 */
/***/ function(module, exports) {

	/**
	 * A no-operation function that returns `undefined` regardless of the
	 * arguments it receives.
	 *
	 * @static
	 * @memberOf _
	 * @category Utility
	 * @example
	 *
	 * var object = { 'user': 'fred' };
	 *
	 * _.noop(object) === undefined;
	 * // => true
	 */
	function noop() {
	  // No operation performed.
	}
	
	module.exports = noop;


/***/ },
/* 386 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _classCallCheck = function (instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	/* jshint -W084 */
	var PathUtils = __webpack_require__(80);
	
	function deepSearch(route, pathname, query) {
	  // Check the subtree first to find the most deeply-nested match.
	  var childRoutes = route.childRoutes;
	  if (childRoutes) {
	    var match, childRoute;
	    for (var i = 0, len = childRoutes.length; i < len; ++i) {
	      childRoute = childRoutes[i];
	
	      if (childRoute.isDefault || childRoute.isNotFound) continue; // Check these in order later.
	
	      if (match = deepSearch(childRoute, pathname, query)) {
	        // A route in the subtree matched! Add this route and we're done.
	        match.routes.unshift(route);
	        return match;
	      }
	    }
	  }
	
	  // No child routes matched; try the default route.
	  var defaultRoute = route.defaultRoute;
	  if (defaultRoute && (params = PathUtils.extractParams(defaultRoute.path, pathname))) {
	    return new Match(pathname, params, query, [route, defaultRoute]);
	  } // Does the "not found" route match?
	  var notFoundRoute = route.notFoundRoute;
	  if (notFoundRoute && (params = PathUtils.extractParams(notFoundRoute.path, pathname))) {
	    return new Match(pathname, params, query, [route, notFoundRoute]);
	  } // Last attempt: check this route.
	  var params = PathUtils.extractParams(route.path, pathname);
	  if (params) {
	    return new Match(pathname, params, query, [route]);
	  }return null;
	}
	
	var Match = (function () {
	  function Match(pathname, params, query, routes) {
	    _classCallCheck(this, Match);
	
	    this.pathname = pathname;
	    this.params = params;
	    this.query = query;
	    this.routes = routes;
	  }
	
	  _createClass(Match, null, [{
	    key: 'findMatch',
	
	    /**
	     * Attempts to match depth-first a route in the given route's
	     * subtree against the given path and returns the match if it
	     * succeeds, null if no match can be made.
	     */
	    value: function findMatch(routes, path) {
	      var pathname = PathUtils.withoutQuery(path);
	      var query = PathUtils.extractQuery(path);
	      var match = null;
	
	      for (var i = 0, len = routes.length; match == null && i < len; ++i) match = deepSearch(routes[i], pathname, query);
	
	      return match;
	    }
	  }]);
	
	  return Match;
	})();
	
	module.exports = Match;

/***/ },
/* 387 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var PropTypes = __webpack_require__(16);
	
	/**
	 * A mixin for components that modify the URL.
	 *
	 * Example:
	 *
	 *   var MyLink = React.createClass({
	 *     mixins: [ Router.Navigation ],
	 *     handleClick(event) {
	 *       event.preventDefault();
	 *       this.transitionTo('aRoute', { the: 'params' }, { the: 'query' });
	 *     },
	 *     render() {
	 *       return (
	 *         <a onClick={this.handleClick}>Click me!</a>
	 *       );
	 *     }
	 *   });
	 */
	var Navigation = {
	
	  contextTypes: {
	    router: PropTypes.router.isRequired
	  },
	
	  /**
	   * Returns an absolute URL path created from the given route
	   * name, URL parameters, and query values.
	   */
	  makePath: function makePath(to, params, query) {
	    return this.context.router.makePath(to, params, query);
	  },
	
	  /**
	   * Returns a string that may safely be used as the href of a
	   * link to the route with the given name.
	   */
	  makeHref: function makeHref(to, params, query) {
	    return this.context.router.makeHref(to, params, query);
	  },
	
	  /**
	   * Transitions to the URL specified in the arguments by pushing
	   * a new URL onto the history stack.
	   */
	  transitionTo: function transitionTo(to, params, query) {
	    this.context.router.transitionTo(to, params, query);
	  },
	
	  /**
	   * Transitions to the URL specified in the arguments by replacing
	   * the current URL in the history stack.
	   */
	  replaceWith: function replaceWith(to, params, query) {
	    this.context.router.replaceWith(to, params, query);
	  },
	
	  /**
	   * Transitions to the previous URL.
	   */
	  goBack: function goBack() {
	    return this.context.router.goBack();
	  }
	
	};
	
	module.exports = Navigation;

/***/ },
/* 388 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var invariant = __webpack_require__(2);
	var canUseDOM = __webpack_require__(8).canUseDOM;
	var getWindowScrollPosition = __webpack_require__(394);
	
	function shouldUpdateScroll(state, prevState) {
	  if (!prevState) {
	    return true;
	  } // Don't update scroll position when only the query has changed.
	  if (state.pathname === prevState.pathname) {
	    return false;
	  }var routes = state.routes;
	  var prevRoutes = prevState.routes;
	
	  var sharedAncestorRoutes = routes.filter(function (route) {
	    return prevRoutes.indexOf(route) !== -1;
	  });
	
	  return !sharedAncestorRoutes.some(function (route) {
	    return route.ignoreScrollBehavior;
	  });
	}
	
	/**
	 * Provides the router with the ability to manage window scroll position
	 * according to its scroll behavior.
	 */
	var ScrollHistory = {
	
	  statics: {
	
	    /**
	     * Records curent scroll position as the last known position for the given URL path.
	     */
	    recordScrollPosition: function recordScrollPosition(path) {
	      if (!this.scrollHistory) this.scrollHistory = {};
	
	      this.scrollHistory[path] = getWindowScrollPosition();
	    },
	
	    /**
	     * Returns the last known scroll position for the given URL path.
	     */
	    getScrollPosition: function getScrollPosition(path) {
	      if (!this.scrollHistory) this.scrollHistory = {};
	
	      return this.scrollHistory[path] || null;
	    }
	
	  },
	
	  componentWillMount: function componentWillMount() {
	    invariant(this.constructor.getScrollBehavior() == null || canUseDOM, 'Cannot use scroll behavior without a DOM');
	  },
	
	  componentDidMount: function componentDidMount() {
	    this._updateScroll();
	  },
	
	  componentDidUpdate: function componentDidUpdate(prevProps, prevState) {
	    this._updateScroll(prevState);
	  },
	
	  _updateScroll: function _updateScroll(prevState) {
	    if (!shouldUpdateScroll(this.state, prevState)) {
	      return;
	    }var scrollBehavior = this.constructor.getScrollBehavior();
	
	    if (scrollBehavior) scrollBehavior.updateScrollPosition(this.constructor.getScrollPosition(this.state.path), this.state.action);
	  }
	
	};
	
	module.exports = ScrollHistory;

/***/ },
/* 389 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var PropTypes = __webpack_require__(16);
	
	/**
	 * A mixin for components that need to know the path, routes, URL
	 * params and query that are currently active.
	 *
	 * Example:
	 *
	 *   var AboutLink = React.createClass({
	 *     mixins: [ Router.State ],
	 *     render() {
	 *       var className = this.props.className;
	 *
	 *       if (this.isActive('about'))
	 *         className += ' is-active';
	 *
	 *       return React.DOM.a({ className: className }, this.props.children);
	 *     }
	 *   });
	 */
	var State = {
	
	  contextTypes: {
	    router: PropTypes.router.isRequired
	  },
	
	  /**
	   * Returns the current URL path.
	   */
	  getPath: function getPath() {
	    return this.context.router.getCurrentPath();
	  },
	
	  /**
	   * Returns the current URL path without the query string.
	   */
	  getPathname: function getPathname() {
	    return this.context.router.getCurrentPathname();
	  },
	
	  /**
	   * Returns an object of the URL params that are currently active.
	   */
	  getParams: function getParams() {
	    return this.context.router.getCurrentParams();
	  },
	
	  /**
	   * Returns an object of the query params that are currently active.
	   */
	  getQuery: function getQuery() {
	    return this.context.router.getCurrentQuery();
	  },
	
	  /**
	   * Returns an array of the routes that are currently active.
	   */
	  getRoutes: function getRoutes() {
	    return this.context.router.getCurrentRoutes();
	  },
	
	  /**
	   * A helper method to determine if a given route, params, and query
	   * are active.
	   */
	  isActive: function isActive(to, params, query) {
	    return this.context.router.isActive(to, params, query);
	  }
	
	};
	
	module.exports = State;

/***/ },
/* 390 */
/***/ function(module, exports, __webpack_require__) {

	/* jshint -W058 */
	
	'use strict';
	
	var Cancellation = __webpack_require__(130);
	var Redirect = __webpack_require__(131);
	
	/**
	 * Encapsulates a transition to a given path.
	 *
	 * The willTransitionTo and willTransitionFrom handlers receive
	 * an instance of this class as their first argument.
	 */
	function Transition(path, retry) {
	  this.path = path;
	  this.abortReason = null;
	  // TODO: Change this to router.retryTransition(transition)
	  this.retry = retry.bind(this);
	}
	
	Transition.prototype.abort = function (reason) {
	  if (this.abortReason == null) this.abortReason = reason || 'ABORT';
	};
	
	Transition.prototype.redirect = function (to, params, query) {
	  this.abort(new Redirect(to, params, query));
	};
	
	Transition.prototype.cancel = function () {
	  this.abort(new Cancellation());
	};
	
	Transition.from = function (transition, routes, components, callback) {
	  routes.reduce(function (callback, route, index) {
	    return function (error) {
	      if (error || transition.abortReason) {
	        callback(error);
	      } else if (route.onLeave) {
	        try {
	          route.onLeave(transition, components[index], callback);
	
	          // If there is no callback in the argument list, call it automatically.
	          if (route.onLeave.length < 3) callback();
	        } catch (e) {
	          callback(e);
	        }
	      } else {
	        callback();
	      }
	    };
	  }, callback)();
	};
	
	Transition.to = function (transition, routes, params, query, callback) {
	  routes.reduceRight(function (callback, route) {
	    return function (error) {
	      if (error || transition.abortReason) {
	        callback(error);
	      } else if (route.onEnter) {
	        try {
	          route.onEnter(transition, params, query, callback);
	
	          // If there is no callback in the argument list, call it automatically.
	          if (route.onEnter.length < 4) callback();
	        } catch (e) {
	          callback(e);
	        }
	      } else {
	        callback();
	      }
	    };
	  }, callback)();
	};
	
	module.exports = Transition;

/***/ },
/* 391 */
/***/ function(module, exports) {

	/**
	 * A scroll behavior that always scrolls to the top of the page
	 * after a transition.
	 */
	"use strict";
	
	var ScrollToTopBehavior = {
	
	  updateScrollPosition: function updateScrollPosition() {
	    window.scrollTo(0, 0);
	  }
	
	};
	
	module.exports = ScrollToTopBehavior;

/***/ },
/* 392 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _classCallCheck = function (instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _inherits = function (subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) subClass.__proto__ = superClass; };
	
	/**
	 * This component is necessary to get around a context warning
	 * present in React 0.13.0. It sovles this by providing a separation
	 * between the "owner" and "parent" contexts.
	 */
	
	var React = __webpack_require__(1);
	
	var ContextWrapper = (function (_React$Component) {
	  function ContextWrapper() {
	    _classCallCheck(this, ContextWrapper);
	
	    if (_React$Component != null) {
	      _React$Component.apply(this, arguments);
	    }
	  }
	
	  _inherits(ContextWrapper, _React$Component);
	
	  _createClass(ContextWrapper, [{
	    key: 'render',
	    value: function render() {
	      return this.props.children;
	    }
	  }]);
	
	  return ContextWrapper;
	})(React.Component);
	
	module.exports = ContextWrapper;

/***/ },
/* 393 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _classCallCheck = function (instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _inherits = function (subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) subClass.__proto__ = superClass; };
	
	var React = __webpack_require__(1);
	var assign = __webpack_require__(5);
	var PropTypes = __webpack_require__(16);
	
	function isLeftClickEvent(event) {
	  return event.button === 0;
	}
	
	function isModifiedEvent(event) {
	  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
	}
	
	/**
	 * <Link> components are used to create an <a> element that links to a route.
	 * When that route is active, the link gets an "active" class name (or the
	 * value of its `activeClassName` prop).
	 *
	 * For example, assuming you have the following route:
	 *
	 *   <Route name="showPost" path="/posts/:postID" handler={Post}/>
	 *
	 * You could use the following component to link to that route:
	 *
	 *   <Link to="showPost" params={{ postID: "123" }} />
	 *
	 * In addition to params, links may pass along query string parameters
	 * using the `query` prop.
	 *
	 *   <Link to="showPost" params={{ postID: "123" }} query={{ show:true }}/>
	 */
	
	var Link = (function (_React$Component) {
	  function Link() {
	    _classCallCheck(this, Link);
	
	    if (_React$Component != null) {
	      _React$Component.apply(this, arguments);
	    }
	  }
	
	  _inherits(Link, _React$Component);
	
	  _createClass(Link, [{
	    key: 'handleClick',
	    value: function handleClick(event) {
	      var allowTransition = true;
	      var clickResult;
	
	      if (this.props.onClick) clickResult = this.props.onClick(event);
	
	      if (isModifiedEvent(event) || !isLeftClickEvent(event)) {
	        return;
	      }if (clickResult === false || event.defaultPrevented === true) allowTransition = false;
	
	      event.preventDefault();
	
	      if (allowTransition) this.context.router.transitionTo(this.props.to, this.props.params, this.props.query);
	    }
	  }, {
	    key: 'getHref',
	
	    /**
	     * Returns the value of the "href" attribute to use on the DOM element.
	     */
	    value: function getHref() {
	      return this.context.router.makeHref(this.props.to, this.props.params, this.props.query);
	    }
	  }, {
	    key: 'getClassName',
	
	    /**
	     * Returns the value of the "class" attribute to use on the DOM element, which contains
	     * the value of the activeClassName property when this <Link> is active.
	     */
	    value: function getClassName() {
	      var className = this.props.className;
	
	      if (this.getActiveState()) className += ' ' + this.props.activeClassName;
	
	      return className;
	    }
	  }, {
	    key: 'getActiveState',
	    value: function getActiveState() {
	      return this.context.router.isActive(this.props.to, this.props.params, this.props.query);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var props = assign({}, this.props, {
	        href: this.getHref(),
	        className: this.getClassName(),
	        onClick: this.handleClick.bind(this)
	      });
	
	      if (props.activeStyle && this.getActiveState()) props.style = props.activeStyle;
	
	      return React.DOM.a(props, this.props.children);
	    }
	  }]);
	
	  return Link;
	})(React.Component);
	
	// TODO: Include these in the above class definition
	// once we can use ES7 property initializers.
	// https://github.com/babel/babel/issues/619
	
	Link.contextTypes = {
	  router: PropTypes.router.isRequired
	};
	
	Link.propTypes = {
	  activeClassName: PropTypes.string.isRequired,
	  to: PropTypes.oneOfType([PropTypes.string, PropTypes.route]).isRequired,
	  params: PropTypes.object,
	  query: PropTypes.object,
	  activeStyle: PropTypes.object,
	  onClick: PropTypes.func
	};
	
	Link.defaultProps = {
	  activeClassName: 'active',
	  className: ''
	};
	
	module.exports = Link;

/***/ },
/* 394 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var invariant = __webpack_require__(2);
	var canUseDOM = __webpack_require__(8).canUseDOM;
	
	/**
	 * Returns the current scroll position of the window as { x, y }.
	 */
	function getWindowScrollPosition() {
	  invariant(canUseDOM, 'Cannot get current scroll position without a DOM');
	
	  return {
	    x: window.pageXOffset || document.documentElement.scrollLeft,
	    y: window.pageYOffset || document.documentElement.scrollTop
	  };
	}
	
	module.exports = getWindowScrollPosition;

/***/ },
/* 395 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.DefaultRoute = __webpack_require__(133);
	exports.Link = __webpack_require__(393);
	exports.NotFoundRoute = __webpack_require__(134);
	exports.Redirect = __webpack_require__(135);
	exports.Route = __webpack_require__(57);
	exports.ActiveHandler = __webpack_require__(58);
	exports.RouteHandler = exports.ActiveHandler;
	
	exports.HashLocation = __webpack_require__(138);
	exports.HistoryLocation = __webpack_require__(81);
	exports.RefreshLocation = __webpack_require__(139);
	exports.StaticLocation = __webpack_require__(140);
	exports.TestLocation = __webpack_require__(397);
	
	exports.ImitateBrowserBehavior = __webpack_require__(132);
	exports.ScrollToTopBehavior = __webpack_require__(391);
	
	exports.History = __webpack_require__(32);
	exports.Navigation = __webpack_require__(387);
	exports.State = __webpack_require__(389);
	
	exports.createRoute = __webpack_require__(26).createRoute;
	exports.createDefaultRoute = __webpack_require__(26).createDefaultRoute;
	exports.createNotFoundRoute = __webpack_require__(26).createNotFoundRoute;
	exports.createRedirect = __webpack_require__(26).createRedirect;
	exports.createRoutesFromReactChildren = __webpack_require__(137);
	
	exports.create = __webpack_require__(136);
	exports.run = __webpack_require__(398);

/***/ },
/* 396 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(1);
	
	function isValidChild(object) {
	  return object == null || React.isValidElement(object);
	}
	
	function isReactChildren(object) {
	  return isValidChild(object) || Array.isArray(object) && object.every(isValidChild);
	}
	
	module.exports = isReactChildren;

/***/ },
/* 397 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _classCallCheck = function (instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var invariant = __webpack_require__(2);
	var LocationActions = __webpack_require__(42);
	var History = __webpack_require__(32);
	
	/**
	 * A location that is convenient for testing and does not require a DOM.
	 */
	
	var TestLocation = (function () {
	  function TestLocation(history) {
	    _classCallCheck(this, TestLocation);
	
	    this.history = history || [];
	    this.listeners = [];
	    this._updateHistoryLength();
	  }
	
	  _createClass(TestLocation, [{
	    key: 'needsDOM',
	    get: function () {
	      return false;
	    }
	  }, {
	    key: '_updateHistoryLength',
	    value: function _updateHistoryLength() {
	      History.length = this.history.length;
	    }
	  }, {
	    key: '_notifyChange',
	    value: function _notifyChange(type) {
	      var change = {
	        path: this.getCurrentPath(),
	        type: type
	      };
	
	      for (var i = 0, len = this.listeners.length; i < len; ++i) this.listeners[i].call(this, change);
	    }
	  }, {
	    key: 'addChangeListener',
	    value: function addChangeListener(listener) {
	      this.listeners.push(listener);
	    }
	  }, {
	    key: 'removeChangeListener',
	    value: function removeChangeListener(listener) {
	      this.listeners = this.listeners.filter(function (l) {
	        return l !== listener;
	      });
	    }
	  }, {
	    key: 'push',
	    value: function push(path) {
	      this.history.push(path);
	      this._updateHistoryLength();
	      this._notifyChange(LocationActions.PUSH);
	    }
	  }, {
	    key: 'replace',
	    value: function replace(path) {
	      invariant(this.history.length, 'You cannot replace the current path with no history');
	
	      this.history[this.history.length - 1] = path;
	
	      this._notifyChange(LocationActions.REPLACE);
	    }
	  }, {
	    key: 'pop',
	    value: function pop() {
	      this.history.pop();
	      this._updateHistoryLength();
	      this._notifyChange(LocationActions.POP);
	    }
	  }, {
	    key: 'getCurrentPath',
	    value: function getCurrentPath() {
	      return this.history[this.history.length - 1];
	    }
	  }, {
	    key: 'toString',
	    value: function toString() {
	      return '<TestLocation>';
	    }
	  }]);
	
	  return TestLocation;
	})();
	
	module.exports = TestLocation;

/***/ },
/* 398 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var createRouter = __webpack_require__(136);
	
	/**
	 * A high-level convenience method that creates, configures, and
	 * runs a router in one shot. The method signature is:
	 *
	 *   Router.run(routes[, location ], callback);
	 *
	 * Using `window.location.hash` to manage the URL, you could do:
	 *
	 *   Router.run(routes, function (Handler) {
	 *     React.render(<Handler/>, document.body);
	 *   });
	 * 
	 * Using HTML5 history and a custom "cursor" prop:
	 * 
	 *   Router.run(routes, Router.HistoryLocation, function (Handler) {
	 *     React.render(<Handler cursor={cursor}/>, document.body);
	 *   });
	 *
	 * Returns the newly created router.
	 *
	 * Note: If you need to specify further options for your router such
	 * as error/abort handling or custom scroll behavior, use Router.create
	 * instead.
	 *
	 *   var router = Router.create(options);
	 *   router.run(function (Handler) {
	 *     // ...
	 *   });
	 */
	function runRouter(routes, location, callback) {
	  if (typeof location === 'function') {
	    callback = location;
	    location = null;
	  }
	
	  var router = createRouter({
	    routes: routes,
	    location: location
	  });
	
	  router.run(callback);
	
	  return router;
	}
	
	module.exports = runRouter;

/***/ },
/* 399 */
/***/ function(module, exports) {

	'use strict';
	
	function supportsHistory() {
	  /*! taken from modernizr
	   * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
	   * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
	   * changed to avoid false negatives for Windows Phones: https://github.com/rackt/react-router/issues/586
	   */
	  var ua = navigator.userAgent;
	  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) {
	    return false;
	  }
	  return window.history && 'pushState' in window.history;
	}
	
	module.exports = supportsHistory;

/***/ },
/* 400 */
/***/ function(module, exports) {

	'use strict';
	
	function ToObject(val) {
		if (val == null) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	module.exports = Object.assign || function (target, source) {
		var from;
		var keys;
		var to = ToObject(target);
	
		for (var s = 1; s < arguments.length; s++) {
			from = arguments[s];
			keys = Object.keys(Object(from));
	
			for (var i = 0; i < keys.length; i++) {
				to[keys[i]] = from[keys[i]];
			}
		}
	
		return to;
	};


/***/ },
/* 401 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(402);


/***/ },
/* 402 */
/***/ function(module, exports, __webpack_require__) {

	// Load modules
	
	var Stringify = __webpack_require__(404);
	var Parse = __webpack_require__(403);
	
	
	// Declare internals
	
	var internals = {};
	
	
	module.exports = {
	    stringify: Stringify,
	    parse: Parse
	};


/***/ },
/* 403 */
/***/ function(module, exports, __webpack_require__) {

	// Load modules
	
	var Utils = __webpack_require__(141);
	
	
	// Declare internals
	
	var internals = {
	    delimiter: '&',
	    depth: 5,
	    arrayLimit: 20,
	    parameterLimit: 1000
	};
	
	
	internals.parseValues = function (str, options) {
	
	    var obj = {};
	    var parts = str.split(options.delimiter, options.parameterLimit === Infinity ? undefined : options.parameterLimit);
	
	    for (var i = 0, il = parts.length; i < il; ++i) {
	        var part = parts[i];
	        var pos = part.indexOf(']=') === -1 ? part.indexOf('=') : part.indexOf(']=') + 1;
	
	        if (pos === -1) {
	            obj[Utils.decode(part)] = '';
	        }
	        else {
	            var key = Utils.decode(part.slice(0, pos));
	            var val = Utils.decode(part.slice(pos + 1));
	
	            if (Object.prototype.hasOwnProperty(key)) {
	                continue;
	            }
	
	            if (!obj.hasOwnProperty(key)) {
	                obj[key] = val;
	            }
	            else {
	                obj[key] = [].concat(obj[key]).concat(val);
	            }
	        }
	    }
	
	    return obj;
	};
	
	
	internals.parseObject = function (chain, val, options) {
	
	    if (!chain.length) {
	        return val;
	    }
	
	    var root = chain.shift();
	
	    var obj = {};
	    if (root === '[]') {
	        obj = [];
	        obj = obj.concat(internals.parseObject(chain, val, options));
	    }
	    else {
	        var cleanRoot = root[0] === '[' && root[root.length - 1] === ']' ? root.slice(1, root.length - 1) : root;
	        var index = parseInt(cleanRoot, 10);
	        var indexString = '' + index;
	        if (!isNaN(index) &&
	            root !== cleanRoot &&
	            indexString === cleanRoot &&
	            index >= 0 &&
	            index <= options.arrayLimit) {
	
	            obj = [];
	            obj[index] = internals.parseObject(chain, val, options);
	        }
	        else {
	            obj[cleanRoot] = internals.parseObject(chain, val, options);
	        }
	    }
	
	    return obj;
	};
	
	
	internals.parseKeys = function (key, val, options) {
	
	    if (!key) {
	        return;
	    }
	
	    // The regex chunks
	
	    var parent = /^([^\[\]]*)/;
	    var child = /(\[[^\[\]]*\])/g;
	
	    // Get the parent
	
	    var segment = parent.exec(key);
	
	    // Don't allow them to overwrite object prototype properties
	
	    if (Object.prototype.hasOwnProperty(segment[1])) {
	        return;
	    }
	
	    // Stash the parent if it exists
	
	    var keys = [];
	    if (segment[1]) {
	        keys.push(segment[1]);
	    }
	
	    // Loop through children appending to the array until we hit depth
	
	    var i = 0;
	    while ((segment = child.exec(key)) !== null && i < options.depth) {
	
	        ++i;
	        if (!Object.prototype.hasOwnProperty(segment[1].replace(/\[|\]/g, ''))) {
	            keys.push(segment[1]);
	        }
	    }
	
	    // If there's a remainder, just add whatever is left
	
	    if (segment) {
	        keys.push('[' + key.slice(segment.index) + ']');
	    }
	
	    return internals.parseObject(keys, val, options);
	};
	
	
	module.exports = function (str, options) {
	
	    if (str === '' ||
	        str === null ||
	        typeof str === 'undefined') {
	
	        return {};
	    }
	
	    options = options || {};
	    options.delimiter = typeof options.delimiter === 'string' || Utils.isRegExp(options.delimiter) ? options.delimiter : internals.delimiter;
	    options.depth = typeof options.depth === 'number' ? options.depth : internals.depth;
	    options.arrayLimit = typeof options.arrayLimit === 'number' ? options.arrayLimit : internals.arrayLimit;
	    options.parameterLimit = typeof options.parameterLimit === 'number' ? options.parameterLimit : internals.parameterLimit;
	
	    var tempObj = typeof str === 'string' ? internals.parseValues(str, options) : str;
	    var obj = {};
	
	    // Iterate over the keys and setup the new object
	
	    var keys = Object.keys(tempObj);
	    for (var i = 0, il = keys.length; i < il; ++i) {
	        var key = keys[i];
	        var newObj = internals.parseKeys(key, tempObj[key], options);
	        obj = Utils.merge(obj, newObj);
	    }
	
	    return Utils.compact(obj);
	};


/***/ },
/* 404 */
/***/ function(module, exports, __webpack_require__) {

	// Load modules
	
	var Utils = __webpack_require__(141);
	
	
	// Declare internals
	
	var internals = {
	    delimiter: '&',
	    arrayPrefixGenerators: {
	        brackets: function (prefix, key) {
	            return prefix + '[]';
	        },
	        indices: function (prefix, key) {
	            return prefix + '[' + key + ']';
	        },
	        repeat: function (prefix, key) {
	            return prefix;
	        }
	    }
	};
	
	
	internals.stringify = function (obj, prefix, generateArrayPrefix) {
	
	    if (Utils.isBuffer(obj)) {
	        obj = obj.toString();
	    }
	    else if (obj instanceof Date) {
	        obj = obj.toISOString();
	    }
	    else if (obj === null) {
	        obj = '';
	    }
	
	    if (typeof obj === 'string' ||
	        typeof obj === 'number' ||
	        typeof obj === 'boolean') {
	
	        return [encodeURIComponent(prefix) + '=' + encodeURIComponent(obj)];
	    }
	
	    var values = [];
	
	    if (typeof obj === 'undefined') {
	        return values;
	    }
	
	    var objKeys = Object.keys(obj);
	    for (var i = 0, il = objKeys.length; i < il; ++i) {
	        var key = objKeys[i];
	        if (Array.isArray(obj)) {
	            values = values.concat(internals.stringify(obj[key], generateArrayPrefix(prefix, key), generateArrayPrefix));
	        }
	        else {
	            values = values.concat(internals.stringify(obj[key], prefix + '[' + key + ']', generateArrayPrefix));
	        }
	    }
	
	    return values;
	};
	
	
	module.exports = function (obj, options) {
	
	    options = options || {};
	    var delimiter = typeof options.delimiter === 'undefined' ? internals.delimiter : options.delimiter;
	
	    var keys = [];
	
	    if (typeof obj !== 'object' ||
	        obj === null) {
	
	        return '';
	    }
	
	    var arrayFormat;
	    if (options.arrayFormat in internals.arrayPrefixGenerators) {
	        arrayFormat = options.arrayFormat;
	    }
	    else if ('indices' in options) {
	        arrayFormat = options.indices ? 'indices' : 'repeat';
	    }
	    else {
	        arrayFormat = 'indices';
	    }
	
	    var generateArrayPrefix = internals.arrayPrefixGenerators[arrayFormat];
	
	    var objKeys = Object.keys(obj);
	    for (var i = 0, il = objKeys.length; i < il; ++i) {
	        var key = objKeys[i];
	        keys = keys.concat(internals.stringify(obj[key], key, generateArrayPrefix));
	    }
	
	    return keys.join(delimiter);
	};


/***/ },
/* 405 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015 Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule BeforeInputEventPlugin
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(12);
	var EventPropagators = __webpack_require__(45);
	var ExecutionEnvironment = __webpack_require__(8);
	var FallbackCompositionState = __webpack_require__(413);
	var SyntheticCompositionEvent = __webpack_require__(447);
	var SyntheticInputEvent = __webpack_require__(450);
	
	var keyOf = __webpack_require__(21);
	
	var END_KEYCODES = [9, 13, 27, 32]; // Tab, Return, Esc, Space
	var START_KEYCODE = 229;
	
	var canUseCompositionEvent = (
	  ExecutionEnvironment.canUseDOM &&
	  'CompositionEvent' in window
	);
	
	var documentMode = null;
	if (ExecutionEnvironment.canUseDOM && 'documentMode' in document) {
	  documentMode = document.documentMode;
	}
	
	// Webkit offers a very useful `textInput` event that can be used to
	// directly represent `beforeInput`. The IE `textinput` event is not as
	// useful, so we don't use it.
	var canUseTextInputEvent = (
	  ExecutionEnvironment.canUseDOM &&
	  'TextEvent' in window &&
	  !documentMode &&
	  !isPresto()
	);
	
	// In IE9+, we have access to composition events, but the data supplied
	// by the native compositionend event may be incorrect. Japanese ideographic
	// spaces, for instance (\u3000) are not recorded correctly.
	var useFallbackCompositionData = (
	  ExecutionEnvironment.canUseDOM &&
	  (
	    (!canUseCompositionEvent || documentMode && documentMode > 8 && documentMode <= 11)
	  )
	);
	
	/**
	 * Opera <= 12 includes TextEvent in window, but does not fire
	 * text input events. Rely on keypress instead.
	 */
	function isPresto() {
	  var opera = window.opera;
	  return (
	    typeof opera === 'object' &&
	    typeof opera.version === 'function' &&
	    parseInt(opera.version(), 10) <= 12
	  );
	}
	
	var SPACEBAR_CODE = 32;
	var SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE);
	
	var topLevelTypes = EventConstants.topLevelTypes;
	
	// Events and their corresponding property names.
	var eventTypes = {
	  beforeInput: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onBeforeInput: null}),
	      captured: keyOf({onBeforeInputCapture: null})
	    },
	    dependencies: [
	      topLevelTypes.topCompositionEnd,
	      topLevelTypes.topKeyPress,
	      topLevelTypes.topTextInput,
	      topLevelTypes.topPaste
	    ]
	  },
	  compositionEnd: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onCompositionEnd: null}),
	      captured: keyOf({onCompositionEndCapture: null})
	    },
	    dependencies: [
	      topLevelTypes.topBlur,
	      topLevelTypes.topCompositionEnd,
	      topLevelTypes.topKeyDown,
	      topLevelTypes.topKeyPress,
	      topLevelTypes.topKeyUp,
	      topLevelTypes.topMouseDown
	    ]
	  },
	  compositionStart: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onCompositionStart: null}),
	      captured: keyOf({onCompositionStartCapture: null})
	    },
	    dependencies: [
	      topLevelTypes.topBlur,
	      topLevelTypes.topCompositionStart,
	      topLevelTypes.topKeyDown,
	      topLevelTypes.topKeyPress,
	      topLevelTypes.topKeyUp,
	      topLevelTypes.topMouseDown
	    ]
	  },
	  compositionUpdate: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onCompositionUpdate: null}),
	      captured: keyOf({onCompositionUpdateCapture: null})
	    },
	    dependencies: [
	      topLevelTypes.topBlur,
	      topLevelTypes.topCompositionUpdate,
	      topLevelTypes.topKeyDown,
	      topLevelTypes.topKeyPress,
	      topLevelTypes.topKeyUp,
	      topLevelTypes.topMouseDown
	    ]
	  }
	};
	
	// Track whether we've ever handled a keypress on the space key.
	var hasSpaceKeypress = false;
	
	/**
	 * Return whether a native keypress event is assumed to be a command.
	 * This is required because Firefox fires `keypress` events for key commands
	 * (cut, copy, select-all, etc.) even though no character is inserted.
	 */
	function isKeypressCommand(nativeEvent) {
	  return (
	    (nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) &&
	    // ctrlKey && altKey is equivalent to AltGr, and is not a command.
	    !(nativeEvent.ctrlKey && nativeEvent.altKey)
	  );
	}
	
	
	/**
	 * Translate native top level events into event types.
	 *
	 * @param {string} topLevelType
	 * @return {object}
	 */
	function getCompositionEventType(topLevelType) {
	  switch (topLevelType) {
	    case topLevelTypes.topCompositionStart:
	      return eventTypes.compositionStart;
	    case topLevelTypes.topCompositionEnd:
	      return eventTypes.compositionEnd;
	    case topLevelTypes.topCompositionUpdate:
	      return eventTypes.compositionUpdate;
	  }
	}
	
	/**
	 * Does our fallback best-guess model think this event signifies that
	 * composition has begun?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionStart(topLevelType, nativeEvent) {
	  return (
	    topLevelType === topLevelTypes.topKeyDown &&
	    nativeEvent.keyCode === START_KEYCODE
	  );
	}
	
	/**
	 * Does our fallback mode think that this event is the end of composition?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionEnd(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case topLevelTypes.topKeyUp:
	      // Command keys insert or clear IME input.
	      return (END_KEYCODES.indexOf(nativeEvent.keyCode) !== -1);
	    case topLevelTypes.topKeyDown:
	      // Expect IME keyCode on each keydown. If we get any other
	      // code we must have exited earlier.
	      return (nativeEvent.keyCode !== START_KEYCODE);
	    case topLevelTypes.topKeyPress:
	    case topLevelTypes.topMouseDown:
	    case topLevelTypes.topBlur:
	      // Events are not possible without cancelling IME.
	      return true;
	    default:
	      return false;
	  }
	}
	
	/**
	 * Google Input Tools provides composition data via a CustomEvent,
	 * with the `data` property populated in the `detail` object. If this
	 * is available on the event object, use it. If not, this is a plain
	 * composition event and we have nothing special to extract.
	 *
	 * @param {object} nativeEvent
	 * @return {?string}
	 */
	function getDataFromCustomEvent(nativeEvent) {
	  var detail = nativeEvent.detail;
	  if (typeof detail === 'object' && 'data' in detail) {
	    return detail.data;
	  }
	  return null;
	}
	
	// Track the current IME composition fallback object, if any.
	var currentComposition = null;
	
	/**
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {DOMEventTarget} topLevelTarget The listening component root node.
	 * @param {string} topLevelTargetID ID of `topLevelTarget`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?object} A SyntheticCompositionEvent.
	 */
	function extractCompositionEvent(
	  topLevelType,
	  topLevelTarget,
	  topLevelTargetID,
	  nativeEvent
	) {
	  var eventType;
	  var fallbackData;
	
	  if (canUseCompositionEvent) {
	    eventType = getCompositionEventType(topLevelType);
	  } else if (!currentComposition) {
	    if (isFallbackCompositionStart(topLevelType, nativeEvent)) {
	      eventType = eventTypes.compositionStart;
	    }
	  } else if (isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	    eventType = eventTypes.compositionEnd;
	  }
	
	  if (!eventType) {
	    return null;
	  }
	
	  if (useFallbackCompositionData) {
	    // The current composition is stored statically and must not be
	    // overwritten while composition continues.
	    if (!currentComposition && eventType === eventTypes.compositionStart) {
	      currentComposition = FallbackCompositionState.getPooled(topLevelTarget);
	    } else if (eventType === eventTypes.compositionEnd) {
	      if (currentComposition) {
	        fallbackData = currentComposition.getData();
	      }
	    }
	  }
	
	  var event = SyntheticCompositionEvent.getPooled(
	    eventType,
	    topLevelTargetID,
	    nativeEvent
	  );
	
	  if (fallbackData) {
	    // Inject data generated from fallback path into the synthetic event.
	    // This matches the property of native CompositionEventInterface.
	    event.data = fallbackData;
	  } else {
	    var customData = getDataFromCustomEvent(nativeEvent);
	    if (customData !== null) {
	      event.data = customData;
	    }
	  }
	
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The string corresponding to this `beforeInput` event.
	 */
	function getNativeBeforeInputChars(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case topLevelTypes.topCompositionEnd:
	      return getDataFromCustomEvent(nativeEvent);
	    case topLevelTypes.topKeyPress:
	      /**
	       * If native `textInput` events are available, our goal is to make
	       * use of them. However, there is a special case: the spacebar key.
	       * In Webkit, preventing default on a spacebar `textInput` event
	       * cancels character insertion, but it *also* causes the browser
	       * to fall back to its default spacebar behavior of scrolling the
	       * page.
	       *
	       * Tracking at:
	       * https://code.google.com/p/chromium/issues/detail?id=355103
	       *
	       * To avoid this issue, use the keypress event as if no `textInput`
	       * event is available.
	       */
	      var which = nativeEvent.which;
	      if (which !== SPACEBAR_CODE) {
	        return null;
	      }
	
	      hasSpaceKeypress = true;
	      return SPACEBAR_CHAR;
	
	    case topLevelTypes.topTextInput:
	      // Record the characters to be added to the DOM.
	      var chars = nativeEvent.data;
	
	      // If it's a spacebar character, assume that we have already handled
	      // it at the keypress level and bail immediately. Android Chrome
	      // doesn't give us keycodes, so we need to blacklist it.
	      if (chars === SPACEBAR_CHAR && hasSpaceKeypress) {
	        return null;
	      }
	
	      return chars;
	
	    default:
	      // For other native event types, do nothing.
	      return null;
	  }
	}
	
	/**
	 * For browsers that do not provide the `textInput` event, extract the
	 * appropriate string to use for SyntheticInputEvent.
	 *
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The fallback string for this `beforeInput` event.
	 */
	function getFallbackBeforeInputChars(topLevelType, nativeEvent) {
	  // If we are currently composing (IME) and using a fallback to do so,
	  // try to extract the composed characters from the fallback object.
	  if (currentComposition) {
	    if (
	      topLevelType === topLevelTypes.topCompositionEnd ||
	      isFallbackCompositionEnd(topLevelType, nativeEvent)
	    ) {
	      var chars = currentComposition.getData();
	      FallbackCompositionState.release(currentComposition);
	      currentComposition = null;
	      return chars;
	    }
	    return null;
	  }
	
	  switch (topLevelType) {
	    case topLevelTypes.topPaste:
	      // If a paste event occurs after a keypress, throw out the input
	      // chars. Paste events should not lead to BeforeInput events.
	      return null;
	    case topLevelTypes.topKeyPress:
	      /**
	       * As of v27, Firefox may fire keypress events even when no character
	       * will be inserted. A few possibilities:
	       *
	       * - `which` is `0`. Arrow keys, Esc key, etc.
	       *
	       * - `which` is the pressed key code, but no char is available.
	       *   Ex: 'AltGr + d` in Polish. There is no modified character for
	       *   this key combination and no character is inserted into the
	       *   document, but FF fires the keypress for char code `100` anyway.
	       *   No `input` event will occur.
	       *
	       * - `which` is the pressed key code, but a command combination is
	       *   being used. Ex: `Cmd+C`. No character is inserted, and no
	       *   `input` event will occur.
	       */
	      if (nativeEvent.which && !isKeypressCommand(nativeEvent)) {
	        return String.fromCharCode(nativeEvent.which);
	      }
	      return null;
	    case topLevelTypes.topCompositionEnd:
	      return useFallbackCompositionData ? null : nativeEvent.data;
	    default:
	      return null;
	  }
	}
	
	/**
	 * Extract a SyntheticInputEvent for `beforeInput`, based on either native
	 * `textInput` or fallback behavior.
	 *
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {DOMEventTarget} topLevelTarget The listening component root node.
	 * @param {string} topLevelTargetID ID of `topLevelTarget`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?object} A SyntheticInputEvent.
	 */
	function extractBeforeInputEvent(
	  topLevelType,
	  topLevelTarget,
	  topLevelTargetID,
	  nativeEvent
	) {
	  var chars;
	
	  if (canUseTextInputEvent) {
	    chars = getNativeBeforeInputChars(topLevelType, nativeEvent);
	  } else {
	    chars = getFallbackBeforeInputChars(topLevelType, nativeEvent);
	  }
	
	  // If no characters are being inserted, no BeforeInput event should
	  // be fired.
	  if (!chars) {
	    return null;
	  }
	
	  var event = SyntheticInputEvent.getPooled(
	    eventTypes.beforeInput,
	    topLevelTargetID,
	    nativeEvent
	  );
	
	  event.data = chars;
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * Create an `onBeforeInput` event to match
	 * http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105/#events-inputevents.
	 *
	 * This event plugin is based on the native `textInput` event
	 * available in Chrome, Safari, Opera, and IE. This event fires after
	 * `onKeyPress` and `onCompositionEnd`, but before `onInput`.
	 *
	 * `beforeInput` is spec'd but not implemented in any browsers, and
	 * the `input` event does not provide any useful information about what has
	 * actually been added, contrary to the spec. Thus, `textInput` is the best
	 * available event to identify the characters that have actually been inserted
	 * into the target node.
	 *
	 * This plugin is also responsible for emitting `composition` events, thus
	 * allowing us to share composition fallback code for both `beforeInput` and
	 * `composition` event types.
	 */
	var BeforeInputEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  /**
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {DOMEventTarget} topLevelTarget The listening component root node.
	   * @param {string} topLevelTargetID ID of `topLevelTarget`.
	   * @param {object} nativeEvent Native browser event.
	   * @return {*} An accumulation of synthetic events.
	   * @see {EventPluginHub.extractEvents}
	   */
	  extractEvents: function(
	    topLevelType,
	    topLevelTarget,
	    topLevelTargetID,
	    nativeEvent
	  ) {
	    return [
	      extractCompositionEvent(
	        topLevelType,
	        topLevelTarget,
	        topLevelTargetID,
	        nativeEvent
	      ),
	      extractBeforeInputEvent(
	        topLevelType,
	        topLevelTarget,
	        topLevelTargetID,
	        nativeEvent
	      )
	    ];
	  }
	};
	
	module.exports = BeforeInputEventPlugin;


/***/ },
/* 406 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ChangeEventPlugin
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(12);
	var EventPluginHub = __webpack_require__(44);
	var EventPropagators = __webpack_require__(45);
	var ExecutionEnvironment = __webpack_require__(8);
	var ReactUpdates = __webpack_require__(14);
	var SyntheticEvent = __webpack_require__(28);
	
	var isEventSupported = __webpack_require__(100);
	var isTextInputElement = __webpack_require__(163);
	var keyOf = __webpack_require__(21);
	
	var topLevelTypes = EventConstants.topLevelTypes;
	
	var eventTypes = {
	  change: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onChange: null}),
	      captured: keyOf({onChangeCapture: null})
	    },
	    dependencies: [
	      topLevelTypes.topBlur,
	      topLevelTypes.topChange,
	      topLevelTypes.topClick,
	      topLevelTypes.topFocus,
	      topLevelTypes.topInput,
	      topLevelTypes.topKeyDown,
	      topLevelTypes.topKeyUp,
	      topLevelTypes.topSelectionChange
	    ]
	  }
	};
	
	/**
	 * For IE shims
	 */
	var activeElement = null;
	var activeElementID = null;
	var activeElementValue = null;
	var activeElementValueProp = null;
	
	/**
	 * SECTION: handle `change` event
	 */
	function shouldUseChangeEvent(elem) {
	  return (
	    elem.nodeName === 'SELECT' ||
	    (elem.nodeName === 'INPUT' && elem.type === 'file')
	  );
	}
	
	var doesChangeEventBubble = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // See `handleChange` comment below
	  doesChangeEventBubble = isEventSupported('change') && (
	    (!('documentMode' in document) || document.documentMode > 8)
	  );
	}
	
	function manualDispatchChangeEvent(nativeEvent) {
	  var event = SyntheticEvent.getPooled(
	    eventTypes.change,
	    activeElementID,
	    nativeEvent
	  );
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	
	  // If change and propertychange bubbled, we'd just bind to it like all the
	  // other events and have it go through ReactBrowserEventEmitter. Since it
	  // doesn't, we manually listen for the events and so we have to enqueue and
	  // process the abstract event manually.
	  //
	  // Batching is necessary here in order to ensure that all event handlers run
	  // before the next rerender (including event handlers attached to ancestor
	  // elements instead of directly on the input). Without this, controlled
	  // components don't work properly in conjunction with event bubbling because
	  // the component is rerendered and the value reverted before all the event
	  // handlers can run. See https://github.com/facebook/react/issues/708.
	  ReactUpdates.batchedUpdates(runEventInBatch, event);
	}
	
	function runEventInBatch(event) {
	  EventPluginHub.enqueueEvents(event);
	  EventPluginHub.processEventQueue();
	}
	
	function startWatchingForChangeEventIE8(target, targetID) {
	  activeElement = target;
	  activeElementID = targetID;
	  activeElement.attachEvent('onchange', manualDispatchChangeEvent);
	}
	
	function stopWatchingForChangeEventIE8() {
	  if (!activeElement) {
	    return;
	  }
	  activeElement.detachEvent('onchange', manualDispatchChangeEvent);
	  activeElement = null;
	  activeElementID = null;
	}
	
	function getTargetIDForChangeEvent(
	    topLevelType,
	    topLevelTarget,
	    topLevelTargetID) {
	  if (topLevelType === topLevelTypes.topChange) {
	    return topLevelTargetID;
	  }
	}
	function handleEventsForChangeEventIE8(
	    topLevelType,
	    topLevelTarget,
	    topLevelTargetID) {
	  if (topLevelType === topLevelTypes.topFocus) {
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForChangeEventIE8();
	    startWatchingForChangeEventIE8(topLevelTarget, topLevelTargetID);
	  } else if (topLevelType === topLevelTypes.topBlur) {
	    stopWatchingForChangeEventIE8();
	  }
	}
	
	
	/**
	 * SECTION: handle `input` event
	 */
	var isInputEventSupported = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // IE9 claims to support the input event but fails to trigger it when
	  // deleting text, so we ignore its input events
	  isInputEventSupported = isEventSupported('input') && (
	    (!('documentMode' in document) || document.documentMode > 9)
	  );
	}
	
	/**
	 * (For old IE.) Replacement getter/setter for the `value` property that gets
	 * set on the active element.
	 */
	var newValueProp =  {
	  get: function() {
	    return activeElementValueProp.get.call(this);
	  },
	  set: function(val) {
	    // Cast to a string so we can do equality checks.
	    activeElementValue = '' + val;
	    activeElementValueProp.set.call(this, val);
	  }
	};
	
	/**
	 * (For old IE.) Starts tracking propertychange events on the passed-in element
	 * and override the value property so that we can distinguish user events from
	 * value changes in JS.
	 */
	function startWatchingForValueChange(target, targetID) {
	  activeElement = target;
	  activeElementID = targetID;
	  activeElementValue = target.value;
	  activeElementValueProp = Object.getOwnPropertyDescriptor(
	    target.constructor.prototype,
	    'value'
	  );
	
	  Object.defineProperty(activeElement, 'value', newValueProp);
	  activeElement.attachEvent('onpropertychange', handlePropertyChange);
	}
	
	/**
	 * (For old IE.) Removes the event listeners from the currently-tracked element,
	 * if any exists.
	 */
	function stopWatchingForValueChange() {
	  if (!activeElement) {
	    return;
	  }
	
	  // delete restores the original property definition
	  delete activeElement.value;
	  activeElement.detachEvent('onpropertychange', handlePropertyChange);
	
	  activeElement = null;
	  activeElementID = null;
	  activeElementValue = null;
	  activeElementValueProp = null;
	}
	
	/**
	 * (For old IE.) Handles a propertychange event, sending a `change` event if
	 * the value of the active element has changed.
	 */
	function handlePropertyChange(nativeEvent) {
	  if (nativeEvent.propertyName !== 'value') {
	    return;
	  }
	  var value = nativeEvent.srcElement.value;
	  if (value === activeElementValue) {
	    return;
	  }
	  activeElementValue = value;
	
	  manualDispatchChangeEvent(nativeEvent);
	}
	
	/**
	 * If a `change` event should be fired, returns the target's ID.
	 */
	function getTargetIDForInputEvent(
	    topLevelType,
	    topLevelTarget,
	    topLevelTargetID) {
	  if (topLevelType === topLevelTypes.topInput) {
	    // In modern browsers (i.e., not IE8 or IE9), the input event is exactly
	    // what we want so fall through here and trigger an abstract event
	    return topLevelTargetID;
	  }
	}
	
	// For IE8 and IE9.
	function handleEventsForInputEventIE(
	    topLevelType,
	    topLevelTarget,
	    topLevelTargetID) {
	  if (topLevelType === topLevelTypes.topFocus) {
	    // In IE8, we can capture almost all .value changes by adding a
	    // propertychange handler and looking for events with propertyName
	    // equal to 'value'
	    // In IE9, propertychange fires for most input events but is buggy and
	    // doesn't fire when text is deleted, but conveniently, selectionchange
	    // appears to fire in all of the remaining cases so we catch those and
	    // forward the event if the value has changed
	    // In either case, we don't want to call the event handler if the value
	    // is changed from JS so we redefine a setter for `.value` that updates
	    // our activeElementValue variable, allowing us to ignore those changes
	    //
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForValueChange();
	    startWatchingForValueChange(topLevelTarget, topLevelTargetID);
	  } else if (topLevelType === topLevelTypes.topBlur) {
	    stopWatchingForValueChange();
	  }
	}
	
	// For IE8 and IE9.
	function getTargetIDForInputEventIE(
	    topLevelType,
	    topLevelTarget,
	    topLevelTargetID) {
	  if (topLevelType === topLevelTypes.topSelectionChange ||
	      topLevelType === topLevelTypes.topKeyUp ||
	      topLevelType === topLevelTypes.topKeyDown) {
	    // On the selectionchange event, the target is just document which isn't
	    // helpful for us so just check activeElement instead.
	    //
	    // 99% of the time, keydown and keyup aren't necessary. IE8 fails to fire
	    // propertychange on the first input event after setting `value` from a
	    // script and fires only keydown, keypress, keyup. Catching keyup usually
	    // gets it and catching keydown lets us fire an event for the first
	    // keystroke if user does a key repeat (it'll be a little delayed: right
	    // before the second keystroke). Other input methods (e.g., paste) seem to
	    // fire selectionchange normally.
	    if (activeElement && activeElement.value !== activeElementValue) {
	      activeElementValue = activeElement.value;
	      return activeElementID;
	    }
	  }
	}
	
	
	/**
	 * SECTION: handle `click` event
	 */
	function shouldUseClickEvent(elem) {
	  // Use the `click` event to detect changes to checkbox and radio inputs.
	  // This approach works across all browsers, whereas `change` does not fire
	  // until `blur` in IE8.
	  return (
	    elem.nodeName === 'INPUT' &&
	    (elem.type === 'checkbox' || elem.type === 'radio')
	  );
	}
	
	function getTargetIDForClickEvent(
	    topLevelType,
	    topLevelTarget,
	    topLevelTargetID) {
	  if (topLevelType === topLevelTypes.topClick) {
	    return topLevelTargetID;
	  }
	}
	
	/**
	 * This plugin creates an `onChange` event that normalizes change events
	 * across form elements. This event fires at a time when it's possible to
	 * change the element's value without seeing a flicker.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - select
	 */
	var ChangeEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  /**
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {DOMEventTarget} topLevelTarget The listening component root node.
	   * @param {string} topLevelTargetID ID of `topLevelTarget`.
	   * @param {object} nativeEvent Native browser event.
	   * @return {*} An accumulation of synthetic events.
	   * @see {EventPluginHub.extractEvents}
	   */
	  extractEvents: function(
	      topLevelType,
	      topLevelTarget,
	      topLevelTargetID,
	      nativeEvent) {
	
	    var getTargetIDFunc, handleEventFunc;
	    if (shouldUseChangeEvent(topLevelTarget)) {
	      if (doesChangeEventBubble) {
	        getTargetIDFunc = getTargetIDForChangeEvent;
	      } else {
	        handleEventFunc = handleEventsForChangeEventIE8;
	      }
	    } else if (isTextInputElement(topLevelTarget)) {
	      if (isInputEventSupported) {
	        getTargetIDFunc = getTargetIDForInputEvent;
	      } else {
	        getTargetIDFunc = getTargetIDForInputEventIE;
	        handleEventFunc = handleEventsForInputEventIE;
	      }
	    } else if (shouldUseClickEvent(topLevelTarget)) {
	      getTargetIDFunc = getTargetIDForClickEvent;
	    }
	
	    if (getTargetIDFunc) {
	      var targetID = getTargetIDFunc(
	        topLevelType,
	        topLevelTarget,
	        topLevelTargetID
	      );
	      if (targetID) {
	        var event = SyntheticEvent.getPooled(
	          eventTypes.change,
	          targetID,
	          nativeEvent
	        );
	        EventPropagators.accumulateTwoPhaseDispatches(event);
	        return event;
	      }
	    }
	
	    if (handleEventFunc) {
	      handleEventFunc(
	        topLevelType,
	        topLevelTarget,
	        topLevelTargetID
	      );
	    }
	  }
	
	};
	
	module.exports = ChangeEventPlugin;


/***/ },
/* 407 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ClientReactRootIndex
	 * @typechecks
	 */
	
	'use strict';
	
	var nextReactRootIndex = 0;
	
	var ClientReactRootIndex = {
	  createReactRootIndex: function() {
	    return nextReactRootIndex++;
	  }
	};
	
	module.exports = ClientReactRootIndex;


/***/ },
/* 408 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DOMChildrenOperations
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var Danger = __webpack_require__(409);
	var ReactMultiChildUpdateTypes = __webpack_require__(150);
	
	var setTextContent = __webpack_require__(473);
	var invariant = __webpack_require__(2);
	
	/**
	 * Inserts `childNode` as a child of `parentNode` at the `index`.
	 *
	 * @param {DOMElement} parentNode Parent node in which to insert.
	 * @param {DOMElement} childNode Child node to insert.
	 * @param {number} index Index at which to insert the child.
	 * @internal
	 */
	function insertChildAt(parentNode, childNode, index) {
	  // By exploiting arrays returning `undefined` for an undefined index, we can
	  // rely exclusively on `insertBefore(node, null)` instead of also using
	  // `appendChild(node)`. However, using `undefined` is not allowed by all
	  // browsers so we must replace it with `null`.
	  parentNode.insertBefore(
	    childNode,
	    parentNode.childNodes[index] || null
	  );
	}
	
	/**
	 * Operations for updating with DOM children.
	 */
	var DOMChildrenOperations = {
	
	  dangerouslyReplaceNodeWithMarkup: Danger.dangerouslyReplaceNodeWithMarkup,
	
	  updateTextContent: setTextContent,
	
	  /**
	   * Updates a component's children by processing a series of updates. The
	   * update configurations are each expected to have a `parentNode` property.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @param {array<string>} markupList List of markup strings.
	   * @internal
	   */
	  processUpdates: function(updates, markupList) {
	    var update;
	    // Mapping from parent IDs to initial child orderings.
	    var initialChildren = null;
	    // List of children that will be moved or removed.
	    var updatedChildren = null;
	
	    for (var i = 0; i < updates.length; i++) {
	      update = updates[i];
	      if (update.type === ReactMultiChildUpdateTypes.MOVE_EXISTING ||
	          update.type === ReactMultiChildUpdateTypes.REMOVE_NODE) {
	        var updatedIndex = update.fromIndex;
	        var updatedChild = update.parentNode.childNodes[updatedIndex];
	        var parentID = update.parentID;
	
	        ( false ? invariant(
	          updatedChild,
	          'processUpdates(): Unable to find child %s of element. This ' +
	          'probably means the DOM was unexpectedly mutated (e.g., by the ' +
	          'browser), usually due to forgetting a <tbody> when using tables, ' +
	          'nesting tags like <form>, <p>, or <a>, or using non-SVG elements ' +
	          'in an <svg> parent. Try inspecting the child nodes of the element ' +
	          'with React ID `%s`.',
	          updatedIndex,
	          parentID
	        ) : invariant(updatedChild));
	
	        initialChildren = initialChildren || {};
	        initialChildren[parentID] = initialChildren[parentID] || [];
	        initialChildren[parentID][updatedIndex] = updatedChild;
	
	        updatedChildren = updatedChildren || [];
	        updatedChildren.push(updatedChild);
	      }
	    }
	
	    var renderedMarkup = Danger.dangerouslyRenderMarkup(markupList);
	
	    // Remove updated children first so that `toIndex` is consistent.
	    if (updatedChildren) {
	      for (var j = 0; j < updatedChildren.length; j++) {
	        updatedChildren[j].parentNode.removeChild(updatedChildren[j]);
	      }
	    }
	
	    for (var k = 0; k < updates.length; k++) {
	      update = updates[k];
	      switch (update.type) {
	        case ReactMultiChildUpdateTypes.INSERT_MARKUP:
	          insertChildAt(
	            update.parentNode,
	            renderedMarkup[update.markupIndex],
	            update.toIndex
	          );
	          break;
	        case ReactMultiChildUpdateTypes.MOVE_EXISTING:
	          insertChildAt(
	            update.parentNode,
	            initialChildren[update.parentID][update.fromIndex],
	            update.toIndex
	          );
	          break;
	        case ReactMultiChildUpdateTypes.TEXT_CONTENT:
	          setTextContent(
	            update.parentNode,
	            update.textContent
	          );
	          break;
	        case ReactMultiChildUpdateTypes.REMOVE_NODE:
	          // Already removed by the for-loop above.
	          break;
	      }
	    }
	  }
	
	};
	
	module.exports = DOMChildrenOperations;


/***/ },
/* 409 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule Danger
	 * @typechecks static-only
	 */
	
	/*jslint evil: true, sub: true */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(8);
	
	var createNodesFromMarkup = __webpack_require__(459);
	var emptyFunction = __webpack_require__(24);
	var getMarkupWrap = __webpack_require__(160);
	var invariant = __webpack_require__(2);
	
	var OPEN_TAG_NAME_EXP = /^(<[^ \/>]+)/;
	var RESULT_INDEX_ATTR = 'data-danger-index';
	
	/**
	 * Extracts the `nodeName` from a string of markup.
	 *
	 * NOTE: Extracting the `nodeName` does not require a regular expression match
	 * because we make assumptions about React-generated markup (i.e. there are no
	 * spaces surrounding the opening tag and there is at least one attribute).
	 *
	 * @param {string} markup String of markup.
	 * @return {string} Node name of the supplied markup.
	 * @see http://jsperf.com/extract-nodename
	 */
	function getNodeName(markup) {
	  return markup.substring(1, markup.indexOf(' '));
	}
	
	var Danger = {
	
	  /**
	   * Renders markup into an array of nodes. The markup is expected to render
	   * into a list of root nodes. Also, the length of `resultList` and
	   * `markupList` should be the same.
	   *
	   * @param {array<string>} markupList List of markup strings to render.
	   * @return {array<DOMElement>} List of rendered nodes.
	   * @internal
	   */
	  dangerouslyRenderMarkup: function(markupList) {
	    ( false ? invariant(
	      ExecutionEnvironment.canUseDOM,
	      'dangerouslyRenderMarkup(...): Cannot render markup in a worker ' +
	      'thread. Make sure `window` and `document` are available globally ' +
	      'before requiring React when unit testing or use ' +
	      'React.renderToString for server rendering.'
	    ) : invariant(ExecutionEnvironment.canUseDOM));
	    var nodeName;
	    var markupByNodeName = {};
	    // Group markup by `nodeName` if a wrap is necessary, else by '*'.
	    for (var i = 0; i < markupList.length; i++) {
	      ( false ? invariant(
	        markupList[i],
	        'dangerouslyRenderMarkup(...): Missing markup.'
	      ) : invariant(markupList[i]));
	      nodeName = getNodeName(markupList[i]);
	      nodeName = getMarkupWrap(nodeName) ? nodeName : '*';
	      markupByNodeName[nodeName] = markupByNodeName[nodeName] || [];
	      markupByNodeName[nodeName][i] = markupList[i];
	    }
	    var resultList = [];
	    var resultListAssignmentCount = 0;
	    for (nodeName in markupByNodeName) {
	      if (!markupByNodeName.hasOwnProperty(nodeName)) {
	        continue;
	      }
	      var markupListByNodeName = markupByNodeName[nodeName];
	
	      // This for-in loop skips the holes of the sparse array. The order of
	      // iteration should follow the order of assignment, which happens to match
	      // numerical index order, but we don't rely on that.
	      var resultIndex;
	      for (resultIndex in markupListByNodeName) {
	        if (markupListByNodeName.hasOwnProperty(resultIndex)) {
	          var markup = markupListByNodeName[resultIndex];
	
	          // Push the requested markup with an additional RESULT_INDEX_ATTR
	          // attribute.  If the markup does not start with a < character, it
	          // will be discarded below (with an appropriate console.error).
	          markupListByNodeName[resultIndex] = markup.replace(
	            OPEN_TAG_NAME_EXP,
	            // This index will be parsed back out below.
	            '$1 ' + RESULT_INDEX_ATTR + '="' + resultIndex + '" '
	          );
	        }
	      }
	
	      // Render each group of markup with similar wrapping `nodeName`.
	      var renderNodes = createNodesFromMarkup(
	        markupListByNodeName.join(''),
	        emptyFunction // Do nothing special with <script> tags.
	      );
	
	      for (var j = 0; j < renderNodes.length; ++j) {
	        var renderNode = renderNodes[j];
	        if (renderNode.hasAttribute &&
	            renderNode.hasAttribute(RESULT_INDEX_ATTR)) {
	
	          resultIndex = +renderNode.getAttribute(RESULT_INDEX_ATTR);
	          renderNode.removeAttribute(RESULT_INDEX_ATTR);
	
	          ( false ? invariant(
	            !resultList.hasOwnProperty(resultIndex),
	            'Danger: Assigning to an already-occupied result index.'
	          ) : invariant(!resultList.hasOwnProperty(resultIndex)));
	
	          resultList[resultIndex] = renderNode;
	
	          // This should match resultList.length and markupList.length when
	          // we're done.
	          resultListAssignmentCount += 1;
	
	        } else if (false) {
	          console.error(
	            'Danger: Discarding unexpected node:',
	            renderNode
	          );
	        }
	      }
	    }
	
	    // Although resultList was populated out of order, it should now be a dense
	    // array.
	    ( false ? invariant(
	      resultListAssignmentCount === resultList.length,
	      'Danger: Did not assign to every index of resultList.'
	    ) : invariant(resultListAssignmentCount === resultList.length));
	
	    ( false ? invariant(
	      resultList.length === markupList.length,
	      'Danger: Expected markup to render %s nodes, but rendered %s.',
	      markupList.length,
	      resultList.length
	    ) : invariant(resultList.length === markupList.length));
	
	    return resultList;
	  },
	
	  /**
	   * Replaces a node with a string of markup at its current position within its
	   * parent. The markup must render into a single root node.
	   *
	   * @param {DOMElement} oldChild Child node to replace.
	   * @param {string} markup Markup to render in place of the child node.
	   * @internal
	   */
	  dangerouslyReplaceNodeWithMarkup: function(oldChild, markup) {
	    ( false ? invariant(
	      ExecutionEnvironment.canUseDOM,
	      'dangerouslyReplaceNodeWithMarkup(...): Cannot render markup in a ' +
	      'worker thread. Make sure `window` and `document` are available ' +
	      'globally before requiring React when unit testing or use ' +
	      'React.renderToString for server rendering.'
	    ) : invariant(ExecutionEnvironment.canUseDOM));
	    ( false ? invariant(markup, 'dangerouslyReplaceNodeWithMarkup(...): Missing markup.') : invariant(markup));
	    ( false ? invariant(
	      oldChild.tagName.toLowerCase() !== 'html',
	      'dangerouslyReplaceNodeWithMarkup(...): Cannot replace markup of the ' +
	      '<html> node. This is because browser quirks make this unreliable ' +
	      'and/or slow. If you want to render to the root you must use ' +
	      'server rendering. See React.renderToString().'
	    ) : invariant(oldChild.tagName.toLowerCase() !== 'html'));
	
	    var newChild = createNodesFromMarkup(markup, emptyFunction)[0];
	    oldChild.parentNode.replaceChild(newChild, oldChild);
	  }
	
	};
	
	module.exports = Danger;


/***/ },
/* 410 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DefaultEventPluginOrder
	 */
	
	'use strict';
	
	var keyOf = __webpack_require__(21);
	
	/**
	 * Module that is injectable into `EventPluginHub`, that specifies a
	 * deterministic ordering of `EventPlugin`s. A convenient way to reason about
	 * plugins, without having to package every one of them. This is better than
	 * having plugins be ordered in the same order that they are injected because
	 * that ordering would be influenced by the packaging order.
	 * `ResponderEventPlugin` must occur before `SimpleEventPlugin` so that
	 * preventing default on events is convenient in `SimpleEventPlugin` handlers.
	 */
	var DefaultEventPluginOrder = [
	  keyOf({ResponderEventPlugin: null}),
	  keyOf({SimpleEventPlugin: null}),
	  keyOf({TapEventPlugin: null}),
	  keyOf({EnterLeaveEventPlugin: null}),
	  keyOf({ChangeEventPlugin: null}),
	  keyOf({SelectEventPlugin: null}),
	  keyOf({BeforeInputEventPlugin: null}),
	  keyOf({AnalyticsEventPlugin: null}),
	  keyOf({MobileSafariClickEventPlugin: null})
	];
	
	module.exports = DefaultEventPluginOrder;


/***/ },
/* 411 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EnterLeaveEventPlugin
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(12);
	var EventPropagators = __webpack_require__(45);
	var SyntheticMouseEvent = __webpack_require__(63);
	
	var ReactMount = __webpack_require__(20);
	var keyOf = __webpack_require__(21);
	
	var topLevelTypes = EventConstants.topLevelTypes;
	var getFirstReactDOM = ReactMount.getFirstReactDOM;
	
	var eventTypes = {
	  mouseEnter: {
	    registrationName: keyOf({onMouseEnter: null}),
	    dependencies: [
	      topLevelTypes.topMouseOut,
	      topLevelTypes.topMouseOver
	    ]
	  },
	  mouseLeave: {
	    registrationName: keyOf({onMouseLeave: null}),
	    dependencies: [
	      topLevelTypes.topMouseOut,
	      topLevelTypes.topMouseOver
	    ]
	  }
	};
	
	var extractedEvents = [null, null];
	
	var EnterLeaveEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  /**
	   * For almost every interaction we care about, there will be both a top-level
	   * `mouseover` and `mouseout` event that occurs. Only use `mouseout` so that
	   * we do not extract duplicate events. However, moving the mouse into the
	   * browser from outside will not fire a `mouseout` event. In this case, we use
	   * the `mouseover` top-level event.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {DOMEventTarget} topLevelTarget The listening component root node.
	   * @param {string} topLevelTargetID ID of `topLevelTarget`.
	   * @param {object} nativeEvent Native browser event.
	   * @return {*} An accumulation of synthetic events.
	   * @see {EventPluginHub.extractEvents}
	   */
	  extractEvents: function(
	      topLevelType,
	      topLevelTarget,
	      topLevelTargetID,
	      nativeEvent) {
	    if (topLevelType === topLevelTypes.topMouseOver &&
	        (nativeEvent.relatedTarget || nativeEvent.fromElement)) {
	      return null;
	    }
	    if (topLevelType !== topLevelTypes.topMouseOut &&
	        topLevelType !== topLevelTypes.topMouseOver) {
	      // Must not be a mouse in or mouse out - ignoring.
	      return null;
	    }
	
	    var win;
	    if (topLevelTarget.window === topLevelTarget) {
	      // `topLevelTarget` is probably a window object.
	      win = topLevelTarget;
	    } else {
	      // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	      var doc = topLevelTarget.ownerDocument;
	      if (doc) {
	        win = doc.defaultView || doc.parentWindow;
	      } else {
	        win = window;
	      }
	    }
	
	    var from, to;
	    if (topLevelType === topLevelTypes.topMouseOut) {
	      from = topLevelTarget;
	      to =
	        getFirstReactDOM(nativeEvent.relatedTarget || nativeEvent.toElement) ||
	        win;
	    } else {
	      from = win;
	      to = topLevelTarget;
	    }
	
	    if (from === to) {
	      // Nothing pertains to our managed components.
	      return null;
	    }
	
	    var fromID = from ? ReactMount.getID(from) : '';
	    var toID = to ? ReactMount.getID(to) : '';
	
	    var leave = SyntheticMouseEvent.getPooled(
	      eventTypes.mouseLeave,
	      fromID,
	      nativeEvent
	    );
	    leave.type = 'mouseleave';
	    leave.target = from;
	    leave.relatedTarget = to;
	
	    var enter = SyntheticMouseEvent.getPooled(
	      eventTypes.mouseEnter,
	      toID,
	      nativeEvent
	    );
	    enter.type = 'mouseenter';
	    enter.target = to;
	    enter.relatedTarget = from;
	
	    EventPropagators.accumulateEnterLeaveDispatches(leave, enter, fromID, toID);
	
	    extractedEvents[0] = leave;
	    extractedEvents[1] = enter;
	
	    return extractedEvents;
	  }
	
	};
	
	module.exports = EnterLeaveEventPlugin;


/***/ },
/* 412 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @providesModule EventListener
	 * @typechecks
	 */
	
	var emptyFunction = __webpack_require__(24);
	
	/**
	 * Upstream version of event listener. Does not take into account specific
	 * nature of platform.
	 */
	var EventListener = {
	  /**
	   * Listen to DOM events during the bubble phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  listen: function(target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, false);
	      return {
	        remove: function() {
	          target.removeEventListener(eventType, callback, false);
	        }
	      };
	    } else if (target.attachEvent) {
	      target.attachEvent('on' + eventType, callback);
	      return {
	        remove: function() {
	          target.detachEvent('on' + eventType, callback);
	        }
	      };
	    }
	  },
	
	  /**
	   * Listen to DOM events during the capture phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  capture: function(target, eventType, callback) {
	    if (!target.addEventListener) {
	      if (false) {
	        console.error(
	          'Attempted to listen to events during the capture phase on a ' +
	          'browser that does not support the capture phase. Your application ' +
	          'will not receive some events.'
	        );
	      }
	      return {
	        remove: emptyFunction
	      };
	    } else {
	      target.addEventListener(eventType, callback, true);
	      return {
	        remove: function() {
	          target.removeEventListener(eventType, callback, true);
	        }
	      };
	    }
	  },
	
	  registerDefault: function() {}
	};
	
	module.exports = EventListener;


/***/ },
/* 413 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule FallbackCompositionState
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var PooledClass = __webpack_require__(17);
	
	var assign = __webpack_require__(5);
	var getTextContentAccessor = __webpack_require__(161);
	
	/**
	 * This helper class stores information about text content of a target node,
	 * allowing comparison of content before and after a given event.
	 *
	 * Identify the node where selection currently begins, then observe
	 * both its text content and its current position in the DOM. Since the
	 * browser may natively replace the target node during composition, we can
	 * use its position to find its replacement.
	 *
	 * @param {DOMEventTarget} root
	 */
	function FallbackCompositionState(root) {
	  this._root = root;
	  this._startText = this.getText();
	  this._fallbackText = null;
	}
	
	assign(FallbackCompositionState.prototype, {
	  /**
	   * Get current text of input.
	   *
	   * @return {string}
	   */
	  getText: function() {
	    if ('value' in this._root) {
	      return this._root.value;
	    }
	    return this._root[getTextContentAccessor()];
	  },
	
	  /**
	   * Determine the differing substring between the initially stored
	   * text content and the current content.
	   *
	   * @return {string}
	   */
	  getData: function() {
	    if (this._fallbackText) {
	      return this._fallbackText;
	    }
	
	    var start;
	    var startValue = this._startText;
	    var startLength = startValue.length;
	    var end;
	    var endValue = this.getText();
	    var endLength = endValue.length;
	
	    for (start = 0; start < startLength; start++) {
	      if (startValue[start] !== endValue[start]) {
	        break;
	      }
	    }
	
	    var minEnd = startLength - start;
	    for (end = 1; end <= minEnd; end++) {
	      if (startValue[startLength - end] !== endValue[endLength - end]) {
	        break;
	      }
	    }
	
	    var sliceTail = end > 1 ? 1 - end : undefined;
	    this._fallbackText = endValue.slice(start, sliceTail);
	    return this._fallbackText;
	  }
	});
	
	PooledClass.addPoolingTo(FallbackCompositionState);
	
	module.exports = FallbackCompositionState;


/***/ },
/* 414 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule HTMLDOMPropertyConfig
	 */
	
	/*jslint bitwise: true*/
	
	'use strict';
	
	var DOMProperty = __webpack_require__(33);
	var ExecutionEnvironment = __webpack_require__(8);
	
	var MUST_USE_ATTRIBUTE = DOMProperty.injection.MUST_USE_ATTRIBUTE;
	var MUST_USE_PROPERTY = DOMProperty.injection.MUST_USE_PROPERTY;
	var HAS_BOOLEAN_VALUE = DOMProperty.injection.HAS_BOOLEAN_VALUE;
	var HAS_SIDE_EFFECTS = DOMProperty.injection.HAS_SIDE_EFFECTS;
	var HAS_NUMERIC_VALUE = DOMProperty.injection.HAS_NUMERIC_VALUE;
	var HAS_POSITIVE_NUMERIC_VALUE =
	  DOMProperty.injection.HAS_POSITIVE_NUMERIC_VALUE;
	var HAS_OVERLOADED_BOOLEAN_VALUE =
	  DOMProperty.injection.HAS_OVERLOADED_BOOLEAN_VALUE;
	
	var hasSVG;
	if (ExecutionEnvironment.canUseDOM) {
	  var implementation = document.implementation;
	  hasSVG = (
	    implementation &&
	    implementation.hasFeature &&
	    implementation.hasFeature(
	      'http://www.w3.org/TR/SVG11/feature#BasicStructure',
	      '1.1'
	    )
	  );
	}
	
	
	var HTMLDOMPropertyConfig = {
	  isCustomAttribute: RegExp.prototype.test.bind(
	    /^(data|aria)-[a-z_][a-z\d_.\-]*$/
	  ),
	  Properties: {
	    /**
	     * Standard Properties
	     */
	    accept: null,
	    acceptCharset: null,
	    accessKey: null,
	    action: null,
	    allowFullScreen: MUST_USE_ATTRIBUTE | HAS_BOOLEAN_VALUE,
	    allowTransparency: MUST_USE_ATTRIBUTE,
	    alt: null,
	    async: HAS_BOOLEAN_VALUE,
	    autoComplete: null,
	    // autoFocus is polyfilled/normalized by AutoFocusMixin
	    // autoFocus: HAS_BOOLEAN_VALUE,
	    autoPlay: HAS_BOOLEAN_VALUE,
	    cellPadding: null,
	    cellSpacing: null,
	    charSet: MUST_USE_ATTRIBUTE,
	    checked: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    classID: MUST_USE_ATTRIBUTE,
	    // To set className on SVG elements, it's necessary to use .setAttribute;
	    // this works on HTML elements too in all browsers except IE8. Conveniently,
	    // IE8 doesn't support SVG and so we can simply use the attribute in
	    // browsers that support SVG and the property in browsers that don't,
	    // regardless of whether the element is HTML or SVG.
	    className: hasSVG ? MUST_USE_ATTRIBUTE : MUST_USE_PROPERTY,
	    cols: MUST_USE_ATTRIBUTE | HAS_POSITIVE_NUMERIC_VALUE,
	    colSpan: null,
	    content: null,
	    contentEditable: null,
	    contextMenu: MUST_USE_ATTRIBUTE,
	    controls: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    coords: null,
	    crossOrigin: null,
	    data: null, // For `<object />` acts as `src`.
	    dateTime: MUST_USE_ATTRIBUTE,
	    defer: HAS_BOOLEAN_VALUE,
	    dir: null,
	    disabled: MUST_USE_ATTRIBUTE | HAS_BOOLEAN_VALUE,
	    download: HAS_OVERLOADED_BOOLEAN_VALUE,
	    draggable: null,
	    encType: null,
	    form: MUST_USE_ATTRIBUTE,
	    formAction: MUST_USE_ATTRIBUTE,
	    formEncType: MUST_USE_ATTRIBUTE,
	    formMethod: MUST_USE_ATTRIBUTE,
	    formNoValidate: HAS_BOOLEAN_VALUE,
	    formTarget: MUST_USE_ATTRIBUTE,
	    frameBorder: MUST_USE_ATTRIBUTE,
	    headers: null,
	    height: MUST_USE_ATTRIBUTE,
	    hidden: MUST_USE_ATTRIBUTE | HAS_BOOLEAN_VALUE,
	    high: null,
	    href: null,
	    hrefLang: null,
	    htmlFor: null,
	    httpEquiv: null,
	    icon: null,
	    id: MUST_USE_PROPERTY,
	    label: null,
	    lang: null,
	    list: MUST_USE_ATTRIBUTE,
	    loop: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    low: null,
	    manifest: MUST_USE_ATTRIBUTE,
	    marginHeight: null,
	    marginWidth: null,
	    max: null,
	    maxLength: MUST_USE_ATTRIBUTE,
	    media: MUST_USE_ATTRIBUTE,
	    mediaGroup: null,
	    method: null,
	    min: null,
	    multiple: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    muted: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    name: null,
	    noValidate: HAS_BOOLEAN_VALUE,
	    open: HAS_BOOLEAN_VALUE,
	    optimum: null,
	    pattern: null,
	    placeholder: null,
	    poster: null,
	    preload: null,
	    radioGroup: null,
	    readOnly: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    rel: null,
	    required: HAS_BOOLEAN_VALUE,
	    role: MUST_USE_ATTRIBUTE,
	    rows: MUST_USE_ATTRIBUTE | HAS_POSITIVE_NUMERIC_VALUE,
	    rowSpan: null,
	    sandbox: null,
	    scope: null,
	    scoped: HAS_BOOLEAN_VALUE,
	    scrolling: null,
	    seamless: MUST_USE_ATTRIBUTE | HAS_BOOLEAN_VALUE,
	    selected: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    shape: null,
	    size: MUST_USE_ATTRIBUTE | HAS_POSITIVE_NUMERIC_VALUE,
	    sizes: MUST_USE_ATTRIBUTE,
	    span: HAS_POSITIVE_NUMERIC_VALUE,
	    spellCheck: null,
	    src: null,
	    srcDoc: MUST_USE_PROPERTY,
	    srcSet: MUST_USE_ATTRIBUTE,
	    start: HAS_NUMERIC_VALUE,
	    step: null,
	    style: null,
	    tabIndex: null,
	    target: null,
	    title: null,
	    type: null,
	    useMap: null,
	    value: MUST_USE_PROPERTY | HAS_SIDE_EFFECTS,
	    width: MUST_USE_ATTRIBUTE,
	    wmode: MUST_USE_ATTRIBUTE,
	
	    /**
	     * Non-standard Properties
	     */
	    // autoCapitalize and autoCorrect are supported in Mobile Safari for
	    // keyboard hints.
	    autoCapitalize: null,
	    autoCorrect: null,
	    // itemProp, itemScope, itemType are for
	    // Microdata support. See http://schema.org/docs/gs.html
	    itemProp: MUST_USE_ATTRIBUTE,
	    itemScope: MUST_USE_ATTRIBUTE | HAS_BOOLEAN_VALUE,
	    itemType: MUST_USE_ATTRIBUTE,
	    // itemID and itemRef are for Microdata support as well but
	    // only specified in the the WHATWG spec document. See
	    // https://html.spec.whatwg.org/multipage/microdata.html#microdata-dom-api
	    itemID: MUST_USE_ATTRIBUTE,
	    itemRef: MUST_USE_ATTRIBUTE,
	    // property is supported for OpenGraph in meta tags.
	    property: null,
	    // IE-only attribute that controls focus behavior
	    unselectable: MUST_USE_ATTRIBUTE
	  },
	  DOMAttributeNames: {
	    acceptCharset: 'accept-charset',
	    className: 'class',
	    htmlFor: 'for',
	    httpEquiv: 'http-equiv'
	  },
	  DOMPropertyNames: {
	    autoCapitalize: 'autocapitalize',
	    autoComplete: 'autocomplete',
	    autoCorrect: 'autocorrect',
	    autoFocus: 'autofocus',
	    autoPlay: 'autoplay',
	    // `encoding` is equivalent to `enctype`, IE8 lacks an `enctype` setter.
	    // http://www.w3.org/TR/html5/forms.html#dom-fs-encoding
	    encType: 'encoding',
	    hrefLang: 'hreflang',
	    radioGroup: 'radiogroup',
	    spellCheck: 'spellcheck',
	    srcDoc: 'srcdoc',
	    srcSet: 'srcset'
	  }
	};
	
	module.exports = HTMLDOMPropertyConfig;


/***/ },
/* 415 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule MobileSafariClickEventPlugin
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(12);
	
	var emptyFunction = __webpack_require__(24);
	
	var topLevelTypes = EventConstants.topLevelTypes;
	
	/**
	 * Mobile Safari does not fire properly bubble click events on non-interactive
	 * elements, which means delegated click listeners do not fire. The workaround
	 * for this bug involves attaching an empty click listener on the target node.
	 *
	 * This particular plugin works around the bug by attaching an empty click
	 * listener on `touchstart` (which does fire on every element).
	 */
	var MobileSafariClickEventPlugin = {
	
	  eventTypes: null,
	
	  /**
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {DOMEventTarget} topLevelTarget The listening component root node.
	   * @param {string} topLevelTargetID ID of `topLevelTarget`.
	   * @param {object} nativeEvent Native browser event.
	   * @return {*} An accumulation of synthetic events.
	   * @see {EventPluginHub.extractEvents}
	   */
	  extractEvents: function(
	      topLevelType,
	      topLevelTarget,
	      topLevelTargetID,
	      nativeEvent) {
	    if (topLevelType === topLevelTypes.topTouchStart) {
	      var target = nativeEvent.target;
	      if (target && !target.onclick) {
	        target.onclick = emptyFunction;
	      }
	    }
	  }
	
	};
	
	module.exports = MobileSafariClickEventPlugin;


/***/ },
/* 416 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule React
	 */
	
	/* globals __REACT_DEVTOOLS_GLOBAL_HOOK__*/
	
	'use strict';
	
	var EventPluginUtils = __webpack_require__(83);
	var ReactChildren = __webpack_require__(418);
	var ReactComponent = __webpack_require__(145);
	var ReactClass = __webpack_require__(13);
	var ReactContext = __webpack_require__(88);
	var ReactCurrentOwner = __webpack_require__(19);
	var ReactElement = __webpack_require__(7);
	var ReactElementValidator = __webpack_require__(46);
	var ReactDOM = __webpack_require__(420);
	var ReactDOMTextComponent = __webpack_require__(147);
	var ReactDefaultInjection = __webpack_require__(431);
	var ReactInstanceHandles = __webpack_require__(35);
	var ReactMount = __webpack_require__(20);
	var ReactPerf = __webpack_require__(27);
	var ReactPropTypes = __webpack_require__(151);
	var ReactReconciler = __webpack_require__(37);
	var ReactServerRendering = __webpack_require__(440);
	
	var assign = __webpack_require__(5);
	var findDOMNode = __webpack_require__(156);
	var onlyChild = __webpack_require__(471);
	
	ReactDefaultInjection.inject();
	
	var createElement = ReactElement.createElement;
	var createFactory = ReactElement.createFactory;
	var cloneElement = ReactElement.cloneElement;
	
	if (false) {
	  createElement = ReactElementValidator.createElement;
	  createFactory = ReactElementValidator.createFactory;
	  cloneElement = ReactElementValidator.cloneElement;
	}
	
	var render = ReactPerf.measure('React', 'render', ReactMount.render);
	
	var React = {
	  Children: {
	    map: ReactChildren.map,
	    forEach: ReactChildren.forEach,
	    count: ReactChildren.count,
	    only: onlyChild
	  },
	  Component: ReactComponent,
	  DOM: ReactDOM,
	  PropTypes: ReactPropTypes,
	  initializeTouchEvents: function(shouldUseTouch) {
	    EventPluginUtils.useTouchEvents = shouldUseTouch;
	  },
	  createClass: ReactClass.createClass,
	  createElement: createElement,
	  cloneElement: cloneElement,
	  createFactory: createFactory,
	  createMixin: function(mixin) {
	    // Currently a noop. Will be used to validate and trace mixins.
	    return mixin;
	  },
	  constructAndRenderComponent: ReactMount.constructAndRenderComponent,
	  constructAndRenderComponentByID: ReactMount.constructAndRenderComponentByID,
	  findDOMNode: findDOMNode,
	  render: render,
	  renderToString: ReactServerRendering.renderToString,
	  renderToStaticMarkup: ReactServerRendering.renderToStaticMarkup,
	  unmountComponentAtNode: ReactMount.unmountComponentAtNode,
	  isValidElement: ReactElement.isValidElement,
	  withContext: ReactContext.withContext,
	
	  // Hook for JSX spread, don't use this for anything else.
	  __spread: assign
	};
	
	// Inject the runtime into a devtools global hook regardless of browser.
	// Allows for debugging when the hook is injected on the page.
	if (
	  typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' &&
	  typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.inject === 'function') {
	  __REACT_DEVTOOLS_GLOBAL_HOOK__.inject({
	    CurrentOwner: ReactCurrentOwner,
	    InstanceHandles: ReactInstanceHandles,
	    Mount: ReactMount,
	    Reconciler: ReactReconciler,
	    TextComponent: ReactDOMTextComponent
	  });
	}
	
	if (false) {
	  var ExecutionEnvironment = require("./ExecutionEnvironment");
	  if (ExecutionEnvironment.canUseDOM && window.top === window.self) {
	
	    // If we're in Chrome, look for the devtools marker and provide a download
	    // link if not installed.
	    if (navigator.userAgent.indexOf('Chrome') > -1) {
	      if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined') {
	        console.debug(
	          'Download the React DevTools for a better development experience: ' +
	          'https://fb.me/react-devtools'
	        );
	      }
	    }
	
	    var expectedFeatures = [
	      // shims
	      Array.isArray,
	      Array.prototype.every,
	      Array.prototype.forEach,
	      Array.prototype.indexOf,
	      Array.prototype.map,
	      Date.now,
	      Function.prototype.bind,
	      Object.keys,
	      String.prototype.split,
	      String.prototype.trim,
	
	      // shams
	      Object.create,
	      Object.freeze
	    ];
	
	    for (var i = 0; i < expectedFeatures.length; i++) {
	      if (!expectedFeatures[i]) {
	        console.error(
	          'One or more ES5 shim/shams expected by React are not available: ' +
	          'https://fb.me/react-warning-polyfills'
	        );
	        break;
	      }
	    }
	  }
	}
	
	React.version = '0.13.3';
	
	module.exports = React;


/***/ },
/* 417 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactChildReconciler
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var ReactReconciler = __webpack_require__(37);
	
	var flattenChildren = __webpack_require__(461);
	var instantiateReactComponent = __webpack_require__(99);
	var shouldUpdateReactComponent = __webpack_require__(102);
	
	/**
	 * ReactChildReconciler provides helpers for initializing or updating a set of
	 * children. Its output is suitable for passing it onto ReactMultiChild which
	 * does diffed reordering and insertion.
	 */
	var ReactChildReconciler = {
	
	  /**
	   * Generates a "mount image" for each of the supplied children. In the case
	   * of `ReactDOMComponent`, a mount image is a string of markup.
	   *
	   * @param {?object} nestedChildNodes Nested child maps.
	   * @return {?object} A set of child instances.
	   * @internal
	   */
	  instantiateChildren: function(nestedChildNodes, transaction, context) {
	    var children = flattenChildren(nestedChildNodes);
	    for (var name in children) {
	      if (children.hasOwnProperty(name)) {
	        var child = children[name];
	        // The rendered children must be turned into instances as they're
	        // mounted.
	        var childInstance = instantiateReactComponent(child, null);
	        children[name] = childInstance;
	      }
	    }
	    return children;
	  },
	
	  /**
	   * Updates the rendered children and returns a new set of children.
	   *
	   * @param {?object} prevChildren Previously initialized set of children.
	   * @param {?object} nextNestedChildNodes Nested child maps.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @return {?object} A new set of child instances.
	   * @internal
	   */
	  updateChildren: function(
	    prevChildren,
	    nextNestedChildNodes,
	    transaction,
	    context) {
	    // We currently don't have a way to track moves here but if we use iterators
	    // instead of for..in we can zip the iterators and check if an item has
	    // moved.
	    // TODO: If nothing has changed, return the prevChildren object so that we
	    // can quickly bailout if nothing has changed.
	    var nextChildren = flattenChildren(nextNestedChildNodes);
	    if (!nextChildren && !prevChildren) {
	      return null;
	    }
	    var name;
	    for (name in nextChildren) {
	      if (!nextChildren.hasOwnProperty(name)) {
	        continue;
	      }
	      var prevChild = prevChildren && prevChildren[name];
	      var prevElement = prevChild && prevChild._currentElement;
	      var nextElement = nextChildren[name];
	      if (shouldUpdateReactComponent(prevElement, nextElement)) {
	        ReactReconciler.receiveComponent(
	          prevChild, nextElement, transaction, context
	        );
	        nextChildren[name] = prevChild;
	      } else {
	        if (prevChild) {
	          ReactReconciler.unmountComponent(prevChild, name);
	        }
	        // The child must be instantiated before it's mounted.
	        var nextChildInstance = instantiateReactComponent(
	          nextElement,
	          null
	        );
	        nextChildren[name] = nextChildInstance;
	      }
	    }
	    // Unmount children that are no longer present.
	    for (name in prevChildren) {
	      if (prevChildren.hasOwnProperty(name) &&
	          !(nextChildren && nextChildren.hasOwnProperty(name))) {
	        ReactReconciler.unmountComponent(prevChildren[name]);
	      }
	    }
	    return nextChildren;
	  },
	
	  /**
	   * Unmounts all rendered children. This should be used to clean up children
	   * when this component is unmounted.
	   *
	   * @param {?object} renderedChildren Previously initialized set of children.
	   * @internal
	   */
	  unmountChildren: function(renderedChildren) {
	    for (var name in renderedChildren) {
	      var renderedChild = renderedChildren[name];
	      ReactReconciler.unmountComponent(renderedChild);
	    }
	  }
	
	};
	
	module.exports = ReactChildReconciler;


/***/ },
/* 418 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactChildren
	 */
	
	'use strict';
	
	var PooledClass = __webpack_require__(17);
	var ReactFragment = __webpack_require__(60);
	
	var traverseAllChildren = __webpack_require__(164);
	var warning = __webpack_require__(6);
	
	var twoArgumentPooler = PooledClass.twoArgumentPooler;
	var threeArgumentPooler = PooledClass.threeArgumentPooler;
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * traversal. Allows avoiding binding callbacks.
	 *
	 * @constructor ForEachBookKeeping
	 * @param {!function} forEachFunction Function to perform traversal with.
	 * @param {?*} forEachContext Context to perform context with.
	 */
	function ForEachBookKeeping(forEachFunction, forEachContext) {
	  this.forEachFunction = forEachFunction;
	  this.forEachContext = forEachContext;
	}
	PooledClass.addPoolingTo(ForEachBookKeeping, twoArgumentPooler);
	
	function forEachSingleChild(traverseContext, child, name, i) {
	  var forEachBookKeeping = traverseContext;
	  forEachBookKeeping.forEachFunction.call(
	    forEachBookKeeping.forEachContext, child, i);
	}
	
	/**
	 * Iterates through children that are typically specified as `props.children`.
	 *
	 * The provided forEachFunc(child, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} forEachFunc.
	 * @param {*} forEachContext Context for forEachContext.
	 */
	function forEachChildren(children, forEachFunc, forEachContext) {
	  if (children == null) {
	    return children;
	  }
	
	  var traverseContext =
	    ForEachBookKeeping.getPooled(forEachFunc, forEachContext);
	  traverseAllChildren(children, forEachSingleChild, traverseContext);
	  ForEachBookKeeping.release(traverseContext);
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * mapping. Allows avoiding binding callbacks.
	 *
	 * @constructor MapBookKeeping
	 * @param {!*} mapResult Object containing the ordered map of results.
	 * @param {!function} mapFunction Function to perform mapping with.
	 * @param {?*} mapContext Context to perform mapping with.
	 */
	function MapBookKeeping(mapResult, mapFunction, mapContext) {
	  this.mapResult = mapResult;
	  this.mapFunction = mapFunction;
	  this.mapContext = mapContext;
	}
	PooledClass.addPoolingTo(MapBookKeeping, threeArgumentPooler);
	
	function mapSingleChildIntoContext(traverseContext, child, name, i) {
	  var mapBookKeeping = traverseContext;
	  var mapResult = mapBookKeeping.mapResult;
	
	  var keyUnique = !mapResult.hasOwnProperty(name);
	  if (false) {
	    ("production" !== process.env.NODE_ENV ? warning(
	      keyUnique,
	      'ReactChildren.map(...): Encountered two children with the same key, ' +
	      '`%s`. Child keys must be unique; when two children share a key, only ' +
	      'the first child will be used.',
	      name
	    ) : null);
	  }
	
	  if (keyUnique) {
	    var mappedChild =
	      mapBookKeeping.mapFunction.call(mapBookKeeping.mapContext, child, i);
	    mapResult[name] = mappedChild;
	  }
	}
	
	/**
	 * Maps children that are typically specified as `props.children`.
	 *
	 * The provided mapFunction(child, key, index) will be called for each
	 * leaf child.
	 *
	 * TODO: This may likely break any calls to `ReactChildren.map` that were
	 * previously relying on the fact that we guarded against null children.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} mapFunction.
	 * @param {*} mapContext Context for mapFunction.
	 * @return {object} Object containing the ordered map of results.
	 */
	function mapChildren(children, func, context) {
	  if (children == null) {
	    return children;
	  }
	
	  var mapResult = {};
	  var traverseContext = MapBookKeeping.getPooled(mapResult, func, context);
	  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
	  MapBookKeeping.release(traverseContext);
	  return ReactFragment.create(mapResult);
	}
	
	function forEachSingleChildDummy(traverseContext, child, name, i) {
	  return null;
	}
	
	/**
	 * Count the number of children that are typically specified as
	 * `props.children`.
	 *
	 * @param {?*} children Children tree container.
	 * @return {number} The number of children.
	 */
	function countChildren(children, context) {
	  return traverseAllChildren(children, forEachSingleChildDummy, null);
	}
	
	var ReactChildren = {
	  forEach: forEachChildren,
	  map: mapChildren,
	  count: countChildren
	};
	
	module.exports = ReactChildren;


/***/ },
/* 419 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactCompositeComponent
	 */
	
	'use strict';
	
	var ReactComponentEnvironment = __webpack_require__(87);
	var ReactContext = __webpack_require__(88);
	var ReactCurrentOwner = __webpack_require__(19);
	var ReactElement = __webpack_require__(7);
	var ReactElementValidator = __webpack_require__(46);
	var ReactInstanceMap = __webpack_require__(36);
	var ReactLifeCycle = __webpack_require__(91);
	var ReactNativeComponent = __webpack_require__(61);
	var ReactPerf = __webpack_require__(27);
	var ReactPropTypeLocations = __webpack_require__(92);
	var ReactPropTypeLocationNames = __webpack_require__(62);
	var ReactReconciler = __webpack_require__(37);
	var ReactUpdates = __webpack_require__(14);
	
	var assign = __webpack_require__(5);
	var emptyObject = __webpack_require__(65);
	var invariant = __webpack_require__(2);
	var shouldUpdateReactComponent = __webpack_require__(102);
	var warning = __webpack_require__(6);
	
	function getDeclarationErrorAddendum(component) {
	  var owner = component._currentElement._owner || null;
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * ------------------ The Life-Cycle of a Composite Component ------------------
	 *
	 * - constructor: Initialization of state. The instance is now retained.
	 *   - componentWillMount
	 *   - render
	 *   - [children's constructors]
	 *     - [children's componentWillMount and render]
	 *     - [children's componentDidMount]
	 *     - componentDidMount
	 *
	 *       Update Phases:
	 *       - componentWillReceiveProps (only called if parent updated)
	 *       - shouldComponentUpdate
	 *         - componentWillUpdate
	 *           - render
	 *           - [children's constructors or receive props phases]
	 *         - componentDidUpdate
	 *
	 *     - componentWillUnmount
	 *     - [children's componentWillUnmount]
	 *   - [children destroyed]
	 * - (destroyed): The instance is now blank, released by React and ready for GC.
	 *
	 * -----------------------------------------------------------------------------
	 */
	
	/**
	 * An incrementing ID assigned to each component when it is mounted. This is
	 * used to enforce the order in which `ReactUpdates` updates dirty components.
	 *
	 * @private
	 */
	var nextMountID = 1;
	
	/**
	 * @lends {ReactCompositeComponent.prototype}
	 */
	var ReactCompositeComponentMixin = {
	
	  /**
	   * Base constructor for all composite component.
	   *
	   * @param {ReactElement} element
	   * @final
	   * @internal
	   */
	  construct: function(element) {
	    this._currentElement = element;
	    this._rootNodeID = null;
	    this._instance = null;
	
	    // See ReactUpdateQueue
	    this._pendingElement = null;
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    this._renderedComponent = null;
	
	    this._context = null;
	    this._mountOrder = 0;
	    this._isTopLevel = false;
	
	    // See ReactUpdates and ReactUpdateQueue.
	    this._pendingCallbacks = null;
	  },
	
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {string} rootID DOM ID of the root node.
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function(rootID, transaction, context) {
	    this._context = context;
	    this._mountOrder = nextMountID++;
	    this._rootNodeID = rootID;
	
	    var publicProps = this._processProps(this._currentElement.props);
	    var publicContext = this._processContext(this._currentElement._context);
	
	    var Component = ReactNativeComponent.getComponentClassForElement(
	      this._currentElement
	    );
	
	    // Initialize the public class
	    var inst = new Component(publicProps, publicContext);
	
	    if (false) {
	      // This will throw later in _renderValidatedComponent, but add an early
	      // warning now to help debugging
	      ("production" !== process.env.NODE_ENV ? warning(
	        inst.render != null,
	        '%s(...): No `render` method found on the returned component ' +
	        'instance: you may have forgotten to define `render` in your ' +
	        'component or you may have accidentally tried to render an element ' +
	        'whose type is a function that isn\'t a React component.',
	        Component.displayName || Component.name || 'Component'
	      ) : null);
	    }
	
	    // These should be set up in the constructor, but as a convenience for
	    // simpler class abstractions, we set them up after the fact.
	    inst.props = publicProps;
	    inst.context = publicContext;
	    inst.refs = emptyObject;
	
	    this._instance = inst;
	
	    // Store a reference from the instance back to the internal representation
	    ReactInstanceMap.set(inst, this);
	
	    if (false) {
	      this._warnIfContextsDiffer(this._currentElement._context, context);
	    }
	
	    if (false) {
	      // Since plain JS classes are defined without any special initialization
	      // logic, we can not catch common errors early. Therefore, we have to
	      // catch them here, at initialization time, instead.
	      ("production" !== process.env.NODE_ENV ? warning(
	        !inst.getInitialState ||
	        inst.getInitialState.isReactClassApproved,
	        'getInitialState was defined on %s, a plain JavaScript class. ' +
	        'This is only supported for classes created using React.createClass. ' +
	        'Did you mean to define a state property instead?',
	        this.getName() || 'a component'
	      ) : null);
	      ("production" !== process.env.NODE_ENV ? warning(
	        !inst.getDefaultProps ||
	        inst.getDefaultProps.isReactClassApproved,
	        'getDefaultProps was defined on %s, a plain JavaScript class. ' +
	        'This is only supported for classes created using React.createClass. ' +
	        'Use a static property to define defaultProps instead.',
	        this.getName() || 'a component'
	      ) : null);
	      ("production" !== process.env.NODE_ENV ? warning(
	        !inst.propTypes,
	        'propTypes was defined as an instance property on %s. Use a static ' +
	        'property to define propTypes instead.',
	        this.getName() || 'a component'
	      ) : null);
	      ("production" !== process.env.NODE_ENV ? warning(
	        !inst.contextTypes,
	        'contextTypes was defined as an instance property on %s. Use a ' +
	        'static property to define contextTypes instead.',
	        this.getName() || 'a component'
	      ) : null);
	      ("production" !== process.env.NODE_ENV ? warning(
	        typeof inst.componentShouldUpdate !== 'function',
	        '%s has a method called ' +
	        'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
	        'The name is phrased as a question because the function is ' +
	        'expected to return a value.',
	        (this.getName() || 'A component')
	      ) : null);
	    }
	
	    var initialState = inst.state;
	    if (initialState === undefined) {
	      inst.state = initialState = null;
	    }
	    ( false ? invariant(
	      typeof initialState === 'object' && !Array.isArray(initialState),
	      '%s.state: must be set to an object or null',
	      this.getName() || 'ReactCompositeComponent'
	    ) : invariant(typeof initialState === 'object' && !Array.isArray(initialState)));
	
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    var childContext;
	    var renderedElement;
	
	    var previouslyMounting = ReactLifeCycle.currentlyMountingInstance;
	    ReactLifeCycle.currentlyMountingInstance = this;
	    try {
	      if (inst.componentWillMount) {
	        inst.componentWillMount();
	        // When mounting, calls to `setState` by `componentWillMount` will set
	        // `this._pendingStateQueue` without triggering a re-render.
	        if (this._pendingStateQueue) {
	          inst.state = this._processPendingState(inst.props, inst.context);
	        }
	      }
	
	      childContext = this._getValidatedChildContext(context);
	      renderedElement = this._renderValidatedComponent(childContext);
	    } finally {
	      ReactLifeCycle.currentlyMountingInstance = previouslyMounting;
	    }
	
	    this._renderedComponent = this._instantiateReactComponent(
	      renderedElement,
	      this._currentElement.type // The wrapping type
	    );
	
	    var markup = ReactReconciler.mountComponent(
	      this._renderedComponent,
	      rootID,
	      transaction,
	      this._mergeChildContext(context, childContext)
	    );
	    if (inst.componentDidMount) {
	      transaction.getReactMountReady().enqueue(inst.componentDidMount, inst);
	    }
	
	    return markup;
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function() {
	    var inst = this._instance;
	
	    if (inst.componentWillUnmount) {
	      var previouslyUnmounting = ReactLifeCycle.currentlyUnmountingInstance;
	      ReactLifeCycle.currentlyUnmountingInstance = this;
	      try {
	        inst.componentWillUnmount();
	      } finally {
	        ReactLifeCycle.currentlyUnmountingInstance = previouslyUnmounting;
	      }
	    }
	
	    ReactReconciler.unmountComponent(this._renderedComponent);
	    this._renderedComponent = null;
	
	    // Reset pending fields
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	    this._pendingCallbacks = null;
	    this._pendingElement = null;
	
	    // These fields do not really need to be reset since this object is no
	    // longer accessible.
	    this._context = null;
	    this._rootNodeID = null;
	
	    // Delete the reference from the instance to this internal representation
	    // which allow the internals to be properly cleaned up even if the user
	    // leaks a reference to the public instance.
	    ReactInstanceMap.remove(inst);
	
	    // Some existing components rely on inst.props even after they've been
	    // destroyed (in event handlers).
	    // TODO: inst.props = null;
	    // TODO: inst.state = null;
	    // TODO: inst.context = null;
	  },
	
	  /**
	   * Schedule a partial update to the props. Only used for internal testing.
	   *
	   * @param {object} partialProps Subset of the next props.
	   * @param {?function} callback Called after props are updated.
	   * @final
	   * @internal
	   */
	  _setPropsInternal: function(partialProps, callback) {
	    // This is a deoptimized path. We optimize for always having an element.
	    // This creates an extra internal element.
	    var element = this._pendingElement || this._currentElement;
	    this._pendingElement = ReactElement.cloneAndReplaceProps(
	      element,
	      assign({}, element.props, partialProps)
	    );
	    ReactUpdates.enqueueUpdate(this, callback);
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _maskContext: function(context) {
	    var maskedContext = null;
	    // This really should be getting the component class for the element,
	    // but we know that we're not going to need it for built-ins.
	    if (typeof this._currentElement.type === 'string') {
	      return emptyObject;
	    }
	    var contextTypes = this._currentElement.type.contextTypes;
	    if (!contextTypes) {
	      return emptyObject;
	    }
	    maskedContext = {};
	    for (var contextName in contextTypes) {
	      maskedContext[contextName] = context[contextName];
	    }
	    return maskedContext;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`, and asserts that they are valid.
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _processContext: function(context) {
	    var maskedContext = this._maskContext(context);
	    if (false) {
	      var Component = ReactNativeComponent.getComponentClassForElement(
	        this._currentElement
	      );
	      if (Component.contextTypes) {
	        this._checkPropTypes(
	          Component.contextTypes,
	          maskedContext,
	          ReactPropTypeLocations.context
	        );
	      }
	    }
	    return maskedContext;
	  },
	
	  /**
	   * @param {object} currentContext
	   * @return {object}
	   * @private
	   */
	  _getValidatedChildContext: function(currentContext) {
	    var inst = this._instance;
	    var childContext = inst.getChildContext && inst.getChildContext();
	    if (childContext) {
	      ( false ? invariant(
	        typeof inst.constructor.childContextTypes === 'object',
	        '%s.getChildContext(): childContextTypes must be defined in order to ' +
	        'use getChildContext().',
	        this.getName() || 'ReactCompositeComponent'
	      ) : invariant(typeof inst.constructor.childContextTypes === 'object'));
	      if (false) {
	        this._checkPropTypes(
	          inst.constructor.childContextTypes,
	          childContext,
	          ReactPropTypeLocations.childContext
	        );
	      }
	      for (var name in childContext) {
	        ( false ? invariant(
	          name in inst.constructor.childContextTypes,
	          '%s.getChildContext(): key "%s" is not defined in childContextTypes.',
	          this.getName() || 'ReactCompositeComponent',
	          name
	        ) : invariant(name in inst.constructor.childContextTypes));
	      }
	      return childContext;
	    }
	    return null;
	  },
	
	  _mergeChildContext: function(currentContext, childContext) {
	    if (childContext) {
	      return assign({}, currentContext, childContext);
	    }
	    return currentContext;
	  },
	
	  /**
	   * Processes props by setting default values for unspecified props and
	   * asserting that the props are valid. Does not mutate its argument; returns
	   * a new props object with defaults merged in.
	   *
	   * @param {object} newProps
	   * @return {object}
	   * @private
	   */
	  _processProps: function(newProps) {
	    if (false) {
	      var Component = ReactNativeComponent.getComponentClassForElement(
	        this._currentElement
	      );
	      if (Component.propTypes) {
	        this._checkPropTypes(
	          Component.propTypes,
	          newProps,
	          ReactPropTypeLocations.prop
	        );
	      }
	    }
	    return newProps;
	  },
	
	  /**
	   * Assert that the props are valid
	   *
	   * @param {object} propTypes Map of prop name to a ReactPropType
	   * @param {object} props
	   * @param {string} location e.g. "prop", "context", "child context"
	   * @private
	   */
	  _checkPropTypes: function(propTypes, props, location) {
	    // TODO: Stop validating prop types here and only use the element
	    // validation.
	    var componentName = this.getName();
	    for (var propName in propTypes) {
	      if (propTypes.hasOwnProperty(propName)) {
	        var error;
	        try {
	          // This is intentionally an invariant that gets caught. It's the same
	          // behavior as without this statement except with a better message.
	          ( false ? invariant(
	            typeof propTypes[propName] === 'function',
	            '%s: %s type `%s` is invalid; it must be a function, usually ' +
	            'from React.PropTypes.',
	            componentName || 'React class',
	            ReactPropTypeLocationNames[location],
	            propName
	          ) : invariant(typeof propTypes[propName] === 'function'));
	          error = propTypes[propName](props, propName, componentName, location);
	        } catch (ex) {
	          error = ex;
	        }
	        if (error instanceof Error) {
	          // We may want to extend this logic for similar errors in
	          // React.render calls, so I'm abstracting it away into
	          // a function to minimize refactoring in the future
	          var addendum = getDeclarationErrorAddendum(this);
	
	          if (location === ReactPropTypeLocations.prop) {
	            // Preface gives us something to blacklist in warning module
	            ( false ? warning(
	              false,
	              'Failed Composite propType: %s%s',
	              error.message,
	              addendum
	            ) : null);
	          } else {
	            ( false ? warning(
	              false,
	              'Failed Context Types: %s%s',
	              error.message,
	              addendum
	            ) : null);
	          }
	        }
	      }
	    }
	  },
	
	  receiveComponent: function(nextElement, transaction, nextContext) {
	    var prevElement = this._currentElement;
	    var prevContext = this._context;
	
	    this._pendingElement = null;
	
	    this.updateComponent(
	      transaction,
	      prevElement,
	      nextElement,
	      prevContext,
	      nextContext
	    );
	  },
	
	  /**
	   * If any of `_pendingElement`, `_pendingStateQueue`, or `_pendingForceUpdate`
	   * is set, update the component.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function(transaction) {
	    if (this._pendingElement != null) {
	      ReactReconciler.receiveComponent(
	        this,
	        this._pendingElement || this._currentElement,
	        transaction,
	        this._context
	      );
	    }
	
	    if (this._pendingStateQueue !== null || this._pendingForceUpdate) {
	      if (false) {
	        ReactElementValidator.checkAndWarnForMutatedProps(
	          this._currentElement
	        );
	      }
	
	      this.updateComponent(
	        transaction,
	        this._currentElement,
	        this._currentElement,
	        this._context,
	        this._context
	      );
	    }
	  },
	
	  /**
	   * Compare two contexts, warning if they are different
	   * TODO: Remove this check when owner-context is removed
	   */
	   _warnIfContextsDiffer: function(ownerBasedContext, parentBasedContext) {
	    ownerBasedContext = this._maskContext(ownerBasedContext);
	    parentBasedContext = this._maskContext(parentBasedContext);
	    var parentKeys = Object.keys(parentBasedContext).sort();
	    var displayName = this.getName() || 'ReactCompositeComponent';
	    for (var i = 0; i < parentKeys.length; i++) {
	      var key = parentKeys[i];
	      ( false ? warning(
	        ownerBasedContext[key] === parentBasedContext[key],
	        'owner-based and parent-based contexts differ '  +
	        '(values: `%s` vs `%s`) for key (%s) while mounting %s ' +
	        '(see: http://fb.me/react-context-by-parent)',
	        ownerBasedContext[key],
	        parentBasedContext[key],
	        key,
	        displayName
	      ) : null);
	    }
	  },
	
	  /**
	   * Perform an update to a mounted component. The componentWillReceiveProps and
	   * shouldComponentUpdate methods are called, then (assuming the update isn't
	   * skipped) the remaining update lifecycle methods are called and the DOM
	   * representation is updated.
	   *
	   * By default, this implements React's rendering and reconciliation algorithm.
	   * Sophisticated clients may wish to override this.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevParentElement
	   * @param {ReactElement} nextParentElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function(
	    transaction,
	    prevParentElement,
	    nextParentElement,
	    prevUnmaskedContext,
	    nextUnmaskedContext
	  ) {
	    var inst = this._instance;
	
	    var nextContext = inst.context;
	    var nextProps = inst.props;
	
	    // Distinguish between a props update versus a simple state update
	    if (prevParentElement !== nextParentElement) {
	      nextContext = this._processContext(nextParentElement._context);
	      nextProps = this._processProps(nextParentElement.props);
	
	      if (false) {
	        if (nextUnmaskedContext != null) {
	          this._warnIfContextsDiffer(
	            nextParentElement._context,
	            nextUnmaskedContext
	          );
	        }
	      }
	
	      // An update here will schedule an update but immediately set
	      // _pendingStateQueue which will ensure that any state updates gets
	      // immediately reconciled instead of waiting for the next batch.
	
	      if (inst.componentWillReceiveProps) {
	        inst.componentWillReceiveProps(nextProps, nextContext);
	      }
	    }
	
	    var nextState = this._processPendingState(nextProps, nextContext);
	
	    var shouldUpdate =
	      this._pendingForceUpdate ||
	      !inst.shouldComponentUpdate ||
	      inst.shouldComponentUpdate(nextProps, nextState, nextContext);
	
	    if (false) {
	      ("production" !== process.env.NODE_ENV ? warning(
	        typeof shouldUpdate !== 'undefined',
	        '%s.shouldComponentUpdate(): Returned undefined instead of a ' +
	        'boolean value. Make sure to return true or false.',
	        this.getName() || 'ReactCompositeComponent'
	      ) : null);
	    }
	
	    if (shouldUpdate) {
	      this._pendingForceUpdate = false;
	      // Will set `this.props`, `this.state` and `this.context`.
	      this._performComponentUpdate(
	        nextParentElement,
	        nextProps,
	        nextState,
	        nextContext,
	        transaction,
	        nextUnmaskedContext
	      );
	    } else {
	      // If it's determined that a component should not update, we still want
	      // to set props and state but we shortcut the rest of the update.
	      this._currentElement = nextParentElement;
	      this._context = nextUnmaskedContext;
	      inst.props = nextProps;
	      inst.state = nextState;
	      inst.context = nextContext;
	    }
	  },
	
	  _processPendingState: function(props, context) {
	    var inst = this._instance;
	    var queue = this._pendingStateQueue;
	    var replace = this._pendingReplaceState;
	    this._pendingReplaceState = false;
	    this._pendingStateQueue = null;
	
	    if (!queue) {
	      return inst.state;
	    }
	
	    if (replace && queue.length === 1) {
	      return queue[0];
	    }
	
	    var nextState = assign({}, replace ? queue[0] : inst.state);
	    for (var i = replace ? 1 : 0; i < queue.length; i++) {
	      var partial = queue[i];
	      assign(
	        nextState,
	        typeof partial === 'function' ?
	          partial.call(inst, nextState, props, context) :
	          partial
	      );
	    }
	
	    return nextState;
	  },
	
	  /**
	   * Merges new props and state, notifies delegate methods of update and
	   * performs update.
	   *
	   * @param {ReactElement} nextElement Next element
	   * @param {object} nextProps Next public object to set as properties.
	   * @param {?object} nextState Next object to set as state.
	   * @param {?object} nextContext Next public object to set as context.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {?object} unmaskedContext
	   * @private
	   */
	  _performComponentUpdate: function(
	    nextElement,
	    nextProps,
	    nextState,
	    nextContext,
	    transaction,
	    unmaskedContext
	  ) {
	    var inst = this._instance;
	
	    var prevProps = inst.props;
	    var prevState = inst.state;
	    var prevContext = inst.context;
	
	    if (inst.componentWillUpdate) {
	      inst.componentWillUpdate(nextProps, nextState, nextContext);
	    }
	
	    this._currentElement = nextElement;
	    this._context = unmaskedContext;
	    inst.props = nextProps;
	    inst.state = nextState;
	    inst.context = nextContext;
	
	    this._updateRenderedComponent(transaction, unmaskedContext);
	
	    if (inst.componentDidUpdate) {
	      transaction.getReactMountReady().enqueue(
	        inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext),
	        inst
	      );
	    }
	  },
	
	  /**
	   * Call the component's `render` method and update the DOM accordingly.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  _updateRenderedComponent: function(transaction, context) {
	    var prevComponentInstance = this._renderedComponent;
	    var prevRenderedElement = prevComponentInstance._currentElement;
	    var childContext = this._getValidatedChildContext();
	    var nextRenderedElement = this._renderValidatedComponent(childContext);
	    if (shouldUpdateReactComponent(prevRenderedElement, nextRenderedElement)) {
	      ReactReconciler.receiveComponent(
	        prevComponentInstance,
	        nextRenderedElement,
	        transaction,
	        this._mergeChildContext(context, childContext)
	      );
	    } else {
	      // These two IDs are actually the same! But nothing should rely on that.
	      var thisID = this._rootNodeID;
	      var prevComponentID = prevComponentInstance._rootNodeID;
	      ReactReconciler.unmountComponent(prevComponentInstance);
	
	      this._renderedComponent = this._instantiateReactComponent(
	        nextRenderedElement,
	        this._currentElement.type
	      );
	      var nextMarkup = ReactReconciler.mountComponent(
	        this._renderedComponent,
	        thisID,
	        transaction,
	        this._mergeChildContext(context, childContext)
	      );
	      this._replaceNodeWithMarkupByID(prevComponentID, nextMarkup);
	    }
	  },
	
	  /**
	   * @protected
	   */
	  _replaceNodeWithMarkupByID: function(prevComponentID, nextMarkup) {
	    ReactComponentEnvironment.replaceNodeWithMarkupByID(
	      prevComponentID,
	      nextMarkup
	    );
	  },
	
	  /**
	   * @protected
	   */
	  _renderValidatedComponentWithoutOwnerOrContext: function() {
	    var inst = this._instance;
	    var renderedComponent = inst.render();
	    if (false) {
	      // We allow auto-mocks to proceed as if they're returning null.
	      if (typeof renderedComponent === 'undefined' &&
	          inst.render._isMockFunction) {
	        // This is probably bad practice. Consider warning here and
	        // deprecating this convenience.
	        renderedComponent = null;
	      }
	    }
	
	    return renderedComponent;
	  },
	
	  /**
	   * @private
	   */
	  _renderValidatedComponent: function(childContext) {
	    var renderedComponent;
	    var previousContext = ReactContext.current;
	    ReactContext.current = this._mergeChildContext(
	      this._currentElement._context,
	      childContext
	    );
	    ReactCurrentOwner.current = this;
	    try {
	      renderedComponent =
	        this._renderValidatedComponentWithoutOwnerOrContext();
	    } finally {
	      ReactContext.current = previousContext;
	      ReactCurrentOwner.current = null;
	    }
	    ( false ? invariant(
	      // TODO: An `isValidNode` function would probably be more appropriate
	      renderedComponent === null || renderedComponent === false ||
	      ReactElement.isValidElement(renderedComponent),
	      '%s.render(): A valid ReactComponent must be returned. You may have ' +
	        'returned undefined, an array or some other invalid object.',
	      this.getName() || 'ReactCompositeComponent'
	    ) : invariant(// TODO: An `isValidNode` function would probably be more appropriate
	    renderedComponent === null || renderedComponent === false ||
	    ReactElement.isValidElement(renderedComponent)));
	    return renderedComponent;
	  },
	
	  /**
	   * Lazily allocates the refs object and stores `component` as `ref`.
	   *
	   * @param {string} ref Reference name.
	   * @param {component} component Component to store as `ref`.
	   * @final
	   * @private
	   */
	  attachRef: function(ref, component) {
	    var inst = this.getPublicInstance();
	    var refs = inst.refs === emptyObject ? (inst.refs = {}) : inst.refs;
	    refs[ref] = component.getPublicInstance();
	  },
	
	  /**
	   * Detaches a reference name.
	   *
	   * @param {string} ref Name to dereference.
	   * @final
	   * @private
	   */
	  detachRef: function(ref) {
	    var refs = this.getPublicInstance().refs;
	    delete refs[ref];
	  },
	
	  /**
	   * Get a text description of the component that can be used to identify it
	   * in error messages.
	   * @return {string} The name or null.
	   * @internal
	   */
	  getName: function() {
	    var type = this._currentElement.type;
	    var constructor = this._instance && this._instance.constructor;
	    return (
	      type.displayName || (constructor && constructor.displayName) ||
	      type.name || (constructor && constructor.name) ||
	      null
	    );
	  },
	
	  /**
	   * Get the publicly accessible representation of this component - i.e. what
	   * is exposed by refs and returned by React.render. Can be null for stateless
	   * components.
	   *
	   * @return {ReactComponent} the public component instance.
	   * @internal
	   */
	  getPublicInstance: function() {
	    return this._instance;
	  },
	
	  // Stub
	  _instantiateReactComponent: null
	
	};
	
	ReactPerf.measureMethods(
	  ReactCompositeComponentMixin,
	  'ReactCompositeComponent',
	  {
	    mountComponent: 'mountComponent',
	    updateComponent: 'updateComponent',
	    _renderValidatedComponent: '_renderValidatedComponent'
	  }
	);
	
	var ReactCompositeComponent = {
	
	  Mixin: ReactCompositeComponentMixin
	
	};
	
	module.exports = ReactCompositeComponent;


/***/ },
/* 420 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOM
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(7);
	var ReactElementValidator = __webpack_require__(46);
	
	var mapObject = __webpack_require__(469);
	
	/**
	 * Create a factory that creates HTML tag elements.
	 *
	 * @param {string} tag Tag name (e.g. `div`).
	 * @private
	 */
	function createDOMFactory(tag) {
	  if (false) {
	    return ReactElementValidator.createFactory(tag);
	  }
	  return ReactElement.createFactory(tag);
	}
	
	/**
	 * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
	 * This is also accessible via `React.DOM`.
	 *
	 * @public
	 */
	var ReactDOM = mapObject({
	  a: 'a',
	  abbr: 'abbr',
	  address: 'address',
	  area: 'area',
	  article: 'article',
	  aside: 'aside',
	  audio: 'audio',
	  b: 'b',
	  base: 'base',
	  bdi: 'bdi',
	  bdo: 'bdo',
	  big: 'big',
	  blockquote: 'blockquote',
	  body: 'body',
	  br: 'br',
	  button: 'button',
	  canvas: 'canvas',
	  caption: 'caption',
	  cite: 'cite',
	  code: 'code',
	  col: 'col',
	  colgroup: 'colgroup',
	  data: 'data',
	  datalist: 'datalist',
	  dd: 'dd',
	  del: 'del',
	  details: 'details',
	  dfn: 'dfn',
	  dialog: 'dialog',
	  div: 'div',
	  dl: 'dl',
	  dt: 'dt',
	  em: 'em',
	  embed: 'embed',
	  fieldset: 'fieldset',
	  figcaption: 'figcaption',
	  figure: 'figure',
	  footer: 'footer',
	  form: 'form',
	  h1: 'h1',
	  h2: 'h2',
	  h3: 'h3',
	  h4: 'h4',
	  h5: 'h5',
	  h6: 'h6',
	  head: 'head',
	  header: 'header',
	  hr: 'hr',
	  html: 'html',
	  i: 'i',
	  iframe: 'iframe',
	  img: 'img',
	  input: 'input',
	  ins: 'ins',
	  kbd: 'kbd',
	  keygen: 'keygen',
	  label: 'label',
	  legend: 'legend',
	  li: 'li',
	  link: 'link',
	  main: 'main',
	  map: 'map',
	  mark: 'mark',
	  menu: 'menu',
	  menuitem: 'menuitem',
	  meta: 'meta',
	  meter: 'meter',
	  nav: 'nav',
	  noscript: 'noscript',
	  object: 'object',
	  ol: 'ol',
	  optgroup: 'optgroup',
	  option: 'option',
	  output: 'output',
	  p: 'p',
	  param: 'param',
	  picture: 'picture',
	  pre: 'pre',
	  progress: 'progress',
	  q: 'q',
	  rp: 'rp',
	  rt: 'rt',
	  ruby: 'ruby',
	  s: 's',
	  samp: 'samp',
	  script: 'script',
	  section: 'section',
	  select: 'select',
	  small: 'small',
	  source: 'source',
	  span: 'span',
	  strong: 'strong',
	  style: 'style',
	  sub: 'sub',
	  summary: 'summary',
	  sup: 'sup',
	  table: 'table',
	  tbody: 'tbody',
	  td: 'td',
	  textarea: 'textarea',
	  tfoot: 'tfoot',
	  th: 'th',
	  thead: 'thead',
	  time: 'time',
	  title: 'title',
	  tr: 'tr',
	  track: 'track',
	  u: 'u',
	  ul: 'ul',
	  'var': 'var',
	  video: 'video',
	  wbr: 'wbr',
	
	  // SVG
	  circle: 'circle',
	  clipPath: 'clipPath',
	  defs: 'defs',
	  ellipse: 'ellipse',
	  g: 'g',
	  line: 'line',
	  linearGradient: 'linearGradient',
	  mask: 'mask',
	  path: 'path',
	  pattern: 'pattern',
	  polygon: 'polygon',
	  polyline: 'polyline',
	  radialGradient: 'radialGradient',
	  rect: 'rect',
	  stop: 'stop',
	  svg: 'svg',
	  text: 'text',
	  tspan: 'tspan'
	
	}, createDOMFactory);
	
	module.exports = ReactDOM;


/***/ },
/* 421 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMButton
	 */
	
	'use strict';
	
	var AutoFocusMixin = __webpack_require__(59);
	var ReactBrowserComponentMixin = __webpack_require__(18);
	var ReactClass = __webpack_require__(13);
	var ReactElement = __webpack_require__(7);
	
	var keyMirror = __webpack_require__(48);
	
	var button = ReactElement.createFactory('button');
	
	var mouseListenerNames = keyMirror({
	  onClick: true,
	  onDoubleClick: true,
	  onMouseDown: true,
	  onMouseMove: true,
	  onMouseUp: true,
	  onClickCapture: true,
	  onDoubleClickCapture: true,
	  onMouseDownCapture: true,
	  onMouseMoveCapture: true,
	  onMouseUpCapture: true
	});
	
	/**
	 * Implements a <button> native component that does not receive mouse events
	 * when `disabled` is set.
	 */
	var ReactDOMButton = ReactClass.createClass({
	  displayName: 'ReactDOMButton',
	  tagName: 'BUTTON',
	
	  mixins: [AutoFocusMixin, ReactBrowserComponentMixin],
	
	  render: function() {
	    var props = {};
	
	    // Copy the props; except the mouse listeners if we're disabled
	    for (var key in this.props) {
	      if (this.props.hasOwnProperty(key) &&
	          (!this.props.disabled || !mouseListenerNames[key])) {
	        props[key] = this.props[key];
	      }
	    }
	
	    return button(props, this.props.children);
	  }
	
	});
	
	module.exports = ReactDOMButton;


/***/ },
/* 422 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMForm
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(12);
	var LocalEventTrapMixin = __webpack_require__(85);
	var ReactBrowserComponentMixin = __webpack_require__(18);
	var ReactClass = __webpack_require__(13);
	var ReactElement = __webpack_require__(7);
	
	var form = ReactElement.createFactory('form');
	
	/**
	 * Since onSubmit doesn't bubble OR capture on the top level in IE8, we need
	 * to capture it on the <form> element itself. There are lots of hacks we could
	 * do to accomplish this, but the most reliable is to make <form> a
	 * composite component and use `componentDidMount` to attach the event handlers.
	 */
	var ReactDOMForm = ReactClass.createClass({
	  displayName: 'ReactDOMForm',
	  tagName: 'FORM',
	
	  mixins: [ReactBrowserComponentMixin, LocalEventTrapMixin],
	
	  render: function() {
	    // TODO: Instead of using `ReactDOM` directly, we should use JSX. However,
	    // `jshint` fails to parse JSX so in order for linting to work in the open
	    // source repo, we need to just use `ReactDOM.form`.
	    return form(this.props);
	  },
	
	  componentDidMount: function() {
	    this.trapBubbledEvent(EventConstants.topLevelTypes.topReset, 'reset');
	    this.trapBubbledEvent(EventConstants.topLevelTypes.topSubmit, 'submit');
	  }
	});
	
	module.exports = ReactDOMForm;


/***/ },
/* 423 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMIframe
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(12);
	var LocalEventTrapMixin = __webpack_require__(85);
	var ReactBrowserComponentMixin = __webpack_require__(18);
	var ReactClass = __webpack_require__(13);
	var ReactElement = __webpack_require__(7);
	
	var iframe = ReactElement.createFactory('iframe');
	
	/**
	 * Since onLoad doesn't bubble OR capture on the top level in IE8, we need to
	 * capture it on the <iframe> element itself. There are lots of hacks we could
	 * do to accomplish this, but the most reliable is to make <iframe> a composite
	 * component and use `componentDidMount` to attach the event handlers.
	 */
	var ReactDOMIframe = ReactClass.createClass({
	  displayName: 'ReactDOMIframe',
	  tagName: 'IFRAME',
	
	  mixins: [ReactBrowserComponentMixin, LocalEventTrapMixin],
	
	  render: function() {
	    return iframe(this.props);
	  },
	
	  componentDidMount: function() {
	    this.trapBubbledEvent(EventConstants.topLevelTypes.topLoad, 'load');
	  }
	});
	
	module.exports = ReactDOMIframe;


/***/ },
/* 424 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMImg
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(12);
	var LocalEventTrapMixin = __webpack_require__(85);
	var ReactBrowserComponentMixin = __webpack_require__(18);
	var ReactClass = __webpack_require__(13);
	var ReactElement = __webpack_require__(7);
	
	var img = ReactElement.createFactory('img');
	
	/**
	 * Since onLoad doesn't bubble OR capture on the top level in IE8, we need to
	 * capture it on the <img> element itself. There are lots of hacks we could do
	 * to accomplish this, but the most reliable is to make <img> a composite
	 * component and use `componentDidMount` to attach the event handlers.
	 */
	var ReactDOMImg = ReactClass.createClass({
	  displayName: 'ReactDOMImg',
	  tagName: 'IMG',
	
	  mixins: [ReactBrowserComponentMixin, LocalEventTrapMixin],
	
	  render: function() {
	    return img(this.props);
	  },
	
	  componentDidMount: function() {
	    this.trapBubbledEvent(EventConstants.topLevelTypes.topLoad, 'load');
	    this.trapBubbledEvent(EventConstants.topLevelTypes.topError, 'error');
	  }
	});
	
	module.exports = ReactDOMImg;


/***/ },
/* 425 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMInput
	 */
	
	'use strict';
	
	var AutoFocusMixin = __webpack_require__(59);
	var DOMPropertyOperations = __webpack_require__(43);
	var LinkedValueUtils = __webpack_require__(84);
	var ReactBrowserComponentMixin = __webpack_require__(18);
	var ReactClass = __webpack_require__(13);
	var ReactElement = __webpack_require__(7);
	var ReactMount = __webpack_require__(20);
	var ReactUpdates = __webpack_require__(14);
	
	var assign = __webpack_require__(5);
	var invariant = __webpack_require__(2);
	
	var input = ReactElement.createFactory('input');
	
	var instancesByReactID = {};
	
	function forceUpdateIfMounted() {
	  /*jshint validthis:true */
	  if (this.isMounted()) {
	    this.forceUpdate();
	  }
	}
	
	/**
	 * Implements an <input> native component that allows setting these optional
	 * props: `checked`, `value`, `defaultChecked`, and `defaultValue`.
	 *
	 * If `checked` or `value` are not supplied (or null/undefined), user actions
	 * that affect the checked state or value will trigger updates to the element.
	 *
	 * If they are supplied (and not null/undefined), the rendered element will not
	 * trigger updates to the element. Instead, the props must change in order for
	 * the rendered element to be updated.
	 *
	 * The rendered element will be initialized as unchecked (or `defaultChecked`)
	 * with an empty value (or `defaultValue`).
	 *
	 * @see http://www.w3.org/TR/2012/WD-html5-20121025/the-input-element.html
	 */
	var ReactDOMInput = ReactClass.createClass({
	  displayName: 'ReactDOMInput',
	  tagName: 'INPUT',
	
	  mixins: [AutoFocusMixin, LinkedValueUtils.Mixin, ReactBrowserComponentMixin],
	
	  getInitialState: function() {
	    var defaultValue = this.props.defaultValue;
	    return {
	      initialChecked: this.props.defaultChecked || false,
	      initialValue: defaultValue != null ? defaultValue : null
	    };
	  },
	
	  render: function() {
	    // Clone `this.props` so we don't mutate the input.
	    var props = assign({}, this.props);
	
	    props.defaultChecked = null;
	    props.defaultValue = null;
	
	    var value = LinkedValueUtils.getValue(this);
	    props.value = value != null ? value : this.state.initialValue;
	
	    var checked = LinkedValueUtils.getChecked(this);
	    props.checked = checked != null ? checked : this.state.initialChecked;
	
	    props.onChange = this._handleChange;
	
	    return input(props, this.props.children);
	  },
	
	  componentDidMount: function() {
	    var id = ReactMount.getID(this.getDOMNode());
	    instancesByReactID[id] = this;
	  },
	
	  componentWillUnmount: function() {
	    var rootNode = this.getDOMNode();
	    var id = ReactMount.getID(rootNode);
	    delete instancesByReactID[id];
	  },
	
	  componentDidUpdate: function(prevProps, prevState, prevContext) {
	    var rootNode = this.getDOMNode();
	    if (this.props.checked != null) {
	      DOMPropertyOperations.setValueForProperty(
	        rootNode,
	        'checked',
	        this.props.checked || false
	      );
	    }
	
	    var value = LinkedValueUtils.getValue(this);
	    if (value != null) {
	      // Cast `value` to a string to ensure the value is set correctly. While
	      // browsers typically do this as necessary, jsdom doesn't.
	      DOMPropertyOperations.setValueForProperty(rootNode, 'value', '' + value);
	    }
	  },
	
	  _handleChange: function(event) {
	    var returnValue;
	    var onChange = LinkedValueUtils.getOnChange(this);
	    if (onChange) {
	      returnValue = onChange.call(this, event);
	    }
	    // Here we use asap to wait until all updates have propagated, which
	    // is important when using controlled components within layers:
	    // https://github.com/facebook/react/issues/1698
	    ReactUpdates.asap(forceUpdateIfMounted, this);
	
	    var name = this.props.name;
	    if (this.props.type === 'radio' && name != null) {
	      var rootNode = this.getDOMNode();
	      var queryRoot = rootNode;
	
	      while (queryRoot.parentNode) {
	        queryRoot = queryRoot.parentNode;
	      }
	
	      // If `rootNode.form` was non-null, then we could try `form.elements`,
	      // but that sometimes behaves strangely in IE8. We could also try using
	      // `form.getElementsByName`, but that will only return direct children
	      // and won't include inputs that use the HTML5 `form=` attribute. Since
	      // the input might not even be in a form, let's just use the global
	      // `querySelectorAll` to ensure we don't miss anything.
	      var group = queryRoot.querySelectorAll(
	        'input[name=' + JSON.stringify('' + name) + '][type="radio"]');
	
	      for (var i = 0, groupLen = group.length; i < groupLen; i++) {
	        var otherNode = group[i];
	        if (otherNode === rootNode ||
	            otherNode.form !== rootNode.form) {
	          continue;
	        }
	        var otherID = ReactMount.getID(otherNode);
	        ( false ? invariant(
	          otherID,
	          'ReactDOMInput: Mixing React and non-React radio inputs with the ' +
	          'same `name` is not supported.'
	        ) : invariant(otherID));
	        var otherInstance = instancesByReactID[otherID];
	        ( false ? invariant(
	          otherInstance,
	          'ReactDOMInput: Unknown radio button ID %s.',
	          otherID
	        ) : invariant(otherInstance));
	        // If this is a controlled radio button group, forcing the input that
	        // was previously checked to update will cause it to be come re-checked
	        // as appropriate.
	        ReactUpdates.asap(forceUpdateIfMounted, otherInstance);
	      }
	    }
	
	    return returnValue;
	  }
	
	});
	
	module.exports = ReactDOMInput;


/***/ },
/* 426 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMOption
	 */
	
	'use strict';
	
	var ReactBrowserComponentMixin = __webpack_require__(18);
	var ReactClass = __webpack_require__(13);
	var ReactElement = __webpack_require__(7);
	
	var warning = __webpack_require__(6);
	
	var option = ReactElement.createFactory('option');
	
	/**
	 * Implements an <option> native component that warns when `selected` is set.
	 */
	var ReactDOMOption = ReactClass.createClass({
	  displayName: 'ReactDOMOption',
	  tagName: 'OPTION',
	
	  mixins: [ReactBrowserComponentMixin],
	
	  componentWillMount: function() {
	    // TODO (yungsters): Remove support for `selected` in <option>.
	    if (false) {
	      ("production" !== process.env.NODE_ENV ? warning(
	        this.props.selected == null,
	        'Use the `defaultValue` or `value` props on <select> instead of ' +
	        'setting `selected` on <option>.'
	      ) : null);
	    }
	  },
	
	  render: function() {
	    return option(this.props, this.props.children);
	  }
	
	});
	
	module.exports = ReactDOMOption;


/***/ },
/* 427 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMSelect
	 */
	
	'use strict';
	
	var AutoFocusMixin = __webpack_require__(59);
	var LinkedValueUtils = __webpack_require__(84);
	var ReactBrowserComponentMixin = __webpack_require__(18);
	var ReactClass = __webpack_require__(13);
	var ReactElement = __webpack_require__(7);
	var ReactUpdates = __webpack_require__(14);
	
	var assign = __webpack_require__(5);
	
	var select = ReactElement.createFactory('select');
	
	function updateOptionsIfPendingUpdateAndMounted() {
	  /*jshint validthis:true */
	  if (this._pendingUpdate) {
	    this._pendingUpdate = false;
	    var value = LinkedValueUtils.getValue(this);
	    if (value != null && this.isMounted()) {
	      updateOptions(this, value);
	    }
	  }
	}
	
	/**
	 * Validation function for `value` and `defaultValue`.
	 * @private
	 */
	function selectValueType(props, propName, componentName) {
	  if (props[propName] == null) {
	    return null;
	  }
	  if (props.multiple) {
	    if (!Array.isArray(props[propName])) {
	      return new Error(
	        ("The `" + propName + "` prop supplied to <select> must be an array if ") +
	        ("`multiple` is true.")
	      );
	    }
	  } else {
	    if (Array.isArray(props[propName])) {
	      return new Error(
	        ("The `" + propName + "` prop supplied to <select> must be a scalar ") +
	        ("value if `multiple` is false.")
	      );
	    }
	  }
	}
	
	/**
	 * @param {ReactComponent} component Instance of ReactDOMSelect
	 * @param {*} propValue A stringable (with `multiple`, a list of stringables).
	 * @private
	 */
	function updateOptions(component, propValue) {
	  var selectedValue, i, l;
	  var options = component.getDOMNode().options;
	
	  if (component.props.multiple) {
	    selectedValue = {};
	    for (i = 0, l = propValue.length; i < l; i++) {
	      selectedValue['' + propValue[i]] = true;
	    }
	    for (i = 0, l = options.length; i < l; i++) {
	      var selected = selectedValue.hasOwnProperty(options[i].value);
	      if (options[i].selected !== selected) {
	        options[i].selected = selected;
	      }
	    }
	  } else {
	    // Do not set `select.value` as exact behavior isn't consistent across all
	    // browsers for all cases.
	    selectedValue = '' + propValue;
	    for (i = 0, l = options.length; i < l; i++) {
	      if (options[i].value === selectedValue) {
	        options[i].selected = true;
	        return;
	      }
	    }
	    if (options.length) {
	      options[0].selected = true;
	    }
	  }
	}
	
	/**
	 * Implements a <select> native component that allows optionally setting the
	 * props `value` and `defaultValue`. If `multiple` is false, the prop must be a
	 * stringable. If `multiple` is true, the prop must be an array of stringables.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that change the
	 * selected option will trigger updates to the rendered options.
	 *
	 * If it is supplied (and not null/undefined), the rendered options will not
	 * update in response to user actions. Instead, the `value` prop must change in
	 * order for the rendered options to update.
	 *
	 * If `defaultValue` is provided, any options with the supplied values will be
	 * selected.
	 */
	var ReactDOMSelect = ReactClass.createClass({
	  displayName: 'ReactDOMSelect',
	  tagName: 'SELECT',
	
	  mixins: [AutoFocusMixin, LinkedValueUtils.Mixin, ReactBrowserComponentMixin],
	
	  propTypes: {
	    defaultValue: selectValueType,
	    value: selectValueType
	  },
	
	  render: function() {
	    // Clone `this.props` so we don't mutate the input.
	    var props = assign({}, this.props);
	
	    props.onChange = this._handleChange;
	    props.value = null;
	
	    return select(props, this.props.children);
	  },
	
	  componentWillMount: function() {
	    this._pendingUpdate = false;
	  },
	
	  componentDidMount: function() {
	    var value = LinkedValueUtils.getValue(this);
	    if (value != null) {
	      updateOptions(this, value);
	    } else if (this.props.defaultValue != null) {
	      updateOptions(this, this.props.defaultValue);
	    }
	  },
	
	  componentDidUpdate: function(prevProps) {
	    var value = LinkedValueUtils.getValue(this);
	    if (value != null) {
	      this._pendingUpdate = false;
	      updateOptions(this, value);
	    } else if (!prevProps.multiple !== !this.props.multiple) {
	      // For simplicity, reapply `defaultValue` if `multiple` is toggled.
	      if (this.props.defaultValue != null) {
	        updateOptions(this, this.props.defaultValue);
	      } else {
	        // Revert the select back to its default unselected state.
	        updateOptions(this, this.props.multiple ? [] : '');
	      }
	    }
	  },
	
	  _handleChange: function(event) {
	    var returnValue;
	    var onChange = LinkedValueUtils.getOnChange(this);
	    if (onChange) {
	      returnValue = onChange.call(this, event);
	    }
	
	    this._pendingUpdate = true;
	    ReactUpdates.asap(updateOptionsIfPendingUpdateAndMounted, this);
	    return returnValue;
	  }
	
	});
	
	module.exports = ReactDOMSelect;


/***/ },
/* 428 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMSelection
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(8);
	
	var getNodeForCharacterOffset = __webpack_require__(463);
	var getTextContentAccessor = __webpack_require__(161);
	
	/**
	 * While `isCollapsed` is available on the Selection object and `collapsed`
	 * is available on the Range object, IE11 sometimes gets them wrong.
	 * If the anchor/focus nodes and offsets are the same, the range is collapsed.
	 */
	function isCollapsed(anchorNode, anchorOffset, focusNode, focusOffset) {
	  return anchorNode === focusNode && anchorOffset === focusOffset;
	}
	
	/**
	 * Get the appropriate anchor and focus node/offset pairs for IE.
	 *
	 * The catch here is that IE's selection API doesn't provide information
	 * about whether the selection is forward or backward, so we have to
	 * behave as though it's always forward.
	 *
	 * IE text differs from modern selection in that it behaves as though
	 * block elements end with a new line. This means character offsets will
	 * differ between the two APIs.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getIEOffsets(node) {
	  var selection = document.selection;
	  var selectedRange = selection.createRange();
	  var selectedLength = selectedRange.text.length;
	
	  // Duplicate selection so we can move range without breaking user selection.
	  var fromStart = selectedRange.duplicate();
	  fromStart.moveToElementText(node);
	  fromStart.setEndPoint('EndToStart', selectedRange);
	
	  var startOffset = fromStart.text.length;
	  var endOffset = startOffset + selectedLength;
	
	  return {
	    start: startOffset,
	    end: endOffset
	  };
	}
	
	/**
	 * @param {DOMElement} node
	 * @return {?object}
	 */
	function getModernOffsets(node) {
	  var selection = window.getSelection && window.getSelection();
	
	  if (!selection || selection.rangeCount === 0) {
	    return null;
	  }
	
	  var anchorNode = selection.anchorNode;
	  var anchorOffset = selection.anchorOffset;
	  var focusNode = selection.focusNode;
	  var focusOffset = selection.focusOffset;
	
	  var currentRange = selection.getRangeAt(0);
	
	  // If the node and offset values are the same, the selection is collapsed.
	  // `Selection.isCollapsed` is available natively, but IE sometimes gets
	  // this value wrong.
	  var isSelectionCollapsed = isCollapsed(
	    selection.anchorNode,
	    selection.anchorOffset,
	    selection.focusNode,
	    selection.focusOffset
	  );
	
	  var rangeLength = isSelectionCollapsed ? 0 : currentRange.toString().length;
	
	  var tempRange = currentRange.cloneRange();
	  tempRange.selectNodeContents(node);
	  tempRange.setEnd(currentRange.startContainer, currentRange.startOffset);
	
	  var isTempRangeCollapsed = isCollapsed(
	    tempRange.startContainer,
	    tempRange.startOffset,
	    tempRange.endContainer,
	    tempRange.endOffset
	  );
	
	  var start = isTempRangeCollapsed ? 0 : tempRange.toString().length;
	  var end = start + rangeLength;
	
	  // Detect whether the selection is backward.
	  var detectionRange = document.createRange();
	  detectionRange.setStart(anchorNode, anchorOffset);
	  detectionRange.setEnd(focusNode, focusOffset);
	  var isBackward = detectionRange.collapsed;
	
	  return {
	    start: isBackward ? end : start,
	    end: isBackward ? start : end
	  };
	}
	
	/**
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setIEOffsets(node, offsets) {
	  var range = document.selection.createRange().duplicate();
	  var start, end;
	
	  if (typeof offsets.end === 'undefined') {
	    start = offsets.start;
	    end = start;
	  } else if (offsets.start > offsets.end) {
	    start = offsets.end;
	    end = offsets.start;
	  } else {
	    start = offsets.start;
	    end = offsets.end;
	  }
	
	  range.moveToElementText(node);
	  range.moveStart('character', start);
	  range.setEndPoint('EndToStart', range);
	  range.moveEnd('character', end - start);
	  range.select();
	}
	
	/**
	 * In modern non-IE browsers, we can support both forward and backward
	 * selections.
	 *
	 * Note: IE10+ supports the Selection object, but it does not support
	 * the `extend` method, which means that even in modern IE, it's not possible
	 * to programatically create a backward selection. Thus, for all IE
	 * versions, we use the old IE API to create our selections.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setModernOffsets(node, offsets) {
	  if (!window.getSelection) {
	    return;
	  }
	
	  var selection = window.getSelection();
	  var length = node[getTextContentAccessor()].length;
	  var start = Math.min(offsets.start, length);
	  var end = typeof offsets.end === 'undefined' ?
	            start : Math.min(offsets.end, length);
	
	  // IE 11 uses modern selection, but doesn't support the extend method.
	  // Flip backward selections, so we can set with a single range.
	  if (!selection.extend && start > end) {
	    var temp = end;
	    end = start;
	    start = temp;
	  }
	
	  var startMarker = getNodeForCharacterOffset(node, start);
	  var endMarker = getNodeForCharacterOffset(node, end);
	
	  if (startMarker && endMarker) {
	    var range = document.createRange();
	    range.setStart(startMarker.node, startMarker.offset);
	    selection.removeAllRanges();
	
	    if (start > end) {
	      selection.addRange(range);
	      selection.extend(endMarker.node, endMarker.offset);
	    } else {
	      range.setEnd(endMarker.node, endMarker.offset);
	      selection.addRange(range);
	    }
	  }
	}
	
	var useIEOffsets = (
	  ExecutionEnvironment.canUseDOM &&
	  'selection' in document &&
	  !('getSelection' in window)
	);
	
	var ReactDOMSelection = {
	  /**
	   * @param {DOMElement} node
	   */
	  getOffsets: useIEOffsets ? getIEOffsets : getModernOffsets,
	
	  /**
	   * @param {DOMElement|DOMTextNode} node
	   * @param {object} offsets
	   */
	  setOffsets: useIEOffsets ? setIEOffsets : setModernOffsets
	};
	
	module.exports = ReactDOMSelection;


/***/ },
/* 429 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMTextarea
	 */
	
	'use strict';
	
	var AutoFocusMixin = __webpack_require__(59);
	var DOMPropertyOperations = __webpack_require__(43);
	var LinkedValueUtils = __webpack_require__(84);
	var ReactBrowserComponentMixin = __webpack_require__(18);
	var ReactClass = __webpack_require__(13);
	var ReactElement = __webpack_require__(7);
	var ReactUpdates = __webpack_require__(14);
	
	var assign = __webpack_require__(5);
	var invariant = __webpack_require__(2);
	
	var warning = __webpack_require__(6);
	
	var textarea = ReactElement.createFactory('textarea');
	
	function forceUpdateIfMounted() {
	  /*jshint validthis:true */
	  if (this.isMounted()) {
	    this.forceUpdate();
	  }
	}
	
	/**
	 * Implements a <textarea> native component that allows setting `value`, and
	 * `defaultValue`. This differs from the traditional DOM API because value is
	 * usually set as PCDATA children.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that affect the
	 * value will trigger updates to the element.
	 *
	 * If `value` is supplied (and not null/undefined), the rendered element will
	 * not trigger updates to the element. Instead, the `value` prop must change in
	 * order for the rendered element to be updated.
	 *
	 * The rendered element will be initialized with an empty value, the prop
	 * `defaultValue` if specified, or the children content (deprecated).
	 */
	var ReactDOMTextarea = ReactClass.createClass({
	  displayName: 'ReactDOMTextarea',
	  tagName: 'TEXTAREA',
	
	  mixins: [AutoFocusMixin, LinkedValueUtils.Mixin, ReactBrowserComponentMixin],
	
	  getInitialState: function() {
	    var defaultValue = this.props.defaultValue;
	    // TODO (yungsters): Remove support for children content in <textarea>.
	    var children = this.props.children;
	    if (children != null) {
	      if (false) {
	        ("production" !== process.env.NODE_ENV ? warning(
	          false,
	          'Use the `defaultValue` or `value` props instead of setting ' +
	          'children on <textarea>.'
	        ) : null);
	      }
	      ( false ? invariant(
	        defaultValue == null,
	        'If you supply `defaultValue` on a <textarea>, do not pass children.'
	      ) : invariant(defaultValue == null));
	      if (Array.isArray(children)) {
	        ( false ? invariant(
	          children.length <= 1,
	          '<textarea> can only have at most one child.'
	        ) : invariant(children.length <= 1));
	        children = children[0];
	      }
	
	      defaultValue = '' + children;
	    }
	    if (defaultValue == null) {
	      defaultValue = '';
	    }
	    var value = LinkedValueUtils.getValue(this);
	    return {
	      // We save the initial value so that `ReactDOMComponent` doesn't update
	      // `textContent` (unnecessary since we update value).
	      // The initial value can be a boolean or object so that's why it's
	      // forced to be a string.
	      initialValue: '' + (value != null ? value : defaultValue)
	    };
	  },
	
	  render: function() {
	    // Clone `this.props` so we don't mutate the input.
	    var props = assign({}, this.props);
	
	    ( false ? invariant(
	      props.dangerouslySetInnerHTML == null,
	      '`dangerouslySetInnerHTML` does not make sense on <textarea>.'
	    ) : invariant(props.dangerouslySetInnerHTML == null));
	
	    props.defaultValue = null;
	    props.value = null;
	    props.onChange = this._handleChange;
	
	    // Always set children to the same thing. In IE9, the selection range will
	    // get reset if `textContent` is mutated.
	    return textarea(props, this.state.initialValue);
	  },
	
	  componentDidUpdate: function(prevProps, prevState, prevContext) {
	    var value = LinkedValueUtils.getValue(this);
	    if (value != null) {
	      var rootNode = this.getDOMNode();
	      // Cast `value` to a string to ensure the value is set correctly. While
	      // browsers typically do this as necessary, jsdom doesn't.
	      DOMPropertyOperations.setValueForProperty(rootNode, 'value', '' + value);
	    }
	  },
	
	  _handleChange: function(event) {
	    var returnValue;
	    var onChange = LinkedValueUtils.getOnChange(this);
	    if (onChange) {
	      returnValue = onChange.call(this, event);
	    }
	    ReactUpdates.asap(forceUpdateIfMounted, this);
	    return returnValue;
	  }
	
	});
	
	module.exports = ReactDOMTextarea;


/***/ },
/* 430 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDefaultBatchingStrategy
	 */
	
	'use strict';
	
	var ReactUpdates = __webpack_require__(14);
	var Transaction = __webpack_require__(64);
	
	var assign = __webpack_require__(5);
	var emptyFunction = __webpack_require__(24);
	
	var RESET_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: function() {
	    ReactDefaultBatchingStrategy.isBatchingUpdates = false;
	  }
	};
	
	var FLUSH_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: ReactUpdates.flushBatchedUpdates.bind(ReactUpdates)
	};
	
	var TRANSACTION_WRAPPERS = [FLUSH_BATCHED_UPDATES, RESET_BATCHED_UPDATES];
	
	function ReactDefaultBatchingStrategyTransaction() {
	  this.reinitializeTransaction();
	}
	
	assign(
	  ReactDefaultBatchingStrategyTransaction.prototype,
	  Transaction.Mixin,
	  {
	    getTransactionWrappers: function() {
	      return TRANSACTION_WRAPPERS;
	    }
	  }
	);
	
	var transaction = new ReactDefaultBatchingStrategyTransaction();
	
	var ReactDefaultBatchingStrategy = {
	  isBatchingUpdates: false,
	
	  /**
	   * Call the provided function in a context within which calls to `setState`
	   * and friends are batched such that components aren't updated unnecessarily.
	   */
	  batchedUpdates: function(callback, a, b, c, d) {
	    var alreadyBatchingUpdates = ReactDefaultBatchingStrategy.isBatchingUpdates;
	
	    ReactDefaultBatchingStrategy.isBatchingUpdates = true;
	
	    // The code is written this way to avoid extra allocations
	    if (alreadyBatchingUpdates) {
	      callback(a, b, c, d);
	    } else {
	      transaction.perform(callback, null, a, b, c, d);
	    }
	  }
	};
	
	module.exports = ReactDefaultBatchingStrategy;


/***/ },
/* 431 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDefaultInjection
	 */
	
	'use strict';
	
	var BeforeInputEventPlugin = __webpack_require__(405);
	var ChangeEventPlugin = __webpack_require__(406);
	var ClientReactRootIndex = __webpack_require__(407);
	var DefaultEventPluginOrder = __webpack_require__(410);
	var EnterLeaveEventPlugin = __webpack_require__(411);
	var ExecutionEnvironment = __webpack_require__(8);
	var HTMLDOMPropertyConfig = __webpack_require__(414);
	var MobileSafariClickEventPlugin = __webpack_require__(415);
	var ReactBrowserComponentMixin = __webpack_require__(18);
	var ReactClass = __webpack_require__(13);
	var ReactComponentBrowserEnvironment =
	  __webpack_require__(86);
	var ReactDefaultBatchingStrategy = __webpack_require__(430);
	var ReactDOMComponent = __webpack_require__(89);
	var ReactDOMButton = __webpack_require__(421);
	var ReactDOMForm = __webpack_require__(422);
	var ReactDOMImg = __webpack_require__(424);
	var ReactDOMIDOperations = __webpack_require__(146);
	var ReactDOMIframe = __webpack_require__(423);
	var ReactDOMInput = __webpack_require__(425);
	var ReactDOMOption = __webpack_require__(426);
	var ReactDOMSelect = __webpack_require__(427);
	var ReactDOMTextarea = __webpack_require__(429);
	var ReactDOMTextComponent = __webpack_require__(147);
	var ReactElement = __webpack_require__(7);
	var ReactEventListener = __webpack_require__(434);
	var ReactInjection = __webpack_require__(435);
	var ReactInstanceHandles = __webpack_require__(35);
	var ReactMount = __webpack_require__(20);
	var ReactReconcileTransaction = __webpack_require__(438);
	var SelectEventPlugin = __webpack_require__(443);
	var ServerReactRootIndex = __webpack_require__(444);
	var SimpleEventPlugin = __webpack_require__(445);
	var SVGDOMPropertyConfig = __webpack_require__(442);
	
	var createFullPageComponent = __webpack_require__(458);
	
	function autoGenerateWrapperClass(type) {
	  return ReactClass.createClass({
	    tagName: type.toUpperCase(),
	    render: function() {
	      return new ReactElement(
	        type,
	        null,
	        null,
	        null,
	        null,
	        this.props
	      );
	    }
	  });
	}
	
	function inject() {
	  ReactInjection.EventEmitter.injectReactEventListener(
	    ReactEventListener
	  );
	
	  /**
	   * Inject modules for resolving DOM hierarchy and plugin ordering.
	   */
	  ReactInjection.EventPluginHub.injectEventPluginOrder(DefaultEventPluginOrder);
	  ReactInjection.EventPluginHub.injectInstanceHandle(ReactInstanceHandles);
	  ReactInjection.EventPluginHub.injectMount(ReactMount);
	
	  /**
	   * Some important event plugins included by default (without having to require
	   * them).
	   */
	  ReactInjection.EventPluginHub.injectEventPluginsByName({
	    SimpleEventPlugin: SimpleEventPlugin,
	    EnterLeaveEventPlugin: EnterLeaveEventPlugin,
	    ChangeEventPlugin: ChangeEventPlugin,
	    MobileSafariClickEventPlugin: MobileSafariClickEventPlugin,
	    SelectEventPlugin: SelectEventPlugin,
	    BeforeInputEventPlugin: BeforeInputEventPlugin
	  });
	
	  ReactInjection.NativeComponent.injectGenericComponentClass(
	    ReactDOMComponent
	  );
	
	  ReactInjection.NativeComponent.injectTextComponentClass(
	    ReactDOMTextComponent
	  );
	
	  ReactInjection.NativeComponent.injectAutoWrapper(
	    autoGenerateWrapperClass
	  );
	
	  // This needs to happen before createFullPageComponent() otherwise the mixin
	  // won't be included.
	  ReactInjection.Class.injectMixin(ReactBrowserComponentMixin);
	
	  ReactInjection.NativeComponent.injectComponentClasses({
	    'button': ReactDOMButton,
	    'form': ReactDOMForm,
	    'iframe': ReactDOMIframe,
	    'img': ReactDOMImg,
	    'input': ReactDOMInput,
	    'option': ReactDOMOption,
	    'select': ReactDOMSelect,
	    'textarea': ReactDOMTextarea,
	
	    'html': createFullPageComponent('html'),
	    'head': createFullPageComponent('head'),
	    'body': createFullPageComponent('body')
	  });
	
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(HTMLDOMPropertyConfig);
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(SVGDOMPropertyConfig);
	
	  ReactInjection.EmptyComponent.injectEmptyComponent('noscript');
	
	  ReactInjection.Updates.injectReconcileTransaction(
	    ReactReconcileTransaction
	  );
	  ReactInjection.Updates.injectBatchingStrategy(
	    ReactDefaultBatchingStrategy
	  );
	
	  ReactInjection.RootIndex.injectCreateReactRootIndex(
	    ExecutionEnvironment.canUseDOM ?
	      ClientReactRootIndex.createReactRootIndex :
	      ServerReactRootIndex.createReactRootIndex
	  );
	
	  ReactInjection.Component.injectEnvironment(ReactComponentBrowserEnvironment);
	  ReactInjection.DOMComponent.injectIDOperations(ReactDOMIDOperations);
	
	  if (false) {
	    var url = (ExecutionEnvironment.canUseDOM && window.location.href) || '';
	    if ((/[?&]react_perf\b/).test(url)) {
	      var ReactDefaultPerf = require("./ReactDefaultPerf");
	      ReactDefaultPerf.start();
	    }
	  }
	}
	
	module.exports = {
	  inject: inject
	};


/***/ },
/* 432 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactErrorUtils
	 * @typechecks
	 */
	
	"use strict";
	
	var ReactErrorUtils = {
	  /**
	   * Creates a guarded version of a function. This is supposed to make debugging
	   * of event handlers easier. To aid debugging with the browser's debugger,
	   * this currently simply returns the original function.
	   *
	   * @param {function} func Function to be executed
	   * @param {string} name The name of the guard
	   * @return {function}
	   */
	  guard: function(func, name) {
	    return func;
	  }
	};
	
	module.exports = ReactErrorUtils;


/***/ },
/* 433 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactEventEmitterMixin
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(44);
	
	function runEventQueueInBatch(events) {
	  EventPluginHub.enqueueEvents(events);
	  EventPluginHub.processEventQueue();
	}
	
	var ReactEventEmitterMixin = {
	
	  /**
	   * Streams a fired top-level event to `EventPluginHub` where plugins have the
	   * opportunity to create `ReactEvent`s to be dispatched.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {object} topLevelTarget The listening component root node.
	   * @param {string} topLevelTargetID ID of `topLevelTarget`.
	   * @param {object} nativeEvent Native environment event.
	   */
	  handleTopLevel: function(
	      topLevelType,
	      topLevelTarget,
	      topLevelTargetID,
	      nativeEvent) {
	    var events = EventPluginHub.extractEvents(
	      topLevelType,
	      topLevelTarget,
	      topLevelTargetID,
	      nativeEvent
	    );
	
	    runEventQueueInBatch(events);
	  }
	};
	
	module.exports = ReactEventEmitterMixin;


/***/ },
/* 434 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactEventListener
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var EventListener = __webpack_require__(412);
	var ExecutionEnvironment = __webpack_require__(8);
	var PooledClass = __webpack_require__(17);
	var ReactInstanceHandles = __webpack_require__(35);
	var ReactMount = __webpack_require__(20);
	var ReactUpdates = __webpack_require__(14);
	
	var assign = __webpack_require__(5);
	var getEventTarget = __webpack_require__(98);
	var getUnboundedScrollPosition = __webpack_require__(465);
	
	/**
	 * Finds the parent React component of `node`.
	 *
	 * @param {*} node
	 * @return {?DOMEventTarget} Parent container, or `null` if the specified node
	 *                           is not nested.
	 */
	function findParent(node) {
	  // TODO: It may be a good idea to cache this to prevent unnecessary DOM
	  // traversal, but caching is difficult to do correctly without using a
	  // mutation observer to listen for all DOM changes.
	  var nodeID = ReactMount.getID(node);
	  var rootID = ReactInstanceHandles.getReactRootIDFromNodeID(nodeID);
	  var container = ReactMount.findReactContainerForID(rootID);
	  var parent = ReactMount.getFirstReactDOM(container);
	  return parent;
	}
	
	// Used to store ancestor hierarchy in top level callback
	function TopLevelCallbackBookKeeping(topLevelType, nativeEvent) {
	  this.topLevelType = topLevelType;
	  this.nativeEvent = nativeEvent;
	  this.ancestors = [];
	}
	assign(TopLevelCallbackBookKeeping.prototype, {
	  destructor: function() {
	    this.topLevelType = null;
	    this.nativeEvent = null;
	    this.ancestors.length = 0;
	  }
	});
	PooledClass.addPoolingTo(
	  TopLevelCallbackBookKeeping,
	  PooledClass.twoArgumentPooler
	);
	
	function handleTopLevelImpl(bookKeeping) {
	  var topLevelTarget = ReactMount.getFirstReactDOM(
	    getEventTarget(bookKeeping.nativeEvent)
	  ) || window;
	
	  // Loop through the hierarchy, in case there's any nested components.
	  // It's important that we build the array of ancestors before calling any
	  // event handlers, because event handlers can modify the DOM, leading to
	  // inconsistencies with ReactMount's node cache. See #1105.
	  var ancestor = topLevelTarget;
	  while (ancestor) {
	    bookKeeping.ancestors.push(ancestor);
	    ancestor = findParent(ancestor);
	  }
	
	  for (var i = 0, l = bookKeeping.ancestors.length; i < l; i++) {
	    topLevelTarget = bookKeeping.ancestors[i];
	    var topLevelTargetID = ReactMount.getID(topLevelTarget) || '';
	    ReactEventListener._handleTopLevel(
	      bookKeeping.topLevelType,
	      topLevelTarget,
	      topLevelTargetID,
	      bookKeeping.nativeEvent
	    );
	  }
	}
	
	function scrollValueMonitor(cb) {
	  var scrollPosition = getUnboundedScrollPosition(window);
	  cb(scrollPosition);
	}
	
	var ReactEventListener = {
	  _enabled: true,
	  _handleTopLevel: null,
	
	  WINDOW_HANDLE: ExecutionEnvironment.canUseDOM ? window : null,
	
	  setHandleTopLevel: function(handleTopLevel) {
	    ReactEventListener._handleTopLevel = handleTopLevel;
	  },
	
	  setEnabled: function(enabled) {
	    ReactEventListener._enabled = !!enabled;
	  },
	
	  isEnabled: function() {
	    return ReactEventListener._enabled;
	  },
	
	
	  /**
	   * Traps top-level events by using event bubbling.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} handle Element on which to attach listener.
	   * @return {object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapBubbledEvent: function(topLevelType, handlerBaseName, handle) {
	    var element = handle;
	    if (!element) {
	      return null;
	    }
	    return EventListener.listen(
	      element,
	      handlerBaseName,
	      ReactEventListener.dispatchEvent.bind(null, topLevelType)
	    );
	  },
	
	  /**
	   * Traps a top-level event by using event capturing.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} handle Element on which to attach listener.
	   * @return {object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapCapturedEvent: function(topLevelType, handlerBaseName, handle) {
	    var element = handle;
	    if (!element) {
	      return null;
	    }
	    return EventListener.capture(
	      element,
	      handlerBaseName,
	      ReactEventListener.dispatchEvent.bind(null, topLevelType)
	    );
	  },
	
	  monitorScrollValue: function(refresh) {
	    var callback = scrollValueMonitor.bind(null, refresh);
	    EventListener.listen(window, 'scroll', callback);
	  },
	
	  dispatchEvent: function(topLevelType, nativeEvent) {
	    if (!ReactEventListener._enabled) {
	      return;
	    }
	
	    var bookKeeping = TopLevelCallbackBookKeeping.getPooled(
	      topLevelType,
	      nativeEvent
	    );
	    try {
	      // Event queue being processed in the same cycle allows
	      // `preventDefault`.
	      ReactUpdates.batchedUpdates(handleTopLevelImpl, bookKeeping);
	    } finally {
	      TopLevelCallbackBookKeeping.release(bookKeeping);
	    }
	  }
	};
	
	module.exports = ReactEventListener;


/***/ },
/* 435 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactInjection
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(33);
	var EventPluginHub = __webpack_require__(44);
	var ReactComponentEnvironment = __webpack_require__(87);
	var ReactClass = __webpack_require__(13);
	var ReactEmptyComponent = __webpack_require__(90);
	var ReactBrowserEventEmitter = __webpack_require__(34);
	var ReactNativeComponent = __webpack_require__(61);
	var ReactDOMComponent = __webpack_require__(89);
	var ReactPerf = __webpack_require__(27);
	var ReactRootIndex = __webpack_require__(153);
	var ReactUpdates = __webpack_require__(14);
	
	var ReactInjection = {
	  Component: ReactComponentEnvironment.injection,
	  Class: ReactClass.injection,
	  DOMComponent: ReactDOMComponent.injection,
	  DOMProperty: DOMProperty.injection,
	  EmptyComponent: ReactEmptyComponent.injection,
	  EventPluginHub: EventPluginHub.injection,
	  EventEmitter: ReactBrowserEventEmitter.injection,
	  NativeComponent: ReactNativeComponent.injection,
	  Perf: ReactPerf.injection,
	  RootIndex: ReactRootIndex.injection,
	  Updates: ReactUpdates.injection
	};
	
	module.exports = ReactInjection;


/***/ },
/* 436 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactMultiChild
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var ReactComponentEnvironment = __webpack_require__(87);
	var ReactMultiChildUpdateTypes = __webpack_require__(150);
	
	var ReactReconciler = __webpack_require__(37);
	var ReactChildReconciler = __webpack_require__(417);
	
	/**
	 * Updating children of a component may trigger recursive updates. The depth is
	 * used to batch recursive updates to render markup more efficiently.
	 *
	 * @type {number}
	 * @private
	 */
	var updateDepth = 0;
	
	/**
	 * Queue of update configuration objects.
	 *
	 * Each object has a `type` property that is in `ReactMultiChildUpdateTypes`.
	 *
	 * @type {array<object>}
	 * @private
	 */
	var updateQueue = [];
	
	/**
	 * Queue of markup to be rendered.
	 *
	 * @type {array<string>}
	 * @private
	 */
	var markupQueue = [];
	
	/**
	 * Enqueues markup to be rendered and inserted at a supplied index.
	 *
	 * @param {string} parentID ID of the parent component.
	 * @param {string} markup Markup that renders into an element.
	 * @param {number} toIndex Destination index.
	 * @private
	 */
	function enqueueMarkup(parentID, markup, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  updateQueue.push({
	    parentID: parentID,
	    parentNode: null,
	    type: ReactMultiChildUpdateTypes.INSERT_MARKUP,
	    markupIndex: markupQueue.push(markup) - 1,
	    textContent: null,
	    fromIndex: null,
	    toIndex: toIndex
	  });
	}
	
	/**
	 * Enqueues moving an existing element to another index.
	 *
	 * @param {string} parentID ID of the parent component.
	 * @param {number} fromIndex Source index of the existing element.
	 * @param {number} toIndex Destination index of the element.
	 * @private
	 */
	function enqueueMove(parentID, fromIndex, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  updateQueue.push({
	    parentID: parentID,
	    parentNode: null,
	    type: ReactMultiChildUpdateTypes.MOVE_EXISTING,
	    markupIndex: null,
	    textContent: null,
	    fromIndex: fromIndex,
	    toIndex: toIndex
	  });
	}
	
	/**
	 * Enqueues removing an element at an index.
	 *
	 * @param {string} parentID ID of the parent component.
	 * @param {number} fromIndex Index of the element to remove.
	 * @private
	 */
	function enqueueRemove(parentID, fromIndex) {
	  // NOTE: Null values reduce hidden classes.
	  updateQueue.push({
	    parentID: parentID,
	    parentNode: null,
	    type: ReactMultiChildUpdateTypes.REMOVE_NODE,
	    markupIndex: null,
	    textContent: null,
	    fromIndex: fromIndex,
	    toIndex: null
	  });
	}
	
	/**
	 * Enqueues setting the text content.
	 *
	 * @param {string} parentID ID of the parent component.
	 * @param {string} textContent Text content to set.
	 * @private
	 */
	function enqueueTextContent(parentID, textContent) {
	  // NOTE: Null values reduce hidden classes.
	  updateQueue.push({
	    parentID: parentID,
	    parentNode: null,
	    type: ReactMultiChildUpdateTypes.TEXT_CONTENT,
	    markupIndex: null,
	    textContent: textContent,
	    fromIndex: null,
	    toIndex: null
	  });
	}
	
	/**
	 * Processes any enqueued updates.
	 *
	 * @private
	 */
	function processQueue() {
	  if (updateQueue.length) {
	    ReactComponentEnvironment.processChildrenUpdates(
	      updateQueue,
	      markupQueue
	    );
	    clearQueue();
	  }
	}
	
	/**
	 * Clears any enqueued updates.
	 *
	 * @private
	 */
	function clearQueue() {
	  updateQueue.length = 0;
	  markupQueue.length = 0;
	}
	
	/**
	 * ReactMultiChild are capable of reconciling multiple children.
	 *
	 * @class ReactMultiChild
	 * @internal
	 */
	var ReactMultiChild = {
	
	  /**
	   * Provides common functionality for components that must reconcile multiple
	   * children. This is used by `ReactDOMComponent` to mount, update, and
	   * unmount child components.
	   *
	   * @lends {ReactMultiChild.prototype}
	   */
	  Mixin: {
	
	    /**
	     * Generates a "mount image" for each of the supplied children. In the case
	     * of `ReactDOMComponent`, a mount image is a string of markup.
	     *
	     * @param {?object} nestedChildren Nested child maps.
	     * @return {array} An array of mounted representations.
	     * @internal
	     */
	    mountChildren: function(nestedChildren, transaction, context) {
	      var children = ReactChildReconciler.instantiateChildren(
	        nestedChildren, transaction, context
	      );
	      this._renderedChildren = children;
	      var mountImages = [];
	      var index = 0;
	      for (var name in children) {
	        if (children.hasOwnProperty(name)) {
	          var child = children[name];
	          // Inlined for performance, see `ReactInstanceHandles.createReactID`.
	          var rootID = this._rootNodeID + name;
	          var mountImage = ReactReconciler.mountComponent(
	            child,
	            rootID,
	            transaction,
	            context
	          );
	          child._mountIndex = index;
	          mountImages.push(mountImage);
	          index++;
	        }
	      }
	      return mountImages;
	    },
	
	    /**
	     * Replaces any rendered children with a text content string.
	     *
	     * @param {string} nextContent String of content.
	     * @internal
	     */
	    updateTextContent: function(nextContent) {
	      updateDepth++;
	      var errorThrown = true;
	      try {
	        var prevChildren = this._renderedChildren;
	        // Remove any rendered children.
	        ReactChildReconciler.unmountChildren(prevChildren);
	        // TODO: The setTextContent operation should be enough
	        for (var name in prevChildren) {
	          if (prevChildren.hasOwnProperty(name)) {
	            this._unmountChildByName(prevChildren[name], name);
	          }
	        }
	        // Set new text content.
	        this.setTextContent(nextContent);
	        errorThrown = false;
	      } finally {
	        updateDepth--;
	        if (!updateDepth) {
	          if (errorThrown) {
	            clearQueue();
	          } else {
	            processQueue();
	          }
	        }
	      }
	    },
	
	    /**
	     * Updates the rendered children with new children.
	     *
	     * @param {?object} nextNestedChildren Nested child maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     */
	    updateChildren: function(nextNestedChildren, transaction, context) {
	      updateDepth++;
	      var errorThrown = true;
	      try {
	        this._updateChildren(nextNestedChildren, transaction, context);
	        errorThrown = false;
	      } finally {
	        updateDepth--;
	        if (!updateDepth) {
	          if (errorThrown) {
	            clearQueue();
	          } else {
	            processQueue();
	          }
	        }
	
	      }
	    },
	
	    /**
	     * Improve performance by isolating this hot code path from the try/catch
	     * block in `updateChildren`.
	     *
	     * @param {?object} nextNestedChildren Nested child maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @final
	     * @protected
	     */
	    _updateChildren: function(nextNestedChildren, transaction, context) {
	      var prevChildren = this._renderedChildren;
	      var nextChildren = ReactChildReconciler.updateChildren(
	        prevChildren, nextNestedChildren, transaction, context
	      );
	      this._renderedChildren = nextChildren;
	      if (!nextChildren && !prevChildren) {
	        return;
	      }
	      var name;
	      // `nextIndex` will increment for each child in `nextChildren`, but
	      // `lastIndex` will be the last index visited in `prevChildren`.
	      var lastIndex = 0;
	      var nextIndex = 0;
	      for (name in nextChildren) {
	        if (!nextChildren.hasOwnProperty(name)) {
	          continue;
	        }
	        var prevChild = prevChildren && prevChildren[name];
	        var nextChild = nextChildren[name];
	        if (prevChild === nextChild) {
	          this.moveChild(prevChild, nextIndex, lastIndex);
	          lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	          prevChild._mountIndex = nextIndex;
	        } else {
	          if (prevChild) {
	            // Update `lastIndex` before `_mountIndex` gets unset by unmounting.
	            lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	            this._unmountChildByName(prevChild, name);
	          }
	          // The child must be instantiated before it's mounted.
	          this._mountChildByNameAtIndex(
	            nextChild, name, nextIndex, transaction, context
	          );
	        }
	        nextIndex++;
	      }
	      // Remove children that are no longer present.
	      for (name in prevChildren) {
	        if (prevChildren.hasOwnProperty(name) &&
	            !(nextChildren && nextChildren.hasOwnProperty(name))) {
	          this._unmountChildByName(prevChildren[name], name);
	        }
	      }
	    },
	
	    /**
	     * Unmounts all rendered children. This should be used to clean up children
	     * when this component is unmounted.
	     *
	     * @internal
	     */
	    unmountChildren: function() {
	      var renderedChildren = this._renderedChildren;
	      ReactChildReconciler.unmountChildren(renderedChildren);
	      this._renderedChildren = null;
	    },
	
	    /**
	     * Moves a child component to the supplied index.
	     *
	     * @param {ReactComponent} child Component to move.
	     * @param {number} toIndex Destination index of the element.
	     * @param {number} lastIndex Last index visited of the siblings of `child`.
	     * @protected
	     */
	    moveChild: function(child, toIndex, lastIndex) {
	      // If the index of `child` is less than `lastIndex`, then it needs to
	      // be moved. Otherwise, we do not need to move it because a child will be
	      // inserted or moved before `child`.
	      if (child._mountIndex < lastIndex) {
	        enqueueMove(this._rootNodeID, child._mountIndex, toIndex);
	      }
	    },
	
	    /**
	     * Creates a child component.
	     *
	     * @param {ReactComponent} child Component to create.
	     * @param {string} mountImage Markup to insert.
	     * @protected
	     */
	    createChild: function(child, mountImage) {
	      enqueueMarkup(this._rootNodeID, mountImage, child._mountIndex);
	    },
	
	    /**
	     * Removes a child component.
	     *
	     * @param {ReactComponent} child Child to remove.
	     * @protected
	     */
	    removeChild: function(child) {
	      enqueueRemove(this._rootNodeID, child._mountIndex);
	    },
	
	    /**
	     * Sets this text content string.
	     *
	     * @param {string} textContent Text content to set.
	     * @protected
	     */
	    setTextContent: function(textContent) {
	      enqueueTextContent(this._rootNodeID, textContent);
	    },
	
	    /**
	     * Mounts a child with the supplied name.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to mount.
	     * @param {string} name Name of the child.
	     * @param {number} index Index at which to insert the child.
	     * @param {ReactReconcileTransaction} transaction
	     * @private
	     */
	    _mountChildByNameAtIndex: function(
	      child,
	      name,
	      index,
	      transaction,
	      context) {
	      // Inlined for performance, see `ReactInstanceHandles.createReactID`.
	      var rootID = this._rootNodeID + name;
	      var mountImage = ReactReconciler.mountComponent(
	        child,
	        rootID,
	        transaction,
	        context
	      );
	      child._mountIndex = index;
	      this.createChild(child, mountImage);
	    },
	
	    /**
	     * Unmounts a rendered child by name.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to unmount.
	     * @param {string} name Name of the child in `this._renderedChildren`.
	     * @private
	     */
	    _unmountChildByName: function(child, name) {
	      this.removeChild(child);
	      child._mountIndex = null;
	    }
	
	  }
	
	};
	
	module.exports = ReactMultiChild;


/***/ },
/* 437 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactOwner
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(2);
	
	/**
	 * ReactOwners are capable of storing references to owned components.
	 *
	 * All components are capable of //being// referenced by owner components, but
	 * only ReactOwner components are capable of //referencing// owned components.
	 * The named reference is known as a "ref".
	 *
	 * Refs are available when mounted and updated during reconciliation.
	 *
	 *   var MyComponent = React.createClass({
	 *     render: function() {
	 *       return (
	 *         <div onClick={this.handleClick}>
	 *           <CustomComponent ref="custom" />
	 *         </div>
	 *       );
	 *     },
	 *     handleClick: function() {
	 *       this.refs.custom.handleClick();
	 *     },
	 *     componentDidMount: function() {
	 *       this.refs.custom.initialize();
	 *     }
	 *   });
	 *
	 * Refs should rarely be used. When refs are used, they should only be done to
	 * control data that is not handled by React's data flow.
	 *
	 * @class ReactOwner
	 */
	var ReactOwner = {
	
	  /**
	   * @param {?object} object
	   * @return {boolean} True if `object` is a valid owner.
	   * @final
	   */
	  isValidOwner: function(object) {
	    return !!(
	      (object &&
	      typeof object.attachRef === 'function' && typeof object.detachRef === 'function')
	    );
	  },
	
	  /**
	   * Adds a component by ref to an owner component.
	   *
	   * @param {ReactComponent} component Component to reference.
	   * @param {string} ref Name by which to refer to the component.
	   * @param {ReactOwner} owner Component on which to record the ref.
	   * @final
	   * @internal
	   */
	  addComponentAsRefTo: function(component, ref, owner) {
	    ( false ? invariant(
	      ReactOwner.isValidOwner(owner),
	      'addComponentAsRefTo(...): Only a ReactOwner can have refs. This ' +
	      'usually means that you\'re trying to add a ref to a component that ' +
	      'doesn\'t have an owner (that is, was not created inside of another ' +
	      'component\'s `render` method). Try rendering this component inside of ' +
	      'a new top-level component which will hold the ref.'
	    ) : invariant(ReactOwner.isValidOwner(owner)));
	    owner.attachRef(ref, component);
	  },
	
	  /**
	   * Removes a component by ref from an owner component.
	   *
	   * @param {ReactComponent} component Component to dereference.
	   * @param {string} ref Name of the ref to remove.
	   * @param {ReactOwner} owner Component on which the ref is recorded.
	   * @final
	   * @internal
	   */
	  removeComponentAsRefFrom: function(component, ref, owner) {
	    ( false ? invariant(
	      ReactOwner.isValidOwner(owner),
	      'removeComponentAsRefFrom(...): Only a ReactOwner can have refs. This ' +
	      'usually means that you\'re trying to remove a ref to a component that ' +
	      'doesn\'t have an owner (that is, was not created inside of another ' +
	      'component\'s `render` method). Try rendering this component inside of ' +
	      'a new top-level component which will hold the ref.'
	    ) : invariant(ReactOwner.isValidOwner(owner)));
	    // Check that `component` is still the current ref because we do not want to
	    // detach the ref if another component stole it.
	    if (owner.getPublicInstance().refs[ref] === component.getPublicInstance()) {
	      owner.detachRef(ref);
	    }
	  }
	
	};
	
	module.exports = ReactOwner;


/***/ },
/* 438 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactReconcileTransaction
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var CallbackQueue = __webpack_require__(82);
	var PooledClass = __webpack_require__(17);
	var ReactBrowserEventEmitter = __webpack_require__(34);
	var ReactInputSelection = __webpack_require__(148);
	var ReactPutListenerQueue = __webpack_require__(152);
	var Transaction = __webpack_require__(64);
	
	var assign = __webpack_require__(5);
	
	/**
	 * Ensures that, when possible, the selection range (currently selected text
	 * input) is not disturbed by performing the transaction.
	 */
	var SELECTION_RESTORATION = {
	  /**
	   * @return {Selection} Selection information.
	   */
	  initialize: ReactInputSelection.getSelectionInformation,
	  /**
	   * @param {Selection} sel Selection information returned from `initialize`.
	   */
	  close: ReactInputSelection.restoreSelection
	};
	
	/**
	 * Suppresses events (blur/focus) that could be inadvertently dispatched due to
	 * high level DOM manipulations (like temporarily removing a text input from the
	 * DOM).
	 */
	var EVENT_SUPPRESSION = {
	  /**
	   * @return {boolean} The enabled status of `ReactBrowserEventEmitter` before
	   * the reconciliation.
	   */
	  initialize: function() {
	    var currentlyEnabled = ReactBrowserEventEmitter.isEnabled();
	    ReactBrowserEventEmitter.setEnabled(false);
	    return currentlyEnabled;
	  },
	
	  /**
	   * @param {boolean} previouslyEnabled Enabled status of
	   *   `ReactBrowserEventEmitter` before the reconciliation occured. `close`
	   *   restores the previous value.
	   */
	  close: function(previouslyEnabled) {
	    ReactBrowserEventEmitter.setEnabled(previouslyEnabled);
	  }
	};
	
	/**
	 * Provides a queue for collecting `componentDidMount` and
	 * `componentDidUpdate` callbacks during the the transaction.
	 */
	var ON_DOM_READY_QUEUEING = {
	  /**
	   * Initializes the internal `onDOMReady` queue.
	   */
	  initialize: function() {
	    this.reactMountReady.reset();
	  },
	
	  /**
	   * After DOM is flushed, invoke all registered `onDOMReady` callbacks.
	   */
	  close: function() {
	    this.reactMountReady.notifyAll();
	  }
	};
	
	var PUT_LISTENER_QUEUEING = {
	  initialize: function() {
	    this.putListenerQueue.reset();
	  },
	
	  close: function() {
	    this.putListenerQueue.putListeners();
	  }
	};
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [
	  PUT_LISTENER_QUEUEING,
	  SELECTION_RESTORATION,
	  EVENT_SUPPRESSION,
	  ON_DOM_READY_QUEUEING
	];
	
	/**
	 * Currently:
	 * - The order that these are listed in the transaction is critical:
	 * - Suppresses events.
	 * - Restores selection range.
	 *
	 * Future:
	 * - Restore document/overflow scroll positions that were unintentionally
	 *   modified via DOM insertions above the top viewport boundary.
	 * - Implement/integrate with customized constraint based layout system and keep
	 *   track of which dimensions must be remeasured.
	 *
	 * @class ReactReconcileTransaction
	 */
	function ReactReconcileTransaction() {
	  this.reinitializeTransaction();
	  // Only server-side rendering really needs this option (see
	  // `ReactServerRendering`), but server-side uses
	  // `ReactServerRenderingTransaction` instead. This option is here so that it's
	  // accessible and defaults to false when `ReactDOMComponent` and
	  // `ReactTextComponent` checks it in `mountComponent`.`
	  this.renderToStaticMarkup = false;
	  this.reactMountReady = CallbackQueue.getPooled(null);
	  this.putListenerQueue = ReactPutListenerQueue.getPooled();
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array<object>} List of operation wrap proceedures.
	   *   TODO: convert to array<TransactionWrapper>
	   */
	  getTransactionWrappers: function() {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function() {
	    return this.reactMountReady;
	  },
	
	  getPutListenerQueue: function() {
	    return this.putListenerQueue;
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be resused.
	   */
	  destructor: function() {
	    CallbackQueue.release(this.reactMountReady);
	    this.reactMountReady = null;
	
	    ReactPutListenerQueue.release(this.putListenerQueue);
	    this.putListenerQueue = null;
	  }
	};
	
	
	assign(ReactReconcileTransaction.prototype, Transaction.Mixin, Mixin);
	
	PooledClass.addPoolingTo(ReactReconcileTransaction);
	
	module.exports = ReactReconcileTransaction;


/***/ },
/* 439 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactRef
	 */
	
	'use strict';
	
	var ReactOwner = __webpack_require__(437);
	
	var ReactRef = {};
	
	function attachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(component.getPublicInstance());
	  } else {
	    // Legacy ref
	    ReactOwner.addComponentAsRefTo(component, ref, owner);
	  }
	}
	
	function detachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(null);
	  } else {
	    // Legacy ref
	    ReactOwner.removeComponentAsRefFrom(component, ref, owner);
	  }
	}
	
	ReactRef.attachRefs = function(instance, element) {
	  var ref = element.ref;
	  if (ref != null) {
	    attachRef(ref, instance, element._owner);
	  }
	};
	
	ReactRef.shouldUpdateRefs = function(prevElement, nextElement) {
	  // If either the owner or a `ref` has changed, make sure the newest owner
	  // has stored a reference to `this`, and the previous owner (if different)
	  // has forgotten the reference to `this`. We use the element instead
	  // of the public this.props because the post processing cannot determine
	  // a ref. The ref conceptually lives on the element.
	
	  // TODO: Should this even be possible? The owner cannot change because
	  // it's forbidden by shouldUpdateReactComponent. The ref can change
	  // if you swap the keys of but not the refs. Reconsider where this check
	  // is made. It probably belongs where the key checking and
	  // instantiateReactComponent is done.
	
	  return (
	    nextElement._owner !== prevElement._owner ||
	    nextElement.ref !== prevElement.ref
	  );
	};
	
	ReactRef.detachRefs = function(instance, element) {
	  var ref = element.ref;
	  if (ref != null) {
	    detachRef(ref, instance, element._owner);
	  }
	};
	
	module.exports = ReactRef;


/***/ },
/* 440 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks static-only
	 * @providesModule ReactServerRendering
	 */
	'use strict';
	
	var ReactElement = __webpack_require__(7);
	var ReactInstanceHandles = __webpack_require__(35);
	var ReactMarkupChecksum = __webpack_require__(149);
	var ReactServerRenderingTransaction =
	  __webpack_require__(441);
	
	var emptyObject = __webpack_require__(65);
	var instantiateReactComponent = __webpack_require__(99);
	var invariant = __webpack_require__(2);
	
	/**
	 * @param {ReactElement} element
	 * @return {string} the HTML markup
	 */
	function renderToString(element) {
	  ( false ? invariant(
	    ReactElement.isValidElement(element),
	    'renderToString(): You must pass a valid ReactElement.'
	  ) : invariant(ReactElement.isValidElement(element)));
	
	  var transaction;
	  try {
	    var id = ReactInstanceHandles.createReactRootID();
	    transaction = ReactServerRenderingTransaction.getPooled(false);
	
	    return transaction.perform(function() {
	      var componentInstance = instantiateReactComponent(element, null);
	      var markup =
	        componentInstance.mountComponent(id, transaction, emptyObject);
	      return ReactMarkupChecksum.addChecksumToMarkup(markup);
	    }, null);
	  } finally {
	    ReactServerRenderingTransaction.release(transaction);
	  }
	}
	
	/**
	 * @param {ReactElement} element
	 * @return {string} the HTML markup, without the extra React ID and checksum
	 * (for generating static pages)
	 */
	function renderToStaticMarkup(element) {
	  ( false ? invariant(
	    ReactElement.isValidElement(element),
	    'renderToStaticMarkup(): You must pass a valid ReactElement.'
	  ) : invariant(ReactElement.isValidElement(element)));
	
	  var transaction;
	  try {
	    var id = ReactInstanceHandles.createReactRootID();
	    transaction = ReactServerRenderingTransaction.getPooled(true);
	
	    return transaction.perform(function() {
	      var componentInstance = instantiateReactComponent(element, null);
	      return componentInstance.mountComponent(id, transaction, emptyObject);
	    }, null);
	  } finally {
	    ReactServerRenderingTransaction.release(transaction);
	  }
	}
	
	module.exports = {
	  renderToString: renderToString,
	  renderToStaticMarkup: renderToStaticMarkup
	};


/***/ },
/* 441 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactServerRenderingTransaction
	 * @typechecks
	 */
	
	'use strict';
	
	var PooledClass = __webpack_require__(17);
	var CallbackQueue = __webpack_require__(82);
	var ReactPutListenerQueue = __webpack_require__(152);
	var Transaction = __webpack_require__(64);
	
	var assign = __webpack_require__(5);
	var emptyFunction = __webpack_require__(24);
	
	/**
	 * Provides a `CallbackQueue` queue for collecting `onDOMReady` callbacks
	 * during the performing of the transaction.
	 */
	var ON_DOM_READY_QUEUEING = {
	  /**
	   * Initializes the internal `onDOMReady` queue.
	   */
	  initialize: function() {
	    this.reactMountReady.reset();
	  },
	
	  close: emptyFunction
	};
	
	var PUT_LISTENER_QUEUEING = {
	  initialize: function() {
	    this.putListenerQueue.reset();
	  },
	
	  close: emptyFunction
	};
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [
	  PUT_LISTENER_QUEUEING,
	  ON_DOM_READY_QUEUEING
	];
	
	/**
	 * @class ReactServerRenderingTransaction
	 * @param {boolean} renderToStaticMarkup
	 */
	function ReactServerRenderingTransaction(renderToStaticMarkup) {
	  this.reinitializeTransaction();
	  this.renderToStaticMarkup = renderToStaticMarkup;
	  this.reactMountReady = CallbackQueue.getPooled(null);
	  this.putListenerQueue = ReactPutListenerQueue.getPooled();
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array} Empty list of operation wrap proceedures.
	   */
	  getTransactionWrappers: function() {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function() {
	    return this.reactMountReady;
	  },
	
	  getPutListenerQueue: function() {
	    return this.putListenerQueue;
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be resused.
	   */
	  destructor: function() {
	    CallbackQueue.release(this.reactMountReady);
	    this.reactMountReady = null;
	
	    ReactPutListenerQueue.release(this.putListenerQueue);
	    this.putListenerQueue = null;
	  }
	};
	
	
	assign(
	  ReactServerRenderingTransaction.prototype,
	  Transaction.Mixin,
	  Mixin
	);
	
	PooledClass.addPoolingTo(ReactServerRenderingTransaction);
	
	module.exports = ReactServerRenderingTransaction;


/***/ },
/* 442 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SVGDOMPropertyConfig
	 */
	
	/*jslint bitwise: true*/
	
	'use strict';
	
	var DOMProperty = __webpack_require__(33);
	
	var MUST_USE_ATTRIBUTE = DOMProperty.injection.MUST_USE_ATTRIBUTE;
	
	var SVGDOMPropertyConfig = {
	  Properties: {
	    clipPath: MUST_USE_ATTRIBUTE,
	    cx: MUST_USE_ATTRIBUTE,
	    cy: MUST_USE_ATTRIBUTE,
	    d: MUST_USE_ATTRIBUTE,
	    dx: MUST_USE_ATTRIBUTE,
	    dy: MUST_USE_ATTRIBUTE,
	    fill: MUST_USE_ATTRIBUTE,
	    fillOpacity: MUST_USE_ATTRIBUTE,
	    fontFamily: MUST_USE_ATTRIBUTE,
	    fontSize: MUST_USE_ATTRIBUTE,
	    fx: MUST_USE_ATTRIBUTE,
	    fy: MUST_USE_ATTRIBUTE,
	    gradientTransform: MUST_USE_ATTRIBUTE,
	    gradientUnits: MUST_USE_ATTRIBUTE,
	    markerEnd: MUST_USE_ATTRIBUTE,
	    markerMid: MUST_USE_ATTRIBUTE,
	    markerStart: MUST_USE_ATTRIBUTE,
	    offset: MUST_USE_ATTRIBUTE,
	    opacity: MUST_USE_ATTRIBUTE,
	    patternContentUnits: MUST_USE_ATTRIBUTE,
	    patternUnits: MUST_USE_ATTRIBUTE,
	    points: MUST_USE_ATTRIBUTE,
	    preserveAspectRatio: MUST_USE_ATTRIBUTE,
	    r: MUST_USE_ATTRIBUTE,
	    rx: MUST_USE_ATTRIBUTE,
	    ry: MUST_USE_ATTRIBUTE,
	    spreadMethod: MUST_USE_ATTRIBUTE,
	    stopColor: MUST_USE_ATTRIBUTE,
	    stopOpacity: MUST_USE_ATTRIBUTE,
	    stroke: MUST_USE_ATTRIBUTE,
	    strokeDasharray: MUST_USE_ATTRIBUTE,
	    strokeLinecap: MUST_USE_ATTRIBUTE,
	    strokeOpacity: MUST_USE_ATTRIBUTE,
	    strokeWidth: MUST_USE_ATTRIBUTE,
	    textAnchor: MUST_USE_ATTRIBUTE,
	    transform: MUST_USE_ATTRIBUTE,
	    version: MUST_USE_ATTRIBUTE,
	    viewBox: MUST_USE_ATTRIBUTE,
	    x1: MUST_USE_ATTRIBUTE,
	    x2: MUST_USE_ATTRIBUTE,
	    x: MUST_USE_ATTRIBUTE,
	    y1: MUST_USE_ATTRIBUTE,
	    y2: MUST_USE_ATTRIBUTE,
	    y: MUST_USE_ATTRIBUTE
	  },
	  DOMAttributeNames: {
	    clipPath: 'clip-path',
	    fillOpacity: 'fill-opacity',
	    fontFamily: 'font-family',
	    fontSize: 'font-size',
	    gradientTransform: 'gradientTransform',
	    gradientUnits: 'gradientUnits',
	    markerEnd: 'marker-end',
	    markerMid: 'marker-mid',
	    markerStart: 'marker-start',
	    patternContentUnits: 'patternContentUnits',
	    patternUnits: 'patternUnits',
	    preserveAspectRatio: 'preserveAspectRatio',
	    spreadMethod: 'spreadMethod',
	    stopColor: 'stop-color',
	    stopOpacity: 'stop-opacity',
	    strokeDasharray: 'stroke-dasharray',
	    strokeLinecap: 'stroke-linecap',
	    strokeOpacity: 'stroke-opacity',
	    strokeWidth: 'stroke-width',
	    textAnchor: 'text-anchor',
	    viewBox: 'viewBox'
	  }
	};
	
	module.exports = SVGDOMPropertyConfig;


/***/ },
/* 443 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SelectEventPlugin
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(12);
	var EventPropagators = __webpack_require__(45);
	var ReactInputSelection = __webpack_require__(148);
	var SyntheticEvent = __webpack_require__(28);
	
	var getActiveElement = __webpack_require__(158);
	var isTextInputElement = __webpack_require__(163);
	var keyOf = __webpack_require__(21);
	var shallowEqual = __webpack_require__(474);
	
	var topLevelTypes = EventConstants.topLevelTypes;
	
	var eventTypes = {
	  select: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onSelect: null}),
	      captured: keyOf({onSelectCapture: null})
	    },
	    dependencies: [
	      topLevelTypes.topBlur,
	      topLevelTypes.topContextMenu,
	      topLevelTypes.topFocus,
	      topLevelTypes.topKeyDown,
	      topLevelTypes.topMouseDown,
	      topLevelTypes.topMouseUp,
	      topLevelTypes.topSelectionChange
	    ]
	  }
	};
	
	var activeElement = null;
	var activeElementID = null;
	var lastSelection = null;
	var mouseDown = false;
	
	/**
	 * Get an object which is a unique representation of the current selection.
	 *
	 * The return value will not be consistent across nodes or browsers, but
	 * two identical selections on the same node will return identical objects.
	 *
	 * @param {DOMElement} node
	 * @param {object}
	 */
	function getSelection(node) {
	  if ('selectionStart' in node &&
	      ReactInputSelection.hasSelectionCapabilities(node)) {
	    return {
	      start: node.selectionStart,
	      end: node.selectionEnd
	    };
	  } else if (window.getSelection) {
	    var selection = window.getSelection();
	    return {
	      anchorNode: selection.anchorNode,
	      anchorOffset: selection.anchorOffset,
	      focusNode: selection.focusNode,
	      focusOffset: selection.focusOffset
	    };
	  } else if (document.selection) {
	    var range = document.selection.createRange();
	    return {
	      parentElement: range.parentElement(),
	      text: range.text,
	      top: range.boundingTop,
	      left: range.boundingLeft
	    };
	  }
	}
	
	/**
	 * Poll selection to see whether it's changed.
	 *
	 * @param {object} nativeEvent
	 * @return {?SyntheticEvent}
	 */
	function constructSelectEvent(nativeEvent) {
	  // Ensure we have the right element, and that the user is not dragging a
	  // selection (this matches native `select` event behavior). In HTML5, select
	  // fires only on input and textarea thus if there's no focused element we
	  // won't dispatch.
	  if (mouseDown ||
	      activeElement == null ||
	      activeElement !== getActiveElement()) {
	    return null;
	  }
	
	  // Only fire when selection has actually changed.
	  var currentSelection = getSelection(activeElement);
	  if (!lastSelection || !shallowEqual(lastSelection, currentSelection)) {
	    lastSelection = currentSelection;
	
	    var syntheticEvent = SyntheticEvent.getPooled(
	      eventTypes.select,
	      activeElementID,
	      nativeEvent
	    );
	
	    syntheticEvent.type = 'select';
	    syntheticEvent.target = activeElement;
	
	    EventPropagators.accumulateTwoPhaseDispatches(syntheticEvent);
	
	    return syntheticEvent;
	  }
	}
	
	/**
	 * This plugin creates an `onSelect` event that normalizes select events
	 * across form elements.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - contentEditable
	 *
	 * This differs from native browser implementations in the following ways:
	 * - Fires on contentEditable fields as well as inputs.
	 * - Fires for collapsed selection.
	 * - Fires after user input.
	 */
	var SelectEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  /**
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {DOMEventTarget} topLevelTarget The listening component root node.
	   * @param {string} topLevelTargetID ID of `topLevelTarget`.
	   * @param {object} nativeEvent Native browser event.
	   * @return {*} An accumulation of synthetic events.
	   * @see {EventPluginHub.extractEvents}
	   */
	  extractEvents: function(
	      topLevelType,
	      topLevelTarget,
	      topLevelTargetID,
	      nativeEvent) {
	
	    switch (topLevelType) {
	      // Track the input node that has focus.
	      case topLevelTypes.topFocus:
	        if (isTextInputElement(topLevelTarget) ||
	            topLevelTarget.contentEditable === 'true') {
	          activeElement = topLevelTarget;
	          activeElementID = topLevelTargetID;
	          lastSelection = null;
	        }
	        break;
	      case topLevelTypes.topBlur:
	        activeElement = null;
	        activeElementID = null;
	        lastSelection = null;
	        break;
	
	      // Don't fire the event while the user is dragging. This matches the
	      // semantics of the native select event.
	      case topLevelTypes.topMouseDown:
	        mouseDown = true;
	        break;
	      case topLevelTypes.topContextMenu:
	      case topLevelTypes.topMouseUp:
	        mouseDown = false;
	        return constructSelectEvent(nativeEvent);
	
	      // Chrome and IE fire non-standard event when selection is changed (and
	      // sometimes when it hasn't).
	      // Firefox doesn't support selectionchange, so check selection status
	      // after each key entry. The selection changes after keydown and before
	      // keyup, but we check on keydown as well in the case of holding down a
	      // key, when multiple keydown events are fired but only one keyup is.
	      case topLevelTypes.topSelectionChange:
	      case topLevelTypes.topKeyDown:
	      case topLevelTypes.topKeyUp:
	        return constructSelectEvent(nativeEvent);
	    }
	  }
	};
	
	module.exports = SelectEventPlugin;


/***/ },
/* 444 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ServerReactRootIndex
	 * @typechecks
	 */
	
	'use strict';
	
	/**
	 * Size of the reactRoot ID space. We generate random numbers for React root
	 * IDs and if there's a collision the events and DOM update system will
	 * get confused. In the future we need a way to generate GUIDs but for
	 * now this will work on a smaller scale.
	 */
	var GLOBAL_MOUNT_POINT_MAX = Math.pow(2, 53);
	
	var ServerReactRootIndex = {
	  createReactRootIndex: function() {
	    return Math.ceil(Math.random() * GLOBAL_MOUNT_POINT_MAX);
	  }
	};
	
	module.exports = ServerReactRootIndex;


/***/ },
/* 445 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SimpleEventPlugin
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(12);
	var EventPluginUtils = __webpack_require__(83);
	var EventPropagators = __webpack_require__(45);
	var SyntheticClipboardEvent = __webpack_require__(446);
	var SyntheticEvent = __webpack_require__(28);
	var SyntheticFocusEvent = __webpack_require__(449);
	var SyntheticKeyboardEvent = __webpack_require__(451);
	var SyntheticMouseEvent = __webpack_require__(63);
	var SyntheticDragEvent = __webpack_require__(448);
	var SyntheticTouchEvent = __webpack_require__(452);
	var SyntheticUIEvent = __webpack_require__(47);
	var SyntheticWheelEvent = __webpack_require__(453);
	
	var getEventCharCode = __webpack_require__(96);
	
	var invariant = __webpack_require__(2);
	var keyOf = __webpack_require__(21);
	var warning = __webpack_require__(6);
	
	var topLevelTypes = EventConstants.topLevelTypes;
	
	var eventTypes = {
	  blur: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onBlur: true}),
	      captured: keyOf({onBlurCapture: true})
	    }
	  },
	  click: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onClick: true}),
	      captured: keyOf({onClickCapture: true})
	    }
	  },
	  contextMenu: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onContextMenu: true}),
	      captured: keyOf({onContextMenuCapture: true})
	    }
	  },
	  copy: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onCopy: true}),
	      captured: keyOf({onCopyCapture: true})
	    }
	  },
	  cut: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onCut: true}),
	      captured: keyOf({onCutCapture: true})
	    }
	  },
	  doubleClick: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onDoubleClick: true}),
	      captured: keyOf({onDoubleClickCapture: true})
	    }
	  },
	  drag: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onDrag: true}),
	      captured: keyOf({onDragCapture: true})
	    }
	  },
	  dragEnd: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onDragEnd: true}),
	      captured: keyOf({onDragEndCapture: true})
	    }
	  },
	  dragEnter: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onDragEnter: true}),
	      captured: keyOf({onDragEnterCapture: true})
	    }
	  },
	  dragExit: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onDragExit: true}),
	      captured: keyOf({onDragExitCapture: true})
	    }
	  },
	  dragLeave: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onDragLeave: true}),
	      captured: keyOf({onDragLeaveCapture: true})
	    }
	  },
	  dragOver: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onDragOver: true}),
	      captured: keyOf({onDragOverCapture: true})
	    }
	  },
	  dragStart: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onDragStart: true}),
	      captured: keyOf({onDragStartCapture: true})
	    }
	  },
	  drop: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onDrop: true}),
	      captured: keyOf({onDropCapture: true})
	    }
	  },
	  focus: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onFocus: true}),
	      captured: keyOf({onFocusCapture: true})
	    }
	  },
	  input: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onInput: true}),
	      captured: keyOf({onInputCapture: true})
	    }
	  },
	  keyDown: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onKeyDown: true}),
	      captured: keyOf({onKeyDownCapture: true})
	    }
	  },
	  keyPress: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onKeyPress: true}),
	      captured: keyOf({onKeyPressCapture: true})
	    }
	  },
	  keyUp: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onKeyUp: true}),
	      captured: keyOf({onKeyUpCapture: true})
	    }
	  },
	  load: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onLoad: true}),
	      captured: keyOf({onLoadCapture: true})
	    }
	  },
	  error: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onError: true}),
	      captured: keyOf({onErrorCapture: true})
	    }
	  },
	  // Note: We do not allow listening to mouseOver events. Instead, use the
	  // onMouseEnter/onMouseLeave created by `EnterLeaveEventPlugin`.
	  mouseDown: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onMouseDown: true}),
	      captured: keyOf({onMouseDownCapture: true})
	    }
	  },
	  mouseMove: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onMouseMove: true}),
	      captured: keyOf({onMouseMoveCapture: true})
	    }
	  },
	  mouseOut: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onMouseOut: true}),
	      captured: keyOf({onMouseOutCapture: true})
	    }
	  },
	  mouseOver: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onMouseOver: true}),
	      captured: keyOf({onMouseOverCapture: true})
	    }
	  },
	  mouseUp: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onMouseUp: true}),
	      captured: keyOf({onMouseUpCapture: true})
	    }
	  },
	  paste: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onPaste: true}),
	      captured: keyOf({onPasteCapture: true})
	    }
	  },
	  reset: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onReset: true}),
	      captured: keyOf({onResetCapture: true})
	    }
	  },
	  scroll: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onScroll: true}),
	      captured: keyOf({onScrollCapture: true})
	    }
	  },
	  submit: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onSubmit: true}),
	      captured: keyOf({onSubmitCapture: true})
	    }
	  },
	  touchCancel: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onTouchCancel: true}),
	      captured: keyOf({onTouchCancelCapture: true})
	    }
	  },
	  touchEnd: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onTouchEnd: true}),
	      captured: keyOf({onTouchEndCapture: true})
	    }
	  },
	  touchMove: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onTouchMove: true}),
	      captured: keyOf({onTouchMoveCapture: true})
	    }
	  },
	  touchStart: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onTouchStart: true}),
	      captured: keyOf({onTouchStartCapture: true})
	    }
	  },
	  wheel: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onWheel: true}),
	      captured: keyOf({onWheelCapture: true})
	    }
	  }
	};
	
	var topLevelEventsToDispatchConfig = {
	  topBlur:        eventTypes.blur,
	  topClick:       eventTypes.click,
	  topContextMenu: eventTypes.contextMenu,
	  topCopy:        eventTypes.copy,
	  topCut:         eventTypes.cut,
	  topDoubleClick: eventTypes.doubleClick,
	  topDrag:        eventTypes.drag,
	  topDragEnd:     eventTypes.dragEnd,
	  topDragEnter:   eventTypes.dragEnter,
	  topDragExit:    eventTypes.dragExit,
	  topDragLeave:   eventTypes.dragLeave,
	  topDragOver:    eventTypes.dragOver,
	  topDragStart:   eventTypes.dragStart,
	  topDrop:        eventTypes.drop,
	  topError:       eventTypes.error,
	  topFocus:       eventTypes.focus,
	  topInput:       eventTypes.input,
	  topKeyDown:     eventTypes.keyDown,
	  topKeyPress:    eventTypes.keyPress,
	  topKeyUp:       eventTypes.keyUp,
	  topLoad:        eventTypes.load,
	  topMouseDown:   eventTypes.mouseDown,
	  topMouseMove:   eventTypes.mouseMove,
	  topMouseOut:    eventTypes.mouseOut,
	  topMouseOver:   eventTypes.mouseOver,
	  topMouseUp:     eventTypes.mouseUp,
	  topPaste:       eventTypes.paste,
	  topReset:       eventTypes.reset,
	  topScroll:      eventTypes.scroll,
	  topSubmit:      eventTypes.submit,
	  topTouchCancel: eventTypes.touchCancel,
	  topTouchEnd:    eventTypes.touchEnd,
	  topTouchMove:   eventTypes.touchMove,
	  topTouchStart:  eventTypes.touchStart,
	  topWheel:       eventTypes.wheel
	};
	
	for (var type in topLevelEventsToDispatchConfig) {
	  topLevelEventsToDispatchConfig[type].dependencies = [type];
	}
	
	var SimpleEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  /**
	   * Same as the default implementation, except cancels the event when return
	   * value is false. This behavior will be disabled in a future release.
	   *
	   * @param {object} Event to be dispatched.
	   * @param {function} Application-level callback.
	   * @param {string} domID DOM ID to pass to the callback.
	   */
	  executeDispatch: function(event, listener, domID) {
	    var returnValue = EventPluginUtils.executeDispatch(event, listener, domID);
	
	    ( false ? warning(
	      typeof returnValue !== 'boolean',
	      'Returning `false` from an event handler is deprecated and will be ' +
	      'ignored in a future release. Instead, manually call ' +
	      'e.stopPropagation() or e.preventDefault(), as appropriate.'
	    ) : null);
	
	    if (returnValue === false) {
	      event.stopPropagation();
	      event.preventDefault();
	    }
	  },
	
	  /**
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {DOMEventTarget} topLevelTarget The listening component root node.
	   * @param {string} topLevelTargetID ID of `topLevelTarget`.
	   * @param {object} nativeEvent Native browser event.
	   * @return {*} An accumulation of synthetic events.
	   * @see {EventPluginHub.extractEvents}
	   */
	  extractEvents: function(
	      topLevelType,
	      topLevelTarget,
	      topLevelTargetID,
	      nativeEvent) {
	    var dispatchConfig = topLevelEventsToDispatchConfig[topLevelType];
	    if (!dispatchConfig) {
	      return null;
	    }
	    var EventConstructor;
	    switch (topLevelType) {
	      case topLevelTypes.topInput:
	      case topLevelTypes.topLoad:
	      case topLevelTypes.topError:
	      case topLevelTypes.topReset:
	      case topLevelTypes.topSubmit:
	        // HTML Events
	        // @see http://www.w3.org/TR/html5/index.html#events-0
	        EventConstructor = SyntheticEvent;
	        break;
	      case topLevelTypes.topKeyPress:
	        // FireFox creates a keypress event for function keys too. This removes
	        // the unwanted keypress events. Enter is however both printable and
	        // non-printable. One would expect Tab to be as well (but it isn't).
	        if (getEventCharCode(nativeEvent) === 0) {
	          return null;
	        }
	        /* falls through */
	      case topLevelTypes.topKeyDown:
	      case topLevelTypes.topKeyUp:
	        EventConstructor = SyntheticKeyboardEvent;
	        break;
	      case topLevelTypes.topBlur:
	      case topLevelTypes.topFocus:
	        EventConstructor = SyntheticFocusEvent;
	        break;
	      case topLevelTypes.topClick:
	        // Firefox creates a click event on right mouse clicks. This removes the
	        // unwanted click events.
	        if (nativeEvent.button === 2) {
	          return null;
	        }
	        /* falls through */
	      case topLevelTypes.topContextMenu:
	      case topLevelTypes.topDoubleClick:
	      case topLevelTypes.topMouseDown:
	      case topLevelTypes.topMouseMove:
	      case topLevelTypes.topMouseOut:
	      case topLevelTypes.topMouseOver:
	      case topLevelTypes.topMouseUp:
	        EventConstructor = SyntheticMouseEvent;
	        break;
	      case topLevelTypes.topDrag:
	      case topLevelTypes.topDragEnd:
	      case topLevelTypes.topDragEnter:
	      case topLevelTypes.topDragExit:
	      case topLevelTypes.topDragLeave:
	      case topLevelTypes.topDragOver:
	      case topLevelTypes.topDragStart:
	      case topLevelTypes.topDrop:
	        EventConstructor = SyntheticDragEvent;
	        break;
	      case topLevelTypes.topTouchCancel:
	      case topLevelTypes.topTouchEnd:
	      case topLevelTypes.topTouchMove:
	      case topLevelTypes.topTouchStart:
	        EventConstructor = SyntheticTouchEvent;
	        break;
	      case topLevelTypes.topScroll:
	        EventConstructor = SyntheticUIEvent;
	        break;
	      case topLevelTypes.topWheel:
	        EventConstructor = SyntheticWheelEvent;
	        break;
	      case topLevelTypes.topCopy:
	      case topLevelTypes.topCut:
	      case topLevelTypes.topPaste:
	        EventConstructor = SyntheticClipboardEvent;
	        break;
	    }
	    ( false ? invariant(
	      EventConstructor,
	      'SimpleEventPlugin: Unhandled event type, `%s`.',
	      topLevelType
	    ) : invariant(EventConstructor));
	    var event = EventConstructor.getPooled(
	      dispatchConfig,
	      topLevelTargetID,
	      nativeEvent
	    );
	    EventPropagators.accumulateTwoPhaseDispatches(event);
	    return event;
	  }
	
	};
	
	module.exports = SimpleEventPlugin;


/***/ },
/* 446 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticClipboardEvent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(28);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/clipboard-apis/
	 */
	var ClipboardEventInterface = {
	  clipboardData: function(event) {
	    return (
	      'clipboardData' in event ?
	        event.clipboardData :
	        window.clipboardData
	    );
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticClipboardEvent(dispatchConfig, dispatchMarker, nativeEvent) {
	  SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent);
	}
	
	SyntheticEvent.augmentClass(SyntheticClipboardEvent, ClipboardEventInterface);
	
	module.exports = SyntheticClipboardEvent;


/***/ },
/* 447 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticCompositionEvent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(28);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#events-compositionevents
	 */
	var CompositionEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticCompositionEvent(
	  dispatchConfig,
	  dispatchMarker,
	  nativeEvent) {
	  SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent);
	}
	
	SyntheticEvent.augmentClass(
	  SyntheticCompositionEvent,
	  CompositionEventInterface
	);
	
	module.exports = SyntheticCompositionEvent;


/***/ },
/* 448 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticDragEvent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(63);
	
	/**
	 * @interface DragEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var DragEventInterface = {
	  dataTransfer: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticDragEvent(dispatchConfig, dispatchMarker, nativeEvent) {
	  SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticDragEvent, DragEventInterface);
	
	module.exports = SyntheticDragEvent;


/***/ },
/* 449 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticFocusEvent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(47);
	
	/**
	 * @interface FocusEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var FocusEventInterface = {
	  relatedTarget: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticFocusEvent(dispatchConfig, dispatchMarker, nativeEvent) {
	  SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticFocusEvent, FocusEventInterface);
	
	module.exports = SyntheticFocusEvent;


/***/ },
/* 450 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticInputEvent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(28);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105
	 *      /#events-inputevents
	 */
	var InputEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticInputEvent(
	  dispatchConfig,
	  dispatchMarker,
	  nativeEvent) {
	  SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent);
	}
	
	SyntheticEvent.augmentClass(
	  SyntheticInputEvent,
	  InputEventInterface
	);
	
	module.exports = SyntheticInputEvent;


/***/ },
/* 451 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticKeyboardEvent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(47);
	
	var getEventCharCode = __webpack_require__(96);
	var getEventKey = __webpack_require__(462);
	var getEventModifierState = __webpack_require__(97);
	
	/**
	 * @interface KeyboardEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var KeyboardEventInterface = {
	  key: getEventKey,
	  location: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  repeat: null,
	  locale: null,
	  getModifierState: getEventModifierState,
	  // Legacy Interface
	  charCode: function(event) {
	    // `charCode` is the result of a KeyPress event and represents the value of
	    // the actual printable character.
	
	    // KeyPress is deprecated, but its replacement is not yet final and not
	    // implemented in any major browser. Only KeyPress has charCode.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    return 0;
	  },
	  keyCode: function(event) {
	    // `keyCode` is the result of a KeyDown/Up event and represents the value of
	    // physical keyboard key.
	
	    // The actual meaning of the value depends on the users' keyboard layout
	    // which cannot be detected. Assuming that it is a US keyboard layout
	    // provides a surprisingly accurate mapping for US and European users.
	    // Due to this, it is left to the user to implement at this time.
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  },
	  which: function(event) {
	    // `which` is an alias for either `keyCode` or `charCode` depending on the
	    // type of the event.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticKeyboardEvent(dispatchConfig, dispatchMarker, nativeEvent) {
	  SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticKeyboardEvent, KeyboardEventInterface);
	
	module.exports = SyntheticKeyboardEvent;


/***/ },
/* 452 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticTouchEvent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(47);
	
	var getEventModifierState = __webpack_require__(97);
	
	/**
	 * @interface TouchEvent
	 * @see http://www.w3.org/TR/touch-events/
	 */
	var TouchEventInterface = {
	  touches: null,
	  targetTouches: null,
	  changedTouches: null,
	  altKey: null,
	  metaKey: null,
	  ctrlKey: null,
	  shiftKey: null,
	  getModifierState: getEventModifierState
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticTouchEvent(dispatchConfig, dispatchMarker, nativeEvent) {
	  SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticTouchEvent, TouchEventInterface);
	
	module.exports = SyntheticTouchEvent;


/***/ },
/* 453 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticWheelEvent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(63);
	
	/**
	 * @interface WheelEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var WheelEventInterface = {
	  deltaX: function(event) {
	    return (
	      'deltaX' in event ? event.deltaX :
	      // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
	      'wheelDeltaX' in event ? -event.wheelDeltaX : 0
	    );
	  },
	  deltaY: function(event) {
	    return (
	      'deltaY' in event ? event.deltaY :
	      // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
	      'wheelDeltaY' in event ? -event.wheelDeltaY :
	      // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
	      'wheelDelta' in event ? -event.wheelDelta : 0
	    );
	  },
	  deltaZ: null,
	
	  // Browsers without "deltaMode" is reporting in raw wheel delta where one
	  // notch on the scroll is always +/- 120, roughly equivalent to pixels.
	  // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
	  // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
	  deltaMode: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticMouseEvent}
	 */
	function SyntheticWheelEvent(dispatchConfig, dispatchMarker, nativeEvent) {
	  SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticWheelEvent, WheelEventInterface);
	
	module.exports = SyntheticWheelEvent;


/***/ },
/* 454 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule adler32
	 */
	
	/* jslint bitwise:true */
	
	'use strict';
	
	var MOD = 65521;
	
	// This is a clean-room implementation of adler32 designed for detecting
	// if markup is not what we expect it to be. It does not need to be
	// cryptographically strong, only reasonably good at detecting if markup
	// generated on the server is different than that on the client.
	function adler32(data) {
	  var a = 1;
	  var b = 0;
	  for (var i = 0; i < data.length; i++) {
	    a = (a + data.charCodeAt(i)) % MOD;
	    b = (b + a) % MOD;
	  }
	  return a | (b << 16);
	}
	
	module.exports = adler32;


/***/ },
/* 455 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule camelize
	 * @typechecks
	 */
	
	var _hyphenPattern = /-(.)/g;
	
	/**
	 * Camelcases a hyphenated string, for example:
	 *
	 *   > camelize('background-color')
	 *   < "backgroundColor"
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelize(string) {
	  return string.replace(_hyphenPattern, function(_, character) {
	    return character.toUpperCase();
	  });
	}
	
	module.exports = camelize;


/***/ },
/* 456 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule camelizeStyleName
	 * @typechecks
	 */
	
	"use strict";
	
	var camelize = __webpack_require__(455);
	
	var msPattern = /^-ms-/;
	
	/**
	 * Camelcases a hyphenated CSS property name, for example:
	 *
	 *   > camelizeStyleName('background-color')
	 *   < "backgroundColor"
	 *   > camelizeStyleName('-moz-transition')
	 *   < "MozTransition"
	 *   > camelizeStyleName('-ms-transition')
	 *   < "msTransition"
	 *
	 * As Andi Smith suggests
	 * (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
	 * is converted to lowercase `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelizeStyleName(string) {
	  return camelize(string.replace(msPattern, 'ms-'));
	}
	
	module.exports = camelizeStyleName;


/***/ },
/* 457 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule createArrayFromMixed
	 * @typechecks
	 */
	
	var toArray = __webpack_require__(475);
	
	/**
	 * Perform a heuristic test to determine if an object is "array-like".
	 *
	 *   A monk asked Joshu, a Zen master, "Has a dog Buddha nature?"
	 *   Joshu replied: "Mu."
	 *
	 * This function determines if its argument has "array nature": it returns
	 * true if the argument is an actual array, an `arguments' object, or an
	 * HTMLCollection (e.g. node.childNodes or node.getElementsByTagName()).
	 *
	 * It will return false for other array-like objects like Filelist.
	 *
	 * @param {*} obj
	 * @return {boolean}
	 */
	function hasArrayNature(obj) {
	  return (
	    // not null/false
	    !!obj &&
	    // arrays are objects, NodeLists are functions in Safari
	    (typeof obj == 'object' || typeof obj == 'function') &&
	    // quacks like an array
	    ('length' in obj) &&
	    // not window
	    !('setInterval' in obj) &&
	    // no DOM node should be considered an array-like
	    // a 'select' element has 'length' and 'item' properties on IE8
	    (typeof obj.nodeType != 'number') &&
	    (
	      // a real array
	      (// HTMLCollection/NodeList
	      (Array.isArray(obj) ||
	      // arguments
	      ('callee' in obj) || 'item' in obj))
	    )
	  );
	}
	
	/**
	 * Ensure that the argument is an array by wrapping it in an array if it is not.
	 * Creates a copy of the argument if it is already an array.
	 *
	 * This is mostly useful idiomatically:
	 *
	 *   var createArrayFromMixed = require('createArrayFromMixed');
	 *
	 *   function takesOneOrMoreThings(things) {
	 *     things = createArrayFromMixed(things);
	 *     ...
	 *   }
	 *
	 * This allows you to treat `things' as an array, but accept scalars in the API.
	 *
	 * If you need to convert an array-like object, like `arguments`, into an array
	 * use toArray instead.
	 *
	 * @param {*} obj
	 * @return {array}
	 */
	function createArrayFromMixed(obj) {
	  if (!hasArrayNature(obj)) {
	    return [obj];
	  } else if (Array.isArray(obj)) {
	    return obj.slice();
	  } else {
	    return toArray(obj);
	  }
	}
	
	module.exports = createArrayFromMixed;


/***/ },
/* 458 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule createFullPageComponent
	 * @typechecks
	 */
	
	'use strict';
	
	// Defeat circular references by requiring this directly.
	var ReactClass = __webpack_require__(13);
	var ReactElement = __webpack_require__(7);
	
	var invariant = __webpack_require__(2);
	
	/**
	 * Create a component that will throw an exception when unmounted.
	 *
	 * Components like <html> <head> and <body> can't be removed or added
	 * easily in a cross-browser way, however it's valuable to be able to
	 * take advantage of React's reconciliation for styling and <title>
	 * management. So we just document it and throw in dangerous cases.
	 *
	 * @param {string} tag The tag to wrap
	 * @return {function} convenience constructor of new component
	 */
	function createFullPageComponent(tag) {
	  var elementFactory = ReactElement.createFactory(tag);
	
	  var FullPageComponent = ReactClass.createClass({
	    tagName: tag.toUpperCase(),
	    displayName: 'ReactFullPageComponent' + tag,
	
	    componentWillUnmount: function() {
	      ( false ? invariant(
	        false,
	        '%s tried to unmount. Because of cross-browser quirks it is ' +
	        'impossible to unmount some top-level components (eg <html>, <head>, ' +
	        'and <body>) reliably and efficiently. To fix this, have a single ' +
	        'top-level component that never unmounts render these elements.',
	        this.constructor.displayName
	      ) : invariant(false));
	    },
	
	    render: function() {
	      return elementFactory(this.props);
	    }
	  });
	
	  return FullPageComponent;
	}
	
	module.exports = createFullPageComponent;


/***/ },
/* 459 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule createNodesFromMarkup
	 * @typechecks
	 */
	
	/*jslint evil: true, sub: true */
	
	var ExecutionEnvironment = __webpack_require__(8);
	
	var createArrayFromMixed = __webpack_require__(457);
	var getMarkupWrap = __webpack_require__(160);
	var invariant = __webpack_require__(2);
	
	/**
	 * Dummy container used to render all markup.
	 */
	var dummyNode =
	  ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Pattern used by `getNodeName`.
	 */
	var nodeNamePattern = /^\s*<(\w+)/;
	
	/**
	 * Extracts the `nodeName` of the first element in a string of markup.
	 *
	 * @param {string} markup String of markup.
	 * @return {?string} Node name of the supplied markup.
	 */
	function getNodeName(markup) {
	  var nodeNameMatch = markup.match(nodeNamePattern);
	  return nodeNameMatch && nodeNameMatch[1].toLowerCase();
	}
	
	/**
	 * Creates an array containing the nodes rendered from the supplied markup. The
	 * optionally supplied `handleScript` function will be invoked once for each
	 * <script> element that is rendered. If no `handleScript` function is supplied,
	 * an exception is thrown if any <script> elements are rendered.
	 *
	 * @param {string} markup A string of valid HTML markup.
	 * @param {?function} handleScript Invoked once for each rendered <script>.
	 * @return {array<DOMElement|DOMTextNode>} An array of rendered nodes.
	 */
	function createNodesFromMarkup(markup, handleScript) {
	  var node = dummyNode;
	  ( false ? invariant(!!dummyNode, 'createNodesFromMarkup dummy not initialized') : invariant(!!dummyNode));
	  var nodeName = getNodeName(markup);
	
	  var wrap = nodeName && getMarkupWrap(nodeName);
	  if (wrap) {
	    node.innerHTML = wrap[1] + markup + wrap[2];
	
	    var wrapDepth = wrap[0];
	    while (wrapDepth--) {
	      node = node.lastChild;
	    }
	  } else {
	    node.innerHTML = markup;
	  }
	
	  var scripts = node.getElementsByTagName('script');
	  if (scripts.length) {
	    ( false ? invariant(
	      handleScript,
	      'createNodesFromMarkup(...): Unexpected <script> element rendered.'
	    ) : invariant(handleScript));
	    createArrayFromMixed(scripts).forEach(handleScript);
	  }
	
	  var nodes = createArrayFromMixed(node.childNodes);
	  while (node.lastChild) {
	    node.removeChild(node.lastChild);
	  }
	  return nodes;
	}
	
	module.exports = createNodesFromMarkup;


/***/ },
/* 460 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule dangerousStyleValue
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(142);
	
	var isUnitlessNumber = CSSProperty.isUnitlessNumber;
	
	/**
	 * Convert a value into the proper css writable value. The style name `name`
	 * should be logical (no hyphens), as specified
	 * in `CSSProperty.isUnitlessNumber`.
	 *
	 * @param {string} name CSS property name such as `topMargin`.
	 * @param {*} value CSS property value such as `10px`.
	 * @return {string} Normalized style value with dimensions applied.
	 */
	function dangerousStyleValue(name, value) {
	  // Note that we've removed escapeTextForBrowser() calls here since the
	  // whole string will be escaped when the attribute is injected into
	  // the markup. If you provide unsafe user data here they can inject
	  // arbitrary CSS which may be problematic (I couldn't repro this):
	  // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
	  // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
	  // This is not an XSS hole but instead a potential CSS injection issue
	  // which has lead to a greater discussion about how we're going to
	  // trust URLs moving forward. See #2115901
	
	  var isEmpty = value == null || typeof value === 'boolean' || value === '';
	  if (isEmpty) {
	    return '';
	  }
	
	  var isNonNumeric = isNaN(value);
	  if (isNonNumeric || value === 0 ||
	      isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name]) {
	    return '' + value; // cast to string
	  }
	
	  if (typeof value === 'string') {
	    value = value.trim();
	  }
	  return value + 'px';
	}
	
	module.exports = dangerousStyleValue;


/***/ },
/* 461 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule flattenChildren
	 */
	
	'use strict';
	
	var traverseAllChildren = __webpack_require__(164);
	var warning = __webpack_require__(6);
	
	/**
	 * @param {function} traverseContext Context passed through traversal.
	 * @param {?ReactComponent} child React child component.
	 * @param {!string} name String name of key path to child.
	 */
	function flattenSingleChildIntoContext(traverseContext, child, name) {
	  // We found a component instance.
	  var result = traverseContext;
	  var keyUnique = !result.hasOwnProperty(name);
	  if (false) {
	    ("production" !== process.env.NODE_ENV ? warning(
	      keyUnique,
	      'flattenChildren(...): Encountered two children with the same key, ' +
	      '`%s`. Child keys must be unique; when two children share a key, only ' +
	      'the first child will be used.',
	      name
	    ) : null);
	  }
	  if (keyUnique && child != null) {
	    result[name] = child;
	  }
	}
	
	/**
	 * Flattens children that are typically specified as `props.children`. Any null
	 * children will not be included in the resulting object.
	 * @return {!object} flattened children keyed by name.
	 */
	function flattenChildren(children) {
	  if (children == null) {
	    return children;
	  }
	  var result = {};
	  traverseAllChildren(children, flattenSingleChildIntoContext, result);
	  return result;
	}
	
	module.exports = flattenChildren;


/***/ },
/* 462 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getEventKey
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var getEventCharCode = __webpack_require__(96);
	
	/**
	 * Normalization of deprecated HTML5 `key` values
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var normalizeKey = {
	  'Esc': 'Escape',
	  'Spacebar': ' ',
	  'Left': 'ArrowLeft',
	  'Up': 'ArrowUp',
	  'Right': 'ArrowRight',
	  'Down': 'ArrowDown',
	  'Del': 'Delete',
	  'Win': 'OS',
	  'Menu': 'ContextMenu',
	  'Apps': 'ContextMenu',
	  'Scroll': 'ScrollLock',
	  'MozPrintableKey': 'Unidentified'
	};
	
	/**
	 * Translation from legacy `keyCode` to HTML5 `key`
	 * Only special keys supported, all others depend on keyboard layout or browser
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var translateToKey = {
	  8: 'Backspace',
	  9: 'Tab',
	  12: 'Clear',
	  13: 'Enter',
	  16: 'Shift',
	  17: 'Control',
	  18: 'Alt',
	  19: 'Pause',
	  20: 'CapsLock',
	  27: 'Escape',
	  32: ' ',
	  33: 'PageUp',
	  34: 'PageDown',
	  35: 'End',
	  36: 'Home',
	  37: 'ArrowLeft',
	  38: 'ArrowUp',
	  39: 'ArrowRight',
	  40: 'ArrowDown',
	  45: 'Insert',
	  46: 'Delete',
	  112: 'F1', 113: 'F2', 114: 'F3', 115: 'F4', 116: 'F5', 117: 'F6',
	  118: 'F7', 119: 'F8', 120: 'F9', 121: 'F10', 122: 'F11', 123: 'F12',
	  144: 'NumLock',
	  145: 'ScrollLock',
	  224: 'Meta'
	};
	
	/**
	 * @param {object} nativeEvent Native browser event.
	 * @return {string} Normalized `key` property.
	 */
	function getEventKey(nativeEvent) {
	  if (nativeEvent.key) {
	    // Normalize inconsistent values reported by browsers due to
	    // implementations of a working draft specification.
	
	    // FireFox implements `key` but returns `MozPrintableKey` for all
	    // printable characters (normalized to `Unidentified`), ignore it.
	    var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
	    if (key !== 'Unidentified') {
	      return key;
	    }
	  }
	
	  // Browser does not implement `key`, polyfill as much of it as we can.
	  if (nativeEvent.type === 'keypress') {
	    var charCode = getEventCharCode(nativeEvent);
	
	    // The enter-key is technically both printable and non-printable and can
	    // thus be captured by `keypress`, no other non-printable key should.
	    return charCode === 13 ? 'Enter' : String.fromCharCode(charCode);
	  }
	  if (nativeEvent.type === 'keydown' || nativeEvent.type === 'keyup') {
	    // While user keyboard layout determines the actual meaning of each
	    // `keyCode` value, almost all function keys have a universal value.
	    return translateToKey[nativeEvent.keyCode] || 'Unidentified';
	  }
	  return '';
	}
	
	module.exports = getEventKey;


/***/ },
/* 463 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getNodeForCharacterOffset
	 */
	
	'use strict';
	
	/**
	 * Given any node return the first leaf node without children.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {DOMElement|DOMTextNode}
	 */
	function getLeafNode(node) {
	  while (node && node.firstChild) {
	    node = node.firstChild;
	  }
	  return node;
	}
	
	/**
	 * Get the next sibling within a container. This will walk up the
	 * DOM if a node's siblings have been exhausted.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {?DOMElement|DOMTextNode}
	 */
	function getSiblingNode(node) {
	  while (node) {
	    if (node.nextSibling) {
	      return node.nextSibling;
	    }
	    node = node.parentNode;
	  }
	}
	
	/**
	 * Get object describing the nodes which contain characters at offset.
	 *
	 * @param {DOMElement|DOMTextNode} root
	 * @param {number} offset
	 * @return {?object}
	 */
	function getNodeForCharacterOffset(root, offset) {
	  var node = getLeafNode(root);
	  var nodeStart = 0;
	  var nodeEnd = 0;
	
	  while (node) {
	    if (node.nodeType === 3) {
	      nodeEnd = nodeStart + node.textContent.length;
	
	      if (nodeStart <= offset && nodeEnd >= offset) {
	        return {
	          node: node,
	          offset: offset - nodeStart
	        };
	      }
	
	      nodeStart = nodeEnd;
	    }
	
	    node = getLeafNode(getSiblingNode(node));
	  }
	}
	
	module.exports = getNodeForCharacterOffset;


/***/ },
/* 464 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getReactRootElementInContainer
	 */
	
	'use strict';
	
	var DOC_NODE_TYPE = 9;
	
	/**
	 * @param {DOMElement|DOMDocument} container DOM element that may contain
	 *                                           a React component
	 * @return {?*} DOM element that may have the reactRoot ID, or null.
	 */
	function getReactRootElementInContainer(container) {
	  if (!container) {
	    return null;
	  }
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    return container.documentElement;
	  } else {
	    return container.firstChild;
	  }
	}
	
	module.exports = getReactRootElementInContainer;


/***/ },
/* 465 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getUnboundedScrollPosition
	 * @typechecks
	 */
	
	"use strict";
	
	/**
	 * Gets the scroll position of the supplied element or window.
	 *
	 * The return values are unbounded, unlike `getScrollPosition`. This means they
	 * may be negative or exceed the element boundaries (which is possible using
	 * inertial scrolling).
	 *
	 * @param {DOMWindow|DOMElement} scrollable
	 * @return {object} Map with `x` and `y` keys.
	 */
	function getUnboundedScrollPosition(scrollable) {
	  if (scrollable === window) {
	    return {
	      x: window.pageXOffset || document.documentElement.scrollLeft,
	      y: window.pageYOffset || document.documentElement.scrollTop
	    };
	  }
	  return {
	    x: scrollable.scrollLeft,
	    y: scrollable.scrollTop
	  };
	}
	
	module.exports = getUnboundedScrollPosition;


/***/ },
/* 466 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule hyphenate
	 * @typechecks
	 */
	
	var _uppercasePattern = /([A-Z])/g;
	
	/**
	 * Hyphenates a camelcased string, for example:
	 *
	 *   > hyphenate('backgroundColor')
	 *   < "background-color"
	 *
	 * For CSS style names, use `hyphenateStyleName` instead which works properly
	 * with all vendor prefixes, including `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenate(string) {
	  return string.replace(_uppercasePattern, '-$1').toLowerCase();
	}
	
	module.exports = hyphenate;


/***/ },
/* 467 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule hyphenateStyleName
	 * @typechecks
	 */
	
	"use strict";
	
	var hyphenate = __webpack_require__(466);
	
	var msPattern = /^ms-/;
	
	/**
	 * Hyphenates a camelcased CSS property name, for example:
	 *
	 *   > hyphenateStyleName('backgroundColor')
	 *   < "background-color"
	 *   > hyphenateStyleName('MozTransition')
	 *   < "-moz-transition"
	 *   > hyphenateStyleName('msTransition')
	 *   < "-ms-transition"
	 *
	 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
	 * is converted to `-ms-`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenateStyleName(string) {
	  return hyphenate(string).replace(msPattern, '-ms-');
	}
	
	module.exports = hyphenateStyleName;


/***/ },
/* 468 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule isTextNode
	 * @typechecks
	 */
	
	var isNode = __webpack_require__(162);
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM text node.
	 */
	function isTextNode(object) {
	  return isNode(object) && object.nodeType == 3;
	}
	
	module.exports = isTextNode;


/***/ },
/* 469 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule mapObject
	 */
	
	'use strict';
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	/**
	 * Executes the provided `callback` once for each enumerable own property in the
	 * object and constructs a new object from the results. The `callback` is
	 * invoked with three arguments:
	 *
	 *  - the property value
	 *  - the property name
	 *  - the object being traversed
	 *
	 * Properties that are added after the call to `mapObject` will not be visited
	 * by `callback`. If the values of existing properties are changed, the value
	 * passed to `callback` will be the value at the time `mapObject` visits them.
	 * Properties that are deleted before being visited are not visited.
	 *
	 * @grep function objectMap()
	 * @grep function objMap()
	 *
	 * @param {?object} object
	 * @param {function} callback
	 * @param {*} context
	 * @return {?object}
	 */
	function mapObject(object, callback, context) {
	  if (!object) {
	    return null;
	  }
	  var result = {};
	  for (var name in object) {
	    if (hasOwnProperty.call(object, name)) {
	      result[name] = callback.call(context, object[name], name, object);
	    }
	  }
	  return result;
	}
	
	module.exports = mapObject;


/***/ },
/* 470 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule memoizeStringOnly
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/**
	 * Memoizes the return value of a function that accepts one string argument.
	 *
	 * @param {function} callback
	 * @return {function}
	 */
	function memoizeStringOnly(callback) {
	  var cache = {};
	  return function(string) {
	    if (!cache.hasOwnProperty(string)) {
	      cache[string] = callback.call(this, string);
	    }
	    return cache[string];
	  };
	}
	
	module.exports = memoizeStringOnly;


/***/ },
/* 471 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule onlyChild
	 */
	'use strict';
	
	var ReactElement = __webpack_require__(7);
	
	var invariant = __webpack_require__(2);
	
	/**
	 * Returns the first child in a collection of children and verifies that there
	 * is only one child in the collection. The current implementation of this
	 * function assumes that a single child gets passed without a wrapper, but the
	 * purpose of this helper function is to abstract away the particular structure
	 * of children.
	 *
	 * @param {?object} children Child collection structure.
	 * @return {ReactComponent} The first and only `ReactComponent` contained in the
	 * structure.
	 */
	function onlyChild(children) {
	  ( false ? invariant(
	    ReactElement.isValidElement(children),
	    'onlyChild must be passed a children with exactly one child.'
	  ) : invariant(ReactElement.isValidElement(children)));
	  return children;
	}
	
	module.exports = onlyChild;


/***/ },
/* 472 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule quoteAttributeValueForBrowser
	 */
	
	'use strict';
	
	var escapeTextContentForBrowser = __webpack_require__(66);
	
	/**
	 * Escapes attribute value to prevent scripting attacks.
	 *
	 * @param {*} value Value to escape.
	 * @return {string} An escaped string.
	 */
	function quoteAttributeValueForBrowser(value) {
	  return '"' + escapeTextContentForBrowser(value) + '"';
	}
	
	module.exports = quoteAttributeValueForBrowser;


/***/ },
/* 473 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule setTextContent
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(8);
	var escapeTextContentForBrowser = __webpack_require__(66);
	var setInnerHTML = __webpack_require__(101);
	
	/**
	 * Set the textContent property of a node, ensuring that whitespace is preserved
	 * even in IE8. innerText is a poor substitute for textContent and, among many
	 * issues, inserts <br> instead of the literal newline chars. innerHTML behaves
	 * as it should.
	 *
	 * @param {DOMElement} node
	 * @param {string} text
	 * @internal
	 */
	var setTextContent = function(node, text) {
	  node.textContent = text;
	};
	
	if (ExecutionEnvironment.canUseDOM) {
	  if (!('textContent' in document.documentElement)) {
	    setTextContent = function(node, text) {
	      setInnerHTML(node, escapeTextContentForBrowser(text));
	    };
	  }
	}
	
	module.exports = setTextContent;


/***/ },
/* 474 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule shallowEqual
	 */
	
	'use strict';
	
	/**
	 * Performs equality by iterating through keys on an object and returning
	 * false when any key has values which are not strictly equal between
	 * objA and objB. Returns true when the values of all keys are strictly equal.
	 *
	 * @return {boolean}
	 */
	function shallowEqual(objA, objB) {
	  if (objA === objB) {
	    return true;
	  }
	  var key;
	  // Test for A's keys different from B.
	  for (key in objA) {
	    if (objA.hasOwnProperty(key) &&
	        (!objB.hasOwnProperty(key) || objA[key] !== objB[key])) {
	      return false;
	    }
	  }
	  // Test for B's keys missing from A.
	  for (key in objB) {
	    if (objB.hasOwnProperty(key) && !objA.hasOwnProperty(key)) {
	      return false;
	    }
	  }
	  return true;
	}
	
	module.exports = shallowEqual;


/***/ },
/* 475 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule toArray
	 * @typechecks
	 */
	
	var invariant = __webpack_require__(2);
	
	/**
	 * Convert array-like objects to arrays.
	 *
	 * This API assumes the caller knows the contents of the data type. For less
	 * well defined inputs use createArrayFromMixed.
	 *
	 * @param {object|function|filelist} obj
	 * @return {array}
	 */
	function toArray(obj) {
	  var length = obj.length;
	
	  // Some browse builtin objects can report typeof 'function' (e.g. NodeList in
	  // old versions of Safari).
	  ( false ? invariant(
	    !Array.isArray(obj) &&
	    (typeof obj === 'object' || typeof obj === 'function'),
	    'toArray: Array-like object expected'
	  ) : invariant(!Array.isArray(obj) &&
	  (typeof obj === 'object' || typeof obj === 'function')));
	
	  ( false ? invariant(
	    typeof length === 'number',
	    'toArray: Object needs a length property'
	  ) : invariant(typeof length === 'number'));
	
	  ( false ? invariant(
	    length === 0 ||
	    (length - 1) in obj,
	    'toArray: Object should have keys for indices'
	  ) : invariant(length === 0 ||
	  (length - 1) in obj));
	
	  // Old IE doesn't give collections access to hasOwnProperty. Assume inputs
	  // without method will throw during the slice call and skip straight to the
	  // fallback.
	  if (obj.hasOwnProperty) {
	    try {
	      return Array.prototype.slice.call(obj);
	    } catch (e) {
	      // IE < 9 does not support Array#slice on collections objects
	    }
	  }
	
	  // Fall back to copying key by key. This assumes all keys have a value,
	  // so will not preserve sparsely populated inputs.
	  var ret = Array(length);
	  for (var ii = 0; ii < length; ii++) {
	    ret[ii] = obj[ii];
	  }
	  return ret;
	}
	
	module.exports = toArray;


/***/ }
/******/ ]);


/** WEBPACK FOOTER **
 ** main-4aceb3446d3bac511a62.js
 **/